import React, { createContext, useState, useCallback, useContext, useEffect, forwardRef, createElement, useMemo, useRef, Component } from 'react';
import moment$1 from 'moment';
import 'antd/lib/button/style';
import _Button from 'antd/lib/button';
import get$3 from 'lodash/get';
import 'antd/lib/form/style';
import _Form from 'antd/lib/form';
import 'antd/lib/input/style';
import _Input from 'antd/lib/input';
import 'antd/lib/drawer/style';
import _Drawer from 'antd/lib/drawer';
import 'antd/lib/menu/style';
import _Menu from 'antd/lib/menu';
import 'antd/lib/layout/style';
import _Layout from 'antd/lib/layout';
import 'antd/lib/avatar/style';
import _Avatar from 'antd/lib/avatar';
import findLastIndex from 'lodash/findLastIndex';
import min$1 from 'lodash/min';
import 'antd/lib/upload/style';
import _Upload from 'antd/lib/upload';
import 'antd/lib/select/style';
import _Select from 'antd/lib/select';
import upperFirst from 'lodash/upperFirst';
import 'antd/lib/auto-complete/style';
import _AutoComplete from 'antd/lib/auto-complete';
import 'antd/lib/date-picker/style';
import _DatePicker from 'antd/lib/date-picker';
import 'antd/lib/time-picker/style';
import _TimePicker from 'antd/lib/time-picker';
import 'antd/lib/dropdown/style';
import _Dropdown from 'antd/lib/dropdown';
import 'antd/lib/progress/style';
import _Progress from 'antd/lib/progress';
import 'antd/lib/popover/style';
import _Popover from 'antd/lib/popover';
import 'antd/lib/tooltip/style';
import _Tooltip from 'antd/lib/tooltip';
import isEmpty from 'lodash/isEmpty';
import 'antd/lib/card/style';
import _Card from 'antd/lib/card';
import 'antd/lib/spin/style';
import _Spin from 'antd/lib/spin';
import 'antd/lib/badge/style';
import _Badge from 'antd/lib/badge';
import 'antd/lib/col/style';
import _Col from 'antd/lib/col';
import 'antd/lib/row/style';
import _Row from 'antd/lib/row';
import 'antd/lib/table/style';
import _Table from 'antd/lib/table';
import 'antd/lib/tabs/style';
import _Tabs from 'antd/lib/tabs';
import 'antd/lib/message/style';
import _message from 'antd/lib/message';
import 'antd/lib/divider/style';
import _Divider from 'antd/lib/divider';
import 'antd/lib/modal/style';
import _Modal from 'antd/lib/modal';
import remove from 'lodash/remove';
import crypto from 'crypto';
import keyBy from 'lodash/keyBy';
import 'antd/lib/carousel/style';
import _Carousel from 'antd/lib/carousel';
import 'antd/lib/steps/style';
import _Steps from 'antd/lib/steps';
import cloneDeep from 'lodash/cloneDeep';
import set$1 from 'lodash/set';
import ReactDOM, { findDOMNode } from 'react-dom';
import 'antd/lib/radio/style';
import _Radio from 'antd/lib/radio';
import 'antd/lib/skeleton/style';
import _Skeleton from 'antd/lib/skeleton';
import 'antd/lib/switch/style';
import _Switch from 'antd/lib/switch';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var translations = {
	"ui.no.payment.text": "No available payments",
	"ui.calendar": "Calendar",
	"ui.month": "Month",
	"ui.week": "Week",
	"ui.day": "Day",
	"ui.agenda": "Agenda",
	"ui.student.count": "{{count}} students",
	"ui.flexible.schedule": "Flexible Schedule",
	"ui.read.more": "Read More",
	"ui.read.less": "Read Less",
	"ui.type.message": "Type a message...",
	"ui.practice": "Practice",
	"ui.book": "Book",
	"news.date": "Date",
	"news.author": "Author"
};

const defaultProps = {
  translate: key => translations[key] || key,
  locale: 'en',
  momentLocale: 'en'
};
const ConfigContext = createContext(defaultProps);

const TProvider = _a => {
  var {
    children,
    momentLocale
  } = _a,
      props = __rest(_a, ["children", "momentLocale"]);

  moment$1.locale(momentLocale);
  return React.createElement(ConfigContext.Provider, {
    value: Object.assign(Object.assign(Object.assign({}, defaultProps), props), {
      momentLocale,
      moment: moment$1
    })
  }, children);
};

const withLocalization = Component => props => React.createElement(ConfigContext.Consumer, null, context => {
  return React.createElement(Component, Object.assign({}, props, {
    momentLocale: context.momentLocale,
    moment: context.moment
  }));
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".t-button {\n  border-radius: var(--border-radius, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.t-button.ant-btn {\n  border-radius: var(--border-radius, 8px);\n}\n.t-button span + svg {\n  margin-left: 8px;\n}\n.t-button svg + span {\n  margin-left: 8px;\n}\n.t-button.t-button-primary {\n  background-color: var(--primary-color, #f54e95);\n  color: #fff;\n  border-color: var(--primary-color, #f54e95);\n}\n.t-button.t-button-primary:hover {\n  background: var(--primary-background-hover-color, #eb4b8f);\n  border-color: var(--primary-background-hover-color, #eb4b8f);\n}\n.t-button.t-button-link {\n  color: #52aeff;\n}\n.t-button.t-button-link:hover {\n  color: #52aeff;\n}\n.t-button.t-button-default {\n  background: #f2f2f3;\n  color: var(--text-dark-100, #262626);\n  border: none;\n}\n.t-button.t-button-small {\n  border-radius: var(--border-radius, 8px);\n}\n.t-button.t-button-large {\n  font-size: 15px;\n}\n.t-button.t-button-fullwidth {\n  width: 100%;\n}\n.t-button.t-button-disabled[disabled] {\n  background: #e6e6e7;\n  border-color: #e6e6e7;\n}\n.t-button.t-button-disabled[disabled]:hover {\n  color: #fff;\n  background: #e6e6e7;\n  border-color: #e6e6e7;\n}\n.t-button.t-button-dashed {\n  text-align: center;\n  background: #f2f2f3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n.t-button.t-button-dashed:hover {\n  background: #eaeaeb;\n  border-color: #eaeaeb;\n  color: black;\n}\n.t-button.t-button-dashed:focus {\n  background: #eaeaeb;\n  border-color: #eaeaeb;\n  color: black;\n}\n.t-button a.ant-btn {\n  padding-top: 4px;\n  display: flex;\n  align-items: center;\n}\n";
styleInject(css_248z);

const TButton = _a => {
  var {
    size = 'middle',
    type = 'primary',
    htmlType = 'submit',
    fullWidth = false,
    reset = false,
    disabled = false
  } = _a,
      props = __rest(_a, ["size", "type", "htmlType", "fullWidth", "reset", "disabled"]);

  const newTypes = {
    reset: 'dashed',
    primary: 'primary',
    link: 'link',
    default: 'default',
    text: 'text',
    ghost: 'ghost'
  };
  const classNames = ['t-button', `t-button-${newTypes[type]}`, `t-button-${size}`];

  if (fullWidth) {
    classNames.push('t-button-fullwidth');
  }

  if (reset) {
    classNames.push('t-button-reset');
  }

  if (disabled) {
    classNames.push('t-button-disabled');
  }

  return React.createElement(_Button, Object.assign({
    className: classNames.join(' '),
    htmlType: htmlType,
    type: type,
    size: size,
    disabled: disabled
  }, props), props.children);
};

var css_248z$1 = ".t-icon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: middle;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.t-icon svg {\n  fill: var(--text-dark-100, #262626);\n}\n";
styleInject(css_248z$1);

const sizes = {
  xxs: {
    width: 10,
    height: 10
  },
  xs: {
    width: 13,
    height: 13
  },
  s: {
    width: 16,
    height: 16
  },
  sm: {
    width: 20,
    height: 20
  },
  xl: {
    width: 32,
    height: 32
  },
  md: {
    width: 24,
    height: 24
  },
  lg: {
    width: 18,
    height: 20
  }
};

const Icon = ({
  size = 'sm',
  onClick,
  fill = 'currentColor',
  stroke = 'none',
  children
}) => {
  return React.createElement("svg", Object.assign({}, sizes[size], {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: fill,
    className: "t-icon",
    onClick: onClick,
    stroke: stroke
  }), children);
};

const IconLink = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "23.9993",
    height: "24.0002",
    rx: "4",
    fill: "#F7F7F8"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0142 11.9299L12.4819 12.462C12.3532 12.5907 12.1856 12.651 12.0073 12.6577C11.8276 12.6657 11.66 12.5786 11.5327 12.462C11.4093 12.3481 11.3369 12.1524 11.3369 11.9875C11.3369 11.8146 11.4107 11.635 11.5327 11.5131L11.5421 11.5037C11.6833 11.3589 11.8276 11.2159 11.9717 11.0731C12.0436 11.0017 12.1155 10.9304 12.187 10.859L13.517 9.52946L15.0509 7.99619L15.7056 7.34174H15.3575H14.3506C14.1696 7.34174 14.0074 7.26535 13.876 7.14606C13.7446 7.0241 13.6882 6.8445 13.6802 6.6716C13.6722 6.50407 13.7593 6.31375 13.876 6.19715C13.998 6.07652 14.179 6.00146 14.3506 6.00146H14.7166H16.3202H17.3088C17.3146 6.00109 17.3204 6.00078 17.3262 6.00051C17.4506 5.99495 17.5692 6.03499 17.6727 6.09886C17.7106 6.12155 17.7459 6.14731 17.777 6.17514C17.7851 6.18204 17.793 6.18906 17.8008 6.1962C17.8059 6.20085 17.8108 6.20565 17.8157 6.21058C17.8842 6.27908 17.9308 6.36392 17.9598 6.45477C17.9812 6.51895 17.9937 6.58546 17.9961 6.64833C17.9967 6.6561 17.9972 6.66386 17.9975 6.6716C17.9985 6.69127 17.9981 6.71126 17.9965 6.7314V7.03801V8.64098V9.64753C17.9965 9.82847 17.9201 9.99064 17.8008 10.122C17.6789 10.2533 17.4993 10.3096 17.3264 10.3177C17.1589 10.3257 16.9685 10.2386 16.8519 10.122C16.7313 10 16.6562 9.81909 16.6562 9.64753V9.28164V8.28926L15.8165 9.12872L14.2826 10.662L13.0142 11.9299ZM16.6571 13.3194V12.2069C16.6571 12.0247 16.7336 11.8638 16.8542 11.7338C16.9762 11.6025 17.1559 11.5462 17.3289 11.5382C17.4965 11.5301 17.6869 11.6172 17.8035 11.7338C17.9242 11.8558 17.9993 12.0367 17.9993 12.2083V12.4884V14.0713V15.2641C17.9993 15.693 17.8974 16.0938 17.7177 16.4811C17.5099 16.9261 17.1546 17.2987 16.7483 17.5681C16.33 17.8455 15.8165 17.9902 15.3164 17.9996C15.277 18.0005 15.237 18.0002 15.1972 17.9999L15.138 17.9996H14.1204H12.5074H10.7617H9.34585L9.13803 17.9999H9.1377C8.99926 18.0002 8.86082 18.0005 8.72239 17.9996C7.7597 17.9969 6.84261 17.4742 6.36261 16.6379C6.12663 16.2278 6.00194 15.7533 6.0006 15.2802V15.106V14.0431V12.4107V10.671V9.28783L6.0003 9.09895L6.0003 9.09865L6.0003 9.09836C6 8.97316 5.9997 8.84837 6.0006 8.72357C6.00194 8.22365 6.14004 7.71434 6.40819 7.29082C6.66831 6.87935 7.0397 6.52016 7.47948 6.30437C7.87233 6.11137 8.29199 6.00415 8.73177 6.00415H9.13132H10.7765H11.7928C11.9751 6.00415 12.136 6.07921 12.2674 6.19983C12.3988 6.3218 12.4551 6.50139 12.4632 6.67429C12.4712 6.84182 12.3841 7.03214 12.2674 7.14875C12.1454 7.26937 11.9644 7.34443 11.7928 7.34443H11.3812H9.64216H8.93021L8.88113 7.34437H8.88113C8.76342 7.34418 8.64579 7.34399 8.52872 7.35378C8.40979 7.37568 8.29347 7.40728 8.18055 7.44897C8.07252 7.50014 7.96945 7.56093 7.87135 7.63009C7.78186 7.70578 7.69869 7.789 7.62307 7.87853C7.55422 7.97629 7.49407 8.07995 7.44261 8.18825C7.40072 8.30232 7.36907 8.41892 7.34726 8.53847C7.34168 8.60029 7.3387 8.6623 7.3387 8.72491C7.3378 8.88659 7.3381 9.04886 7.3384 9.21133V9.21133V9.21133L7.3387 9.45536V11.1334V13.1009V14.7039C7.3387 14.7726 7.33766 14.842 7.33661 14.9117C7.33384 15.0968 7.33103 15.284 7.34759 15.4672C7.36952 15.587 7.40128 15.7041 7.44328 15.8178C7.49447 15.9258 7.55529 16.0288 7.62447 16.1269C7.70019 16.2164 7.78343 16.2995 7.873 16.3751C7.97079 16.4439 8.0745 16.504 8.18284 16.5555C8.29695 16.5973 8.4136 16.629 8.53319 16.6508C8.59503 16.6564 8.65707 16.6593 8.7197 16.6593C8.88144 16.6602 9.04378 16.6599 9.20631 16.6596L9.45043 16.6593H11.1291H13.0974H14.7009C14.7696 16.6593 14.839 16.6604 14.9086 16.6614L14.9088 16.6614C15.094 16.6642 15.2813 16.667 15.4646 16.6505C15.5844 16.6285 15.7016 16.5968 15.8153 16.5548C15.9233 16.5036 16.0264 16.4428 16.1245 16.3737C16.214 16.298 16.2971 16.2148 16.3728 16.1252C16.4416 16.0275 16.5018 15.9238 16.5532 15.8155C16.5946 15.7029 16.6259 15.5879 16.6477 15.4699C16.6585 15.3424 16.658 15.2143 16.6574 15.0861V15.0861V15.0861L16.6571 15.0001V13.3194Z",
    fill: "#52AEFF"
  }));
};

var css_248z$2 = ".event-buttons-container {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.event-buttons-container .t-button {\n  border-radius: var(--border-radius, 8px);\n  margin-left: 8px;\n}\n.event-buttons-container .t-button.t-button-primary {\n  background-color: var(--primary-color, #f54e95);\n  color: #fff;\n  border-color: var(--primary-color, #f54e95);\n}\n.event-buttons-container .t-button.t-button-primary:hover {\n  background: var(--primary-background-hover-color, #eb4b8f);\n  border-color: var(--primary-background-hover-color, #eb4b8f);\n}\n.event-buttons-container .t-button.t-button-link {\n  color: #52aeff;\n}\n.event-buttons-container .t-button.t-button-link:hover {\n  color: #52aeff;\n}\n.event-buttons-container .t-button.t-button-default {\n  background: #f2f2f3;\n  color: var(--text-dark-100, #262626);\n  border: none;\n}\n.event-buttons-container .t-button.t-button-small {\n  border-radius: var(--border-radius, 8px);\n}\n.event-buttons-container .t-button.t-button-fullwidth {\n  width: 100%;\n}\n.event-buttons-container .t-button.t-button-dashed {\n  text-align: center;\n  background: #f2f2f3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n.event-buttons-container .t-button.t-button-dashed:hover {\n  background: #eaeaeb;\n  border-color: #eaeaeb;\n  color: black;\n}\n.event-buttons-container .t-button.t-button-dashed:focus {\n  background: #eaeaeb;\n  border-color: #eaeaeb;\n  color: black;\n}\n";
styleInject(css_248z$2);

const EventButton = ({
  size = 'middle',
  type = 'primary',
  fullWidth = false,
  reset = false,
  group,
  getTrainingLink,
  getPlacementTestResultsForGroupMember
}) => {
  const newTypes = {
    reset: 'dashed',
    primary: 'primary',
    link: 'link',
    default: 'default',
    text: 'text',
    ghost: 'ghost'
  };
  const classNames = ['t-button', `t-button-${newTypes[type]}`, `t-button-${size}`];

  if (fullWidth) {
    classNames.push('t-button-fullwidth');
  }

  if (reset) {
    classNames.push('t-button-reset');
  }

  const [disabled, setDisabled] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const getLinks = useCallback(type => __awaiter(void 0, void 0, void 0, function* () {
    const {
      link
    } = yield getTrainingLink(type, group);

    if (!link) {
      setDisabled(true);
      return;
    }

    return link;
  }), [getTrainingLink]);

  const setProps = () => {
    const buttonsProps = [];

    if (get$3(group, 'practice', false) && get$3(group, 'member')) {
      buttonsProps.push({
        title: 'Practice',
        color: '#f54e95',
        onButtonClick: () => __awaiter(void 0, void 0, void 0, function* () {
          return yield getPlacementTestResultsForGroupMember({
            groupId: group.id,
            userId: group.member.userId
          });
        })
      });
    }

    if (get$3(group, 'customTrainingLink')) {
      buttonsProps.push({
        titletype: 'link',
        icon: React.createElement(IconLink, {
          size: "md",
          fill: "#52AEFF"
        }),
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: () => __awaiter(void 0, void 0, void 0, function* () {
          return yield getLinks('custom');
        })
      });
      return buttonsProps;
    }

    if (get$3(group, 'apps.lessonspace.enable')) {
      buttonsProps.push({
        title: '',
        icon: React.createElement(IconLink, {
          size: "md",
          fill: "#52AEFF"
        }),
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: () => __awaiter(void 0, void 0, void 0, function* () {
          return yield getLinks('lessonspace');
        })
      });
      return buttonsProps;
    }

    if (get$3(group, 'apps.zoom.enable')) {
      buttonsProps.push({
        title: '',
        icon: React.createElement(IconLink, {
          size: "md",
          fill: "#52AEFF"
        }),
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: () => __awaiter(void 0, void 0, void 0, function* () {
          return yield getLinks('zoom');
        })
      });
      return buttonsProps;
    }

    if (get$3(group, 'apps.liveboard.enable')) {
      buttonsProps.push({
        title: '',
        icon: React.createElement(IconLink, {
          size: "md",
          fill: "#52AEFF"
        }),
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: () => __awaiter(void 0, void 0, void 0, function* () {
          return yield getLinks('liveboard');
        })
      });
      return buttonsProps;
    }

    return buttonsProps;
  };

  const buttonsProps = setProps();
  return React.createElement("div", {
    className: "event-buttons-container"
  }, buttonsProps.map((buttonProps, index) => React.createElement(_Button, {
    key: index,
    className: classNames.join(' '),
    style: {
      backgroundColor: buttonProps.color,
      borderColor: buttonProps.color
    },
    type: buttonProps.type,
    loading: buttonLoading,
    disabled: disabled,
    icon: buttonProps.icon,
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      setButtonLoading(true);
      let link = null;

      try {
        link = yield buttonProps.onButtonClick();
      } catch (e) {
        setDisabled(true);
      } finally {
        setButtonLoading(false);
      }

      if (!link) {
        setDisabled(true);
        return;
      }

      window.location.href = link;
    })
  }, buttonProps.title)));
};

var css_248z$3 = ".t-text-input {\n  border-radius: var(--border-radius, 8px);\n  color: #1e093c;\n  letter-spacing: 0.28px;\n}\n.t-text-input.ant-input {\n  border-radius: var(--border-radius, 8px);\n}\n.t-text-input:hover {\n  border: 1px solid #8f859e;\n}\n.t-text-input:focus {\n  border-color: #8f859e;\n  box-shadow: none;\n}\n";
styleInject(css_248z$3);

const TForm = _a => {
  var {
    onSuccess,
    onError
  } = _a,
      props = __rest(_a, ["onSuccess", "onError"]);

  return React.createElement(_Form, Object.assign({
    onFinish: onSuccess,
    onFinishFailed: onError
  }, props), props.children);
};

var css_248z$4 = ".t-text {\n  padding: 0;\n  margin: 0;\n  word-break: break-all;\n  white-space: normal;\n  color: var(--text-dark-100, #262626);\n}\n.t-text a {\n  color: inherit;\n}\n.t-text-hover:hover {\n  color: var(--primary-color, #f54e95);\n}\n.t-body {\n  font-size: 20px;\n}\n.t-body2 {\n  line-height: 24px;\n  letter-spacing: 0.3px;\n  font-weight: 300;\n  font-size: 15px;\n}\n.t-paragraph {\n  font-size: 13px;\n}\n.t-caption {\n  font-size: 12px;\n}\n.t-bold {\n  font-weight: bold;\n}\n.t-underline {\n  text-decoration: underline;\n}\n.t-semiBold {\n  font-weight: 600;\n}\n.t-text-paddingBottom-1 {\n  margin-bottom: 16px;\n}\n.t-text-paddingBottom-2 {\n  margin-bottom: 8px;\n}\n.t-text-paddingBottom-3 {\n  margin-bottom: 4px;\n}\n.t-text-paddingBottom-4 {\n  margin-bottom: 2px;\n}\n.t-text-color-primary {\n  color: var(--primary-color, #f54e95);\n}\n.t-text-color-white {\n  color: #fff;\n}\n.t-text-color-dark-100 {\n  color: var(--text-dark-100, #262626);\n}\n.t-text-color-dark-50 {\n  color: var(--text-dark-50, #909091);\n}\n.t-text-color-dark-30 {\n  color: var(--text-dark-30, #bbbbbc);\n}\n.t-text-color-dark-20 {\n  color: var(--text-dark-20, #d0d0d1);\n}\n.t-text-color-dark-10 {\n  color: var(--text-dark-10, #e6e6e7);\n}\n.t-text-color-light {\n  color: #fff;\n}\n.t-text-color-blue {\n  color: #394f93;\n}\n.t-text-color-indicator-good {\n  color: #3be3c5;\n}\n.t-text-color-indicator-caution {\n  color: #ffc960;\n}\n.t-text-color-indicator-bad {\n  color: #ff395d;\n}\n.t-text-color-indicator-neutral {\n  color: #9696ff;\n}\n.t-text-color-trial {\n  color: #3ece76;\n}\n.t-text-color-currentcolor {\n  color: currentcolor;\n}\n.t-text-row {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  height: fit-content;\n}\n.t-text-row-1 {\n  -webkit-line-clamp: 1;\n}\n.t-text-row-2 {\n  -webkit-line-clamp: 2;\n}\n.t-text-row-3 {\n  -webkit-line-clamp: 3;\n}\n.t-read-more-wrapper {\n  color: #52aeff;\n  cursor: pointer;\n}\n";
styleInject(css_248z$4);

const TText = ({
  children,
  level = 1,
  bold = false,
  semiBold = false,
  paddingBottom,
  rows,
  readMore = false,
  textColor = 'dark-100',
  title,
  innerText,
  underline = false,
  hover = false
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  const [moreText, setMoreText] = useState(false);
  const names = {
    1: 'body',
    2: 'body2',
    3: 'paragraph',
    4: 'caption'
  };
  const classNames = ['t-text', `t-${names[level]}`];
  if (bold) classNames.push('t-bold');
  if (hover) classNames.push('t-text-hover');
  if (semiBold) classNames.push('t-semiBold');
  if (paddingBottom) classNames.push(`t-text-paddingBottom-${paddingBottom}`);
  if (textColor) classNames.push(`t-text-color-${textColor}`);
  if (moreText) classNames.push('t-readMore');
  if (rows && !moreText) classNames.push(`t-text-row t-text-row-${rows}`);
  if (underline) classNames.push('t-underline');

  function buttonText() {
    if (moreText) {
      return translate('iu.read.less');
    }

    return translate('ui.read.more');
  }

  return React.createElement(React.Fragment, null, innerText ? React.createElement("p", {
    className: classNames.join(' '),
    title: title,
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  }) : React.createElement("p", {
    className: classNames.join(' '),
    title: title
  }, children), readMore && React.createElement("span", {
    className: 't-read-more-wrapper',
    style: {
      padding: 0
    },
    onClick: () => setMoreText(!moreText)
  }, buttonText()));
};

var css_248z$5 = ".t-tag {\n  font-size: 13px;\n  color: #fff;\n  border-radius: var(--border-radius, 8px);\n  padding: 2px 8px 3px 8px;\n}\n.t-tag.t-tag-warning {\n  background-color: #f7b500;\n}\n.t-tag.t-tag-wrong {\n  background-color: #ff6464;\n}\n.t-tag.t-tag-positive {\n  background-color: #52aeff;\n}\n.t-tag.t-tag-trial {\n  background-color: #3ece76;\n}\n.t-tag.t-tag-neutral {\n  background-color: #9696ff;\n}\n.t-tag.t-tag-good {\n  background-color: #3be3c5;\n}\n.t-tag.t-tag-default-white {\n  background-color: #fff;\n  color: var(--text-dark-100, #262626);\n  border: 1px solid #bbbbbc;\n}\n.t-tag.t-tag-shadow-white {\n  background-color: #fff;\n  color: var(--text-dark-100, #262626);\n  border: 1px solid #f7f7f8;\n  box-sizing: border-box;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n";
styleInject(css_248z$5);

const TTag = _a => {
  var {
    children,
    style,
    type = 'positive'
  } = _a,
      props = __rest(_a, ["children", "style", "type"]);

  const classNames = ['t-tag', `t-tag-${type}`];
  return React.createElement("span", Object.assign({
    style: style,
    className: classNames.join(' ')
  }, props), children);
};

var css_248z$6 = ".t-attendanceTag {\n  font-size: 13px;\n  color: #fff;\n  border-radius: 2px;\n  padding: 4px;\n  display: block;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.t-attendanceTag .t-note-indicator {\n  position: absolute;\n  right: -2px;\n  top: -1px;\n}\n.t-attendanceTag.t-attendanceTag-warning {\n  background-color: #f7b500;\n}\n.t-attendanceTag.t-attendanceTag-wrong {\n  background-color: #ff6464;\n}\n.t-attendanceTag.t-attendanceTag-positive {\n  background-color: #52aeff;\n}\n.t-attendanceTag.t-attendanceTag-trial {\n  background-color: #3ece76;\n}\n.t-attendanceTag.t-attendanceTag-neutral {\n  background-color: #9696ff;\n}\n.t-attendanceTag.t-attendanceTag-good {\n  background-color: #3be3c5;\n}\n.t-attendanceTag.t-attendanceTag-lighter {\n  background-color: #f7f7f8;\n}\n";
styleInject(css_248z$6);

const img = "data:image/svg+xml,%3csvg width='8' height='8' viewBox='0 0 6 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='3' cy='3' r='2.7' fill='%239696FF' stroke='white' strokeWidth='0.6'/%3e%3c/svg%3e";

const TAttendanceTag = _a => {
  var {
    children,
    size = 'md',
    type = 'positive',
    note = false
  } = _a,
      props = __rest(_a, ["children", "size", "type", "note"]);

  const classNames = ['t-attendanceTag', `t-attendanceTag-${type}`];
  const sizes = {
    sm: {
      minWidth: 20,
      mineight: 20
    },
    md: {
      minWidth: 24,
      height: 24
    },
    lg: {
      minWidth: 36,
      height: 36
    }
  };
  return React.createElement("span", Object.assign({
    style: sizes[size],
    className: classNames.join(' ')
  }, props), !!note && React.createElement("img", {
    className: "t-note-indicator",
    alt: "note",
    src: img
  }), children);
};

var InputTypes;

(function (InputTypes) {
  InputTypes["BUTTON"] = "button";
  InputTypes["CHECKBOX"] = "checkbox";
  InputTypes["COLOR"] = "color";
  InputTypes["DATE"] = "date";
  InputTypes["DATETIME_LOCAL"] = "datetime-local";
  InputTypes["EMAIL"] = "email";
  InputTypes["FILE"] = "file";
  InputTypes["HIDDEN"] = "hidden";
  InputTypes["IMAGE"] = "image";
  InputTypes["MONTH"] = "month";
  InputTypes["NUMBER"] = "number";
  InputTypes["PASSWORD"] = "password";
  InputTypes["RADIO"] = "radio";
  InputTypes["RANGE"] = "range";
  InputTypes["RESET"] = "reset";
  InputTypes["SEARCH"] = "search";
  InputTypes["SUBMIT"] = "submit";
  InputTypes["TEL"] = "tel";
  InputTypes["TEXT"] = "text";
  InputTypes["TIME"] = "time";
  InputTypes["URL"] = "url";
  InputTypes["WEEK"] = "week";
})(InputTypes || (InputTypes = {}));

var SelectTypes;

(function (SelectTypes) {
  SelectTypes["BUTTON"] = "button";
  SelectTypes["CHECKBOX"] = "checkbox";
  SelectTypes["COLOR"] = "color";
  SelectTypes["DATE"] = "date";
  SelectTypes["DATETIME_LOCAL"] = "datetime-local";
  SelectTypes["EMAIL"] = "email";
  SelectTypes["FILE"] = "file";
  SelectTypes["HIDDEN"] = "hidden";
  SelectTypes["IMAGE"] = "image";
  SelectTypes["MONTH"] = "month";
  SelectTypes["NUMBER"] = "number";
  SelectTypes["PASSWORD"] = "password";
  SelectTypes["RADIO"] = "radio";
  SelectTypes["RANGE"] = "range";
  SelectTypes["RESET"] = "reset";
  SelectTypes["SEARCH"] = "search";
  SelectTypes["SUBMIT"] = "submit";
  SelectTypes["TEL"] = "tel";
  SelectTypes["TEXT"] = "text";
  SelectTypes["TIME"] = "time";
  SelectTypes["URL"] = "url";
  SelectTypes["WEEK"] = "week";
})(SelectTypes || (SelectTypes = {}));

var TagTypes;

(function (TagTypes) {
  TagTypes["WARNING"] = "warning";
  TagTypes["WRONG"] = "wrong";
  TagTypes["POSITIVE"] = "positive";
  TagTypes["TRIAL"] = "trial";
  TagTypes["NEUTRAL"] = "neutral";
  TagTypes["DEFAULT_WHITE"] = "default-white";
  TagTypes["SHADOW_WHITE"] = "shadow-white";
})(TagTypes || (TagTypes = {}));

var AttendanceTagTypes;

(function (AttendanceTagTypes) {
  AttendanceTagTypes["SM"] = "sm";
  AttendanceTagTypes["LG"] = "lg";
  AttendanceTagTypes["MD"] = "md";
})(AttendanceTagTypes || (AttendanceTagTypes = {}));

var StatusType;

(function (StatusType) {
  StatusType["SUCCESS"] = "success";
  StatusType["PROCESSING"] = "processing";
  StatusType["ERROR"] = "error";
  StatusType["DEFAULT"] = "default";
  StatusType["WARNING"] = "warning";
})(StatusType || (StatusType = {}));

var SummeryType;

(function (SummeryType) {
  SummeryType["LARGE"] = "large";
  SummeryType["MEDIUM"] = "medium";
  SummeryType["SMALL"] = "small";
  SummeryType["EXTRASMALL"] = "extraSmall";
})(SummeryType || (SummeryType = {}));

var TabsSizeType;

(function (TabsSizeType) {
  TabsSizeType["DEFAULT"] = "default";
  TabsSizeType["LARGE"] = "large";
  TabsSizeType["SMALL"] = "small";
})(TabsSizeType || (TabsSizeType = {}));

var PaymentTypes;

(function (PaymentTypes) {
  PaymentTypes["STRIPE"] = "stripe";
  PaymentTypes["ARCA"] = "arca";
  PaymentTypes["OMISE"] = "omise";
})(PaymentTypes || (PaymentTypes = {}));

const TTextInput = _a => {
  var {
    size = 'middle',
    type = InputTypes.TEXT,
    disabled = false,
    label,
    value,
    name,
    rules = [],
    dependencies = [],
    autoFocus = false
  } = _a,
      props = __rest(_a, ["size", "type", "disabled", "label", "value", "name", "rules", "dependencies", "autoFocus"]);

  const input = React.createElement(_Input, Object.assign({
    size: size,
    className: "t-text-input",
    value: value,
    type: type,
    autoFocus: autoFocus
  }, props));
  return name ? React.createElement(_Form.Item, {
    dependencies: dependencies,
    label: label,
    name: name,
    initialValue: value,
    rules: rules
  }, input) : input;
};

var css_248z$7 = ".search-bar {\n  background: #f7f7f8;\n  border: none;\n  border-radius: 44px;\n  padding: 0px 14px 0px 7px;\n}\n.search-bar .button:hover {\n  background-color: #f7f7f8;\n}\n.search-bar .icon {\n  color: var(--text-dark-30, #bbbbbc);\n}\n.search-bar .ant-input {\n  background: #f7f7f8;\n}\n.search-bar:focus {\n  border: none;\n  box-shadow: none;\n}\n";
styleInject(css_248z$7);

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var tinycolor = createCommonjsModule(function (module) {
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else {
    window.tinycolor = tinycolor;
}

})(Math);
});

var generate_1 = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(tinycolor);
var hueStep = 2; // 色相阶梯
var saturationStep = 16; // 饱和度阶梯，浅色部分
var saturationStep2 = 5; // 饱和度阶梯，深色部分
var brightnessStep1 = 5; // 亮度阶梯，浅色部分
var brightnessStep2 = 15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下
function getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
        hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    }
    else {
        hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    }
    if (hue < 0) {
        hue += 360;
    }
    else if (hue >= 360) {
        hue -= 360;
    }
    return hue;
}
function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) {
        return hsv.s;
    }
    var saturation;
    if (light) {
        saturation = Math.round(hsv.s * 100) - saturationStep * i;
    }
    else if (i === darkColorCount) {
        saturation = Math.round(hsv.s * 100) + saturationStep;
    }
    else {
        saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    }
    // 边界值修正
    if (saturation > 100) {
        saturation = 100;
    }
    // 第一格的 s 限制在 6-10 之间
    if (light && i === lightColorCount && saturation > 10) {
        saturation = 10;
    }
    if (saturation < 6) {
        saturation = 6;
    }
    return saturation;
}
function getValue(hsv, i, light) {
    if (light) {
        return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }
    return Math.round(hsv.v * 100) - brightnessStep2 * i;
}
function generate(color) {
    var patterns = [];
    var pColor = tinycolor2_1.default(color);
    for (var i = lightColorCount; i > 0; i -= 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i, true),
            s: getSaturation(hsv, i, true),
            v: getValue(hsv, i, true),
        }).toHexString();
        patterns.push(colorString);
    }
    patterns.push(pColor.toHexString());
    for (var i = 1; i <= darkColorCount; i += 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i),
            s: getSaturation(hsv, i),
            v: getValue(hsv, i),
        }).toHexString();
        patterns.push(colorString);
    }
    return patterns;
}
exports.default = generate;
});

var lib = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1$1 = __importDefault(generate_1);
exports.generate = generate_1$1.default;
var presetPrimaryColors = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666',
};
exports.presetPrimaryColors = presetPrimaryColors;
var presetPalettes = {};
exports.presetPalettes = presetPalettes;
Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = generate_1$1.default(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];
});
var red = presetPalettes.red;
exports.red = red;
var volcano = presetPalettes.volcano;
exports.volcano = volcano;
var gold = presetPalettes.gold;
exports.gold = gold;
var orange = presetPalettes.orange;
exports.orange = orange;
var yellow = presetPalettes.yellow;
exports.yellow = yellow;
var lime = presetPalettes.lime;
exports.lime = lime;
var green = presetPalettes.green;
exports.green = green;
var cyan = presetPalettes.cyan;
exports.cyan = cyan;
var blue = presetPalettes.blue;
exports.blue = blue;
var geekblue = presetPalettes.geekblue;
exports.geekblue = geekblue;
var purple = presetPalettes.purple;
exports.purple = purple;
var magenta = presetPalettes.magenta;
exports.magenta = magenta;
var grey = presetPalettes.grey;
exports.grey = grey;
});

/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
/* eslint-enable */

var containers = []; // will store container HTMLElement references
var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}

var usage = 'insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).';

function insertCss(css, options) {
    options = options || {};

    if (css === undefined) {
        throw new Error(usage);
    }

    var position = options.prepend === true ? 'prepend' : 'append';
    var container = options.container !== undefined ? options.container : document.querySelector('head');
    var containerId = containers.indexOf(container);

    // first time we see this container, create the necessary entries
    if (containerId === -1) {
        containerId = containers.push(container) - 1;
        styleElements[containerId] = {};
    }

    // try to get the correponding container + position styleElement, create it otherwise
    var styleElement;

    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
        styleElement = styleElements[containerId][position];
    } else {
        styleElement = styleElements[containerId][position] = createStyleElement();

        if (position === 'prepend') {
            container.insertBefore(styleElement, container.childNodes[0]);
        } else {
            container.appendChild(styleElement);
        }
    }

    // strip potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xFEFF) { css = css.substr(1, css.length); }

    // actually add the stylesheet
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText += css;
    } else {
        styleElement.textContent += css;
    }

    return styleElement;
}
function createStyleElement() {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    return styleElement;
}

var insertCss_1 = insertCss;
var insertCss_2 = insertCss;
insertCss_1.insertCss = insertCss_2;

function warning$1(valid, message) {
  warningOnce(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return React.createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return React.createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return lib.generate(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var cssInjectedFlag = false;
var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;
  useEffect(function () {
    if (!cssInjectedFlag) {
      insertCss_2(styleStr, {
        prepend: true
      });
      cssInjectedFlag = true;
    }
  }, []);
};

var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties(props, ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"]);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }

  useInsertStyles();
  warning$1(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!isIconDefinition(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return generate(target.icon, "svg-".concat(target.name), _objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = IconBase.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

// should move it to antd main repo?

setTwoToneColor('#1890ff');
var Icon$1 = forwardRef(function (props, ref) {
  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties(props, ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]);

  var classString = classnames('anticon', _defineProperty({}, "anticon-".concat(icon.name), Boolean(icon.name)), className);
  var svgClassString = classnames({
    'anticon-spin': !!spin || icon.name === 'loading'
  });
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return createElement("span", Object.assign({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), createElement(IconBase, {
    className: svgClassString,
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon$1.displayName = 'AntdIcon';
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;

// This icon file is generated automatically.
var EllipsisOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EllipsisOutlined$1 = function EllipsisOutlined$1(props, ref) {
  return createElement(Icon$1, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlined
  }));
};

EllipsisOutlined$1.displayName = 'EllipsisOutlined';
var EllipsisOutlined$2 = forwardRef(EllipsisOutlined$1);

// This icon file is generated automatically.
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SearchOutlined$1 = function SearchOutlined$1(props, ref) {
  return createElement(Icon$1, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlined
  }));
};

SearchOutlined$1.displayName = 'SearchOutlined';
var SearchOutlined$2 = forwardRef(SearchOutlined$1);

const TSearch = _a => {
  var {
    onSearch = () => {}
  } = _a,
      props = __rest(_a, ["onSearch"]);

  return React.createElement(_Input, Object.assign({
    className: "search-bar"
  }, props, {
    prefix: React.createElement(_Button, {
      onClick: onSearch,
      block: true,
      type: "text",
      shape: "circle",
      className: "button",
      icon: React.createElement(SearchOutlined$2, {
        className: "icon"
      })
    })
  }));
};

const Password = _a => {
  var {
    size = 'middle',
    type = InputTypes.TEXT,
    disabled = false,
    label,
    value,
    name,
    rules = [],
    dependencies = []
  } = _a,
      props = __rest(_a, ["size", "type", "disabled", "label", "value", "name", "rules", "dependencies"]);

  const input = React.createElement(_Input.Password, Object.assign({
    size: size,
    className: "t-text-input",
    value: value,
    type: type
  }, props));
  return name ? React.createElement(_Form.Item, {
    dependencies: dependencies,
    label: label,
    name: name,
    initialValue: value,
    rules: rules
  }, input) : input;
};

const Inputs = TTextInput;
Inputs.Search = TSearch;
Inputs.Password = Password;

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    } // Add event listener


    window.addEventListener('resize', handleResize); // Call handler right away so state gets updated with initial window size

    handleResize(); // Remove event listener on cleanup

    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

var css_248z$8 = ".t-popup-item .ant-menu-vertical {\n  padding: 12px;\n}\n.t-popup-item .navMenuItem {\n  height: 40px !important;\n  line-height: 40px !important;\n  border-radius: 4px !important;\n}\n.t-popup-item .ant-menu-item-selected svg path,\n.t-popup-item .ant-menu-item-active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-popup-item .navMenuItem svg path {\n  transition-duration: 0.3s;\n  transition: 0.3s;\n}\n.t-navbar.ant-menu-horizontal .ant-menu-item {\n  margin: -1px !important;\n  padding: 0 24px !important;\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu {\n  padding-left: 16px !important;\n  padding-right: 16px;\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu .ant-menu-item {\n  margin-left: 0;\n  margin-right: 0;\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu-selected .ant-menu-submenu-title svg path,\n.t-navbar.ant-menu-inline .ant-menu-submenu-active .ant-menu-submenu-title svg path,\n.t-navbar.ant-menu-inline .ant-menu-submenu-selected .ant-menu-submenu-title svg rect,\n.t-navbar.ant-menu-inline .ant-menu-submenu-active .ant-menu-submenu-title svg rect {\n  fill: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu-selected .ant-menu-submenu-title i,\n.t-navbar.ant-menu-inline .ant-menu-submenu-active .ant-menu-submenu-title i {\n  color: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-item {\n  width: auto;\n  margin-left: 16px;\n  margin-right: 16px;\n  padding-left: 16px !important;\n  padding-right: 16px;\n  transition: border-color 0.3s, background 0.3s, padding 0.15s, margin 0.15s ease-in-out;\n}\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-active svg path,\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-active svg rect {\n  fill: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected {\n  border-radius: var(--border-radius, 8px);\n  background-color: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected svg path,\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected svg rect {\n  fill: #fff;\n}\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected:after {\n  border: 0;\n}\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected a,\n.t-navbar.ant-menu-inline .ant-menu-item.ant-menu-item-selected a:hover {\n  color: #fff;\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu-title {\n  padding-left: 16px !important;\n  padding-right: 16px;\n}\n.t-navbar.ant-menu-inline .ant-menu-submenu-title span:nth-child(2) {\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline {\n  padding-left: 32px !important;\n  padding-right: 32px;\n  background: none;\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item {\n  padding-left: 16px !important;\n  padding-right: 16px;\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected {\n  border-radius: var(--border-radius, 8px);\n  background-color: var(--primary-color, #f54e95);\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected svg path,\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected svg rect {\n  fill: #fff;\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected:after {\n  border: 0;\n}\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected a,\n.t-navbar.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item-selected a:hover {\n  color: #fff;\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-title {\n  padding: 0 calc(50% - 12px);\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-title span:nth-child(2) {\n  opacity: 0;\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-item {\n  padding: 0 calc(50% - 12px);\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-item-selected,\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-selected {\n  background-color: var(--primary-color, #f54e95);\n  border-radius: var(--border-radius, 8px);\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-item-selected svg path,\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-selected svg path,\n.t-sider .ant-menu-inline-collapsed .ant-menu-item-selected svg rect,\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-selected svg rect {\n  fill: #fff;\n}\n.t-sider .ant-menu-inline-collapsed .ant-menu-item-active:not(.ant-menu-item-selected) svg path,\n.t-sider .ant-menu-inline-collapsed .ant-menu-submenu-active:not(.ant-menu-submenu-selected) svg path {\n  fill: var(--primary-color, #f54e95);\n}\n";
styleInject(css_248z$8);

const TNavbar = ({
  navigation,
  mode = 'vertical',
  current,
  setCurrent = () => {},
  onClick = () => {},
  onOpenChange,
  height
}) => {
  const itemClicked = e => {
    setCurrent(e.key);
    onClick(e);
  };

  function getSubMenu(navigation) {
    return navigation.map(item => {
      if (item.component) {
        return item.component;
      } else if (item.subMenu) {
        const children = getSubMenu(item.subMenu);
        return React.createElement(_Menu.SubMenu, {
          key: item.key,
          icon: item.icon,
          title: item.content,
          style: {
            height: height,
            lineHeight: height
          },
          popupClassName: "t-popup-item"
        }, children);
      } else {
        return React.createElement(_Menu.Item, {
          key: item.key,
          icon: item.icon,
          className: "navMenuItem",
          style: {
            height: height,
            lineHeight: height
          }
        }, item.content);
      }
    });
  }

  const menuItems = getSubMenu(navigation);
  return React.createElement(_Menu, {
    className: "t-navbar",
    onClick: itemClicked,
    onOpenChange: onOpenChange,
    mode: mode,
    selectedKeys: current,
    defaultOpenKeys: mode === 'inline' ? current : [],
    style: {
      height: height,
      lineHeight: height
    },
    forceSubMenuRender: true
  }, menuItems);
};

var css_248z$9 = ".t-toolbar-popup-item .ant-menu-item {\n  border-radius: 4px;\n}\n.t-toolbar-popup-item .ant-menu-vertical .ant-menu-item-selected,\n.t-toolbar-popup-item .ant-menu-vertical .ant-menu-item-active {\n  color: var(--primary-color, #f54e95);\n}\n.t-toolbar-popup-item .ant-menu-vertical .ant-menu-item-selected svg path,\n.t-toolbar-popup-item .ant-menu-vertical .ant-menu-item-active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-toolbar-inline {\n  position: absolute;\n  bottom: 16px;\n  width: 100%;\n}\n.t-toolbar-inline .ant-menu-inline .ant-menu-item {\n  width: auto;\n  padding-left: 16px !important;\n  padding-right: 16px;\n  margin-left: 16px;\n  margin-right: 16px;\n}\n";
styleInject(css_248z$9);

const TToolbar = ({
  items,
  mode = 'vertical',
  onClick
}) => {
  return React.createElement("div", {
    className: `t-toolbar t-toolbar-${mode}`
  }, items.map((item, index) => {
    let children = null;

    if (item.subMenu) {
      children = item.subMenu.map(child => {
        return React.createElement(_Menu.Item, {
          key: child.key
        }, child.content);
      });
      children = React.createElement(_Menu.SubMenu, {
        className: "t-submenu",
        key: item.key,
        icon: item.icon,
        title: item.content,
        popupClassName: "t-toolbar-popup-item"
      }, children);
    } else {
      children = React.createElement(_Menu.Item, {
        key: item.key,
        icon: item.icon
      }, item.content);
    }

    return React.createElement(_Menu, {
      key: `menu-${index}`,
      mode: mode,
      onClick: onClick,
      selectable: false
    }, children);
  }));
};

const IconHamburger = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M3.35992 3.84009C2.56492 3.84009 1.91992 4.48509 1.91992 5.28009C1.91992 6.07509 2.56492 6.72009 3.35992 6.72009H20.6399C21.4349 6.72009 22.0799 6.07509 22.0799 5.28009C22.0799 4.48509 21.4349 3.84009 20.6399 3.84009H3.35992ZM3.35992 10.5601C2.56492 10.5601 1.91992 11.2051 1.91992 12.0001C1.91992 12.7951 2.56492 13.4401 3.35992 13.4401H20.6399C21.4349 13.4401 22.0799 12.7951 22.0799 12.0001C22.0799 11.2051 21.4349 10.5601 20.6399 10.5601H3.35992ZM3.35992 17.2801C2.56492 17.2801 1.91992 17.9251 1.91992 18.7201C1.91992 19.5151 2.56492 20.1601 3.35992 20.1601H20.6399C21.4349 20.1601 22.0799 19.5151 22.0799 18.7201C22.0799 17.9251 21.4349 17.2801 20.6399 17.2801H3.35992Z",
    fill: fill || '#262626'
  }));
};

var css_248z$a = ".t-header-horizontal {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: auto;\n  padding: 0 24px;\n  line-height: normal;\n  background: #fff;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid #e8e8e8;\n}\n.t-header-horizontal .t-logo {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.t-header-horizontal nav {\n  flex: 1;\n  min-width: 0;\n}\n.t-header-horizontal nav .t-toggle-button {\n  display: none;\n  width: 56px;\n  font-size: 20px;\n  cursor: pointer;\n}\n@media screen and (max-width: 768px) {\n  .t-header-horizontal nav .t-toggle-button {\n    display: block;\n    flex: none;\n  }\n}\n.t-header-horizontal nav .ant-menu-horizontal {\n  text-align: right;\n}\n.t-header-horizontal nav .ant-menu-horizontal.ant-menu-overflow {\n  justify-content: flex-end;\n}\n@media screen and (max-width: 768px) {\n  .t-header-horizontal nav .ant-menu-horizontal {\n    display: none;\n  }\n}\n.t-header-horizontal .t-toolbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.t-header-horizontal .t-toolbar .t-submenu {\n  vertical-align: middle;\n  border-bottom: none;\n  margin: 0;\n}\n.t-header-horizontal .t-toolbar .t-submenu:hover,\n.t-header-horizontal .t-toolbar .t-submenu:hover::after,\n.t-header-horizontal .t-toolbar .ant-menu-submenu::after,\n.t-header-horizontal .t-toolbar .ant-menu-submenu-selected::after,\n.t-header-horizontal .t-toolbar .ant-menu-submenu-open::after,\n.t-header-horizontal .t-toolbar .ant-menu-submenu-active::after {\n  border-bottom-color: transparent !important;\n  border-bottom: none !important;\n}\n.t-header-horizontal .t-toolbar .ant-menu-horizontal {\n  min-width: 6em;\n}\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-item:hover,\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-submenu:hover,\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-item.ant-menu-item-selected,\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-selected,\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-open,\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-active {\n  border-bottom-color: transparent !important;\n  border-bottom: none !important;\n}\n.t-header-horizontal .t-toolbar .ant-menu-horizontal .ant-menu-submenu-title {\n  display: flex;\n  align-items: center;\n}\n.t-header-horizontal .ant-menu-item::after,\n.t-header-horizontal .ant-menu-submenu::after {\n  left: 0;\n  right: 0;\n}\n.t-header-horizontal .ant-menu-horizontal {\n  border-bottom: none;\n}\n.t-header-horizontal .ant-menu-horizontal .ant-menu-item svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu .ant-menu-submenu-title svg path {\n  transition-duration: 0.3s;\n  transition: 0.3s;\n  transition-property: fill;\n}\n.t-header-horizontal .ant-menu-horizontal .ant-menu-item:hover,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-item.ant-menu-item-selected,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-active,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-selected,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-open,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu:hover {\n  color: var(--primary-color, #f54e95);\n  border-bottom-color: var(--primary-color, #f54e95);\n}\n.t-header-horizontal .ant-menu-horizontal .ant-menu-item:hover svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-item.ant-menu-item-selected svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-active svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-selected svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu.ant-menu-submenu-open svg path,\n.t-header-horizontal .ant-menu-horizontal .ant-menu-submenu:hover svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-header-horizontal .ant-drawer-content-wrapper {\n  display: none;\n}\n.t-header-horizontal .ant-menu-submenu-vertical {\n  height: 40px;\n  line-height: 40px;\n  border-radius: 4px;\n  padding: 0;\n  transition-duration: 0.3s;\n  transition: 0.3s;\n}\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-selected .ant-menu-submenu-title,\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-active .ant-menu-submenu-title {\n  background: #fff0f4;\n}\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-selected .ant-menu-submenu-title svg path,\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-active .ant-menu-submenu-title svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-selected .ant-menu-item:not(.ant-menu-item-selected):not(:hover) a,\n.t-header-horizontal .ant-menu-vertical .ant-menu-submenu-active .ant-menu-item:not(.ant-menu-item-selected):not(:hover) a {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-menu-inline {\n  border-right: none;\n}\n.ant-drawer-left .ant-drawer-content-wrapper {\n  width: 20rem !important;\n}\n.ant-drawer-left .ant-drawer-header-title {\n  flex-direction: row-reverse;\n}\n.mobile_drawer .mobile_drawer_avatar {\n  display: flex;\n  justify-content: flex-end;\n}\n.mobile_drawer button.ant-drawer-close {\n  display: flex;\n  left: 0;\n}\n.mobile_drawer .ant-menu-vertical {\n  height: 0 !important;\n}\n.mobile_drawer .ant-drawer-content-wrapper {\n  width: 15rem !important;\n}\n";
styleInject(css_248z$a);

const Header = ({
  logo,
  avatar,
  navigation,
  toolbar,
  drawer,
  current,
  setCurrent,
  onClick,
  onOpenChange,
  height
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);
  const size = useWindowSize();
  const mobile = size.width < 769;
  const handleOpenDrawer = useCallback(() => {
    setDrawerVisible(true);
  }, []);
  const handleCloseDrawer = useCallback(() => {
    setDrawerVisible(false);
  }, []);
  const handleOpenMobileDrawer = useCallback(() => {
    setMobileDrawerVisible(true);
  }, []);
  const handleCloseMobileDrawer = useCallback(() => {
    setMobileDrawerVisible(false);
  }, []);
  return React.createElement("div", {
    className: "t-header t-header-horizontal"
  }, !mobile && React.createElement("div", {
    className: "t-logo t-logo-desktop"
  }, logo), React.createElement("nav", null, React.createElement("div", {
    className: "t-toggle-button",
    onClick: handleOpenDrawer
  }, React.createElement(IconHamburger, {
    size: "md",
    fill: "currentcolor"
  })), React.createElement(TNavbar, {
    mode: "horizontal",
    navigation: navigation,
    setCurrent: setCurrent,
    current: current,
    onClick: onClick,
    height: height,
    onOpenChange: onOpenChange
  }), React.createElement(_Drawer, {
    title: logo,
    placement: "left",
    visible: drawerVisible,
    onClose: handleCloseDrawer
  }, React.createElement(TNavbar, {
    mode: "vertical",
    onClick: handleCloseDrawer,
    navigation: navigation,
    setCurrent: setCurrent,
    current: current,
    // onClick={onClick}
    height: height,
    onOpenChange: onOpenChange
  }))), mobile && React.createElement("div", {
    className: "t-logo t-logo-mobile"
  }, logo), !mobile ? React.createElement(TToolbar, {
    mode: "horizontal",
    items: toolbar,
    onClick: onClick
  }) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "t-toggle-button",
    onClick: handleOpenMobileDrawer
  }, avatar), React.createElement(_Drawer, {
    title: React.createElement("div", {
      className: "mobile_drawer_avatar"
    }, avatar),
    placement: "right",
    className: "mobile_drawer",
    visible: mobileDrawerVisible,
    onClose: handleCloseMobileDrawer
  }, React.createElement(TNavbar, {
    mode: "vertical",
    navigation: drawer,
    setCurrent: setCurrent,
    current: current,
    onClick: handleCloseMobileDrawer,
    height: height,
    onOpenChange: onOpenChange
  }))));
};

const IconHamburgerNew = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props, {
    fill: "none"
  }), React.createElement("path", {
    d: "M1 1H17M1 7H11M1 13H5",
    stroke: props.fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var css_248z$b = ".t-sider {\n  background: none;\n  box-shadow: var(--box-shadow-right, 2px 0px 4px 0px rgba(119, 110, 171, 0.12));\n  border-right: 1px solid #f7f7f8;\n  min-height: 100vh;\n}\n@media screen and (max-width: 768px) {\n  .t-sider {\n    display: none;\n  }\n}\n.t-sider .t-logo {\n  width: 100%;\n  opacity: 1;\n  transition: width 0.3s, opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.t-sider.ant-layout-sider-collapsed .t-logo {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n}\n.t-sider.ant-layout-sider-collapsed .t-header-vertical .t-logo-wrapper .t-switcher {\n  position: relative;\n  text-align: center;\n  right: initial;\n  top: initial;\n}\n.t-sider .t-header-vertical .ant-menu-vertical {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.t-sider .t-header-vertical .t-logo-wrapper {\n  position: relative;\n  padding: 16px 32px;\n  border-bottom: 1px solid #f7f7f8;\n  height: var(--header-height, 90px);\n}\n.t-sider .t-header-vertical .t-logo-wrapper .t-switcher {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  margin-top: 20px;\n  cursor: pointer;\n  z-index: 10;\n}\n.t-sider .t-header-vertical .t-logo-wrapper .t-switcher svg path {\n  stroke: var(--primary-color, #f54e95);\n}\n@media screen and (max-width: 768px) {\n  .t-sider .t-header-vertical .t-logo-wrapper .t-switcher {\n    display: block;\n  }\n}\n.t-drawer-wrapper {\n  display: none;\n}\n@media screen and (max-width: 768px) {\n  .t-drawer-wrapper {\n    display: block;\n  }\n}\n.t-drawer-wrapper .t-logo-wrapper {\n  position: fixed;\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  height: var(--header-height-mobile, 70px);\n  z-index: 10;\n}\n.t-drawer-wrapper .t-logo-wrapper .t-toggle-button {\n  display: none;\n  width: 56px;\n  text-align: center;\n  font-size: 20px;\n  cursor: pointer;\n  margin-right: 32px;\n  margin-top: 12px;\n}\n.t-drawer-wrapper .t-logo-wrapper .t-toggle-button svg path {\n  stroke: var(--primary-color, #f54e95);\n}\n@media screen and (max-width: 768px) {\n  .t-drawer-wrapper .t-logo-wrapper .t-toggle-button {\n    display: block;\n  }\n}\n.t-drawer .ant-drawer-header {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  height: var(--header-height-mobile, 70px);\n}\n.t-drawer .ant-menu {\n  border-right: none;\n}\n.t-drawer .ant-menu .ant-menu-item-selected {\n  border-radius: var(--border-radius, 8px);\n  background-color: var(--primary-color, #f54e95);\n}\n.t-drawer .ant-menu .ant-menu-item-selected svg path {\n  fill: #fff;\n}\n.t-drawer .ant-menu .ant-menu-item-selected a,\n.t-drawer .ant-menu .ant-menu-item-selected a:hover {\n  color: #fff;\n}\n.t-drawer .ant-menu .ant-menu-submenu-selected {\n  background-color: var(--primary-color, #f54e95);\n  border-radius: var(--border-radius, 8px);\n}\n.t-drawer .ant-menu .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #fff;\n}\n.t-drawer .ant-menu .ant-menu-submenu-selected .ant-menu-submenu-title i {\n  color: #fff;\n}\n.t-drawer .ant-menu .ant-menu-submenu-selected svg path {\n  fill: #fff;\n}\n.t-drawer .t-toolbar {\n  position: absolute;\n  bottom: 16px;\n}\n";
styleInject(css_248z$b);

const {
  Sider
} = _Layout;

const Header$1 = ({
  logo,
  navigation,
  toolbar,
  current,
  setCurrent,
  onClick,
  onOpenChange,
  height,
  width = '300px',
  collapsible = true,
  defaultCollapsed = false,
  onVisiblityChange
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const handleOpenDrawer = useCallback(() => {
    setDrawerVisible(true);
  }, []);
  const handleCloseDrawer = useCallback(() => {
    setDrawerVisible(false);
  }, []);
  const handleCollapseMenu = useCallback(() => {
    setCollapsed(!collapsed);
    onVisiblityChange(collapsed);
  }, [collapsed]);
  return React.createElement(React.Fragment, null, React.createElement(Sider, {
    className: "t-sider",
    trigger: null,
    collapsible: collapsible,
    collapsed: collapsed,
    width: width
  }, React.createElement("div", {
    className: "t-header t-header-vertical"
  }, React.createElement("div", {
    className: "t-logo-wrapper"
  }, React.createElement("div", {
    className: "t-logo"
  }, logo), collapsible && React.createElement("div", {
    className: "t-switcher",
    onClick: handleCollapseMenu
  }, React.createElement(IconHamburgerNew, {
    size: "md"
  }))), React.createElement("nav", null, React.createElement(TNavbar, {
    mode: "inline",
    navigation: navigation,
    setCurrent: setCurrent,
    current: current,
    onClick: onClick,
    height: height,
    onOpenChange: onOpenChange
  })), React.createElement(TToolbar, {
    mode: "inline",
    items: toolbar,
    onClick: onClick
  }))), React.createElement("nav", {
    className: "t-drawer-wrapper"
  }, React.createElement("div", {
    className: "t-logo-wrapper"
  }, React.createElement("div", {
    className: "t-toggle-button",
    onClick: handleOpenDrawer
  }, React.createElement(IconHamburgerNew, {
    size: "xl"
  })), React.createElement("div", {
    className: "t-logo"
  }, logo)), React.createElement(_Drawer, {
    title: logo,
    placement: "left",
    visible: drawerVisible,
    onClose: handleCloseDrawer,
    className: "t-drawer"
  }, React.createElement(TNavbar, {
    mode: "vertical",
    // onClick={handleCloseDrawer}
    navigation: navigation,
    setCurrent: setCurrent,
    current: current,
    onClick: onClick,
    height: height,
    onOpenChange: onOpenChange
  }), React.createElement(TToolbar, {
    mode: "vertical",
    items: toolbar,
    onClick: onClick
  }))));
};

const randomColors = ['#bfdafd', '#bfc0fd', '#bfb5fd', '#bfd2fd', '#b6b5fd', '#bfe3fd', '#b5f0fd', '#bbb5fd'];

const randomHex = () => {
  return randomColors[Math.floor(Math.random() * randomColors.length)];
};

var css_248z$c = ".t-avatar-with-text-container {\n  display: flex;\n  align-items: center;\n}\n.t-avatar-with-text-container .t-avatar-text-wrapper {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n.t-avatar-with-text-container .t-avatar-container {\n  display: flex;\n  align-items: center;\n}\n.t-avatar-with-text-container .t-avatar-container .ant-avatar-string {\n  font-weight: bold;\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-dark-100 {\n  background: var(--text-dark-100, #262626);\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-dark-50 {\n  background: var(--text-dark-50, #909091);\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-dark-30 {\n  background: var(--text-dark-30, #bbbbbc);\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-dark-20 {\n  background: var(--text-dark-20, #d0d0d1);\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-dark-10 {\n  background: var(--text-dark-10, #e6e6e7);\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-indicator-good {\n  background: #3be3c5;\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-indicator-caution {\n  background: #ffc960;\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-indicator-bad {\n  background: #ff395d;\n}\n.t-avatar-with-text-container .t-avatar-container .t-avatar-wrapperBg-indicator-neutral {\n  background: #9696ff;\n}\n.t-avatar-with-text-container .t-avatar-container .avatar-text {\n  font-size: 13px;\n  letter-spacing: 0.2px;\n  padding-left: 8px;\n}\n";
styleInject(css_248z$c);

const sizeMapping = {
  xxs: 16,
  xs: 24,
  x: 32,
  sm: 40,
  md: 44,
  lg: 48,
  lm: 52,
  l: 64,
  xl: 74,
  xxl: 94,
  xxxl: 116,
  xxxxl: 200
};

const nameFirstLetters = (name = '') => {
  const arr = name.split(' ').map(s => s.trim()).filter(Boolean);

  while (arr.length > 2) {
    const minVal = min$1(arr.map(s => s.length));
    arr.splice(findLastIndex(arr, s => s.length === minVal), 1);
  }

  return arr.map(s => s.charAt(0).toLocaleUpperCase()).join('');
};

const TAvatar = _a => {
  var {
    size = 'md',
    avatarColor,
    textLevel = 2,
    children,
    boldText,
    description = '',
    textColor
  } = _a,
      props = __rest(_a, ["size", "avatarColor", "textLevel", "children", "boldText", "description", "textColor"]);

  const {
    src,
    name,
    text = ''
  } = props;
  const classNames = ['t-avatar', `t-avatar-wrapperBg-${avatarColor}`];
  const randomColorHex = useMemo(randomHex, []);
  return React.createElement("div", {
    className: `t-avatar-with-text-container`
  }, React.createElement("div", {
    className: `t-avatar-container`
  }, React.createElement(_Avatar, Object.assign({
    className: classNames.join(' '),
    size: sizeMapping[size]
  }, props, {
    style: {
      background: !src && randomColorHex
    }
  }), nameFirstLetters(name) || children)), React.createElement("div", null, text && React.createElement("div", {
    className: "t-avatar-text-wrapper"
  }, typeof text === 'string' ? React.createElement(TText, {
    textColor: textColor,
    bold: boldText,
    rows: 1,
    level: textLevel
  }, text) : text), !!description && React.createElement("div", {
    className: "t-avatar-text-wrapper"
  }, description)));
};

const IconEditPenCircle = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15.5V18H8.5L15.8665 10.6335L13.3665 8.13354L6 15.5ZM17.8001 8.69995C18.0667 8.43335 18.0667 8.03326 17.8001 7.76666L16.2333 6.19995C15.9667 5.93335 15.5667 5.93335 15.3001 6.19995L14.0667 7.43335L16.5667 9.93329L17.8001 8.69995V8.69995Z",
    fill: "white"
  }));
};

var css_248z$d = ".t-profile-avatar-container {\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 767px) {\n  .t-profile-avatar-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.t-profile-avatar-container .t-avatar-wrapper {\n  position: relative;\n  margin-right: 40px;\n}\n@media screen and (max-width: 767px) {\n  .t-profile-avatar-container .t-avatar-wrapper {\n    margin-right: 0;\n    margin-bottom: 16px;\n  }\n}\n.t-profile-avatar-container .t-avatar-wrapper .t-upload-wrapper {\n  cursor: pointer;\n  position: absolute;\n  bottom: 30px;\n  right: 0;\n}\n.t-profile-avatar-container .t-avatar-info-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n@media screen and (max-width: 767px) {\n  .t-profile-avatar-container .t-avatar-info-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n}\n";
styleInject(css_248z$d);

const sizeMapping$1 = {
  xxs: 16,
  xs: 24,
  x: 32,
  sm: 40,
  md: 44,
  lg: 48,
  lm: 52,
  l: 64,
  xl: 74,
  xxl: 94,
  xxxl: 116,
  xxxxl: 200
};

const nameFirstLetters$1 = (alt = '') => {
  const arr = alt.split(' ').map(s => s.trim()).filter(Boolean);

  while (arr.length > 2) {
    const minVal = min$1(arr.map(s => s.length));
    arr.splice(findLastIndex(arr, s => s.length === minVal), 1);
  }

  return arr.map(s => s.charAt(0).toLocaleUpperCase()).join('');
};

const ProfileAvatar = _a => {
  var {
    size = 'md',
    children,
    description,
    uploadAction,
    fileList,
    onUploadChange = () => {},
    uploadIcon = React.createElement(IconEditPenCircle, {
      size: "xl",
      fill: "black"
    })
  } = _a,
      props = __rest(_a, ["size", "children", "description", "uploadAction", "fileList", "onUploadChange", "uploadIcon"]);

  const {
    src,
    alt,
    name
  } = props;
  const classNames = ['t-avatar'];
  const randomColorHex = useMemo(randomHex, []);
  return React.createElement("div", {
    className: `t-profile-avatar-container`
  }, React.createElement("div", {
    className: `t-avatar-wrapper`
  }, React.createElement(_Avatar, Object.assign({
    className: classNames.join(' '),
    size: sizeMapping$1[size]
  }, props, {
    style: {
      background: !src && randomColorHex
    }
  }), nameFirstLetters$1(alt) || children), uploadAction && size === 'xxxxl' && React.createElement("div", {
    className: "t-upload-wrapper"
  }, React.createElement(_Upload, {
    fileList: fileList,
    showUploadList: false,
    onChange: onUploadChange,
    action: uploadAction
  }, uploadIcon))), React.createElement("div", {
    className: "t-avatar-info-wrapper"
  }, !!name && React.createElement("div", null, name), !!description && React.createElement("div", null, description)));
};

var css_248z$e = ".t-avatar-group {\n  display: flex;\n}\n.t-avatar-group .ant-avatar-image {\n  margin-right: -12px;\n}\n";
styleInject(css_248z$e);

const TAvatarGroup = ({
  maxCount,
  children,
  size
}) => {
  return React.createElement("div", {
    className: "t-avatar-group"
  }, children, React.createElement(TAvatar, {
    size: size
  }, "+", maxCount));
};

var css_248z$f = "";
styleInject(css_248z$f);

const {
  Option
} = _Select;

const TSelect = _a => {
  var {
    size = 'middle',
    options,
    useDefaultWrapper = false,
    renderItem = option => upperFirst(get$3(option, 'key'))
  } = _a,
      props = __rest(_a, ["size", "options", "useDefaultWrapper", "renderItem"]);

  const classNames = [`t-select t-select-${size}`];
  const wrapperProp = !useDefaultWrapper ? {
    getPopupContainer: trigger => trigger.parentNode
  } : '';
  return React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement(_Select, Object.assign({
    className: classNames.join(' '),
    size: size
  }, wrapperProp, props), (options || []).map(option => {
    const value = get$3(option, 'value');
    const extra = get$3(option, 'extra');
    const disabled = get$3(option, 'disabled');
    const title = get$3(option, 'title', undefined);
    return React.createElement(Option, {
      key: value,
      value: value,
      disabled: disabled,
      title: title
    }, renderItem(option), "\u00A0", React.createElement("small", {
      title: extra
    }, extra));
  })));
};

var css_248z$g = ".dropdown {\n  top: 36px !important;\n}\n";
styleInject(css_248z$g);

const TAutoComplete = _a => {
  var {
    useDefaultWrapper
  } = _a,
      props = __rest(_a, ["useDefaultWrapper"]);

  const wrapperProp = !useDefaultWrapper ? {
    getPopupContainer: trigger => trigger.parentNode
  } : '';
  return React.createElement(_AutoComplete, Object.assign({}, props, wrapperProp, {
    getPopupContainer: trigger => trigger.parentNode
  }));
};

const Wrapper = Component => props => React.createElement("div", {
  style: {
    position: 'relative'
  }
}, React.createElement(Component, Object.assign({}, props, {
  getPopupContainer: trigger => trigger.parentNode
})));

const TDatePicker = Wrapper(_DatePicker); // @ts-ignore

TDatePicker.RangePicker = Wrapper(_DatePicker.RangePicker); // @ts-ignore

TDatePicker.MonthPicker = Wrapper(_DatePicker.MonthPicker);

const Wrapper$1 = Component => props => React.createElement("div", {
  style: {
    position: 'relative'
  }
}, React.createElement(Component, Object.assign({}, props, {
  getPopupContainer: trigger => trigger.parentNode
})));

const TTimePicker = Wrapper$1(_TimePicker); //TODO
// @ts-ignore

TTimePicker.RangePicker = Wrapper$1(_TimePicker.RangePicker); // @ts-ignore

TTimePicker.MonthPicker = Wrapper$1(_TimePicker.MonthPicker);

var css_248z$h = ".dropdown {\n  top: 36px !important;\n}\n";
styleInject(css_248z$h);

const TDropdown = _a => {
  var {
    children,
    overlay
  } = _a,
      props = __rest(_a, ["children", "overlay"]);

  return React.createElement(_Dropdown, Object.assign({}, props, {
    overlay: overlay,
    getPopupContainer: trigger => trigger.parentNode
  }), children);
};

var css_248z$i = ".t-divider {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: var(--text-dark-100, #262626);\n  font-size: 13px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  -webkit-font-feature-settings: 'tnum';\n  font-feature-settings: 'tnum', 'tnum';\n  border-top: 1px solid var(--text-dark-10, #e6e6e7);\n}\n.t-divider-horizontal {\n  display: -ms-flexbox;\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 24px 0;\n}\n.t-divider-vertical {\n  position: relative;\n  top: 0;\n  display: inline-block;\n  height: 0.9em;\n  margin: 0 8px;\n  vertical-align: middle;\n  border-top: 0;\n  border-left: 1px solid var(--text-dark-10, #e6e6e7);\n}\n.t-divider-with-text:after,\n.t-divider-with-text:before {\n  position: relative;\n  top: 50%;\n  width: 50%;\n  border-top: 1px solid transparent;\n  border-top-color: inherit;\n  border-bottom: 0;\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n  content: '';\n}\n.t-divider-with-text-right:after,\n.t-divider-with-text-left:before {\n  top: 50%;\n  width: 5%;\n}\n.t-divider-with-text-right:before,\n.t-divider-with-text-left:after {\n  top: 50%;\n  width: 95%;\n}\n.t-divider-dashed {\n  background: 0 0;\n  border: dashed var(--text-dark-10, #e6e6e7);\n  border-width: 1px 0 0;\n}\n";
styleInject(css_248z$i);

const TDivider = ({
  className,
  dashed,
  plain,
  orientation,
  type = 'horizontal'
}) => {
  const classNames = ['t-divider', dashed && 't-divider-dashed', `t-divider-${type}`, plain && orientation && `t-divider-with-text t-divider-with-text-${orientation}`, className];
  return React.createElement("div", {
    className: classNames.join(' ')
  });
};

const IconBarChart = _a => {
  var props = __rest(_a, []);
  return (// <Icon {...props}>
    React.createElement("svg", {
      width: "60",
      height: "39",
      viewBox: "0 0 60 39",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("rect", {
      y: "25",
      width: "6",
      height: "14",
      rx: "3",
      fill: "#4E25E6",
      fillOpacity: "0.3"
    }), React.createElement("rect", {
      x: "18",
      y: "18",
      width: "6",
      height: "21",
      rx: "3",
      fill: "#4E25E6",
      fillOpacity: "0.5"
    }), React.createElement("rect", {
      x: "36",
      width: "6",
      height: "39",
      rx: "3",
      fill: "#4E25E6",
      fillOpacity: "0.7"
    }), React.createElement("rect", {
      x: "54",
      y: "12",
      width: "6",
      height: "27",
      rx: "3",
      fill: "#4E25E6"
    })) // </Icon>

  );
};

var css_248z$j = ".t-rank-container svg rect {\n  fill: var(--primary-color, #f54e95);\n}\n.t-rank-container .t-rank-order {\n  font-size: 88px;\n  color: var(--primary-color, #f54e95);\n  font-family: monospace;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: bold;\n  margin: 0 12px;\n  line-height: 68px;\n}\n";
styleInject(css_248z$j);

const Rank = _a => {
  var {
    order
  } = _a,
      props = __rest(_a, ["order"]);

  const classNames = ['t-rank-container'];
  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(IconBarChart, null), React.createElement("span", {
    className: "t-rank-order"
  }, order), React.createElement(IconBarChart, null));
};

const IconStar = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.4697L17.8514 21L16.3035 14.3407L21.4688 9.86292L14.6594 9.27816L12 3L9.34017 9.27816L2.53125 9.86292L7.6965 14.3407L6.14817 21L12 17.4697Z",
    fill: fill || '#26262'
  }));
};

var css_248z$k = ".t-display-block {\n  display: block;\n}\n.t-display-flex {\n  display: flex;\n}\n.t-display-inline {\n  display: inline;\n}\n.t-display-none {\n  display: none;\n}\n.t-justifyContent-space-between {\n  justify-content: space-between;\n}\n.t-justifyContent-center {\n  justify-content: center;\n}\n.t-justifyContent-flex-end {\n  justify-content: flex-end;\n}\n.t-alignItems-center {\n  align-items: center;\n}\n.t-alignItems-end {\n  align-items: end;\n}\n.t-flexDirecton-column {\n  flex-direction: column;\n}\n.t-wrapper-with-shadow {\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n.t-wrapper-rounded {\n  border-radius: var(--border-radius, 8px);\n}\n.t-wrapper-bordered {\n  border: 1px solid #f7f7f8;\n}\n.t-p-1 {\n  padding: 16px;\n}\n.t-p-2 {\n  padding: 8px;\n}\n.t-p-3 {\n  padding: 4px;\n}\n.t-p-4 {\n  padding: 2px;\n}\n.t-px-1 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.t-px-2 {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.t-px-3 {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.t-px-4 {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n.t-py-1 {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.t-py-2 {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.t-py-3 {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.t-py-4 {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.t-pt-1 {\n  padding-top: 16px;\n}\n.t-pt-2 {\n  padding-top: 8px;\n}\n.t-pt-3 {\n  padding-top: 4px;\n}\n.t-pt-4 {\n  padding-top: 2px;\n}\n.t-pr-1 {\n  padding-right: 16px;\n}\n.t-pr-2 {\n  padding-right: 8px;\n}\n.t-pr-3 {\n  padding-right: 4px;\n}\n.t-pr-4 {\n  padding-right: 2px;\n}\n.t-pb-1 {\n  padding-bottom: 16px;\n}\n.t-pb-2 {\n  padding-bottom: 8px;\n}\n.t-pb-3 {\n  padding-bottom: 4px;\n}\n.t-pb-4 {\n  padding-bottom: 2px;\n}\n.t-pl-1 {\n  padding-left: 16px;\n}\n.t-pl-2 {\n  padding-left: 8px;\n}\n.t-pl-3 {\n  padding-left: 4px;\n}\n.t-pl-4 {\n  padding-left: 2px;\n}\n.t-m-1 {\n  margin: 16px;\n}\n.t-m-2 {\n  margin: 8px;\n}\n.t-m-3 {\n  margin: 4px;\n}\n.t-m-4 {\n  margin: 2px;\n}\n.t-mx-1 {\n  margin-left: 16px;\n  margin-right: 16px;\n}\n.t-mx-2 {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.t-mx-3 {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.t-mx-4 {\n  margin-left: 2px;\n  margin-right: 2px;\n}\n.t-my-1 {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n.t-my-2 {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.t-my-3 {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.t-my-4 {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n.t-mt-1 {\n  margin-top: 16px;\n}\n.t-mt-2 {\n  margin-top: 8px;\n}\n.t-mt-3 {\n  margin-top: 4px;\n}\n.t-mt-4 {\n  margin-top: 2px;\n}\n.t-mr-1 {\n  margin-right: 16px;\n}\n.t-mr-2 {\n  margin-right: 8px;\n}\n.t-mr-3 {\n  margin-right: 4px;\n}\n.t-mr-4 {\n  margin-right: 2px;\n}\n.t-mb-1 {\n  margin-bottom: 16px;\n}\n.t-mb-2 {\n  margin-bottom: 8px;\n}\n.t-mb-3 {\n  margin-bottom: 4px;\n}\n.t-mb-4 {\n  margin-bottom: 2px;\n}\n.t-ml-1 {\n  margin-left: 16px;\n}\n.t-ml-2 {\n  margin-left: 8px;\n}\n.t-ml-3 {\n  margin-left: 4px;\n}\n.t-ml-4 {\n  margin-left: 2px;\n}\n.t-al-left {\n  text-align: left;\n}\n.t-al-right {\n  text-align: right;\n}\n.t-al-center {\n  text-align: center;\n}\n.t-al-justify {\n  text-align: justify;\n}\n.t-al-inherit {\n  text-align: inherit;\n}\n.t-al-initial {\n  text-align: initial;\n}\n.t-op-0 {\n  opacity: 0;\n}\n.t-op--025 {\n  opacity: 0.25;\n}\n.t-op-05 {\n  opacity: 0.5;\n}\n.t-op-075 {\n  opacity: 0.75;\n}\n.t-visibility-visible {\n  visibility: visible;\n}\n.t-visibility-hidden {\n  visibility: hidden;\n}\n";
styleInject(css_248z$k);

const Wrapper$2 = React.forwardRef((_a, ref) => {
  var {
    children,
    textAlign,
    isInline = false,
    divider = false,
    shadow = false,
    rounded = false,
    bordered = false,
    opacity = 1,
    style
  } = _a,
      props = __rest(_a, ["children", "textAlign", "isInline", "divider", "shadow", "rounded", "bordered", "opacity", "style"]);

  const classNames = Object.keys(props).map(key => `t-${key}-${props[key]}`);

  if (shadow) {
    classNames.push('t-wrapper-with-shadow');
  }

  if (rounded) {
    classNames.push('t-wrapper-rounded');
  }

  if (bordered) {
    classNames.push('t-wrapper-bordered');
  }

  if (isInline) {
    classNames.push('t-wrapper-inline');
  }

  if (textAlign) {
    classNames.push(`t-al-${textAlign}`);
  }

  if (opacity !== 1) {
    classNames.push(`t-op-${opacity.toString().replace(/\D/, '')}`);
  }

  return React.createElement("div", {
    ref: ref,
    style: style,
    className: classNames.join(' ')
  }, children);
});

var css_248z$l = "";
styleInject(css_248z$l);

const RateResult = ({
  iconColor = '#F7D10C',
  rating = 0,
  maxRating = 5,
  ratersCount
}) => {
  return React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "center"
  }, React.createElement(IconStar, {
    fill: iconColor
  }), React.createElement(Wrapper$2, {
    display: "flex",
    ml: 4
  }, React.createElement(Wrapper$2, null, React.createElement(TText, {
    level: 3
  }, rating, React.createElement(Wrapper$2, {
    display: "inline",
    mx: 4
  }, "/"), maxRating)), ratersCount && React.createElement(Wrapper$2, {
    ml: 4
  }, React.createElement(TText, {
    level: 3,
    textColor: "dark-30"
  }, "(", ratersCount, ")"))));
};

const IconWatch = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || 'black';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.48 22 2 17.53 2 12C2 6.48 6.48 2 12 2C17.53 2 22 6.48 22 12C22 17.53 17.53 22 12 22ZM15.19 15.71C15.31 15.78 15.44 15.82 15.58 15.82C15.83 15.82 16.08 15.69 16.22 15.45C16.43 15.1 16.32 14.64 15.96 14.42L12.4 12.3V7.68C12.4 7.26 12.06 6.93 11.65 6.93C11.24 6.93 10.9 7.26 10.9 7.68V12.73C10.9 12.99 11.04 13.23 11.27 13.37L15.19 15.71Z",
    fill: fill
  }));
};

const IconUser = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.294 7.29105C17.294 10.2281 14.9391 12.5831 12 12.5831C9.0619 12.5831 6.70601 10.2281 6.70601 7.29105C6.70601 4.35402 9.0619 2 12 2C14.9391 2 17.294 4.35402 17.294 7.29105ZM12 22C7.66237 22 4 21.295 4 18.575C4 15.8539 7.68538 15.1739 12 15.1739C16.3386 15.1739 20 15.8789 20 18.599C20 21.32 16.3146 22 12 22Z",
    fill: fill
  }));
};

var css_248z$m = ".t-agenda-card {\n  border-radius: 16px;\n  cursor: pointer;\n  height: 144px;\n}\n.t-agenda-card .t-dates-wrapper {\n  padding-left: 16px;\n  position: absolute;\n  right: 34px;\n  top: calc(144px - 50px);\n  height: 52px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.t-agenda-card .t-title-wrapper {\n  padding-left: 16px;\n  position: absolute;\n  height: 52px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  top: calc(144px - 46px);\n}\n.t-agenda-card .t-custom-cover-icon-wrapper {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  padding: 16px;\n  height: 100%;\n}\n.t-agenda-card .t-custom-cover-icon-wrapper img {\n  height: 100px;\n}\n.t-agenda-card .t-cover-wrapper img {\n  height: 144px;\n  width: 100%;\n  border-radius: 16px;\n}\n";
styleInject(css_248z$m);

const AgendaCard = ({
  dates = [],
  cover,
  customCover,
  author,
  onClick = () => {},
  title
}) => {
  return React.createElement("div", {
    style: {
      backgroundColor: customCover.backgroundColor
    },
    className: "t-agenda-card",
    onClick: () => onClick()
  }, !!customCover.icon && !!customCover.backgroundColor ? React.createElement("div", {
    className: "t-custom-cover-icon-wrapper"
  }, React.createElement("img", {
    src: customCover.icon
  })) : React.createElement("div", {
    className: "t-cover-wrapper"
  }, React.createElement("img", {
    src: cover
  })), React.createElement("div", {
    className: "t-title-wrapper"
  }, React.createElement(Wrapper$2, {
    mb: 3
  }, React.createElement(Wrapper$2, {
    mb: 3
  }, React.createElement(TText, {
    rows: 1,
    semiBold: true,
    textColor: "white",
    level: 2
  }, title)), !!author && React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "center"
  }, React.createElement(Wrapper$2, {
    mr: 3
  }, React.createElement(IconUser, {
    fill: "white",
    size: "xs"
  })), React.createElement(TText, {
    rows: 1,
    textColor: "white",
    level: 3
  }, author)), React.createElement(Wrapper$2, null, !!dates.length && dates.map((item, index) => {
    return React.createElement(Wrapper$2, {
      display: "flex",
      alignItems: "center",
      key: index
    }, React.createElement(Wrapper$2, {
      mr: 3
    }, React.createElement(IconWatch, {
      fill: "white",
      size: "xs"
    })), React.createElement(TText, {
      rows: 1,
      textColor: "white",
      level: 3
    }, item));
  })))));
};

const IconArrowRight = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M8.578 16.594l4.594-4.594-4.594-4.594 1.406-1.406 6 6-6 6z",
    fill: fill
  }));
};

var css_248z$n = ".t-notification-card {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 16px;\n  cursor: pointer;\n}\n.t-notification-card .t-text-block-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.t-notification-card .t-icon-container {\n  width: max-content;\n}\n.t-notification-card .t-icon-container .t-icon-wrapper {\n  width: 54px;\n  height: 54px;\n  background: #fbfbfc;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n}\n";
styleInject(css_248z$n);

const NotificationCard = ({
  icon,
  date,
  onClick = () => {},
  title,
  description,
  backgroundColor
}) => {
  return React.createElement("div", {
    style: {
      backgroundColor: backgroundColor
    },
    className: "t-notification-card",
    onClick: () => onClick()
  }, React.createElement("div", {
    className: "t-icon-container"
  }, React.createElement("div", {
    className: "t-icon-wrapper"
  }, icon)), React.createElement("div", {
    className: "t-text-block-container"
  }, React.createElement("div", null, React.createElement(TText, {
    semiBold: true,
    level: 2,
    rows: 1
  }, title), React.createElement(TText, {
    textColor: "dark-50",
    level: 3,
    rows: 1
  }, description), React.createElement(TText, {
    textColor: "dark-20",
    level: 4,
    rows: 1
  }, date)), React.createElement(Wrapper$2, {
    ml: 2
  }, React.createElement(IconArrowRight, {
    fill: "black"
  }))));
};

var css_248z$o = "";
styleInject(css_248z$o);

const TProgress = ({
  label,
  labelRows = 1,
  labelLevel = 3,
  percent = 0,
  type,
  status,
  showInfo,
  strokeColor,
  strokeLinecap,
  style,
  width,
  format
}) => {
  return React.createElement("div", null, label && React.createElement(TText, {
    bold: true,
    rows: labelRows,
    level: labelLevel
  }, label), React.createElement(_Progress, {
    width: width,
    style: style,
    showInfo: showInfo,
    type: type,
    percent: percent,
    status: status,
    strokeColor: strokeColor,
    strokeLinecap: strokeLinecap,
    format: format
  }));
};

var css_248z$p = ".ant-popover {\n  width: max-content !important;\n}\n";
styleInject(css_248z$p);

const TPopover = _a => {
  var {
    children
  } = _a,
      props = __rest(_a, ["children"]);

  return React.createElement(_Popover, Object.assign({}, props, {
    getPopupContainer: trigger => trigger.parentNode
  }), children);
};

var css_248z$q = "";
styleInject(css_248z$q);

const TTooltip = _a => {
  var {
    children
  } = _a,
      props = __rest(_a, ["children"]);

  return React.createElement(_Tooltip, Object.assign({}, props, {
    getPopupContainer: trigger => trigger.parentNode
  }), children);
};

var css_248z$r = ".t-nextSessionCard {\n  padding: 13px 16px 13px 16px;\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  background: #ffffff;\n  height: 125px;\n}\n.t-nextSessionCard .t-sessionInfoWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.t-nextSessionCard .t-sessionInfoWrapper .t-classTitlesWrapper {\n  display: flex;\n  flex-direction: column;\n}\n.t-nextSessionCard .t-sessionInfoWrapper .t-classTimeWrapper {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  margin-left: 12px;\n}\n";
styleInject(css_248z$r);

var css_248z$s = ".link-container {\n  display: flex;\n  align-items: center;\n}\n";
styleInject(css_248z$s);

const TLink = _a => {
  var props = __rest(_a, []);

  return React.createElement("a", {
    href: props.href,
    className: 'link-container',
    target: props.target,
    onClick: props.onClick
  }, props.icon, React.createElement("span", null, props.title));
};

const TExternalLink = ({
  href
}) => {
  const handleClick = event => event.stopPropagation();

  return React.createElement(TLink, {
    href: href,
    icon: React.createElement(IconLink, {
      size: "xl",
      fill: "#52AEFF"
    }),
    target: "_blank",
    onClick: handleClick
  });
};

var css_248z$t = ".button-wrapper {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 1px;\n}\n.button-wrapper .ant-btn {\n  display: block;\n  margin-left: 8px;\n}\n";
styleInject(css_248z$t);

const PracticeActions = ({
  trainingLink,
  practiceLink
}) => {
  const {
    translate
  } = useContext(ConfigContext);

  const handleClick = event => event.stopPropagation();

  return React.createElement("div", {
    className: "button-wrapper"
  }, !!trainingLink && React.createElement(TExternalLink, {
    href: trainingLink
  }), !!practiceLink && React.createElement(TButton, {
    href: practiceLink,
    target: "_blank",
    onClick: handleClick
  }, translate('ui.practice')));
};

const TNextSessionCard = ({
  title,
  session,
  noSessionText,
  moment
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  const trainingLink = !isEmpty(session === null || session === void 0 ? void 0 : session.trainingLinks) && !!Object.values(session === null || session === void 0 ? void 0 : session.trainingLinks)[0] && Object.values(session === null || session === void 0 ? void 0 : session.trainingLinks)[0];
  const getTimeLeft = useCallback(() => {
    const days = moment(session.date).diff(moment(), 'day');

    if (days < 1) {
      const hours = moment(session.date).diff(moment(), 'hour');

      if (hours < 1) {
        return `${moment(session.date).diff(moment(), 'minutes')} ${translate('minutes', {}, false)}`;
      }

      return `${hours} ${translate('hours', {}, false)}`;
    }

    return `${days} ${translate('days', {}, false)}`;
  }, [session]);
  return React.createElement("div", {
    className: "t-nextSessionCard"
  }, React.createElement(TText, {
    level: 1,
    rows: 1,
    bold: true,
    paddingBottom: 1
  }, title), session && React.createElement("div", {
    className: "t-sessionInfoWrapper"
  }, React.createElement("div", {
    className: "t-classTitlesWrapper"
  }, React.createElement(TText, {
    level: 2,
    rows: 1,
    paddingBottom: 3,
    bold: true
  }, session.title), React.createElement(TText, {
    rows: 1,
    level: 3
  }, session.groupTitle)), React.createElement("div", {
    className: "t-classTimeWrapper"
  }, React.createElement(Wrapper$2, {
    mb: 4,
    display: "flex",
    justifyContent: "flex-end"
  }, React.createElement(TText, {
    level: 4,
    rows: 1
  }, translate('will start in {{timeLeft}}', {
    timeLeft: getTimeLeft()
  }))), React.createElement(PracticeActions, {
    trainingLink: trainingLink
  }))), !session && React.createElement("div", {
    className: "t-noSession"
  }, noSessionText));
};

var NextSessionCard = withLocalization(TNextSessionCard);

var css_248z$u = ".t-welcomeMessage {\n  display: flex;\n  align-items: center;\n}\n.t-welcomeMessage .t-avatarWrapper {\n  margin-right: 24px;\n}\n";
styleInject(css_248z$u);

const TStudentInfoList = ({
  title,
  text,
  avatar,
  avatarAlt
}) => {
  return React.createElement("div", {
    className: "t-welcomeMessage"
  }, React.createElement("div", {
    className: "t-avatarWrapper"
  }, React.createElement(TAvatar, {
    size: "xl",
    src: avatar
  }, avatarAlt)), React.createElement("div", {
    className: "t-welcomeTextWrapper"
  }, React.createElement(TText, {
    rows: 2,
    level: 1,
    bold: true,
    paddingBottom: 2
  }, title), React.createElement(TText, {
    rows: 2,
    level: 3
  }, text)));
};

var css_248z$v = ".t-welcomeCard {\n  display: flex;\n  background-color: #f0eefe;\n  border-radius: var(--border-radius, 8px);\n  justify-content: space-between;\n  align-items: center;\n  height: 152px;\n}\n@media screen and (max-width: 767px) {\n  .t-welcomeCard {\n    flex-direction: column;\n    align-items: flex-start;\n    height: unset;\n  }\n}\n.t-welcomeCard .t-welcomeMessageInCard {\n  padding: 32px;\n  max-width: 500px;\n}\n.t-welcomeCard .t-sessionCard {\n  width: 356px;\n  padding: 16px;\n}\n@media screen and (max-width: 767px) {\n  .t-welcomeCard .t-sessionCard {\n    padding: 16px;\n    width: 100%;\n  }\n}\n.t-welcomeCard-bgColor-indicator-good-10 {\n  background: rgba(59, 227, 197, 0.1);\n}\n.t-welcomeCard-bgColor-indicator-caution-10 {\n  background: rgba(255, 201, 96, 0.1);\n}\n.t-welcomeCard-bgColor-indicator-bad-10 {\n  background: rgba(255, 57, 93, 0.1);\n}\n.t-welcomeCard-bgColor-indicator-neutral-10 {\n  background: #9696ff;\n}\n.cardHover:hover {\n  -webkit-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -moz-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  transition: all 0.3s ease-in-out;\n}\n";
styleInject(css_248z$v);

const TWelcomeCard = ({
  avatar,
  avatarAlt,
  title,
  text,
  sessionCardTitle,
  session,
  noSessionText,
  backGroundColor,
  onHover
}) => {
  const classNames = [`t-welcomeCard t-welcomeCard-bgColor-${backGroundColor}`];

  if (onHover) {
    classNames.push('cardHover');
  }

  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement("div", {
    className: "t-welcomeMessageInCard"
  }, React.createElement(TStudentInfoList, {
    avatar: avatar,
    avatarAlt: avatarAlt,
    title: title,
    text: text
  })), React.createElement("div", {
    className: "t-sessionCard"
  }, React.createElement(NextSessionCard, {
    title: sessionCardTitle,
    session: session,
    noSessionText: noSessionText
  })));
};

const img$1 = "data:image/svg+xml,%3csvg width='612' height='366' viewBox='0 0 612 366' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect width='612' height='366' fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'%3e%3cuse xlink:href='%23image0_491_7492' transform='translate(0 -0.057377) scale(0.000333333 0.000557377)'/%3e%3c/pattern%3e%3cimage id='image0_491_7492' width='3000' height='2000' xlink:href='data:image/jpeg%3bbase64%2c/9j/4AAQSkZJRgABAQAAAQABAAD/4QBKRXhpZgAASUkqAAgAAAABAJiCAgAnAAAAGgAAAAAAAABGcmVlcGlrIENvbXBhbnkgUy5MLiAtIHd3dy5mcmVlcGlrLmNvbQAA/%2bIMWElDQ19QUk9GSUxFAAEBAAAMSExpbm8CEAAAbW50clJHQiBYWVogB84AAgAJAAYAMQAAYWNzcE1TRlQAAAAASUVDIHNSR0IAAAAAAAAAAAAAAAAAAPbWAAEAAAAA0y1IUCAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARY3BydAAAAVAAAAAzZGVzYwAAAYQAAABsd3RwdAAAAfAAAAAUYmtwdAAAAgQAAAAUclhZWgAAAhgAAAAUZ1hZWgAAAiwAAAAUYlhZWgAAAkAAAAAUZG1uZAAAAlQAAABwZG1kZAAAAsQAAACIdnVlZAAAA0wAAACGdmlldwAAA9QAAAAkbHVtaQAAA/gAAAAUbWVhcwAABAwAAAAkdGVjaAAABDAAAAAMclRSQwAABDwAAAgMZ1RSQwAABDwAAAgMYlRSQwAABDwAAAgMdGV4dAAAAABDb3B5cmlnaHQgKGMpIDE5OTggSGV3bGV0dC1QYWNrYXJkIENvbXBhbnkAAGRlc2MAAAAAAAAAEnNSR0IgSUVDNjE5NjYtMi4xAAAAAAAAAAAAAAASc1JHQiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAADzUQABAAAAARbMWFlaIAAAAAAAAAAAAAAAAAAAAABYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9kZXNjAAAAAAAAABZJRUMgaHR0cDovL3d3dy5pZWMuY2gAAAAAAAAAAAAAABZJRUMgaHR0cDovL3d3dy5pZWMuY2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZGVzYwAAAAAAAAAuSUVDIDYxOTY2LTIuMSBEZWZhdWx0IFJHQiBjb2xvdXIgc3BhY2UgLSBzUkdCAAAAAAAAAAAAAAAuSUVDIDYxOTY2LTIuMSBEZWZhdWx0IFJHQiBjb2xvdXIgc3BhY2UgLSBzUkdCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGRlc2MAAAAAAAAALFJlZmVyZW5jZSBWaWV3aW5nIENvbmRpdGlvbiBpbiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAACxSZWZlcmVuY2UgVmlld2luZyBDb25kaXRpb24gaW4gSUVDNjE5NjYtMi4xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB2aWV3AAAAAAATpP4AFF8uABDPFAAD7cwABBMLAANcngAAAAFYWVogAAAAAABMCVYAUAAAAFcf521lYXMAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAKPAAAAAnNpZyAAAAAAQ1JUIGN1cnYAAAAAAAAEAAAAAAUACgAPABQAGQAeACMAKAAtADIANwA7AEAARQBKAE8AVABZAF4AYwBoAG0AcgB3AHwAgQCGAIsAkACVAJoAnwCkAKkArgCyALcAvADBAMYAywDQANUA2wDgAOUA6wDwAPYA%2bwEBAQcBDQETARkBHwElASsBMgE4AT4BRQFMAVIBWQFgAWcBbgF1AXwBgwGLAZIBmgGhAakBsQG5AcEByQHRAdkB4QHpAfIB%2bgIDAgwCFAIdAiYCLwI4AkECSwJUAl0CZwJxAnoChAKOApgCogKsArYCwQLLAtUC4ALrAvUDAAMLAxYDIQMtAzgDQwNPA1oDZgNyA34DigOWA6IDrgO6A8cD0wPgA%2bwD%2bQQGBBMEIAQtBDsESARVBGMEcQR%2bBIwEmgSoBLYExATTBOEE8AT%2bBQ0FHAUrBToFSQVYBWcFdwWGBZYFpgW1BcUF1QXlBfYGBgYWBicGNwZIBlkGagZ7BowGnQavBsAG0QbjBvUHBwcZBysHPQdPB2EHdAeGB5kHrAe/B9IH5Qf4CAsIHwgyCEYIWghuCIIIlgiqCL4I0gjnCPsJEAklCToJTwlkCXkJjwmkCboJzwnlCfsKEQonCj0KVApqCoEKmAquCsUK3ArzCwsLIgs5C1ELaQuAC5gLsAvIC%2bEL%2bQwSDCoMQwxcDHUMjgynDMAM2QzzDQ0NJg1ADVoNdA2ODakNww3eDfgOEw4uDkkOZA5/DpsOtg7SDu4PCQ8lD0EPXg96D5YPsw/PD%2bwQCRAmEEMQYRB%2bEJsQuRDXEPURExExEU8RbRGMEaoRyRHoEgcSJhJFEmQShBKjEsMS4xMDEyMTQxNjE4MTpBPFE%2bUUBhQnFEkUahSLFK0UzhTwFRIVNBVWFXgVmxW9FeAWAxYmFkkWbBaPFrIW1hb6Fx0XQRdlF4kXrhfSF/cYGxhAGGUYihivGNUY%2bhkgGUUZaxmRGbcZ3RoEGioaURp3Gp4axRrsGxQbOxtjG4obshvaHAIcKhxSHHscoxzMHPUdHh1HHXAdmR3DHeweFh5AHmoelB6%2bHukfEx8%2bH2kflB%2b/H%2bogFSBBIGwgmCDEIPAhHCFIIXUhoSHOIfsiJyJVIoIiryLdIwojOCNmI5QjwiPwJB8kTSR8JKsk2iUJJTglaCWXJccl9yYnJlcmhya3JugnGCdJJ3onqyfcKA0oPyhxKKIo1CkGKTgpaymdKdAqAio1KmgqmyrPKwIrNitpK50r0SwFLDksbiyiLNctDC1BLXYtqy3hLhYuTC6CLrcu7i8kL1ovkS/HL/4wNTBsMKQw2zESMUoxgjG6MfIyKjJjMpsy1DMNM0YzfzO4M/E0KzRlNJ402DUTNU01hzXCNf02NzZyNq426TckN2A3nDfXOBQ4UDiMOMg5BTlCOX85vDn5OjY6dDqyOu87LTtrO6o76DwnPGU8pDzjPSI9YT2hPeA%2bID5gPqA%2b4D8hP2E/oj/iQCNAZECmQOdBKUFqQaxB7kIwQnJCtUL3QzpDfUPARANER0SKRM5FEkVVRZpF3kYiRmdGq0bwRzVHe0fASAVIS0iRSNdJHUljSalJ8Eo3Sn1KxEsMS1NLmkviTCpMcky6TQJNSk2TTdxOJU5uTrdPAE9JT5NP3VAnUHFQu1EGUVBRm1HmUjFSfFLHUxNTX1OqU/ZUQlSPVNtVKFV1VcJWD1ZcVqlW91dEV5JX4FgvWH1Yy1kaWWlZuFoHWlZaplr1W0VblVvlXDVchlzWXSddeF3JXhpebF69Xw9fYV%2bzYAVgV2CqYPxhT2GiYfViSWKcYvBjQ2OXY%2btkQGSUZOllPWWSZedmPWaSZuhnPWeTZ%2bloP2iWaOxpQ2maafFqSGqfavdrT2una/9sV2yvbQhtYG25bhJua27Ebx5veG/RcCtwhnDgcTpxlXHwcktypnMBc11zuHQUdHB0zHUodYV14XY%2bdpt2%2bHdWd7N4EXhueMx5KnmJeed6RnqlewR7Y3vCfCF8gXzhfUF9oX4BfmJ%2bwn8jf4R/5YBHgKiBCoFrgc2CMIKSgvSDV4O6hB2EgITjhUeFq4YOhnKG14c7h5%2bIBIhpiM6JM4mZif6KZIrKizCLlov8jGOMyo0xjZiN/45mjs6PNo%2bekAaQbpDWkT%2bRqJIRknqS45NNk7aUIJSKlPSVX5XJljSWn5cKl3WX4JhMmLiZJJmQmfyaaJrVm0Kbr5wcnImc951kndKeQJ6unx2fi5/6oGmg2KFHobaiJqKWowajdqPmpFakx6U4pammGqaLpv2nbqfgqFKoxKk3qamqHKqPqwKrdavprFys0K1ErbiuLa6hrxavi7AAsHWw6rFgsdayS7LCszizrrQltJy1E7WKtgG2ebbwt2i34LhZuNG5SrnCuju6tbsuu6e8IbybvRW9j74KvoS%2b/796v/XAcMDswWfB48JfwtvDWMPUxFHEzsVLxcjGRsbDx0HHv8g9yLzJOsm5yjjKt8s2y7bMNcy1zTXNtc42zrbPN8%2b40DnQutE80b7SP9LB00TTxtRJ1MvVTtXR1lXW2Ndc1%2bDYZNjo2WzZ8dp22vvbgNwF3IrdEN2W3hzeot8p36/gNuC94UThzOJT4tvjY%2bPr5HPk/OWE5g3mlucf56noMui86Ubp0Opb6uXrcOv77IbtEe2c7ijutO9A78zwWPDl8XLx//KM8xnzp/Q09ML1UPXe9m32%2b/eK%2bBn4qPk4%2bcf6V/rn%2b3f8B/yY/Sn9uv5L/tz/bf///9sAQwAIBgYHBgUIBwcHCQkICgwUDQwLCwwZEhMPFB0aHx4dGhwcICQuJyAiLCMcHCg3KSwwMTQ0NB8nOT04MjwuMzQy/9sAQwEJCQkMCwwYDQ0YMiEcITIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIy/8AAEQgH0Au4AwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5%2bv/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5%2bjp6vLz9PX29/j5%2bv/aAAwDAQACEQMRAD8A9/ooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooprusaM7sFRRksxwAPU0AOorgdd%2bMvgjQnaJtV%2b2zqeY7FDL/AOPfc/8AHq4%2b4/aS0RS32bQdQkH8JkkRM/XGaAPbqK8H/wCGl7P/AKFif/wMH/xFH/DS9n/0LE//AIGD/wCIoA94orwf/hpez/6Fif8A8DB/8RR/w0vZ/wDQsT/%2bBg/%2bIoA94orwf/hpez/6Fif/AMDB/wDEUf8ADS9n/wBCxP8A%2bBg/%2bIoA94orwf8A4aXs/wDoWJ//AAMH/wARR/w0vZ/9CxP/AOBg/wDiKAPeKK8H/wCGl7P/AKFif/wMH/xFH/DS9n/0LE//AIGD/wCIoA94orwf/hpez/6Fif8A8DB/8RR/w0vZ/wDQsT/%2bBg/%2bIoA94orwf/hpez/6Fif/AMDB/wDEUf8ADS9n/wBCxP8A%2bBg/%2bIoA94orwf8A4aXs/wDoWJ//AAMH/wARR/w0vZ/9CxP/AOBg/wDiKAPeKK8H/wCGl7P/AKFif/wMH/xFH/DS9n/0LE//AIGD/wCIoA94orwf/hpez/6Fif8A8DB/8RR/w0vZ/wDQsT/%2bBg/%2bIoA94orxe1/aQ8OySAXWj6nCpON0flvj6jIrufD3xP8ACHiaRIbDWIVuXOBb3AMTk%2bgDYDH6E0AdfRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRWR4m8Q2XhXw9eazftiG2TIUHmRjwqj3JwKAM7xt460jwLpP2zUpC88mRb2sZ/eTMPT0A7k8D6kA%2bJQ2/xC%2bN900ss/wDZnhzfgDlYcA9Ao5lYep4znlelSeCPCuofGDxZc%2bLvFO46TFJsSEEgS46RJ6Ivc9yfUkj6MgghtbeO3t4kihjUKkaLhVA6AAdBQB5z4e%2bBng3RUR7u1k1W5HWS7b5M%2byDAx9c129r4b0KxVVtNF06BV5AitUXH5CtSigCv9gs/%2bfSD/v2KPsFn/wA%2bkH/fsVYooAr/AGCz/wCfSD/v2KPsFn/z6Qf9%2bxViigCv9gs/%2bfSD/v2KPsFn/wA%2bkH/fsVYooAr/AGCz/wCfSD/v2KPsFn/z6Qf9%2bxViigCv9gs/%2bfSD/v2KPsFn/wA%2bkH/fsVYooAr/AGCz/wCfSD/v2KPsFn/z6Qf9%2bxViigCv9gs/%2bfSD/v2KPsFn/wA%2bkH/fsVYooAr/AGCz/wCfSD/v2KPsFn/z6Qf9%2bxViigCv9gs/%2bfSD/v2KPsFn/wA%2bkH/fsVYooAr/AGCz/wCfSD/v2KQ2FmeDaQY/65irNFAGJe%2bEPDeox%2bXeaBpky/7dqmR9DjIrz3xN%2bz94a1SOSXRZJtJujyqgmWEn3VjkfgePSvXaKAPm%2bw8YeOvg/qsWl%2bKYZdS0VjtjcuXG31ikPp/cb9M5r33Qdf03xNpEOqaTdLcWsvRhwVI6qw6gj0NP1rRNO8Q6VNpmq2qXNpMPmR%2bx7EHqCOxFfPED6r8B/iEIJnlufDeoHOcffjzjd6eYmefUfUYAPpeiore4hu7aK5t5FlgmQSRyIchlIyCD6YqWgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK%2bfvjXqN34r8eaL4D02TADo03oJZOhYeip83/AAI19A189/DNP%2bEk%2bPfiPXJwGW0a4eInqpL%2bWn/jm4UAe6aJo9noGiWek2Eey2tYxGg7nHUn3JyT7k1oUUUAFFFFABRRRQAUUUUAFFFFABRRXL6z8RfCHh%2bRo9S1%2bzjlXhoo2MrqfQqmSPxoA6iivKbv9oPwVbsREuqXWO8NsBn/AL7Zaq/8NHeD/wDoG65/34h/%2bO0AewUV5fY/HzwNdMBNcXtnnvPak4/743V3Gi%2bKtA8RLnSNXs7w4yUilBcD3XqPxFAGxRRRQAUUUUAFFFFABRRRQAUUUUAFcf8AEvwhH4z8F3lgEBvYgZ7Nu4lUcD6MMqfr7V2FFAHjv7Pvid9T8LXWg3Lkz6XIPK3dfJfJA/Bg34ECvYq%2be/Byf8Iv%2b0vq%2bkRDbDe%2beAg6BWQXCgfQDFfQlABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV8//ALO4H/CReKzjn93z/wADevoCvn/9nf8A5GHxZ/2y/wDQ5KAPoCiiigAooooAKKKKACiiigArjPHnxK0XwHaAXbfadRkXdDYxN87D1Y/wr7n3wDim/Evx7B4C8Nm6ASXUbnMdnA3Rm7sf9lcjP1A715v8M/hlceKrs%2bNvG2%2b7a7bzre2n/wCWvo7j%2b7jG1emMdsAgGXEnxP8AjHmXzv7J0BycYLRQsPYD5pfx%2bXPpXZaH%2bzz4XsER9WubvVJh95d/kxn6Bfm/8er11VWNAiKFVRgADAAp1AHJ2nwz8E2IAh8MaawH/PaES/8Aoeauf8IJ4P8A%2bhU0P/wXQ/8AxNdBRQBxV98JfAmoKVl8OWsfGA1uWhI/75Irgte/Z3t0b7X4U1m4tLpDuSK6bIz22yKAy/ka9yooA%2bedB%2bKPiv4eaymgeP7W4ntc4W6b5pVX%2b8G6Sr%2bvvxivfrO8ttRsobyznSe2mQPHLGcqynoQax/GPhDTfGmgTaXqMYyQTBOB88EnZl/qO44ryT4I67f%2bH/E%2bp/D3WGw0LyNbAkkLIp%2bdV/2WHzj6E96APe6KKKACiiigAooooAKKKKACiiigD5/1QAftXWZAxnyyf/AY19AV8/6r/wAnX2X/AGz/APSY19AUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRVae%2bt7bIkkG7%2b6OTVCTXFBxFCT7scVx18ww1B2nNX%2b/8i405S2RsUVgHW7k9EiH4H/Gk/tq69I/%2b%2bTXG88wnn9xp9XmdBRXP/wBtXXpH/wB8mj%2b2rr0j/wC%2bTS/t3Cef3B9XmdBRXP8A9tXXpH/3yaP7auvSP/vk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/AHyaP7dwnn9wfV5nQUVz/wDbV16R/wDfJo/tq69I/wDvk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/fJo/t3Cef3B9XmdBRXP/wBtXXpH/wB8mj%2b2rr0j/wC%2bTR/buE8/uD6vM6Ciuf8A7auvSP8A75NH9tXXpH/3yaP7dwnn9wfV5nQUVz/9tXXpH/3yaP7auvSP/vk0f27hPP7g%2brzOgorn/wC2rr0j/wC%2bTR/bV16R/wDfJo/t3Cef3B9XmdBRXP8A9tXXpH/3yaP7auvSP/vk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/AHyaP7dwnn9wfV5nQUVz/wDbV16R/wDfJo/tq69I/wDvk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/fJo/t3Cef3B9XmdBRXP/wBtXXpH/wB8mj%2b2rr0j/wC%2bTR/buE8/uD6vM6Ciuf8A7auvSP8A75NH9tXXpH/3yaP7dwnn9wfV5nQUVz/9tXXpH/3yaP7auvSP/vk0f27hPP7g%2brzOgorn/wC2rr0j/wC%2bTR/bV16R/wDfJo/t3Cef3B9XmdBRXP8A9tXXpH/3yaP7auvSP/vk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/AHyaP7dwnn9wfV5nQUVz/wDbV16R/wDfJo/tq69I/wDvk0f27hPP7g%2brzOgorn/7auvSP/vk0f21dekf/fJo/t3Cef3B9XmdBRXP/wBtXXpH/wB8mj%2b2rr0j/wC%2bTR/buE8/uD6vM6Cvn/8AZ3/5GHxZ/wBsv/Q5K9g/tq69I/8Avk14/wDs7HOv%2bKifSL/0KSuzCY%2bji7%2bzvoZzpyhufQFFFFdpAUUUUAFFFFABRRRQB5J8WPhLf%2bNr1NX03VMXcUQiWzuTiIgZPyMB8pOe%2bc%2borltE%2bMHijwRex6J490id0QBVnCBJVUcZGPlkHuCPqa%2bhKztZ0LS/ENg1jq9jBeW7fwSrnHuD1U%2b4waAK/h7xToviux%2b16LqEV1EPvhTh0PoynlfxFedfEH41RaHqD6D4Yt11LWN/lPJgvHE/TaAOXftgdD68isDxH8DNW0O8fV/AOq3EcqA7bVpvLlAPUJICAR7Nj6mum%2bDnwzXwxpg1vWbXOu3WSBKMtapyMD0Y9SffHrkA5CHwr8bPFafa7zXZdKVxlYpLtrfIPbZCDj6MM0lz4V%2bNPhCL7dZ69NqqRDLRRXb3JAHby5V5%2bigmvoemu6xozuwVFGSzHAA9TQB538K/icnjy0ntL2FLbWLRQ0saZ2yp03qDyOeCO2R616NXzv8ADB4dX%2bPniDVNHXGmbbhy68Kys4AI/wB4/MB/hX0RQAV8%2b%2bOkGjftK%2bHLyH5XvmtGcr33O0J/8dWvoKvnvxDJ/wAJR%2b07pdrB86aY8Ks3YeUDM35MSPrQB9CUUUUAFFFFABRRRQAUUUUAFFFFAHz/AKr/AMnX2X/bP/0mNfQFfPPiGZoP2oraVMblEeM/9e5r2b%2b2rr0j/wC%2bTXBisyoYWahUvdq5pClKaujoKK5/%2b2rr0j/75NH9tXXpH/3ya5f7dwnn9xf1eZ0FFc//AG1dekf/AHyaP7auvSP/AL5NH9u4Tz%2b4Pq8zoKK5/wDtq69I/wDvk0f21dekf/fJo/t3Cef3B9XmdBRXP/21dekf/fJo/tq69I/%2b%2bTR/buE8/uD6vM6Ciuf/ALauvSP/AL5NH9tXXpH/AN8mj%2b3cJ5/cH1eZ0FFc/wD21dekf/fJo/tq69I/%2b%2bTR/buE8/uD6vM6Ciuf/tq69I/%2b%2bTR/bV16R/8AfJo/t3Cef3B9XmdBRXP/ANtXXpH/AN8mj%2b2rr0j/AO%2bTR/buE8/uD6vM6Ciuf/tq69I/%2b%2bTR/bV16R/98mj%2b3cJ5/cH1eZ0FFc//AG1dekf/AHyaP7auvSP/AL5NH9u4Tz%2b4Pq8zoKK5/wDtq69I/wDvk0f21dekf/fJo/t3Cef3B9XmdBRXP/21dekf/fJo/tq69I/%2b%2bTR/buE8/uD6vM6Ciuf/ALauvSP/AL5NH9tXXpH/AN8mj%2b3cJ5/cH1eZ0FFc/wD21dekf/fJo/tq69I/%2b%2bTR/buE8/uD6vM6Ciuf/tq69I/%2b%2bTR/bV16R/8AfJo/t3Cef3B9XmdBRXP/ANtXXpH/AN8mj%2b2rr0j/AO%2bTR/buE8/uD6vM6CiufGt3I6pEfwP%2bNTR64ekkH4q39KuGdYOTs5NfIToTRtUVTg1K2nwA%2b1vR%2bKuV6VKtTqrmpyTXkZOLW4UUUVoIKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiop50t4mkkOFH61MpKKcpOyQJXCaaOCMySttUVh3erSzErFmOP26n8aq3V3Jdyl3OAPur2FQV8hmGcVKzcKLtH8WdtOio6y3CiiivENwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvMP2df%2bQ94q%2bkX/oT16fXmH7Ov/Ie8VfSL/wBCevpeHd6ny/U5sT0PoGiiivpzkCiiigAooooAKKKKACiiigAooooAa7rGjO7BUUZLMcAD1NfPvxA%2bI2o%2bPtWXwV4HWSWCdjHPcx8faB3AP8MQ7t3%2bnW38YfGOo6/r8Pw88M73mmcJeGM4LsRkR57KByx/PGDXpHw%2b%2bH%2bneAtFW3gCzahMoN3d45kb0Hoo7D8TzQAfDrwDZ%2bAdA%2byRMJ76ch7u5xjew6Af7IycfUnvXY0Vw/xF%2bJOm%2bAdNG8Lc6rOp%2bzWgP/j7%2bi5/Pt3wASfEjx/Z%2bBPD7zF0fVJ1K2dueSzf3iP7o7/l3rivgR4Qu4YbzxnrAdr3U8/ZzIPmMbNuaQ/75xj2GejVg%2bCPh5rHxG1weNPGzubOVhJBbMMfaFH3QB/BEOw/i/HJ%2bhURY0VEUKijAVRgAegoAdRRRQAUUUUAFFFFABRRRQAUUUUAfOvif/k52D6R/wDpPXrFeT%2bJ/wDk52D6R/8ApPXrFfI8Qf7xH0/VnZhvhYUUUV4J0BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVctdRntSBnfH/AHW/pXPa54k0jw5bCfVb6K3DfcQ8u/8AuqOT%2bVeY6z8dUVmj0XSd47TXbYH/AHwv/wAVXoYLDYycufDprz2X/BM6koJWkfRlrdxXabozyOqnqKs18gS/Gbxo03m21/BaHsIbZCB/32GpV%2bN3xCVgTr4YDsbODB/JK%2b1w3tvZr26XN5HDLlv7p9fUV8w6V%2b0V4otGVdRsdPv4x94hWic/iCR/47XqHhf45%2bE/EDpb3kkmkXTcBbsjyifaQcf99ba3JPTqKajrIiujBkYZDKcgj1FOoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArm9TvPtM%2b1T%2b6Q4HufWtfU7j7PZsQcM3yrXNV81n2Lath4%2br/Rfr9x1YeH2mFFFFfMHUFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeYfs6/8h7xV9Iv/Qnr0%2bvMP2df%2bQ94q%2bkX/oT19Lw7vU%2bX6nNieh9A0UUV9OcgUUUUAFFFFABRRRQAUUUUAFVNTvV03Sby/cZS2geZh6hVJ/pVus/XNMGtaBqOlNKYlvbWW2MgGSgdSucd8ZoA8N%2bANnDf6trvizVJ42vXk8qN5GAO58vI3Pc/Lz7mvevt9n/z9wf9/BXhzfs12SKWbxRMFAySbRcAf991kP8ABbwfHN5L/EiwWX%2b4xhB/LzKAPc/Eniiw8PeHNQ1d5oZfssLSLGsgy7fwr%2bJwK8U%2bFfgub4g63deOfFjG7iNwfJhflZpB6j%2b4vAC9OMdBg3Yf2b9OuIllg8WSSxt0dLVWB/EPXrngzwyng/wnZaDHctcra%2bZiZk2Ftzs/TJ/vY/CgDe6fSloooAKKKKACiiigAooooAKKKKACiiigD518T/8AJzsH0j/9J69YryfxP/yc7B9I/wD0nr1ivkeIP94j6fqzsw3wsKKKK8E6AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArzP4gfFSHQHl0rRDHPqQyssx5S3Pp/tN7dB37irHxT8dt4a04aZp0mNUu0zvHWGPpu%2bp5A/E9hXzuSWJJJJPU19DlOVKqvb1lp0Xf8A4Bz1q1vdiWb6/u9Tu5Lu%2buZbi4kOWkkbcTVWiivqkklZHGFFFFMAooooA7/wB8V9b8ETJbl2vtIJ%2bezlb7g9Y2P3T7dD6d6%2bqfDniTS/FejRarpNwJraTgjoyMOqsOxH%2beDXwvXY/Drx5eeA/ESXaF5NPmIS8tgeHT%2b8B/eHUH6joaAPs6iq9je22o2MF7aTLNbXEYkikXoykZBqxQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFRyTRwruldUHqxxQBJRTY3WVA6HKsMginUAFQyXMEP%2bsmRfYsKypNO1C4lfzLnEe44BY9PoOKfHoEI/wBZM7H/AGQB/jW3s6a%2bKX3C1NcEMAR0NLTUUIioOijAp1YjMM685JCWvI/2s/0o/te%2bb7tn/wCOsa2wABgUtb%2b0p9IfiKzGqSygkYJFOoorAZh/2pqS/esv/IbUf25cJ9%2b0/Uj%2blblFb%2b0h1gKw1TuUEjBIzinUUhGQQawGVk1Czk%2b7cR/icfzqyrBhlSCPasyTQ7RvumRPo2f51X/sOaJ90F1j81P6VtyUntK3qLU3KKQUjuscbOxwqgk1iMdRVWDULW44jmXPoeD%2btWqbTWjAKKKKQBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGFrku6eOLsq5/E//qrKq5qjbtRl9sD9BVOvgMxqOpiqjfe33aHo0laCCiiiuIsKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8w/Z1/5D3ir6Rf8AoT16fXmH7Ov/ACHvFX0i/wDQnr6Xh3ep8v1ObE9D6Booor6c5AooooAKKKKACiiigAooooAKx/FHiOx8J%2bHbvWdQJ8m3XIRfvSMeFUe5P%2bPativCv2lb%2bWLSdA09SRFcTzTMPUxqoH/ow0Ac9Y6V44%2bON7Lf3l%2bdN8PrIVRTnyhjsiDHmMO7Ej69q6xP2bvD4t9smt6m02PvqIwv/fO0n0716zoOk2%2bhaBYaVaqqw2kCxLt74HJ%2bpOT%2bNaNAHzbrPw%2b8Z/CXfr/hfWZLvT4jvuFRNpVR3kjyQy%2bpHTrx1r2T4eeObXx54bXUI4xDdxN5V1bg52PjqP8AZPUfiO1dXJGksbRyKro4KsrDIIPUEV8//CBP%2bEf%2bNHinw9bH/Qgs6qoOceXKAmforMPxoA%2bg6KKKACiiigAooooAKKKKACiiigAooooA%2bdfE/wDyc7B9I/8A0nr1ivJ/E/8Ayc7B9I//AEnr1ivkeIP94j6fqzsw3wsKKKK8E6AooooAKKKKACiivNPin8QH8PW40fSpdupzruklXrAh9P8AaPb0HPpW%2bGw88RUVOG7FKSirs1fF/wATdG8Ks9qub7UV628TYCH/AG2/h%2bnJ9q8g1n4reK9WdhHfCwhPSO0Xbj/gXLZ/GuJZmdi7sWZjkknJJptfZYXKcPQWq5n3f%2bRwzrSkajeItceQSPrOos4ydxunJ5685rb0f4meK9HdduqSXcQ6xXn70H8T8w/AiuQortnh6M1yyimvQhSktmfRXhP4uaNrzpa6iBpt62APMbMTn2bsfY/ma9D618ZV6P4E%2bKd74dMen6q0l3pfCqScyQD/AGT3X2/L0Pz%2bOyOyc8N93%2bR0U8R0kfQ1eY%2bMfi/a6FqE2m6VaLe3ULFJZXfEaMOqjHLEd%2blejWN/a6nZRXllOk9tKu5JEOQRXx9MZDPIZiTLuO/d1z3zXJk%2bBp4ipP2y%2bG2nrf8AyLrVHFLl6no//C7/ABP5u77Lpe3%2b55L4/wDQ8/rXRaP8dIZHWPWdKaId5rV9w/75bn9TXiVFfQTyrBzVuS3oc6rTXU%2bvdG13TPEFkLvS72K5i77Typ9GB5U/UVoV8haRrWo6Ffpe6ZdPbzp/Ep4YehHQj2NfQngL4j2fi2EWl0EtdWQfNDn5ZR3KZ/UdR7187mGUTwy9pT96P4r1/wAzpp1lLR7nc0UUV4xsFFFFABRRRQAUUUUAFFFFABUF9eQadYXF7cttgt42lkb0UDJqevPPjLqjWHgc2qNh76dYj67R8x/9BA/Gt8NR9tWjT7sUpcsWzwjXtZufEGuXeqXZzLcPuxnhV6BR7AYFZlFFfocYqMVGOyPMbvqFFFFUAUUUUAFFFFABRRRQB9Ffs7%2bL2uLK78K3UmWtgbmz3H%2bAn51H0Yg/8CPpXutfFfw21p9A%2bIeiXwbahuVhl/3JPkb9Gz%2bFfalABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFZt3rFvb5VD5r%2bingfU1UYSk7RQGlRWfpt1c3QkeeLahwUOMCtCiUXF2YGRezak1y0FtHhOMOB/U8VFHockrb7u4JJ7Kcn8zW5RWirSirR0FYighS3hWJM7V6ZOaloorFu%2bowooooAKKKKACiiigAooooAKKKKACiiigAooooAKa6LIhRwGVuCD3p1FAGVPoVvJzEzRH8xUdraaja3Maedugz83OQB9D0/CtmitfbTtZ6isFFFUtRjupIV%2byNtcHJ5wT7VnFXdhl2isODWZYX8q9iII/iAwfxFa8M8U6b4nDr7Vc6cobiuS0UUVmMKKKKACiiigAooooAKKKKAOY1P/AJCM31H8hVSrep/8hGb6j%2bQqpX53i/8AeKnq/wAz0ofCgooornKCiiigAoorM8Q65a%2bG9CutUuz%2b7gXhAeXY8BR7k/54qoxc5KMVqwbtqyDxJ4q0nwrYfatTn2luI4U5kkPoo/r0rzJPHXj/AMcXMkHhDR3htwdplRA5X/ekf5FqTwB4Hvviprk/irxS8h0pZNscSkqJiD/q17hF7kdTnnOSPo2ysbXTrOK0sreK3tol2xxRKFVR7AV9jgsmo0Yp1VzS/A4p15S22Pn5fhz8YZ1EsniBImbqhv2BH/fK4/Knf8Kz%2bL3/AEMsf/gwk/8Aia%2bh6K9P6vR/kX3Iy5pdz54/4Vn8Xv8AoZY//BhJ/wDE0f8ACs/i9/0Msf8A4MJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv%2bhlj/8ABhJ/8TR/wrP4vf8AQyx/%2bDCT/wCJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/6GWP/AMGEn/xNH/Cs/i9/0Msf/gwk/wDia%2bh6KPq9H%2bRfcg5pdz54/wCFZ/F7/oZY/wDwYSf/ABNH/Cs/i9/0Msf/AIMJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv8AoZY//BhJ/wDE0f8ACs/i9/0Msf8A4MJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv%2bhlj/8ABhJ/8TR/wrP4vf8AQyx/%2bDCT/wCJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/6GWP/AMGEn/xNH/Cs/i9/0Msf/gwk/wDia%2bh6KPq9H%2bRfcg5pdz54/wCFZ/F7/oZY/wDwYSf/ABNH/Cs/i9/0Msf/AIMJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv8AoZY//BhJ/wDE0f8ACs/i9/0Msf8A4MJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv%2bhlj/8ABhJ/8TR/wrP4vf8AQyx/%2bDCT/wCJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/6GWP/AMGEn/xNH/Cs/i9/0Msf/gwk/wDia%2bh6KPq9H%2bRfcg5pdz54/wCFZ/F7/oZY/wDwYSf/ABNH/Cs/i9/0Msf/AIMJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv8AoZY//BhJ/wDE0f8ACs/i9/0Msf8A4MJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv%2bhlj/8ABhJ/8TR/wrP4vf8AQyx/%2bDCT/wCJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/6GWP/AMGEn/xNH/Cs/i9/0Msf/gwk/wDia%2bh6KPq9H%2bRfcg5pdz54/wCFZ/F7/oZY/wDwYSf/ABNH/Cs/i9/0Msf/AIMJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv8AoZY//BhJ/wDE0f8ACs/i9/0Msf8A4MJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv%2bhlj/8ABhJ/8TR/wrP4vf8AQyx/%2bDCT/wCJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/6GWP/AMGEn/xNH/Cs/i9/0Msf/gwk/wDia%2bh6KPq9H%2bRfcg5pdz54/wCFZ/F7/oZY/wDwYSf/ABNH/Cs/i9/0Msf/AIMJP/ia%2bh6KPq9H%2bRfcg5pdz54/4Vn8Xv8AoZY//BhJ/wDE0/8AZwR01jxMkhy6pCGPqdz5r6Er5/8A2ejs8TeK4n%2bWT938p68O%2bf5irhThD4UkJtvc%2bgKKKKsQUUUUAFFFFABRRRQAUUUUAFeUfHvwxPrvgmLULSNpJ9KlMzIoyTEww5/DCn6A16vSEBlIIBB4IPegDgPhT49svGHhe1t3nUavZwrFdQM3zNtGPMA7g9TjoePTPoFeK%2bLfgR5uqNrHgvUf7Kuyxf7OWZEVvWN15T6YI9MDisgaD8eIV%2bzpqjPGBt8w3MLHHrlhu/rQB6/4y8YaZ4L0KbUtRmXftIgt93zzv2VR%2bWT2FeV/AHRb6%2b1LW/G2oqd98zwxOR/rWZ98rD23BRn/AHvSk0X4Fatq%2bqrqnjzXHvW4LQRTPI7j%2b60jY2j2X8CK9vs7O206yhs7OBILaFAkcUYwqqOgAoAsUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB8x/EfTtV1b4/vY6JcC31GZIhBKXKbT5IJ5AyOAa1f%2bFZ/F7/AKGWP/wYSf8AxNT6r/ydfZf9s/8A0mNfQFZypU5u8op/IabWx88f8Kz%2bL3/Qyx/%2bDCT/AOJo/wCFZ/F7/oZY/wDwYSf/ABNfQ9FT9Xo/yL7kPml3Pnj/AIVn8Xv%2bhlj/APBhJ/8AE0f8Kz%2bL3/Qyx/8Agwk/%2bJr6Hoo%2br0f5F9yDml3Pnj/hWfxe/wChlj/8GEn/AMTR/wAKz%2bL3/Qyx/wDgwk/%2bJr6Hoo%2br0f5F9yDml3PnC/8AAHxX03Trq/ufFEa29tE80rfb5OFUEk/d9BXi95eXOoXcl3eTyTzyHLySNuZj05NfXvxivGsvhRr0iHDPHHF1xkPIqn9Ca%2bOquFKnB3jFL5Cbb3CiiirEFFFFABRRRQBq6d4k1rSIGg07Vby1hZtxjhlKrn1x607XdIu9Mltri5uYLtL%2bH7TFcwOXWQEkHJIB3AgggjINZFWPtcxsRZs26ASeaqn%2bFiMEj0yAM%2bu0elSoRTcktWO7K9FFFUIKlguJrW4jnt5XimjYMjo2CpHQg1FRRvuB6V4NTx745muYNJ8VMtxbqGaG4vXRip43AAHIzwfqPWuu/wCFZ/F7/oZY/wDwYSf/ABNeN%2bHtev8Awzrtpq%2bnSbLm3fcPRx3U%2bxGQa%2b0vC/iOy8V%2bHbPWbA/ubhMlCfmjYcMh9wc/z71j9Xo/yL7kVzS7niP/AArP4vf9DLH/AODCT/4mj/hWfxe/6GWP/wAGEn/xNfQ9FH1ej/IvuQc0u588f8Kz%2bL3/AEMsf/gwk/8AiaP%2bFZ/F7/oZY/8AwYSf/E19D0UfV6P8i%2b5BzS7nzx/wrP4vf9DLH/4MJP8A4mj/AIVn8Xv%2bhlj/APBhJ/8AE19D0UfV6P8AIvuQc0u588f8Kz%2bL3/Qyx/8Agwk/%2bJo/4Vn8Xv8AoZY//BhJ/wDE19D0UfV6P8i%2b5BzS7nzufhp8XgpI8SIcdhqEnP8A47XA/EK28caa1jYeMHZgu97Vi0b7hwGO5efTrX2NXz7%2b0vAwm8N3H8JW4Q%2bxHln%2bp/KmqFKLUlFXXkhcz7ngVFFFaiCiiigAooooAKKKKACiiigByO0bq6nDKcg%2bhr74t5TNbRSkYLoGI9MivgdVLsFUEsTgADkmvve2jaG1hibG5EVSR0yBigCaiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiimswRSzEADqTQA6isW51h3lENim9s/exnP0FbCFmQFl2sRyM9KuVOUEnLqFyrqFtJd23lxyFGyO/BHvUdppNva4Zh5sn95hwPoK0KKFUko8qegWCiiioAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKxNd8SWuiR7CPNumGViB6e5PYVzMdt4m8T/vZZja2jcgElFI9lHJ/H86TZ008LKUeeb5Y93%2bh3b3VujbXniVvQuAadHLHKuY5FceqnNcdH8PYAn73UJGbvtjAH8zUc3gO4tz5unakVlHTcCh/76H%2bFK77F%2bxwz0VT8DuaK4K38R6xoF0trrcLyxHgOfvY9Qw4b8f0rtbS7gvrZLi2kWSJxwR/L6007mVbDzpavVPqth09tDcptmjDj37VFZWMVkH8sk7jnLenpVuir5pW5b6GAUUVgzTahpty0kh82F2yfT/61OEOfRPUTZvUVVtL2G8TMbfMOqnqKtVLTTsxhRRRSAKKKKACiiigDmNT/wCQjN9R/IVUq3qf/IRm%2bo/kKqV%2bd4v/AHip6v8AM9KHwoKKKK5ygooooAK8e%2bMdzc6tr%2bg%2bFLVvnuJFkK9md28tM/T5v%2b%2bq9hryHVQJf2jtBV/mVWgwD2wCR%2btevklNSxab6Jsxru0D6B0XSLXQdFs9KskCW1pEsSDHXHc%2b5OSfcmr9FFfanCFFFFABRRRQAUUUUAFFFcd43%2bJWgeBYMX0xnv2XMdlAQZG9C3ZR7n8AaAOxrA1vxr4Z8Oll1bW7K2kXrEZA0n/fAy36V4cNc%2bKXxclK6RG2k6MxI8yNjDFj3k%2b859Qv5V02g/s6aLbKsuvandX8x5aOD9zHnuM8sfrkUAa97%2b0B4ItWIhbUbwDvBbYz/wB9lazJP2kPDIciPSNXZexZYwfy3mu2sPhZ4G05QIfDNg%2bP%2bfhDN/6GTWrH4O8MQrtj8OaQi%2bi2MQH/AKDQB5l/w0j4b/6A2q/lH/8AFUf8NI%2bG/wDoDar%2bUf8A8VXqH/CJ%2bG/%2bhf0r/wAAo/8ACj/hE/Df/Qv6V/4BR/4UAeX/APDSPhv/AKA2q/lH/wDFUf8ADSPhv/oDar%2bUf/xVeof8In4b/wChf0r/AMAo/wDCj/hE/Df/AEL%2blf8AgFH/AIUAeX/8NI%2bG/wDoDar%2bUf8A8VR/w0j4b/6A2q/lH/8AFV6h/wAIn4b/AOhf0r/wCj/wo/4RPw3/ANC/pX/gFH/hQB5f/wANI%2bG/%2bgNqv5R//FUf8NI%2bG/8AoDar%2bUf/AMVXqH/CJ%2bG/%2bhf0r/wCj/wo/wCET8N/9C/pX/gFH/hQB5f/AMNI%2bG/%2bgNqv5R//ABVH/DSPhv8A6A2q/lH/APFV6h/wifhv/oX9K/8AAKP/AAo/4RPw3/0L%2blf%2bAUf%2bFAHl/wDw0j4b/wCgNqv5R/8AxVH/AA0j4b/6A2q/lH/8VXqH/CJ%2bG/8AoX9K/wDAKP8Awo/4RPw3/wBC/pX/AIBR/wCFAHl//DSPhv8A6A2q/lH/APFUf8NI%2bG/%2bgNqv5R//ABVeof8ACJ%2bG/wDoX9K/8Ao/8KP%2bET8N/wDQv6V/4BR/4UAeX/8ADSPhv/oDar%2bUf/xVH/DSPhv/AKA2q/lH/wDFV6h/wifhv/oX9K/8Ao/8KP8AhE/Df/Qv6V/4BR/4UAeX/wDDSPhv/oDar%2bUf/wAVR/w0j4b/AOgNqv5R/wDxVeof8In4b/6F/Sv/AACj/wAKP%2bET8N/9C/pX/gFH/hQB5f8A8NI%2bG/8AoDar%2bUf/AMVR/wANI%2bG/%2bgNqv5R//FV6h/wifhv/AKF/Sv8AwCj/AMKP%2bET8N/8AQv6V/wCAUf8AhQB5f/w0j4b/AOgNqv5R/wDxVH/DSPhv/oDar%2bUf/wAVXqH/AAifhv8A6F/Sv/AKP/Cj/hE/Df8A0L%2blf%2bAUf%2bFAHl//AA0j4b/6A2q/lH/8VR/w0j4b/wCgNqv5R/8AxVeof8In4b/6F/Sv/AKP/Cj/AIRPw3/0L%2blf%2bAUf%2bFAHl/8Aw0j4b/6A2q/lH/8AFUf8NI%2bG/wDoDar%2bUf8A8VXqH/CJ%2bG/%2bhf0r/wAAo/8ACj/hE/Df/Qv6V/4BR/4UAeX/APDSPhv/AKA2q/lH/wDFUf8ADSPhv/oDar%2bUf/xVeof8In4b/wChf0r/AMAo/wDCj/hE/Df/AEL%2blf8AgFH/AIUAeX/8NI%2bG/wDoDar%2bUf8A8VR/w0j4b/6A2q/lH/8AFV6h/wAIn4b/AOhf0r/wCj/wo/4RPw3/ANC/pX/gFH/hQB5f/wANI%2bG/%2bgNqv5R//FVxfwe8R2a/GfUGtw8VnrP2hYI5QAVJbzEBxxnCkfjX0J/wifhv/oX9K/8AAKP/AArxf42%2bFP8AhGtQ0fxn4etIbQWsiRzLBEEVHVt0bkL6nKn6KO9AH0BRWJ4T8S2fi3w1Z6zZEbJ0%2bePOTG4%2b8h9wf6HvW3QAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAfNPjzxBb%2bFv2ihrV1FJNBaLEzJFjccwbeMkDvXaQ/tHeE3wJtM1mMk44iiYAev38/pXOa7a295%2b1La291BFPA/lho5UDK3%2bjk8g8GvZp/A/hK5z53hjRnJGCxsY8/ntzQBzWmfG7wJqLBG1WSzc9FuoGUf99AFR%2bJruNP1TT9WthcabfW15AePMt5VkX8wa4vVfgr4E1RWxo/2OQ/8ALS0laPH0XJX9K8%2b1T4D694enbUvBPiGbz05WKR/Jlx6CRflb8QooA%2bgaK8A0P41eIPC2pLovxB0qYMnBuVj2Sgf3iv3XHuuPxr3HSdY0/XdNi1DS7uK6tJR8skZyPoe4PseaAL1FFFAHAfGm2Nz8JtbCruaMQyD2xKmT%2bWa%2bP6%2b6fE%2blf254V1XSsAtd2kkSZ7MVIU/gcGvhhlaNyjqVZTggjBBoAbRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXaeCvifr/gSyu7TShaywXLhyl0jMI2AxuXDDBIxnOfuiuLooA9Y/4aG8af88tK/wDAdv8A4ulX9obxoGBMOksAckG3fB/8fryaigD2a3/aQ8TKf9J0fSZBn/lmsicfi5ras/2lhkLfeGPq8F5/7KU%2bvevn%2bigD6n039oPwbeFVu01GwY9WlgDqPxQk/pXb6P468La%2byrpmvWM8jdIvNCSH/gDYb9K%2bIaKAPv8Aor4p0D4i%2bLPDRQadrdyIV6QTN5sWPTa2QPwxXr/hb9ou2mKW/ijTTbseDd2eWT8UPI/An6UAe715P%2b0Dozaj8PVv41y%2bnXSSt/uNlD%2brKfwr0jR9c0vxBYLe6TfQXls38cTZwfQjqD7Hmn6tplvrWj3mmXa5t7uFoZAOuGGMj3oA%2bDaK0/EGiXXhzX73R71cT2kpjY4wGHZh7EYI%2btZlABRRRQAUUUUAFFFFABRRRQB0/wAPNGbX/iBomnhdyNdJJKP%2bmafO3/jqmvtivA/2dfCTxpe%2bK7qPAkBtbMsOozmRh%2bIC59mr3ygAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKinmWCIyN26D1oSvogJGYKMsQAO5qu1/bKceZn6A1SSKfUH8yRtsfb/61W00%2b2UcoWPqTWjjGPxMCSO7t5DhZRn0PFT1Rl0yFx%2b7yh%2buRUENxLZSiGflOx9Pf6UckZfCwNWikByPalrMAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooqGS5hilSJ5Arv90Gmk3sBNWRqFpeXl0Iw4FtjOew%2bvqa16KqE3B3QFa0sobOPbGvzHqx6mrNFFS227sAooopAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFZut6omj6XLdMAz/djU/xMen%2bP4VpVwvjN3v9d07SkbAOM/Vmx%2bgH60m7I6MLSVSqlLbdh4X0JtSlbWtUBmMjExq/8R/vH29B/wDWruqjhhS3gSGJQsaKFUDsBUlCVia9Z1p8z26BRRRTMSrf2FvqVq9tdRh42/MH1B7GuH0%2bafwh4iNhcOWsZyMMemDwH/of/wBVehVy3jmxW40QXQH7y2cHP%2byeCPzwfwqZLqdmEqe97Gfwy/PudTRWT4bvDfeH7OZjl9mxj7qcf0rWqjlnFwk4voFNZQ6lWAIPUGnUUEmWNHSO9SeGRo0ByUH9D6VqUUVUpyluAUVny6rDDffZ5FZRjlz0z/hV8EEZHShxcbXW4C0UUVIBRRRQBzGp/wDIRm%2bo/kKqVb1P/kIzfUfyFVK/O8X/ALxU9X%2bZ6UPhQUUUVzlBRRRQAV5FqP8Aycjof%2b9D/wCgmvXa8i1H/k5HQ/8Aeh/9BNe1kP8AvT9H%2bhhiPgPo%2biiivsjiCiiigAooooAKKK4X4pePY/AvhgywlW1S7zFZxnnB7ufZcj8SBQBg/Fb4sjwqToWhbZ9dlUZcAMLbPTI7uey/Qn0OL8P/AILPczjxH46L3l9OfNFlMxbk87pifvH/AGenrnoJfgz8OHUL418Ro0%2bpXZM9os/zFA3Pmtnq7ZyPQc9Tx7bQAyKKOCJYokWONAFVVGAo9AKfRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFUtW0qz1vSbrTNQhE1pcxmORD3B/kR1B9au0UAfM2nahrXwG8by6dfJJeeHr1twZR/rEzgSL2EijAK//WNfRek6vp%2bu6bDqOmXUd1aTDKSRnIPsfQ%2bxqv4i8OaX4p0eXS9XtVntpOR2ZG7Mp7Ef54rwi98CePvhRqUmpeD7qbUtLY5eJE3kj0kiH3v95f8Ax2gD6NorxPQP2itKmAg8RaXcWFwvyvLb/vI898qcMv0%2bau1tvi74Duo96eI7ZR6So8Z/JlFAHb0Vx/8AwtTwN/0M1j/30f8ACj/hangb/oZrH/vo/wCFAHYUVx//AAtTwN/0M1j/AN9H/Cj/AIWp4G/6Gax/76P%2bFAHYUVx//C1PA3/QzWP/AH0f8KP%2bFqeBv%2bhmsf8Avo/4UAdhRXH/APC1PA3/AEM1j/30f8KP%2bFqeBv8AoZrH/vo/4UAdhRXH/wDC1PA3/QzWP/fR/wAKP%2bFqeBv%2bhmsf%2b%2bj/AIUAdhRXH/8AC1PA3/QzWP8A30f8KP8Ahangb/oZrH/vo/4UAdhRXH/8LU8Df9DNY/8AfR/wo/4Wp4G/6Gax/wC%2bj/hQB2FFcf8A8LU8Df8AQzWP/fR/wo/4Wp4G/wChmsf%2b%2bj/hQB2FFcf/AMLU8Df9DNY/99H/AAo/4Wp4G/6Gax/76P8AhQB2FFcf/wALU8Df9DNY/wDfR/wpR8UvA7MAPE1hzxy5H9KAOvopkciSxJLE6vG4DKynIIPQg%2blPoAKKKKAPn/Vf%2bTr7L/tn/wCkxr6Ar5/1X/k6%2by/7Z/8ApMa%2bgKACiiigDG8R%2bF9G8Waa1hrNlHcxH7jHh4z/AHlbqp/ya8B1PSPFPwJ19dT0qd7/AMPXEm1g/CP/ALEgH3X9GHXH1Wvpequoafaarp89hf26XFrOhSWKQZDA0AZfhLxZpnjPQYtV0yQlG%2bWSJvvwuOqt7/zrer5ouYNR%2bBHxHSeAy3HhvUDjH9%2bLPKn/AKaJnIPcY6ZIH0hZ3lvqFlBeWkqzW88ayRSL0ZSMgj8KAJ6%2bPfjD4abw18RdQVE22t832yAgcYcncPwbcMemK%2bwq8u%2bOXg4%2bI/Bh1K1j3X2k7pwAOXix%2b8X8gG/4CfWgD5RooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKANXQfEWr%2bGdRW/0e%2bltJxjJQ8OPRl6MPY19JfDj406f4raLS9aEdhrDYVGziG4P%2byT91v9k/gT0r5Ypen1oA%2bnvjd8N5PEunr4g0iDfqlmm2aJB81xEOeB3ZeceoyOwFfMJ4%2btfQ/wAHPi7Jfyw%2bGPElzuuDhLK8kPMh7Ruf73oe/Q84zyPxz8M2Om%2bP7OPR7MRS6nAJZIo%2bA8rSMuQOgzge1GwHktFTXNtPZ3D29zDJDNGdrxyKVZT6EGoaFrqgCiiigAooooAK6nwF4JvvHXiOLTrUFLZMPd3OOIY/X/ePQDufYEi14F%2bGuueOrtfskRt9OVsTX0qnYvqF/vN7D8SK%2brvCfhLSvBmippmlQ7UB3SStgvM395j3P8qANLS9NtNG0u202xhEVrbRiOJB2A/r71coooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACsu9JnvY7cHgYz%2bP/wBatSsxvl1oE9D0/wC%2bcVpS3b8gNFVCKFUYAGBTqKKzAKq30IltmOPmT5hVqo5iFhcnoFNOLaaaAg06UyWoB6qdtW6z9JB8mQ/7VaFVUVpMAoooqACiiigAooooAKKKKACq19qFnplo93f3UFrbp96WeQIo%2bpPFcb8RfibpngGyEbAXerTLmC0VscdNzn%2bFf1OOO5HlOk%2bBfGvxdu49b8V6hLY6Ux3QIV6qf%2beUfRR/tHrx96gDuNd/aB8J6Y7xadHd6rIvRok8uL/vpufyU1y4/aA8R6iSdJ8Gh0PC/PJNz9VUZr1Dw98LvB/hqNPsmjQTzqObi7AmkJ9ctwp/3QK7AAKoAAAHAA7UAeAf8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNH/C5fiP8A9CN/5JXH%2bNfQFFAHz/8A8Ll%2bI/8A0I3/AJJXH%2bNB%2bOHjm0Ba%2b8EhVxkZgnj4HXrmvoCigDw/Sv2kNLlkEesaDd2fOC9vKJgD7ghSP1r1Hw5408PeLIt%2bi6pBcuBuaHO2RB7ocEfXGKsax4X0LxDGU1fSLO8yMbpYgWH0bqPwNeQ%2bKfgG1pN/avgfUJrS8iO%2bO1llIwR/zzl6qf8Ae/MUAe60V4b4D%2bMl7aaqPDHj2NrW9RhEt7KuwhuwlHQf7446Z9a9x6/SgBaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiq15O9vB5kabzkDFZ/8Aa12OTadenBrir4%2bjQnyTvf0ZcacpK6NmisYa4VOJLcj6N/8AWqzFq9rIcFmQ/wC0KmnmeEqOymvnp%2bY3SmuhoUU1WV1DKQwPcHNOruTvqjMKKKKYFDUdSSyTavzTHovp7mqVhpr3D/a7wli3IU9/c/4VoPp1vJefaWXLY6difWrlbe0UY2hu92KwUUUViMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArhdS%2bX4j2hfodmO3Yj%2bdd1XD%2bN4JLTULDVoRyhCk%2bjKdy/1/KplsdmC1qOPdNHcUVBaXMV7aRXMJzHKoZanqjkaadmFFFFAgrI8UFR4avi3Ty/1yMVr1yPjvUFh02OwQ5kuGDMB/dB/xx%2bRpPY3wsHOtFLuW/BAI8Nx56GR8fnXR1naFZHTtEtLZhh1TLj0Y8n9TWjQtia8lKrKS7sKKKKZkFFFFAFS9sY72PDcOPuuO1Zdndz6dcfY7pSUzhSOcfT1Fb9MaNHZWZQWXlSR0rWFS0eWWqFYfRRRWQwooooA5jU/%2bQjN9R/IVUq3qf8AyEZvqP5CqlfneL/3ip6v8z0ofCgooornKCiiigAryLUf%2bTkdD/3of/QTXrteRaj/AMnI6H/vQ/8AoJr2sh/3p%2bj/AEMMR8B9H0UUV9kcQUUUUAFFFFACEhQSTgDua%2bbrOL/hcvxqmuZsvoOm8hT91oUbCr/wNsk%2b2fSvXPi1rreH/htq1zE%2b2edBaxHvmQ7Tj3C7j%2bFYPwE8PLpHw%2bXUXTFxqspmYnr5akqg/Rm/4FQB6mAFUAAADgAdqWiigAqlqmq2GiabNqOp3UdraQruklkOAP8AE%2bgHJq7Xzn8btUvPEfxB07wfDK0dpbhGcdjI4yWI74TGPq3rQNJt2R0Go/tIaLBdtHp%2bi3l3CpwJZJVi3e4GCcfXFdP4L%2bMvhvxheR6fibTtRk4jgucbZD6K44J9jgntmuJ03QtN0m1W3tLSJVA5YqCzH1J6muR8feF7WPTn1rT4hbXNuwaTyhtDDIGcDoQcHP1oO%2bpl84Q573sfVNFch8MfEc3in4faXqV0%2b%2b72GGdu7OhK7j7kAN%2bNdfQeeVr6/tNMsZr2%2buI7e1hXfJLI2FUe5ryDVv2jtBtLxotM0m7v4VOPPZxCG9wCCcfUCsn48ape6x4p0PwVZyFIp9ksnozu5Rd3soBP/Avauv8AD/hDRfDmnpa2VlDuC4kndA0kh7kk8/h0HavOx%2bZQwaSau30NadJzHeD/AI3%2bG/FN/Fp08c2l30rBY0uCDHIx6KHHf6ge1em14D8UPAenXmgXWtWFtHbX9mhlcxKFEqD724DuBk59sfT0D4O%2bJbjxP8PLSe8kMt3aSNaTSE5LlcEE%2b%2b1lzWuCxsMXT546d0TUg4OzO%2bqG5uYLK2lubmaOGCJS8kkjBVRR1JJ6Cpq8I/aJ8RXSR6T4YtXZEu83FwBxvAbain2zuJHqF9K7Er6EGlrf7RPh6wvWg0vTrrUo1ODPuEKN/u5BJH1ArQ8LfHjw14gvo7K%2bhn0m4lbajTsGiJPQbx0/EAe9eM6fpVrYQKiRq0mPmkI5Y1U1zR4LqzkmjjVJ41LBlGN2Oxr2Z5LVjS5%2bbXt/wTV0na59jUV5j8DPE1x4g8BCC9kaW502Y229jktHgFCfoCV/4DXp1eMZBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAYWteDfDfiIltW0WzupDx5rRASf99jDfrXIT/AfwHLIWSwuoR/dju3I/8AHiT%2btemUUAeX/wDCgfA3/Pvff%2bBR/wAKP%2bFA%2bBv%2bfe%2b/8Cj/AIV6hRQB5f8A8KB8Df8APvff%2bBR/wo/4UD4G/wCfe%2b/8Cj/hXqFFAHl//CgfA3/Pvff%2bBR/wo/4UD4G/5977/wACj/hXqFFAHl//AAoHwN/z733/AIFH/Cj/AIUD4G/5977/AMCj/hXqFFAHl/8AwoHwN/z733/gUf8ACj/hQPgb/n3vv/Ao/wCFeoUUAeX/APCgfA3/AD733/gUf8KP%2bFA%2bBv8An3vv/Ao/4V6hRQB5f/woHwN/z733/gUf8KP%2bFA%2bBv%2bfe%2b/8AAo/4V6hRQB5f/wAKB8Df8%2b99/wCBR/wo/wCFA%2bBv%2bfe%2b/wDAo/4V6hRQB5f/AMKB8Df8%2b99/4FH/AAo/4UD4G/5977/wKP8AhXqFFAHl/wDwoHwN/wA%2b99/4FH/Cq2o/s%2beEJ7CeOxa9tbplPlTGbeFbtlT1HqK9ZooA%2bcfCXjfXfhJrv/CJ%2bMopG0oH9zKvz%2bSpPDxn%2bKM9x1HOBkEH6ItbqC%2btYrq1mjmt5VDxyRsGVlPQgisPxj4M0nxvoradqkWCPmhuEA8yFvVT/MdDXhuia/4j%2bB3iT%2bw9fjku/D07lo2j5BXPMkXoem5D/UEgH0pRVPS9UstZ02DUdOuUuLS4XfHKh4I/ofUdquUAfP8Aqv8AydfZf9s//SY19AV8/wCq/wDJ19l/2z/9JjX0BQAUUUUAFFFFAHMePvCMHjTwjeaTIFE%2b3zLWQ/8ALOYfdP0PQ%2bxNec/ADxRO1rf%2bDtS3LdaezSQI/wB5U3YdP%2bAsc/8AAj6V7bXzv4xjHgH9oPS9chHl2epOksuOFG8mOX8f4/q1AH0RSEBgQRkHsaWigD5A%2bLfgVvBXix/s0RGk3xM1oQOE5%2baP/gJPHsV968/r7c8beELHxt4an0m8%2bRz89vPjJhlHRh/IjuCa%2bNte0LUPDWs3Ok6nAYbqBtrDsw7Mp7gjkGgDMooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAHKxRgykhgcgg8g13V74yuvGPiTwjNfgtfWRhtZpT/AMtcTZD/AFIIz7gnvXB1f0a5jstbsLubIiguY5HwMnAYE/yqKibg0uw1ufUXiHwfofiiHbqdkjygYSdPlkT6N/Q8V5ZrPwMvI3Z9F1SKZO0V0CjD23KCD%2bQr22ORJY1kjYMjgMrDoQehp1fB4bMMThtIS07PY9CVOMt0fMd38LvGNoxDaM8qjo0MqPn8Ac/pVZfhz4vdgo0G6yfXAH5k19S0V6K4gxFtYr8f8zL6tHufOum/BnxXeuouY7WxU9TNMGP5JmvXvC/7P/hzSHjuNZnl1e4XnYw8uEH/AHQct%2bJwfSuuT76/Wuwr1spx9XF87qW0tt8zKtTULWIoIIbWBILeJIYUG1I41Cqo9ABwKloor2DAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArO1KJgUuE6r19vetGkIDDB5Bqoy5XcCG2uFuIgw%2b9/EPQ1PWbLYSRSeZasR/s56U0Xt3HxJBn32kVfs09YsDUrO1C5BX7PHyzH5sfyphmvrj5UjKA9wMfqasWtisB3ud0n6ChRUNZAS2sPkW6p36n61PRRWbd3cAooopAFFFFABRRRQAVy3j/AMZ2vgfwtPqk22S5b93awE/62Ujj8B1PsPcV1NfOXjIy/FL44W3hqKRjpemOYpSp6BeZm9iSNg%2bi0AXPhX8PrjxfqUvjrxiDdi4kMltBOMiZs/fYdNg6KvTj0Az9AdPpUdvBFaW0VtBGscMSBI0UYCqBgAe2KloAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOC%2bJfw2sfHekM8aRwazAp%2bzXOMbv9hz3U/oeR3B474LeO71LuXwJ4jLx6hZ7ktDMfnwud0R9SuMj2BHYV7dXgfx38OzaNq%2bl%2bPNIBhuY5kjuGUdJF5jc/kVP0WgD3yisnwzrkPiTw1p2swABLuBZCoOdrfxL%2bByPwrWoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGsqsMMAR6Gqs2m2sw/wBUEPqnH/1quUVlVoU6qtUin6jUmtmYUlpd6cxlt5C8Y5I/xFaFjfpeJj7sg6r/AFFXaw9RgNjOl5B8ozyO2f8AA15ssPUwUlPD3cG9Y779V/X/AANVJVFaW/c07u8is4w8pPJwAOpqaORZY1kQ5VhkH1rCtoZNXvDcT8Qqfu/0/wAa3wAoAAwB2Fe5UhGFl16mCFooorIYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVS1PT4tU0%2ba0m%2b644b%2b6exq7RQOMnFprc8%2b0TV5/DF/JpOqAi33ZV%2buzP8Q9VNd7HIk0ayRurowyrKcgiqOraLaazb%2bVcp8y/ckX7y/Q/wBK5P8AsXxJ4edjpkxuLfOdq8/mh7/Sp1R3S9lifevyz632Z31FcKPF%2buQfJcaP84/6Zuv6U1tf8U6l8lnpxhB6OsR/9CbijmRH1Gr1aS73Oq1fWbTR7Uy3DguR8kQPzOf8965TQbC68Q6y2t6gv7hGzGp6MR0A9h/nvVjTvBk9xcfa9cuDK5OTEGLE/wC839B%2bddjHGkMaxxoqIowqqMACize5TqU6EXGk7ye7/wAiSiiiqOEKKKKACiiigAooooAKyYdUcX7290gjBOE9vrWtWdqeni8h3oB5yfdPqPStKfLe0uomaNFZWkXzTobeUHzYx1Pce/vWrUzg4S5WNHMan/yEZvqP5CqlW9T/AOQjN9R/IVUr85xf%2b8VPV/melD4UFFFFc5QUUUUAFeRaj/ycjof%2b9D/6Ca9dryLUf%2bTkdD/3of8A0E17WQ/70/R/oYYj4D6Pooor7I4gooooAKKKKAPDv2lL8x6BoWnA8T3Uk5H/AFzUD/2pXr/h/T10jw5pmnKu0WtrFDj/AHVA/pXiP7RY8zXPCsT/ADRnzsqTxy0YNfQFABRRRQAV83fGa1uPDXxW0/xK0bSWd1Gh3AfxINjqPfbg/jX0jWR4j8N6X4r0aXStWtxNbScg9GRh0ZT2I/zwaBxk4tNdDyWzvbbULVLm0mSaFxkMp/zg1yPxE1%2b2s9Fl0tJFa7ucKUB5RM5JP1xgfX2rdvP2d9VtLlzoXiZEt3P3Z1aNwvoSmQ35Cul8GfAfStB1CLVNbvTq15G29I9m2FW9SCSXOfXA9qD0auYudPlSs2dN8JdBuPDvw30u0u0MdzKrXEqHqpclgCOxC7cj1zXb0UUHmnz38c7S70Hx94f8XxxGS1URxn0Ekbltp9Nynj6GvRNI1mw17TY7/TrhJ4JBnKnlT6MOx9q6/W9E07xFpM%2bl6rbJcWkwwyN29CD1BHYivE779nrU7G8eXw14oMETdFnDRuo9Cyfe/IV5mY5bHGWd7NGtKryF/wCKXiuy0XwveaaJlbUL6IwpCp5VG4Zm9BjOPU10/wAENBn0L4a2xuUMct/M17sPUKwVVz9VVT%2bNYPhX4A6dp2orqPiTUG1edW3iAIViJ9XJJL/TgeuRXsgAUAAYA7CtcBgo4OnyJ3b3YqlRzdxa8A/aL0a6jvdF8RxKXgjBtpOOEYMXTP1y35e9e/1T1TS7LWdNn07UbZLi0uF2SROOCP6H0Pau9OzujM%2bVrK9gvrdZoHBB6jup9DVXW9RisbCRSw86RSqL357/AEr0HWf2c5kvJJvDuviGJj8sN2p3J7b16/lWh4Y/Z5srS%2bW88S6mdR2HItYVKIx/2mJyR7DH1r2553KVLlUfe7mzqu1jW%2bAGgz6V4CkvrlGRtSuDNGrf88wAqn8SGP0xXrFMjjSKJIokVI0AVVUYAA6AD0p9eGYhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVj%2bJfDOl%2bLNGl0vVrZZoX5VsfPE3ZkPYj/6x4NbFFAHzRDP4n%2bAvicwzB9Q8NXknBAwsg9V/uSgduh9%2bCPoTQdf0zxNpEOqaTcrcWso4I4KnurDsR6U/WdF07xBpc2m6papc2kwwyOPyIPYjsRzXzzf6Z4m%2bBHib%2b0dNaTUPDly2GD5CMOySY4Vx2bv%2ba0Aa2q/8nX2X/bP/wBJjX0BXzTp3iOw8V/tHaRrOms5t7gJgOuGVhbkMp9wQRX0tQAUUUUAFFFFABXh/wC0np6yeHtE1Pb80N09vn2dN3/tOvcK8n/aGAPw2iJHTUIse3yvQB6J4bvm1TwvpGoOSWurKGck9SWQN/WtSuX%2bG/8AyTXw5/2D4f8A0EV1FABXEfEb4cad4%2b0sLIwt9Tt1P2W6A6f7LDupP4jqO4Pb0UAfCviHw7qnhbV5dM1a1a3uI%2bmfuuueGU9wfWsqvuLxT4R0XxjpZsdZtBKoyY5V4kiPqjdv5HuDXzT45%2bC/iDwo0l3Yo%2bq6WMnzoU/eRj/bQc/iMj1xQB5nRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAfSHwi146x4KitpX3XGnt9nbPXZ1Q/lx/wGu9r5/wDglqhtPF1xp7N%2b7vbc4Hq6fMP0319AV8Lm1BUcVJLZ6/f/AMG56FGXNBBRRRXmmg5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKa7qilnYKo6knAFADqKxrvxTo1nkPepI392L5/5cfrVjSNVj1i0a6hikjiDlF34y2Mc8Urmjo1Ix5mtDRooopmYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFY%2bgeIrPxHBczWayhLedoW8xQMkdxz05qlCTi5JaILGxRRRUgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBU1S9XTNIvb9/uWsDzN9FUn%2bleH/s56cbqfxD4iuSXuJXW3WQ9eSXk/M7Pyr1X4hyNF8OPEjL1OnTrz6FCD/OuK/Z3jVPhxcMM5fUpWP12Rj%2bgoA9booooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACuY%2bIWkLrnw%2b1ywYAs1o8kef76Dev/AI8orp6ZJGssTxvyrgqfoaAPI/2dtVa88C3enu2TY3jBBnojgMP/AB7fXr9eBfszyMY/E8ZPyqbVgPc%2bbn%2bQr32gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACqt7aJeW5jbOeqkHoam82PzfK3r5mM7c84qSnqtVoBkaLLhHtm4ZDkA/rWvWHeA2GqLcKPkfk4/UVtKyuoZTkEZBrzMvqzalQqu8oP710ZrVS0ktmOooor0jIKKKKACiiqk%2boW1u213y2eQvOPrWdSrClHmm7LzGk3oi3RSAgjIpa0EFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAMVFQsVUAsckgdTT6KpXuoR2JjDozFz26Ad6cYuTsgMXU/%2bQjN9R/IVUq1qLB7%2bVlIIOCCO/AqrX53i/wDeKnq/zPSh8KCiiiuYoKKKKACvItR/5OR0P/eh/wDQTXrteRaj/wAnI6H/AL0P/oJr2sh/3p%2bj/QwxHwH0fRRRX2RxBRRRQAUUUUAfP/7RH/Iw%2bE/%2b2v8A6HHX0BXz/wDtEf8AIw%2bE/wDtr/6HHX0BQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABVW/sLTVbCexv7eO4tZ1KSRSDIYVaooA8HsfhNd%2bC/i/oep6YslzoUlw%2bG6tbExvhX9vRvwPPX3iiigAooooAKKKKACvJ/2hv%2bSbRf8AYQi/9BevWK8n/aG/5JtF/wBhCL/0F6AOw%2bG//JNfDn/YPh/9BFdRXL/Df/kmvhz/ALB8P/oIrqKACiiigAooooA4Hxb8IPCniwyTvZ/YL9%2bTdWeELH/aX7re5xn3rxHxR8CPFGgrLcWDQarZRgsXjYRyKo7sjH%2bRNfVleP8AiTWdR8e%2bJP8AhHdFfGnxsfMcH5ZMHl2P90HoO/HqK6cLhnXk9bJat9kVGNz59tPC19OoaUpAp7Ny35CrD%2bEJwpMd1GzejKR/jXoHxK8N22leOPC/hSwlmzeLF9okLkGUySlBx0A%2bU4r1LU/gl4SvXaWyW90qYnO6zuDjP%2b6%2b4Y9hiul1cDF8qg2u97fgO8F0PlO90660%2bTbcRFQejdQfoaqV9C%2bLfhTc6Loklx9sGqWqn96DB5bxr/eOCQceox9K8wtvhd4n1aCa70WxW%2bto3KkpOiuvfBViD37ZrPEYaCgq1F3g/vT8wlFWutjiaK6O88A%2bLrAn7R4a1VQOrLaOy/mARWJPZXdq4S4tponJwFkjKnP41wkFetW18PajdgMIhGh6GU7f06/pWzY6fa6HZi%2bv8Gc/dXrtPoB61l33iS%2bumIif7PF2Cdfz/wAK9JYWjQipYlu7%2byt/macqXxE58I3mOJ4Cfqf8Kz7zRL%2bxBeWEtGOrocj/AOtVcahehtwu7jd6%2bYa1tP8AE91AwW7/AH8XQnHzD/H8aE8DU92zj57r5h7jMCiuo1fSLe6tP7R03BBG5kXoR6gdiO4/yeXrlxOGnh58suuz6NEyi0FFTva3EcAne3lWIkASMhCkkZAz06VBXOSFFFFABRRRQAUUUUAdL4AuzZePdElUkFrpIuP9v5D/AOhV9UV8keGN/wDwlmjeXnf9ug24658xcV9b18pxDFe1g/L9Tsw2zCiiivnjoHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRVO71SxsB/pV3DEeu1mGfy61g3njvTIMi3Sa5bsQNq/mef0pXSNadCrU%2bGLZ1VFcH/wAJP4h1XjTdO2IejqhfH/Aj8v6Uf8Iz4j1U51LUPLQ9UaQtj/gK/L%2btLm7G/wBT5f4s1H8WdTd6/pVjkT30QYdVU7m/IZNYV34/tEytpayzHsXIQf1NS2fgPTIcG5lmuW7jOxT%2bA5/Wt600qwscfZbOGMj%2bIL8359aNQvhYd5fgv8zkP7X8Wat/x52Zt4z0YR7cj/ef%2blKvgzVdQYPqmp%2b%2bNxkI/PAFd3RRy9w%2buyj/AAoqP5nnHibQNP0LTofJaWS5lkxuduigc4A/Cu00Cz%2bw6FZwEYYRhmHueT%2bprlvEn/E28Z2WmjlI9quPr8zf%2bO4rvKEtTTFVJOjCM3dvX/IKKKKo88KKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKinnitoHnnkSKKMbnd2wFHqSayf8AhMPDf/Qbsf8Av8KuNOc/hTY0mzbrz74T/wDIJ1X/AK/2/wDQRXTf8Jh4b/6Ddj/3%2bFcR8Nde0nTNM1KO%2b1G2t3kvGdBLIFLLtHIrto0an1aouV/Z6epST5WepUVif8Jh4b/6Ddj/AN/hVmw13SdUmaGx1G1uZVG4pFKGYD1xXG6NSKu4v7ibM0qKKKzEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHL/ABI/5Jr4j/7B83/oJrj/ANnn/km0v/YQl/8AQUrsPiR/yTXxH/2D5v8A0E1x/wCzz/yTaX/sIS/%2bgpQB6xRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHz/APsy/wDM0/8Abp/7Wr6Ar5//AGZf%2bZp/7dP/AGtX0BQAUUUUAFFFFABRRRQAUUUUAFFFISAMnpQAtUrvU7W0yJH3P/cXk1lalrTOxhtW2oODIOp%2blYvXk9aaR008PfWRtTeIpCcQwKo9XJNVm12%2bJ%2b%2bg%2biCs2inY6FSguhqpr94p%2bYRv9Vq9b%2bIYXIE8bRn%2b8OR/jXOUUWFKjB9DuYpo5kDxurqe4NSVxNtdzWkm%2bFyD3HY/UV1Gn6jHfx8fLKv3k/qPak0ctSi4a9C9RRRSMQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqK4nS2geZ%2bij86lrM1a1ubvykix5efm55z61cEnJJvQGVdKhe7u3vpucH5fr/9at2ooIUghSJB8qjAqWnUnzyv0EiveWy3Vu0Z4PVT6GsyyvWsnNtdAqoPB9P/AK1bdV7i0hulxKuSOjDqK8vFYWcpqvQdpr7muzNYTSXLLYlR1kXcjBge4OafWM2iyI2YLjH14/UUf2VeNw13x/vE1n9cxa0lQd/Jqw%2bSH8xqSTxQj95Iq/U1Rm1mBOIlaQ/kKZHocYOZJmb/AHRirsNlbQcxxLkdzyaL5hW0SVNfe/8AIP3cfMzM6lqHQeVGf%2bAj/E1at9Ihiw0p81vfp%2bVaVFXTy2kpc9Vucu7/AEWwOq7WWiEAAGAKWiivRMgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqrfWi3ls0Z%2b91U%2bhq1RTTad0Bx21kJVgQynBBpKt6n/yEZvqP5CqlfnmNd8TUf95/melD4EFFFFcpQUUUUAFeRaj/AMnI6H/vQ/8AoJr12vItR/5OR0P/AHof/QTXtZD/AL0/R/oYYj4D6Pooor7I4gooooAKKKKAPnz9o8yLrPhgxDMgSYoPfcmKk/4Sr45/9AH/AMk1/wAaT9oj/kYfCf8A21/9Djr6AoA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAaP%2bEq%2bOf/AEAf/JNf8a9/ooA8A/4Sr45/9AH/AMk1/wAa5P4h638S9Q8NLB4t0v7Npv2hGD/Zwn7zDYGQfTNfVdeT/tDf8k2i/wCwhF/6C9AHYfDf/kmvhz/sHw/%2bgiuorl/hv/yTXw5/2D4f/QRXUUAFFFFABRRRQBzPjzVm0fwffTxttmlUQRkdQW4JHuBk/hWV8LNETTvDIv2UfaL5t5PcICQo/mfxqr8YXYeGrJAeGuwT%2bCN/jXY%2bHI1i8M6UifdWziA/74Fei37PAJL7UtfkXtA8T8f8/tJeF/8At0/9GNX0BXz/AOPv%2bTk/C/8A26f%2bjGr1jxH8QvDHhW7W01bUhHdMA3kxxtIyg9ztBx%2bNecQdJJEk0TxSoro4KsrDIIPUGvJ/CCv4V%2bJ19oG4/ZrjcqAn0G9D9duR%2bNelaJrumeI9NTUNJvI7q2Y43rkEH0IPIPsRXnXicCP4y6OyfKX8jcR3%2bYj%2bVejl75lUpPZxf3rYuHVHq9cB8VddfTtAj06Bis1%2bSrEHkRjG788gfTNdz9oiNybbePNCbyvoM4zXlni1Rqvxc0mxf5oovJBXrkZLnP1FRl0Iyr80topv7ggtdTq/CfgvT9L8OwQX1jb3F1KvmTmaIPhiPu89gOPzrTk8HeGJl2yeHNIdfRrGIj/0GpPEHibR/C9kt3rN9HaxMdqBgWZz6KoyT%2bArO8O/ELwv4quzaaVqayXQBIhkRo3YDuAwGfwrkq1JVZuct2S3d3LH/CCeD/8AoVND/wDBdD/8TQPAvhAHI8K6GCO40%2bL/AOJroKKgR518QvBWnv4ce%2b0rT7a1ns8yMtvEsYeP%2bLIAGSOv4H1rU%2bHN/bap4Vt5Vt4EubYmCUpGFJI6Hj1BGffNdbLEk8LxSLuR1KsD3B4NeW/CN3ttT1zTidyoVOfdWZT%2beR%2bVelB%2b2wUoy3g016PdGi1hbsXfjrYfbPhZfSgZa0mhnH/fYQ/o5r5Jr7c8e2H9p/D/AF%2b027mexlKD1ZVLL%2boFfEdeaZhRRXU6N8OPGGvxLNp3h%2b8khYZWSQCJGHqGcgH8KAOWor0Sb4H%2bP4oi40VJMdVS7iJ/Vq5DWfDWteHZhFrGl3dkxOFM0RVW%2bjdD%2bBoAyqKKKAOl%2bH9ob3x9okQBO26WX/vj5/8A2WvqivAvgjpTXXiq51Jl/d2UBAPo78D/AMdD177Xx%2bfVVLEqC6L/AIJ24dWjcKKKK8M3HJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGF4i8Ow63bb0xHdoP3cnr/sn2/lXMeGbmz03UH07VrKGO4DYSaRASp9CT29DXolYXiLw7DrdtvTEd2g/dyev%2byfb%2bVS11R24fELl9jUfuv8Dc6DFLXEeHfEU1lcf2PrGY3Q7I5H7eik%2bnoa7emncwrUZUpcsv8AhwooopmIUhIAyTgClrJ8SXn2Lw/eSg4YpsX6tx/WgqEXOSiupzPhQf2p4qv9TblU3FfYscD/AMdBrvK5fwNafZ9CM5HzXEhbPsOB%2boP511FKOx0Y2SdZpbLT7gooopnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAV7yzt7%2b0ltbqISwSrtdD0IrB/wCFfeFf%2bgPF/wB/H/xrpqK0hWqU1aEmvRjTa2OZ/wCFfeFf%2bgPF/wB/H/xrjPh34W0XWdN1CXULBJ3iu2jQlmGFwOODXrNeffCf/kE6r/1/t/6CK7qWIrPD1G5u65er8y1J8r1Nv/hX3hX/AKA8X/fx/wDGrml%2bFdE0W6Nzp2nxwTFChcMxODjjkn0FbVFccsRWkrSm2vVkcz7hRRRWIgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5f4kf8k18R/8AYPm/9BNcf%2bzz/wAk2l/7CEv/AKCldh8SP%2bSa%2bI/%2bwfN/6Ca4/wDZ5/5JtL/2EJf/AEFKAPWKKKKACiiigAooooAKK4Txl8WfDPguVrW5ne81BetpagMy/wC8ScL9M59q86b9o%2b9lZntfCO6EHGTds35kJigD6AoryDw3%2b0H4c1adbfV7SfSJHOBIzebEPqwAI%2bu3HvXrcM0VxCk0EiSxSKGR0YMrA8ggjqKAJKKKKACiis/WNb0zw/p0moatexWlrH1kkPU%2bgHUn2HNAGhRXh%2br/ALR2nx3LQaHoNzfDOFlnl8rd7hQGJ/HFVbX9o8xXITVfC0sMR53Q3OWA/wB1lGfzFAHvVFc74U8b6B4ztGn0a%2bWR0AMtu42yx/7y%2bnuMj3roqACiiigAoorznxh8aPC/hO4kskeTUr%2bMkPDa4Kxn0ZzwD7DJHcUAejUV8/n9o%2b%2bbM0fhAfZxzn7Wx4%2bvl4rq/Cvx48Ma/cR2moJLo905wpnYNCT6eYMY/EAUAeq0UgIZQQQQeQR3paACiiigAooooA%2bf/wBmX/maf%2b3T/wBrV9AV8/8A7Mv/ADNP/bp/7Wr6AoAKKKKACiiigAooooAKKKKACsDXdQOfskR/66EfyrZupxbW0kx/gXP1NcU7tI7OxyzHJPvTR0YeF3zPoNorb8PIjvcb1VsBcZGfWtS8kjtYfNFoJU7lQOPenc3lW5ZctjkKK3/7cs/%2bfP8AQUf25Z/8%2bf6CgfPP%2bUwKK3/7cs/%2bfP8AQUq61auwVbIljwAAKA9pP%2bU5%2bpIJ5LaZZYzhl/WuyjjjZFLwIjEfdIBxXJagANQuAAAA5xihO4qdVVG1Y6y0uku7ZJk/iHI9D6VYrmtAujHctbk/LIMj6j/61dLSZyVYckrBRRRSMwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACis241F49TjtYo1fOA3PIJ/%2btWlVSg42b6gFFFFSAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBzGp/wDIRm%2bo/kKqVb1P/kIzfUfyFVK/O8X/ALxU9X%2bZ6UPhQUUUVzlBRRRQAV5FqP8Aycjof%2b9D/wCgmvXa8i1H/k5HQ/8Aeh/9BNe1kP8AvT9H%2bhhiPgPo%2biiivsjiCiiigAooooA%2bf/2iP%2bRh8J/9tf8A0OOvoCvn/wDaI/5GHwn/ANtf/Q46%2bgKACiiigAooooAKKKKACimu6xoXdgqgZJJwAKyX8UaNG5Vr5SR/dRmH5gVUYSl8KuBsUVi/8JXon/P7/wCQn/wo/wCEr0T/AJ/f/IT/AOFX7Gr/ACv7gNqisX/hK9E/5/f/ACE/%2bFH/AAleif8AP7/5Cf8Awo9jV/lf3AbVFYv/AAleif8AP7/5Cf8Awo/4SvRP%2bf3/AMhP/hR7Gr/K/uA2qKxf%2bEr0T/n9/wDIT/4Uf8JXon/P7/5Cf/Cj2NX%2bV/cBtUVi/wDCV6J/z%2b/%2bQn/wo/4SvRP%2bf3/yE/8AhR7Gr/K/uA2qKxf%2bEr0T/n9/8hP/AIUf8JXon/P7/wCQn/wo9jV/lf3AbVFV7W8tr2LzbaZJU9VPT6%2blWKzaadmAUUUUgCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKwdS1W5tb54oymwAcFfaq6eIbofejiYewI/rTsbKhNq6OmorDi8RxniWBl91Of8K0INStLniOZdx/hbg/rSsRKnOO6LlFFFBAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeT/tDf8AJNov%2bwhF/wCgvXrFeT/tDf8AJNov%2bwhF/wCgvQB2Hw3/AOSa%2bHP%2bwfD/AOgiuorl/hv/AMk18Of9g%2bH/ANBFdRQAUUUUAFFFFAHFfFGwa98FyyICWtZUnwPTlT%2bjZ/Cr3gDUk1PwXp7KRvgT7O49CnA/Tafxrobm2ivLWa2nQPDMhR1PdSMEV5BomoXHw28XXGlajuOmXDAiTH8P8Mg/kR/hXpUI/WMLKivii7rzXVGkfejYxPH3/Jyfhf8A7dP/AEY1ed/ES1vrX4ha4uoBvOe7kkUt/FGxyhHttxj8u1eg%2bN54rn9orwrcQSpJC62jK6HKkeY3INe3anoeia/sGp6dZXxj%2b4Zolcr9CeRXm7GZ5B%2bzta3yx63dMGWwcxIuc4aQbicfQEZ%2boqDxfqFzqvxAu7jTZCrWrCOKVWxtKcEg/wC9nFeheM/Fdh4R0f8AsvSlhivWTZDBAoVbdT/FgcD2FcFbaPc6VZwtc28sb3CCXfIuC2RmvSw85YOk8Q1rLSN/xZ3YKgqk/eeg7RtH8Yand3E9jrcguUQM5a7kDOOgGcYP41HZT6zY/EvTJvEIdL0zJGzuANyn5AQRwR7iu4%2bHv/H/AHn/AFyH86r/ABa0eSbTrTWbcN5lm%2b2Qr1CN0b8GA/76rfBY91p%2bzqJLmTV0rbjxMVCs6a2PK/jxNeP8Q/KuC32eO0j%2bzA9NpzuI/wCBbvyHpXA%2bH57u28RabLYFxdrdR%2bTs6ltwwPx6V9OSaL4f%2bK/hWzuNTib7TENrTQMFlhkx8wBwRg9cEEdKPCfwj8N%2bE9QTUYRc3l7H/q5bpgRGfVVAAz7nPtXkThKEnCW6OBqx31FVbu/t7Ncyvyeijkmsp/EnzfJbcf7T/wD1qmxcac5apG6zBFLMQFAySe1eU/CbN1rmu3yrhGC4z/tMxA/Stfxp40W08N3NukZS7u0MUeGzgH7x/LP4kVd%2bGWj/ANl%2bE45pABNeN5zeoXoo/Ln8a9KkvZYKc5fbaS%2bWrKcXCLudjNEk8LwyLujkUqwPcHg18LRaHf3XiE6HZ273F8bhrdI0HLMCQfp0OfSvuyvOPAvgCLRvGnijxJdQj7Rd38q2eQMJEx3Mw%2bpJX6L715pkQfD34OaP4St4rzU4otR1kgM0ki7o4T6Rg%2bn948%2bmK9OrnfGnjCw8E%2bH5dUvsu2dkECnDTSHoo9B3J7D8q%2bb7/wAffEHx/qjW%2bmzXyg8rZ6WGQKv%2b0V5I92OKAPrKoLuztr%2b1ktby3iuLeQbXilQMrD0INfLtj4D%2bLEV9BJBDqdvIHG2Vr4AJ7n5%2bnrX1NGHEaByGcAbiO5oA%2bc/ir8Fk0a1n8QeGEY2UY33NjksYV7uh6lR3B6denTw%2bvv4gMpBAIPBB718l%2bP8AwVbeF/ivbaekQGk388U8KHosbvhk%2bgO4fTFKT5U2CPTPhV4fOh%2bCoJJU23N8ftMmeoBHyD/vnB%2bpNdvSABVCqAABgAdqWvzqvWlWqyqS3bPTiuVWQUUUViMcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGF4i8Ow63bb0xHdoP3cnr/sn2/lWL4d8RTWVx/Y%2bsZjdDsjkft6KT6ehrt6wvEXh2HW7bemI7tB%2b7k9f9k%2b38qTXVHXRrRcfY1vh6PsbtFcR4d8RTWVx/Y%2bsZjdDsjkft6KT6ehrt6E7mVajKlLll/w4Vxnj%2b6P2ezsU5aVy5A9uB/M/lXZ1wd3/wATj4iRQ9YrYgH6INx/8e4pS2NsEl7Tne0U2dlp9qLLTra1H/LKNVP1A5q1RRVHI227sKKKKBBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVg%2bGfDUXhm3u4Ibh5luLhpssuNuQBj36da3qKtTkouKej3%2bQ79AoooqBBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcv8SP%2bSa%2bI/8AsHzf%2bgmuP/Z5/wCSbS/9hCX/ANBSuw%2bJH/JNfEf/AGD5v/QTXH/s8/8AJNpf%2bwhL/wCgpQB6xRRRQAUUUUAFeZ/Gbx/J4M8OR2mnSbdW1HckTg8wxj7z/XkAe/PbFemV89%2bMoV8QftL6Ppl4A9tb%2bQAh5BVVM2CPckg0Abfwz%2bDFna2cWu%2bLbcXup3H75bWf5khzz84P3nPfPA%2bvNeywwx28SRQxpHGgwqIoAUegAqSigDjfGXwy8OeM7aT7XZx29%2bR%2b7voECyKf9rH3x7H8MV5b8MvEGrfD3x3L8P8AxFITaTS7LV2J2pIeVKH%2b4/p2bHTmvoSvAv2jbIWl34d162/d3SM8JkHX5Srp%2bRL/AJ0Ae%2b0VBZXIvLC3uQMCaJZAPqAanoAhubmGztZrq4kWKCFGkkduiqBkk/QV822ltq3x58fTz3E81r4csG%2bVVx%2b7jJ4Ve3mNjJPOPoAK9a%2bM99LYfCrWmhJDzLHBkf3XkUN%2ba5H41W%2bB2mRaf8LdOlRQJL2SW4lI7neVH/jqrQB1vh/wpoXhe0W20bTILVQMF1XMj%2b7OeW/E1f1DTLDVrRrXUbOC7t26xzxh1P4GrdFAHzn8Q/h/d/DPUYPGfgyaWC1ikAlhyW8gnjv96M9CDnr78e2eC/FFv4x8K2WtW4CGZcTRA58uQcMv59PYg1o61pkWtaHfaZOoaO7geFs/7QIzXjP7NN9LJpXiCwLHyoJoZlHYF1YH/wBFigD3WiiigDx/43ePLzR7a28LaGzjVdSA8x4j86Rk7Qq453Ocj6A%2boItfDv4MaR4dsoL7XbaLUNZcB2Eo3R25/uqp4JH94/hiuR0qJfEf7UV9Ncnemnu7Ip6AxIEXr6N83HevoSgBqqEUKoAUDAAHAFef%2bO/hJoHi%2bymlt7aHT9XwTHdQptDN6SAfeB9ev8q9CooA8J%2bDXi/U9I8QXHw88RlhPbs62hkbJRl5Mee6kZZfp7ivdq%2be/i/Cui/GXwvrVoAk8xhaTHG9klxk/VSF%2bgr6EoAKKKKACiiigD5//Zl/5mn/ALdP/a1fQFfP/wCzL/zNP/bp/wC1q%2bgKACiiigAooooAKKKKACiiigDI8QyFLFUH8bgH6Dn/AArma6HxJ/q7f6t/Sueqlsd%2bHXuG74b/ANZcfRf61Bp%2brG1kaGfLQEkD/Z/%2btU/hv/WXH0X%2btYkn%2bsb6mgXKpTkn5GvqelAKbqzAaI8lF7e49qxq0dM1R7Jgj5aAnkd19xVy%2b0pLpRdWG0h%2bSoOAfcUDUnB8s/vMREeWRURSzMcACuht7a30a3%2b0XBDTnpj%2bQ/xoSO20O23uQ9ww6evsPasO6upbuYyytknoOwHoKNxXdXbb8zW0y9lvdXMkh4EZ2qOijIrM1H/kI3H/AF0NW/D/APyEj/1zP8xVTUf%2bQjcf9dDR1HFJVGl2I7WXybuKQH7rg129cFXe0mZYpbMKKKKRyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVHNKsMLyN91QSakqKeBLiFopMlW64OKatfUDI0WJp7ia8k5OSB9T1rcqG2tktYFijztGeT1NTVdWfPK6EgooorMYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBzGp/8hGb6j%2bQqpVvU/wDkIzfUfyFVK/O8X/vFT1f5npQ%2bFBRRRXOUFFFFABXkWo/8nI6H/vQ/%2bgmvXa8i1H/k5HQ/96H/ANBNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5/8A2iP%2bRh8J/wDbX/0OOvoCvn/9oj/kYfCf/bX/ANDjr6AoAKKKKACiiigAooooA4/xlczy3NnpkTbVmILc8MScDPsP89K0YPCGkRQqksLTOOrtIwz%2bAIFReKtGnv0hvLME3EH8IPJHXj3BrNj8Y6hAgjuNN3Srwx5X9MV3xU50oqi9t%2bgzc/4RTRP%2bfL/yK/8AjR/wimif8%2bX/AJFf/Gsb/hNrn/oF/wDj5/wo/wCE2uf%2bgX/4%2bf8ACl7LF939/wDwQszZ/wCEU0T/AJ8v/Ir/AONH/CKaJ/z5f%2bRX/wAaxv8AhNrn/oF/%2bPn/AAo/4Ta5/wCgX/4%2bf8KPZYvu/v8A%2bCFmbP8Awimif8%2bX/kV/8aP%2bEU0T/ny/8iv/AI1jf8Jtc/8AQL/8fP8AhR/wm1z/ANAv/wAfP%2bFHssX3f3/8ELM2f%2bEU0T/ny/8AIr/40f8ACKaJ/wA%2bX/kV/wDGsb/hNrn/AKBf/j5/wo/4Ta5/6Bf/AI%2bf8KPZYvu/v/4IWZs/8Ipon/Pl/wCRX/xo/wCEU0T/AJ8v/Ir/AONY3/CbXP8A0C//AB8/4Uf8Jtc/9Av/AMfP%2bFHssX3f3/8ABCzNn/hFNE/58v8AyK/%2bNB8J6KR/x54/7av/AI1jf8Jtc/8AQL/8fP8AhR/wm11/0C//AB8/4UeyxXd/f/wQsyuIW8NeLLeGCRjb3BUFSf4WOOfoa7Wa5gt8edNHHu6b2Az%2bdchpVjqGt62mrX8ZihiIZAQRnHQKPTPOa6DWdCg1ryfOlkTyd2NmOc49fpU1%2bVzipvW2rBlv%2b0rH/n9t/wDv6v8AjR/aVj/z%2b2//AH9X/GsD/hBbH/n6uP8Ax3/Cj/hBbH/n6uP/AB3/AAqOTD/zP7g0N/8AtKx/5/bf/v6v%2bNH9pWP/AD%2b2/wD39X/GsD/hBbH/AJ%2brj/x3/CkPgWxxxdXH/jv%2bFHJh/wCZ/cGh06OkiB42VlPQqcg0%2buDt7q/8I3/2a6DS2LnII6Eeq%2bh9R/8Arrtra5hvLdJ4JA8bjKsKirRdPVap7MViaiiisQCiiigAooooAKKQkKMk4FYl/wCK9KsSV87z5B/DD8369KC4U5zdoq5uUVwV147umyLW1jjHrISx/TFZc3inWZjzesg9EULj8hmg7IZdWlvZHqNFeRtrWqMcnUbvPtMw/rXqtoS1nAxJJMakk9%2bKDLE4WVBJt3uc3rn/ACFZPov8qza0tc/5Csn0X%2bVZtUdFP4EFFFFMsu2uqXVpgLJuT%2b4/IrfstXt7vCE%2bVKf4WPX6GuTopWMp0YzO9ormtO1p4MRXJLR9A/df8a6NHWRA6MGU8gg8GpscU6bg9R1FFFBAUUUUAFFFFABTXdY0LuwVQMkk4AFOrj/GNzNNdWelxNtWbDNzgMScDPt1rSlT9pNRA2H8UaNG5Vr5SR/dRmH5gU3/AISvRP8An9/8hP8A4VFB4Q0iKFUkgaZwOXaRgT%2bAIFS/8Ipon/Pl/wCRX/xrX/Zv734D0D/hK9E/5/f/ACE/%2bFH/AAleif8AP7/5Cf8Awo/4RTRP%2bfL/AMiv/jR/wimif8%2bX/kV/8aP9m/vfgGgf8JXon/P7/wCQn/wo/wCEr0T/AJ/f/IT/AOFH/CKaJ/z5f%2bRX/wAaP%2bEU0T/ny/8AIr/40f7N/e/ANA/4SvRP%2bf3/AMhP/hR/wleif8/v/kJ/8KP%2bEU0T/ny/8iv/AI0f8Ipon/Pl/wCRX/xo/wBm/vfgGgf8JXon/P7/AOQn/wAKP%2bEr0T/n9/8AIT/4Uf8ACKaJ/wA%2bX/kV/wDGj/hFNE/58v8AyK/%2bNH%2bzf3vwDQP%2bEr0T/n9/8hP/AIUf8JXon/P7/wCQn/wo/wCEU0T/AJ8v/Ir/AONH/CKaJ/z5f%2bRX/wAaP9m/vfgGgf8ACV6J/wA/v/kJ/wDCtK1vLa9i822mSVPVT0%2bvpWafCeikf8eeP%2b2r/wCNc8IG8NeLLeGCRmt7gqCpP8LHHP0NUqVGomqbd/OwHd0UUVyCCvJ/2hv%2bSbRf9hCL/wBBevWK8n/aG/5JtF/2EIv/AEF6AOw%2bG/8AyTXw5/2D4f8A0EV1Fcv8N/8Akmvhz/sHw/8AoIrqKACiiigAooooAKx/EPhvT/Eth9lv4zlcmKVeHjPqD/TpWxRVQnKElKLs0Cdj5p1vRm8L/ESz0qGRbjVVjE1pKseMqd3HPA4DcdK6Ay%2bNrzCKr2/Yuu2M/XPX8qg8ef8AJxeh/wDXmn8pa9Ar0VmMpazhFvu0dtC8o3Zj%2bDfB1pb6ut3rUn2u8zujBJKB%2buTnlj6Zr065tYLyBobmJJY26qwzXFxuY5FdeqkEVxer/tCR217Pb2Hh5pFjkZBLPc7ScHGdoU4/OuPEV6leXNUdzOvHlkmj1PSPDkGjX9xPbSMYZVAEbclefXuK1ri3hu7aW3njWSGVSjo3RgeCK%2ben%2bO3jHUWKaZo1iP8AcgklYfk2P0qte%2bNvi7LZTXkkV9ZWkSl5JP7OWNVUc53Muf1rBabGM6kpvmk7s664t9X%2bFuvtc2qNc6NcNg56MOysf4XHY9/zFegaf450XVdPM9pdIJ8f8e0p2yA%2bmO/1Ga4H4K65rXiy116HxBdNqNmnlBVuVDDLbtw6dMAcfT1rS8U/DbSUmjl06SWzMpbKffQYx0B57%2bten7ehikvrHuy/mXX1RcLTaT3NiaV55WkkYszHJJrC1bxPp2lxsPNWeftFGcnPue1YH/CCXjfI%2bqjyvTYT%2bma1NO8E6bZuJJy11IOm8YX8h/WmqODp%2b9KpzeSVjt12SMfStNvPFOqDVdTXFop%2bVMYDY6KB6etemaXftY3ABP7ljhh6e9Z4AVQqgAAYAHalrnxOJdeS0slsuwOCaszvaKq6e5k0%2b3Y9dgq1XGea1Z2PmL4/a1NqPjyPSFYmHToFURjn95IA5P4goPwr3fwJ4StPBvha006CNRcFA91KBzLKR8xJ9B0HoAK8x8YfCXxDrnxXOtW32Z9LuJoZZJZJOYwoUMpXqfu8Y45HSvdKBBRRRQAV4Z%2b0lZj%2by9A1JBiWG4kh3jr8yhh/6B/Ovc68I/aPvPNt/D2jxZeeaaSby1PoFVePcscfQ0Ad9Yzm60%2b2uCMGWJXI9MgGp6itIBa2cFuDkRRqgPrgYqWvzSVrux6gUUUUgHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAYHiTw5HrVv5keEvIx8j9mH901j%2bG/EctpcDR9X3JIjbI5H6g/3W/oa7euf8R%2bHItag82LbHeIPkfsw/umpa6o7KNaMo%2bxrfD0fY255lgt5JnOEjUs30Aya4vwLE11f6hqco%2bZjtz7sdzf0rNk8SXsOiXejXyOLkARq7dQMjIb8OhrrfCFp9k8OW5Iw0xMrfj0/QCi92aypPD0J33k0vlub1FFFUecFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcv8SP%2bSa%2bI/wDsHzf%2bgmuP/Z5/5JtL/wBhCX/0FK7D4kf8k18R/wDYPm/9BNcf%2bzz/AMk2l/7CEv8A6ClAHrFFFFABRRRQAV89fFgy%2bDfjPoXi4oxtJhGzkdTs%2bSRR/wAAK/nX0LXNeOfBtl448NS6Tdt5cmfMt5wMmGQdDjuOSCPQ/jQBv21zDeWsV1bSrLBMgkjkU5DKRkEfhU1fNeg%2bNfFXwavP%2bEd8TabJdaSGJgKt90Z5aJzwy99pxgntzXpVt8dvAU9v5smpXFu%2bM%2bVLaSFvp8oI/WgD0qvnf41X/wDwmHxC0LwbprCSWB9krLztklK5B/3VUE/U%2blaHin4%2btqCnSvBOnXU17OfLS5liywJ/55xjJJ9M/ka3fhJ8L7nw9M/ibxGWk165DFUdtxgDfeLHu7d/QE%2bpoA9YijWGJIkGERQqj2FPoooA5H4naJL4g%2bHGtWECF5zD5sSgclo2DgD3O3H41yH7P3iWHUvBTaE8g%2b16ZI2EPUxOxYN7/MWHtx6167Xz9468Aa/4G8VN418DI5g3GSe2hXcYifvDZ/FGfQdPbAIAPoGivHPDv7Q3h2%2btkXXra4026AAdo0MsRPqMfMPpj8TWhq3x98FWFuzWM13qUuPlSGBowT7lwMD8DQB1vj7xLD4T8FalqkkgSVYjHbjPLzMCEA/Hk%2bwJ7V5/%2bzpoklj4R1DVpUK/2jcBY8/xJGCM/wDfTOPwrj4LHxd8dvEEF7qEZ07w3budpUHYo7hCfvucct0Ht0P0Zp2n2uk6dbafYwrDa28YjijXoqgYH/66ALVFFFAHzrr9yPh/%2b0dHq95lNO1Ah2kPQJIuxiT/ALLjJ9hX0SCGUEEEHkEd64v4k/D%2b28faALYusGo2xL2lwRwrHqrf7J4z9Ae2D5N4Z%2bKXiL4aTL4Z8a6VdTW1v8sMn/LVEH90k7ZE9Ofx7UAfR1Febx/HTwC9t5rapOj/APPFrSXd%2bilf1rhfFHxu1PxO50HwJpt4J7n5PtJXMxB4OxVzt/3iePbrQBW8Y3S%2bPv2gNI0exbzbXTZEildTx8jGSU59vu/UV9F15r8JvhkPA9hJfaiVk1u8QCUqciFOuwHuc4JPsMdMn0qgAooooAKKKKAPn/8AZl/5mn/t0/8Aa1fQFfP/AOzL/wAzT/26f%2b1q%2bgKACiiigAooooAKKKKACiiigDH8QxlrJHH8D8/Q/wCRXNV213ALq0khP8S8fXtXFspRirDDA4IPY1SO3DSvGxt%2bG/8AWXH0X%2btYkn%2bsb6mtvw3/AKy4%2bi/1qu2hXpdiFTBP96jqNSUakrvsZVXLHUprFjs%2bZD1QnjPrU/8AYN9/dT/vqj%2bwb7%2b6n/fVBbnTkrNlCeeS5laWVizH9KjrT/sG%2b/up/wB9Uf2Dff3U/wC%2bqLjVSC6jvD//ACEj/wBcz/MVU1H/AJCNx/10Na%2blaZc2d4ZZQu3YRw2fSsjUf%2bQjcf8AXQ0dSIyTqNrsRW0fnXMUf95wP1ruK5nQbYy3ZnI%2bWIcfU/5NdNSZhiZXlbsFFFFI5wooooAKKKKACiiigAooooAKKKKACiiigAooooAKKZLIIonkPRQSfwrM0Wa4nSZ5ZGZc4UH17/0q1BuLl2A1qKKKgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5jU/%2bQjN9R/IVUq3qf/IRm%2bo/kKqV%2bd4v/eKnq/zPSh8KCiiiucoKKKKACvItR/5OR0P/AHof/QTXrteRaj/ycjof%2b9D/AOgmvayH/en6P9DDEfAfR9FFFfZHEFFFFABRRRQB8/8A7RH/ACMPhP8A7a/%2bhx19AV8//tEf8jD4T/7a/wDocdfQFABRRRQAUUUUAFFFFABVG/1ay0zy/tk3leZnZ8jNnGM9AfUVeqjf6TZan5f2yHzfLzs%2bdlxnGehHoKqHLze/t5AU/wDhK9E/5/f/ACE/%2bFH/AAleif8AP7/5Cf8Awo/4RTRP%2bfL/AMiv/jR/wimif8%2bX/kV/8a3/ANm/vfgPQP8AhK9E/wCf3/yE/wDhR/wleif8/v8A5Cf/AAo/4RTRP%2bfL/wAiv/jR/wAIpon/AD5f%2bRX/AMaP9m/vfgGgf8JXon/P7/5Cf/Cj/hK9E/5/f/IT/wCFH/CKaJ/z5f8AkV/8aP8AhFNE/wCfL/yK/wDjR/s3978A0D/hK9E/5/f/ACE/%2bFH/AAleif8AP7/5Cf8Awo/4RTRP%2bfL/AMiv/jR/wimif8%2bX/kV/8aP9m/vfgGgf8JXon/P7/wCQn/wo/wCEr0T/AJ/f/IT/AOFH/CKaJ/z5f%2bRX/wAaP%2bEU0T/ny/8AIr/40f7N/e/ANA/4SvRP%2bf3/AMhP/hV6w1Oz1NHezm8xUOGO0jB/EVR/4RTRP%2bfL/wAiv/jV6w0yz0xHSzh8tXOWG4nJ/E1E/YcvuXv52EXKKKKxAKKKKACiiigCtfWNvqFs1vcxh42/MH1B9a4v/iYeDr/vPYSH8G/wau9qG5tobuB4J4w8bjBU1vSrcnuy1i%2bgyOxvrfULVbi2kDxt%2bYPoR61arg7m1v8Awjf/AGm1LS2LnBB6Eejeh9D/APqrrtM1S21W1E9u3syHqh9DRVo8q54axYF6iikJCjJOAPWsBC1haz4ns9K3RKfPuR/yzU/d/wB49qxPEPi5mZ7TTHwo4ecdT7L/AI/lXHEkkknJPc0HqYbAOXvVduxpanr2oaqxE8xWLtEnC/l3/GsyiiketCEYK0VZBRRRQUFex2f/AB42/wD1zX%2bVeOV7HZ/8eNv/ANc1/lTR5WabR%2bZzeuf8hWT6L/Ks2tLXP%2bQrJ9F/lWbVGVP4EFFFFMsKKKKACtLS9Uayfy5MtAx5H933FZtFIUoqSszu1ZXQMpDKRkEVHc3MNpbvPPIscaDJY1zFnr0elwMl0WaPBMYHXPoKz44dS8X3gllJgsUbjHQew9T71rTocy5pO0e5504ckrMlutW1LxHe/ZNL3w26nJcHafqxHQe1S/8ACL67/wBBf/yK9dTY2Fvp1stvbRhEHX1J9Se5q1WjxXLpSVkTc4z/AIRfXf8AoL/%2bRXo/4RfXf%2bgv/wCRXrs6Kn63U8vuC5zGlaDqtlqcNxc6j50KbtyeYxzlSOh46mn%2bKtGnv0hvLME3EH8IPJHXj3BrpKKn6xPnU%2bqC5xMfjHUIEEdxpu6VeGPK/pin/wDCbXP/AEC//Hz/AIV0t/q1lpnl/bJvK8zOz5GbOMZ6A%2boqn/wleif8/v8A5Cf/AArZOMldUvzAxv8AhNrn/oF/%2bPn/AAo/4Ta5/wCgX/4%2bf8K2f%2bEr0T/n9/8AIT/4Uf8ACV6J/wA/v/kJ/wDCnZf8%2bX%2bIfIxv%2bE2uf%2bgX/wCPn/Cj/hNrn/oF/wDj5/wrZ/4SvRP%2bf3/yE/8AhR/wleif8/v/AJCf/Ciy/wCfL/EPkY3/AAm1z/0C/wDx8/4Uf8Jtc/8AQL/8fP8AhWz/AMJXon/P7/5Cf/Cj/hK9E/5/f/IT/wCFFl/z5f4h8jG/4Ta5/wCgX/4%2bf8KP%2bE2uf%2bgX/wCPn/Ctn/hK9E/5/f8AyE/%2bFH/CV6J/z%2b/%2bQn/wosv%2bfL/EPkY3/CbXP/QL/wDHz/hR/wAJtc/9Av8A8fP%2bFbP/AAleif8AP7/5Cf8Awo/4SvRP%2bf3/AMhP/hRZf8%2bX%2bIfIxv8AhNrr/oF/%2bPn/AApulWOoa1raatfxmOKMhkBGM46AA9gec11NhqdnqaO9nN5iocMdpGD%2bIq5WcqyheMYcrAKKKK5RBXk/7Q3/ACTaL/sIRf8AoL16xXk/7Q3/ACTaL/sIRf8AoL0Adh8N/wDkmvhz/sHw/wDoIrqK5f4b/wDJNfDn/YPh/wDQRXUUAFFFFABRRRQAUUUUAeBePP8Ak4vQ/wDrzT%2bUtegV558UHOm/HvwxeP8A6qeGCMsf4Q0jox/ANmvY4/DiBsyXLMPRUx/jTTOqjVjCNmZmmWbXd4gx8iEM59vSvIfir4XvfBnjWPxbpcINlcTifJTckU2csrD0bk/iR2r6It7aK1iEcKBV/nTb2yttRs5bO8t47i2lXbJFKoZWHuDQ2ZVanOzz/wAP/FzwlqekpLc3sWmXCr%2b9tpgRtPfaQMMPTHPtXnXxK%2bJX/CZeV4a8MxTzWssoEkgQhrls/Kqr125555PHTHPb3/wC8K3V00ttdajZox/1Mciso%2bhZSfzJrq/Cnw68OeDmM2mWjPdkbTdXDb5MegPAX8AM0jIZ8OfCA8GeEbewl2m9lJnu2XkGQ9gfQAAfgT3rW8QQGS0SUDPltz9D/kVsUx0WRGRwCrDBFBUJcskzhaK0tQ0mW0cvGDJD1BHVfrWbVHpRkpK6ClVSzBVGWJwAO9Kqs7BVUsx6ADOa6DSdIaBxcXA%2bf%2bFPT3NBM5qCuzVtovItYov7igVNRRUnmvUKK89f4s6NpfjnUfC%2bvsthLbyKILtj%2b5kVkVxuP8Bw3fj3HSu9guIbqBJ7eWOWFxlZI2DKw9QR1oAloorK1zxLo3hqzN1rOowWcWMjzG%2bZvZVHLH2AoA0J54bW3kuLiRIoYlLvI5wqqOSSfSvkjxN4vPjX4uWepxlvsaXkEForcERK4wce5Jb8a7DxL408Q/GLVP8AhGPCFpNBo%2b4faJ5Pl3rn70hH3U9F6n3PAxvHPhCw8E%2bN/Buk2PzkJC885GGmkM5yx/IADsAKzq/BL0Y1ue50UUV%2bbnphRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAwPEXhuHW4hIhWK7ThZMcMPQ1twxLBDHEgwqKFA9hxUlFFi5VJSioN6IKKKKCAooooAKKKKACiiigAooooAKKKKACiikYhVLEgAckmgBelZN54gs7UlUJmkHZOg/GsXWNbku3aC3YrbjgkdX/8ArVjV6FHBXXNU%2b4RvSeKbkn93bwqPRst/hTP%2bEpvv%2beVv/wB8t/jWJRXWsNSX2QNv/hKb7/nlb/8AfLf40f8ACU33/PK3/wC%2bW/xrEoo%2br0v5QNv/AISm%2b/55W/8A3y3%2bNH/CU33/ADyt/wDvlv8AGsSij6vS/lA2/wDhKb7/AJ5W/wD3y3%2bNH/CU33/PK3/75b/GsSij6vS/lA2/%2bEpvv%2beVv/3y3%2bNH/CU33/PK3/75b/GsSij6vS/lA2/%2bEpvv%2beVv/wB8t/jR/wAJTff88rf/AL5b/GsSij6vS/lA2/8AhKb7/nlb/wDfLf40f8JTff8APK3/AO%2bW/wAaxKKPq9L%2bUDb/AOEpvv8Anlb/APfLf40f8JTff88rf/vlv8axKKPq9L%2bUDb/4Sm%2b/55W//fLf40f8JTff88rf/vlv8axKKPq9L%2bUDb/4Sm%2b/55W//AHy3%2bNH/AAlN9/zyt/8Avlv8axKKPq9L%2bUDb/wCEpvv%2beVv/AN8t/jR/wlN9/wA8rf8A75b/ABrErlPFXj/SfC4MLE3V/ji2iP3f94/w/qfaplRoQV5JAejf8JTff88rf/vlv8aP%2bEpvv%2beVv/3y3%2bNfMGsfE3xJqrMI7sWMJ6R2o2n/AL6%2b9%2bormZtV1G4bdPf3Upzkl5mbn8TXHKtQW0APsX/hKb7/AJ5W/wD3y3%2bNH/CU33/PK3/75b/GvkWz8T67p7hrXV72P/Z85ip%2boPBrt9B%2bMOoWzpFrdul3D0M0QCSD3x90/TiqhVw7dnGwH0H/AMJTff8APK3/AO%2bW/wAaP%2bEpvv8Anlb/APfLf41y%2bk6vY63YJe6fcJPA/GV6qfQjqD7GrtdioUWrpIDb/wCEpvv%2beVv/AN8t/jR/wlN9/wA8rf8A75b/ABrEoo%2br0v5QNv8A4Sm%2b/wCeVv8A98t/jR/wlN9/zyt/%2b%2bW/xrEoo%2br0v5QNv/hKb7/nlb/98t/jR/wlN9/zyt/%2b%2bW/xrEoo%2br0v5QNv/hKb7/nlb/8AfLf40f8ACU33/PK3/wC%2bW/xrEoo%2br0v5QNv/AISm%2b/55W/8A3y3%2bNH/CU33/ADyt/wDvlv8AGsSij6vS/lA2/wDhKb7/AJ5W/wD3y3%2bNH/CU33/PK3/75b/GsSij6vS/lA2/%2bEpvv%2beVv/3y3%2bNH/CU33/PK3/75b/GsSij6vS/lA2/%2bEpvv%2beVv/wB8t/jR/wAJTff88rf/AL5b/GsSij6vS/lA2/8AhKb7/nlb/wDfLf40f8JTff8APK3/AO%2bW/wAaxKKPq9L%2bUCHx14iu7jwHrsLxwBXspVOFOfun3qt%2bzz/yTaX/ALCEv/oKVS8Z/wDIl6z/ANekn/oNXf2ef%2bSbS/8AYQl/9BSvPxlOMJJRVhnrFFFFcgBRRRQAUUUUAVb7T7LVLRrXULSC6t3%2b9FPGHU/geK5Cb4O%2bALifzn8OQhs5xHNKi/8AfKsB%2bldzRQBjaJ4T0Dw2pGj6RaWbEYMkcY3sPQsfmP4mtmiigAooooAKKKKAOY1n4eeEfEErTaloFnLM33pUUxu31ZCCfzqnp/wn8C6ZKstt4ctWZTkeezzgfhISK7OigBiIkSKiKqoowqqMAD2p9FFABRRRQAVR1PR9N1u1%2by6pYW17BnPl3EQcA%2boz0PvV6igDhH%2bDfgB5/NPhyLd6C4mC/wDfIfH6V0%2bj%2bHdG8PwmLSNLtLJW%2b95EQUt9T1P41qUUAFFFFABRRRQAUUUUAfP/AOzL/wAzT/26f%2b1q%2bgK%2bf/2Zf%2bZp/wC3T/2tX0BQAUUUUAFFFFABRRRQAUUUUAFc7rtgVf7XEPlb74HY%2btdFTWUMpVgCDwQe9CLhNwd0cVBczWxYwyMm7rjvU39qX3/Py9W9T0d4GM1upaLqVHVf/rVkVR3x5Jq6Ln9qX3/Py9H9qX3/AD8vVOigfJHsXP7Uvv8An5ej%2b1L7/n5eqdFAckexc/tS%2b/5%2bXqBVlu7gKMvLIfzNEEEtzKI4kLMfTt9a6fTtMjsU3HDzEct6ewo2InONNablixtFs7VIl5I5Y%2bpqzRRUnA227sKKKKBBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBn6zL5enOOhchR/n8KdpMXladF6t8x/H/wCtirUsMU67ZY1cejCnKoRAijCqMAe1ac69nyLuIdRRRWYwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5jU/wDkIzfUfyFVKt6n/wAhGb6j%2bQqpX53i/wDeKnq/zPSh8KCiiiucoKKKKACvItR/5OR0P/eh/wDQTXrteRaj/wAnI6H/AL0P/oJr2sh/3p%2bj/QwxHwH0fRRRX2RxBRRRQAUUUUAfP/7RH/Iw%2bE/%2b2v8A6HHX0BXz/wDtEf8AIw%2bE/wDtr/6HHX0BQAUUUUAFFFFABRRRQAVi6/earafZ/wCzLbzt27zP3ZbGMY6fjW1Uck0UWPMkRM9NzAZqoS5ZXtcDkP7Z8Vf9A3/yA3%2bNH9s%2bKv8AoG/%2bQG/xrrftlr/z8w/99ij7Za/8/MP/AH2K6fbL/n2h3OS/tnxV/wBA3/yA3%2bNH9s%2bKv%2bgb/wCQG/xrrftlr/z8w/8AfYo%2b2Wv/AD8w/wDfYo9sv%2bfaC5yX9s%2bKv%2bgb/wCQG/xo/tnxV/0Df/IDf411v2y1/wCfmH/vsUfbLX/n5h/77FHtl/z7QXOS/tnxV/0Df/IDf40f2z4q/wCgb/5Ab/Gut%2b2Wv/PzD/32KPtlr/z8w/8AfYo9sv8An2gucl/bPir/AKBv/kBv8aP7Z8Vf9A3/AMgN/jXW/bLX/n5h/wC%2bxR9stf8An5h/77FHtl/z7QXOS/tnxV/0Df8AyA3%2bNbmhXepXcEralb%2bS6thBsK5H41o/bLX/AJ%2bYf%2b%2bxT45Y5QTHIrgddpzWdSopRtyJAPooorAQUUUUAFFFFABRRRQAyWKOeJopUDxuMMpHBFcRqGl3nhm9/tHTWZrXPzJ12j0b1HvXdU1lV1KsAVIwQRwRWtKs6b7p7oDO0fWbfWLYSRHbKo/eRE8qf6j3rlfFXiQ3DPp1m/7kHEsin75/uj2/n/Ot4js4tD1RTp9w0RmQkxqSCgPHX0Pp/wDWrnCMVdWiuX2lPWP5Ho4GlDnvPfoJRRRXMe2FFFFABRRRQAV7HZ/8eNv/ANc1/lXjlex2f/Hjb/8AXNf5U0eVmm0fmc3rn/IVk%2bi/yrNrS1z/AJCsn0X%2bVZtUZU/gQUUUUywooooAKq3d8lsuB80h6L6fWm391JAFSJDvfo2On/16itNPw3nXHzSHkKecfWuinTjGPtKm3RdzOUm3yxI7ezlu5PPuidp6D1/wFeg6PcRzaeiIqoYhsKqMAVydaOjXX2e/VSfkl%2bU/XtWdarKpvt2M6lFcmm51lFFFYHEFFFFABRRRQBRv9JstT8v7ZD5vl52fOy4zjPQj0FU/%2bEU0T/ny/wDIr/40a/earafZ/wCzLbzt27zP3ZbGMY6fjWN/bPir/oG/%2bQG/xrqpQquKcZ2XqM2f%2bEU0T/ny/wDIr/40f8Ipon/Pl/5Ff/Gsb%2b2fFX/QN/8AIDf40f2z4q/6Bv8A5Ab/ABrT2df%2bf/yYDZ/4RTRP%2bfL/AMiv/jR/wimif8%2bX/kV/8axv7Z8Vf9A3/wAgN/jR/bPir/oG/wDkBv8AGj2df%2bf/AMmA2f8AhFNE/wCfL/yK/wDjR/wimif8%2bX/kV/8AGsb%2b2fFX/QN/8gN/jR/bPir/AKBv/kBv8aPZ1/5//JgNn/hFNE/58v8AyK/%2bNH/CKaJ/z5f%2bRX/xrG/tnxV/0Df/ACA3%2bNH9s%2bKv%2bgb/AOQG/wAaPZ1/5/8AyYDZ/wCEU0T/AJ8v/Ir/AONH/CKaJ/z5f%2bRX/wAaxv7Z8Vf9A3/yA3%2bNH9s%2bKv8AoG/%2bQG/xo9nX/n/8mA6ew0yz0xHSzh8tXOWG4nJ/E1crI0K71K7glbUrfyXVsINhXI/GteuSopKTUndiCiiioAK8n/aG/wCSbRf9hCL/ANBevWK8n/aG/wCSbRf9hCL/ANBegDsPhv8A8k18Of8AYPh/9BFdRXL/AA3/AOSa%2bHP%2bwfD/AOgiuooAKKKKACiiigAooooA8N/aO0qT%2bztD16AFXtZ2gdx1G4BlP4FG/OvXvDmsReIPDenavDjbd26SkD%2bEkcr%2bByPwqn428OR%2bLPB%2bpaM4G%2beImFj/AAyr8yH/AL6Az7Zry74AeKXW3vvBepEx3dlI8tuj8Hbn94n1Vuf%2bBH0oA9xooooAKKKKACiiigAqu9nbSNue3iY%2bpUZqxRQNNrYijgihH7qJE/3VAqWiigQUUUUAfIHxt/5K9rv/AG7/APpPHWb4A03xbrmtjTfCuoXVnKQZJZY7l4Y41/vOV/AdDXU/EXw9d%2bK/2gr/AEOxaNbi6eABpDhVAtkZifoqk19DeDfBul%2bCNDTTdNjyxw09ww%2bed/7x/oO1AHkg%2bHPxjuC0M3jQRxngsNSn5Ge2Fz/Kr2kfs8wSXf2zxRr9zqMpOWjhyu76uxLEfgK9vooAztG0LS/D2npYaRYw2dqnRIl6n1J6sfc814Z8bf8AkrXhP/ch/wDR5r6Er57%2bNv8AyVrwn/uQ/wDo81FX4JejGtz1KiiivzY9MKKKKAHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVgeJb4wwLaIcNLy%2bP7v/wBf%2blb9cPrkpm1ec54UhB7Y/wDr5rqwlNSqXfQDOooor2BBRRRQAVR1PWNN0aETajew2yHp5j4LfQdT%2bFcP4x%2bIktrff2F4biN3qbt5RkRPM2OeNqKPvN%2bg9%2b17wx8Bb/WZBqvjfU51mlwxtYXDSf8AA5DkD6AH6iuOtjIwfLHVgR3Xxd8M27lYvttyB/FFCAP/AB4g1R/4XRov/QNv/wAk/wDiq9j034XeCNLiEcPhuwlwMFrqPzyffL5rY/4RLw2OB4f0rH/XlH/hXI8bVGeCf8Lo0X/oG3/5J/8AFUf8Lo0X/oG3/wCSf/FV73/wifhv/oX9K/8AAKP/AAo/4RPw3/0L%2blf%2bAUf%2bFL65V7geCf8AC6NF/wCgbf8A5J/8VR/wujRf%2bgbf/kn/AMVXvf8Awifhv/oX9K/8Ao/8KP8AhE/Df/Qv6V/4BR/4UfXKvcDwT/hdGi/9A2//ACT/AOKo/wCF0aL/ANA2/wDyT/4qve/%2bET8N/wDQv6V/4BR/4Uf8In4b/wChf0r/AMAo/wDCj65V7geCf8Lo0X/oG3/5J/8AFUf8Lo0X/oG3/wCSf/FV73/wifhv/oX9K/8AAKP/AAo/4RPw3/0L%2blf%2bAUf%2bFH1yr3A8E/4XRov/AEDb/wDJP/iqP%2bF0aL/0Db/8k/8Aiq97/wCET8N/9C/pX/gFH/hR/wAIn4b/AOhf0r/wCj/wo%2buVe4Hgn/C6NF/6Bt/%2bSf8AxVH/AAujRf8AoG3/AOSf/FV73/wifhv/AKF/Sv8AwCj/AMKP%2bET8N/8AQv6V/wCAUf8AhR9cq9wPBP8AhdGi/wDQNv8A8k/%2bKo/4XRov/QNv/wAk/wDiq9wv9H8F6XD52o6boFnF/fuIIYx%2bZFcR4g8b/CrSdOu2tYdCvL5ImMEMNgsiySYO0FlTaBnHOaPrlXuB5lr/AMYBdaY8Gi2s9tcycGebb8i/7IBPNeVSSPLI0kjs7scszHJJ9TTp53ubmWeTbvlcu21QoyTk4A4A9qirGpVnUd5MAooorMAooooA6XwX4sm8KawLjDyWco23ECn7w7EZ4yD/AFHevR/%2bF0aL/wBA2/8AyT/4qvE6%2b4bTwp4fNnB5nh/S9/lru3WUec45zxW9PEVKa5YsDwr/AIXRov8A0Db/APJP/iqP%2bF0aL/0Db/8AJP8A4qvadTsvAeiru1S08O2Q7faIoUJ%2bgI5rmLjxr8HbYkSPoZIOP3emmT/0GM1f1yr3A89/4XRov/QNv/yT/wCKo/4XRov/AEDb/wDJP/iq9MsvE3wjv5BHDL4cDHp51qkQ/N1Arq4PDXha5hWaDRNGlicZV47SJlYexAo%2buVe4HhH/AAujRf8AoG3/AOSf/FUf8Lo0X/oG3/5J/wDFV73/AMIn4b/6F/Sv/AKP/Cj/AIRPw3/0L%2blf%2bAUf%2bFH1yr3A8E/4XRov/QNv/wAk/wDiqP8AhdGi/wDQNv8A8k/%2bKr3v/hE/Df8A0L%2blf%2bAUf%2bFH/CJ%2bG/8AoX9K/wDAKP8Awo%2buVe4Hgn/C6NF/6Bt/%2bSf/ABVH/C6NF/6Bt/8Akn/xVe9/8In4b/6F/Sv/AACj/wAKP%2bET8N/9C/pX/gFH/hR9cq9wPBP%2bF0aL/wBA2/8AyT/4qj/hdGi/9A2//JP/AIqve/8AhE/Df/Qv6V/4BR/4Uf8ACJ%2bG/wDoX9K/8Ao/8KPrlXuB4J/wujRf%2bgbf/kn/AMVR/wALo0X/AKBt/wDkn/xVe9/8In4b/wChf0r/AMAo/wDCj/hE/Df/AEL%2blf8AgFH/AIUfXKvcDwT/AIXRov8A0Db/APJP/iqP%2bF0aL/0Db/8AJP8A4qve/wDhE/Df/Qv6V/4BR/4Uf8In4b/6F/Sv/AKP/Cj65V7geCf8Lo0X/oG3/wCSf/FUf8Lo0X/oG3/5J/8AFV73/wAIn4b/AOhf0r/wCj/wo/4RPw3/ANC/pX/gFH/hR9cq9wPnTXvivpWraBf6fFYXqSXMDRqz7MAkd8GvS/2ef%2bSbS/8AYQl/9BStv4geGtBtvh74gng0TTYpY7GVkkjtEVlIU4IIGQaxP2ef%2bSbS/wDYQl/9BSsalWVR3kB6xRRRWYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVHNMsEEkz/AHI1LN9AM0AeB/sy/wDM0/8Abp/7Wr6ArwL9meNhF4mk/hZrVR9R5v8AiK99oAKKKKACiiigAooooAKKKKACiiigArPu9Itboltvluf4k7/UVoUUDjJxd0czN4euUJ8p0kHvwarHR79T/wAe5/Bh/jXX0U7myxE0cmmiXz9Y1T3Zh/Sr1v4dAIa4mz/sp/jW9RRcTrzZDBbw2ybIY1RfbvU1FFIxvcKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKxbaWSXX5hvbYu75c8ccdK2qucORpAFFFFQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFUdR1bT9It/P1C8hto%2bxkbBb6DqfwpqLk7JXYF6ivNdV%2bLtlG5h0ewlvJCcLJJ8ik%2bw5J/Ss4XnxL8Scwwvp9u3oggA%2bhb5/yrvjlta3NUagvN2L5H10PWWZUUsxAA6kms6fxFotscT6vYRn0a5QH8s150nwq1nUSH1nxBufOTjfMfzYitKD4PaMgH2jUL6Q/7BRB/6CaPq%2bDj8VW/og5Y9zp38a%2bGoyAdasz/ALsmf5UqeNPDcnTWrIf70gX%2bdYifCjw0gOVvH/3pv8BSSfCbw2/3ftqcY%2bWYf1Bo5MB/NL7kHuHVQa3pN0cW%2bqWUx/6Z3CN/I1oda82uPg5pbD/RtTvIz/00Cv8AyArPPw08TaT82jeIBgdhI8JP4DI/Wn9Wwk/gq29V%2bocsXsz1mivIz4g%2bInhr/kJWBvYF6u0QcAf70fT8a29H%2bLOjXpWPUYZbCQ/xH95H%2bY5H5VM8urpc0LSXk7g4Poeg0VXtLy2vrdbi0uI54W6PGwYH8RViuBpp2ZAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHMan/yEZvqP5CqlW9T/AOQjN9R/IVUr87xf%2b8VPV/melD4UFFFFc5QUUUUAFeRaj/ycjof%2b9D/6Ca9dryLUf%2bTkdD/3of8A0E17WQ/70/R/oYYj4D6Pooor7I4gooooAKKKKAPn/wDaI/5GHwn/ANtf/Q46%2bgK%2bf/2iP%2bRh8J/9tf8A0OOvoCgAooooAKKKKACiiigArI1vQotb8jzJnj8ndjaAc5x/hWvRVQnKD5o7gcl/wglr/wA/s3/fIo/4QS1/5/Zv%2b%2bRXW0Vt9brfzDucl/wglr/z%2bzf98ij/AIQS1/5/Zv8AvkV1tFH1ut/MFzkv%2bEEtf%2bf2b/vkUf8ACCWv/P7N/wB8iutoo%2bt1v5gucl/wglr/AM/s3/fIo/4QS1/5/Zv%2b%2bRXW0UfW638wXOS/4QS1/wCf2b/vkUf8IJa/8/s3/fIrraKPrdb%2bYLnJf8IJa/8AP7N/3yK2dF0WPRYZY45mkEjBiWGMVqUVM8RUmuWT0FcKKKKxAKKKKACiiigAooooAKr3l1HZWctzKcJEpY/4VYrjvHWoFIINPRuZP3kgHoOg/PP5UG1Cl7WooHHX15LqF7LdTH55Gzj09BUIPY02itKVWVN3R9DUoQnHlfTbyFIxSUuaSlUcXK8FZFUlJRtN3YUUUVmWFFFFABXsdn/x42//AFzX%2bVeOV7HZ/wDHjb/9c1/lTR5WabR%2bZzeuf8hWT6L/ACrNrS1z/kKyfRf5Vm1RlT%2bBBRRRTLCiiigAwDjI6dKKKUAk4AJPoKAEpQSDkHkVai028m%2b5bv8AVht/nV2Lw9ctzJJGg9uTSIdSC3ZvWk32i0im7soJ%2bvep6rWNr9jtVg3l8E84xVmpPOla7sFFFFAgooooAjkmiix5kiJnpuYDNN%2b2Wv8Az8w/99is7W9Ci1vyPMmePyd2NoBznH%2bFZP8Awglr/wA/s3/fIreEKLjeUrP0GdP9stf%2bfmH/AL7FH2y1/wCfmH/vsVzH/CCWv/P7N/3yKP8AhBLX/n9m/wC%2bRVezw/8AP%2bAaHT/bLX/n5h/77FH2y1/5%2bYf%2b%2bxXMf8IJa/8AP7N/3yKP%2bEEtf%2bf2b/vkUezw/wDP%2bAaHT/bLX/n5h/77FH2y1/5%2bYf8AvsVzH/CCWv8Az%2bzf98ij/hBLX/n9m/75FHs8P/P%2bAaHT/bLX/n5h/wC%2bxR9stf8An5h/77Fcx/wglr/z%2bzf98ij/AIQS1/5/Zv8AvkUezw/8/wCAaHT/AGy1/wCfmH/vsUfbLX/n5h/77Fcx/wAIJa/8/s3/AHyKP%2bEEtf8An9m/75FHs8P/AD/gGh1UcscoJjkVwOu05p9Zei6LHosMscczSCRgxLDGK1Kwkop2i7oQUUUVIBXk/wC0N/yTaL/sIRf%2bgvXrFeT/ALQ3/JNov%2bwhF/6C9AHYfDf/AJJr4c/7B8P/AKCK6iuX%2bG//ACTXw5/2D4f/AEEV1FABRRRQAUUUUAFFFFABXgnxh8I6j4a8RwfETw2DHJFIr3gRc%2bW44EhHdWHyt/8AZGve6ingiuoJIJ40lhkUo6OoZWUjBBB6igDmvAfjjT/HXh%2bO/tCsdygC3VsT80L/APxJ6g9/qDXVV87%2bLPhx4h%2bHGut4r8CSTPZKS0lsg3tCvdSv/LSP9R%2bG6u08FfHLw/4iijttZkj0jUsYIlbEDn1Vzwv0b8zQB6pRTI5EmjWSJ1dGGVZTkEexp9ABRRRQAUUUUAFFFFABRRRQB8//APN3n%2bf%2bfCvoCvn/AP5u8/z/AM%2bFfQFABRRRQAV89/G3/krXhP8A3If/AEea%2bhK%2be/jb/wAla8J/7kP/AKPNRV%2bCXoxrc9Sooor82PTCiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFef6kSdTus/8APZ/5mvQK8/1H/kJ3f/XZ/wD0I134H4mJlaiiivTAK4b4l%2bLH8P6QlnZSFdQvQVVlPMad2Hv2H4%2bldzXl/hixHjz48SPcKJbDS2aQqehWI7VH0MhBx6ZrlxVVwhpuwPRfg98M4vCmkx6xqkAbXLtN2HHNqh6IPRj/ABH8O3PqlFFeOMKKKKACiiigAooooAKKKKACiiigAqK5uYLO3kuLqaOCCMbnllYKqj1JPAFch4%2b%2bJWjeArMfaW%2b06lIuYbKNvmb/AGmP8K%2b/fsDg18u%2bMPiB4g8bXRk1S8ItgcxWcPyxR/h3PucmgD3nxV%2b0B4c0gvb6JDJq9yON6ny4Qf8AeIy34DB9a8f8QfGnxrrxdF1L%2bzbdv%2bWVgvln/vvl/wBa89ooAmubq4vJ2mup5Z5W%2b88rlmP1J5qGiigAooooAKKKKACiiigC3pk1tbaraT3kTTW0UyPLGuAXUEEqD7jiu%2b8U/G3xb4ieSO1uv7Isj0hs2w%2bPeT72fpge1ebUUAPllknlaWaRpJGOWdzkk%2b5plFFABW34e8W674VuhcaNqU9qc5ZFbMb/AO8h4P4isSigD6v%2bGXxfs/GpGmalHHZa0FyEU/u7gDqUzyD6qc8cgnnHqFfA1tcz2d1DdW0rxTwuJI5EOCjA5BB9Qa%2byvht4xXxt4MtdSfaLxD5F2i8ASrjJA9CCGH1x2oA6%2biiigAooooAKKKKACiiigAooooAKKKKAOX%2bJH/JNfEf/AGD5v/QTXH/s8/8AJNpf%2bwhL/wCgpXYfEj/kmviP/sHzf%2bgmuP8A2ef%2bSbS/9hCX/wBBSgD1iiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK5P4la0mg/DrW7wvtc2zQREdd8nyLj6Fs/hXWV8%2b/G3X7jxV4o0zwDoh86RZ1a4CngzMMKpPoqkk/X2oA6f8AZ60l7L4fzX8ikG/u3dD6ooCD/wAeD163WdoOj2/h/QLHSLX/AFNpCsSkjlsDlj7k5J%2btaNABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGHpHz6pdSfX9WrcqNIYoySkaKW6lQBmpK0qT55XQkgooorMYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVWvb61021e6vJ44IEGWdzgD/6/tWJ4q8Zad4Wth5x868cZitkPJ9yew/yK8/sdB8RfEa7XUtYuHtdMBzGAMAj0jX/ANmP64rtoYPnj7Wq%2bWHfv6FxjfV7Ghq/xLv9Vu/7N8J2UjyNwJzHuc%2b6r0A9z%2bQpNM%2bF9/qlx9v8UalK0r4LRI%2b9/oXPA%2bgz9a9C0bQdN0C0Fvp1skSn779Wc%2brHqa061ljlSXJhY8q79WHPb4TK0nw5pGhoBp1hDC2MGTGXP1Y81q1y%2buePtA0ItHLdfaLhePItsOwPoT0H0JzXGyfEXxPr8jQ%2bHdGKLnHmBDKw%2bp4UfiKzhg8TX/eS27t2/MFGT1PWqrz3trajNxcwwj/po4X%2bdeW/8Ih4%2b1sbtU1k2yHrG1wf/QU%2bX9asW/wbhzuu9alkYnJ8uEL%2bpJq/qmGh/ErL5Jv8Q5Y9Wd63iXQUba%2bt6ap9DdIP60qeJNCkJCa1pzEddt0h/rXIL8H9CA%2be91In1Dxj/wBkpJPg9oZH7u%2b1BT/tMh/9lFL2WB/5%2bP7gtDud/DcQ3C5hmjlHqjA/yqWvK5vg6Y28yx1x0cdN8OD/AN9Bv6VAdA%2bI%2bgDdY6k17Gv8Cz%2bYAP8AdkH8qf1OhP8Ah1l800HKnsz1usDWvBuha7ua8sIxM3/LeL5JM%2bpI6/jmuItfijq2lzi28SaK6N3ZFMT49drcH8CK7nRPF2i%2bIFAsb1POPWCT5ZB%2bB6/hms54XE4Z86vbuv8AgA4yjqcBe%2bAPEXhe4a/8L6hLMg5MQIWTHoV%2b6/8AnitLw/8AFKNphY%2bI7c2dyp2mYKQuf9pTyp/zxXpVYHiLwjpXiWEi8gC3AGEuY%2bHX8e49jWqxtOuuXFRv/eW//BHzp/EbcUsc8SSxSLJG4yrochh6g1JXjO7xL8ML0Bs3ujO/HXY3/wAQ36H3xXqGg%2bIdP8R2Au7CXdjiSNuHjPoRWOIwcqS9pB80H1X69iZRtqtjWooorjJCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOY1P/AJCM31H8hVSrep/8hGb6j%2bQqpX53i/8AeKnq/wAz0ofCgooornKCiiigAryLUf8Ak5HQ/wDeh/8AQTXrteRaj/ycjof%2b9D/6Ca9rIf8Aen6P9DDEfAfR9FFFfZHEFFFFABRRRQB8/wD7RH/Iw%2bE/%2b2v/AKHHX0BXz/8AtEf8jD4T/wC2v/ocdfQFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeVeI7w3mvXUmcqreWv0Xj/E16fczC3tZpj0jRnP4DNeOMxZizHJJyT60HqZZC8pTEooopHsBRRRQAUUUUAFFFFABXsdn/x42/8A1zX%2bVeOV7HZ/8eNv/wBc1/lTR5WabR%2bZzeuf8hWT6L/Ks2ulvNGN5etMZgikDgLk9KfFoFmn3/MkPu2B%2blVc5Y14RikcvU0VrcT48qGRh6hePzrr4rK2hx5cEYPrt5/OrFK5LxPZHKxaFeyfeVIx/tN/hmrsXhxestwT7IuP51u1DPdW9su6eeOIersF/nRczdepLRFWLRrGL/llvI7uc/8A1quRwxRDEcaoP9kYrIufFmj2%2bR9q81h2iUn9en61kXHj2IcW1k7ehlfH6DP86Vyo4fEVOj%2bZ2VFebXPjPV58iN4oB/0zTJ/XNd3pFybzSLS4ZtzvEpY%2brY5/XNAVsLUoxUpdS9RRRQcwUUUUAFFFFAGVrOuwaL5PnRSP527GzHGMev1rL/4Tqx/59bj/AMd/xro5raC4x50Mcm3pvUHH51H/AGbY/wDPlb/9%2bl/wreEqKjaUbv1GYH/CdWP/AD63H/jv%2bNH/AAnVj/z63H/jv%2bNb/wDZtj/z5W//AH6X/Cj%2bzbH/AJ8rf/v0v%2bFVz4f%2bV/eGhgf8J1Y/8%2btx/wCO/wCNH/CdWP8Az63H/jv%2bNb/9m2P/AD5W/wD36X/Cj%2bzbH/nyt/8Av0v%2bFHPh/wCV/eGhgf8ACdWP/Prcf%2bO/40f8J1Y/8%2btx/wCO/wCNb/8AZtj/AM%2bVv/36X/Cj%2bzbH/nyt/wDv0v8AhRz4f%2bV/eGhgf8J1Y/8APrcf%2bO/40f8ACdWP/Prcf%2bO/41v/ANm2P/Plb/8Afpf8KP7Nsf8Anyt/%2b/S/4Uc%2bH/lf3hoYH/CdWP8Az63H/jv%2bNH/CdWP/AD63H/jv%2bNb/APZtj/z5W/8A36X/AAo/s2x/58rf/v0v%2bFHPh/5X94aFbR9Zh1mKSSGORBGwU78f0rTqKG3htwRDDHGDyQihc/lUtYScXL3VoIKKKKkAryf9ob/km0X/AGEIv/QXr1ivJ/2hv%2bSbRf8AYQi/9BegDsPhv/yTXw5/2D4f/QRXUVy/w3/5Jr4c/wCwfD/6CK6igAooooAKKKKACiiigAooooAK8%2b8XfB3wr4skkumtm0%2b/fk3Fnhdx9WX7p%2buAfevQaKAPnz/hS/j7w1I58LeLV8nJOxZ5Lct9UGVP4mn/ANi/HqH92mpb1HRvPgOfxYZr6AooA%2bf/AOyvj7/z/wD/AJGtv8Kw/FGtfGPwbYw3mt6u8EE0vlIyGB8tgnHAPYGvpyvFf2kpUHhLR4i6iRr4sq55IEbZP4ZH5igD1bw5czXnhjSbq4cyTzWcMkjkfeYoCT%2bdalY/hP8A5E3Q/wDsH2//AKLWtigAooooAKKKKAPn/wD5u8/z/wA%2bFfQFfM/inxHbeE/2mrjWryN5La3eISCP7wV7RUJHrjdnHfFfSVpdQX1pDd2sqy28yCSORDkMpGQR%2bFAE1FFFABXz38bf%2bSteE/8Ach/9HmvoSvnv42/8la8J/wC5D/6PNRV%2bCXoxrc9Sooor82PTCiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFef6j/yE7v8A67P/AOhGvQK8/wBR/wCQnd/9dn/9CNd%2bB%2bJiZWooor0wCuG/ZtQXGo%2bJ76TmYLAuf98yE/qorua4j9mX/maf%2b3T/ANrV52P%2bz8/0GfQFFFFecAUUUUAFFFFABRRRQAUUUUAFcN8TfiHb%2bAtCEiBJtVucraQMePd2/wBkfqcD3HX6hf22l6dc395II7a2iaWVz2VRk18V%2bNfFd34z8UXesXW5VkbbBETnyoh91f6n1JJ70AZWqape6zqU%2bo6jcvcXdw2%2bSVzyT/Qeg7VToooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAr2n9nLWntvFOpaMzHyby285R/txkf%2bys35CvFq9C%2bCLsnxc0VVOA4nVvceRIf5gUAfXtFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcv8SP%2bSa%2bI/wDsHzf%2bgmuP/Z5/5JtL/wBhCX/0FK7D4kf8k18R/wDYPm/9BNcf%2bzz/AMk2l/7CEv8A6ClAHrFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFMkljhQvK6og6sxwPzoAfRXK6z8SPB%2bgxs174gsi65/dQSedJn02pkj8cV5Rr/xt1zxTdnRPAOk3KyS/KLlk3zEdCVUZCD/aJP4UAdp8VPipa%2bC7F9O06SOfXpkwqAgi2BH339/Re/U8dcr4LfDu50pJPFuvq7avfKWhWXl4kfku2f42/MD6kUnw7%2bCw0u8XX/F0q3%2brs3mpAzeYkT9dzsfvv%2bgPrwR7HQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUjZKkDrigBaKxtBleVZw8jMQV%2b8c%2btbNXUhyScQQUUUVABRRRQAUUUUAFFFFABRRRQAUUUUAFcf458aJ4WtUggj83UJ1JiDD5UHTcfX6V2FY/iLw7Y%2bJdMazvEwRzFKB80beo/qO9bYeVKNWLqq8eo42vqcF4N8DyaxKviPxJIblrj97FC5zvz0Z/b0X6fSvVFUKoAAAHQDtXj2h65qXw61o6HrgZ9NdspIuSEBP309V9R/Xr03i/4jWmkW622kyR3l/MoKsh3JGD0Jx1PoPz7Z9HGUMRXrpR1i/httb9DSUZNnQ%2bIfFOl%2bGbbzb6b94wzHAnLv9B6e54rzeTVfF/xEmeHTYzY6ZnaxDFUx6M%2bMsfYD8Kv%2bG/h7d6vdf214sklkklO8Wzk7m9N/oP8AZH6dK7HXfFGi%2bELNIZSiuq4htIAN2O3HRR7miHssPL2dBe0qd%2bi9P8wVlotWY%2bg/C7RtMCy6gDqNyOf3gxGD7L3/ABz9K2tS8VeHfDkf2ee8giaMYFvANzL7bV%2b7%2bOK8%2bbVvGnxAkaPTYzYaaSQXViiY9Gfqx9Qv5V0Gi/CbSLMLJqksl/N1KglIwfoOT%2bf4U61OKfNjal3/ACrX/gIGv52UL34wI8nlaTo8szscK0z4J/4Cuc/nUA8TfEfU/mtNH%2bzqehFqV/WQ16ZY6ZYaZH5djZwWyHqIowufrjrVysPreHh/Dor5u5PNFbI8oEPxXnxvl8vHT5rcfyo2/Fe26HzVHJ/492z/AFr1eij%2b0P8Ap1D/AMB/4Ic/kjyY%2bMfH%2blc3%2bh%2bdGPvObVv/AEJTir2nfGCwkYJqWmz2zZwWiYSAfUHBH616XWbqWg6Vq6kX%2bn29wTxudBuH0bqPzo%2btYaelSlbzTt%2bAc0Xuiraar4e8V2phintL6MjLQyKCw9yjcj64rlNe%2bFFjck3GiTtY3AO4RuS0ZPseq/r9Ki1j4S25f7ToN9JaTqdyxSsSoPbDD5l/Ws218ZeKfBt0ll4ls5bm2zhZHPzkeqv0b6Hn3FdFGm172Cqf9uvR/wCTKS/kYWXjLxL4Mu00/wATWstzbdElY5fHqr9H%2bh59xXp2kazYa7ZLd6dcLNEeDjqp9COoNUbS/wBB8a6Q6p5V5bNjzIZB8yH3HUH0I/A157rPhTWPAl82teHJ5JbNeZEPJRe4cfxL79vwzUShRxT5JL2dT8H/AJMWkvJnrVzbQ3lvJb3ESSwyDa6OMhh7ivIvEnh2%2b%2bH2ppr2g3BFkzhWids7c/wN/eU/mPqM12GjfEbRtQ0Ka%2bvJRaz2y5mgJySe2z%2b8Cfy7%2btcQiav8U/EG991rpFs3bkRj0H95z/njFVgaVahOXtdIL4r7P/gjgmnrsemeFfE1t4p0r7XAjRSI2yaJudjex7it6qemaZaaRYRWVlCIoIxhVH8ye5q5XlVXBzbpqy6GbtfQKKKKgQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHMan/wAhGb6j%2bQqpVvU/%2bQjN9R/IVUr87xf%2b8VPV/melD4UFFFFc5QUUUUAFeRaj/wAnI6H/AL0P/oJr12vItR/5OR0P/eh/9BNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5/wD2iP8AkYfCf/bX/wBDjr6Ar5//AGiP%2bRh8J/8AbX/0OOvoCgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAM3xA/l%2bH74jvCy/nx/WvJ69T8Tgnw3egD%2bAH/x4V5ZQe1ln8NvzCiiikekFFFFABRRRQAUUUUAFex2f/Hjb/wDXNf5V45WzJ4o1d4liW68pFG0CNQP160zixmGlX5VHoensyopZiFA6kms658QaTa58y%2bhJHZDvP6Zry6e6uLk7p55ZT6yOW/nUNBzwytfakegXHjqwjyIIJ5j6nCg/1/SvNPFXxz1O11X%2byNA0qG4vc7TkNIQ390AYLGrLukYy7qo9ScVxPgTV7Pwj8bbuXVzGlvfebHHcP92LzGDq2fTjbn/aNBGLw9OhBOC1LV98SPijCPN1bw/fQwd/9CngH59Kz7T4rWU7/wDEwsbiFz1ZGEgz75wa%2bp%2bv0rH1jwp4f19Cuq6NZXZP8ckI3j6N1H4Gg5KeLq0/hf4HjOm%2bJNH1fAsr%2bF3PSNjtf/vk4NatTeIf2d/D98Hl0O9udLmPKxufOi%2bnJ3D/AL6NefanoHxH%2bHeXuYTqWlp1mjJnjAHqfvpj3wPrQd1LM09Ki%2b47uvTfCD7/AA3bAnJUuvX/AGif614NofxA0nVisVw32G5P8MrfIx9m/wAcV7r4LB/4R1D6yMR%2bdBWOqQqUFKLvqdDRRRQeMFeZ/E34tWfghDp1gkd5rki5EROUgB6F8c59F/lxnpPiB4ui8E%2bELvV2Ctcf6q1jb%2bOVvuj6Dlj7Ka8w%2bC/gSTVrh/HviTddXVxKz2Ym5y2fmmI9c5C%2bmCfTABzeoXvxk0vRR40v9QuoLVXVmt3ZRtVjgFocYC5IHIzyOO9e9eCPE8fjDwhp%2btIgR50ImjH8EinDD6ZHHsRVnxXpy6v4R1jT2Xd9os5Yx/vFTg/nivK/2br8y%2bGNY08tn7PdrMBnoHTH/tM0Aepa/b6vP9n/ALKm8vbu8z5sZ6Y/rWN/Z3i7/n8/8ij/AArp73U7PTtn2ucReZnbkE5xjPT6iqv/AAk2jf8AP8n/AHy3%2bFdVKdRRSjC69BmF/Z3i7/n8/wDIo/wo/s7xd/z%2bf%2bRR/hW7/wAJNo3/AD/J/wB8t/hR/wAJNo3/AD/J/wB8t/hV%2b0rf8%2b19wGF/Z3i7/n8/8ij/AAo/s7xd/wA/n/kUf4Vu/wDCTaN/z/J/3y3%2bFH/CTaN/z/J/3y3%2bFHtK3/PtfcBhf2d4u/5/P/Io/wAKP7O8Xf8AP5/5FH%2bFbv8Awk2jf8/yf98t/hR/wk2jf8/yf98t/hR7St/z7X3AYX9neLv%2bfz/yKP8ACj%2bzvF3/AD%2bf%2bRR/hW7/AMJNo3/P8n/fLf4Uf8JNo3/P8n/fLf4Ue0rf8%2b19wGF/Z3i7/n8/8ij/AAo/s7xd/wA/n/kUf4Vu/wDCTaN/z/J/3y3%2bFH/CTaN/z/J/3y3%2bFHtK3/PtfcAmhQapBBMNUl8xyw2HdnArXqpZajaaijvaTCVUOGIBGD%2bNW65ajbk3JWYgoooqACvJ/wBob/km0X/YQi/9BevWK8n/AGhv%2bSbRf9hCL/0F6AOw%2bG//ACTXw5/2D4f/AEEV1Fcv8N/%2bSa%2bHP%2bwfD/6CK6igAooooAKKKKACiiigAooooAKKKKACiiigCve3lvp9lPeXcyw20CGSWRzgKoGSTXxz8QvFd/461%2b51xopU0yGQW1qp%2b7GpyVB/2m2sx/wAr1T40%2bLrvXtYtvh74e3SzzSoLzyz99ycrFn0H3m/D0NZ3xY8I2ngr4S6BpFthpFv99xMB/rZTG25vp2HsBQB7n4T/wCRN0P/ALB9v/6LWtisfwn/AMibof8A2D7f/wBFrWxQAUUUUAFFFFAHzF408OL4u/aM1LQ2m8k3UY2SdldbIMpPtuUZ9s10vwU8X3Wi6rc/D7xBuhuIJHFn5h%2b64J3RZ9Dyy/j6iq//ADd5/n/nwrV%2bOXgiaSOLxvooaPULDaboxcMUX7sg907%2b3%2b7QB7XRXG/DTxxD468KxXpKrqEGIr2Ifwvj7wHo3UfiO1dlQAV89/G3/krXhP8A3If/AEea%2bhK%2be/jb/wAla8J/7kP/AKPNRV%2bCXoxrc9Sooor82PTCiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFef6j/wAhO7/67P8A%2bhGvQK8/1H/kJ3f/AF2f/wBCNd%2bB%2bJiZWooor0wCuI/Zl/5mn/t0/wDa1dvXEfsy/wDM0/8Abp/7Wrzsf9n5/oM%2bgKKKK84AooooAKKKKACiiigAooooA8S/aJ8Umy0Sy8NW74kvm8%2b4wf8Alkp%2bUH6tz/wCvm2u1%2bLGtnXviVrNwGzFBN9li9AsfynH1IY/jXFUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFepfAHTmvPibFdBSVsbWWYt2BI8sf8AoZ/WvLa%2bovgD4TfRfCc2t3Ue251ZlaMEciFc7T/wIlj9NtAHrtFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcv8SP8AkmviP/sHzf8AoJrj/wBnn/km0v8A2EJf/QUrsPiR/wAk18R/9g%2bb/wBBNcf%2bzz/yTaX/ALCEv/oKUAesUUVFPPFawSTzyJFDGpd3dgqqoGSST0FAEhIVSSQAOST2rwT4ifFK/wDE%2bo/8Id4DEty858qa7t87pfVYz2X1f69uTT8bfEHWfiVrX/CHeCI5TYyMVmuVJUzr0JY/wReuev44r1L4efDfTPAWmYjC3GqTLi5vCvLd9q/3V/n1PbAB5ha/s0XD2sT3XimOGcqDJHHY%2bYqt3AYyDP1wKl/4Zl/6m7/ym/8A22voCigD5Q%2bI/wAH/wDhX/h631X%2b3ft/nXa23lfZPKxlHbdne39zpjvRpXwf/tPR7K//ALd8v7VBHNs%2bybtu5QcZ3jPWvT/2jv8Aknmn/wDYVj/9FS0eFf8AkUNF/wCvCD/0WtdeEpQqSakgPO/%2bFI/9TD/5Jf8A2yj/AIUj/wBTD/5Jf/bK9boru%2bqUe35iPJP%2bFI/9TD/5Jf8A2yuk/wCGZf8Aqbv/ACm//ba7evSa48XShT5eVDPn/wD4Zl/6m7/ym/8A22j/AIZl/wCpu/8AKb/9tr6AoriA%2bf8A/hmX/qbv/Kb/APbaP%2bGZf%2bpu/wDKb/8Aba%2bgKKAPn/8A4Zl/6m7/AMpv/wBto/4Zl/6m7/ym/wD22voCigD5/wD%2bGZf%2bpu/8pv8A9to/4Zl/6m7/AMpv/wBtr6AooA%2bf/wDhmX/qbv8Aym//AG2j/hmX/qbv/Kb/APba%2bgKKAPn/AP4Zl/6m7/ym/wD22j/hmX/qbv8Aym//AG2voCigD5//AOGZf%2bpu/wDKb/8Abacn7MyBwX8WMy9wunYP5%2baa9%2booA8j0j9nnwnYusmoXN/qLDqjyCOM/go3f%2bPV6Vo%2bg6T4ftPsukadbWUPdYYwu4%2bpPUn3NaVFABRRRQAUUVHLKsMTSOcKoyaUpKKu9gJKKx0W61QlzIYbfPAHU1J/Y0S8xTSo/Y5rgjjK1Rc1GlePdu1/Rf52NOSK0k9TUorLtrme2uRa3Z3bvuSetaldOHxEa8W1o1o090yZRcQooorckKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiub8T3E0F5pAildA9xhgrY3cr1oNKVN1JcqOkooooMwooooAKKKKACiiigAooooAKKKKACiiigDD8P/LJcr/u/wBa3KjSGKIkpGqk9Sq4zUlaVZ88uYSCiiisxhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGP4i8O2PiXTGs7xMEcxSgfNG3qP6jvXM%2bDfhxDoFwb7Umjub5WIiC/cjHZhn%2bL%2bVd9VTUbV77Tri1juJLZ5Yygmi%2b8me4rpp4qrCm6KlaLKUmlY4jxp8QTps7aPoa/aNSY7GkVdwiY8bQP4m9u3v0qn4Y%2bGzTTf2t4oZ7i6kbf9md93PrIe59unrnpXOaIT8O/GbRa5ZLJG42pdBSdqk/fT1Hr3/kfbIZormBJ4JFkikUMjochgehBrvxMng6ahh9pL4u/%2bRcnyq0RYokhjWKJFREGFVRgAegFNubq3s4Gnupo4Yl5Z5GCqPxNcV4s%2bJNnosj2OmKt7qAO04OY4z6EjqfYfnXOWngrxP4xnW/8AEl9LbQHlInGWA9FTon48%2b1c1LAvl9rXlyR8936IlQ6s6PVfiroFiSlp51/IP%2beS7U/76b%2bgNYI%2bJPinVSf7G8PAoe4ikmx%2bIwP0rtNL8E%2bHNCjEkdjE7oMme5w7D3yeB%2bAFJfePPDGm5STVYXYcbbcGT8MqCK2hLD35aFFzfd/5Ia5eiucaNV%2bKM/wAyWBjHp5Ma/wDoRzS/2z8T7XmXTfOHXHkK3/oBral%2bLnhyM/LFfy8/wRKP5sKdD8WfDcpAdb2HP/PSEHH/AHyTW/7/AP6Blb0K1/lMJPilrmmuqa34f2Z44V4T%2bTZrp9I%2bJfh3VCsclw1lMeNtyNo/76GR%2bZFaNl4u8Na0vkw6navv48qb5C3thsZqjrPw58O6urMlr9inPSW1%2bUfiv3f0z71zzlhW%2bWtScH5f5Mn3eqsdWjpKivGwZWGQynIIqG8srXULV7W8gjngfhkkXINeSTaR4v8Ah47XOnzm90xTllUFkA9WTqv1H513PhTx3pvidBDn7Lfgc27t973U/wAX86xq4KVOPtaUuaPddPVdBOFtUcfr3gbU/Ct4db8KTzeXHy8IO50Hfj%2bNfY8/XrXVeDPHNp4ph%2by3CrBqSr88X8Mg7lc/y7e9dHq2rWeiadLfX0ojhjHXux7ADuTXjWj6ZeeNvGcuqadB/ZVokokeaHjy8dMernqe3f69dJ/XKEniNOXaX6PuUveXvHUa/wDCqHUNeiutOmS1s5nzcxAfc7koOnPp2%2bnFd/pmmWmkWEVlZQiKCMYVR/MnuatAYAGSfc06vOq4qrWgoTldIhyb0YUUUVzkhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHMan/wAhGb6j%2bQqpVvU/%2bQjN9R/IVUr87xf%2b8VPV/melD4UFFFFc5QUUUUAFeRaj/wAnI6H/AL0P/oJr12vItR/5OR0P/eh/9BNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5/wD2iP8AkYfCf/bX/wBDjr6Ar5//AGiP%2bRh8J/8AbX/0OOvoCgAooooAKKKKACiiigAooooAKKrR3tvLey2iSAzxKGdfQH/P6irNNprcAooopAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBn65H5uh3yAc%2bQx/IZ/pXktezyRrJG0bfdYFT%2bNeOTRNBPJC/wB6Nip%2boOKD2MrlpKJHRRRSPUCiiigAooooAKKKKACiiigArlfHfiGfQdHjFowS5uX2K5GdgAySPfp%2bddRJIkMbSSOqIgLMzHAAHUk15T478V6Tr1nHaWSzvJBNuWYqAjDBBAyc%2bnbtQc2LqqFJ2dmdtoXwA1PXtPh1TXvEJgmuIxIIliMzgMMjcxYc%2bwz9aTU/2bNUiQtpev2lyw5CXEDQ/hkFv6Vs%2bBvjzoVr4c07TfEK3sN7bRCF7lIg8bqvCscHdnGM8da9Y0Lxj4d8TLnRtYtbtsZMaviQD3Q4YflTPnL33PB7HxB8U/hTbLbappcl9o8IwPOHnRxr/syoSVHoG6elei%2bFfjn4V8QNHb3zvo943Gy6IMRPtIOP%2b%2bgtenHn6VwHiv4O%2bE/FIkm%2bx/2dfNk/abMBMn1ZPut78A%2b9AHeo6SoroysjDKspyCPan182y6N8Svg3I9xplx/amgqdzqqmSIDuXj%2b9GfUqce9el%2bBvjJ4f8YeXaTsNM1VsAW07jbIf9h%2bAfocH2NAC%2bM/gz4Z8ViS4ghGl6i2T9otUAVz/ALadD9Rg%2b9eY2%2bqfED4JXS22oQf2l4eL4Q7i0Rz/AHHxmNv9kjHXg9a%2blKhubaC8tpLa6hjngkXa8cihlYehB4NAHOeDfH%2bg%2bOLPzdKusXCDMtpLhZY/qO49xkfjXU14R40%2bCt5pV9/wkXw/nltrqE%2bZ9iSQqynuYm/9lPvg9q1Ph38aY9VuV0Lxaq2Grq3lLO6%2bWkrjjawP3Hz26E%2bnSgDA%2bNVxN4q%2bJHh7wXauQqlPMx/C8rckj/ZQA/8AAjXvVjZW%2bnWFvY2kYit7eNYokHRVUYA/IV4J4TX%2b3/2ndavXG77A1wRnt5YEA/nX0HQAV8//ALP/APxL/GHizSem0L8vT/VyMvT/AIFX0BXz98N/%2bJb%2b0R4rszkLP9rCr06zK4/TNAHuWo6RZ6r5f2uMv5eduGIxnGen0FUf%2bER0b/n3f/v63%2bNbtFaRq1IqykwML/hEdG/593/7%2bt/jR/wiOjf8%2b7/9/W/xrdop%2b3q/zP7wuYX/AAiOjf8APu//AH9b/Gj/AIRHRv8An3f/AL%2bt/jW7RR7er/M/vC5hf8Ijo3/Pu/8A39b/ABo/4RHRv%2bfd/wDv63%2bNbtFHt6v8z%2b8LmF/wiOjf8%2b7/APf1v8aP%2bER0b/n3f/v63%2bNbtFHt6v8AM/vC5hf8Ijo3/Pu//f1v8aP%2bER0b/n3f/v63%2bNbtFHt6v8z%2b8LlLT9LtNLjdLSMornLZYnn8au0UVm25O7AKKKKQBXk/7Q3/ACTaL/sIRf8AoL16xXk/7Q3/ACTaL/sIRf8AoL0Adh8N/wDkmvhz/sHw/wDoIrqK5f4b/wDJNfDn/YPh/wDQRXUUAFFFFABRRRQAUUUUAFFFFABRRWbrevaX4d059Q1e9itLVP45D1PoB1J9hzQBpVwHxJ%2bJmmeC9HuYbe7hl110xb2oO4ox/jcdgOuD1xivJfHfx61PVzLYeGFk02yOVN02PPkHt2QfTn3HSua%2bFfgabx54t8y%2b3vplqwmvZGJJkJPCZ9WOc%2bwNAHqvwN8DS21vJ4z1lWk1HUNzW3m8sqMctIc/xP6%2bn%2b9Wt8fdIk1L4btcxLubT7qO4bHXYQUP/oYP4V6giJFGscaqqKAFVRgADoAKhvbO31GxuLK7iEttcRtFLG3RlYYI/KgDkvhPr8XiD4b6RKj7prWEWc47q8YC8/VdrfjXbV8z2tzrPwG8czW9xFNeeHL5sqR/y1QdGB6CRc4I4z9CDX0B4e8UaL4qsRd6NqEN1HjLKrYeM%2bjL1U/UUAbFFFFABTWYIpZiAoGSSeAKZPcQ2sDz3E0cMMY3PJIwVVHqSeBXg/xO%2bLB8QZ8IeCvMvZLw%2bRPcwqT5gPBjj9Qect0x065oArfDqQ%2bMvj9rPiaEFrO1ErxyHuCPJjH1KZP4GvoOSNJY2jkVXRwVZWGQQeoIri/hh4FXwJ4WW0lKvqNywmu5F6bsYCA%2bij9ST3rtqAPmvUYLv4HfFOO%2btVkfw5qOfkHOYifmT/eQkEe2PU19BaLr%2bk%2bI7Bb3R9QgvLc9WibJU%2bjDqp9iAazPHXhC18beFrnSbjakp/eW0xH%2bqlH3W%2bnY%2bxNfIdpP4i8G%2bI5obKa7sNVtZGjkWInOV6gjoy8Z5yCKAPuKvnv42/8AJWvCf%2b5D/wCjzWh4H/aCtbsx2Pi2FbWU4UX8Ckxsf9teq/UZHsKyvjHdW978UPB9zaTxz28sUDRyxOGVh555BHBqKvwS9GNbnq9FFFfmx6YUUUUAOT76/Wuwrj0%2b%2bv1rsK%2bn4d2qfL9TlxPQKKKK%2blOUKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArz/Uf%2bQnd/wDXZ/8A0I16BXn%2bo/8AITu/%2buz/APoRrvwPxMTK1FFFemAVxH7Mv/M0/wDbp/7Wrt64j9mX/maf%2b3T/ANrV52P%2bz8/0GfQFFFFecAUUUUAFFFFABRRRQAVBeXC2dlPcsMrDG0hHsBmp6x/FZI8Ha2QcEWE%2bD/2zagD4cmme4nknlbdJIxdj6knJqOiigAooooAKKKKACiiigAooooAKKKfHG80ixxIzu5wqqMknsAKAGUV634G%2bBWta%2b8V5r4k0rTiQfLYYuJB6BT9z6tz7GvbNQ%2bEfgnUNHg01tEigSBNkU9uSky%2b5fqx/3s0AfHFFe%2baz%2bzZMGd9D19GX%2bGK%2biII%2brpnP/fNcfefAbx3bMRDZWl3joYLpBn/vvbQB5nRXdSfBvx/G%2b0%2bHZSR/dniYfmHrG0jwTr%2bteJLnw/Z2Y/tO23%2bdDJKqbdhAbknB5I6UAc9RXr2nfs7%2bLLpwb2702yj75kaR/wAABj9RXpvhT4D%2bGNAkS51Iyaxdpgj7QoWEH1EYzn/gRIoA8p%2bFPwluvFt5Fq2sQyQaFEwYBhta7I/hX/Z9W/Ac8j6njjSKNY41VEQBVVRgADoAKVVWNAiKFVRgADAAp1ABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHL/Ej/kmviP8A7B83/oJrj/2ef%2bSbS/8AYQl/9BSuw%2bJH/JNfEf8A2D5v/QTXA/BLWNP0D4RXepancpb2kF9KzyOf9lOAO5PYDrQB67fX1rpllNe31xHb2sK7pJZWCqo9zXzv4l8W%2bIPjL4h/4RjwrHJBoqnMsj5USKD/AKyUgcLwML6%2bpxiLUdV8TfHfxMdM0pXsfDtswZ9/3UH9%2bTH3nPOF/wDrtXvPhTwlpXgzRk0zSYNkY%2baSVuXmfuzHuf0HagCn4H8CaT4E0cWenp5lxIAbm6cfPMw/kBzgdvrknqaKKACiiigDx/8AaO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtH7R3/JPNP/7Csf8A6Klo8K/8ihov/XhB/wCi1rvwPxMTNeiiivTAK9JrzavSa87H/Z%2bf6DCiiivOAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArN1liLNVBwGcA/rWlVS/tzc2bIv3hyv1rkx0JVMNOMN2i6bSkmyxGixxqi8KowKfVCwvlnjWORtsy8EHvV4kAZPArShWp1aanT2/IUotOzM7WUBtFk6MjDBq/Gd0asepANZV1J/aVzHawnManc7jpWuBgcVy4WSqYirUh8Oiv3avf7tipq0UmLRRRXomYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVh6n/AMJD9sP9nC2%2bz4GN/XPeguEOd2ul6m5XL%2bLP%2bP7Rf%2bvn%2bq0f8Vf/ANOf6Vja3/bv2nT/ALf5Hmed%2b42Y%2b9kdf0oOzDUOWonzLr18j0GiuX/4q/8A6c/0o/4q/wD6c/0oMPq/9%2bP3nUUVDbecbaI3AUT7B5mzpu74qag52FFFFABRRRQAUUUUAFFFFABRRRQAUViXzvDrlu287G28Z4HODW3VyhypPuAUUUVABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBj%2bIvDtj4l0xrO8TBHMUoHzRt6j%2bo715DJ/wmHhySTwhbvKRcv%2b4MYOWU9TG38IPf056c17tTDGjSLIUUuoIVscjPXB/AV24XGyoRcJLmj2fR9y4ztocd4P8AWXh2NLq7CXOp4yZD92L2Qf16/SqXib4nWmnStY6LGt/e527%2bsat6DHLn6fnWR8T/E%2bpR3w0KFZLK0dQZJ2484H0Iz8o79/69V4M8GaVoVlDeRNHe3kiBvtfUYI/g9B79TXVKKUVisX7zlsv8%2b3oV/ekcdD4O8X%2bMXW61%2b/e0t2%2bZYpOSPpGMBfxwa6jT/hX4bs1H2iKe8f1mlIH5Lj9c129Z%2bo63pmkIG1C/gt88gSOAx%2bg6mueWPxFT3Kei7R0/LUlzk9EVIfCHhyEYXRLA9vngV/5g0yfwX4buAQ%2biWQz/zzjCf%2bg4rLm%2bKHhaJsLeTS%2b6QNj9QKfbfEzwtcMFN%2b8JPTzYXA/MAil7LHL3rS/ELTKGpfCXQbpSbKS4sX7bX8xfxDc/rXNvpnjfwFmaynN9pyclFzIgHuh5X6j869XstRstSh82xu4biP%2b9E4YD8qt1UMwrx9yr7y7P8Aq4KbWjON8K/ELTfEZS1mH2PUCP8AVOflkP8Asnv9Dz9ayvGPw6W4Y6t4eX7NfxnzDDGdocjnK/3W/Q%2b1M%2bIng7SRp0%2buQSxafdx/MeyTN6YH8R7Efj6i38M/E%2bpa5ZTWl/FJL9lA23p6N/st6t7%2bnX36EvZw%2bt4R2XVP%2btV%2bJWy5onG6dZeI/iNqcMGpTyJaWI8uaQptCkdeO7nvXsumaZaaRYRWVlCIoIxhVH8ye5qykaR7tiKu47mwMZPrT648VjJV7RS5YrZIiUrhRRRXGSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHMan/AMhGb6j%2bQqpVvU/%2bQjN9R/IVUr87xf8AvFT1f5npQ%2bFBRRRXOUFFFFABXkWo/wDJyOh/70P/AKCa9dryLUf%2bTkdD/wB6H/0E17WQ/wC9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5//aI/5GHwn/21/wDQ46%2bgK%2bf/ANoj/kYfCf8A21/9Djr6AoAKKKKACiiigAooooAKpapqEel6dLdPg7RhV/vN2FXawPEGh3etPEqXUcUEYyEIJy3r/n3rSkoua53ZAcRZatcWmrjUCxZy5Mg/vA9RXqME8dxAk0TBo3UMp9Qa80tNClu9Zn01ZkV4d2XIODg4rutB0250qza1nnSVA2Y9oI256j/PvXbjvZtJp6/oNmtRRRXnCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8y8W2RtNelcDCTgSr%2bPX9c16bXNeM9NN3pQuY1zJbHccf3T1/ofzoOzA1fZ1lfZ6HnVFFFI%2bgCiiigAooooAKKKKACiikd1jRnchVUEknsKAOd8eeb/AMIZqHk5zhN2Ou3euf0rtPgjoHhy5%2bHNlfLplnNfvJKt1NLErvvDnAyRwNu3gevqa8p0TR/E/wAXdWvY7G7Wz0u2wH8xmCKDnaMAfOxwTz%2bnAroY/hr8Ufh8r3HhjVUuoN3mPBayfeOOpikG1jgdsmmfPYyvGtUvHZaHs%2bpfDvwdqyFbzw3pxJ6vFAInP/Akwf1rzjX/ANnawcm58M6tPY3CnckVyd6A9sOMMv1%2bameF/j6I7v8Asvxrpr6fdI2x7mKNgFP/AE0jPzL%2bGfoK9osr611KzivLG5iubaVd0csThlYexFByHz3H43%2bJnwtuI7bxRZSappmdqyzNuBH%2bzOM8%2bzZPtXrng34l%2bG/GqKmn3fk323LWVx8so9cdmHuM%2b%2bK6yeCG6geC4iSaFxteORQysPQg8GvHfGfwFsb2RtS8Iz/2Xfqd62xY%2bUzDn5T1jOfqPYUAez15b47%2bCWh%2bKBJe6SI9J1U87o1/cyn/AGlHQ/7Q/EGuO8O/F7xF4J1IeH/iFY3LqnAuiuZlHYk9JV/2gc9eTXu2l6rYa1p8V/pl3FdWsoyksTZB9vY%2boPIoA8C0P4j%2bLPhfqsfh/wAc2txdWA4inJ3SKn95H6SL7HkdOMYr3rRta03xBpkWo6Vdx3VpKPlkjP6EdQfUHkVF4g8O6V4n0uTTdXtEubd%2bgb7yHsynqD7io/C/hjTfCGgw6RpUbJbxksWcgvIx6sxHUn%2bgHQUAbNed/Ef4UaZ45t3vLfZZa2q/JcgfLLjosgHUds9Rx1AxXolFAHzh%2bzxZyw%2bOde8/BmgtTFIScncZBnn6rX0fXz/8Gv8ARvjJ4xsuUx9o/d/7twB%2bma%2bgKACvn1/%2bJL%2b1arfdivGH477fH/odfQVfPnxtz4f%2bKXhXxNgiMCMsR/EYZdzf%2bOuBQB9B0UgIZQQQQeQR3paACiiigAooooAKKKKACiiigAooooAKKKKACiiigAryf9ob/km0X/YQi/8AQXr1ivJ/2hv%2bSbRf9hCL/wBBegDsPhv/AMk18Of9g%2bH/ANBFdRXL/Df/AJJr4c/7B8P/AKCK6igAooooAKKKKACiiigAopCQqkkgAckntXgnxI%2bNks00ugeC5GeRiY5dRj6n1EX/AMX%2bXZqaTbsgO2%2bIfxd0fwSkllbbb/WscWyN8sR7GQjp/ujk%2b2c187a5deJ/G9zJq2r3LSPg%2bTCx2qq/3UXoo/n3z1qbS/D6wv8Aar4%2bfdMdx3HIBPc%2bpq5rOpLplkXBHnP8sY9/X8K9uhlUYU3VxTsrbf1%2bRsqdleRzmnRtqVtb%2bHdO0jdrF5dbXuGbczLxtjUEYQA5LHqeOQBX154H8I2ngrwvbaRbYaRRvuJgP9bKfvN9Ow9gK83%2bBHgJtPsj4u1SIm9vFIs1ccpEer/Vu3t/vV7XXiPfQxCiiikBQ1jRdN1/TZNO1Wziu7ST70cg7%2boPUH0I5rxrV/2eDBe/bPCviCWycHKR3AOV%2bkiYOPw/GvdKKAPn2T4YfFm3hZ38fpHDGuSzaxdKqqO5%2bTgVz1lpvjHUdQWwtPi9p8ty7bURdeuvnPop2YJ%2bld9%2b0Xqd7aeEtOsrdmS2vLki4ZTjcFXKofYnn/gIrh/Gfw58JaF8K7DxBp2rPLqEoiKOZQVui2N4Vccbck%2b23B5oA3V%2bBPi/W5kPijxiJo1YHiWW6b8PM24OO9epeDfhv4d8DxltMtmkvGXbJeXBDSsPQHgKPYAds5pPhfqd7q/w10O91Bme6eFlZ3OS4V2VWJ7kqoP4119ABRRRQAV4r8cvBE0kcXjfRQ0eoWG03Ri4Yov3ZB7p39v92vaqbJGksbRyKro4KsrDIIPUEUAfFfiPU7LxbqdncaVoq2N9JCPt/lNiOabu6r0QHqfr%2bJisNPn03xdosEsocfaoWTBOAPMH9a6j4geE5fhr42326O2jXxL2564XPzR/VSRj2x71jzusnjTQJEYMrTwEEdx5grqlSpSwNSpf31%2bRpFK1z6aooor8pPQCiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFef6j/wAhO7/67P8A%2bhGvQK8/1H/kJ3f/AF2f/wBCNd%2bB%2bJiZWooor0wCuI/Zl/5mn/t0/wDa1dvXEfsy/wDM0/8Abp/7Wrzsf9n5/oM%2bgKKKK84AooooAKKKKACiiigAqnqlr9v0i9swB/pEDxc9PmUj%2btXKKAPgEgqxBBBHBB7UldN8QdGOgeP9b07btRLpniH/AEzf50/8dYVzNABRT443mkWOJGd3OFVRkk9gBXa6Z8IfHWqwiaHQJoYyODcukJ/75Yhv0oA4eiu81D4NePdOgMz6C8yAZP2aaOVv%2b%2bVbcfwFcRcW09ncSW9zDJBNGdrxyKVZT6EHkUARV9PaD8EfCWreC9Gmv7S5g1GWziknmgnZWLMoY5ByvGcdK%2bbNMsX1PVrOwj%2b/czpCuPVmAH86%2b8YokghSKNQqIoVVHYDgCgDxS6/Zs0Ry32TXtQiHbzY0kxz7be1V0/ZpsQwL%2bJrgr3AtFB/Pca92ooA8i0/9nfwjasGvLrU70jqrSqiH8FXP613%2bg%2bDPDnhkAaNo9ravjHmqm6Qj3dssfzrU1DULPSrCa%2bv7mO3tYRuklkOAorldK%2bK3g3WdSj0%2b01cfaJW2xiWF4w57AFgBk9s0AdpRRRQAUVDb3EV1bxzwuHjkXcrDuKZfX1rptlNe3txHBbQrvklkOAooBq2jLNfP%2biD7P%2b1TqEcZwshl3e%2bYAx/WvT9G%2bKPhDXtUTTbHVgbmQ7Y1lieMSH0BYAZ9BXmGlf8AJ197/wBtP/SYUAfQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBy/wASP%2bSa%2bI/%2bwfN/6Ca%2bavh94K1/4hLBpYuJYPDlnOZZpT9xXYDO0fxOQAPYfXn6u1rSYNd0S80q6Z1gu4mhkKHDBWGDjPen6Xpdjoumwadp1tHbWkC7Y40GAB/U%2bpPWgCv4f8Pab4Y0eDStKt1htoR9Wc92Y9yfWtSiigAooooAKKKKAPH/ANo7/knmn/8AYVj/APRUtHhX/kUNF/68IP8A0WtH7R3/ACTzT/8AsKx/%2bipaPCv/ACKGi/8AXhB/6LWu/A/ExM16KKK9MAr0mvNq9Jrzsf8AZ%2bf6DCiiivOAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAp3OnQXR3MCr/AN5ag/scNxJcysvpWnRXHUwGGqScpQ1f9alqpJKyZDBbxW0eyJQo7%2bpqaiiuqEIwXLFWRLbe4UUVQvta0rTM/wBoanZWmP8An4nWP37mqEX6K58eOfCLEAeKtDJPAA1CL/4qtez1Cy1CPzLK8t7lB/FDKHH5g0AWaKKKACiiigAooooAKKKKACiiigAooooAK5fxZ/x/aL/18/1WuormvFEMst7o5jjZwtx8xUZxyvWg6MK7VV8/yOlooooOcKKKKACiiigAooooAKKKKACiiigAooooAxdfQgQTDqCRn9R/WteJxLEkg6Mob86HRHwHUNjkZGcU/pVyneCj2EFFFFQMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDH8ReHbHxLpjWd4mCOYpQPmjb1H9R3rzXQ9c1L4da0dD1wM%2bmu2UkXJCAn76eq%2bo/r19irH8ReHbHxLpjWd4mCOYpQPmjb1H9R3rtwuKUE6NZXg/w80XGXR7Hn%2bsePdY8SaidI8IwShTwbhRh2Hrk8IvuefpVnSvhKsrfadf1GWedzuZIW7%2b7nJP5Cu28O%2bHLHw1pq2lmmWODLMR80rep/oO1cb418Z6hLq48NeG95vGbZLLH94N/dU9sdz29sV2U60py9jg1yx6vrbu2Um3pA228HeCdLAS4tLKIn/n5nOT/301I3gXwbq0TNbWsB/wCmlrcHj8jj9K5zT/hEZ4/P1rVZTcycssIBwfdmzn8qh1L4X6jo/wDp/hvU5nni5EZ%2bSQ/RhwfoQKE4OVliXzd9bfmGn8w/UvhfqGkym/8ADGpzeanKxO2yT6BxgH6ECptB%2bJ0tk8un%2bKreSK5hB/fLGQzEfwsvYnsRx9Ota/gHxtJr4k0zUwE1SAZzjb5oHBOOzDuK1vFPgzTvFMUZnzBcxkbbiNRu255U%2bo649Pzyp1/f9hjlfzW//BQN62mecomr/FPxBvfda6RbN25EY9B/ec/54xXr2maZaaRYRWVlCIoIxhVH8ye5o0zTLTSLCKysoRFBGMKo/mT3NXK48VivbWhBWgtl%2br8yJSvotgooorjJCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5jU/%2bQjN9R/IVUq3qf/IRm%2bo/kKqV%2bd4v/eKnq/zPSh8KCiiiucoKKKKACvItR/5OR0P/AHof/QTXrteRaj/ycjof%2b9D/AOgmvayH/en6P9DDEfAfR9FFFfZHEFFFFABRRRQB8/8A7RH/ACMPhP8A7a/%2bhx19AV8//tEf8jD4T/7a/wDocdfQFABRRRQAUUUUAFFFFABRRRQBxmjf8j3qH/bT/wBCFdnXGaN/yPeof9tP/QhXZ104r4l6IbCiiiuYQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABTWVXQowBVhgg9xTqKAPJ9c0t9I1OSDB8o/NEx7qf84rNr1PxBoyaxYFBgXCfNE3ofT6GvL5YngleKVCjoSrKeoNB9Dg8Qq0Nd1uMooopHWFFFFABRRRQAVFcwi5tJoCcCWNkJHbIxUtFANXOW%2bCvi628Ga9qPhfXdtr9rmUxzvwqyjjDE9mGMHp%2bdfSdfOPinwhaeI4fMUiC%2bQYSYDqP7reo/lUPgv4q634BvI9A8XRTXOmrhYpvvSQr2Kn%2bNPbqO3TFM%2bdxOFlRfke4eLPAvh/xnZmHV7FXmC7Y7qP5Zo/o39Dke1eIXmheOPgjqD6lo9w2o%2bHmfMq4JQj/AKaJ/Ae28e3POK%2bhtL1Ww1rTodQ0y7iurSYZSWJsg%2b3sR3B5FWnRJUaORVZGBDKwyCD1BFBynIeBPiRovjyyzZv9n1BFzPZSt86epX%2b8vuPbIGa7KvDPHvwYnsbv/hJfALPaXsDeabGFtpB7mE9j/sdDzj0Ot8NPjHDr8seg%2bJQtlriny1kYbEuGHGCP4H9uhPTrigD0TxJ4W0fxZpjWGsWaXER%2b42MPGfVW6g14Nqnhbxl8FdTk1rw7dPf6EzZmVlJUL2EyDp7OP0zivpKkIDAgjIPY0AZ2gajcavoNjqF3YSWE9xCsj2sjZaPPY/5B9QDWlRRQAUUVw3jL4seGfBjvbXNw13qK/wDLna4ZlP8Atnov4nPsaAPN/C5/sX9qHWLM/J9tM/HrvQT/ANM19A18t6Xq%2bveOfjDp3i/S/Dl2kCXMImMOXRUXCsTIQBnZnivqSgAryf8AaA0I6p4AXUYk3S6ZcLKT38tvkb9Sh/4DXrFVNT0%2b31fS7vTrtN9vdQtDIP8AZYYP86AOa%2bF%2bvjxH8OtHvC%2b6eKEW0/rvj%2bUk%2b5ADf8CrsK%2be/g3qVz4L%2bIOr%2bA9UfaJZGMJbgGVRwR7OmD/wFfWvoSgAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8n/aG/5JtF/wBhCL/0F69Yryf9ob/km0X/AGEIv/QXoA7D4b/8k18Of9g%2bH/0EV1Fcv8N/%2bSa%2bHP8AsHw/%2bgiuooAKKKKACiiigAqG5uYLK2lubmaOGCJS8kkjBVRR1JJ6CodT1Oy0bTZ9R1G5jtrSBd0ksh4Uf1PoB1r5h8f/ABG1T4kai2l6UJLXQom%2b4TgzYPDyflwvb37VCEpyUYq7YJXND4lfFa98aXcnh3w0ZItI5Wab7rXQz1PdU9up7%2blc3pWkQaZF8vzzMPnkP8h6CptP06DTbfyoRyfvOerGrdfV5flscOueesvyOmFPl1YEgDJ4FQ/D/wALN8R/Hv8ApIY6PY4kn9GXPyp9WIP4A%2blV9YlMOj3TjrsIH48f1r2L9nzSorP4evfgfvb%2b7d2b/ZT5APzDH8a488rtctFbbv8AQms%2bh6siJFGscaqqKAFVRgADoAKdRRXzxgFFFFABRRRQBjeKPC%2bmeL9Cm0jVomeCQhlZDh43HR1PYjn8yDwa8U0D4G%2bGNR8R6har4slvk0yYR3VpFbiN1JGQC%2b4gjqDgdQRwRXo/xW8ep4H8LO1u6/2teAxWaf3T/FIR6Ln8yK8E0GXxN8LdW0PxbewSmy1ZC0qliTLGTyr56MRhxn29xQB9Y2dnb6fZQWdpEsNvBGscUajhVAwAPwqequn39rqunW9/ZTLNa3EYkikXoykZFWqACiiigAooooA5rx14QtfG3ha50m42rMR5ltMR/qpR91vp2PsTXyLpkF3ZeM9N0%2b9Vkns9QjheNuqESjI/PNfb9fMfxX0qPTfjrp00QwL57W6YDs3mbD/6Lz%2bNRUbVOXoOO57XRRRX5semFFFFADk%2b%2bv1rsK49Pvr9a7Cvp%2bHdqny/U5cT0CiiivpTlCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8/1H/kJ3f8A12f/ANCNegV5/qP/ACE7v/rs/wD6Ea78D8TEytRRRXpgFcR%2bzL/zNP8A26f%2b1q7euI/Zl/5mn/t0/wDa1edj/s/P9Bn0BRRRXnAFFFFABRRRQAUUUUAFFFFAHzx%2b0b4ZMd5pviaBPklX7JckDowyyE/Ubh/wEV4xoei33iLWrXSdNi827uX2IOw9ST2AGST6CvsX4j2lje/DrXo9RXNulnJLkdQ6DcpHvuArzH9nLw1Emn6l4mmTM0kn2OAkfdQAM5H1JUf8BNAHoHgH4Z6N4GsYzFElzqrL%2b%2bvpF%2bYnuE/ur7Dr3zXQ614m0Tw4sTaxqdtZCUkRiV8FsdcDrWtXm3xL%2bFQ8fX9lfQ6p9int4jCweLzFZckjGCMHJP8AkUAdRpvjrwrq9wLew1/T5pmOFj84KzH2BwT%2bFV/GngHQ/HGnNBqNuqXSqRBeRriWI/XuPVTx%2bPNeE%2bJ/gNr2g6XLqFjeQapHCpeWKNDHIFHJIUkhsemc%2bgNdP8DfiNeXt5/wiusXLzsUL2M0jZYbRkxk9TwCR9CPSgDivBvgXUNC%2bOWlaFqcYL2sxuhIo%2bSREVnVx7EqB9eO1fVtUJtHsp9btdYkhBvbWGSGOTuFcqSP/Hf1PrV%2bgAoqreX8FkmZW%2bY9FHU1jv4jlLfu4EA/2jmnY0jSlLVI8/8A2hftn/CMaV5W77H9rPn46btvyZ/8fr52Gc8de2K%2bx59Q0/WLKXT9WskktZhtdHG5SPcVn6R8LPBmkajFqVlpKmaM74jJM8ioexAYkfQ0iZQlHc6Hw79sHhnSv7Q3fbfscP2jf97zNg3Z985q/M/lwSPnG1Sc1JVTUn8vSrx8j5YHPP8AumgUVdpHHeBdZ2s2lTtwcvASe/df6/nUPxn03UNT%2bHdxHp8UkrRTxzSxx8loxnPHfBIP4e1c1ptve3F9ELCN3uFYMpQfdI7k9B%2bNexQGU28ZnVVlKjeqnIB74qYPQ9DMqUYVOZdT4q0HTdR1fXbOy0pJGvZJV8ooOUIOd2ewHUn2r1rSv%2bTr73/tp/6TCveYbO2t5Hlht4Y5JPvsiAFvqR1rwbSv%2bTr73/tp/wCkwqjzj6AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDx/wDaO/5J5p//AGFY/wD0VLR4V/5FDRf%2bvCD/ANFrR%2b0d/wAk80//ALCsf/oqWjwr/wAihov/AF4Qf%2bi1rvwPxMTNeiiivTAK9JrzavSa87H/AGfn%2bgwooorzgCiiigAooooAKKKKACiiigAoormNd%2bIfhLw4zR6nrtpHMvDQxt5sgPuqZI/GgDp6K8c1H9ozwxbsVsNN1K7I/iZUiU/TJJ/SsN/2k5pn2WfhEs2cjdeliR9BH/WgD3%2bivAU/aTlhcJe%2bEird9t6VOPoY/wCtdBpf7RHhS7dUv7TULAnq7RiRB%2bKnP6UAevUVj6F4q0HxLD5ujara3gAyVjf51Hup%2bYfiK2KACiiigAooooAK8v8AHXxs0LwpJLYacBquqISrJG%2bIoj/tP3I9BnvkiuS%2bIfxK1bxXrh8E%2bBRJKJGMU91AfmmP8Sq3RUHdu/PQdex%2bHvwc0jwfFFe6ikWo6zwxmdcxwn0jB7/7R59MUAcBDa/GD4mATyXL6Npcv3QWNqhX2UZkcfXIPrWtp/7Ntljfq3iK5mkblhbQhOfqxbP1xXutFAHjzfs4%2bEipC6nrYbsTNEQPw8usW%2b/ZzntZPtHh7xPJFOvKC4jKkf8AbRDkf98173RQB85v4j%2bLfwxOdahbVtKQ4M0x89Mevmj51/4H%2bVeneCPi34c8aFLZJDYam3/LncMMsf8AYbo36H2rvGUOpVgCpGCCOCK8l8e/A7S9dWTUfDnl6Xqo%2bfy0%2bWCU/QfcPuOPbvQB65RXgfgf4s6r4Y1X/hFPiCksTxERx3sw%2beP0Eh/iU9n/ADyOR70jrIiujBkYZDKcgj1FADqKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKbvXdt3DdjOM806sG5P2LXkm6JJgn8eDWlOHO2hNm9RRRWYwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigCtfXIs9PubogEQxNJg%2bwJrzP4R2AuZ9U1u4/eXBfylduuT8zn6n5f1r1C4gW5tpYH%2b5IhRvoRivKPhtqH/CPeI9R8N6iRFLLJiMtwDIuRj/AIECCPp716WFu8LWUN9Pu6mkfhdj1yiikJCgknAHrXmmZ5H4rhTQfivpV/a4T7U8bygcAksUf8x%2bpNeu14/eXS%2bNPixZLZHzLOxZcyDoVjbczfQscA/T1r2CvSx6ahSjL4lHX9DSeyCiiivNMwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDmNT/5CM31H8hVSrep/8hGb6j%2bQqpX53i/94qer/M9KHwoKKKK5ygooooAK8i1H/k5HQ/8Aeh/9BNeu15FqP/JyOh/70P8A6Ca9rIf96fo/0MMR8B9H0UUV9kcQUUUUAFFFFAHz/wDtEf8AIw%2bE/wDtr/6HHX0BXz/%2b0R/yMPhP/tr/AOhx19AUAFFFFABRRRQAUUUUAFFFFAHGaN/yPeof9tP/AEIV2dcXpBC%2bOdQJIAHmZ/76FdFPrulW5Ikv4MjqFbd/KurFfEvRFKMpfCrmlRWVD4h0m4mWKK9RpHIVVwRkngDkVq1yhKEo6SVgooooJCiiigAooooAKKKKACiiigAooooAKKKKACioLqdba3eVsHHQepqHTLk3Vrlzl1OGrB4mmqyoX95q5XK%2bXmLtFFFbkhXNeJfDi6pGbq1AW8UcjtIPT6%2bhrpaKDSlUlTlzRPF3Ro3ZHUqynBBGCDTa9L17wzBqymaLbDdgcPjh/Zv8a89vbG50%2b4MF1E0bj16EeoPeke/h8VCstN%2bxWooooOkKKKKACiiigAqjquj2OtWZtb6BZE/hP8SH1B7Gr1FAmlJWZ5zZXXif4Saqb7SpjdaRKw86J8mNx6OB91vRh/XFfQ/gnx7o3jrS/tWmy7LiMD7RaSEeZCff1HoRx%2bPFeeSRpLG0ciK6MCGVhkEHqCK871fw5qfhDVE8R%2bE55YTCSzRx8tGO%2bB/Eh7g//qZ42KwLh79PbsfWFeYfE34R2PjOKTU9MEdprqj7/RLjHZ/f0b888Y0Pht8UNP8AHlh5Mvl2mtQr%2b%2btd3Dj%2b/Hnkr6jqO/Ynv6DzTivhfD4sg8IRReLmBu0crCH5mEY4HmHoT6e2MnNdrRRQAUUVWv7xNP066vZf9XbxPK30UEn%2bVAHkXxb%2bJV/Z36eDfCu99YudqTTQcvFu6Rpj%2bMjqewPqciXwH8DNM0qKPUfFKJqeqP8AOYHO6GI%2bhH8Z9SePbvXPfATTG1/xPrvjHUgJbpZNsbHnEkmWdh6YGAPZjX0FQAyKKOCJIoY1jjQYVEGAo9AKfRRQAUUUUAeEfHvw7c6ffaX460otHcW0iRTug5VlOYn/AD%2bU/wDAa9d8KeIbfxV4XsNatsBbmIM6A/cccMv4MCKs65o9r4g0O90m9Xdb3cTRP6jPQj3BwR7ivD/gvrVz4R8Zar8P9YfYzTMbfPTzVHOPZ0AYfQetAH0DRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV5P%2b0N/yTaL/sIRf%2bgvXrFeT/tDf8k2i/7CEX/oL0Adh8N/%2bSa%2bHP8AsHw/%2bgiuorl/hv8A8k18Of8AYPh/9BFdRQAUUUUAFZfiDxBpnhjR5tU1a5WC2iHU/ec9lUdyfSqfi/xjpPgrRn1LVZsZyIYF/wBZM/8AdUfzPQd6%2bXdf8Qa38TdbN/qUhg0%2bJiILdD8kS%2bi%2brdMsf8BWlKlOtNQgrtjSbdkW/GPjTWfihrG0brTRbdj5MAPA/wBp/wC85H4Dt3JfZ2UFjbiGBNqjqe7H1NOt7eK1hWGFAiL0AqWvrsDgIYWN95d/8jphBRCiiivRLM/XYzLot0oGcJu/Ig/0r234CXyXfwvt4FbLWdzNCwz0Jbf/AOz15A6LJGyOMqwII9Qav/BvxYvgvxlc6Fqcwj0/USEEjnCpKPuMT2BBIP4Z6V83nlJ80avTYwrLqfT9FFFeAYhRRRQAVV1LUbXSNNudQvplhtbaMySyN2Uc1ar5x%2bPfxA/tC%2b/4RLTZs2ts4a%2bdT9%2bUdE%2bi9/8Aa/3aAGeF9Pu/jT8TrjxDqsTDQrBhthY8bQcpD%2bPLN%2bPTIr3Pxh4VsvGHhi60W8AVZFzDIBzDIPusPp%2boJHesX4TS%2bHT4AsYfDk4lhiX/AEncNsgnIy%2b8djnp1GMYJFdzQB4B8HPFN74U8SXXw88RHymWZltCx4SXqUB/uv8AeX3P%2b1Xv1fP/AO0RbaLBd6XqUF4sHiNSAYYvvPEMlXJH3SrDAPfJ9OPRvhX47Txz4WSWd1Gq2mIrxBxk9nA9Gx%2bYI7UAd1RRRQAUUUUAFfNvxhvkuvjfodsjZ%2byLaxuPRjKX/ky17/4g16w8M6HdavqMwjtrdCx55c9lHqSeBXx1HrN14h%2bI1trF5/rrzUo5CB0X94MKPYDAH0qKv8OXoxrc%2bp6KKK/Nj0wooooAcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXn%2bo/8hO7/wCuz/8AoRr0CvP9R/5Cd3/12f8A9CNd%2bB%2bJiZWooor0wCuI/Zl/5mn/ALdP/a1dvXEfsy/8zT/26f8AtavOx/2fn%2bgz6AooorzgCiiigAooooAKKKKACiiigDjPiuJD8LfEAjIDfZsnPpuXP6ZrI%2bBBQ/Cqx2Y3CeYPj13nr%2bGK7vWtMi1rQ7/S5uI7y3kgY%2bgZSM/rXi/wB1p9LvNa8Fal%2b6vIJ2mijbqWX5JFH02qcfU0Ae70UUUAFfJZt/8AhHfj3Hb2SbEi1xFjjj7I8g%2bUf8BbFfWlZT%2bGtEk1xNbfS7RtUUYW6MQ3jjGc%2buOM0AatMkkWKNpG%2b6oJP4U%2bquoAtp1wF6%2bWaBpXdjkrm4e6naaQ8senoPSoaKKs9RK2iCt7w/eMS1q5yMbk9vUVg05rKbUrHULK3Zkmnsp4kZTgqzIVBB%2bpFJmdVJwdztYLmC5UtBPHKB1MbhsflSXNul1aTW0hISVGRivXBGDXx74R8K3vinW30yzvbeyv0RnjW5Zk3FfvKCoJyBk/ga7v/hX/AMWNI/48NUuZAP4bbVCoP4MVFSecnZ3R9B2OnWmmwCG0hWJO%2bOp9yepo1C8WytjIRljwq%2bpr5p1Lxx8T/B13Ha6rqU8ErrvWO4SGXcucZzg8Z969otr/AFHVPCmhX2qRLFeXFt5kqKMDJxg47ZGDjtmhGkF7SfvEk99c3LlpJWIP8IOAPwrznSgB%2b0raHHJsmJPqfKau%2brgtJ/5OUsv%2bvJv/AEU1UzpxCShoe9UUUVJxBRRRQAUUUUAFFFFABRRRQAUVgt418Mpra6M2uWP9os/li384bt/Tb6bs9utb1ABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHj/wC0d/yTzT/%2bwrH/AOipaPCv/IoaL/14Qf8AotaP2jv%2bSeaf/wBhWP8A9FS0eFf%2bRQ0X/rwg/wDRa134H4mJmvRRRXpgFek15tXpNedj/s/P9BhRRRXnAFFFFABRRRQAUUUhIVSSQAOST2oAWvO/HPxh8P8Ag1pLONv7S1VeDawPgRn/AG36L9Bk%2b1cP47%2bKmreJ9YPhH4fpLK8jGOW9tz80h7iNv4UHd8/TA5PS%2bAPgnpPhxY9R14R6pq5%2bbDjdDCf9kH7x/wBo/gBQBxCp8V/i0fM3to%2biS9BloImX6cvJ%2bq59K6zQP2ePDdgqvrV5dapL3RT5EX5Kd3/j1ew9PpS0Ac9pvgXwppCqLHw9psTL0c26s/8A30wJ/Wt5I0iQJGqoo6KowBT6KAGSRRzIUlRXQ9VYZH5Vzer/AA88Ia4jLfeHrBmbrJFEIn/76TB/WunooA8J8Q/ACSxl/tPwVrFxbXcR3RwTybSD/sSrgr7ZH403wb8YtW0LWP8AhGfiHA9vMjCMXsibWQ9vMA4ZT/fH1Oc5r3iuO%2bIHw%2b0zx7o5guFWHUIgfst4F%2baM%2bh9VPcfiOaAOvR1kRXRgyMMhlOQR6inV86%2bBviDqvwz1lvBnjaORbKJtsNwct5CnoQf4oj2xyP0H0Lb3EN3bx3FvKksMihkkjYMrA9CCOooAlryX45eOZfD%2bgxaBpspXU9UUhin3o4OhI92Pyj23d8V6XrGr2Wg6RdapqMwitbaMvIx9PQepJ4A9a8D%2bHmnXfxS%2bKN5401aI/wBnWMoaGJuV3j/VRj/dGGPvj%2b9QB6P8Jvh3D4J8PpcXUSnWrxA1y5HMQPIiB9B39T9BXolFFABRRRQAUUUUAFFFFAHHfED4eaX490gw3CrBqMSn7LeKvzRn%2b6fVT3H4jmvL/hj441PwV4ibwD4vLRRpIIrWWRuIWP3Vz3jbI2nt9Dx9A15Z8a/ASeJ/DTaxZRf8TbTELqVHMsI5ZPcjlh%2bI70Aep0V5z8GvGz%2bL/B6xXkpfU9OIguGbrIv8D/iAQfdT616NQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWXrdsZbRZFBLRt29D/kVqUVUJOElJAV7N5HtImlVlfbhgw5qxRRSbu7gFFFFIAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACuJ8beAovEhF9ZyLb6mi43H7soHQNjoR2P%2bR21Fa0a06M1Om7MabTujyKDxD8Q/DqC1vNKkvkTgSPC0px2%2bdDz%2bOTTLm4%2bIPjNTaGybT7OTiT92YVK%2b5b5iPYflXsFFdv8AaEU%2bZUo83f8A4BfP1sc14Q8IWnhWwZEbzruXBmnIxn2HoK6WiiuCpUnVm5zd2yG76sKKKKgQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBzGp/8hGb6j%2bQqpVvU/8AkIzfUfyFVK/O8X/vFT1f5npQ%2bFBRRRXOUFFFFABXkWo/8nI6H/vQ/wDoJr12vItR/wCTkdD/AN6H/wBBNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5//AGiP%2bRh8J/8AbX/0OOvoCvn/APaI/wCRh8J/9tf/AEOOvoCgAooooAKKKKACiisjW9et9FhG9TJO4%2bSMcZ9yewoKhCU5csVdmlNPFbxNLNIsca9WY4ApYZo54UliYNG4DKw7g1w0Gnav4qmW5vpTBZ5yoxx/wFf6muzsbGHTrNLWDd5adNzZNBtWpRpK3NeX4HI6dAlz4x1WB/uSJKjfQkCtK38EaZGAZXnmPfLbR%2bn%2bNUtG/wCR71D/ALaf%2bhCuzrpxXxL0REa1SmrRdjEg8K6VbXMVxDC6yRsGU%2bYTyPrW3RRXMTOpKesncYXRXVCwDNnAJ5OKfXJ%2bK9Lu/NTV7KaTzIB8yg/dA7r/AFFafh/XI9Zs8nC3MfEif1HtQaSofu1Ui7rr5GzRRRQYBRRRQAUUUUAFFFFABRRRQAUUVVvrkWtszj754Ue9Z1akaUHOWyGk27Izr%2bRr2%2bS0jPyqeT79z%2bFJZ/6Dqr25PyPwP6f4VY0i22RG4f78nTPpTNahO2O4TqhwSP0r56VGp7L%2b0H8d%2ba393a33HSpK/s%2bn6mvRUNrMLi2SUfxDn61NX0cJqcVKOzOZqzsFFFFUIKq3tha6hAYbqFZE9%2bo9we1WqKBptO6OC1TwRcREyadJ5yf883OGH0PQ/pXLz209rKYp4nicfwuuDXstQ3FtBdR%2bXcQpKn911BFB6FLMZx0mrnjdFekXXg3Sbg5jSSBj/wA834/I5rKm8Atk%2bRfgj0eP%2boNI7oZhQlu7HGUV1J8Caln5bi0I92Yf%2by0DwJqWfmuLQD2Zv/iaDX63Q/mOWorsYvAMpx51%2bi%2boSPP8zWra%2bCtLgIMvnTn0dsD8hj%2bdBnLH0I7O555FDJPII4o2kc9FUZJ/Cul0zwVeXOJL1vs0f90cuf6D/PFd1bWdtZpstoI4l77Fxn6%2btWKZw1cynLSmrHgnxH%2bE8/h%2bQeL/AAS80FxZnzpreM/MuOskf65XpjOPSu5%2bF3xMtfHeleRcmODW7df38AOBIP8Anog9PUdj9RXoVeAfFL4f3vhHV18e%2bDi1r5D%2bbcwwj/Uk9XUdChzhl9z2JwHmt31Z7/RXH/Dvx7ZePfD63kQWG%2bhwl3bA5Mbeo77T2P1HUGuwoAKz9cs31Dw/qVlH/rLi1lhX6spA/nWhRQB5h8E/CWueEPDd9ba5ax20lxciaNBKHYDaAd2MgdB3r0%2biigAooooAKKKKACvCPj34WntLix8c6VvjubZ0junj6qQf3cn4H5Sf92vd6p6rplrrOlXWmX0fmWt1E0Uq%2bqkY49D6GgDzvweNS8X%2bGLPWbTV8CZcSR%2bc%2bY5Bwyn8f0x61u/8ACL67/wBBf/yK9eT/AA01O6%2bGfxMv/BGsSYsryYLDK3C%2bZ/yzcezrgH32%2bhr3G%2b8WaHpuv2Oh3eoRR6lfHEEBPJ9M9hnGBnqeldP1up5fcO5jf8Ivrv8A0F//ACK9H/CL67/0F/8AyK9dnRR9bqeX3Bc4z/hF9d/6C/8A5Fej/hF9d/6C/wD5Feuzoo%2bt1PL7gucZ/wAIvrv/AEF//Ir0f8Ivrv8A0F//ACK9dnRR9bqeX3Bc4z/hF9d/6C//AJFej/hF9d/6C/8A5Feuzoo%2bt1PL7gucZ/wi%2bu/9Bf8A8ivWfPBqWk61Y29xqEkvmOjfLK2MbsYOa9DrjPFH/I0aX/wD/wBDrehXnUlyytaz6AmdnRRRXniCvJ/2hv8Akm0X/YQi/wDQXr1ivJ/2hv8Akm0X/YQi/wDQXoA7D4b/APJNfDn/AGD4f/QRXUVy/wAN/wDkmvhz/sHw/wDoIrqKACuP8ffEPSfAWl%2bddMJ7%2bVT9ms0bDyH1P91ff8smsr4l/FXT/A1q1nbbLrXJEzHb5%2bWIEcPJ7ei9T7DmvniO11DxHqcmueIZ5Liedt%2bJOrenHZR2A/lW%2bHw1TET5IIqMXJ2Q%2b9utY8e602t6/OzI3EaLwoUdFQfwr/P681tRxpFGscahUUYCgcAU4AAYAwB0Aor7DB4OnhoWjv1Z0xgooKKKK7CgooooAKy9a0dNUhDIQlwn3WPQj0NalFZVaUK0HCaumJpNWZveAfjZe%2bHjFonjCOaa1jASO8A3SxDtuH8a%2b45%2btfQmnalZavYxX2nXUN1ayjKSxMGU/wD1/avlS9sLe/h8u4jDDsw6r9DWbpyeJvCl01x4b1aaHcclEfbu/wB5T8rfjXy%2bKymrSd6fvL8TnlTa2PseivmGH4y/Eq3j8uWC1nbGN72nP/jpA/SsnVfGfxG8TxtBearJbWr8NHDthUj0Oz5iPrmuCOFrydlB/cRyvseu/FD4v2Xhi0m0nQ547rXHBQsh3Ja9iSehf0X8/Q%2bGaLoxEMtzqC%2bZPcZ3CTkgHk59zU2l%2bHrawZZZD5046MRwv0FbFe/l2V%2byftK2/RG8KdtWYum6hrPw91tdZ0OY%2bT92WN%2bUdf7rjuPQ9q9a1z9oXTB4Shn0W2c63cAqbeZcpakdWY/xe2OvfHSvPmUMpVgCDwQe9cpoNnA%2buXZaMEQsfLB6D5sVzY3K4qvFUnZSf3Ezp6qxdtNOvNWv5NZ12aS4up23kSnJY%2brf0H/6qsaRrOo/DnxXHrmmJ5lo/wAksBOFdD1Q%2bnqD7DrzWvTZI0mjaORQ6MMFSODXo1Mpouh7KOjXXz8y3TVrH0d4T8Z6L4z0xbzSLpXYAebbuQJYT6Mv9eh7V0FfGZ0K8029W%2b0K/mtJ0OVKSFGX6MOa6iz%2bK/xN0tRHLJHfBehnt1c/mmCfxr52tgMRSdpRfy1MHCSPqSuX8ZeP9B8EWXm6pc7rlhmKziw0sn0HYe5wK8Avvij8TdYjaJLhbGNuv2eFIyB/vNlh%2bBrm4PD0lxdveavdPd3Dtucs5YsfVmPJp0cvxFV2Ubeb0GoSZo%2bKfF/iD4oakrXP%2biaTC2YrZDlE9yf43x3/ACxmstreK08YeH4IV2ok8IA/7aCuhRFjQIihVHAAGAKw7v8A5HjQf%2bviH/0aK9DH4CGFwE7aye7NHBRR9MUUUV%2bLHaFFFFADk%2b%2bv1rsK49Pvr9a7Cvp%2bHdqny/U5cT0CiiivpTlCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8/wBR/wCQnd/9dn/9CNegV5/qP/ITu/8Ars//AKEa78D8TEytRRRXpgFcR%2bzL/wAzT/26f%2b1q7euI/Zl/5mn/ALdP/a1edj/s/P8AQZ9AUUUV5wBRRRQAUUUUAFFFFABRRRQAV4r8XPAWpw6xD488JrIup2xV7qKEZZtvAkA78cMO4/HPtVFAHnHw/wDi9onjC2htbyaLT9ZwFa3kbasresZPXP8Ad6/XrXo9eaeNPgp4c8VzyXttu0rUZMlpbdAY5G9Wj4BPuCM981xifDn4ueHsQ6L4sW4tlOI1N2/A/wBx1IH0BoA9%2brldf%2bIGhaDqlnpDXSXOrXlxHbxWcLAuGdgoLnog578%2bgNfPPjy8%2bKnh3y4vEesX6W9yMLJbT7YnP90lMDPHQ1yPgYlviJ4bZiSTq1qST3/erQB9vUhAIwelLRQByGpae9lOcAmFj8jf0NUa7t0WRCjqGU9QRkGs99EsXbPllf8AdY07nXDEq1pHKgEnAGSewrptF09rWJppRiWTjB/hFW7fTrW1O6KIbv7x5NW6GyKtfmVkeCfFD4darpPiBvGHhZJTmT7RPHAMyQS9S6jupPJ6457Hila/tA6pDpghutEt575Vx9oExRCfUpt/kRX0RVCXRNJnuvtUul2UlxnPmvboX/MjNI5zwDwX4K1z4keKf%2bEm8ULINN3iRjIu37Rj7saD%2b56n09zmvoHUbFb208sYV15Q%2bh9KudBS0DTad0cPPbTWz7Zo2Q%2b44P0Nee6EDc/tJqU/5drEmT2zF/8AZivcr27gsLC4vLpwlvbxNLKx/hVQST%2bQrwj4B282teL/ABP4tuEw0pKA/wC3K5kYD6bV/wC%2bqdzWpW542aPf6KKKRiFFFFABRRRQAUUUUAFeM/F/4lXdjcr4P8MM76xc4SeSEZeLd0jTH8Zz17AjHJ47T4l%2bOIfAvhWW9BVtQnzFZRH%2bJ8feI9F6n8B3rhPgh4ElCP4411Wm1C%2bLPaGblgrfelOf4m5wfTn%2bKgDy3x58Pv8AhAdF0E3N20muXzSSTxxn5YQu3aFPUnLcnuenSvrq28wWsQlz5mwb8%2buOa%2bX/AIg%2bLNL1j41w3Goyu2jaPKsLCNdxk8olmUD/AGnyuc9Mc10N78efFOsyXB8K%2bGF%2bywKXklljedlUclm24VeB3z9aAPoSiuJ%2bF/jmTx74VbULm3jgvIJzBOsWdhIAIZQckAhumT0NdtQAUUUUAFFFFABRRRQAUUUUAFFFFAHj/wC0d/yTzT/%2bwrH/AOipaPCv/IoaL/14Qf8AotaP2jv%2bSeaf/wBhWP8A9FS0eFf%2bRQ0X/rwg/wDRa134H4mJmvRRRXpgFdzqMt7G0ZtE3Lg7uM1w1ek1wY18ri7X3/QDC/ta/i/11px/ulav6fqH29XPlFNmO%2bc1epAAOQAM1wynCS0jZgLRRWZqGnz3U6zQz7GVcAcj9RURSbs3YZp0Vg%2bbq9l99TKg9Ru/Uc1p2F015b%2ba8ew5xjPWrnScVe90K5brwj4v%2bO77WdYT4f8AhbfLczOIrx4jyzH/AJZA9gByx/Dsa9H%2bJnjAeCvBd1qMbL9tl/cWikZzK2cHHoAC34Y71xHwI8Emy0yTxfqaF9Q1HP2dpOWSInl/q57%2bmPU1kM7H4c/DvT/AWjBECz6pOo%2b13WPvH%2b4voo/XqfbtqTpWLf8AiK3tiY4B57jqQcKPx71cKcpu0UBt0VxU3iHUJSdsqxj0RR/Wof7Y1D/n7k/OupYGp1aFc7uiuE/tjUP%2bfuT86P7Y1D/n7k/On9Rn3QXO7orhP7Y1D/n7k/Oj%2b2NQ/wCfuT86PqM%2b6C53dFcJ/bGof8/cn50f2xqH/P3J%2bdH1GfdBc1PGvgXR/HOk/Y9TiKzR5NvdR/6yFj6eo9Qev1wa8YttH%2bKnwmuZIdIhfWdH3bljiiaeNvfyx86H1xx7nFep/wBsah/z9yfnR/bGof8AP3J%2bdH1GfdBc8pu9P%2bJvxgv7e21WxfR9GjfcQ8LQxL/tbWO6RsdO30ya978N%2bHdP8K6DbaPpsey3gXGT9527sx7kn/OK5r%2b2NQ/5%2b5Pzo/tjUP8An7k/Oj6jPugud3RXCf2xqH/P3J%2bdH9sah/z9yfnR9Rn3QXO7orhP7Y1D/n7k/Oj%2b2NQ/5%2b5Pzo%2boz7oLnd0Vwn9sah/z9yfnR/bGof8AP3J%2bdH1GfdBc7uiuE/tjUP8An7k/Oj%2b2NQ/5%2b5Pzo%2boz7oLnd0h5%2blcL/bGof8/cn50f2xqH/P3J%2bdH1GfdBc8y8KR/8IB%2b0Re6FH8mn6iWjjX%2bEK6%2bZHj6H5Pzr6Ir5h%2bIl3cR/Frw3qAmb7QPs53f7sxx/OvY/7Y1D/n7k/Os44SUm0nsM7uiuE/tjUP8An7k/Oj%2b2NQ/5%2b5PzrT6jPuhXO7orhP7Y1D/n7k/Oj%2b2NQ/5%2b5Pzo%2boz7oLnd0Vwn9sah/wA/cn50f2xqH/P3J%2bdH1GfdBc7uiuE/tjUP%2bfuT86P7Y1D/AJ%2b5Pzo%2boz7oLnd0Vwn9sah/z9yfnR/bGof8/cn50fUZ90Fzu6K4T%2b2NQ/5%2b5Pzo/tjUP%2bfuT86PqM%2b6C53dFcJ/bGof8/cn50f2xqH/AD9yfnR9Rn3QXO7orhP7Y1D/AJ%2b5Pzo/tjUP%2bfuT86PqM%2b6C53dFcJ/bGof8/cn50f2xqH/P3J%2bdH1GfdBc7uiuE/tjUP%2bfuT86P7Y1D/n7k/Oj6jPugud3RXCf2xqH/AD9yfnR/bGof8/cn50fUZ90Fzu6K4T%2b2NQ/5%2b5Pzo/tjUP8An7k/Oj6jPugudpdXUdnD5kucZwMDOTT4ZVmhSVPusMiuFl1O9mjKSXDsp7GiLU72GMJHcOqjsDT%2bovl31C531FcJ/bGof8/cn50f2xqH/P3J%2bdL6jPugud3RXCf2xqH/AD9yfnR/bGof8/cn50fUZ90Fzu6K4T%2b2NQ/5%2b5PzoGs6iDkXT/jil9Rn3QXO7orkbbxNdxkCdUmXucbT%2bnH6V0NjqdrqC/unw46o3BFYVMPUp6taDLtFFFYgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBzGp/8hGb6j%2bQqpVvU/wDkIzfUfyFVK/O8X/vFT1f5npQ%2bFBRRRXOUFFFFABXkWo/8nI6H/vQ/%2bgmvXa8i1H/k5HQ/96H/ANBNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5/8A2iP%2bRh8J/wDbX/0OOvoCvn/9oj/kYfCf/bX/ANDjr6AoAKKKKACiiuR8Ra5dvejR9LSQTkgO6ghj3wvt6mg1o0pVZcqOuqrdWFrfGI3MCS%2bU25Nw6H/PalsluUsolu3V7gLh2QcE1ZoM7uL0YnSloooEcZo3/I96h/20/wDQhXZ1xmjf8j3qH/bT/wBCFdnXTiviXohsKKKK5hBXMx%2bGZLTxGt9YzrBbfedAOfdQPQ/p%2bFdNRQaU6sqd%2bXqFFNJCgkkADvTYpo54llidXjbkMpyDQZklFFFABRRRQAUUUUAFFFFABWFOTqeprEp/dR9SPTuav6ndfZrUhT%2b8fge3vTdKtfItt7D55OT7DtXk4t/Wq8cKvhWsv0XzNoe5Hn%2b4vKAqgAYA4Apk8QngeJujDFS0V6koqUeV7GNzH0eUpJLavwwOQPfoa2KxNQBs9SjulHyscnH5H9K2VYMoYHIPINeblknBSw0t4P8AB7GtVXtJdR1FFFeoZBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABTHRJUaORVZGBDKwyCD1BFPooA%2bbfF2haj8GPHUHijw8pbRLpyrQEnaueWhY%2bh6qe2O%2b3n37w/r1h4m0K11fTZfMtrhNw9VPdWHYg5Bp%2bt6NY%2bIdGutJ1KES2lymx17j0IPYg4IPqK%2bf/B2r33wc%2bIlx4W1yX/iS3jgrMeFGeEmHoONremP9mgD6RopOv0paACiiigAooooAKKKKACikPH0rw74i/F%2b5vb0%2bFfAnmXV9O3lSXluNxyeqxY6nrlu3b1ABi/tB6l4fvtX062sJWl8Q2rGOYwchYzyEY/3w3IA6ZOeorEvfhH4wn8KXXjHUbqZta3C5Nq5LTmMcli2chxwQvUAevFeo/DL4QW/hYprWvbLzXX%2bcBvmS2J54P8AE/q35ep9WoA8a%2bH/AMVdZ8U6ULf7NDcalaoBOFhYs46B8A9%2b/v8AhXZf8JD4m/6A/wD5LSf415P8RPDWofC3xnb%2bN/DCbNPml/fQqPkidvvIQP8Alm/b0PHHy17f4X8Vab4s8P2usWEy%2bVMMNGzDdE4%2b8je4P58EcGuiNaKVnBMZkf8ACQ%2bJv%2bgP/wCS0n%2bNH/CQ%2bJv%2bgP8A%2bS0n%2bNdh50X/AD0T/vqjzov%2beif99VXt4f8APtBc4/8A4SHxN/0B/wDyWk/xo/4SHxN/0B//ACWk/wAa7Dzov%2beif99UedF/z0T/AL6o9vD/AJ9oLnH/APCQ%2bJv%2bgP8A%2bS0n%2bNa%2bg6lql%2b841Gy%2bzhANh8pk3dc9TWz50X/PRP8AvqlV0f7rK30NROrGUbKCQDq4zxR/yNGl/wDAP/Q67OuM8Uf8jRpf/AP/AEOqwn8T5MEdnRRRXMIK8n/aG/5JtF/2EIv/AEF69Yryf9ob/km0X/YQi/8AQXoA7D4b/wDJNfDn/YPh/wDQRXE/FH4xQ%2bHPN0Pw66XOsn5JJlw6Wp6Y/wBp/boO/pXnuofF27j8CaL4T8LiVLlbGOG7vAMMDtwUj9Pdvy9a5nR9CSx/0i4Ilum5z1C/T3967MHgqmKnaOi6sqMHIi03R5prp9T1aR57yVjIfMbcdx5LMT1P%2bfpvUUV9fh8NTw8OSmjqjFRVkFFFFdAwooooAKKKKACiiigAooooAKKKKACiiigArmfD3/Ib1L/eP/oRrpq5nw9/yG9S/wB4/wDoRrz8X/vFH1f5ES%2bJHTUUUV6BYUUUUAFFFFABWFd/8jxoP/XxD/6NFbtYV3/yPGg/9fEP/o0V4%2be/7jMiex9MUUUV%2bEHUFFFFADk%2b%2bv1rsK49Pvr9a7Cvp%2bHdqny/U5cT0CiiivpTlCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAprMFUsegGTTqoarP5NkwB%2baT5R/WscRVVGlKo%2biHFczSIdJnmuGmeRyVGMA%2b9atUdLh8mxTPV/mP4/wD1qvVhl8Zxw0Od3bV/v1KqNObsFFFFdpAUUUUAFef6j/yE7v8A67P/AOhGvQK8/wBR/wCQnd/9dn/9CNd%2bB%2bJiZWooor0wCuI/Zl/5mn/t0/8Aa1dvXEfsy/8AM0/9un/tavOx/wBn5/oM%2bgKKKK84AooooAKKKKACiiigAooooAKKKKACiiigChq%2bj6fr2mTadqlpHdWkww8bj9QeoPoRyK%2bY9V8Ew%2bA/jh4Z0y2umuLaa%2bs7mEuMMitPt2t2JBQ8/SvquvAPin/ycL4K/wC3H/0regD3%2biiigAooooAKKKKACiiigAoorhviH8TNK8Caeys6XOryJm3sw3Psz4%2b6v8%2b3sAcp8e/GY0/Qo/Cti5e/1LBmVDlkhB6cc5YjH0Detdr8M/Cf/CHeBrHTZVAvJAZ7rH/PVuo/AYX/AIDXmfwp8Dan4l8Qn4g%2bLA0jyP51nHKOZG/hkx2VRjaPYHoBn3ugAooooAKKKKACiiigAprusaM7sFRRksxwAPU06vLvjp4rbw94GbT7eTbeasxt1I6iID94fyIX/gVAHnE9wvxh%2bLEt1dziHwtpClnkkbaiwKepJwAZG%2bh2/wC7W94t%2bM95ql2vhr4dWcksr/ulu44skjpiJOwA/iPT0GM15n4E8I%2bJPG0Emk2ErWmiCUS3ty42xAgcbv75A6L2yTxkmvVIfGnw5%2bEmnvYeH0OsaoRieaAgmRh/fl6Aey5x6d6AGeCP2f4ItmoeMZvtM7fN9hhkOxT/ALbjlj7Dj3NVfiv8RtI0rRZfA/hFLaNXHk3clsoWKJD96NccEnox6AZHXOM%2bXxD8V/inE8Gk2TaZo8wwzxjyY2U%2bsrfM3vs/KtHR/wBm%2bCOHzvEOvsMDLx2SBVUDr87/APxIoA7n4OaZpOheDY9OstX0%2b/v3Y3N79juUl2OwA2/KTwAAPrn1r0Wvl/4VaXbN8cCfDE11JotiJS087AtJFsKZJAAIZyCBjpjuK%2boKACiiigAooooAKKKKACiiigAooooA8f8A2jv%2bSeaf/wBhWP8A9FS0eFf%2bRQ0X/rwg/wDRa0ftHf8AJPNP/wCwrH/6Klo8K/8AIoaL/wBeEH/ota78D8TEzXooor0wCvSa82r0mvOx/wBn5/oMKKKK84AooooAKKKa7rHG0jkKigkk9gKAPnr4nvL4%2b%2bM2keDbeRja2hVJtp6Fhvlb6hAB9Qa9qN3PpLLAloqWUQEcKKMBVAwACPavGfgZE/iP4h%2bJvFdwpLfMVJ/haZy3H0VCPoa9w128%2byaa%2b378vyL7Z6n8q1o6z5bXuJmHq%2buNdr5Fvujix8%2berH0%2blYtFFe1Tpxpx5YgFFFFWAUUVka34m0fw9Fv1O9jiYjKxD5nb6KOfx6UnJRV2Br0V5be/GaEymLS9GmnJ%2b600m0n/AICoP86j/wCFmeKf%2bhTk/wC/Uv8AhXO8XSXUD1aivKf%2bFmeKf%2bhTk/79S/4Uf8LM8U/9CnJ/36l/wpfXKXcD1aivKf8AhZnin/oU5P8Av1L/AIUf8LM8U/8AQpyf9%2bpf8KPrlLuB6tRXlP8AwszxT/0Kcn/fqX/Cj/hZnin/AKFOT/v1L/hR9cpdwPVqK8p/4WZ4p/6FOT/v1L/hR/wszxT/ANCnJ/36l/wo%2buUu4Hq1FeU/8LM8U/8AQpyf9%2bpf8KP%2bFmeKf%2bhTk/79S/4UfXKXcD1aivKf%2bFmeKf8AoU5P%2b/Uv%2bFH/AAszxT/0Kcn/AH6l/wAKPrlLuB6tRXlP/CzPFP8A0Kcn/fqX/Cj/AIWZ4p/6FOT/AL9S/wCFH1yl3A9Woryn/hZnin/oU5P%2b/Uv%2bFMl%2bKPiWCJpZvC7RxqMs7pIAB7kij65S7gM8YMNU%2bMWiWUfP2cwBwPZjIf8Ax3FeuV88aR4g1ZvF1x4oi0iS%2bnZnwqI7LGWGMAgHovFdj/wszxT/ANCnJ/36l/wrGliacXJye7A9Woryn/hZnin/AKFOT/v1L/hR/wALM8U/9CnJ/wB%2bpf8ACtvrlLuB6tRXlP8AwszxT/0Kcn/fqX/Cj/hZnin/AKFOT/v1L/hR9cpdwPVqK8p/4WZ4p/6FOT/v1L/hR/wszxT/ANCnJ/36l/wo%2buUu4Hq1FeU/8LM8U/8AQpyf9%2bpf8KP%2bFmeKf%2bhTk/79S/4UfXKXcD1aivKf%2bFmeKf8AoU5P%2b/Uv%2bFH/AAszxT/0Kcn/AH6l/wAKPrlLuB6tRXlP/CzPFP8A0Kcn/fqX/Cj/AIWZ4p/6FOT/AL9S/wCFH1yl3A9Woryn/hZnin/oU5P%2b/Uv%2bFH/CzPFP/Qpyf9%2bpf8KPrlLuB6tRXlP/AAszxT/0Kcn/AH6l/wAKP%2bFmeKf%2bhTk/79S/4UfXKXcD1aivKf8AhZnin/oU5P8Av1L/AIUf8LM8U/8AQpyf9%2bpf8KPrlLuB6tRXlP8AwszxT/0Kcn/fqX/Cj/hZnin/AKFOT/v1L/hR9cpdwPVqK8p/4WZ4p/6FOT/v1L/hR/wszxT/ANCnJ/36l/wo%2buUu4Hq1FeU/8LM8U/8AQpyf9%2bpf8KP%2bFmeKf%2bhTk/79S/4UfXKXcD1aivKf%2bFmeKf8AoU5P%2b/Uv%2bFH/AAszxT/0Kcn/AH6l/wAKPrlLuB6tRXlP/CzPFP8A0Kcn/fqX/Cmv8VPEFqvm3fhdkhH3iwkT9SMUfXKXcD1iivPdJ%2bL2h3zrHfwz2Dn%2bJv3kY/Ec/pXe211b3lulxazRzQuMrJGwZT9CK2hUhP4WBLRRRWgBTo5HikWSNirryCDTaKQHa6Nqg1GDa%2bBOn3h6%2b4rUrz%2bwu2sbyOdScA/MB3HcV36sGUMDkHkGvHxVH2c7rZjFooormAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOY1P/AJCM31H8hVSrep/8hGb6j%2bQqpX53i/8AeKnq/wAz0ofCgooornKCiiigAryLUf8Ak5HQ/wDeh/8AQTXrteRaj/ycjof%2b9D/6Ca9rIf8Aen6P9DDEfAfR9FFFfZHEFFFFABRRRQB8/wD7RH/Iw%2bE/%2b2v/AKHHX0BXz/8AtEf8jD4T/wC2v/ocdfQFABRRRQAVF5MRn87y080Lt34GcemalooAKKKKACiiigDjNG/5HvUP%2b2n/AKEK7OuM0b/ke9Q/7af%2bhCuzrpxXxL0Q2FFFFcwgooooArXtpHf2ctrKWCSLtJU4Iri/I1vwnKzQD7TYk5PGV%2bpHVTXe0UG9Gu6acWrp9DB0PxLFrUzQrbyRSqm9skFcZA6/j6VvVAlrbxTNNHBGkjcM6oAT9TU9BnUcHK8FZGXq2uWmjeX9qEhMgO0Iuc46/wA6w5vHsA4t7GV/Te4X9BmumurC0vWQ3VvHNszt3rnGev8AIU%2bG0trb/UW8UX%2b4gX%2bVBrTnQjH3otv1M3QdVudVtpZbm2MBV8J8pAZcep6962aKKDGbUpNxVkczrPhq71TUWuI78wxMANhycED0zWefBFyBk6r/AOOH/Gu2rM1e68qDyUPzydfYVhia8cPSdWXQ6aWKraQi/wAEZGj2LN5Vs8pmjgzl8YyNxP8AWuqqnp9t9ltQCPnblv8ACrlc%2bX0JU6bnU%2bOer/y%2bRjWqc8rnHXuteIdPvp2ax8y0Eh2Ex5wueOV9vWp7LxxZTELdwyW7d2HzqP6/pXVVQvNG0%2b/bdc2kTvnO/GD%2bYrvNlVoyVpw%2baFv4hd6eWTkgb09/8imaRP51psJ%2baPj8O1aNc7JcxaJqLvO%2by3bvjsenFeXiU6OLp147S91/oZQXPFwW/Q6Kio4Zo54llidXjYZVlOQakr1DEKKKKACiiigAooooAKKKKACiiigAooooAKKKKACuA%2bLPgJPG/hdvs0Y/tayBltG7v/ejJ9Gxx7ge9d/RQB5F8DvHj63pD%2bGdUdhqmmJiPzOGkhBxg/7SHCn2x7167Xz58W/Dd74H8YWfxB8PDy0ecG5UD5UlPUkf3XGQffP94V7V4W8SWfizw5Z6zYn91cJlkzkxuOGU%2b4P%2bPegDZooooAKKKKACobq6gsbWW6upo4beJS8kkjBVVR1JJqnrmu6b4c0mbU9WuktrWIcsx5Y9lUdST2Ar581LWPFXx0186VpEb2Hh2BwXL/dUdmlI%2b83og6fgWoAueMfiJrfxM1k%2bEfA8UosZCVmuBlWmTOCzH%2bCP9T%2bOK9O%2bHXwy0vwHYiQBbrV5VxPeMOn%2byg7L%2bp79gNjwd4K0jwRpAsNLh%2bZsGe4fBkmb1Y/yHQfnXR0AU9V1GDR9JvNSuiRb2kLzyY67VBJx78V89Wnij4s/Eaa91Xw3I1pp1s5CQwtGig9QgLcu2ME54%2bmQK9/1/SY9d8PajpMrlEvbaSAuOq7lIz%2bHWvnPQPEXj34SJfeHX8Om6jeUyQs0Tsm8jG5GXhlIA49uxzQB6B8MvGsvxG0nV/C3i21SW9gjKzZj2ebGTtO5f4XVsdMduhFeZ3emXnwi8e/YL95pNAvGyk6ru3R5%2b8B/fXPI7/iK9F%2bCXgzWtNvNV8VeIIHtrvUgVjhkXa5DNvdmX%2bHJxgex9q9B8beDrDxv4cm0u9AR/v284GWhk7MPbsR3FVGTg%2baO4Gba%2bDbO%2btIbu11XzreZA8ciRghlPIIOam/4QOL/AKCD/wDfof415D8PvHmofDbW7vwT4oRmghl2wNu4hc88E/wMCCPTPua9h/4Tu1/58pv%2b%2bhXZTq4qorxd/uHqM/4QOL/oIP8A9%2bh/jR/wgcX/AEEH/wC/Q/xp/wDwndr/AM%2bU3/fQo/4Tu1/58pv%2b%2bhV3xv8AVg1Gf8IHF/0EH/79D/GtbQ/D66K8zLcNL5oA5XGMZ/xrM/4Tu1/58pv%2b%2bhWrouvxa08yxwPH5QBO4g5zn/Cs6rxXI/abfINTYrjPFH/I0aX/AMA/9Drs64zxR/yNGl/8A/8AQ6zwn8T5MEdnRRWT4i8SaV4V0iXU9Xulgt06Dq0jdlUdyf8APFcwi9e3ttp1lNeXk8cFtCpeSWQ4VQO5NfMfxO%2bJU/xDu10HRINukQy%2bZ5si4aZhkbz/AHV5OB1559BneMvHWufE/UzBGHstEhfMdvnj/ef%2b83oO3buS2xsLfToBFAuP7zHqx9TXp4DLZ4l80tI/n6GkKbkQaVo8GmRfLh5mHzSEfoPQVo0UV9ZSpQpRUIKyR0pJKyCiiitACiiigAooooAKKKKACiiigAooooAKKKKACiiigArmfD3/ACG9S/3j/wChGumrmfD3/Ib1L/eP/oRrz8X/ALxR9X%2bREviR01FFFegWFFFFABRRRQAVhXf/ACPGg/8AXxD/AOjRW7WFd/8AI8aD/wBfEP8A6NFePnv%2b4zInsfTFFFFfhB1BRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooprMqKWYgAdSTSbsA6sKVjqepLGv8AqU7%2b3c0%2b91Brhvs1oC27gsO/sKvWFkLSHBwZG5Y149af1%2bqqNP8Ahxd5Po/JG8V7Ncz3LYAAwOlLRRXsmAUUUUAFFFFABXn%2bo/8AITu/%2buz/APoRr0CvP9R/5Cd3/wBdn/8AQjXfgfiYmVqKKK9MAriP2Zf%2bZp/7dP8A2tXb1xH7Mv8AzNP/AG6f%2b1q87H/Z%2bf6DPoCiiivOAKKKKACiiigAooooAKKKKACiiigAooooAK8A%2bKf/ACcL4K/7cf8A0revf68A%2bKf/ACcL4K/7cf8A0regD3%2biiigAooooAK8im/aJ8IwzSRNp2tlkYqSIIsZH/bWvXa%2bcfgVomk61r/iddV0uyv1iMZjF1bpKEJZ843A46CgDrv8Aho7wf/0Ddc/78Q//AB2orj9pDwwsebfSNXkf0kSJB%2bYc/wAq9F/4QTwf/wBCpof/AILof/iakh8GeFrZ/Mg8NaPE46NHYxKfzC0AeJXfxc8e%2bOXax8G6BJao52maJTM6/WQgIn4j8a3vBXwM8q/Gt%2bNrkalfs3mfZS5kTd1zIx5c%2b3T617RHHHFGI40VEUYCqMAfhT6AEACqAAABwAO1LRRQAUUUUAFFFFABRRVXUNQtNK0%2be/v7hLe1gQvLLIcBQKAK2v65Y%2bGtEutX1KXy7W2TcxHVj0CgdyTgD618heKvG8vjfxQdT1wTfYosi3soGC7EzwgY5wT3bB%2bnQDufGnjDWPjJqsXhnwrpcjabBMJfMfguRkb3PRE5OAefx4HofgT4IaJ4YEV7rAj1XVBhsuuYYj/sqep92/ACgDzbRvDfj74k6fBZwRpoHhRBiKFEMUBX1C/elJ67mJBOea9Z8JfBjwp4X2TyW39qXy4Pn3gDBT/sp90fjkj1r0Pp9Kqanqljo2nTahqV1Fa2kI3PLI2AP8T6DvQBZZkijLMyoiDJJOAAK%2bffiR8R9Q8b6r/whPglZLiGZvKnnh63HqqntGO7d/p1q%2bJfHPiT4u6w3hjwfbTQaSTiaQnaZE6bpW/hT/Z7%2b54Hrvw/%2bHel%2bAdMMVt/pGoTKPtN4y4Z/ZR/Cvt%2beaAHfDvwHZ%2bAvDwsois19MQ95cgY8x%2bwH%2byOg/E967CiigAooooAKKKKACiiigAooooAKKKKAPH/ANo7/knmn/8AYVj/APRUtHhX/kUNF/68IP8A0WtH7R3/ACTzT/8AsKx/%2bipaPCv/ACKGi/8AXhB/6LWu/A/ExM16KKK9MAr0mvNq9Jrzsf8AZ%2bf6DCiiivOAKKKKACsHxtdmx8Ca/dKcPHp85X/e2HH64rerkPikzJ8MPEJU4P2Nhx6HANAHFfs42Yi8EaleEYefUCufVVRMfqzV3fiqQm4t4%2bwUt%2bZ/%2btXLfABEX4YoV6teTFue/A/kBXSeKf8AkJx/9cR/6E1dWDV6qBmJRRRXsCCiiuc8b%2bJB4Y8NzXiEG6kPlW6n%2b%2be/0Ayfw96mUlFOTAwfHPj%2bTSrgaJoafaNWkIRmVd/lE9FA/ic%2blaHgv4EPfMuseObiaa4m%2bc2Syndz/wA9X659lP49qu/A3wAILQeM9YQy6hebmtPM5KIc5kP%2b03OPb617bXi1q0qru9hmbpOgaRoNuINJ021so8YxBEFJ%2bpHJ%2bprSoorEAooooAKKKKACiiigApksscETSyuscaAszMcBR6k0rMEUsxAUDJJPAFfOXiXXtd%2bM/jR/DHhydoNAt2zJKchHCnmV8ckE/dX6HjnAB3nir47%2bFtBJh0wtrV0M5W3bbEv1kIIP/AQa5e1/aTCzKNQ8KyRRN8waK7y23tgFBn65Fd94T%2bEPhTwm0NxHZm91CPn7XdncQfVV%2b6vtxn3rtL2ws9RtzBfWkF1Cesc8YdT%2bB4oA5Xwv8U/CXixkhsdSEF23S1ux5Uh9hnhj/uk12deSeK/gF4b1hXn0R30e7PIVMvCx91Jyv4HHtXFjV/ip8JSItRhbVtFi4DvmaIL7SD509g3HtQB9H0V5PoP7QHhLU41XVBc6TOeokQyx59mQE/mororj4ueBLaAyv4jtmA/hjV3Y/gBmgDtq%2bfvi943n8W6tB4B8LE3TSzql08R4lkB4jB6bVI3MenHsah8TfFrXvHt0fDfgPTrqOOfKSXGMTOvQ9DiNfUk5%2bleg/DD4WWngSzN5dMlzrc6bZZgMpEP7kfGcdMnvjtQBp6Fp%2bifCj4fww315FBBbrvubg/8ALaZvvEDqScYA64A9K811P9oi7ubx4fDfhszIp%2bWS5ZmZh67E6f8AfRrH%2bLep3XjP4ow%2bFoZmSw0/CsFPBcrud8eoB2jPofWug03TLPSbRLWygWKJR2HLH1J7mg7MLg3X1bsiPRv2iWjvVtvE2gNbKT801sxyn1jbkj8fwNe26ZqdlrOmwajp1zHc2k67o5Yzww/ofUHpXieraPZa1ZNa3sKupHytj5kPqp7Gs34H6zd%2bHvHWoeDLuYtbzh3hXsJUGcj0DICT9BQLFYR0LO90z6KooooOQKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5HxJ8NPCfimJ/t%2bkQx3DdLq2AilB9cgfN/wIEV4b4g8IeKfg9fHUtNuGv8AQncb22naOwEq/wAJ7Bh%2bmcV9QVDdWsF9ay2t1Ck1vMhSSNxlWU8EEU4ycXdAeSeG/Edj4n0lL6zbB%2b7LE33o29D/AENbFeS63pU/we%2bJcflM7aBqHKZJP7rPIPqyE/kR/eNesqyuoZSGUjIIPBFezh63tY67oQtFFFdABXd6PKZdItmP9zb%2bXH9K4Su30D/kCW//AAL/ANCNcOOX7tPzA0qKKK8sYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQA1mCKWYgKBkk1hQyS6nqolRmSGLuDjj/AOvVvV0upY0igQlGOHI/TPtVuytEs7dY15PVj6mt4NQhzdWIwdT/AOQjN9R/IVUq3qf/ACEZvqP5CqlfmmL/AN4qer/M9OHwoKKKK5ygooooAK8i1H/k5HQ/96H/ANBNeu15FqP/ACcjof8AvQ/%2bgmvayH/en6P9DDEfAfR9FFFfZHEFFFFABRRRQB8//tEf8jD4T/7a/wDocdfQFfP/AO0R/wAjD4T/AO2v/ocdfQFABRRRQAUUUUAFFFFABRRRQBxmjf8AI96h/wBtP/QhXZ1xmjf8j3qH/bT/ANCFdnXTiviXohsKKKK5hBTQQcgEZHWs6/1Lyj5MHzSngkc7f/r1RQ3WmSrLICVk%2b8M5z9fevLr5pTp1OWKbS%2bJrZGsaLaudDRUUMyTxLJGcqalr04yUkpR2ZlsFFFFMAooooAKKKKAGu6xozscKoyTWLZo2oai1y4%2bRDkA/oKm1e4OFtY%2bWcgsB%2bgq9Z24tbZYx16sfU15NT/a8Wqf2Ker830XyNl7kL9WWKKKK9YxCiiigArD8R6bFfWatIpOw9R1Ge9blMljWWJo26MMGsMTSdWk4xdn0fn0LpzcJKSPPbeXVPC7JPH%2b/sJDyP4c%2bh/umu403UbfVLNbm2YlScMp6qfQ1n6eqF7jT7lFdGzlWGQcdf8%2b1atpaQWNslvbRiOJeiissBiHXoKUvi2fqjpxNSM9173fuixRRRXYcYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAUdX0qz1zSLrS7%2bIS2t1GY5EPoe49COoPYgV8/eCNUvPhD8S7rwlrM3/EovZBsmbhQTxHMPQH7ren/Aa%2bj684%2bMPgIeMvDBubOLOr6eDJb7RzKv8Uf49R7j3NAHo9FeU/BLx9/wkvh86LqEudW01AuWPzTQjhW9yOFP4HvXq1ABXOeMfGukeCNIN/qk3zNkQW6YMkzeij%2bZ6D8qx/iL8TdL8B2JjJW61eVcwWanp/tOey/qe3cjzDwf8O9c%2bJusjxd44llFhKd0NuSUaZc5CqP4I%2bvue3XdQBT03R/FXx18QDVNXkew8O27kIEHyKO6RA/ec93PT8AtfQmh6FpvhzSYdM0m1S2tYhwqjlj3Zj1JPcmrlra29jaxWtpDHBbxKEjijXaqgdAAKmoAKKKKACiiigAryL4p/GCHw0JdD8PulxrbfJJKBuW1P8mf26Dv6Vj/ABR%2bMrRyS%2bHPCExkumPlz38XOzsUj9T/ALXbtzyPLdG0JbLFzc4kum555Cf/AF/euzB4Kpip2jt1ZUYORnt4fvdQhnvr64kfUJ2Mh8xslieTuJ7mvZPgv8RINRSPwn4gSMajCNtnPIozMo/5ZsT/ABjse49xzwtYet6S8rLqFiWS8iIbMZwTjkEY/iHavXxuUxjSUqG638/%2bCazp6aH2H9jtf%2bfaH/vgUfY7X/n2h/74FeafCT4ox%2bMrAaVqsix69bJznCi6UfxqP7w/iH4jjgeo187zPuYEP2O1/wCfaH/vgU6OGKLPlxomeu1QM1JRRdsArjPFH/I0aX/wD/0OuzrxL4u/ES00DW4bfTJIrrVYEG5QdywNuJG/36fL%2bdbYaahO8uzGj0Dx38QdH8B6Z598/nXkg/0eyjb55T6n%2b6vqT%2bp4r5m1fVdd%2bI2sf2prdwy2qkiGFOEjX%2b6g/mx5OO%2bKhjsdQ1/U5dZ8Q3EtxcztvIkPLemfQegFb4AVQqgADgAdq9bL8pc7VK607f5msKd9WRwQRW0KwwoEjXoBUlFFfSpJKyNwooopgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVzPh7/kN6l/vH/0I101cz4e/5Depf7x/9CNefi/94o%2br/IiXxI6aiiivQLCiiigAooooAKwrv/keNB/6%2bIf/AEaK3awrv/keNB/6%2bIf/AEaK8fPf9xmRPY%2bmKKKK/CDqCiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVmareNCqwRE%2bY/cdQKwxOIhh6bqT2RUYuTsia51K3tiVJLuP4V7fWqX9q3c3/HvbceuC1T2WlRxKHnAeQ84PIFaQAAwK4I0sbiFzVJ8ifRb/NmjdOOiVzHxrEv%2bwP8AgI/%2bvSf2VdTkG5uMj0yWraoq/wCyqUv4s5S9WL2zWySK1tZQ2i4jX5j1Y9TVmiivQp04U48sFZGbbbuwoooqxBRRRQAUUUUAFef6j/yE7v8A67P/AOhGvQK8/wBR/wCQnd/9dn/9CNd%2bB%2bJiZWooor0wCuI/Zl/5mn/t0/8Aa1dvXEfsy/8AM0/9un/tavOx/wBn5/oM%2bgKKKK84AooooAKKKKACiiigAooooAKKKKACiiigArwD4p/8nC%2bCv%2b3H/wBK3r3%2bvnHx/rOn61%2b0F4UfTrpLlLaeyt5Hj5UOLliQD0PDDkUAfR1FFFABRRRQAV8//s7/APIw%2bLP%2b2X/oclfQFfOPwF1rT9N8X69Z3l0kM96yJbh%2bBIwd8qD0zyMDvQB9HUUUUAFFFFABRRRQAUUUUAFFFFABXz78YNUvvGXxD0rwBpc7CFXT7QF6ea3JLDuETn8W9K9z1rVbfQtEvdVujiC0haZ/UgDOB7noK8Q%2bA%2blXOveJdc8cakN8ryNFEx6eY53OR9BtA9mNAHsXhXwppXg/RY9M0m3Eca8ySkfPM3dnPc/y6DityiigDkfG/wARdC8C2W%2b/m869dcw2URBkk9z/AHV9z74yeK8Ys9I8afHPVkv9UlbTvDsT5TAIjA9I1P329WPA5/3asfHPw0mheM9O8YJZpc2V1Kgu4JBlGlTHyt7Ogxj/AGW9a990S%2bsdT0OxvtN2CyngR4QgACqRwMDpjpjtQBW8NeF9I8JaSmm6ParBCOXbq8rf3mbuf8jArlvEvxm8I%2bGNZbS7ma6urmNts32SIOsJ7hiSOR3AzitT4leKf%2bEQ8C3%2bpRvtu2XyLX/rq/AP4DLf8BrzP4SfCrSdY8F3Gr%2bI7T7TPqoYQGQndDGCRvU9mJyc%2bgHqcgHtWjazp/iDS4dT0u6S5tJhlJE/UEdQR3BrQrwP9na6uLTUvEugyyM0cLJIo7K4ZkY/j8v/AHzXvlABRRRQAUUUUAFFFFABRRRQAUUUUAeP/tHf8k80/wD7Csf/AKKlo8K/8ihov/XhB/6LWj9o7/knmn/9hWP/ANFS0eFf%2bRQ0X/rwg/8ARa134H4mJmvRRRXpgFek15tXpNedj/s/P9BhRRRXnAFFFFABXN%2bP4GuPh34jjTO46bOQAM5whOP0rpKrX9ol/p1zZyfcnieJsjPDAg/zoA8r/Z1nEnw8u4uN0WpSAj2McZB/n%2bVdf4p/5Ccf/XEf%2bhNXmP7OF49vN4j0WfKyxtHMIz2I3I//ALJXp3in/kJx/wDXEf8AoTV14L%2bKDMSiiivXEFeT%2bPo5PE/xI0HwujsImaNHI/hMjfMfwUA/nXrFea6Ivm/tO2qPyqkkD0xZkj9a48a7UvmB9HW8EVrbRW8EaxwxIEjReiqBgAfhUtFFeSMKKKKACiiigAooooAKKKKAPPvjRr76B8Nb8wvsnvmWzjYHpvzu/wDHA9Vfgf4Yj0H4fW168YF5qv8ApMrd9nSMfTbz9WNcp%2b0reFNM8P2W7iSaaUj/AHQoH/oZr2nSLMado1jYqu0W1vHCB6bVA/pQBdooooAKQ8/SlooA4/Wvhd4L152kvNBtlmbky2%2bYWJ9TsIyfrmsKL4C%2bBI5VdrK7lUdUe6cA/XGD%2btem0UAZui6BpPh2z%2byaRp9vZQ9SsKAFj6serH3NaVFFAHy/4lB0H9oDUDefLHdyZjc8AiRBtP8A318v5121dL8VPhlF480%2bK5s3jg1m0UiGR%2bFlTOdjHr1yQexJ9a8TfX/GPgv/AEHxFok7rFwJZlK5A9JBlWHvzQelgsXGknCex6PXIfDcHXvj82pWnz21oksjuOhUReSDn3LCsddR8bePD/Z%2bhaLPDBL8ryRqdoB/vSnAA/L8a9U8PWnhf4GeGnOt6lHLrF4BJMsI3SSY6JGvXaOeTjJJzjgAFjcXGqlCGx67TWYIpZiAoGSSeAK%2baPE/7Q2u37PD4etItMt%2b00oEsx9%2bflX6YP1ry7VvEmt69IX1bVby8JOds0zMo%2bi9B%2bAoPOPs278Z%2bF7AkXfiLSoWH8L3kYb8s5qp/wALH8F/9DRpX/gSv%2bNfFFFAH3FaeM/C9%2bQtp4i0qZj0VLyMt%2bWc1tqyuoZGDKRkEHINfAVaOl69q%2biyeZpeqXlk3/TvOyZ%2boB5oA%2b7qK%2bV/D/x/8WaUVj1NbbVoAefNXy5MegZePzU17J4U%2bNHhPxO6W8ly2mXrcCC8wqsf9l/un8cH2oA9EopOv0paACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPMvjroMesfDi4vAubjTZFuIyOu0kK4%2bmDn/AICK5n4c6m2p%2bB7B3bdLADbt/wABOB/47tr1Hx6iv8PPEoYZH9l3J59RExFeK/Bok%2bD7oE8C/fH/AH7jrswTaqWA9Dooor1hBXb6B/yBLf8A4F/6Ea4iu30D/kCW/wDwL/0I1xY7%2bGvX/MDSoooryhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFUtQv1soc8GVvur/U%2b1M0prp7cvctkMcpkc4/wq/Zvk52FzQoooqAOY1P/AJCM31H8hVSrep/8hGb6j%2bQqpX53i/8AeKnq/wAz0ofCgooornKCiiigAryLUf8Ak5HQ/wDeh/8AQTXrteRaj/ycjof%2b9D/6Ca9rIf8Aen6P9DDEfAfR9FFFfZHEFFFFABRRRQB8/wD7RH/Iw%2bE/%2b2v/AKHHX0BXz/8AtEf8jD4T/wC2v/ocdfQFABRRRQAUUUUAFFFFABRRRQBxmjf8j3qH/bT/ANCFdnXGaN/yPeof9tP/AEIV2JIUEk4A9a6cX8S9ENjqyL7UWZ/s9plnPBZf5CmXl9Jdy/ZbQEg8Fh3/APrVdsbBLNMnDSkct/QV8/Vr1MZJ0cM7RW8v0X%2bZqoqC5pb9iOw05bYCSTDTH/x2rssSTRtG4yrdakor0KOGpUqfsoLT8/UzlJt3Zggy6RdYOXgY/n/9etqORZUDoQVIyCKSeCO4iMcgyp/SsaKSXSbnypfmhY9f6ivNTll0%2bV60n/5K/wDL%2bvXX%2bKr9fzN6imqyuoZSCp5BHenV7CaaujAKKKKYBUc0qwRNI/3VGTUlY2qzNPOlnFycgt9a5Mbifq9FzW%2by829i4R5pWE0yJrq7e8lHQ8fX/wCtW1UVvCtvAkS9FH51LSwOG%2br0VF/E9X6sKkuaVwooorsICiiigAooooAxdUQ217FdoOp5%2bo/%2btWujiRFdeQwyKgv4PtNo6AfMOV%2boqto1x5lsYmPzRn9DXlU/9nxsqf2amq9Vv/mbP3qafYp6z4iOkajbQSWx8iTl5T6dPl%2bnGa3EdZEV0YMrDII6EVn65pSavprwHAlHzRN6N/gaxPB2qOVk0m5yJoM%2bWG64B5X8D/nivVNPZxnR54bx3/zOuooooOUKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPnf4oaDe/Dnx3ZePPD6bbWefM8a8Ksp%2b8p/2XGfxz7V0PjD48afb6Hap4WH2vVr6JWAZci1LdmH8T542/iewOT8VPianiQyeCPClqNTkunEU06p5gYgg7Yh3ORy3bHHqOm%2bF/wAHrTwksWra0sd1rZG5F%2b9Ha/7vq3%2b127epAMT4dfCC5vb0eKvHfmXV9O3mx2dwdxyejS56nphe3f0HuPT6UtFABRRRQAUUVWvr6102ymvb24jt7aFd0ksjBVUepNAE0sscMTyyuscaKWZ3OAoHJJPYV86/E34vXPiGeTw34SkcWbZS4vE4af1CH%2bFPU9/p1yviJ8UNR8f3raJoPmW%2biKfnY5Vrj/af0X0X8TzgDG0zS4NMg2RjdI335D1b/wCtXoYHL54qV3pHv/kXCDkQ6RosWmR7jh7hh8z%2bnsK1KKK%2bupUoUoKEFZI6UklZBRRRWozB1KyutNv4tc0eV4Lu3cS5i4IYfxD%2bor6D%2bHfxZ0vxboypqM8dprECgXEJ4En%2b2nse47H8CfGq5zUdPutJvl1jSXaOSNt7Kn8Pqcdx6ivnsyy1X9tTWnVL80Y1KfVH17/wkOkf8/8AD%2bdNbxHo6KWbUIAoGSSeleV%2bEPGXgjXPC02o6tONOvLNAbuB5jz6NGOrAnsOQePQnyvxX4suPGepPY6Dby2ekKcYkfLSD%2b9Ie3so/WvHjTozfLC7Zja56B8RvjbJcSSaD4KkZ3f5JdRQc%2b4i/wDi/rjs1eaaToK2z/arw%2bddsd3zHIU%2bvufermmaRb6ZFiMb5SPmkI5P09BV%2bvfwGVRo2qVdZfgv%2bCbwp21YUUUV7RqFFFFABRRRQAUVj32syW2sQWMUSyeZjdkkEEn/AArYrKnWhUlKMfs6MSaYUUUVqMKKKKACiiigAooooAKKKKACiiigAooooAK5nw9/yG9S/wB4/wDoRrpq5nw9/wAhvUv94/8AoRrz8X/vFH1f5ES%2bJHTUUUV6BYUUUUAFFFFABWFd/wDI8aD/ANfEP/o0Vu1hXf8AyPGg/wDXxD/6NFePnv8AuMyJ7H0xRRRX4QdQUUUUAOT76/Wuwrj0%2b%2bv1rsK%2bn4d2qfL9TlxPQKKKK%2blOUKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACsS3H2rW5JDysZJH4cCtusXReZrhuvT%2bteXjvfxFCm9m2/uRrT0jJm1RRRXqGQUUUUAFFFFABRRRQAUUUUAFFFFABXn%2bo/8hO7/wCuz/8AoRr0CvP9R/5Cd3/12f8A9CNd%2bB%2bJiZWooor0wCuI/Zl/5mn/ALdP/a1dvXEfsy/8zT/26f8AtavOx/2fn%2bgz6AooorzgCiiigAooooAKKKKACiiigAoopkkiQxtJK6oiDLMxwAO5JoAfRXl/ij46%2bFNAMkFgz6xdr/DakCIH3kPH4qGrhh4u%2bLvxEJGg6e2l6c/SaJPKXHr5r8n/AIB%2bVAHW/GrxncaXaQeG9NkZLm9TfcOh%2bZYicBR/vEHPsPevA9QtrjQrnTtVt2/f28qvu7K6kMv8q3tb8P6x4Y8VxWXiC8F5fMqytP5rSB9wOPmYAnB4/CrFzbR3du8Ey5RxgivYy/AQxNCbfxbLy6/jsawgpJn074c16z8TaBZ6xYOGguYw2M5KN3U%2b4OQfpWrXyJ4X8W%2bJPhjfyNZYu9KlbdLbyZ8tu2cjlGx3%2bmc4r1mx/aM8LT24a907U7WfA3IiJIufZtwJ/ECvLq0p0pcs1ZmbTWjPYqK8n/4aG8F/88tV/wDAdf8A4uqOp/tG%2bHILcnTdL1G7nxwsoSJPxOWP6VmI9B8eeKrfwd4QvdVmkUTBDHaoeskxB2gfjyfYGvknRtKkm06S7BYSs2U/2gP/AK/8q2dc1vxD8SNWS/1qTyrOPPkwINqRqeyA9Se7H%2bgFacUaQxLHGoVEGAB2Fe1luWuqnOsvdtp/ma06d9WezfB/xpN4m0CWw1CQyahp21TI3WWM/dY%2bpGCD%2bB6mvSa%2bSfCvhrxF4m1q9Hha/wDsN1bKZvOE7xZG7AUMoPJznnjiuuHxC%2bKfw%2bcR%2bKtIbULJTjzpUGCPaaPK5/3gTXjyXLJoyZ9EUV5z4W%2bNXhLxKyQS3LaXeNx5N7hVY/7L/dP44PtXooIYAg5B7ipAWiiigAooooAKKKa7rGjO7BUUZLMcAD1NAHi/7QviZrbRbHwxaMTc6jIJZkU8%2bUp%2bUY/2n/8AQDXo/gTw2vhLwXpmjhVE0UQacj%2bKVvmc578kgewFeLeElf4o/HS78QygvpeluJYQRwFQ4hHsSQXx7NX0ZQAUUUUAYHjLw1B4u8J3%2biz7QZ48xOf%2bWcg5Rvzxn2zXlvwD8TT251HwPqm6O7sZHkt0fqoDYkj/AAbn/gTele4189fF/TrrwN8RdJ8eaVHtjnkHnAcAyqMMp9A6cfgxoAm%2bPl7Prfirw54Os2/eSMsjL2MkjbEz9AG/76r3XT7GDTNNtbC1TZBbRLDGo7KoAH8q%2bfPBV0nxC/aEuvEEYdrG0Rp4g4x8qqIo%2bOxyQ2PrX0TNKsEEkz/cjUs30AzQB4H8Bzu%2bIHi515U55HT/AFrV9AV4F%2bzZG003ie%2bc/MxgXjoSTITx%2bVe%2b0AFFFFABRRRQAUUUUAFFFFABRRRQB4/%2b0d/yTzT/APsKx/8AoqWjwr/yKGi/9eEH/otaP2jv%2bSeaf/2FY/8A0VLR4V/5FDRf%2bvCD/wBFrXfgfiYma9FFFemAV6TXm1ek152P%2bz8/0GFFFFecAUUUUAFFFFAHzxpz/wDCDftL3Nu/yWeryMoPQET4dcf9tcLXrPin/kJx/wDXEf8AoTVwP7QnhuabS9P8V2QZbjTnEUzp1WNjlGz/ALL/APodbmneKIfGGhaXrEbKZZLZUuEX%2bCYEhxj68j2IrrwX8UGT0UUV64grzbQP%2bTobf/gX/pEa9JrzbQP%2bTobf/gX/AKRGuLHfw16/5gfSVFFFeUMKKKKACiiigAooooAKKKgvbuDT7G4vbqQR29vG0sjnoqqMk/kKAPAviox8T/HDw54djO5LcwpKB/CXfe5/74CmvoSvnv4OW8/jH4o6542u0IjiLmLP8LyZCqP92MEfiK%2bhKACiiigAooooAKKKKACiiigAoorwT41/FV7dp/CegXBWX7l/dRnlfWJT6/3j26etAGh8TvjdHo0k2i%2bFnjnv0yk96RuSA91UdGb36D3OcfOd7fXWo3kt3e3EtxcytukllYszH3JqvRQAUUUUAFFFFABRRRQAUUUUAd74J%2bLXiTwY8cCzm/0wYBs7liQo/wBhuqfy9q%2bl/BXxB0Lx1ZGXTZyl1GoM9nLgSR%2b%2bP4l9x%2bh4r4rq3pupXuj6hDf6dcyW13C26OWNsFT/AJ7UAfelFeafCz4qW3je0FhqBjt9dhXLxjhbhR/Gnv6jt16dPS6ACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5/wAd/wDJPPEv/YKuv/RTV4l8Gv8AkULv/r/f/wBFx17b47/5J54l/wCwVdf%2bimrxL4Nf8ihd/wDX%2b/8A6LjrrwX8UGeiUUUV64grt9A/5Alv/wAC/wDQjXEV2%2bgf8gS3/wCBf%2bhGuLHfw16/5gaVFFFeUMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmSFljYooZwOBnGTTsg5HeloAw7Kwlu7lrq9U4zwjdz9PStzpRRV1Kjm7sEgoooqAOY1P/kIzfUfyFVKt6n/yEZvqP5CqlfneL/3ip6v8z0ofCgooornKCiiigAryLUf%2bTkdD/wB6H/0E167XkWo/8nI6H/vQ/wDoJr2sh/3p%2bj/QwxHwH0fRRRX2RxBRRRQAUUUUAfP/AO0R/wAjD4T/AO2v/ocdfQFfP/7RH/Iw%2bE/%2b2v8A6HHX0BQAUUUUAFFFFABRRRQAUUVHLKkMZkkYKo7mlKSirvYDjtJZU8caizEBQJCSe3zCti4uptSm%2bz2wIi7n19z7VmW9jFc6xO8ZAlnZny3ULn0/KuptraO1iCRj6k9TXnYmtPM58tK8aS0b6y9PI30p6vcZaWcdpHtXlj95vWrVFFd9OlClFQgrJGLbbuwoooqxBUFzbJdQmNx9D6Gp6KmcIzi4yV0xptO6MK2uJdMuDb3H%2bqPQ%2bnuPattWDKCCCD0NQXdol3CUbgj7rehrNs7uSxmNrdZCdie3/wBavIpzlgJqlUd6b%2bF9vJ/1/wADZpVFzLc26KOtFeyYEF1cLbW7yt2HA9TWdpEDO73kvLMSFJ/U0y/dr6/S0jPyqeT79z%2bFbEcaxRqiDCqMCvJh/teLc/sU9F5y6/cbP3IW6sfRRRXrGIUUUUAFFFFABRRRQAVh/wDIP1n0jk/kf/r1uVmaxb%2bZaiUD5oz%2bhrzszpydJVYfFB3X6/ga0nrZ9TTqnHplnFfyXqW6C5k6yd%2bmOPSnWE/2mzRyfmHyt9RVqu2lUjVgpx2epHvRbQUVAl3byXDQJNG0qDLIGBIHuKnrQlprcKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPnHx/o158J/iNZ%2bMtDh/4ll3KTJCOFVz/rIj6Bhkr6c/3a9%2b0TWLLxBo1pq2nyiW1uow6N39wfQg5BHqKh8SeH7HxT4fvNG1BN1vcpt3DqjdVYe4ODXhvwx8QX/wAN/HF14D8RtstJ5sW8pPyJIfusp/uOMfQ46c0AfRFFFFABRRWF4r8W6T4N0V9T1afZGPljiXl5n7Ko7n9B3oAua3rmneHNJn1TVblLe0hGWdu57ADqSewFfL3jbx5rPxO1Q2tuHs9DhfKQZ6%2bjyY6t6DoPzNUvEnibXPifrf2q9Y22mQsfIt0OUiHoP7zHuf5DAq7bW0NpAsMCBEX07%2b5r1svyyVd%2b0qaR/M0hTvqyOxsINPtxDAuB3Y9WPqas0UV9XCEYRUYqyR0pWCiiiqAKKKKACiiikByevaAYy13Zp8h5kjUfd9x7VpeHb%2b0ns1t4kWGVB80Y/i/2h61tVzer6E6S/btNykqnc0acfiv%2bFeVVwzwtV4ihG6e6/wAv8jNx5XzI6SisTRtfS%2bxb3OI7kcDsH%2bnv7Vt16FCvCvDnpu6LTTV0FFFFbDCiiigAooqnq1x9l0q5lzghCB9TwP51FSahFyfQG7amBpH/ABMfE1xenlI8lT/46v6V1dYPhS38rTXmI5mfg%2bw4/nmt6uPLYNUFKW8tX8yKa0uFFFFd5YUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVzPh7/AJDepf7x/wDQjXTVzPh7/kN6l/vH/wBCNefi/wDeKPq/yIl8SOmooor0CwooooAKKKKACsK7/wCR40H/AK%2bIf/RordrCu/8AkeNB/wCviH/0aK8fPf8AcZkT2Ppiiiivwg6gooooAcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFY2jfLdXCnr/8AXrZrFsv3Wtzp/e3Y/PNeZjvdxFCfm196NafwyRtUUUV6ZkFFFFABRRRQAUUUUAFFFFABWZdazDA%2byIea2ecHgVDfi/uro20a7IcfeHQj3P8ASrVlpcFoA2N8v989vpW6jCK5p6%2bQi6rB0DAHBGeRiuB1H/kJ3f8A12f/ANCNegV5/qP/ACE7v/rs/wD6Ea6MD8TBlaiiivTAK4j9mX/maf8At0/9rV29cR%2bzL/zNP/bp/wC1q87H/Z%2bf6DPoCiiivOAKKKKACiiigAooooAKKoavrGn6Dpk2o6pdx2tpEMvI54%2bgHUn0A5rwPXviL4r%2bKWqv4e8D2lxbaf8A8tZwdkjL6yP0jX2HJ984oA9A8dfGfQfCLSWVoRqmqrkGGFx5cR/235wfYZPrivOoPD/xK%2bMEi3Os3baVobkMiOpSMjtsi6v7Fj9DXoPgL4K6H4UEd7qYTVNWGGEki/uoj/sKe/8AtHn0xXp9AHA%2bFPg/4S8K7JVsv7QvV5%2b03oDkH/ZXG1fbjPvXe9PpS0UAea/FvwFN4p0yLUtMj3apYqQIx1mj6lR7g5I%2bpHevCrPUwT5F2DHMh2ncMZI9fQ19f1xHjD4X6D4uZ7l0ay1Ej/j6gA%2bY/wC2vRv0PvXVhMXUw0%2baHzRUZOOx4TwRVV9MsZG3PZwEnv5YrptU%2bEPjPQ2Y6cYtSthyDA4DY90bHP0zXNXNp4m04lb7QL2LHd7Z1B/HGK96Gb4aqrVY2%2bVzZVYvcj/sjTv%2bfKD/AL4FSRadZQtujtIVbsQgyKqf2je/9A6X8j/hV6203xXqTBbLw/evk43C1fA%2bpPAq3mOAjql%2bA%2beCJSQASSAB1zWbcXsl5Mlhp0bz3EzBFEYyWJ7KO5rtNJ%2bDPi3WXV9Xnh02AnkSMJHx7IvH5kV6/wCEPh3oXg1RJZQme%2bIw13Pgv7heyj6fiTXn4vOJVIuFJWXfqRKrfRFP4YeCD4N8PMLsKdTvCJLkrzsA%2b6gPfGT%2bJNduyrIhR1DKwwQRkEU6ivEMTzbxX8E/CfiQPNbW50m9bkS2agIT/tR9D%2bG0%2b9ebvH8TPgy%2b5HOreHo%2bvWSFV9x96I/T5cnvX0jSEBlIIBB4IPegDgvA3xZ8PeNglskn2DVCObO4YZY9/Lbo/wCh9q76vIvHfwN0vXC%2bpeGymlaoDv8ALXIglb6D7h9xx7d65nwt8Wde8EaoPDXxCtbgpHgLduN0sY7EnpIn%2b0OevXpQB9B0VWsb611KyhvbK4juLaZd0csbBlYeoNWaACvM/jf4s/4RzwJLZwSbb7VSbaMA4Ijx%2b8b8vl/4EK9Mr5wvyfi78dEtEPnaFpZw391ooz85/wCBvxn0I9KAPS/gx4T/AOEY8BW8k8e2%2b1HF1PkYKgj5F/BcHHqxr0SkACgADAHYUtABRRRQAVz3jfwxD4w8I3%2bjS7RJKm6Bz/BKOUb8%2bvsTXQ0UAeJfs7%2bHptN07Xr%2b7haK4a6FkVcYKGIEsPzfH/Aa9O8b3n9n%2bBdfus4aPT5yp/2thA/XFbMFtBbCQQRJH5khkfaMbmPVj7muA%2bN%2boCx%2bFepqDh7p4oF59XBP/jqtQBg/s5WfleB9RuyMGfUGUe6qic/mzV7HXAfBaw%2bwfCrR8jDz%2bZO3vukbH/ju2u/oAKKKKACiiigAooooAKKKKACiiigDx/8AaO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtH7R3/JPNP/7Csf8A6Klo8K/8ihov/XhB/wCi1rvwPxMTNeiiivTAK9JrzavSa87H/Z%2bf6DCiiivOAKKKKACiiigCpqWn22rabc6fexCW2uY2ikQ91Iwa%2bYtOe7%2bE/j%2b78Pas7HS7hgUnIwCp%2b5KP5N9D6V9UV5b8W/CVv4sSOFiI7yGHdbTY%2b6ct8p/2Txn8D2ragpOfubgWFYMoZSCCMgjvS15B4Q8aXnhS9PhvxQkkUUR2RSyDJh9AT3T0Izj6dPXY5EljWSN1eNgGVlOQQehBr16VVVFpuIdXm2gf8nQ2/wDwL/0iNek15toH/J0Nv/wL/wBIjXPjv4a9f8wPpKiiivKGFFFFABRRRQAUUUUAFeKfHjxm0VlD4L0pmlv79lNysfLKhPyoMfxMcceg/wBqu1%2bI/wARbDwHoxdmSbVZ1ItLXPU/3m9FH69B7cB8HvA1/qurP8QfE%2b%2bW6uGMtmso5YnrKR2GOFH4jtQB6T8OvCKeC/BlnpRAN0R512w7ytjd%2bA4Uey11lFFABRRRQAUUUUAFFFFABRRRQBwHxa8c/wDCE%2bEna1kA1W%2bzDaDunHzSf8BBH4la%2bQnd5XaSRmZ2JLMxyST1JNdx8XPFjeK/Ht7JHJusrIm1tgOhVT8zfi2T9MelcJQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBa0/ULvStQt7%2bxneC6t3EkUiHBUivsb4c%2bN7fx14Wiv1Cx3sR8q8hH8EgHUf7J6j8R2r4vrvvhF4wbwj45tjNJt0%2b%2bItroE8AE/K//AWxz6Z9aAPsGiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5/wAd/wDJPPEv/YKuv/RTV4l8Gv8AkULv/r/f/wBFx17b47/5J54l/wCwVdf%2bimrxL4Nf8ihd/wDX%2b/8A6LjrrwX8UGeiUUUV64grt9A/5Alv/wAC/wDQjXEV2%2bgf8gS3/wCBf%2bhGuLHfw16/5gaVFFFeUMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKy9Q1VbcmGDDzdPZf/AK9aMieZGyZK7hjIPIqjYaVHaHzHPmS9mxwPpWlPkWsvuEyPS7O4jZ7i4kbdJ1Q/zNatFFTObm7sYUUUVIBRRRQBzGp/8hGb6j%2bQqpVvU/8AkIzfUfyFVK/O8X/vFT1f5npQ%2bFBRRRXOUFFFFABXkWo/8nI6H/vQ/wDoJr12vItR/wCTkdD/AN6H/wBBNe1kP%2b9P0f6GGI%2bA%2bj6KKK%2byOIKKKKACiiigD5//AGiP%2bRh8J/8AbX/0OOvoCvn/APaI/wCRh8J/9tf/AEOOvoCgAooooAKKKKACiioriXyIHk2ltozgVMpKMXJ7IFqJcXEdtEZJDgdvU1jqtxq8%2b5spAp/Af4mlht59Um86clYQeAP5D/GtpEWNAiKFUdAK8hRqZg%2baXu0u3WXr5G%2blLbf8jjtEG3xteoCdqK6rk9ACMV2lcZo3/I96h/20/wDQhXZ19DiIxi4xirJJGLCiiiucQUUUUAFFFFABVS%2bs0vIsHiRfutVuis6tKFWDhNXTGm07oxrC9e2k%2byXWVwcKT29vpV%2b/ufstszg/OeFHvUd/Yrdx5XAlUfKfX2rJijnvLmO2mLYi4Oewrw6lXE4OLwyXNfSD/R%2bh0JRm%2bf7zQ0e2KRG4cfPJ0z6VqU1VCqABgDgCnV7GFw8cPSVOPT8zCcnJ3YUUUV0EhRRRQAUUUUAFFFFABTXVXRkYZVhg06ik0mrMDF0xja30to569PqP/rVtVRnsBNepcCQoVxkAdSKvVw4CjUoQlSlsm7ehpUkpO6OGlH9iePFccQ3Ryfo/H/oVdzXL%2bL9JuNQS1ms4meaNip2nBwec/gR%2btdFbmVreIzLtlKDePQ45rvNsRJThCd9bWfyJqKKKDlCiiigAooooAKKKKACiiigAooooAKKKKACvL/jN8Pf%2bEt0D%2b1NOh3azp6lkCjmeLqye5HVffI716hRQB5f8GfiEPFugf2ZqE2dZ09ArljzNF0D%2b57H3we9eoV87/E/w3ffDnxpa%2bPfDa7LWabNxEo%2bWOQ/eBH9xxn6HPTiuy8QfHLQNP8HWup6ay3Wp30WYbItkwt0Pm46AHI/2scccgA6rx14%2b0nwHpX2m/fzbuQH7NZo2HlP9FHc/zPFfMmo6hrXxB1ttZ12dvJ6RRrwiLn7iDsPU9T7mozHqfizVpdd8Q3Ek8kx3BW7jsAP4VHYCt4AKoVQABwAO1e7l2VudqtZadF3NoU76sbHEkMSxxqERRgADgU6iivpUklZG4UUUUwCiiigAooooAKKKKACiiigDE1jQI77NxbYjuep7B/r7%2b9U9O1%2bW0l%2bx6qGUqcCQjkfX1%2btdPVPUNMttSi2zLhh9116ivOrYSUZ%2b2w7tLquj9SHHW8S2jrIgdGDKeQQcg0tVrCyj0%2bzS3jJIXq3qe5qzXdBycU5KzLQUUUVYBXPeLZ9tlDADzI%2b4/Qf/AKxXQ1yuq/6d4qtrXqse0MP/AB4/pXn5nJrDuC3k0vvIqbWOisLf7LYQQY5RAD9e/wCtWKKK7oRUYqK6FrQKKKKoAooooAKKKKACiiigAooooAKKKKACiiigArmfD3/Ib1L/AHj/AOhGumrmfD3/ACG9S/3j/wChGvPxf%2b8UfV/kRL4kdNRRRXoFhRRRQAUUUUAFYV3/AMjxoP8A18Q/%2bjRW7WFd/wDI8aD/ANfEP/o0V4%2be/wC4zInsfTFFFFfhB1BRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKxbn9xr0UnZ8frxW1UT28Urq7xqzL0JGcVx43DyrwiouzTT%2b4uEuV6ktFFFdhAUUUUAFFFFABRSdKxb3VXmf7NYgsx4Lj%2bn%2bNXCm5uyBs1Bdwm5%2bziQebjO2p6y9P0pbYiab55uvsv/ANf3rUomop2i7iQUUUVAwrz/AFH/AJCd3/12f/0I16BXn%2bo/8hO7/wCuz/8AoRrvwPxMTK1FFFemAVxH7Mv/ADNP/bp/7Wrt64f9mlhHP4ogfiTFsdv0MoP8xXnY/wCz8/0GfQNFFFecAUUUUAFFFFABXO%2bMPGek%2bCdGbUdUm5PywwJzJM3oo/megqPxv430vwLojX%2boNvmfK21qrYeZ/QegHc9vqQD4t4S8G618YPED%2bLfFskkekBsQxLlRKAf9XH/djHdupOe%2bSACDT9I8WfHXXhqeqyvYeHYHwgXOxRnlYwfvP6sen5LX0B4e8N6V4W0qPTdHtEt4E645Z2/vMerH3rQtLS3sbSK1tII4LeJQscUahVUDsAOlTUAFR%2bdEW2%2bYm703DNY2rXrtMbeNiqL97Hc1lV4GLzyNGq6dON7b6nRDD8yu2dlRWLpF65k%2bzSMSCPkJ7e1bVerg8XDFUlUh/TMpwcHZhRRRXUQFFFFABRRRQAUUUUAFR%2bdEW2%2bYm703DNY2rXrtKbeNiEXhsdzWVXgYvPI0arp043tu7nRDDuSu2dlRWLpF65k%2bzyMWBGUJ7e1bVerg8XDFUlUgZTg4OzCuf8WeDtG8Z6U1jq9sHxnyp0wJIT6q3b6dD3roKK6iD5oSTxb8BvEAjk3aj4aupO2RHJ9P%2becmO3fHcDj6A8N%2bJdL8V6NDqmk3Imt5Oqnh427qw7Ef/q4q1qmlWOt6bPp2pW0dzaTrtkikGQf8D6EdK%2bd9X0XxB8CvFK6zozyXnh65YJIrnhh/zzkx0Yc7Wx/UUAeq/GDxh/wiXga4%2bzybdQv821tg8rkfO4%2bi9/Uisv4FeDz4e8GDVbmPbfattmORysI/1Y/HJb/gQ9K86nvH%2bOHxasYoo5o9Cs4ld0k4KxDBfODgMzELx7elfS6IsaKiKFRRgKowAPQUAOooooAKKKKACiiigArw/wDaS1HyvD2i6YG5uLp5yPaNdv8A7Ur3Cvnz4qZ8R/HLwzoC/NFD5CyL6bpC7n/vgLQB7f4b07%2bx/DGlabjBtbSKE/VUAP61qUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4/8AtHf8k80//sKx/wDoqWjwr/yKGi/9eEH/AKLWk/aOZR4A09SRuOqRkD2EUv8AiKd4WBHhHRQRgiwg4P8A1zWu/AfExM1qKKK9MAr0mvNq9Jrzsf8AZ%2bf6DCiiivOAKKKKACiiigArkfFP/ITj/wCuI/8AQmrrq5HxT/yE4/8AriP/AEJq68F/FBnDeKPCOm%2bKrMRXibLhB%2b6uEHzp/iPY15okvi/4YTFHT7do27g8mPHsesZ/TPrXtNI6LIjI6hkYYZSMgj0NehUoqT5k7PuI5PQfiN4f1wJGbkWd0f8Aljcnbz7N0P559qw/D5B/agtiOR83/pEa0dd%2bFugauzzWyNp1w3O63HyE%2b6Hj8sV5tp%2bi%2bJPD3xNj0vw3P5%2buWxJt5ECDcDCWPD/L9wsMH8K48U6vIlNddwPsqivnwfFn4neHQE1/wn5yKcGZ7SSIt/wNcp%2bQq3a/tK2hGLzwzPGR18q7D8/io964BnvFFeNR/tH%2bFy373SdYVcdVSJjn/vsU2T9pDw0C3laPqzD%2bHcI1z9cOaAPZ6K8Guf2lISQlj4XmkZjhfNuwvP0CHP51U/4Wf8V/EY2aH4W%2bzRuPlmSydsf8DkOz9KAPf554bWB57iVIYUG55JGCqo9STwK8f8bfHjTtP3ad4TQapqLnYLjaTCjHj5R1kPpjj3PSuej%2bEvxE8azrP4z8QG3g3bjC8vnMv%2b7GhEa/gfwr1Pwf8MPDPgvbLYWhnvgMG8uiHk/4DxhfwA980AedeBvhHqmvav8A8JX8QnlmuJGEiWU5yznsZR0Cjsg9gcAYPu4AVQAAAOAB2paKACiiigAooooAKKKKACiiigArmviBrp8N%2bA9Z1RG2zRW5WE%2bkjfIh/wC%2bmFdLXj37Reom28DWNirYN3fKWHqiKxP6laAPmGiiigAooooAKKKKACiiigDs/BPw/vvHOl65LpzD7Xp0cTxRNwJixbKZ7HCnHvx3yOQlikgmeGVGSRGKujDBUjggj1r6m%2bAWgNpPw%2b%2b3yptm1Odphkc%2bWvyr/Jj/AMCqP4q/CCDxYkus6IqQa2oy8ZIVLoD19H9D36H1AB8s0VPeWdzp95LaXkEkFzCxWSKRSrKR2INQUAFFFFABRRRQB9q/DfXm8SfD7R9SkYtOYBFMxPJkQlGJ%2bpXP411VeNfs437TeC9SsmOfs18WX2V0Xj81P517LQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAc/47/wCSeeJf%2bwVdf%2bimrxL4Nf8AIoXf/X%2b//ouOvbfHf/JPPEv/AGCrr/0U1eJfBr/kULv/AK/3/wDRcddeC/igz0SiiivXEFdLourJb2cVvMu1BnDj3JPNc1XX6VZw3ehW6ypk/Nhh1HzGuXFuKguba4GwjrIgZGDKehBp1YS2N/YTr9lffGzY56fiP61u9q8ucFHZ3QIKKKKzGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUx3SJGd2VUUZZmOAB71w/wAQPijo/gODyZP9M1V13RWcbYIHZnP8I/U9hXk9t4f%2bI3xkkW91a8OmaG5DRqwKxEeqRA5f/eY/Q0Aesa18YfBGhs0cmspdzL/yzslM2f8AgQ%2bX9a5K5/aQ8ORti10bVJRnrJ5afyY1taD8CPBmkIrXlvPqk4xl7qQhc%2byLgY%2bua7S18I%2bG7FQtr4f0uEAY/d2kYP54oA8pP7SmkY48P32feZKZF%2b0npgT97oF4Wz/DKuMV7H/YWj/9Aqx/8B0/wo/sLR/%2bgVY/%2bA6f4UAeP/8ADSmj/wDQv33/AH%2bSj/hpTR/%2bhfvv%2b/yV7B/YWj/9Aqx/8B0/wo/sLR/%2bgVY/%2bA6f4UAeP/8ADSmj/wDQv33/AH%2bSj/hpTR/%2bhfvv%2b/yV7B/YWj/9Aqx/8B0/wo/sLR/%2bgVY/%2bA6f4UAeP/8ADSmj/wDQv33/AH%2bSj/hpTR/%2bhfvv%2b/yV7B/YWj/9Aqx/8B0/wo/sLR/%2bgVY/%2bA6f4UAeP/8ADSmj/wDQv33/AH%2bSj/hpTR/%2bhfvv%2b/yV7B/YWj/9Aqx/8B0/wo/sLR/%2bgVY/%2bA6f4UAeFXfx90u4uXlGiXgDdjKtQ/8AC99M/wCgLd/9/Fr3v%2bwtH/6BVj/4Dp/hR/YWj/8AQKsf/AdP8K8yeUYScnOUdX5s1VaaVjwT/he%2bmf8AQFu/%2b/i0f8L30z/oC3f/AH8Wve/7C0f/AKBVj/4Dp/hR/YWj/wDQKsf/AAHT/Cp/sXB/y/ix%2b3n3PBP%2bF76Z/wBAW7/7%2bLR/wvfTP%2bgLd/8Afxa97/sLR/8AoFWP/gOn%2bFH9haP/ANAqx/8AAdP8KP7Fwf8AL%2bLD28%2b54J/wvfTP%2bgLd/wDfxa4u6%2bIFrP8AFGw8WixmEFsULQFhubaCOD0719X/ANhaP/0CrH/wHT/Cj%2bwtH/6BVj/4Dp/hW%2bHy7D4efPTVn6kyqykrM8f/AOGlNH/6F%2b%2b/7/JR/wANKaP/ANC/ff8Af5K9g/sLR/8AoFWP/gOn%2bFH9haP/ANAqx/8AAdP8K7jM8f8A%2bGlNH/6F%2b%2b/7/JR/w0po/wD0L99/3%2bSvYP7C0f8A6BVj/wCA6f4Uf2Fo/wD0CrH/AMB0/wAKAPH/APhpTR/%2bhfvv%2b/yVNb/tI%2bHmb/SdF1ONfWMxuf1YV61/YWj/APQKsf8AwHT/AAqvc%2bFPDt4u260HS5hjGJLONv5igD5x%2bLHjzQ/G%2breHbjSJJttqXEyzx7CmWTHt2PQ19RQzRXEKTQSJJE4yrowYMPUEV51rnwO8E6wjGCyl0yc9JLOQgZ/3GyuPoBXnF54M%2bIfwklfUvDmoPqOkod0kcall29zJDz/30p49RQB9IUV518PPi3pPjlVsplFhrAXJtnbKy%2bpjPf6Hke%2bM16LQAUUUUAFFFFADQAowBgCnUUUJWA4zRv8Ake9Q/wC2n/oQrs64Sa01uz8Q3l7Y2btvdgrFcgqTVj%2b0fF3/AD5/%2bQh/jXfWpe0akpLZdRnZ0Vxn9o%2bLv%2bfP/wAhD/Gj%2b0fF3/Pn/wCQh/jWP1WX8y%2b8LHZ0Vxn9o%2bLv%2bfP/AMhD/Gj%2b0fF3/Pn/AOQh/jR9Vl/MvvCx2dFcZ/aPi7/nz/8AIQ/xo/tHxd/z5/8AkIf40fVZfzL7wsdnRXGf2j4u/wCfP/yEP8aP7R8Xf8%2bf/kIf40fVZfzL7wsdnTBGocuFG4jBPrXH/wBo%2bLv%2bfP8A8hD/ABo/tHxd/wA%2bf/kIf40nhG95L7wsdnRXGf2j4u/58/8AyEP8aP7R8Xf8%2bf8A5CH%2bNP6rL%2bZfeFjs6K4z%2b0fF3/Pn/wCQh/jR/aPi7/nz/wDIQ/xo%2bqy/mX3hY7OiuM/tHxd/z5/%2bQh/jR/aPi7/nz/8AIQ/xo%2bqy/mX3hY7OiuM/tHxd/wA%2bf/kIf40f2j4u/wCfP/yEP8aPqsv5l94WOzorjP7R8Xf8%2bf8A5CH%2bNH9o%2bLv%2bfP8A8hD/ABo%2bqy/mX3hY7OiuM/tHxd/z5/8AkIf40f2j4u/58/8AyEP8aPqsv5l94WOzorjP7R8Xf8%2bf/kIf40f2j4u/58//ACEP8aPqsv5l94WOzorjP7R8Xf8APn/5CH%2bNVLfxF4hu55IIIkeWPO9RGMjBxR9Wa%2b0vvKUJNNrod9RXGf2j4u/58/8AyEP8aP7R8Xf8%2bf8A5CH%2bNH1WX8y%2b8mx0Gr6xFo4geeNmjlcqWXqvvjvVu0vbe%2bhE1tMkqHup6fUdq8%2b1651meCIapB5aBjsOzGTWZYXV5aXSvZPIsxOAE53e2O9dKwKlTvfX8AseuUVQ0qa/mslfUIEhm9FPUepHar9edJWdhBRRRSAKKKKACiiigAooooAKKKKAKWq6XZ61pVzpmoQrNaXMZjkRu4P8iOoPY4r5A8S%2bE38A%2bOG03U0M1pnfbTkcSRk/K2PUdCPUGvsyuM%2bJPgS38d%2bGXtPkj1G3zJZTn%2bF8fdJ/ut0P4HnFXTm4SUl0BOzueCAggEEEEcEUtYGi3dzY3c2ianG8N3bO0eyTgqRwUP0rfr7jC4iOIpqpH/hjsjLmVwoooroGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyui/6b4lu7s8qu4qfqcD9M10d9N9nsZ5s4KRsR9ccVh%2bEIdtnPP3dwv5D/69ebivfxVKn2u/u2IlrJI6OiiivSLCiiigAooooAKKKKACiiigAooooAKKKKACiiigArmfD3/Ib1L/AHj/AOhGumrmfD3/ACG9S/3j/wChGvPxf%2b8UfV/kRL4kdNRRRXoFhRRRQAUUUUAFYV3/AMjxoP8A18Q/%2bjRW7WFd/wDI8aD/ANfEP/o0V4%2be/wC4zInsfTFFFFfhB1BRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKjmmjt4jJI21R3rOsdQnvL19sX%2bjgdf7tXGEmnLoguatQQ2kFu7vFGFZzkmp6Km72AKKKKQBRRRQAV5/qP/ITu/wDrs/8A6Ea9Arz/AFH/AJCd3/12f/0I134H4mJlaiiivTAK82%2bG94vhD446hpE52W%2bpb4Y88DLESR//ABP1avSa82%2bKfh64litvEum71vLDHmFPvBAcq491P6H2rkxlNzp3XQD6Sorifhp4/tPHfh2OYuiarbqFvLcHkN/fA/ut1HpyO1dtXkDCiiigArF8VeJ9O8IaBcavqcm2KIYRB96Vz0RR6n/E9BWpdXUFlaTXV1KkUEKGSSRzgKoGSSa%2bb7iTU/jv8Rfs8LzW/hrTznPTZHnG708x8cDsPoaAJfCnhvV/jP4vl8U%2bJC8eiQSbY4QThwDkQp/sj%2bJupz6nj6MggitYI4II0ihjUIiIoVVUDAAA6CodN02z0jTbfT7CBYLS3QJFGvRQP89at0AFFFFAHMalG0d/LkcMdw9waqV1N1ZxXaASAgjow6is/wDsL5ubj5f9z/69fIY3J8R7ZypK6bvuv1O2nXjy2ZU0mNnv0IHCZJrpKr21rFax7Ix16k9TVivfyzBvCUOST1buzmqz55XQUUUV6BmFFFFABRRRQAUUUUAcxqUbR38uRwx3D3BqpXU3VnFdoBICCOjDqKz/AOwvm5uPl/3P/r18hjcmxHtnKkrpu%2b6/U7adePLZlTSY2e/Rh0TJJrpKr21rFax7Ix16k9TVivfyzBvCUOST1buzmqz55XQUUUV6BmFeYfHHxXb6B4Gm0zbHLe6sDBHG4DbUGN74PpwB7kHtXpVxcQ2ltLc3EixQQoZJJHOAqgZJJ9MV8i%2bJdel%2bI3j251STf/Z0P7u3jb%2bGIE7R9WOWP1NaUaUqs1TjuxpXdj1L4AT%2bF9P8PyRx6taHX72TM8DtskVRkIihsbuMsdueW9q9tr4g8RafZWMkItVZZZCSUDZAH8%2btdVonjv4geDlQQ3r31mo/497nM6Aen95fwIFbVcHVpzlC1%2bXe2o3Fp2PrWivGfDf7Q%2bhX22DX7KbS5uhljzNF9Tgbh9MH616vpWs6ZrlqLrSr%2b2vYP78EgcD2OOh9jXKSX6KKKACiiigAr578E48U/tIa3rB%2beKxM7I3YhQIE/Q5/CvcPEWqjQ/DWp6qcf6JayTAHuVUkD8TgV5D%2bzfpTLpOt63KCWubhLdWPX5BuY/iXH/fNAHuVFFFABRRRQAUUUUAFFFFABRRRQAUUVg%2bL/FeneDfD1xq2ouMINsUQPzTSdkX/ADwMntQB4z%2b0Dqbax4m0HwrZtumQ%2bZIB03yEKgP0AJ/4FXbW0CWtrFbxDEcSBFHoAMCvL/h/YX3inxVfeN9ZG5pJGMOehc8Hbn%2bFV%2bUf/Wr1WvVwVNxhzPqIKKKK7QCvSa82r0mvOx/2fn%2bgwooorzgCiiigAooooAK5HxT/AMhOP/riP/Qmrrq5HxT/AMhOP/riP/QmrrwX8UGYlFFFeuIK820D/k6G3/4F/wCkRr0mvNtA/wCTobf/AIF/6RGuLHfw16/5gfSVVbnTbG9Obqytpz/01iVv5irVFeUMxJPBvheZdsvhvR5FBzhrGIjP/fNLH4Q8MwqFi8O6TGq9AtlGMf8AjtbVFAFe3sbSz/49rWCD/rlGF/lViiigAooooAKKKKACiiigAooooAKKKKACiiigAr5%2b/aXny3hq3BPAuXYdv%2bWYH9a%2bga%2bfP2mISJ/Dc/JDLcp06YMZ6/j%2blAHgdFFFABRRRQAUUUUAFavhrQrjxN4jsNGtQfNu5gm4DOxerN9AAT%2bFZVfSfwG%2bH8mlWLeKtThKXd2myzjccpEer%2bxbt7f71AHsljZQabp9tY2qBLe2iWGJB/CqjAH5CrFFFAHGeOvhpoXju2zeRm21BFxFfQj519mHRl9j%2bBGa%2bZPGXwz8R%2bCZma%2btDPYZwl9bgtER23d0PsfwzX2dTXRZEZHUMjDBVhkEehoA%2bAqK%2btvEvwQ8H6%2bzzwW0mlXLZO%2byIVCfeMgr%2bWK8x1b9nHxDbOzaVqthexjoJQ0Ln8MMP1oA8Xortb/4SeO9OJEvh25lHY27LNn/AL4JNc5eaBrGm3cFrf6Ve2dxcECGO5gaIvk44DAZ5oA93/ZqjYaX4gkI%2bVp4VB9wrZ/mK92riPhX4Ol8FeCYLG7VV1Cd2uLoKdwV2wAufZQo9M5xXb0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHP%2bO/8AknniX/sFXX/opq8S%2bDX/ACKF3/1/v/6Ljr23x3/yTzxL/wBgq6/9FNXiXwa/5FC7/wCv9/8A0XHXXgv4oM9Eooor1xBXb6B/yBLf/gX/AKEa4iu30D/kCW//AAL/ANCNcWO/hr1/zA0qKKK8oZUv55re23wRl3yO2cCqttrcEmFmBib16itWqlzp1tdZLxgN/eXg1rB07WmvmLUso6yKGRgynoQcinVn2GmixmkcSlwwwBjGK0KiSSdou6GFFQy3UELqksqozDI3HFSqwYZUgg9xSs0AtFFFIAooooAKKKKACiiigAooooAKKKKACiiigAooqCa8t7f/AFsyKfTPP5U0m9EBPXnvxV%2bI8XgTRBHaFJNZuwRbRnkRjvIw9B2Hc%2bwNdveala2OlT6ncShLSCFp5H9EUZJ/Kvnv4f6VcfFn4mX/AIt1uMtptlIGjgflSf8AlnF6EKBuPqcZ%2b9SA2vhf8KH1GRfGHjRXu7y5bz4bW45znkSSZ6k9lPGOvoPdOn0paKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8X%2bKPwiW68zxP4Tja11aA%2bdJbW/wAvnEc70x0k78dfr12vhF8TB4z01tN1N1XXbNMycY89BxvA9egI9cHvgenV87fFnQLn4feONP8AHegIIop7jMyAfKs3JYH/AGZF3Z993qKAPomis/RNXttf0Sy1azObe7hWVM9Rkcg%2b4OQfpWhQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVzWmaJd2Xii8viEFtNvx83PzEHp9RXS0UGkKkoJpdQooooMzF1/RpNZS2iWVY0RyzsRk4x2FWNM0Wy0pP8AR4syYw0rcsf8PwrSorT2s%2bTkvoAUUUVmAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4p8cPhy2o2zeLtGiI1C1UG8jQcyxr0kH%2b0o6%2bo/3efKtE1VdStBuIE8fEg9fevr88/SvmD4seApfAniBfEOixY0e7kw0ajiCQ8lD/snqPTp2Ge/L8a8LUu/he5cJcrKVFQWd3FfWqTwnKt2PUHuDU9fZRkpJSjszqWoUUUVQBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBk%2bJZvK0WUdDIVQfnn%2bQNP8PxeVoluO7AsfxP%2bGKzvGEuLe1h/vOW/If8A1637aLyLSGL%2b4ir%2bQxXm0/fx03/LFL79SFrNktFFFekWFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXM%2bHv%2bQ3qX%2b8f/AEI101cz4e/5Depf7x/9CNefi/8AeKPq/wAiJfEjpqKKK9AsKKKKACiiigArCu/%2bR40H/r4h/wDRordrCu/%2bR40H/r4h/wDRorx89/3GZE9j6Yooor8IOoKKKKAHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHPyR3eq3xjkUxRRnken%2bJrchhjt4hHGoVR2qSitJ1HJJbJCsFFFFZjCiiigAooooAK8/1H/kJ3f/AF2f/wBCNegV5/qP/ITu/wDrs/8A6Ea78D8TEytRRRXpgFIyq6lWAZSMEEcEUtFAHk%2bueEta8E64PE3g2SRVQlngjG4xg9Rt/jT27fhkejeDfjzoGtxx22vY0i/6FmyYHPqG6r9G6eprSrmNe8AeH/EDtNcWnkXLcme3OxifUjofqRXBWwV3eAHtFpe2moW4nsrqG5hbpJDIHU/iOKsV8vv8Hrq0mMuleIXiPbdGVYf8CVv6Uv8AwrPxT/0Nkn/f2X/GuR4WqugzpPjN4uvfEOuW3w88OlpppZVW88s/ffqsefRfvN%2bHoa9W8DeDrLwR4Zg0q1w8v37mfHM0p6t9OwHYAV89x/CHWork3MevRJcEk%2baocNk9TnrVr/hWfin/AKGyT/v7L/jS%2bq1ewH0/RXzB/wAKz8U/9DZJ/wB/Zf8AGj/hWfin/obJP%2b/sv%2bNH1Wr2A%2bn6K%2bYP%2bFZ%2bKf8AobJP%2b/sv%2bNH/AArPxT/0Nkn/AH9l/wAaPqtXsB9P0V8wf8Kz8U/9DZJ/39l/xo/4Vn4p/wChsk/7%2by/40fVavYD6for5g/4Vn4p/6GyT/v7L/jR/wrPxT/0Nkn/f2X/Gj6rV7AfT9FfMH/Cs/FP/AENkn/f2X/Gj/hWfin/obJP%2b/sv%2bNH1Wr2A%2bn6K%2bYP8AhWfin/obJP8Av7L/AI0f8Kz8U/8AQ2Sf9/Zf8aPqtXsB9P0V8wf8Kz8U/wDQ2Sf9/Zf8aP8AhWfin/obJP8Av7L/AI0fVavYD6for5g/4Vn4p/6GyT/v7L/jR/wrPxT/ANDZJ/39l/xo%2bq1ewH0/RXzB/wAKz8U/9DZJ/wB/Zf8AGj/hWfin/obJP%2b/sv%2bNH1Wr2A%2bn6K%2bYP%2bFZ%2bKf8AobJP%2b/sv%2bNH/AArPxT/0Nkn/AH9l/wAaPqtXsB9P0V8wf8Kz8U/9DZJ/39l/xo/4Vn4p/wChsk/7%2by/40fVavYDrvj544a2tI/B2myE3V2A97sPKx/wx/VjyfYDs1ea6VYLptgkXG/70jeprRk%2bD2rzTmeXXIHmJyZGVyx/Gg/B/WCMHXYcfR69DASlhZObp3fqXCajqcfZj%2b2vEz3J5ghO5foPu/rz%2bddLfXIs7Ga4P8CkjPc9v1qynwb1WPOzWrdc9dqMM0rfB3V3Xa%2btwMPQq5rooYurSpyXJeUru9%2bo41LI5HQNIhv7See8QvvbCnJBGOp/X9Klnsbzwy39p6RqtxayRkYaNyj89gV611K/B3V0UKuuQKB2CuKH%2bDmrSDD63Aw9CrmudqLoKm6PvW3v1FzRtaxe8OfHzxRpMUQ1yzj1W0bgTFfJlPbhgNpx7jPvXr3hr4x%2bDvEmyMaj/AGfdN/ywvsR8%2bzZ2n88%2b1eJf8Kc1XZ5f9t2%2bz%2b7tbFM/4UrqP/QXtf8Av21cLwtTpEg%2brgQygggg8gjvS18uw/C3xJbwrFB4nMUa8KiPIoH0ANP/AOFZ%2bKf%2bhsk/7%2by/41P1Wr2A9P8Aj3rP9mfDWW0VsS6jcRwAA87Qd7H6fIB/wKtr4S6P/Ynwy0WBl2yzxfapMjkmQlhn/gJUfhXh9z8JtevVVbvxEs4XlRKXbH5mpl%2bGPidVCr4rdVAwAJJcAfnR9Vq9gPqCivmD/hWfin/obJP%2b/sv%2bNH/Cs/FP/Q2Sf9/Zf8aPqtXsB9P0V8wf8Kz8U/8AQ2Sf9/Zf8aP%2bFZ%2bKf%2bhsk/7%2by/40fVavYD6for5g/wCFZ%2bKf%2bhsk/wC/sv8AjR/wrPxT/wBDZJ/39l/xo%2bq1ewH0/RXzB/wrPxT/ANDZJ/39l/xo/wCFZ%2bKf%2bhsk/wC/sv8AjR9Vq9gPp%2bo5poreJpZpEjiUZZ3YAKPcmvmT/hWfin/obJP%2b/sv%2bNNPwi1O%2bkB1PxK0qr0%2bRpD/483FP6rV7Aer%2bLfjZ4V8NxSRWVyur34GFhtHzGD/tScqB9Mn2ryOHT/E3xY1xNa8RyPb6Uh/dRqCqhf7sSn1xyx/XFdZonwz8O6M6zNbte3C8h7ohgD7KBj8wa7EAAAAV00cFZ3qfcIhtbWCxtIrW1iWKCJQiIo4UCpqKK9AAooopgFek15tXpNedj/s/P9BhRRRXnAFFFFABRRRQAVyPin/kJx/9cR/6E1ddXI%2bKf%2bQnH/1xH/oTV14L%2bKDMSiiivXEFebaB/wAnQ2//AAL/ANIjXpNebaB/ydDb/wDAv/SI1xY7%2bGvX/MD6SoooryhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeNftG6abjwZp2oKpJtL3axHZXU5P5qv517LXhnjnxHqXxO1%2bbwB4SSJrCNgdRv5ACnysDweyhgORyx6cdQD5zq5BpOo3MQlt9PupYz0eOFmB/ECvrbwf8I/C3hKCN/sceoagB815doGOf9lTkJ%2bHPua7zp9KAPgae2ntZTHcQyQyDqsilT%2bRqKvvLUtJ07WLU22pWNveQH/lnPGHH4Zrwf4k/ApLS2m1jwikjLGC8umkljjuYyeT/ALpyfT0oA8FpQCxAAyT2FdR4T%2bH3iPxpOF0mxb7NnD3c2UhX1%2bbufYZNfRvgP4N6F4OMd7dY1PVlwRcSp8kR/wCma9j/ALRyfTFAHAfCv4KS3EkGu%2bLLZo4FIe30%2bQYaQ9mlHYf7PU9%2bOD9D9PpS0UAJ0FVLbVNPvZnhtL61nlj%2b%2bkUysy/UA8V5P%2b0H4gv9M0HTNLtJXih1F5TcMhwWVAuE%2bhL5P%2b7XzxY311pt7FeWVxJb3MLBo5Y2wyn2NAH3XRWZ4c1GXV/DGk6lOgWW7s4Z3UdAzoGOPxNadACAgjIII9qWuT8L61517d6dM2T5ryQnPUZJIH8/zqf4gahfaX4B1q900ut3FbMUdOqdAWH0BJ/Cg0q0pUpcrNoanYG%2b%2bwi%2btvteM%2bR5q%2bZ/3znNeF/Hf/kofhD/AID/AOjRXh4nmW5FwJZBOH3iUMdwbOd2euc969R8f395ql38N77UCTdz2kTyMRgsfMX5vxGD%2bNBmfT1FFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBz/jv/knniX/ALBV1/6KavEvg1/yKF3/ANf7/wDouOvbfHf/ACTzxL/2Crr/ANFNXiXwa/5FC7/6/wB//RcddeC/igz0SiiivXEFdvoH/IEt/wDgX/oRriK7fQP%2bQJb/APAv/QjXFjv4a9f8wNKiiivKGFFFFABRRRQBSu9NgvW3ybg4GAyms86NdQMWtbnHtkqf0rdorWNacVZPQVipYLdLARdtl93HTp%2bFW6KKzk7u4ynPqVtbzGKVyrAZ%2b6TTl1CzfpcR/i2P50T2FrcOXliDMe%2bSDVV9CtG6GRfo3%2bNaR9k1re4tTSR1kXcjBh6g5p1V7S1WzgESMWAJOTVis3a%2bgworKvNNuLm5aSO42KQPlyag/sW6/wCfz9TWqpwa1kK5uUVWsrd7a2EcknmMCTmrNZNJOyGQyXMERIkmjUjsWANV31eyT/ltu/3QTTbjSILm4aaRpMnGQCMfypU0eyTrEW/3mNaJUrati1LNvcJcwrLHnac4zU1RxRRwpsjQKvoKkrN2voMx7qy1C5uZAs%2b2DPy5bHH0FEOgwrzNIzn0HArYorT280rLQVjyX4960NF%2bHkelWx2NqU6xYB58tfnb9Qo/E11Hwt8PL4a%2bHelWmzbPPELq49TJIAxB9wML/wABrzD4/Z1Pxr4U0Uk7XB4H/TWRU/8AZa9/VQihVACgYAA4ArIY6iiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACud8c%2bHk8U%2bCtV0koGkmgJhyOkq/Mh/76A/DNdFRQB4v%2bzprrXnhbUdFlfLafcCSMHtHJk4H/AlY/wDAq9or59%2bEq/2R8cvFukoNsBFyEUf7M67f/HSa%2bgqACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqlqulWet6Vc6ZqECz2lzGY5Y27g%2bnoR1B7EA1dooA%2bQPEvh2/%2bGXi2TT7ovLplwd9vPjiRPX/eHQj/ABFaKOsiK6MGVhkEdCK%2bifG/g2w8ceHJtLvAEk%2b/bXAGWhk7MPUdiO4/A18sxJf%2bE9duPDutxmGSF9oJ6DPQg91PUGvbyrH%2bzfsaj0e3ka0520ZvUUUV9QdAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUActr/wDpHiGxtu3yg/i3P6Cuprlj/pHjcD%2bGM/yT/GuprzsD71StPvK33EQ3bCiiivRLCiiigAooooAKKKKACiiigAooooAKKKKACiiigArmfD3/ACG9S/3j/wChGumrmfD3/Ib1L/eP/oRrz8X/ALxR9X%2bREviR01FFFegWFFFFABRRRQAVhXf/ACPGg/8AXxD/AOjRW7WFd/8AI8aD/wBfEP8A6NFePnv%2b4zInsfTFFFFfhB1BRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmsyopZiAo5JPanVkasLueWO2iQ%2bU/Vh0J96uEeaVrgRJe3N/qSi1YrCnXPQj1NblV7O0js4BGnPdj6mrFOpKLdorRCQUUUVmMKKKKACiiigAooooAK8/1H/kJ3f/AF2f/wBCNegV5/qP/ITu/wDrs/8A6Ea78D8TEytRRRXpgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRXM%2bM/GFt4S01ZCgmvJsiCDOM46sfYV5NE/jfx/O8kUlxJbhsHa/lQJ7YyAT%2bZrnqYhQfKldge/0V4Hc%2bDvHHh1DfQG4wgyz2lwWYD3AOSPwNdf4B%2bJUmrXUeka0UF2/ENyAFEp/usBwG9COvTr1mGJTlyzVmB6bRRRXUAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFek15tXpNedj/s/P8AQYUUUV5wBRRRQAUUUUAFcj4p/wCQnH/1xH/oTV11cj4p/wCQnH/1xH/oTV14L%2bKDMSiiivXEFebaB/ydDb/8C/8ASI16TXm2gf8AJ0Nv/wAC/wDSI1xY7%2bGvX/MD6SoooryhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcH8XvFUnhT4f3c9s5S9u2FpbsDyrMDlvwUNg%2buKf8KfB0Xg/wTaRPGBqF4q3F45HO4jIT/gIOPrk964/47D7VrngXTZMG2ur9xIpHX5oV/k7V7TQAV5x8TND8eateae/g/VGtIY0bz0Fx5W5sjb254z7V6PRQB87Hx58T/htewDxfaG/0yR9vmOEOfXZKnRvZvTpXu%2bg67YeJNFttW0ybzbS4Xcpxgg9CpHYg5BpviHQ7TxLoF7pF8gaC6jKEkcoezD3BwR9K8e/Z11G4h/4SDw9cE/6NKsyL/dY5R/8A0Ff1oA9zVVRQqKFUDAAGAKdRTJZFhiaRzhVGTQASSpEheR1RR3Y4qg2uWKkjzGb3Cmuevr6W9nLuSEB%2bVOyiqtVY64YZW94v%2bLvDWi/ELRP7NuZykqN5kEyD54m9QD1GOo/qAR5tpH7Oiw6mkura4s9kjZMMEJVpR6Ek/L%2bGa7sEqwKkgjoR2rqNH1A3kJSU/vU6n%2b8PWk0RVociutjQiijghSGJFSONQqIowFA4AFPJwMmlqOYM0EgQDcVIGfXFI5zx%2bG5lt7tbmJtsqPvUjsa9WsbmLVtKjmaIGOdMPG65B7EEHqOtYuj%2bDraz2zXxW4nHO3%2bBfw7/AI/lXTEqiZOFVR%2bAFB347EU6rSh06nAr8F/Ay6n9t/spz8%2b/yDO3lZ/3c9PbOPwrz746KqfEDweiqFVQoAAwAPNWvYrvxAQ5W1jUgfxv3%2bgrxX4xTveeLfB91LjeZzHgDjAkjP8A7MadjkdKSjzM%2biaKKKRmFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHP%2bO/8AknniX/sFXX/opq8S%2bDX/ACKF3/1/v/6Ljr23x3/yTzxL/wBgq6/9FNXiXwa/5FC7/wCv9/8A0XHXXgv4oM9Eooor1xBXb6B/yBLf/gX/AKEa4iu30D/kCW//AAL/ANCNcWO/hr1/zA0qKKK8oYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHz/8Zf8Aksng3/t3/wDSg19AV8//ABl/5LJ4N/7d/wD0oNfQFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB8/8AgH/k5PxR/wBvf/oxa%2bgK%2bf8AwD/ycn4o/wC3v/0YtfQFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeefFX4bweOtG8%2b1VI9atFJt5Tx5i9TGx9D2PY%2bxNeh0UAfGujajPFcPpOpI8N5Axj2yDDZHBUj1FbtemfGP4WnxBA/iPQocaxAuZoYxzcqO4/2x29Rx2FeNaHrP25Ps9wdt3HwQeN/v9fWvpsqzHnSo1Xr0ffyOinO%2bjNmiiivdNQooooAKKKKACiiigAooooAKKKKACiigkAEntSA5bRv3/iq9l6hd%2bP8AvoAfpXU1y/hMeZcXsx6nb%2bpJrqK8/K9cPzd23%2bJFP4Qooor0SwooooAKKKKACiiigAooooAKKKKACiiigAooooAK5nw9/wAhvUv94/8AoRrpq5nw9/yG9S/3j/6Ea8/F/wC8UfV/kRL4kdNRRRXoFhRRRQAUUUUAFYV3/wAjxoP/AF8Q/wDo0Vu1hXf/ACPGg/8AXxD/AOjRXj57/uMyJ7H0xRRRX4QdQUUUUAOT76/Wuwrj0%2b%2bv1rsK%2bn4d2qfL9TlxPQKKKK%2blOUKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiqmoXi2VsX4LnhB704pydkBboqlpktxNaK9wBk/dPcj1q7RJcraAKKKKQBRRRQAUUUUAFFFFABRRRQAV5/qP/ITu/8Ars//AKEa9Arg9WTy9WulIxmQt%2bfP9a7sD8TQmUqKKK9QAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8F8V%2bb4p%2bKh05nIjFwlmn%2bwg%2b8R%2bO417nZWVvp1lDZ2sSxQQqERF7Af5614X4jd/C/xZe/mQmIXS3Q4%2b8jcnH/AI8Pwr3a3uIbu2iuLeRZIZVDo6nhgeQRXHhrc0773Alrwz4qaHFoXiO21GxHkLeAybU42yoRkj06qfrmvc68Q%2bLmsxan4gtdMtSJDYqyuV5/eORlfw2r%2bOaeMt7PXcD2DQ786poNhfsMNcW6SMPcqCf1q/WdoNi%2bmeHtOsZP9Zb20cb/AO8FGf1zWjXTG/KrgFFFFUAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV6TXnMSGWZIx1Zgv516NXnY/7PzGFFFFecAUUUUAFFFFABXI%2bKf8AkJx/9cR/6E1ddXI%2bKf8AkJx/9cR/6E1deC/igzEooor1xBXm2gf8nQ2//Av/AEiNek15toH/ACdDb/8AAv8A0iNcWO/hr1/zA%2bkqKKK8oYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHjn7QVnPHomheIIFy%2bl33JH8IbBB/wC%2bo1H4ivWNN1CDVdLtNQtX3W91Cs0beqsAR/Oq3iLQ7XxL4fvtGvQfIu4jGxHJU9VYe4IBH0ryX4YeKrjwVq83w68WMLeWCU/2fcyHCSKxyFBPY9VPuR1AFAHt1FFFABWVpvhvRdGvJ7vTdLtbS4uOJZIYwpfnPOOvNatMaREdFZ1VnO1QTgscE4HrwCfwoAfWbrjFdLfH8RAP51pVVv7f7VZSwjqRx9RyKEVBpSTZxlFKwKkqQQRwR6UlWemFWbOS4jNwbTPn/Z5PLwM/NtJHXjqBVatvw9akyvcsPlUbV9z3pMzqtKDueI6P8bfH92spt9GtdTSLBlaKzlYpnOMlGwOncdq14/2h720cR6n4TKP323JjI/4CyH271lasl98Gvim%2bqQW7yaBqLMdqdDGxyyDsGQ8j2x6mvaLDxj4X1vSheQ6vYPbMu51mlVSns6typ%2btSeekcLaftEeGpcC70vVICe6KkgH/jwP6V2dv4rsfFHhddS0ozfZppjFmWMoTt649s8fnXifj7VNO8f%2bKrHw14N0qzY%2bbhr2K3VDK2OTuAyI1GST369hXu1n4ah0XwdZ6LZDctlGApxgu3O5sepJY/U0IqnZTVzFry74r/APIw%2bDv%2bvt//AEOGvUq8v%2bKqNJ4k8GIgyzXjgAdzvhqmdtf%2bGz6MoooqTzwooooAKKKKACiiigAooooAKKKKACiiigAooooA5/x3/wAk88S/9gq6/wDRTV4l8Gv%2bRQu/%2bv8Af/0XHXtvjv8A5J54l/7BV1/6KavEvg1/yKF3/wBf7/8AouOuvBfxQZ6JRRRXriCu30D/AJAlv/wL/wBCNcRXb6B/yBLf/gX/AKEa4sd/DXr/AJgaVFFFeUMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoory/4o/Fq38Gq2k6UqXWvSKPlIyluCOC3q3TC/ie2QDtfEni3QvCVl9q1rUIrZT9xD80kn%2b6o5P8AnNeP6n8f9U1a8Nj4M8NS3Ep%2b486NLI3uIo%2bn/fRqHwn8HNX8W3f/AAkfxBvLstPhxaM2JnHUbz/yzH%2byOf8AdxXuGj6FpXh%2byFnpNhb2cA/hhTG73J6k%2b5oA8NWL486%2bRKZH0%2bJuVBMEGPwHz/nT/wDhAvjS3zHxZgnkj%2b0ZOPyWvoCigD5M1zRvFWifEvwxB4t1L7fdvcW7xP57S7U87GMsBjnNfWdfP/xl/wCSyeDf%2b3f/ANKDX0BQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAfN3hrXtL8PftEeI7rVryO0t5ZbmFZZMhd5kBAJ7dDyeK%2bjLe5gu4Entpo5oXGVkjYMrD2I4r5lsvCGn%2bNvjp4q0jUnnji8y5lV4GAZXEi4PIIPU1ty/BLxr4Ynefwf4oyhOdgle2dvYgZVvxIoA%2bhKK%2bfV1v47aH8lzpjX6r0Jt4ps/jEQTTv%2bFn/GCL92/gbey9W/sm6OfxD4oA%2bgKK8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bivAP%2bFp/F/8A6EP/AMo93/8AF0f8LT%2bL/wD0If8A5R7v/wCLoA9/orwD/hafxf8A%2bhD/APKPd/8AxdH/AAtP4v8A/Qh/%2bUe7/wDi6APf6K8A/wCFp/F//oQ//KPd/wDxdH/C0/i//wBCH/5R7v8A%2bLoA9/orwD/hafxf/wChD/8AKPd//F0f8LT%2bL/8A0If/AJR7v/4ugD3%2bvB/jF8LHWSXxf4ahKTp%2b8vbWFfvesqAd/wC8O/X1zB/wtP4v/wDQh/8AlHu//i6P%2bFp/F/8A6EP/AMo93/8AF002ndAee6NrEepwbXIW5QfOvr7itSue1rRvF9zq91rz%2bD7/AEvJM0gttOmjhjwMs3zZ2jqTzjrV/SNYi1OHHCXCj50/qPavqstzFVl7Op8X5/8ABOinO%2bjNKiiivYNQooooAKKKKACiiigAooooAKhu38uynf8Auxsf0qaqerNs0i7P/TJh%2bYxWdaXLTk/JiexkeEExZ3L%2bsgH5D/69dHWH4UXbpDH%2b9Kx/QD%2blblc2XR5cLBeQofCgooortKCiiigAooooAKKKKACiiigAooooAKKKKACiiigArmfD3/Ib1L/eP/oRrpq5nw9/yG9S/wB4/wDoRrz8X/vFH1f5ES%2bJHTUUUV6BYUUUUAFFFFABWFd/8jxoP/XxD/6NFbtYV3/yPGg/9fEP/o0V4%2be/7jMiex9MUUUV%2bEHUFFFFADk%2b%2bv1rsK49Pvr9a7Cvp%2bHdqny/U5cT0CiiivpTlCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBGIVST0AzXPxK%2bsaiZHBEEfb27D8a6GmKioTtUDJycDqa0hU5L23E0OACjAGAKWiisxhRRRQAUUUUAFFFFABRRRQAUUUUAFcr4ntClzHdKPlkG1j7j/wCt/Kuqqvd2sd5bPBKPlYdfQ9jWtCr7OakB59RVi8s5bK4aGZcEdD2YeoqvXuJpq6EFFFFMAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDk/HPguLxbYIYnWHUIAfJlYcMD/C3t/L8a8qtdZ8YfD6VrOSOSO3DcQ3Cb4WPqrf/EmvoGkZQylWAIPUHvXPUw6lLmi7MDwa7%2bJ3izW0%2bxWqxQPJ8uLGFvMb6ZLEfhXR%2bAPhzc297FrevR7JEO%2bC2flt3UO/p7DrnrjFeqJFHFny40TPXaMZp9THDe9zTlcAooorqAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKkggkuZliiQs7HAApN21YGj4ftDcamrkfJD85Pv2/X%2bVdpVHTNPTTrQRDBc8u3qavV4uIq%2b0ndbDCiiisACiiigAooooAK5HxT/yE4/%2buI/9CauurkfFP/ITj/64j/0Jq68F/FBmJRRRXriCvNtA/wCTobf/AIF/6RGvSa820D/k6G3/AOBf%2bkRrix38Nev%2bYH0lRRRXlDCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK5Pxz8PtH8eaaINQQw3cQP2e8jA3xH0/wBpfUH9DzXWUUAeGQah8VPhmotLvTv%2bEo0aLiOaLc8iKO2QCyjH95SB2NXof2jPD6ZTUND1i2mH3kRY3wfTllP6V7LUUsEM%2bPNijkx03qDigDxl/jpqmuZg8IeDL69nbhZZgWVD7qgPH/AhWN8Mtb8R618a7tPFNw0l9Z2c8fkErsgbcgKqF4HoSOvqa%2bg%2bn0rwDwD/AMnJ%2bKP%2b3v8A9GLQB9AUUUUAZeoaPHeMZYz5cvc44b61ktoV8pwERh6hv8a6qinc1jWnFWOdtfD8hYNcuFUfwryT%2bNb0USQxrHGoVV6AdqkopEzqSnuUNY0XTdf02XT9VtI7q1k%2b9HIOh9QeoPuOa8suv2d/Dst0ZLbVNRt4Sc%2bUdj49gSP55r2Kigg5jwj4C0HwVbsmk2x8%2bQYlupjulf2J6AewAFdPRRQBn3WkWt0xcqUc9WQ4zXhXikDWP2gPD3h6DMkOmXEUrkjJJwJnz7bVA/OveNW1O10XSLvU719ltaxNLI3sBnj39K8N%2bBthdeJPGuveOb%2bP7zukRPI8yQ7mx/urgfRhQVzyta%2bh7/RRRQSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHP8Ajv8A5J54l/7BV1/6KavEvg1/yKF3/wBf7/8AouOvbfHf/JPPEv8A2Crr/wBFNXiXwa/5FC7/AOv9/wD0XHXXgv4oM9Eooor1xBXb6B/yBLf/AIF/6Ea4iu30D/kCW/8AwL/0I1xY7%2bGvX/MDSoooryhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcR8UPHcfgTws9xEVbU7omKyjbn5u7keijn64HeuF%2bDnw3aYr438TK9zqF03n2iT/MVzz5zZ6seo9Bz1Ixg3UZ%2bLnx3a0kJk0PSiysAeDFGcH673OPXafavo1VCKFUAKBgADgCgB1FFFABRRRQB8/8Axl/5LJ4N/wC3f/0oNfQFfP8A8Zf%2bSyeDf%2b3f/wBKDX0BQAUUUUAFFFFABRRXFfE/xuPA3hGS9h2tqFw3kWaNyN5GSxHoo5%2buB3oAXxt8T/D3gYeTfTPcagy7lsrfBfHYsTwo%2bvPoDXmI%2bN/jrW5Gl8N%2bDFmth6W090fxZNo/SrXws%2bFi60g8Y%2bMVa%2buL0%2bfb29x8wYHnzJM/ez2HTHrnj3WONIY1jiRURBhVUYAHYAUAeBR/HjxVolyieK/CHkI56LHLbNj2Em7P6V634Q8daD42smn0e63SRgebbSjbLFn1X09xke9b15ZWuoWslre20VzbyDDxSoGVh7g8V88/EXwJdfDLV7bxp4Okkgs45QJYdxYQMTgD1MbdCD0J9xgA%2bjaKwvB/iW28XeFrHWrYbRcJ%2b8jzny5Bwy/gQfqMGt2gAoormPH3i%2bHwT4Ru9YdVecYitom6SSt90fQYJPspoAi8Z/ETw/4HtwdUuS904zFaQANK/vjoB7nFeVH46eM9cmc%2bF/ByzQqe8M102Pfy9oFR/DD4bP43uJPG3jN5LxLmQvBBIf8AXkHG9/8AYGMBRxx6cH6Agt4bWBILeGOGGMbUjjUKqj0AHAoA8DHxz8Z6HMh8T%2bDRDAxxxBNatj2Mm4GvVPBfxF8P%2bOYCdMuGju0XdLZzgLKg9cdGHuCe2cV1E8EN1A8FxEk0Lja8cihlYehB4NeBfE/4ayeDJ08beC2kshayB54Ij/qcnG9P9jnBXpz6ZAAPoKiuW%2bH3jCLxv4RttWVVS4yYbqJeiSrjIHscgj2IrqaACiisTxb4ktvCXhi%2b1q6%2bZbePKR5wZHPCqPqSP1NAFbxd450LwTYi51i62yOD5VtGN0sv%2b6vp7nA968jk%2bPPijWrl4/CnhDz1U/xxy3L49SI9uPpk1R%2bHvga8%2bKOt3HjPxfI81i8pEcOSvnkfwj%2b7GvTjr%2bBr6GsrG0060jtLG2htreMYSKFAiqPYDigDwVvjf480R1l8R%2bDFhtiR1tp7Un/gT7h%2blemeCfih4e8cjyLKVrbUQMtZXGA5A6lT0YfTn1Ars5I0mjaOVFdHGGVhkEdwRXhXxV%2bE8elwv4u8Ho1lcWZ8%2b4trclQoHPmR4%2b6R1IHGBkYxyAe8UVxHwu8bjxz4Rju59q6jbN5F2q8AsBkMB6MOfrkdq7egAooooAKKKKAPn/wD/wAnJ%2bKP%2b3v/ANGLX0BXz/4B/wCTk/FH/b3/AOjFr6AoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAEPP0r59%2bKnwgl06abxR4SiYIp8y5sYl5j9XjA/h9V7c444H0HRTTad0B8eaNrcWpJ5b4S5A5Ts3uP8K1q9A%2bKHwY/tGWXxB4TjWHUATJPZIdomPUsno/t0PsevkWma6TKbLUlMF3G2w7xtyR1BB6GvpsvzVVLU6zs%2b/f8A4J0QqX0Zu0UUV7hqFFFFABRRRQAUUUUAFZuvtt0O6OcfKB%2bZAqxe6hbafHvuJAvoo5LfQVzWoXmqazp11c29nKul25UTShcqCSAoZumScYH%2bFebmGMpUqUoN%2b801Yic0lY2PDK40OI4%2b8zH9SK16zPD67dCtR7Mf/HjWnXTg1bDwXkvyKj8KCiiiukYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcz4e/5Depf7x/8AQjXTVzPh7/kN6l/vH/0I15%2bL/wB4o%2br/ACIl8SOmooor0CwooooAKKKKACsK7/5HjQf%2bviH/ANGit2sK7/5HjQf%2bviH/ANGivHz3/cZkT2Ppiiiivwg6gooooAcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVXu7uOzh82TJGcADqasVz9wx1XVVgQ/uY%2b/t3NaUoKT12QmbkMqTwrKmdrDIyMVJTVUIoVRgAYAp1ZvyGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAFa7soL6Hy503DsR1H0NczeeG7uAlrfE6dscMPwrr6K2pV50ttgPO5LaeI4khkQ%2bjKRUVek0V1LHvrH8QPNqK9Jop/X/7v4/8ADzaivSaKPr/APd/H/gAebUV6TRR9f8A7v4/8ADzaivSaKPr/wDd/H/gAebUV6TRR9f/ALv4/wDAA82or0mij6//AHfx/wCAB5tRXpNFH1/%2b7%2bP/AAAPNqK9Joo%2bv/3fx/4AHm1Fek0UfX/7v4/8ADzaivSaKPr/APd/H/gAebUV6TRR9f8A7v4/8ADzaivSaKPr/wDd/H/gAebUV6TRR9f/ALv4/wDAA82or0C9tFvYBEzlRnORUsMQggSIHIRQMmn9fVr8uojzqivSaKX1/wDu/j/wBnm1Fek0UfX/AO7%2bP/AA82or0mij6/8A3fx/4AHm1Fek0UfX/wC7%2bP8AwAPNqK9Joo%2bv/wB38f8AgAebUV6TRR9f/u/j/wAADzaivSaKPr/938f%2bAB5tRXpNFH1/%2b7%2bP/AA82or0mij6/wD3fx/4AHm1Fek0UfX/AO7%2bP/AA82or0mij6/8A3fx/4AHm1Fek0UfX/wC7%2bP8AwAPNqekMshAjidif7qk16NRSeP8A7v4gcXaeH725IMi%2bQnq/X8q6ew0y30%2bPES5c/edupq7RXNVxE6mj2AKKKKwAKKKKACiiigAooooAK5HxT/yE4/8AriP/AEJq66uR8U/8hOP/AK4j/wBCauvBfxQZiUUUV64grzbQP%2bTobf8A4F/6RGvSa820D/k6G3/4F/6RGuLHfw16/wCYH0lRRRXlDCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAr5/8AAP8Aycn4o/7e/wD0YtfQFfP/AIB/5OT8Uf8Ab3/6MWgD6AooooAKKKKACiiigAooooAKKzNZ8QaR4etDdavqNtZQ44MzgFvZR1Y%2bwFeG%2bLvi3rPji9PhjwDZ3W24yjXKjbLKvfb/AM809WJz9KAHfFvxjc%2bNdftvAHhf/SQ04W5eNvlllH8OR/AnUn1H%2bzz7N4P8M23hDwvY6LancIE/eSYx5kh5ZvxOcegwO1cx8MPhfaeA7E3N0Y7nW51xNOvKxr12Jnt6nvXolABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAc/47/5J54l/7BV1/wCimrxL4Nf8ihd/9f7/APouOvbfHf8AyTzxL/2Crr/0U1eJfBr/AJFC7/6/3/8ARcddeC/igz0SiiivXEFdvoH/ACBLf/gX/oRriK7fQP8AkCW//Av/AEI1xY7%2bGvX/ADA0qKKK8oYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFYvi7VW0PwfrGqI22S2s5ZIz/thTt/XFbVcF8Z5Wh%2bEmvMuMlYV59DMgP86AOQ/Zw0ZYPDWq6y6/vbu5ECk/3I1zkfUuf%2b%2ba9srzr4HQrF8JdJdesrzu3HfznX%2bSivRaACiiigAooooA%2bf8A4y/8lk8G/wDbv/6UGvoCvn/4y/8AJZPBv/bv/wClBr6AoAKKKKACiiigAr58%2bNinXfit4U8NyOTbSLErAH7pmmKN9OEWvoOvn747JNofxB8K%2bKhGXihCAY/vQy%2bZj8d/6GgD36ONIYkijVURAFVVGAAOgAp9QWl3Bf2UF5ayLLbzxrLG69GVhkEfhU9ABWb4g0mHXvD2oaVOoMd3bvFyOhI4P1BwfwrSrE8Xa7D4a8J6nq8zhfs0DMmT95zwi/ixA/GgDyf9mvUZJdF17TWJMdvcRTKOwMisD/6LFe514n%2bzfpUlt4b1jVXUqt5cpEmf4hGp5%2bmZCPwNe2UAFeBftEzzXureGNEjbakrO59CzMqKfw5/Ovfa8H/aMsbi3k8Oa/AvEEjws3ZW4dP/AEF/yoA9vsLKDTdPtrC1QJb20SxRqOyqMAfkKs1n6Lq1truiWWq2bBre7hWVOemR0PuDwfpWhQAVBe2cGoWNxZXKCS3uI2ikQ/xKwwR%2bRqeqOr6pbaJo95ql4%2b23tYWlc%2bwGcD3PQUAeIfs8SzWWt%2bKNEL74oijg%2bjKzISPqMfkK99rwX9nWzuLu78SeIJxhZ5EhBA4ZyS7/AJZT8696oAK8P/aT1GSHQNE01WwlzcyTMB38tQB/6M/lXuFeK/tHaTJc%2bFtK1RF3Cyumjfj7qyKOfplFH4igD1bw3pMWheGtN0qJNq2tskZHqQOT9ScmtSsHwbrkXiPwdpWqxOGM9upkwc4kAw4/Bga3qACmuiyIyOoZGGCrDII9DTqhubmGztZrq4kWKCFGkkduiqBkk/QUAeBfBlD4e%2bL3irw3GWFsqzKoz18qUBCf%2bAs1fQdfPvwPWXxB8SfFHito2EUgkxu7NNLvAH0VCPxr6CoAKKKKACiiigD5/wDAP/Jyfij/ALe//Ri19AV8/wDgH/k5PxR/29/%2bjFr6AoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArzv4ifCXSfHET3kG2x1kL8tyq/LLjoJAOv16j3HFeiUUAfG%2boQa/4F1L%2byvENlIqD/AFcnUMvqjdGH8vbpWpa3lvexeZbyq698dR9R2r6j1nQ9M8Q6dJp%2brWUN3bP1SQdD6g9Qfcc14X4q%2bAGoafO9/wCDb8yKORZ3D7ZB7K/Rvo2Pqa9bB5tUorkn70fxNI1Gtzl6Kwby%2b1/w7cfZdf0ieCQcZljMZb3Bxhvwpq%2bLrHHzQXAPsFP9a9ynmmFmr81vU2VSLOgorm38XRk7YLOR2JwNzAfyzWtpvhz4geKCBpuh3MMDdJXj8lMeu98Z/Cpq5vhYLR39BOrFE91e21nHvuJljHbJ5P0HWsVdY1HWr1dP0CwmuLiThQkZdz7hR0Hua9U8Ofs7bpVuvFertMx5a2syef8AekYZ/AD8a9k0Hwzovhiz%2by6Lp0FnEcbvLX5n92Y8sfqa8bE5xWq6U/dX4mcqrex4t4O%2bAM9zMmo%2bNLpiSd32GCTJPs8g/kv5103xq0%2bz0b4PyWGm2sVpaJcQqsUKBVxuz0%2bozmvWa8r/AGgpfL%2bGZXGfMvYl%2bnDH%2bleS227syPFtDAGi2oH9z%2btaFUdGXbo9oM/8swavV93hlajBeS/I7I7IKKKK3GFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXM%2bHv%2bQ3qX%2b8f/QjXTVzPh7/AJDepf7x/wDQjXn4v/eKPq/yIl8SOmooor0CwooooAKKKKACsK7/AOR40H/r4h/9Git2sK7/AOR40H/r4h/9GivHz3/cZkT2Ppiiiivwg6gooooAcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAyRN8bLkjcMZHUVV0/T1sVcbt7MfvYxx2q7RTUmk4oAooopAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRVDU757GONo1Vixx81XI23xqx7gGqcWoqXcB9FFFSAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXI%2bKf%2bQnH/ANcR/wChNXXVyPin/kJx/wDXEf8AoTV14L%2bKDMSiiivXEFebaB/ydDb/APAv/SI16TXm2gf8nQ2//Av/AEiNcWO/hr1/zA%2bkqKKK8oYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFfP/AIB/5OT8Uf8Ab3/6MWvoCvn/AMA/8nJ%2bKP8At7/9GLQB9AUUUUAFFFFABXyx4Ym%2bJfjjVNUg0XxTdp9jfLie9dBhiwGMA%2bhr6nr5/wD2d/8AkYfFn/bL/wBDkoAP%2bEB%2bNP8A0Nv/AJUpP/iaRvhz8ZLkeVL4w2I3U/2nMB%2bO1c19A0UAeE6Z%2bzs1zd/a/E/iOa7djl1tgdzfWR8n/wAdr13w74V0TwrZfZNF06G1Q43soy8mO7MeW/E1s0UAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAc/47/wCSeeJf%2bwVdf%2bimrxL4Nf8AIoXf/X%2b//ouOvbfHf/JPPEv/AGCrr/0U1eJfBr/kULv/AK/3/wDRcddeC/igz0SiiivXEFdvoH/IEt/%2bBf8AoRriK7fQP%2bQJb/8AAv8A0I1xY7%2bGvX/MDSoooryhhRRWVqWpGBjDDjf/ABN/drnxOJp4an7So9CoQcnZGrRXIPI8hy7sx9zmpILue3YGOQgf3T0P4V4seIYOVpQdvX9P%2bCbvDO251dFVbK8W8h3AYYcMvpVqvepVY1YKcHdM52mnZhRRRWggooooAKKKKACiiigArz/42/8AJIdd/wC3f/0ojr0CvP8A42/8kh13/t3/APSiOgA%2bCX/JIdC/7eP/AEokr0CvP/gl/wAkh0L/ALeP/SiSvQKACiiigAooooA%2bf/jL/wAlk8G/9u//AKUGvoCvn/4y/wDJZPBv/bv/AOlBr6AoAKKKKACiiigArmPHvg%2b28b%2bFbnSJmWObiS2mIz5Uo6H6ckH2Jrp6KAPnTwF8R7/4a38ng3xrbzR2tu%2bIZwCxgBPt96M9QRyPft71pWuaTrlutxpWo2t5ERnMEobH1A5H41S8T%2bDdB8YWYttasI59v%2brlHyyR/wC6w5H06eteU6h%2bzVp8s5bTvElzbQnok9qsxH4hl/lQB61rvi3QPDVu02sata2u0Z8t5AZG/wB1B8x/AV4F4k8R638b/E1v4f8AD9tLb6Jbyb3kkHHp5smOBgZ2rn17njqtK/Zu0a3mV9V1y7vVBz5cMSwBvYnLHH0Ir1nQ/D2k%2bGtPWx0ewhtLcHJWMcsfVieWPuSaAF8P6HZ%2bG9BstHsFK21rGEXPVj1LH3JJJ9zWnRRQAVieLfDVp4u8NXmi3vypOvySAZMbjlWH0P5jI71t0UAfNvg3xrq3wf1qfwp4ttZm0wyFopEG7ysn78f95G6kdjnvkH3zRvE2ieIYFm0jVLW8UjOIpAWH1XqPoRTfEPhfRfFVh9i1qwiu4hyhbhkPqrDkH6GvJtS/Zs0qaYtpniC7tIyc7LiBZ8ewIKUAeu6z4j0bw/btPq2p2tmijP72QBj9F6k%2bwFeBeM/G%2bq/F/WYfCPhK1lGmGQPLJINvm7T99/7sY6gdScd8Ct/Tf2bNMhnDan4hurqMHOyC3WHPsSS1es%2bHfCuieFLH7HounxWkZwXZeXkPqzHlvxNAEfhDwxaeD/DNno1mdywrmSXGDLIeWY/U/kMDtW7RRQAVna7otp4i0O90i/TfbXcZjf1HoR7g4I9xWjRQB80eH/EGt/A3xTPoOu28lzoVy5kR4x1HA82PPGcYDL9Px980LxboHia3WbR9WtrrcM%2bWr4kX/eQ/MPxFWdb0DSvEenPYavYxXds3OyQcqfVT1U%2b4INeSat%2bzfo1zMX0rW7uxQnPlzRCcD6cqcfUmgD1zVdc0rQ7dp9V1G1s4wM7p5QufoD1/CvBPiB8Sr74jXieD/BNvcTW1w22aUKVa4wenP3Yx1JOPfAHOvYfs1afHMDqHiS5uIu629qsJP4lm/lXq3hfwZoPg6zNvotgkG/HmSk7pJP8AeY8n6dPQUAVvAPg238D%2bFbfSYmWSfJluZlGPMlPU/QYAHsBXUUUUAFFFFABRRRQB8/8AgH/k5PxR/wBvf/oxa%2bgK%2bf8AwD/ycn4o/wC3v/0YtfQFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBHNDFcRNFPEksbdUdQwP1BrFk8E%2bE5nLy%2bGNFdz1ZrCIk/%2bO1vUUAULLRdK005sNMs7U%2bsECp/IVfoooAKKKKACvJ/2hv%2bSbRf9hCL/wBBevWK8n/aG/5JtF/2EIv/AEF6APHdI/5BFp/1yX%2bVXapaR/yCLT/rkv8AKrtfe0P4UfRfkdkdgooorYYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcz4e/5Depf7x/8AQjXTVzPh7/kN6l/vH/0I15%2bL/wB4o%2br/ACIl8SOmooor0CwooooAKKKKACsOZTL4/wBAiX7zXEAH4y4rcqn4Fsz4i%2bKdvOgLW1kTOWHQBBhfzcivA4jrxpYGXMTPWyPoeiiivw86QooooAcn31%2btdhXHp99frXYV9Pw7tU%2bX6nLiegUUUV9KcoUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABVHVLr7LZsVOHf5V9ver1YF8f7Q1eO2U/Ihw2P1rWjFSlrshM09MM7WKNO5Zm5GfTtVykACgADAFLWcndtjCiiikAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAY/iAf6NEf9v%2bladuc20R9UH8qivrJb2JY2Yrht2RU0UYihSMEkKoUE%2b1aSmnTUeqF1JKKKKzGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyPin/AJCcf/XEf%2bhNXXVyPin/AJCcf/XEf%2bhNXXgv4oMxKKKK9cQV5toH/J0Nv/wL/wBIjXpNebaB/wAnQ2//AAL/ANIjXFjv4a9f8wPpKiiivKGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXz/AOAf%2bTk/FH/b3/6MWvV/HHjnTvBGlC5uh511LkW9qrYaQjvnso7mvD/g9rT6t8bdQ1G7Ecc%2boQ3D7E6biysQM%2bwP5UAfTNFFFABRRRQAV8//ALO//Iw%2bLP8Atl/6HJXvssiQxPLIwVEUszHoAOpr5M%2bFvxBTwZ4k1C5mtDNY37KJtp/eRgMxBXsepyP1oA%2btqKraff2uqWEF9ZTpPazoHjkQ8MDVmgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5/x3/wAk88S/9gq6/wDRTV4l8Gv%2bRQu/%2bv8Af/0XHXtvjv8A5J54l/7BV1/6KavEvg1/yKF3/wBf7/8AouOuvBfxQZ6JRRRXriCu30D/AJAlv/wL/wBCNcRXb6B/yBLf/gX/AKEa4sd/DXr/AJgaVFFFeUMQnAJ9BXIO5kkZ2PLHJrryMjBrk7iFoJ3ib%2bE/mO1fN8QqXLTfTX9Dqw1rsiooor5c6jQ0eQpfBM8OpH9a6KsDRYC9yZsfKgx%2bJrfr7PIlJYT3u7t6f8Pc4sRbnCiiivZMAooooAKKKKACiiigArz/AONv/JIdd/7d/wD0ojr0CvP/AI2/8kh13/t3/wDSiOgA%2bCX/ACSHQv8At4/9KJK9Arz/AOCX/JIdC/7eP/SiSvQKACiiigAooooA%2bf8A4y/8lk8G/wDbv/6UGvoCvn/4y/8AJZPBv/bv/wClBr6AoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPn/wD/wAnJ%2bKP%2b3v/ANGLX0BXynP4l1bwr8bPEuo6Npwv7o3FxEYTG7/KXBJwvPYV1H/C7fiB/wBCZH/4CT/41LnFaNjsz6Eor57/AOF2/ED/AKEyP/wEn/xo/wCF2/ED/oTI/wDwEn/xpe1h/MvvCzPoSivnv/hdvxA/6EyP/wABJ/8AGj/hdvxA/wChMj/8BJ/8aPaw/mX3hZn0JRXz3/wu34gf9CZH/wCAk/8AjR/wu34gf9CZH/4CT/40e1h/MvvCzPoSivnv/hdvxA/6EyP/AMBJ/wDGj/hdvxA/6EyP/wABJ/8AGj2sP5l94WZ9CUV89/8AC7fiB/0Jkf8A4CT/AONH/C7fiB/0Jkf/AICT/wCNHtYfzL7wsz6Eor57/wCF2/ED/oTI/wDwEn/xo/4Xb8QP%2bhMj/wDASf8Axo9rD%2bZfeFmfQlFfPf8Awu34gf8AQmR/%2bAk/%2bNH/AAu34gf9CZH/AOAk/wDjR7WH8y%2b8LM%2bhKK%2be/wDhdvxA/wChMj/8BJ/8aP8AhdvxA/6EyP8A8BJ/8aPaw/mX3hZn0JRXz3/wu34gf9CZH/4CT/40f8Lt%2bIH/AEJkf/gJP/jR7WH8y%2b8LM%2bhKK%2be/%2bF2/ED/oTI//AAEn/wAaP%2bF2/ED/AKEyP/wEn/xo9rD%2bZfeFmfQlFfPf/C7fiB/0Jkf/AICT/wCNH/C7fiB/0Jkf/gJP/jR7WH8y%2b8LM%2bhKK%2be/%2bF2/ED/oTI/8AwEn/AMaP%2bF2/ED/oTI//AAEn/wAaPaw/mX3hZn0JRXz3/wALt%2bIH/QmR/wDgJP8A40f8Lt%2bIH/QmR/8AgJP/AI0e1h/MvvCzPoSivnv/AIXb8QP%2bhMj/APASf/Gj/hdvxA/6EyP/AMBJ/wDGj2sP5l94WZ9CUV89/wDC7fiB/wBCZH/4CT/40f8AC7fiB/0Jkf8A4CT/AONHtYfzL7wsz6Eor57/AOF2/ED/AKEyP/wEn/xo/wCF2/ED/oTI/wDwEn/xo9rD%2bZfeFmfQlFfPf/C7fiB/0Jkf/gJP/jR/wu34gf8AQmR/%2bAk/%2bNHtYfzL7wsz6Eor57/4Xb8QP%2bhMj/8AASf/ABo/4Xb8QP8AoTI//ASf/Gj2sP5l94WZ9CUV89/8Lt%2bIH/QmR/8AgJP/AI0f8Lt%2bIH/QmR/%2bAk/%2bNHtYfzL7wsz6Eor57/4Xb8QP%2bhMj/wDASf8Axo/4Xb8QP%2bhMj/8AASf/ABo9rD%2bZfeFmfQlFfPf/AAu34gf9CZH/AOAk/wDjR/wu34gf9CZH/wCAk/8AjR7WH8y%2b8LM%2bhKK%2be/8AhdvxA/6EyP8A8BJ/8aP%2bF2/ED/oTI/8AwEn/AMaPaw/mX3hZn0JRXz3/AMLt%2bIH/AEJkf/gJP/jR/wALt%2bIH/QmR/wDgJP8A40e1h/MvvCzPoSivnv8A4Xb8QP8AoTI//ASf/Gj/AIXb8QP%2bhMj/APASf/Gj2sP5l94WZ9CUV89/8Lt%2bIH/QmR/%2bAk/%2bNH/C7fiB/wBCZH/4CT/40e1h/MvvCzPoSivnv/hdvxA/6EyP/wABJ/8AGj/hdvxA/wChMj/8BJ/8aPaw/mX3hZn0JRXz3/wu34gf9CZH/wCAk/8AjR/wu34gf9CZH/4CT/40e1h/MvvCzPoSivnv/hdvxA/6EyP/AMBJ/wDGj/hdvxA/6EyP/wABJ/8AGj2sP5l94WZ9CUV89/8AC7fiB/0Jkf8A4CT/AONH/C7fiB/0Jkf/AICT/wCNHtYfzL7wsz6Eor57/wCF2/ED/oTI/wDwEn/xo/4Xb8QP%2bhMj/wDASf8Axo9rD%2bZfeFmfQlFfPf8Awu34gf8AQmR/%2bAk/%2bNH/AAu34gf9CZH/AOAk/wDjR7WH8y%2b8LM%2bhKK%2be/wDhdvxA/wChMj/8BJ/8aP8AhdvxA/6EyP8A8BJ/8aPaw/mX3hZn0JRXz3/wu34gf9CZH/4CT/40f8Lt%2bIH/AEJkf/gJP/jR7WH8y%2b8LM%2bhKK%2be/%2bF2/ED/oTI//AAEn/wAaP%2bF2/ED/AKEyP/wEn/xo9rD%2bZfeFmfQleT/tDf8AJNov%2bwhF/wCgvXJ/8Lt%2bIH/QmR/%2bAk/%2bNc3428d%2bNPHOhLpN94VeCFZlm3wWs27KgjHORj5qPaw/mX3hZmbpH/IItP8Arkv8qu1zttJ4mtraKBPD12VjUKCbWXJx%2bFS/a/FH/Qu3X/gLLX1dLO8FGnGLnskdKmrG7RWF9r8Uf9C7df8AgLLR9r8Uf9C7df8AgLLV/wBu4H%2bcPaI3aKwvtfij/oXbr/wFlo%2b1%2bKP%2bhduv/AWWj%2b3cD/OHtEbtFYX2vxR/0Lt1/wCAstH2vxR/0Lt1/wCAstH9u4H%2bcPaI3aKwvtfij/oXbr/wFlo%2b1%2bKP%2bhduv/AWWj%2b3cD/OHtEbtFYX2vxR/wBC7df%2bAstH2vxR/wBC7df%2bAstH9u4H%2bcPaI3aKwvtfij/oXbr/AMBZaPtfij/oXbr/AMBZaP7dwP8AOHtEbtFYX2vxR/0Lt1/4Cy0fa/FH/Qu3X/gLLR/buB/nD2iN2isL7X4o/wChduv/AAFlo%2b1%2bKP8AoXbr/wABZaP7dwP84e0Ru1zPh7/kN6l/vH/0I1Z%2b1%2bKP%2bhduv/AWWqFlaeI7G7nuI9BvWaYksGtZMDnPpXJXzfCTq05qWkW7/cTKSbTOsorC%2b1%2bKP%2bhduv8AwFlo%2b1%2bKP%2bhduv8AwFlrr/t3A/zle0Ru0Vhfa/FH/Qu3X/gLLR9r8Uf9C7df%2bAstH9u4H%2bcPaI3aKwhc%2bKmIVPDt2WPAH2SU5NaFn4K8d%2bI2CSWjWFsfvNcfuQPw%2b8fyrGvxHgaUebmHz32RmazrBkI07Tt01zK2w%2bWMnJ42jHUnpXs3w18GHwloJa6Uf2leYe4xzsA%2b6mfbJz7k%2blJ4L%2bGuleEit05%2b26nj/j4kXAj9Qg7fXr%2beK7avzTP8/lmMuSHwmlOm780twooor5k1CiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFM8qMS%2bZsXfjG7HOKDKgkCF1DkZCk8mn0agFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFRzOyQSOoBZVJA9TVTTL172B3kChlbGFHGMf/rqlFuLkBfoooqQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK5HxT/AMhOP/riP/Qmrrq5HxT/AMhOP/riP/QmrrwX8UGYlFFFeuIK820D/k6G3/4F/wCkRr0mvNtA/wCTobf/AIF/6RGuLHfw16/5gfSVFFFeUMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAormfFHj7w34PjJ1fUo0nxlbaP55m9PlHT6nA968d1n49eIdcuHs/B%2bimBegnlTzpceu37i/juoGk27I%2bhJporeJpZpEjiUZZ3YAKPcmuK1n4v8AgfRNyya3FdSj/lnZAzZ/4Evy/ma8Km8KeLvFUouPE%2buzEZyI5JDKV%2bighV/Ctew%2bHOgWeDNFLduO8z8fkMD880HXTwNafS3qcX8QPFs3irxLd6qS4ikby7VH6xxD7ox2Pc%2b5Nc/4d1y68N%2bIbHWbMjz7SUSAE8MOjKfYgkH61Nr1g9jfT27KQYJGXHt2P8qxaDkkmnZn3L4W8UaZ4u0OHVdLmDxSDDxkjfE/dGHYj/6/etqvhbQfEus%2bGL77ZouoTWc5GGMZ4cejKeGH1Br0W3/aJ8ZQwhJLXR52HWSS3kDH/vlwP0oEfUlFfMH/AA0d4w/6Buh/9%2bJv/jtZmsfHjxtq1sYIp7PTlYYZrKEqxH%2b87MR9RigD1j42fES20Dw/ceHrC4V9Wv4zHIqnJt4mHzE%2bhI4A98%2bmfl2KRonDL/8ArpZp5bmd555XllkYs8jsWZiepJPJNMALEADJNAHvXwR8eWWkpd6NrOow2tnJia1kuJAiK54Zdx4GeD%2bB9a9/guIbqFZreaOaJuVeNgyn6EV8d%2bFfC0XiHz4rp5UghjHzxEA7z06jpgGtuLwf4p8MTm68L65KpBzsSQxFvYjO1vxoOiOFqyhzxV0fV1FfOmj/AB18T%2bHp0s/F%2bj/akzjz0TyZSPX%2b434Y%2btexeFfiH4Z8Yoo0nUUNzjLWk3yTL/wE9ceq5HvQYNNOzOpooooEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBz/jv/AJJ54l/7BV1/6KavEvg1/wAihd/9f7/%2bi469t8d/8k88S/8AYKuv/RTV4l8Gv%2bRQu/8Ar/f/ANFx114L%2bKDPRKKKK9cQV2%2bgf8gS3/4F/wChGuIrt9A/5Alv/wAC/wDQjXFjv4a9f8wNKiiivKGFUr2wjvFBztkHRqu0VlWowrQcKiumOMnF3Rzcmk3aHiMOPVWFSQaPcOwMuI1785P6V0FFeVHIcKpczu12v/wLmzxE7EUECW8QjjGFFS0UV7EYqKUYqyRg3cKKKKoAooooAKKKKACiiigArz/42/8AJIdd/wC3f/0ojr0CvP8A42/8kh13/t3/APSiOgA%2bCX/JIdC/7eP/AEokr0CvP/gl/wAkh0L/ALeP/SiSvQKACiiigAooooA%2bf/jL/wAlk8G/9u//AKUGvoCvn/4y/wDJZPBv/bv/AOlBr6AoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPm/wAN/wDJwnif/fuv/Ri169XjvgKT%2b1PjT4q1NTmHfclSP9qYbf0Br2KvjM8f%2b1/JHdh/gCiiivGNgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRUc7MkEjIu5wp2gdzQBip/p3iBm6pEc/l/9et6snRLZ4Y5ZJFZXZsYYYOB/wDrrWrau1zcq2QkFFFFYjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAQgEYPQ1iaIfKu7m3PUf0OP61uVTj0%2bKK9e6Vm3tnjtzWsJpRlF9RMuUUUVkMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArkfFP/ITj/64j/0Jq66uR8U/8hOP/riP/QmrrwX8UGYlFFFeuIK800txZftM2U0vCynav/ArUoP1r0uvKfihFcaH4n0PxVaL80EiD0%2beNt65%2boyP%2bA1yY2N6XoB9P0VS0nU7bWtItNTs33211EssbexGcH37GrteQMKKKKACiiigAooooAKKKKACiiigAooooAKKK8/%2bI3xU0vwJbm2QLeay65jtFbhB2aQ9h7dT%2btAHWa94h0nwzpr3%2bsX0Vpbr0Lnlj6KByx9hXgniX4z%2bJPF13JpXguzmsrY8G4wPPYeu7pGPxz71zsek%2bIfiHqY1vxTeTLbnmKP7vynsi9EX37%2b/Wu90/TbPS7Vbayt0hiXso6%2b5PUn60Hfh8DKp709EcZpHw3i843mvXT3lw53NGrHaT33N1b9K7e1s7axgWC1gjhiXokahR%2blTUUj2KVCnSVoIKKKKDU5Pxf4VOrr9ts1X7Wi4ZDx5q/415Nd6dJBK6FGR1OGjcYINfQtZ2qaFp2sLi8t1ZwOJF%2bVx%2bIpnn4nAqo%2beGjPnxlZDhgQfekr1a%2b%2bGxOTZXqsOyXC/1H%2bFYU/w81dCdtpDL/1zlA/nig8yWErR3icNRXZj4f61n/kGf%2bR0/wDiqu2vw51RyPMW1gHcu%2b4/oDQSsNWf2X9xwccMkp%2bVSfftW9ofh661S7EVrHvf%2bOQ/cQepNeg6f8PLKBg99cSXJH8CjYv%2bP8q6y2tbeygWC2hSKJeioMCg7KOXTbvU0RV0bSINF05LSD5sfM7kcu3c1oUUUj2IxUVyrYiuLaC7hMNzDHNE3VJFDA/ga4nWPhtbSP8AatEuHsrlTuVCx2Z9j1X9a7uigzq0adVWmjlvDvxg8U%2bCruPTPF9rNqFkOFnY/vlX1V%2bkn4nPvXvnh3xNpHirTE1DRr2O5hP3gOGjP91l6qfrXkl9YWupWrW15Ak8LdVcfqPQ%2b9cBcaBr3gTU/wC3fCd5PsTl4xywX0Zejr%2bH%2bNM8jEYCVP3oar8T6xorzj4b/FrTfHES2N0EstbVctbk/JNjq0ZP/oPUe4Ga9HoPPCiiigAooooAKKKKACiiigAooooAKKKKACiiigDm/iDMkHw68SPIcKdNuE/Fo2UfqRXjHwcRk8HXBIwHvnYe42IP5g1137QXiRNN8Ex6Kkg%2b06pKAyg8iJCGJ/762D35qn4I0ltF8H6dZyLtm8vzJQRyGY7iD7jOPwrswUW6l%2bwmdBRRRXrAFdvoH/IEt/8AgX/oRriK7fQP%2bQJb/wDAv/QjXFjv4a9f8wNKiiivKGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXn/xt/5JDrv/AG7/APpRHXoFef8Axt/5JDrv/bv/AOlEdAB8Ev8AkkOhf9vH/pRJXoFef/BL/kkOhf8Abx/6USV6BQAUUUUAFFFFAHz/APGX/ksng3/t3/8ASg19AV8//GX/AJLJ4N/7d/8A0oNfQFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXP8AjbxAnhfwZqurs2HggPk%2b8rfKg/76IroK%2bdvjJ4lm8Z%2bLLHwNob%2bakE/%2bkMpyrTdCDjsg3Z98%2blKUlFNvZBuP%2bB%2bkvb6Bf6tKDuvZgiE91TPP/fTMP%2bA16pVHRtKg0TRrTTLUfubaIRqT1bHUn3Jyfxq9X59jK/1ivKr3f4dD0oR5YpBRRRXKUFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRR0rzXxX8X9O0iZ7HRoRqV6p2lwcRKfTI5Y/T863oYariJctJXYpSUVdnpVFeKR3Xxd8SfvoY30%2bBuQCiQAfTd89PbSvjBYDzor9rggcoJon/AEYYrt/sy2kqsE/Uz9r/AHWe0UV43p3xc1nRb0WPjDRpIz0MscZjkA9Sp4YfTFesaVq1hrdhHfabcx3Fu/R0PQ%2bhHUH2Nc2JwVbD2c1o%2bq1RcZxlsXKKKK5CgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigByffX612Fcen31%2btdhX0/Du1T5fqcuJ6BRRRX0pyhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVX%2b1wfafsxk/ff3cH600m9gLFFFFIAooooAKKKKACiiigAooooAKKKKACiiqeo6pYaPZNeale29pbLwZZ5Ai59Mnv7UAXKK5fS/iL4Q1m9FnYeILKW5Ztqxlyhc%2bi7gN34V1FABRRRQAUUUUAFFFFAHz34z8R%2bJ/iN8Q7jwV4XvGtLC0ZknkSQoH2cO8jDnaG%2bUAdTj14z9b%2bEniv4eac/iTQPEb3ElqvnXIhRoXUD7xxuIcDuD2zwa1Pg1/yWTxl/28f%2blAr27xAqv4b1RGAKtaSgg9xsNAHPfDLxofHPg%2bLUZkRL2GQ290qdN4AO4D0IIP5jtXZ14h%2bzYx/wCEc1tcnaLtCBnjOz/6wr2%2bgAooooAKKKKACiiqWqavp2iWTXmqX1vZ24ODJPIEGfQZ6n2oAu0VzOkfEHwlrt4LTTdfsprljtWIvsZz6KGxu/DNdNQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRUF20iWsrREeYq5GRmmld2AnorP0m7e7tSZG3SI2CfUdq0KcouMnFgFFFFSAUUUUAFFFFABRRRQAUUUUAZ%2bsalHpOmTXb4JUYRT/ABMegql4X1r%2b2dNzKw%2b0wnbL2z6H8f8AGuP8Zaz/AGjqf2WFs29sSvHRn7n%2bn5%2btZ3h/Vm0fVY7jJ8lvklX1U/4dajm1PWhgL4a/2nr/AMA9eopiOsiK6MGVhkEdCKfVnkhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyPin/kJx/8AXEf%2bhNXXVyPin/kJx/8AXEf%2bhNXXgv4oMxKKKK9cQVleJNDg8R6Fc6bOceYMxvj7jjlW/P8ATNatFJpNWYHn/wAIvHkng/VZvBHid/s8AmItppGwsLnnaSf4G6g9Mn34%2biOv0rw3xn4Hs/FlqHyLfUIhiK4A6j%2b63qP5foea8PfEnxf8MZI9I8R2MmoaWnyxMzfMq/8ATOTow/2T04HFeNXw8qT8hn0xRXAaN8ZvA%2bsxqf7YWxlI5ivUMRX/AIFyv5Guji8ZeFplJi8SaPIBwSt9Ecf%2bPVzgblFY/wDwlnhv/oYNK/8AA2P/ABo/4Szw3/0MGlf%2bBsf%2bNAGxRWP/AMJZ4b/6GDSv/A2P/Gj/AISzw3/0MGlf%2bBsf%2bNAGxRWP/wAJZ4b/AOhg0r/wNj/xo/4Szw3/ANDBpX/gbH/jQBsUVj/8JZ4b/wChg0r/AMDY/wDGj/hLPDf/AEMGlf8AgbH/AI0AbFFY/wDwlnhv/oYNK/8AA2P/ABrjPiP8WNL8L%2bHidGvrO%2b1W5ykCwyrIsXq7YJ6dgep9s0AVfit8WE8IodG0UpPr0qjJxuW2B6Ejux7D8T2B8t8L%2bDJZbg634jL3F/MxlEUx3EE87nz1b27fXpT8G6fYm4bxDrmqW8uoTMZEWa4UspPV2yc7j%2bn16d3/AG1pX/QTs/8Av%2bv%2bNI9XB4WK/eVPki9RVH%2b2tK/6Cdn/AN/1/wAaP7a0r/oJ2f8A3/X/ABoPV549y9RVH%2b2tK/6Cdn/3/X/Gj%2b2tK/6Cdn/3/X/GgOePcvUVR/trSv8AoJ2f/f8AX/Gj%2b2tK/wCgnZ/9/wBf8aA549y9RVH%2b2tK/6Cdn/wB/1/xo/trSv%2bgnZ/8Af9f8aA549y9RVH%2b2tK/6Cdn/AN/1/wAaP7a0r/oJ2f8A3/X/ABoDnj3L1FUf7a0r/oJ2f/f9f8aP7a0r/oJ2f/f9f8aA549y9RVH%2b2tK/wCgnZ/9/wBf8aP7a0r/AKCdn/3/AF/xoDnj3L1FUf7a0r/oJ2f/AH/X/Gj%2b2tK/6Cdn/wB/1/xoDnj3L1FUf7a0r/oJ2f8A3/X/ABo/trSv%2bgnZ/wDf9f8AGgOePcvUVR/trSv%2bgnZ/9/1/xo/trSv%2bgnZ/9/1/xoDnj3OU8VeCWmmGsaCTb6hEwkKRtt3MOdykdGz/AJB6%2bj/Cj4sjxIE0DxC4h1yL5UkYbRc47Y7OO479R3FYf9taV/0E7P8A7/r/AI1xHjXTdOuWGuaPqdrFqVuRIwiuFDPt5DLg53DH4/WmeXjMLCSdSnv2Pq%2bivLfhh8WdP8SaB5GvX9rZ6taAJK08ixrOvZxkgZ9QO/sRXdf8JZ4b/wChg0r/AMDY/wDGg8k2KKx/%2bEs8N/8AQwaV/wCBsf8AjR/wlnhv/oYNK/8AA2P/ABoA2KKx/wDhLPDf/QwaV/4Gx/40f8JZ4b/6GDSv/A2P/GgDYorH/wCEs8N/9DBpX/gbH/jR/wAJZ4b/AOhg0r/wNj/xoA2KKx/%2bEs8N/wDQwaV/4Gx/40f8JZ4b/wChg0r/AMDY/wDGgDYorH/4Szw3/wBDBpX/AIGx/wCNVLnx74QtFYzeJ9IBXqq3kbN%2bQOaAOjrL8QeINN8MaNPquq3AhtYRyerO3ZVHcnsK828S/tA%2bGdMjePRY5tWucYVgpihB92YZP4D8a82/szxd8VdVi1TxJO9rpi8xRhdiqp7RIfXj5j19TjFXCEpu0UAaWb/4q/EGbxLqkRTTbVgI4jyqheUiB79dzH3PTIr12qunadaaVYRWVlCsNvEMIi/zPqatV7FCiqUbdRBRRRW4BXb6B/yBLf8A4F/6Ea4iu30D/kCW/wDwL/0I1xY7%2bGvX/MDSoooryhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV5/8bf8AkkOu/wDbv/6UR16BXn/xt/5JDrv/AG7/APpRHQAfBL/kkOhf9vH/AKUSV6BXn/wS/wCSQ6F/28f%2blElegUAFFFFABRRRQB8//GX/AJLJ4N/7d/8A0oNfQFfP/wAZf%2bSyeDf%2b3f8A9KDX0BQAUUUUAFFFISFBJOAO5oAWiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/go%2b32f/P3B/38FAFiiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/go%2b32f/P3B/38FAFiiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/go%2b32f/P3B/38FAFiiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/go%2b32f/P3B/38FAFiiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/go%2b32f/P3B/38FAFiiq/2%2bz/5%2b4P%2b/go%2b32f/AD9wf9/BQBYoqv8Ab7P/AJ%2b4P%2b/gqtc6/o1kpa61axgA5JluUXH5mgDRorz3XfjT4I0RHC6p/aEw6RWKGTP/AALhP1ry3V/iR44%2bJkj6Z4Y0%2bTTtOY7JXif5iP8Abl4CjHZcHqOamc4wjzSdkNJvRHYfFT4vR6Skvh3wxMbjWJT5UlxD8wtyTjauOsnbjp9eKz/hl4CbwzZtqepLnVrpcFTz5Cdduf7x4yfw7cz%2bBvhnp/hTbe3TLearj/WkfJF6hB/U8/TNd3XymaZsq69jR%2bHq%2b/8AwDro0eX3pbhRRRXgHQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRVPV9QTSdGvdRkGVtYHmI9dqk4ppOTSQHmHxO8X317qieDPD5ZrmciO5eM8kt0jB7DHLH8PWun8EfDvTfCdrHPKkd1qrDMlwwyEPomeg9%2bp/SuQ%2bDGktqN9qvim%2b/e3LSmKN2/vt80jfXlR%2bJr2OvWx1X6uvqdLRL4n3f8AkZU1ze%2bwoooryDUz9Z0PTdfsGstTtY7iFum4cqfVT1B%2bleKzQ6r8HfF0csbyXWh3bYI/56J3B7CRex7/AIkD3que8b%2bH4/EnhK%2bsSgacIZbc45EijK4%2bvT6E16GBxfspeyqa05aNfqZ1IXV1ujbs7uC/s4bu1kElvOgkjcdGUjINTV5j8Etae%2b8M3WmStuawlGz2R8kD/voNXp1c%2bKoPD1pUn0KhLmimFFFFc5QUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFADk%2b%2bv1rsK49Pvr9a7Cvp%2bHdqny/U5cT0CiiivpTlCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArCsP9I12ebsu7B/QfpW2%2b7Y23lscfWszR7Oa1ExmTazEAc56f/rram0oSfUTNWiiisRhRRRQAUUUUAFFFFABRRRQAUUUUAFfNupWt98Y/jJfaPPeSwaNpTSLhP4I0YIxUHjc7Y5PQeuMV9JV85arLN8Jvju2qSA/2NrDM8j448uRgXA90fBx6Y9aAOg8YfAHRR4enuPDX2uLU7eMukTyeYLjAyV9mPbHGe3prfA7xzL4l8OyaPqU7SappmF3SH55YTwrH1IPyn/gOeTXqqOsiK6MGRhkMpyCPUV86eN7Sf4UfF6z8VafGw0rUXMksadDkjzo/1DD3I/u0AfRtFQWl3Bf2UF5ayLLbzxrLG69GVhkEfhU9ABRRRQAUUUUAfP8A8Gv%2bSyeMv%2b3j/wBKBXuGu/8AIvan/wBekv8A6Aa8P%2bDX/JZPGX/bx/6UCvcNd/5F7U/%2bvSX/ANANAHj/AOzX/wAi7rn/AF9p/wCgV7hXh/7Nf/Iu65/19p/6BXuFABRRRQAUUUUARzSxwQvNM6pHGpZ3Y4Cgckmvmy1tLz47fEu7lnuZ4PD1gPkC8FIycKqg8B3wSSc9D6AV23x88ZHSvD0XhqyfN9qg/ehD8yQA9Mf7R4%2bgaut%2bF/g1fBfgu2spEAv7j/SLxsc%2bYw%2b79FGB%2bBPegDz7x58CtFsPDF1qnhyS5t7ywiacxyS71mVRluvIbAJGOO2OeOv%2bC3iq78U%2bA0bUJWmvLGY2ryt96RQqlWJ7nBwT1OMnrVf43%2bMV8N%2bCpNOgfF/qytbpj%2bGL/lo35HaP972q58GvCs3hb4f263Slbu/c3kqHqgYAKv12gE%2b5NAHoVFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUdaKKAMGx/wBB1mS3PCOcD%2bYreqBrWB5xO8YMijhj2qetKk1NpiQUUUVmMKKKKACiiigAooooAKwfFOsf2TpTeW2LmfKRY7erfh/PFbbuqIXcgKoySewryXxDqzaxqsk4J8lfkiHoo7/j1qZOyO3A4f21S72RlUUUVmfRnoXgfWPtNo2mzPmWAZjz3T0/D%2borsK8WsL2XTr6G7hPzxNnHqO4P1FewWV5Ff2cV1AcxyLuHt7VpF30PAzHD%2bznzrZ/mWaKKKo84KKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK5HxT/yE4/8AriP/AEJq66uR8U/8hOP/AK4j/wBCauvBfxQZiUUUV64gooooAKiuLaC7gaC5gjmhb70ciBlP1B4qWikBxl/8LfC18xZLSW1Y9TbykD8jkD8qyn%2bDGhFvk1DUVGOjMh/9lFekUVk8PSf2QPNf%2bFL6L/0Er/8ANP8A4mj/AIUvov8A0Er/APNP/ia9KopfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelUUfVqX8oHmv/Cl9F/6CV/8Amn/xNH/Cl9F/6CV/%2baf/ABNelVFcXVvZwma5nihiHV5XCgfiaPq1LsB51/wpfRf%2bglf/AJp/8TR/wpfRf%2bglf/mn/wATXYp4u8OSSeWuuaeWJwP9IXn8c1ro6yIHRgytyGU5BpKhReyA83/4Uvov/QSv/wA0/wDiaP8AhS%2bi/wDQSv8A80/%2bJr0qin9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E0f8KX0X/oJX/5p/8AE16VRR9Wpfygea/8KX0X/oJX/wCaf/E1ND8G/DyFTJd6jIR1HmIAf/HM/rXolFH1al/KBz%2bk%2bCPDuiustppkRmXkSy5kYH1BbOPwxXQUUVrGKirJAFFFFUAUUUUAFdvoH/IEt/8AgX/oRriK7fQP%2bQJb/wDAv/QjXFjv4a9f8wNKiiivKGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXn/xt/5JDrv/AG7/APpRHXoFef8Axt/5JDrv/bv/AOlEdAB8Ev8AkkOhf9vH/pRJXoFef/BL/kkOhf8Abx/6USV6BQAUUUUAFFFFAHz/APGX/ksng3/t3/8ASg19AV8//GX/AJLJ4N/7d/8A0oNfQFABRRVe8vLbTrKa8vJ0gtoULySyHCqo6kmgCWWWOGJ5ZXWONFLM7nAUDkknsK%2be/HPxF1f4jax/whvgaOV7SXKTzr8pnAPJz/DF6k4zn8DW8U%2bMNf8AjHr/APwi3hOKSPRVYNLI2V8xQf8AWSnsgPRep9zgD2XwL4C0rwJpAtLFPNupObi8dQHlP9FHYf1yaAPL4P2aYTBGbjxNIJto3iO0BUN3wS2cU/8A4Zos/wDoZ5//AADH/wAXXvFFAHg//DNFn/0M8/8A4Bj/AOLo/wCGaLP/AKGef/wDH/xde8UUAeD/APDNFn/0M8//AIBj/wCLo/4Zos/%2bhnn/APAMf/F17xRQB4P/AMM0Wf8A0M8//gGP/i6P%2bGaLP/oZ5/8AwDH/AMXXvFFAHg//AAzRZ/8AQzz/APgGP/i6P%2bGaLP8A6Gef/wAAx/8AF17xRQB4P/wzRZ/9DPP/AOAY/wDi6P8Ahmiz/wChnn/8Ax/8XXvFFAHg/wDwzRZ/9DPP/wCAY/8Ai6P%2bGaLP/oZ5/wDwDH/xde8UUAeD/wDDNFn/ANDPP/4Bj/4uj/hmiz/6Gef/AMAx/wDF17xRQB4P/wAM0Wf/AEM8/wD4Bj/4uj/hmiz/AOhnn/8AAMf/ABde8UUAeD/8M0Wf/Qzz/wDgGP8A4uj/AIZos/8AoZ5//AMf/F17xRQB4P8A8M0Wf/Qzz/8AgGP/AIuvPPil8NIfh3/ZXlapJffbvOzvhEezZs9znO/9K%2bu6%2bf8A9pr/AJlb/t7/APaNAGb/AMKGtf8AoPzf%2bAw/%2bKqaD4Eaap/0jWruQZ/giVOPxzXrVFfCvNsY/t/gv8j0PYw7HEaX8JvCWlurtZSXsi9Gu5N4/FQAp/EV2cEENrCkNvFHFEgwqRqFVR7AVJRXHVr1azvUk36lqKjsgooorEYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXK/EkuPh3rJjznyR0GeN65/TNdVWb4g03%2b2PDuo6cMbrm3eNc9mIOD%2beK2w81CrGT2TX5ikrpo5T4OrGvw8timNzTyl/rux/ICu9ryP4I6wFtNS8Pz5S4glNwiN1wcKw/Agf8AfVeuV05lBwxc0%2brv9%2bpNJ3ggooorgLCiisnxPrUfh7w3f6pIwBgiJjB/ic8KPxJFVCDnJRjuwbsrnl3wbwni7xJHF/qgOAORxIcfpXs9eU/A3SpIdF1LVpQf9LmWNCe4TOT%2bbEf8Br1avQzaSeLlbpZfcjOivcQUUUV5poFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQA5Pvr9a7CuPT76/Wuwr6fh3ap8v1OXE9Aooor6U5QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKr3V3FaKrTEgMcDAzUyMHQOOjDIp2drgOooopAFFFFABRRRQAUUUUAFFFFABRRRQAVwXxb8F/8Jl4Lnjt492pWWbi0x1YgfMn/Ah%2boWu9ooA8o%2bBXjT%2b3/Ch0W7kzqGkgRjd1eDoh/D7p%2bi%2btdZ8RPCMfjXwdeaXtX7UB51o7fwSr057A8qfZjXjfjG1m%2bEnxgtPE1jGw0jUXZ5Io%2bhBI86P06kOB06elfRNtcw3lrDdW8iywTIskbr0ZSMgj6igDxv4BeLpLjTrrwhqJZb3Tiz26yfe8vOGT6qx/Jvavaq%2bePixpd34A%2bI2m%2bPdIj/c3M2ZlAwolAwyk%2bki5/HdXvWkapa63pFpqdjIJLa6iWWNh6EdD7jofegC7RRRQAUUUUAfP/wAGv%2bSyeMv%2b3j/0oFe4a7/yL2p/9ekv/oBrwj4Y3kGhfHbxNYak4t57uS4ih3nAd/NDgZ915Hr%2bNey%2bOdas9A8F6te3syRr9mkSMMeZHZSFUepJoA8x/Zr/AORd1z/r7T/0CvcK8Y/Zxs5YfB2p3bqRHcXu1MjqFQZI/E4/CvZ6ACiiigAqtf31tpmn3N/eSiK2to2llc/wqBkmrNeIfHvxXM0dl4J0rdJeX7o9wkfUqWxHH9Wbn8B60AYfw6sbn4n/ABWvvGepxN9gsZA8MbdA44iT/gIG447getfREsscMTyyuqRopZmY4Cgckk1zvgPwpD4M8IWWkRhTMq%2bZcuv8czY3H6dh7AVw3x58ZHR/Dcfhyyf/AE/VRiQL95YM4P8A30fl%2bm6gDjNFjf4yfGebU7hC2g6YQyxuMqYlP7tCPV2yxHpuHavpGuJ%2bFng0eC/BdtaTJjULnFxdnuHIHyf8BGB9cnvXbUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFNLKGClgCegz1p1YWrxvbXkV7HnqAfqP8RV04c8uW4mbtFRwypPCkqH5WGRUlRsMKKKKACiiigAooooA5DxxrP2WzXToWxLOMyY7J6fj/AENeeV7JcaRp11M009lBLI3VnQEmo/7A0j/oG2v/AH7FQ4ts9TDY6lQpqHK79Tx%2bivYP7A0j/oG2v/fsUf2BpH/QNtf%2b/Ypch0f2rT/lZ4/XY%2bBtZ8m5bTJm/dy/NFns3cfiP5e9df8A2BpH/QNtf%2b/YpU0PSopFkTT7dXUhlYRjII6GmotGNfH0qtNwcWaNFFFWeSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcj4p/5Ccf/XEf%2bhNXXVyPin/kJx/9cR/6E1deC/igzEooor1xBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBi%2bKfEVv4Y0KbUJhvf7kMeceY56D6dSfYGvFrTT/E/xL1V7iSXdHGcNLISsMOf4VHr7Dn19a3/jTdyNqel2ef3SQtLj1LNj/wBl/WvTPCumw6T4X060gUACBWcgfedhlj%2bZrimnWquDeiA83l%2bCdwtuWh1yJ5scI9sVXP8AvBif0rA03WPEPw21z7Feo5ts7pLYtmORT/Eh7H3H0Ne/1wnxZ0uC88GyXzqPPspEZG74ZghH05B/4CKKuHjCPPT0aA7OwvrfU9PgvbSQPBOgdGHcH%2btWK89%2bD15JP4Rmgc5W3umWP2UgNj8yfzr0KumlPngpAFFFFaAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFdvoH/IEt/wDgX/oRriK7fQP%2bQJb/APAv/QjXFjv4a9f8wNKiiivKGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXn/xt/wCSQ67/ANu//pRHXoFef/G3/kkOu/8Abv8A%2blEdAB8Ev%2bSQ6F/28f8ApRJXoFef/BL/AJJDoX/bx/6USV6BQAUUUUAFFFFAHz/8Zf8Aksng3/t3/wDSg19AV8//ABl/5LJ4N/7d/wD0oNe1eIvEel%2bFdHl1TV7kQW0fA7s7dlUdyfT%2blAFjV9XsNC0ufUtTuktrOBd0kj9B7AdST2A5NfPGrax4k%2bOviX%2byNHjksvDttJud3B2qOzyY%2b8x52oP8WpuPFHx68Tf8tNO8NWj%2b5SP%2bjykH8B6d/oHw94d0vwto8Wl6RbLBbR8nuzt3Zj3J9aAKvhHwfpPgvRY9N0uEDgGadgPMnb%2b8x/kOg7V0FFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV8/wD7TX/Mr/8Ab3/7Rr6Ar53%2bNcw1z4reHNAiO7yljEn%2byZJOc/8AAQpqZSUYuT6AtXY9Wooor81PUCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8V%2bIOh6h4N8WReNNET9w8u6dQPlSQ8MGA/hf%2bZPqK9M8K%2bLtM8W6atzYygTKB51ux%2beI%2b49PQ962p4Ibq3kguIklhkUq6OuQwPUEGvJNe%2bEl/puoHVfBl89vKpLC2MpRl9kf09m/M160KtHF040q75Zx0UujXZ/5mTjKDvHVHr9FeKp8QviFoH7jWdANwE4Mr2zKW/4Enyn8BT2%2bL/ie%2b/d6X4WzKeB8kk3P0UCp/sjEbxs13urB7aJ7Fc3MFlbSXN1NHDBGNzySNtVR6k14d4o1y%2b%2bKfie38P6CHGlwvuaVlOG7GVh2UDoOvPqcCdfCPj/x9OkniO7awsAdwjkAXH%2b7Evf/AHsfWvVfDPhXS/CmnfY9NhILYMsz8vKfVj/TpWkPY4D3%2bZTqdLbLz82J81TTZF3SNLttE0m102zXbb26BFB6n1J9yck/WrtFFeTKTk23uzYKKKKkAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAHJ99frXYVx6ffX612FfT8O7VPl%2bpy4noFFFFfSnKFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGJ4gYn7Og77j/KtpVCqFHYYrL1KznubuB0UGNMbuR61q1tNr2cUvMSCiiisRhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHJfEfwgnjXwZd6YAou0HnWjn%2bGVeg%2bhGVP1rhPgF4ve70m48JagSl7ppLQLJwxiJ%2bZcdcq36MPSvaK8O%2bIXw38Rab4w/4TbwNuN2z%2bbcW8eA4fGGZQeHDc5XrknrngA9M8f6LZ6/4F1eyvsLGLd5lkP/ACzdBuVs%2bxHPtmuA/Zz1G5ufBmoWUrlobS7/AHOf4QyglR7Zyf8AgRrlNT1b4xePrM6DJoMunW0w2XDi0e2WRe%2b55CePUL16YPSvZfh94Lg8C%2bFYdKjkE1wzGa5mAwHkIAOPYAAD6e9AHVUUUUAFFFFAHm3xF%2bEOm%2bOrldSguTp%2brKoVpwm5JQOgdcjkdAQenrgY4q1/Z%2b1vULyH/hJPFRntIeFWIvI%2b30BfhfyNe/UUAUdI0mx0LSrfTNNt1t7O3TZHGvYep9STyT3NXqKKACiiigAr51%2bGNtH4p%2bOGv6xqrCS6snlmhibnDb9innsi8D8PSvoqvCPG/wAOvFPh3xrL4z8CFpHncyT20eC6M33/AJTw6MecdcnpxmgD2%2b%2bvbfTrC4vruQRW9vG0srnoqqMk/kK%2be/AFlcfFP4tX3i/Uo2Om2EgeGNugI/1Mf4Abj7j/AGqj1W8%2bL3xJgTQ7nQpNMs3YCdjavao4Hd2kJJHfC/ka9s8DeELXwT4VttHt2Eki5kuJgMebKfvN9OgHsBQB0lFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABUNzAtzbvC/Rh19DU1FCdndAZWjx3MCywzRkRg/KT698e1atFFVOXPLmAKKKKkAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArl/FUZFxby9ipX8j/8AXrqKzNcszeacwQZkj%2bdR6%2bo/KtsPNQqpsDiaKKK9wQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeUfGbSJHisNYjUskeYJT/AHcnKn8936V0/wAPPFNtr3h63tmlUahaRiKaInlgvAceoIxn3zXU3tlbajZTWd3EstvMu10boRXjWufC3W9Gvftnh6Z7iJW3Jsk8uaL8cjP1Bz7Vx1Izp1PaRV09wPbK8s%2bLfii3Fgvh%2b1lV55HD3O05CKOQp9ycH8PeuZf/AIWZcxfZWGtbTx0K5%2brcfzre8JfCicXaX/iMrhW3C0VtxY/7ZHGPYZz/ADmdWdZckI2v3A6j4X6PJpPg2Jp0KS3khuCpHIUgBf0AP412dAAAAAorrhBQioroAUUUVYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXd6REYtJtlPXZu/Pn%2btcdp9m19exwDOCcsR2XvXfABVAAwBwMV52PmtIALRRRXnDCiiigAooooAKKKKACiiigAooooAKKKKACiiigArz/AONv/JIdd/7d/wD0ojr0CvP/AI2/8kh13/t3/wDSiOgA%2bCX/ACSHQv8At4/9KJK9Arz/AOCX/JIdC/7eP/SiSvQKACiiigAooooA%2bdfjxfLpnxO8NX7oXS1gimKqeWCzMcfpVTStG8S/HTxMdX1h5LHw5buQiKTtUd0iz95jj5n/APrLXpXjb4Xjxz4%2b03UNQlCaNaWgSVEbEkz72Owf3RgjJ/Aeo9Ds7O206yhs7OBILaFAkcUYwqqOgAoAh0jSLDQtLg03TLVLazgXbHGnQe5PUk9yeTV6iigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAILy7gsLKe8upFit4I2kkkboqgZJP4V83eAvP8AG/xS1bxhcowgidmiDc7Sw2xr/wABQfyrc%2bNXjuXV7xPAfh0m4mllVL1oudzZyIgfY8t6Yx611ng7w1D4U8N2%2bmRkNKPnnkH8ch6n6dAPYCvHznFqjQdNfFLT5df8jehDmlfsb1FFFfFnaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAPjG6VAO7CuvrltPj82/hX0bd%2bXNdTX1XD0Gqc592vw/4c5MS9Ugooor6I5gooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKrPfQpdrbEt5jdOOKs02mtwCiiikAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRXKeL/AIieHfBMOdVvN10wylnAN8r/AIdh7kgV45ffFL4gePbh7XwlpzafZZ2mWMAvj/albCr9Fwfc1M5xguaTshpN7H0FqOq6dpEHn6jf21nF/fuJVjH5kiuL1H40%2bA9PYoda%2b0uP4baB3H/fWNv615ZZfBi/1Of7b4o8QTTXD/fERMjn/to/%2bBrrLD4T%2bD7IDdpzXLj%2bO4mZv0BA/SvKq53hKbsm5ei/zsaxoTZZl/aL8HoxCWOtSccFYIwP1kzTIv2jvCbBfN03WkYnnEUTAfj5n9K04vBnheFdq%2bHtLI9WtEY/mRmny%2bEfDc2TJ4f0ti3U/Y48/njNcv8ArDS/kZf1Z9x9h8dPAd6wWTUZ7QnoLi2f%2bagiuz0nxNoevLnSdXsr3jJWCZWYfVeo/EV5pe/DDwffA79GjiY9Ggdo8fgDj9K5LU/gdahvO0TWLi2lU5VbgBhn/eXBH5GuilnuFm7SvH1X%2bVyXh5rY%2bjaK%2baYvFHxS%2bG%2bP7Qzq2lR9WmJnQD/roPnX23ce1epeCvjH4b8XtHaSSHTNTbAFtcsMOfRH6N9Dg%2b1erTqwqx5oO68jFpp2Z6JRRRWggooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArMvdSks7yNGjHkHq3c/T6Vp1WvbRby3MbcHqrehq6bipe9sJk6sHUMpBBGQRTqw9Kunt5jYXAIIOEz2PpW5RUg4SsNMKKKKgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDlNd0ZoXa7tlzETl1A%2b6fX6Vg16TWLf%2bHba5JkgPkSHqAMqfw7V6FDGJLlqfeByFFas3h3UIj8sayj1Rh/XFQf2PqH/AD6SV3KtTe0kIo0Ve/sfUP8An0k/Kj%2bx9Q/59JPyp%2b0h3QFGir39j6h/z6SflR/Y%2bof8%2bkn5Ue0h3QFGir39j6h/z6SflR/Y%2bof8%2bkn5Ue0h3QFGip1s7h5vKSFjJkjaPap/7H1D/n0k/Khzit2BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uf2PqH/PpJ%2bVHtId0BRoq9/Y%2bof8%2bkn5Uq6LqLHAtX/Egf1pe1h3QFCnxRPNIscaFnY4AHetm28MXUhBndIl7gfMf8K6Gx0y209cQp8x6u3JNYVcZCK93VgQaRpa6dAS2Gnf77ensK06KK8qcnOXNIYUUUVIBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV5/8bf8AkkOu/wDbv/6UR16BXn/xt/5JDrv/AG7/APpRHQAfBL/kkOhf9vH/AKUSV6BXn/wS/wCSQ6F/28f%2blElegUAFFFFABRTJZY4YnlldY40UszucBQOSSewrx7Vf2ifDtjqc9tZ6deX0EbbVuEZUWT3APOKAPZKK8P8A%2bGlNH/6F%2b%2b/7/JR/w0po/wD0L99/3%2bSgD3CivD/%2bGlNH/wChfvv%2b/wAlH/DSmj/9C/ff9/koA9worw//AIaU0f8A6F%2b%2b/wC/yUf8NKaP/wBC/ff9/koA9worw/8A4aU0f/oX77/v8lH/AA0po/8A0L99/wB/koA9worw/wD4aU0f/oX77/v8lH/DSmj/APQv33/f5KAPcKK8P/4aU0f/AKF%2b%2b/7/ACUf8NKaP/0L99/3%2bSgD3CivD/8AhpTR/wDoX77/AL/JR/w0po//AEL99/3%2bSgD3CivD/wDhpTR/%2bhfvv%2b/yUf8ADSmj/wDQv33/AH%2bSgD3CivD/APhpTR/%2bhfvv%2b/yUf8NKaP8A9C/ff9/koA9worw//hpTR/8AoX77/v8AJR/w0po//Qv33/f5KAPcKK8P/wCGlNH/AOhfvv8Av8lH/DSmj/8AQv33/f5KAPcKK8Of9pTSghKeHr0t2DTqB%2beDWVcfH3xPrOYfDnhVFc8AnfcsPwUKP50m0ldgfQF1dW9lbSXN1PHBBGNzySsFVR6kngV4X4%2b%2bNM2pzN4d8CLNPcTExPfRodx9REOv/Aj%2bHrXPyeDviF4/uEn8Waq9raA7likYHb/uxJhQfrg16P4X8FaL4Tg26fb7rhhiS5l%2baR/x7D2FeTi84oUFaD5peW33m0KEpb6GD8Ovh3H4Xh/tLUts2szKcnO4QA9VB7n1P4Djr39FFfIV69SvUdSo7tnbGKirIKKKKxGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUU%2bGJp5VjQZZjgVUYuTSW7DY1dEg5ecj/AGV/r/StqooIVt4EiXoo/Opa%2b%2bwOG%2brUI0%2bvX1POqT5pNhRRRXYQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGHc/wDIxw/8B/lW5WVPZzvrMdyqjylxk5rVraq01G3YSCiiisRhRRRQAVna5rVj4d0W71bUpfKtLZN7sBknsAB3JJAHua0a8q/aDW5b4aAwZ8tb6I3GP7mGA/8AHilAHHr8WviP4tvJ5vCPh5RYRNtGIDKf%2bBOSFz7CnL8cPG3h87PE/hABV4LGKW1J/FgwP4CvTvhNLpsvwx0MaYU8tLcLMF6ib/lpn33ZP0Irs2UOpVgCpGCCOCKAPItL/aJ8K3YVdQs9RsHPU7FlQfipz/47Xa6X8SPBms7RZ%2bI7As3RJpPJY/RXwf0qXVPh94Q1nJvvDunu56yJCI3P/Alwf1ridU/Z68I3mWsZ9Q09%2bwSUSIPwYE/rQB6yjpIgeNgyEZDKcg06vn1/gR4s0KRpfC/i8Ic5A3yWrH2yhYGorH4hePPhr4httN8do93ps%2bMTNtdgueWSRfvY7q3PTpmgD6HopkUqTRJLGweN1DKwPBB5BFPoAKKKKAEPH0rw/wCIHxoma%2bbw54GU3V87eW97Gu8Bu6xD%2bI/7XT0z1Gf8U/iJf%2bJtXPgfwgzyq7mK7nhP%2bubuisOiDnce/PYHPQ%2bB/ANh4Ost3y3GpyD99dFeg/ur6L/P9B5%2bPzCnhI66yey/roaU6TmzlvC/wk82c6t4wne9vZT5jW5kLDce8j5yx9s4%2btepwW8NrAkFvEkMMY2pHGoVVHoAKkor4zE4utiZc1R/LojuhCMVoFFFFcxQUUUUAFFFFAAQCMEZBrz3xd8JtI15XutLVNN1DrmNcRSH/aUdPqPyNehUVvQxFWhLnpuzFKKkrM8k8J/FDxD8PdUTw743hnnsFwI7hvnkiXoGVv8Alont1H4Yr6Esb%2b01OxhvbG4juLWZd8csbZVh7GvP/EfhrTfFGmNY6lCHXrHIvDxN/eU9v6968t8NeI9a%2bDHij%2bx9Y33Ph66fcGUHAGf9ZH6Ecbl/%2bsa%2bwy7M4YtcstJ/n6HFVpOGq2PpuioLS7t76zhu7WVJreZBJHIhyGUjIIqevVMQooooAKK89%2bK3xHXwDo8K2sSTatebhbo/3UUYy7Dv1AA7/ga84tvB/wAYvGlul1qevS6dbTgN5U1yYcqf%2bmcQ/RsUAe86lrmk6NHv1PVLOyX1uJ1j/ma4vVPjd4F0zcq6o97IP4LSBn/Jjhf1rjtN/Zts93maz4iup2blltYRH/48xbP5V2ul/BbwJpe1v7H%2b1yD%2bO7maTP1XIX9KAOIv/wBpCGSUQ6J4auLh2OENzMFJP%2b4obP51THxA%2bMuqq11ZeFzBAOirp7jI9t5y34V7rp%2bj6ZpMfl6bp1pZpjG23hWMfoBV6gDyr4Z/FxvFeoyaBr1mlhrce7aEBVZdv3l2tyrDHTJ6HpjFeq186%2bMHtrj9pbQxopVrlJ7YXpi7uGPmZx6RYB%2bhr6KoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAI/Jj87zdi%2bZjG7HOKkoqOaTyomk2s20Z2r1NGrAkoqhp%2bpJeqVI2Sjque3qKv1UouLswCiiipAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKz7/U0smVAu%2bQnlc9BV1G3orYK5GcHqKpxaSb6gNWGNZmlVFEjDBYDk1LRRUgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFef/G3/kkOu/8Abv8A%2blEdegV5/wDG3/kkOu/9u/8A6UR0AHwS/wCSQ6F/28f%2blElegV5/8Ev%2bSQ6F/wBvH/pRJXoFABVe8vLbTrKa8vJ0gtoULySyHCqo6kmodW1ew0LTJ9S1O6S2s4F3SSueB7D1PoBya%2beNW1rxL8dPEv8AY%2bjJJZeHbd8u7A7QM8PLjgscfKn/ANc0AS%2bKfGOvfGHX/wDhFvCUUkejKwMsrAr5ig/flP8ACg7L1PucAeveDvhroHhDRVsktILy5b5p7u4hVnlb8c7VHYfzJJrS8IeD9J8F6Kmm6XDjoZp2HzzP/eY/yHQdq6CgDP8A7C0f/oFWP/gOn%2bFH9haP/wBAqx/8B0/wrQooAz/7C0f/AKBVj/4Dp/hR/YWj/wDQKsf/AAHT/CtCigDP/sLR/wDoFWP/AIDp/hR/YWj/APQKsf8AwHT/AArQooAz/wCwtH/6BVj/AOA6f4Uf2Fo//QKsf/AdP8K0KKAM/wDsLR/%2bgVY/%2bA6f4Uf2Fo//AECrH/wHT/CtCigDP/sLR/8AoFWP/gOn%2bFH9haP/ANAqx/8AAdP8K0KKAM/%2bwtH/AOgVY/8AgOn%2bFH9haP8A9Aqx/wDAdP8ACtCigDP/ALC0f/oFWP8A4Dp/hUU%2blaFbJum02wUe9unP6VcvWuEtWa2UGQdsZ/KsyDSJrh/OvpWyf4c8/n2rWEItc0nZfiIbZ2mh3szxppFkNoyCbdOf0qa78NaPcwFBplkrdVYW68H8q04YIrdNkSBV9qlrGtCFRONtGNNrU4SXQtPhkMcmmWgYf9MF/wAKj/sfTP8AoHWn/fhf8K7W8sorxMNww%2b6w6iufubOa1bEi/L2YdDXxWPy%2bvhXzJtw7/wCZ306sZ%2bplf2Ppn/QOtP8Avwv%2bFH9j6Z/0DrT/AL8L/hV2ivM55dzWyKi6VpyMGXT7VWHQiFQR%2blWlVVUKoAA6ADpS0VLbe7AKKKKQBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRUkMElw%2byJCx/l9aqMZSfLFXYN23GAFmAAJJPA9a6DTbD7Km%2bQZlb/AMdHpS2OmpagO%2bHl9ew%2blaFfWZVlXsf31b4ui7f8E461bm92OwUUUV7xzhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFVrm%2bhtZESTdufpgVZptNK7AKKKKQBRRRQAVS1XS7PW9LudN1CBZ7S5QxyRt3H9D3Bq7RQB8/3PwT8Y%2bGb%2ba48E%2bJmS3Y5EbTvBIR2Vto2v9Tj6VH/wkfxw8Lg/b9JfU4l7tbLOMeuYSD%2bdfQlFAHgtl%2b0bLbS/Z9e8Lywyr98wTEEf8AcD/wBCrsdL%2bOngXUtqyX9xYO3Rbu3YfmV3KPzrv77TbDU4fJv7K2u4v7k8SyD8iK47VPg54F1Uln0KO2kP8do7RY/4CDt/SgDp9M8R6JrQ/wCJXq9jeH0guFcj6gHIrxv9onXtLudN0zQbeWOfVEuvOdYzuaJdrLtOOhYkcdfl%2blWNS/Zs0iZydM1%2b9tRnpcQrP/IpW34K%2bBmieFdTj1O%2bvJNWvITuh8yIRxI3ZtmTkjtk8emaAO%2b8L2dxp3hLRbK7z9pt7GCKXJyd6xqD%2boNa9FFABXlHxt8fyeGdETQ9MlI1bUlILIfmhhPBYe7HKj8T2r1C9u4NPsbi9upBHb28bSyOeiqoyT%2bQr5q8HRTfEf4maj4u1JCbW2kDwxNyAekSf8BAyffHrWGJrxoUpVZbIqMXJ2R2Hw08Dp4W0gXd3GP7Wu0BlJHMS9RGP0J9/pXdUUV8BXrzr1HUm9WejGKirIKKKKxGFFFFABRRRQAUUUUAFFFFABWJ4r8MWfizQ5dOugFfG6GbGTE/Zh/UdxW3RVwnKnJTi7NA0mrM8w%2bDPi698N%2bIJ/AGvts/eMLQseEk6lAf7rD5h7/71fQNfO3xj8OusFr4r0/dHd2Tqszpwdufkf6q2B%2bI9K9l8B%2bJ08YeDdP1gFRNJHsuFX%2bGVeHGOwzyPYivvcDiliqKqLfr6nnVIckrHSUUUV2EHz38dVOl/Enwtr13C02mxpGGjxkMYpi7r%2bKsK91sta0zUdLTU7S/t5rF13CdZBtx7nsfY1V8TeGNK8XaNJper2/mwMdysDh42HRlPY//AKjkGvHpP2aLY3RaLxTKtvnhGsgzgf728D9KAPTNV%2bJ/grR9wuvEdkzr1S3fzmz6YTNcVqn7Rfhm1JXTtO1C%2bYfxMFiQ/iST/wCO1c0v9n3wZZYa9N/qLdxNPsU/QIAf1rttL8C%2bFdF2nT/D%2bnQuv3ZPIVnH/Amyf1oA8d/4XP8AEDxGSvhnwiBG3R1gkuCv/AhhfzFIfDnxw8Ugi/1VtMhk6hrlIBj6Qgn86%2bg%2bn0paAPNPht8I7TwRcPql9dDUNYkUqJQpCQg/eC55JPdj%2bnOfS6KKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAxNR094ZftlnkMDllX%2bY/wq7pt/8AbYSWXbIvDYHH4VepiRpGCEUKCckAd61lU5ocslr3FYfRRRWQwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACs7U9R%2bxIFRcyuPlyOB71o0x40kKl1DFTkZHQ1UGlK8lcDK03TW3/AGu7y0h5VW7e5962KKKc5ubuwCiiioAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8/8Ajb/ySHXf%2b3f/ANKI69Arz/42/wDJIdd/7d//AEojoAPgl/ySHQv%2b3j/0okrq/EPiLTPC2jy6pq1ysFtH0/vO3ZVHdj6V5r4B8YaT4L%2bA%2bjalqkwHFwIYFI8ydvPk%2bVR/M9B3ridK0fxL8dfE39ravI9l4ctpCqIp4Ve6R/3mOBuY/wCC0AMJ8T/HvxPgb9O8N2jjIJJSP%2bjykfkPTv8AQXh3w5pfhXR4tL0i2EFtHye7O3dmPcn1/pVjSNIsNB0uDTdMtktrSBdqRp/M9yT1JPJq9QAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVl6nfy2zLBBGTI44bH8veqhBzdkBYvNQhs1%2bc7nPRF61YhlWaJZEOVYZFZVlpGW8%2b9O%2bQ87Cc/n61sAADA6VVRQWkdWJC0UUVmMKKKKACmsqupVgCD1BFOopNXAzLjR4JMmImI%2bnUflVCTR7pPubHHscfzroqK8yvk%2bEqu/LZ%2bWn/ANY15o5Y6fdr1gf8Bmk%2bw3X/PvJ/3zXVUVxvh6j/O/wNPrMuxyv2G6/wCfeT/vmj7Ddf8APvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/wA%2b8n/fNH2G6/595P8Avmuqoo/1eo/zv8A%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf980fYbr/AJ95P%2b%2ba6qij/V6j/O/wD6zLscr9huv%2bfeT/AL5o%2bw3X/PvJ/wB811VFH%2br1H%2bd/gH1mXY5X7Ddf8%2b8n/fNH2G6/595P%2b%2ba6qij/AFeo/wA7/APrMuxyv2G6/wCfeT/vmj7Ddf8APvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75quwKsVbhhwQa7Kqd7p8N6vzDbJjhx1/%2bvVQ4ew9/em/wF9Zl2MEWV0RxBJ/3zR9huv%2bfeT/AL5q9Zm%2bsbtLR0MkTHg9gPUH%2blblOpw3Ri/jb%2b4FiZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qio/1eo/zv8B/WZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/wA%2b8n/fNH2G6/595P8Avmuqoo/1eo/zv8A%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf980fYbr/AJ95P%2b%2ba6qij/V6j/O/wD6zLscr9huv%2bfeT/AL5o%2bw3X/PvJ/wB811VFH%2br1H%2bd/gH1mXY5X7Ddf8%2b8n/fNH2G6/595P%2b%2ba6qij/AFeo/wA7/APrMuxyv2G6/wCfeT/vmj7Ddf8APvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75qF0aNyjqQw6g11k0qwQvK3RRmuTdzJIztyzHJryczwFLB8sYybb/I2pVJT3Q2iiivJNQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAFUFmCgZJ4AHep/sN1/wA%2b8n/fNVwSDkda6qzn%2b02qSfxEYb616eWYKli5ShOTTWplVqOCukc79huv%2bfeT/vmj7Ddf8%2b8n/fNdVRXs/wCr1H%2bd/gY/WZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/wA%2b8n/fNH2G6/595P8Avmuqoo/1eo/zv8A%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf980fYbr/AJ95P%2b%2ba6qij/V6j/O/wD6zLscr9huv%2bfeT/AL5o%2bw3X/PvJ/wB811VFH%2br1H%2bd/gH1mXY5X7Ddf8%2b8n/fNH2G6/595P%2b%2ba6qij/AFeo/wA7/APrMuxyv2G6/wCfeT/vmj7Ddf8APvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/wA%2b8n/fNH2G6/595P8Avmuqoo/1eo/zv8A%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf980fYbr/AJ95P%2b%2ba6qij/V6j/O/wD6zLscr9huv%2bfeT/AL5o%2bw3X/PvJ/wB811VFH%2br1H%2bd/gH1mXY5X7Ddf8%2b8n/fNH2G6/595P%2b%2ba6qij/AFeo/wA7/APrMuxyv2G6/wCfeT/vmj7Ddf8APvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/z7yf8AfNH2G6/595P%2b%2ba6qij/V6j/O/wAA%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlfsN1/wA%2b8n/fNH2G6/595P8Avmuqoo/1eo/zv8A%2bsy7HK/Ybr/n3k/75o%2bw3X/PvJ/3zXVUUf6vUf53%2bAfWZdjlRYXR/5d5PyqePSLt%2bqKg9Wb/Cujoq4cP4dP3pN/cJ4mRkwaJGvMzlz6LwK0o4khTbGgVfQCpKK9TD4Ohh1%2b6jb8/vMZTlLdhRRRXSSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAYfiAEG3cdt39K21IZQR0IzWfq1pJdwIsQBZXzyccYq7ArLbxq/3goDY9cVrOSdOK6q4upJRRRWQwooooAKKKKACiiigAooooAKKKKACiiigDyv4%2beIDpHw%2bNhE%2b2fVJhBwefLX5nP6Kp/3qrfDjQxoXgfT4SuJ7hPtM3rufnB%2bg2j8K5X42yNr/AMUvDnhwMTEiJvA/hMsnzf8AjqKa9VACgAAADoB2r5ziGtaMKS66/wCR1YaOrYUUUV8sdQUUUUAFFFPSKSUkRozn0UZppNuyAZRTnR422urKfRhim0NNOzAKKKKQBRRRQAUUUUAVtSsIdU0y6sLhcw3ETRP9CMfnXnfwA1ObSPEOv%2bD7xsOjGZF7B422SY%2bo2/8AfNem14/dOPDP7Rul3iny4r%2bSPIHT96phOf8AgQJr6Hh%2btarKk9mr/cc%2bJjomfSVFFFfVnGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAENyJWt3EBAlI%2bUmsmz1SS3f7NfBgRwHPUfX/Gtyq13ZQ3ibZF%2bYdGHUVrTlFLlktBE6sHUMpBB6EU6s7TbKezaRZJd0f8Kjp9fatGokknZO4woooqQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAa7rGhd2CqOpNYlzqc93L9nsVbn%2bMdT/gKtahYT3s8YWbEP8AED2P071btbSKzj2RLz3bua2i4QXM9WLcli8wRKJSDJj5iOmafRRWIwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvP/AI2/8kh13/t3/wDSiOvQKztc0Sx8RaTLpepRGWzlaNpI843bHVwD7ZUZ9qAPmv4Z/DDUvHSWV9rks8XhyzDJAhbDS/MWKx%2bi7ixLfUDnkfTtnZ22nWUNnZwJBbQoEjijGFVR0AFSRRRwQpFCixxoAqogwFA6AAdBUlABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRTWYIpZiAo5JNYc15caldiGzLJGpzu6fiaunTc/QTZvU0qCQxAJHQ46UICEAZtzAcnGMmnVAwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBMjdjPI7UtYeoQXNndG%2bhdmUn5ge3sfatKyvY72HcvDD7y%2blaSp2ipLVCuWqKKKzGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRTWYKpJOAOTQ3YDJ1u4wiW6nr8zfTtWLU11Obm5eU/xHj2FQ18Bj8T9ZxEqnTp6Ho048sUgoooriLCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK1dFuNszQN0flfr/AJ/lWVT45GilWReqnIrpwmIeHrxqrp%2bXUmceaLR19FRwyLNCki/dYZqSv0KMlJJo80KKKKYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUh4FVbO/ivS/lBhsxncPWmotq6At0UUUgCiiigAooooAKKKKACiiigAooooAKKKKAPnLVD/aH7UEu77luRgHttth/7NzXrdeSXH7j9qC9SQYLk4/G2DD9K9br5DP2/rMf8K/Nnbh/gCiiivCNwooq8ulztaCdcHIyE7kVtSoVK11TV7aicktyjW7PKNLsokhQFm7n%2bdZKWdy/3YJPxXFbcds9zp4gul2uOAc5%2bhr1cro1rVFCLUmtHb8L%2bZjWlHS%2bxBK66jpTzMoEkeefQj/61V7OwiNubm7bEfYZxxVm%2bAstPFvCjEN1fHH4mkjVNR0tIUcLJGBwfUcc12TpRniEqiUqkYbdHL9bIhNqOmiuQXllbm0F1aH5B1GT/AFrLrcltnttIMCo0kjHnaM45zWQLac/8sJP%2b%2bDXm5lh3GpFxhZtJtJaJmtKV07sioq/FpFzIhYgJ6BupqgRg4NcFXD1aSUqkWr7GiknswooorEYV438ZD9g8VeGtTB2shJ3dPuOrf%2bzV7JXjPxy/0nUfDtmuAzeb7n5jGBx%2bFepkzf12Hz/JmVf4GfTFFFFfcHAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAFG2uJJNQuYmbKJjaMdKvVmWf/IWvK064sDOUqTcnfWX5suoknoFFFFdpAUUUUAFFFFABRRRQBk/20I7t4riJkQHCtjn8RWlFLHMm%2bNwynuDTLi1huk2yxhvQ9xWV/ZN1a3Aezm%2bUnnPUD37Gtkqc1po/wFqblFFFYjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKjlnjgQvK4RfU05gSpCnBxwfSsVNIuLmXzL2Y/QHJP9BVwjF6ydhE8WsCe9SGGFmjJwWxz9celatQwW8NsmyGMKO%2bOp%2bpqaibi37qsMKKKKgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiq19qFnpls1zf3cFrbr96WeQIo/E8UAWaK4W5%2bMfgC0mMcviOFmHeKCWQfmqEVq6T8QPCWuSrFp/iCxllY4WJpPLdvorYJ/KgDpaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAMzVba6uvLjhYeUT84z39T7VbtLSOzhEcY/3mPUmrFFW5txUegWCiiioAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAQgMCCMg9jWZHpRg1ETQSbIupXv9PpWpRVRm43t1AKKKajrIuUYMM4yDUgOooooAKKKKACiiigAooooAKKKKACiiigAooooAKztXuPJtPLB%2baTj8O9aNczqVx9ovGIPyp8q15WcYn2GGaW8tP8AM2ow5pehTooor4g7gooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA29FuN0bQMeV%2bZfp3rXrlLSc211HL2B5%2bldUCCAR0r7PJMV7XD%2bze8dPl0/yOKvC0r9xaKKK9kwCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArC03/R9ZuID0bOPzyP0rdrMksJTq63cbKEGC2Tz0wf0ralJJST6oTNOiiisRhRRRQAUUVDc3MFlay3V1MkNvEpeSSRsKqjkkn0oAmorx3X/wBofw5p7yRaRZXWqSqcCQ4hiPuCct/47XNf8Jv8YPG/GgaM2nWj/dljgCAj/rrLwf8AgOKAPoC7vLWwt2uLy5ht4V6yTOEUfUniuB1342%2bCNF3JHqD6jMP%2bWdjHvH/fZwv5GuEtPgN4k164W78YeKWd%2bpVHe4f6bnwF/AEV3uh/BTwRou1m0xtRmX/lpfP5mf8AgAwn6UAcHP8AtCa1qFw39g%2bE/Nt4%2bXMjPK231OwAL%2btdv8Ovi9pvjm4Omz2x0/VgpYQF9ySgdSjYHI6kEfng16FbWtvZQLBawRQQr92OJAqj6AcV89/Ee3tNI%2bP3hy40dVivLiW2kuUhHV2lKkkDuy4z69e9AH0VRRRQB86/FFf%2bEf8AjvomsMNsN0kDO/bqY2/JcH8a9Yrj/wBobw8dQ8IWmtQpmXTJ8SEdopMAn8GCfma0fBWujxF4R0/UC%2b6YxiOf1Ei8Nn6nn8RXzPENF%2b5WXp%2bq/U6sNLeJv0UUV8ydQV0GkXQlt/JP34x%2bYrn6lt52t5llTqvb1HpXdl%2bMeFrqfR6P0IqQ542NrUrq6tGUxhPLbvjkGsmS%2bupfvTP%2bBx/KugZYr%2bzx1RxwfQ1zU0TwTNG4wyn869LOfbwkqkZtwl56f12MqHK1ZrVF6DWZ4xtlVZR6ng1I2t4U%2bVbqpPcmsmivPjmmLjHlU/yv9%2b5o6UG72L6axdqeWRvqv%2bFW7PUbu7nEYSIL1Zgp4H51jAEkADJPYV0tjarZ22GxvPLmu/K6mLxNWzqPlW%2bv4GdZQittR17dC0ty/wDEeFHvXLk5OTVvULs3dwSD%2b7XhR/Wqlcma436zWtH4Y6L9WXRp8kddwoooryzUK8d8WD/hIvjr4e0iM7ktpIBKo/3jK/8A45ivXbq5hsrSa6uHCQwo0kjH%2bFQMk/lXl/wTspvFHxF1vxjdIQkO4RZ7PIcAD/dQEfiK9/IKLlWlVeyX4v8A4Bz4iVo2PoeiiivrTjKeq6pZ6LpdzqeoTrBaWyGSWRuwH8z2A7nFeH3v7QWqXt9Kvhvwu1zaRHLPLvdyvqQnC/ma3f2ip7mLwDZxREiGbUEWYjuAjkA%2b2Rn8BXZ/DTTtM074eaKulrH5M1rHNI6DmSRlBdmPrnI9sY7UAcDof7Rmi3JEWuaTd2EnQyQsJkHuRww%2bmDXpWh%2bOPDHiTYNJ1uzuJG6Q%2bZsk/wC%2bGw36U/XPBnhvxIG/tfRbO6cjBlaPbJ%2bDjDD86811z9nTQLstJoupXenSHkJIBPGPYdGH5mgD2eivnj/hEvjJ4G50bVW1O0TpHHMJgF9PLlGR9FqzZ/H3XdFuBZ%2bL/CzxzDq0QaBwPXY4OfzFAHv1Fcj4P%2bJHhvxuGTSrp0ukG5rS4XZKB64yQR9Ca66gAooooAKKKKACiiigAooooAKQ8AnGaWigDM/tC8/6B7/mf8KP7Qvf%2bfB/1/wrTorh%2bq1/%2bfz%2b6P8Akac8f5TAt7q4S%2bnkW1Znb7yf3auf2he/8%2bD/AK/4UWf/ACFrytOuPBYetKm2qrWsui7vyLqSjfYz4by5kmVHs2RT1Ynp%2blaFFFepRpzgrTk5etv0MpNPZWCiiitiQooooAKKKKACiiigAqtercPastswEhxg5x%2bVWaKadncDBXVb2zbZeQFh64wT%2bPQ1pWupW94dkbMHxnawq0yq6lWAYHsRUMVlbwTGWKMI5GDj/CtJTpyW1n5C1LFFFUNRvJbMRmKHzAc7jg8fjURi5OyGX6KyI9fhbiSJ0PtzV62vYLvPkvuK9RgjFVKlOO6Fcs0UUVmMKKKKACiiigAooooAKKKq3N9b2hCzPhiMgAE5ppNuyAtUVjy6/EOIoXY/7RxVvT7qW7id5YvLIbA4PIq5UpxXM0K5dqjdapb2jFGLNIP4VFXqrSWVtLP50kSu%2bMc9PyqYct/eGZR1K/vSVtIdq/3gM/qeK17RZktY1nIMgHJzmpgoUYAAA6AUtVOakrRVhWCiiisxhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFISFUkkADkk9q8g8X/HfTtMu30zwxaf2xf7tnmjPkhvRccyfhgehNAHsFMeRIkLyMqKOrMcAV87O3xi8YfPc6idFtX5CK/2fA9MIDJ/30ajX4KXV84m1jxPNcS98RFz/AN9M39K4KuZ4Sk7Smvlr%2bRoqU30Pe5fEugwMBNremxk9nu0H8zVf/hNfCnm%2bV/wk%2bi%2bZnGz7fFnP03V41H8DPDwH73UdUY%2bqvGv80NWR8E/CwXHm6keMZ89f/ia5nnmEXV/cX9Xmexx%2bJ9AmbbFrmmO2M4W7jJx%2bdaMNxBcLugmjlX1Rgw/SvBH%2bBnhwr%2b71DVVb1aSMj/0AVSl%2bBVqr7rPxBcwsD8peAMR%2bRWqjneDe8mvkxewmfRtFfOS/Dzx/pRzo/jabA52vczRg/gNwP41MmtfGvw%2bCXMeqQJ2ZIpc/987XNdNPMcLU%2bGovy/Mh0prdH0PRXgdr%2b0Dq%2blyrB4n8JPC5PzNCXhI%2biSA5/wC%2bq7rQvjT4I1woh1M6fO3Hl36eX/4/yn/j1diaauiD0Kio4J4bmFJoJUlicZV42DKw9iKkpgFFFRTzw2tvJcXEiRQxKXeRzhVUckk%2blADndIkaSRlVFBLMxwAB1JNeK%2bOfj/Z6ZLLYeFYY7%2b4XKtey58lT/sgcv9cgfWuB%2bKnxcuvF1zLpOjyyW%2bhIcEj5XuiP4m7hfRfxPPA8roA6PW/HninxFKz6nrl5Kp/5ZLJ5cY%2biLhf0rDt7y6tJvOtrmaGXOd8blWz9RUFFAH0R8DPiTq%2btanL4a1u5e8Ihaa1uZTmQbSMox6sMHIJ54Ptj3Y8fSvl79n2wz4w1DWZ5FistOsWMsrnCqWIxkngDarn8Kl%2bKfxln8QvNovhyZ4NI%2b7LcAFZLn1A7qnt1PfjigDufiD8drDQ2l0zw0ItQ1Bcq9yxzBCfbH3z9OPc9K%2bedd8R6x4lvjeazqE95N2MjfKg9FUcKPYAVlUUAFFFFAHoPgj4veI/B80UEk76jpY4a0uHJ2j/pm3JX6cj2r6k8L%2bKdL8YaJFqukz%2bZC/Do3DxN3Vh2P/6xkV8NV2/wv8cTeCPFsM7yN/Zl0VhvY88bM8Pj1UnP0yO9AH2RRTVYOoZSCpGQQeCKdQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUU1yQhKruYDgZ6mgDO1a/wDs0XkxH964/wC%2bR61NpkEtvZqszksedp/hHpVHT7Kaa8e7vFIYNwpHf/AVt1vUajHkj8xLuFFFFYDCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAZJGJY2RsgMMHBwawraWTSL5reY/uXP3v5H/GugqnqNkLy3KjHmLyh/pWtKaXuy2YmW%2btLVPT4p4bNI7ggsOmOw9KuVnJWdhhRRRSAKKKKACiiigAooooAKKKKACiiigCpqFx9mtHYHDH5V%2bprmK0tYuPMuRED8sfX6ms2vic5xPtsS4raOn%2bf9eR3UIcsb9woooryTYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACui0m4860CE/NH8v4dq52rul3H2e8UE/K/yn%2blellWJ9hiU3s9GZ1oc0TpaKKK%2b6PPCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooprHapIGcDoKAHUVR0/UFvvMwmwoRxnORV6nKLi7MAooopAFeJftH6zdWmgaPpMLskF/NJJNt/iEYXCn2y%2bf%2bAivba4P4reBH8d%2bFhb2rKmpWjma1LnAc4wyE9sjHPqB2oAt%2bDPh14e8JaVaLb6fazX6xqZb50DyO%2bOSrH7oz0A9q7GvnDS/if8RvCOnR6DqHheW6ntVEUUs9vLu2jgZK8OPQjr6nrVjb8bvHQ%2bYyaLZP64tAM/nKR%2bdAHuer%2bItF0GIyatqlpZLjIE8wUt9AeT%2bFeca5%2b0H4U07cmmQ3eqyjoUTyo/8Avpuf/HTWNpH7OkMk32nxL4guLqZjukS1Xbk%2b8j5J/IV6Pofwz8HeHtrWOhWpmXpNcL5z59QXzg/TFAHkx%2bJvxS8a5XwroBs7ZzhZooN/4GWT5P0FdF8OvhHqeneJD4r8YXi3eq7i8UW8yFXPG92PUjsBwODnivY%2bn0paACiiigCnqmm22saVd6beJvtrqJoZB7MMce9fOHgS8ufh/wCP9Q8Gau%2bIZptsUh4UyfwMPZ1x%2bO33r6bryf42fD5/E2jrrmlxE6vpyElUHzTwjkqP9pTkj8R1IrDE4eOIpOlLqVGTi7o6aiuD%2bGfjpPFOkizvJQNWtVAkBPMy9A4/r7/Wu8r4CvQnQqOnNao9GMlJXQUUUViM09IvPKl8hz8jnjPY1b1e082Hz0Hzp19xWDXS6ddfa7UFuXX5W96%2bhyyrHFUZYKr8v68tzmqpwl7RHNUVYvYBb3ckY%2b6DkfQ1CiGSRUHViAK8KdOUJum907HSmmrmno9pvf7Q4%2bVThfc%2btT6xebE%2bzofmb73sPSrrGOwsuB8sa8e5/wD11zMsjTSNI5yzHJr6DGTWAwiw0Pilv%2bv%2bXoc0F7SfO9kMooor5s6QoorD8W%2bKLPwnoUuoXRDSfcghzzLJ2H09T6VdOEqklCCu2DaSuziPjF4maGwh8MWBZ72%2bZTMsfLBM/KvHOWOPwHvXrHw48JL4L8F2elsFN2w8%2b7Yd5WxkfQDCj/dryv4N%2bEL3xL4hm8f%2bIVLjzC1mHGBJJ03gf3V6D3/3a%2bga%2b9wOEWFoqmt%2bvqedUnzyuFFFFdhBi%2bKvDVj4u8O3WjagGEM4GHX70bA5Vh7g/wBRXhsHhj4t/DISQ6BL/aelBywjgCyqf%2b2TfOpPfb%2bZr6MooA8F039oe6sLj7H4r8NSwTJjzGtsow/7Zyf/ABVeiaH8WfBWv7Et9bht5m/5Y3n7ls%2bmW%2bUn6E11GpaRpusQeRqen2t5F/cuIlkA/MV53rnwE8G6qGeyjutLmPINtLuQn3V88fQigD09HSVFdGVkYZVlOQR7VDeWFnqNube%2btILqA9Y54w6n8DxXgb/B/wCIXhB2l8IeJfPiBz5KTNbsx90YlD%2bJpY/ij8UvDL/ZNf8ADBvHAwJWtWUsf96P5D%2bAoAzfivoFn8M/G%2bg%2bIfDS/ZPPZpfsyE7VaMrux6KwfBH1r6Wr510Lwz4v%2bK3je08ReK7N7HSLRlZIniMasqncEjVuSCerH356CvoqgAooooAKKKKACiiigAooooAKKKKACiiigDMs/wDkLXn4Vp0wKoYsFAJ6nHWn1z4ai6MHFu%2brf3u5UpczuFFFFdBIUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAQyWtvNzJDGx9SvNNt7SC1LmFNm/GeSelWKKfM7WvoAVn6hZ3Ny8bQTeXtBzyRn8q0KKcZOLugMP7Fq6fdut3/bQn%2bYq9p0d5GJPtb7s4285%2btXqKuVVyVmkKwVn6hHfSOn2STauDu5xzWhRURlyu4zD%2bw6u/wB662/9tCP5Cr2nWs9sJPPm8wtjHJOPzq9RVyrSkrCsFV57K3uXV5o9xUYGSasUVmm1qhkMdtBD/q4kT3C1NRRSbb3AKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKgubmGzt5Li4kEcUYyzHtU9cF4%2b1FzPb6chwir5r47k5AH8/zpN2RvhqPtqigVtU8c3s8jJp4FvCDw5AZ2/PgVkL4l1lH3jUZs%2b5BH5Hisqis7s%2bihhqMFZRR3Wh%2bODJKtvqoUBuBOowM/7Q/qK7cEEZHSvDq9N8Fai97onlStue2by8n%2b72/qPwqoy6HmZhhIwj7SCt3OloooqzyQooooAKKKKACiiigAorG1HxBBZsYoQJpR15%2bVfqa5641m/uCd1wyL/dj%2bUfpXTTwlSavsgO6orzkzSsctI5PqWpPMf%2b%2b351v9Qf834Aej0V5x5j/wB9vzo8x/77fnR9Qf8AN%2bAHo9FeceY/99vzo8x/77fnR9Qf834Aej0V5x5j/wB9vzo8x/77fnR9Qf8AN%2bAHo9FeceY/99vzo8x/77fnR9Qf834Aej0V5x5j/wB9vzo8x/77fnR9Qf8AN%2bAHN/HHxdfNNZ%2bB9EZ/tmobTcmM4JRjhY89s8k%2bwHYmtDwZ4G03whp6CONJtQdf392y/Mx7hfRfb864HwJGfEXxe1vWZ8yLZ7xET2OfLT/xwNXs9fDZ/i5Kr9Wg9Fv5nXh4K3Mwooor5w6QooooAKKKKACiiqmp6nZ6Pp01/fzrBbQrud2/kPU%2bgppOTstwE1a50%2bz0ue51RoVso13SmYArj6Hr9K8Ch0NfiX4xkbQ9Kh0nRoSBJLHHtAX1IHG89gOn61qvJrXxi8R%2bXH5ll4dtH59vr2aQj8FH6%2bz6TpNloemQ6fp8Cw20Qwqjv6knuT3NezGf9mwaveq%2bnSP%2bb/r1xt7V%2bX5nlX/Cv/GvgqdrvwZrsksedxt9wQt9UbKP%2bOPpXTeGPju0F4uk%2bONNfTrpSFa6SNgoPq8Z5X6jI9gK7ysbxF4W0jxRZG21S1WQgYjlXiSM%2bqt/TpW2Fz6pF8tdXXfqTPDp/Cei211b3ttHc2s8c8Eqho5YmDKwPcEcEV86fHP4ktqN7L4S0mbFlbti%2bkU/66QH7n%2b6p6%2brfTnjJdf1X4eatq2gabqq3loN0asGOInI%2b8PRx3A4z9K4ZmLMWYkknJJ719XGUZwU4vc5GrOw2iiimIKKKKAOhm8SS23hRPDmnMYrWZ/tF/IvDXMn8Kn/AGEGMDucn0xz1FFABRRRQAUUUUAFFFFAH2Z8KdXfWvhlod1KxaVITbuT1/dsUBP1Cg/jXZ14B8JmkXwJDywBnkI5967jzH/vt%2bdd0ME5xUubcD0eivOPMf8Avt%2bdHmP/AH2/Oq%2boP%2bb8APR6K848x/77fnR5j/32/Oj6g/5vwA9HorzjzH/vt%2bdHmP8A32/Oj6g/5vwA9HorzjzH/vt%2bdHmP/fb86PqD/m/AD0eivOPMf%2b%2b350eY/wDfb86PqD/m/AD0eivOPMf%2b%2b350eY/99vzo%2boP%2bb8APR6K848x/77fnT0uZ4zlJ5F/3XIo%2boP8AmA9EorjLXxDfW5AkYTp6P1/Oul0/VLfUU/dHa4%2b9G3UVzVcPUp6vYC9RRRWABRRRQBjeKppbfwpqs0MjRypayFXU4KnHUGqvgWea58F6ZNcSvLKyNueRizH5iOSaseMP%2bRN1j/r0k/lVT4ff8iJpX%2b43/obV1pL6pf8AvfoV9k6aiiiuQkKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKyIr%2bePVnt7kja3CYGAPT86uMHK9ugGvRRRUAFFFFABRRRQAUUUUAFFFFABUU8oggeU/wjNS1Q1ckae2O7CsMVVdKhOot0mVBXkkc87F3LMcljk02iivzttt3Z6QUUUUgCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigApaSigDqbGf7RaJIfvYw31qzWVoZP2aQdt/wDStWv0HAVXVw0Jy3aPOqLlk0FFFFdZAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAYNv/oOvPF0SQkD8eR/hW9VC705bu5im8woyeg5PcVfrWrNTs%2bttRIKKKKyGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAfP3xU%2bHl/4Z1g%2bOfCKvGqOZruCL/li3dwO6HncO2T2PHS%2bCPG9l4y0zem2HUIgPtFtn7v8AtL6qf06H39bIDKQQCDwQe9fPvxG%2bF%2boeFNTbxh4I8yKKNvMntIB80PqUH8UZ7r2%2bnTzswy%2bGLh2ktn%2bjNaVRwfkeo0VxngT4g2XjC18mTbbarGuZbfPDD%2b8meo9uo/Wuzr4mtRnRm6dRWaO6MlJXQVq6G%2bJ5U9VB/I//AF6yq0dFOL4j1Qj%2bVdWWS5cXTfn%2bZNVXgx%2buJi6R/wC8mPyNVtNTfqEI9Dn8hmr%2bur8sDehI/lVbRVzfE/3UJ/lXbiKP/Cqo95J/kzOMv3Ny7rbYtEX1f%2blYNbWun5YF9Sx/lWLWOdSvjJLtb8rlUF7iCiisXxP4o03wppTX2oScniKFfvyt6AfzPavMhCVSSjBXbNW0ldljXtf0/wAOaVJqGpTCOJOFUfekbsqjua8m8M%2bH9X%2bM/i5tW1YPb%2bH7R9uFyFxnPlIe7H%2bJu35Cl8O%2bF/EHxn1/%2b2NZd7PQIGKqU4GM8pGD1Pq3%2bAFfSGl6XZaNpsGnadbJb2luuyOJBwB/U%2bp719llmWRwq556zf4ehw1avPotia1tYLG0htLWFIbeFAkcaDAVRwABU1FFeuYhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXmfjqJk8QByPleFSD%2bY/pXplc/4q0I6zYBoQPtUGTGP7w7rUyV0deCqxpVk5bPQ8top0kbwyNHIjI6nDKwwQfcU2sz6UK7/4exMtleykfK0iqD7gc/zFcTYWFzqV0ltaxl5G/JR6k9hXrWk6bHpOmw2kfOwfM2PvMepqoLW55uZVoxp%2bz6sv0UUVoeCFFFFABRRRQAVz2v6u0ObO3bDkfvGHYelbd3OLW1lnbkIpOPX2rz6SR5ZGkcksxySe5rswdFTlzPZANooor1hBRRRQAUVm6zr%2bmaBa/aNTu0gU/dU8s/sqjk157d/Fu6vrr7J4b0KW5lP3DKGdm/7Zpz%2btZVK0KfxMD1SivMEvvi9dL5sfhuaND0VrPbj8GOad53xi/wChfk/8Bl/xrD67S8wPTaK8y874xf8AQvyf%2bAy/40ed8Yv%2bhfk/8Bl/xo%2bu0vMD02ivMvO%2bMX/Qvyf%2bAy/40ed8Yv8AoX5P/AZf8aPrtLzA9NorzLzvjF/0L8n/AIDL/jR53xi/6F%2bT/wABl/xo%2bu0vMB/wIUPFr9w3MjyQgn/vs/1r2GvH/gQSkWvwMpDxyQ7s9vvj%2bhr2CvzDN/8AfZ38vyR6NH%2bGgooorzDQKKKKACiiqWratZaHpk2oahOsNtEMsx7%2bgA7k9hVRi5NRirtgO1PU7PR9Omv7%2bdYLaFdzu38h6n0FeLO%2bs/GPxH5cfmWXh20fknt7ns0hH4KP1WMa38YvEJZzJZeHLSToO3t6NIR%2bCg/n7Rpel2WjafFYafbpBbxDCoo/UnufU163u5dHvVf3R/4P9euOtT0/MbpOk2Wh6ZDp%2bnwLDbRDCqO/qSe5Pc1dooryZScm23qzYK8p%2bJnxMGmCXQ9DmzenK3Fyh/1Pqqn%2b96nt9eh8TfiYNLE2haHNm%2bOUublT/qPVVP8Ae9T2%2bvTwkksSSSSepr6HKcp5rV6606L9Wc1atb3YgSWJJJJPU0lFFfUnIFFFFABRRRQAUUUUAFFFFABRRRQAUUVc0vS77WtRi0/TbWS5u5c%2bXFGMs2ASf0BoA%2bhvANidP8DaVCwwzQ%2bceP75L/yYV0leYRt8X4o1jTw66ooCqBbLwB%2bNO874xf8AQvyf%2bAy/416kcZSjFLUR6bRXmXnfGL/oX5P/AAGX/GjzvjF/0L8n/gMv%2bNV9dpeYHptFeZed8Yv%2bhfk/8Bl/xo874xf9C/J/4DL/AI0fXaXmB6bRXmXnfGL/AKF%2bT/wGX/GjzvjF/wBC/J/4DL/jR9dpeYHptFeZed8Yv%2bhfk/8AAZf8aPO%2bMX/Qvyf%2bAy/40fXaXmB6bRXmXnfGL/oX5P8AwGX/ABqKbXvinpCmW/8AC8ssI5Y/YnIUfVDx%2bNH12kB6lRXnGi/F/TLuRYNWtZNPk6GQHzIwffjI/I16Fb3MF3bpPbTRzQuMrJGwZWHsRXRCrCfwsCWiiitACnwzSQSrLE5V1OQR2plFJq%2bjA7nSdRXUbUPwJV4kX0Pr9K0K4fRLs2mpx5PySHY349P1ruK8bE0vZz02YzI8QNri2KHQUtXufMG8XJONmD0x3ziub874lf8APvo/5n/Gu7oop1%2bSNuRP1RSlboeY6/L4%2bPh7UBqEGlizMDecYydwXHOOetQeFJPHS%2bGLEaVBpjWIU%2bUZSd%2bNxznn1zXdeMP%2bRN1j/r0k/lVT4ff8iJpX%2b43/AKG1dv1n/Zebkj8XbTYrm93YyvO%2bJX/Pvo/5n/Gt/wAON4iaGf8A4SCOzSTcPK%2bzE8jvnn6VuUVxVMRzx5eSK9ES5X6BRRRXOSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVka3bF4VuU4ePrj0rXproroUYZVhgj1q4TcJKQMr2FyLu0SX%2bLo31q1TI4kiTZGqqvoBin1Mmm20AUUUUgCiiigAooooAKKKKACq19CZ7OSNeuMj6jmrNFRUpqpBwls1Yadnc42itbUtNYM08C5U8so7e4rJr8/xWFqYao4TX/BPRhNSV0FFFFcxQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFaOn6c07iWVcRDnB/i/%2btW%2bHw9TEVFTpq7FKSirs0tKhMNipPVzu/wq/SUtfoFCiqNKNNdEebJ8zuFFFFaiCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoorJvr2e01KEMw%2bznsB%2bBzVwg5uyA1qKTrS1ABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4T8UfhVPYXR8X%2bC42t7uBvNuLS3GDkdZIx/Ne/b0N34efECDxhZtbXISHVYFzJGp4kXpvX8eo7fjXtNfMPxY0G4%2bHvxFtfE2jhY7a9kM8agYVZRjzEIH8LZz/wIjtXn5hgIYunb7S2f9dDSnUcH5HtlXtIJGoJ7g/yrx3S/jlo86qup6ddWsndoiJU/of0NdpoPxN8G3N9E4163hHOfPDRY4P8AeAFfM4fA4mjiabnB2uvz7o65VIyg7M7/AFtc2aH0cfyNVtCX99M3ooFU9R8W%2bGrnTmMHiLSZRkfcvYznn2NQaP4p8OwRzvLr2loOOWvIxwM%2b9evWpN5tCVtLX/BmEZfuWjV1770A9m/pWPWb4j%2bI3g6CRCfEVhKFU5%2bzyed/6BmuG1L42%2bHLVWFjb3l7J2wgjQ/ief0rzcxweIr4ybpwbWnpsuprSnGMFdnXeLPFVj4S0Z7%2b8O9z8sECnDSv6D29T2rznwT4H1b4ra63ifxUZY9HBxFGvyiYA/cj7hB3Pf1zkjn7F9Q%2bMvxIsbW4T7PZINzxo%2bRDAuC5B/vNwM46kdhX1fbW0Fnaw2ttEkUEKCOONBgIoGAAPQCvcyvLlhYc017738vIwq1ed2WwWtrb2NrFa2kMcFvEoSOKNdqqB0AAqaiivVMQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAM7UNE07VObu1V3xgOPlYfiKy18DaMr7iJ2H90ycfoM10tFKyNYV6sFaMmkVbLT7TTovKtLdIVPXaOT9T1NWqKKZm227sKKKKBBRRRQAUUUUAZHiRymkMB/G6g/z/pXG12Hib/kFD/rqP5GuPr1sF/C%2bYgooorsAK5Xxv40g8JaeNgSbUZh%2b4hJ4A/vt7fz/PHR3t5Dp9jPeXDbYYI2kc%2bgAya84%2bGHhuT4l%2bObzxPrkXmadZSArCwyjv8AwR%2b6qOT68Z6muXFV/Zxst2Ba8DfCbUvHMyeJ/GlzcLaT4eG3ztkmXsT/AHE9AOT2xwT73o2g6T4esxaaRp9vZwDqsKAbvcnqx9zmtHp9KWvIbbd2MKKKKQBRRRQAUUUUAFFFFAHzj8O1/sv4r%2bL9Ibj97MVHqEmwP0evXK8q1pP%2bEf8A2lS5OyDU0Uj33x7f/RiV6rXxue0%2bXFc3dL/I7sO7wsFFFFeKbBRRVDWtasdA0ubUdRmEVvGPxY9lUdyaqMXJqMVdsNh2ratZaHpk2oahOsNtEMsx7%2bgA7k9hXjCJrPxj8R%2bZJ5ll4dtH4A7ew7NIR%2bCj9X20GtfGLXxcXe%2by8O2j8Kv8h/ecjqeg/HB9n03TbPR9PhsbC3SC2hGEjXt/Un1Jr1rxy6NlrVf3R/4P9euOtR%2bX5iaZplno%2bnQ2FhAsFtCu1EX%2bZ9T6mrdFFeQ25O73Ngry74l/EtdFWXRdFlDaiw2zzqci3HoP9v8Al9ejPiT8TxpPnaJocga%2bwVnuVPEH%2byvq38vr08IZmdi7sWZjkknJJr6LKsp57V6606Lv5v8ArU5q1a3uxBmZ2LuxZmOSSckmm0UV9ScgUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV9Cfs7%2bD9kN34suo%2bZM21nkfwg/O4/EBR9Grxnwd4Xu/GPie00azBBlbMsuMiKMfeY/QdPcgd6%2b1dK0y10bSrXTLGPy7W1iWKJfRQMc%2bp9TQBcooooAKKKKACiiigAooooAKKKKACiiigDlfFfw88NeMoHGp6fGLkjC3kACTL/wL%2bL6HIrwLV9H8TfBbW0YSG/0G5f5XwQknsRzskx%2beO%2bCB9T1n63o1h4h0e50rUoBNaXKFHU9R6EHsQeQaqMnF3QHnOk6taa3pkOoWMnmQSrkeqnuCOxFXa8l8N/bPh18R7zwjqEha0uJQsUhGAxIzG4/3hhT7/SvWq9qhV9rC/UQUUUVsAoJByDyK9FifzIkc/wASg15zXolv/wAe0X%2b4P5V52PWkRktFFFecBjeK4pJ/CWrRRIzyNayBVUZJO3sKqeA4pIfBOlxyxvHII2yrrgj5m7V0lFa%2b1fsfZW63/Cw76WCiiishBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAhYKMkgAdSaRWV1DKwZT0IPFQX8H2iyljxzjI%2bo6VT0KfzLRoieY24%2bh/yatQvBy7CuatFFFQMKKKKACiiigAooooAKKKKACqs1hbTkl4huPccGrVFRUpQqLlmk15jTa2M46Nak/wDLQf8AAqP7FtfWT/vqtGiuX%2bzsJ/z7RXtZ9zO/sW19ZP8Avqj%2bxbX1k/76rRoo/s7Cf8%2b0HtZ9zO/sW19ZP%2b%2bqP7FtfWT/AL6rRoo/s7Cf8%2b0HtZ9zO/sW19ZP%2b%2bqP7FtfWT/vqtGij%2bzsJ/z7Qe1n3M7%2bxbX1k/76o/sW19ZP%2b%2bq0aKP7Own/AD7Qe1n3M7%2bxbX1k/wC%2bqP7FtfWT/vqtGij%2bzsJ/z7Qe1n3M7%2bxbX1k/76o/sW19ZP8AvqtGij%2bzsJ/z7Qe1n3M7%2bxbX1k/76o/sW19ZP%2b%2bq0aKP7Own/PtB7Wfczv7FtfWT/vqj%2bxbX1k/76rRoo/s7Cf8APtB7Wfczv7FtfWT/AL6o/sW19ZP%2b%2bq0aKP7Own/PtB7Wfczv7FtfWT/vqk/sW19ZD/wKtKij%2bzsJ/wA%2b0HtZ9ypFp1rCcrECfVuat0UV006NOkrU4pLyJbb3CiiitBBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFY%2bu%2bJdL8OWwm1G4CFvuRKMu/0H9elefXnxlfzSLHSB5YPDTS8kfQDj8zXVQwVeur046FKDex6zRXk9l8ZD5oF9pA8snloJeQPoRz%2bYr0LQ/EWmeIrUz6dcCTb9%2bNuHT6j%2bvSivgq9BXqR0Bwa3NaiiiuUkKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKz9XtvtFkzAZeP5h9O9aFHWqjJxkpIDP0i5%2b0WSqT88fyn6dq0Kiht4bddsUaoPapaJtOTaBBRRRUgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeR/tD6f9p%2bH1vdhfmtL5GJx0VlZSPzK165XEfF2yF/8ACvXosZKQrMOOmx1f%2bQNAHh2lfFLw5daba2Hi7wTY3/kQpD9tt1VZmCgDJzgknHOGH0rUSD4E62Awn1LRXb/lmxl4/EiRR%2bdcV4d%2bFniTxZ4d/tnRUtbqIStC0JmCSBlwf4sL0I71Tvvht4008kXHhnUjjqYYDKB%2bKZFAHpEfw2%2bEl0wMHj9kUjgTXkCn8yop0nww%2bFEGDJ8QVZeuI763Y4/AGvHJtB1i23efpN/Ft%2b9vtnXH1yKZFo2qTjMOm3kgzjKQMefTgUAevPpHwL0b/XazqOqOP4Aztn8URR%2btVZfiZ4B0Hjwr4At5JFHyXGo4LKfUZLsf%2b%2bhXA2fgDxffkC38M6qQejNaui/mwArcn%2bDfjCx0K91fUra2sLa0gedxNcBmYKM4ATdyegzigDu/2eYpNT8T%2bJ9fnRfOZFVmUYGZXZ2A/FB%2blfQleM/s42XleDNTvSMGe/KD3CIuP1Y17NQAUUUUAFFFFABRRRQAUUUUAFFFFABRUc00cEZklkVEHdjisa58T20ZKwRPMfU/KP8AH9KuFKc/hQG7RXKP4puj9yCEfXJ/qKZ/wlN9/wA8rf8A75b/ABrf6nVC511Fcj/wlN9/zyt/%2b%2bW/xo/4Sm%2b/55W//fLf40/qdULnXUVyP/CU33/PK3/75b/Gj/hKb7/nlb/98t/jR9Tqhc66iuR/4Sm%2b/wCeVv8A98t/jR/wlN9/zyt/%2b%2bW/xo%2bp1QuddRXI/wDCU33/ADyt/wDvlv8AGj/hKb7/AJ5W/wD3y3%2bNH1OqFzrqK5H/AISm%2b/55W/8A3y3%2bNH/CU33/ADyt/wDvlv8AGj6nVC511Fcj/wAJTff88rf/AL5b/Gj/AISm%2b/55W/8A3y3%2bNH1OqFzrqK5H/hKb7/nlb/8AfLf40f8ACU33/PK3/wC%2bW/xo%2bp1QuddRXI/8JTff88rf/vlv8aP%2bEpvv%2beVv/wB8t/jR9Tqhc66iuR/4Sm%2b/55W//fLf40f8JTff88rf/vlv8aPqdULnXUVyDeKrxVLNHbADqSp4/Wq3/CeLnb9p03OcY8z/AOypfU6qA7iiuQXxVeMoZY7Yg9CFPP60v/CU33/PK3/75b/Gj6nVC511Fcj/AMJTff8APK3/AO%2bW/wAaP%2bEpvv8Anlb/APfLf40/qdULnXUVyP8AwlN9/wA8rf8A75b/ABo/4Sm%2b/wCeVv8A98t/jR9Tqhc66iuR/wCEpvv%2beVv/AN8t/jR/wlN9/wA8rf8A75b/ABo%2bp1QuddRXI/8ACU33/PK3/wC%2bW/xo/wCEpvv%2beVv/AN8t/jR9Tqhc66iuR/4Sm%2b/55W//AHy3%2bNH/AAlN9/zyt/8Avlv8aPqdULnXUVyP/CU33/PK3/75b/Gj/hKb7/nlb/8AfLf40fU6oXOuorkf%2bEpvv%2beVv/3y3%2bNH/CU33/PK3/75b/Gj6nVC511Fcj/wlN9/zyt/%2b%2bW/xo/4Sm%2b/55W//fLf40fU6oXOuorkf%2bEpvv8Anlb/APfLf40f8JTff88rf/vlv8aPqdULnXUVyP8AwlN9/wA8rf8A75b/ABo/4Sm%2b/wCeVv8A98t/jR9Tqhc66iuR/wCEpvv%2beVv/AN8t/jR/wlN9/wA8rf8A75b/ABo%2bp1QuddRXI/8ACU33/PK3/wC%2bW/xo/wCEpvv%2beVv/AN8t/jR9Tqhc66iuR/4Sm%2b/55W//AHy3%2bNH/AAlN9/zyt/8Avlv8aPqdULnXUVyP/CU33/PK3/75b/Gj/hKb7/nlb/8AfLf40fU6oXOuorkf%2bEpvv%2beVv/3y3%2bNH/CU33/PK3/75b/Gj6nVC511Fcj/wlN9/zyt/%2b%2bW/xo/4Sm%2b/55W//fLf40fU6oXOuorkf%2bEpvv8Anlb/APfLf40f8JTff88rf/vlv8aPqdULnXUVyP8AwlN9/wA8rf8A75b/ABo/4Sm%2b/wCeVv8A98t/jR9Tqhc66iuR/wCEpvv%2beVv/AN8t/jR/wlN9/wA8rf8A75b/ABo%2bp1QuddRXI/8ACU33/PK3/wC%2bW/xo/wCEpvv%2beVv/AN8t/jR9Tqhc66iuR/4Sm%2b/55W//AHy3%2bNPTxVdD78EJ%2bmR/U0vqdULnV0VhW3ie1kIWeN4T6/eH%2bP6VswzRzxiSJ1dD0KnNYTpTh8SAkoooqACiiigAooooAKKKKACiiigAooooAKKKKAMbxN/yCh/11H8jXH12Hib/AJBQ/wCuo/ka4%2bvXwX8IQUUUV1gcJ8W9Ray8GG3RsNeTpEcf3Rlj/wCggfjXqHwp0NNB%2bG2jQBAss8IupT3LSfNz9AVH4V4v8a2IsNITPymWQke4C/4mvpHTI1i0qzjQYVIEUfQKK8fGO9UaLdFFFcoBRRRQAUUUUAFFFFABRRRQB4J%2b0DavpeveGPE8CfPC5iZh6owkQfq9ejQTJcW8c8Tbo5FDqfUEZFUfjXov9s/DHUWRN0tiVvE9tpw3/jjPWB8MNW/tfwDpzM2ZbZTbSc9CnC/%2bO7a%2bd4ho3pwqro7ff/wx04aWrR2FFFZuva9YeHNKl1HUZhHCnAA5Z27Ko7k/56V8vGMpyUYq7Z1t21Y/WtasdA0ubUdRmEVvGPxY9lUdya8atbXWfjF4j%2b13fmWfh%2b0fCqp4A/ur6ue57fkDJZWOs/GHXvt%2boGSy8P2rFURD%2bar6se7Y4/IV7Pp%2bn2mlWENjYwJBbQrtSNRwB/jXrNxy%2bNlrVf8A5L/wTHWo/L8w0/T7TSrCGxsYEgtoV2pGo4A/xqzRRXkNtu7Ngryn4mfEwaYJdD0ObN6crcXKH/U%2bqqf73qe316RfEr4nmwaXQ9AmH2kZW5u1P%2bq7bEP971Pb69PDiSxJJJJ6mvo8qynmtXrrTov1ZzVq1vdiBJYkkkk9TSUUV9QcgUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVNbW097dRWtrC81xKwSOONcszHgAD1qbTNLvtZ1GHT9NtZbq7mO1Io1yT/gPU9q%2bo/hb8JbXwXEup6n5d1rrrw4GVtgRgqnqeSC34DjOQC98KPh2ngXQDJdqjazeANdOOfLHaMH0Hf1PsBXoVFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4P%2b0bpHkx6F4jgGyeKU2ryDr/AH0/Ih/zrpNLvRqOk2d8vS4gSXHpuUH%2btL%2b0BEsnwxZm6x3kLL9fmH8iayfAzl/A%2bjljz9mUflwK78A/eaEzoKKKK9MAr0S3/wCPaL/cH8q87r0S3/49ov8AcH8q8/H7RGS0UUV5oBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWPrfibSPDsQfUbtY3YZSJfmdvoB/PpWL488aL4YtFtrTa%2bpzjMYIyI1/vEfyH%2bFc54Z%2bHM2rONZ8UyTSSzneLdmIZvdz1H0GMfpXfRwsPZ%2b2xDtHour9C1FWvIfdfGDzJvK0vRZJcn5Wlk%2bY/8BUH%2bdQn4r6vb4e68OhYu5LOn6kGvTrLTrPToRDZWsNvH/diQKP0qyQCMHpVfWcItFR09XcOaPY4jRfijoWqSLDdF9Pmb/nsQYyf98f1ArtlZXUOjBlYZBByCK5bX/AGh67EzfZ1s7o9J7dQpz/tL0b%2bfvXEaRrOr/DnWl0fW90ulSH5HGSFH95Pb1X/Jf1ajiU3hrqS%2by/0Y%2bVS%2bE9ioqOOVJoklidXRwGVlOQQehFSV5pmFFFFABRRRQAVi2UEttrMyiNvJbPzY49RW1RVxnypruAUUUVABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVk%2bItbh8PaHc6lMN3lriNM/fc8Afn%2bma1q8s%2bMt262%2bk2QJ2O8krD3AAH/oTV1YKgq9eNN7MqCu7HmGp6nd6vqEt9ezGWeU5JPb0AHYCqlFFfbxioqy2OsKvaTq15ompRX1jKY5oz%2bDDupHcGqNFEoqSs9gPprQdYg17RbbUrfhZlyyZyUYcFfwNadeYfBu7eTTdUsyTshlSVfbeCD/AOgCvT6%2bHxlBUK8qa2RySVnYKKKK5iQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqOOaOVmWN1Yr97B6VJXPsDpGrBhxBJ/L/AOtWlOHPddRNnQUUgIYAjkGlrMYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVmeIrH%2b1PDOq6eF3G6s5oQB33IR/WtOigD5T%2bFnxag8A6bc6Xe6ZNdWs9x9o8yGQBkJVVI2kYP3R3Feyad8c/Al%2bq%2bbqU9k5/gubZxj6lQw/WvneTwPqmq%2bPda8O6PBHLdWk8%2byJpBHvRHx8pYgdCDyelRX3w18a6eSJ/DGpEDqYYDKB%2bKZFAH1bB8R/BdxjZ4o0oZ6eZdKn/AKERT5viF4Ng5fxTo54/gvEf%2bRNfG02g6xbbvP0m/i2/e32zrj65FMi0bVJxmHTbyQZxlIGPPpwKAPrG/wDjT4CsAf8Aidi4cfwW8Ej5/Hbj9a8x%2bIXx00/xJ4av9C0fSrpEu1CNc3LqhVQwJwi5zkDHUda8ys/h/wCML8gW/hnVSD0Z7V0X82AFJ4l8DeIPCFtZza7ZpafbCwhjMyOx24ySFJx94fnQB9N/BSxNj8KdJLDDzmWZvxkbH/joFeg1jeEtO/snwdo2nkANb2UMbgf3ggyfzzWzQAUUUUAFFFFABRRRQAUUUUAFZ%2bqapFpsIz80rfcT%2bp9qs3dylnayTyfdQZx6nsK4O6uZLu4eaU5Zj%2bXtXVhqHtXeWyAW7vJ72bzJ3LHsOw%2bgqCiivXSSVkIKKKKYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAIzKilmIVQMkk8AV5X4t%2bLIt5JLLw6EkZSVa8cblB/2B3%2bp49qh%2bK/jB1kPhyxkKjAN46nrnkJ%2bXJ/AeteSV52JxTT5IAX9R1rU9XlMmoX89yc5xI5IH0HQfhVCiivPbb1Yy/putano8ok0%2b/ntmBziNyAfqOh/GvU/CXxZW5ljsfEKpE7YVbxBhSf9sdvqOPYV47RWlOtOm9GB9aqwZQykEEZBHelryb4T%2bMJJXHh2/lLYUmzdjyABzH%2bXI/Eeles17NKoqkeZCCiiitACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqxaXtxYy%2bZA5X1HZvqKr0Umk1Zgd1pmqRalDlfllX76Z6e/wBKv155aXUlncpPEcMvb1Hoa721uEu7aOeP7rjI9vavIxND2TutmMmooorlAKKKKACiiigAooooAKKKKACiiigDG8Tf8gof9dR/I1x9dh4m/wCQUP8ArqP5GuPr18F/CEFFFFdYHlXxs/489G/66S/yWvpaw/5B1t/1yT%2bQr5p%2bNn/Hno3/AF0l/ktfS1h/yDrb/rkn8hXjYv8AjMaLFFFFcwBRRRQAUUUUAFFFFABRRRQBDd2sN9Zz2lwm%2bGeNopFPdWGCPyNfOvwlkm0HxR4h8I3jYlglZkB7sjbGI%2bo2n6CvpCvnX4rIfBHxg0vxXFGxtr2MNMqDG4qNkgHbOwofqa5MdQ%2bsYeVNb209UXTlyyTPRte16w8OaVLqOozCOFOAByzt2VR3J/z0rx7TtO1j4v8AiI6lqRe10C2YqiKeMf3E9WPGW/8ArCn6dpWsfF7Xf7W1QvaaBbuViiU9RnlU9T6t/wDqHtNlZW2nWUVnZwpDbwqFjjQYCivlnKOXx5Y61Xu/5f8AgnXrUd3t%2bYWVlbadZRWdnCkNvCoWONBgKKnooJCgkkADqT2ryG23dmwV478Svij5XmaJ4duBv%2b7c3kZzt9VQ%2bvq35VU%2bJHxS%2b1edonh%2bcfZyNlxeIf8AWeqofT1PftxyfH6%2bmyvKNq2IXov1f%2bRy1q32Yi9aSiivpTlCiiigAooooAKKKKACiiigAooooAKKvHRtTGmNqZ067FgpAN0YW8rJ4A3YxXqfgj4D3niXS7PWNQ1eC1sLqMSRpbqZJWU9jnAU/nQB4/1%2btek%2bDPgt4l8UNHcXkLaTprYJmuUxI4/2I%2bp%2bpwPrX0H4W%2bF3hPwkUlsNNWa8X/l7uj5kmfUZ4U/7oFdlQBzPg/wJoXgixMGk2uJnAE11L80sv1PYewwK6aiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPL/j9/yS6f8A6%2b4f5msTwH/yI2kf9e4/ma2/j9/yS6f/AK%2b4f5msTwH/AMiNpH/XuP5mu7A/G/QTOiooor1ACvRLf/j2i/3B/KvO69Et/wDj2i/3B/KvPx%2b0RktFFFeaAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABUVxPHa20txM22KJC7t6ADJNS1zfj2drfwPqzqcExBPwZgp/nWlKHtKkYd3YaV3Y4PwRZP4x8Z3viPUU3wwPvRG5G/wDgX6KB/KvYK4n4V2yweCYZVHzTzSSMfcHb/wCy121dWY1Oeu4raOi%2bRU3eQUUUVwkBXPeMfDkfiTw/NbbR9qjBktn7hx2z6Hof/rV0NFXTqSpzU47oadnc88%2bE%2buPe6LPpNwSZbFhsz18ts8fgQfzFeh15N4UUaf8AF/WLWLiOTzhjsAWDj/CvWa7MxhFV%2baO0kn95U1qFFFFcBAUUUUAFRyyxwRmSRgqjqTUlVNSTzNNnH%2bzn8uacUnJJgTxSpPEJI23Ieh9akrN0N92nAf3WI/r/AFrSpzjyycQQUUUVIBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXl/wAY7B5LDTb9VJWGR4nI/wBoAj/0E/nXqFZ%2bs6Tb63pNxp10P3Uy4yOqnqCPcHBrpwlf2FeNR9CouzufMVFauv6BfeHNSeyvo8HrHIPuyL6g1lV9xCcZxUou6Z1p3Ciitfw74cvvEupLaWaYUcyzMPljX1P9B3pTnGEXKTskDdj0v4O2Dw6RqN8wIW4mWNc9wgPP5ufyr0uqWk6Zb6Ppdvp9qu2GBNq56n1J9ycmrtfD4ut7etKp3OSTu7hRRRXOSFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFU9RtBeWpUf6xeUPv6Vcopxk4u6AqafFPDZpHORuXpg9B6Vbooobu7gFFFFIAooooAKKKKACiiigAooooAKKKKACiiigD5u8Z6mnw7/AGhl1%2baCR7OeNbh44sbmR4zG2MkDO5Setemad8cPAd%2bAH1SWzc/wXNu4/VQV/WuT/aN8OvdaNpviGFCfsbm3uCB0R8bSfYMMf8DFeE2PhbX9UsPt2naPe3tsCQZLaEyhSOx25x%2bNAH2DB8RPBlwMp4p0gcZ/eXiJ/wChEU%2bTx/4OiXc3irRiM4%2bW%2bjb%2bRr40m0HWLbd5%2bk30W373mW7rj65FMi0fVLjmHTbyTnHyQMefwFAH1nf/ABm8BWCnOurO3ZLeGRyfxC4/WvG/GPiuy%2bLPxJ8NWOm29ytgsqQMLhQGO6TLtgE8bQO/Y1583g3xKlnLeS6DqMNrEpeSee3aNFA6/MwAr0T9nrw62o%2bM59bkQmDTISEbHHmyAqB/3zv/AEoA%2bn6KKKACiiigAooooAKKKKACiiigDmvFN0cw2qnj/WN/If1rm609fcvrMw7LtUfkKzK9vDx5aSQgooorcAooprukUbSSMqIoLMzHAAHUk0AKSACScAdSa4LxH8VdJ0iRrbTU/tK5HBMbYiU/738X4fnWDq2t658S9fHhnwojiy582XlQ6jq7n%2bFPQd/ckCvZfA3wk8P%2bDIo7hoV1DVgAWvJ0B2n/AKZr0X69fevOr4yz5af3geSWlt8XPGSiWyspNOtH6OVW3XHYgv8AOR7itNPgt8RrkeZdeLYFc9vts7Y9vuj9K%2biKK4ZVJy3Yz55/4Ub49/6HCH/wKn/wo/4Ub49/6HCH/wACp/8ACvoailzS7gfPP/CjfHv/AEOEP/gVP/hR/wAKN8e/9DhD/wCBU/8AhX0NRRzS7gfPP/CjfHv/AEOEP/gVP/hR/wAKN8e/9DhD/wCBU/8AhX0NRRzS7gfPP/CjfHv/AEOEP/gVP/hR/wAKN8e/9DhD/wCBU/8AhX0NRRzS7gfPP/CjfHv/AEOEP/gVP/hR/wAKN8e/9DhD/wCBU/8AhX0NRRzS7gfPP/CjfHv/AEOEP/gVP/hVbUfg5430zTLu/uPGEQgtYXmkIuZ87VUk9vQV9H1y3xIZ0%2bG3iMxjJNhKOuOCpB/TNHNLuB8WyyyTytLNI8kjnLO7ZJPuTUdFFSAUUUUAFFFFAEkM0tvKssMjxyIcq6Ngg%2bxFe22Pwa8cahp9teweMIjDcRLKhN1P91gCO3oa8Or7Y%2bHTs/w38Nljk/2dAOfQIAKak1sB5B/wo3x7/wBDhD/4FT/4Uf8ACjfHv/Q4Q/8AgVP/AIV9DUU%2baXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD55/4Ub49/wChwh/8Cp/8KP8AhRvj3/ocIf8AwKn/AMK%2bhqKOaXcD52f4LfEe2HmWvi2F37j7bOpP/juD%2bNZt3H8W/BqmW/sJNQs05L7FuFx3JKfOPxr6bopxqTjswPnrw18U9I1l0t79f7Oum4HmNmJj7N2/HH1rvKn8d/CLQPGUMtxFEmn6seVu4UwHP/TRRw316%2b/avHNF8Qa18OvEB8LeK0b7KpAjmJLCNTwHRv4o/wCXtgiu6hjLvlqfeI9copFZXVXRgysMhgcgilr0QCiiigArpfC10SJrVj0%2bdf5H%2blc1Wp4ecrrMQH8YYH8if6VhiY81JgdrRRRXiDCiiigAooooAKKKKACiiigAooooAxvE3/IKH/XUfyNcfXYeJv8AkFD/AK6j%2bRrj69fBfwhBRRRXWB5V8bP%2bPPRv%2bukv8lr6WsP%2bQdbf9ck/kK%2bafjZ/x56N/wBdJf5LX0tYf8g62/65J/IV42L/AIzGixRRRXMAUUUUAFFFFABRRRQAUUUUAFea/HDw5/b3w6ubiJN1zpji7TA5KDhx9NpLf8BFelVHPDHcwSQTIHikUo6HowIwQaAPIfhhq8Wr%2bA9PKBFktF%2byyqowAV6fmu0/ia7CvH/AYk8EfE7WvBt058mVz9nLH7xUbkP/AAKM8%2b4Ar1fUNQtNKsZb2%2buEgtohueRzwB/U%2b1fCZnhnRxUopb6r5/1Y9ClLmhcmmmjt4XmmkWOKNSzu5wFA6kn0rwf4jfFCTWjLo%2bhyNHp3KzTjhrj2Hon8/pWZ4/8AiTd%2bKpWsbEvbaQrfczhp/d/b0X889uAr28syhUrVq697ou3/AATCrWvpEKKKK%2bgOYKs2FnJqGo2tlEQJLiVIkz6sQB/Oq1df8LrD%2b0vid4egxnbdrNj/AK5gyf8AstAHd3P7N3iBM/Zdb0yX080SR5/JWrNm/Z58aR7tkulS46bLhvm%2bmUFfU9FAHydJ8BPHaIWW0s3P91bpcn88VD/worx9/wBAuD/wLj/%2bKr63ooA%2bTk%2bAnjp0DNa2aE/wtdLkflkVbh/Z58aS7d82kw5HO%2b4fj64Q19TUUAfNlt%2bzbrjY%2b167p0XTPlI8n16ha3LL9mqzTBvvEs8vqsFqI/1LN79q93ooA8u0/wCAPgey2m4hvr4jr9ouSoP/AHwFrsdL8DeFtFKtp/h/T4XXpJ5Cs4/4Ecn9a6CigDifi3Zre/CzX42XOyASjA6FHVs/pVD4H3RufhRpak5MDzRH/v4xH6EVu/Ej/kmviP8A7B83/oJrl/gD/wAkug/6%2b5v5igD1CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDy/4/f8kun/AOvuH%2bZrE8B/8iNpH/XuP5mtv4/f8kun/wCvuH%2bZrE8B/wDIjaR/17j%2bZruwPxv0EzoqKKK9QAr0S3/49ov9wfyrzuvRLf8A49ov9wfyrz8ftEZLRRRXmgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVg%2bNLRr3wbqsKAlvs5cAd9vzY/St6msoZSrAEEYINXTm4TU10dxp2dzhPhNfJceEWtQf3lrOykezfMD%2bp/Ku9rxqymf4beP5recMNJvOjYyPLJ%2bVvcqcg/j6ivYYpY54klidXjcBldTkMD0INdmY07Vfax%2bGeq/Uqa1v3JKKKK4CAo6UVxHxG8Vx6Ho72FvIP7Qu0KqAeY0PBY%2bnoP/AK1a0KMq1RU4bsaTbsjnPAr/ANsfE3WdWTmBRKyN/vMAv/joNetVxvw48OvoPh0S3CFLy8IlkB6qv8Kn8CT9Sa7KujMKsZ12obLRfIqbu9AoooriICiiigAqOZfMgkT%2b8pH6VJRQBl6LBNbwyLNGUy2RmtSiiqnLmk5MAoooqQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigClqWlWOr2pttQtYriE/wuOh9QeoPuK4a9%2bD%2bkTOWs767tgf4WAkA%2bnQ/rXo1FdFHFVqP8OTRSk1sedWXwg0eB1e8vbq5A/gGI1P1xk/rXc6dpllpNotrYWsdvCv8ACgxk%2bp7k%2b5q5RSrYqtW/iSbByb3CiiisCQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACsf%2b0J7bVWiuiBE3CkDgDsf8a2Ko6lYi8t/lH71OVP8AStKTje0tmJl6isrRrqSWJoJVbdFxkjt6H3rVqZwcJcrGFFFFSAUUUUAFFFFABRRRQAUUUUAFFFFAFTUtOtNX0240%2b/gWe0uEMcsbdGU/5614bqXwN8ReHdRfUfAniGSM9oZJTDKB/d3r8rj6gV77RQB8/Jrvx20ceVcaU17s/iNvFLkfWMjP86D4p%2bOV8vlwaE1s33d/2NF59f3hI/pX0DRQB89J8JPiH40uI5vGniD7PApz5LS%2bcy/7qJiMfUGvafCvhXTPB2hRaTpUbLCpLu7nLyuerMfXgfkPStyigAooooAKKKKACiiigAooooAKKKKAOG1z/kM3P%2b8P5Cs%2btDXP%2bQzc/wC8P5Cs%2bvepfw4%2biEFFFFaAFeZ/FHxBcySW3hTSg0l3elRKsf3iGOEjHux6%2b2PWvS2YKpZjgDkk9q85%2bDtgfGHxS1XxTcqXhscyRBh0d8rGPwQN%2bIFceMqckLLqB7D8OvA1p4E8NR2SBXv5gJLycfxyeg/2R0H59Sa6%2biivJGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFZ2vaaNZ8Palphxi8tZYMntuUjP61o0UAfAk0MlvPJBMjJLGxR0YYKkHBBqOvYPjt4El0TxE3iSyiJ07UXzNtXiGfvn2b7w993tXj9ABRRRQAUUUUAS28Et1cRW8CGSaVwiIOrMTgAfjX3XounjSNB07TFYMtnbR24I77FC/0r5x%2bA/gSTWdfXxNexEafpz/uNw/1s/bHsvX6496%2bnaACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKK8l8d/HHS/Dl1JpehQLq2pq2x2DfuYm9CRy59h%2beeK5WO6%2bOnisfaIEfTLV%2bVXZFbgfQNmT86APoSivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACj/hFfjn/wBB7/ycX/CgD3%2bivAP%2bEV%2bOf/Qe/wDJxf8ACo5Lf48eHwbhZ31CJeWRWhnz7bSN/wD3zQB9B0V4r4T%2bPUUt%2bNJ8Zaf/AGVeBtjXCqyxhvR0b5k%2bvI%2blezo6SoskbKyMAVZTkEHoQaAH1xfxJ8B2vjvw3JbbUTUrcF7Kc8bX/uk/3W6H8D2rtKKAPmz4WeILhkuvDGph0vLAnylk4YKDhkPup7e/tXpVebfFqx/4Qz4uaZ4ltxst7/EsuBgFlwko/FSp%2brGvSQQQCDXr4Oo5ws%2bggooorrAK0tA/5Ddv/wAC/wDQTWbWloH/ACG7f/gX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/yCh/11H8jXH16%2bC/hCCiiiusDyr42f8AHno3/XSX%2bS19LWH/ACDrb/rkn8hXzT8bP%2bPPRv8ArpL/ACWvpaw/5B1t/wBck/kK8bF/xmNFiiiiuYAooooAKKKKACiiigAooooAKKKKAPCfj5os%2bmajovjfTl2zW0iwTsPUHdGT7feU/wDARXjvjDxvqnjG833TeTZxnMNpG3yp7k/xN7n8MV9latpFhrumTabqdslzZzbfMifOGwQw6e4FfJHjLwFc6Z8UZfDGmRq/2ydWslDdEkOVB9NvIOey5rN0acpqo1qtmPmaVjD8KeENY8Z6sNP0e28xxgyyucRxL/eZu38z2r6A8N/s9%2bHNPhV9dnn1W4I%2bZFYwxD6BTuP1z%2bFeg%2bDfCOn%2bC/DsGlWCDKgNPNj5ppMcuf6DsMCtXVL0aZpN5fmF5hawPN5Uf3n2qTtHucVoI5gfCjwKqBB4assYxzuJ/POa5jxB%2bz/4T1OF20k3Gk3HVSjmWPPurEn8iK4Vv2kdeM5KaHpoh3cIWcsB6ZzjPviu58HfHnQ/EN7FYatbNpF1KQsbvIHhY%2bhbAKk%2b4x70AeA%2bM/Aet%2bBtRFtqsAMMmfIuosmKUex7H1B5/DBrrv2fbD7X8SvtBXIs7KWUH0J2p/Jz%2btfSviHw/p3ijRLjSdUgEttMMf7SN2ZT2YdjXlPwT8HXXhXxb4utr0ZltGhto5NuBIjbn3D2ICH8fagD2uiiigAriPij42k8D%2bFftdqiSX9zJ5FuH5VTgkuR3AA6epFdvXBfFnwVc%2bNfCiwaeV/tC0l8%2bBWOBJwQyZ6DIPHuBQB8/W3xa8cW%2boi9OvTzNuy0UqqY29tmMAfTFfUHg3xJH4u8KWGtxx%2bUbhDvjznY6kqw%2bmQce2K%2bUrb4ceMrq/WzTw1qSSFtu%2bWBkjHvvIC4/GvqnwP4a/4RHwfp%2bjNKJZYELSuvRnZizY9snA9gKAOirEGsiPxRJpkzDY8amL2bGSPxFbdeZeKpmXxTcPG21oym1h1BCg/zoOvB0VWk4vsem18xfEL4teJbjxZf2Wk6hLp9hZztBGsGFZyhwWZuvJB49Pxr6K0PVF1bTI7jjzB8sg9GHX/GvIPHPwJvNZ8R3Oq6Bf2cKXchllguiyhHPLFSqtkE5OMDFBzSi4ScXuil4e%2bIOpeLvhX4x03WXE15Zac7pcBQDIhUjDAcZBHXvn256/4A/wDJLoP%2bvub%2bYrKh%2bHEfgH4S%2bK2nuVudSu9Pk8%2bRAQihVOFXPPc5PfjjitX4A/8AJLoP%2bvub%2bYoJPUKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPL/j9/wAkun/6%2b4f5msTwH/yI2kf9e4/ma2/j9/yS6f8A6%2b4f5msTwH/yI2kf9e4/ma7sD8b9BM6KiiivUAK9Et/%2bPaL/AHB/KvO69Et/%2bPaL/cH8q8/H7RGS0UUV5oBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGH4o8MWfijSza3P7uVDuhnUZaNv6j1H/1q81s9Z8SfDa4Gn6lam60wt%2b7IJ2/VGxx/un9M17NUU8ENzC0M8SSxMMMkihgfqDXZh8X7OPsqi5oPp/l2LjKys9jl9O%2bI/hnUEUm/%2byyHrHcqVx%2bPK/rV6Xxr4ahjLtrVoQOyPuP5DJrPvvhp4YvXLiye2Y9TBIVH5HI/Sqkfwn8NI4ZvtkgH8LTcH8gDWtsA9byXloHuGZrnxXibNp4dtZLm4c7UmkQ7cn%2b6vVj9cfjSeEfAl5daj/wkHigtLcswkjgkOTu7M/07L2/Su50rw3o%2biD/iXafDC2MbwMuf%2bBHJ/WtWlPGQpwdPDR5b7t7v/IHJJWiFFFFeeQFFFFABRRRQAUUUUAQQ3cE7skUgZl6jHSp6w9F5vbo9v/r1uVpVgoSshIKKKKzGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRXN%2bLvHWg%2bCbIT6vd7ZHGYraL5pZf91fT3OB7141N8TfiN8QrqS18F6S1laBsGWNQzAf7Ur4VT3wMH3NAH0QSFUkkADkk9qg%2b32f8Az9wf9/BXgkfwK8X6%2bwm8T%2bLRvbkgtJdMPb5io/Imrf8AwzRZ/wDQzz/%2bAY/%2bLoA9w%2b32f/P3B/38FH2%2bz/5%2b4P8Av4K8P/4Zos/%2bhnn/APAMf/F0f8M0Wf8A0M8//gGP/i6APcPt9n/z9wf9/BR9vs/%2bfuD/AL%2bCvD/%2bGaLP/oZ5/wDwDH/xdH/DNFn/ANDPP/4Bj/4ugD3D7fZ/8/cH/fwUfb7P/n7g/wC/grw//hmiz/6Gef8A8Ax/8XR/wzRZ/wDQzz/%2bAY/%2bLoA9w%2b32f/P3B/38FH2%2bz/5%2b4P8Av4K8P/4Zos/%2bhnn/APAMf/F0f8M0Wf8A0M8//gGP/i6APcPt9n/z9wf9/BR9vs/%2bfuD/AL%2bCvD/%2bGaLP/oZ5/wDwDH/xdH/DNFn/ANDPP/4Bj/4ugD3D7fZ/8/cH/fwUfb7P/n7g/wC/grw//hmiz/6Gef8A8Ax/8XR/wzRZ/wDQzz/%2bAY/%2bLoA9w%2b32f/P3B/38FH2%2bz/5%2b4P8Av4K8P/4Zos/%2bhnn/APAMf/F0f8M0Wf8A0M8//gGP/i6APcPt9n/z9wf9/BR9vs/%2bfuD/AL%2bCvD/%2bGaLP/oZ5/wDwDH/xdH/DNFn/ANDPP/4Bj/4ugD3D7fZ/8/cH/fwUfb7P/n7g/wC/grw//hmiz/6Gef8A8Ax/8XR/wzRZ/wDQzz/%2bAY/%2bLoA9w%2b32f/P3B/38FH2%2bz/5%2b4P8Av4K8P/4Zos/%2bhnn/APAMf/F0f8M0Wf8A0M8//gGP/i6APcPt9n/z9wf9/BUscscy7opFdc4ypyK8K/4Zos/%2bhnn/APAMf/F1BN%2bzpqNg/n6J4t2Tj7u%2bBoiD/vKxP6UAe/0V86Sal8Yvhr%2b8vw%2bsaXHy7uTcpjuS/Eij64FejeBfjDoHjOSOykJ03VW4FrOwIkP/AEzfgN9Dg%2b1AHotFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFADQqrnAAycnFOoqjqV69lErpFvycEnoKcYuTsgL1FQ21xHdQrLGcqf0PpU1DTTswCiiikAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBw2uf8hm5/wB4fyFZ9aGuf8hm5/3h/IVn171L%2bHH0QgooorQDK8T3BtfCmrzKcMlnKVPvsOP1qH9nKyWHwRqN5jDz35TPqqomP1ZqTxn/AMiXrP8A16Sf%2bg1d/Z5/5JtL/wBhCX/0FK8zH/EgR6xRRRXAMKKKKACiiigAooooAKKKKACiiigAooooAKKKKAKeqaXZazps%2bnajbJcWlwuySJxwR/Q%2bh7V8x%2bPvgjrPhuaW90OObVNKySAi7p4R/tKB8w9x%2bIFfVFFAHwCQVJBGCOxpK%2b4Na8E%2bGfELmTVdDsrmU9ZWjCyH/gQwf1rnv%2bFJ/D3Of%2bEe/wDJy4/%2bOUAfIIBZgACSeAB3r1f4f/BHWPEU8V9r0UumaTw21xtmnHoqn7o9z%2bANfQFp4Z8HeC7WTUINM03TY4Bue6kUBkH/AF0bn9a8n8aftDbWksvCFsCAcG/uU6/7kZ/m3/fNAHtsEOk%2bGNEht4zb6fptogRd7hERfck/qetcdq/xs8C6SzINVa%2bkXqtnEZB/30cKfwNfK2s%2bIdX8Q3ZutX1G4vZc8GZyQvso6KPYAVmUAfSN3%2b0noqN/oeg38y9jNIkZ/TdVIftL2/msD4Vk8vHDC%2bGSfp5f9a%2be6KAPpO0/aS0JyPtmh6jCO/kukn8ytdZpPxp8C6qyp/a/2OQ/wXkTR/8Aj3K/rXyBRQB97Wd/Z6jbi4sbuC6gPSSCQOp/EcVZr4O0zWNS0W6Fzpl/cWc4/jgkKE/XHUV6z4V/aF1vTmSDxFax6nbjgzxARzD34%2bVvyH1oA%2bmKK5zwr468PeMrbzNHv0klUZkt5Pklj%2bqn%2bYyPeujoAKKKKACiiigAooooAK8f%2bN/j260Wzg8MaK8g1XUVHmPF9%2bOInAVcc7mOR9AfUV7BXzz4ZiHjH9pTVr65Hmw6XJK8YP3f3RESY/Ehh7jNAHd/DD4U2Hg2whv9QgjuNekXc8rDcLfI%2b4nbI7t1PPavS6KKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA4zx/8ONJ8d6Y6Txpb6mi/wCj3qr8ynsG/vL7H8MV5z8GvFmpaB4iuPh34iLLJC7raFz9xxyUB7qRllP%2bIr3mvnv48Wx8O%2bOPDni2zGy4Y/Pt4y8LKQT9Q2PotAH0JRTI5FljWRDlWAYH1Bp9AHi37SNoj%2bENJvTjfDf%2bUPo8bE/%2bgCr/AIena68NaVcP96Wzhc/UoDUP7R3/ACTzT/8AsKx/%2bipaPCv/ACKGi/8AXhB/6LWu/AfFITNeiiivTAK0tA/5Ddv/AMC/9BNZtaWgf8hu3/4F/wCgmsq38OXowO3ooorwhhRRRQAUUUUAFFFFABRRRQAUUUUAY3ib/kFD/rqP5GuPrsPE3/IKH/XUfyNcfXr4L%2bEIKKKK6wPKvjZ/x56N/wBdJf5LX0tYf8g62/65J/IV80/Gz/jz0b/rpL/Ja%2blrD/kHW3/XJP5CvGxf8ZjRYooormAKKKKACiiigAooooAKKKKACiiigArwnwGg8RftC%2bKdYnw/9n%2bbFCfQhhCpH/AFb8692rwn4Tgaf8avG%2bnS5ErPM6ZGNyifr%2bTqaAPdqKKKAMaTwl4bmDCXw/pT787t1nGc59flrwr40/CzTtA09fEmgQ/Z7USLHd2qnKJu4V19BnAI9xivo6uZ%2bIWk3OueANa06zg8%2b5mtz5UeR8zAhgBnvxxQBznwT8VT%2bJvAaR3kjSXmnSfZndjlnUAFGP4HH/Aa9ESCJJ5JljVZZAA7gcsBnGfzNeO/s/eG9c0Kx12XV9OubGO5khWGO5jMbEoH3HacHHzLz3/CvZ6ACue1HW3LmK0bao4Mnc/StHWJzBpsm04ZzsH49f0zXJU0jpw9NP3mSNNK7bnkdj6lqnt9RurVgUlYqP4GORVSiqOtxTVmjsbC/jvod6/K44ZfQ1crktGnMOpRgH5X%2bQj69P1qpL8XvA8GoT2M2tiOaBzGxNvKVLDOcMFI7dfyqWcFaHJKyO4rznUdJvdZ8T3otosqJNrSHhVwAOTXRWnj/wAI32PI8SaWSeivcqhP4MQa3LW7tLpN1rcQzL1zE4YfpSKoV3RbcVqzO0LQYtEhcLK8ksmN7HgcegrVmmjgTfK6ovqTTyQoJPAFcbfXj3tw0jE7AfkX0FNIIqVeblJiePdStrzwD4gtoGZpHsJgvy4BO0%2btYfwB/wCSXQf9fc38xS%2bIv%2bRZ1b/rzm/9ANJ8Af8Akl0H/X3N/MUNCrU1C1j1CiiikYhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHl/wAfv%2bSXT/8AX3D/ADNYngP/AJEbSP8Ar3H8zW38fv8Akl0//X3D/M1ieA/%2bRG0j/r3H8zXdgfjfoJnRUUUV6gBXolv/AMe0X%2b4P5V53Xolv/wAe0X%2b4P5V5%2bP2iMlooorzQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDF0KN1kuGkRlJ29Rj1raooq6k%2beXMCCiiioAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK4L4nfEm08A6Sqxqlxq90p%2by25PCjpvf/ZHp3PHqR12s6ra6Fo15qt6%2by2tImlkPcgDoPc9B7mvAPhvoF18UvHd9408RR%2bZYW837uFuUZxykY/2UGCfXjPU0AXPAvwo1DxleDxd48mnmW5IkitXYh5h2L/3UxjCjHHoOvvdnZ2un2kdpZW8VvbxDakUSBVUegA4FT0UAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFeS/ET4K6b4hil1Pw9HHp%2bsLl/LT5Yrg%2bhHRW/2h%2bPqPWqKAPEfhV8Ub7%2b0/wDhDfGBkj1KJvJt7icEOzDjypM/xejd%2b/OM%2b3V5B8b/AIfrrOknxRpcZTVtPXdN5fBmiHfj%2bJeoPpkdhjo/hN42bxr4OjmunDanZkQXfqxA%2bV8f7Q/UNQB3lFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFMkjSaNo3UFWGCKfRQBz377Rb3u1u5/Mf41vI4kjV1%2b6wyKJIkmXbIgZc5wRT60qVOeza1EkFFFFZjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOG1z/kM3P%2b8P5Cs%2btDXP8AkM3P%2b8P5Cs%2bvepfw4%2biEFFFFaAYfjP8A5EvWf%2bvST/0Grv7PP/JNpf8AsIS/%2bgpVLxn/AMiXrP8A16Sf%2bg1d/Z5/5JtL/wBhCX/0FK8vHfEho9YooorhAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArB8W%2bLtL8GaHJqmqS4UfLFEv35n7Ko9f5VZ8Q6/YeGNCutX1KXy7a3XJA6ueyqO5J4FfHHjTxnqfjfXpNS1BysYJW3twcpAmeFHv6nvQBa8c/ELWvHeoma/l8qyRibeyjJ8uIdif7zerH8MDiuSoooAKKKKACiiigAooooAKKKKAJ7S7ubC6jurOeW3uIjujlicqyn1BHIr3j4efHti8Wl%2bMSMH5Y9SRcYPbzFH/AKEPxHU14BRQB99xTR3EKTQyJJE6hkdGyrA9CD3FSV8pfCn4sXHg66TStWkkn0KVvdmtSf4l/wBn1X8RzkH6ognhureO4t5ElhlUOkiHKsp5BB9KAJaKKKACiiigAr59%2bGjjRv2gfFGmXBw10bpYs9WPmiRf/HMmvoKvAPjRot/4V8Z6Z8QtIU48xFuCBwsq8Dd/sso2n6e9AHv9FYXhPxVp3jHQINW02QFHGJYifmhfuje4/Xg963aACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8B/aQuVubvw1pMI33TGWTYOuGKKv5kN%2bVe46tq1joel3GpajcJb2luheSRj2HYep9AOTXz/4NhvPiz8YZfFV3C6aRprq8av0Xb/qox75%2bc/j6igD6It4vItooid2xAufXAqWiigDx/8AaO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtH7R3/JPNP/7Csf8A6Klo8K/8ihov/XhB/wCi1rvwPxMTNeiiivTAK0tA/wCQ3b/8C/8AQTWbWloH/Ibt/wDgX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/wAgof8AXUfyNcfXr4L%2bEIKKKK6wPKvjZ/x56N/10l/ktfS1h/yDrb/rkn8hXzT8bP8Ajz0b/rpL/Ja%2blrD/AJB1t/1yT%2bQrxsX/ABmNFiiiiuYAooooAKKKKACiiigAooooAKKKKACvBPiSk/w%2b%2bL2k%2bOYImOn3pEd3tH8QXY4%2bpTDD1Kn0r3usfxN4c0/xZoFzo%2bpIWgnHDL96Nh0ZT6g0AaNnd29/Zw3drKs1vOgkjkQ5DKRkEVPXzxofiXxF8E9V/wCEf8T28174ekcm1uYudg7mPP6oTx1HXn3DQvE%2bieJrQXOjalb3iEZKxv8AOn%2b8vVT9QKANeiis7V9d0rQLM3erahb2cA/imcLn2A6k%2bwoA0aK4zwT8QbTx3qWrjS7d106w8pEuJeGmdt2SF/hUBR15Oe1dnQBl69GZNNJA%2b44b%2bn9a5au6kjWWNkcZVhgj1rkr/TpbGU5BaIn5X/x96aOvDTVuVlKiilVWdgqgsxPAA61R1FvS4zJqUAHZtx/Dmvn/AFzw7pWi/GK70vxGJo9IubpnEsb7SkcmWRgSDkAnB%2bjelfTmkaabNDLKP3zjp/dHpXL/ABN%2bHEHjvTI5IHS31a1B%2bzzMPldepRu%2bPQ9j9TUs4K81KWhyd1%2bzzoMo3WWtahEDyDKEkH6Ba4zxh8Gj4N0O41lvE0LRw42I9uY3dz0VcMef/rntUun%2bMPiT8Nov7Iv9Ke4tIfkiF1Czqo/2JFPI/E/hSx6B4/8AjBrEM%2btRyafpcROHkhMUUY7%2bWhOXJ9cn3NIy0Oj%2bAkeuXun61eXd9cy6cVEEEU0hZTJjJK56YBA467vau2rrdE0ay8PaNa6Vp0Xl2tsm1FJyT3JJ7knJP1qhqmjO0rT2q7t3LJ6H2po3w81FtM4/xF/yLOrf9ec3/oBpPgD/AMkug/6%2b5v5imeMzJp/gvWp5keILZyqGZcDcylV6%2bpIFXfgbam3%2bFGmOwwZ5Jpf/ACIyj9FoY8S02j0aiiikcwUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB5f8fv%2bSXT/APX3D/M1ieA/%2bRG0j/r3H8zW38fv%2bSXT/wDX3D/M1ieA/wDkRtI/69x/M13YH436CZ0VFFFeoAV6Jb/8e0X%2b4P5V53Xolv8A8e0X%2b4P5V5%2bP2iMlooorzQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmSSJEm%2bRgq%2bpNPrI1%2bTbaRx93fP4D/wDWKunDnkogzVV1dQyMGU9CDkU6oLOPyrOFO4QZ%2btT1L0egBRRRSAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8U/aK16S38P6boEDHfqExllVepRMYGPdmB/wCA16X4J8Ox%2bFfB2maOqgSQQgzEfxSnlz/30T%2bGK8d%2bJA/tn9oXwxprjdDD9mDIehHmM7fmMV9BUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQA1lDqVYAqRggjgivnjwQh%2bHvx%2b1Dw2CV0%2b/LRRA9MMPMiPuR9z6k19E18%2b/GNP7M%2bMfhLV4eJG8gsAepSb%2bobH4UAfQVFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBlXepy2l%2bqSRYtyOvc%2b4/wrTjkWVA6MGU8gjvUdzbR3UJilGQeh7g%2btY0Au9LvFg2mWKQ8Y7%2b49DW6jGpHTRr8RbG/RRRWAwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOG1z/AJDNz/vD%2bQrPrQ1z/kM3P%2b8P5Cs%2bvepfw4%2biEFFFFaAYfjP/AJEvWf8Ar0k/9Bq7%2bzz/AMk2l/7CEv8A6ClUvGf/ACJes/8AXpJ/6DV39nn/AJJtL/2EJf8A0FK8vHfEho9YooorhAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiuT%2bJHij/hEfAuo6nG4W6KeTa/9dX4Uj6ct/wABNAHgnxz8ct4i8TnQ7OUnTNLcowU8Sz9Gb8Puj/gXrXk9OZi7FmJLE5JJ5JptABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXu/wABfiG0Fyvg/U5swyktp8jH7jdWj%2bh5I98juMeEVLbzy2lzFcwSNHNE4eN1OCrA5BHvmgD76ornfA3iZPF3g7TtZXaJZo9s6r/DKvDj8xkexFdFQAUUUUAFVdQ0%2b01XT57C/t0uLWdCksUgyGBq1RQB876t8OfGnwy1qXWvAtxNeae3L26jfIFzna8f/LQehXnr061f039o7yB9n8QeHJYrlDiQ2smOf9x%2bV/76Ne81TvdJ07UsfbtPtbrHTz4VfH5igDyP/hpHw3/0BtV/KP8A%2bKo/4aR8N/8AQG1X8o//AIqvUP8AhE/Df/Qv6V/4BR/4Uf8ACJ%2bG/wDoX9K/8Ao/8KAPL/8AhpHw3/0BtV/KP/4qj/hpHw3/ANAbVfyj/wDiq9Q/4RPw3/0L%2blf%2bAUf%2bFH/CJ%2bG/%2bhf0r/wCj/woA8v/AOGkfDf/AEBtV/KP/wCKo/4aR8N/9AbVfyj/APiq9Q/4RPw3/wBC/pX/AIBR/wCFH/CJ%2bG/%2bhf0r/wAAo/8ACgDy/wD4aR8N/wDQG1X8o/8A4qj/AIaR8N/9AbVfyj/%2bKr1D/hE/Df8A0L%2blf%2bAUf%2bFH/CJ%2bG/8AoX9K/wDAKP8AwoA8v/4aR8N/9AbVfyj/APiqP%2bGkfDf/AEBtV/KP/wCKr1D/AIRPw3/0L%2blf%2bAUf%2bFH/AAifhv8A6F/Sv/AKP/CgDy//AIaR8N/9AbVfyj/%2bKo/4aR8N/wDQG1X8o/8A4qvUP%2bET8N/9C/pX/gFH/hR/wifhv/oX9K/8Ao/8KAPL/wDhpHw3/wBAbVfyj/8AiqP%2bGkfDf/QG1X8o/wD4qvUP%2bET8N/8AQv6V/wCAUf8AhR/wifhv/oX9K/8AAKP/AAoA8v8A%2bGkfDf8A0BtV/KP/AOKqnqH7SVj5e3SvD11NMwwv2mZUAP0XcT%2bleuf8In4b/wChf0r/AMAo/wDCrFnoek6fJ5llpdlbP/egt0Q/mBQB8/x%2bGviJ8YdRhufERk0rREbeqPGY1A/6Zxk5Y4/ib8%2b1e9eHPDmm%2bFNEg0nSoPKtoh1PLOx6sx7k/wCeK1qKACiiigDx/wDaO/5J5p//AGFY/wD0VLR4V/5FDRf%2bvCD/ANFrR%2b0d/wAk80//ALCsf/oqWjwr/wAihov/AF4Qf%2bi1rvwPxMTNeiiivTAK0tA/5Ddv/wAC/wDQTWbWloH/ACG7f/gX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/yCh/11H8jXH16%2bC/hCCiiiusDyr42f8AHno3/XSX%2bS19LWH/ACDrb/rkn8hXzT8bP%2bPPRv8ArpL/ACWvpaw/5B1t/wBck/kK8bF/xmNFiiiiuYAooooAKKKKACiiigAooooAKKKKACiue8SeN/DnhKLdrOqwW8hGVgB3yt9EGTj3xivIdd/aLmmlNv4X0PcTwJr3LE/SND/7N%2bFCTeiA9z1PS7DWbCSx1Kzhu7WT70UyBlPvz3968c8TfA7wvZTG%2b07xM/h5/vKLiVWjX/dJZWA9yxrzfUfFvxG8SZ%2b163cWsLf8s4XEC49MJgn8axR4VaaQy3l%2b8sjcsQMk/ia7aeXYmptD79PzLUJPodheWdzYIYZPjajRDI2wXlxKCOeyEj/PvXleoTzXF9K096164Yr9oZmbzAOhBYBsfUA110fhbTU%2b8JZP95/8MUtz4a0%2bW2ZIIvJk6q%2b4nB/E9K6v7FxNr6feP2Uj079mj/kHeIv%2busH8nr3ivB/2aP8AkHeIv%2busH8nr3ivIMwprKrKQwBB6g06igCi%2bk2Ltk2y5/wBkkfyqeG0t7f8A1MKIfUDn86nooKcpPRsKKKKCQooooAKKKZLLHDE8srqkaKWZmOAoHJJNAHjv7RGtC38KafocJJuNQuQ5ReSUTtj3Zkx9DXpfhLR/%2bEf8I6TpJAD2trHHJju%2bPmP/AH1mvEtDZ/i38b21koW0LRirRbhwVUnywR6s%2bWx6AivoegAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8v8Aj9/yS6f/AK%2b4f5msTwH/AMiNpH/XuP5mtv4/f8kun/6%2b4f5msTwH/wAiNpH/AF7j%2bZruwPxv0EzoqKKK9QAr0S3/AOPaL/cH8q87r0S3/wCPaL/cH8q8/H7RGS0UUV5oBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWNqcE1zqNugjYxDALY45PNbNFXCbg7oAoooqACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDwDxV/wAnQ6J/2w/9Bavf68A8Vf8AJ0Oif9sP/QWr3%2bgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvn/8AaI/5GLwof%2bun/oaV9AV8/wD7RH/Iw%2bE/%2b2v/AKHHQB9AUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVjajBdw3P223kZgBgqP4R9O4q4RUna9gZs0VQsNTivBsbCTd19fpV%2blKLi7MAoooqQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOG1z/kM3P%2b8P5Cs%2btDXP%2bQzc/wC8P5Cs%2bvepfw4%2biEFFFFaAYfjP/kS9Z/69JP8A0Grv7PP/ACTaX/sIS/8AoKVS8Z/8iXrP/XpJ/wCg1d/Z5/5JtL/2EJf/AEFK8vHfEho9YooorhAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvnr9pLXC15o2go%2bFRGvJV9SSUT8sP8AnX0LXx/8adROofFTV/mylv5dunttQZ/8eLUAcBRRRQAUUUUAFFFFABRRRQB33w8%2bHUnj7S9fNvL5V5ZRxNbMx%2bR3Yt8jexC9exx%2bPE3lnc6dezWd5A8FzC5SSKQYZWHUEV9UfAjw%2b2jfDuO7lTbPqcrXJz12cKg%2bmAW/4FU/xP8AhVZ%2bObU31mUtdciTEcx4WYDosn9D29xQB8kUVe1bSNQ0LUptO1O1ktruI4eOQYP1HqPcVRoAKKKKACiiigD3/wDZt11i2s%2bH5HyMLewr6dEf/wBp19AV8jfA2%2bNn8VtNjzhbqOaFv%2b/ZYfqor65oAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPH/wBo7/knmn/9hWP/ANFS0eFf%2bRQ0X/rwg/8ARa0ftHf8k80//sKx/wDoqWjwr/yKGi/9eEH/AKLWu/A/ExM16KKK9MArS0D/AJDdv/wL/wBBNZtaWgf8hu3/AOBf%2bgmsq38OXowO3ooorwhhRRRQAUUUUAFFFFABRRRQAUUUUAY3ib/kFD/rqP5GuPrsPE3/ACCh/wBdR/I1x9evgv4QgooorrA8q%2bNn/Hno3/XSX%2bS19LWH/IOtv%2buSfyFfNPxs/wCPPRv%2bukv8lr6WsP8AkHW3/XJP5CvGxf8AGY0WKKKK5gCiiigAooooAKKKKACiiuZ8b%2bN9L8C6I1/qDb5nyttaq2Hmf0HoB3Pb6kAgGprevaZ4c0yTUdWvI7W1j4Luep7ADqT7Cvn7xd8cdd8RTyad4RglsLXobkgGdx656Rj9fcdK43V9W134j6wdT1m4ZLRSRDCnCRr/AHUH82PJrStrWCzhEUEYRB6d/qa9XBZXOuueekfxZpCm5asxYPDZnma61W5kuZ5DufLklj7seTW3BbQWqbIIkjX0UYzUtFfS0MJRoL93G35nQopbBRRRXSMKKKKAO1/Zo/5B3iL/AK6wfyeveK8H/Zo/5B3iL/rrB/J694r88OIKKKKACiiigAornbvx54TsLya0u/EWmwXELFJIpLhQyMOoI9ah/wCFj%2bC/%2bho0r/wJX/GgDqKK5Y/EjwWAT/wlGlcelytc7rXx08E6VE32a9m1KYcCO0hOPxZsLj6E0AelHj6V4L8TviDc%2bMdRTwJ4LLXRuXEd1cwn5ZPVFI/gHVm6YHpnOXP4o8e/GmebS9Bt10vRAQlywkwMHtI/Vv8AdUfUd69c8A/DjSPAVgVtQbjUJVxPeyLhn/2VH8K57fmTQBb8BeDLTwN4Yh0u3KyXBPmXU4GPNkPU/QdAPQepNdRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeX/H7/kl0/8A19w/zNYngP8A5EbSP%2bvcfzNbfx%2b/5JdP/wBfcP8AM1ieA/8AkRtI/wCvcfzNd2B%2bN%2bgmdFRRRXqAFeiW/wDx7Rf7g/lXndeiW/8Ax7Rf7g/lXn4/aIyWiiivNAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiuO8RfFHwf4YleC/1iJ7pMhre2BlcH0O3hT9SK4W7/aS0GNmFnoeozAdDK6R5/ItQB7XRXiVr%2b0nojsPteg6hEO5hkSTH5la7bw/8WfBniORIbbV0t7l%2bBBeDyWJ7AE/KT7AmgDt6KTr9KWgAooooAKKKKACiiigAooooAKKKKAILm6itIhJKcLnHAqSORZY1dDlWGQaxdWc3eoQ2aHoefqf/rVtogRFRRhVGAK0nBRin1Yh1FFFZjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDwDxV/wAnQ6J/2w/9Bavf68A8Vf8AJ0Oif9sP/QWr3%2bgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvn/8AaI/5GHwn/wBtf/Q46%2bgK%2bf8A9oj/AJGHwn/21/8AQ46APoCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDMutHinmWWJjE27Lbe/09DWkBgAUtFVKcpJJvYAorP1K%2blshGyQ71J%2bZj0%2blS2l/BeL%2b7bD90PUU/Zy5ea2gXLdFFFQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHDa5/yGbn/eH8hWfWhrn/IZuf8AeH8hWfXvUv4cfRCCiiitAMPxn/yJes/9ekn/AKDV39nn/km0v/YQl/8AQUql4z/5EvWf%2bvST/wBBq7%2bzz/yTaX/sIS/%2bgpXl474kNHrFFFFcIBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV8QeOp/tPxA8RS7twbUrjacY48xsfpivt%2bvh3xrF5HjvxDDknZqVyuSOuJG5oAwqKKKACiiigAooooAK2vCnh%2bfxT4p07RYMhrqYKzD%2bBBy7fgoJrFr6X%2bA3gCTRtNfxPqUWy8vo9trGw5jhPO4%2b7YGPYD1oA9itLWGxs4LS2jEcEEaxRoOiqowB%2bQqaiigDmPGXgPQ/HFh9n1W3xOgxDdRYEsX0Pcex4r5l8b/CTxF4MeScwm/0sEkXluhIUf7a8lP5e9fYNIefpQB8A0V9feJ/g14Q8TO85sm067fkz2JCZPqUwVPvxn3ryrWf2ctetmZtH1Wyvox0WYGF/6j9RQB4tRXZaj8KfHOlk%2bd4cvJAD1tgJ8/8AfBJrnLvRdV09Wa90y8tlXG4zQMgGfXIoA6r4OqW%2bK%2bghVJPmyHgdhE5NfY1fO/7P3gi7/tN/Ft9btHapE0dizceYzHDOB6AAr/wL2r6IoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPH/2jv%2bSeaf8A9hWP/wBFS0eFf%2bRQ0X/rwg/9FrR%2b0d/yTzT/APsKx/8AoqWjwr/yKGi/9eEH/ota78D8TEzXooor0wCtLQP%2bQ3b/APAv/QTWbWloH/Ibt/8AgX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/wCQUP8ArqP5GuPrsPE3/IKH/XUfyNcfXr4L%2bEIKKKK6wPKvjZ/x56N/10l/ktfS1h/yDrb/AK5J/IV80/Gz/jz0b/rpL/Ja%2blrD/kHW3/XJP5CvGxf8ZjRYooormAKKKKACiiigAooooAz9a1iz8P6Nd6tqEvl2trGZJG/kB7k4AHqRXyVq2r6h8R/FNxrWplktFbbFAGysaDog/mT3J969C/aC8TTXmp6f4PspPlG24ugO7nhFP0GW/wCBD0rjrO1SytI7eP7qDGfU9zXq5VgliKnPP4V%2bLNKcLu7JlVUUKqhVAwABwBS0UV9adIUUUUwDpzWVY6/aXtw8HMThiED/AMY/x9q1ayNW0GDUMyxYiuf7w6N9f8a5cT7dJSo2dt13%2bZMr9DXorl7LWrrTJhZ6qjbR0kPJA/qK6aORJY1kjcMjDIZTkGnh8VCuvd0a3T3Q4yTO3/Zo/wCQd4i/66wfyeveK8H/AGaP%2bQd4i/66wfyeveK%2bFOMKKKKACiiigD4%2b8UWEGo/FfxNDOGKC7mYbTjneB/Wof%2bEX0z%2b5L/33V3XZEi%2bLfil5HVFFzPlmOAP3grKvfE26T7PpsRmkPAfaSPwHU17%2bB%2bqQwynWSbu%2bl2zaHKo3Y%2b40HRrSIy3DNGnqZOtP0uy0W9hd7a1DAEqfMyT9eTxVW28PXV9KLnVp2JP/ACzB5/PoPwrobe1gtIhFBEsaDsB1%2btd2Hoc8%2bd0lGPmtf%2bAXGN3exk6fe6x8P9bTWtCnYRAgSRtkq65%2b447r79vrzX1F4I8bab450JdRsDslTCXNsx%2baF/Q%2bo9D3%2buQPndlV1KsoZSMEEcEVk6JrV/8ADbxZBq%2bn5kspDsmgJ4kjPVD79wfbvyK8zM8tVH97S%2bHqu3/AM6kLao%2bxKKo6RqtnrmkWuqWEoltbqMSRuPQ9j6EdCOxBq9XimQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeX/H7/kl0/wD19w/zNYngP/kRtI/69x/M1t/H7/kl0/8A19w/zNYngP8A5EbSP%2bvcfzNd2B%2bN%2bgmdFRRRXqAFeiW//HtF/uD%2bVed16Jb/APHtF/uD%2bVefj9ojJaKKK80AooooAKKKKACiiigAooooAKKKKACiimSSpCheR1RR1LHAFAD6KwrrxNbRErbxtMfX7o/xrOfxRek/JFCo%2bhP9a6I4WrLWwHXUVx//AAk1/wD3Yf8Avk/40f8ACTX/APdh/wC%2bT/jV/UqoHYUVx/8Awk1//dh/75P%2bNH/CTX/92H/vk/40fUqoHYUVx/8Awk1//dh/75P%2bNH/CTX/92H/vk/40fUqoHYUVx/8Awk1//dh/75P%2bNH/CTX/92H/vk/40fUqoHYUVx/8Awk1//dh/75P%2bNB8T3wGSIcf7p/xo%2bpVQOh1fV7DQdKuNT1O5S3tIF3SSP%2bgA7k9AB1r5f8f/ABo1rxXNLZ6VJLpmkcqI42xLMPV2HT/dBx65rP8Aij8RL3xrq4tlmA0qzYiGOPhZG6GQ%2bvoPQfU15/XK1Z2AKKKKQBRRRQB6J4C%2bLuu%2bDJYrWeR9Q0ccNaytkxj1jY/d%2bnT6da%2bpfDviLTPFOjRarpNyJ7aTg9mRu6sOxHp/Q18LV2nw58f33gXXPMjkLafckJdQtyMdnA/vD%2bWRTSu7AfZdFcbH4qvJY0kjMDI4DKwUkEHoetO/4Sa//uw/98n/ABrq%2bpVQOworj/8AhJr/APuw/wDfJ/xo/wCEmv8A%2b7D/AN8n/Gj6lVA7CiuP/wCEmv8A%2b7D/AN8n/Gj/AISa/wD7sP8A3yf8aPqVUDsKK4//AISa/wD7sP8A3yf8aP8AhJr/APuw/wDfJ/xo%2bpVQOworj/8AhJr/APuw/wDfJ/xo/wCEmv8A%2b7D/AN8n/Gj6lVA3LHT5Yb6W5nZWY/dI9%2btalcf/AMJNf/3Yf%2b%2bT/jR/wk1//dh/75P%2bNVPC1pu7sI7CiuP/AOEmv/7sP/fJ/wAaP%2bEmv/7sP/fJ/wAan6lVGdhRXH/8JNf/AN2H/vk/40f8JPf%2bkP8A3yf8aPqVUDsKK8X8SfHW00QvBaCHULxeNsI%2bRT7vnH5Z/CvJvEXxi8Z%2bISyNqjWFs3HkWP7oY92HzH88VzzhyOzYH1hqWvaPowzqeq2VkMZH2i4WPP5mubm%2bLXgSCTY/iS1J/wBhXcfmFIr44kkeWRnkdndjksxySfc0yoA%2by4fi14EnkCJ4ktAT/fV0H5sAK6XTdb0rWYvM0vU7O9QdTbzrJj64PFfB9SwTzWsyzW8skUqnKvGxVgfYigD76or5Q8LfHPxVoWyDUZxq1mOD9p5lUez9T/wLP4V7VoHxITxJYC706WBwOHjZCHjPowzWtOjKppED0WiuP/4Sa/8A7sP/AHyf8aP%2bEmv/AO7D/wB8n/GtvqVUDsKK4/8A4Sa//uw/98n/ABo/4Sa//uw/98n/ABo%2bpVQOworj/wDhJr/%2b7D/3yf8AGj/hJr/%2b7D/3yf8AGj6lVA7CiuP/AOEmv/7sP/fJ/wAaP%2bEmv/7sP/fJ/wAaPqVUDsKK4/8A4Sa//uw/98n/ABo/4Sa//uw/98n/ABo%2bpVQOworj/wDhJr/%2b7D/3yf8AGj/hJr/%2b7D/3yf8AGj6lVA7CiuP/AOEmv/7sP/fJ/wAaP%2bEmv/7sP/fJ/wAaPqVUDsKK4/8A4Sa//uw/98n/ABo/4Sa//uw/98n/ABo%2bpVQPMPFX/J0Oif8AbD/0Fq9/r5x1K8lvv2kdDnmC7y0I%2bUYH3Wr6OrmlFxbiwCiiipAKKKKACvJvid8Xv%2bEXvP7A8Pwrea4%2bFcld6wFui7RyznIwPcZz0rvfF%2bvDwz4R1TWSAWtbdnjDdC54QH6sRXknwF8Ji/a88c6tm4vpp3S2eTkg/wDLST6kkr%2bDetAGZbfCb4heN1F94s8QyWay8iCdjK6j/rkpCL9Mj3Aqab4A%2bJdCH2rw14sDXSfMBte1JPoGVm/XFfQlFAHg3hL4t674a18eGPiLC8TghVvZFCtHnoXxwyH%2b%2bPxz1Hu6sHUMpBUjIIPBFcB8XfBNv4t8HXUyQj%2b1NPjae1kA%2bY4GWj9wwHT1xWb8B/E82u%2bBTY3Uhe40uXyAxOSYiMpn6fMv0UUAep0UUUAZHiTxHpvhTRJ9W1WbyraLgActI3ZVHcn/ADwK8HHiD4k/GG9mTQS2kaIjbS6SmNF9nkA3O3qFGParHxRluvH3xh0zwRbyulpalVl29mZd8j/UJgD3B9a960rS7LRNLt9N063SC0t0CRxqOg/qe5Pc0AeFj9m69lX7RP4uX7X1JFmzc/7xkB/Ss67h%2bKPwfZbw3p1XRFYB8u00IB7MG%2baP6jAzjk5xX0lUc0UdxC8MyLJFIpR0cZDA8EEelAHN%2bBfHOm%2bPND/tCxzFNGQlzbOcvC39Qex789wQOor5wt7ZvhL8ebeztXZdG1Yoqxk8CKVtoB/3HHXrge9fR9ABRRXHfFDxLJ4U%2bH%2bpahbvsu3UQW7A4IdzjI9wMt%2bFAHEfET4w3dprDeF/BcH2vVi/kyXCp5myT%2b5GvRmHcnIH8sC3%2bCfjXxWovPFviZoJX58qRmunT2I3BR9AcV0vwF8Fwad4c/4Si7jD6jqO4Qu3WOEHHHuxBJPpt969ioA%2beZ/gd4x8MKbvwp4pMsyfN5aFrV29h8xU/QkCtnwD8YdQXWx4W8dQ/ZdQDiJLp4/LJfssi9Bnsw46fWvba8l%2bOvgm31vwpLr9vCBqWmJvZ1HMkOfmU/7v3h9D60AetUVw3wk8Ty%2bKfh5Y3VzJ5l3bE2lwxPLMmME%2b5UqT7k13NABRRRQAV8//ALRH/Iw%2bE/8Atr/6HHX0BXz/APtEf8jD4T/7a/8AocdAH0BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAIVDKQwBB6g1j3ejfN51m2xxztzj8j2rZoq4VJQd0FirY/aDar9q/wBZ9Oce9WqKY7bELYJwM4A5NS3d3AfRWTba3FI2y4Xym9eo/wDrVqKyuoZSGB6EGnOEoO0kFx1FFFSAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBw2uf8hm5/wB4fyFZ9aGuf8hm5/3h/IVn171L%2bHH0QgooorQDD8Z/8iXrP/XpJ/6DV39nn/km0v8A2EJf/QUql4z/AORL1n/r0k/9Bq7%2bzz/yTaX/ALCEv/oKV5eO%2bJDR6xRRRXCAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFfHPxh05tN%2bKetoVISaRbhD6h1DE/mSPwr661TU7PRtMuNR1CdYLS3QvJIx4A/x7Ad6%2bd5dD1X48eMn1uK0XSdCtkFsLp13PIqkkADozndz2UYGTgZAPFKK%2byvD3wo8HeHIUEGjwXc4HNxeqJnJ9fm4X8AK6r%2bzbDy/L%2bxW2zG3b5S4x6YxQB8F0V9k%2bIvhP4O8SQsJtIhs7gji4sVELg%2bpAG1v%2bBA184/EP4X6t4CuRK5%2b2aVK22K8RcYP91x/C36Ht6AA4Sl6/Wt/wx4L1/xhd%2bRo2nyTKDh52%2bWKP/ec8D6dfQV9HeAPgto/hJ4tQ1MpqerLyrsv7qE/7Cnqf9o/gBQBwvwo%2bC8t3Lb%2bIPFNu0dspEltYSLhpT1DSDsvovfvx1%2biun0paKACivJPjx4z1Lwx4fsNP0uZ7a41N5A1xGcMkaBdwU9iS68%2bgNfN%2bmeItZ0bUl1HT9TuoLsNu8xZDlv97%2b8PY0AfddFYfg7XT4m8IaXrLoEku4FeRR0D9Gx7ZBxW5QAUVzVnrXl%2bLL7Tpn%2bSVwYiezBQCPxx%2bnvXS0GlSnKm0n1Vwrzf46/8ko1L/rrB/wCjFr5p8U%2bL9Z8Ua9PqN/dzhjITDDvIWBc8Ko7YrvovFeqeIvgBr9rqk8ly%2bn3dskVxIcsyM4IUnqSCDyexFBme0fB//klGgf8AXJ//AEY9dxXD/B//AJJRoH/XJ/8A0Y9dxQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeP8A7R3/ACTzT/8AsKx/%2bipaPCv/ACKGi/8AXhB/6LWj9o7/AJJ5p/8A2FY//RUtHhX/AJFDRf8Arwg/9FrXfgfiYma9FFFemAVpaB/yG7f/AIF/6Caza0tA/wCQ3b/8C/8AQTWVb%2bHL0YHb0UUV4QwooooAKKKKACiiigAooooAKKKKAMbxN/yCh/11H8jXH12Hib/kFD/rqP5GuPr18F/CEFFFFdYHlXxs/wCPPRv%2bukv8lr6WsP8AkHW3/XJP5Cvmn42f8eejf9dJf5LX0tYf8g62/wCuSfyFeNi/4zGixRRRXMAUUUUAFFFFABRRUN1I0VpPIn3kjZhn1AoA%2bQ7y/bxF8Stc1hzuU3EhjPoudqD/AL5Fatcx4PHy3jdyUH866evsMogo4WL73Z1Ul7oUUUV6ZYUUUUAFFFFAFe9sbe/gMVwm4diOqn1Brmmj1Dw1NvjJnsmPIPT8fQ%2b9dbSMoZSrKCCMEEda48RhI1XzxfLNbNfr3JlG%2bvU7T9mmSP7H4hi3r5hkgbZnnGH5x6V71XxsbDUNC1FNX8OXUtrdRHcBG2D7gdiPVTwa9v8Ah18arDxI0Wk%2bIPL0/WM7Fc/LFcN6DP3WP909ex5xXyGJwtXDy5aiOaUXHc9aoorz/wAa/F7w14OElv539o6mvH2S2YHaf9t%2bi/Tk%2b1c5J3zMsaF3YKqjJJOABXlHjT466HoPmWehBdY1AfLuRv3CH3Yff%2bi/mK8i8ReMvGHxEcreXH2HSici2hysZHv3c/Xj0xUGn6LZ6cAY03y95H5P4elejhcsrYj3npHu/wBC402zIn07UvEus3esapst3vJWmkCLgkscnA7D61u2WnWunx7beIKe7Hlj9TVqivpcLgKOG1irvu9zojBRCiiiu0oKr3tpHfWklvIOHHB9D2NWKKmUVJOMtmB1f7P/AIqlstSvvBt%2b5%2bYtPaAno4%2b%2bo%2bo%2bYfRvWvoKvja5vpPDXjLSfEEGQYZkkYL1baRuH4qcV9jRyJLEkkbBkcBlI7g18NiqLoVpU%2bxxyVnYfRRRXOIKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8v%2bP3/JLp/wDr7h/maxPAf/IjaR/17j%2bZrb%2bP3/JLp/8Ar7h/maxPAf8AyI2kf9e4/ma7sD8b9BM6KiiivUAK9Et/%2bPaL/cH8q87r0S3/AOPaL/cH8q8/H7RGS0UUV5oBRRRQAUUUUAFFFFABRRRQAUUUySRYo2kcgKoJJ9BQBW1C/h0%2b3MkhyTwqjqxrjL7ULi/lLzP8oPyoOi0uo3z6hdtM2QvRF9BVSvYw%2bHVNXe4gooorqAKKKKACiiigAooooAKKKKACuQ%2bJWtNo3g64ETbZ7si2QjqM53H/AL5B/MV19eQ/Gu6Jm0i0B%2bULJIR6k7QP5H86wxEuWk2gPJ6KKK8QYUUUUAFFFFABRRRQB738KNbbVPCv2OV901g/lc9fLIyn9R%2bFd3XivwXuWTxBqNqPuyWvmH6q4A/9DNe1V7WFlzUlcQUUUV0AFFFFABWZrviDT/DmnNe6jNsTOERRlpG9FHc1cvLuCws5ru5kEcEKF3Y9gOTXzb4r8TXXinWpL2YssK5W3hzxGnYfX1Nc2Ir%2byWm4HR6z8WtevpmGneXp8H8IVQ7ke5YY/ICsNfH3ilWBGtXOR64P9K5uivLlWqSd2xnc6f8AFjxPaOvnzQXiDqs0IBx9VxXovhf4naTr8sdpdKbC%2bc4VJGyjn0VvX2OPbNeA0dK0p4qpB73A%2btqK8%2b%2bF3i6XXNPl0y/lMl7aKGSRjzJF0yfUg4BPuPeus8QeILHw1pb319JgDiOMfekb%2b6BXqwqxlDn6CJ9W1ex0Owe91C4WGBO56sewA6k14b4v%2bI2peI2e1tS9npp48pT88g/2yP5Dj61ieJfE%2boeKNRN1evhFyIYFPyxr6D39T3rErza%2bKc9I6IYUUUVxgFFFFABRRRQAVqaFrt94d1SO/sJdsi8Mh%2b7IvdWHcVl0U02ndAfUPh3XrXxJosGpWhwr/K6E8xuOqn/PTB71q14T8J9fbTvEv9mSPi2vxtwegkAyp/HkfiPSvdq9rD1faQv1EFFFFbgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeZTf8nFaH/vxf%2bgmvpavmmb/k4rQ/9%2bL/ANBNfS1eFX/iS9RhRRRWQBRRRQB578bYpZPhNrHlZ%2bUws4HdRMmf8fwpfgnNBN8JtGWHGYjMkig5w3muTn65B/Guy1rSrfXNEvtKugfIu4XhfHUBhjI9x1FfP/wz8UzfC7xZqHgzxRm3s5Z8pO3CRycAPn%2b46hee2B05wAfR9FMR0lRZI2VkYAqynIIPQg0%2bgCG6mit7WaacgQxozyE9AoGTn8K8I/ZnjcReJpCp8tmtVB9SPNz/ADFbHxq%2bJFtYaTP4U0eYT6rejybnyjnyIzwVOP4m6Y9Cfaur%2bE/g%2bTwb4It7W6TbqF0xubof3WIAC/goA%2buaAO6ooooA%2bffD7LbftTanHcYV5WmEe7uTEGGP%2bA5r6CrwX43aDqGgeJtN%2bIWjKQ8LxrckDIV1PyM3sw%2bU/Qeteq%2bC/G2leN9Fjv8AT5lEwUfaLVm%2beBu4I9PQ96AOloorK8Q%2bItM8L6PNqmrXKwW8Y/4E7dlUdyfSgDxL48Mtx8QfClnbf8fu1eh5%2baUBOPqGr6Cr518AWt/8UPi1ceNL%2bBo9MsJA8KnoGX/VRg9yPvHHf/eFfRVABXkn7RMcj/Di2aPO1NSiaTH93ZIOfxIr1usHxn4bj8W%2bENR0R2CNcxfunPRJAQyH6bgM%2b2aAK3w5mhn%2bG3hx4MbBp8KHH95VCt/48DXT18/fBzx1/wAItdXPgXxQ32F4Z2Fs8xwI3J%2baMnoAT8wPTk88ivoDr9KAFrB8bTQweBPEEk%2bPKGnXAYHvmNhj8elb1eC/Gnx8ms%2bX4G8Nuby5uZlS7aD5ssG%2bWFT3O7BPpgD1wAa37OEci%2bB9SkYEI2osF%2bojTP8ASvZK5rwF4XXwf4M0/Rsq08Sb7h16NKxy31AJwPYCuloAKKKKACvn/wDaI/5GHwn/ANtf/Q46%2bgK%2bf/2iP%2bRh8J/9tf8A0OOgD6AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAqXWn292MyJh/768GqNrp13Z3i%2bXNm3Jy2P6itmitI1ZJcvQVgooqjqK3jRobQ4KnJ55NRFXdhl6isOLWpoW8u8gII7gYP5GtS2u4LtSYX3Y6juKudKcNWtBXLFFFFZjCiiigAooooAKKKKACiiigDhtc/wCQzc/7w/kKz60Nc/5DNz/vD%2bQrPr3qX8OPohBRRRWgGH4z/wCRL1n/AK9JP/Qau/s8/wDJNpf%2bwhL/AOgpVLxn/wAiXrP/AF6Sf%2bg1d/Z5/wCSbS/9hCX/ANBSvLx3xIaPWKKKK4QCiiigAooooAKKKKACiiigAooooAKKKKACiiigDxD4q3d1418f6P8ADrT5mjgDLcag69uN3P8AuplgO5Yelex6Xpdnoul22m6fAsFpbIEijXsB/M9ye5rx/wCFanV/jD481uXLPBM1shPZWkYD8dsQFe2UAFeJ%2bJvG/wAVtK8SalDpvhkXWmwTsIJRYSSb4weDlW549K9sooA8h8EfHG01zU00bxFZDSdRd/LSTJ8pn/ukNyh7DOfrXqmo6dZ6tYTWOoW0VzazDbJFKu5WH0ryr47%2bC7TU/C0viS3hVNT0/aZJFGDLCSAQfXbkEH0BHeus%2bFXiKXxN8PNMvbly91Gpt52JyWZDjJ9yNpP1oA6y0tLawtY7Wzt4re3jGEiiQKqj0AHAqeimSSLFG0jnCqMk%2blAD6rte2qtta5iB9C4rmb/VJr1yASkPZB3%2btUKdjqjhrr3mL8TfAMXxD8PRRW1zHFf2jmS1mY5Q5HzI2OxwOR0IH0rxLTf2f/GN1qKQ3wtLK13fPcGYSceqqvJPpnH4V7jBcS20m%2bJyje3f611Wm3638GSAJF4df60NGdSi4a9BNG0q10LRrPSrNSLa0hWGPceSAMZPuepq/RRSMTyjW5mHiK8lRsOk5ww7EHj%2bVeiaHqq6tpkc%2bR5o%2bWVR2Yf5zXKxeFLvVNWuri5Jt7Z53bOPmYFj0Hb8a7HT9NtdMg8m1iCA8k9Sx9SaD0sZUpSpxgtZI8t8T/ADQ9d1ubUrLUZ9NFw5eWBIhIm49SuSNufTn29Kr/Ebwjpfgr4F3%2blaWj%2bX58LySyHLyuZFyzEfQD8K9avNRt7LiRiXPRF5Neb/ABdvxq/w11W3SMx7Aku5jnIVwcUWOBU5NXSNz4P/APJKNA/65P8A%2bjHruK4f4P8A/JKNA/65P/6Meu4oICiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDx/wDaO/5J5p//AGFY/wD0VLR4V/5FDRf%2bvCD/ANFrR%2b0d/wAk80//ALCsf/oqWjwr/wAihov/AF4Qf%2bi1rvwPxMTNeiiivTAK0tA/5Ddv/wAC/wDQTWbWloH/ACG7f/gX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/yCh/11H8jXH16%2bC/hCCiiiusDyr42f8AHno3/XSX%2bS19LWH/ACDrb/rkn8hXzT8bP%2bPPRv8ArpL/ACWvpaw/5B1t/wBck/kK8bF/xmNFiiiiuYAooooAKK4TxX8XPCfhMvDLffbr1ePstniRgfRmztX6E59q8d1v4y%2bNfFJeHRIV0iybjfF80hHvIw/9BANXCnKb5YK7BK%2bx9Ea14k0Xw7B52sapa2SEfL50gDN/ur1P4CvLde/aJ0G1Lw6Hp11qUucLJL%2b5iPuM5Y/QgV40vhyS7uGutWvpru4c5di5JY%2b7Hk1r21haWY/0e3SM%2boHP59a9WhkteetR8q%2b9mqpN7nOeE5PLvLuArtLKG2nqMEjH611dcjezJpfiwThhsfBkA7BuDn%2bddcCCMjkV7GWPlpyoN6wbRrT2t2CiiivTLCiiigAorDvvE0FrcGCCFrh1OGIbaM%2b3XNS6Z4gg1GXyWjMM3ZScg/Q1yLHYd1PZqWv9ddieeN7GvRRUF1e29lHvuJVQdgep%2bgrplJRXNJ2RRPXO%2bJINMMZeWQR3ePl2DJb6j%2btQza3f6pIbfS4GRO8nfH16CrNh4Zijfzr5/tEpOSuflz7%2bteXWrfXIulRhzLu9vl3M2%2bbRIs2njjx5qvh%2bPQotYuRYJ8plJ2uV/uGT7xA9M98HjGG6f4dtLPEko8%2bb%2b844H0Fa6qqKFVQqjgADAparC5XRoe9L3pf10HGmkFFFFeoWFFFFABRRRQAUUUUAYPi1A2lxv3WUfqDX1V4DumvfAHh64cku%2bnwbiT1IQAn8xXyr4tcDS407tKP5Gl0U%2bJ/D8MV3oGtT2zOqyNCkhVSSM4KnKt%2bIr5fM8PUrYqXs1eyVznqRblofZVFfOWj/AB98S6O6Q%2bJtHjvIuhniHkyH34yjfQAV6p4a%2bLfg/wATlIoNTW0un6W16PKbPoCflJ9gTXjSjKLtJWZkdzRSdfpS1IBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeX/AB%2b/5JdP/wBfcP8AM1ieA/8AkRtI/wCvcfzNbfx%2b/wCSXT/9fcP8zWJ4D/5EbSP%2bvcfzNd2B%2bN%2bgmdFRRRXqAFeiW/8Ax7Rf7g/lXndeiW//AB7Rf7g/lXn4/aIyWiiivNAKKKKACiiigAooooAKKKKACsTxLcmGwWFTgzNg/Qcn%2blbdcp4pfN7AnpHn8yf8K6MLHmqq4GDRRRXtCCiiigAooryrxZ4t1TxLra%2bE/CSvM8reVJLCcNIe4B7KOct9e3XKrVjSjdgbvif4naRoLva2o/tC9XhkjbCIf9pvX2GfwrEsrf4r%2bOVE1havpti/3ZMC3Qj1DN87fUZr0/4f/BrRvCMMV5qMcWpax1Msi5jhPpGp/wDQjz6Yr02vKqYmpPrZDPniP4C%2bMbwbtS8Ww72Pz7ZJpePq2M1L/wAM56r/ANDev/gM3/xdfQVFYXYHz7/wznqv/Q3r/wCAzf8AxdH/AAznqv8A0N6/%2bAzf/F19BUUXYHz7/wAM56r/ANDev/gM3/xdee/Er4eXngC405LnUxqC3iyFHEZTaUK5HJP94V9iV5H%2b0JoT6l4Fg1OJCz6ZcB3wP%2bWb/K367P1pXA%2bXKKKKACiiigAooooAKKKKAOz%2bHHgW68ea1dWNtqAsPItzM0xQtn5gAuAR6k/hXpX/AAznqv8A0N6/%2bAzf/F1qfs46C1roGqa5KmDezLBCSOqR5yR7Fmx/wGvbqLgfPv8Awznqv/Q3r/4DN/8AF0f8M56r/wBDev8A4DN/8XX0AzBFLMQFAySTwBXnnif41eEPDheCK7bVLtePKssMoPu/3fyJPtTuwOC/4Zz1X/ob1/8AAZv/AIuj/hnPVf8Aob1/8Bm/%2bLrA139obxRqBZNJtrTSoj91gvnSj8W%2bX/x2vPtT8aeJ9ZYnUNe1GdT/AANcME/BQcD8qLsDe%2bI/gaXwDcWVnNr39oT3SM7RrGU8tQQATlj1Ocf7prhKU8/WkpAFFFFABRRRQBb05YHvkW5vHs4SDvmRC5XgnhQRnJwOtQSSyS43yO4HTcc1HRQAUUUUAFFFFABRRRQAUUUUAFFFFADkO11O4rg9V6ivel/Z11NlBHjBCDyCLdv/AIuvBVUuwVQSxOAAOSa%2b%2bLaMw2sUTEEogUkewxRcDwL/AIZz1X/ob1/8Bm/%2bLo/4Zz1X/ob1/wDAZv8A4uvoKindgfPv/DOeq/8AQ3r/AOAzf/F0f8M56r/0N6/%2bAzf/ABdfQVFF2B8%2b/wDDOeq/9Dev/gM3/wAXR/wznqv/AEN6/wDgM3/xdfQVFF2B8%2b/8M56r/wBDev8A4DN/8XR/wznqv/Q3r/4DN/8AF19BUUXYHz7/AMM56r/0N6/%2bAzf/ABdH/DOeq/8AQ3r/AOAzf/F19BUUXYHz7/wznqv/AEN6/wDgM3/xdH/DOeq/9Dev/gM3/wAXX0FRRdgfPv8Awznqv/Q3r/4DN/8AF0f8M56r/wBDev8A4DN/8XX0FRRdgfK%2bk%2bE5vBfx30HR574XsiyxyecEK53KeMEmvqivAPFX/J0Oif8AbD/0Fq9/pAFFFFABRRRQAVx/jr4c6L48s1W%2bUwX0YxDexAb0H90/3l9j%2bGK7CigD54h8DfF/wKTB4b1QX1ivKxxzIygf9c5uFP8Au0%2bbTPjr4nX7Ldztp9s3ys4mhgH4mP5yK%2bhKKAPLvh78F9N8IXMeq6lMNS1heUfbiKE%2bqg8k/wC0fwAr1GiigAooooAhubaC9tZbW6hSa3lUpJHIuVZTwQR6V4dr/wACtT0nVTq/gHWHs5AcrbSTNG6eyyDqPZvxJr3eigD59E3x/t0%2byCJnPRZSLRj/AN9dPzp1h8GPFvizU47/AMe66/lqf9Sk3my47qP4EH0z9K%2bgKKAM/RtF07w/pcOm6XapbWkIwqIPzJPcnuTzWhRRQAUUUUAcD8QfhVo/jtPtLMbLVkXal5GudwHQOv8AEPyI9ccV5tb%2bGPjX4LX7Jo199vsY%2bECTRyoF7ALNhl%2bgr6HooA%2beLjw78bfGKm01W8On2UnD7pooVI7giLLEexr0T4efCTSPApF68n2/WCuDdOm1YweojXt9ep9gcV6HRQAUUUUAFFFFABXz/wDtEf8AIw%2bE/wDtr/6HHX0BXz/%2b0R/yMPhP/tr/AOhx0AfQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFISFBJOAPWuI134oaJpMjwWu/UJ14PkkCMH/f8A8Aa1o0KlZ8tNXGk3sdxRXk6/E3xLdjzbLw4HhPQiOST9RgVJb/Fu5tZxDrOhvEf4jGxVh/wFh/Wut5XieiT%2baK9nI9UorI0PxJpXiG3MunXSyFfvxt8rp9V/r0rXrhlCUHyyVmQ1YKKKKkAooooAKKKKACiiigAooooAKKKKAI5YY5k2yIrr6EVHbWcNpvEK7Qxyec1Yop3drAFZ9xqsFrdGGRW4Ayy84rQqGa2guB%2b9iV/cjn86cHFP3tgGw3ttcf6uZCfTOD%2bRqxWTNoNu/MTvGfT7wq9ZW7WtqsTPvIzk1U1TteDEWKKKz31i2juHhfepQ4LYyKmMZS%2bFDNCiq0d/aS/cuI/oTg/rVgEEZHIpNNboBaKKKQHDa5/yGbn/AHh/IVn1oa5/yGbn/eH8hWfXvUv4cfRCCiiitAMPxn/yJes/9ekn/oNXf2ef%2bSbS/wDYQl/9BSqXjP8A5EvWf%2bvST/0Grv7PP/JNpf8AsIS/%2bgpXl474kNHrFFFFcIBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4n8Ln/sf4yeOtDlJV7iVrmMNxlRISPx2yg/nXtleJfFezu/BvjnSPiPpkLSRKwt9QRe4xtBP%2b8pK56AqvrXr%2bkatZa7pNtqenTrNaXKB43Hceh9COhFAF6iiigDP1rSYNe0S90m6eRILyFoZGiIDBWGDgkEZ/CsvwV4OsvA%2bhtpNhcXE8DTtNvnILAkAY4AHaukooAKyfEEpSxVAfvuAfoOf8K1qydehMunh1H%2brYE/Tp/hTRpStzq5zFFFFUeiFaWiSmPU0UdHBU/ln%2blZtaWhwtJqSvj5YwWP8qRFS3I7mnoninQ/Ebzro%2bpQXjW%2b0yiIn5N2cZ/I1sV866de/8Kk%2bNF9b3waPRdSJxJjhYnbcj%2b%2b05U/8Cr6HjkSaJJYnV43AZXU5DA9CD3FSeaPqK4lFvbSSnnYpOPWuI%2bKnjeHwf4VnWGcLqt4hitEB%2bZc8GT2Cjv64qt8L7fxDcfDgXGvX1zdXF5mS3W4bc6RYG3JPJzgnk9CKBq11ctyyPNK0jnLMck1zHxA/5ELWf%2bvc/wAxXSVzfxBIHgLWcn/l3P8AMVR6UvhZ1Pwf/wCSUaB/1yf/ANGPXcVw/wAH/wDklGgf9cn/APRj13FSeYFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHj/7R3/JPNP8A%2bwrH/wCipaPCv/IoaL/14Qf%2bi1o/aO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtd%2bB%2bJiZr0UUV6YBWloH/ACG7f/gX/oJrNrS0D/kN2/8AwL/0E1lW/hy9GB29FFFeEMKKKKACiiigAooooAKKKKACiiigDG8Tf8gof9dR/I1x9dh4m/5BQ/66j%2bRrj69fBfwhBRRRXWB5V8bP%2bPPRv%2bukv8lr6WsP%2bQdbf9ck/kK%2bafjZ/wAeejf9dJf5LX0tYf8AIOtv%2buSfyFeNi/4zGixRXO%2bK/G2g%2bDLL7RrN6sbsCY7dPmll/wB1f6nA96%2bf/FHxa8VeOHkstFV9J0o/K3lv%2b8cd90n/ALKv45rCEJVJcsFdglfY9k8Z/Fzwz4NMlu85v9SXI%2byWrAlT6O3Rfp19q8Q8Q/ETxr483xJL/ZWlPx5NuSgZf9pvvP8AoPasfT/DlpZ4kmH2ibrlxwD7D/GtivewuSt%2b9XfyX%2bZtGl3Mex8OWVphpF8%2bT1ccfgK2AABgDAFFFe7SoU6K5aasbJJbBVa/vUsLKS4f%2bEYUf3j2FWa5TUZH13W0sIWP2eEncw/U/wBB/wDXrLGV3Sp%2b78T0XqKTstCtb6PcapYXOoSFjO5LRj%2b96/4Ctfw3qYurX7JKf38IwM/xL2/Lp%2bVbccaxRrHGoVFAAA7CuZ1vTpbG6Gq2OVwd0gH8J9foe9cDw0sFy16etvi8/P5EcvJqjqKKoaVqkOp2%2b5fllX78fof8KvkgAknAFetTqRqRU4O6ZqnfVBUc5YW8hU4YIcH3xWXf%2bJLK0ykTefKOyHgfj/hWZ9n1jXyDMfs1qe2MA/h1P41yVcdC/s6S55dl%2br6EOa2Wpn6Vqi6dBJ5Vv5l5KwCsRwB/PrVvUZRPrGnyRReXeMVMqD%2bFs8Z/z6Vfk8JW5VPJuZEcdWI3Z/lVvTNAttNk87cZZsYDsMAfQV5lLBYvlVGaXLprpp19bmahLZmtXLaxEl14ptYJRmNkVSOmRkmuprOl0hZNZj1HziCgxs29eCOterjaMq0Ixir6q/oazV0XoYIreIRwxrGg6KoxT6KK7EklZFBRRRTAKKKoavqa6XZ%2bbt3yMdqKfX39qzqVI04Oc3ogbtqy/RXKrJ4llh%2b1q2EI3BAFyR9K1tE1b%2b1LZt6hZoyA4HQ56GuajjoVJqDi4t7XVr%2bhKmm7GpRRRXaUFFFVr%2b9jsLN7iT%2bHoP7x7CpnNQi5S2QN2Oe8ROb7V7XT4z93G7HYt/8AWrqVUKoVRgAYA9K5rw3ayXN1NqtxyzEhD7nqf6fnXTVwYBOfPiJfbenotiIa%2b93EZVdSrAMD1BHWsm88N2F1lo0MD%2bsfT8un8q16K66tCnVVqkblNJ7lTRPFHjjwOVGl6g13Yp/y6zZkjx6bScr/AMBIr1nwp8f9B1Upa6/A%2bkXZ%2bUyHLwMfrjK/iMD1rzGqV9pVnqA/fxDf2deGH4/4142JySL1ou3k/wDMylS7H1pbXMF5bx3FrPHPBINySxOGVh6gjg1NXx9pGo%2bK/Atybjw9qMrW5O57Y/Mj/wC8h4P1HP0r2bwX8dtE11ksdeQaPqBO3e7fuHP%2b8fufRuPevBrYerQly1FYxcWtz1uimqyyIHRgysMgg5BFOrEQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB5f8AH7/kl0//AF9w/wAzWJ4D/wCRG0j/AK9x/M1t/H7/AJJdP/19w/zNYngP/kRtI/69x/M13YH436CZ0VFFFeoAV6Jb/wDHtF/uD%2bVed16Jb/8AHtF/uD%2bVefj9ojJaKKK80AooooAKKKKACiiigAooooAK5HxT/wAhOP8A64j/ANCauurkfFP/ACE4/wDriP8A0Jq68F/FBmJRRRXriCiiigDhfif4pbQtCFlaybb2%2bygYHlI/4m%2bvYfU%2bldz8Hvh9F4P8OJf3kONZv0DzlhzCh5WMenYn3%2bgry/SbIeOvj4kE48yx0xyzoRkbYex9jIRn2NfTVeLianPUfZDCiiiucAooooAKKKKACquoWFtqmnXNheRiS2uYmilQ91YYNWqKAPiDxl4VvfBvie60e8BPltuhlxgTRH7rD8OvoQR2rn6%2bzfiJ8PrDx9oot5mWC/gy1rdbclD3U9yp7j6HtXyV4k8Mat4T1Z9N1i0a3nXlT1SRf7yN3H%2bTg0AY9FFFABRRRQAVreHPD994o1%2b00fT4909w%2b3OOEXux9gOaj0TQdT8R6pFp2k2cl1dSdEQcKPVj0A9zxX1X8O/h5pvw20Oa7vbiB9Rkj3Xl652pGo52qT0Udz36noAADsNA0W08O6DZaPYri3tIhGuererH3JyT7muQ8dfF3w/4LElqH/tDVQP%2bPOBvuH/po3IX6cn2rzD4kfHS51FpdJ8JSvb2fKyX4G2SX/c7ovv1Pt38SZi7FmJLE5JJ5JoA7Dxf8TvE3jN3jv70w2JPFlbZSLHv3b8Sa42iigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA6b4faK3iDx/omnBd0b3SvKP%2bmafO/wD46pr7ZrwT9nbwi0UN54ruoyPNBtbPPdc5dh%2bICg%2bzV73QAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeAeKv%2bTodE/wC2H/oLV7/XgHir/k6HRP8Ath/6C1e/0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV8//tEf8jD4T/7a/wDocdfQFfP/AO0R/wAjF4UH/XT/ANDSgD6AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiuf8aau2ieE768ibbNs8uIjqGY4BH0zn8KunB1JqEd3oNK7scN4u8Raj4q1//hFtAc%2bRuKTSKcCQj72SP4B%2bvvxXV%2bGvh/pGgQpJLCl5fYy08q5AP%2byp4H8/esz4U6Gll4fbVpE/0m9Y4Y9RGDgD8SCfy9K9Br0MZiPZf7NR0it/N9blylb3UFVrywtNQgMF7bRXER6pKoYfrVmivNTad0ZnkninwRdeFph4g8MSyxpAd8kQOWiHqM/eX1Bz%2bI6dx4O8UQ%2bKdGFwAEuoiEuIgejdiPY9vxHauhZQylWAIIwQa8i0uP8A4Qz4tNp8Z22N8diL22vygH0b5fz9a9SE3jaMoVPjirp911TNE%2bdWe56/RRRXlGYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABVaWxtZyTJAhJ6nGCfxFWaKabWqAypNCtW%2b40ifQ5H61oQQiCCOIHIQAZ9aloqpVJSVpMLBWLLearFM%2b223JuO35CeO3StqiiElHdXA4DUZXmv5ZJU2OxGVxjHFVa0Nc/5DNz/vD%2bQrPr3KesE/IQUUUVYGH4z/AORL1n/r0k/9Bq7%2bzz/yTaX/ALCEv/oKVS8Z/wDIl6z/ANekn/oNXf2ef%2bSbS/8AYQl/9BSvLx3xIaPWKKKK4QCiiigAooooAKKKKACiiigAooooAKKKKACiiigCrqOn2mradcaffwJPa3CGOWNxwyn/AD1r5%2b1CfXPgD4hijtLhdS8Nak7vHazPhxtxux/dYBl%2bYDB4yOmPouvm39pO8L%2bJtFss8RWbS4z03uR/7JQB6v4d%2bL/gzxDEm3Vo7C4PWC/IiIPoGJ2n8DXU/wDCQaME3nV7DbjOftKYx%2bdfCVFAH2H4i%2bMHgzw9E2dVjv7gdILAiYk/7wO0fiaq/Cvx1f8Aj463qVzGltaxTRxW1qnPljDEkt1YnIz0HyjA618jV9H/ALNf/Iu65/19p/6BQB7hTWVXQqwBUjBBp1FAHK6ho81s5eFTJD145K/Wsyu9pjRRsctGpPqRTudMcS0rNHG21lcXbhYYyR3Y9B%2bNdTp9iljBsU7mPLN6mrYAA46UtDZFSs56dDlfHPgTTPHWki0vcw3MWWtrpBlomPt3U8ZH8q8otvCPxj8HxnTvD9%2bt1YAny9k0LKo9lm5X6DivoGikYniHhn4O6xq2vDXviBfC7kBDfZDJ5hfHQO3QKP7q5B9q9tVQihVACgYAHanUUAYuoaH58hmtmVXbllPQmvMPi/v0b4f3aXShWvJEghGQdzbgx6f7Ktz9PWvaa%2bfPjneSeJvHfh/wZYNulVh5gHIWSUgDP0Ubvo1O5qq0lHlPVvhjZtY/DPw9CwwTZpLg/wC38/8A7NXW1Da20VnaQ2sK7YoY1jRfRQMAflU1IyCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDx/8AaO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtH7R3/JPNP/7Csf8A6Klo8K/8ihov/XhB/wCi1rvwPxMTNeiiivTAK0tA/wCQ3b/8C/8AQTWbWloH/Ibt/wDgX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/wAgof8AXUfyNcfXr4L%2bEIKKKK6wPKvjZ/x56N/10l/ktdJ4t%2bOwhto9H8Gw/aLvy1R750yqnHPlqfvH3PHHQ1zfxs/489G/66S/yWsPTdNtrCBRCnzMBuc8k/jXJDAvF4iSvZK1y4Q5jPTSLzVL59S1%2b7lu7uU7m8xyxJ9z/QcVtoixoERVVRwFUYAp1FfR4fC0sPHlpr/M6oxUdgoorK1ixv7t4pLK68oxg/LkrnPuK0rTlCDlGN32QN2Rq0VzAvPEdnxLbCcDvs3f%2bg0HxLfxj97pjAjr95f6Vyf2lRXxpx9UyfaLqaWv6l9gsCqHE0vyp7eppvh7TfsFj5kg/fzfM3sOwrmZr651LU1vPsplWMjEQBYDHbj3rW/tHxFc8RWIi9zHj/0I1w08ZCpiHWabtpFJX9X8yFNN3OnqrdahZWqlbmeNeOUJySPp1rB/srXr3/j6vfLU9V3/ANF4q1beFLOPBuJJJj6fdB/Ln9a7frOJqaU6VvOWn4bl80nsjnprmK31Pz9IMqqOcEfmAPT61Zt5LvxDcmG4v1jX/nn0z9B3/E12FvaW9ou2CFIx32jr9TWPqnhyO5c3FmRDPnJXorH%2bhrgnl1eEeZPmV7uKul8iHTaLljoVjYYdY/MlH8cnJH0HQVpVytrr15psgttUhdgOA/8AF/g31ro7W8t7yPfbyrIO%2bOo%2bo7V6WDr4eUeSkuVrpsy4OOyJ6KKK7iwooooAKKKKACiiigArnvFtu8lpBOoJWJjuHoDjn9P1roaRlDKVYAg8EHvXPiaCr0pU27XFJXVjkrvxGxu7We3lYQgAywYxg9xnvx0q14Xikklu70ptSVsKO3Uk4qfVPD1m1lNJawBJwNy7ScHHbHSpPDV4LnS1iON8HyEe3Y/59K8qjSrLGRWIl3attfb/AINjNJ8/vGzRRWfqOs2mnKQ775e0Snn8fSvZqVYUo803ZGraW5cuLiK1gaaZwiL1Jrh9S1NtUvY3lDpaK%2b0Adh3P1xV2O31DxJcCWcmK0U8Y6D6DufetnUNHhfRWtLaMKY/nj9Sw/wAa8fEOvjYN01aC1V95f8D%2bvTKV5rTY04I44oESEARqAFA6Yp9Ynhm/%2b06d5Dn95B8vPde3%2bH4Vt16uHqxq0ozjszSLurhRRRW4wooooAKz9Q0a01EEyJsl7SJwfx9a0KKzqUoVI8s1dA0nuReGfHfiv4byLEkn9o6KDzbSklVH%2byesZ/T2NfQ3gz4h6B44tN%2bmXOy7RczWc3Esfrx/EPcZH0PFfPpAYEEAgjkHvWJcaLPZXaalodxJaXkR3p5TlcH/AGSOlfO4zJ3H36Gq7dfl3MJ0rao%2byaK8R%2bHvxxju5Y9G8Y7bS9GES%2bI2xyH0kH8B9/u/SvbQQygggg8gjvXhNNOzMRaKKKACiiigAooooAKKKKACiiigDy/4/f8AJLp/%2bvuH%2bZrE8B/8iNpH/XuP5mtv4/f8kun/AOvuH%2bZrE8B/8iNpH/XuP5mu7A/G/QTOiooor1ACvQ4WC2kbHoIwT%2bVeeV6Jb/8AHtF/uD%2bVefj9ojK1lqcN4zIuUcHhWPUVerI1DSvMb7Ra/LKOSo4z7j3p%2bmai9wxt51PnL3x1%2bvpXHKnFx54bCv3NSiiisRhRRRQAUUUUAFFFFABXI%2bKf%2bQnH/wBcR/6E1ddXI%2bKf%2bQnH/wBcR/6E1deC/igzEooor1xBRRRQBwf7O8YvfE3ifVGBZwiLv/66OzH89g/KvoWvn/8AZl/5mn/t0/8Aa1fQFfOjCiiigAooooAKKKKACiiigArL1zw9pHiXT2sdYsIbu3PIWQcqfVSOVPuDWpRQB4J4i/ZwikkeXw3rHlA9Le%2bXcB9JFGcf8BP1rhLz4E%2bPbZ9sWm292M/ehu4wP/HytfW1FAHyRa/Avx9cOFk0qC2GfvS3cRH/AI6xNdt4e/ZvfzEl8R6ymwHm3sFJJ/7aMOP%2b%2ba%2bgaKAMDStC8OeBNEm%2bw21vp1jEnmTzMeSAPvO55P4mvmv4p/FW78a3j6fpzyW%2bgxN8seSrXJB%2b%2b49PRe3U89NX42fEpvEGpSeG9JnP9lWj4uHQ8XEo9%2b6qenqeewrx6gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACup8A%2bCb3x14ki062DR2yYe7uMcQx%2bv1PQD19gab4I8Dar471g2OnKqRRYa5uZPuQqe59ScHAHX2GTX1z4R8I6X4L0OPS9Liwo%2baWZvvzP3Zj/TtQBqabp1rpGm22nWMKw2ttGI4o17KOP8mrdFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4B4q/wCTodE/7Yf%2bgtXv9eAeKv8Ak6HRP%2b2H/oLV7/QAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXz78Y3/tP4x%2bEtIh5kXyAxA6F5v6Bc/jX0AzBFLMQFAySTwBXzv4Hc/EL4%2b6h4lALafYFpYiRxtA8uIexI%2bf6g0AfRVFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVwPxdLjwfDt6G9QN9Nr/ANcV31c1480t9X8HX8ES7po1E0YHUlTkge5GR%2bNdODmoYiEntdFRdpIt%2bEQg8H6OI/u/Y4s/XaM/rmtquE%2bFmtJqHhgWDP8A6RYsVIPUoSSp/mPwru6WLpunXnGXcJKzCiiiuckK8n%2bIWB8SPDzL9/8Ac8jr/rjj%2btesdK8ht5f%2bEw%2bL6XMPz2dgQyuORtj6H8XOR9a9HLVacqj2jFl097nr1FFFecQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBw2uf8AIZuf94fyFZ9aGuf8hm5/3h/IVn171L%2bHH0QgooorQDD8Z/8AIl6z/wBekn/oNXf2ef8Akm0v/YQl/wDQUql4z/5EvWf%2bvST/ANBq7%2bzz/wAk2l/7CEv/AKCleXjviQ0esUUUVwgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXyt%2b0JOZviWqHP7mwiQZ%2brNx/31X1TXyh8fv%2bSoT/8AXpD/ACNAHl9FFFABX0f%2bzX/yLuuf9faf%2bgV84V9H/s1/8i7rn/X2n/oFAHuFFFFABRRRQAUUUUAFFFFABRRWZrmvaZ4b0uXUtWvI7a1j6s55Y/3VHUk%2bgoAi8T%2bI7Hwp4du9Z1BsQ26ZVM8yOfuoPcn/AB7V4z8FdEvfFHi7U/iDrK7mMjrbEjgysMMR7Kp2j6%2b1Yl1d698efGaWlsktn4csn3EkZES/3m7NIw6Dt9Mk/RekaVZ6HpNrpenwiG0toxHGg9PU%2bpJySe5JoAvUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHj/AO0d/wAk80//ALCsf/oqWjwr/wAihov/AF4Qf%2bi1o/aO/wCSeaf/ANhWP/0VLR4V/wCRQ0X/AK8IP/Ra134H4mJmvRRRXpgFaWgf8hu3/wCBf%2bgms2tLQP8AkN2//Av/AEE1lW/hy9GB29FFFeEMKKKKACiiigAooooAKKKKACiiigDG8Tf8gof9dR/I1x9dh4m/5BQ/66j%2bRrj69fBfwhBRRRXWB5b8a42OnaTJ/Cssin6kDH8jWTAwe3iYdCgP6V2XxU0xtR8FTSxruezkW4wOu0ZVv0Yn8K8%2b0C6F1o8PPzRDy2/Dp%2bmK1y%2bSjiZxfVJ/cbUXrY06KKK9w6AooooAK5/xNfMsaafBkyzkbgOuOw/E1t3NwlrbSTyHCIMmud0G3fUdRm1W5HRvkB9f/rCvPx05Sth4by/BdSJv7KNvS7FdOsI4B977zn1Y9auUV1Xgbwm3ijVj525bC3w07Dgt6KPc/wAq6ZSp4ald6RiitIoqeHPB%2breJpM2cIS3U4e4l4QewPc%2bw/SvR9P8AhBpMKA399dXMncR4jX8uT%2bteg21tDZ20dvbRJFDGu1EQYCj2qavmMRm9eq/cfKv66nPKo3scO/wp8MshAS7Qn%2bJZuR%2bYxXMa18IbiGNpdGvftGORBOArH6MOCfqBXr9FYU8yxVN357%2buolUkup8panpRWWSx1K0KyRnDRyrhlP8AT61zNz4Ylgk87TLllYdFZsEfQivqrxp4PtvFGnFkVU1GFT5EvTP%2by3sf0/PPz/NDJbzyQzIUljYo6t1Ujgg17tCWHzGHNKNpL7/kzZcs1qcgmvanprCPUbYuOm4jaT%2bPQ1rW3iLTrnAM3lMe0ox%2bvStRkV1KuoZT1BGQayrnw5p1ySREYWPeI4/TpW3scXR/hzUl2lv96HaS2ZqI6SKGRlZT0KnIp1cu/ha5t232V8VPvlT%2bYpNvia06EzL9VbP9aPrtWH8Wk/lqHO1ujqaK5b%2b3dag/1%2bn5Hr5TD9elH/CXSJxJYc/9dMf0p/2ph18Ta9Uw9pE6miuYHjFMc2TZ/wCun/1qT/hL2bhLDn/rrn%2blH9q4T%2bf8H/kHtI9zqKK5b/hIdVm/499Ozn/YZqTf4mu%2bimFT7KuP60f2lTf8OMpeiD2i6HUu6xqWdgqjqScAVxiX0Oja7O9uyzWr54jPrzgfQ1bXwxe3LBr6%2bz9CXP60/UvDVvBpcj23mNNH85LHOQOo/wA%2blcmKeKrRVSNPl5dVd6/cTLmetiFtU1fWGMdjCYYjwWXt9W/wq7p/hiGFhLet58nXb/CD7%2btW9Avhe6YgOBJF8jj%2bR/z71qV0YbCU6yjXqy52%2b%2by%2bQ4xT1eogAUAAAADgDtS0UV6Zocpcf8SPxKs4%2bW2uOW9AD1/I811dZev2P23TH2jMsXzr/UflTfD1/wDbdMVWOZYfkb3HY/l/KvOw/wC4xEqHSXvL9URHSVjWooor0iwooooAKKKKACiiigChqekW%2bpx4kG2UD5ZAOR/iK3PAfxS1bwBcxaNrwkvNDJxGw5eAeqE9V9VPTtjoaVQ3dpDewNDOgZD%2bYPqK8zHZbDErmjpL8/UznTUj6o03UrLV9Phv9PuY7m0nXdHLGchh/ntVuvkrwj4x1n4X6wCpe70O4cGe3PQ%2b6/3XA/A459vqHw/4g03xPo0Gq6VcCa1mHB6Mjd1YdiO4r5OrSnSm4TVmjnaa0ZqUUUVmIKKKKACiiigAooooA8q/aCnWL4Z7G6zX0SLz3wzfyU1meCIzF4I0dT1NsrfnyP51kftDasdR1TQvCtmd9wX8%2bRAf4n%2bSMfX735iuusbRLDT7azj%2b5BEsS/RQAP5V34COrYmWKKKK9MAr0S3/AOPaL/cH8q87r0S3/wCPaL/cH8q8/H7RGS0wIgcuFAZupxyafRXmgFJkUtYV1bXtlcvdW8jSKxyw/wARVwgpu17AzdorNs9XhuQFkxFL6E8H6GtKlKEou0kAUUUVIBRRRQAVyPin/kJx/wDXEf8AoTV11cj4p/5Ccf8A1xH/AKE1deC/igzEooor1xBRRRQBxH7Mv/M0/wDbp/7Wr6Ar5/8A2Zf%2bZp/7dP8A2tX0BXzowooooAKKKKACiiigAooooAKKKKACiiigArzP40%2bOT4S8JmyspduqamGiiIPMUf8AG/scEAe5z2r0mSRIYnlkZURAWZmOAAOpJr4u%2bIvi1/GfjO91QM32UN5Nop/hiXheO2eWPuxoA5SiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACil6/WtzTfBnibWCP7P0HUZ1P8a27bP%2b%2biMfrQBhUV6po3wA8ZaiVa9Wz0yM9fPm3vj2VMjP1Ir0jQP2d/Dunskus3t1qkgwTGv7mL8QCWP/fQoA%2bY6K7f4s%2bHbbwz8RL%2bxsYFgsnWOaCNeiqyjI/76DVxFAGr4f8AEOp%2bF9Yh1TSbloLmI9vuuvdWHdT6V9d/D7x/p3j3RPtVtiG%2bhAW7tScmJj3HqpwcH%2bor4vra8LeJtR8I6/b6vpku2aI4dD92VD1Rh3B/wI5FAH3LRWH4T8U6f4w8PW%2bsac/7uQYkjJ%2baJx95G9x%2bvB71uUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHgHir/k6HRP%2b2H/oLV7/AF4B4q/5Oh0T/th/6C1e/wBABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUh4%2bleS/EP416doCS6X4dePUdYb5PMT5ooG6dR95vYcZ69MUAQ/HD4gDSNJbwrpbl9U1BNk/l8mKFu3%2b8/THpn1FdL8JvBJ8FeDo4blAup3hE936qSPlT/gI/UtXH/Cv4W3qal/wmPjAPLqkredb285y6Mf8AlpJn%2bL0Hb69PbKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPIPEmjaj4C8Rf8JHoiZ0%2bRv3kYHypuPKMP7pPQ9jj0Ge%2b8OeMdJ8SwKbadY7rHz20hw6n2/vD3FbskaTRtHIiujAqysMgg9QRXn2t/Cewu5jc6PdPYS53eWRuTPt3X9a9JV6OJio4h2ktpb/eaXUl7x6LUcsscETSyyLHGoyzMcAD3JrytfCvxFsf3dtrfmxjgf6UxAH/AAMUg%2bG3ifWJFOu68DEDnaZHmI%2bgOAKX1KitZVlby1f3C5F3JvGPj86ju0Hw1vuJrg%2bU9xEDznqqev1/L1rqPA3hNfC%2bkETbWv7jDTsO3og9hz9STVvw54O0nwzGTZxF7hhh7iXlz7egH0roKnEYmn7P2FBWj1b3YOStZBRRRXAQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBw2uf8hm5/3h/IVn1oa5/yGbn/AHh/IVn171L%2bHH0QgooorQDD8Z/8iXrP/XpJ/wCg1d/Z5/5JtL/2EJf/AEFKpeM/%2bRL1n/r0k/8AQau/s8/8k2l/7CEv/oKV5eO%2bJDR6xRRRXCAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFfKf7QEZT4muxIxJZRMMenzD%2blfVlfNf7SVkU8VaPfkHbNZGEH/ccn/2oKAPFKKKKACvo/8AZr/5F3XP%2bvtP/QK%2bcK%2bj/wBmv/kXdc/6%2b0/9AoA9wooooAKKKKACvLbr4%2b%2bDrO8ntpYtU8yGRo22264yDg/x16lXwhr3/Iw6n/19y/8AoZoA%2bl/%2bGhvBf/PLVf8AwHX/AOLpsn7RHg1EJW21eQ/3Vt0z%2brivlqigD3vXP2kZnjaPQdDWJj0nvZN2P%2bAL/wDFV53pmpyfEbx3YQ%2bNdeuUtp5NglAAVCeiKPuoCcDOD2z61xFFAH3bomhaZ4c0qLTdJtEtrSLoidz3JPUn3NaVeA/Cv42QJawaD4suPLMYCW%2bov0I6BZPQj%2b9%2bfqfeopop4UmhkWSNwGV0bIYeoIoAkooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPH/2jv%2bSeaf8A9hWP/wBFS0eFf%2bRQ0X/rwg/9FrR%2b0d/yTzT/APsKx/8AoqWjwr/yKGi/9eEH/ota78D8TEzXooor0wCtLQP%2bQ3b/APAv/QTWbWloH/Ibt/8AgX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/wCQUP8ArqP5GuPrsPE3/IKH/XUfyNcfXr4L%2bEIKKKK6wGTwx3NvJBMgeKRSjoejKRgg18/X1jP4G8VT2FzuaylO6OTH3k/hb6jofxr6ErC8VeFrLxXpf2S5/dzJ80E6jLRt/Ueo/wAKympJqpT%2bJbf5DTs7nm6srqGVgykZBB4Ipa526g1nwRe/YdTt2e1JPluv3WHqjf0P6Vq2mr2N6o8qddx/gY7W/KvYw2PpVlZ6S7M6ozUi7RRVe%2bu0sbOS4fog4HqewrslJQi5S2Rexg%2bIrmS8u4dJt%2bWZgX%2bvYH8Oa6C0tks7WO3j%2b6i4z6%2b9YPhq0eaSXU7j5pJCQhP6n%2bn510lcGBi6jliZ7y28l0/zIhr7zCvoX4f6Suk%2bDrFduJbhftEh9S/I/wDHdo/CvnqvqPTgg0u0EedghTbn0wMVx57NqnCC6v8AIis9Ei1RRRXzJgFFFFABXh3xW0lbDxOl5EoWO%2bj3tj%2b%2bvDfptP4mvca8s%2bMwXyNHJxv3TY%2bmEz/SvTyibjiopdbr9TSk/ePJaKKK%2bwOkKKKKACiiigBpjQnJRSfUinUUUrAFFFFMAooooA5M58PeIM9LO4/IA/4H9PrXWAgjI5FZ%2bs6cNSsGjAHmr80Z9/T8ao%2bG9SM0BsZyRPBwAepUf4V5lH/Zq7ov4Zax9eqIXuuxvUUUV6ZYVysP/Ej8TGL7ttcdPQA9PyPFdVWJ4msftOneeo/eQHd9V7/41wY%2bnJ01Vh8UNV%2bq%2b4ia0uuht0VQ0a%2b%2b36ZHKTmRRsf6j/Oav1106kakFOOzLTurhRRRWgBRRRQAUUUUAFFFFADJoY7iF4pUDowwQe9VPC/ijVvhfr/2q13XOkXDAXFuTw4/o47H/wCvV6mTQx3ELxSoHRhgg964MdgYYqFnpJbMicFJH07oGvaf4m0W31bS5/OtZ1ypxgqe6sOxB4NadfJfgvxff/C/xGNxkuNDu2AniB7f31HTeP1HH0%2bqtP1C01XT4L%2bxnSe1nQSRyochga%2bPq0pUpuE1Zo5mmnZlqiiisxBRRUcs0UETSzSJHGoyzu2AB7mgCSsLxZ4q07wdoE%2bralIAiDEUQPzTP2Rfc/pye1cp4t%2bNfhTw3C8dpdLq98MhYbRgyA/7Un3QPpk%2b1eQLY%2bJ/i3rceseIZGtdKj/1KIu1QvXbEp9e7n9cYqoQlN2iBP4Gsb/xh4xvfG2srnMrNCCOC%2bMAL/souAPw9K9XqCzs7fT7OG0tIlighUIiL0AFT17VGkqUOUQUUUVsAV6Jb/8AHtF/uD%2bVed16Jb/8e0X%2b4P5V5%2bP2iMlooorzQCiiigClNpdtPMsrJhgcnb0b61doopuTejYCEgdSBS1T1CzN7AIxIUwc9Mg/WszzdT0ziQebEO5%2bYfn1FaQp860evYVzfoqlY6il8GCoysv3gen51drOUXF2YwrkfFP/ACE4/wDriP8A0Jq66uR8U/8AITj/AOuI/wDQmrqwX8UGYlFFFeuIKKKKAOI/Zl/5mn/t0/8Aa1fQFfP/AOzL/wAzT/26f%2b1q%2bgK%2bdGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeX/HPxWfD/AIFewt5Nt5qzG3XB5EXWQ/lhf%2bB18oV6N8a/Ep8Q/ES7hjk3WmmD7HEAeNyn5z9d2R9FFec0AFFFFABRRRQAUUUUAFFSQwy3EqxQxvJIxwERSSfoBWk3hjX44vNfQ9SWPGd5tJAMfXFAGTRTmUoxVgQwOCCOQabQAV6r8Lvg/ceM1XV9WkktNFDEIE4kuSOu3PRfVvwHqOS%2bH3hKTxr4xs9IBZbfmW6deqRLjd%2bJ4Ue7CvtCztLews4bS1iWG3gQRxxoMBVAwAKAOf074d%2bDtLtBbW/hrTCm3aTNbrK7D3ZwSfxNQXXwv8D3jEy%2bGdPXP/PGPyv/AEHFddRQBwUnwX%2bH0rbm8OoDjHy3U6j8g9M/4Ul8PP8AoXv/ACduP/jlegVQu9a0qwnEF5qdnbzHkRzTqjH8Cc0AcpF8G/AEIAXw7Eec/PPK383NaNv8N/Bdscx%2bF9KPOf3lssn/AKFmuoBDKCCCCMgjvS0AUrPSNM07H2HTrS1x08iBU/kKu00sFxkgZOOadQAUUnQVStdZ0u9uGt7TUrOedc7o4p1ZhjrkA5oA%2bcP2joAnjvTphgeZpqAj3EknP6j8q8dr2j9pH/kctJ/7B/8A7UevF6ACiiigD0D4T%2bP38EeJlW5kP9kXpEd2vZP7sg9xnn1Gfavr1HWRFdGDIwyGU5BHqK%2bAq%2bnfgJ43Ot%2bH38OXspa90xQYSx5e36Af8BOB9CtAHsVFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHgHir/k6HRP8Ath/6C1e/14B4q/5Oh0T/ALYf%2bgtXv9ABRRTJJEijaSRlREBZmY4AA6kmgBx4%2bleReKPj9oeg63Lp2n2EmqrD8slxFOEj3dwpwd2PWua8e/ErVPHWr/8ACGeBVkkhnYxT3MfBuB3Cn%2bGMd24z9Ot7WPhhpvgP4M69K4S61ia3j8%2b6I4X94nyR%2bi%2b/U9%2bwAAz/AIaXs/8AoWJ//Awf/EUf8NL2f/QsT/8AgYP/AIiq/wALreGTwHZs8UbMZJeSoP8AGa7H7Lb/APPvF/3wK7oYLmipc24HLf8ADS9n/wBCxP8A%2bBg/%2bIo/4aXs/wDoWJ//AAMH/wARXU/Zbf8A594v%2b%2bBR9lt/%2bfeL/vgVX1B/zfgBy3/DS9n/ANCxP/4GD/4ij/hpez/6Fif/AMDB/wDEV11vaW32mL/R4vvj%2bAetehfYLP8A59IP%2b/Yrnr0PZNa3uB4f/wANL2f/AELE/wD4GD/4ij/hpez/AOhYn/8AAwf/ABFe4fYLP/n0g/79ij7BZ/8APpB/37Fc4Hh//DS9n/0LE/8A4GD/AOIo/wCGl7P/AKFif/wMH/xFe4fYLP8A59IP%2b/Yo%2bwWf/PpB/wB%2bxQB4f/w0vZ/9CxP/AOBg/wDiKP8Ahpez/wChYn/8DB/8RXuH2Cz/AOfSD/v2KPsFn/z6Qf8AfsUAeH/8NL2f/QsT/wDgYP8A4ij/AIaXs/8AoWJ//Awf/EV7h9gs/wDn0g/79ij7BZ/8%2bkH/AH7FAHh//DS9n/0LE/8A4GD/AOIo/wCGl7P/AKFif/wMH/xFe4fYLP8A59IP%2b/Yo%2bwWf/PpB/wB%2bxQB4f/w0vZ/9CxP/AOBg/wDiKP8Ahpez/wChYn/8DB/8RXuH2Cz/AOfSD/v2KPsFn/z6Qf8AfsUAeH/8NL2f/QsT/wDgYP8A4ij/AIaXs/8AoWJ//Awf/EV7h9gs/wDn0g/79ij7BZ/8%2bkH/AH7FAHh//DS9n/0LE/8A4GD/AOIqvN%2b0TquoP5GheEt854XfM0xJ/wB1FB/WvePsFn/z6Qf9%2bxUscaRJsjRUUdlGBQB87yaR8YfiWPK1Nn0jS5PvRyj7MmPQoP3jfRuK9H8C/B/w/wCDHjvXB1HVU5F1OuBGf9hOQv15PvXolFABRRRQAUUUUAFFFFABRRRQAUVR1LVLPSrfzruUIP4VHLMfQCuA1jxnfX5aK0za2/8Asn52%2bp7fhSckjpw%2bEqV/hWnc7rUde03SwRdXKh/%2bea/M35Dp%2bNcxefEE8rY2X0eZv/ZR/jXEEkkknJPUnvSVDkz16WW0YfFqzduPGGtzk4uhEP7saAfr1/WqMmt6rLndqN2QewmYD8qoUVN2dcaNOO0V9xcGq6iCCL%2b6BHpM3%2bNTxeItYhIK6jcH/ffd/PNZlFBTpwe6R09r461aEgTCG4Hfcm0/pgfpW/Y%2bPNPuMLdxSWzev31/Mc/pXnNFNSZzVMDQn0t6HtdtdQXcQlt5kljP8SNkVPXitnfXVhN51pO8L%2bqnr9R0NdvovjiKcrBqiiJzwJl%2b6fqO3%2belWpXPMr5dUp6w1X4nZ0U1WV1DKQykZBB4NOqjzgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOG1z/kM3P%2b8P5Cs%2btDXP%2bQzc/wC8P5Cs%2bvepfw4%2biEFFFFaAYfjP/kS9Z/69JP8A0Grv7PP/ACTaX/sIS/8AoKVS8Z/8iXrP/XpJ/wCg1d/Z5/5JtL/2EJf/AEFK8vHfEho9YooorhAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvGv2jNIN34N0/VEXLWN3sY%2biSDBP/fSpXstYfjDQV8T%2bEdU0ZsZuoCsZPQSDlCfowU0AfDlFSTRSQTPDMjJJGxV0YYKkcEGo6ACvo/9mv8A5F3XP%2bvtP/QK%2bcK%2bj/2a/wDkXdc/6%2b0/9AoA9wooooAKKKKACvhDXv8AkYdT/wCvuX/0M19318Ia9/yMOp/9fcv/AKGaAM%2biiigAooooAK2dH8WeIdATZpOtX1nHnPlxTMEJ9dvT9KxqKAO%2bt/jR8QLbAGvtIo7S20TZ/Ern9a2LT9oPxrblfOXTLoDr5tuRn/vlhXlNFAHv%2blftKHcq6v4dG3%2bKW0n5H0Rh/wCzV6b4X%2bKfhLxY6QWGpCG8fpa3Y8qQn0HZj/uk18Z0vT60Aff1FfNnwp%2bM9zpt1BoXii6afT3IjgvZTlrc9AHPdPc9Pp0%2bkuv0oAWiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8f/AGjv%2bSeaf/2FY/8A0VLR4V/5FDRf%2bvCD/wBFrR%2b0d/yTzT/%2bwrH/AOipaPCv/IoaL/14Qf8Aota78D8TEzXooor0wCtLQP8AkN2//Av/AEE1m1paB/yG7f8A4F/6Cayrfw5ejA7eiiivCGFFFFABRRRQAUUUUAFFFFABRRRQBjeJv%2bQUP%2buo/ka4%2buw8Tf8AIKH/AF1H8jXH16%2bC/hCCiiiusAooooAgvLK11C2e2vLeOeBx80cihgfwrgtW%2bD%2biXjtJYXNxYO38I/eRj8Dz%2bteiUVnOlCfxIDx8/BzVEJWHXotnbKMv6ZNNf4OatIMPrcDD0Kua9iorP6tT2/Udzx1fg9q6gKuuQADsFel/4U/rH/Qdh/J69hoo%2brU/P72F2ePf8Kf1j/oOw/k9Wl%2bGXihQFXxW4UDAAkl4/WvV6KHhab3/ADFc8p/4Vn4p/wChsk/7%2by/40f8ACs/FP/Q2Sf8Af2X/ABr1aip%2bp0uwHlP/AArPxT/0Nkn/AH9l/wAaP%2bFZ%2bKf%2bhsk/7%2by/416tRR9TpdgPKf8AhWfin/obJP8Av7L/AI1FP8KfENzt8/xKJdv3fMaRsfma9boprCUlsgPHv%2bFP6x/0HYfyej/hT%2bsf9B2H8nr2Giq%2brQ8/vY7s8e/4U/rH/Qdh/J6P%2bFP6x/0HYfyevYaKPq0PP72F2ePf8Kf1j/oOw/k9H/Cn9Y/6DsP5PXsNFH1aHn97C7PHv%2bFP6x/0HYfyej/hT%2bsf9B2H8nr2Gij6tDz%2b9hdnj3/Cn9Y/6DsP5PR/wp/WP%2bg7D%2bT17DRR9Wh5/ewuzx7/AIU/rH/Qdh/J6P8AhT%2bsf9B2H8nr2Gij6tDz%2b9hdnj3/AAp/WP8AoOw/k9YPif4d6r4Y04ambtLqMPiVogwZM9Cc9s8flXv9R3FvFdW8lvPGskMilHRhkMD1BqJYWDWm4XPDvD/w9vfEmjxajZa/Fsfh0YPujYdVPP8Anj1rU/4U/rH/AEHYfyeoh9t%2bFXi88STaDet9fl/%2bLXP4j68ew2t1Be2sV1bSrLBKodHU8MD3qKVOEtJXut9WF2eR/wDCn9Y/6DsP5PQfg/rBGDrsJB6gq9ew0Vr9Wh5/ewuzxxPg3qsYITW7dQeuFYU7/hT%2bsf8AQdh/J69hooWGpr/hwuePf8Kf1j/oOw/k9H/Cn9Y/6DsP5PXsNFP6tDz%2b9hdnj3/Cn9Y/6DsP5PR/wp/WP%2bg7D%2bT17DRR9Wh5/ewuzx7/AIU/rH/Qdh/J6P8AhT%2bsf9B2H8nr2Gij6tDz%2b9hdnj3/AAp/WP8AoOw/k9H/AAp/WP8AoOw/k9ew0UfVoef3sLs8e/4U/rH/AEHYfyej/hT%2bsf8AQdh/J69hoo%2brQ8/vYXZ44/wc1aRcPrcDD0ZXNWYPhX4itYRDb%2bJvJiXokbSKo/AGvWqKl4Sk90I8p/4Vn4p/6GyT/v7L/jR/wrPxT/0Nkn/f2X/GvVqKX1Ol2A8p/wCFZ%2bKf%2bhsk/wC/sv8AjTT8I9TvnU6n4kaVV6ZRpD/48wx3r1iin9UpdgON0X4Y%2bHNHZZXt3vpxyHuiGAPsoAH55rsgAAABRRW0IRgrRVgCiiirAKKKKACvRLf/AI9ov9wfyrzuvRLf/j2i/wBwfyrz8ftEZLRRRXmgFFFFABRRRQAUUUUARpFHGWKIqljk4GM1JRRQBl32pyWdyE8gtHtBLdOfY1zuuXiXt5HKisoEYUhvXJrtSARgjIrj/EkUcWooI0VAYgSFGOcmu7Byg5pW1EY9FFFeoAUUUUAcR%2bzL/wAzT/26f%2b1q%2bgK%2bf/2Zf%2bZp/wC3T/2tX0BXzowooooAKKKKACiiigAooprMqIzsQFUZJPYUAY%2bs%2bLfD/h6eGDV9XtLKWYZRJZAGI6Zx2Hua14pY5oklidZI3UMrochgeQQe4r5d8OeGp/jN4p8VaveXUsWyMtbHPCOxPlIf9kKpBFaHgjx/faH8NPFnh%2b8leK/0qBvse4/PFvcRMv8AwF3Uj/e9qdgPoG08R6JfanLptpq9jPfQ58y3juFZ1x1yoOeO/pVTxl4kg8KeFNQ1aaWNJIoW8hXYDzJcHYoz1ye3pmvle38NaroHgnR/iFp11Ikv250%2bUf6vacK2e4LK6nPHIHeur8da0Pij428GadBM0dneW0JkVefKkkciXA7lQuP%2bA0WA8fkkeWV5JGLO5LMx6knqaZWz4p8P3PhbxLfaLdHdLaybQ4GA6nlWx7gg/jT9N8I69rGiXus6fpstxp9kcXEqFfkwMn5c5OBycA470WAw6KDRSAKKKKACvbfhp8Dm1q1h1rxR5sFlIA0NkpKySr2Zz1VT2A5Pt3wfgl4Ij8VeK2vr%2bESabpgWV0YZWSUn5FI7jgsfoAetfWFAGdpGg6ToFqLbSdOtrKLusMYXd7k9Sfc1o1zPj%2b712w8EaldeG4jJqkaAxBU3sBuG4qvchckD%2bfSvm1/G3xWs1%2b1y3muRxr82%2bW0Oz9VxigD6a8Q%2bDfD3iq3aLWdLt7liMCXbtlX6OPmH5182/Ez4QX3gkNqenSPe6IWwZCP3luT0D44I9GHfggcZ6zwN%2b0BdNfQ2Hi6OJoJCFF/Cm0ofV1HBHuMY9DXvlxb22pWMkE8cdxa3EZV0b5ldCP1BFAHjn7Onh4Wnhu/1%2bVP319N5MRI/5Zp1I%2brE5/3RXtdZfh7QrPwzoNro9gGFrbBhGGOTgsWOfxJrUoAKKKgkvLaJtsk8at6FhmgaTexieOtbn8O%2bB9X1W1x9oggPlEjO12IUHB64JBx7V8Z3NzPe3UtzdTPNPKxeSSRtzMx6kk19uahbafr%2blXemXDpNb3UTRSKj87SMcehr541T9n/xPb6i8em3Fld2Zb93K8hjYD/aXHX6ZoFa250v7PXiO%2buk1LQLiV5ba2jWe33EnysnDKD6HggfX1r3SuD%2bGXw5j8A6ZcedcJc6ldlTPKgIVQOiLnnGSeeM%2bnFd5QBg%2bLbh7bQzJE21xKhVh1BBz/Sr2jakmraZFcrgMRtkX%2b6w6isjxy23Q4h/euFH/jrVzfhXV/7N1MRSti3nwrZPCnsf8/0oPQhh/aYXmW6bKnx81jUNM8EW9vZu8UV9c%2bTcSIcEptY7Pxxz7AjvXzTZ3lzp95DeWc7wXELB45YzhlYdCDX2x4g8P6d4n0afStUg822lxnBwykdGU9iK870n4A%2bGdO1VLu5u72%2bhjbcltMVCkj%2b%2bQMsPbig888z%2bN99Ne6v4U1C6hUTzaPDPLERwGLFiv55r0TxN8IfDXjnQLfW/DUcOlXlzAs8JiXbBIGUEB0HC/VR9Qa439oa1lvPHmhWlsm6WazWKNB3YysAPzrr/ANnzxQdQ8MXPh65c/adLfMQY8mFyTj8G3fmKAPnLWNHv9B1WfTdTtnt7uBtrxuP1B7g9QR1qhX1/8U/hxb%2bOtDaS3RI9atVJtZunmDr5bH0Pb0PPrn5Enhltp5IJkaOWNijowwVYHBBHrmgCOt/wZ4ln8IeLLDWoNxWCTEqD/lpGeHX8s498VgUUAffVtcQ3lrFc28iyQzIJI3XoykZBH4VLXlnwF8SHWvAQ06Z91zpUnkHPUxHlD/6Ev/Aa9ToAKKKKACiiigAooooAKKKKACiiigAooooA8A8Vf8nQ6J/2w/8AQWr3%2bvAPFX/J0Oif9sP/AEFq9z1TVLLRtNn1HUblLe0t13ySueAP6n0HegCa5uYLK1lurqZIbeJS8kkjYVVHJJPpXzv4u8b678Wtc/4RLwbFIulE/vpW%2bTzlB5eQ/wAMY7DqeO5AEOu6/wCI/jh4l/sLQI3tfD0EgaR2BA29pJfU8Han%2bGR7j4N8F6T4I0VdP0yLLHBnuHA8yZvVj6eg7UAU/APw%2b0vwFpP2e0HnXsoBubx1w0h9B6KOw/marfGD/klGv/8AXJP/AEYldxXD/GD/AJJRr/8A1yT/ANGJQB538K/%2bRBsv%2bukv/oZrs64z4V/8iDZf9dJf/QzXZ17tD%2bHH0EFFFFagS23/AB9Q/wC%2bP516JXndt/x9Q/74/nXolebj94jCiiivPAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArC8Q%2bJLfRYti4lu2HyRZ6e7e386d4i16PRLLcMPcycRIf5n2ryyeeW6neeZy8jnLMx5JqZSsejgsF7X35/D%2bZJe31zqN01xdSmSRu56AegHYVXoorM95JJWQUUUUDCiiigAooooAKKKKACiiigDf8P%2bJ7jR5FilLTWZPMZPK%2b6/4V6XaXcF7bJcW8gkicZBFeK1t%2bHfEEui3YDEvaSH95H6f7Q9/wCdVGVtzzcZglUXPD4vzPV6KihmjuIUmicPG4DKw6EGpa0PB2CiiigAooooAKKKKACiiigAooooAKKKKAGhlJIBBI6jPSnVy/h4n/hJdd5/5aj%2bbV1FBpVp%2bzly%2bn5BRRRQZhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcNrn/IZuf94fyFZ9aGuf8hm5/wB4fyFZ9e9S/hx9EIKKKK0Aw/Gf/Il6z/16Sf8AoNXf2ef%2bSbS/9hCX/wBBSqXjP/kS9Z/69JP/AEGrv7PP/JNpf%2bwhL/6CleXjviQ0esUUUVwgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFcT4p%2bK3hLwoXiutRF1eJwbWzxLID6Hnav4kUAdtUNzdW9nA091PFBCgy0krhVH1J4rwC4%2bL/jzxrcPaeCdAa3jztMyx%2bc6/7zsAifiPxpbT4IeL/FE63fjPxKynr5fmNcyL7ckKv4ZoA4T4wx%2bH38c3GoeHtTtb2G9Hm3C253COb%2bL5uhDfe4J5JrhIYJrmQRwRSSyHoqKWP5CvrTRfgf4I0fa8unyajMv8d7KWH/AHyML%2bYq/wCP1tPC/wAMdbfSbO3sl8gQhbaJYwPMZY%2bAMdmoA%2bXPDHha98Q6illZxgysMu7fdiXuSa9b/Z11H7DqPiDw7dfu7oFZlQ9coSjj8CV/WtL4TaZDaeDkvlUedeyOzt3wrFQP0J/GuZ8f6HqvhHxZD488PDAWQSXCqMhG6EsB1RxwfqfWvIpZpGWMlh5aLZeq3/4H/BN5UbQUkfSdFcP4H%2bKPh/xraxJFcpaaoRiSxmcB93fYf4x9OfUCu4r1zAKKKqahqVjpVo93qF3Ba26felmkCKPxNACarqVvo%2bkXmpXTBbe1haaQ57KM/nXxtpnhvVPEGk6t4gjhWWGGb98B94k5ZiB7ZGe/Nei/Ef4i3PxGvovCHhGKWWykkHmz4K/aCORwfuxjqSeuB0xz6L4V8O2/hjw7baVCQ/lgmWTH%2bsc/eP8Ah7Yry8zzFYSKUdZPp5G1KnzvXY%2bU57WSLcwVjECPnxwM9ATVevffAsSaD8cb7RIVDWV4ksbRYyu0p5oBHTjGP/116Vrvwj8Fa/uabRorWZv%2bW1l%2b5YH1wPlP4g16NOaqQU1s1cyas7HxxRXuniP9nG%2bg3zeHNWjuUHIt7wbH%2bgccE/ULXkuveE9e8MT%2bVrOlXNmScK7plGP%2by4yp/A1YjFooooAKKKKACiiigAr6u%2bBfi1/Efgn7BdSb7zSWEBJPLREfuyfwBX/gNfKNeu/s8ak1p4/uLEt%2b7vbNxtzjLoQwP5bvzoA%2boqKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDx/8AaO/5J5p//YVj/wDRUtHhX/kUNF/68IP/AEWtH7R3/JPNP/7Csf8A6Klo8K/8ihov/XhB/wCi1rvwPxMTNeiiivTAK0tA/wCQ3b/8C/8AQTWbWloH/Ibt/wDgX/oJrKt/Dl6MDt6KKK8IYUUUUAFFFFABRRRQAUUUUAFFFFAGN4m/5BQ/66j%2bRrj67DxN/wAgof8AXUfyNcfXr4L%2bEIKKKK6wCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiio7iZbe3lnf7saFzj0AzQBwvj74hr4bP8AZ2nKkupMuXZuVgB6ZHdvQfiffz620fx34yUXjPdyQPysk83lxn/dXI4%2bgxTvA%2bm/8Jl47lutTxKi7rudW6Odwwv0yRx6DFe%2bAAAADAHQCuCEJYi8pOy6IDwGe38deBWW5eS7itwR8yyebCf94cgfiAa9Q8DeOYPFls8MyLBqUK5kiB4cf3l9vUduK6ueCK5geCeNZIpFKujjIYHqCK8DuYD4F%2bKCLbFhbxXCsvPWF8ZX8iR%2bFOSlh5Jp3iwPb9c0Sy8Q6VLp99HuiflWH3kbsynsf8968s0XWdS%2bGeuHRNbDS6RKxaKVRkKCfvr7eq/5PslZXiDw/YeJNMaxv48qeUkXh429VNb1aTk%2baOkkBowTxXMCTwSLJFIoZHQ5DA9CDUleNWeo698LNSFjqKPe6JK58t16euUz91vVT/8AXr1fSdY0/XLFbzTrlJ4W67Typ9COoP1p06qno9H2AvUUUVsAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXolv/AMe0X%2b4P5V53Xolv/wAe0X%2b4P5V5%2bP2iMlooorzQCiiigAooooAKKKKACiiigArkfFP/ACE4/wDriP8A0Jq66uR8U/8AITj/AOuI/wDQmrrwX8UGYlFFFeuIKKKKAOI/Zl/5mn/t0/8Aa1fQFfP/AOzL/wAzT/26f%2b1q%2bgK%2bdGFFFFABRRRQAUUUUAFZXiWVoPCusTJ96OymcZ9QhNatY/ioFvB%2btgAkmwnAA/65tQB5Z%2bzdCi%2bFtYnA%2bd70IT7KgI/9CNecfG7R30H4j38kAMdvqsKXJC9GyfmB/wCBpu/EV6X%2bzeR/wh2rDPP9oZx/2zWqv7SOkebomjawq829w9s5A7Ou4Z9gUP8A31T6gbXg/QI9f/Z1t9HCZNzZT%2bWOuJfMdlP/AH3g14d8J1D/ABT8PpKxULcHGTjBCsQOfevoz4MSGX4SaExABCzLx7TOP6V4jZaavh/9o%2bKyK7Y11fdGoHRZPmQfk60Ab/7R%2bhrDq2ka7GmPtMTW0xA43IcqT7kM3/fNdv8AAGCNPhiCFB868mZwR1Pyr/ICp/jvpQ1H4YXVwFy9jPFcL69dh/RyfwqH9n%2bUSfDMKB/q72VTz1%2b6f60dAPnv4h%2bH18MePNX0uNNkEc2%2bADoI3AZR%2bAYD8K5evav2j9KFv4r0rU1XAvLQxN7tG3J/J1H4V4rQAUUUUgPqr9n7T0tPhqLkAb7y7lkY9%2bMIB/46fzr1WvLPgBfx3XwzS3UjfaXcsbjvyQ4P/j36V6nQAUUUUAfPvx88A2NlaQ%2bKtLt0t2aYRXsca4Vy2SsmOgORg%2buR757P4EeIZdb%2bHyWty7PPpkxtgzHJMeAyfkDtH%2b7XRfEzw/eeKPh7quk6dGkl7KsbQq5AyUkVyATwCQpA%2btcr8DvBmt%2bEtH1Rtbtvsst3MhjhLhmCqCNxwSOS36UAer0UVR1WUw6bMy9SNv5nFA0ruxj6pq7zSNDbuViBwWHVv/rVkUUVR6UYqKshQSpBBII6Edq39J1Z5XFtctlj9xz39jXP0qsVYMpwwOQR2oFOCmrM7yiooJPOt45P76hvzFS1J5pzXi%2bzutQtbS3tYWkcyknHQcdz261Ho/g22tNs19tuJuuz%2bBf8fxrqaKDoWJqRp%2bzjohOFGTwBWXca7awsVQNKR3Xp%2bdQ6/dtHGlshxvGWx6elc7TSHSoKS5pHm3xWn%2b2/FPwZeBdimWGLaTk5WcE/%2bhCmXCf8K5/aOikTMenaw4JA6bJjgg%2bwlGfoBTPiP/yP3gn/AK/F/wDRsda37SOnhbLQNYj%2bWaKaSAsOpyAy/kVb86GZVYqM2ke7V82ftBeC003VoPFFnHtgv28q6A6CYDIb/gSg/ip9a%2bhtIvTqWi2N8Rg3NvHNj03KD/WsX4g6CviTwHrGm7N0rW7SQ8f8tE%2bZf1AH40jM%2bJ6KKKAPWP2ftbOnfEFtOd8Q6lbtHtzgeYnzqfyDj/gVfU9fDXhHU/7F8YaPqW7atteRO5/2Qw3D8s19y0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAfOXxB1a00P9onT9Uv5DHa2scMkrBSxACt0AqrNP4n%2bPXifyIA%2bneG7R%2bWIJSMerc4eQjoO3sMk9L40%2bGOoePPi/PK%2b%2b10eG3g8%2b6K8vx9yP1b36Dv2B9i0bRdO8P6VDpml2qW1pCMLGn6knqSe5NAFbw14Y0rwlo0Wl6RbiKBOWY8vK3dmPcn/wDVxWzRRQAVw/xg/wCSUa//ANck/wDRiV3FcP8AGD/klGv/APXJP/RiUAed/Cv/AJEGy/66S/8AoZrs64z4V/8AIg2X/XSX/wBDNdnXu0P4cfQQUUUVqBLbf8fUP%2b%2bP516JXndt/wAfUP8Avj%2bdeiV5uP3iMKKKK88AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKr3l3FY2ct1O22ONdx/wHvViuA8d6tvnj0yJvljw8uPU9B%2bXP4ik3ZG%2bGoutUUDmNU1KbVdQku5jyx%2bVc8KvYCqdFFZH1EYqKSWwUVu6L4Xutbs3uYZ4UVZDHh85yAD2HvWj/wr7UP%2bfu2/8e/wp2ZhLFUYPllLU5Giuu/4V9qH/P3bf%2bPf4Uf8K%2b1D/n7tv/Hv8KLMn67Q/mORorrv%2bFfah/z923/j3%2bFH/CvtQ/5%2b7b/x7/CizD67Q/mORorrv%2bFfah/z923/AI9/hR/wr7UP%2bfu2/wDHv8KLMPrtD%2bY5Giuu/wCFfah/z923/j3%2bFH/CvtQ/5%2b7b/wAe/wAKLMPrtD%2bY5Giuu/4V9qH/AD923/j3%2bFH/AAr7UP8An7tv/Hv8KLMPrtD%2bY5GitjW/DtzoaQtPNFJ5pIGzPGMev1rHpG8JxnHmi7o7HwTrpgn/ALLuH/dSHMJP8Lf3fof5/WvQa8OVmRg6kqynII6g167oOpjVtIhucjzMbJQOzDr/AI/jVxfQ8fMsPyy9rHrualFFFWeUFFFFABRRRQAUUUUAFFFRyq7ROsb7HKkK2M4PrQBJRXL/ANi%2bIv8AoO/%2bOmj%2bxfEX/Qd/Q0HR7GH86/H/ACDw/wD8jLrv/XUfzauorz7S9P1WbV9Sit9S8qaN8SyYP7w5PNbP9i%2bIv%2bg7%2bhoN8RSg53c0tF37eh1FFYOn6ZrNvexy3WredCM7o9v3uK3qDjnFRdk7hRRRQQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHDa5/yGbn/eH8hWfWhrn/ACGbn/eH8hWfXvUv4cfRCCiiitAMPxn/AMiXrP8A16Sf%2bg1d/Z5/5JtL/wBhCX/0FKpeM/8AkS9Z/wCvST/0Grv7PP8AyTaX/sIS/wDoKV5eO%2bJDR6xRRRXCAUUUUAFFFFABRRRQAUUUUAFFFYXifxdong/Tje6zerApz5cY%2baSUjsq9T/IdyKAN2vP/ABp8X/DXg8yW3nf2jqacfZLZgdp/236L%2bp9q8x1Hx147%2bLN/LpPhGzl0/Ss7ZZFbadp7yy/w8fwryefvV3Pgr4G6B4d8u81gLrGojn96v7iM%2byH731b8hQBwf9ofFH4vuVslOk6G/BZCYYSvu/3pPcDj2Fdz4V%2bAnhnRBHPq5fWLsckSjZCD7IOv/AifpXqyqEUKoAUDAAHAFOoAhtrW3srdLe1giggjGEiiQKqj0AHAqaiigArH8VaKPEXhbUtJ3BWuoGRGPQP1Un2yBWxRQB88/C/xCNNkuPCmqg291FO3krJx82cNH9cjI9cmvU3RZEZHUMjDDKRkEehrH%2bI/wrh8VyHV9JkW01pQMk8JPjpkj7reje2D6jz2y8e%2bIvB9yuleL9LuH2cLKw2yEDuD92Qe%2bR9a%2bbzPKJ1JutQ1b3X%2bR1UqyS5ZGj4h%2bDGiapM9xpc76XK3JjVN8WfZcgj8Dj2rGT4X%2bN7ZfKtfGDJCPugXMyfoOK9A0zx54a1VR5OqwxOf%2bWdwfKIPp82AfwNdBFLHMm%2bKRJE/vK2R%2bleasxx%2bGXJJv5r/ADNfZU5ao8g/4Vv8QP8AodJP/A2eiL4L6lqNws2v%2bJZJ8ddgaRj9Gc8flXsVUL3W9K00E3uo2lvjtJMqn8s5p/2xjp%2b7F6%2bSD2NNblPw34T0fwraGDS7bYzD95M53SSfU/0HFXdY1ez0PTJb%2b%2blEcMY/Fj2UDuTXF638XNGsUaPS45NQn7NgpGPqTyfwH41l6R4J8W/EzUYtR8RPLp%2bkKcqpXYSvpGh55/vH9cYrXDZTicTU9piLpdb7sUq0YK0TS%2bDmnXfiHxpqvjK7iKwjekR7eY2OB6hU4/4EK92qlpWlWWiabBp2nW6QWsC7URf5n1J7mrtfXxiopRWyOJu4VFcW0F5byW9zDHPDINrxyKGVh6EHg1LRTEeTeK/gJ4a1oST6OX0e7PIEY3wsfdD0/wCAkfQ14V4u%2bGXifwazSahYmayHS8tsvF%2bJxlf%2bBAV9nU1lDqVYAqRggjgigD4Cor6p8afAzw/4i8270gLpGoNlv3S5gkPun8P1XH0NfPPivwRr/gy88jWbFo0YkR3CfNFL/ut/Q4PtQBzlFFFABXoPwRdl%2bLmigHAYXAPuPIkP9BXn1ejfAyAzfFjS3Gf3Mc7nH/XJl/8AZqAPrmiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA8f8A2jv%2bSeaf/wBhWP8A9FS0eFf%2bRQ0X/rwg/wDRa0ftHf8AJPNP/wCwrH/6Klo8K/8AIoaL/wBeEH/ota78D8TEzXooor0wCtLQP%2bQ3b/8AAv8A0E1m1paB/wAhu3/4F/6Cayrfw5ejA7eiiivCGFFFFABRRRQAUUUUAFFFFABRRRQBj%2bJFLaSSP4XUn%2bX9a46vQb23F3ZTQHGXUgfXt%2btefspRirAhgcEHsa9TAyTg49hCUUUV3AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFQXluLqyntiQBLGyc%2b4xU9FIDwf4Zakug%2bNZbG%2b/dfaFa2bdxtlDcA/iCPqRXvFeXfET4dz6jcya1ose%2b5fm4thgFyP4l9/Ud/r15nTfif4l0FPsN/ClyYvl23aMsq%2bxPB/ME1w06n1f3J7dGB7uSACSa8B165Xxh8UVSyO%2bGS4jgjcd1XAZvpwx%2blO1X4geJ/FgOmWcQiSb5TBZoxeQehPJx64x713fw68BP4dU6nqaqdRkXakYOfIU9ef7x74/rROf1iSjBaLdgeg0UUV3gV76xtdSs5LS9gSe3kGHjcZBry/Uvh/rfhe%2bbVfB15Ky9Wtifnx6c8OPY8/WvWKKyqUoz33Aw/CWp6nq%2bgRXerWQtLosylMEZA43FTyvOeP8a3KKKuKsrMAoooqgCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAr0aFSkCKeqqAa4fSLU3epRJj5VO9voK7uvMx8k2ojCiiiuAAooooAKKKKACiiigAooooAK5HxT/yE4/%2buI/9CauurkfFP/ITj/64j/0Jq68F/FBmJRRRXriCiiigDiP2Zf8Amaf%2b3T/2tX0BXz/%2bzL/zNP8A26f%2b1q%2bgK%2bdGFFFFABRRRQAUUUUAFV763%2b2afc23/PaJo%2bT6girFFAHg/wCzZckWniOxcbXjlhk2kYPIcH/0EV6R8T/Dd14r8A6hpdjEsl6xjeBWYLllcHqeBxury74Sn%2bwvjZ4q0M/LHJ54jHTOyUFeP90k19A0wOL%2bFnh7U/C3gO00nVoo4rqKSRiqSBxhmLDkcZ5rlfFnw31vU/jJpHinTFgFjC9tLdO8u1sxv8wA5J%2bQL%2bdevUUgMbxZpLa74R1fSowDLdWkkUeem8qdp/PFcr8H/B%2bseCvC93p2sCASy3jXCLC%2b/AKIvJx/s16HRQB43%2b0bp32jwZpuoKuWtb3YT6K6nJ/NVr5kr7O%2bKekHW/hprlqi5kSD7QgA5zGQ%2bB9QpH418ZGmAlFFFID1b4F%2bNIvDfiqTSr6UR2Oq7UDscCOYZ2E%2bxyV/EelfVNfAFe8/DX46LZ20GjeLXdoowEh1EAsQBwBIByf94c%2bo70AfQ1FU9P1Sw1e0W6069t7u3bpJBIHX8xVygAorJ13xLovhm0N1rOpW9nHjIEjfM/8AuqOWP0BrB8CeP4fHlzq81javFptm8cUEknDysQxZiOw%2b7gfX6AA7SqGrxmXTJgvUAN%2bRzV%2bkIDDB5BoHF2aZwdFaWp6W9nIZI1LQHoR/D7Gs2qPTjJSV0FKAScAc0lbej6W7SrczqVVeUU9SfWgU5qCuzy/4%2bzatpumeHGtL24gtR5kcohkKAyBV2kkdeN2Px9a5HRtO%2bLs2kWuq6PqOpXdlcJvjZdRWQAdMbXbOc5B47V71498JxeM/CV3pLMqTnEttI3RJV%2b6foeVPsxrwz4e/EC8%2bGupXXhnxNazpZLKdy4y9s56kD%2bJD14%2bo68yebu9Sx/wl3xo0j/j5stQnQf39MWRR9WRff1p0fx%2b8XWEgi1PRdPLDnDRSRMR%2bLH27V6hf/F7wVY6c12msJdNtykECMZHPYYIGPxxXjuj6fq/xp%2bIjajfxNFpUDL520/LDCDkRKe7Nzz7k%2b1AM9rbUn1zSNJ1prZrYXtokvksclc84z36jBqCuxudPhuLMWwURqgAj2jATHAwPSuauNLu7d8GFnXsyDINUjsoVE42Z5J8R/wDkfvBP/X4v/o2Oug/aSvI08LaPYlh5st6ZlHchEIJ/8fFcx8SNQtbL4meFft7%2bXb2Msdzcgg5VPMDHgc5ITgUaLDqHxu%2bKA1i8t3i8Paaw/dt0CA5WP0LMeW9s%2bgpM56zvNnvnhW0ew8IaJZyBg8FhBEwbrlY1HP5Vr0VHNLHBDJNKwSONSzMegA5JpGR8Ka5arY6/qVooCrBdSxADoArEf0rPq1qV2b/VLu8Oc3EzynPX5mJ5/OqtABX3jo10b7QtPvCcme2jlJ9dyg/1r4Or7g8Dsz/D/wANuxJZtLtSSe58paAN%2biiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK4f4wf8ko1/8A65J/6MSu4rh/jB/ySjX/APrkn/oxKAPO/hX/AMiDZf8AXSX/ANDNdnXGfCv/AJEGy/66S/8AoZrs692h/Dj6CCiiitQJbb/j6h/3x/OvRK87tv8Aj6h/3x/OvRK83H7xGFFFFeeAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAQ3NwlrbS3Eh%2bSJC7fQDNeM3VzJeXctzKcvK5c/jXpHja7%2bzeHmiB%2bad1j/Dqf5Y/GvMazmz3Mrp2g59woooqT1Dv/B1z9j8JX9yF3GGWSTbnGcIpxVq8iHifTFvdIvZoLlBgxiQrk/3WAPB9D/kZ/hr/kRNY/7bf%2bihXJ6Zql1pN4txavg9GU9GHoaq%2biPJVB1KtScH7yf9IWa%2b1S3maGa7u0kQ4ZWlYEH86Z/amof8/wBdf9/m/wAa7e5tdP8AGmnfabUiG/jGCD1B/ut6j0P/ANcVwd1azWVy9vcRmOVDgqaTVjsoVYVfdcbSW6Jf7U1D/n%2buv%2b/zf40f2pqH/P8AXX/f5v8AGqlFI6OSPYt/2pqH/P8AXX/f5v8AGj%2b1NQ/5/rr/AL/N/jVSigOSPYt/2pqH/P8AXX/f5v8AGj%2b1NQ/5/rr/AL/N/jVSrWn6fc6neJa2qbpG6k9FHck%2blAnGEVdpE9pc6vfXKW9tdXckrnhRK35nnpXcrND4S0vzL67lu72TorSE5PooPQe//wBYVAzad4J03aoE%2boyr%2bLfX0X%2bdcLfX1xqN29zdSF5G/ID0A9KrY4OX609FaH4v/gHY%2bP232enNjklz%2bi1wtdz49/48NM/4F/Ja4alLc2wH%2b7r5/mFdb4C1Aw6lLYs3yTruUf7S/wD1s/kK5KrWnXZsdStroH/VSKx9xnkflSTszbEU/aUpQPaKKQEEZByDS1sfKhRRRQAUUUUAFFFFABRRRQAUUUUAcv4f/wCRl13/AK6j%2bbV1Fc/o1jc22u6vPNEUimkBjYn7wyTXQUG%2bJadS67L8kFFFFBgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFVNSuXs9MubmMAvFGzqG6ZAqLRryTUNIt7qUKJJFJYL04JH9KCuR8nP02NCiiigkKKKKACiiigAooooA4bXP%2bQzc/wC8P5Cs%2btDXP%2bQzc/7w/kKz696l/Dj6IQUUUVoBh%2bM/%2bRL1n/r0k/8AQau/s8/8k2l/7CEv/oKVS8Z/8iXrP/XpJ/6DV39nn/km0v8A2EJf/QUry8d8SGj1iiiiuEAooooAKKKKACiiigAoqK4uILS3kuLmaOGCJSzySMFVQOpJPAFeAeMfijrfjzVj4U8AQzmGXKSXUeVeUdyD/wAs09ScE%2b3QgHV/ET41WHht5NJ0AR6lrOdjEfNFA3TBx95v9kfieMVy/hX4Q654z1IeJPiFd3P73DC0ZtsrjqA2P9Wv%2byAD/u123w5%2bEGl%2bDI47%2b%2bEV/rfXzyvyQH0jB7/7R5%2bnSvS6AKem6XY6NYRWOm2kVraxDCRRLgD/AOv71coooAKKKKACiiigAooooAKqahpljq1qbXUbOC7gPWOeMOPrg96t0UAeaat8DvCWosz2q3enOeQLeXcmfo4P6EVzM37PbxyF7LxOyez2nOPqH/pXuNFAHhf/AAoDUH%2bWTxUNh6/6Mx4%2bm%2btKw/Z80eIqdQ1q9uMHkQxrED%2be6vYqKErBc5bQfh34V8OOsthpEP2heRPNmVwfUFs4/DFdTRRQAUUUUAFFFFABRRRQAVVv9Ps9UspbO/tobm2lGHimQMrD3Bq1RQB89eP/AIAyQiXUfB5aROWfTpW%2bYf8AXNj1/wB08%2b56V4VPBNazvBcRSQzRsVeORSrKR2IPINffVcR48%2bGOh%2bO7cyXCfZdUVcRX0S/N7Bx/GvseR2IoA%2bN69n/Zx01p/GOp6iVzHa2Xl59GkcY/RGrzrxf4K1rwTqZstWttqtnybhOYpgO6n%2bYPIr6B/Z60mCy8Azaiskbz390xfY2Sip8qq3ofvN9GFAHrlFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB4/wDtHf8AJPNP/wCwrH/6Klo8K/8AIoaL/wBeEH/otaP2jv8Aknmn/wDYVj/9FS0eFf8AkUNF/wCvCD/0Wtd%2bB%2bJiZr0UUV6YBWloH/Ibt/8AgX/oJrNrS0D/AJDdv/wL/wBBNZVv4cvRgdvRRRXhDCiiigAooooAKKKz9U1EWMK7QGlf7oPb3NA4xcnZGhRXGtqd67bjcyA%2bxwPyrW0nVnnlFvcEFz91%2bmfY07G0qEoq5uUUUUjAK5nxDpLb2vYFyD/rVHb/AGv8a6ak61pSqunLmQHm9FdTqPhxJWMtmRGx5MZ%2b6fp6Vz1xYXVqSJ4HQDvjj8%2blexSrwqLRiK9FFFbAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFQXNjaXoAurWCcDoJYw386nopNXAht7O2s1KW1tDAp6iJAo/SpqKKACiiimAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRQBngUAFORGkcIilmY4AHertro19dkbYSin%2bOT5RXT6bo0Gnjf8A6yb%2b%2bR0%2bgrmrYmFNd2AaNpn9n22XwZpOXPp7Vp0UV5E5OcnJjCiiipAKKKKACiiigAooooAKKKKACuR8U/8AITj/AOuI/wDQmrrq5HxT/wAhOP8A64j/ANCauvBfxQZiUUUV64gooooA4j9mX/maf%2b3T/wBrV9AV8/8A7Mv/ADNP/bp/7Wr6Ar50YUUUUAFFFFABRRRQAUUUUAfPfiY/8In%2b0zpuon5IdRaFj6YkUwMT%2bIJr6Erw39ozR3/s7RfEMGVktZmt3deoDDch/Aq3/fVeueGNZTxD4X0zV0I/0u3SRgP4WI%2bYfgcj8KANaiiigAooooAY6LLGyOoZGBDKRwQe1fEnjfw5J4T8Yalo7A%2bXBKTCx/iiblD/AN8kZ9819vV5J8cfh/J4l0VNd0yHfqenIfMjUfNND1IHqVOSB7t3xQB8t0UpFJQAUUUUAWbPUL3TpvOsbu4tZem%2bCQo35g1rN448XOpV/FOtsp4IOoSkH/x6sCigCWe4mupjLcTSSyN1eRixP4mvor9mv/kXdc/6%2b0/9Ar5wr6P/AGa/%2bRd1z/r7T/0CgD3CiiigBCARg9KpyaVYytua3XP%2bySP5VdooGm1sVIdOs7dt0cChh0J5I/OrdFFANt7hXM%2bK/AXh7xlGBq1lmdBhLmI7JVHpu7j2ORXTUUCPI7b9nrwtDciSa/1SeIH/AFTSIoP1IXP5Yr07SNH07QdOi0/S7SK1tY/uxxj9SepPueavVFPPDawPPcSxwwxqWeSRgqqB3JPAFAEtct4z8faH4H0/z9TuN1w4Pk2kZzLKfYdh/tHj8eK858Z/HNpbr%2bxPAts1/fSN5Yu/LLjP/TJOrH3PHHQ1D4O%2bCV5qeof8JB8QLqS6upW8z7EZdxY9vNf/ANlXjpz2oA43S/Cmv/Grxpd%2bIrqD%2bz9KmkUST9QqqAoSPP3mwOTjGck%2blfSfh/w/pvhjRoNK0q3ENrCOB1Z27sx7k9zV%2b3t4LS3jt7aGOGCJQqRxqFVQOgAHAFS0AFedfGnxQnhz4fXcCOBeamDaQrnnaw%2bdvoFyM%2brCvQLi4htLeW4uJVihiUu7ucBVAyST6V8d/E/xxJ458WS3cZZdOtgYbKM/3M8uR6sefpgdqAOJooooAK%2b6fC9ubTwlo1qVCmGxgjwO2I1FfEej6e%2bq63Yacmd93cRwDHqzBf6194KqoiooAVRgAdhQA6iiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK4f4wf8AJKNf/wCuSf8AoxK7iuH%2bMH/JKNf/AOuSf%2bjEoA87%2bFf/ACINl/10l/8AQzXZ1xnwr/5EGy/66S/%2bhmuzr3aH8OPoIKKKK1Altv8Aj6h/3x/OvRK87tv%2bPqH/AHx/OvRK83H7xGFFFFeeAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcH8QpyZbGAHgB3I%2buAP5GuJrq/iAT/AG5AM8C2B/8AHmrlKylufTYJWw8QooopHUdz4a/5ETWP%2b23/AKKFcNXc%2bGv%2bRE1j/tt/6KFcNTeyOPDfxKnqWbC/uNNu0ubWQpIv5EehHcV3WdO8b6dg4g1CIdOpX/Fa88qa1up7K5S4t5DHKhyrChOxdfD%2b096LtJbMff6fc6bdtbXUZSRfyYeoPcVWr0K2utP8aacbW6UQ6hGuQQOQf7y%2bo9R/9Y1xWqaVc6ReNb3K4PVXHRx6ihrqFDEc75Jq0l0/yKVFFaei6Jda1deVCNsa8ySkcKP6n2pG85xhHmk7Ii0rSbrWLwW9sme7ueiD1Ndpd3un%2bDNP%2byWYE184yxbrn1b29B/%2bum6nqtl4Usf7M0xFN2R8zddp/vN6n0FcFNNJPM8srs8jnLMxySar4ThUZYp80tIdF39R1zczXlw89xI0krnLMx61FRRUnekkrI7nx7/x4aZ/wL%2bS1w1dz49/48NM/wCBfyWuGpy3OTAfwF8/zCiiikdh7Hos5uNEsZScloEyffGDV%2bsTwk%2b/wvZE%2bjD8nIrbrVbHydZctSS82FFFFMzCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKz9V1SPSbZZ5IZZQW24jGSPrWP/wm1r/z4Xn/AHyP8aDaFCpNc0Voa%2bu/8gC//wCuDfyqDwv/AMi3Zf7p/wDQjWLqfi23u9MubdbO6VpIyoZlGBkd%2bai0bxVb2GkW9q9pcu0YILIoweSfWg6fq1X2HLbW/wCh29Fcv/wm1r/z4Xn/AHyP8a1tJ1ePV4pJI4Jogjbf3i4z9KDmnh6kFzSWhpUUUUGIUUUUAFFFFAHDa5/yGbn/AHh/IVn1oa5/yGbn/eH8hWfXvUv4cfRCCiiitAMXxfG0vg3WVXr9jlP5KTU/7O0yyfDu6jH3otRkBGfVIzn9f0q9cwJdWk1vJ9yVGRvoRg1xf7PWptpmva/4Xuztm4lRTx80ZKOPryv/AHya83HrVMD6CooorzxhRRRQAUUUUAFVNR1Ky0jT5r/ULmO2tIF3SSyNhVH%2be3el1DULTStPnv7%2b4S3tYELyyyHAUCvnTUdR8QfHfxaNN00SWXhuzfczMPlQdN7/AN5zzhe35mgB2t%2bIfEnxv8SHQfD6SWnh6Bw0kjZA254eX1PB2oP6ZHtvgvwPo/gfSRZabCDM4BuLpx%2b8mYdyew64HQfmau%2bGfC%2bleEdGj0vSLcRQJyzE5eVu7Me5P/1hgVs0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBna3oem%2bItLl03VbSO5tZfvI46HsQeoI7EV8%2ba14Z8U/BLWzrnh2eS90CRgJVcZAXPCTKPyDj9M4P0pUcsMdxC8M0aSROpV0dcqwPUEdxQBzHgbx7pHjvSftVg/l3UYH2m0c/PCf6r6N/I8V1dfPfjr4aar4C1X/hMfAjyxwQEyTW0ZyYF7kA/fjPcHOPp09H%2bG3xN0/x7p/lNtttYgQG4tc8N23p6r%2bozg9iQDvaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPHP2j5VHgPTYifnbU0YD2EUgP8xUvhhSnhPRkYYZbGAEeh8ta5j9oDUW1jxXoHha0bMqDe%2bDn55WCqCPYKT9GruIYkt4I4YxhI1CKPQAYFehgFrJiZJRRRXpAFaWgf8AIbt/%2bBf%2bgms2tLQP%2bQ3b/wDAv/QTWVb%2bHL0YHb0UUV4QwooooAKKKKACub8RKwu4mP3THgfXJ/xFdJVa8s4r2AxyAjByrDqDTRpSmoSuzi6tacrNqNuF6%2bYD%2bA6/pV5vD1yHwssRX1JI/pWnp2lR2OXLb5SMbscAe1O51TrQ5dGaVFFFScIUUUUAFFFFAEZghY5MSE%2b6ik%2bzwf8APGP/AL5FS0U7sCL7PB/zxj/75FH2eD/njH/3yKloou%2b4EX2eD/njH/3yKPs8H/PGP/vkVLRRd9wKtzFFHazOsUe5UJHyDqBVTSMXVo7zJGzByoPlgcYHtVvUTt06c/7BFV9DXGnZ/vOTWq/hN%2bYupd%2bzwf8APGP/AL5FH2eD/njH/wB8ipaKyu%2b4yL7PB/zxj/75FH2eD/njH/3yKloou%2b4EX2eD/njH/wB8ij7PB/zxj/75FS0UXfcCL7PB/wA8Y/8AvkUfZ4P%2beMf/AHyKloou%2b4EX2eD/AJ4x/wDfIo%2bzwf8APGP/AL5FS0UXfcCL7PB/zxj/AO%2bRR9ng/wCeMf8A3yKloou%2b4EX2eD/njH/3yKPs8H/PGP8A75FS0UXfcCL7PB/zxj/75FH2eD/njH/3yKloou%2b4EX2eD/njH/3yKPs8H/PGP/vkVLRRd9wIvs8H/PGP/vkUfZ4P%2beMf/fIqWii77gRfZ4P%2beMf/AHyKPs8H/PGP/vkVLRRd9wIvs8H/ADxj/wC%2bRR9ng/54x/8AfIqWii77gRfZ4P8AnjH/AN8ij7PB/wA8Y/8AvkVLRRd9wIvs8H/PGP8A75FH2eD/AJ4x/wDfIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/wDvkVLRRd9wIvs8H/PGP/vkUfZ4P%2beMf/fIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf88Y/%2b%2bRR9ng/54x/98ipaKLvuBF9ng/54x/8AfIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf8APGP/AL5FH2eD/njH/wB8ipaKLvuBF9ng/wCeMf8A3yKPs8H/ADxj/wC%2bRUtFF33Ai%2bzwf88Y/wDvkUfZ4P8AnjH/AN8ipaKLvuBF9ng/54x/98ij7PB/zxj/AO%2bRUtFF33Ai%2bzwf88Y/%2b%2bRTlijT7iKv0GKfRRdgFFFFIAooooAKKKKACiiigAooooAKKKKACiiigArkfFP/ACE4/wDriP8A0Jq66uR8U/8AITj/AOuI/wDQmrrwX8UGYlFFFeuIKKKKAOI/Zl/5mn/t0/8Aa1fQFfP/AOzL/wAzT/26f%2b1q%2bgK%2bdGFFFFABRRRQAUUUUAFFFFAHOePPD3/CU%2bCdV0gKDNNCWgz/AM9V%2bZP1AH4mvOv2ePEX2rw7feHZ2xPp8pliVuD5bnkY9nzn/eFe0V85eKUf4T/G238Qwow0fU2aSRUHBVjiVMeoYhwP92mB9G0VHBNFcwRzwuskMih0dTkMpGQQfTFSUgCiiigAooooA8D%2bK3wWeeafxB4VgBdsvc6cg6nu0Y/mv5elfP7xvE7RurK6khlYYII6givvyuE8b/Cjw94233E0ZstTI4vbcDLHtvXo4/I%2b4pgfHdFegeLPg94s8LNJL9iOo2K8i5sgXwP9pPvL78Y964AgjikAlFFFABX0f%2bzX/wAi7rn/AF9p/wCgV84V9H/s1/8AIu65/wBfaf8AoFAHuFFFFABRRRQAUUUUAFFFeffFL4kweAtIWO3CTazdqfs0LdEHQyMPQHoO5%2bhwAa/jX4gaH4FsPO1KbfdSKTBZxEGST8Oy%2b5/U8V4pHD48%2bOd7vlf%2by/Dav7iEYPYcGVx69B/s5rX8B/CW/wDFF9/wlnj6SeZ7hhLHZynDS%2bhk/ur6IMdugGD71DBFbQJBBEkUUahUjRQqqB0AA4AoA5jwZ8PdA8D2gTTbbfdsuJbyYZlk/H%2bEew9utdXRRQAUUV4r8bfie2iW7%2bF9FnK6jOn%2blzoeYIyPug9mYd%2bw9zwAcx8bPiiNVml8LaHPmxibF7cIeJmH8Ckfwg9fUj0HPiNFFABRRRQB6V8DNDOsfEq0nZMw6dG9057ZHyr/AOPMD%2bFfWteTfALwsdF8FPq9wm251ZxIuRyIVyE/Mlm%2bjCvWaACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK4f4wf8ko1//rkn/oxK7iuH%2bMH/ACSjX/8Arkn/AKMSgDzv4V/8iDZf9dJf/QzXZ1xnwr/5EGy/66S/%2bhmuzr3aH8OPoIKKKK1Altv%2bPqH/AHx/OvRK87tv%2bPqH/fH869ErzcfvEYUUUV54BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB5x4/B/tyA9vsyjP/AmrlK7X4hQ4uLGfsysh/Ag/wBa4qspbn02Cd8PEKKKKR1Hc%2bGv%2bRE1j/tt/wCihXDV3Phr/kRNY/7bf%2bihXDU3sjjw38Sp6hRRRSOwfDNJBMksTskiHKspwQa73TtVsfFlj/ZupqqXg5Ujjcf7y%2bh9RXn9OR2jdXRirKchlOCD6imnYwr0FVXZrZnTw%2bCL9tWNtKQLVfmNwP4l9h6/yrT1nXrXQLT%2bydGVBKuQ7jnYe/Pdv5VkzeNtQl0gWgGy4%2b69yp%2bYr7DsfeuaJJOSead0tjnhQq1ZJ4jZdO/mwZmdizEsxOSSeSaSiipO8KKKKAO58e/8eGmf8C/ktcNXc%2bPf%2bPDTP%2bBfyWuGpy3OPAfwF8/zCiiikdh6t4RUr4XsgfRz%2bbsa3KztDh%2bz6FYxkYIhUkehIyf51o1qtj5Os%2bapJ%2bbCiiimZhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGdrv/IAv/8Arg38qg8L/wDIt2X%2b6f8A0I1Prv8AyAL/AP64N/KoPC//ACLdl/un/wBCNB0f8w/z/Q2KKKKDnCiiigAooooAKKKKAOG1z/kM3P8AvD%2bQrPrQ1z/kM3P%2b8P5Cs%2bvepfw4%2biEFFFFaAFeTeNI7zwP4/wBO8Z6ah8t5Q0ijgFwMMp9A6Z/8er1mqOsaTa65pU%2bnXiboZlwcdVPYj3BrGvS9pDlA9H0TWbLxDo1pq2nSiW1uow6MO3qD6EHII9Qa0K%2bXfCnirWPg54kfSdVjkudAuZNx2jr282P/AGsYyv8A9Y19J6RrGna9psWoaXdxXVpKPlkjOR7g%2bhHcHmvElFxdmMv0UUUgCobm5gsrWW5uZUhghQvJI7YVFAyST6VKePpXzx8Q/GOpfEvxNH4G8IkyWIkxPOpIWZl6sxH/ACyX9T68UAVfEWuaz8bvGKeHtAEkHh%2b1k3PMQdpGcec44/4CvX9ce8eFvC%2bmeD9Ch0nSodkKfM7ty8rnq7HuTj%2bQHAqr4K8Gab4H0CPTLBQ8hw1xclcNO/qfb0HYfiT0lABRRRQAUUUUAFFFFABRRUN3dQWNpLd3UqQ28KF5JHOAqjkkmgCaivD9Y%2bNuranqT2Pg3RvtCrnE0sTSO4/vBFI2j65/CoLP4z%2bJ9Cvo4PFuhDyWON8cTRSY7kZJVvwx9annjzct9ew7Pc93orO0TXNO8RaXFqWl3Kz20nRhwVPdSOoI9Kq%2bKPFGmeEtIfUdTl2oDtjjXl5W/uqPWqEbdFeCP8YfG%2bsSyT6D4di%2bxITj/R5Jj%2bLAgZ9gK7H4efFRPF18%2bj6nZrZasqllCE7JcfeAB5Uj0OeAealSi20nqh2Z6VRRRVCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAQ8/SvBvif8NLvw5f8A/CceCt1rLbN51zbW4x5frIg/u/3l6Yz2yB71SHn6UAcN8M/iJaePdE3Nsh1a2AF3bjgf76/7J/Q8ehPdV86/ETwrqHwv8WW/jjwovl6e8v7%2bAZKRM3VGH/PN/wBD0x8te3%2bE/FFh4w8O22sae37uUYeMn5onH3kPuP1GD3oA26KKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArN17XLLw3od3q%2boyeXbWyF2Pdj2Ue5OAPrTtZ1vTfD2my6jq15FaWsYy0kh6%2bwHUn0Aya%2bbfE/ifWPjN4li03TY5LTQbRt3z9u3mSdixGQq9ufc04xcnZAL4FhvPGXjnUfGmprwJWMYPI3kYCj2RMD8q9YqlpOl2ui6XBp1kmyCFdoz1J7k%2b5PJq7Xt0KXs4cogooorYArS0D/kN2/8AwL/0E1m1paB/yG7f/gX/AKCayrfw5ejA7eiiivCGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAEc0KTxNFIMq3UZxSW8CW0IiiGFGe9S0U7u1gCiiikAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyPin/kJx/wDXEf8AoTV11cj4p/5Ccf8A1xH/AKE1deC/igzEooor1xBRRRQBxH7Mv/M0/wDbp/7Wr6Ar5/8A2Zf%2bZp/7dP8A2tX0BXzowooooAKKKKACiiigAooooAK5T4h%2bDIPHHhO40x9qXSfvbSUj7koHGfY9D7H2rq6KAPCPhB8QJdFuW8B%2bKi1rdW0hhs3mOMHP%2bpY/%2bgnoc49K93rzv4k/CnT/AB3D9st3Sy1qNdqXGPllA6LIB%2bh6j36V5xpfxE8a/C28i0Xxjp017py/LFMxy4Uf885Ojj2PPQZFMD6LormPC/xA8NeMIx/ZOpRtcY%2ba1l%2bSZf8AgJ6/UZHvXT0gCiiigAooooAK4zxZ8MPC3jBXkvbBbe9b/l8tcRyZ9Txhv%2bBA12dFAHyb42%2bCniHwqkl5Zj%2b1tNXJMsCYkjHq6cnHuMj1xXmeK%2b/q8l%2bI/wAFtO8SpNqegxxWOr8s0YG2K5PuP4WP94fj1zTA%2bWq%2bj/2a/wDkXdc/6%2b0/9Ar571DTrzSr%2bexv7eS3uoGKSRSDBUj/AD1r6E/Zr/5F3XP%2bvtP/AECkB7hRRRQAUUUUAFfMv7RNzPD8QLBYp5EU6XGSFcgZ82WvpqvmD9o7/koen/8AYKj/APRstAHk/wBvvP8An7n/AO/hr0f4K%2bFl8W%2bORd6ihuLLTIxPIJDuDPnEanPbOWx/s15hX1D%2bzxo4svAlxqTL%2b91C6YhvWNBtA/763/nQB69RRRQAUUUUAcv8QPF0Xgnwhd6uwVrj/VWsbfxyt90fQcsfZTXxhe3lxqF7PeXczTXM7mSWRzksxOSTXrv7RHiJ77xba6FG/wC406EPIoP/AC1kAPP0Xbj6n1rxqgAooooAK6v4eeDpvG3i610xQwtFPm3co/giB559TwB7n2rA0vS73WtTt9O063e4u7hwkcaDkn%2bg7k9q%2bwvhz4DtfAfhxbNNst/PiS8uB/G/oP8AZHQfie9AHWQQRWtvFbwIscMSBI0UYCqBgAfhUtFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcP8YP8AklGv/wDXJP8A0YldxXD/ABg/5JRr/wD1yT/0YlAHnfwr/wCRBsv%2bukv/AKGa7OuM%2bFf/ACINl/10l/8AQzXZ17tD%2bHH0EFFFFagS23/H1D/vj%2bdeiV53bf8AH1D/AL4/nXolebj94jCiiivPAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOZ8cWnn6B5yjJgkV%2bPQ8H%2bY/KvM69qvLVL2yntZPuyoUPtkda8Znge2uJIJRiSNijD3Bwazme5ldS9Nw7EdFFFSeodz4a/5ETWP%2b23/ooVw1dz4a/5ETWP%2b23/AKKFcNTeyOPDfxKnqFFFFI7AooooAKKKKACiiigAooooA7nx7/x4aZ/wL%2bS1w1dz49/48NM/4F/Ja4anLc48B/AXz/MKsWNs15fwWy9ZZFT6ZNV66rwLp5udXe8YfJbLwT/ePA/TP6Ukrs3r1PZ03PsejKoRQqjAAwBTqKK2PlAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAjmijnheKRQ0bgqynoQabb28VrAkMKBI0GFUdqmooHd2sFFFFAgooooAKKKKACiiigDhtc/5DNz/vD%2bQrPrQ1z/kM3P8AvD%2bQrPr3qX8OPohBRRRWgBRRRQBQ1jRdP17T2stRt1mhbkZ6ofVT2Neaf8Ir4y%2bH%2bovqHg/UJp7c8vEuCzAdnjPD/Uc%2bgFetUVjVoQq77gcZpH7RU1q32XxR4ekjmTh5LQ7Tn3jfp/31XUxftAeCJIwzPqEZP8LW3I/IkUt3p1lqCbL2zt7lR2miVx%2borHbwL4Xdix0S0BPomP0FcUsBLowuYHxO%2bN1prOg/2R4We4QXQK3dzIhjYJ/cX69z6cd%2bG/DDxx8PfAehASz3Uur3Kg3c62pOPSNT/dH6nn0A6D/hA/C3/QEtfyP%2bNH/CB%2bFv%2bgJa/kf8aX1GfdBc2/8Ahf3gb/n4vv8AwFP%2bNH/C/vA3/Pxff%2bAp/wAaxP8AhA/C3/QEtfyP%2bNH/AAgfhb/oCWv5H/Gj6jPugubf/C/vA3/Pxff%2bAp/xo/4X94G/5%2bL7/wABT/jWJ/wgfhb/AKAlr%2bR/xo/4QPwt/wBAS1/I/wCNH1GfdBc2/wDhf3gb/n4vv/AU/wCNH/C/vA3/AD8X3/gKf8axP%2bED8Lf9AS1/I/40f8IH4W/6Alr%2bR/xo%2boz7oLm3/wAL%2b8Df8/F9/wCAp/xo/wCF/eBv%2bfi%2b/wDAU/41if8ACB%2bFv%2bgJa/kf8aP%2bED8Lf9AS1/I/40fUZ90Fzb/4X94G/wCfi%2b/8BT/jXE/FH4vaF4m8KLpWiT3W%2bW4Vp/MhKAxgE4/762/lW3/wgfhb/oCWv5H/ABo/4QPwt/0BLX8j/jR9Rn3QXOd8J/EPwV4b0G3s4zcrOUDXEgt%2bXk75PcA5A9q0NS%2bKPgXV7CSyv1uZ7eTqrW549wc8H3rS/wCED8Lf9AS1/I/40f8ACB%2bFv%2bgJa/kf8a8mfDFOVR1HN3ve9/8AgG6rySsedeDPiFa%2bBPF0jWNzcXWgXDhZo2TDFOzY/vr%2bvPrw3xT480/xv46W71W4uIdCgYpBEqEt5Y9h0ZiOT2/AV6P/AMIH4W/6Alr%2bR/xo/wCED8Lf9AS1/I/416by6bjy83z6/kY82tynbfFvwVZ20dtbG5ihjXaiJbEBR7CuNsPHmhJ8Yk8TTNPDpsbE5SL52/clBx7n9K77/hA/C3/QEtfyP%2bNH/CB%2bFv8AoCWv5H/GuLC8Pww03UhLV6av/gGk60pKzNv/AIX94G/5%2bL7/AMBT/jR/wv7wN/z8X3/gKf8AGsT/AIQPwt/0BLX8j/jR/wAIH4W/6Alr%2bR/xr0PqM%2b6Mrm3/AML%2b8Df8/F9/4Cn/ABo/4X94G/5%2bL7/wFP8AjWJ/wgfhb/oCWv5H/Gj/AIQPwt/0BLX8j/jR9Rn3QXNv/hf3gb/n4vv/AAFP%2bNH/AAv7wN/z8X3/AICn/GsT/hA/C3/QEtfyP%2bNH/CB%2bFv8AoCWv5H/Gj6jPugubf/C/vA3/AD8X3/gKf8aP%2bF/eBv8An4vv/AU/41if8IH4W/6Alr%2bR/wAaP%2bED8Lf9AS1/I/40fUZ90Fzb/wCF/eBv%2bfi%2b/wDAU/40f8L%2b8Df8/F9/4Cn/ABrE/wCED8Lf9AS1/I/40f8ACB%2bFv%2bgJa/kf8aPqM%2b6C5t/8L%2b8Df8/F9/4Cn/Gj/hf3gb/n4vv/AAFP%2bNYn/CB%2bFv8AoCWv5H/Gj/hA/C3/AEBLX8j/AI0fUZ90Fzb/AOF/eBv%2bfi%2b/8BT/AI0f8L%2b8Df8APxff%2bAp/xrE/4QPwt/0BLX8j/jR/wgfhb/oCWv5H/Gj6jPugubf/AAv7wN/z8X3/AICn/Gj/AIX94G/5%2bL7/AMBT/jWJ/wAIH4W/6Alr%2bR/xo/4QPwt/0BLX8j/jR9Rn3QXNv/hf3gb/AJ%2bL7/wFP%2bNH/C/vA3/Pxff%2bAp/xrE/4QPwt/wBAS1/I/wCNH/CB%2bFv%2bgJa/kf8AGj6jPugubf8Awv7wN/z8X3/gKf8AGj/hf3gb/n4vv/AU/wCNYn/CB%2bFv%2bgJa/kf8aP8AhA/C3/QEtfyP%2bNH1GfdBc0tR%2bNvw71bTrjT743k1rcRmOWNrU4ZT%2bNeT/Dz4gWPw/wDGd7FBcz3fhm6Ygkph1A5R9v8AeH3T68%2bgr0b/AIQPwt/0BLX8j/jR/wAIH4W/6Alr%2bR/xo%2boz7oLm3/wv7wN/z8X3/gKf8aP%2bF/eBv%2bfi%2b/8AAU/41if8IH4W/wCgJa/kf8aP%2bED8Lf8AQEtfyP8AjR9Rn3QXNv8A4X94G/5%2bL7/wFP8AjR/wv7wN/wA/F9/4Cn/GsT/hA/C3/QEtfyP%2bNH/CB%2bFv%2bgJa/kf8aPqM%2b6C5t/8AC/vA3/Pxff8AgKf8aP8Ahf3gb/n4vv8AwFP%2bNYn/AAgfhb/oCWv5H/Gj/hA/C3/QEtfyP%2bNH1GfdBc2/%2bF/eBv8An4vv/AU/40f8L%2b8Df8/F9/4Cn/GsT/hA/C3/AEBLX8j/AI0f8IH4W/6Alr%2bR/wAaPqM%2b6C5t/wDC/vA3/Pxff%2bAp/wAaP%2bF/eBv%2bfi%2b/8BT/AI1if8IH4W/6Alr%2bR/xo/wCED8Lf9AS1/I/40fUZ90Fzb/4X94G/5%2bL7/wABT/jR/wAL%2b8Df8/F9/wCAp/xrE/4QPwt/0BLX8j/jR/wgfhb/AKAlr%2bR/xo%2boz7oLm3/wv7wN/wA/F9/4Cn/Gj/hf3gb/AJ%2bL7/wFP%2bNYn/CB%2bFv%2bgJa/kf8AGj/hA/C3/QEtfyP%2bNH1GfdBc2Jf2gfBEcZZH1GUj%2bBLbk/mQP1rldX/aJuLxja%2bF/Dsjzvwkl0d7f9%2b07/8AAq018DeF0YMNEtMj1TI/I1s2lhZWEeyztILZP7sMYQfkBTjgJdWFzy1PCPjDx5qCal4x1GeKAHKxORvAPZEHyp/P2NemaTo9jodgllp9usMC84HVj3JPc1eortpUIUvh3AKKKK2AKKKKACtLQP8AkN2//Av/AEE1m1paB/yG7f8A4F/6Cayrfw5ejA7eiiivCGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGRqF3PHqNvBBIV3Y3cA9TitesKI/afEbt1WMn9Bj%2bdbtbVUoqK8hIKKKKxGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcj4p/5Ccf/XEf%2bhNXXVyPin/kJx/9cR/6E1deC/igzEooor1xBRRRQBxH7Mv/ADNP/bp/7Wr6Ar5//Zl/5mn/ALdP/a1fQFfOjCiiigAooooAKKKKACiiigAooooAKq3%2bn2eqWclnf2sN1bSDDxTIHU/gatUUAfK3xR%2bFN54Mvn1jRVml0Vm37kyXtGz0Y9dvo34Hnkw%2bE/jl4o8PGOC/kGsWS8FLlv3oHtJ1/wC%2bt1fVjokqNHIqsjAhlYZBB6givIfGXwB0bWpJLzw/ONJu2yxg27rdj7Dqn4ZHtTA6zwb8UfDXjRUitLr7NqBHNlc4WQ/7p6N%2bBz6gV2tfG2v/AAr8aeF3Ms%2bkzTwxnIubI%2baox/F8vzL%2bIFdp8Pvjpf6PLFpfitpbyxBCC7IzNB/vd3H/AI99elAH0rRVaxvrXUrKG9sriO4tpl3RyxsGVh6g1ZpAFFFFABRRRQB598T/AIaWnjvSzPbqkOt26H7POeBIOvlv6g9j2P4g/Mem2Op2mqXekyahPpN3Fu3QszJudeqnB6%2blfbteOfG74bjW9OfxPpMH/E0s0zcpGOZ4h392X9Rx2Apji0nqeM%2bGtM1/xLbzzQ%2bILmEQuFIeaQ5yM9jUcVjr8vix9AGvXQlTP73z32nC7uma6H4UyJ9h1GPcN4lVtuecY61Xs/8Akss//Av/AEVQehHD03Tpytq3ZmN4nsde8MfZfO166m%2b0b8bJ5Bjbt9T/ALVaWseGfEWj6TcahJ4kuJEhAJRZpATkgevvU/xZ/wCYR/22/wDZK6rxx/yJmpf7i/8AoS0XLeFpc1VW%2bFK33HFaF4f8Q67pMeoReIriJZCwCNNISMHHrWFZaFq3ifULuFbsT3FoNpa4lYlgGIwCc9816T8O/wDkTbX/AH5P/QjXP/Dr/kZtb/H/ANDNAlhab9l/e3%2b48%2b1DT7rS72S0vIjFPH95SQffqK%2byvhtp40v4beHrbbtP2JJWA7GQbz%2brGvlf4go0nja4RBlmWMAe%2b0V9l2dstnZQWqfchjWNfoBgfypHBVgoVHFdGT0UUUGYUUUUAfFPxJu2vfiV4jlcklb%2bWLn0Rtg/RRXLV2HiDw7qmt/E/wAR6bpNlPd3Q1G6cRry20Sn5jn6jn3rodJ%2bAfjXUCpu4bPTUPJNxOGOPom7n64oA8urovCfgnXfGl%2bLbR7NnRTiW5k%2bWKL/AHm/oMn0Fe%2beGv2e/DumMk2tXc%2brTDB8vHkxZ%2bgJY/n%2bFes2VjaadaR2ljbQ21vGMJFCgRVHsBxQByHw9%2bGmleArEmLF1qcq4nvXXBP%2byg/hX279%2b2O3oooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK4f4wf8AJKNf/wCuSf8AoxK7iuH%2bMH/JKNf/AOuSf%2bjEoA87%2bFf/ACINl/10l/8AQzXZ1xnwr/5EGy/66S/%2bhmuzr3aH8OPoIKKKK1Altv8Aj6h/3x/OvRK87tv%2bPqH/AHx/OvRK83H7xGFFFFeeAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFed%2bOtKMF6moxr%2b7n%2bWTHZwOPzH8jXolVNRsItSsJrScfJIuM/3T2I%2bhpNXR0YWv7GopdOp4xRVm/sptOvZbW4XEkZx7EdiPaq1ZH06aaujtvCd5pyeHLuyvruKHzpXUqzhTtZFGR%2btP8A7D8If9BT/wAmF/wrhqKdzkeEfO5Rm1c7n%2bw/CH/QU/8AJhf8KP7D8If9BT/yYX/CuGoov5B9Vn/z8Z3P9h%2bEP%2bgp/wCTC/4Uf2H4Q/6Cn/kwv%2bFcNRRfyD6rP/n4zuf7D8If9BT/AMmF/wAKP7D8If8AQU/8mF/wrhqKL%2bQfVZ/8/Gdz/YfhD/oKf%2bTC/wCFH9h%2bEP8AoKf%2bTC/4Vw1FF/IPqs/%2bfjO5/sPwh/0FP/Jhf8KP7D8If9BT/wAmF/wrhqKL%2bQfVZ/8APxnY%2bNr%2byvLaxS0uopvLLZ2NnAwMVx1FFJu5vQpKlBQTFAJOAMk9hXrPhvSv7J0aKFhiZ/3kv%2b8e34DArkPBehm9vP7QnT/R4G%2bQEfff/Af4V6PVxXU8rM8Rd%2byj03CiiirPJCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOG1z/kM3P8AvD%2bQrPrQ1z/kM3P%2b8P5Cs%2bvepfw4%2biEFFFFaAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFcH46%2bIsXhtjp9giT6mRlt33IQemfU%2b35%2b8TqRguaQHeUV4Bb2PjzxqDciS8lt2OQ8kvlRf8AARwD%2bANPm8J%2bO/Da/a4Dd7V5ZrS4L4%2bqg5P5Gub603qoOwHvlFeV%2bCfii95cx6Z4gKCRztjuwAoJ9HHQfUf/AF69Urop1Y1FeIBRRRWgBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWloH/Ibt/8AgX/oJrNrS0D/AJDdv/wL/wBBNZVv4cvRgdvRRRXhDCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigCCK0gglaWOMK7dSD1qeiim23uAUUUUgCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAorP1rUTpWkz3gQO0eMKT1JIH9aTSdXtdYtRPbNyPvofvIfegv2cuTntoaNFFFBAUUUUAFFFFABRRRQAVyPin/AJCcf/XEf%2bhNXXVyPin/AJCcf/XEf%2bhNXXgv4oMxKKKK9cQUUUUAcR%2bzL/zNP/bp/wC1q%2bgK%2bf8A9mX/AJmn/t0/9rV9AV86MKKKKACiiigAooooAKKKKACiiigAooooAKKKKACub8U%2bBfD/AIvsZrfU9PhMzjC3caBZoz2IfGfwPB710lFAHzXo2r6/8DfF39ja15t14duWLIyD5WBI/ex%2bjDjcuf6Gvo20u7e/s4bu0mSa3nQSRSIchlIyCDWJ408IWHjXw5PpV8oDEboJ8ZaGQdGH9R3Ga8k%2bDnii%2b8LeJbr4eeISYmWVha7zxHJ1KAn%2bFh8y%2b5/2qYHvtFFFIAooooAKQ8/SlooA%2bYPiJ4dl%2bGXxAh1rTYiNH1BiwjX7q5%2b/F7f3l/D0rG0u4iu/i29xA4eKVS6MO4MQNfSfjvwpB4z8JXmkS7VmZfMtpG/5Zyj7p%2bnY%2bxNfK3gW3ms/HsVrcxtHPD5sciN1VlUgg/QimdWGqPmjDpdM2viz/wAwj/tt/wCyV1Xjj/kTNS/3F/8AQlrlfiz/AMwj/tt/7JXVeOP%2bRM1L/cX/ANCWkek/jr%2bi/IrfDv8A5E21/wB%2bT/0I1z/w6/5GbW/x/wDQzXQfDv8A5E21/wB%2bT/0I1z/w6/5GbW/x/wDQzTFH/lx/XQqa5b/bPjDYW2M%2bdd2kePXJQV9fV8pLD5/x70ZCpbF7avgf7O05/Svq2keVif40vVhRRRQYhRRRQB8%2bRn/hG/2p3DHZBqDHBxjd5sWR/wCRBivoOvAv2gbGbSfEPhvxdaAiWJhEWHGHjbzI/wCb/wDfNe56dfQ6nplrf2zboLqFJoz6qwBH6GgC1RRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcP8AGD/klGv/APXJP/RiV3FcP8YP%2bSUa/wD9ck/9GJQB538K/wDkQbL/AK6S/wDoZrs64z4V/wDIg2X/AF0l/wDQzXZ17tD%2bHH0EFFFFagS23/H1D/vj%2bdeiV53bf8fUP%2b%2bP516JXm4/eIwooorzwCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5/xP4fXWbTzYQBeRD5D/AHx/dP8AT/69eXyRvDI0ciFHU4ZWGCDXuFc34k8MR6whuLfbHeqOp6SD0Pv71Eo31PTwON9n%2b7qbfkeY0VLcW81pO0NxG0cqHBVhzUVQe6ndXQUUUUAFFFFABRRRQAUUUUAFFFFABWpoWiTa3fCJMrCvMsmPuj29/Sn6F4eutbn%2bQGO2U/PMRx9B6mvUNP0%2b20y0S1tU2xr37se5J7mqjG55%2bMxqpLkh8X5ElrbQ2drHbwIEijGFUVPRRWh4DbbuwooooEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcNrn/IZuf94fyFZ9aGuAjWbnPqP5Cs%2bvepfw4%2biEFFFFaAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAUda1JdI0S91FhuFvC0gU/wARA4H4nFeKfD7w9/wmPia61HViZ4ID50wb/lrIxOAfbgk/QDvXqfxCRpPAWrBFJIiBwPQMpP6VyfwVmjOnatCCPNWZHI9iCB/I1x1VzV4xewHqKqqKFUBVAwABwBS0UV2AeQ/FrwnBbIviCyjEZeTZdIo4JPR/z4P1HvXZ/DrXJNd8H20s7Fri3Y28jE8sVAwfrtK5/GovifPFD4A1BZMZlaNEBPVt6n%2bQJ/Csb4MRSL4bv5Dny3u8KMdwi5P6iuNJQxNo9UB6TRRRXYAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVpaB/yG7f/gX/AKCaza0tA/5Ddv8A8C/9BNZVv4cvRgdvRRRXhDCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACsS6mkuNbigikZQmA2049zWvNKIYXlIyFUmsjQ4mkkmu5OWY4B9%2bprelZRlNiZt0UUVgMKKKKACiiigAooooAKKKKACiiigAoqC4uEtYTLICVHHHWpVYMoYdCM1CqRcnC%2bqHZ2uOoooqxBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQByPj%2b58vSbe3B5llyfoo/wASKx59E1Lw5Hb6rp0jMojUzLj7pwMgjuufy/Wrfi7/AE/xRpunjlflBHpubn9AK7ogEYPSotds9JVnQowSV73bRj6F4gttbg%2bXEdyo%2beInke49RWzXE674Yms7j%2b1NE3RyIdzQx9R7r7eo/wD1Vp%2bHPFEOroLe42xXoH3egk919/amn0ZjVoRlH2tHWPVdUdHRRRVHGFFFFABRRRQAVyPin/kJx/8AXEf%2bhNXXVyPin/kJx/8AXEf%2bhNXXgv4oMxKKKK9cQUUUUAcR%2bzL/AMzT/wBun/tavoCvn/8AZl/5mn/t0/8Aa1fQFfOjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK8P8Aj74VlWCy8aaYGju7F0juXj4IXOY5PqrcZ/2h6V7hXKePdd8M6V4bvLTxLfRwwXkDxeSPmlkBBHyL1z79AccigCx4G8TR%2bL/B2n6wu0SyptnQfwyrww/MZHsRXR188fs5%2bIvJ1LVPDkjkxzL9rt88fMuFcY9SCp/4Ca%2bh6ACiiigAooooAK%2bcPjXoE3hTxvY%2bMdOjxBeOPOA4AmUcg/76/qGNfR9cx4/8Lp4v8F6hpO0Gdk8y2Y/wyryv0z0PsTQNNp3R82/E26ivrPQbqBt0UySuh9iIzXX%2bOP8AkTNS/wBxf/QlryCW4v8AULG00r7PLI1i0pVVQllDFcgj2I/Wuq1jxbrmsaTcafJoEkaTAAssbkjBB9PanY9KOKg/aN/aS/I6z4d/8iba/wC/J/6Ea5/4df8AIza3%2bP8A6Gaz9B8T65oOkx6fFoUsqxljvaNwTk59Ko6FdeJdN1G8m03RriWe76g2ztt5zwB/WgaxMF7L%2b7v9x1unKz/tCaSFBJ86M8egjya%2bpK%2bTvASaunxw0X%2b3EZL9pCzqwAIBhbbwOBxivrGkefWlzVJS7sKKKKDMKKKKAOI%2bLXh//hI/hxqtuibri3T7XB67o%2bSB7ldw/GsT4DeIv7Y%2bHy6fI%2bbjS5TAc9fLPzIfpyV/4DXqJAYEEZB7GvnbwUx%2bG/x4v/DbnZp2pMYoc9MN88J9yM7PqTQB9FUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXD/ABg/5JRr/wD1yT/0YldxXD/GD/klGv8A/XJP/RiUAed/Cv8A5EGy/wCukv8A6Ga7OuM%2bFf8AyINl/wBdJf8A0M12de7Q/hx9BBRRRWoEtt/x9Q/74/nXoled23/H1D/vj%2bdeiV5uP3iMKKKK88AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDL1bQ7LWYdlymJB92VeGX/AOt7V57rHhXUNJLPsNxbj/lrGOg9x2r1aik4pnXh8ZUoaLVdjw2ivVtS8K6VqRLtB5Mp/wCWkPyk/UdD%2bVcxeeALyMk2dzFMv918o39RUOLPXpZhRnu7PzOQorUuPDmsWx/eafOfdF3j/wAdzVF7S5jOHt5VPoyEVJ1xqQl8LuQ0U5Y3YkKjHHXA6VYi02%2bnI8myuJM/3Yif6UFOSW7KtFbtr4P1q5wTaiFT/FK4H6df0roLD4fwphr%2b7aQ90iGB%2bZ5/QU1FnNUxlCnvL7tThoYZbiZYoY2kkbgKoyTXZaL4GZis%2bqnavUQIeT/vEf0rsLHTLPTYvLtLdIgepA5P1PU1cqlDueZXzKc9Kei/Ejhhjt4lihRY41GFVRgAVJRRVnmBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAch4mgMepLLj5ZUHPuOP8Kxa7XXbE3unkoMyxfOvv6iuKr2MJUU6aXYQUUUV1AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAQ3drFe2c9pOu6KeNo3HqpGDXgVlc6j8M/G0iTRmSIfI69BPCTww9%2bMj3BHrX0HWP4h8MaZ4nshb6hDll/1cycPGfY/wBOlc9ek52lHdAP0XxHpPiC2WbTryOUkZaInEiexXqKt3%2bpWWl25uL66ht4h/FK4Gfp6149qPwc1i3mLaZfW1zGDlfMJjcfzH61Bb/CLxJdzA3lzaQr0LNKXbHsAP61n7astHDUCv428Vz%2bONYttM0mKV7RJNsKYw00h43Edhjp6DOetexeFtDTw74ctNNUhnjXMrj%2bJzyx/Pp7AVn%2bFfAmleFV82EG5vmGGuZRyPUKP4R%2bvvXUVdGlJNznuwCiiiukAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArb8MQF9QebHyxp%2bp/yaxK7bRLE2WnrvGJZPnb29BXLi6nLTa7gadFFFeOMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooprusaM7HCqMk0AOpqqFGFAA9hUcFxFcx74XDL/KpqGmtGAUUUUAFFFFABRRRQAUUUUAFFFFABRUck0UWPMkRM9NzAZpn2u2/5%2bYv%2b%2bxWbqwi7Nr7x2bK2sf8eB/3hV2H/Up/uis7VbiGSyKpNGzbhwrA1aiurcRIDcRA7R/GK4adWn9cm%2bZfDHr5s0afIi1RUH2u2/5%2bYv8AvsVIjpIu5GDL6g5rvjUhJ2i0zOzW4%2biiirEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVHLIsMTyOcKilj9BQBxFn/xMfiRPL1W3Lcf7o2fzru64fwHG091qN%2b/3mIXPqSST/Su4qY7HZjtKih/Kkgrk/EfhX7Wxv9N/dXincUU4Dn1Hoa6yim1cwpVZ0pc0TkfDnis3Eg07VP3V2p2K7DG8%2bh9Grrq53xF4Yh1lDNDtivQOH7P7N/jWToXiafTrj%2bytbDIyHasr9V9A3qPele2jOmdKFePtKO/Vf5HcUU1WDKCCCD0Ip1UcIUUUUAFcj4p/5Ccf/XEf%2bhNXXVyPin/kJx/9cR/6E1deC/igzEooor1xBRRRQBxH7Mv/ADNP/bp/7Wr6Ar5//Zl/5mn/ALdP/a1fQFfOjCiiigAooooAKKKKACiiigAooooAKKKKACiiigAqG5uoLK2kubqeOCCJS0ksrBVUDuSeAK53xn490TwNp/2jVJ91w4PkWkXMsp9h2HqTx%2bPFeCXd54y%2bM1%2bJJ3/s/QI3%2bWME%2bUvPYdZH9%2bg9s0DUXJ2R13jH46y3N0dG8C2z3VzIdgvWiLZP/TND1%2brfl3rntE%2bFt9rF6dX8Z381xcSHc0Hmlnb2d%2b30X867zw14R0jwtbeXp9uPOYYkuH5kf6nsPYcVu1Vjsp4dLWR47qENv4C%2bNWhX9lEltYTNFuVBhVVsxSfp83419P183fG6yLaTpWoKMGGdoiR1%2bZcj/wBAr33w3qX9seGNK1Mnm7tIpj9WQEj8zSZz1o8s2alFRSXMELBZZo4yeQGYCqUniHRIVLS6xp6KOMtcoP60jI0qKwpPGvhSFtsvifRUbrhr%2bIH/ANCqjJ8S/BMShm8T6aRnHyzhj%2bQoA6uiuJk%2bLvgKJiG8SWxIGfkjkYfotUpPjf8AD%2bMArrbyZ7LZzf1QUAeV%2bM7U/Dz43RapGvl6bqbec2Pu7XOJB%2bDfNj6V612ryn4x%2bPfB/jbQrVNLuJ5NRs590TPbsqtGww4yfop/4DXX/D3W/wC3fBdjO7bp4V%2bzzc87k4yfcjafxqkdeGlvE6eiiimdR5VITb/tI6PIvJkaPOe2Yyv8q%2bkq%2bYfFWp23h745aRq165W1hEMsrBSSq/MpOByfWvVv%2bF6%2bAf8AoKT/APgJJ/8AE1DPNq/Gz0iivN/%2bF6%2bAf%2bgpP/4CSf8AxNH/AAvXwD/0FJ//AAEk/wDiaCD0iivN/wDhevgH/oKT/wDgJJ/8TR/wvXwD/wBBSf8A8BJP/iaAPSK8O/aE8PSrbaV4vsQUubGQQTSJ1VSd0bfg2R/wMV1P/C9fAP8A0FJ//AST/wCJrN8QfFv4c%2bIvD9/o91qc/k3cLRE/Y5DtJ6N06g4P4UAd74P8QxeKvCem6zEVzcwgyqP4JBw6/gwNbtfPX7O3ioQ3moeFbiUFJM3VoexYcOoz6jDAf7LV9C0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXD/GD/AJJRr/8A1yT/ANGJXcVw/wAYP%2bSUa/8A9ck/9GJQB538K/8AkQbL/rpL/wChmuzrjPhX/wAiDZf9dJf/AEM12de7Q/hx9BBRRRWoEtt/x9Q/74/nXoled23/AB9Q/wC%2bP516JXm4/eIwooorzwCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACuU13Rmhdru2TMR5dR/CfX6V1dJ1rWlVlSlzIDzeius1Hw5FcEy2pEUh6r/Cf8K5%2b40u9tSfNt3wP4lGR%2bYr1qeIp1NmIp0UUVuAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRVy20q9uiPLt3wf4mGB%2bZrodO8Ow25ElywmkHRcfKP8awqYinTWr1ApaFoxdkvLlcIOY0P8R9T7V1NFFeTVqyqy5mMKKKKyAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArH1u6IVbSPl35bHp2FbFZcGmyDU3uZ3Vx1THr/8AWrWk4p80ugmW7G2FpaJF/FjLH1NWaKKzbbd2MKKKKQBRRRQAUUUUAFFFFABRRRQBXntILnb50e7b05IqL%2byrL/nj/wCPN/jV2isJ4WhOXNOCb80ilOS0TMfUrC2t7MyRR7WyBncTVmPS7NolYw8kAn5j/jSax/x4H/eFXYf9Sn%2b6K4IYTDvFzjyK1l0XdmjnLkTuVf7Ksv8Anj/483%2bNWIYY4IxHGu1R2qWivQp4ajTfNCCT8kkZuUnuwooorYkKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArI8TXH2Xw5euOrR%2bWP%2bBHb/WteuR8f3Pl6Tb24PMsuT9FH%2bJFJ7G%2bGhz1ox8yz4Ht/J8OrIes8rP8AgPl/9lrpaoaNbfZNFs4MYKRLuHvjn9c1foWxNefPVlLzCiiimZBWRrmgW2t22JAI7hR%2b7mA5HsfUVr1RvdX0/Tl/0q7jiP8AdJy35Dmh%2bZpSc1JOnucdpms33he9/svV1ZrYfcfrtHYqe6%2b3/wCqu7hmjniWWJw8bjKsp4Irg/EPifTtWtjaQ2Mlw2f3crfKVPqo5J/SpvCNtr9lKFNsVsHOXWc7ce6jrn8MGoT1sd%2bIoc9P2slyy7dzuqKKKs8wK5HxT/yE4/8AriP/AEJq66uR8U/8hOP/AK4j/wBCauvBfxQZiUUUV64gooooA4j9mX/maf8At0/9rV9AV8//ALMv/M0/9un/ALWr6Ar50YUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV5b8S/jBZeERJpWkCO91w/KV6x23%2b/jq3oo/HHQ4PxL%2bMEpum8MeC3ae/lbypb2D5tpPGyLHVv9rt255Gf4F%2bG0OiFNV1nFzqzHeFY7lgJ5/4E3v8Al600jSnTc3oY3hr4fal4l1E%2bI/Gs800s53i3lPzv6b/7q%2bij9OleswwxW8KQwRpHEgCoiDAUDsBT6Ko7oQUFZBRRRQWcX8VrUXPw%2bvnxloHjlX/vsA/oxryvQPBNz4g0OG7/ALZaKGTcphMZbbtYj%2b8B2Br2rxtD9o8D60npZyP/AN8jd/SvPfhjL5nhV1/553Lr%2bin%2btJip0oVK/LNdDh/FfhAeF4bV/t32kzsw/wBVs24x/tH1rqYPhbYPHG76jckMoJCqo7U74rAf2Zp5x0mbn/gNdvpx3aXaNnOYUOfX5RU3NqeFpe2nBrRWPI9D8LWWoeMNQ0a6muFht/N8toyAzbXAGcgjoSa6q/8Ahxo1vpl3NAbppkgdo98gxuCkjPA71Q0b9x8XNQTO3zPM4PfIDV6S6q6MjDKsMEUNjw2HpyhK61u0eWeAvDWj67pdzJf27STxTYBEjL8pUYGB75q5448H6Vpfh43umWnkyRSr5h8x2yhyP4ie5Wk%2bFzm3vdXsnPzLsP8A3yWB/mK7fxDZf2h4ev7UDLSQttH%2b0BkfqBR1FRowqYX4VezOd8N%2bHNA1bwtZXD6dCZJItruM53DKk/XINM%2bEN9JpXiLV/Dly2CcugP8AfQ4bH1Bz/wABpnwuvfO0K5tCctbzbgPRWHH6hqoeIpP%2bEX%2bJWma6uVhlZXkI9B8kg/75P601uZVIx9jCtFbbnu1FAIIBB4oqgPFPinbRSfEvRBPGGgmhhWQf3h5rAj8iK3v%2bEH8Nf9AqP/vt/wDGsj4yD7P4l0C86YU85wflcHr/AMCrt6hmuDhCUp8yvseS6Boemz/EHVNMurVZLVPN8qMsRtw4xjnJ4yK7S88E%2bHlsp2i0tBII2KkO3XHHeuasv9G%2bMtxHyPM3dfeLdXpLoJI2QnhgRxQXhaUJRknFaNo8t%2bHehaTrNnfNqFos8kUihSzMMAg%2bh9qi%2bIegafoj6dLp9qsUcm8SKGJBI2kdT7mtH4TOTHqycYBhP57/APCtD4pW/meHbacDJiuQD9Crf1AoMFTjLBc1tf8AgmsngrwzJGsi6XGVYAg736H8a4SPRNOsfiW2lXdqr2MzERoWIA3LlcHOevFel%2bHp/tXhvTZs5LW0e4%2b%2b0A/rmuI%2bJcD2Oq6TrUIw6Hbn0ZG3L/M/lQbYmnBU1UjFaWexH4isT4D8TaR4i0SIRRRSglNxI3jqDnsy5H519VaVqdrrWk2mp2T77a6iWaM%2bxGeff1FeFazp8PiXw1JCmCLiISQMezYyp/z71pfs%2beKXlsL7wlfOVuLFjNbI/XYTh1/4Cxz/AMCPpQcOOoqnPmjsz3Ciiig4QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArh/jB/ySjX/APrkn/oxK7iuH%2bMH/JKNf/65J/6MSgDzv4V/8iDZf9dJf/QzXZ1xnwr/AORBsv8ArpL/AOhmuzr3aH8OPoIKKKK1Altv%2bPqH/fH869Erzu2/4%2bof98fzr0SvNx%2b8RhRRRXngFFFFABRRRQAUUUUAFFFFABRRRQAUUVBPdQ25AlcKT0yKmc4wXNN2Q0m9ieiqg1KzJ/14/I1Il1byfcmjJ9NwrOOJoydozT%2baG4yW6J6KKK2JCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKz7rWLS2yu/zH/upz%2bvSgai5OyNCiuZn8QXL5ESJGPU/MapSaleyH5rmT/gJx/KnY3WHm9zs6K4c3E5OTNIT7saVbu5T7txKPo5osV9Wfc7eiuRi1i%2biI/fbx6OM/8A160bfxEpIFxEV/2k/wADRYiWHmjdoqGC6gul3QyK49uo/CpqRg1bcKKKKACiiigAooooAKKKKACiiigBjRRv9%2bNW%2bozTfs8H/PGP/vkVLRTuwIvs8H/PGP8A75FH2eD/AJ4x/wDfIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/wDvkVLRRd9wIvs8H/PGP/vkUfZ4P%2beMf/fIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf88Y/%2b%2bRR9ng/54x/98ipaKLvuBF9ng/54x/8AfIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf8APGP/AL5FH2eD/njH/wB8ipaKLvuBF9ng/wCeMf8A3yKPs8H/ADxj/wC%2bRUtFF33Ai%2bzwf88Y/wDvkUfZ4P8AnjH/AN8ipaKLvuBF9ng/54x/98ij7PB/zxj/AO%2bRUtFF33Ai%2bzwf88Y/%2b%2bRR9ng/54x/98ipaKLvuBF9ng/54x/98ij7PB/zxj/75FS0UXfcCL7PB/zxj/75FH2eD/njH/3yKloou%2b4EX2eD/njH/wB8ij7PB/zxj/75FS0UXfcCL7PB/wA8Y/8AvkUfZ4P%2beMf/AHyKloou%2b4EX2eD/AJ4x/wDfIo%2bzwf8APGP/AL5FS0UXfcCL7PB/zxj/AO%2bRR9ng/wCeMf8A3yKloou%2b4EX2eD/njH/3yKYtlbK7OIIwzdTtFWKKOZ9wIvs8H/PGP/vkUfZ4P%2beMf/fIplxeQWrIsr4LHgVY60/eSuwIvs8H/PGP/vkUfZ4P%2beMf/fIqWild9wIvs8H/ADxj/wC%2bRR9ng/54x/8AfIqWii77gRfZ4P8AnjH/AN8ij7PB/wA8Y/8AvkVLRRd9wIvs8H/PGP8A75FH2eD/AJ4x/wDfIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/wDvkVLRRd9wIvs8H/PGP/vkUfZ4P%2beMf/fIqWii77gRfZ4P%2beMf/fIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf88Y/%2b%2bRR9ng/54x/98ipaKLvuBF9ng/54x/8AfIo%2bzwf88Y/%2b%2bRUtFF33Ai%2bzwf8APGP/AL5FH2eD/njH/wB8ipaKLvuBF9ng/wCeMf8A3yKPs8H/ADxj/wC%2bRUtFF33Ai%2bzwf88Y/wDvkUfZ4P8AnjH/AN8ipaKLvuBF9ng/54x/98inLFGn3I1X6DFPoouwCiiikAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVm6rf/ZYfLjP75%2bmP4R61UIuUuVAaVFVbAXAtE%2b0tmQ889QO2ferVJqzsAUUUUgCiiigAooooAKKKKACiiigAooooAKKKKAK93bC6tzEW25IOQKmVdqBR2GKdRUKnFTc0tXp9w7u1goooqxBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXCeL/wDT/E%2bm6eDlflB9tzc/oBXd154b22b4gz3d3MkcFuzDLHuq7ePx5qZHbgU%2beU10TPQ6K5C98e2cRKWNvJcN0DN8i/4/pVDzfF2vfcVrOBu4/dD8z8xo5kTHBVLXnaK8zsrzU7HT1zd3UUXHRm5P0HU1zV94%2btkYx2FrJO2cBn%2bUH6Dqf0pLLwFCD5mo3bzOeSsfA/Enk/pXSWWkafpy/wCi2kcR/vAZb8zzRqyv9lp95v7kch/xV2vetnA3/bIf/FGrll4Bt1PmX91JO55Kp8oz7nqf0rsaKOVEyxtS1qaUV5FOz0yx09cWlrFFx1VeT9T1NXKKKo5XJyd2wooooEFcj4p/5Ccf/XEf%2bhNXXVyPin/kJx/9cR/6E1deC/igzEooor1xBRRRQBxH7Mv/ADNP/bp/7Wr6Ar5//Zl/5mn/ALdP/a1fQFfOjCiiigAooooAKKKKACiiigAooooAQ8fSvAfiZ8VbzXtQbwf4LZphKTDcXUJ5lPdIz2Xrlu/PbkyfFf4l3WtX7%2bCfCJkmkkcw3dxCeZD3jU/3f7zexHTOb/gXwLa%2bEbHzJNk2qTL%2b%2bnA4Uf3F9v5/kKaRpSpub8hngbwDaeErUTy7Z9VlXEs2OE/2U9vU9/0rsqKKo9CMVFWQUUUUDCiiigDO1%2bMy%2bHNUjABL2kq4PfKGvJvhW4Oi30fPFxn81H%2bFev6opbSL1VBLGBwAO/ymvG/hSwOn6incSoT%2bIP8AhSZVH/eI/Mn%2bKin%2bwLNscC6AJ/4C1dbojBtA01gcg2sRB/4CK5j4oqW8LwEfw3aE/wDfLj%2btdD4bYP4X0oj/AJ9Ih%2bSgVJ1Q/wB5l6I4kf6P8aSOQrnv3zB/jXpVea6t%2b4%2bL1i/TzPL5PfKla9KoYYXRzX95nmvhf/Qfifq9seBL5wUf8DDD9K9KrzW6/wBB%2bMcMnRZyv47o9v8AOvSqGGE0Uo9mzzPwd/xJ/iBqmlHiOTeqD12ncv8A47mtr4lad9r8NC6VcvaSB8/7J%2bU/qR%2bVYvij/iTfEvTtSB2xzmNnb2%2b43/juK9D1GzXUNNubN8bZ4mjye2RjNBlShzU6lHs3/wAA0vAOrf2z4J0y5Zt0qReTJzzuT5cn3IAP410leTfBTUWSPVtEmJDxOJ0U9v4X/UL%2bdes1Zy03eKZ5L8coN1jo1x/cklT/AL6Cn/2WuntJvtFnBNnPmRq%2bfXIzWb8aLfzfBkEoHMN4jE%2bxVh/Min%2bGJ/tHhfS5Op%2bzIp9yBg/yqWdGDdqsl3SOJ1D/AEf4x2sn/PTZ0PrHtr0uvNPF3%2bj/ABN0SY/dbyMkjp%2b8IP6V6XSN8NpKovM81%2bGf7vWtahP3hjp04Zh/Wul8fW/2jwbfYGWj2SD8GGf0zXNeAv3XjbXIAcAeZ8p68SY/rXc%2bILf7V4d1KHGS9tIB9dpx%2btIzw8ebCuPqZXw/n8/wbZAnLRl0P4McfoRSfECw%2b3eEblgMvbFZ1/Dg/wDjpNZnwsn3%2bH7qAnmO5LfQFR/UGu1uYEurWa3lGY5UZGHsRg0GtJe1wyj3Rz3gG/8At/hG1BbL25MDe23p/wCOlawNemufA3xB07xVYqTG8m%2bRBwGPR1P%2b8p/PPpUPw0u/sOoarpNw6qVO8ZPGVO1v5j8q63xPa2Gt6Hc2D3Vus2N8W6RRtcdO/wCH0JpmHKq%2bFSe6/NHv2n39tqmnW1/ZyCS2uYllicd1YZFWq8Q/Z78XG70u68KXkn7%2byzNahjyYifmX/gLHP/Avavb6DxAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArh/jB/wAko1//AK5J/wCjEruK4f4wf8ko1/8A65J/6MSgDzv4V/8AIg2X/XSX/wBDNdnXGfCv/kQbL/rpL/6Ga7Ovdofw4%2bggooorUCW2/wCPqH/fH869Erzu2/4%2bof8AfH869ErzcfvEYUUUV54BRRRQAUUUUAFFFFABRRRQAUUUUAFV7izhuiplXO3pg4qxRUVKcKkeWauhptaooHSLM/8ALNh/wI1E%2biQH7kkin35rUorlll2EkrOmvy/ItVZrqYhsb%2bz5t5d6jsD/AEPFTW2r5fyrpfLbpuxx%2bPpWrVS7sortPmGHHRh1Fc0sDVw/vYST/wAL1T/yK9opaTXzLQIIyDS1jadcSW1wbK49cKfQ/wCFbNdmExMcRT5krNaNdmROHK7BRRRXUQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVXuruGzi8yVsegHU/SmX17HZQGR%2bWPCr6muTubmW6mMsrZJ7dgPSmkbUqLnq9i1fatPeEqCY4v7qnr9az6KKZ3RioqyCiiimMKKKKACiiigB8cjwuHjYqw6EGt7T9dD4iu8K3aQdD9fSueopETpxmtTvOopa5nStWa3ZYJ2zCeAx/h/%2btXSggjI6VJwVKbg7MWiiiggKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAKWpWQvbcgYEq8of6VU0i%2bLf6JPkSJwue4Hatis%2b50yOe7S4DFCDltvf0raE04uE9hGhRRRWIwooooAKKKKACiiigAooooAKKKKACiiigAoqOSaKL/WSImf7zAUqOki7kYMvqDmgLPcfRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAEcrmOJnVC5UZCjqaxtOtZL26a9uRkA/KCOp/wFbtFaRqcsWl1FYKKKKzGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFcbbeBI5Jnn1G7aR3YsyQjAyTnqeT%2bQrsqKTVzWnXqUr8jtcoWOjadpo/wBEtI42/v4y35nmr9FFMzlJyd5O4UUUUCCiiigAooooAKKKKACuR8U/8hOP/riP/Qmrrq5HxT/yE4/%2buI/9CauvBfxQZiUUUV64gooooA4b9nBxbar4osD9/bAeevyNID/6FX0FXzX4Fux4R%2bPt1ZTHZb6oZIVJ6fvCJEx/wIBfxr6Ur5%2bUeWTQwoooqQCiiigAooooAKKKKACvFfjF8TZbN28H%2bG3aTVLjEdzNDy0Qbjy0x/Ge/oD6njofi38SU8E6P9isJFbXLxD5K9fIToZCP5A9T6gGuC%2bGngd9OT/hIdZVn1S5y8ay8tEG5LHP8Zzz6fiaaRdODm7Gn8PvAkPhWx%2b1XapJq06/vHHPlKf4F/qe/wCFdtRRVHoxioqyCiiigYUUUUAFFFFAFe/cR6ddO2dqwuTj2Br518HReLmt7p/DdsZYi6iYgIcEA4%2b99a%2bhdZYJoeoOxwq20hJ9BtNec/BBSNE1RscG5UA/8B/%2bvSMp39pGzscxq2h/EfW7MWl9pjyQhw%2bB5S8jPcH3qe00/wCJtjZw2tvpzLDCoRARCcAdOc17nRRYrklfm5nf1Pn668MfEG81iDVZ9KdruHbscGIAYORxnFanlfFP/nwP/fMP%2bNe20UWBQkrtSevmfP154Y%2bIN9q8GqT6XIbuDbscGMfdORwDg1qeV8U/%2bfA/98w/417bRRYFCSbak9fM%2bftZ8MfEDXvJOoaU8hhzsK%2bUuM4z0PsK1BD8UwAPsDceqw/417bRRYFCSbak7vzPAvCEmqeHPinbLrUDW1xflklU4%2bbzM7Txx98Cvfa8i%2bM1pJZ6homvwcSxMYi3oVO9P/Zq9WsrqO%2bsbe7iOY541lT6MMj%2bdBFLRuJzPxNtTdfD3VFA%2baNUkHttdSf0zXlfhXwn4v8AEGhpc6VraW1mjtGkbXciYIPPCqfX9a9v8Q2n27w1qloBkzWkqD6lTj9a4L4JXfmeHtRs85MN0JMegZQP/ZDRYJr94jAm%2bEfi%2b7uI5rvWrKaROFke5mdl5zwSnrVn/hVXjD/oZo//AAIm/wAK9loosV7KJ4unwY1pJDMuvQLK/wB51D5OeuT1PNS/8KY1aUZn8SKW6f6tm4/FhXsdFFkL2MDxtPgbP91/EKKh67bUnn6bxT/%2bFFf9TH/5I/8A2yvYaKLIPYU%2bx5L/AMKMtv8AoPS/%2bAw/%2bKqRPgdYBfn1q5ZvVYVA/ma9Woosg9jT7HhmqaHdfCTxTo2v6bPJdW6ud28bcn%2bKM47MpOPx9K%2bpdM1G21fS7XUbOTzLa5iWWJvVWGR%2bNeaeKtAi8S%2bHLvTZAod13Quf4JByp/Pr7E1hfAPxXLF9u8E6mzJc2jvJao55ABxJH%2bB%2bbHu3pSaOWtT5Hpse50UUUjEKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArhPjJKkXwn10ucApGo%2bplQCu7rxf8AaL11bTwtp%2biRt%2b%2bvrjzXUf8APOMf1Zl/75NAGZ8LVK/D%2bxJHDPKR/wB/GH9K7KsnwvpraR4X02xcYkigUOPRzy36k1rV71JcsEn2EFFFFaAS23/H1D/vj%2bdeiV53bf8AH1D/AL4/nXolebj94jCiiivPAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDI1mEhY7lOGU4JH6Vo20wuLaOUfxDn696WeJZ4HibowxWXo8xjkktJOGBJA9%2b4ryn/s%2bOv9mov/Jl/mjb4qfobNFFFeqYhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUVXuL61sxm5uIov8AfcA00m9EBYornbrxlpcGRD5tw3%2bwuB%2bZxWYfFOsagdunadgf3gpcj8eBW8cLVerVvUdjtapXWr6fZZ%2b0XcSEdV3Zb8hzXLf2L4k1Pm9vDEh6qZP/AGVeKkm8I2Om6dPdXM8s7RRlgB8qk44Hr196tUaSdpTu/ILG3p/iGz1S%2ba2tFlfahdpGXC44H17%2bla9cl4Gtdlnc3RHMjhB9Bz/X9K62ssRCMKjjHZAwooorEQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFRzSpDE0khwqjJqSue8QXhLraIeB8z%2b57ChF04c8rGXe3b3ty0r9Oir/dFV6KkgiM86RKQC5ABNWeikoojorZ/wCEduP%2be0X6/wCFH/CO3H/PaL9f8KVyPbQ7mNRWz/wjtx/z2i/X/Cj/AIR24/57Rfr/AIUXD20O5jUVs/8ACO3H/PaL9f8ACj/hHbj/AJ7Rfr/hRcPbQ7mNRWz/AMI7cf8APaL9f8KP%2bEduP%2be0X6/4UXD20O5jUVs/8I7cf89ov1/wpD4euFUnzouPrRcPbQ7mPXQaHqBb/RJW5H%2brJ/lXP05HaN1dThlOQfQ0DqQU42Z3dFV7O5W7tY5l/iHI9D3qxUnnNWdmFFFFAgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKhiuYp2dY5AxQ4bHapSARg9Kwby0l024F3aZ8vuPT2PtWlOCno3r0EzfoqrZXsd7DuXhh95fSrVQ04uzGFFFFIAooooAKKKKACiiigCOaaOCF5pXCRoCzMegFcLda/q3iK8az0VHhgHVx8rEepb%2bEfSrfjm9ldrTSLckvOQzqP4ucKPzz%2bQro9H0qHSNPjtogN2MyOBy7dzU7ux3U1ChSVWSvJ7f5nLw%2bAGk/eXmos0h5OxM/qev5VHN4K1HTyZ9K1AtIOdvMbH2znB/HFd5RRyon6/Xvq7rtZHH6D4qme7/szWV8q5B2rIy7cn0Ydj712Fcp400ZLvTm1CJcXFuMsR/EnfP06/nWl4Y1NtU0OGaQ5lTMch9SO/4jBoXYK8ITpqtTVujXZmzRRRVHGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUANd1jQu5CqBkk9qyrfUp7zUtsCA26/e3Dt6//WqK/F3fXv2RUKRLzk9CPU1q2trHaQiOMe5J6k1vaMI3erf4CJ6KKKwGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXI%2bKf%2bQnH/ANcR/wChNXXVyPin/kJx/wDXEf8AoTV14L%2bKDMSiiivXEFFFFAHmvxY0GZ7e18SWIZbmxIEjJ1CZyrf8Bb/0L2r2b4deNbfxx4Ut9QVlW9jAivIQeUkA5OP7rdR%2bXY1gSxRzwvFKivG6lXRhkMDwQRXkc0WtfCDxWNc0VWn0ec7ZImY7WU/8s39CP4W/%2buK8zGUHf2kfmM%2bqKK5rwf440Xxvpou9KuR5qqPPtXOJYT6EenuODXS1wAFFFFABRRRQAVz3jPxbY%2bC/Ddxq96QxUbIIQcGaQ9FH9fQA1uTzxWtvLcTyLHDEheR2OAqgZJJ9AK%2bY9Z1K8%2bM3xE8uJpIvD9hwnbbHnlj/ALbkceg9cGhDSbdkSeB9BvvG3iKfxr4kJmVpS0KMOJHHAwD/AALjAHt7V7BUVrbQ2drFbW0SxQRKERFHCqOABUtWejTgoKwUUUUFhRRRQAUUUUAFFFFAGT4pl8nwjrMvHy2MxGe52HFcX8FI9vhG9kOctfMPwCJ/ia6b4gTfZ/AWsv6wbP8Avohf61j/AAgh8rwFE/8Az1uJH/Xb/wCy0GT/AIq9DvKKKKDUKKKKACiiigAooooA434p6b/aPgK9KjL2rLcKP904b/x1mpfhfqX9o%2bArHc2Xti1u3/AT8v8A46VrqdQtE1DTbqyk%2b5cQvE30YEH%2bdeWfBS7eFta0eb5XikWUL6HlX/ktBk9Kifc9b7V478Kv%2bJT468QaIcqAGABPXy5No/RjXsVeOXJGg/H2KT7sN6y8evmJt/8AQ6AqaOL8z2Oiiig1CiiigAooooAKKKKACvIfiNY3fhLxdpvjbSBsbzl80DgeYPX2dcg/j6169WfrmkW%2bvaLdaZdD91cJtz3U9Qw9wcGgipDnjY7rw/rdp4j0Gy1exbdb3cQkUZyVPdT7g5B9xWnXz78EPElx4d8SX/gPWG2FpWa13HhZR95R7Mo3D6f7VfQVQeaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRVW/1Gz0qxlvb%2b6itrWEbpJZWCqo%2btAD7y7t7Czmu7qVYbeBDJJI5wFUDJJr5ijvJ/ip8V5dZlRhpNiV8pG6CNSdi/VjliP96rfjz4gap8UdWXw14XjlXRw2ZHYFfPwfvv/djHYH2zzgDuPDXh208MaNHp9qNxHzSykYMj92P9BXVhaDnLmeyA2KKKK9gQUUUUAS23/H1D/vj%2bdeiV53bf8fUP%2b%2bP516JXm4/eIwooorzwCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKxtTge3uFvYeCD831rZprKHUqwyDwQa5cZhliKXJez3T7MuE%2bV3IbW6S6hDoef4h6GrFY0umz20plsnP%2b7nkf40g1O9i4mtskd9pFccMxlRXJi4tNdUrplulzawZtUVinVbuQYjtfp8pNG3Vrngkxr9dv/wBeq/tWnLSlCUvRf5i9i1u0jUmuYbcZlkVfbv8AlWbLrDO3l2kRZj0JGf0p0WioDunlZz6DitGKCKBdsUaqPYUrY7Eb2px%2b9/5B%2b7j5mba2d49ylzcS4K/w9T9PQVr0UV24bDQw8XGLbvq23e5EpOT1CiiiugkKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigCtfXa2NnJcNFJIqDJWMZOPWuUl8aXVzJ5Wnafuc9N2XJ/AV2lcZruhTabc/2vpOU2Hc8a/w%2bpA9PUf0rqw3sm7TWvTsNDPsnizVB%2b9mNtGexYJ%2bi8/nVi38DRbt95eSSMeojGP1Oc1raFrsOsW/ZLlB%2b8j/AKj2rYp1MRVg3BLl9AuZdr4e0qzwY7ONm/vSfOf1rTACgBQAB0ApaK5pSlLWTuIK5rxrd%2bTo6wA/NPIAR/sjk/riulrifEf/ABM/FNlpw5VNoYem45b/AMdxW2FinVTey1GjpNBtPsWiWsJGG2Bm%2bp5P860qTpS1hKTlJyfUQUUUUgCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBjuscbOxwqjJ%2blcTPK087yt95yTXU6zL5WmS46thfz6/pXJVSOzDR0bCrWnf8hG3/AOugqrVrTv8AkI2//XQUHRL4WdLNeQ/bDZTZUuoKtnGc9s9jWJqNveWL5FxM0J%2b6288expfEH/ISH/XMfzNTadqqSR/ZL3DIRtDN/I/40HNCLjFSWvcyvtVz/wA/Ev8A32aPtVz/AM/Ev/fZq5qelPZsZI8tAT17r7H/ABrNpnRFxkrom%2b1XP/PxL/32aPtVz/z8S/8AfZqGigdkTfarn/n4l/77NH2q5/5%2bJf8Avs1DW1pulKE%2b13mFjA3BG/maRM3GKux2mWlzMBcXM8qwjkAuRu9/pWpb30d59oEQ%2bSPgN69awtT1VrsmKHKwD82%2bvtVzw/8A8e91%2bH8jSZz1INxc5GBRRRVHWbnh24w8tuTwRvX69/6V0Ncbpkvk6lA3q20/jxXZVLOHERtO/cKKKKRgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABSEBgQRkHsaWigClbabDa3LzR5%2bbgL2WrtFNZtqlsE4GcAU5ScndgOorNs9WiuZTFIPKfPygnr/APXrSpyhKLtJAFFFFSAUUUUAFFFFAHC6vj/hYlj5n3cx7c/jj9a7quL8c2UqNa6vBnfAQjEfw85U/nn8xXSaRqkOr6dHdREZIw691buKlbnbiFz0ac1slY0KKKKo4ipqWz%2by7zzPueQ%2b76bTXNfD7d/Zl3n7vncfXaM/0qbxprMdppzWETg3FwMMAeVTv%2bfT860PC%2bmtpmhwxSLtmkzJIPQnt%2bWBU9TtS5MK7/aenyNqiiiqOIKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiqt3exWce6Q/MfuoOpppNuyAtUVg2wvNTu1uGcxRIflx/Ietb1XUhyO19RJhRRRWYwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooqjq2q2ei6dLf30ojgjH4sewA7k04xcnZbgXqjeWOLG%2bRVz03HFeRy%2bIvF3jy9kt9BjexsFOGdW2YH%2b3J1z7L%2bvWrUXwdlmBkvtcJnbltkO7n/eLZP5V6DwNOn/vFRRfZK7%2bdi%2bRL4meqghhkHIPpS15HL8PPE/h3Nz4f1gzFeTGhMTN/wABJKt%2bJrY8IfER769Gj6/ELXUAdiyFdgdv7rA/db%2bftUzwN4OpQkppb9GvkDhpdO56JRRRXAQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXI%2bKf8AkJx/9cR/6E1ddXI%2bKf8AkJx/9cR/6E1deC/igzEooor1xBRRRQAVHcW8N1byQXESSwyDa6OMhh6EVJRQB5dq/wAMr/S9QGr%2bDdQktblDuWHzSjL7I/p7N%2bdXrD43%2bMvDDLa%2bK9CF2Aceaym3kb33AFG/AD616HTXRJEKSKrKeCrDINcdTBQk7x0AybX9ozwpKo%2b06dq0D98Rxuv57wf0qz/w0N4L/wCeWq/%2bA6//ABdV5/Cvh%2b4bdLomns3dvsyAn8QKi/4Qzw1/0A7D/vwtc/1CXcLl3/hobwX/AM8tV/8AAdf/AIuj/hobwX/zy1X/AMB1/wDi6pf8IZ4a/wCgHYf9%2bFo/4Qzw1/0A7D/vwtH1CfcLnIfFP4z2finQE0Xw8t1FBO2bySdAjMo6IME8E8n6AdzVTwd4%2b8IeFNAisUjvnuG%2be4lEA%2bdz1/i6DoP/AK9d1/whnhr/AKAdh/34Wj/hDPDX/QDsP%2b/C0/qM%2b5cKjg7oxP8Ahc3hf/nnqH/flf8A4qj/AIXN4X/556h/35X/AOKrb/4Qzw1/0A7D/vwtH/CGeGv%2bgHYf9%2bFo%2boz7mv1mZif8Lm8L/wDPPUP%2b/K//ABVH/C5vC/8Azz1D/vyv/wAVW3/whnhr/oB2H/fhaP8AhDPDX/QDsP8AvwtH1GfcPrMzE/4XN4X/AOeeof8Aflf/AIqj/hc3hf8A556h/wB%2bV/8Aiq2/%2bEM8Nf8AQDsP%2b/C0f8IZ4a/6Adh/34Wj6jPuH1mZif8AC5vC/wDzz1D/AL8r/wDFUf8AC5vC/wDzz1D/AL8r/wDFVt/8IZ4a/wCgHYf9%2bFo/4Qzw1/0A7D/vwtH1GfcPrMzE/wCFzeF/%2beeof9%2bV/wDiqP8Ahc3hf/nnqH/flf8A4qtv/hDPDX/QDsP%2b/C0f8IZ4a/6Adh/34Wj6jPuH1mZwXjn4maL4g8J3Wl6el2Jp2TmWMKMKwY85PpU3g34meHvD/hOw0u5S9M0CtvKRAjLOzcHd712//CGeGv8AoB2H/fhaP%2bEM8Nf9AOw/78LR9Rn3RPt5c3MYn/C5vC//ADz1D/vyv/xVH/C5vC//ADz1D/vyv/xVbf8Awhnhr/oB2H/fhaP%2bEM8Nf9AOw/78LR9Rn3K%2bszMT/hc3hf8A556h/wB%2bV/8AiqP%2bFzeF/wDnnqH/AH5X/wCKrb/4Qzw1/wBAOw/78LR/whnhr/oB2H/fhaPqM%2b4fWZmJ/wALm8L/APPPUP8Avyv/AMVR/wALm8L/APPPUP8Avyv/AMVW3/whnhr/AKAdh/34Wj/hDPDX/QDsP%2b/C0fUZ9w%2bszMT/AIXN4X/556h/35X/AOKo/wCFzeF/%2beeof9%2bV/wDiq2/%2bEM8Nf9AOw/78LR/whnhr/oB2H/fhaPqM%2b4fWZmJ/wubwv/zz1D/vyv8A8VXn%2bgeMdM0T4kajrSLcf2bdmXKqg3gOQw4zj7w9a9b/AOEM8Nf9AOw/78LR/wAIZ4a/6Adh/wB%2bFo%2boz7kuvJtN9DE/4XN4X/556h/35X/4qvP/AB74x0zXtf0rV9IW4We0AD%2bcgX7rblxgnuWr1v8A4Qzw1/0A7D/vwtH/AAhnhr/oB2H/AH4Wj6jPuEq8pKzMT/hc3hf/AJ56h/35X/4qj/hc3hf/AJ56h/35X/4qtv8A4Qzw1/0A7D/vwtH/AAhnhr/oB2H/AH4Wj6jPuV9ZmYn/AAubwv8A889Q/wC/K/8AxVH/AAubwv8A889Q/wC/K/8AxVbf/CGeGv8AoB2H/fhaP%2bEM8Nf9AOw/78LR9Rn3D6zMxP8Ahc3hf/nnqH/flf8A4qj/AIXN4X/556h/35X/AOKrb/4Qzw1/0A7D/vwtH/CGeGv%2bgHYf9%2bFo%2boz7h9ZmYn/C5vC//PPUP%2b/K/wDxVH/C5vC//PPUP%2b/K/wDxVbf/AAhnhr/oB2H/AH4Wj/hDPDX/AEA7D/vwtH1GfcPrMzE/4XN4X/556h/35X/4qj/hc3hf/nnqH/flf/iq2/8AhDPDX/QDsP8AvwtH/CGeGv8AoB2H/fhaPqM%2b4fWZnkfjnxXo%2bsa5Ya7oDXdvqUDAuzxhclTlGBBPI6fl6V7Bp/7Q/hZ9Otmv7bUY7wxL56RQKyB8fNtJbOM5xUf/AAhnhr/oB2H/AH4Wj/hDPDX/AEA7D/vwtH1GfcxlLmd2Xf8AhobwX/zy1X/wHX/4uj/hobwX/wA8tV/8B1/%2bLql/whnhr/oB2H/fhaP%2bEM8Nf9AOw/78LS%2boT7k3Lv8Aw0N4L/55ar/4Dr/8XR/w0N4L/wCeWq/%2bA6//ABdUv%2bEM8Nf9AOw/78LR/wAIZ4a/6Adh/wB%2bFo%2boT7hcu/8ADQ3gv/nlqv8A4Dr/APF0f8NDeC/%2beWq/%2bA6//F1S/wCEM8Nf9AOw/wC/C0f8IZ4a/wCgHYf9%2bFo%2boT7hcu/8NDeC/wDnlqv/AIDr/wDF0f8ADQ3gv/nlqv8A4Dr/APF1S/4Qzw1/0A7D/vwtH/CGeGv%2bgHYf9%2bFo%2boT7hcu/8NDeC/8Anlqv/gOv/wAXR/w0N4L/AOeWq/8AgOv/AMXVL/hDPDX/AEA7D/vwtH/CGeGv%2bgHYf9%2bFo%2boT7hcu/wDDQ3gv/nlqv/gOv/xdH/DQ3gv/AJ5ar/4Dr/8AF1S/4Qzw1/0A7D/vwtH/AAhnhr/oB2H/AH4Wj6hPuFy7/wANDeC/%2beWq/wDgOv8A8XTJf2iPBqJlbXV5D/dW3QfzcVV/4Qzw1/0A7D/vwtKng/w2jBhoWnE%2b9up/Qij6hLuFzF1P9ou6u2%2bzeG/DbPO3CPdOXP8A37Tr/wB9VzUnhvxz8Q7xLvxZqEttaA7khfjb/uxDhT2yefrXqdtZ2tkmy1toYE/uxRhR%2blT1tDAxWsncDL0Lw7pnhyxFpptuI1PLu3LyH1Y9/wDOK1KKK7UklZAFFFFMAooooAltv%2bPqH/fH869Erzu2/wCPqH/fH869ErzcfvEYUUUV54BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcZruhTabcf2tpOU2Hc8afw%2bpA9PUf0rb0LXYdYt%2byXKD95H/Ue1bFcZruhTabcf2tpOU2Hc8afw%2bpA9PUf0rrhONaPJPfo/0Y9zs6Kx9C12HWLfslyg/eR/1HtWxXNOEoS5ZbiE6VxXhz/iZ%2bKb3UTyqbip9Nxwv/jua6TXrv7Fol1MDhthVfqeB/OszwVaeTo7TkfNPISD/sjgfrmuil7tGc%2b%2bn%2bY%2bh0tFFFcogooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAMXxG2LWFfV8/kP/r1zldD4jB8q3Pbcf6Vz1UtjvofAgq1p3/IRt/%2bugqrVrTv%2bQjb/wDXQUGsvhZb8Qf8hIf9cx/M1lVq%2bIP%2bQkP%2buY/mayqETS%2bBGxpmrCNRbXfzRHgM3OPY%2b1M1PSTbjz7f5oDyQOdv/wBasqtXTNWNriGfLQHgd9v/ANagiUHF80PuMqlrZ1LSAB9pshvjbkovP4j2qaysIdOh%2b2XpG8chT/D/AImi43Wjy3QzT9MjtY/tl9hdvKq3b3PvVLUtTe%2bfYuVhB4X19zTNQ1GS%2bl5ysQPyp/U%2b9UqAhB35p7hW/wCH/wDj3uvw/kawK3/D/wDx73X4fyNDCv8AAzAooopmo5GKOrDqDmu7rgq7tRtRQewqWcuK6DqKKKRyBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGdf6VHd5kjwk3r2b61Bp1zeJc/Y7iNm2jO49h9e4rYorVVXy8stRWCiioDdwLceQ0gEmM4NZpN7DJ6KKKQBRRRQBFNDHcQvDKgeNxtZT0IrhrrQtX8OXjXeiu81ueqAbiB6Ff4vqP0rvqKTVzejXlSulqnumcPD8QCg2XenMJB1KPjn6EcfnTJ/Gt/fkwaTp7CQ/xf6xh74AwPxzXbSW8MpBkijcj%2b8oNOSNI12oqqvooxSs%2b5r7fDrVU9fXQ5HQfCs/2wanrL%2bZcFt6xsd2D6sf6V2NFFNKxhWrTqy5pBRRRTMgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoqvdXkFom6V8Hso6mqdhqM15dOPJ2wgcMOx9zVqnJxcugXNSsx9ISW%2beeWRnQ8hD/j6Vp0UozlH4QEVQqgKAAOgHalooqQCiua1vx1oGhFo7i8E1wvWC3%2bdwfQ9h%2bJFcBqvxf1CYlNLsYbZP%2bekx8x/rjgD9a7aGX4itrGOnd6FqEmeyVVudQsrMf6VeQQf9dZQv86%2bddQ8Wa/qZP2rVrplPVFcoh/4CuB%2blY5JZiSSSTyT3r0qeRS%2b3P7kWqPdn0fL4x8Nw/e1uxPP8Ewb%2bWaj/AOE58Mf9Bm1/M1850V0LIqPWT/Ar2KPpCLxl4bm%2b7rdiO3zyhf54rTttQsrwf6LeQT/9cpQ38q%2bXKUEggg4I6EVMsih9mb%2b7/hhexXc%2brKK%2ba7DxZr%2bmEfZNWukA6Iz71H/AWyP0rr9K%2bL%2bpQMqanZQ3Kd3iPlv9e4P6VxVclrw1g1L%2bv66kulJbHstFczonjvQNdKxwXgguG6QXHyN%2bHY/ga6avKqUp03yzVmZtNbhRRRUCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACvIfFk1z418fweHLaQrZ2r7ZCOgIGXc%2b4%2b6Pf6169Xk3wtAuvFWu30uDMQeT1%2bdyT/IV6OA/dxqV%2bsVp6vS5cNLs9O07TrbSrCGys4ligiXaqj%2bZ9T6mrdFFee227sgK4D4l%2bFItT0qTWLWMLf2i73KjmSMdc%2b4HI%2bhFd/TJI0mjaORQyOCrA9weta4evKhUVSPQcW07nL/D/wAQP4g8MRSTtuurY%2bRMx6sQBhvxBH45rq68p%2bD5aO81y3DExr5ZGfUFxXq1bZhSjSxMox2/z1HNWkFFFFcZIUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyPin/kJx/9cR/6E1ddXI%2bKf%2bQnH/1xH/oTV14L%2bKDMSiiivXEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRXI%2bN/HNv4TtViiVZ9SmXMcJPCj%2b83t7d68sgtfGvxBkebfPNbEnLSP5cC%2bwHQ/gCfWuepiFGXLFXYHv6yI%2bdjq2ODg5xTq8Hm%2bFXivT1FxatbSyqMgW05Vx/30F/nVvw38SNY8P6iNN8Riae3VtjmZT50Pvnqw%2bvPofWFirO1SNgPbaKjt7iK6t47iCRZIZFDo6nIYHoRUldYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBLbf8fUP%2b%2bP516JXndt/x9Q/74/nXolebj94jCiiivPAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA4zXdCm024/tbScpsO540/h9SB6eo/pW3oWuw6xb9kuUH7yP%2bo9q2K4vXtEm0y6GraUCiqdzon8HqQPT1H9OnXCSrr2c9%2bj/Rj3J/HN0VtLW0XrI5cgeg4/r%2bldHp9qLLTre2GP3cYU49e/61w8F2/iTxPYvJGFEYXco6fLlj%2bZr0KjEJ04RpPfdgwooorkEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBkeIU3WCMP4ZB%2bWDXM12Wow%2bfp80YHO3I%2bo5rjapHbhneFgq1p3/IRt/wDroKq1a07/AJCNv/10FBvL4WW/EH/ISH/XMfzNZVaviD/kJD/rmP5msqhE0vgQUUUUyzR07VJLE7Gy8J6r3H0qC9vpb6bfIcKPuoOgqrRSJUIqXNbUKKKKZQVv%2bH/%2bPe6/D%2bRrArf8P/8AHvdfh/I0mZV/gZgUUUUzUkgTzbiOP%2b8wH5mu5rk9Fh87U0OOIwWP9P1rrKlnHiX7yQUUUUjmCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArNvtJiuiZEOyU9%2bx%2btaVFVGcou8QMBLu%2b0tglyhki7En%2bRrcik8yJXCldwzg9RSsqupVlDKeoIzTqqc1PW1mJBRUVxMtvA8r/dUZ%2btVrfVbW4wN/lt/dfj9alQk1dIZeoooqQCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoqtcX1ta582Ubv7o5P5Vlyaxc3LmOyhI/2iMn/AVpClOWqWgrm7UVwsrQOIW2yEfKfeiDzDAhlGJMfMPepajZjMW20Vnfzb1y7HkqD/ADNbCIsaBEUKo6ACnUVU6kp7isFFHSvMPGfxOS0aTT9AkSSYfLJd/eVPZOxPv0%2bvbTD4apiJ8lNf8AqMXJ2R1/iPxhpXhmH/AEubfckZS2i5dvc%2bg9z%2bteP%2bIviFrWvs0SSmysz0hgYgkf7TdT%2bg9q5aaeW5meaeV5ZXO5ndslj6k1HX1OEyujQ1fvS7/wCR0xppBRUkMEtzMsMETyyscKkalmJ9gK7jRfhTrWoBZb949PiPOH%2beT/vkcfma7K2IpUVepKxTklucHRXu2mfC3w5YhWuIpr2Qd5nwuf8AdXH65rqbPR9N04AWWn2tv7xRKp/MCvKqZ5Rj8EW/wM3WXQ%2ba4dK1G4GYLC6lGM/JCzfyFWf%2bEa13Zv8A7E1LZ13fZXx%2beK%2bmaK5nns%2bkF95Ptn2Pl6bStRtxmewuoh6vCy/zFU6%2brao3mk6dqAIvLC1uM/8APWJWP6irhn380Px/4A1W7o%2bYKK931L4XeHL7LQQzWUh5zBJxn6NkfliuF1r4U61p6tLYPHqEQ/hT5JAP908H8DXoUc1w1XS9n5/1YtVIs4Kus8PfEHW9AKRGX7ZZr/ywnJOB/st1H6j2rl57ea1neC4ieKVDhkdSpB9wajrtqUqdaPLNXRTSe59GeG/GWk%2bJosWk3l3QGXtpeHH09R7iuhr5Vhmlt5kmhkeOVDuV0OCp9Qa9a8GfE5blo9O191SU/LHd9Fb2f0Pv09cV85jcolTvOjqu3X/gmE6VtUeoUUgIIyOlLXiGQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXkOhTf8ACJ/Fi%2bsLk7Le9dkRj0%2bc74z/AOy/jXr1cV8QPBp8SWSXdkANStgdmePNTrtz656fj68d2BqwjKVOo7RmrenZlwa2fU7WivMPC3xKW3UaX4mElvcw/J9odDzjs46g%2b%2bPrivQ7fVdPvI/Mtr62mT%2b9HKrD9DWNfC1aErTXz6CcWty5WP4m1iPQfD15fuwDIhEQ/vOeFH5/1qHV/GWg6LEzXWowtIBxDCwdz%2bA6fjivNZZdY%2bKeupHHG9ro1u/J6hB3JP8AE5HQdvzNb4XBym/aVdILdv8AJDjG%2br2Og%2bEGmPb6Le6jIuPtcoRM91TPP5sR%2bFekVWsbKDTrGCztU8uCFAiL6AVZrnxVf29aVTuKTu7hRRRWBIUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVyPin/AJCcf/XEf%2bhNXXVyXikf8TGJuxiA/U11YP8AigzDooor2BBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABSMwRS7HCqMknsKWq2oRvNpt1Egy7wuqj1JBApMDwfSLWT4hfESSS6ZvIkdp5QDysKkAKP/HV/GvfYIIrWBIII0jhjUKiIMBQOgArxP4OTxxeK7qJzh5bRgme5DKSPyz%2bVe4VyYNJwcurAK4T4n%2bF4NX0CbVIowL6xQybwOXjHLKfoMkfT3ru6zPEdzFaeGdUnmx5aWsmQe/ykAfieK6KsVKDTA4b4O61JdaRd6TM%2bfsjB4s/3GzkfgR/49XpleM/BaF21fVJxny0gVG9Ms2R/6Ca9mrPCtukrgFFFFdABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAEtt/x9Q/74/nXoleeWilryBR3kUfrXodebj94jCiiivPAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKQgEYNLRQBkWOgW2n6vNe2/yrIm0R44Uk5OPyrXooqpTlJ3kwCiiipAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArjdStfsl9JGBhCdy/Q12VZetWX2q28xBmWLkY7juKaNqE%2bWWvU5arWnf8AIRt/%2bugqrT4pWhlSRMblORmqO6SurGzrNlc3F8HihZ12AZH41n/2Xff8%2bz1P/b19/eT/AL5o/t6%2b/vJ/3zS1MoqrFW0IP7Lvv%2bfZ6P7Lvv8An2ep/wC3r7%2b8n/fNH9vX395P%2b%2baNR3q9kQf2Xff8%2bz0f2Xff8%2bz1P/b19/eT/vmj%2b3r7%2b8n/AHzRqF6vZEH9l33/AD7PR/Zd9/z7PU/9vX395P8Avmj%2b3r7%2b8n/fNGoXq9kQf2Xff8%2bz1r6NbTW0FyJo2QtjGe/BrP8A7evv7yf980HXb0ggsnP%2bzRqTONSSs7GZRRVmxtGvLpYhnb1Y%2bgpm7aSuzc0C18q1adhhpTx9BWxTURY0VFGFUYA9BTqg8ycuaTYUUUUEhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFACEBgQRkHsaz7jRrWfJQGJv8AZ6flWjRVRnKLvFgZFnYXtpdKPP3W/OQD/Q1r0UU5zc3dgNd0QZdgoPHJxTutVL6yW9iEbOy4ORj1rN/su/tj/o1zkegJX9OlOEIyXxWYrm7RWbp76gZWS8XCgcEgcn6itKplHldhhRUFxdwWu3zn27unBNNXULN%2blzH%2bLY/nQoyavYCzRTElST7jq3%2b6c0%2bpAKKKKACiiigAoqGa5ht8ebKqZ6ZPWqr6zZJ0lLf7qmqjCUtkFzQoqpZ6hFelxGrDZjO7vmrdJxcXZgFV5ry2tx%2b9mRT6ZyfyqtqNlcXcieVPsjxhhuOPyqGHQYEwZZHkPoOBWkY07XlIWpftbuK7jLxEkA45GKsVDBbw2ybYYwoPp3qas5Wv7uwzPk0m2mumnk3HdztzgVdiijiXbGiqvoBin0U3OTVmwCiiipAKKKKAPM/itrWsWNtDZWsTw6fcDElyh5c/88/YY/P8DXj1fUWoafa6pYy2V7CstvKMMrf54PvXgvi/wZeeGNQAQPPYzNiCYDnP91sfxfz7dwPpcnxdLk9ja0vz/wCCb0pK1jl67Xwp8OdR19Uu7stZaeeQ7D55B/sj09z%2btdX4I%2bG0dqsep67EHuDhorVuVj93Hc%2b3QfXp6YSFGSQAKnHZvyt06G/f/IJ1eiMnRPDeleHrfytOtVjYjDSty7/Vv6dK0p7iG1haa4ljhiUZZ5GCqPqTXAeKPilZaaXtdGVL25HBmJ/dIfbH3vw4968n1bXtU1yfzdRvJZznKqThF%2bijgVx0MrxGJftKrsn33JVNy1Z7LqvxS8PaeWS3eW/lHGIFwuf944/TNcjffGHVJCRY6dawL6ylpD%2bmB%2bleb0V7NLKcLT3V/U1VOKOtn%2bJfiuYnGpLED2jgQfqQT%2btQf8LB8Vf9BiX/AL9p/wDE1zNFdSwmHW0F9yK5V2Otg%2bJfiuEjOpLKB2kgQ/qAD%2btbVj8YdUiIF9p9rcKO8ZaNj/MfpXnFFRPAYae8F%2bX5CcIvoe66V8UvD%2boFUuWmsZD/AM9lyv8A30M/riuzt7iC7hWa3mjmib7rxsGU/QivletHSdd1PQ7jztOvJIDnLKDlW%2bqng15uIyOD1ouz89v6%2b8zlSXQ%2bhta8OaV4gg8rUbRJCBhZBw6fRuteP%2bK/hvqGgq93ZFr2wHJZR%2b8jH%2b0B29x%2bldh4X%2bKdnqBS11pUs7k8Cdf9U31/u/jx716KCGUEEEEdu9edCvisvnyS27dPkQnKDsfKdFexeNvhrHerJqWhRLHdfektVwFl917A%2b3Q/z4Lwn4NvvEuptCVe3tYGxczMuCh/ugH%2bL%2bXevoaOYUKtJ1b2S38jdTTVzuPhTres3iS6fPE0%2bnW64S4Y/wCqPZM/xD27fTFeoVT0zTLTSLCKysoRFBGMKo/mT3NXK%2bSxdaNas5wjZM5pO7uFFFFc5IUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAGHrnhLRfEIzf2atMBgTxna4/EdfxzXHTfBuxaQmDV7lE7CSJXP5jH8q9NorqpY3EUVywm0ilOS2Z59p3wl0O1kWS8nubwj%2bBiEQ/UDn9a7m0tLextkt7WCOGFBhUjXAH4VYorOtiatb%2bJJsTk3uFFFFYiCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArnPFMBMVvOB90lD%2bPI/ka6Oq19are2UsDfxDg%2bh7GtaM%2bSopAef0U6SNoZWjcFXU4I9DTa9zcQUUUUwCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPBvGOj33gfxkmsaeCtvLMZ7eQD5VY8tGfzPHcH616d4b%2bIGi%2bIbdAbmO0vcfPbzuFOf9knhh9Ofauh1DTrPVbKSzvrdJ7eQYZHH6j0PvXmGsfBkNK0mjaiqIekN0D8v/Ah/hXG6dSlJumrp9APTrrVdOsoTNdX1tDGBktJKAP51478QfHo8RbdF0bzHsy48yQKcztnhQOuM4PqTj05SH4M660gE2oacid2RnY/kVH8677wr8OtJ8MyLdEteX46TyqAE/3F7fXk0pe2re7blQEnw%2b8MN4Z8OLHcKBe3LebOP7vHC/gP1JrrKKK64RUIqKAKKKKoAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDR0OAz6vAMcId59sdP1xXcVh%2bG7AwWpuZFw8v3c9l/8Ar/4VuV4%2bLqc9TToMKKKK5QCiiigAooqG4uIbWB5p5FjjQZZmOAKASvoiaiuIvfGd1eXBtdDtGkY9JGQsT7he34/pUa6F4r1H57vUTAD1UzEfovFTzdjsWDcVerJR9d/uO7orhT4P1yH5oNY%2bb/ro6/qKjbUPFWgHdeRm5th1ZgHGP94cj8aOYawkZaU5pv7jvqKxdF8S2WsrsQmK5AyYXPP4HvW1VbnLOEoS5ZKzCiiiggKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5nWNMMEhuIV/dN94D%2bE/4VkV3bKroVYBlIwQa5rU9Ha2JmtwWh6le6/wD1qpM7KNa/uyMmiiimdIUUUUAFFFFABRRRQAUUVJDDJPKI4lLMewoDYaiPLIqIpZmOABXW6bYLY24XgyNy7f0pmm6Wlku98NOerensK0als4q1Xm0WwUUUUjnCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGOyohdyFVRkk9AKZb3EV1Cs0EiyRt0ZTkGo9S/wCQVef9cH/9BNZfg/8A5FqD/ef/ANCNBoqd6Tn52N6iiigzCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAK9zZwXYXzk3benJGKptoVo33TIv0atSirjUnHRMLFKx05LFpGR2beB96rtFFTKTk7sChqNlJeeX5c3llM5984/wql/Ylw33rv9Cf61uUVpGtOKshWKGn6e9k0habzN2O3Sr9FFRKTk7sZVu7GG8Kebu%2bTOMHHWo00myT/lgD/vEmr1FCnNKyYWI44IoRiKNEz/dXFSUUVN77gFFFFABRRRQAUUUUAFFFFABRRRQAUx40kADorAEMNwzgjoafRQBBd3dvY2kt1dSrFBEu53Y4AFeIeM/iFdeIHeysC9tpnQjo83%2b97e3517ZqFha6pYy2V5CstvKNro3f/A%2b9eB%2bMfB114WvsjdLYSn9zPj/x1vRv5/nj2cmjh3UfP8XTt/w5rStfU5iipbe3mu7iO3t4nlmkO1EQZLH0Ar1jwt8KYYlju/EB82XqLRG%2bVf8AeI6/QcfWvoMTjKWGjeo/l1NpSUdzzPStC1TW5fL02xmuCDgsowq/VjwPxNdzpvwe1CZQ%2bpahBbA/wRKZG%2bhPA/nXr0FvDawLDbxJFEgwqRqFUD2AqvqGr6dpUe%2b/vYLZTyPNkCk/Qd68CrnOIqPloq34sxdWT2OMtvhFoEQHn3F9O3fMiqP0Gf1q7/wq3wt5e37LPn%2b957Z/w/Sm3fxS8MWxIjuLi5x/zxhP/s2Kp/8AC4PD/wDz56n/AN%2bo/wD4us/%2bFKevvfkL94xbn4R%2bH5smGe%2bgbtiRWH6jP61zupfB7UIgW07UYLgddkymNvoDyP5V1tr8U/DFwwEk9xbZ/wCe0J/9lzXT6frGm6rHvsL63uQByI5ASPqOo/Gl9bzDD6zvbzQc047nzlqugarokvl6jYzQc4DsMo30YcH86za%2bqJ7eG6gaG4iSWJxhkkUMpHuDXm3in4VQTq93oBEM3U2jn5G/3Sfun2PH0r0sLnUJvlrLlffp/wAA0jVT3PIK7XwZ8QLvw9Ilnel7nTCcbSctD7r7e35Yrj7m2ns7mS3uYnhmjO10cYKn3Fb3hDwhd%2bKr/Ym6KyiI8%2bfHT/ZHq1elilRnRbrfD/WxcrW1PoKyvbbULOK6tJkmglGUkU8EVKkaR7tiKu47mwMZPrVbTNMtNI0%2bKxsoRFBEMKo/Uk9yauV8PK13y7HIFFFFIAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKimuILcZmmjiB7uwH865fxX4obTG%2bw2RH2kjLv18sHpgev%2be9efTTy3ErSzSPJI3VnbJP4mpcrHo4bL5VY88nZHs8N3bXBIhuIpSOoRw38qnrw5XaNw6MVYcgg4IruPCviyWWdNP1GTeX4imbrn0b1%2btCkPEZbKnHmg7nc0UUVR5oUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAYeuaP8Aax9ptx%2b/UfMo/jH%2bNcmQVJBBBHUGvSKzNR0W2v8A5%2bY5v76jr9R3rtw%2bK5Fyz2A4mitO50G/tySsXnL/AHo%2bf061nPG8Zw6Mp9GGK9KNSM/hdxDaKKKsAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKACTgAk%2b1XINKvrk4jtnx6sNo/M1MpKO7Ap1saLo7XkizzqRbqe/8fsPatGw8NRxESXbCVv7i/d/H1reACgAAADoBXBXxity0/vAUAKMAYApaKK84YUUUUAFFFFADJJEijaSRgqKCzMegArz%2baW88a6z5ELNFp0JzkjoP7x9WPYdvzrX8dai1tpkdlGcPct82P7o6/mcfrWt4e0tdJ0iKDbiVhvlPqx6/l0qXq7HdStQpe2%2b09F/mWNN0u00m2ENpEFH8TfxMfUmr1FFUcUpOTu3qFIQCMEZBpaKBHGeIvCoQHU9IBinjO9oo%2bM47r6H2/wAnT8L6%2bNZsikxAu4QBIB/EOzD%2bv/166CvP9Tj/AOEZ8YQXsQ22twdzAdME4cf1/Kpemp30pfWYOlP4ls/0PQKKTqM0tUcAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAZN9okNwTJCRFJ6fwn/CsG5sbm0P76Ihf7w5B/Gu0pCARg8inc2hXlHR6nB0V182k2U/JhCt6px/9aqL%2bHIj/q7h1H%2b0uf8ACnc6FiIPc56itw%2bHJO1yv4r/APXpy%2bGzn5rkfgn/ANei6K9vT7mDSgFiAAST2Heuli8P2qYMjySexOBWhBaW9sMQxInuBz%2bdFyJYmK2OdtNDuJyGm/cp7/eP4V0FrZwWce2FMerHqfqas0UrnNOrKe4UUUUjMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKo6pYHUrP7P9olgywO6M4PHasX/hD/APqLXn5//XoNYQptXlK3yN7Uv%2bQVef8AXB//AEE1l%2bD/APkWoP8Aef8A9CNZ934T8mynl/tS7bZGzbSeDgZxVLQfDn9o6RFc/wBoXEO4sNiHgYOKDqVOl7Frn0uunqd3RXL/APCH/wDUWvPz/wDr1qaRpH9krKv2ye4EhB/en7uM9KDmnCmleM7v0NSiiigxCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKqahp9rqljLZXsKy28owyt/ng%2b9W6KabTugOY8L%2bCdN8LebJBunuZGP7%2bUDcqZ4Uenue/5AbepanZaRZPeX9wkECdWY9T6Adz7VcrxH4p2muR62Lm%2bkMumscWpQEJH6qR2b37/hgd2GpvG4i1Wf8Am/JFxXPLVkviT4qX9%2bzW%2biq1lbdPNODK/wDRfw5968/mnluZmmnleWVjlnkYsxPuTUdFfW0MNSoR5aasdKilsFFbmneDvEOqqHtNJuGQ8h5AI1P0LEA1r/8ACrvFOzd9khzn7vnrn/ClLF0IO0ppP1QcyXU4ynwzy28qywSvFIpyroxUg%2bxFbWoeDfEWloXutJuAg6vGBIB9SuQKwq0hUhUV4tNfeNNPY9C8OfFXUbBkg1hTfW3TzRxKv49G/Hn3r17TNVstYsUvLC4SeB%2bjL2PoR1B9jXy/Xd/C%2b21yTXvO06TyrBCBdtIMow/ugd29PT9D42ZZbR5HVh7rX3MynTVrnpninwXpvilI3nzBdRkAXEYG4rnlT6%2b3p/Pa0zTLTSLCKysoRFBGMKo/mT3NXKK%2bdlWqSgqbei6GF3awUUUVmIKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACkJCgk8AUtIQGBB5BoA8VvLl7y9muZD80rlj7ZNQVYvrV7K%2bntXB3ROV57471XrE%2bvjay5dgpQSrAg4IOQR2pKcqs7hEBLMcADuaBnsum3JvNMtblvvSxK5%2bpHNW6qadbGz0y1tjjdFEqH6gc1brY%2bRnbmdtgooooJCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAOE8Qj7X46063PKL5YI/4ESf0ru64TxEfsXjjTrpuEbyyT/wIg/pXd1K3Z2Yn%2bHTttYKKKKo4wooooAK5Hx/AH0i3nx80c%2b3PoCDn%2bQrrq5D4gThNJtoM/NJNu/BQc/zFKWx1YK/t42Oh0iYz6NYyk5ZoEJ%2bu0Zq9VLSYTb6PZQsMMkCAj3wM1dpowqW53YKKKKCAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAq6l/yCrz/rg/8A6Cay/B//ACLUH%2b8//oRrWvImnsZ4UxukjZRn1IxVLw/YTabo8NrPt81SxO05HJJoN1Jewcet1%2bpq0UUUGAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFVNQ0%2b11Sxlsr2FZbeUYZW/zwferdFNNp3QHheq/DHV7fxEljYIZ7OYlo7luFRe4f0I/Xt6V6T4a8BaR4dRZPKF1e9TcTLnB/2R0X%2bfvXV1FPPHa28lxM4SKJC7segUDJNd1fMcRXgqbf3dS3OTVh7MFUsxAAGSTWd/wkOi%2bd5P8Aa%2bn%2bbnGz7Sm78s14d4t8a3/iW8kRZXh04N%2b6t1OMjsX9T/KuWr0KGRuUb1ZWfYtUdNT6rVgyhlIIIyCK5jxJ4D0fxFG8jRC1vTyLmJcEn/aHRv5%2b9eReEvGl/wCGLxF3vNp7H97bk8Aeq%2bh/n3r6AtriK7tYrmBw8MqB0YfxKRkGuHEYatgKilGXo0RKLgzw/T/hlrM/iJtPvEMNpEQ0l2vKsv8AsepP6d69q0zTLTSLCKysoRFBGMKo/mT3NXKKyxeOq4mynsv6uKU3LcKKKK4yQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDlvFPhf%2b1f8ATLTat2owyngSAf1rzy5tbizlMVzC8Tj%2bF1xXtlMkjSVdsiK6%2bjDIqXG56GGzCdGPJJXR4nFFJPII4o3kc9FRck/hXdeF/CclrOmoaigWReYoeu0/3j7%2bgrsY4YoQRHGiZ67VAqShRsViMxnUjyxVkFFFFUeaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAHK%2bOdOa70pLyNcvasS2P7h6/rj9a0vDmqrq2kRSlszRjZKP9od/x61quiyoyOoZWGCD0Irz%2b7trzwZrH2y0UyWEpwVJ4x/dPoR2P/16l6O53UbV6XsX8S1X%2bR6HRWfpesWerweZaygsB80Z4ZfqK0Ko45RcXaSswooprMqKWYgKBkk9qCR1efX8n/CUeMYbaH57S3OCexUHLH8Tx%2bVWvEPig3ZOl6PuleX5GlTv7L/jW14Z0FdFsiZMNdS4MjDt6KKnfQ76cfq0HUn8T2X6m7RRRVHAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFct8RJXh8Bao0ZwxVFOPQyKD%2bhNdTVDWNNi1jR7vTpThLiMpuxnaex/A4Na0JqFWMpbJp/iNOzufMNFXNU0y60fUZrG9iMc8TYIPQjsR6g9qp195GSkrrY7Ar6B%2bG8sk3gPTjJklfMVSe6h2A/w/CvCNN0661bUIbGyiMk8zbVUfzPoB3r6T0TS49G0W006M5W3jCFv7x7n8Tk14meVI%2bzjT63uY1npY0KKKK%2bZMAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACo5oY54WilRXjYYZWGQRUlFAHF3/gl4Z/tWjXRgcHIjZiMfRuv5/nVddR8Y6d8ktm1yBwCYvM/VK7yip5ex2LGSatUSl67nC/8JN4nn%2bWHSNp7n7O5x%2buKjOieJtdYDUrnyIDztYjH/fK/wBa76ijl7j%2buKP8OCT%2b8yNG8PWWipmFS8xGGmf7x9h6CteiiqOSc5TfNJ3YUUUUEhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBj654a0rxFAI9RtVkZR8koO10%2bhH8ulcn/AMKe0Tzc/btQ2Z%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'/%3e%3c/defs%3e%3c/svg%3e";

var css_248z$w = ".t-welcome-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card {\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card .t-image-wrapper {\n    margin-bottom: 16px;\n  }\n}\n.t-welcome-card .t-image-wrapper img {\n  width: 100%;\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card .t-image-wrapper img {\n    height: auto !important;\n  }\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card .t-welcome-card-extracontent-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n.t-welcome-card .t-text-block {\n  margin-right: 16px;\n  width: 360px;\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card .t-text-block {\n    width: 100%;\n    margin-right: 0;\n    text-align: center;\n  }\n}\n.t-welcome-card .t-text-block .t-welcome-card-text {\n  margin: 0;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 47px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.2px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  height: fit-content;\n  word-break: unset;\n  -webkit-line-clamp: 2;\n}\n@media screen and (max-width: 768px) {\n  .t-welcome-card .t-text-block .t-welcome-card-text {\n    font-size: 24px;\n    line-height: 37px;\n  }\n}\n";
styleInject(css_248z$w);

const TWelcomeCard$1 = ({
  title,
  text,
  extraContent,
  img,
  imgHeight
}) => {
  const classNames = [`t-welcome-card`];
  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement("div", {
    className: "t-text-block"
  }, React.createElement(Wrapper$2, {
    mb: 2
  }, React.createElement(TText, {
    level: 3,
    textColor: "dark-30",
    rows: 1
  }, title)), React.createElement(Wrapper$2, {
    mb: 1
  }, React.createElement("p", {
    className: "t-welcome-card-text"
  }, text)), React.createElement("div", {
    className: "t-welcome-card-extracontent-wrapper"
  }, extraContent)), React.createElement("div", {
    className: 't-image-wrapper'
  }, React.createElement("img", {
    style: {
      height: imgHeight
    },
    src: img || img$1
  })));
};

var css_248z$x = ".t-loading {\n  text-align: center;\n}\n.t-loading.t-loading-fullscreen {\n  height: 100vh;\n}\n.t-loading.t-loading-overlay {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.5);\n  z-index: 10;\n}\n.t-loading.t-loading-overlay .t-loading-content {\n  position: absolute;\n  top: 50%;\n  margin-top: -20px;\n  width: 100%;\n}\n.t-loading .ant-spin-dot-item {\n  background-color: var(--primary-color, #f54e95);\n}\n";
styleInject(css_248z$x);

const TLoading = ({
  label,
  fullscreen = false,
  overlay = false
}) => {
  const classes = ['t-loading'];

  if (fullscreen) {
    classes.push('t-loading-fullscreen');
  }

  if (overlay) {
    classes.push('t-loading-overlay');
  }

  return React.createElement("div", {
    className: classes.join(' ')
  }, React.createElement("div", {
    className: "t-loading-content"
  }, React.createElement(_Spin, {
    tip: label
  })));
};

var css_248z$y = ".t-cardList-container {\n  border-radius: var(--border-radius, 8px);\n  border: 1px solid #f2f2f3;\n  box-shadow: 0 2px 4px rgba(119, 110, 171, 0.12);\n}\n.t-cardList-container .t-card-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f2f2f3;\n  border-top-left-radius: var(--border-radius, 8px);\n  border-top-right-radius: var(--border-radius, 8px);\n  padding: 16px 16px 16px 24px;\n}\n.t-cardList-container .t-card-title .t-card-title-text {\n  font-size: 20px;\n  color: var(--text-dark-100, #262626);\n  margin-right: 16px;\n}\n.t-cardList-container .t-card-title a {\n  font-size: 13px;\n  color: var(--text-dark-20, #d0d0d1);\n}\n.t-cardList-container .t-card-title a:hover {\n  color: var(--primary-color, #f54e95);\n}\n.t-cardList-container .t-card-table-footer {\n  padding: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n.t-cardList-container .ant-card {\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  border-bottom-left-radius: var(--border-radius, 8px);\n  border-bottom-right-radius: var(--border-radius, 8px);\n}\n.t-cardList-container .ant-card .t-card-fallback,\n.t-cardList-container .ant-card .t-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.t-cardList-container .t-cardListContainer {\n  background: #ffffff;\n}\n.t-cardList-container .t-cardListContainer .t-header {\n  border-bottom: 1px solid #f2f2f3;\n  padding: 32px 32px 17px 32px;\n  display: flex;\n  justify-content: space-between;\n}\n.t-cardList-container .t-cardListContainer .t-header .t-headerLeftPart {\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 767px) {\n  .t-cardList-container .t-cardListContainer .t-header .t-headerLeftPart {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n.t-cardList-container .t-cardListContainer .t-header .t-headerLeftPart .t-headerTitle {\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: var(--text-dark-100, #262626);\n  font-family: HelveticaNeue;\n  margin: 0 16px 0 0;\n}\n.t-cardList-container .t-cardListContainer .t-header .t-headerLeftPart .t-headerLink {\n  font-family: HelveticaNeue;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.2px;\n  color: var(--text-dark-20, #d0d0d1);\n  margin: 0;\n}\n.t-cardList-container .t-cardListContainer .t-header .t-headerRightPart {\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 767px) {\n  .t-cardList-container .t-cardListContainer .t-header .t-headerRightPart {\n    align-items: flex-end;\n  }\n}\n.t-cardList-container .t-cardListContainer .t-header .t-headerRightPart .t-events {\n  color: #ff6464;\n}\n.t-cardList-container .t-cardListContainer .t-content {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.t-cardList-container .t-tab-bar-container {\n  display: flex;\n  justify-content: center;\n  height: 20px;\n  align-items: center;\n  margin-top: 20px;\n}\n.cardHover:hover {\n  -webkit-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -moz-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  transition: all 0.3s ease-in-out;\n}\n";
styleInject(css_248z$y);

const TCardList = ({
  title,
  seeAllLink,
  height,
  loading = false,
  fallback,
  children,
  seeMoreLink,
  onItemClick,
  onHover
}) => {
  const classNames = ['t-cardList-container'];

  if (onHover) {
    classNames.push('cardHover');
  }

  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onItemClick
  }, title && React.createElement("div", {
    className: "t-card-title"
  }, React.createElement(TText, {
    rows: 1,
    level: 1,
    bold: true
  }, title), seeAllLink && React.createElement(TText, {
    level: 3,
    textColor: "dark-20"
  }, seeAllLink)), React.createElement(_Card, {
    style: {
      height: height || 'auto'
    },
    bodyStyle: {
      padding: '0px'
    }
  }, loading ? React.createElement(TLoading, null) : children ? children : React.createElement("div", {
    className: "t-card-fallback"
  }, fallback)), seeMoreLink && React.createElement("div", {
    className: "t-card-table-footer"
  }, seeMoreLink));
};

var css_248z$z = ".t-timViewerContainer {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  background: #fbfbfc;\n  border-radius: var(--border-radius, 8px);\n  width: 48px;\n  padding: 11px;\n}\n.t-timViewerContainer div {\n  width: 32px;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 109.8%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.3px;\n  color: #000000;\n  font-family: HelveticaNeue;\n}\n";
styleInject(css_248z$z);

const TDateViewer = ({
  date,
  moment
}) => {
  const month = moment(date).format('MMM D').toUpperCase();
  return React.createElement("div", {
    className: "t-timViewerContainer"
  }, React.createElement("div", null, React.createElement("span", null, month)));
};

var DateViewer = withLocalization(TDateViewer);

var css_248z$A = ".t-time-viewer-container {\n  min-width: 118px;\n}\n";
styleInject(css_248z$A);

const TTimeViewer = ({
  start,
  end,
  rows,
  fromNow = false,
  moment
}) => {
  if (fromNow) {
    const startDate = moment(start).fromNow();
    return React.createElement("div", {
      className: "t-time-viewer-container"
    }, React.createElement(TText, {
      title: moment(start).format('YYYY-MM-DD hh:mm'),
      level: 4
    }, startDate));
  }

  const startDate = moment(start).format('LT'); // const startDateDay = moment(start).format('MMMM D');

  const endDate = moment(end).format('LT');

  const timeShow = () => {
    if (!!start && !!end) {
      return `${startDate} - ${endDate}`;
    }

    return start || end;
  };

  return React.createElement("div", {
    className: "t-time-viewer-container"
  }, React.createElement(TText, {
    rows: rows,
    level: 4
  }, timeShow()));
};

var TimeViewer = withLocalization(TTimeViewer);

var css_248z$B = ".event-card-list .ant-card-body {\n  padding: 16px;\n}\n.t-calendarListItem {\n  display: flex;\n  border-bottom: 1px solid #eaeaeb;\n  padding: 16px;\n  justify-content: space-between;\n  border-right: 4px solid transparent;\n}\n.t-calendarListItem .t-timeAndEvents {\n  text-align: right;\n}\n.t-calendarListItem .t-infoContainer {\n  display: flex;\n  align-items: center;\n  width: 70%;\n}\n.t-calendarListItem .t-infoContainer .t-avatarGroup {\n  display: flex;\n  align-items: center;\n}\n.t-calendarListItem .t-infoContainer .t-avatarGroup p {\n  margin-left: 8px;\n  margin-top: 2px;\n}\n@media screen and (max-width: 390px) {\n  .t-calendarListItem .t-infoContainer .t-avatarGroup {\n    flex-direction: unset;\n    align-items: flex-start;\n    padding-bottom: 16px;\n  }\n}\n.t-calendarListItem .t-infoContainer .t-dateContainer {\n  margin-right: 17px;\n}\n.t-calendarListItem:hover {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n}\n";
styleInject(css_248z$B);

const TCalendarEventViewItem = ({
  title,
  eventStartDate,
  eventEndDate,
  attendees = [],
  meetingLinks,
  altLink,
  type = 'event',
  locale,
  onItemClick,
  onBook
}) => {
  var _a, _b, _c;

  const {
    translate
  } = useContext(ConfigContext);
  const link = !isEmpty(meetingLinks) && !!Object.values(meetingLinks)[0] && Object.values(meetingLinks)[0];
  return React.createElement("div", {
    className: "t-calendarListItem",
    onClick: onItemClick
  }, React.createElement("div", {
    className: "t-infoContainer"
  }, React.createElement("div", {
    className: "t-dateContainer"
  }, React.createElement(DateViewer, {
    locale: locale,
    date: eventStartDate
  })), React.createElement("div", {
    className: "t-titleAndImages"
  }, React.createElement(TText, {
    level: 2,
    rows: 1,
    bold: true,
    paddingBottom: 2
  }, title), attendees.length > 0 && React.createElement("div", {
    className: "t-avatarGroup"
  }, React.createElement(TAvatar, {
    src: (_a = attendees[0]) === null || _a === void 0 ? void 0 : _a.avatar,
    name: (_b = attendees[0]) === null || _b === void 0 ? void 0 : _b.name,
    size: "xs"
  }), React.createElement("div", {
    className: "t-avatar-text"
  }, React.createElement(TText, {
    level: 3
  }, (_c = attendees[0]) === null || _c === void 0 ? void 0 : _c.name))))), React.createElement("div", {
    className: "t-timeAndEvents"
  }, React.createElement(Wrapper$2, {
    mb: 2
  }, React.createElement(TimeViewer, {
    locale: locale,
    start: eventStartDate,
    end: eventEndDate
  })), type === 'booking' && React.createElement(TButton, {
    onClick: onBook
  }, translate('ui.book')), type !== 'booking' && React.createElement(PracticeActions, {
    trainingLink: link,
    practiceLink: altLink
  })));
};

const TCalendarCardList = ({
  title,
  seeAllLink,
  events = [],
  loading = false,
  height,
  fallback,
  onItemClick = () => {},
  onHover = false
}) => {
  return React.createElement(TCardList, {
    title: title,
    seeAllLink: seeAllLink,
    loading: loading,
    height: height,
    fallback: fallback,
    onHover: onHover
  }, events.map((item, index) => React.createElement(TCalendarEventViewItem, Object.assign({
    key: index
  }, item, {
    onItemClick: () => {
      onItemClick(item);
    }
  }))));
};

var css_248z$C = ".e-cardList-container {\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n.e-cardList-container .e-card-fallback {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.e-cardList-container .e-card-loading-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.e-cardList-container .e-card-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color-base, #e5e5e5);\n}\n.e-cardList-container .e-card-list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 16px 24px;\n}\n";
styleInject(css_248z$C);

const TCardList$1 = ({
  title,
  height,
  loading = false,
  fallback,
  children,
  viewAll,
  onItemClick,
  headerIcon
}) => {
  return React.createElement("div", {
    className: "e-cardList-container",
    onClick: onItemClick
  }, React.createElement("div", {
    className: "e-card-list-header"
  }, React.createElement(TText, {
    rows: 1,
    level: 1,
    bold: true
  }, title), React.createElement(Wrapper$2, {
    ml: 2
  }, React.createElement("img", {
    style: {
      width: '32px',
      height: '32px'
    },
    src: headerIcon
  }))), React.createElement("div", {
    className: "e-card-list-fallback-wrapper",
    style: {
      height: height || 'auto',
      overflow: 'auto'
    }
  }, loading ? React.createElement("div", {
    className: "e-card-loading-wrapper"
  }, React.createElement(TLoading, null)) : children ? children : React.createElement("div", {
    className: "e-card-fallback"
  }, fallback)), viewAll && React.createElement("div", {
    className: 'e-card-list-footer'
  }, viewAll));
};

var css_248z$D = "";
styleInject(css_248z$D);

const TTimeViewer$1 = ({
  start,
  end,
  rows,
  fromNow = false,
  moment
}) => {
  if (fromNow) {
    const startDate = moment(start).fromNow();
    return React.createElement("div", {
      className: "e-time-viewer-container"
    }, React.createElement(TText, {
      textColor: "dark-30",
      title: moment(start).format('YYYY-MM-DD hh:mm'),
      level: 4
    }, startDate));
  }

  const startDate = moment(start).format('LT'); // const startDateDay = moment(start).format('MMMM D');

  const endDate = moment(end).format('LT');

  const timeShow = () => {
    if (!!start && !!end) {
      return `${startDate} - ${endDate}`;
    }

    return start || end;
  };

  return React.createElement("div", null, React.createElement(TText, {
    textColor: "dark-30",
    rows: rows,
    level: 4
  }, timeShow()));
};

var TimeViewer$1 = withLocalization(TTimeViewer$1);

var css_248z$E = ".e-button-wrapper {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  margin-bottom: 1px;\n}\n.e-button-wrapper .ant-btn {\n  display: block;\n  margin-left: 8px;\n}\n";
styleInject(css_248z$E);

const PracticeActions$1 = ({
  trainingLink
}) => {
  const {
    translate
  } = useContext(ConfigContext);

  const handleClick = event => event.stopPropagation();

  return React.createElement("div", {
    className: "e-button-wrapper"
  }, !!trainingLink && React.createElement(TButton, {
    href: trainingLink,
    target: "_blank",
    onClick: handleClick
  }, translate('ui.join')));
};

var css_248z$F = ".e-calendarListItem {\n  display: flex;\n  padding: 24px;\n  justify-content: space-between;\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-titleAndImages {\n    margin-bottom: 8px;\n  }\n}\n.e-calendarListItem .e-timeAndEvents {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-timeAndEvents {\n    display: none;\n  }\n}\n.e-calendarListItem .e-infoContainer {\n  display: flex;\n  align-items: center;\n  width: 70%;\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-infoContainer {\n    display: flex;\n    width: 100%;\n    flex-direction: column-reverse;\n    align-items: initial;\n  }\n}\n.e-calendarListItem .e-infoContainer .e-dateContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-right: 17px;\n}\n.e-calendarListItem .e-infoContainer .e-dateContainer .e-border-left::before {\n  content: '';\n  display: inline-block;\n  margin-right: 6px;\n  width: 4px;\n  height: 100%;\n  border-radius: 50px;\n  background-color: var(--primary-color, #f54e95);\n}\n.e-calendarListItem .e-infoContainer .e-dateContainer .e-timeAndEvents-mobile {\n  display: none;\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-infoContainer .e-dateContainer .e-timeAndEvents-mobile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n  }\n}\n.e-calendarListItem .e-infoContainer .e-dateContainer .e-timeAndEvents-mobile .e-time-viewer-wrapper {\n  margin-bottom: 4px;\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-infoContainer .e-dateContainer .e-timeAndEvents-mobile .e-time-viewer-wrapper {\n    width: max-content;\n  }\n}\n@media screen and (max-width: 576px) {\n  .e-calendarListItem .e-infoContainer .e-dateContainer {\n    margin-bottom: 4px;\n  }\n}\n.e-calendarListItem:hover {\n  background: #fbfbfc;\n}\n";
styleInject(css_248z$F);

const TCalendarEventViewItem$1 = ({
  title,
  eventStartDate,
  eventEndDate,
  attendees = [],
  meetingLinks,
  type = 'event',
  locale,
  onItemClick,
  onBook
}) => {
  var _a, _b, _c;

  const {
    translate
  } = useContext(ConfigContext);
  const link = !isEmpty(meetingLinks) && !!Object.values(meetingLinks)[0] && Object.values(meetingLinks)[0];

  const TimeAndEvents = ({
    className = 'e-timeAndEvents'
  }) => {
    return React.createElement("div", {
      className: className
    }, React.createElement("div", {
      className: "e-time-viewer-wrapper"
    }, React.createElement(TimeViewer$1, {
      locale: locale,
      start: eventStartDate,
      end: eventEndDate,
      rows: 2
    })), type === 'booking' && React.createElement(Wrapper$2, {
      display: "flex",
      justifyContent: "flex-end"
    }, React.createElement(TButton, {
      onClick: onBook
    }, translate('ui.book'))), type !== 'booking' && React.createElement(PracticeActions$1, {
      trainingLink: link
    }));
  };

  return React.createElement("div", {
    className: "e-calendarListItem",
    onClick: onItemClick
  }, React.createElement("div", {
    className: "e-infoContainer"
  }, React.createElement("div", {
    className: "e-dateContainer"
  }, React.createElement("div", {
    className: "e-border-left"
  }), React.createElement(DateViewer, {
    locale: locale,
    date: eventStartDate
  }), React.createElement(TimeAndEvents, {
    className: "e-timeAndEvents-mobile"
  })), React.createElement("div", {
    className: "e-titleAndImages"
  }, React.createElement(TText, {
    level: 2,
    rows: 1,
    bold: true,
    paddingBottom: 2
  }, title), attendees.length > 0 && React.createElement("div", {
    className: "e-avatarGroup"
  }, React.createElement(TAvatar, {
    src: (_a = attendees[0]) === null || _a === void 0 ? void 0 : _a.avatar,
    name: (_b = attendees[0]) === null || _b === void 0 ? void 0 : _b.name,
    size: "xs",
    text: (_c = attendees[0]) === null || _c === void 0 ? void 0 : _c.name,
    textLevel: 3
  })))), React.createElement(TimeAndEvents, null));
};

const img$2 = "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M2.48389 25.3796L2.17017 27.2358V29.917C2.17017 31.0671 3.10229 32 4.25244 32H29.4517C30.6016 32 31.5347 31.0671 31.5347 29.917V26.1021L31.0955 25.1592L2.48389 25.3796ZM22.354 4.72949C23.2366 4.72949 23.9521 5.44531 23.9521 6.32788C23.9521 7.21045 23.2366 7.92603 22.354 7.92603C21.4714 7.92603 20.7556 7.21045 20.7556 6.32788C20.7556 5.44531 21.4714 4.72949 22.354 4.72949ZM11.3069 4.72949C12.1897 4.72949 12.9053 5.44531 12.9053 6.32788C12.9053 7.21045 12.1897 7.92603 11.3069 7.92603C10.4243 7.92603 9.70874 7.21045 9.70874 6.32788C9.70874 5.44531 10.4243 4.72949 11.3069 4.72949Z' fill='url(%23paint0_linear)'/%3e%3cpath d='M29.4517 2.63574H4.25244C3.10156 2.63574 2.17017 3.56787 2.17017 4.71802V25.8191C2.17017 26.9131 3.05542 27.801 4.14941 27.803C10.4517 27.8147 29.6272 27.7913 29.6272 27.7913C29.5991 27.7913 29.5715 27.7893 29.5437 27.7878C30.6541 27.7214 31.5347 26.801 31.5347 25.6736V4.71875C31.5347 3.5686 30.6025 2.63574 29.4517 2.63574ZM11.3069 7.92627C10.4243 7.92627 9.70874 7.21069 9.70874 6.32813C9.70874 5.44556 10.4243 4.72974 11.3069 4.72974C12.1897 4.72974 12.9053 5.44556 12.9053 6.32813C12.9053 7.21069 12.1897 7.92627 11.3069 7.92627ZM22.354 7.92627C21.4714 7.92627 20.7556 7.21069 20.7556 6.32813C20.7556 5.44556 21.4712 4.72974 22.354 4.72974C23.2366 4.72974 23.9521 5.44556 23.9521 6.32813C23.9521 7.21069 23.2366 7.92627 22.354 7.92627Z' fill='url(%23paint1_linear)'/%3e%3cpath d='M4.28809 27.7915H29.416C30.5859 27.7915 31.5344 26.843 31.5344 25.6733V25.5193L27.5039 21.4888C27.1162 21.0627 26.5574 20.7949 25.936 20.7949H2.16992V25.6733C2.16992 26.8433 3.11816 27.7915 4.28809 27.7915Z' fill='url(%23paint2_linear)'/%3e%3cpath d='M25.936 20.7949H2.24316C1.07349 20.7949 0.125 21.7432 0.125 22.9131V23.6694C0.125 25.9458 1.97046 27.7913 4.24683 27.7913H29.6267C28.7583 27.7913 28.0542 27.0872 28.0542 26.2187V22.9131C28.0542 21.7432 27.1057 20.7949 25.936 20.7949Z' fill='url(%23paint3_linear)'/%3e%3cpath d='M31.5347 25.6738V29.9172C31.5347 31.0674 30.6018 32.0002 29.4517 32.0002H6.42798L2.17017 27.7417C2.17017 27.5447 2.17285 27.3777 2.17847 27.2361C2.78589 27.5896 3.49316 27.7917 4.24658 27.7917H29.6272C29.6135 27.7917 29.5991 27.7917 29.5854 27.7905C29.5715 27.7893 29.5581 27.7878 29.5437 27.7874C30.6541 27.7214 31.5347 26.8003 31.5347 25.6738Z' fill='url(%23paint4_linear)'/%3e%3cpath d='M17.5645 7.76318C17.8513 7.76318 18.1274 7.81348 18.3831 7.90601C18.3889 7.9231 18.3955 7.94019 18.4014 7.95703L19.8647 9.42041H20.8804L14.0957 2.63574H7.4646C7.40723 2.88232 7.3772 3.1394 7.3772 3.40356C7.3772 4.37158 7.78369 5.24585 8.43481 5.86548L15.0862 12.5176C15.4783 12.9338 15.9734 13.2522 16.531 13.4302C16.8567 13.5347 17.2043 13.5908 17.5645 13.5908C18.3608 13.5908 19.095 13.3154 19.6748 12.8555C19.6194 12.5093 19.4517 12.2 19.2104 11.9663C19.2085 11.9683 19.2058 11.9702 19.2031 11.9722L15.7849 8.54272C16.2285 8.06348 16.8618 7.76318 17.5645 7.76318ZM11.3069 7.92627C10.4243 7.92627 9.70874 7.21069 9.70874 6.32812C9.70874 5.44556 10.4243 4.72974 11.3069 4.72974C12.1897 4.72974 12.9053 5.44556 12.9053 6.32812C12.9053 7.21069 12.1897 7.92627 11.3069 7.92627Z' fill='url(%23paint5_linear)'/%3e%3cpath d='M28.6108 7.76318C28.8979 7.76318 29.1741 7.81348 29.4297 7.90601C29.4355 7.9231 29.4421 7.94019 29.448 7.95703L30.9111 9.42041H31.9268L25.1423 2.63574H18.5112C18.4536 2.88232 18.4238 3.1394 18.4238 3.40356C18.4238 4.37158 18.8301 5.24585 19.4812 5.86548L26.1326 12.5176C26.5247 12.9338 27.0198 13.2522 27.5776 13.4302C27.9031 13.5347 28.2507 13.5908 28.6108 13.5908C29.4075 13.5908 30.1414 13.3154 30.7214 12.8555C30.6658 12.5093 30.4983 12.2 30.2568 11.9663C30.2549 11.9683 30.2522 11.9702 30.2498 11.9722L26.8313 8.54272C27.2749 8.06348 27.9084 7.76318 28.6108 7.76318ZM22.3535 7.92627C21.4709 7.92627 20.7554 7.21069 20.7554 6.32812C20.7554 5.44556 21.4709 4.72974 22.3535 4.72974C23.2363 4.72974 23.9519 5.44556 23.9519 6.32812C23.9519 7.21069 23.2363 7.92627 22.3535 7.92627Z' fill='url(%23paint6_linear)'/%3e%3cpath d='M10.78 0.978516C11.8491 0.978516 12.7585 1.67334 13.0801 2.6355H14.0957C13.7468 1.1272 12.3926 0 10.78 0C9.16724 0 7.81372 1.1272 7.4646 2.6355C7.40723 2.88208 7.3772 3.13916 7.3772 3.40332C7.3772 4.91943 8.37402 6.20728 9.74658 6.64551C10.072 6.75 10.4197 6.80591 10.78 6.80591C11.5764 6.80591 12.3103 6.53076 12.8904 6.0708C12.8347 5.72437 12.6672 5.41528 12.4258 5.18164C11.9934 5.58228 11.4148 5.82739 10.78 5.82739C10.457 5.82739 10.1484 5.76416 9.8667 5.64868C8.98145 5.28735 8.35571 4.41724 8.35571 3.40332C8.35571 3.13525 8.39941 2.87695 8.48047 2.6355C8.802 1.67334 9.71143 0.978516 10.78 0.978516Z' fill='url(%23paint7_linear)'/%3e%3cpath d='M21.8264 0.978516C22.8958 0.978516 23.8049 1.67334 24.1267 2.6355H25.1423C24.7935 1.1272 23.439 0 21.8264 0C20.2139 0 18.8601 1.1272 18.5112 2.6355C18.4536 2.88208 18.4238 3.13916 18.4238 3.40332C18.4238 4.91943 19.4204 6.20728 20.793 6.64551C21.1187 6.75 21.4663 6.80591 21.8264 6.80591C22.623 6.80591 23.3569 6.53076 23.9368 6.0708C23.8813 5.72437 23.7136 5.41528 23.4724 5.18164C23.0398 5.58228 22.4612 5.82739 21.8264 5.82739C21.5037 5.82739 21.1951 5.76416 20.9131 5.64868C20.0278 5.28735 19.4023 4.41724 19.4023 3.40332C19.4023 3.13525 19.446 2.87695 19.5269 2.6355C19.8484 1.67334 20.7578 0.978516 21.8264 0.978516Z' fill='url(%23paint8_linear)'/%3e%3cpath d='M12.189 9.40625C13.8347 9.40625 15.2251 10.5271 15.2251 12.2295C15.2251 15.2798 10.6284 16.2727 10.6284 17.9041V18.4434H14.7996C15.0547 18.4434 15.2959 18.7412 15.2959 19.0959C15.2959 19.4504 15.0547 19.7769 14.7996 19.7769H9.74902C9.46509 19.7769 9.08228 19.5781 9.08228 19.2803V17.9041C9.08228 15.606 13.7212 14.4568 13.7212 12.2722C13.7212 11.5769 13.2673 10.7825 12.189 10.7825C11.3945 10.7825 10.7561 11.2222 10.7561 12.187C10.7561 12.4707 10.4583 12.7544 9.96167 12.7544C9.56445 12.7544 9.28076 12.5559 9.28076 11.9175C9.28076 10.3994 10.6426 9.40625 12.189 9.40625Z' fill='url(%23paint9_linear)'/%3e%3cpath d='M21.4304 13.4922C23.2324 13.4922 24.6226 14.2866 24.6226 16.4714V16.741C24.6226 19.0107 23.2039 19.8621 21.4448 19.8621C19.3877 19.8621 18.2527 18.6704 18.2527 17.3508C18.2527 16.8118 18.5364 16.6558 18.9905 16.6558C19.6147 16.6558 19.7566 16.9111 19.7566 17.2515C19.7566 18.0603 20.4944 18.5283 21.4165 18.5283C22.4805 18.5283 23.1189 17.9609 23.1189 16.7407V16.4712C23.1189 15.2654 22.4805 14.6838 21.4307 14.6838H19.3735C18.877 14.6838 18.7351 14.4568 18.7351 14.1021C18.7351 14.0027 18.7493 13.8608 18.7634 13.7617L19.0898 9.90283C19.1182 9.59082 19.2175 9.40625 19.4302 9.40625H23.6438C23.9558 9.40625 24.1118 9.74683 24.1118 10.073C24.1118 10.4136 23.9558 10.7397 23.6438 10.7397H20.3667L20.168 13.4919H21.4304V13.4922Z' fill='url(%23paint10_linear)'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient id='paint0_linear' x1='16.8524' y1='29.1508' x2='16.8524' y2='32.4273' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4'/%3e%3cstop offset='0.8111' stop-color='%237045D4'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='16.5876' y1='13.777' x2='18.8056' y2='26.237' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23ECF7FF'/%3e%3cstop offset='1' stop-color='%23C2E0FF'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='26.8665' y1='36.0478' x2='19.853' y2='29.0343' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0029' stop-color='%23C2E0FF' stop-opacity='0'/%3e%3cstop offset='0.0763' stop-color='%23BFDCFD' stop-opacity='0.07451'/%3e%3cstop offset='1' stop-color='%239EB2E7'/%3e%3c/linearGradient%3e%3clinearGradient id='paint3_linear' x1='14.8759' y1='23.0605' x2='14.8759' y2='28.6723' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23ECF7FF'/%3e%3cstop offset='1' stop-color='%23C2E0FF'/%3e%3c/linearGradient%3e%3clinearGradient id='paint4_linear' x1='16.8524' y1='30.1894' x2='16.8524' y2='26.2681' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4' stop-opacity='0'/%3e%3cstop offset='0.436' stop-color='%237045D4' stop-opacity='0.435294'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3clinearGradient id='paint5_linear' x1='14.2586' y1='7.44025' x2='3.10331' y2='0.547036' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0029' stop-color='%23C2E0FF' stop-opacity='0'/%3e%3cstop offset='0.0763' stop-color='%23BFDCFD' stop-opacity='0.07451'/%3e%3cstop offset='1' stop-color='%239EB2E7'/%3e%3c/linearGradient%3e%3clinearGradient id='paint6_linear' x1='25.3051' y1='7.44024' x2='14.1498' y2='0.547005' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0029' stop-color='%23C2E0FF' stop-opacity='0'/%3e%3cstop offset='0.0763' stop-color='%23BFDCFD' stop-opacity='0.07451'/%3e%3cstop offset='1' stop-color='%239EB2E7'/%3e%3c/linearGradient%3e%3clinearGradient id='paint7_linear' x1='7.37721' y1='3.40302' x2='14.0958' y2='3.40302' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23D3E843'/%3e%3cstop offset='0.6244' stop-color='%23A9C93C'/%3e%3cstop offset='1' stop-color='%238DB437'/%3e%3c/linearGradient%3e%3clinearGradient id='paint8_linear' x1='18.4238' y1='3.40302' x2='25.1424' y2='3.40302' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23D3E843'/%3e%3cstop offset='0.6244' stop-color='%23A9C93C'/%3e%3cstop offset='1' stop-color='%238DB437'/%3e%3c/linearGradient%3e%3clinearGradient id='paint9_linear' x1='9.03301' y1='9.79385' x2='17.1222' y2='24.4066' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4'/%3e%3cstop offset='0.8111' stop-color='%237045D4'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3clinearGradient id='paint10_linear' x1='17.1316' y1='6.56262' x2='25.2208' y2='21.1753' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4'/%3e%3cstop offset='0.8111' stop-color='%237045D4'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3cclipPath id='clip0'%3e%3crect width='32' height='32' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

const TCalendarCardList$1 = ({
  title,
  viewAll,
  events = [],
  loading = false,
  height,
  fallback,
  headerIcon,
  onItemClick = () => {}
}) => {
  return React.createElement(TCardList$1, {
    title: title,
    viewAll: viewAll,
    loading: loading,
    height: height,
    fallback: fallback,
    headerIcon: headerIcon || img$2
  }, !!events.length ? events.map((item, index) => React.createElement(TCalendarEventViewItem$1, Object.assign({
    key: index
  }, item, {
    onItemClick: () => {
      onItemClick(item);
    }
  }))) : null);
};

var css_248z$G = ".t-card-container {\n  padding: 16px;\n  border-radius: var(--border-radius, 8px);\n}\n.t-card-container-with-shadow {\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n.t-card-container-with-divider {\n  border-bottom: 1px solid #eaeaeb;\n}\n.t-card-container-bg-light-100 {\n  background: #fbfbfc;\n}\n.t-card-container-bg-light-50 {\n  background: #f7f7f8;\n}\n.t-card-container-bg-light-30 {\n  background: #f2f2f3;\n}\n.t-card-container-bg-light-20 {\n  background: #eaeaeb;\n}\n.t-card-container-bg-light-10 {\n  background: #e6e6e7;\n}\n.t-card-container-bg-white {\n  background: #fff;\n}\n.t-card-container-borderd {\n  border: 1px solid #f7f7f8;\n}\n.t-card-container-highlighted {\n  border: 1px #e0e0e0 solid;\n  background: #fbfbfc;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n";
styleInject(css_248z$G);

const TCardContainer = ({
  children,
  background = 'white',
  borderd,
  shadow = true,
  divider = false,
  style,
  highlighted
}) => {
  const classNames = ['t-card-container', `t-card-container-bg-${background}`];

  if (!!borderd) {
    classNames.push('t-card-container-borderd');
  }

  if (!!shadow) {
    classNames.push('t-card-container-with-shadow');
  }

  if (!!divider && !shadow) {
    classNames.push('t-card-container-with-divider');
  }

  if (!!highlighted) {
    classNames.push('t-card-container-highlighted');
  }

  return React.createElement("div", {
    style: style,
    className: classNames.join(' ')
  }, children);
};

var css_248z$H = ".badge-container-reverse .ant-badge-status {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n}\n.badge-container-reverse .ant-badge-status .ant-badge-status-dot {\n  margin-left: 4px;\n  top: 0;\n}\n";
styleInject(css_248z$H);

const TBadge = _a => {
  var {
    statusText,
    type
  } = _a,
      props = __rest(_a, ["statusText", "type"]);

  const classNames = ['badge-container', `badge-container-${type}`];
  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(_Badge, Object.assign({
    text: statusText
  }, props)));
};

const IconCalendar = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z",
    fill: fill
  }));
};

const IconChat = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.015C2 6.74712 6.21 2 12.02 2C17.7 2 22 6.65699 22 11.985C22 18.1642 16.96 22 12 22C10.36 22 8.54 21.5593 7.08 20.698C6.57 20.3876 6.14 20.1572 5.59 20.3375L3.57 20.9384C3.06 21.0986 2.6 20.698 2.75 20.1572L3.42 17.9139C3.53 17.6034 3.51 17.2729 3.35 17.0125C2.49 15.4301 2 13.6975 2 12.015ZM10.7 12.015C10.7 12.7261 11.27 13.2969 11.98 13.307C12.69 13.307 13.26 12.7261 13.26 12.025C13.26 11.314 12.69 10.7431 11.98 10.7431C11.28 10.7331 10.7 11.314 10.7 12.015ZM15.31 12.025C15.31 12.7261 15.88 13.307 16.59 13.307C17.3 13.307 17.87 12.7261 17.87 12.025C17.87 11.314 17.3 10.7431 16.59 10.7431C15.88 10.7431 15.31 11.314 15.31 12.025ZM7.37 13.307C6.67 13.307 6.09 12.7261 6.09 12.025C6.09 11.314 6.66 10.7431 7.37 10.7431C8.08 10.7431 8.65 11.314 8.65 12.025C8.65 12.7261 8.08 13.2969 7.37 13.307Z",
    fill: fill
  }));
};

const IconPencil = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M14.6653 0.0103353C16.1038 -0.0795717 17.5224 0.419911 18.5913 1.3989C19.5703 2.46779 20.0697 3.88633 19.9898 5.33483V14.6652C20.0797 16.1137 19.5703 17.5322 18.6013 18.6011C17.5323 19.5801 16.1038 20.0796 14.6653 19.9897H5.33487C3.88636 20.0796 2.46781 19.5801 1.39891 18.6011C0.419915 17.5322 -0.0795724 16.1137 0.0103353 14.6652V5.33483C-0.0795724 3.88633 0.419915 2.46779 1.39891 1.3989C2.46781 0.419911 3.88636 -0.0795717 5.33487 0.0103353H14.6653ZM8.98113 14.845L15.7042 8.10196C16.3136 7.4826 16.3136 6.48364 15.7042 5.87427L14.4056 4.57561C13.7862 3.95625 12.7872 3.95625 12.1679 4.57561L11.4985 5.25491C11.3986 5.35481 11.3986 5.52463 11.4985 5.62453C11.4985 5.62453 13.0869 7.20289 13.1169 7.24285C13.2268 7.36273 13.2967 7.52256 13.2967 7.70238C13.2967 8.06201 13.007 8.36169 12.6374 8.36169C12.4675 8.36169 12.3077 8.29177 12.1978 8.18188L10.5295 6.5236C10.4496 6.44368 10.3098 6.44368 10.2298 6.5236L5.46474 11.2887C5.13507 11.6183 4.94527 12.0579 4.93528 12.5274L4.87534 14.8949C4.87534 15.0248 4.9153 15.1447 5.00521 15.2346C5.09512 15.3245 5.21499 15.3744 5.34486 15.3744H7.69245C8.17196 15.3744 8.63149 15.1846 8.98113 14.845Z"
  }));
};

const IconNotification = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7071 8.79633C18.7071 10.0523 19.039 10.7925 19.7695 11.6456C20.3231 12.2741 20.5 13.0808 20.5 13.956C20.5 14.8302 20.2128 15.6601 19.6373 16.3339C18.884 17.1417 17.8215 17.6573 16.7372 17.747C15.1659 17.8809 13.5937 17.9937 12.0005 17.9937C10.4063 17.9937 8.83505 17.9263 7.26375 17.747C6.17846 17.6573 5.11602 17.1417 4.36367 16.3339C3.78822 15.6601 3.5 14.8302 3.5 13.956C3.5 13.0808 3.6779 12.2741 4.23049 11.6456C4.98384 10.7925 5.29392 10.0523 5.29392 8.79633V8.3703C5.29392 6.68834 5.71333 5.58852 6.577 4.51186C7.86106 2.9417 9.91935 2 11.9558 2H12.0452C14.1254 2 16.2502 2.98702 17.5125 4.62466C18.3314 5.67916 18.7071 6.73265 18.7071 8.3703V8.79633ZM9.07367 20.0608C9.07367 19.5573 9.53582 19.3266 9.96318 19.2279C10.4631 19.1222 13.5093 19.1222 14.0092 19.2279C14.4366 19.3266 14.8987 19.5573 14.8987 20.0608C14.8738 20.5402 14.5926 20.9653 14.204 21.2352C13.7001 21.628 13.1088 21.8767 12.4906 21.9664C12.1487 22.0107 11.8128 22.0117 11.4828 21.9664C10.8636 21.8767 10.2723 21.628 9.76938 21.2342C9.37978 20.9653 9.09852 20.5402 9.07367 20.0608Z",
    fill: fill || '#200E32'
  }));
};

const IconSetting = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4022 13.5801C20.7599 13.7701 21.0358 14.0701 21.23 14.3701C21.6081 14.9901 21.5775 15.7501 21.2096 16.4201L20.4942 17.6201C20.1161 18.2601 19.4109 18.6601 18.6853 18.6601C18.3277 18.6601 17.9291 18.5601 17.6021 18.3601C17.3364 18.1901 17.0298 18.1301 16.7027 18.1301C15.691 18.1301 14.8428 18.9601 14.8121 19.9501C14.8121 21.1001 13.8719 22.0001 12.6967 22.0001H11.3068C10.1213 22.0001 9.18113 21.1001 9.18113 19.9501C9.16069 18.9601 8.31247 18.1301 7.30073 18.1301C6.96348 18.1301 6.6569 18.1901 6.40141 18.3601C6.07438 18.5601 5.6656 18.6601 5.31813 18.6601C4.58232 18.6601 3.87717 18.2601 3.49905 17.6201L2.7939 16.4201C2.41577 15.7701 2.39533 14.9901 2.77346 14.3701C2.93697 14.0701 3.24356 13.7701 3.59102 13.5801C3.87717 13.4401 4.06112 13.2101 4.23486 12.9401C4.74584 12.0801 4.43925 10.9501 3.57059 10.4401C2.55885 9.87012 2.23182 8.60012 2.81434 7.61012L3.49905 6.43012C4.09178 5.44012 5.35901 5.09012 6.38097 5.67012C7.27007 6.15012 8.42488 5.83012 8.94608 4.98012C9.10959 4.70012 9.20157 4.40012 9.18113 4.10012C9.16069 3.71012 9.27311 3.34012 9.46728 3.04012C9.8454 2.42012 10.5301 2.02012 11.2761 2.00012H12.7171C13.4734 2.00012 14.1581 2.42012 14.5362 3.04012C14.7201 3.34012 14.8428 3.71012 14.8121 4.10012C14.7917 4.40012 14.8837 4.70012 15.0472 4.98012C15.5684 5.83012 16.7232 6.15012 17.6225 5.67012C18.6342 5.09012 19.9117 5.44012 20.4942 6.43012L21.1789 7.61012C21.7716 8.60012 21.4446 9.87012 20.4227 10.4401C19.554 10.9501 19.2474 12.0801 19.7686 12.9401C19.9321 13.2101 20.1161 13.4401 20.4022 13.5801ZM9.10959 12.0101C9.10959 13.5801 10.4075 14.8301 12.012 14.8301C13.6164 14.8301 14.8837 13.5801 14.8837 12.0101C14.8837 10.4401 13.6164 9.18012 12.012 9.18012C10.4075 9.18012 9.10959 10.4401 9.10959 12.0101Z",
    fill: "#200E32"
  }));
};

const IconList = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z",
    fill: fill || '#200E32'
  }));
};

const IconLevel = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7.37142 10.2017V17.0618",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.0381 6.91913V17.0618",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.6286 13.8268V17.0618",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconInBox = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19.0557 2H5.05566C4.26028 2.00087 3.49772 2.31722 2.9353 2.87964C2.37288 3.44206 2.05653 4.20462 2.05566 5V19C2.05653 19.7954 2.37288 20.5579 2.9353 21.1204C3.49772 21.6828 4.26028 21.9991 5.05566 22H19.0557C19.851 21.9991 20.6136 21.6828 21.176 21.1204C21.7384 20.5579 22.0548 19.7954 22.0557 19V5C22.0548 4.20462 21.7384 3.44206 21.176 2.87964C20.6136 2.31722 19.851 2.00087 19.0557 2ZM5.05566 4H19.0557C19.3208 4.00026 19.575 4.10571 19.7625 4.29319C19.95 4.48066 20.0554 4.73486 20.0557 5V13H17.5908C17.2615 12.9997 16.9373 13.0809 16.6469 13.2363C16.3566 13.3917 16.1092 13.6165 15.9268 13.8906L14.5205 16H9.59082L8.18457 13.8906C8.00214 13.6165 7.75474 13.3917 7.46441 13.2363C7.17407 13.0809 6.84982 12.9997 6.52051 13H4.05566V5C4.05593 4.73486 4.16137 4.48066 4.34885 4.29319C4.53633 4.10571 4.79053 4.00026 5.05566 4ZM19.0557 20H5.05566C4.79053 19.9997 4.53633 19.8943 4.34885 19.7068C4.16137 19.5193 4.05593 19.2651 4.05566 19V15H6.52051L7.92676 17.1094C8.1092 17.3835 8.35659 17.6083 8.64693 17.7637C8.93726 17.9191 9.26152 18.0003 9.59082 18H14.5205C14.8498 18.0003 15.1741 17.9191 15.4644 17.7637C15.7547 17.6083 16.0021 17.3835 16.1846 17.1094L17.5908 15H20.0557V19C20.0554 19.2651 19.95 19.5193 19.7625 19.7068C19.575 19.8943 19.3208 19.9997 19.0557 20Z",
    fill: "#262626"
  }));
};

const IconSend = _a => {
  var props = __rest(_a, []); //deleted default setting stroke="#200E32"


  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19.4354 0.581983C18.9352 0.0685981 18.1949 -0.122663 17.5046 0.0786645L1.408 4.75952C0.679698 4.96186 0.163487 5.54269 0.0244302 6.28055C-0.117628 7.0315 0.378575 7.98479 1.02684 8.38342L6.0599 11.4768C6.57611 11.7939 7.24238 11.7144 7.66956 11.2835L13.4329 5.4843C13.723 5.18231 14.2032 5.18231 14.4934 5.4843C14.7835 5.77623 14.7835 6.24935 14.4934 6.55134L8.71999 12.3516C8.29181 12.7814 8.21178 13.4508 8.52691 13.9702L11.6022 19.0538C11.9623 19.6577 12.5826 20 13.2628 20C13.3429 20 13.4329 20 13.513 19.9899C14.2933 19.8893 14.9135 19.3558 15.1436 18.6008L19.9156 2.52479C20.1257 1.84028 19.9356 1.09537 19.4354 0.581983Z",
    fill: "white"
  }));
};

const IconVoice = (_a, size) => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({
    size: size
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1748 15.2174H11.825C9.42166 15.2174 7.47358 13.2927 7.47358 10.9203V6.29706C7.47358 3.92373 9.42166 2 11.825 2H12.1748C14.5781 2 16.5272 3.92373 16.5272 6.29706V10.9203C16.5272 13.2927 14.5781 15.2174 12.1748 15.2174ZM18.5626 10.7829C18.5626 10.2539 18.9966 9.82626 19.5313 9.82626C20.066 9.82626 20.5 10.2539 20.5 10.7829C20.5 15.0866 17.2006 18.6404 12.9692 19.1178V21.0434C12.9692 21.5714 12.5352 22 12.0005 22C11.4648 22 11.0318 21.5714 11.0318 21.0434V19.1178C6.79945 18.6404 3.5 15.0866 3.5 10.7829C3.5 10.2539 3.93398 9.82626 4.46872 9.82626C5.00345 9.82626 5.43743 10.2539 5.43743 10.7829C5.43743 14.3558 8.38136 17.2629 12.0005 17.2629C15.6186 17.2629 18.5626 14.3558 18.5626 10.7829Z",
    fill: "#262626"
  }));
};

const IconPaperPlus = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66618 22H16.3328C19.7231 22 22 19.6219 22 16.0833V7.91672C22 4.37811 19.7231 2 16.3338 2H7.66618C4.2769 2 2 4.37811 2 7.91672V16.0833C2 19.6219 4.2769 22 7.66618 22ZM8.49886 11C7.12021 11 6 9.87827 6 8.5C6 7.12173 7.12021 6 8.49886 6C9.8765 6 10.9977 7.12173 10.9977 8.5C10.9977 9.87827 9.8765 11 8.49886 11ZM19.8208 14.934C20.1557 15.7926 19.9817 16.8246 19.6237 17.6749C19.1994 18.6863 18.3869 19.452 17.3632 19.7864C16.9087 19.935 16.432 20 15.9564 20H7.52864C6.68999 20 5.94788 19.7988 5.3395 19.4241C4.95839 19.1889 4.89102 18.646 5.17358 18.2941C5.6462 17.7059 6.11279 17.1156 6.5834 16.5201C7.48038 15.3808 8.08473 15.0506 8.75645 15.3406C9.02896 15.4603 9.30248 15.6398 9.58404 15.8297C10.3342 16.3395 11.377 17.0402 12.7506 16.2797C13.6906 15.7532 14.2358 14.8501 14.7106 14.0637L14.7185 14.0506C14.7522 13.9954 14.7855 13.9402 14.8187 13.8852C14.9783 13.6212 15.1357 13.3607 15.3138 13.1207C15.5371 12.8204 16.3646 11.8813 17.4366 12.5501C18.1194 12.9711 18.6936 13.5408 19.308 14.1507C19.5423 14.3839 19.7092 14.6491 19.8208 14.934Z",
    fill: "#262626"
  }));
};

const IconDashboard = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z",
    fill: "#200E32"
  }));
};

const IconAdmin = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1583 8.23285C16.1583 10.5825 14.2851 12.4666 11.949 12.4666C9.61292 12.4666 7.73974 10.5825 7.73974 8.23285C7.73974 5.88227 9.61292 4 11.949 4C14.2851 4 16.1583 5.88227 16.1583 8.23285ZM11.949 20C8.51785 20 5.58809 19.456 5.58809 17.2802C5.58809 15.1034 8.49904 14.5396 11.949 14.5396C15.3802 14.5396 18.31 15.0836 18.31 17.2604C18.31 19.4362 15.399 20 11.949 20ZM17.9571 8.30922C17.9571 9.50703 17.5998 10.6229 16.973 11.5505C16.9086 11.646 16.9659 11.7748 17.0796 11.7946C17.2363 11.8216 17.3984 11.8369 17.5631 11.8414C19.2062 11.8846 20.6809 10.821 21.0883 9.21974C21.6918 6.84123 19.9198 4.7059 17.6634 4.7059C17.4181 4.7059 17.1835 4.73201 16.9551 4.77884C16.9238 4.78605 16.8907 4.80046 16.8728 4.82838C16.8513 4.8626 16.8674 4.90853 16.8889 4.93825C17.5667 5.8938 17.9571 7.05918 17.9571 8.30922ZM20.6782 13.5126C21.7823 13.7296 22.5084 14.1727 22.8093 14.8166C23.0636 15.3453 23.0636 15.9586 22.8093 16.4864C22.349 17.4851 20.8654 17.8058 20.2887 17.8886C20.1696 17.9066 20.0738 17.8031 20.0864 17.6833C20.3809 14.9157 18.0377 13.6035 17.4315 13.3018C17.4055 13.2883 17.4002 13.2676 17.4028 13.255C17.4046 13.246 17.4154 13.2316 17.4351 13.2289C18.7468 13.2046 20.1571 13.3847 20.6782 13.5126ZM6.43711 11.8413C6.60186 11.8368 6.76304 11.8224 6.92063 11.7945C7.03434 11.7747 7.09165 11.6459 7.02718 11.5504C6.4004 10.6228 6.04313 9.50694 6.04313 8.30913C6.04313 7.05909 6.43353 5.89371 7.11135 4.93816C7.13284 4.90844 7.14806 4.86251 7.12746 4.82829C7.10956 4.80127 7.07553 4.78596 7.04509 4.77875C6.81586 4.73192 6.58127 4.70581 6.33593 4.70581C4.07951 4.70581 2.30751 6.84114 2.91191 9.21965C3.31932 10.8209 4.79405 11.8845 6.43711 11.8413ZM6.59694 13.2545C6.59962 13.268 6.59425 13.2878 6.56918 13.3022C5.9621 13.6039 3.61883 14.9161 3.91342 17.6827C3.92595 17.8034 3.83104 17.9061 3.71195 17.889C3.13531 17.8061 1.65163 17.4855 1.19139 16.4867C0.936203 15.9581 0.936203 15.3457 1.19139 14.817C1.49225 14.1731 2.21752 13.73 3.32156 13.512C3.84358 13.385 5.25294 13.2049 6.5656 13.2292C6.5853 13.2319 6.59515 13.2464 6.59694 13.2545Z",
    fill: fill || '#200E32'
  }));
};

const IconApplication = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.761 12.001C19.761 12.8145 20.429 13.4764 21.25 13.4764C21.664 13.4764 22 13.8093 22 14.2195V16.8958C22 19.159 20.142 21 17.858 21H6.143C3.859 21 2 19.159 2 16.8958V14.2195C2 13.8093 2.336 13.4764 2.75 13.4764C3.572 13.4764 4.24 12.8145 4.24 12.001C4.24 11.2083 3.599 10.6118 2.75 10.6118C2.551 10.6118 2.361 10.5335 2.22 10.3938C2.079 10.2541 2 10.0648 2 9.86866L2.002 7.10514C2.002 4.84201 3.86 3 6.144 3H17.856C20.14 3 21.999 4.84201 21.999 7.10514L22 9.78245C22 9.97864 21.921 10.1689 21.781 10.3076C21.64 10.4473 21.45 10.5256 21.25 10.5256C20.429 10.5256 19.761 11.1875 19.761 12.001ZM14.252 12.648L15.431 11.5105C15.636 11.3143 15.707 11.025 15.618 10.7575C15.53 10.4899 15.3 10.2997 15.022 10.261L13.393 10.0252L12.664 8.5627C12.539 8.31102 12.285 8.15446 12.002 8.15347H12C11.718 8.15347 11.464 8.31003 11.337 8.56171L10.608 10.0252L8.982 10.26C8.701 10.2997 8.471 10.4899 8.382 10.7575C8.294 11.025 8.365 11.3143 8.569 11.5105L9.748 12.648L9.47 14.2562C9.422 14.5336 9.535 14.8091 9.765 14.9746C9.895 15.0667 10.046 15.1143 10.199 15.1143C10.316 15.1143 10.434 15.0855 10.542 15.0291L12 14.2701L13.455 15.0271C13.707 15.1608 14.006 15.14 14.235 14.9736C14.466 14.8091 14.579 14.5336 14.531 14.2562L14.252 12.648Z",
    fill: "#200E32"
  }));
};

const IconManagement = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53988 2H7.91988C9.32988 2 10.4599 3.15 10.4599 4.561V7.97C10.4599 9.39 9.32988 10.53 7.91988 10.53H4.53988C3.13988 10.53 1.99988 9.39 1.99988 7.97V4.561C1.99988 3.15 3.13988 2 4.53988 2ZM4.53988 13.4697H7.91988C9.32988 13.4697 10.4599 14.6107 10.4599 16.0307V19.4397C10.4599 20.8497 9.32988 21.9997 7.91988 21.9997H4.53988C3.13988 21.9997 1.99988 20.8497 1.99988 19.4397V16.0307C1.99988 14.6107 3.13988 13.4697 4.53988 13.4697ZM19.46 2H16.08C14.67 2 13.54 3.15 13.54 4.561V7.97C13.54 9.39 14.67 10.53 16.08 10.53H19.46C20.86 10.53 22 9.39 22 7.97V4.561C22 3.15 20.86 2 19.46 2ZM16.08 13.4697H19.46C20.86 13.4697 22 14.6107 22 16.0307V19.4397C22 20.8497 20.86 21.9997 19.46 21.9997H16.08C14.67 21.9997 13.54 20.8497 13.54 19.4397V16.0307C13.54 14.6107 14.67 13.4697 16.08 13.4697Z",
    fill: fill || '#200E32'
  }));
};

const IconFile = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9 0H11.07C13.78 0 15.97 1.07 16 3.79V18.97C16 19.14 15.96 19.31 15.88 19.46C15.75 19.7 15.53 19.88 15.26 19.96C15 20.04 14.71 20 14.47 19.86L7.99 16.62L1.5 19.86C1.351 19.939 1.18 19.99 1.01 19.99C0.45 19.99 0 19.53 0 18.97V3.79C0 1.07 2.2 0 4.9 0ZM4.22 7.62H11.75C12.18 7.62 12.53 7.269 12.53 6.83C12.53 6.39 12.18 6.04 11.75 6.04H4.22C3.79 6.04 3.44 6.39 3.44 6.83C3.44 7.269 3.79 7.62 4.22 7.62Z",
    fill: "#200E32"
  }));
};

const IconBoldLevel = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3304 0.000427246H14.6694C18.0704 0.000427246 19.9904 1.92943 20.0004 5.33043V14.6704C20.0004 18.0704 18.0704 20.0004 14.6694 20.0004H5.3304C1.9294 20.0004 0.000396729 18.0704 0.000396729 14.6704V5.33043C0.000396729 1.92943 1.9294 0.000427246 5.3304 0.000427246ZM10.0494 15.8604C10.4804 15.8604 10.8394 15.5404 10.8794 15.1104V4.92043C10.9194 4.61043 10.7704 4.29943 10.5004 4.13043C10.2194 3.96043 9.8794 3.96043 9.6104 4.13043C9.3394 4.29943 9.1904 4.61043 9.2194 4.92043V15.1104C9.2704 15.5404 9.6294 15.8604 10.0494 15.8604ZM14.6504 15.8604C15.0704 15.8604 15.4294 15.5404 15.4804 15.1104V11.8304C15.5094 11.5094 15.3604 11.2104 15.0894 11.0404C14.8204 10.8704 14.4804 10.8704 14.2004 11.0404C13.9294 11.2104 13.7804 11.5094 13.8204 11.8304V15.1104C13.8604 15.5404 14.2194 15.8604 14.6504 15.8604ZM6.2194 15.1104C6.1794 15.5404 5.8204 15.8604 5.3894 15.8604C4.9594 15.8604 4.5994 15.5404 4.5604 15.1104V8.20043C4.5304 7.88943 4.6794 7.58043 4.9504 7.41043C5.2194 7.24043 5.5604 7.24043 5.8304 7.41043C6.0994 7.58043 6.2504 7.88943 6.2194 8.20043V15.1104Z",
    fill: "#200E32"
  }));
};

const IconUsers = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M11.9996 2C10.06 2.00369 8.16344 2.57131 6.54079 3.63374C4.91814 4.69617 3.63946 6.20754 2.8605 7.98377C2.08155 9.76 1.83594 11.7244 2.15359 13.6378C2.47124 15.5511 3.33844 17.3308 4.64956 18.76C5.58598 19.775 6.7225 20.5851 7.9875 21.1392C9.25249 21.6933 10.6185 21.9793 11.9996 21.9793C13.3806 21.9793 14.7466 21.6933 16.0116 21.1392C17.2766 20.5851 18.4131 19.775 19.3496 18.76C20.6607 17.3308 21.5279 15.5511 21.8455 13.6378C22.1632 11.7244 21.9176 9.76 21.1386 7.98377C20.3597 6.20754 19.081 4.69617 17.4583 3.63374C15.8357 2.57131 13.9391 2.00369 11.9996 2ZM11.9996 20C9.92803 19.9969 7.93848 19.1903 6.44956 17.75C6.9016 16.6495 7.67059 15.7083 8.65881 15.0459C9.64703 14.3835 10.8099 14.0298 11.9996 14.0298C13.1893 14.0298 14.3521 14.3835 15.3403 15.0459C16.3285 15.7083 17.0975 16.6495 17.5496 17.75C16.0606 19.1903 14.0711 19.9969 11.9996 20ZM9.99956 10C9.99956 9.60444 10.1169 9.21776 10.3366 8.88886C10.5564 8.55996 10.8687 8.30362 11.2342 8.15224C11.5996 8.00087 12.0018 7.96126 12.3897 8.03843C12.7777 8.1156 13.1341 8.30608 13.4138 8.58579C13.6935 8.86549 13.884 9.22186 13.9611 9.60982C14.0383 9.99778 13.9987 10.3999 13.8473 10.7654C13.6959 11.1308 13.4396 11.4432 13.1107 11.6629C12.7818 11.8827 12.3951 12 11.9996 12C11.4691 12 10.9604 11.7893 10.5853 11.4142C10.2103 11.0391 9.99956 10.5304 9.99956 10ZM18.9096 16C18.0161 14.4718 16.641 13.283 14.9996 12.62C15.5087 12.0427 15.8405 11.3307 15.955 10.5694C16.0696 9.80822 15.962 9.03011 15.6453 8.3285C15.3286 7.62688 14.8161 7.03156 14.1695 6.61397C13.5228 6.19637 12.7694 5.97425 11.9996 5.97425C11.2298 5.97425 10.4763 6.19637 9.82965 6.61397C9.18298 7.03156 8.67053 7.62688 8.35381 8.3285C8.03709 9.03011 7.92955 9.80822 8.04409 10.5694C8.15863 11.3307 8.49039 12.0427 8.99956 12.62C7.35816 13.283 5.98303 14.4718 5.08956 16C4.3775 14.7871 4.00128 13.4065 3.99956 12C3.99956 9.87827 4.84242 7.84344 6.34271 6.34315C7.843 4.84285 9.87783 4 11.9996 4C14.1213 4 16.1561 4.84285 17.6564 6.34315C19.1567 7.84344 19.9996 9.87827 19.9996 12C19.9978 13.4065 19.6216 14.7871 18.9096 16Z",
    fill: "white"
  }));
};

const IconTestResult = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M11.5 20H5.5C5.23478 20 4.98043 19.8946 4.79289 19.7071C4.60536 19.5196 4.5 19.2652 4.5 19V5C4.5 4.73478 4.60536 4.48043 4.79289 4.29289C4.98043 4.10536 5.23478 4 5.5 4H10.5V7C10.5 7.79565 10.8161 8.55871 11.3787 9.12132C11.9413 9.68393 12.7044 10 13.5 10H16.5V15C16.5 15.2652 16.6054 15.5196 16.7929 15.7071C16.9804 15.8946 17.2348 16 17.5 16C17.7652 16 18.0196 15.8946 18.2071 15.7071C18.3946 15.5196 18.5 15.2652 18.5 15V9C18.5 9 18.5 9 18.5 8.94C18.4896 8.84813 18.4695 8.75763 18.44 8.67V8.58C18.3919 8.47718 18.3278 8.38267 18.25 8.3L12.25 2.3C12.1673 2.22222 12.0728 2.15808 11.97 2.11C11.9369 2.10421 11.9031 2.10421 11.87 2.11C11.7728 2.058 11.6683 2.02092 11.56 2H5.5C4.70435 2 3.94129 2.31607 3.37868 2.87868C2.81607 3.44129 2.5 4.20435 2.5 5V19C2.5 19.7956 2.81607 20.5587 3.37868 21.1213C3.94129 21.6839 4.70435 22 5.5 22H11.5C11.7652 22 12.0196 21.8946 12.2071 21.7071C12.3946 21.5196 12.5 21.2652 12.5 21C12.5 20.7348 12.3946 20.4804 12.2071 20.2929C12.0196 20.1054 11.7652 20 11.5 20ZM12.5 5.41L15.09 8H13.5C13.2348 8 12.9804 7.89464 12.7929 7.70711C12.6054 7.51957 12.5 7.26522 12.5 7V5.41ZM7.5 14H13.5C13.7652 14 14.0196 13.8946 14.2071 13.7071C14.3946 13.5196 14.5 13.2652 14.5 13C14.5 12.7348 14.3946 12.4804 14.2071 12.2929C14.0196 12.1054 13.7652 12 13.5 12H7.5C7.23478 12 6.98043 12.1054 6.79289 12.2929C6.60536 12.4804 6.5 12.7348 6.5 13C6.5 13.2652 6.60536 13.5196 6.79289 13.7071C6.98043 13.8946 7.23478 14 7.5 14ZM11.5 16H7.5C7.23478 16 6.98043 16.1054 6.79289 16.2929C6.60536 16.4804 6.5 16.7348 6.5 17C6.5 17.2652 6.60536 17.5196 6.79289 17.7071C6.98043 17.8946 7.23478 18 7.5 18H11.5C11.7652 18 12.0196 17.8946 12.2071 17.7071C12.3946 17.5196 12.5 17.2652 12.5 17C12.5 16.7348 12.3946 16.4804 12.2071 16.2929C12.0196 16.1054 11.7652 16 11.5 16ZM7.5 10H8.5C8.76522 10 9.01957 9.89464 9.20711 9.70711C9.39464 9.51957 9.5 9.26522 9.5 9C9.5 8.73478 9.39464 8.48043 9.20711 8.29289C9.01957 8.10536 8.76522 8 8.5 8H7.5C7.23478 8 6.98043 8.10536 6.79289 8.29289C6.60536 8.48043 6.5 8.73478 6.5 9C6.5 9.26522 6.60536 9.51957 6.79289 9.70711C6.98043 9.89464 7.23478 10 7.5 10ZM21.21 16.29C21.117 16.1963 21.0064 16.1219 20.8846 16.0711C20.7627 16.0203 20.632 15.9942 20.5 15.9942C20.368 15.9942 20.2373 16.0203 20.1154 16.0711C19.9936 16.1219 19.883 16.1963 19.79 16.29L16.5 19.59L15.21 18.29C15.1168 18.1968 15.0061 18.1228 14.8842 18.0723C14.7624 18.0219 14.6319 17.9959 14.5 17.9959C14.3681 17.9959 14.2376 18.0219 14.1158 18.0723C13.9939 18.1228 13.8832 18.1968 13.79 18.29C13.6968 18.3832 13.6228 18.4939 13.5723 18.6158C13.5219 18.7376 13.4959 18.8681 13.4959 19C13.4959 19.1319 13.5219 19.2624 13.5723 19.3842C13.6228 19.5061 13.6968 19.6168 13.79 19.71L15.79 21.71C15.883 21.8037 15.9936 21.8781 16.1154 21.9289C16.2373 21.9797 16.368 22.0058 16.5 22.0058C16.632 22.0058 16.7627 21.9797 16.8846 21.9289C17.0064 21.8781 17.117 21.8037 17.21 21.71L21.21 17.71C21.3037 17.617 21.3781 17.5064 21.4289 17.3846C21.4797 17.2627 21.5058 17.132 21.5058 17C21.5058 16.868 21.4797 16.7373 21.4289 16.6154C21.3781 16.4936 21.3037 16.383 21.21 16.29Z",
    fill: fill || '#262626'
  }));
};

const IconGroup = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z",
    fill: fill
  }));
};

const IconCourse = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.1696 2.06012C20.4528 1.93665 19.7269 1.8731 18.9996 1.87012C16.518 1.86809 14.0881 2.57969 11.9996 3.92012C9.90574 2.59729 7.47625 1.90315 4.9996 1.92012C4.27224 1.9231 3.5464 1.98665 2.8296 2.11012C2.5948 2.1506 2.38218 2.27358 2.23001 2.45691C2.07784 2.64025 1.99613 2.87189 1.9996 3.11012V15.1101C1.99745 15.2571 2.02772 15.4027 2.08825 15.5366C2.14877 15.6705 2.23806 15.7894 2.34977 15.8849C2.46148 15.9803 2.59285 16.05 2.73455 16.089C2.87625 16.1279 3.02479 16.1351 3.1696 16.1101C4.60262 15.862 6.0708 15.9032 7.48766 16.2312C8.90453 16.5592 10.2414 17.1675 11.4196 18.0201L11.5396 18.0901H11.6496C11.7605 18.1363 11.8795 18.1601 11.9996 18.1601C12.1197 18.1601 12.2387 18.1363 12.3496 18.0901H12.4596L12.5796 18.0201C13.7496 17.1484 15.0826 16.5205 16.4997 16.1735C17.9169 15.8265 19.3893 15.7675 20.8296 16.0001C20.9744 16.0251 21.1229 16.0179 21.2646 15.979C21.4063 15.94 21.5377 15.8703 21.6494 15.7749C21.7611 15.6794 21.8504 15.5605 21.9109 15.4266C21.9715 15.2927 22.0017 15.1471 21.9996 15.0001V3.00012C21.9892 2.77228 21.9012 2.55483 21.7502 2.38386C21.5993 2.21289 21.3944 2.09866 21.1696 2.06012ZM10.9996 15.3501C9.14948 14.3768 7.09011 13.8688 4.9996 13.8701C4.6696 13.8701 4.3396 13.8701 3.9996 13.8701V3.87012C4.33265 3.85093 4.66654 3.85093 4.9996 3.87012C7.13298 3.86776 9.21981 4.49381 10.9996 5.67012V15.3501ZM19.9996 13.9101C19.6596 13.9101 19.3296 13.9101 18.9996 13.9101C16.9091 13.9088 14.8497 14.4168 12.9996 15.3901V5.67012C14.7794 4.49381 16.8662 3.86776 18.9996 3.87012C19.3327 3.85093 19.6665 3.85093 19.9996 3.87012V13.9101ZM21.1696 18.0601C20.4528 17.9367 19.7269 17.8731 18.9996 17.8701C16.518 17.8681 14.0881 18.5797 11.9996 19.9201C9.91111 18.5797 7.48123 17.8681 4.9996 17.8701C4.27224 17.8731 3.5464 17.9367 2.8296 18.0601C2.69942 18.0808 2.57462 18.127 2.46236 18.196C2.3501 18.2651 2.2526 18.3557 2.17546 18.4625C2.09833 18.5694 2.04308 18.6905 2.0129 18.8188C1.98272 18.9471 1.9782 19.0801 1.9996 19.2101C2.05042 19.4698 2.20209 19.6988 2.42139 19.8468C2.64069 19.9949 2.90974 20.05 3.1696 20.0001C4.60262 19.752 6.0708 19.7932 7.48766 20.1212C8.90453 20.4492 10.2414 21.0575 11.4196 21.9101C11.589 22.0307 11.7917 22.0955 11.9996 22.0955C12.2075 22.0955 12.4102 22.0307 12.5796 21.9101C13.7578 21.0575 15.0947 20.4492 16.5115 20.1212C17.9284 19.7932 19.3966 19.752 20.8296 20.0001C21.0895 20.05 21.3585 19.9949 21.5778 19.8468C21.7971 19.6988 21.9488 19.4698 21.9996 19.2101C22.021 19.0801 22.0165 18.9471 21.9863 18.8188C21.9561 18.6905 21.9009 18.5694 21.8237 18.4625C21.7466 18.3557 21.6491 18.2651 21.5368 18.196C21.4246 18.127 21.2998 18.0808 21.1696 18.0601Z"
  }));
};

const IconMaterial = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7.5 10H8.5C8.76522 10 9.01957 9.89464 9.20711 9.70711C9.39464 9.51957 9.5 9.26522 9.5 9C9.5 8.73478 9.39464 8.48043 9.20711 8.29289C9.01957 8.10536 8.76522 8 8.5 8H7.5C7.23478 8 6.98043 8.10536 6.79289 8.29289C6.60536 8.48043 6.5 8.73478 6.5 9C6.5 9.26522 6.60536 9.51957 6.79289 9.70711C6.98043 9.89464 7.23478 10 7.5 10ZM11.5 16H7.5C7.23478 16 6.98043 16.1054 6.79289 16.2929C6.60536 16.4804 6.5 16.7348 6.5 17C6.5 17.2652 6.60536 17.5196 6.79289 17.7071C6.98043 17.8946 7.23478 18 7.5 18H11.5C11.7652 18 12.0196 17.8946 12.2071 17.7071C12.3946 17.5196 12.5 17.2652 12.5 17C12.5 16.7348 12.3946 16.4804 12.2071 16.2929C12.0196 16.1054 11.7652 16 11.5 16ZM11.5 12H7.5C7.23478 12 6.98043 12.1054 6.79289 12.2929C6.60536 12.4804 6.5 12.7348 6.5 13C6.5 13.2652 6.60536 13.5196 6.79289 13.7071C6.98043 13.8946 7.23478 14 7.5 14H11.5C11.7652 14 12.0196 13.8946 12.2071 13.7071C12.3946 13.5196 12.5 13.2652 12.5 13C12.5 12.7348 12.3946 12.4804 12.2071 12.2929C12.0196 12.1054 11.7652 12 11.5 12ZM18.42 9.38C18.4966 9.19789 18.5175 8.99718 18.4801 8.80319C18.4428 8.6092 18.3488 8.43062 18.21 8.29L12.21 2.29C12.1273 2.21222 12.0328 2.14808 11.93 2.1C11.9002 2.09576 11.8699 2.09576 11.84 2.1L11.56 2H5.5C4.70435 2 3.94129 2.31607 3.37868 2.87868C2.81607 3.44129 2.5 4.20435 2.5 5V19C2.5 19.7956 2.81607 20.5587 3.37868 21.1213C3.94129 21.6839 4.70435 22 5.5 22H11.5C11.7652 22 12.0196 21.8946 12.2071 21.7071C12.3946 21.5196 12.5 21.2652 12.5 21C12.5 20.7348 12.3946 20.4804 12.2071 20.2929C12.0196 20.1054 11.7652 20 11.5 20H5.5C5.23478 20 4.98043 19.8946 4.79289 19.7071C4.60536 19.5196 4.5 19.2652 4.5 19V5C4.5 4.73478 4.60536 4.48043 4.79289 4.29289C4.98043 4.10536 5.23478 4 5.5 4H10.5V7C10.5 7.79565 10.8161 8.55871 11.3787 9.12132C11.9413 9.68393 12.7044 10 13.5 10H17.5C17.6974 9.99901 17.8901 9.93961 18.0539 9.82928C18.2176 9.71895 18.345 9.56262 18.42 9.38ZM13.5 8C13.2348 8 12.9804 7.89464 12.7929 7.70711C12.6054 7.51957 12.5 7.26522 12.5 7V5.41L15.09 8H13.5ZM20.5 12H15.5C15.2348 12 14.9804 12.1054 14.7929 12.2929C14.6054 12.4804 14.5 12.7348 14.5 13V21C14.5005 21.1809 14.55 21.3583 14.6434 21.5133C14.7367 21.6682 14.8703 21.795 15.03 21.88C15.1864 21.9603 15.3611 21.9979 15.5367 21.9892C15.7123 21.9804 15.8824 21.9255 16.03 21.83L18 20.53L20 21.83C20.1494 21.9164 20.3186 21.9627 20.4912 21.9643C20.6637 21.9659 20.8338 21.9229 20.9848 21.8393C21.1358 21.7558 21.2626 21.6346 21.3529 21.4875C21.4432 21.3404 21.4938 21.1725 21.5 21V13C21.5 12.7348 21.3946 12.4804 21.2071 12.2929C21.0196 12.1054 20.7652 12 20.5 12ZM19.5 19.12L18.56 18.49C18.3946 18.3782 18.1996 18.3185 18 18.3185C17.8004 18.3185 17.6054 18.3782 17.44 18.49L16.5 19.12V14H19.5V19.12Z",
    fill: fill || '#200E32'
  }));
};

const IconEnrolment = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM10 4H14V7.13L12.55 6.13C12.3867 6.02247 12.1955 5.96516 12 5.96516C11.8045 5.96516 11.6133 6.02247 11.45 6.13L10 7.13V4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00048 9.1809 8.05003 9.35829 8.14336 9.51326C8.2367 9.66823 8.37032 9.79498 8.53 9.88C8.68637 9.96029 8.86115 9.99795 9.03671 9.98917C9.21227 9.98039 9.38242 9.92549 9.53 9.83L12 8.2L14.45 9.83C14.6004 9.92905 14.7748 9.98565 14.9547 9.99381C15.1346 10.002 15.3133 9.96142 15.4721 9.87641C15.6308 9.7914 15.7637 9.66509 15.8566 9.51083C15.9495 9.35657 15.9991 9.18008 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z",
    fill: "#262626"
  }));
};

const IconStudent = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M15.7105 12.7101C16.6909 11.9388 17.4065 10.881 17.7577 9.68407C18.109 8.48709 18.0784 7.21039 17.6703 6.03159C17.2621 4.85279 16.4967 3.83052 15.4806 3.10698C14.4644 2.38344 13.2479 1.99463 12.0005 1.99463C10.753 1.99463 9.5366 2.38344 8.52041 3.10698C7.50423 3.83052 6.73883 4.85279 6.3307 6.03159C5.92257 7.21039 5.892 8.48709 6.24325 9.68407C6.59449 10.881 7.31009 11.9388 8.29048 12.7101C6.61056 13.3832 5.14477 14.4995 4.04938 15.94C2.95398 17.3806 2.27005 19.0914 2.07048 20.8901C2.05604 21.0214 2.0676 21.1543 2.10451 21.2812C2.14142 21.408 2.20295 21.5264 2.2856 21.6294C2.4525 21.8376 2.69527 21.971 2.96049 22.0001C3.2257 22.0293 3.49164 21.9519 3.69981 21.785C3.90798 21.6181 4.04131 21.3753 4.07049 21.1101C4.29007 19.1553 5.22217 17.3499 6.6887 16.0389C8.15524 14.7279 10.0534 14.0032 12.0205 14.0032C13.9876 14.0032 15.8857 14.7279 17.3523 16.0389C18.8188 17.3499 19.7509 19.1553 19.9705 21.1101C19.9977 21.3558 20.1149 21.5828 20.2996 21.7471C20.4843 21.9115 20.7233 22.0016 20.9705 22.0001H21.0805C21.3426 21.97 21.5822 21.8374 21.747 21.6314C21.9119 21.4253 21.9886 21.1625 21.9605 20.9001C21.76 19.0963 21.0724 17.3811 19.9713 15.9383C18.8703 14.4955 17.3974 13.3796 15.7105 12.7101ZM12.0005 12.0001C11.2094 12.0001 10.436 11.7655 9.7782 11.326C9.12041 10.8865 8.60772 10.2618 8.30497 9.53086C8.00222 8.79995 7.923 7.99569 8.07734 7.21976C8.23168 6.44384 8.61265 5.73111 9.17206 5.1717C9.73147 4.61229 10.4442 4.23132 11.2201 4.07698C11.996 3.92264 12.8003 4.00186 13.5312 4.30461C14.2621 4.60736 14.8868 5.12005 15.3264 5.77784C15.7659 6.43564 16.0005 7.209 16.0005 8.00012C16.0005 9.06099 15.5791 10.0784 14.8289 10.8286C14.0788 11.5787 13.0614 12.0001 12.0005 12.0001Z",
    fill: fill || '#262626'
  }));
};

const IconAttendance = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12H20V19ZM20 10H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V10Z",
    fill: "#262626"
  }));
};

const IconSubject = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M18 2H8C6.93913 2 5.92172 2.42143 5.17157 3.17157C4.42143 3.92172 4 4.93913 4 6V18C4 19.0609 4.42143 20.0783 5.17157 20.8284C5.92172 21.5786 6.93913 22 8 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4H18V14H8C7.29504 14.003 6.60399 14.1964 6 14.56V6ZM8 20C7.46957 20 6.96086 19.7893 6.58579 19.4142C6.21071 19.0391 6 18.5304 6 18C6 17.4696 6.21071 16.9609 6.58579 16.5858C6.96086 16.2107 7.46957 16 8 16H18V20H8ZM10 8H14C14.2652 8 14.5196 7.89464 14.7071 7.70711C14.8946 7.51957 15 7.26522 15 7C15 6.73478 14.8946 6.48043 14.7071 6.29289C14.5196 6.10536 14.2652 6 14 6H10C9.73478 6 9.48043 6.10536 9.29289 6.29289C9.10536 6.48043 9 6.73478 9 7C9 7.26522 9.10536 7.51957 9.29289 7.70711C9.48043 7.89464 9.73478 8 10 8Z",
    fill: fill
  }));
};

const IconPaymant = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M13 16.0001H7.00001C6.73479 16.0001 6.48044 16.1054 6.2929 16.293C6.10537 16.4805 6.00001 16.7349 6.00001 17.0001C6.00001 17.2653 6.10537 17.5196 6.2929 17.7072C6.48044 17.8947 6.73479 18.0001 7.00001 18.0001H13C13.2652 18.0001 13.5196 17.8947 13.7071 17.7072C13.8947 17.5196 14 17.2653 14 17.0001C14 16.7349 13.8947 16.4805 13.7071 16.293C13.5196 16.1054 13.2652 16.0001 13 16.0001ZM9.00001 10.0001H11C11.2652 10.0001 11.5196 9.89471 11.7071 9.70717C11.8947 9.51964 12 9.26528 12 9.00007C12 8.73485 11.8947 8.4805 11.7071 8.29296C11.5196 8.10543 11.2652 8.00007 11 8.00007H9.00001C8.73479 8.00007 8.48044 8.10543 8.2929 8.29296C8.10537 8.4805 8.00001 8.73485 8.00001 9.00007C8.00001 9.26528 8.10537 9.51964 8.2929 9.70717C8.48044 9.89471 8.73479 10.0001 9.00001 10.0001ZM21 12.0001H18V3.00007C18.0007 2.82386 17.9548 2.65059 17.867 2.49781C17.7792 2.34504 17.6526 2.21817 17.5 2.13007C17.348 2.0423 17.1755 1.99609 17 1.99609C16.8245 1.99609 16.652 2.0423 16.5 2.13007L13.5 3.85007L10.5 2.13007C10.348 2.0423 10.1755 1.99609 10 1.99609C9.82447 1.99609 9.65203 2.0423 9.50001 2.13007L6.50001 3.85007L3.50001 2.13007C3.34799 2.0423 3.17554 1.99609 3.00001 1.99609C2.82447 1.99609 2.65203 2.0423 2.50001 2.13007C2.3474 2.21817 2.22079 2.34504 2.13299 2.49781C2.04518 2.65059 1.99931 2.82386 2.00001 3.00007V19.0001C2.00001 19.7957 2.31608 20.5588 2.87869 21.1214C3.4413 21.684 4.20436 22.0001 5.00001 22.0001H19C19.7957 22.0001 20.5587 21.684 21.1213 21.1214C21.6839 20.5588 22 19.7957 22 19.0001V13.0001C22 12.7349 21.8947 12.4805 21.7071 12.293C21.5196 12.1054 21.2652 12.0001 21 12.0001ZM5.00001 20.0001C4.73479 20.0001 4.48044 19.8947 4.2929 19.7072C4.10536 19.5196 4.00001 19.2653 4.00001 19.0001V4.73007L6.00001 5.87007C6.15435 5.95068 6.32589 5.99278 6.50001 5.99278C6.67413 5.99278 6.84567 5.95068 7.00001 5.87007L10 4.15007L13 5.87007C13.1543 5.95068 13.3259 5.99278 13.5 5.99278C13.6741 5.99278 13.8457 5.95068 14 5.87007L16 4.73007V19.0001C16.0027 19.3412 16.0636 19.6794 16.18 20.0001H5.00001ZM20 19.0001C20 19.2653 19.8947 19.5196 19.7071 19.7072C19.5196 19.8947 19.2652 20.0001 19 20.0001C18.7348 20.0001 18.4804 19.8947 18.2929 19.7072C18.1054 19.5196 18 19.2653 18 19.0001V14.0001H20V19.0001ZM13 12.0001H7.00001C6.73479 12.0001 6.48044 12.1054 6.2929 12.293C6.10537 12.4805 6.00001 12.7349 6.00001 13.0001C6.00001 13.2653 6.10537 13.5196 6.2929 13.7072C6.48044 13.8947 6.73479 14.0001 7.00001 14.0001H13C13.2652 14.0001 13.5196 13.8947 13.7071 13.7072C13.8947 13.5196 14 13.2653 14 13.0001C14 12.7349 13.8947 12.4805 13.7071 12.293C13.5196 12.1054 13.2652 12.0001 13 12.0001Z",
    fill: fill
  }));
};

const IconSalaryIn = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M12 12C11.4067 12 10.8266 12.1759 10.3333 12.5056C9.83994 12.8352 9.45542 13.3038 9.22836 13.8519C9.0013 14.4001 8.94189 15.0033 9.05764 15.5853C9.1734 16.1672 9.45912 16.7018 9.87868 17.1213C10.2982 17.5409 10.8328 17.8266 11.4147 17.9424C11.9967 18.0581 12.5999 17.9987 13.1481 17.7716C13.6962 17.5446 14.1648 17.1601 14.4944 16.6667C14.8241 16.1734 15 15.5933 15 15C15 14.2044 14.6839 13.4413 14.1213 12.8787C13.5587 12.3161 12.7956 12 12 12ZM12 16C11.8022 16 11.6089 15.9414 11.4444 15.8315C11.28 15.7216 11.1518 15.5654 11.0761 15.3827C11.0004 15.2 10.9806 14.9989 11.0192 14.8049C11.0578 14.6109 11.153 14.4327 11.2929 14.2929C11.4327 14.153 11.6109 14.0578 11.8049 14.0192C11.9989 13.9806 12.2 14.0004 12.3827 14.0761C12.5654 14.1518 12.7216 14.28 12.8315 14.4444C12.9414 14.6089 13 14.8022 13 15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16ZM11.29 9.71C11.3851 9.80104 11.4972 9.87241 11.62 9.92C11.7397 9.97291 11.8691 10.0002 12 10.0002C12.1309 10.0002 12.2603 9.97291 12.38 9.92C12.5028 9.87241 12.6149 9.80104 12.71 9.71L15 7.46C15.1936 7.26639 15.3024 7.0038 15.3024 6.73C15.3024 6.4562 15.1936 6.19361 15 6C14.8064 5.80639 14.5438 5.69762 14.27 5.69762C13.9962 5.69762 13.7336 5.80639 13.54 6L13 6.59V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V6.59L10.46 6C10.2664 5.80639 10.0038 5.69762 9.73 5.69762C9.4562 5.69762 9.19361 5.80639 9 6C8.80639 6.19361 8.69762 6.4562 8.69762 6.73C8.69762 7.0038 8.80639 7.26639 9 7.46L11.29 9.71ZM19 15C19 14.8022 18.9414 14.6089 18.8315 14.4444C18.7216 14.28 18.5654 14.1518 18.3827 14.0761C18.2 14.0004 17.9989 13.9806 17.8049 14.0192C17.6109 14.0578 17.4327 14.153 17.2929 14.2929C17.153 14.4327 17.0578 14.6109 17.0192 14.8049C16.9806 14.9989 17.0004 15.2 17.0761 15.3827C17.1518 15.5654 17.28 15.7216 17.4444 15.8315C17.6089 15.9414 17.8022 16 18 16C18.2652 16 18.5196 15.8946 18.7071 15.7071C18.8946 15.5196 19 15.2652 19 15ZM20 8H17C16.7348 8 16.4804 8.10536 16.2929 8.29289C16.1054 8.48043 16 8.73478 16 9C16 9.26522 16.1054 9.51957 16.2929 9.70711C16.4804 9.89464 16.7348 10 17 10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V19C21 19.2652 20.8946 19.5196 20.7071 19.7071C20.5196 19.8946 20.2652 20 20 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H7C7.26522 10 7.51957 9.89464 7.70711 9.70711C7.89464 9.51957 8 9.26522 8 9C8 8.73478 7.89464 8.48043 7.70711 8.29289C7.51957 8.10536 7.26522 8 7 8H4C3.20435 8 2.44129 8.31607 1.87868 8.87868C1.31607 9.44129 1 10.2044 1 11V19C1 19.7956 1.31607 20.5587 1.87868 21.1213C2.44129 21.6839 3.20435 22 4 22H20C20.7956 22 21.5587 21.6839 22.1213 21.1213C22.6839 20.5587 23 19.7956 23 19V11C23 10.2044 22.6839 9.44129 22.1213 8.87868C21.5587 8.31607 20.7956 8 20 8ZM5 15C5 15.1978 5.05865 15.3911 5.16853 15.5556C5.27841 15.72 5.43459 15.8482 5.61732 15.9239C5.80004 15.9996 6.00111 16.0194 6.19509 15.9808C6.38907 15.9422 6.56725 15.847 6.70711 15.7071C6.84696 15.5673 6.9422 15.3891 6.98079 15.1951C7.01937 15.0011 6.99957 14.8 6.92388 14.6173C6.84819 14.4346 6.72002 14.2784 6.55557 14.1685C6.39112 14.0586 6.19778 14 6 14C5.73478 14 5.48043 14.1054 5.29289 14.2929C5.10536 14.4804 5 14.7348 5 15Z",
    fill: "#262626"
  }));
};

const IconSalaryOut = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M10.46 5.9999L11 5.4099V8.9999C11 9.26511 11.1054 9.51947 11.2929 9.707C11.4804 9.89454 11.7348 9.9999 12 9.9999C12.2652 9.9999 12.5196 9.89454 12.7071 9.707C12.8946 9.51947 13 9.26511 13 8.9999V5.4099L13.54 5.9599C13.6308 6.06242 13.7416 6.14521 13.8657 6.20313C13.9898 6.26105 14.1244 6.29287 14.2613 6.29662C14.3982 6.30037 14.5344 6.27597 14.6615 6.22493C14.7885 6.17389 14.9038 6.09729 15 5.9999C15.0937 5.90693 15.1681 5.79633 15.2189 5.67447C15.2697 5.55261 15.2958 5.42191 15.2958 5.2899C15.2958 5.15788 15.2697 5.02718 15.2189 4.90532C15.1681 4.78346 15.0937 4.67286 15 4.5799L12.71 2.2899C12.6149 2.19886 12.5028 2.12749 12.38 2.0799C12.1365 1.97988 11.8635 1.97988 11.62 2.0799C11.4972 2.12749 11.3851 2.19886 11.29 2.2899L9 4.5399C8.80639 4.7335 8.69762 4.99609 8.69762 5.2699C8.69762 5.5437 8.80639 5.80629 9 5.9999C9.19361 6.1935 9.4562 6.30227 9.73 6.30227C10.0038 6.30227 10.2664 6.1935 10.46 5.9999ZM12 11.9999C11.4067 11.9999 10.8266 12.1758 10.3333 12.5055C9.83994 12.8351 9.45542 13.3037 9.22836 13.8518C9.0013 14.4 8.94189 15.0032 9.05764 15.5852C9.1734 16.1671 9.45912 16.7017 9.87868 17.1212C10.2982 17.5408 10.8328 17.8265 11.4147 17.9423C11.9967 18.058 12.5999 17.9986 13.1481 17.7715C13.6962 17.5445 14.1648 17.16 14.4944 16.6666C14.8241 16.1733 15 15.5932 15 14.9999C15 14.2042 14.6839 13.4412 14.1213 12.8786C13.5587 12.316 12.7956 11.9999 12 11.9999ZM12 15.9999C11.8022 15.9999 11.6089 15.9412 11.4444 15.8314C11.28 15.7215 11.1518 15.5653 11.0761 15.3826C11.0004 15.1999 10.9806 14.9988 11.0192 14.8048C11.0578 14.6108 11.153 14.4326 11.2929 14.2928C11.4327 14.1529 11.6109 14.0577 11.8049 14.0191C11.9989 13.9805 12.2 14.0003 12.3827 14.076C12.5654 14.1517 12.7216 14.2799 12.8315 14.4443C12.9414 14.6088 13 14.8021 13 14.9999C13 15.2651 12.8946 15.5195 12.7071 15.707C12.5196 15.8945 12.2652 15.9999 12 15.9999ZM5 14.9999C5 15.1977 5.05865 15.391 5.16853 15.5555C5.27841 15.7199 5.43459 15.8481 5.61732 15.9238C5.80004 15.9995 6.00111 16.0193 6.19509 15.9807C6.38907 15.9421 6.56725 15.8469 6.70711 15.707C6.84696 15.5672 6.9422 15.389 6.98079 15.195C7.01937 15.001 6.99957 14.7999 6.92388 14.6172C6.84819 14.4345 6.72002 14.2783 6.55557 14.1684C6.39112 14.0585 6.19778 13.9999 6 13.9999C5.73478 13.9999 5.48043 14.1053 5.29289 14.2928C5.10536 14.4803 5 14.7347 5 14.9999ZM19 14.9999C19 14.8021 18.9414 14.6088 18.8315 14.4443C18.7216 14.2799 18.5654 14.1517 18.3827 14.076C18.2 14.0003 17.9989 13.9805 17.8049 14.0191C17.6109 14.0577 17.4327 14.1529 17.2929 14.2928C17.153 14.4326 17.0578 14.6108 17.0192 14.8048C16.9806 14.9988 17.0004 15.1999 17.0761 15.3826C17.1518 15.5653 17.28 15.7215 17.4444 15.8314C17.6089 15.9412 17.8022 15.9999 18 15.9999C18.2652 15.9999 18.5196 15.8945 18.7071 15.707C18.8946 15.5195 19 15.2651 19 14.9999ZM20 7.9999H16C15.7348 7.9999 15.4804 8.10525 15.2929 8.29279C15.1054 8.48033 15 8.73468 15 8.9999C15 9.26511 15.1054 9.51947 15.2929 9.707C15.4804 9.89454 15.7348 9.9999 16 9.9999H20C20.2652 9.9999 20.5196 10.1053 20.7071 10.2928C20.8946 10.4803 21 10.7347 21 10.9999V18.9999C21 19.2651 20.8946 19.5195 20.7071 19.707C20.5196 19.8945 20.2652 19.9999 20 19.9999H4C3.73478 19.9999 3.48043 19.8945 3.29289 19.707C3.10536 19.5195 3 19.2651 3 18.9999V10.9999C3 10.7347 3.10536 10.4803 3.29289 10.2928C3.48043 10.1053 3.73478 9.9999 4 9.9999H8C8.26522 9.9999 8.51957 9.89454 8.70711 9.707C8.89464 9.51947 9 9.26511 9 8.9999C9 8.73468 8.89464 8.48033 8.70711 8.29279C8.51957 8.10525 8.26522 7.9999 8 7.9999H4C3.20435 7.9999 2.44129 8.31597 1.87868 8.87858C1.31607 9.44118 1 10.2042 1 10.9999V18.9999C1 19.7955 1.31607 20.5586 1.87868 21.1212C2.44129 21.6838 3.20435 21.9999 4 21.9999H20C20.7956 21.9999 21.5587 21.6838 22.1213 21.1212C22.6839 20.5586 23 19.7955 23 18.9999V10.9999C23 10.2042 22.6839 9.44118 22.1213 8.87858C21.5587 8.31597 20.7956 7.9999 20 7.9999Z",
    fill: fill || '#262626'
  }));
};

const IconDiscount = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7.75827 10.7578C8.35162 10.7578 8.93164 10.5818 9.42498 10.2522C9.91833 9.92255 10.3028 9.45401 10.5299 8.90583C10.757 8.35766 10.8164 7.75446 10.7006 7.17251C10.5849 6.59057 10.2992 6.05602 9.87959 5.63646C9.46004 5.21691 8.92549 4.93118 8.34354 4.81543C7.7616 4.69967 7.1584 4.75908 6.61022 4.98615C6.06204 5.21321 5.59351 5.59773 5.26386 6.09107C4.93422 6.58442 4.75827 7.16444 4.75827 7.75778C4.75914 8.55317 5.07549 9.31572 5.63791 9.87814C6.20033 10.4406 6.96289 10.7569 7.75827 10.7578ZM7.75827 6.75778C7.95605 6.75778 8.14939 6.81643 8.31384 6.92631C8.47829 7.0362 8.60646 7.19237 8.68215 7.3751C8.75784 7.55783 8.77764 7.75889 8.73906 7.95287C8.70047 8.14686 8.60523 8.32504 8.46538 8.46489C8.32553 8.60474 8.14734 8.69998 7.95336 8.73857C7.75938 8.77715 7.55832 8.75735 7.37559 8.68166C7.19286 8.60598 7.03668 8.4778 6.9268 8.31335C6.81692 8.1489 6.75827 7.95557 6.75827 7.75778C6.75845 7.49262 6.86386 7.23837 7.05136 7.05087C7.23886 6.86337 7.49311 6.75796 7.75827 6.75778ZM16.2427 13.2422C15.6493 13.2422 15.0693 13.4181 14.5759 13.7478C14.0826 14.0774 13.6981 14.5459 13.471 15.0941C13.244 15.6423 13.1845 16.2455 13.3003 16.8274C13.4161 17.4094 13.7018 17.9439 14.1213 18.3635C14.5409 18.783 15.0754 19.0688 15.6574 19.1845C16.2393 19.3003 16.8425 19.2409 17.3907 19.0138C17.9389 18.7867 18.4074 18.4022 18.7371 17.9089C19.0667 17.4155 19.2427 16.8355 19.2427 16.2422C19.2418 15.4468 18.9254 14.6842 18.363 14.1218C17.8006 13.5594 17.038 13.243 16.2427 13.2422ZM16.2427 17.2422C16.0449 17.2422 15.8515 17.1835 15.6871 17.0736C15.5226 16.9638 15.3945 16.8076 15.3188 16.6248C15.2431 16.4421 15.2233 16.2411 15.2619 16.0471C15.3005 15.8531 15.3957 15.6749 15.5355 15.5351C15.6754 15.3952 15.8536 15.3 16.0476 15.2614C16.2415 15.2228 16.4426 15.2426 16.6253 15.3183C16.8081 15.394 16.9642 15.5221 17.0741 15.6866C17.184 15.851 17.2427 16.0444 17.2427 16.2422C17.2425 16.5073 17.1371 16.7616 16.9496 16.9491C16.7621 17.1366 16.5078 17.242 16.2427 17.2422ZM19.7075 4.29297C19.6146 4.20009 19.5044 4.12641 19.3831 4.07614C19.2618 4.02587 19.1318 4 19.0004 4C18.8691 4 18.7391 4.02587 18.6178 4.07614C18.4965 4.12641 18.3862 4.20009 18.2934 4.29297L4.2934 18.293C4.1996 18.3856 4.12504 18.4959 4.07401 18.6174C4.02299 18.739 3.99651 18.8695 3.9961 19.0013C3.99569 19.1331 4.02135 19.2638 4.07161 19.3856C4.12188 19.5075 4.19575 19.6182 4.28897 19.7115C4.38219 19.8047 4.49293 19.8786 4.61482 19.9288C4.7367 19.9791 4.86731 20.0047 4.99915 20.0043C5.13099 20.0039 5.26144 19.9774 5.383 19.9264C5.50456 19.8753 5.61483 19.8008 5.70746 19.707L19.7075 5.70697C19.8003 5.61414 19.874 5.50393 19.9243 5.38262C19.9745 5.26131 20.0004 5.13128 20.0004 4.99997C20.0004 4.86866 19.9745 4.73864 19.9243 4.61733C19.874 4.49602 19.8003 4.3858 19.7075 4.29297Z",
    fill: "#262626"
  }));
};

const IconCheckInOut = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.7101 9.29019L17.7101 5.29019C17.6169 5.19695 17.5062 5.12299 17.3844 5.07253C17.2626 5.02207 17.132 4.99609 17.0001 4.99609C16.7338 4.99609 16.4784 5.10188 16.2901 5.29019C16.1018 5.47849 15.996 5.73388 15.996 6.00019C15.996 6.26649 16.1018 6.52188 16.2901 6.71019L18.5901 9.00019H7.00014C6.73492 9.00019 6.48057 9.10554 6.29303 9.29308C6.1055 9.48062 6.00014 9.73497 6.00014 10.0002C6.00014 10.2654 6.1055 10.5198 6.29303 10.7073C6.48057 10.8948 6.73492 11.0002 7.00014 11.0002H21.0001C21.1976 10.9992 21.3903 10.9398 21.554 10.8295C21.7177 10.7191 21.8451 10.5628 21.9201 10.3802C21.9967 10.1981 22.0176 9.99736 21.9803 9.80337C21.9429 9.60938 21.8489 9.43081 21.7101 9.29019ZM17.0001 13.0002H3.00014C2.80271 13.0012 2.61 13.0606 2.44628 13.1709C2.28256 13.2812 2.15516 13.4376 2.08014 13.6202C2.00356 13.8023 1.98264 14.003 2.02001 14.197C2.05739 14.391 2.15138 14.5696 2.29014 14.7102L6.29014 18.7102C6.3831 18.8039 6.4937 18.8783 6.61556 18.9291C6.73742 18.9798 6.86813 19.006 7.00014 19.006C7.13215 19.006 7.26286 18.9798 7.38472 18.9291C7.50658 18.8783 7.61718 18.8039 7.71014 18.7102C7.80387 18.6172 7.87826 18.5066 7.92903 18.3848C7.9798 18.2629 8.00594 18.1322 8.00594 18.0002C8.00594 17.8682 7.9798 17.7375 7.92903 17.6156C7.87826 17.4937 7.80387 17.3831 7.71014 17.2902L5.41014 15.0002H17.0001C17.2654 15.0002 17.5197 14.8948 17.7072 14.7073C17.8948 14.5198 18.0001 14.2654 18.0001 14.0002C18.0001 13.735 17.8948 13.4806 17.7072 13.2931C17.5197 13.1055 17.2654 13.0002 17.0001 13.0002Z",
    fill: "#262626"
  }));
};

const IconNews = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M17 11H16C15.7348 11 15.4804 11.1054 15.2929 11.2929C15.1054 11.4804 15 11.7348 15 12C15 12.2652 15.1054 12.5196 15.2929 12.7071C15.4804 12.8946 15.7348 13 16 13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11ZM17 15H16C15.7348 15 15.4804 15.1054 15.2929 15.2929C15.1054 15.4804 15 15.7348 15 16C15 16.2652 15.1054 16.5196 15.2929 16.7071C15.4804 16.8946 15.7348 17 16 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16C18 15.7348 17.8946 15.4804 17.7071 15.2929C17.5196 15.1054 17.2652 15 17 15ZM11 9H17C17.2652 9 17.5196 8.89464 17.7071 8.70711C17.8946 8.51957 18 8.26522 18 8C18 7.73478 17.8946 7.48043 17.7071 7.29289C17.5196 7.10536 17.2652 7 17 7H11C10.7348 7 10.4804 7.10536 10.2929 7.29289C10.1054 7.48043 10 7.73478 10 8C10 8.26522 10.1054 8.51957 10.2929 8.70711C10.4804 8.89464 10.7348 9 11 9ZM21 3H7C6.73478 3 6.48043 3.10536 6.29289 3.29289C6.10536 3.48043 6 3.73478 6 4V7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H18C19.0609 21 20.0783 20.5786 20.8284 19.8284C21.5786 19.0783 22 18.0609 22 17V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM6 18C6 18.2652 5.89464 18.5196 5.70711 18.7071C5.51957 18.8946 5.26522 19 5 19C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V9H6V18ZM20 17C20 17.5304 19.7893 18.0391 19.4142 18.4142C19.0391 18.7893 18.5304 19 18 19H7.82C7.93642 18.6793 7.9973 18.3411 8 18V5H20V17ZM11 13H12C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12C10 12.2652 10.1054 12.5196 10.2929 12.7071C10.4804 12.8946 10.7348 13 11 13ZM11 17H12C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16C10 16.2652 10.1054 16.5196 10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17Z",
    fill: "#262626"
  }));
};

const IconContacts = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M14.81 12.28C15.443 11.6002 15.7996 10.7088 15.81 9.78C15.81 8.77748 15.4118 7.81602 14.7029 7.10714C13.994 6.39825 13.0325 6 12.03 6C11.0275 6 10.066 6.39825 9.35714 7.10714C8.64825 7.81602 8.25 8.77748 8.25 9.78C8.26044 10.7088 8.61702 11.6002 9.25 12.28C8.36865 12.7189 7.61022 13.3699 7.04292 14.1746C6.47561 14.9793 6.11723 15.9124 6 16.89C5.97083 17.1552 6.0482 17.4212 6.21511 17.6293C6.38202 17.8375 6.62478 17.9708 6.89 18C7.15522 18.0292 7.42116 17.9518 7.62932 17.7849C7.83749 17.618 7.97083 17.3752 8 17.11C8.11933 16.1411 8.58885 15.2494 9.32009 14.6027C10.0513 13.956 10.9938 13.599 11.97 13.599C12.9462 13.599 13.8887 13.956 14.6199 14.6027C15.3512 15.2494 15.8207 16.1411 15.94 17.11C15.9678 17.3664 16.0936 17.6022 16.2911 17.768C16.4887 17.9339 16.7426 18.017 17 18H17.11C17.3721 17.9698 17.6117 17.8373 17.7766 17.6313C17.9414 17.4252 18.0181 17.1624 17.99 16.9C17.8815 15.9276 17.5344 14.997 16.9796 14.191C16.4248 13.3851 15.6796 12.7286 14.81 12.28ZM12 11.56C11.6479 11.56 11.3038 11.4556 11.0111 11.26C10.7184 11.0644 10.4902 10.7864 10.3555 10.4612C10.2208 10.1359 10.1855 9.77803 10.2542 9.43274C10.3229 9.08745 10.4924 8.77029 10.7414 8.52135C10.9903 8.27241 11.3075 8.10288 11.6527 8.0342C11.998 7.96552 12.3559 8.00077 12.6812 8.13549C13.0064 8.27022 13.2844 8.49837 13.48 8.79109C13.6756 9.0838 13.78 9.42795 13.78 9.78C13.78 10.2521 13.5925 10.7048 13.2586 11.0387C12.9248 11.3725 12.4721 11.56 12 11.56ZM19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z",
    fill: "#262626"
  }));
};

const IconTask = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7 14H9C9.26522 14 9.51957 13.8946 9.70711 13.7071C9.89464 13.5196 10 13.2652 10 13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM13 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H13C13.2652 18 13.5196 17.8946 13.7071 17.7071C13.8946 17.5196 14 17.2652 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16ZM19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM14 4V7.29L12.49 6.45C12.338 6.36223 12.1655 6.31603 11.99 6.31603C11.8145 6.31603 11.642 6.36223 11.49 6.45L10 7.29V4H14ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00105 9.17451 8.04776 9.34571 8.13547 9.49658C8.22319 9.64746 8.34886 9.77274 8.5 9.86C8.65202 9.94777 8.82446 9.99397 9 9.99397C9.17554 9.99397 9.34798 9.94777 9.5 9.86L12 8.47L14.51 9.87C14.6595 9.9547 14.8282 9.99947 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z",
    fill: "#262626"
  }));
};

const IconForm = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M13 18H3C2.73478 18 2.48043 18.1054 2.29289 18.2929C2.10536 18.4804 2 18.7348 2 19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H13C13.2652 20 13.5196 19.8946 13.7071 19.7071C13.8946 19.5196 14 19.2652 14 19C14 18.7348 13.8946 18.4804 13.7071 18.2929C13.5196 18.1054 13.2652 18 13 18ZM3 8H11C11.2652 8 11.5196 7.89464 11.7071 7.70711C11.8946 7.51957 12 7.26522 12 7C12 6.73478 11.8946 6.48043 11.7071 6.29289C11.5196 6.10536 11.2652 6 11 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8ZM3 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H3C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12ZM21 14H3C2.73478 14 2.48043 14.1054 2.29289 14.2929C2.10536 14.4804 2 14.7348 2 15C2 15.2652 2.10536 15.5196 2.29289 15.7071C2.48043 15.8946 2.73478 16 3 16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15C22 14.7348 21.8946 14.4804 21.7071 14.2929C21.5196 14.1054 21.2652 14 21 14ZM21 4H15C14.7348 4 14.4804 4.10536 14.2929 4.29289C14.1054 4.48043 14 4.73478 14 5V11C14 11.2652 14.1054 11.5196 14.2929 11.7071C14.4804 11.8946 14.7348 12 15 12H21C21.2652 12 21.5196 11.8946 21.7071 11.7071C21.8946 11.5196 22 11.2652 22 11V5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4ZM20 10H16V6H20V10Z",
    fill: "#262626"
  }));
};

const IconAnalytics = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19 12H12V5C12 4.4 11.6 4 11 4C6 4 2 8 2 13C2 18 6 22 11 22C16 22 20 18 20 13C20 12.4 19.6 12 19 12ZM12 19.9C8.2 20.5 4.6 17.8 4.1 14C3.5 10.2 6.2 6.6 10 6.1V13C10 13.6 10.4 14 11 14H17.9C17.5 17.1 15.1 19.5 12 19.9ZM15 2C14.4 2 14 2.4 14 3V9C14 9.6 14.4 10 15 10H21C21.6 10 22 9.6 22 9C22 5.1 18.9 2 15 2ZM16 8V4.1C18 4.5 19.5 6 19.9 8H16Z",
    fill: fill || '#262626'
  }));
};

const IconExpense = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22 17H2C1.73478 17 1.48043 17.1054 1.29289 17.2929C1.10536 17.4804 1 17.7348 1 18C1 18.2652 1.10536 18.5196 1.29289 18.7071C1.48043 18.8946 1.73478 19 2 19H22C22.2652 19 22.5196 18.8946 22.7071 18.7071C22.8946 18.5196 23 18.2652 23 18C23 17.7348 22.8946 17.4804 22.7071 17.2929C22.5196 17.1054 22.2652 17 22 17ZM22 21H2C1.73478 21 1.48043 21.1054 1.29289 21.2929C1.10536 21.4804 1 21.7348 1 22C1 22.2652 1.10536 22.5196 1.29289 22.7071C1.48043 22.8946 1.73478 23 2 23H22C22.2652 23 22.5196 22.8946 22.7071 22.7071C22.8946 22.5196 23 22.2652 23 22C23 21.7348 22.8946 21.4804 22.7071 21.2929C22.5196 21.1054 22.2652 21 22 21ZM6 7C5.80222 7 5.60888 7.05865 5.44443 7.16853C5.27998 7.27841 5.15181 7.43459 5.07612 7.61732C5.00043 7.80004 4.98063 8.00111 5.01921 8.19509C5.0578 8.38907 5.15304 8.56725 5.29289 8.70711C5.43275 8.84696 5.61093 8.9422 5.80491 8.98079C5.99889 9.01937 6.19996 8.99957 6.38268 8.92388C6.56541 8.84819 6.72159 8.72002 6.83147 8.55557C6.94135 8.39112 7 8.19778 7 8C7 7.73478 6.89464 7.48043 6.70711 7.29289C6.51957 7.10536 6.26522 7 6 7ZM20 1H4C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H20C20.7956 15 21.5587 14.6839 22.1213 14.1213C22.6839 13.5587 23 12.7956 23 12V4C23 3.20435 22.6839 2.44129 22.1213 1.87868C21.5587 1.31607 20.7956 1 20 1ZM21 12C21 12.2652 20.8946 12.5196 20.7071 12.7071C20.5196 12.8946 20.2652 13 20 13H4C3.73478 13 3.48043 12.8946 3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V12ZM12 5C11.4067 5 10.8266 5.17595 10.3333 5.50559C9.83994 5.83524 9.45542 6.30377 9.22836 6.85195C9.0013 7.40013 8.94189 8.00333 9.05764 8.58527C9.1734 9.16721 9.45912 9.70176 9.87868 10.1213C10.2982 10.5409 10.8328 10.8266 11.4147 10.9424C11.9967 11.0581 12.5999 10.9987 13.1481 10.7716C13.6962 10.5446 14.1648 10.1601 14.4944 9.66671C14.8241 9.17336 15 8.59334 15 8C15 7.20435 14.6839 6.44129 14.1213 5.87868C13.5587 5.31607 12.7956 5 12 5ZM12 9C11.8022 9 11.6089 8.94135 11.4444 8.83147C11.28 8.72159 11.1518 8.56541 11.0761 8.38268C11.0004 8.19996 10.9806 7.99889 11.0192 7.80491C11.0578 7.61093 11.153 7.43275 11.2929 7.29289C11.4327 7.15304 11.6109 7.0578 11.8049 7.01921C11.9989 6.98063 12.2 7.00043 12.3827 7.07612C12.5654 7.15181 12.7216 7.27998 12.8315 7.44443C12.9414 7.60888 13 7.80222 13 8C13 8.26522 12.8946 8.51957 12.7071 8.70711C12.5196 8.89464 12.2652 9 12 9ZM18 7C17.8022 7 17.6089 7.05865 17.4444 7.16853C17.28 7.27841 17.1518 7.43459 17.0761 7.61732C17.0004 7.80004 16.9806 8.00111 17.0192 8.19509C17.0578 8.38907 17.153 8.56725 17.2929 8.70711C17.4327 8.84696 17.6109 8.9422 17.8049 8.98079C17.9989 9.01937 18.2 8.99957 18.3827 8.92388C18.5654 8.84819 18.7216 8.72002 18.8315 8.55557C18.9414 8.39112 19 8.19778 19 8C19 7.73478 18.8946 7.48043 18.7071 7.29289C18.5196 7.10536 18.2652 7 18 7Z",
    fill: "#262626"
  }));
};

const IconVacation = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16.9995 9.27979C17.3951 9.27979 17.7818 9.16249 18.1107 8.94272C18.4396 8.72296 18.6959 8.41061 18.8473 8.04515C18.9987 7.6797 19.0383 7.27757 18.9611 6.88961C18.8839 6.50164 18.6934 6.14528 18.4137 5.86557C18.134 5.58587 17.7777 5.39539 17.3897 5.31822C17.0017 5.24105 16.5996 5.28065 16.2342 5.43203C15.8687 5.5834 15.5563 5.83975 15.3366 6.16865C15.1168 6.49754 14.9995 6.88422 14.9995 7.27979C14.9995 7.81022 15.2102 8.31893 15.5853 8.694C15.9604 9.06907 16.4691 9.27979 16.9995 9.27979ZM2.70952 13.9198C2.90768 13.9831 3.09871 14.0669 3.27952 14.1698C3.90145 14.5336 4.609 14.7253 5.32952 14.7253C6.05005 14.7253 6.75759 14.5336 7.37952 14.1698C7.7706 13.9508 8.21132 13.8358 8.65952 13.8358C9.10773 13.8358 9.54845 13.9508 9.93952 14.1698L10.1495 14.2698C10.7563 14.5652 11.4262 14.7078 12.1007 14.6851C12.7752 14.6625 13.4339 14.4753 14.0195 14.1398C14.4106 13.9208 14.8513 13.8058 15.2995 13.8058C15.7477 13.8058 16.1884 13.9208 16.5795 14.1398C17.2133 14.502 17.9296 14.6948 18.6595 14.6998C19.3639 14.6925 20.0538 14.4993 20.6595 14.1398C20.8403 14.0369 21.0314 13.9531 21.2295 13.8898C21.3773 13.8796 21.521 13.8367 21.6502 13.7642C21.7794 13.6917 21.8909 13.5914 21.9766 13.4706C22.0623 13.3497 22.1201 13.2113 22.1457 13.0654C22.1714 12.9195 22.1643 12.7697 22.125 12.6269C22.0857 12.484 22.0152 12.3517 21.9185 12.2395C21.8218 12.1272 21.7013 12.0379 21.5659 11.9779C21.4304 11.9178 21.2833 11.8887 21.1352 11.8925C20.9871 11.8963 20.8417 11.9329 20.7095 11.9998C20.3606 12.1081 20.0251 12.2557 19.7095 12.4398C19.3903 12.6241 19.0282 12.7211 18.6595 12.7211C18.2909 12.7211 17.9288 12.6241 17.6095 12.4398C16.9168 12.049 16.1349 11.8437 15.3395 11.8437C14.5442 11.8437 13.7623 12.049 13.0695 12.4398C12.9754 12.4858 12.8786 12.5259 12.7795 12.5598L14.3395 10.9998C14.3753 10.9535 14.4055 10.9031 14.4295 10.8498C14.4748 10.8006 14.515 10.747 14.5495 10.6898C14.5542 10.6265 14.5542 10.563 14.5495 10.4998C14.5552 10.4366 14.5552 10.373 14.5495 10.3098C14.5543 10.2499 14.5543 10.1897 14.5495 10.1298C14.5552 10.0666 14.5552 10.003 14.5495 9.93979C14.5199 9.881 14.4865 9.82421 14.4495 9.76979C14.4236 9.71218 14.3899 9.65836 14.3495 9.60979L11.2795 6.27979C11.1988 6.19173 11.1042 6.11743 10.9995 6.05979C10.9298 6.05056 10.8592 6.05056 10.7895 6.05979C10.7332 6.05064 10.6758 6.05064 10.6195 6.05979C10.4864 6.00622 10.3423 5.98564 10.1995 5.99979L6.65952 7.31979C6.41029 7.41005 6.20709 7.59558 6.09458 7.83559C5.98207 8.07561 5.96946 8.35048 6.05952 8.59979C6.14979 8.84902 6.33531 9.05222 6.57533 9.16473C6.81535 9.27724 7.09022 9.28985 7.33952 9.19979L10.2695 8.12979L12.2695 10.2498L10.3695 12.1498C9.73293 11.9023 9.04938 11.7991 8.36809 11.8475C7.6868 11.8959 7.02473 12.0948 6.42952 12.4298C6.11028 12.6141 5.74815 12.7111 5.37952 12.7111C5.0109 12.7111 4.64877 12.6141 4.32952 12.4298C4.01394 12.2457 3.67846 12.0981 3.32952 11.9898C3.20158 11.942 3.0652 11.921 2.92882 11.928C2.79243 11.935 2.65892 11.9698 2.53652 12.0304C2.41411 12.091 2.30541 12.1759 2.21711 12.2801C2.12881 12.3843 2.06279 12.5055 2.02311 12.6361C1.98342 12.7668 1.97093 12.9042 1.98639 13.0399C2.00185 13.1756 2.04494 13.3067 2.113 13.4251C2.18106 13.5435 2.27265 13.6467 2.38213 13.7283C2.4916 13.81 2.61664 13.8683 2.74952 13.8998L2.70952 13.9198ZM20.7095 17.0098C20.3606 17.1181 20.0251 17.2657 19.7095 17.4498C19.3903 17.6341 19.0282 17.7311 18.6595 17.7311C18.2909 17.7311 17.9288 17.6341 17.6095 17.4498C16.9168 17.059 16.1349 16.8537 15.3395 16.8537C14.5442 16.8537 13.7623 17.059 13.0695 17.4498C12.7476 17.6368 12.3819 17.7354 12.0095 17.7354C11.6372 17.7354 11.2715 17.6368 10.9495 17.4498C10.2568 17.059 9.47489 16.8537 8.67952 16.8537C7.88416 16.8537 7.10226 17.059 6.40952 17.4498C6.09028 17.6341 5.72815 17.7311 5.35952 17.7311C4.9909 17.7311 4.62877 17.6341 4.30952 17.4498C3.99394 17.2657 3.65846 17.1181 3.30952 17.0098C3.18158 16.962 3.0452 16.941 2.90882 16.948C2.77243 16.955 2.63892 16.9898 2.51652 17.0504C2.39411 17.111 2.28541 17.1959 2.19711 17.3001C2.10881 17.4043 2.04279 17.5255 2.00311 17.6561C1.96342 17.7868 1.95093 17.9242 1.96639 18.0599C1.98185 18.1956 2.02494 18.3267 2.093 18.4451C2.16106 18.5635 2.25265 18.6667 2.36213 18.7483C2.4716 18.83 2.59664 18.8883 2.72952 18.9198C2.92768 18.9831 3.11871 19.0669 3.29952 19.1698C3.92145 19.5336 4.629 19.7253 5.34952 19.7253C6.07005 19.7253 6.77759 19.5336 7.39952 19.1698C7.7906 18.9508 8.23132 18.8358 8.67952 18.8358C9.12773 18.8358 9.56845 18.9508 9.95952 19.1698C10.5868 19.5285 11.2969 19.7172 12.0195 19.7172C12.7421 19.7172 13.4522 19.5285 14.0795 19.1698C14.4706 18.9508 14.9113 18.8358 15.3595 18.8358C15.8077 18.8358 16.2484 18.9508 16.6395 19.1698C17.2733 19.532 17.9896 19.7248 18.7195 19.7298C19.4239 19.7225 20.1138 19.5293 20.7195 19.1698C20.9003 19.0669 21.0914 18.9831 21.2895 18.9198C21.4156 18.8817 21.5329 18.8192 21.6348 18.7357C21.7367 18.6523 21.8212 18.5496 21.8834 18.4335C21.9456 18.3175 21.9844 18.1903 21.9974 18.0592C22.0105 17.9282 21.9976 17.7959 21.9595 17.6698C21.9214 17.5437 21.8589 17.4264 21.7755 17.3245C21.692 17.2226 21.5894 17.1381 21.4733 17.0759C21.3572 17.0137 21.23 16.9749 21.099 16.9619C20.9679 16.9488 20.8356 16.9617 20.7095 16.9998V17.0098Z",
    fill: "#262626"
  }));
};

const IconExtra = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M3 8H21C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8ZM21 16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM21 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z",
    fill: "#262626"
  }));
};

const IconSchool = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M14 8H15C15.2652 8 15.5196 7.89464 15.7071 7.70711C15.8946 7.51957 16 7.26522 16 7C16 6.73478 15.8946 6.48043 15.7071 6.29289C15.5196 6.10536 15.2652 6 15 6H14C13.7348 6 13.4804 6.10536 13.2929 6.29289C13.1054 6.48043 13 6.73478 13 7C13 7.26522 13.1054 7.51957 13.2929 7.70711C13.4804 7.89464 13.7348 8 14 8ZM14 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10H14C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11C13 11.2652 13.1054 11.5196 13.2929 11.7071C13.4804 11.8946 13.7348 12 14 12ZM9 8H10C10.2652 8 10.5196 7.89464 10.7071 7.70711C10.8946 7.51957 11 7.26522 11 7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6H9C8.73478 6 8.48043 6.10536 8.29289 6.29289C8.10536 6.48043 8 6.73478 8 7C8 7.26522 8.10536 7.51957 8.29289 7.70711C8.48043 7.89464 8.73478 8 9 8ZM9 12H10C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10H9C8.73478 10 8.48043 10.1054 8.29289 10.2929C8.10536 10.4804 8 10.7348 8 11C8 11.2652 8.10536 11.5196 8.29289 11.7071C8.48043 11.8946 8.73478 12 9 12ZM21 20H20V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V20H3C2.73478 20 2.48043 20.1054 2.29289 20.2929C2.10536 20.4804 2 20.7348 2 21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21C22 20.7348 21.8946 20.4804 21.7071 20.2929C21.5196 20.1054 21.2652 20 21 20ZM13 20H11V16H13V20ZM18 20H15V15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14H10C9.73478 14 9.48043 14.1054 9.29289 14.2929C9.10536 14.4804 9 14.7348 9 15V20H6V4H18V20Z",
    fill: "#262626"
  }));
};

const IconChatBot = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M9 15C8.80222 15 8.60888 15.0586 8.44443 15.1685C8.27998 15.2784 8.15181 15.4346 8.07612 15.6173C8.00043 15.8 7.98063 16.0011 8.01921 16.1951C8.0578 16.3891 8.15304 16.5673 8.29289 16.7071C8.43275 16.847 8.61093 16.9422 8.80491 16.9808C8.99889 17.0194 9.19996 16.9996 9.38268 16.9239C9.56541 16.8482 9.72159 16.72 9.83147 16.5556C9.94135 16.3911 10 16.1978 10 16C10 15.7348 9.89464 15.4804 9.70711 15.2929C9.51957 15.1054 9.26522 15 9 15ZM2 14C1.73478 14 1.48043 14.1054 1.29289 14.2929C1.10536 14.4804 1 14.7348 1 15V17C1 17.2652 1.10536 17.5196 1.29289 17.7071C1.48043 17.8946 1.73478 18 2 18C2.26522 18 2.51957 17.8946 2.70711 17.7071C2.89464 17.5196 3 17.2652 3 17V15C3 14.7348 2.89464 14.4804 2.70711 14.2929C2.51957 14.1054 2.26522 14 2 14ZM22 14C21.7348 14 21.4804 14.1054 21.2929 14.2929C21.1054 14.4804 21 14.7348 21 15V17C21 17.2652 21.1054 17.5196 21.2929 17.7071C21.4804 17.8946 21.7348 18 22 18C22.2652 18 22.5196 17.8946 22.7071 17.7071C22.8946 17.5196 23 17.2652 23 17V15C23 14.7348 22.8946 14.4804 22.7071 14.2929C22.5196 14.1054 22.2652 14 22 14ZM17 7H13V5.72C13.3023 5.54549 13.5536 5.29491 13.7291 4.99317C13.9045 4.69143 13.9979 4.34903 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4C10.0021 4.34903 10.0955 4.69143 10.2709 4.99317C10.4464 5.29491 10.6977 5.54549 11 5.72V7H7C6.20435 7 5.44129 7.31607 4.87868 7.87868C4.31607 8.44129 4 9.20435 4 10V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V10C20 9.20435 19.6839 8.44129 19.1213 7.87868C18.5587 7.31607 17.7956 7 17 7ZM13.72 9L13.22 11H10.78L10.28 9H13.72ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H8.22L9 12.24C9.05475 12.4619 9.18385 12.6583 9.36579 12.7966C9.54774 12.9349 9.77157 13.0067 10 13H14C14.2284 13.0067 14.4523 12.9349 14.6342 12.7966C14.8162 12.6583 14.9452 12.4619 15 12.24L15.78 9H17C17.2652 9 17.5196 9.10536 17.7071 9.29289C17.8946 9.48043 18 9.73478 18 10V19ZM15 15C14.8022 15 14.6089 15.0586 14.4444 15.1685C14.28 15.2784 14.1518 15.4346 14.0761 15.6173C14.0004 15.8 13.9806 16.0011 14.0192 16.1951C14.0578 16.3891 14.153 16.5673 14.2929 16.7071C14.4327 16.847 14.6109 16.9422 14.8049 16.9808C14.9989 17.0194 15.2 16.9996 15.3827 16.9239C15.5654 16.8482 15.7216 16.72 15.8315 16.5556C15.9414 16.3911 16 16.1978 16 16C16 15.7348 15.8946 15.4804 15.7071 15.2929C15.5196 15.1054 15.2652 15 15 15Z",
    fill: "#262626"
  }));
};

const IconVocab = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16 6C16 5.73478 15.8946 5.48043 15.7071 5.29289C15.5196 5.10536 15.2652 5 15 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6C2 6.26522 2.10536 6.51957 2.29289 6.70711C2.48043 6.89464 2.73478 7 3 7H8V18C8 18.2652 8.10536 18.5196 8.29289 18.7071C8.48043 18.8946 8.73478 19 9 19C9.26522 19 9.51957 18.8946 9.70711 18.7071C9.89464 18.5196 10 18.2652 10 18V7H15C15.2652 7 15.5196 6.89464 15.7071 6.70711C15.8946 6.51957 16 6.26522 16 6ZM21 11H15C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.2652 14.1054 12.5196 14.2929 12.7071C14.4804 12.8946 14.7348 13 15 13H17V18C17 18.2652 17.1054 18.5196 17.2929 18.7071C17.4804 18.8946 17.7348 19 18 19C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z",
    fill: "#262626"
  }));
};

const IconFeature = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.3803 5.75992C21.3462 5.63223 21.2871 5.51257 21.2064 5.40786C21.1257 5.30316 21.0251 5.21549 20.9103 5.14992L15.7103 2.14992C15.5968 2.08339 15.4712 2.03992 15.3409 2.022C15.2105 2.00409 15.0779 2.01209 14.9506 2.04553C14.8233 2.07897 14.7039 2.13721 14.5992 2.2169C14.4945 2.29659 14.4065 2.39616 14.3403 2.50992L12.0003 6.56992L9.66034 2.50992C9.59417 2.39616 9.50621 2.29659 9.40149 2.2169C9.29676 2.13721 9.17734 2.07897 9.05007 2.04553C8.92279 2.01209 8.79017 2.00409 8.6598 2.022C8.52943 2.03992 8.40387 2.08339 8.29034 2.14992L3.09034 5.14992C2.97557 5.21549 2.87494 5.30316 2.79427 5.40786C2.71359 5.51257 2.65448 5.63223 2.62034 5.75992C2.55415 6.01337 2.59006 6.28266 2.72034 6.50992L6.72034 13.3399C6.27408 14.1575 6.02738 15.0689 6.00034 15.9999C5.99796 16.9082 6.20182 17.8052 6.59656 18.6232C6.99129 19.4412 7.5666 20.159 8.27909 20.7223C8.99159 21.2856 9.82268 21.6798 10.7097 21.8752C11.5967 22.0706 12.5165 22.062 13.3998 21.8502C14.283 21.6383 15.1066 21.2287 15.8085 20.6522C16.5104 20.0757 17.0722 19.3474 17.4517 18.5222C17.8311 17.6969 18.0183 16.7963 17.999 15.8882C17.9797 14.9801 17.7545 14.0883 17.3403 13.2799L21.2403 6.51992C21.3129 6.40886 21.3627 6.28447 21.3867 6.15399C21.4108 6.02351 21.4086 5.88955 21.3803 5.75992ZM5.00034 6.37992L8.46034 4.37992L11.6803 9.99992C10.3078 10.0847 9.00712 10.6431 8.00034 11.5799L5.00034 6.37992ZM12.0003 19.9999C10.9395 19.9999 9.92206 19.5785 9.17191 18.8283C8.42176 18.0782 8.00034 17.0608 8.00034 15.9999C8.00034 14.9391 8.42176 13.9216 9.17191 13.1715C9.92206 12.4213 10.9395 11.9999 12.0003 11.9999C13.0612 11.9999 14.0786 12.4213 14.8288 13.1715C15.5789 13.9216 16.0003 14.9391 16.0003 15.9999C16.0003 17.0608 15.5789 18.0782 14.8288 18.8283C14.0786 19.5785 13.0612 19.9999 12.0003 19.9999ZM16.0003 11.5499C15.4574 11.054 14.8266 10.664 14.1403 10.3999L13.1603 8.56992L15.5803 4.37992L19.0403 6.37992L16.0003 11.5499Z",
    fill: "#262626"
  }));
};

const IconExceptions = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M8.5 17H5.91406L6.20706 16.707C6.39262 16.5191 6.4963 16.2654 6.49547 16.0013C6.49463 15.7372 6.38934 15.4841 6.20259 15.2974C6.01585 15.1107 5.7628 15.0054 5.49871 15.0046C5.23461 15.0037 4.98091 15.1074 4.793 15.293L2.7933 17.2927C2.60648 17.4807 2.50163 17.735 2.50163 18C2.50163 18.2651 2.60648 18.5194 2.7933 18.7074L4.793 20.707C4.98109 20.8917 5.23451 20.9947 5.49812 20.9935C5.76174 20.9923 6.01422 20.887 6.20063 20.7006C6.38703 20.5142 6.49228 20.2617 6.49348 19.9981C6.49467 19.7345 6.39171 19.4811 6.207 19.293L5.91406 19H8.5C8.76522 19 9.01957 18.8946 9.20711 18.7071C9.39464 18.5196 9.5 18.2652 9.5 18C9.5 17.7348 9.39464 17.4804 9.20711 17.2929C9.01957 17.1054 8.76522 17 8.5 17ZM21.2067 17.2927L19.207 15.293C19.0189 15.1083 18.7655 15.0053 18.5019 15.0065C18.2383 15.0077 17.9858 15.113 17.7994 15.2994C17.613 15.4858 17.5077 15.7383 17.5065 16.0019C17.5053 16.2655 17.6083 16.5189 17.793 16.707L18.086 17H15.5C15.2348 17 14.9804 17.1054 14.7929 17.2929C14.6054 17.4804 14.5 17.7348 14.5 18C14.5 18.2652 14.6054 18.5196 14.7929 18.7071C14.9804 18.8946 15.2348 19 15.5 19H18.0859L17.7929 19.293C17.6991 19.3856 17.6246 19.4959 17.5736 19.6175C17.5225 19.739 17.496 19.8695 17.4956 20.0013C17.4952 20.1332 17.5209 20.2638 17.5711 20.3857C17.6214 20.5075 17.6953 20.6183 17.7885 20.7115C17.8817 20.8047 17.9925 20.8786 18.1144 20.9288C18.2362 20.9791 18.3669 21.0048 18.4987 21.0043C18.6305 21.0039 18.761 20.9774 18.8825 20.9264C19.0041 20.8754 19.1144 20.8008 19.207 20.707L21.2067 18.7073C21.3935 18.5193 21.4984 18.265 21.4984 18C21.4984 17.7349 21.3935 17.4806 21.2067 17.2926L21.2067 17.2927ZM20.6403 9.77179C21.1913 9.14291 21.4966 8.33614 21.5 7.5C21.5 6.57174 21.1313 5.6815 20.4749 5.02513C19.8185 4.36875 18.9283 4 18 4C17.0717 4 16.1815 4.36875 15.5251 5.02513C14.8687 5.6815 14.5 6.57174 14.5 7.5C14.5034 8.33614 14.8087 9.14291 15.3597 9.77179C14.6397 10.2182 14.0453 10.8406 13.6324 11.5804C13.2196 12.3201 13.0019 13.1528 13 14C13 14.2652 13.1054 14.5196 13.2929 14.7071C13.4804 14.8946 13.7348 15 14 15C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14C15 13.2044 15.3161 12.4413 15.8787 11.8787C16.4413 11.3161 17.2044 11 18 11C18.7956 11 19.5587 11.3161 20.1213 11.8787C20.6839 12.4413 21 13.2044 21 14C21 14.2652 21.1054 14.5196 21.2929 14.7071C21.4804 14.8946 21.7348 15 22 15C22.2652 15 22.5196 14.8946 22.7071 14.7071C22.8946 14.5196 23 14.2652 23 14C22.9981 13.1528 22.7804 12.3201 22.3676 11.5804C21.9547 10.8406 21.3603 10.2182 20.6403 9.77179ZM18 9C17.7033 9 17.4133 8.91203 17.1666 8.7472C16.92 8.58238 16.7277 8.34811 16.6142 8.07403C16.5007 7.79994 16.4709 7.49834 16.5288 7.20736C16.5867 6.91639 16.7296 6.64912 16.9393 6.43934C17.1491 6.22956 17.4164 6.0867 17.7074 6.02882C17.9983 5.97094 18.2999 6.00065 18.574 6.11418C18.8481 6.22771 19.0824 6.41997 19.2472 6.66664C19.412 6.91332 19.5 7.20333 19.5 7.5C19.4996 7.89769 19.3414 8.27897 19.0602 8.56018C18.779 8.84139 18.3977 8.99957 18 9ZM8.64026 9.77179C9.1913 9.14291 9.49662 8.33614 9.5 7.5C9.5 6.57174 9.13125 5.6815 8.47487 5.02513C7.8185 4.36875 6.92826 4 6 4C5.07174 4 4.1815 4.36875 3.52513 5.02513C2.86875 5.6815 2.5 6.57174 2.5 7.5C2.50338 8.33614 2.8087 9.14291 3.35974 9.77179C2.63973 10.2182 2.04527 10.8406 1.63242 11.5804C1.21957 12.3201 1.00192 13.1528 1 14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15C2.26522 15 2.51957 14.8946 2.70711 14.7071C2.89464 14.5196 3 14.2652 3 14C3 13.2044 3.31607 12.4413 3.87868 11.8787C4.44129 11.3161 5.20435 11 6 11C6.79565 11 7.55871 11.3161 8.12132 11.8787C8.68393 12.4413 9 13.2044 9 14C9 14.2652 9.10536 14.5196 9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C10.9981 13.1528 10.7804 12.3201 10.3676 11.5804C9.95473 10.8406 9.36027 10.2182 8.64026 9.77179ZM6 9C5.70333 9 5.41332 8.91203 5.16664 8.7472C4.91997 8.58238 4.72771 8.34811 4.61418 8.07403C4.50065 7.79994 4.47094 7.49834 4.52882 7.20736C4.5867 6.91639 4.72956 6.64912 4.93934 6.43934C5.14912 6.22956 5.41639 6.0867 5.70736 6.02882C5.99834 5.97094 6.29994 6.00065 6.57403 6.11418C6.84811 6.22771 7.08238 6.41997 7.2472 6.66664C7.41203 6.91332 7.5 7.20333 7.5 7.5C7.49957 7.89769 7.34139 8.27897 7.06018 8.56018C6.77897 8.84139 6.39769 8.99957 6 9Z",
    fill: "#262626"
  }));
};

const IconInternational = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.0553 12H19.0553C18.7901 12 18.5357 12.1054 18.3482 12.2929C18.1606 12.4804 18.0553 12.7348 18.0553 13C18.0553 13.2652 18.1606 13.5196 18.3482 13.7071C18.5357 13.8946 18.7901 14 19.0553 14V16H17.871C17.9896 15.6798 18.0519 15.3415 18.0553 15C18.0554 14.3396 17.8375 13.6976 17.4355 13.1736C17.0335 12.6497 16.4698 12.273 15.8319 12.1021C15.194 11.9313 14.5175 11.9757 13.9074 12.2285C13.2973 12.4813 12.7877 12.9285 12.4576 13.5005C12.3913 13.6143 12.3482 13.74 12.3306 13.8705C12.3131 14.0011 12.3215 14.1338 12.3553 14.261C12.3892 14.3883 12.4479 14.5076 12.528 14.6121C12.6081 14.7166 12.708 14.8043 12.8221 14.8701C12.9362 14.9359 13.0621 14.9785 13.1927 14.9954C13.3233 15.0124 13.456 15.0034 13.5831 14.969C13.7102 14.9346 13.8292 14.8754 13.9334 14.7948C14.0376 14.7142 14.1248 14.6139 14.1901 14.4995C14.2779 14.3477 14.404 14.2217 14.5559 14.1341C14.7077 14.0464 14.88 14.0002 15.0553 14C15.3205 14 15.5749 14.1054 15.7624 14.2929C15.9499 14.4804 16.0553 14.7348 16.0553 15C16.0553 15.2652 15.9499 15.5196 15.7624 15.7071C15.5749 15.8946 15.3205 16 15.0553 16C14.7901 16 14.5357 16.1054 14.3482 16.2929C14.1606 16.4804 14.0553 16.7348 14.0553 17C14.0553 17.2652 14.1606 17.5196 14.3482 17.7071C14.5357 17.8946 14.7901 18 15.0553 18C15.3205 18 15.5749 18.1054 15.7624 18.2929C15.9499 18.4804 16.0553 18.7348 16.0553 19C16.0553 19.2652 15.9499 19.5196 15.7624 19.7071C15.5749 19.8946 15.3205 20 15.0553 20C14.88 19.9998 14.7077 19.9536 14.5559 19.8659C14.404 19.7783 14.2779 19.6522 14.1901 19.5005C14.1248 19.3861 14.0376 19.2858 13.9334 19.2052C13.8292 19.1246 13.7102 19.0654 13.5831 19.031C13.456 18.9966 13.3233 18.9876 13.1927 19.0045C13.0621 19.0215 12.9362 19.0641 12.8221 19.1299C12.708 19.1957 12.6081 19.2834 12.528 19.3879C12.4479 19.4924 12.3892 19.6117 12.3553 19.739C12.3215 19.8662 12.3131 19.9989 12.3306 20.1294C12.3482 20.26 12.3913 20.3857 12.4576 20.4995C12.7877 21.0715 13.2973 21.5186 13.9074 21.7715C14.5175 22.0243 15.194 22.0687 15.8319 21.8978C16.4698 21.7269 17.0335 21.3503 17.4355 20.8264C17.8375 20.3024 18.0554 19.6604 18.0553 19C18.0519 18.6585 17.9896 18.3202 17.871 18H19.0553V21C19.0553 21.2652 19.1606 21.5196 19.3482 21.7071C19.5357 21.8946 19.7901 22 20.0553 22C20.3205 22 20.5749 21.8946 20.7624 21.7071C20.9499 21.5196 21.0553 21.2652 21.0553 21V14C21.3205 14 21.5749 13.8946 21.7624 13.7071C21.9499 13.5196 22.0553 13.2652 22.0553 13C22.0553 12.7348 21.9499 12.4804 21.7624 12.2929C21.5749 12.1054 21.3205 12 21.0553 12ZM9.08557 11.2427C9.14994 11.4999 9.31383 11.721 9.5412 11.8573C9.65378 11.9248 9.77856 11.9695 9.90841 11.9888C10.0383 12.0081 10.1706 12.0016 10.298 11.9697C10.4253 11.9379 10.5451 11.8812 10.6506 11.803C10.7561 11.7249 10.8451 11.6267 10.9126 11.5141C10.9801 11.4015 11.0248 11.2767 11.0441 11.1469C11.0634 11.017 11.0569 10.8847 11.025 10.7573L9.26818 3.72755C9.14487 3.23411 8.86014 2.79607 8.45927 2.48305C8.0584 2.17003 7.56439 2 7.05578 2C6.54718 2 6.05317 2.17003 5.65229 2.48305C5.25142 2.79607 4.96669 3.23411 4.84338 3.72755L3.08557 10.7573C3.02121 11.0145 3.06165 11.2867 3.198 11.5141C3.33434 11.7415 3.55543 11.9054 3.81262 11.9697C4.0698 12.0341 4.34203 11.9937 4.5694 11.8573C4.79677 11.721 4.96066 11.4999 5.02502 11.2427L5.58581 9H8.52508L9.08557 11.2427ZM6.08593 7L6.78283 4.2129C6.80396 4.15763 6.84137 4.11008 6.89011 4.07654C6.93884 4.04299 6.99662 4.02503 7.05578 4.02503C7.11495 4.02503 7.17272 4.04299 7.22146 4.07654C7.2702 4.11008 7.3076 4.15763 7.32873 4.2129L8.02526 7H6.08593ZM14.0553 7H15.0553C15.3204 7.00027 15.5746 7.10571 15.7621 7.29319C15.9496 7.48067 16.055 7.73487 16.0553 8V9C16.0553 9.26522 16.1606 9.51958 16.3482 9.70711C16.5357 9.89465 16.7901 10 17.0553 10C17.3205 10 17.5749 9.89465 17.7624 9.70711C17.9499 9.51958 18.0553 9.26522 18.0553 9V8C18.0544 7.20462 17.7381 6.44206 17.1757 5.87964C16.6132 5.31722 15.8507 5.00087 15.0553 5.00001H14.0553C13.7901 5.00001 13.5357 5.10536 13.3482 5.2929C13.1606 5.48043 13.0553 5.73479 13.0553 6C13.0553 6.26522 13.1606 6.51958 13.3482 6.70711C13.5357 6.89465 13.7901 7 14.0553 7ZM10.0553 16H9.05529C8.79016 15.9997 8.53596 15.8943 8.34848 15.7068C8.161 15.5193 8.05556 15.2651 8.05529 15V14C8.05529 13.7348 7.94994 13.4804 7.7624 13.2929C7.57486 13.1054 7.32051 13 7.05529 13C6.79008 13 6.53572 13.1054 6.34819 13.2929C6.16065 13.4804 6.05529 13.7348 6.05529 14V15C6.05616 15.7954 6.37251 16.5579 6.93493 17.1204C7.49735 17.6828 8.25991 17.9991 9.05529 18H10.0553C10.3205 18 10.5749 17.8946 10.7624 17.7071C10.9499 17.5196 11.0553 17.2652 11.0553 17C11.0553 16.7348 10.9499 16.4804 10.7624 16.2929C10.5749 16.1054 10.3205 16 10.0553 16Z",
    fill: "#262626"
  }));
};

const IconEvents = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M8.4678 8.3947L8.46555 8.39653L8.46341 8.39861L8.4678 8.3947ZM18.4219 8.20817C18.3523 8.14111 18.2751 8.08244 18.1919 8.03336C18.0741 7.96402 17.9433 7.91958 17.8076 7.9028C17.672 7.88601 17.5343 7.89723 17.4031 7.93577C17.272 7.9743 17.1501 8.03933 17.0451 8.12683C16.9401 8.21433 16.8541 8.32245 16.7925 8.4445C16.448 9.12319 15.9729 9.72718 15.3945 10.2218C15.483 9.72344 15.5276 9.21825 15.5278 8.71207C15.5297 7.17217 15.1234 5.65928 14.3505 4.32743C13.5775 2.99558 12.4654 1.89235 11.1274 1.13007C10.98 1.04651 10.8138 1.00178 10.6444 1.00005C10.475 0.998327 10.3079 1.03967 10.1588 1.12021C10.0098 1.20074 9.88362 1.31783 9.7922 1.46048C9.70078 1.60313 9.6471 1.76666 9.6362 1.93574C9.58024 2.88391 9.33236 3.81085 8.90759 4.6604C8.48282 5.50995 7.88999 6.26442 7.16503 6.8781L6.93456 7.0656C6.17648 7.57569 5.50546 8.2045 4.94726 8.9279C4.07958 10.021 3.47851 11.3012 3.19172 12.6671C2.90493 14.0329 2.94031 15.4468 3.29506 16.7966C3.6498 18.1464 4.31415 19.3949 5.23543 20.4433C6.1567 21.4916 7.30956 22.3109 8.60257 22.8361C8.75439 22.8981 8.91914 22.9219 9.08229 22.9052C9.24545 22.8885 9.40198 22.8319 9.5381 22.7404C9.67422 22.6489 9.78573 22.5254 9.8628 22.3806C9.93987 22.2358 9.98013 22.0743 9.98003 21.9103C9.97932 21.8042 9.96252 21.6989 9.93023 21.5978C9.7065 20.7568 9.64208 19.8814 9.74028 19.0168C10.6865 20.8015 12.2054 22.2162 14.0528 23.0334C14.2783 23.1342 14.5332 23.1478 14.7681 23.0715C16.2277 22.6004 17.5425 21.7639 18.5878 20.6415C19.633 19.5191 20.3739 18.1481 20.74 16.6588C21.1061 15.1694 21.0853 13.6112 20.6796 12.1321C20.2739 10.653 19.4967 9.30227 18.4219 8.20817ZM14.5171 21.0392C13.6454 20.5975 12.8765 19.9772 12.2603 19.2187C11.6441 18.4602 11.1944 17.5806 10.9405 16.6369C10.8629 16.3191 10.8029 15.9974 10.7608 15.673C10.7322 15.4665 10.6398 15.274 10.4965 15.1226C10.3532 14.9711 10.1661 14.8682 9.96146 14.8283C9.89841 14.8159 9.8343 14.8096 9.77003 14.8097C9.59427 14.8097 9.42161 14.856 9.26944 14.9439C9.11728 15.0319 8.991 15.1584 8.90333 15.3107C8.0736 16.7419 7.65633 18.3748 7.69776 20.0285C6.968 19.4611 6.35811 18.7545 5.90344 17.9497C5.44876 17.1449 5.15835 16.2578 5.04903 15.3399C4.93971 14.422 5.01366 13.4915 5.26658 12.6024C5.51951 11.7133 5.94639 10.8833 6.52247 10.1603C6.95989 9.59218 7.48756 9.09964 8.08447 8.70235C8.11032 8.68567 8.1351 8.6674 8.15869 8.64766C8.15869 8.64766 8.45538 8.40218 8.46552 8.39656C9.89022 7.19152 10.9035 5.57207 11.3643 3.76387C12.4538 4.7711 13.1804 6.1099 13.431 7.57238C13.6817 9.03485 13.4425 10.5392 12.7505 11.8518C12.6591 12.0269 12.6216 12.2252 12.6427 12.4216C12.6639 12.6181 12.7427 12.8039 12.8693 12.9555C12.9959 13.1072 13.1646 13.218 13.3541 13.2739C13.5436 13.3298 13.7454 13.3284 13.9341 13.2698C15.4659 12.7896 16.8138 11.8517 17.7964 10.5823C18.3869 11.4545 18.773 12.4489 18.9259 13.4911C19.0787 14.5334 18.9944 15.5967 18.6792 16.6018C18.364 17.6069 17.826 18.528 17.1054 19.2963C16.3847 20.0646 15.5 20.6604 14.5171 21.0393L14.5171 21.0392Z",
    fill: "#262626"
  }));
};

const IconCfEvents = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M13 10H11C10.7348 10 10.4804 10.1054 10.2929 10.2929C10.1054 10.4804 10 10.7348 10 11C10 11.2652 10.1054 11.5196 10.2929 11.7071C10.4804 11.8946 10.7348 12 11 12H13C13.2652 12 13.5196 11.8946 13.7071 11.7071C13.8946 11.5196 14 11.2652 14 11C14 10.7348 13.8946 10.4804 13.7071 10.2929C13.5196 10.1054 13.2652 10 13 10ZM18 10C17.9971 9.11544 17.7011 8.25679 17.1583 7.55836C16.6155 6.85993 15.8565 6.36114 15 6.14V5C15 4.20435 14.6839 3.44129 14.1213 2.87868C13.5587 2.31607 12.7956 2 12 2C11.2044 2 10.4413 2.31607 9.87868 2.87868C9.31607 3.44129 9 4.20435 9 5V6.14C8.14353 6.36114 7.38451 6.85993 6.84169 7.55836C6.29887 8.25679 6.00287 9.11544 6 10C4.93913 10 3.92172 10.4214 3.17157 11.1716C2.42143 11.9217 2 12.9391 2 14V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H6.18C6.38631 20.5835 6.76807 21.089 7.27293 21.4471C7.7778 21.8051 8.38106 21.9983 9 22H15C15.6189 21.9983 16.2222 21.8051 16.7271 21.4471C17.2319 21.089 17.6137 20.5835 17.82 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V14C22 12.9391 21.5786 11.9217 20.8284 11.1716C20.0783 10.4214 19.0609 10 18 10ZM6 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12V18ZM11 5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289C12.8946 4.48043 13 4.73478 13 5V6H11V5ZM16 19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H9C8.73478 20 8.48043 19.8946 8.29289 19.7071C8.10536 19.5196 8 19.2652 8 19V18C8 17.4696 8.21071 16.9609 8.58579 16.5858C8.96086 16.2107 9.46957 16 10 16H14C14.5304 16 15.0391 16.2107 15.4142 16.5858C15.7893 16.9609 16 17.4696 16 18V19ZM16 14.56C15.396 14.1964 14.705 14.003 14 14H10C9.29504 14.003 8.60399 14.1964 8 14.56V10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H14C14.5304 8 15.0391 8.21071 15.4142 8.58579C15.7893 8.96086 16 9.46957 16 10V14.56ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H18V12C18.5304 12 19.0391 12.2107 19.4142 12.5858C19.7893 12.9609 20 13.4696 20 14V17Z",
    fill: "#262626"
  }));
};

const IconNotificationTemplates = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.0005 8.00024C20.997 7.617 20.8834 7.24284 20.6733 6.92229C20.4633 6.60174 20.1655 6.3483 19.8155 6.19213C19.4655 6.03596 19.078 5.98364 18.6992 6.0414C18.3203 6.09916 17.966 6.26456 17.6784 6.51792C17.3908 6.77128 17.1821 7.10192 17.0771 7.47051C16.9721 7.83909 16.9752 8.23009 17.086 8.59697C17.1969 8.96384 17.4108 9.29115 17.7023 9.53993C17.9939 9.78871 18.3507 9.94848 18.7305 10.0002C18.9406 10.5802 19.0289 11.1973 18.99 11.8129C18.9511 12.4285 18.7857 13.0296 18.5042 13.5784C18.2228 14.1273 17.8312 14.6124 17.354 15.0032C16.8767 15.3941 16.3241 15.6824 15.7305 15.8502C15.4667 15.2432 15.0097 14.7405 14.4305 14.4202C15.2593 13.3919 15.7803 12.1501 15.9333 10.8383C16.0863 9.52642 15.8651 8.19805 15.2951 7.0066C14.7252 5.81516 13.8298 4.80927 12.7124 4.10513C11.595 3.40099 10.3012 3.02734 8.98047 3.02734C7.65972 3.02734 6.36592 3.40099 5.24853 4.10513C4.13114 4.80927 3.23575 5.81516 2.6658 7.0066C2.09585 8.19805 1.8746 9.52642 2.0276 10.8383C2.18061 12.1501 2.70163 13.3919 3.53047 14.4202C3.07147 14.6782 2.68844 15.0524 2.41988 15.5053C2.15131 15.9582 2.00667 16.4738 2.00047 17.0002V18.0002C2.00047 18.7959 2.31654 19.5589 2.87915 20.1216C3.44176 20.6842 4.20482 21.0002 5.00047 21.0002H13.0005C13.7961 21.0002 14.5592 20.6842 15.1218 20.1216C15.6844 19.5589 16.0005 18.7959 16.0005 18.0002V17.8102C16.898 17.6006 17.7405 17.2016 18.4713 16.64C19.2022 16.0784 19.8046 15.3671 20.2383 14.5538C20.672 13.7404 20.9268 12.8438 20.9858 11.924C21.0448 11.0042 20.9066 10.0823 20.5805 9.22024C20.8514 8.87114 20.9991 8.44213 21.0005 8.00024ZM14.0005 18.0002C14.0005 18.2655 13.8951 18.5198 13.7076 18.7073C13.52 18.8949 13.2657 19.0002 13.0005 19.0002H5.00047C4.73526 19.0002 4.4809 18.8949 4.29337 18.7073C4.10583 18.5198 4.00047 18.2655 4.00047 18.0002V17.0002C4.00047 16.735 4.10583 16.4807 4.29337 16.2931C4.4809 16.1056 4.73526 16.0002 5.00047 16.0002H5.41047C6.49352 16.6549 7.73495 17.0009 9.00047 17.0009C10.266 17.0009 11.5074 16.6549 12.5905 16.0002H13.0005C13.2657 16.0002 13.52 16.1056 13.7076 16.2931C13.8951 16.4807 14.0005 16.735 14.0005 17.0002V18.0002ZM9.00047 15.0002C8.01157 15.0002 7.04487 14.707 6.22262 14.1576C5.40038 13.6082 4.75951 12.8273 4.38108 11.9137C4.00264 11 3.90362 9.99469 4.09655 9.02478C4.28947 8.05488 4.76568 7.16396 5.46494 6.4647C6.1642 5.76544 7.05512 5.28924 8.02502 5.09631C8.99493 4.90338 10.0003 5.0024 10.9139 5.38084C11.8275 5.75928 12.6084 6.40014 13.1578 7.22238C13.7072 8.04463 14.0005 9.01133 14.0005 10.0002C14.0005 10.6568 13.8711 11.307 13.6199 11.9137C13.3686 12.5203 13.0003 13.0715 12.536 13.5358C12.0717 14.0001 11.5205 14.3684 10.9139 14.6196C10.3073 14.8709 9.65708 15.0002 9.00047 15.0002ZM9.00047 9.00024C8.80269 9.00024 8.60935 9.05888 8.4449 9.16877C8.28045 9.27865 8.15228 9.43483 8.07659 9.61755C8.00091 9.80028 7.9811 10.0013 8.01969 10.1953C8.05827 10.3893 8.15351 10.5675 8.29337 10.7073C8.43322 10.8472 8.6114 10.9424 8.80538 10.981C8.99936 11.0196 9.20043 10.9998 9.38316 10.9241C9.56588 10.8484 9.72206 10.7203 9.83194 10.5558C9.94182 10.3914 10.0005 10.198 10.0005 10.0002C10.0005 9.73502 9.89512 9.48067 9.70758 9.29313C9.52004 9.10559 9.26569 9.00024 9.00047 9.00024Z",
    fill: fill || '#262626'
  }));
};

const IconRole = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22 15H20V12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11H13V9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8V2C16 1.73478 15.8946 1.48043 15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1H9C8.73478 1 8.48043 1.10536 8.29289 1.29289C8.10536 1.48043 8 1.73478 8 2V8C8 8.26522 8.10536 8.51957 8.29289 8.70711C8.48043 8.89464 8.73478 9 9 9H11V11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12V15H2C1.73478 15 1.48043 15.1054 1.29289 15.2929C1.10536 15.4804 1 15.7348 1 16V22C1 22.2652 1.10536 22.5196 1.29289 22.7071C1.48043 22.8946 1.73478 23 2 23H8C8.26522 23 8.51957 22.8946 8.70711 22.7071C8.89464 22.5196 9 22.2652 9 22V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15H6V13H18V15H16C15.7348 15 15.4804 15.1054 15.2929 15.2929C15.1054 15.4804 15 15.7348 15 16V22C15 22.2652 15.1054 22.5196 15.2929 22.7071C15.4804 22.8946 15.7348 23 16 23H22C22.2652 23 22.5196 22.8946 22.7071 22.7071C22.8946 22.5196 23 22.2652 23 22V16C23 15.7348 22.8946 15.4804 22.7071 15.2929C22.5196 15.1054 22.2652 15 22 15ZM7 17V21H3V17H7ZM10 7V3H14V7H10ZM21 21H17V17H21V21Z",
    fill: "#262626"
  }));
};

const IconPermission = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.7803 11.88L19.7803 9.38C19.6872 9.26215 19.5687 9.16679 19.4336 9.101C19.2986 9.03521 19.1505 9.00069 19.0003 9H13.0003V3C13.0003 2.73478 12.8949 2.48043 12.7074 2.29289C12.5199 2.10536 12.2655 2 12.0003 2C11.7351 2 11.4807 2.10536 11.2932 2.29289C11.1056 2.48043 11.0003 2.73478 11.0003 3V4H5.00028C4.85008 4.00069 4.70196 4.03521 4.56692 4.101C4.43189 4.16679 4.31341 4.26215 4.22028 4.38L2.22028 6.88C2.08077 7.05655 2.00488 7.27499 2.00488 7.5C2.00488 7.72501 2.08077 7.94345 2.22028 8.12L4.22028 10.62C4.31341 10.7379 4.43189 10.8332 4.56692 10.899C4.70196 10.9648 4.85008 10.9993 5.00028 11H11.0003V20H9.00028C8.73506 20 8.48071 20.1054 8.29317 20.2929C8.10564 20.4804 8.00028 20.7348 8.00028 21C8.00028 21.2652 8.10564 21.5196 8.29317 21.7071C8.48071 21.8946 8.73506 22 9.00028 22H15.0003C15.2655 22 15.5199 21.8946 15.7074 21.7071C15.8949 21.5196 16.0003 21.2652 16.0003 21C16.0003 20.7348 15.8949 20.4804 15.7074 20.2929C15.5199 20.1054 15.2655 20 15.0003 20H13.0003V16H19.0003C19.1505 15.9993 19.2986 15.9648 19.4336 15.899C19.5687 15.8332 19.6872 15.7379 19.7803 15.62L21.7803 13.12C21.9198 12.9435 21.9957 12.725 21.9957 12.5C21.9957 12.275 21.9198 12.0565 21.7803 11.88ZM11.0003 9H5.48028L4.28028 7.5L5.48028 6H11.0003V9ZM18.5203 14H13.0003V11H18.5203L19.7203 12.5L18.5203 14Z",
    fill: "#262626"
  }));
};

const IconAcl = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.25H20C21.5188 1.25 22.75 2.48122 22.75 4V20C22.75 21.5188 21.5188 22.75 20 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V4C1.25 2.48122 2.48122 1.25 4 1.25ZM0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4ZM12.7085 15.48C12.1385 15.48 11.6405 15.393 11.2145 15.219C10.7885 15.039 10.4525 14.769 10.2065 14.409C9.96654 14.049 9.83454 13.593 9.81054 13.041C9.80454 12.795 9.80154 12.531 9.80154 12.249C9.80154 11.967 9.80454 11.697 9.81054 11.439C9.83454 10.899 9.96954 10.449 10.2155 10.089C10.4675 9.723 10.8065 9.45 11.2325 9.27C11.6645 9.09 12.1565 9 12.7085 9C13.1045 9 13.4735 9.048 13.8155 9.144C14.1635 9.234 14.4725 9.375 14.7425 9.567C15.0125 9.753 15.2255 9.984 15.3815 10.26C15.5375 10.536 15.6185 10.86 15.6245 11.232C15.6245 11.286 15.6035 11.334 15.5615 11.376C15.5255 11.412 15.4805 11.43 15.4265 11.43H13.9055C13.8155 11.43 13.7495 11.412 13.7075 11.376C13.6655 11.34 13.6295 11.277 13.5995 11.187C13.5215 10.929 13.4075 10.755 13.2575 10.665C13.1075 10.575 12.9245 10.53 12.7085 10.53C12.4445 10.53 12.2345 10.602 12.0785 10.746C11.9225 10.884 11.8385 11.13 11.8265 11.484C11.8085 11.976 11.8085 12.48 11.8265 12.996C11.8385 13.35 11.9225 13.599 12.0785 13.743C12.2345 13.881 12.4445 13.95 12.7085 13.95C12.9245 13.95 13.1075 13.902 13.2575 13.806C13.4135 13.71 13.5275 13.539 13.5995 13.293C13.6235 13.197 13.6565 13.134 13.6985 13.104C13.7465 13.068 13.8155 13.05 13.9055 13.05H15.4265C15.4805 13.05 15.5255 13.068 15.5615 13.104C15.6035 13.14 15.6245 13.185 15.6245 13.239C15.6185 13.611 15.5375 13.938 15.3815 14.22C15.2255 14.496 15.0125 14.73 14.7425 14.922C14.4725 15.108 14.1635 15.249 13.8155 15.345C13.4735 15.435 13.1045 15.48 12.7085 15.48ZM3.189 15.39C3.135 15.39 3.09 15.372 3.054 15.336C3.018 15.294 3 15.246 3 15.192C3 15.168 3.003 15.147 3.009 15.129L5.061 9.369C5.085 9.303 5.127 9.24 5.187 9.18C5.247 9.12 5.331 9.09 5.439 9.09H7.086C7.2 9.09 7.287 9.12 7.347 9.18C7.407 9.24 7.446 9.303 7.464 9.369L9.525 15.129C9.531 15.147 9.534 15.168 9.534 15.192C9.534 15.246 9.513 15.294 9.471 15.336C9.435 15.372 9.39 15.39 9.336 15.39H7.95C7.848 15.39 7.773 15.366 7.725 15.318C7.677 15.27 7.644 15.225 7.626 15.183L7.347 14.427H5.178L4.899 15.183C4.881 15.225 4.848 15.27 4.8 15.318C4.758 15.366 4.683 15.39 4.575 15.39H3.189ZM5.592 12.906H6.933L6.258 10.881L5.592 12.906ZM16.5225 15.327C16.5705 15.369 16.6245 15.39 16.6845 15.39H21.0225C21.0885 15.39 21.1455 15.369 21.1935 15.327C21.2415 15.279 21.2655 15.222 21.2655 15.156V14.022C21.2655 13.956 21.2415 13.902 21.1935 13.86C21.1455 13.812 21.0885 13.788 21.0225 13.788H18.4215V9.324C18.4215 9.258 18.3975 9.204 18.3495 9.162C18.3015 9.114 18.2445 9.09 18.1785 9.09H16.6845C16.6245 9.09 16.5705 9.114 16.5225 9.162C16.4745 9.204 16.4505 9.258 16.4505 9.324V15.156C16.4505 15.222 16.4745 15.279 16.5225 15.327Z",
    fill: fill || '#262626'
  }));
};

const IconZoom = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: fill || '#52AEFF'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07537 6.75146H11.9367C13.5514 6.75146 14.6788 7.86183 14.6788 9.45309V14.029C14.6788 15.6202 13.5514 16.7306 11.9367 16.7306H8.07537C6.46069 16.7306 5.33334 15.6202 5.33334 14.029V9.45309C5.33334 7.86183 6.46069 6.75146 8.07537 6.75146ZM17.3053 8.33414C17.598 8.18555 17.9413 8.20109 18.2207 8.37669C18.5 8.55162 18.6667 8.85556 18.6667 9.18786V14.2946C18.6667 14.6276 18.5 14.9308 18.2207 15.1058C18.068 15.201 17.8973 15.2496 17.7253 15.2496C17.582 15.2496 17.4387 15.2159 17.3047 15.1476L16.3173 14.6505C15.952 14.4655 15.7253 14.094 15.7253 13.6813V9.80045C15.7253 9.3871 15.952 9.01563 16.3173 8.83192L17.3053 8.33414Z",
    fill: "white"
  }));
};

const IconClassroom = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: fill
  }), React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    d: "M16.7814 5.00002H6.71851C6.52937 4.99864 6.34744 5.07337 6.2127 5.20777C6.07796 5.34218 6.00143 5.52525 5.99997 5.71675V12.8854C6.00069 12.9803 6.01988 13.0741 6.05641 13.1614C6.09293 13.2488 6.14609 13.328 6.21285 13.3945C6.27962 13.4611 6.35866 13.5137 6.4455 13.5493C6.53233 13.5849 6.62524 13.6029 6.71893 13.6022H16.7814C16.9706 13.6035 17.1525 13.5288 17.2873 13.3944C17.422 13.26 17.4985 13.0769 17.5 12.8854V5.71675C17.4985 5.52525 17.422 5.34218 17.2873 5.20777C17.1525 5.07337 16.9706 4.99864 16.7814 5.00002ZM8.33575 11.7206C8.16129 11.718 7.9915 11.6632 7.84769 11.5631C7.70389 11.4631 7.59249 11.3222 7.52752 11.1583C7.46255 10.9943 7.44689 10.8145 7.48252 10.6416C7.51815 10.4686 7.60348 10.3102 7.72777 10.1862C7.85206 10.0622 8.00978 9.97821 8.1811 9.94471C8.35242 9.9112 8.52967 9.9297 8.69063 9.9979C8.85159 10.0661 8.98907 10.181 9.08575 10.328C9.18243 10.4751 9.23401 10.6478 9.23403 10.8245C9.23223 11.0639 9.13659 11.2928 8.96814 11.4608C8.79969 11.6289 8.57222 11.7223 8.33575 11.7206ZM8.33575 8.85324C8.16129 8.8506 7.9915 8.79581 7.84769 8.69576C7.70389 8.5957 7.59249 8.45484 7.52752 8.29088C7.46255 8.12692 7.44689 7.94716 7.48252 7.77422C7.51815 7.60127 7.60348 7.44285 7.72777 7.31886C7.85206 7.19486 8.00978 7.11084 8.1811 7.07733C8.35242 7.04382 8.52967 7.06232 8.69063 7.13053C8.85159 7.19873 8.98907 7.31358 9.08575 7.46065C9.18243 7.60772 9.23401 7.78043 9.23403 7.9571C9.23223 8.19653 9.13659 8.42542 8.96814 8.59347C8.79969 8.76152 8.57222 8.85496 8.33575 8.85324ZM14.0858 11.6314H11.2091C11.0917 11.6314 10.9791 11.5841 10.8961 11.5001C10.8132 11.4161 10.7665 11.3021 10.7665 11.1833C10.7665 11.0645 10.8132 10.9505 10.8961 10.8665C10.9791 10.7824 11.0917 10.7352 11.2091 10.7352H14.0841C14.2014 10.7352 14.314 10.7824 14.397 10.8665C14.48 10.9505 14.5266 11.0645 14.5266 11.1833C14.5266 11.3021 14.48 11.4161 14.397 11.5001C14.314 11.5841 14.2014 11.6314 14.0841 11.6314H14.0858ZM15.5233 9.83908H11.2091C11.0917 9.83908 10.9791 9.79187 10.8961 9.70784C10.8132 9.62381 10.7665 9.50984 10.7665 9.39101C10.7665 9.27217 10.8132 9.15821 10.8961 9.07418C10.9791 8.99015 11.0917 8.94294 11.2091 8.94294H15.5216C15.6389 8.94294 15.7515 8.99015 15.8345 9.07418C15.9175 9.15821 15.9641 9.27217 15.9641 9.39101C15.9641 9.50984 15.9175 9.62381 15.8345 9.70784C15.7515 9.79187 15.6389 9.83908 15.5216 9.83908H15.5233ZM15.5233 8.0468H11.2091C11.0917 8.0468 10.9791 7.99959 10.8961 7.91556C10.8132 7.83153 10.7665 7.71757 10.7665 7.59873C10.7665 7.4799 10.8132 7.36593 10.8961 7.2819C10.9791 7.19787 11.0917 7.15066 11.2091 7.15066H15.5216C15.6389 7.15066 15.7515 7.19787 15.8345 7.2819C15.9175 7.36593 15.9641 7.4799 15.9641 7.59873C15.9641 7.71757 15.9175 7.83153 15.8345 7.91556C15.7515 7.99959 15.6389 8.0468 15.5216 8.0468H15.5233Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M10.913 13.5957L10.9067 13.6026H10.9199L10.913 13.5957ZM14.5441 17.7029L12.2879 15.4522V14.971C12.284 14.8289 12.2255 14.694 12.1248 14.5949C12.0242 14.4958 11.8893 14.4403 11.7489 14.4403C11.6085 14.4403 11.4737 14.4958 11.373 14.5949C11.2724 14.694 11.2139 14.8289 11.2099 14.971V15.4522L8.95464 17.7012C8.90463 17.7507 8.86489 17.8099 8.83776 17.8751C8.81063 17.9404 8.79666 18.0105 8.79666 18.0813C8.79666 18.1522 8.81063 18.2223 8.83776 18.2876C8.86489 18.3529 8.90463 18.412 8.95464 18.4615C9.05641 18.5626 9.19326 18.6192 9.33583 18.6192C9.47839 18.6192 9.61527 18.5626 9.71704 18.4615L11.2078 16.9728V18.261C11.2117 18.403 11.2703 18.538 11.3709 18.6371C11.4716 18.7362 11.6064 18.7916 11.7468 18.7916C11.8872 18.7916 12.022 18.7362 12.1227 18.6371C12.2233 18.538 12.2819 18.403 12.2858 18.261V16.9728L13.7765 18.4615C13.8783 18.5626 14.0152 18.6192 14.1578 18.6192C14.3003 18.6192 14.4372 18.5626 14.5389 18.4615C14.5891 18.4124 14.6291 18.3538 14.6567 18.2889C14.6842 18.224 14.6987 18.1542 14.6993 18.0836C14.6999 18.013 14.6865 17.9429 14.6601 17.8776C14.6337 17.8122 14.5947 17.7528 14.5453 17.7029H14.5441Z",
    fill: "white"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "11.5",
    height: "13.8",
    fill: "white",
    transform: "translate(6 5)"
  }))));
};

const IconGroup$1 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: "#F7F7F8"
  }), React.createElement("path", {
    d: "M12 7V12M12 12H17M12 12H7M12 12V17",
    stroke: "#262F56",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconPlus = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M5.99992 11.1431H5.98773C5.51428 11.1431 5.13086 11.5265 5.13086 11.9999C5.13086 12.4743 5.51431 12.8568 5.98773 12.8568H6.00086H17.9989H18.0111C18.4846 12.8568 18.868 12.4734 18.868 11.9999C18.868 11.5256 18.4845 11.1431 18.0111 11.1431H17.998H5.99992Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12.8568 5.99992V5.98773C12.8568 5.51428 12.4734 5.13086 11.9999 5.13086C11.5256 5.13086 11.1431 5.51431 11.1431 5.98773V6.00086V5.99992V17.999V18.0111C11.1431 18.4846 11.5265 18.868 11.9999 18.868C12.4743 18.868 12.8568 18.4846 12.8568 18.0111V17.998V17.999V5.99992Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12 0C5.38322 0 0.000976562 5.3832 0.000976562 11.999C0.000976562 18.6158 5.38418 23.9981 12 23.9981C18.6168 23.9981 23.9991 18.6149 23.9991 11.999C23.9991 5.38224 18.6159 0 12 0ZM12 1.71468C17.6907 1.71468 22.2852 6.3102 22.2852 11.9999C22.2852 17.6905 17.6904 22.2851 12 22.2851C6.30962 22.2851 1.71482 17.6903 1.71482 11.9999C1.71482 6.30948 6.30962 1.71468 12 1.71468Z",
    fill: fill
  }));
};

const IconPersonal = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16.174 12.9163C16.1558 12.9081 16.1388 12.8994 16.1202 12.8925C15.9825 12.8303 15.8463 12.7655 15.7054 12.7095C16.6868 11.9387 17.4035 10.8811 17.7557 9.68394C18.1078 8.48676 18.078 7.20957 17.6702 6.03017C17.2624 4.85077 16.4971 3.82785 15.4807 3.10384C14.4643 2.37982 13.2474 1.99072 11.9995 1.99072C10.7516 1.99072 9.5348 2.37982 8.51841 3.10384C7.50202 3.82785 6.73666 4.85077 6.3289 6.03017C5.92114 7.20957 5.89126 8.48676 6.24342 9.68394C6.59558 10.8811 7.31226 11.9387 8.29368 12.7095C8.15281 12.7655 8.01658 12.8303 7.87888 12.8925C7.86027 12.8994 7.8433 12.9081 7.82505 12.9163C6.25593 13.6321 4.89993 14.7438 3.89017 16.142C2.88041 17.5402 2.2516 19.177 2.06547 20.8916C2.03672 21.1553 2.11388 21.4195 2.27999 21.6263C2.4461 21.8331 2.68754 21.9654 2.95121 21.9941C3.21487 22.0229 3.47915 21.9457 3.68592 21.7796C3.89269 21.6135 4.025 21.3721 4.05375 21.1084C4.18979 19.8546 4.62237 18.6511 5.31572 17.5976C6.00907 16.544 6.94327 15.6707 8.04105 15.0498L11.2925 18.3013C11.3854 18.3942 11.4956 18.4678 11.6169 18.5181C11.7382 18.5684 11.8683 18.5942 11.9996 18.5942C12.1309 18.5942 12.2609 18.5684 12.3822 18.5181C12.5036 18.4678 12.6138 18.3942 12.7066 18.3013L15.958 15.0498C17.0558 15.6707 17.99 16.544 18.6834 17.5976C19.3767 18.6511 19.8093 19.8546 19.9453 21.1084C19.972 21.3532 20.0881 21.5795 20.2712 21.744C20.4544 21.9085 20.6918 21.9997 20.938 22C20.9747 22 21.0114 21.998 21.0479 21.9941C21.3115 21.9654 21.553 21.8331 21.7191 21.6263C21.8852 21.4195 21.9624 21.1553 21.9336 20.8916C21.7475 19.177 21.1187 17.5402 20.1089 16.142C19.0992 14.7438 17.7432 13.6321 16.174 12.9163ZM8.04055 7.59424C8.13576 6.61026 8.59398 5.697 9.3259 5.03248C10.0578 4.36797 11.011 3.99983 11.9995 3.99983C12.9881 3.99983 13.9413 4.36797 14.6732 5.03248C15.4051 5.697 15.8633 6.61026 15.9585 7.59424H8.04055ZM11.9995 16.1802L10.0626 14.2432C11.3335 13.9189 12.6656 13.9189 13.9365 14.2432L11.9995 16.1802ZM11.9995 12C11.221 11.9988 10.4597 11.7705 9.80894 11.3432C9.15814 10.9159 8.64607 10.3081 8.33543 9.59424H15.6637C15.353 10.3081 14.841 10.9159 14.1902 11.3432C13.5394 11.7705 12.7781 11.9988 11.9995 12Z",
    fill: "#262626"
  }));
};

const IconLearning = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22.47 18.8202L21.47 14.9602L18.32 3.37015C18.2519 3.11449 18.0853 2.89623 17.8567 2.76315C17.628 2.63008 17.3559 2.59304 17.1 2.66015L13.23 3.66015C13.1376 3.5578 13.0251 3.47564 12.8995 3.41886C12.7739 3.36207 12.6379 3.33187 12.5 3.33015H2.5C2.23478 3.33015 1.98043 3.43551 1.79289 3.62305C1.60536 3.81058 1.5 4.06494 1.5 4.33015V20.3302C1.5 20.5954 1.60536 20.8497 1.79289 21.0373C1.98043 21.2248 2.23478 21.3302 2.5 21.3302H12.5C12.7652 21.3302 13.0196 21.2248 13.2071 21.0373C13.3946 20.8497 13.5 20.5954 13.5 20.3302V12.3302L15.7 20.5502C15.7586 20.7683 15.8893 20.9602 16.0709 21.0946C16.2525 21.229 16.4742 21.2979 16.7 21.2902C16.7864 21.3 16.8736 21.3 16.96 21.2902L21.79 20.0002C21.9177 19.966 22.0374 19.9069 22.1421 19.8262C22.2468 19.7456 22.3344 19.6449 22.4 19.5302C22.5055 19.3089 22.5302 19.0577 22.47 18.8202ZM6.47 19.3702H3.47V17.3702H6.47V19.3702ZM6.47 15.3702H3.47V9.37015H6.47V15.3702ZM6.47 7.37015H3.47V5.37015H6.47V7.37015ZM11.47 19.3702H8.47V17.3702H11.47V19.3702ZM11.47 15.3702H8.47V9.37015H11.47V15.3702ZM11.47 7.37015H8.47V5.37015H11.47V7.37015ZM13.72 5.63015L16.62 4.85015L17.14 6.78015L14.24 7.56015L13.72 5.63015ZM16.31 15.2902L14.76 9.49015L17.66 8.71015L19.21 14.5102L16.31 15.2902ZM17.31 19.1502L16.79 17.2202L19.69 16.4402L20.21 18.3702L17.31 19.1502Z",
    fill: "#262626"
  }));
};

const IconFinances = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19 7H18V6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H19C19.7956 21 20.5587 20.6839 21.1213 20.1213C21.6839 19.5587 22 18.7956 22 18V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM5 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM20 15H19C18.7348 15 18.4804 14.8946 18.2929 14.7071C18.1054 14.5196 18 14.2652 18 14C18 13.7348 18.1054 13.4804 18.2929 13.2929C18.4804 13.1054 18.7348 13 19 13H20V15ZM20 11H19C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14C16 14.7956 16.3161 15.5587 16.8787 16.1213C17.4413 16.6839 18.2044 17 19 17H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V8.83C4.32127 8.94302 4.65943 9.00051 5 9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V11Z",
    fill: "#262626"
  }));
};

const IconFinancesBold = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7689 8.3818H22C22 4.98459 19.9644 3 16.5156 3H7.48444C4.03556 3 2 4.98459 2 8.33847V15.6615C2 19.0154 4.03556 21 7.48444 21H16.5156C19.9644 21 22 19.0154 22 15.6615V15.3495H17.7689C15.8052 15.3495 14.2133 13.7975 14.2133 11.883C14.2133 9.96849 15.8052 8.41647 17.7689 8.41647V8.3818ZM17.7689 9.87241H21.2533C21.6657 9.87241 22 10.1983 22 10.6004V13.131C21.9952 13.5311 21.6637 13.8543 21.2533 13.8589H17.8489C16.8548 13.872 15.9855 13.2084 15.76 12.2643C15.6471 11.6783 15.8056 11.0736 16.1931 10.6122C16.5805 10.1509 17.1573 9.88007 17.7689 9.87241ZM17.92 12.533H18.2489C18.6711 12.533 19.0133 12.1993 19.0133 11.7877C19.0133 11.3761 18.6711 11.0424 18.2489 11.0424H17.92C17.7181 11.0401 17.5236 11.1166 17.38 11.255C17.2364 11.3934 17.1555 11.5821 17.1556 11.779C17.1555 12.1921 17.4964 12.5282 17.92 12.533ZM6.73778 8.3818H12.3822C12.8044 8.3818 13.1467 8.04812 13.1467 7.63649C13.1467 7.22487 12.8044 6.89119 12.3822 6.89119H6.73778C6.31903 6.89116 5.9782 7.2196 5.97333 7.62783C5.97331 8.04087 6.31415 8.37705 6.73778 8.3818Z",
    fill: fill || '#200E32'
  }));
};

const IconSales = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7 16C7.39782 16 7.77936 15.842 8.06066 15.5607C8.34196 15.2794 8.5 14.8978 8.5 14.5C8.50488 14.4501 8.50488 14.3999 8.5 14.35L11.29 11.56H11.52H11.75L13.36 13.17C13.36 13.17 13.36 13.22 13.36 13.25C13.36 13.6478 13.518 14.0294 13.7993 14.3107C14.0806 14.592 14.4622 14.75 14.86 14.75C15.2578 14.75 15.6394 14.592 15.9207 14.3107C16.202 14.0294 16.36 13.6478 16.36 13.25V13.17L20 9.5C20.2967 9.5 20.5867 9.41203 20.8334 9.2472C21.08 9.08238 21.2723 8.84811 21.3858 8.57403C21.4993 8.29994 21.5291 7.99834 21.4712 7.70736C21.4133 7.41639 21.2704 7.14912 21.0607 6.93934C20.8509 6.72956 20.5836 6.5867 20.2926 6.52882C20.0017 6.47094 19.7001 6.50065 19.426 6.61418C19.1519 6.72771 18.9176 6.91997 18.7528 7.16664C18.588 7.41332 18.5 7.70333 18.5 8C18.4951 8.04988 18.4951 8.10012 18.5 8.15L14.89 11.76H14.73L13 10C13 9.60218 12.842 9.22064 12.5607 8.93934C12.2794 8.65804 11.8978 8.5 11.5 8.5C11.1022 8.5 10.7206 8.65804 10.4393 8.93934C10.158 9.22064 10 9.60218 10 10L7 13C6.60218 13 6.22064 13.158 5.93934 13.4393C5.65804 13.7206 5.5 14.1022 5.5 14.5C5.5 14.8978 5.65804 15.2794 5.93934 15.5607C6.22064 15.842 6.60218 16 7 16ZM20.5 20H3.5V3C3.5 2.73478 3.39464 2.48043 3.20711 2.29289C3.01957 2.10536 2.76522 2 2.5 2C2.23478 2 1.98043 2.10536 1.79289 2.29289C1.60536 2.48043 1.5 2.73478 1.5 3V21C1.5 21.2652 1.60536 21.5196 1.79289 21.7071C1.98043 21.8946 2.23478 22 2.5 22H20.5C20.7652 22 21.0196 21.8946 21.2071 21.7071C21.3946 21.5196 21.5 21.2652 21.5 21C21.5 20.7348 21.3946 20.4804 21.2071 20.2929C21.0196 20.1054 20.7652 20 20.5 20Z",
    fill: "#262626"
  }));
};

const IconInfo = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3346 2.0002H7.6656C4.26803 2.0002 2.0006 4.43279 2.0006 7.9162V16.0842C2.0006 19.5709 4.26197 22.0002 7.6656 22.0002H16.3336C19.7382 22.0002 22.0006 19.5709 22.0006 16.0842V7.9162C22.0006 4.4297 19.7384 2.0002 16.3346 2.0002ZM7.6656 3.5002H16.3346C18.8851 3.5002 20.5006 5.23516 20.5006 7.9162V16.0842C20.5006 18.7654 18.885 20.5002 16.3336 20.5002H7.6656C5.11536 20.5002 3.5006 18.7655 3.5006 16.0842V7.9162C3.5006 5.23857 5.12094 3.5002 7.6656 3.5002ZM11.9999 7.4543C12.4141 7.4543 12.7499 7.79008 12.7499 8.2043C12.7499 8.58399 12.4677 8.89779 12.1017 8.94745L11.9899 8.9543C11.5757 8.9543 11.2399 8.61851 11.2399 8.2043C11.2399 7.8246 11.5221 7.51081 11.8881 7.46114L11.9999 7.4543ZM11.9899 10.6271C12.3696 10.6271 12.6834 10.9093 12.7331 11.2753L12.7399 11.3771V15.7961C12.7399 16.2103 12.4041 16.5461 11.9899 16.5461C11.6102 16.5461 11.2964 16.2639 11.2467 15.8979L11.2399 15.7961V11.3771C11.2399 10.9629 11.5757 10.6271 11.9899 10.6271Z",
    fill: "#200E32"
  }));
};

const IconPlusOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M5 13h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1z",
    fill: fill
  }));
};

const IconUnorderedListOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M8 7h13c0.552 0 1-0.448 1-1s-0.448-1-1-1h-13c-0.552 0-1 0.448-1 1s0.448 1 1 1zM8 13h13c0.552 0 1-0.448 1-1s-0.448-1-1-1h-13c-0.552 0-1 0.448-1 1s0.448 1 1 1zM8 19h13c0.552 0 1-0.448 1-1s-0.448-1-1-1h-13c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 7c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1zM3 13c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1zM3 19c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1z",
    fill: fill
  }));
};

const IconSearchOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#262626';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M17.0918 15.9083L14.0002 12.8417C15.2002 11.3453 15.7814 9.44608 15.6242 7.53442C15.4669 5.62275 14.5832 3.84399 13.1548 2.56387C11.7263 1.28376 9.86167 0.599592 7.94427 0.652059C6.02686 0.704526 4.20243 1.48964 2.84612 2.84595C1.4898 4.20227 0.70469 6.0267 0.652223 7.9441C0.599756 9.86151 1.28392 11.7261 2.56403 13.1546C3.84415 14.5831 5.62292 15.4668 7.53458 15.624C9.44625 15.7813 11.3455 15.2001 12.8418 14L15.9085 17.0667C15.986 17.1448 16.0781 17.2068 16.1797 17.2491C16.2812 17.2914 16.3902 17.3132 16.5002 17.3132C16.6102 17.3132 16.7191 17.2914 16.8206 17.2491C16.9222 17.2068 17.0144 17.1448 17.0918 17.0667C17.242 16.9113 17.326 16.7036 17.326 16.4875C17.326 16.2714 17.242 16.0637 17.0918 15.9083ZM8.16683 14C7.01311 14 5.88529 13.6579 4.926 13.0169C3.96672 12.3759 3.21904 11.4649 2.77753 10.399C2.33602 9.33308 2.2205 8.1602 2.44558 7.02864C2.67066 5.89708 3.22624 4.85768 4.04204 4.04188C4.85785 3.22607 5.89725 2.6705 7.0288 2.44542C8.16036 2.22034 9.33325 2.33586 10.3992 2.77737C11.4651 3.21888 12.3761 3.96655 13.0171 4.92584C13.658 5.88513 14.0002 7.01294 14.0002 8.16667C14.0002 9.71376 13.3856 11.1975 12.2916 12.2915C11.1977 13.3854 9.71393 14 8.16683 14Z",
    fill: fill
  }));
};

const IconUploadOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M20 15v4c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-14c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1v4c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h14c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1zM11 5.414v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5-5c-0.092-0.092-0.202-0.166-0.324-0.217-0.245-0.101-0.521-0.101-0.766 0-0.118 0.049-0.228 0.121-0.324 0.217l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z",
    fill: fill
  }));
};

const IconBarChartOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M13 20v-10c0-0.552-0.448-1-1-1s-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1zM19 20v-16c0-0.552-0.448-1-1-1s-1 0.448-1 1v16c0 0.552 0.448 1 1 1s1-0.448 1-1zM7 20v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1v4c0 0.552 0.448 1 1 1s1-0.448 1-1z",
    fill: fill
  }));
};

const IconDropBox = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M23 1l-7 6 9 6 7-6z",
    fill: fill
  }), React.createElement("path", {
    d: "M16 7l-7-6-9 6 7 6z",
    fill: fill
  }), React.createElement("path", {
    d: "M25 13l7 6-9 5-7-6z",
    fill: fill
  }), React.createElement("path", {
    d: "M16 18l-9-5-7 6 9 5z",
    fill: fill
  }), React.createElement("path", {
    d: "M22.755 26.424l-6.755-5.79-6.755 5.79-4.245-2.358v2.934l11 5 11-5v-2.934z",
    fill: fill
  }));
};

const IconLetter = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M3 7.921l8.427 5.899c0.34 0.235 0.795 0.246 1.147 0l8.426-5.899v10.079c0 0.272-0.11 0.521-0.295 0.705s-0.433 0.295-0.705 0.295h-16c-0.272 0-0.521-0.11-0.705-0.295s-0.295-0.433-0.295-0.705zM1 5.983c0 0.010 0 0.020 0 0.030v11.987c0 0.828 0.34 1.579 0.88 2.12s1.292 0.88 2.12 0.88h16c0.828 0 1.579-0.34 2.12-0.88s0.88-1.292 0.88-2.12v-11.988c0-0.010 0-0.020 0-0.030-0.005-0.821-0.343-1.565-0.88-2.102-0.541-0.54-1.292-0.88-2.12-0.88h-16c-0.828 0-1.579 0.34-2.12 0.88-0.537 0.537-0.875 1.281-0.88 2.103zM20.894 5.554l-8.894 6.225-8.894-6.225c0.048-0.096 0.112-0.183 0.188-0.259 0.185-0.185 0.434-0.295 0.706-0.295h16c0.272 0 0.521 0.11 0.705 0.295 0.076 0.076 0.14 0.164 0.188 0.259z"
  }));
};

const IconLock = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M5 12h14c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v7c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-14c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-7c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293zM18 10v-3c0-1.657-0.673-3.158-1.757-4.243s-2.586-1.757-4.243-1.757-3.158 0.673-4.243 1.757-1.757 2.586-1.757 4.243v3h-1c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v7c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h14c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-7c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879zM8 10v-3c0-1.105 0.447-2.103 1.172-2.828s1.723-1.172 2.828-1.172 2.103 0.447 2.828 1.172 1.172 1.723 1.172 2.828v3z"
  }));
};

const IconInfoCircle = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0-3.037-1.232-5.789-3.222-7.778s-4.741-3.222-7.778-3.222-5.789 1.232-7.778 3.222-3.222 4.741-3.222 7.778 1.232 5.789 3.222 7.778 4.741 3.222 7.778 3.222 5.789-1.232 7.778-3.222 3.222-4.741 3.222-7.778zM21 12c0 2.486-1.006 4.734-2.636 6.364s-3.878 2.636-6.364 2.636-4.734-1.006-6.364-2.636-2.636-3.878-2.636-6.364 1.006-4.734 2.636-6.364 3.878-2.636 6.364-2.636 4.734 1.006 6.364 2.636 2.636 3.878 2.636 6.364zM13 16v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1v4c0 0.552 0.448 1 1 1s1-0.448 1-1zM12 9c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1z"
  }));
};

const IconHelpCircle = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0-3.037-1.232-5.789-3.222-7.778s-4.741-3.222-7.778-3.222-5.789 1.232-7.778 3.222-3.222 4.741-3.222 7.778 1.232 5.789 3.222 7.778 4.741 3.222 7.778 3.222 5.789-1.232 7.778-3.222 3.222-4.741 3.222-7.778zM21 12c0 2.486-1.006 4.734-2.636 6.364s-3.878 2.636-6.364 2.636-4.734-1.006-6.364-2.636-2.636-3.878-2.636-6.364 1.006-4.734 2.636-6.364 3.878-2.636 6.364-2.636 4.734 1.006 6.364 2.636 2.636 3.878 2.636 6.364zM10.033 9.332c0.183-0.521 0.559-0.918 1.022-1.14s1.007-0.267 1.528-0.083c0.458 0.161 0.819 0.47 1.050 0.859 0.183 0.307 0.284 0.665 0.286 1.037 0 0.155-0.039 0.309-0.117 0.464-0.080 0.16-0.203 0.325-0.368 0.49-0.709 0.709-1.831 1.092-1.831 1.092-0.524 0.175-0.807 0.741-0.632 1.265s0.741 0.807 1.265 0.632c0 0 1.544-0.506 2.613-1.575 0.279-0.279 0.545-0.614 0.743-1.010 0.2-0.4 0.328-0.858 0.328-1.369-0.004-0.731-0.204-1.437-0.567-2.049-0.463-0.778-1.19-1.402-2.105-1.724-1.042-0.366-2.135-0.275-3.057 0.167s-1.678 1.238-2.044 2.28c-0.184 0.521 0.090 1.092 0.611 1.275s1.092-0.091 1.275-0.611zM12 18c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1z",
    fill: fill
  }));
};

const IconPieChart = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M20.289 15.501c-0.968 2.289-2.771 3.968-4.906 4.835s-4.599 0.917-6.888-0.051-3.968-2.771-4.835-4.906-0.918-4.6 0.050-6.889c0.936-2.214 2.652-3.856 4.689-4.743 0.506-0.221 0.738-0.81 0.518-1.316s-0.81-0.738-1.316-0.518c-2.489 1.084-4.589 3.094-5.733 5.798-1.183 2.798-1.119 5.812-0.062 8.419s3.112 4.814 5.909 5.997 5.812 1.119 8.419 0.062 4.814-3.112 5.997-5.909c0.215-0.509-0.023-1.095-0.532-1.311s-1.095 0.023-1.311 0.532zM20.945 11h-7.945v-7.945c2.086 0.23 3.956 1.173 5.364 2.581s2.351 3.278 2.581 5.364zM23 12c0-3.037-1.232-5.789-3.222-7.778s-4.741-3.222-7.778-3.222c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1h10c0.552 0 1-0.448 1-1z",
    fill: fill
  }));
};

const IconMessageSquare = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22 15v-10c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-14c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v16c0 0.256 0.098 0.512 0.293 0.707 0.391 0.391 1.024 0.391 1.414 0l3.707-3.707h11.586c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121zM20 15c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-12c-0.276 0-0.526 0.112-0.707 0.293l-2.293 2.293v-13.586c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h14c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707z",
    fill: fill
  }));
};

const IconPulse = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M18.3334 9H15.0001L12.5001 16.5L7.50008 1.5L5.00008 9H1.66675",
    stroke: fill,
    strokeWidth: "1.5",
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: "0",
    fill: fill
  }));
};

const IconClose = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C6.5887 2.25 2.25 6.5887 2.25 12C2.25 17.4111 6.5887 21.75 12 21.75C17.411 21.75 21.75 17.4111 21.75 12C21.75 6.5887 17.4111 2.25 12 2.25ZM16.8752 15.51L15.5102 16.8749L12 13.3648L8.49 16.8749L7.12493 15.51L10.6351 12L7.12493 8.48992L8.49 7.12514L12 10.635L15.5101 7.12514L16.8751 8.48992L13.365 12L16.8752 15.51Z",
    fill: fill
  }));
};

const IconCloseOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M20.4905 3.51284C15.8111 -1.16655 8.19472 -1.16655 3.51533 3.51284C1.24862 5.78044 0 8.79467 0 12.0004C0 15.2061 1.24862 18.2203 3.51533 20.4871C5.85549 22.8272 8.92921 23.9968 12.0029 23.9968C15.0766 23.9968 18.1503 22.8272 20.4904 20.4871C25.1698 15.8077 25.1698 8.19312 20.4905 3.51284ZM19.1758 19.1724C15.2207 23.1275 8.78507 23.1275 4.82995 19.1724C2.91472 17.2571 1.85946 14.7097 1.85946 12.0004C1.85946 9.29113 2.91472 6.74364 4.82995 4.82746C8.78507 0.872343 15.2207 0.873281 19.1758 4.82746C23.13 8.78258 23.13 15.2182 19.1758 19.1724Z",
    fill: fill
  }), React.createElement("path", {
    d: "M16.0087 14.5702L13.3766 11.9418L16.0087 9.31348C16.3713 8.9509 16.3713 8.36238 16.0097 7.99882C15.6462 7.63436 15.0576 7.6353 14.6941 7.99788L12.0602 10.6281L9.42625 7.99788C9.06273 7.6353 8.47421 7.63436 8.11069 7.99882C7.7481 8.36233 7.7481 8.95085 8.11162 9.31348L10.7437 11.9418L8.11162 14.5702C7.7481 14.9328 7.7481 15.5213 8.11069 15.8848C8.292 16.067 8.53093 16.1572 8.76896 16.1572C9.00699 16.1572 9.24498 16.0661 9.42629 15.8857L12.0602 13.2555L14.6942 15.8857C14.8755 16.0671 15.1135 16.1572 15.3515 16.1572C15.5895 16.1572 15.8284 16.0661 16.0098 15.8848C16.3723 15.5213 16.3723 14.9328 16.0087 14.5702Z",
    fill: fill
  }));
};

const IconPersonOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M16.6668 17.5V15.8333C16.6668 14.9493 16.3156 14.1014 15.6905 13.4763C15.0654 12.8512 14.2176 12.5 13.3335 12.5H6.66683C5.78277 12.5 4.93493 12.8512 4.30981 13.4763C3.68469 14.1014 3.3335 14.9493 3.3335 15.8333V17.5",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fill: fill,
    d: "M9.99984 9.16667C11.8408 9.16667 13.3332 7.67428 13.3332 5.83333C13.3332 3.99238 11.8408 2.5 9.99984 2.5C8.15889 2.5 6.6665 3.99238 6.6665 5.83333C6.6665 7.67428 8.15889 9.16667 9.99984 9.16667Z",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconBriefcase = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M16.6665 5.83337H3.33317C2.4127 5.83337 1.6665 6.57957 1.6665 7.50004V15.8334C1.6665 16.7538 2.4127 17.5 3.33317 17.5H16.6665C17.587 17.5 18.3332 16.7538 18.3332 15.8334V7.50004C18.3332 6.57957 17.587 5.83337 16.6665 5.83337Z",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fill: fill,
    d: "M13.3332 17.5V4.16667C13.3332 3.72464 13.1576 3.30072 12.845 2.98816C12.5325 2.67559 12.1085 2.5 11.6665 2.5H8.33317C7.89114 2.5 7.46722 2.67559 7.15466 2.98816C6.8421 3.30072 6.6665 3.72464 6.6665 4.16667V17.5",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconMail = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M3.33317 1.33337H16.6665C17.5832 1.33337 18.3332 2.08337 18.3332 3.00004V13C18.3332 13.9167 17.5832 14.6667 16.6665 14.6667H3.33317C2.4165 14.6667 1.6665 13.9167 1.6665 13V3.00004C1.6665 2.08337 2.4165 1.33337 3.33317 1.33337Z",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconLockOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M15.8333 9.16663H4.16667C3.24619 9.16663 2.5 9.91282 2.5 10.8333V16.6666C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6666V10.8333C17.5 9.91282 16.7538 9.16663 15.8333 9.16663Z",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fill: fill,
    d: "M5.8335 9.16663V5.83329C5.8335 4.72822 6.27248 3.66842 7.05388 2.88701C7.83529 2.10561 8.89509 1.66663 10.0002 1.66663C11.1052 1.66663 12.165 2.10561 12.9464 2.88701C13.7278 3.66842 14.1668 4.72822 14.1668 5.83329V9.16663",
    stroke: "#CACCCF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconArrowDown = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7.406 8.578l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z",
    fill: fill
  }));
};

const IconArrowUp = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M7.406 15.422l-1.406-1.406 6-6 6 6-1.406 1.406-4.594-4.594z",
    fill: fill
  }));
};

const IconArrowLeft = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M15.422 16.594l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z",
    fill: fill
  }));
};

const IconUserAddPlus = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M17 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-7c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h7c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM13.5 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM11.5 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121zM23 10h-2v-2c0-0.552-0.448-1-1-1s-1 0.448-1 1v2h-2c-0.552 0-1 0.448-1 1s0.448 1 1 1h2v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2h2c0.552 0 1-0.448 1-1s-0.448-1-1-1z",
    fill: fill
  }));
};

const IconEditPen = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16.293 2.293l-13.5 13.5c-0.117 0.116-0.21 0.268-0.258 0.444l-1.5 5.5c-0.046 0.163-0.049 0.346 0 0.526 0.145 0.533 0.695 0.847 1.228 0.702l5.5-1.5c0.159-0.042 0.315-0.129 0.444-0.258l13.5-13.5c0.747-0.747 1.121-1.729 1.121-2.707s-0.374-1.96-1.121-2.707-1.729-1.121-2.707-1.121-1.96 0.374-2.707 1.121zM17.707 3.707c0.357-0.357 0.824-0.535 1.293-0.535s0.936 0.178 1.293 0.536 0.535 0.823 0.535 1.292-0.178 0.936-0.535 1.293l-13.312 13.312-3.556 0.97 0.97-3.555z",
    fill: fill
  }));
};

const IconCheckCircle = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21 11.080v0.92c-0.001 2.485-1.009 4.733-2.64 6.362s-3.88 2.634-6.365 2.632-4.734-1.009-6.362-2.64-2.634-3.879-2.633-6.365 1.009-4.733 2.64-6.362 3.88-2.634 6.365-2.633c1.33 0.001 2.586 0.289 3.649 0.775 0.502 0.23 1.096 0.008 1.325-0.494s0.008-1.096-0.494-1.325c-1.327-0.606-2.866-0.955-4.479-0.956-3.037-0.002-5.789 1.229-7.78 3.217s-3.224 4.74-3.226 7.777 1.229 5.789 3.217 7.78 4.739 3.225 7.776 3.226 5.789-1.229 7.78-3.217 3.225-4.739 3.227-7.777v-0.92c0-0.552-0.448-1-1-1s-1 0.448-1 1zM21.293 3.293l-9.293 9.302-2.293-2.292c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3 3c0.391 0.391 1.024 0.39 1.415 0l10-10.010c0.39-0.391 0.39-1.024-0.001-1.414s-1.024-0.39-1.414 0.001z",
    fill: fill
  }));
};

const IconTrash = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M18 7v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-10c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-13zM17 5v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v13c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h10c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-13h1c0.552 0 1-0.448 1-1s-0.448-1-1-1zM9 5v-1c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1z",
    fill: fill
  }));
};

const IconTrashColored = props => {
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9059 4.36947C17.2301 4.36947 17.5 4.63863 17.5 4.98113V5.29779C17.5 5.63195 17.2301 5.90945 16.9059 5.90945H3.09488C2.76988 5.90945 2.5 5.63195 2.5 5.29779V4.98113C2.5 4.63863 2.76988 4.36947 3.09488 4.36947H5.52464C6.01821 4.36947 6.44775 4.01864 6.55879 3.52364L6.68603 2.95531C6.88378 2.18115 7.53458 1.66699 8.27939 1.66699H11.7206C12.4573 1.66699 13.1154 2.18115 13.3059 2.91448L13.442 3.52281C13.5522 4.01864 13.9818 4.36947 14.4762 4.36947H16.9059ZM15.6715 15.9453C15.9252 13.5812 16.3693 7.9646 16.3693 7.90793C16.3855 7.73626 16.3296 7.57377 16.2186 7.44293C16.0994 7.32044 15.9487 7.24794 15.7826 7.24794H4.22377C4.05681 7.24794 3.89796 7.32044 3.78774 7.44293C3.6759 7.57377 3.62079 7.73626 3.62889 7.90793C3.63038 7.91834 3.64632 8.11618 3.67296 8.44694C3.79132 9.91631 4.12097 14.0088 4.33399 15.9453C4.48474 17.372 5.42082 18.2687 6.77672 18.3012C7.82302 18.3253 8.90094 18.3337 10.0032 18.3337C11.0414 18.3337 12.0958 18.3253 13.1745 18.3012C14.5774 18.277 15.5127 17.3962 15.6715 15.9453Z",
    fill: props.fill
  }));
};

const IconInBoxOutline = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fill: fill,
    d: "M21 13v5c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-16c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-5h4.465l1.703 2.555c0.182 0.27 0.486 0.445 0.832 0.445h4c0.326-0.002 0.64-0.158 0.832-0.445l1.703-2.555zM6.344 5.558c0.066-0.131 0.16-0.246 0.272-0.337 0.172-0.139 0.387-0.221 0.624-0.221h9.513c0.15 0.001 0.295 0.034 0.426 0.094 0.201 0.092 0.37 0.249 0.477 0.464l2.725 5.442h-4.381c-0.346 0-0.65 0.175-0.832 0.445l-1.703 2.555h-2.93l-1.703-2.555c-0.192-0.287-0.506-0.443-0.832-0.445h-4.381zM4.556 4.662l-3.441 6.872c-0.031 0.059-0.056 0.121-0.075 0.187-0.028 0.094-0.041 0.188-0.040 0.279v6c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h16c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-6c0-0.151-0.033-0.293-0.091-0.417-0.005-0.010-0.010-0.021-0.015-0.031l-0.009-0.018-3.441-6.872c-0.315-0.634-0.829-1.111-1.433-1.387-0.388-0.177-0.812-0.272-1.244-0.275h-9.527c-0.711 0-1.367 0.249-1.883 0.667-0.331 0.268-0.605 0.606-0.801 0.995z"
  }));
};

const IconSettingsOutline = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16 12c0-1.104-0.449-2.106-1.172-2.828s-1.724-1.172-2.828-1.172-2.106 0.449-2.828 1.172-1.172 1.724-1.172 2.828 0.449 2.106 1.172 2.828 1.724 1.172 2.828 1.172 2.106-0.449 2.828-1.172 1.172-1.724 1.172-2.828zM14 12c0 0.553-0.223 1.051-0.586 1.414s-0.861 0.586-1.414 0.586-1.051-0.223-1.414-0.586-0.586-0.861-0.586-1.414 0.223-1.051 0.586-1.414 0.861-0.586 1.414-0.586 1.051 0.223 1.414 0.586 0.586 0.861 0.586 1.414zM20.315 15.404c0.046-0.105 0.112-0.191 0.192-0.257 0.112-0.092 0.251-0.146 0.403-0.147h0.090c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121-0.337-1.58-0.879-2.121-1.293-0.879-2.121-0.879h-0.159c-0.11-0.001-0.215-0.028-0.308-0.076-0.127-0.066-0.23-0.172-0.292-0.312-0.003-0.029-0.004-0.059-0.004-0.089-0.024-0.055-0.040-0.111-0.049-0.168 0.020-0.334 0.077-0.454 0.168-0.547l0.062-0.062c0.585-0.586 0.878-1.356 0.877-2.122s-0.294-1.536-0.881-2.122c-0.586-0.585-1.356-0.878-2.122-0.877s-1.536 0.294-2.12 0.879l-0.046 0.046c-0.083 0.080-0.183 0.136-0.288 0.166-0.14 0.039-0.291 0.032-0.438-0.033-0.101-0.044-0.187-0.11-0.253-0.19-0.092-0.112-0.146-0.251-0.147-0.403v-0.090c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879-1.58 0.337-2.121 0.879-0.879 1.293-0.879 2.121v0.159c-0.001 0.11-0.028 0.215-0.076 0.308-0.066 0.127-0.172 0.23-0.312 0.292-0.029 0.003-0.059 0.004-0.089 0.004-0.055 0.024-0.111 0.040-0.168 0.049-0.335-0.021-0.455-0.078-0.548-0.169l-0.062-0.062c-0.586-0.585-1.355-0.878-2.122-0.878s-1.535 0.294-2.122 0.882c-0.585 0.586-0.878 1.355-0.878 2.122s0.294 1.536 0.879 2.12l0.048 0.047c0.080 0.083 0.136 0.183 0.166 0.288 0.039 0.14 0.032 0.291-0.031 0.434-0.006 0.016-0.013 0.034-0.021 0.052-0.041 0.109-0.108 0.203-0.191 0.275-0.11 0.095-0.25 0.153-0.383 0.156h-0.090c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.294-0.879 2.122 0.337 1.58 0.879 2.121 1.293 0.879 2.121 0.879h0.159c0.11 0.001 0.215 0.028 0.308 0.076 0.128 0.067 0.233 0.174 0.296 0.321 0.024 0.055 0.040 0.111 0.049 0.168-0.020 0.334-0.077 0.454-0.168 0.547l-0.062 0.062c-0.585 0.586-0.878 1.356-0.877 2.122s0.294 1.536 0.881 2.122c0.586 0.585 1.356 0.878 2.122 0.877s1.536-0.294 2.12-0.879l0.047-0.048c0.083-0.080 0.183-0.136 0.288-0.166 0.14-0.039 0.291-0.032 0.434 0.031 0.016 0.006 0.034 0.013 0.052 0.021 0.109 0.041 0.203 0.108 0.275 0.191 0.095 0.11 0.153 0.25 0.156 0.383v0.092c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879 1.58-0.337 2.121-0.879 0.879-1.293 0.879-2.121v-0.159c0.001-0.11 0.028-0.215 0.076-0.308 0.067-0.128 0.174-0.233 0.321-0.296 0.055-0.024 0.111-0.040 0.168-0.049 0.334 0.020 0.454 0.077 0.547 0.168l0.062 0.062c0.586 0.585 1.356 0.878 2.122 0.877s1.536-0.294 2.122-0.881c0.585-0.586 0.878-1.356 0.877-2.122s-0.294-1.536-0.879-2.12l-0.048-0.047c-0.080-0.083-0.136-0.183-0.166-0.288-0.039-0.14-0.032-0.291 0.031-0.434zM18.396 9.302c-0.012-0.201-0.038-0.297-0.076-0.382v0.080c0 0.043 0.003 0.084 0.008 0.125 0.021 0.060 0.043 0.119 0.068 0.177 0.004 0.090 0.005 0.091 0.005 0.092 0.249 0.581 0.684 1.030 1.208 1.303 0.371 0.193 0.785 0.298 1.211 0.303h0.18c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707-0.111 0.525-0.293 0.707-0.431 0.293-0.707 0.293h-0.090c-0.637 0.003-1.22 0.228-1.675 0.603-0.323 0.266-0.581 0.607-0.75 0.993-0.257 0.582-0.288 1.21-0.127 1.782 0.119 0.423 0.341 0.814 0.652 1.136l0.072 0.073c0.196 0.196 0.294 0.45 0.294 0.707s-0.097 0.512-0.292 0.707c-0.197 0.197-0.451 0.295-0.709 0.295s-0.512-0.097-0.707-0.292l-0.061-0.061c-0.463-0.453-1.040-0.702-1.632-0.752-0.437-0.037-0.882 0.034-1.293 0.212-0.578 0.248-1.027 0.683-1.3 1.206-0.193 0.371-0.298 0.785-0.303 1.211v0.181c0 0.276-0.111 0.525-0.293 0.707s-0.43 0.292-0.706 0.292-0.525-0.111-0.707-0.293-0.293-0.431-0.293-0.707v-0.090c-0.015-0.66-0.255-1.242-0.644-1.692-0.284-0.328-0.646-0.585-1.058-0.744-0.575-0.247-1.193-0.274-1.756-0.116-0.423 0.119-0.814 0.341-1.136 0.652l-0.073 0.072c-0.196 0.196-0.45 0.294-0.707 0.294s-0.512-0.097-0.707-0.292c-0.197-0.197-0.295-0.451-0.295-0.709s0.097-0.512 0.292-0.707l0.061-0.061c0.453-0.463 0.702-1.040 0.752-1.632 0.037-0.437-0.034-0.882-0.212-1.293-0.248-0.578-0.683-1.027-1.206-1.3-0.371-0.193-0.785-0.298-1.211-0.303l-0.18 0.001c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707 0.111-0.525 0.293-0.707 0.431-0.293 0.707-0.293h0.090c0.66-0.015 1.242-0.255 1.692-0.644 0.328-0.284 0.585-0.646 0.744-1.058 0.247-0.575 0.274-1.193 0.116-1.756-0.119-0.423-0.341-0.814-0.652-1.136l-0.073-0.073c-0.196-0.196-0.294-0.45-0.294-0.707s0.097-0.512 0.292-0.707c0.197-0.197 0.451-0.295 0.709-0.295s0.512 0.097 0.707 0.292l0.061 0.061c0.463 0.453 1.040 0.702 1.632 0.752 0.37 0.032 0.745-0.014 1.101-0.137 0.096-0.012 0.186-0.036 0.266-0.072-0.031 0.001-0.061 0.003-0.089 0.004-0.201 0.012-0.297 0.038-0.382 0.076h0.080c0.043 0 0.084-0.003 0.125-0.008 0.060-0.021 0.119-0.043 0.177-0.068 0.090-0.004 0.091-0.005 0.092-0.005 0.581-0.249 1.030-0.684 1.303-1.208 0.193-0.37 0.298-0.785 0.303-1.21v-0.181c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293 0.525 0.111 0.707 0.293 0.293 0.431 0.293 0.707v0.090c0.003 0.637 0.228 1.22 0.603 1.675 0.266 0.323 0.607 0.581 0.996 0.751 0.578 0.255 1.206 0.286 1.778 0.125 0.423-0.119 0.814-0.341 1.136-0.652l0.073-0.072c0.196-0.196 0.45-0.294 0.707-0.294s0.512 0.097 0.707 0.292c0.197 0.197 0.295 0.451 0.295 0.709s-0.097 0.512-0.292 0.707l-0.061 0.061c-0.453 0.463-0.702 1.040-0.752 1.632-0.032 0.37 0.014 0.745 0.137 1.101 0.012 0.095 0.037 0.185 0.072 0.266-0.001-0.032-0.002-0.062-0.004-0.089z",
    fill: fill
  }));
};

const IconUserOutline = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-8c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h8c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM17 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM15 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121z",
    fill: fill
  }));
};

const IconGroup$2 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M23.3607 5.66491L18.0333 0.606955C17.6337 0.227608 17.0744 0 16.4883 0H2.1576C0.958935 0 0 0.910432 0 2.04847V21.9515C0 23.0896 0.958935 24 2.1576 24H21.8424C23.0411 24 24 23.0896 24 21.9515V7.13172C24 6.57534 23.7603 6.04426 23.3607 5.66491ZM7.64484 4.65332C7.64484 4.22339 8.01776 3.86934 8.47059 3.86934H15.4761C15.929 3.86934 16.3019 4.22339 16.3019 4.65332V9.43309C16.3019 9.86301 15.929 10.2171 15.4761 10.2171H8.49723C8.0444 10.2171 7.67148 9.86301 7.67148 9.43309V4.65332H7.64484ZM18.6193 19.372C18.6193 19.8019 18.2464 20.156 17.7936 20.156H6.1798C5.72697 20.156 5.35405 19.8019 5.35405 19.372V14.1623C5.35405 13.7323 5.72697 13.3783 6.1798 13.3783H17.7669C18.2198 13.3783 18.5927 13.7323 18.5927 14.1623V19.372H18.6193Z",
    fill: "#262626"
  }));
};

const IconMaterial$1 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92623 16.39H14.3124C14.7183 16.39 15.0549 16.05 15.0549 15.64C15.0549 15.23 14.7183 14.9 14.3124 14.9H8.92623C8.52029 14.9 8.18366 15.23 8.18366 15.64C8.18366 16.05 8.52029 16.39 8.92623 16.39ZM12.2728 9.9H8.92623C8.52029 9.9 8.18366 10.24 8.18366 10.65C8.18366 11.06 8.52029 11.39 8.92623 11.39H12.2728C12.6787 11.39 13.0153 11.06 13.0153 10.65C13.0153 10.24 12.6787 9.9 12.2728 9.9ZM19.3386 9.02561C19.5713 9.02292 19.8247 9.02 20.0549 9.02C20.3025 9.02 20.5005 9.22 20.5005 9.47V17.51C20.5005 19.99 18.5104 22 16.0549 22H8.17376C5.5995 22 3.50049 19.89 3.50049 17.29V6.51C3.50049 4.03 5.50049 2 7.96583 2H13.253C13.5104 2 13.7084 2.21 13.7084 2.46V5.68C13.7084 7.51 15.2035 9.01 17.0153 9.02C17.4386 9.02 17.8117 9.02316 18.1382 9.02593C18.3922 9.02809 18.618 9.03 18.8173 9.03C18.9583 9.03 19.141 9.02789 19.3386 9.02561ZM19.6116 7.566C18.7977 7.569 17.8383 7.566 17.1482 7.559C16.0532 7.559 15.1512 6.648 15.1512 5.542V2.906C15.1512 2.475 15.669 2.261 15.965 2.572C16.5009 3.13476 17.2373 3.90834 17.9704 4.67837C18.7014 5.44632 19.4291 6.21074 19.9512 6.759C20.2403 7.062 20.0284 7.565 19.6116 7.566Z",
    fill: "#F54E95"
  }), React.createElement("path", {
    d: "M37.1405 4.29H44.8505V5.91H39.0155V8.715H44.4155V10.245H39.0155V13.38H44.9555V15H37.1405V4.29ZM53.8187 14.595C53.8187 15.765 53.4887 16.635 52.8287 17.205C52.1787 17.785 51.2387 18.075 50.0087 18.075C49.6187 18.075 49.2237 18.035 48.8237 17.955C48.4337 17.875 48.0737 17.74 47.7437 17.55C47.4237 17.36 47.1537 17.11 46.9337 16.8C46.7137 16.49 46.5837 16.11 46.5437 15.66H48.2537C48.3037 15.9 48.3887 16.095 48.5087 16.245C48.6287 16.395 48.7687 16.51 48.9287 16.59C49.0987 16.68 49.2837 16.735 49.4837 16.755C49.6837 16.785 49.8937 16.8 50.1137 16.8C50.8037 16.8 51.3087 16.63 51.6287 16.29C51.9487 15.95 52.1087 15.46 52.1087 14.82V13.635H52.0787C51.8387 14.065 51.5087 14.4 51.0887 14.64C50.6787 14.88 50.2337 15 49.7537 15C49.1337 15 48.6037 14.895 48.1637 14.685C47.7337 14.465 47.3737 14.17 47.0837 13.8C46.8037 13.42 46.5987 12.985 46.4687 12.495C46.3387 12.005 46.2737 11.48 46.2737 10.92C46.2737 10.4 46.3537 9.905 46.5137 9.435C46.6737 8.965 46.9037 8.555 47.2037 8.205C47.5037 7.845 47.8687 7.56 48.2987 7.35C48.7387 7.14 49.2337 7.035 49.7837 7.035C50.2737 7.035 50.7237 7.14 51.1337 7.35C51.5437 7.55 51.8587 7.87 52.0787 8.31H52.1087V7.245H53.8187V14.595ZM50.0237 13.65C50.4037 13.65 50.7237 13.575 50.9837 13.425C51.2537 13.265 51.4687 13.06 51.6287 12.81C51.7987 12.55 51.9187 12.26 51.9887 11.94C52.0687 11.61 52.1087 11.28 52.1087 10.95C52.1087 10.62 52.0687 10.3 51.9887 9.99C51.9087 9.68 51.7837 9.405 51.6137 9.165C51.4537 8.925 51.2387 8.735 50.9687 8.595C50.7087 8.455 50.3937 8.385 50.0237 8.385C49.6437 8.385 49.3237 8.465 49.0637 8.625C48.8037 8.785 48.5937 8.995 48.4337 9.255C48.2737 9.505 48.1587 9.795 48.0887 10.125C48.0187 10.445 47.9837 10.765 47.9837 11.085C47.9837 11.405 48.0237 11.72 48.1037 12.03C48.1837 12.33 48.3037 12.6 48.4637 12.84C48.6337 13.08 48.8437 13.275 49.0937 13.425C49.3537 13.575 49.6637 13.65 50.0237 13.65ZM55.8853 4.29H57.5953V15H55.8853V4.29ZM59.8035 4.29H61.5135V5.91H59.8035V4.29ZM59.8035 7.245H61.5135V15H59.8035V7.245ZM64.9667 12.51C65.0167 13.01 65.2067 13.36 65.5367 13.56C65.8667 13.76 66.2617 13.86 66.7217 13.86C66.8817 13.86 67.0617 13.85 67.2617 13.83C67.4717 13.8 67.6667 13.75 67.8467 13.68C68.0267 13.61 68.1717 13.51 68.2817 13.38C68.4017 13.24 68.4567 13.06 68.4467 12.84C68.4367 12.62 68.3567 12.44 68.2067 12.3C68.0567 12.16 67.8617 12.05 67.6217 11.97C67.3917 11.88 67.1267 11.805 66.8267 11.745C66.5267 11.685 66.2217 11.62 65.9117 11.55C65.5917 11.48 65.2817 11.395 64.9817 11.295C64.6917 11.195 64.4267 11.06 64.1867 10.89C63.9567 10.72 63.7717 10.505 63.6317 10.245C63.4917 9.975 63.4217 9.645 63.4217 9.255C63.4217 8.835 63.5217 8.485 63.7217 8.205C63.9317 7.915 64.1917 7.685 64.5017 7.515C64.8217 7.335 65.1717 7.21 65.5517 7.14C65.9417 7.07 66.3117 7.035 66.6617 7.035C67.0617 7.035 67.4417 7.08 67.8017 7.17C68.1717 7.25 68.5017 7.385 68.7917 7.575C69.0917 7.765 69.3367 8.015 69.5267 8.325C69.7267 8.625 69.8517 8.99 69.9017 9.42H68.1167C68.0367 9.01 67.8467 8.735 67.5467 8.595C67.2567 8.455 66.9217 8.385 66.5417 8.385C66.4217 8.385 66.2767 8.395 66.1067 8.415C65.9467 8.435 65.7917 8.475 65.6417 8.535C65.5017 8.585 65.3817 8.665 65.2817 8.775C65.1817 8.875 65.1317 9.01 65.1317 9.18C65.1317 9.39 65.2017 9.56 65.3417 9.69C65.4917 9.82 65.6817 9.93 65.9117 10.02C66.1517 10.1 66.4217 10.17 66.7217 10.23C67.0217 10.29 67.3317 10.355 67.6517 10.425C67.9617 10.495 68.2667 10.58 68.5667 10.68C68.8667 10.78 69.1317 10.915 69.3617 11.085C69.6017 11.255 69.7917 11.47 69.9317 11.73C70.0817 11.99 70.1567 12.31 70.1567 12.69C70.1567 13.15 70.0517 13.54 69.8417 13.86C69.6317 14.18 69.3567 14.44 69.0167 14.64C68.6867 14.84 68.3167 14.985 67.9067 15.075C67.4967 15.165 67.0917 15.21 66.6917 15.21C66.2017 15.21 65.7467 15.155 65.3267 15.045C64.9167 14.935 64.5567 14.77 64.2467 14.55C63.9467 14.32 63.7067 14.04 63.5267 13.71C63.3567 13.37 63.2667 12.97 63.2567 12.51H64.9667ZM71.755 4.29H73.465V8.265H73.495C73.705 7.915 74.015 7.625 74.425 7.395C74.845 7.155 75.31 7.035 75.82 7.035C76.67 7.035 77.34 7.255 77.83 7.695C78.32 8.135 78.565 8.795 78.565 9.675V15H76.855V10.125C76.835 9.515 76.705 9.075 76.465 8.805C76.225 8.525 75.85 8.385 75.34 8.385C75.05 8.385 74.79 8.44 74.56 8.55C74.33 8.65 74.135 8.795 73.975 8.985C73.815 9.165 73.69 9.38 73.6 9.63C73.51 9.88 73.465 10.145 73.465 10.425V15H71.755V4.29ZM88.2181 4.035H89.8531L85.5481 15.255H83.9131L88.2181 4.035ZM94.4263 7.245H95.7013V6.6C95.7013 6.11 95.7613 5.715 95.8813 5.415C96.0013 5.105 96.1613 4.87 96.3613 4.71C96.5613 4.54 96.7863 4.43 97.0363 4.38C97.2963 4.32 97.5663 4.29 97.8463 4.29C98.3963 4.29 98.7963 4.325 99.0463 4.395V5.73C98.9363 5.7 98.8163 5.68 98.6863 5.67C98.5663 5.65 98.4213 5.64 98.2513 5.64C98.0213 5.64 97.8213 5.695 97.6513 5.805C97.4913 5.915 97.4113 6.13 97.4113 6.45V7.245H98.8663V8.52H97.4113V15H95.7013V8.52H94.4263V7.245ZM100.268 4.29H101.978V5.91H100.268V4.29ZM100.268 7.245H101.978V15H100.268V7.245ZM104.186 4.29H105.896V15H104.186V4.29ZM113.384 10.44C113.364 10.17 113.304 9.91 113.204 9.66C113.114 9.41 112.984 9.195 112.814 9.015C112.654 8.825 112.454 8.675 112.214 8.565C111.984 8.445 111.724 8.385 111.434 8.385C111.134 8.385 110.859 8.44 110.609 8.55C110.369 8.65 110.159 8.795 109.979 8.985C109.809 9.165 109.669 9.38 109.559 9.63C109.459 9.88 109.404 10.15 109.394 10.44H113.384ZM109.394 11.565C109.394 11.865 109.434 12.155 109.514 12.435C109.604 12.715 109.734 12.96 109.904 13.17C110.074 13.38 110.289 13.55 110.549 13.68C110.809 13.8 111.119 13.86 111.479 13.86C111.979 13.86 112.379 13.755 112.679 13.545C112.989 13.325 113.219 13 113.369 12.57H114.989C114.899 12.99 114.744 13.365 114.524 13.695C114.304 14.025 114.039 14.305 113.729 14.535C113.419 14.755 113.069 14.92 112.679 15.03C112.299 15.15 111.899 15.21 111.479 15.21C110.869 15.21 110.329 15.11 109.859 14.91C109.389 14.71 108.989 14.43 108.659 14.07C108.339 13.71 108.094 13.28 107.924 12.78C107.764 12.28 107.684 11.73 107.684 11.13C107.684 10.58 107.769 10.06 107.939 9.57C108.119 9.07 108.369 8.635 108.689 8.265C109.019 7.885 109.414 7.585 109.874 7.365C110.334 7.145 110.854 7.035 111.434 7.035C112.044 7.035 112.589 7.165 113.069 7.425C113.559 7.675 113.964 8.01 114.284 8.43C114.604 8.85 114.834 9.335 114.974 9.885C115.124 10.425 115.164 10.985 115.094 11.565H109.394ZM116.829 12.975H118.914V15H116.829V12.975ZM121.214 7.245H122.834V8.295H122.864C123.104 7.845 123.439 7.525 123.869 7.335C124.299 7.135 124.764 7.035 125.264 7.035C125.874 7.035 126.404 7.145 126.854 7.365C127.314 7.575 127.694 7.87 127.994 8.25C128.294 8.62 128.519 9.055 128.669 9.555C128.819 10.055 128.894 10.59 128.894 11.16C128.894 11.68 128.824 12.185 128.684 12.675C128.554 13.165 128.349 13.6 128.069 13.98C127.799 14.35 127.454 14.65 127.034 14.88C126.614 15.1 126.119 15.21 125.549 15.21C125.299 15.21 125.049 15.185 124.799 15.135C124.549 15.095 124.309 15.025 124.079 14.925C123.849 14.825 123.634 14.7 123.434 14.55C123.244 14.39 123.084 14.205 122.954 13.995H122.924V17.865H121.214V7.245ZM127.184 11.13C127.184 10.78 127.139 10.44 127.049 10.11C126.959 9.78 126.824 9.49 126.644 9.24C126.464 8.98 126.239 8.775 125.969 8.625C125.699 8.465 125.389 8.385 125.039 8.385C124.319 8.385 123.774 8.635 123.404 9.135C123.044 9.635 122.864 10.3 122.864 11.13C122.864 11.52 122.909 11.885 122.999 12.225C123.099 12.555 123.244 12.84 123.434 13.08C123.624 13.32 123.849 13.51 124.109 13.65C124.379 13.79 124.689 13.86 125.039 13.86C125.429 13.86 125.759 13.78 126.029 13.62C126.299 13.46 126.519 13.255 126.689 13.005C126.869 12.745 126.994 12.455 127.064 12.135C127.144 11.805 127.184 11.47 127.184 11.13ZM137.944 15H136.324V13.95H136.294C136.064 14.4 135.729 14.725 135.289 14.925C134.849 15.115 134.384 15.21 133.894 15.21C133.284 15.21 132.749 15.105 132.289 14.895C131.839 14.675 131.464 14.38 131.164 14.01C130.864 13.64 130.639 13.205 130.489 12.705C130.339 12.195 130.264 11.65 130.264 11.07C130.264 10.37 130.359 9.765 130.549 9.255C130.739 8.745 130.989 8.325 131.299 7.995C131.619 7.665 131.979 7.425 132.379 7.275C132.789 7.115 133.204 7.035 133.624 7.035C133.864 7.035 134.109 7.06 134.359 7.11C134.609 7.15 134.849 7.22 135.079 7.32C135.309 7.42 135.519 7.55 135.709 7.71C135.909 7.86 136.074 8.04 136.204 8.25H136.234V4.29H137.944V15ZM131.974 11.205C131.974 11.535 132.014 11.86 132.094 12.18C132.184 12.5 132.314 12.785 132.484 13.035C132.664 13.285 132.889 13.485 133.159 13.635C133.429 13.785 133.749 13.86 134.119 13.86C134.499 13.86 134.824 13.78 135.094 13.62C135.374 13.46 135.599 13.25 135.769 12.99C135.949 12.73 136.079 12.44 136.159 12.12C136.249 11.79 136.294 11.455 136.294 11.115C136.294 10.255 136.099 9.585 135.709 9.105C135.329 8.625 134.809 8.385 134.149 8.385C133.749 8.385 133.409 8.47 133.129 8.64C132.859 8.8 132.634 9.015 132.454 9.285C132.284 9.545 132.159 9.845 132.079 10.185C132.009 10.515 131.974 10.855 131.974 11.205ZM139.344 7.245H140.619V6.6C140.619 6.11 140.679 5.715 140.799 5.415C140.919 5.105 141.079 4.87 141.279 4.71C141.479 4.54 141.704 4.43 141.954 4.38C142.214 4.32 142.484 4.29 142.764 4.29C143.314 4.29 143.714 4.325 143.964 4.395V5.73C143.854 5.7 143.734 5.68 143.604 5.67C143.484 5.65 143.339 5.64 143.169 5.64C142.939 5.64 142.739 5.695 142.569 5.805C142.409 5.915 142.329 6.13 142.329 6.45V7.245H143.784V8.52H142.329V15H140.619V8.52H139.344V7.245Z",
    fill: "#394F93"
  }), React.createElement("path", {
    d: "M37.7425 67.777H36.6375C36.7068 68.5743 36.9972 69.168 37.5085 69.558C38.0198 69.948 38.6612 70.143 39.4325 70.143C40.5505 70.143 41.3608 69.7183 41.8635 68.869C42.3748 68.011 42.6305 66.7847 42.6305 65.19C42.6305 64.3147 42.5438 63.5953 42.3705 63.032C42.2058 62.46 41.9805 62.0093 41.6945 61.68C41.4085 61.3507 41.0748 61.121 40.6935 60.991C40.3122 60.8523 39.9048 60.783 39.4715 60.783C39.0295 60.783 38.6222 60.8567 38.2495 61.004C37.8768 61.1513 37.5562 61.3593 37.2875 61.628C37.0188 61.888 36.8108 62.2043 36.6635 62.577C36.5162 62.941 36.4425 63.344 36.4425 63.786C36.4425 64.2367 36.5032 64.6527 36.6245 65.034C36.7545 65.4153 36.9408 65.7403 37.1835 66.009C37.4348 66.2777 37.7425 66.49 38.1065 66.646C38.4705 66.7933 38.8865 66.867 39.3545 66.867C39.8052 66.867 40.2212 66.7543 40.6025 66.529C40.9838 66.295 41.2785 65.983 41.4865 65.593L41.5125 65.619C41.4778 66.8237 41.2915 67.7207 40.9535 68.31C40.6155 68.8907 40.1085 69.181 39.4325 69.181C38.9905 69.181 38.6092 69.0597 38.2885 68.817C37.9678 68.5743 37.7858 68.2277 37.7425 67.777ZM41.3175 63.864C41.3175 64.1327 41.2742 64.3927 41.1875 64.644C41.1008 64.8867 40.9752 65.1033 40.8105 65.294C40.6458 65.476 40.4465 65.6233 40.2125 65.736C39.9785 65.84 39.7185 65.892 39.4325 65.892C39.1638 65.892 38.9168 65.84 38.6915 65.736C38.4748 65.6233 38.2842 65.476 38.1195 65.294C37.9635 65.112 37.8378 64.904 37.7425 64.67C37.6558 64.436 37.6125 64.1933 37.6125 63.942C37.6125 63.656 37.6428 63.383 37.7035 63.123C37.7728 62.863 37.8768 62.6333 38.0155 62.434C38.1628 62.226 38.3492 62.0613 38.5745 61.94C38.8085 61.8187 39.0902 61.758 39.4195 61.758C39.7315 61.758 40.0045 61.8143 40.2385 61.927C40.4725 62.0397 40.6675 62.1957 40.8235 62.395C40.9882 62.5857 41.1095 62.8067 41.1875 63.058C41.2742 63.3093 41.3175 63.578 41.3175 63.864ZM52.9753 67.686V60.718H51.7403V67.504C51.7403 68.0153 51.632 68.4227 51.4153 68.726C51.2073 69.0293 50.8216 69.181 50.2583 69.181C49.955 69.181 49.7036 69.1377 49.5043 69.051C49.3136 68.9557 49.162 68.8257 49.0493 68.661C48.9453 68.4963 48.8716 68.3013 48.8283 68.076C48.785 67.8507 48.7633 67.6037 48.7633 67.335V66.945H47.5283V67.517C47.5283 68.401 47.7623 69.0727 48.2303 69.532C48.6983 69.9827 49.3656 70.208 50.2323 70.208C50.7523 70.208 51.1856 70.1387 51.5323 70C51.8876 69.8527 52.1693 69.662 52.3773 69.428C52.594 69.1853 52.7456 68.9123 52.8323 68.609C52.9276 68.3057 52.9753 67.998 52.9753 67.686ZM60.5795 70V63.279H59.4745V67.075C59.4745 67.3783 59.4312 67.66 59.3445 67.92C59.2665 68.1713 59.1452 68.3923 58.9805 68.583C58.8158 68.7737 58.6078 68.921 58.3565 69.025C58.1138 69.129 57.8235 69.181 57.4855 69.181C57.0608 69.181 56.7272 69.0597 56.4845 68.817C56.2418 68.5743 56.1205 68.245 56.1205 67.829V63.279H55.0155V67.699C55.0155 68.063 55.0502 68.3967 55.1195 68.7C55.1975 68.9947 55.3275 69.2503 55.5095 69.467C55.6915 69.6837 55.9298 69.8527 56.2245 69.974C56.5192 70.0867 56.8875 70.143 57.3295 70.143C57.8235 70.143 58.2525 70.0477 58.6165 69.857C58.9805 69.6577 59.2795 69.35 59.5135 68.934H59.5395V70H60.5795ZM62.4391 63.279V70H63.5441V66.204C63.5441 65.9007 63.5831 65.6233 63.6611 65.372C63.7478 65.112 63.8735 64.8867 64.0381 64.696C64.2028 64.5053 64.4065 64.358 64.6491 64.254C64.9005 64.15 65.1951 64.098 65.5331 64.098C65.9578 64.098 66.2915 64.2193 66.5341 64.462C66.7768 64.7047 66.8981 65.034 66.8981 65.45V70H68.0031V65.58C68.0031 65.216 67.9641 64.8867 67.8861 64.592C67.8168 64.2887 67.6911 64.0287 67.5091 63.812C67.3271 63.5953 67.0888 63.4263 66.7941 63.305C66.4995 63.1837 66.1311 63.123 65.6891 63.123C64.6925 63.123 63.9645 63.5303 63.5051 64.345H63.4791V63.279H62.4391ZM74.5298 65.996H70.6688C70.6861 65.736 70.7424 65.4933 70.8378 65.268C70.9331 65.034 71.0631 64.8303 71.2278 64.657C71.3924 64.4837 71.5874 64.3493 71.8128 64.254C72.0468 64.15 72.3068 64.098 72.5928 64.098C72.8701 64.098 73.1214 64.15 73.3468 64.254C73.5808 64.3493 73.7801 64.4837 73.9448 64.657C74.1181 64.8217 74.2524 65.021 74.3478 65.255C74.4518 65.489 74.5124 65.736 74.5298 65.996ZM75.5958 67.868H74.5038C74.4084 68.31 74.2091 68.6393 73.9058 68.856C73.6111 69.0727 73.2298 69.181 72.7618 69.181C72.3978 69.181 72.0814 69.1203 71.8128 68.999C71.5441 68.8777 71.3231 68.7173 71.1498 68.518C70.9764 68.31 70.8508 68.076 70.7728 67.816C70.6948 67.5473 70.6601 67.2657 70.6688 66.971H75.6998C75.7171 66.5637 75.6781 66.1347 75.5828 65.684C75.4961 65.2333 75.3314 64.8173 75.0888 64.436C74.8548 64.0547 74.5384 63.7427 74.1398 63.5C73.7498 63.2487 73.2558 63.123 72.6578 63.123C72.1984 63.123 71.7738 63.2097 71.3838 63.383C71.0024 63.5563 70.6688 63.799 70.3828 64.111C70.1054 64.423 69.8888 64.7913 69.7328 65.216C69.5768 65.6407 69.4988 66.1087 69.4988 66.62C69.5161 67.1313 69.5898 67.6037 69.7198 68.037C69.8584 68.4703 70.0621 68.843 70.3308 69.155C70.5994 69.467 70.9288 69.7097 71.3188 69.883C71.7174 70.0563 72.1854 70.143 72.7228 70.143C73.4854 70.143 74.1181 69.9523 74.6208 69.571C75.1234 69.1897 75.4484 68.622 75.5958 67.868ZM80.6033 64.046H81.7083C81.6997 63.7687 81.7257 63.4957 81.7863 63.227C81.8557 62.9497 81.964 62.7027 82.1113 62.486C82.2587 62.2693 82.445 62.096 82.6703 61.966C82.9043 61.8273 83.1817 61.758 83.5023 61.758C83.745 61.758 83.9747 61.797 84.1913 61.875C84.408 61.953 84.5943 62.0657 84.7503 62.213C84.915 62.3603 85.045 62.538 85.1403 62.746C85.2357 62.9453 85.2833 63.1707 85.2833 63.422C85.2833 63.7427 85.2313 64.0243 85.1273 64.267C85.032 64.5097 84.8847 64.735 84.6853 64.943C84.4947 65.151 84.252 65.359 83.9573 65.567C83.6627 65.7663 83.3203 65.9873 82.9303 66.23C82.6097 66.4207 82.302 66.6243 82.0073 66.841C81.7127 67.0577 81.4483 67.309 81.2143 67.595C80.9803 67.881 80.7853 68.219 80.6293 68.609C80.482 68.9903 80.3867 69.454 80.3433 70H86.3623V69.025H81.6303C81.6823 68.739 81.7907 68.4877 81.9553 68.271C82.1287 68.0457 82.3323 67.8377 82.5663 67.647C82.809 67.4563 83.0733 67.2787 83.3593 67.114C83.6453 66.9407 83.9313 66.7673 84.2173 66.594C84.5033 66.412 84.7807 66.2213 85.0493 66.022C85.318 65.8227 85.5563 65.6017 85.7643 65.359C85.9723 65.1077 86.137 64.826 86.2583 64.514C86.3883 64.202 86.4533 63.8423 86.4533 63.435C86.4533 63.0017 86.3753 62.6203 86.2193 62.291C86.072 61.9617 85.8683 61.6887 85.6083 61.472C85.3483 61.2467 85.0407 61.0777 84.6853 60.965C84.3387 60.8437 83.966 60.783 83.5673 60.783C83.082 60.783 82.6487 60.8653 82.2673 61.03C81.886 61.1947 81.5653 61.4243 81.3053 61.719C81.054 62.005 80.8677 62.3473 80.7463 62.746C80.625 63.1447 80.5773 63.578 80.6033 64.046ZM89.171 65.463C89.171 65.2377 89.171 64.9907 89.171 64.722C89.1796 64.4447 89.2013 64.1717 89.236 63.903C89.2793 63.6257 89.3356 63.357 89.405 63.097C89.483 62.837 89.5913 62.6117 89.73 62.421C89.8773 62.2217 90.0593 62.0613 90.276 61.94C90.4926 61.8187 90.757 61.758 91.069 61.758C91.381 61.758 91.6453 61.8187 91.862 61.94C92.0786 62.0613 92.2563 62.2217 92.395 62.421C92.5423 62.6117 92.6506 62.837 92.72 63.097C92.798 63.357 92.8543 63.6257 92.889 63.903C92.9323 64.1717 92.954 64.4447 92.954 64.722C92.9626 64.9907 92.967 65.2377 92.967 65.463C92.967 65.8097 92.954 66.1997 92.928 66.633C92.9106 67.0577 92.8413 67.4607 92.72 67.842C92.6073 68.2147 92.421 68.531 92.161 68.791C91.901 69.051 91.537 69.181 91.069 69.181C90.601 69.181 90.237 69.051 89.977 68.791C89.717 68.531 89.5263 68.2147 89.405 67.842C89.2923 67.4607 89.223 67.0577 89.197 66.633C89.1796 66.1997 89.171 65.8097 89.171 65.463ZM88.001 65.476C88.001 65.814 88.0096 66.165 88.027 66.529C88.0443 66.893 88.0876 67.2483 88.157 67.595C88.2263 67.9417 88.326 68.271 88.456 68.583C88.586 68.8863 88.7636 69.155 88.989 69.389C89.2143 69.623 89.496 69.8093 89.834 69.948C90.1806 70.078 90.5923 70.143 91.069 70.143C91.5543 70.143 91.966 70.078 92.304 69.948C92.642 69.8093 92.9236 69.623 93.149 69.389C93.3743 69.155 93.552 68.8863 93.682 68.583C93.812 68.271 93.9116 67.9417 93.981 67.595C94.0503 67.2483 94.0936 66.893 94.111 66.529C94.1283 66.165 94.137 65.814 94.137 65.476C94.137 65.138 94.1283 64.787 94.111 64.423C94.0936 64.059 94.0503 63.7037 93.981 63.357C93.9116 63.0103 93.812 62.681 93.682 62.369C93.552 62.057 93.3743 61.784 93.149 61.55C92.9236 61.316 92.6376 61.1297 92.291 60.991C91.953 60.8523 91.5456 60.783 91.069 60.783C90.5923 60.783 90.1806 60.8523 89.834 60.991C89.496 61.1297 89.2143 61.316 88.989 61.55C88.7636 61.784 88.586 62.057 88.456 62.369C88.326 62.681 88.2263 63.0103 88.157 63.357C88.0876 63.7037 88.0443 64.059 88.027 64.423C88.0096 64.787 88.001 65.138 88.001 65.476ZM95.4506 64.046H96.5556C96.5469 63.7687 96.5729 63.4957 96.6336 63.227C96.7029 62.9497 96.8113 62.7027 96.9586 62.486C97.1059 62.2693 97.2923 62.096 97.5176 61.966C97.7516 61.8273 98.0289 61.758 98.3496 61.758C98.5923 61.758 98.8219 61.797 99.0386 61.875C99.2553 61.953 99.4416 62.0657 99.5976 62.213C99.7623 62.3603 99.8923 62.538 99.9876 62.746C100.083 62.9453 100.131 63.1707 100.131 63.422C100.131 63.7427 100.079 64.0243 99.9746 64.267C99.8793 64.5097 99.7319 64.735 99.5326 64.943C99.3419 65.151 99.0993 65.359 98.8046 65.567C98.5099 65.7663 98.1676 65.9873 97.7776 66.23C97.4569 66.4207 97.1493 66.6243 96.8546 66.841C96.5599 67.0577 96.2956 67.309 96.0616 67.595C95.8276 67.881 95.6326 68.219 95.4766 68.609C95.3293 68.9903 95.2339 69.454 95.1906 70H101.21V69.025H96.4776C96.5296 68.739 96.6379 68.4877 96.8026 68.271C96.9759 68.0457 97.1796 67.8377 97.4136 67.647C97.6563 67.4563 97.9206 67.2787 98.2066 67.114C98.4926 66.9407 98.7786 66.7673 99.0646 66.594C99.3506 66.412 99.6279 66.2213 99.8966 66.022C100.165 65.8227 100.404 65.6017 100.612 65.359C100.82 65.1077 100.984 64.826 101.106 64.514C101.236 64.202 101.301 63.8423 101.301 63.435C101.301 63.0017 101.223 62.6203 101.067 62.291C100.919 61.9617 100.716 61.6887 100.456 61.472C100.196 61.2467 99.8879 61.0777 99.5326 60.965C99.1859 60.8437 98.8133 60.783 98.4146 60.783C97.9293 60.783 97.4959 60.8653 97.1146 61.03C96.7333 61.1947 96.4126 61.4243 96.1526 61.719C95.9013 62.005 95.7149 62.3473 95.5936 62.746C95.4723 63.1447 95.4246 63.578 95.4506 64.046ZM106.93 70V60.783H106.085C106.025 61.1297 105.912 61.4157 105.747 61.641C105.583 61.8663 105.379 62.044 105.136 62.174C104.902 62.304 104.638 62.395 104.343 62.447C104.049 62.4903 103.745 62.512 103.433 62.512V63.396H105.825V70H106.93ZM118.172 70V60.783H117.327C117.266 61.1297 117.154 61.4157 116.989 61.641C116.824 61.8663 116.621 62.044 116.378 62.174C116.144 62.304 115.88 62.395 115.585 62.447C115.29 62.4903 114.987 62.512 114.675 62.512V63.396H117.067V70H118.172ZM125.375 66.867H122.281L125.349 62.356H125.375V66.867ZM126.415 66.867V60.783H125.531L121.332 66.776V67.842H125.375V70H126.415V67.842H127.663V66.867H126.415ZM130.913 64.722V63.279H129.47V64.722H130.913ZM129.47 68.557V70H130.913V68.557H129.47ZM136.837 70V60.783H135.992C135.932 61.1297 135.819 61.4157 135.654 61.641C135.49 61.8663 135.286 62.044 135.043 62.174C134.809 62.304 134.545 62.395 134.25 62.447C133.956 62.4903 133.652 62.512 133.34 62.512V63.396H135.732V70H136.837ZM141.375 67.777H140.27C140.339 68.5743 140.63 69.168 141.141 69.558C141.652 69.948 142.294 70.143 143.065 70.143C144.183 70.143 144.993 69.7183 145.496 68.869C146.007 68.011 146.263 66.7847 146.263 65.19C146.263 64.3147 146.176 63.5953 146.003 63.032C145.838 62.46 145.613 62.0093 145.327 61.68C145.041 61.3507 144.707 61.121 144.326 60.991C143.945 60.8523 143.537 60.783 143.104 60.783C142.662 60.783 142.255 60.8567 141.882 61.004C141.509 61.1513 141.189 61.3593 140.92 61.628C140.651 61.888 140.443 62.2043 140.296 62.577C140.149 62.941 140.075 63.344 140.075 63.786C140.075 64.2367 140.136 64.6527 140.257 65.034C140.387 65.4153 140.573 65.7403 140.816 66.009C141.067 66.2777 141.375 66.49 141.739 66.646C142.103 66.7933 142.519 66.867 142.987 66.867C143.438 66.867 143.854 66.7543 144.235 66.529C144.616 66.295 144.911 65.983 145.119 65.593L145.145 65.619C145.11 66.8237 144.924 67.7207 144.586 68.31C144.248 68.8907 143.741 69.181 143.065 69.181C142.623 69.181 142.242 69.0597 141.921 68.817C141.6 68.5743 141.418 68.2277 141.375 67.777ZM144.95 63.864C144.95 64.1327 144.907 64.3927 144.82 64.644C144.733 64.8867 144.608 65.1033 144.443 65.294C144.278 65.476 144.079 65.6233 143.845 65.736C143.611 65.84 143.351 65.892 143.065 65.892C142.796 65.892 142.549 65.84 142.324 65.736C142.107 65.6233 141.917 65.476 141.752 65.294C141.596 65.112 141.47 64.904 141.375 64.67C141.288 64.436 141.245 64.1933 141.245 63.942C141.245 63.656 141.275 63.383 141.336 63.123C141.405 62.863 141.509 62.6333 141.648 62.434C141.795 62.226 141.982 62.0613 142.207 61.94C142.441 61.8187 142.723 61.758 143.052 61.758C143.364 61.758 143.637 61.8143 143.871 61.927C144.105 62.0397 144.3 62.1957 144.456 62.395C144.621 62.5857 144.742 62.8067 144.82 63.058C144.907 63.3093 144.95 63.578 144.95 63.864Z",
    fill: "#909091"
  }), React.createElement("path", {
    d: "M38.6135 38.165L40.1865 33.836H40.2125L41.7595 38.165H38.6135ZM39.5365 32.718L35.9225 42H37.1835L38.2235 39.205H42.1495L43.1635 42H44.5285L40.9015 32.718H39.5365ZM45.4232 35.279V42H46.5282V39.01C46.5282 38.5767 46.5715 38.1953 46.6582 37.866C46.7448 37.528 46.8835 37.242 47.0742 37.008C47.2648 36.774 47.5162 36.5963 47.8282 36.475C48.1402 36.3537 48.5172 36.293 48.9592 36.293V35.123C48.3612 35.1057 47.8672 35.227 47.4772 35.487C47.0872 35.747 46.7578 36.15 46.4892 36.696H46.4632V35.279H45.4232ZM49.9913 35.279V42H51.0963V37.814C51.0963 37.684 51.1266 37.5237 51.1873 37.333C51.2566 37.1337 51.3606 36.943 51.4993 36.761C51.6466 36.579 51.8329 36.423 52.0583 36.293C52.2923 36.163 52.5696 36.098 52.8903 36.098C53.1416 36.098 53.3453 36.137 53.5013 36.215C53.6659 36.2843 53.7959 36.3883 53.8913 36.527C53.9866 36.657 54.0516 36.813 54.0863 36.995C54.1296 37.177 54.1513 37.3763 54.1513 37.593V42H55.2563V37.814C55.2563 37.294 55.4123 36.878 55.7243 36.566C56.0363 36.254 56.4653 36.098 57.0113 36.098C57.2799 36.098 57.4966 36.137 57.6613 36.215C57.8346 36.293 57.9689 36.4013 58.0643 36.54C58.1596 36.67 58.2246 36.826 58.2593 37.008C58.2939 37.19 58.3113 37.385 58.3113 37.593V42H59.4163V37.073C59.4163 36.7263 59.3599 36.4317 59.2473 36.189C59.1433 35.9377 58.9916 35.734 58.7923 35.578C58.6016 35.422 58.3676 35.3093 58.0903 35.24C57.8216 35.162 57.5183 35.123 57.1803 35.123C56.7383 35.123 56.3309 35.2227 55.9583 35.422C55.5943 35.6213 55.2996 35.903 55.0743 36.267C54.9356 35.851 54.6973 35.5563 54.3593 35.383C54.0213 35.2097 53.6443 35.123 53.2283 35.123C52.2836 35.123 51.5599 35.5043 51.0573 36.267H51.0313V35.279H49.9913ZM65.9413 37.996H62.0803C62.0976 37.736 62.154 37.4933 62.2493 37.268C62.3446 37.034 62.4746 36.8303 62.6393 36.657C62.804 36.4837 62.999 36.3493 63.2243 36.254C63.4583 36.15 63.7183 36.098 64.0043 36.098C64.2816 36.098 64.533 36.15 64.7583 36.254C64.9923 36.3493 65.1916 36.4837 65.3563 36.657C65.5296 36.8217 65.664 37.021 65.7593 37.255C65.8633 37.489 65.924 37.736 65.9413 37.996ZM67.0073 39.868H65.9153C65.82 40.31 65.6206 40.6393 65.3173 40.856C65.0226 41.0727 64.6413 41.181 64.1733 41.181C63.8093 41.181 63.493 41.1203 63.2243 40.999C62.9556 40.8777 62.7346 40.7173 62.5613 40.518C62.388 40.31 62.2623 40.076 62.1843 39.816C62.1063 39.5473 62.0716 39.2657 62.0803 38.971H67.1113C67.1286 38.5637 67.0896 38.1347 66.9943 37.684C66.9076 37.2333 66.743 36.8173 66.5003 36.436C66.2663 36.0547 65.95 35.7427 65.5513 35.5C65.1613 35.2487 64.6673 35.123 64.0693 35.123C63.61 35.123 63.1853 35.2097 62.7953 35.383C62.414 35.5563 62.0803 35.799 61.7943 36.111C61.517 36.423 61.3003 36.7913 61.1443 37.216C60.9883 37.6407 60.9103 38.1087 60.9103 38.62C60.9276 39.1313 61.0013 39.6037 61.1313 40.037C61.27 40.4703 61.4736 40.843 61.7423 41.155C62.011 41.467 62.3403 41.7097 62.7303 41.883C63.129 42.0563 63.597 42.143 64.1343 42.143C64.897 42.143 65.5296 41.9523 66.0323 41.571C66.535 41.1897 66.86 40.622 67.0073 39.868ZM68.4567 35.279V42H69.5617V38.204C69.5617 37.9007 69.6007 37.6233 69.6787 37.372C69.7654 37.112 69.891 36.8867 70.0557 36.696C70.2204 36.5053 70.424 36.358 70.6667 36.254C70.918 36.15 71.2127 36.098 71.5507 36.098C71.9754 36.098 72.309 36.2193 72.5517 36.462C72.7944 36.7047 72.9157 37.034 72.9157 37.45V42H74.0207V37.58C74.0207 37.216 73.9817 36.8867 73.9037 36.592C73.8344 36.2887 73.7087 36.0287 73.5267 35.812C73.3447 35.5953 73.1064 35.4263 72.8117 35.305C72.517 35.1837 72.1487 35.123 71.7067 35.123C70.71 35.123 69.982 35.5303 69.5227 36.345H69.4967V35.279H68.4567ZM79.9065 32.718V42H81.0765V34.278H81.1025L84.0015 42H85.0545L87.9535 34.278H87.9795V42H89.1495V32.718H87.4595L84.5215 40.518L81.5965 32.718H79.9065ZM95.8897 37.996H92.0287C92.0461 37.736 92.1024 37.4933 92.1977 37.268C92.2931 37.034 92.4231 36.8303 92.5877 36.657C92.7524 36.4837 92.9474 36.3493 93.1727 36.254C93.4067 36.15 93.6667 36.098 93.9527 36.098C94.2301 36.098 94.4814 36.15 94.7067 36.254C94.9407 36.3493 95.1401 36.4837 95.3047 36.657C95.4781 36.8217 95.6124 37.021 95.7077 37.255C95.8117 37.489 95.8724 37.736 95.8897 37.996ZM96.9557 39.868H95.8637C95.7684 40.31 95.5691 40.6393 95.2657 40.856C94.9711 41.0727 94.5897 41.181 94.1217 41.181C93.7577 41.181 93.4414 41.1203 93.1727 40.999C92.9041 40.8777 92.6831 40.7173 92.5097 40.518C92.3364 40.31 92.2107 40.076 92.1327 39.816C92.0547 39.5473 92.0201 39.2657 92.0287 38.971H97.0597C97.0771 38.5637 97.0381 38.1347 96.9427 37.684C96.8561 37.2333 96.6914 36.8173 96.4487 36.436C96.2147 36.0547 95.8984 35.7427 95.4997 35.5C95.1097 35.2487 94.6157 35.123 94.0177 35.123C93.5584 35.123 93.1337 35.2097 92.7437 35.383C92.3624 35.5563 92.0287 35.799 91.7427 36.111C91.4654 36.423 91.2487 36.7913 91.0927 37.216C90.9367 37.6407 90.8587 38.1087 90.8587 38.62C90.8761 39.1313 90.9497 39.6037 91.0797 40.037C91.2184 40.4703 91.4221 40.843 91.6907 41.155C91.9594 41.467 92.2887 41.7097 92.6787 41.883C93.0774 42.0563 93.5454 42.143 94.0827 42.143C94.8454 42.143 95.4781 41.9523 95.9807 41.571C96.4834 41.1897 96.8084 40.622 96.9557 39.868ZM98.4701 32.718V42H99.5751V32.718H98.4701ZM102.293 38.646C102.293 38.2387 102.345 37.879 102.449 37.567C102.562 37.2463 102.713 36.9777 102.904 36.761C103.095 36.5443 103.316 36.3797 103.567 36.267C103.827 36.1543 104.1 36.098 104.386 36.098C104.672 36.098 104.941 36.1543 105.192 36.267C105.452 36.3797 105.677 36.5443 105.868 36.761C106.059 36.9777 106.206 37.2463 106.31 37.567C106.423 37.879 106.479 38.2387 106.479 38.646C106.479 39.0533 106.423 39.4173 106.31 39.738C106.206 40.05 106.059 40.3143 105.868 40.531C105.677 40.739 105.452 40.8993 105.192 41.012C104.941 41.1247 104.672 41.181 104.386 41.181C104.1 41.181 103.827 41.1247 103.567 41.012C103.316 40.8993 103.095 40.739 102.904 40.531C102.713 40.3143 102.562 40.05 102.449 39.738C102.345 39.4173 102.293 39.0533 102.293 38.646ZM101.123 38.646C101.123 39.14 101.192 39.5993 101.331 40.024C101.47 40.4487 101.678 40.8213 101.955 41.142C102.232 41.454 102.575 41.701 102.982 41.883C103.389 42.0563 103.857 42.143 104.386 42.143C104.923 42.143 105.391 42.0563 105.79 41.883C106.197 41.701 106.54 41.454 106.817 41.142C107.094 40.8213 107.302 40.4487 107.441 40.024C107.58 39.5993 107.649 39.14 107.649 38.646C107.649 38.152 107.58 37.6927 107.441 37.268C107.302 36.8347 107.094 36.462 106.817 36.15C106.54 35.8293 106.197 35.578 105.79 35.396C105.391 35.214 104.923 35.123 104.386 35.123C103.857 35.123 103.389 35.214 102.982 35.396C102.575 35.578 102.232 35.8293 101.955 36.15C101.678 36.462 101.47 36.8347 101.331 37.268C101.192 37.6927 101.123 38.152 101.123 38.646ZM111.791 42.897C111.661 43.2263 111.531 43.5037 111.401 43.729C111.279 43.9543 111.141 44.1363 110.985 44.275C110.837 44.4223 110.668 44.5263 110.478 44.587C110.296 44.6563 110.083 44.691 109.841 44.691C109.711 44.691 109.581 44.6823 109.451 44.665C109.321 44.6477 109.195 44.6173 109.074 44.574V43.56C109.169 43.6033 109.277 43.638 109.399 43.664C109.529 43.6987 109.637 43.716 109.724 43.716C109.949 43.716 110.135 43.6597 110.283 43.547C110.439 43.443 110.556 43.2913 110.634 43.092L111.089 41.961L108.424 35.279H109.672L111.635 40.778H111.661L113.546 35.279H114.716L111.791 42.897ZM121.806 41.974C121.615 42.0867 121.351 42.143 121.013 42.143C120.727 42.143 120.497 42.065 120.324 41.909C120.159 41.7443 120.077 41.48 120.077 41.116C119.773 41.48 119.418 41.7443 119.011 41.909C118.612 42.065 118.179 42.143 117.711 42.143C117.407 42.143 117.117 42.1083 116.84 42.039C116.571 41.9697 116.337 41.8613 116.138 41.714C115.938 41.5667 115.778 41.376 115.657 41.142C115.544 40.8993 115.488 40.609 115.488 40.271C115.488 39.8897 115.553 39.5777 115.683 39.335C115.813 39.0923 115.982 38.8973 116.19 38.75C116.406 38.594 116.649 38.477 116.918 38.399C117.195 38.321 117.477 38.256 117.763 38.204C118.066 38.1433 118.352 38.1 118.621 38.074C118.898 38.0393 119.141 37.996 119.349 37.944C119.557 37.8833 119.721 37.801 119.843 37.697C119.964 37.5843 120.025 37.424 120.025 37.216C120.025 36.9733 119.977 36.7783 119.882 36.631C119.795 36.4837 119.678 36.371 119.531 36.293C119.392 36.215 119.232 36.163 119.05 36.137C118.876 36.111 118.703 36.098 118.53 36.098C118.062 36.098 117.672 36.189 117.36 36.371C117.048 36.5443 116.879 36.878 116.853 37.372H115.748C115.765 36.956 115.852 36.605 116.008 36.319C116.164 36.033 116.372 35.8033 116.632 35.63C116.892 35.448 117.186 35.318 117.516 35.24C117.854 35.162 118.213 35.123 118.595 35.123C118.898 35.123 119.197 35.1447 119.492 35.188C119.795 35.2313 120.068 35.3223 120.311 35.461C120.553 35.591 120.748 35.7773 120.896 36.02C121.043 36.2627 121.117 36.579 121.117 36.969V40.427C121.117 40.687 121.13 40.8777 121.156 40.999C121.19 41.1203 121.294 41.181 121.468 41.181C121.563 41.181 121.676 41.1593 121.806 41.116V41.974ZM120.012 38.529C119.873 38.633 119.691 38.711 119.466 38.763C119.24 38.8063 119.002 38.8453 118.751 38.88C118.508 38.906 118.261 38.9407 118.01 38.984C117.758 39.0187 117.533 39.0793 117.334 39.166C117.134 39.2527 116.97 39.3783 116.84 39.543C116.718 39.699 116.658 39.9157 116.658 40.193C116.658 40.375 116.692 40.531 116.762 40.661C116.84 40.7823 116.935 40.882 117.048 40.96C117.169 41.038 117.308 41.0943 117.464 41.129C117.62 41.1637 117.784 41.181 117.958 41.181C118.322 41.181 118.634 41.1333 118.894 41.038C119.154 40.934 119.366 40.8083 119.531 40.661C119.695 40.505 119.817 40.3403 119.895 40.167C119.973 39.985 120.012 39.816 120.012 39.66V38.529ZM123.034 35.279V42H124.139V38.204C124.139 37.9007 124.178 37.6233 124.256 37.372C124.343 37.112 124.469 36.8867 124.633 36.696C124.798 36.5053 125.002 36.358 125.244 36.254C125.496 36.15 125.79 36.098 126.128 36.098C126.553 36.098 126.887 36.2193 127.129 36.462C127.372 36.7047 127.493 37.034 127.493 37.45V42H128.598V37.58C128.598 37.216 128.559 36.8867 128.481 36.592C128.412 36.2887 128.286 36.0287 128.104 35.812C127.922 35.5953 127.684 35.4263 127.389 35.305C127.095 35.1837 126.726 35.123 126.284 35.123C125.288 35.123 124.56 35.5303 124.1 36.345H124.074V35.279H123.034Z",
    fill: "#909091"
  }));
};

const IconMiusOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C6.61406 2.25 2.25 6.61406 2.25 12C2.25 17.3859 6.61406 21.75 12 21.75C17.3859 21.75 21.75 17.3859 21.75 12C21.75 6.61406 17.3859 2.25 12 2.25ZM12 3.5625C14.2547 3.5625 16.3734 4.43906 17.9672 6.03281C19.5609 7.62656 20.4375 9.74531 20.4375 12C20.4375 14.2547 19.5609 16.3734 17.9672 17.9672C16.3734 19.5609 14.2547 20.4375 12 20.4375C9.74531 20.4375 7.62656 19.5609 6.03281 17.9672C4.43906 16.3734 3.5625 14.2547 3.5625 12C3.5625 9.74531 4.43906 7.62656 6.03281 6.03281C7.62656 4.43906 9.74531 3.5625 12 3.5625ZM7.00781 12C7.00781 11.5312 7.34531 11.25 7.75781 11.25H16.2422C16.6547 11.25 16.9922 11.5875 16.9922 12C16.9922 12.4125 16.6547 12.75 16.2422 12.75H7.75781C7.35938 12.75 7.00781 12.4688 7.00781 12Z",
    fill: fill
  }));
};

const IconKey = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M11.75 2C6.39474 2 2 6.39474 2 11.75C2 17.1053 6.39474 21.5 11.75 21.5C17.1053 21.5 21.5 17.1053 21.5 11.75C21.5 6.39474 17.1053 2 11.75 2Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.6313 14.4451V12.2227",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.4453 12.2227H18.0269V14.4451",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4436 12.2224C10.4436 13.4488 9.4488 14.4448 8.2212 14.4448C6.9948 14.4448 6 13.4488 6 12.2224C6 10.996 6.9948 10 8.2212 10C9.4488 10 10.4436 10.996 10.4436 12.2224Z",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconKeyOutlined = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12C2.25 6.61406 6.61406 2.25 12 2.25C17.3859 2.25 21.75 6.61406 21.75 12C21.75 17.3859 17.3859 21.75 12 21.75C6.61406 21.75 2.25 17.3859 2.25 12ZM17.9672 6.03281C16.3734 4.43906 14.2547 3.5625 12 3.5625C9.74531 3.5625 7.62656 4.43906 6.03281 6.03281C4.43906 7.62656 3.5625 9.74531 3.5625 12C3.5625 14.2547 4.43906 16.3734 6.03281 17.9672C7.62656 19.5609 9.74531 20.4375 12 20.4375C14.2547 20.4375 16.3734 19.5609 17.9672 17.9672C19.5609 16.3734 20.4375 14.2547 20.4375 12C20.4375 9.74531 19.5609 7.62656 17.9672 6.03281Z",
    fill: "#200E32"
  }), React.createElement("path", {
    d: "M14.6313 14.0447V11.8223",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.4453 11.8223H18.0269V14.0447",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4436 11.822C10.4436 13.0484 9.4488 14.0444 8.2212 14.0444C6.9948 14.0444 6 13.0484 6 11.822C6 10.5956 6.9948 9.59961 8.2212 9.59961C9.4488 9.59961 10.4436 10.5956 10.4436 11.822Z",
    stroke: "#200E32",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const IconArrowDownBold = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9L12 15L18 9H6Z",
    fill: fill
  }));
};

const IconColoredFile = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: "#F7F7F8"
  }), React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    d: "M13.6325 18.5615C13.6325 19.465 12.9001 20.1974 11.9967 20.1974C11.0932 20.1974 10.3608 19.465 10.3608 18.5615C10.3608 17.6581 11.0932 16.9258 11.9967 16.9258C12.9001 16.9258 13.6325 17.6581 13.6325 18.5615Z",
    fill: "#0784FF"
  }), React.createElement("path", {
    d: "M18.5402 20.197L11.9969 19.3791L5.45362 20.197C4.55023 20.197 3.81787 19.4646 3.81787 18.5611V7.92839C3.81787 7.0249 4.55023 6.29254 5.45362 6.29254L10.3611 5.47461C11.2646 5.47461 11.9969 6.20697 11.9969 7.11047C11.9969 6.20697 12.7293 5.47461 13.6328 5.47461L18.5402 6.29254C19.4436 6.29254 20.176 7.0249 20.176 7.92839V18.5611C20.176 19.4646 19.4436 20.197 18.5402 20.197Z",
    fill: "#0784FF"
  }), React.createElement("path", {
    d: "M4.22684 17.7363C4.00091 17.7363 3.81787 17.9194 3.81787 18.1453V18.5612C3.81787 19.4647 4.55023 20.1971 5.45373 20.1971L10.695 19.5419C11.0015 19.9532 11.484 20.196 11.9969 20.1971H12.0149L12.0169 20.197H12.0216L12.0239 20.1968H12.0249L12.0282 20.1967H12.0327L12.0348 20.1966H12.0361L12.0381 20.1965H12.0415L12.0429 20.1964H12.0447L12.0462 20.1963H12.0481L12.0494 20.1962H12.0514L12.0527 20.1961H12.0551L12.056 20.196L12.0593 20.1959H12.0602L12.0625 20.1958H12.0638L12.0658 20.1956L12.0673 20.1955H12.0691L12.0705 20.1954L12.0725 20.1953H12.0739L12.0757 20.1952L12.0772 20.1951H12.079L12.0804 20.195L12.0825 20.1949L12.0837 20.1948L12.0864 20.1947H12.0872L12.0903 20.1944H12.0913L12.0934 20.1943L12.0947 20.1942L12.0968 20.1941L12.0981 20.194L12.1001 20.1939L12.1015 20.1938L12.1034 20.1937H12.1048L12.1066 20.1936L12.108 20.1935L12.1099 20.1932L12.1113 20.1931L12.1134 20.193L12.1146 20.1929L12.1178 20.1927H12.1184L12.121 20.1925L12.1222 20.1924L12.1243 20.1923L12.1256 20.1922L12.1276 20.1919L12.129 20.1918L12.1309 20.1917L12.1323 20.1916L12.134 20.1915L12.1356 20.1914L12.1373 20.1912L12.1387 20.1911L12.1408 20.191L12.1444 20.1906L12.1452 20.1905L12.1484 20.1902H12.1493L12.1529 20.1899L12.1549 20.1896L12.1563 20.1894L12.1581 20.1893L12.1596 20.1891L12.1613 20.189L12.1628 20.1889L12.1646 20.1887L12.166 20.1884L12.1679 20.1883L12.1693 20.1881L12.1712 20.1879L12.1726 20.1878L12.1748 20.1876L12.1759 20.1875L12.1789 20.1871L12.18 20.1869L12.182 20.1867L12.1835 20.1866L12.1853 20.1864L12.1866 20.1862L12.1885 20.1859L12.1899 20.1858L12.1918 20.1856L12.1931 20.1854L12.195 20.1852L12.1963 20.185L12.1983 20.1847L12.1996 20.1845L12.2016 20.1843L12.2028 20.1842L12.206 20.1837L12.2067 20.1836L12.2091 20.1833L12.2105 20.1832L12.2123 20.183L12.2138 20.1828L12.2156 20.1825L12.217 20.1823L12.2188 20.1821L12.2203 20.1819L12.222 20.1817L12.2234 20.1815L12.2252 20.1811L12.2267 20.181L12.2284 20.1807L12.2297 20.1806L12.2319 20.1803L12.233 20.18L12.2362 20.1796L12.2371 20.1795L12.2392 20.1792L12.2438 20.1784L12.2457 20.1782L12.2471 20.1779L12.2488 20.1776L12.2503 20.1774L12.252 20.1771L12.2534 20.1769L12.2553 20.1767L12.2567 20.1764L12.2586 20.1761L12.2599 20.1759L12.2623 20.1755L12.263 20.1753L12.2661 20.1748L12.2672 20.1747L12.2693 20.1743L12.2707 20.174L12.2724 20.1737L12.2738 20.1735L12.2756 20.1732L12.277 20.1729L12.2788 20.1726L12.2802 20.1724L12.2819 20.1721L12.2833 20.1719L12.2851 20.1715L12.2864 20.1713L12.2886 20.1709L12.2896 20.1707L12.2927 20.1701L12.2932 20.17L12.2971 20.1693L12.2989 20.169L12.3003 20.1687L12.3021 20.1684L12.3035 20.1681L12.3053 20.1678L12.3067 20.1675L12.3084 20.1672L12.3099 20.1668L12.3116 20.1665L12.3129 20.1663L12.3148 20.1659L12.3161 20.1656L12.3179 20.1653L12.3192 20.165L12.3222 20.1644L12.3236 20.1641L12.3254 20.1638L12.3268 20.1634L12.3285 20.1631L12.3299 20.1628L12.3316 20.1625L12.333 20.1621L12.3347 20.1618L12.3362 20.1615L12.3379 20.161L12.3392 20.1608L12.3411 20.1604L12.3424 20.1601L12.3442 20.1597L12.3455 20.1594L12.3476 20.159L12.3486 20.1588L12.3517 20.1581L12.3526 20.1579L12.3548 20.1573L12.356 20.1571L12.3579 20.1567L12.3609 20.1559L12.3625 20.1556L12.3641 20.1553L12.3655 20.1549L12.3672 20.1545L12.3687 20.1542L12.3702 20.1537L12.3716 20.1534L12.3734 20.153L12.3776 20.152L12.3782 20.1519L12.3808 20.1512L12.382 20.1509L12.384 20.1505L12.3853 20.1501L12.3869 20.1497L12.3884 20.1494L12.3901 20.1489L12.3915 20.1486L12.3931 20.1482L12.3946 20.1478L12.3962 20.1474L12.3977 20.147L12.3991 20.1466L12.4024 20.1458L12.4038 20.1454L12.4068 20.1447L12.4079 20.1443L12.4098 20.1439L12.4113 20.1435L12.4129 20.143L12.4144 20.1426L12.4158 20.1423L12.4175 20.1418L12.4189 20.1414L12.4205 20.141L12.4219 20.1406L12.4235 20.1401L12.425 20.1398L12.4296 20.1385L12.4313 20.138L12.4328 20.1376L12.4355 20.1368L12.4431 20.1346L12.4445 20.1342L12.4462 20.1338L12.4476 20.1334L12.4492 20.1329L12.4507 20.1326L12.4523 20.132L12.4537 20.1316L12.4552 20.1311L12.4567 20.1307L12.4583 20.1303L12.4597 20.1298L12.4623 20.1291L12.4642 20.1285L12.4656 20.1281L12.4671 20.1277L12.4687 20.1271L12.4701 20.1267L12.4717 20.1262L12.4731 20.1258L12.4747 20.1254L12.4761 20.1249L12.4836 20.1224L12.4849 20.1221L12.4867 20.1215L12.4873 20.1213L12.4914 20.12L12.4925 20.1197L12.4954 20.1187L12.4969 20.1182L12.4984 20.1177L12.5 20.1172L12.5012 20.1167L12.5029 20.1162L12.5128 20.1129C12.5149 20.1122 12.5171 20.1114 12.5192 20.1106L12.5205 20.1103L12.5221 20.1096L12.5233 20.1092L12.5251 20.1087L12.5263 20.1082L12.528 20.1076L12.5292 20.1072L12.5309 20.1066L12.5351 20.1052L12.5368 20.1045L12.538 20.1041L12.5397 20.1034L12.5404 20.1032L12.545 20.1016L12.5454 20.1015L12.5472 20.1008L12.5483 20.1004L12.5501 20.0997L12.5512 20.0994L12.5529 20.0987L12.5541 20.0983L12.5559 20.0976L12.5571 20.0972L12.5588 20.0965L12.56 20.0961L12.5617 20.0955L12.5629 20.095L12.5646 20.0944L12.5657 20.0939C12.5681 20.0931 12.5704 20.0922 12.5727 20.0913L12.573 20.0912L12.5751 20.0904L12.576 20.09L12.5778 20.0893L12.5788 20.0889L12.5806 20.0882L12.5816 20.0878L12.5835 20.087L12.5846 20.0867L12.5863 20.086L12.5874 20.0855L12.5893 20.0849L12.59 20.0845L12.5921 20.0838L12.5927 20.0836C12.5953 20.0825 12.5978 20.0815 12.6004 20.0804L12.6026 20.0795L12.6033 20.0793L12.6053 20.0784L12.6062 20.0781L12.608 20.0773L12.609 20.0769L12.6109 20.0761L12.6119 20.0757L12.6138 20.0749L12.6146 20.0746L12.6167 20.0737L12.6172 20.0735C12.6206 20.0721 12.624 20.0707 12.6274 20.0691L12.6276 20.069L12.6298 20.0682L12.6305 20.0678L12.6325 20.067L12.6333 20.0666L12.6352 20.0658L12.6361 20.0654L12.6381 20.0646L12.6388 20.0642L12.6408 20.0634L12.6417 20.063L12.6436 20.0622L12.6441 20.0619C12.6474 20.0605 12.6507 20.059 12.654 20.0576L12.6545 20.0574L12.6566 20.0564L12.6574 20.0561L12.6593 20.0552L12.6601 20.0549L12.6621 20.0539L12.6628 20.0535L12.6649 20.0526L12.6655 20.0523L12.6676 20.0514L12.6681 20.0511C12.6723 20.0492 12.6767 20.0472 12.6808 20.0452L12.6811 20.0451L12.6833 20.044L12.6839 20.0438L12.6861 20.0427L12.6866 20.0425L12.6887 20.0415L12.6894 20.0412L12.6914 20.0402L12.692 20.04L12.6942 20.0389L12.6945 20.0387C12.6987 20.0367 12.703 20.0346 12.7073 20.0325L12.7075 20.0324L12.7098 20.0313L12.7124 20.03L12.7129 20.0297L12.715 20.0287L12.7181 20.0271C12.7232 20.0246 12.7282 20.022 12.7332 20.0195L12.7337 20.0193L12.7357 20.0182L12.7364 20.0179L12.7385 20.0168L12.7389 20.0165L12.7412 20.0153L12.7415 20.0152L12.7439 20.0139C12.7482 20.0116 12.7524 20.0094 12.7568 20.0072L12.7592 20.0058L12.7594 20.0057L12.7617 20.0044L12.762 20.0043L12.7644 20.003L12.7646 20.0029L12.7671 20.0016C12.7739 19.9979 12.7807 19.9942 12.7875 19.9903C12.7958 19.9857 12.8041 19.9809 12.8122 19.9761C13.0067 19.8613 13.0715 19.6106 12.9568 19.416C12.8424 19.2222 12.5928 19.1572 12.3983 19.2707C12.2767 19.3424 12.1381 19.3798 11.9969 19.3794C11.7406 19.3783 11.4998 19.2558 11.3479 19.0493C11.1716 18.8158 10.8839 18.6942 10.5936 18.7305L5.41138 19.3783C4.97688 19.3552 4.63624 18.9965 4.6358 18.5614V18.1454C4.6358 17.9194 4.45266 17.7363 4.22684 17.7363ZM14.3201 18.8485C14.0942 18.8488 13.9113 19.0321 13.9117 19.258C13.9119 19.464 14.0653 19.6376 14.2697 19.6632L16.7193 19.9694L16.7204 19.9695L16.7358 19.9715L16.7394 19.9719L16.867 19.9878L16.8694 19.9882L16.873 19.9886L16.8742 19.9887L16.8818 19.9897L16.8875 19.9905L16.9075 19.9929L16.9132 19.9936L17.0253 20.0076L17.0301 20.0082L17.036 20.009L17.0395 20.0094L17.0429 20.0099L17.0438 20.01L17.1321 20.021L17.134 20.0212L17.2269 20.0329H17.2271L17.2494 20.0356L17.2512 20.0359L17.2664 20.0378L17.2687 20.038L17.2965 20.0415L17.3001 20.042L17.303 20.0424L17.3363 20.0466H17.3367L17.3474 20.0479L17.3481 20.048L17.3532 20.0486L17.3539 20.0487L17.3643 20.05L17.3664 20.0503L17.3697 20.0507L17.3706 20.0508L17.3859 20.0527L17.3927 20.0535L17.4023 20.0547L17.4045 20.0551L17.409 20.0556L17.4116 20.0559L17.4254 20.0577L17.4275 20.0579L17.4304 20.0582L17.4395 20.0594L17.4425 20.0598L17.449 20.0605L17.4697 20.0631L17.473 20.0636L17.4745 20.0637L17.4822 20.0647L17.4867 20.0652L17.4947 20.0663L17.4978 20.0666L17.4985 20.0667L17.5136 20.0686L17.5167 20.069L17.5178 20.0691L17.5217 20.0697L17.5303 20.0708L17.5382 20.0717L17.5548 20.0737L17.5593 20.0744L17.5635 20.0748L17.5702 20.0757L17.5727 20.076L17.5795 20.0768L17.5824 20.0772L17.5914 20.0783L17.5939 20.0786L17.6135 20.081L17.6238 20.0824L17.6243 20.0825L17.6332 20.0836L17.6359 20.0839L17.6439 20.0849L17.6454 20.0851L17.6546 20.0863L17.6561 20.0864L17.7012 20.0921L17.7019 20.0922L17.7055 20.0926L17.7079 20.0929L17.714 20.0937L17.7187 20.0943L17.7241 20.0949L17.7264 20.0952L17.7356 20.0963L17.7388 20.0968L17.7566 20.0989L17.7573 20.0991L17.8 20.1044L17.815 20.1063L17.817 20.1066L17.8243 20.1075L17.8263 20.1077L17.8295 20.1081L17.8413 20.1096L17.8436 20.1099L17.845 20.1101L17.8501 20.1106L17.8679 20.1129L17.8715 20.1134L17.8774 20.1141L17.8817 20.1147L17.884 20.1149L17.8907 20.1158L17.9019 20.1172L17.9081 20.1179L17.9118 20.1184L17.9462 20.1227H17.9467L17.9818 20.1271H17.9821L17.9986 20.1292L18.0002 20.1294L18.0032 20.1298L18.0136 20.1311L18.0147 20.1313L18.0173 20.1316L18.0332 20.1335L18.0338 20.1337L18.0825 20.1397L18.084 20.1399L18.1151 20.1438L18.1449 20.1475L18.1472 20.1478L18.1497 20.1481L18.15 20.1482C18.2194 20.1568 18.281 20.1645 18.3339 20.1711L18.3346 20.1712L18.3562 20.1739L18.357 20.174L18.3594 20.1744H18.3595C18.3876 20.1779 18.4126 20.181 18.4346 20.1837H18.4347L18.4921 20.1908L18.4925 20.191L18.5402 20.197H18.5554L18.5571 20.1968H18.5638L18.5663 20.1967H18.5722L18.5732 20.1966H18.5778L18.5789 20.1965H18.5817L18.5834 20.1964H18.5861L18.5874 20.1963H18.5901L18.5923 20.1962H18.5929L18.5957 20.1961H18.5964L18.5984 20.196H18.5994L18.6013 20.1959H18.6023L18.604 20.1958H18.6051L18.6067 20.1956H18.6079L18.6095 20.1955H18.6108L18.6123 20.1954H18.6135L18.6152 20.1953L18.6163 20.1952H18.6184L18.6191 20.1951L18.6218 20.195H18.6226L18.6246 20.1949L18.6255 20.1948H18.6272L18.6284 20.1947L18.6301 20.1946H18.6313L18.6328 20.1944L18.6341 20.1943L18.6357 20.1942H18.6369L18.6384 20.1941L18.6396 20.194L18.6413 20.1939H18.6423L18.6445 20.1937H18.645L18.6479 20.1936L18.6483 20.1935L18.6506 20.1934L18.6515 20.1932L18.6533 20.1931L18.6544 20.193L18.6562 20.1929L18.6573 20.1928L18.6589 20.1927H18.66L18.6617 20.1926L18.6628 20.1925L18.6646 20.1924L18.6654 20.1923L18.6674 20.192H18.6683L18.6706 20.1918H18.671L18.6766 20.1914H18.6773L18.6792 20.1912L18.6804 20.1911L18.682 20.191L18.6831 20.1908L18.6849 20.1907L18.6859 20.1906L18.6876 20.1905L18.6886 20.1904L18.6903 20.1902H18.6914L18.6932 20.19L18.6961 20.1896H18.6969L18.7023 20.1891H18.703L18.7052 20.1889L18.7058 20.1888L18.7079 20.1886L18.7088 20.1884L18.7107 20.1882L18.7115 20.1881L18.7134 20.188L18.7143 20.1879L18.7162 20.1877L18.7171 20.1876L18.719 20.1874L18.7198 20.1872L18.722 20.187H18.7225L18.725 20.1867H18.7254L18.7281 20.1864H18.7284L18.7308 20.186L18.7316 20.1859L18.7336 20.1857L18.7344 20.1856L18.7363 20.1854L18.7373 20.1853L18.739 20.1851L18.74 20.185L18.7417 20.1847L18.7427 20.1846L18.7446 20.1844L18.7455 20.1843L18.7475 20.1841L18.7482 20.184L18.7537 20.1832L18.7564 20.1829H18.757L18.7592 20.1825L18.76 20.1824L18.7618 20.1822L18.7627 20.1821L18.7646 20.1818L18.7655 20.1817L18.7674 20.1815L18.7682 20.1813L18.7701 20.181L18.771 20.1809L18.7731 20.1807L18.7736 20.1806C18.7764 20.1801 18.7792 20.1798 18.7819 20.1794L18.7823 20.1793L18.7846 20.1789L18.7853 20.1788L18.7874 20.1785L18.788 20.1784L18.7901 20.1782L18.7909 20.1781L18.7927 20.1777L18.7936 20.1776L18.7955 20.1773L18.7963 20.1772L18.7985 20.1769L18.7989 20.1768C18.8017 20.1763 18.8045 20.1759 18.8072 20.1753H18.8076L18.8098 20.1749L18.8125 20.1745L18.8133 20.1744L18.8152 20.174L18.8162 20.1739L18.8179 20.1736L18.8188 20.1735L18.8207 20.1732L18.8216 20.1729L18.8235 20.1726L18.8243 20.1725L18.8264 20.1722L18.827 20.1721L18.8324 20.1711L18.8327 20.171L18.8351 20.1705L18.8358 20.1704L18.8377 20.1701L18.8386 20.1699L18.8404 20.1696L18.8413 20.1695L18.8431 20.1691L18.844 20.1689L18.846 20.1686L18.8467 20.1685L18.8488 20.168L18.8494 20.1679L18.8518 20.1675L18.8521 20.1674L18.8575 20.1664L18.8577 20.1663L18.8602 20.1659L18.8608 20.1657L18.8629 20.1653L18.8635 20.1652L18.8656 20.1648L18.8663 20.1646L18.8683 20.1642L18.8689 20.1641L18.871 20.1637L18.8716 20.1636L18.8739 20.1631L18.8742 20.163L18.8768 20.1625H18.877L18.8824 20.1613H18.8825L18.8852 20.1607L18.8855 20.1606L18.8878 20.1602L18.8884 20.16L18.8905 20.1595L18.8911 20.1594L18.893 20.159L18.8939 20.1589L18.8957 20.1584L18.8965 20.1583L18.8986 20.1578L18.8991 20.1577L18.9014 20.1572L18.9017 20.1571L18.9044 20.1565H18.9045L18.9099 20.1553L18.9103 20.1552L18.9126 20.1546L18.9131 20.1545L18.9152 20.1541L18.9159 20.1538L18.9178 20.1534L18.9186 20.1532L18.9204 20.1528L18.9213 20.1525L18.9231 20.1521L18.9239 20.1519L18.9259 20.1514L18.9265 20.1513C18.9291 20.1507 18.9319 20.15 18.9345 20.1494L18.9348 20.1493L18.9371 20.1487L18.9378 20.1485L18.9397 20.1481L18.9405 20.1478L18.9423 20.1474L18.9432 20.1472L18.9451 20.1466L18.9458 20.1465L18.9477 20.146L18.9485 20.1458L18.9505 20.1453L18.951 20.1451L18.9535 20.1445H18.9536L18.959 20.143H18.9592L18.9617 20.1424L18.9621 20.1423L18.9642 20.1417L18.9649 20.1415L18.9668 20.141L18.9676 20.1407L18.9694 20.1403L18.9702 20.1401L18.9721 20.1395L18.9729 20.1393L18.9748 20.1388L18.9754 20.1387L18.9778 20.138L18.978 20.1379L18.9834 20.1364H18.9836L18.986 20.1357L18.9866 20.1355L18.9885 20.135L18.9893 20.1347L18.991 20.1342L18.992 20.134L18.9938 20.1334L18.9945 20.1332L18.9965 20.1327L18.9971 20.1325L18.9992 20.1318L18.9997 20.1317L19.0018 20.131L19.0023 20.1309C19.0049 20.1302 19.0075 20.1294 19.0101 20.1286L19.0106 20.1285L19.0126 20.1279L19.0134 20.1277L19.0154 20.1271L19.0159 20.1269L19.0179 20.1263L19.0185 20.1261L19.0206 20.1255L19.021 20.1254L19.0232 20.1247L19.0237 20.1245L19.0262 20.1238L19.0263 20.1237C19.0288 20.123 19.0314 20.1221 19.034 20.1213L19.0373 20.1202L19.0392 20.1197L19.0399 20.1194L19.0418 20.1188L19.0425 20.1186L19.0443 20.1179L19.0451 20.1177L19.0469 20.1171L19.0477 20.1168L19.0495 20.1162L19.0502 20.1161L19.0525 20.1153L19.0527 20.1152L19.0553 20.1143H19.0554L19.0578 20.1135L19.0584 20.1134L19.0604 20.1126L19.0612 20.1124L19.063 20.1118L19.0638 20.1115L19.0664 20.1106L19.068 20.1101L19.069 20.1098L19.0705 20.1092L19.0715 20.1089L19.073 20.1083L19.074 20.108L19.0754 20.1075L19.0766 20.107L19.0787 20.1064L19.0798 20.1059L19.0815 20.1054L19.0824 20.1051L19.084 20.1044L19.0851 20.1041L19.0864 20.1036L19.0876 20.1032L19.089 20.1027L19.0901 20.1023L19.0915 20.1018L19.0926 20.1015L19.0941 20.1009L19.0952 20.1005L19.0966 20.0999L19.0977 20.0996L19.0993 20.0991L19.1001 20.0987L19.1051 20.0969L19.1058 20.0965L19.1075 20.096L19.1086 20.0956L19.11 20.095L19.1111 20.0947L19.1125 20.0941L19.1136 20.0937L19.1149 20.0933L19.1161 20.0927L19.1173 20.0923L19.1186 20.0919L19.121 20.091L19.1224 20.0904L19.1235 20.09L19.1251 20.0893L19.1264 20.0889L19.1284 20.0881L19.1294 20.0877L19.1308 20.0872L19.1319 20.0867L19.1334 20.0863L19.1344 20.0857L19.1359 20.0853L19.137 20.0849L19.1383 20.0843L19.1395 20.0839L19.1407 20.0833L19.1419 20.0829L19.1432 20.0824L19.1444 20.0819L19.1456 20.0814L19.1468 20.0809L19.148 20.0804L19.1501 20.0796L19.1516 20.079L19.153 20.0784L19.154 20.078L19.1555 20.0774L19.1564 20.077L19.1578 20.0765L19.1588 20.076L19.1603 20.0755L19.1612 20.075L19.1626 20.0745L19.1636 20.0741L19.1651 20.0735L19.166 20.0731L19.1674 20.0725L19.1684 20.0721L19.1699 20.0714L19.1706 20.0712C19.1724 20.0704 19.1742 20.0697 19.176 20.0688L19.177 20.0685L19.1784 20.0678L19.1793 20.0675L19.1808 20.0669L19.1817 20.0664L19.1832 20.0658L19.1841 20.0654L19.1856 20.0648L19.1865 20.0645L19.1888 20.0635L19.1904 20.0627L19.1911 20.0625L19.1928 20.0617L19.1932 20.0615C19.1961 20.0603 19.1991 20.059 19.202 20.0577L19.204 20.0568L19.2044 20.0566L19.2063 20.0557L19.2067 20.0556L19.2086 20.0547L19.2091 20.0545L19.2108 20.0537L19.2114 20.0534L19.2131 20.0526L19.2136 20.0525C19.2179 20.0504 19.2224 20.0484 19.2268 20.0463H19.2269L19.229 20.0454L19.2311 20.0443L19.2315 20.0442L19.2335 20.0432H19.2337C19.2389 20.0407 19.244 20.0383 19.2493 20.0358L19.2514 20.0347H19.2516L19.2536 20.0337L19.2538 20.0336C19.46 19.9333 19.6429 19.7909 19.7907 19.6157C19.9358 19.4425 19.9129 19.1845 19.7396 19.0395C19.5671 18.8951 19.3103 18.9173 19.165 19.0889C19.0192 19.2618 18.8082 19.3665 18.5823 19.3781L14.3712 18.8517C14.3542 18.8495 14.3371 18.8485 14.3201 18.8485Z",
    fill: "#005EEE"
  }), React.createElement("path", {
    d: "M4.63586 5.47461H19.3581C20.2616 5.47461 20.994 6.20697 20.994 7.11047V16.9254C20.994 17.8288 20.2616 18.5611 19.3581 18.5611H4.63586C3.73236 18.5611 3 17.8288 3 16.9254V7.11047C3 6.20697 3.73236 5.47461 4.63586 5.47461Z",
    fill: "#B8C2FF"
  }), React.createElement("path", {
    d: "M19.7669 6.29297C20.4445 6.29297 20.9938 6.84229 20.9938 7.51986V16.5169C20.9938 17.1944 20.4445 17.7438 19.7669 17.7438C19.0894 17.7438 18.54 17.1944 18.54 16.5169V7.51986C18.54 6.84229 19.0894 6.29297 19.7669 6.29297Z",
    fill: "#7388FF"
  }), React.createElement("path", {
    d: "M11.9969 18.5608L5.29088 17.8902C4.45462 17.8066 3.81787 17.103 3.81787 16.2626V6.46388C3.81787 5.56049 4.55023 4.82812 5.45362 4.82812C5.50797 4.82812 5.56233 4.83085 5.61646 4.8362L11.9969 5.47426V18.5608Z",
    fill: "#DFE5FF"
  }), React.createElement("path", {
    d: "M11.9971 18.5608L18.7032 17.8902C19.5393 17.8066 20.1762 17.103 20.1762 16.2626V6.46388C20.1762 5.56049 19.4438 4.82812 18.5403 4.82812C18.486 4.82812 18.4317 4.83085 18.3776 4.8362L11.9971 5.47426V18.5608Z",
    fill: "#CCD4FF"
  }), React.createElement("path", {
    d: "M18.5404 5.47461C18.0888 5.47461 17.7226 5.84079 17.7225 6.29243C17.7225 6.29254 17.7225 6.29254 17.7225 6.29254V16.1075H14.4509C13.9993 16.1076 13.6332 16.474 13.6333 16.9257C13.6335 17.3771 13.9995 17.7431 14.4509 17.7432H17.7225C18.626 17.7432 19.3583 17.0108 19.3583 16.1075V6.29254C19.3583 5.84079 18.9922 5.47461 18.5405 5.47461C18.5405 5.47461 18.5405 5.47461 18.5404 5.47461Z",
    fill: "#B8C2FF"
  }), React.createElement("path", {
    d: "M11.9969 4.65686L6.89301 3.83216C6.50096 3.78315 6.10815 3.91795 5.82874 4.19736C5.58852 4.43758 5.45361 4.76327 5.45361 5.10282V15.4614C5.45361 16.2949 6.08043 16.9952 6.90884 17.0872L11.9969 17.7434V4.65686Z",
    fill: "#EFF2FF"
  }), React.createElement("path", {
    d: "M11.9971 4.6569L17.101 3.82533C17.4931 3.77632 17.8859 3.91101 18.1653 4.19053C18.4055 4.43064 18.5404 4.75633 18.5404 5.09599V15.2998C18.5404 16.1333 17.9136 16.8335 17.0852 16.9256L11.9971 17.7435V4.6569Z",
    fill: "#DFE5FF"
  }), React.createElement("path", {
    d: "M12.815 4.65723C13.2666 4.65723 13.6329 5.02341 13.6329 5.47516V16.9259C13.6329 17.3776 13.2667 17.7438 12.815 17.7438C12.3632 17.7438 11.9971 17.3776 11.9971 16.9259V5.47516C11.9971 5.02341 12.3632 4.65723 12.815 4.65723Z",
    fill: "#CCD4FF"
  }), React.createElement("path", {
    d: "M12.406 5.47461C12.6319 5.47461 12.815 5.65775 12.815 5.88357V16.5164C12.815 16.7422 12.6319 16.9254 12.406 16.9254C12.1802 16.9254 11.9971 16.7422 11.9971 16.5164V5.88357C11.9971 5.65775 12.1802 5.47461 12.406 5.47461Z",
    fill: "#A4B1FF"
  }), React.createElement("path", {
    d: "M14.4506 4.65723C14.9024 4.65723 15.2686 5.02341 15.2686 5.47516V12.0185C15.2686 12.4701 14.9024 12.8363 14.4507 12.8363C13.999 12.8363 13.6328 12.4701 13.6328 12.0185V5.47516C13.6328 5.02341 13.999 4.65723 14.4506 4.65723Z",
    fill: "#A4B1FF"
  }), React.createElement("path", {
    d: "M10.7704 12.8361C10.7433 12.8361 10.7163 12.8335 10.6897 12.8281L6.60021 12.0101C6.37876 11.9658 6.23512 11.7504 6.27955 11.5289C6.32386 11.3074 6.53931 11.1639 6.76076 11.2082L10.8503 12.0262C11.0718 12.0705 11.2153 12.286 11.171 12.5074C11.1328 12.6984 10.9651 12.8359 10.7704 12.8361Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M10.7704 10.3829C10.7433 10.383 10.7163 10.3803 10.6897 10.3749L6.60021 9.55701C6.37876 9.5127 6.23512 9.29725 6.27955 9.0758C6.32386 8.85434 6.53931 8.71071 6.76076 8.75513L10.8503 9.57306C11.0718 9.61737 11.2153 9.83282 11.171 10.0543C11.1328 10.2452 10.9651 10.3827 10.7704 10.3829Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M10.7706 7.92888C10.7435 7.92888 10.7164 7.92626 10.6899 7.9208L8.6451 7.51195C8.42365 7.46752 8.28012 7.25207 8.32444 7.03062C8.36602 6.81102 8.57787 6.66673 8.79747 6.70831C8.8002 6.70886 8.80293 6.7094 8.80576 6.70995L10.8505 7.11892C11.0719 7.16323 11.2156 7.37868 11.1711 7.60014C11.1329 7.79114 10.9653 7.92866 10.7706 7.92888Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M10.7704 15.29C10.7434 15.2901 10.7163 15.2875 10.6898 15.282L6.60024 14.4642C6.37879 14.4196 6.23548 14.2039 6.28012 13.9826C6.32465 13.7616 6.53966 13.6182 6.76079 13.6622L10.8503 14.4802C11.0717 14.5245 11.2153 14.7399 11.171 14.9614C11.1328 15.1524 10.9651 15.2899 10.7704 15.29Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M13.2235 12.8361C12.9976 12.8359 12.8147 12.6526 12.8149 12.4267C12.8152 12.232 12.9527 12.0644 13.1436 12.0262L17.2331 11.2082C17.4546 11.1639 17.67 11.3074 17.7143 11.5289C17.7586 11.7504 17.6151 11.9658 17.3937 12.0101L13.3041 12.8281C13.2776 12.8335 13.2505 12.8361 13.2235 12.8361Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M13.2235 10.383C12.9977 10.3828 12.8147 10.1995 12.8149 9.97359C12.8152 9.77888 12.9527 9.61123 13.1436 9.57303L17.2331 8.7551C17.4546 8.71078 17.67 8.85442 17.7145 9.07587C17.7588 9.29722 17.6151 9.51278 17.3937 9.55709L13.3041 10.375C13.2776 10.3804 13.2505 10.3831 13.2235 10.383Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M13.2235 7.9289C12.9976 7.92868 12.8147 7.74532 12.8149 7.5195C12.8152 7.32478 12.9527 7.15714 13.1436 7.11893L17.2331 6.301C17.4546 6.25669 17.67 6.40021 17.7143 6.62167C17.7586 6.84312 17.6151 7.05858 17.3937 7.103L13.3041 7.92083C13.2776 7.92628 13.2505 7.9289 13.2235 7.9289Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M13.2235 15.29C12.9977 15.2898 12.8147 15.1066 12.8149 14.8807C12.8152 14.686 12.9527 14.5184 13.1436 14.4802L17.2331 13.6622C17.4547 13.6181 17.6699 13.762 17.714 13.9835C17.758 14.2046 17.6147 14.4196 17.3937 14.4641L13.3041 15.2821C13.2776 15.2875 13.2505 15.2901 13.2235 15.29Z",
    fill: "#002755"
  }), React.createElement("path", {
    d: "M13.6329 3.83887C14.0845 3.83887 14.4507 4.20505 14.4507 4.6568V11.2001C14.4507 11.6518 14.0845 12.0179 13.6329 12.0179C13.1811 12.0179 12.8149 11.6518 12.8149 11.2001V4.6568C12.8149 4.20516 13.1811 3.83887 13.6329 3.83887Z",
    fill: "#FFD700"
  }), React.createElement("path", {
    d: "M7.90733 6.29254C7.90733 6.74429 7.54116 7.11047 7.08941 7.11047C6.63766 7.11047 6.27148 6.74429 6.27148 6.29254C6.27148 5.84079 6.63766 5.47461 7.08941 5.47461C7.54116 5.47461 7.90733 5.84079 7.90733 6.29254Z",
    fill: "#002755"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white",
    transform: "translate(3 3)"
  }))));
};

const IconColoredBook = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: "#9696FF"
  }), React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    d: "M17.3929 5.22419H16.7906V4.62186C16.7906 3.70821 16.0472 2.96484 15.1336 2.96484H8.92027C8.78046 2.96484 8.64629 3.02046 8.54742 3.11934L5.1584 6.50835C5.05952 6.60723 5.00391 6.7414 5.00391 6.8812V17.0485C5.00391 17.9622 5.74727 18.7055 6.66092 18.7055H7.26325V19.3079C7.26325 19.7508 7.43573 20.1669 7.74857 20.4791C8.06127 20.7924 8.47752 20.9649 8.9204 20.9649H17.3931C18.3067 20.9649 19.0501 20.2215 19.0501 19.3079V6.8812C19.0501 5.96755 18.3067 5.22419 17.3929 5.22419ZM8.95776 4.2004V6.31637C8.95776 6.64857 8.68763 6.91869 8.35543 6.91869H6.2396L8.95776 4.2004ZM6.0586 17.0485V7.97352H8.35543C9.26908 7.97352 10.0124 7.23016 10.0124 6.3165V4.01953H15.1336C15.4657 4.01953 15.7359 4.2898 15.7359 4.62186V17.0485C15.7359 17.3806 15.4657 17.6508 15.1336 17.6508H6.66092C6.32872 17.6508 6.0586 17.3806 6.0586 17.0485ZM17.9954 19.3079C17.9954 19.6399 17.7251 19.9102 17.3931 19.9102H8.9204C8.75945 19.9102 8.60839 19.8476 8.49427 19.7334C8.38056 19.6199 8.31794 19.4687 8.31794 19.3079V18.7055H15.1336C16.0474 18.7055 16.7906 17.9622 16.7906 17.0485V6.27888H17.3931C17.7251 6.27888 17.9954 6.54914 17.9954 6.8812V19.3079Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M8.35547 10.7979H13.4391C13.7304 10.7979 13.9665 10.5618 13.9665 10.2705C13.9665 9.97924 13.7304 9.74316 13.4391 9.74316H8.35547C8.06433 9.74316 7.82812 9.97924 7.82812 10.2705C7.82812 10.5618 8.06433 10.7979 8.35547 10.7979Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M8.35547 13.0566H13.4391C13.7304 13.0566 13.9665 12.8206 13.9665 12.5293C13.9665 12.238 13.7304 12.002 13.4391 12.002H8.35547C8.06433 12.002 7.82812 12.238 7.82812 12.5293C7.82812 12.8206 8.06433 13.0566 8.35547 13.0566Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M8.35547 15.3164H11.1798C11.4709 15.3164 11.7071 15.0803 11.7071 14.7891C11.7071 14.4979 11.4709 14.2617 11.1798 14.2617H8.35547C8.06433 14.2617 7.82812 14.4979 7.82812 14.7891C7.82812 15.0803 8.06433 15.3164 8.35547 15.3164Z",
    fill: "white"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white",
    transform: "translate(3 3)"
  }))));
};

const IconEye = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9907 5.25C8.22194 5.25 5.25006 7.62187 1.69694 11.4984C1.43913 11.7844 1.43444 12.2109 1.69225 12.4969C4.73444 15.8578 7.41569 18.75 11.9907 18.75C16.5094 18.75 19.8985 15.1078 22.3079 12.4688C22.5563 12.1969 22.5704 11.7844 22.3313 11.4984C19.8751 8.52187 16.4766 5.25 11.9907 5.25ZM12.1969 16.2141C9.71256 16.3266 7.66882 14.2828 7.786 11.8031C7.88444 9.6375 9.63757 7.88438 11.8032 7.78594C14.2876 7.67344 16.3313 9.71719 16.2141 12.1969C16.1157 14.3625 14.3626 16.1156 12.1969 16.2141ZM12.1454 9.00469C12.0516 9.24844 12.0001 9.51562 12.0001 9.79688C12.0001 11.0109 12.961 12 14.1423 12C14.4469 12 14.7329 11.9344 14.9954 11.8172C14.9954 11.8477 14.9965 11.8781 14.9977 11.9086C14.9989 11.9391 15.0001 11.9695 15.0001 12C15.0001 13.7297 13.5282 15.1219 11.7704 14.9906C10.3032 14.8781 9.12194 13.6969 9.00944 12.2297C8.87819 10.4719 10.2704 9 12.0001 9C12.0265 9 12.0516 9.00123 12.0762 9.00243C12.0996 9.00357 12.1225 9.00469 12.1454 9.00469Z",
    fill: fill
  }));
};

const IconLockBold = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 8.9999H8.8125V6.7499C8.8125 5.90146 9.14531 5.10459 9.75 4.4999C10.3547 3.89521 11.1516 3.5624 12 3.5624C12.8484 3.5624 13.6453 3.89521 14.25 4.4999C14.8547 5.10459 15.1875 5.90146 15.1875 6.7499C15.1875 7.11084 15.4828 7.40615 15.8438 7.40615C16.2047 7.40615 16.5 7.11084 16.5 6.7499C16.5 4.25615 14.4422 2.21709 11.9391 2.2499C9.46875 2.28271 7.5 4.33584 7.5 6.81084V8.9999H6.375C5.34375 8.9999 4.5 9.84365 4.5 10.8749V19.8749C4.5 20.9062 5.34375 21.7499 6.375 21.7499H17.625C18.6562 21.7499 19.5 20.9062 19.5 19.8749V10.8749C19.5 9.84365 18.6562 8.9999 17.625 8.9999ZM12.6562 14.8499V18.0749C12.6562 18.4265 12.3844 18.7312 12.0328 18.7499C11.6578 18.7687 11.3438 18.4687 11.3438 18.0937V14.8499C10.8047 14.5874 10.4484 14.0155 10.5047 13.364C10.5703 12.6374 11.1656 12.0562 11.8922 12.0046C12.7688 11.9437 13.5 12.6374 13.5 13.4999C13.5 14.0952 13.1578 14.6062 12.6562 14.8499Z",
    fill: fill
  }));
};

const IconClip = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M16.5 6h1.5v11.484q0 2.297-1.594 3.914t-3.891 1.617-3.914-1.617-1.617-3.914v-12.469q0-1.641 1.195-2.836t2.836-1.195 2.813 1.195 1.172 2.836v10.5q0 1.031-0.727 1.758t-1.758 0.727-1.781-0.727-0.75-1.758v-9.516h1.5v9.516q0 0.422 0.305 0.703t0.727 0.281 0.703-0.281 0.281-0.703v-10.5q0-1.031-0.727-1.781t-1.758-0.75-1.781 0.75-0.75 1.781v12.469q0 1.641 1.195 2.836t2.836 1.195 2.813-1.195 1.172-2.836v-11.484z",
    fill: fill || 'black'
  }));
};

const IconNotes = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2938 3.14062L21.6187 2.46563L21.6094 2.45625C21.4641 2.32969 21.2719 2.25 21.0703 2.25C20.8641 2.25 20.6719 2.32969 20.5266 2.46094L19.9969 2.99531C19.9266 3.07031 19.9266 3.1875 19.9969 3.25781L20.4844 3.74531L21.5016 4.7625C21.5766 4.8375 21.6937 4.8375 21.7687 4.7625L22.2984 4.23281C22.4297 4.0875 22.5047 3.9 22.5047 3.68906C22.5 3.48281 22.425 3.28594 22.2938 3.14062ZM18.9516 4.03125L9.48281 13.5C9.4125 13.5703 9.375 13.6641 9.375 13.7625V15.0047C9.375 15.2109 9.54375 15.375 9.74531 15.375H10.9781C11.0766 15.375 11.175 15.3375 11.2453 15.2672L20.7188 5.79844C20.8641 5.65313 20.8641 5.41875 20.7188 5.27344L19.4766 4.03125C19.3312 3.88594 19.0969 3.88594 18.9516 4.03125ZM11.1891 16.2516C11.3859 16.2516 11.5781 16.1719 11.7188 16.0312L11.7563 15.9937L18.6844 9.075C18.8016 8.95781 19.0031 9.0375 19.0031 9.20625V19.0031C19.0031 20.5219 17.7703 21.7547 16.2516 21.7547H4.25156C2.73281 21.7547 1.5 20.5219 1.5 19.0031V8.50313C1.5 6.98438 2.73281 5.75156 4.25156 5.75156H15.5437C15.7078 5.75156 15.7922 5.95312 15.675 6.07031L8.75625 12.9891L8.71875 13.0266C8.57812 13.1672 8.49844 13.3594 8.49844 13.5562V15.5016C8.49844 15.9141 8.83594 16.2516 9.24844 16.2516H11.1891Z",
    fill: "#262626"
  }));
};

const IconMergeRequest = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M6.9375 16.75H3.875C3.53038 16.75 3.25 16.4696 3.25 16.125V13.1562C3.25 12.8112 2.97019 12.5312 2.625 12.5312C2.27981 12.5312 2 12.8112 2 13.1562V16.125C2 17.1589 2.84113 18 3.875 18H6.9375C7.28269 18 7.5625 17.7202 7.5625 17.375C7.5625 17.0298 7.28269 16.75 6.9375 16.75Z",
    fill: fill
  }), React.createElement("path", {
    d: "M6.59684 6.77546C6.35203 6.53214 5.95628 6.53333 5.71297 6.77814C5.46963 7.02296 5.47084 7.41871 5.71566 7.66202L7.4705 9.40624H2.625C2.27981 9.40624 2 9.68605 2 10.0312C2 10.3764 2.27981 10.6562 2.625 10.6562H7.42209L5.71347 12.3714C5.46984 12.6159 5.47063 13.0117 5.71516 13.2553C5.83713 13.3768 5.99669 13.4375 6.15625 13.4375C6.31659 13.4375 6.47694 13.3762 6.59903 13.2536L8.51331 11.332C8.86747 10.9778 9.0625 10.507 9.0625 10.0061C9.0625 9.50534 8.86747 9.03446 8.51197 8.67899L6.59684 6.77546Z",
    fill: fill
  }), React.createElement("path", {
    d: "M2.625 7.5C2.97019 7.5 3.25 7.22019 3.25 6.875V3.875C3.25 3.53038 3.53038 3.25 3.875 3.25H6.9375C7.28269 3.25 7.5625 2.97019 7.5625 2.625C7.5625 2.27981 7.28269 2 6.9375 2H3.875C2.84113 2 2 2.84113 2 3.875V6.875C2 7.22019 2.27981 7.5 2.625 7.5Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.375 9.40625H12.5295L14.2843 7.66203C14.5292 7.41869 14.5304 7.02297 14.287 6.77816C14.0437 6.53334 13.648 6.53212 13.4032 6.77547L11.4867 8.68034C11.1325 9.0345 10.9375 9.50534 10.9375 10.0062C10.9375 10.507 11.1325 10.9778 11.4858 11.3312L13.401 13.2536C13.5231 13.3762 13.6834 13.4375 13.8438 13.4375C14.0033 13.4375 14.1629 13.3768 14.2848 13.2553C14.5294 13.0117 14.5302 12.6159 14.2865 12.3714L12.5779 10.6562H17.375C17.7202 10.6562 18 10.3764 18 10.0312C18 9.68606 17.7202 9.40625 17.375 9.40625Z",
    fill: fill
  }), React.createElement("path", {
    d: "M16.125 2H13.0625C12.7173 2 12.4375 2.27981 12.4375 2.625C12.4375 2.97019 12.7173 3.25 13.0625 3.25H16.125C16.4696 3.25 16.75 3.53038 16.75 3.875V6.875C16.75 7.22019 17.0298 7.5 17.375 7.5C17.7202 7.5 18 7.22019 18 6.875V3.875C18 2.84113 17.1589 2 16.125 2Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.375 12.5312C17.0298 12.5312 16.75 12.8112 16.75 13.1562V16.125C16.75 16.4696 16.4696 16.75 16.125 16.75H13.0625C12.7173 16.75 12.4375 17.0298 12.4375 17.375C12.4375 17.7202 12.7173 18 13.0625 18H16.125C17.1589 18 18 17.1589 18 16.125V13.1562C18 12.8112 17.7202 12.5312 17.375 12.5312Z",
    fill: fill
  }));
};

const IconPenUnderline = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M15.833 16.6665H4.16634C3.94533 16.6665 3.73337 16.7543 3.57709 16.9106C3.42081 17.0669 3.33301 17.2788 3.33301 17.4998C3.33301 17.7209 3.42081 17.9328 3.57709 18.0891C3.73337 18.2454 3.94533 18.3332 4.16634 18.3332H15.833C16.054 18.3332 16.266 18.2454 16.4223 18.0891C16.5785 17.9328 16.6663 17.7209 16.6663 17.4998C16.6663 17.2788 16.5785 17.0669 16.4223 16.9106C16.266 16.7543 16.054 16.6665 15.833 16.6665Z",
    fill: fill
  }), React.createElement("path", {
    d: "M4.16691 15H4.24191L7.71691 14.6834C8.09758 14.6455 8.45361 14.4777 8.72525 14.2084L16.2252 6.70838C16.5163 6.40085 16.6737 5.99047 16.6627 5.56716C16.6518 5.14385 16.4735 4.74213 16.1669 4.45004L13.8836 2.16671C13.5856 1.88679 13.1951 1.72618 12.7864 1.71542C12.3776 1.70467 11.9792 1.84452 11.6669 2.10838L4.16691 9.60838C3.89755 9.88001 3.72983 10.236 3.69191 10.6167L3.33358 14.0917C3.32235 14.2138 3.33819 14.3368 3.37996 14.452C3.42174 14.5673 3.48842 14.6719 3.57525 14.7584C3.65311 14.8356 3.74546 14.8967 3.84699 14.9382C3.94852 14.9797 4.05724 15.0007 4.16691 15ZM12.7252 3.33338L15.0002 5.60838L13.3336 7.23338L11.1002 5.00004L12.7252 3.33338ZM5.30858 10.7584L10.0002 6.10004L12.2502 8.35004L7.58358 13.0167L5.08358 13.25L5.30858 10.7584Z",
    fill: fill
  }));
};

const IconPrint = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M15.1337 3.83333H14.0003V2.16667C14.0184 1.74361 13.8681 1.33062 13.5822 1.01822C13.2964 0.705814 12.8983 0.519462 12.4753 0.5H5.52534C5.10234 0.519462 4.70431 0.705814 4.41845 1.01822C4.1326 1.33062 3.98225 1.74361 4.00034 2.16667V3.83333H2.86701C2.28056 3.83774 1.71975 4.07437 1.30741 4.4914C0.895064 4.90843 0.664787 5.47187 0.667008 6.05833V11.6083C0.664787 12.1948 0.895064 12.7582 1.30741 13.1753C1.71975 13.5923 2.28056 13.8289 2.86701 13.8333H3.58367C3.58367 14.2754 3.75927 14.6993 4.07183 15.0118C4.38439 15.3244 4.80831 15.5 5.25034 15.5H12.7503C13.1924 15.5 13.6163 15.3244 13.9289 15.0118C14.2414 14.6993 14.417 14.2754 14.417 13.8333H15.1337C15.7201 13.8289 16.2809 13.5923 16.6933 13.1753C17.1056 12.7582 17.3359 12.1948 17.3337 11.6083V6.05833C17.3359 5.47187 17.1056 4.90843 16.6933 4.4914C16.2809 4.07437 15.7201 3.83774 15.1337 3.83333ZM5.66701 2.16667H12.3337V3.83333H5.66701V2.16667ZM5.25034 13.8333V10.5H12.7503V13.8333H5.25034ZM15.667 11.6083C15.6693 11.7528 15.6146 11.8923 15.5148 11.9968C15.415 12.1013 15.2781 12.1623 15.1337 12.1667H14.417V10.5C14.417 10.058 14.2414 9.63405 13.9289 9.32149C13.6163 9.00893 13.1924 8.83333 12.7503 8.83333H5.25034C4.80831 8.83333 4.38439 9.00893 4.07183 9.32149C3.75927 9.63405 3.58367 10.058 3.58367 10.5V12.1667H2.86701C2.72259 12.1623 2.58569 12.1013 2.4859 11.9968C2.3861 11.8923 2.33142 11.7528 2.33367 11.6083V6.05833C2.33142 5.91387 2.3861 5.77432 2.4859 5.66985C2.58569 5.56537 2.72259 5.50436 2.86701 5.5H15.1337C15.2781 5.50436 15.415 5.56537 15.5148 5.66985C15.6146 5.77432 15.6693 5.91387 15.667 6.05833V11.6083Z",
    fill: fill
  }));
};

const IconBellOutlined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7203 13.4038L20.5213 15.2078C20.9903 15.6768 21.1283 16.3768 20.8733 16.9908C20.6193 17.6038 20.0273 17.9998 19.3633 17.9998H16.0003V18.3408C16.0003 20.3588 14.2063 21.9998 12.0003 21.9998C9.79434 21.9998 8.00034 20.3588 8.00034 18.3408V17.9998H4.63734C3.97334 17.9998 3.38034 17.6038 3.12534 16.9898C2.87134 16.3768 3.01034 15.6778 3.47934 15.2078L5.28034 13.4038L5.28134 8.72683C5.28134 6.79283 6.11934 4.94883 7.58334 3.66683C9.03834 2.39083 10.9783 1.80383 12.9003 2.05983C16.2183 2.49883 18.7203 5.45583 18.7203 8.93683V13.4038ZM5.51534 15.9998L6.69534 14.8178C7.07334 14.4398 7.28134 13.9378 7.28134 13.4038V8.72683C7.28134 7.36983 7.87134 6.07283 8.90134 5.17083C9.93934 4.26083 11.2613 3.86083 12.6383 4.04183C14.9653 4.35083 16.7203 6.45483 16.7203 8.93683V13.4038C16.7203 13.9378 16.9283 14.4398 17.3053 14.8168L18.4863 15.9998H5.51534ZM14.0003 18.3408C14.0003 19.2398 13.0843 19.9998 12.0003 19.9998C10.9163 19.9998 10.0003 19.2398 10.0003 18.3408V17.9998H14.0003V18.3408Z",
    fill: fill
  }), React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "2",
    width: "18",
    height: "20"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7203 13.4038L20.5213 15.2078C20.9903 15.6768 21.1283 16.3768 20.8733 16.9908C20.6193 17.6038 20.0273 17.9998 19.3633 17.9998H16.0003V18.3408C16.0003 20.3588 14.2063 21.9998 12.0003 21.9998C9.79434 21.9998 8.00034 20.3588 8.00034 18.3408V17.9998H4.63734C3.97334 17.9998 3.38034 17.6038 3.12534 16.9898C2.87134 16.3768 3.01034 15.6778 3.47934 15.2078L5.28034 13.4038L5.28134 8.72683C5.28134 6.79283 6.11934 4.94883 7.58334 3.66683C9.03834 2.39083 10.9783 1.80383 12.9003 2.05983C16.2183 2.49883 18.7203 5.45583 18.7203 8.93683V13.4038ZM5.51534 15.9998L6.69534 14.8178C7.07334 14.4398 7.28134 13.9378 7.28134 13.4038V8.72683C7.28134 7.36983 7.87134 6.07283 8.90134 5.17083C9.93934 4.26083 11.2613 3.86083 12.6383 4.04183C14.9653 4.35083 16.7203 6.45483 16.7203 8.93683V13.4038C16.7203 13.9378 16.9283 14.4398 17.3053 14.8168L18.4863 15.9998H5.51534ZM14.0003 18.3408C14.0003 19.2398 13.0843 19.9998 12.0003 19.9998C10.9163 19.9998 10.0003 19.2398 10.0003 18.3408V17.9998H14.0003V18.3408Z",
    fill: fill
  })));
};

const IconBellWithPaper = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M9.03125 7.19531C9.03125 6.76383 9.38102 6.41406 9.8125 6.41406H17.3125C18.3491 6.45531 18.3483 7.93566 17.3125 7.97656H9.8125C9.38102 7.97656 9.03125 7.6268 9.03125 7.19531ZM11.6875 16.0625H9.8125C8.77594 16.1037 8.77672 17.5841 9.8125 17.625H11.6875C12.7241 17.5838 12.7233 16.1034 11.6875 16.0625ZM9.8125 12.6641H13.9922C15.0287 12.6228 15.028 11.1425 13.9922 11.1016H9.8125C8.77594 11.1428 8.77672 12.6232 9.8125 12.6641ZM6.6875 11.1016C6.25602 11.1016 5.90625 11.4513 5.90625 11.8828C5.94742 12.9191 7.42777 12.9188 7.46875 11.8828C7.46875 11.4513 7.11898 11.1016 6.6875 11.1016ZM22 18.8816C22.0004 20.0869 21.0739 21.2482 19.8086 21.2188H18.1719C18.1288 22.2554 16.6521 22.2546 16.6094 21.2188H14.9336C13.6682 21.2482 12.7418 20.0867 12.7422 18.8816C12.7422 18.5452 12.9361 18.2541 13.2547 18.1479C13.3406 18.1128 13.8702 17.8714 13.8702 17.2617V16.4922C13.8702 14.829 15.046 13.4198 16.6094 13.0639V12.5469C16.6507 11.5103 18.131 11.5111 18.1719 12.5469V13.0731C19.7158 13.4433 20.8721 14.8429 20.8721 16.4922V17.2617C20.8721 17.8714 21.4017 18.1128 21.4875 18.1479C21.8061 18.2541 22 18.5452 22 18.8816ZM20.3404 19.2823C19.8233 18.902 19.3096 18.2431 19.3096 17.2617V16.4922C19.3096 15.43 18.4466 14.5542 17.3859 14.54C17.381 14.54 17.376 14.5398 17.3711 14.5397C17.3662 14.5398 17.3612 14.54 17.3563 14.54C16.2956 14.5542 15.4326 15.43 15.4326 16.4922V17.2617C15.4326 18.2431 14.9189 18.902 14.4018 19.2823C14.4861 19.4714 14.643 19.6562 14.9335 19.6562H19.8086C20.0992 19.6562 20.2561 19.4714 20.3404 19.2823ZM6.6875 6.41406C6.25602 6.41406 5.90625 6.76383 5.90625 7.19531C5.94742 8.23164 7.42777 8.23133 7.46875 7.19531C7.46875 6.76383 7.11898 6.41406 6.6875 6.41406ZM6.6875 16.0625C6.25602 16.0625 5.90625 16.4123 5.90625 16.8438C5.94742 17.8801 7.42777 17.8798 7.46875 16.8438C7.46875 16.4123 7.11898 16.0625 6.6875 16.0625ZM18.875 2H5.125C3.40188 2 2 3.40188 2 5.125V18.875C2 20.5981 3.40188 22 5.125 22H11.0625C12.0991 21.9588 12.0983 20.4784 11.0625 20.4375H5.125C4.26344 20.4375 3.5625 19.7366 3.5625 18.875V5.125C3.5625 4.26344 4.26344 3.5625 5.125 3.5625H18.875C19.7366 3.5625 20.4375 4.26344 20.4375 5.125V12.1562C20.4787 13.1928 21.9591 13.192 22 12.1562V5.125C22 3.40188 20.5981 2 18.875 2Z",
    fill: fill
  }));
};

const IconExport = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16968 10.0633C9.16812 10.0424 9.16732 10.0213 9.16732 10V3.33333C9.16732 2.87333 9.53982 2.5 10.0007 2.5C10.4615 2.5 10.834 2.87333 10.834 3.33333V9.99986L12.8339 8.50003C13.2023 8.22253 13.7248 8.29836 14.0006 8.6667C14.2773 9.03503 14.2023 9.55753 13.834 9.83336L10.5006 12.3334C10.3531 12.4442 10.1764 12.5 10.0006 12.5C9.83312 12.5 9.66562 12.4492 9.52145 12.3484L6.18812 10.0034C5.81145 9.73836 5.72062 9.21836 5.98562 8.84253C6.25062 8.46586 6.76978 8.37503 7.14645 8.64003L9.16968 10.0633ZM5.00065 14.1667V15H15.0007V14.1667C15.0007 13.7083 15.3757 13.3333 15.834 13.3333C16.2923 13.3333 16.6673 13.7083 16.6673 14.1667V15.8333C16.6673 16.2917 16.2923 16.6667 15.834 16.6667H4.16732C3.70898 16.6667 3.33398 16.2917 3.33398 15.8333V14.1667C3.33398 13.7083 3.70898 13.3333 4.16732 13.3333C4.62565 13.3333 5.00065 13.7083 5.00065 14.1667Z",
    fill: fill
  }), React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "2",
    width: "14",
    height: "15"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16968 10.0633C9.16812 10.0424 9.16732 10.0213 9.16732 10V3.33333C9.16732 2.87333 9.53982 2.5 10.0007 2.5C10.4615 2.5 10.834 2.87333 10.834 3.33333V9.99986L12.8339 8.50003C13.2023 8.22253 13.7248 8.29836 14.0006 8.6667C14.2773 9.03503 14.2023 9.55753 13.834 9.83336L10.5006 12.3334C10.3531 12.4442 10.1764 12.5 10.0006 12.5C9.83312 12.5 9.66562 12.4492 9.52145 12.3484L6.18812 10.0034C5.81145 9.73836 5.72062 9.21836 5.98562 8.84253C6.25062 8.46586 6.76978 8.37503 7.14645 8.64003L9.16968 10.0633ZM5.00065 14.1667V15H15.0007V14.1667C15.0007 13.7083 15.3757 13.3333 15.834 13.3333C16.2923 13.3333 16.6673 13.7083 16.6673 14.1667V15.8333C16.6673 16.2917 16.2923 16.6667 15.834 16.6667H4.16732C3.70898 16.6667 3.33398 16.2917 3.33398 15.8333V14.1667C3.33398 13.7083 3.70898 13.3333 4.16732 13.3333C4.62565 13.3333 5.00065 13.7083 5.00065 14.1667Z",
    fill: fill
  })));
};

const IconImport = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16732 3.3335H15.834C16.2923 3.3335 16.6673 3.7085 16.6673 4.16683V5.8335C16.6673 6.29183 16.2923 6.66683 15.834 6.66683C15.3757 6.66683 15.0007 6.29183 15.0007 5.8335V5.00016H5.00065V5.8335C5.00065 6.29183 4.62565 6.66683 4.16732 6.66683C3.70898 6.66683 3.33398 6.29183 3.33398 5.8335V4.16683C3.33398 3.7085 3.70898 3.3335 4.16732 3.3335ZM6.66817 11.6668C6.414 11.6668 6.16484 11.5518 6.00067 11.3335C5.724 10.9652 5.799 10.4427 6.16734 10.1668L9.50067 7.66683C9.789 7.45016 10.1857 7.44433 10.4798 7.65183L13.8132 9.99683C14.1898 10.2618 14.2807 10.7818 14.0157 11.1577C13.7507 11.5335 13.2315 11.6252 12.8548 11.3602L10.8316 9.9369C10.8332 9.95779 10.834 9.97888 10.834 10.0002V16.6668C10.834 17.1268 10.4615 17.5002 10.0007 17.5002C9.53982 17.5002 9.16732 17.1268 9.16732 16.6668V10.0003L7.16734 11.5002C7.01734 11.6127 6.84234 11.6668 6.66817 11.6668Z",
    fill: fill
  }), React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "3",
    width: "14",
    height: "15"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16732 3.3335H15.834C16.2923 3.3335 16.6673 3.7085 16.6673 4.16683V5.8335C16.6673 6.29183 16.2923 6.66683 15.834 6.66683C15.3757 6.66683 15.0007 6.29183 15.0007 5.8335V5.00016H5.00065V5.8335C5.00065 6.29183 4.62565 6.66683 4.16732 6.66683C3.70898 6.66683 3.33398 6.29183 3.33398 5.8335V4.16683C3.33398 3.7085 3.70898 3.3335 4.16732 3.3335ZM6.66817 11.6668C6.414 11.6668 6.16484 11.5518 6.00067 11.3335C5.724 10.9652 5.799 10.4427 6.16734 10.1668L9.50067 7.66683C9.789 7.45016 10.1857 7.44433 10.4798 7.65183L13.8132 9.99683C14.1898 10.2618 14.2807 10.7818 14.0157 11.1577C13.7507 11.5335 13.2315 11.6252 12.8548 11.3602L10.8316 9.9369C10.8332 9.95779 10.834 9.97888 10.834 10.0002V16.6668C10.834 17.1268 10.4615 17.5002 10.0007 17.5002C9.53982 17.5002 9.16732 17.1268 9.16732 16.6668V10.0003L7.16734 11.5002C7.01734 11.6127 6.84234 11.6668 6.66817 11.6668Z",
    fill: fill
  })));
};

const IconPen = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19.4003 7.33986L16.6603 4.59986C16.3027 4.26395 15.8341 4.07122 15.3436 4.05831C14.8532 4.0454 14.3751 4.21323 14.0003 4.52986L5.0003 13.5299C4.67706 13.8558 4.4758 14.2831 4.4303 14.7399L4.0003 18.9099C3.98683 19.0563 4.00583 19.204 4.05596 19.3422C4.10608 19.4805 4.1861 19.606 4.2903 19.7099C4.38374 19.8025 4.49455 19.8759 4.61639 19.9256C4.73823 19.9754 4.86869 20.0006 5.0003 19.9999H5.0903L9.2603 19.6199C9.71709 19.5744 10.1443 19.3731 10.4703 19.0499L19.4703 10.0499C19.8196 9.68083 20.0084 9.18837 19.9953 8.68039C19.9822 8.17242 19.7682 7.69037 19.4003 7.33986ZM9.0803 17.6199L6.0803 17.8999L6.3503 14.8999L12.0003 9.31986L14.7003 12.0199L9.0803 17.6199ZM16.0003 10.6799L13.3203 7.99986L15.2703 5.99986L18.0003 8.72986L16.0003 10.6799Z",
    fill: fill
  }));
};

const IconTrashLined = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21 5.99991H16V4.32991C15.9765 3.68973 15.7002 3.08497 15.2316 2.64821C14.7629 2.21144 14.1402 1.97831 13.5 1.99991H10.5C9.85975 1.97831 9.23706 2.21144 8.76843 2.64821C8.2998 3.08497 8.02346 3.68973 8 4.32991V5.99991H3C2.73478 5.99991 2.48043 6.10527 2.29289 6.29281C2.10536 6.48034 2 6.7347 2 6.99991C2 7.26513 2.10536 7.51948 2.29289 7.70702C2.48043 7.89456 2.73478 7.99991 3 7.99991H4V18.9999C4 19.7956 4.31607 20.5586 4.87868 21.1212C5.44129 21.6838 6.20435 21.9999 7 21.9999H17C17.7956 21.9999 18.5587 21.6838 19.1213 21.1212C19.6839 20.5586 20 19.7956 20 18.9999V7.99991H21C21.2652 7.99991 21.5196 7.89456 21.7071 7.70702C21.8946 7.51948 22 7.26513 22 6.99991C22 6.7347 21.8946 6.48034 21.7071 6.29281C21.5196 6.10527 21.2652 5.99991 21 5.99991ZM10 4.32991C10 4.16991 10.21 3.99991 10.5 3.99991H13.5C13.79 3.99991 14 4.16991 14 4.32991V5.99991H10V4.32991ZM18 18.9999C18 19.2651 17.8946 19.5195 17.7071 19.707C17.5196 19.8946 17.2652 19.9999 17 19.9999H7C6.73478 19.9999 6.48043 19.8946 6.29289 19.707C6.10536 19.5195 6 19.2651 6 18.9999V7.99991H18V18.9999Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9 17C9.26522 17 9.51957 16.8946 9.70711 16.7071C9.89464 16.5196 10 16.2652 10 16V12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12V16C8 16.2652 8.10536 16.5196 8.29289 16.7071C8.48043 16.8946 8.73478 17 9 17Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16V12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12V16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17Z",
    fill: fill
  }));
};

const IconFilePDF = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22.937 5.938c0.578 0.578 1.062 1.734 1.062 2.562v18c0 0.828-0.672 1.5-1.5 1.5h-21c-0.828 0-1.5-0.672-1.5-1.5v-25c0-0.828 0.672-1.5 1.5-1.5h14c0.828 0 1.984 0.484 2.562 1.062zM16 2.125v5.875h5.875c-0.094-0.266-0.234-0.531-0.344-0.641l-4.891-4.891c-0.109-0.109-0.375-0.25-0.641-0.344zM22 26v-16h-6.5c-0.828 0-1.5-0.672-1.5-1.5v-6.5h-12v24h20zM13.969 16.734c0.391 0.313 0.828 0.594 1.312 0.875 0.656-0.078 1.266-0.109 1.828-0.109 1.047 0 2.375 0.125 2.766 0.766 0.109 0.156 0.203 0.438 0.031 0.812-0.016 0.016-0.031 0.047-0.047 0.063v0.016c-0.047 0.281-0.281 0.594-1.109 0.594-1 0-2.516-0.453-3.828-1.141-2.172 0.234-4.453 0.719-6.125 1.297-1.609 2.75-2.844 4.094-3.781 4.094-0.156 0-0.297-0.031-0.438-0.109l-0.375-0.187c-0.047-0.016-0.063-0.047-0.094-0.078-0.078-0.078-0.141-0.25-0.094-0.562 0.156-0.719 1-1.922 2.938-2.938 0.125-0.078 0.281-0.031 0.359 0.094 0.016 0.016 0.031 0.047 0.031 0.063 0.484-0.797 1.047-1.813 1.672-3.078 0.703-1.406 1.25-2.781 1.625-4.094-0.5-1.703-0.656-3.453-0.375-4.484 0.109-0.391 0.344-0.625 0.656-0.625h0.344c0.234 0 0.422 0.078 0.547 0.234 0.187 0.219 0.234 0.562 0.141 1.062-0.016 0.047-0.031 0.094-0.063 0.125 0.016 0.047 0.016 0.078 0.016 0.125v0.469c-0.016 0.984-0.031 1.922-0.219 3 0.547 1.641 1.359 2.969 2.281 3.719zM4.969 23.156c0.469-0.219 1.141-0.891 2.141-2.469-1.172 0.906-1.906 1.937-2.141 2.469zM11.188 8.781c-0.156 0.438-0.156 1.188-0.031 2.063 0.047-0.25 0.078-0.484 0.109-0.688 0.031-0.266 0.078-0.484 0.109-0.672 0.016-0.047 0.031-0.078 0.063-0.125-0.016-0.016-0.016-0.047-0.031-0.078-0.016-0.281-0.109-0.453-0.203-0.562 0 0.031-0.016 0.047-0.016 0.063zM9.25 19.109c1.375-0.547 2.906-0.984 4.438-1.266-0.156-0.125-0.313-0.234-0.453-0.359-0.766-0.672-1.453-1.609-1.984-2.75-0.297 0.953-0.734 1.969-1.297 3.078-0.234 0.438-0.469 0.875-0.703 1.297zM19.344 18.859c-0.078-0.078-0.484-0.375-2.188-0.375 0.766 0.281 1.469 0.438 1.937 0.438 0.141 0 0.219 0 0.281-0.016 0-0.016-0.016-0.031-0.031-0.047z",
    fill: fill
  }));
};

const IconNotePadColored = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M25.5261 2.44153L2.84144 6.84027C2.56912 6.89308 2.39113 7.15664 2.44387 7.42908L7.12955 31.5931C7.18237 31.8654 7.44593 32.0434 7.71836 31.9907L24.0332 28.827L29.5654 20.6334L26.1149 2.83903C26.062 2.56678 25.7985 2.38871 25.5261 2.44153Z",
    fill: "#F54E95"
  }), React.createElement("path", {
    d: "M24.0333 28.827L29.5654 20.6333L23.1956 21.8685C22.9233 21.9213 22.7453 22.1849 22.7981 22.4573L24.0333 28.827Z",
    fill: "#F082A6"
  }), React.createElement("path", {
    d: "M6.5323 6.12465L9.08742 11.0512L14.613 10.0465L15.0105 4.48059L6.5323 6.12465Z",
    fill: "#F082A6"
  }), React.createElement("path", {
    d: "M15.3524 0.0594374C15.1891 -0.0279374 14.9909 -0.0184375 14.8368 0.0843748L13.6084 0.903311L12.38 0.0843748C12.2112 -0.0281249 11.9914 -0.0281249 11.8227 0.0843748L10.5944 0.903311L9.36599 0.0843748C9.03811 -0.134187 8.58505 0.109375 8.58505 0.502311V10.5489C8.58505 10.8264 8.80999 11.0512 9.08736 11.0512H15.1153C15.3927 11.0512 15.6176 10.8263 15.6176 10.5489V0.502311C15.6177 0.317124 15.5157 0.146875 15.3524 0.0594374Z",
    fill: "#FCDE76"
  }));
};

const IconGlobeOutline = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12ZM19.93 11H17C16.8351 8.64814 16.0293 6.38635 14.67 4.46C16.0665 4.95597 17.2977 5.83007 18.2265 6.98484C19.1553 8.13962 19.745 9.52967 19.93 11ZM9.08 13H15C14.7441 15.4706 13.6911 17.7908 12 19.61C10.3101 17.7984 9.28119 15.4693 9.08 13ZM9.08 11C9.31289 8.54183 10.3376 6.22572 12 4.4C13.7047 6.20612 14.7601 8.52804 15 11H9.08ZM9.44 4.43C8.07355 6.36702 7.2548 8.63672 7.07 11H4.07C4.2589 9.5115 4.86261 8.10612 5.81217 6.94437C6.76172 5.78262 8.01886 4.91133 9.44 4.43ZM4.07 13H7.07C7.23469 15.3613 8.04788 17.6313 9.42 19.56C8.00397 19.0763 6.75199 18.2052 5.80627 17.0456C4.86055 15.886 4.25902 14.4844 4.07 13ZM14.62 19.55C15.9884 17.6207 16.8107 15.3577 17 13H19.95C19.7609 14.4802 19.1615 15.8781 18.2196 17.0356C17.2778 18.193 16.0309 19.064 14.62 19.55Z",
    fill: fill
  }));
};

const IconContact = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9386 4.1109C20.3196 4.0129 20.7106 4.0979 21.0176 4.3359C21.3246 4.5749 21.4996 4.9349 21.4996 5.3219V17.0079C21.4996 17.5789 21.1146 18.0769 20.5616 18.2189L12.9996 20.1599V5.8939L19.9386 4.1109ZM4.058 4.1106L11 5.8936V20.1606L3.438 18.2186C2.886 18.0776 2.5 17.5796 2.5 17.0076V5.3226C2.5 4.9346 2.676 4.5756 2.982 4.3356C3.288 4.0986 3.681 4.0156 4.058 4.1106Z",
    fill: "#0D1C2E"
  }), React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "4",
    width: "20",
    height: "17"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9386 4.1109C20.3196 4.0129 20.7106 4.0979 21.0176 4.3359C21.3246 4.5749 21.4996 4.9349 21.4996 5.3219V17.0079C21.4996 17.5789 21.1146 18.0769 20.5616 18.2189L12.9996 20.1599V5.8939L19.9386 4.1109ZM4.058 4.1106L11 5.8936V20.1606L3.438 18.2186C2.886 18.0776 2.5 17.5796 2.5 17.0076V5.3226C2.5 4.9346 2.676 4.5756 2.982 4.3356C3.288 4.0986 3.681 4.0156 4.058 4.1106Z",
    fill: "white"
  })));
};

const IconMoreActions = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#909091';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M9.11914 19.7264C9.11914 21.2629 10.4148 22.5586 11.9514 22.5586C13.5358 22.5586 14.7836 21.263 14.7836 19.7264C14.7836 18.142 13.488 16.8941 11.9514 16.8941C10.4148 16.8941 9.11914 18.1429 9.11914 19.7264Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.11914 4.26932C9.11914 5.85371 10.4148 7.10156 11.9514 7.10156C13.5358 7.10156 14.7836 5.80595 14.7836 4.26932C14.7836 2.73371 13.5358 1.43708 11.9514 1.43708C10.4148 1.43708 9.11914 2.7327 9.11914 4.26932Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.11914 11.8543C9.11914 13.4387 10.4148 14.6865 11.9514 14.6865C13.5358 14.6865 14.7836 13.3909 14.7836 11.8543C14.7836 10.2699 13.488 9.02209 11.9514 9.02209C10.4148 9.02303 9.11914 10.2708 9.11914 11.8543Z",
    fill: fill
  })));
};

const IconUploadBulk = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    opacity: "0.4",
    d: "M6.447 22C3.996 22 2 19.9698 2 17.4755V12.5144C2 10.0252 3.99 8 6.437 8L17.553 8C20.005 8 22 10.0302 22 12.5256V17.4846C22 19.9748 20.01 22 17.563 22H16.623H6.447Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.4548 2.22109L8.5458 5.06688C8.2458 5.361 8.2458 5.83433 8.5478 6.12748C8.8498 6.41965 9.3368 6.41868 9.6368 6.12553L11.2298 4.56629V6.06125V14.4516C11.2298 14.8655 11.5748 15.2015 11.9998 15.2015C12.4258 15.2015 12.7698 14.8655 12.7698 14.4516V4.56629L14.3628 6.12553C14.6628 6.41868 15.1498 6.41965 15.4518 6.12748C15.6028 5.98042 15.6788 5.78856 15.6788 5.59572C15.6788 5.40483 15.6028 5.21297 15.4538 5.06688L12.5458 2.22109C12.4008 2.07987 12.2048 2.00001 11.9998 2.00001C11.7958 2.00001 11.5998 2.07987 11.4548 2.22109Z",
    fill: fill
  }));
};

const IconMoreActionsCircle = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#D0D0D1';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    opacity: "0.7",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.83984 17.7946C9.83984 18.947 10.8116 19.9187 11.964 19.9187C13.1523 19.9187 14.0882 18.947 14.0882 17.7946C14.0882 16.6063 13.1165 15.6704 11.964 15.6704C10.8116 15.6704 9.83984 16.6069 9.83984 17.7946Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M9.83984 6.20182C9.83984 7.39011 10.8116 8.326 11.964 8.326C13.1523 8.326 14.0882 7.35429 14.0882 6.20182C14.0882 5.05011 13.1523 4.07764 11.964 4.07764C10.8116 4.07764 9.83984 5.04936 9.83984 6.20182Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M9.83984 11.8908C9.83984 13.0791 10.8116 14.0149 11.964 14.0149C13.1523 14.0149 14.0882 13.0432 14.0882 11.8908C14.0882 10.7025 13.1165 9.7666 11.964 9.7666C10.8116 9.7673 9.83984 10.7032 9.83984 11.8908Z",
    fill: "white"
  }));
};

const IconLamp = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3744 18.0397C17.2277 15.8726 18.6783 12.9628 18.6783 10.7794C18.6783 7.35441 15.6948 4.57787 12.0144 4.57787C8.33405 4.57787 5.35052 7.35441 5.35052 10.7794C5.35052 12.9829 6.86085 15.9262 8.74088 18.0994C8.41374 18.3836 8.20689 18.8027 8.20689 19.2701C8.20689 20.1264 8.90103 20.8205 9.75729 20.8205H14.431C15.2873 20.8205 15.9814 20.1264 15.9814 19.2701C15.9814 18.7688 15.7435 18.3231 15.3744 18.0397Z"
  })), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3744 18.0397C17.2277 15.8726 18.6783 12.9628 18.6783 10.7794C18.6783 7.35441 15.6948 4.57787 12.0144 4.57787C8.33405 4.57787 5.35052 7.35441 5.35052 10.7794C5.35052 12.9829 6.86085 15.9262 8.74088 18.0994C8.41374 18.3836 8.20689 18.8027 8.20689 19.2701C8.20689 20.1264 8.90103 20.8205 9.75729 20.8205H14.431C15.2873 20.8205 15.9814 20.1264 15.9814 19.2701C15.9814 18.7688 15.7435 18.3231 15.3744 18.0397Z",
    fill: "#FFD338"
  }), React.createElement("path", {
    d: "M15.3744 18.0397L14.6144 17.3897L13.9293 18.1909L14.7654 18.8328L15.3744 18.0397ZM8.74088 18.0994L9.39677 18.8542L10.15 18.1997L9.49715 17.4451L8.74088 18.0994ZM17.6783 10.7794C17.6783 11.6707 17.3757 12.7937 16.8154 13.9921C16.2609 15.1782 15.4849 16.3718 14.6144 17.3897L16.1344 18.6896C17.1171 17.5405 17.9931 16.1956 18.6272 14.8391C19.2556 13.495 19.6783 12.0715 19.6783 10.7794H17.6783ZM12.0144 5.57787C15.2114 5.57787 17.6783 7.97319 17.6783 10.7794H19.6783C19.6783 6.73563 16.1781 3.57787 12.0144 3.57787V5.57787ZM6.35052 10.7794C6.35052 7.97319 8.8174 5.57787 12.0144 5.57787V3.57787C7.8507 3.57787 4.35052 6.73563 4.35052 10.7794H6.35052ZM9.49715 17.4451C8.61259 16.4226 7.81523 15.2181 7.24309 14.0199C6.66462 12.8084 6.35052 11.6751 6.35052 10.7794H4.35052C4.35052 12.0872 4.7916 13.5273 5.43829 14.8817C6.09132 16.2493 6.98914 17.603 7.98462 18.7536L9.49715 17.4451ZM9.20689 19.2701C9.20689 19.1044 9.27891 18.9566 9.39677 18.8542L8.08499 17.3445C7.54857 17.8106 7.20689 18.501 7.20689 19.2701H9.20689ZM9.75729 19.8205C9.45331 19.8205 9.20689 19.5741 9.20689 19.2701H7.20689C7.20689 20.6787 8.34875 21.8205 9.75729 21.8205V19.8205ZM14.431 19.8205H9.75729V21.8205H14.431V19.8205ZM14.9814 19.2701C14.9814 19.5741 14.735 19.8205 14.431 19.8205V21.8205C15.8396 21.8205 16.9814 20.6787 16.9814 19.2701H14.9814ZM14.7654 18.8328C14.8986 18.9351 14.9814 19.0928 14.9814 19.2701H16.9814C16.9814 18.4449 16.5884 17.711 15.9834 17.2465L14.7654 18.8328Z",
    fill: "#200E32",
    mask: "url(#path-1-inside-1)"
  }), React.createElement("rect", {
    x: "8.86254",
    y: "21.4618",
    width: "6.92695",
    height: "0.461534",
    rx: "0.230767",
    fill: "#200E32",
    stroke: "#200E32",
    strokeWidth: "0.461534"
  }), React.createElement("rect", {
    x: "9.78619",
    y: "22.3845",
    width: "5.07983",
    height: "0.461534",
    rx: "0.230767",
    fill: "#200E32",
    stroke: "#200E32",
    strokeWidth: "0.461534"
  }), React.createElement("rect", {
    x: "10.7098",
    y: "23.3077",
    width: "3.23271",
    height: "0.461534",
    rx: "0.230767",
    fill: "#200E32",
    stroke: "#200E32",
    strokeWidth: "0.461534"
  }), React.createElement("rect", {
    width: "3.47531",
    height: "0.423255",
    rx: "0.211627",
    transform: "matrix(0.849172 -0.528117 0.582878 0.81256 1.35083 16.767)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.93831",
    height: "0.413826",
    rx: "0.206913",
    transform: "matrix(0.995649 -0.0931876 0.107331 0.994224 1.22467 12.5293)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.88363",
    height: "0.422517",
    rx: "0.211259",
    transform: "matrix(0.862246 0.50649 -0.56132 0.827599 2.91821 5.90642)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.75788",
    height: "0.441035",
    rx: "0.220518",
    transform: "matrix(0.342502 0.939518 -0.953601 0.301074 8.7998 1.77188)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.7527",
    height: "0.441773",
    rx: "0.220886",
    transform: "matrix(-0.299062 0.954234 -0.965082 -0.261951 15.9799 1.83092)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.87889",
    height: "0.423255",
    rx: "0.211627",
    transform: "matrix(-0.849298 0.527914 -0.583083 -0.812413 21.5644 6.52057)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "2.93517",
    height: "0.414333",
    rx: "0.207166",
    transform: "matrix(-0.988685 -0.150012 0.172565 -0.984998 22.6918 13.4246)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.54561",
    height: "0.414016",
    rx: "0.207008",
    transform: "matrix(0.993038 0.117793 -0.135554 0.99077 0.0560913 9.00732)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.41879",
    height: "0.430408",
    rx: "0.215204",
    transform: "matrix(0.704602 0.709603 -0.758201 0.652022 4.38171 2.33221)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.30317",
    height: "0.444094",
    rx: "0.222047",
    transform: "matrix(0.00487612 -0.999988 0.999991 0.00422303 11.6971 3.30313)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.40735",
    height: "0.431583",
    rx: "0.215791",
    transform: "matrix(0.673038 -0.739608 0.785403 0.618985 17.2505 4.88342)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.54392",
    height: "0.414243",
    rx: "0.207122",
    transform: "matrix(0.98992 -0.141628 0.162988 0.986628 20.424 9.50928)",
    fill: "#200E32"
  }), React.createElement("rect", {
    width: "3.48481",
    height: "0.422028",
    rx: "0.211014",
    transform: "matrix(0.870667 0.491874 -0.546346 0.837559 19.7253 15.0613)",
    fill: "#200E32"
  }), React.createElement("path", {
    d: "M11.9994 7.65106C11.9994 7.65106 13.5073 7.41877 14.7638 8.58018C16.1517 9.86299 15.7691 10.903 15.7691 10.903",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconExit = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props, {
    fill: "none"
  }), React.createElement("path", {
    d: "M15 4H5V18C5 19.1046 5.89543 20 7 20H15",
    stroke: props.fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M17 15L20 12M20 12L17 9M20 12H10",
    stroke: props.fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const IconHome = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 1.29289C12.3166 0.902369 11.6834 0.902369 11.2929 1.29289L3.29325 9.29254L3.29254 9.29325L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071C1.68342 13.0976 2.31658 13.0976 2.70711 12.7071L3 12.4142V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V12.4142L21.2929 12.7071C21.6834 13.0976 22.3166 13.0976 22.7071 12.7071C23.0976 12.3166 23.0976 11.6834 22.7071 11.2929L12.7071 1.29289Z",
    fill: "#200E32"
  }));
};

const IconApps = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M15.984 20.016v-4.031h4.031v4.031h-4.031zM15.984 14.016v-4.031h4.031v4.031h-4.031zM9.984 8.016v-4.031h4.031v4.031h-4.031zM15.984 3.984h4.031v4.031h-4.031v-4.031zM9.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 20.016v-4.031h4.031v4.031h-4.031zM9.984 20.016v-4.031h4.031v4.031h-4.031zM3.984 8.016v-4.031h4.031v4.031h-4.031z",
    fill: fill || '#262626'
  }));
};

const IconCalendarV2 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2C16.5523 2 17 2.44772 17 3H20C20.5523 3 21 3.44772 21 4V8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8V4C3 3.44772 3.44772 3 4 3H7C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3H15C15 2.44772 15.4477 2 16 2ZM7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5H15C15 5.55228 15.4477 6 16 6C16.5523 6 17 5.55228 17 5H19V7H5V5H7Z",
    fill: "#200E32"
  }));
};

const IconHome$1 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3ZM3 17C3 14.7909 4.79086 13 7 13C9.20914 13 11 14.7909 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V14ZM3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V9C11 10.1046 10.1046 11 9 11H5C3.89543 11 3 10.1046 3 9V4Z",
    fill: "#200E32"
  }));
};

const IconComment = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00002 12C2.00002 6.47715 6.47717 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C10.4773 22 9.03181 21.659 7.73782 21.0485L3.20105 21.9796C2.87178 22.0472 2.53059 21.9448 2.29291 21.7071C2.05523 21.4694 1.95286 21.1282 2.02043 20.799L2.95147 16.2622C2.34101 14.9682 2.00002 13.5227 2.00002 12ZM9 12C9 12.8284 8.32843 13.5 7.5 13.5C6.67157 13.5 6 12.8284 6 12C6 11.1716 6.67157 10.5 7.5 10.5C8.32843 10.5 9 11.1716 9 12ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM16.5 13.5C17.3284 13.5 18 12.8284 18 12C18 11.1716 17.3284 10.5 16.5 10.5C15.6716 10.5 15 11.1716 15 12C15 12.8284 15.6716 13.5 16.5 13.5Z",
    fill: "#200E32"
  }));
};

const IconFileDocument = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.44772 2 4 2.44772 4 3V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V8C20 7.73478 19.8946 7.48043 19.7071 7.29289L14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2H5ZM14 4.41421L17.5858 8H14V4.41421ZM8 13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z",
    fill: "#200E32"
  }));
};

const IconRectangles = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("rect", {
    x: "4",
    y: "5",
    width: "6",
    height: "6",
    rx: "1",
    fill: fill || '#200E32'
  }), React.createElement("rect", {
    x: "4",
    y: "14",
    width: "6",
    height: "6",
    rx: "1",
    fill: fill || '#200E32'
  }), React.createElement("rect", {
    x: "14",
    y: "5",
    width: "6",
    height: "6",
    rx: "1",
    fill: fill || '#200E32'
  }), React.createElement("rect", {
    x: "14",
    y: "14",
    width: "6",
    height: "6",
    rx: "1",
    fill: fill || '#200E32'
  }));
};

const IconInvoice = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.3905 19.7727 21.7453 19.4179 21.9085C19.0631 22.0717 18.6457 22.0134 18.3492 21.7593L17.3175 20.8749C16.943 20.5539 16.3904 20.5539 16.0159 20.8749L14.9841 21.7593C14.6096 22.0802 14.057 22.0802 13.6825 21.7593L12.6508 20.8749C12.2763 20.5539 11.7237 20.5539 11.3492 20.8749L10.3175 21.7593C9.94297 22.0802 9.39036 22.0802 9.01588 21.7593L7.98412 20.8749C7.60963 20.5539 7.05703 20.5539 6.68254 20.8749L5.65079 21.7593C5.35428 22.0134 4.93694 22.0717 4.58214 21.9085C4.22734 21.7453 4 21.3905 4 21V3ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9ZM9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H9ZM10 15C10 14.4477 10.4477 14 11 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H11C10.4477 16 10 15.5523 10 15Z",
    fill: "#200E32"
  }));
};

const IconLogout = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89535 11.23C9.45785 11.23 9.11192 11.57 9.11192 12C9.11192 12.42 9.45785 12.77 9.89535 12.77H16V17.55C16 20 13.9753 22 11.4724 22H6.51744C4.02471 22 2 20.01 2 17.56V6.45C2 3.99 4.03488 2 6.52762 2H11.4927C13.9753 2 16 3.99 16 6.44V11.23H9.89535ZM19.6302 8.5402L22.5502 11.4502C22.7002 11.6002 22.7802 11.7902 22.7802 12.0002C22.7802 12.2002 22.7002 12.4002 22.5502 12.5402L19.6302 15.4502C19.4802 15.6002 19.2802 15.6802 19.0902 15.6802C18.8902 15.6802 18.6902 15.6002 18.5402 15.4502C18.2402 15.1502 18.2402 14.6602 18.5402 14.3602L20.1402 12.7702H16.0002V11.2302H20.1402L18.5402 9.6402C18.2402 9.3402 18.2402 8.8502 18.5402 8.5502C18.8402 8.2402 19.3302 8.2402 19.6302 8.5402Z",
    fill: fill || '#200E32'
  }));
};

const IconLogoutV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M9 20h-4c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-14c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.552 0 1-0.448 1-1s-0.448-1-1-1h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v14c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h4c0.552 0 1-0.448 1-1s-0.448-1-1-1zM18.586 11h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5-5c0.092-0.092 0.166-0.202 0.217-0.324 0.15-0.362 0.078-0.795-0.217-1.090l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z",
    fill: fill || '#200E32'
  }));
};

const IconNewsV2 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4V7H21C21.5523 7 22 7.44772 22 8V18C22 19.6569 20.6569 21 19 21H17H5C3.34315 21 2 19.6569 2 18V4C2 3.44772 2.44772 3 3 3H17C17.5523 3 18 3.44772 18 4ZM20 18C20 18.5523 19.5523 19 19 19C18.4477 19 18 18.5523 18 18V9H20V18ZM6 8C6 7.44772 6.44772 7 7 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H7C6.44772 9 6 8.55228 6 8ZM8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12Z",
    fill: "#200E32"
  }));
};

const IconProfile = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7ZM8 13C5.23858 13 3 15.2386 3 18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18C21 15.2386 18.7614 13 16 13H8Z",
    fill: "#200E32"
  }));
};

const IconSettingsV2 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99959 3.22214C8.99959 2.75558 9.32223 2.35101 9.7771 2.24721C11.2593 1.90896 12.7789 1.9203 14.2221 2.24961C14.677 2.3534 14.9997 2.75797 14.9997 3.22455L14.9997 5.07129C14.9997 5.84109 15.833 6.32221 16.4997 5.93731L18.1007 5.01296C18.5052 4.77944 19.0174 4.85698 19.3346 5.19973C19.8329 5.73808 20.2787 6.33932 20.6599 6.99955C21.0411 7.65976 21.3388 8.34647 21.5559 9.04712C21.6942 9.49322 21.5052 9.9756 21.1007 10.2091L19.4997 11.1335C18.833 11.5184 18.833 12.4806 19.4997 12.8655L21.099 13.7889C21.5031 14.0222 21.6921 14.5039 21.5546 14.9498C21.1181 16.3643 20.3682 17.686 19.3342 18.8005C19.0168 19.1425 18.5051 19.2197 18.1011 18.9864L16.4997 18.0618C15.833 17.6769 14.9997 18.158 14.9997 18.9278L14.9997 20.777C14.9997 21.2435 14.677 21.6481 14.2222 21.7519C12.74 22.0901 11.2204 22.0788 9.77714 21.7495C9.32225 21.6457 8.99959 21.2411 8.99959 20.7745L8.99959 18.9278C8.99959 18.158 8.16626 17.6768 7.49959 18.0617L5.89854 18.9861C5.49408 19.2196 4.98185 19.1421 4.66462 18.7993C4.16639 18.261 3.72056 17.6598 3.33939 16.9995C2.95821 16.3393 2.66044 15.6526 2.44335 14.9519C2.30512 14.5058 2.49409 14.0234 2.89855 13.7899L4.49956 12.8656C5.16623 12.4807 5.16623 11.5184 4.49956 11.1335L2.90026 10.2102C2.49619 9.97688 2.30715 9.49517 2.4447 9.04932C2.88114 7.63477 3.63109 6.31312 4.66513 5.19861C4.98246 4.85658 5.49415 4.77945 5.89821 5.01273L7.49959 5.93729C8.16626 6.32219 8.99959 5.84106 8.99959 5.07127L8.99959 3.22214ZM11.9998 13.9995C13.1043 13.9995 13.9998 13.1041 13.9998 11.9995C13.9998 10.8949 13.1043 9.99951 11.9998 9.99951C10.8952 9.99951 9.99976 10.8949 9.99976 11.9995C9.99976 13.1041 10.8952 13.9995 11.9998 13.9995Z",
    fill: "#200E32"
  }));
};

const IconTrendingUp = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7922 6H16.1297C15.7406 6 15.4219 6.30938 15.4219 6.69375C15.4219 7.07812 15.7406 7.3875 16.1297 7.3875H20.0531L13.5844 14.0531L9.55781 10.1109C9.42188 9.97969 9.24844 9.90937 9.05625 9.90937C8.86875 9.90937 8.69063 9.97969 8.55469 10.1109L1.69688 16.8188C1.60781 16.9078 1.5 17.0625 1.5 17.3203C1.5 17.5125 1.56563 17.6719 1.69688 17.7984C1.83281 17.9297 2.00625 18 2.19844 18C2.38594 18 2.56406 17.9297 2.7 17.7984L9.05625 11.5781L13.0828 15.5203C13.2188 15.6516 13.3922 15.7219 13.5844 15.7219C13.7719 15.7219 13.95 15.6516 14.0859 15.5203L21.0891 8.4V12.2297C21.0891 12.6094 21.4078 12.9234 21.7969 12.9234C22.1859 12.9234 22.5047 12.6141 22.5047 12.2297V6.69375C22.5 6.30938 22.1812 6 21.7922 6Z"
  }));
};

const IconVideoCamera = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11304 4.5H11.9051C14.3271 4.5 16.0181 6.16904 16.0181 8.56091V15.4391C16.0181 17.831 14.3271 19.5 11.9051 19.5H6.11304C3.69102 19.5 2 17.831 2 15.4391V8.56091C2 6.16904 3.69102 4.5 6.11304 4.5ZM19.958 6.87898C20.397 6.65563 20.912 6.67898 21.331 6.94294C21.75 7.20589 22 7.66274 22 8.16223V15.8384C22 16.3389 21.75 16.7947 21.331 17.0577C21.102 17.2008 20.846 17.2739 20.588 17.2739C20.373 17.2739 20.158 17.2231 19.957 17.1206L18.476 16.3734C17.928 16.0952 17.588 15.5369 17.588 14.9165V9.08305C17.588 8.46173 17.928 7.90335 18.476 7.62721L19.958 6.87898Z",
    fill: fill
  }));
};

const IconBadge = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2352 1.99754C13.0428 0.665531 10.9573 0.665532 9.76484 1.99755L9.63046 2.14765C9.42788 2.37394 9.13345 2.4959 8.8302 2.47913L8.62903 2.46801C6.84397 2.36932 5.36932 3.84397 5.46801 5.62903L5.47913 5.8302C5.4959 6.13345 5.37394 6.42788 5.14765 6.63046L4.99754 6.76484C3.66553 7.95729 3.66553 10.0428 4.99755 11.2352L5.14765 11.3696C5.37394 11.5722 5.4959 11.8666 5.47913 12.1698L5.46801 12.371C5.38121 13.9412 6.51171 15.2711 8.00002 15.5015V22C8.00002 22.3688 8.203 22.7077 8.52816 22.8817C8.85332 23.0557 9.24786 23.0366 9.55472 22.8321L12 21.2019L14.4453 22.8321C14.7522 23.0366 15.1467 23.0557 15.4719 22.8817C15.797 22.7077 16 22.3688 16 22V15.5015C17.4883 15.2711 18.6188 13.9412 18.532 12.371L18.5209 12.1698C18.5041 11.8666 18.6261 11.5722 18.8524 11.3696L19.0025 11.2352C20.3345 10.0428 20.3345 7.95729 19.0025 6.76484L18.8524 6.63046C18.6261 6.42788 18.5041 6.13345 18.5209 5.8302L18.532 5.62903C18.6307 3.84397 17.1561 2.36932 15.371 2.46801L15.1698 2.47913C14.8666 2.4959 14.5722 2.37394 14.3696 2.14765L14.2352 1.99754ZM14 16.238C12.8656 17.256 11.1345 17.256 10 16.238V20.1315L11.4453 19.168C11.7812 18.944 12.2188 18.944 12.5547 19.168L14 20.1315V16.238ZM14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L11 9.58579L10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071L14.7071 8.70711Z",
    fill: fill
  }));
};

const IconPlayOutlined = props => React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C17.5228 2 22 6.47716 22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2Z",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0501 12.4669C14.3211 13.2529 12.3371 14.5829 11.3221 15.0099C11.1601 15.0779 10.7471 15.2219 10.6581 15.2239C10.4691 15.2299 10.2871 15.1239 10.1991 14.9539C10.1651 14.8879 10.0651 14.4569 10.0331 14.2649C9.93809 13.6809 9.88909 12.7739 9.89009 11.8619C9.88909 10.9049 9.94209 9.9549 10.0481 9.3769C10.0761 9.2209 10.1581 8.8619 10.1821 8.8039C10.2271 8.6959 10.3091 8.6109 10.4081 8.5579C10.4841 8.5169 10.5711 8.4949 10.6581 8.4979C10.7471 8.4999 11.1091 8.6269 11.2331 8.6759C12.2111 9.0559 14.2801 10.4339 15.0401 11.2439C15.1081 11.3169 15.2951 11.5129 15.3261 11.5529C15.3971 11.6429 15.4321 11.7519 15.4321 11.8619C15.4321 11.9639 15.4011 12.0679 15.3371 12.1549C15.3041 12.1999 15.1131 12.3999 15.0501 12.4669Z",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const IconCloseCircle = props => React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.25C4.61406 0.25 0.25 4.61406 0.25 10C0.25 15.3859 4.61406 19.75 10 19.75C15.3859 19.75 19.75 15.3859 19.75 10C19.75 4.61406 15.3859 0.25 10 0.25ZM12.4703 13.5297L10 11.0594L7.52969 13.5297C7.23906 13.8203 6.76094 13.8203 6.47031 13.5297C6.325 13.3844 6.25 13.1922 6.25 13C6.25 12.8078 6.325 12.6156 6.47031 12.4703L8.94063 10L6.47031 7.52969C6.325 7.38438 6.25 7.19219 6.25 7C6.25 6.80781 6.325 6.61562 6.47031 6.47031C6.76094 6.17969 7.23906 6.17969 7.52969 6.47031L10 8.94063L12.4703 6.47031C12.7609 6.17969 13.2391 6.17969 13.5297 6.47031C13.8203 6.76094 13.8203 7.23906 13.5297 7.52969L11.0594 10L13.5297 12.4703C13.8203 12.7609 13.8203 13.2391 13.5297 13.5297C13.2391 13.825 12.7609 13.825 12.4703 13.5297Z"
}));

const IconClone = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M19.9999 9.7795H21.4025L18.8311 7.20801V8.61068C18.8311 9.25512 19.3554 9.7795 19.9999 9.7795Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.8182 5.80587H13.2209L10.6494 3.23438V4.63705C10.6494 5.28148 11.1738 5.80587 11.8182 5.80587Z",
    fill: fill
  }), React.createElement("path", {
    d: "M19.9996 10.9486C18.7139 10.9486 17.662 9.89667 17.662 8.61092V6.97461H14.623V14.6888C14.623 16.6222 13.0499 18.1953 11.1165 18.1953H10.1816V18.6628C10.1816 19.9485 11.2335 21.0004 12.5192 21.0004H19.2984C20.5841 21.0004 21.636 19.9485 21.636 18.6628V10.9486H19.9996Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.8181 6.97412C10.5324 6.97412 9.48046 5.92222 9.48046 4.63647V3.00016L2 3V14.6882C2 15.974 3.0519 17.0259 4.33764 17.0259H11.1168C12.4026 17.0259 13.4545 15.974 13.4545 14.6882V6.974L11.8181 6.97412ZM8.07779 13.4026H4.57133V12.2338H8.07779V13.4026ZM10.8831 10.8311H4.57145V9.66233H10.8831V10.8311Z",
    fill: fill
  }));
};

const IconBack = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return (//dummy comment
    React.createElement(Icon, Object.assign({}, props), React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#F2F2F3"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5437 11H9.85625L12.45 8.51876C12.8219 8.12814 12.8219 7.49689 12.45 7.10626C12.0781 6.71564 11.475 6.71564 11.1 7.10626L6.78125 11.2938C6.59375 11.475 6.5 11.7219 6.5 11.9938V12.0063C6.5 12.2781 6.59375 12.525 6.78125 12.7063L11.0969 16.8938C11.4719 17.2844 12.075 17.2844 12.4469 16.8938C12.8187 16.5031 12.8187 15.8719 12.4469 15.4813L9.85312 13H16.5406C17.0687 13 17.4969 12.5531 17.4969 12C17.5 11.4375 17.0719 11 16.5437 11V11Z",
      fill: fill
    }))
  );
};

const IconRefresh = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#F2F2F3"
  }), React.createElement("path", {
    d: "M17.5333 12.9533C17.3654 12.901 17.1835 12.9171 17.0274 12.9983C16.8713 13.0795 16.7536 13.2191 16.7 13.3866C16.385 14.3496 15.771 15.187 14.9473 15.7769C14.1236 16.3668 13.1331 16.6785 12.12 16.6666C10.8669 16.6809 9.65929 16.1976 8.76198 15.3228C7.86467 14.448 7.3509 13.253 7.33333 12C7.3509 10.7469 7.86467 9.55197 8.76198 8.67715C9.65929 7.80234 10.8669 7.31907 12.12 7.33331C13.2517 7.33058 14.3486 7.72452 15.22 8.44664L13.7733 8.20664C13.6866 8.19238 13.598 8.19539 13.5124 8.21551C13.4269 8.23563 13.3462 8.27247 13.2749 8.32389C13.2037 8.37531 13.1433 8.44031 13.0973 8.51515C13.0512 8.58999 13.0204 8.6732 13.0067 8.75998C12.9924 8.84668 12.9954 8.93535 13.0155 9.02088C13.0357 9.10641 13.0725 9.18712 13.1239 9.25837C13.1753 9.32962 13.2403 9.39 13.3152 9.43604C13.39 9.48208 13.4732 9.51287 13.56 9.52664L16.3867 9.99331H16.5C16.5773 9.99322 16.654 9.97968 16.7267 9.95331C16.7511 9.94404 16.7737 9.9305 16.7933 9.91331C16.8411 9.89554 16.8861 9.87083 16.9267 9.83998L16.9867 9.76664C16.9867 9.73331 17.0467 9.70664 17.0733 9.66664C17.1 9.62664 17.0733 9.59998 17.1067 9.57331C17.1251 9.53448 17.1407 9.49438 17.1533 9.45331L17.6533 6.78664C17.67 6.6991 17.6692 6.60913 17.6511 6.52188C17.6329 6.43463 17.5978 6.35181 17.5476 6.27814C17.4975 6.20447 17.4333 6.1414 17.3588 6.09253C17.2843 6.04366 17.2009 6.00995 17.1133 5.99331C17.0258 5.97668 16.9358 5.97745 16.8486 5.99558C16.7613 6.01372 16.6785 6.04886 16.6048 6.09901C16.4561 6.20028 16.3536 6.3565 16.32 6.53331L16.14 7.49998C15.024 6.5328 13.5968 6.00026 12.12 5.99998C10.5133 5.98576 8.96656 6.60951 7.8192 7.73436C6.67185 8.85922 6.01759 10.3933 6 12C6.01759 13.6067 6.67185 15.1407 7.8192 16.2656C8.96656 17.3904 10.5133 18.0142 12.12 18C13.4221 18.02 14.6962 17.6214 15.7548 16.8629C16.8133 16.1044 17.6003 15.026 18 13.7866C18.0253 13.7013 18.0332 13.6117 18.0233 13.5233C18.0135 13.4348 17.986 13.3492 17.9425 13.2715C17.899 13.1939 17.8404 13.1257 17.7701 13.071C17.6998 13.0164 17.6193 12.9763 17.5333 12.9533Z",
    fill: "#262626"
  }));
};

const IconGlobe = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.028 2.002C17.529 2.018 22 6.496 22 12C22 17.504 17.529 21.983 12.028 21.998C12.026 21.998 12.023 22 12.02 22C12.019 22 12.0183 21.9998 12.0175 21.9995C12.0168 21.9993 12.016 21.999 12.015 21.999C12.0132 21.999 12.0112 21.9992 12.009 21.9994C12.0063 21.9997 12.0033 22 12 22C6.486 22 2 17.514 2 12C2 6.487 6.486 2 12 2C12.0026 2 12.0056 2.00028 12.0083 2.00054C12.0108 2.00078 12.0131 2.001 12.015 2.001C12.0176 2.001 12.02 2.00128 12.0222 2.00154C12.0242 2.00178 12.0261 2.002 12.028 2.002ZM9.079 11C9.385 7.728 11.059 5.45 12.026 4.397C13.026 5.468 14.674 7.725 14.959 11H9.079ZM7.065 11C7.285 8.137 8.386 5.927 9.438 4.429C6.586 5.397 4.455 7.928 4.069 11H7.065ZM4.069 13H7.061C7.267 15.862 8.344 18.056 9.407 19.561C6.57 18.584 4.454 16.061 4.069 13ZM14.617 19.552C15.666 18.054 16.757 15.851 16.975 13H19.93C19.547 16.052 17.441 18.57 14.617 19.552ZM14.962 13H9.08C9.359 16.272 10.965 18.498 12.012 19.608C12.978 18.555 14.656 16.277 14.962 13ZM19.93 11H16.978C16.773 8.151 15.708 5.964 14.65 4.461C17.458 5.451 19.549 7.96 19.93 11Z",
    fill: fill
  }));
};

const IconPerson = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20Z",
    fill: fill
  }));
};

const IconCloneV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M11 8c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v9c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h9c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-9c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879zM11 10h9c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v9c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-9c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-9c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293zM5 14h-1c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-9c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h9c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-9c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v9c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h1c0.552 0 1-0.448 1-1s-0.448-1-1-1z",
    fill: fill
  }));
};

const IconForward = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#909091';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M0.144241 5.30839C0.182236 5.36762 0.234233 5.41746 0.29604 5.45387L6.22563 9.71956C6.3282 9.7864 6.45442 9.81102 6.57607 9.78803C6.69772 9.76495 6.80467 9.69623 6.87298 9.59708C6.91954 9.52828 6.9471 9.44913 6.95289 9.36733V7.12344C6.95289 7.12344 10.9566 6.06656 15.184 10.8454C15.2644 10.935 15.3787 10.9902 15.5017 10.9988C15.6247 11.0074 15.7462 10.9687 15.8393 10.8913C15.9491 10.7991 16.0081 10.6633 15.9991 10.5237C15.7993 8.22616 13.4339 2.67386 6.96885 2.67386V0.42231C6.96065 0.302391 6.90294 0.190503 6.80849 0.111447C6.71395 0.0323844 6.59051 -0.00727484 6.46539 0.0011012C6.38003 0.006657 6.29753 0.0330671 6.22565 0.0776846L0.296053 4.34338C0.140418 4.45065 0.036516 4.61357 0.00797542 4.79518C-0.0206542 4.9769 0.0284717 5.1619 0.144241 5.30839Z",
    fill: fill
  })));
};

const IconEmoji = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#262626';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.25C4.61406 0.25 0.25 4.61406 0.25 10C0.25 15.3859 4.61406 19.75 10 19.75C15.3859 19.75 19.75 15.3859 19.75 10C19.75 4.61406 15.3859 0.25 10 0.25ZM13.375 7.375C13.9984 7.375 14.5 7.87656 14.5 8.5C14.5 9.12344 13.9984 9.625 13.375 9.625C12.7516 9.625 12.25 9.12344 12.25 8.5C12.25 7.87656 12.7516 7.375 13.375 7.375ZM6.625 7.375C7.24844 7.375 7.75 7.87656 7.75 8.5C7.75 9.12344 7.24844 9.625 6.625 9.625C6.00156 9.625 5.5 9.12344 5.5 8.5C5.5 7.87656 6.00156 7.375 6.625 7.375ZM10 15.2969C7.90469 15.2969 6.14219 13.8953 5.58437 11.9828C5.51406 11.7437 5.69219 11.5 5.94531 11.5H14.05C14.2984 11.5 14.4812 11.7391 14.4109 11.9828C13.8578 13.8953 12.0953 15.2969 10 15.2969Z",
    fill: fill
  }));
};

const IconPieChartV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3264 2.20966C12.4861 2.06632 12.6973 1.99119 12.9135 2.00082C17.4843 2.13765 21.3044 5.4558 21.9967 9.89063C22.0011 9.91711 22.0011 9.94411 21.9967 9.97059C22.0116 10.1804 21.9407 10.3874 21.7996 10.5458C21.6586 10.7043 21.459 10.801 21.2451 10.8147L13.5656 11.3211C13.3116 11.3436 13.0597 11.26 12.8718 11.0909C12.6839 10.9218 12.5774 10.6828 12.5785 10.4326L12.0623 2.88932V2.76493C12.0717 2.55278 12.1667 2.353 12.3264 2.20966ZM11.7997 13.2936L18.4558 12.8671L18.5011 12.8848C18.7869 12.8895 19.0591 13.0054 19.2579 13.207C19.4566 13.4087 19.5655 13.6795 19.5606 13.9599C19.2984 17.782 16.4962 20.9755 12.6828 21.7982C8.86938 22.621 4.96017 20.8754 3.08778 17.5139C2.53722 16.5457 2.1893 15.4794 2.06445 14.3775C2.01603 14.051 1.99483 13.7212 2.00106 13.3913C2.01368 9.32706 4.90728 5.81907 8.95607 4.9595C9.4462 4.86776 9.93762 5.11248 10.1515 5.55479C10.2047 5.63505 10.2473 5.72164 10.2782 5.81245C10.3541 6.98405 10.4329 8.14455 10.5113 9.30015C10.5732 10.2128 10.6349 11.1223 10.6948 12.0319C10.6917 12.2462 10.7254 12.4594 10.7944 12.6627C10.9569 13.0627 11.3614 13.3165 11.7997 13.2936Z",
    fill: fill
  }));
};

const IconMaterialV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C6.34315 2 5 3.34315 5 5V21C5 21.3466 5.17945 21.6684 5.47427 21.8507C5.76909 22.0329 6.13723 22.0494 6.44721 21.8944L12 19.118L17.5528 21.8944C17.8628 22.0494 18.2309 22.0329 18.5257 21.8507C18.8205 21.6684 19 21.3466 19 21V5C19 3.34315 17.6569 2 16 2H8Z",
    fill: fill
  }));
};

const IconAppsV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M4 4H6V6H4V4Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M4 18H6V20H4V18Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M18 4H20V6H18V4Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M18 11H20V13H18V11Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M11 11H13V13H11V11Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M4 11H6V13H4V11Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M11 4H13V6H11V4Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M11 18H13V20H11V18Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }), React.createElement("path", {
    d: "M18 18H20V20H18V18Z",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: fill
  }));
};

const IconClasses = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1199 18.1374H4.01632C2.9079 18.1374 2 17.2302 2 16.1212V4.99304C2 2.90753 2.68422 2 5.01428 2H16.7609V3.13887C15.7802 3.8013 15.8006 4.71984 16.3843 5.41674H15.2393C14.7993 4.63113 14.8749 3.73827 15.5674 3.02153C11.6542 3.02153 8.476 3.0263 4.56288 3.0263C2.7069 3.0263 2.75062 5.90095 4.59633 5.90095H7.26515C6.51388 6.32517 6.12012 7.18616 6.12012 8.40944L6.1199 18.1374ZM21.3687 21.9995V9.63813C20.4498 8.92881 20.2079 7.7855 21.3687 7.00134V5.86247H9.62254C7.29243 5.86247 6.60826 6.77 6.60826 8.8555V19.9837C6.60826 21.0926 7.51597 22 8.62458 22H21.3688L21.3687 21.9995ZM20.1973 9.76363C19.4029 8.88174 19.3354 7.75315 20.1754 6.88417C16.2622 6.88417 13.084 6.88895 9.17087 6.88895C7.31507 6.88895 7.35861 9.7636 9.20431 9.7636H20.1975L20.1973 9.76363Z",
    fill: fill
  }));
};

const IconOnlinePayment = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M18.5319 7.44699H16.2546V6.30566C16.2531 5.55216 15.9532 4.8299 15.4203 4.29713C14.8875 3.76436 14.1654 3.46436 13.4119 3.46289H6.58531C5.83089 3.46289 5.10729 3.76222 4.57329 4.29524C4.03946 4.82815 3.73878 5.55123 3.7373 6.30566V17.6868C3.73878 18.4412 4.03945 19.1643 4.57329 19.6972C5.10726 20.2302 5.83089 20.5296 6.58531 20.5296H13.4119C14.1654 20.5281 14.8875 20.2281 15.4203 19.6953C15.9532 19.1626 16.2531 18.4403 16.2546 17.6868V16.5455H18.5319C18.9845 16.5455 19.4186 16.3657 19.7387 16.0456C20.0586 15.7256 20.2385 15.2915 20.2385 14.8388V9.15356C20.2385 8.70089 20.0586 8.26683 19.7387 7.94674C19.4186 7.62665 18.9845 7.44692 18.5319 7.44692V7.44699ZM19.1026 9.15363V9.72432H12.2705V8.58298H18.5317C18.6821 8.58432 18.8259 8.64512 18.9317 8.752C19.0377 8.85887 19.097 9.00325 19.097 9.15366L19.1026 9.15363ZM15.1186 17.687V17.6869C15.1186 18.1395 14.9387 18.5736 14.6186 18.8937C14.2985 19.2138 13.8645 19.3935 13.4119 19.3935H6.58531C6.13264 19.3935 5.69858 19.2138 5.37849 18.8937C5.05854 18.5736 4.87867 18.1395 4.87867 17.6869V6.30573C4.87867 5.85305 5.05854 5.419 5.37849 5.0989C5.69858 4.77882 6.13264 4.59909 6.58531 4.59909H13.4119C13.8645 4.59909 14.2985 4.77882 14.6186 5.0989C14.9387 5.41899 15.1186 5.85305 15.1186 6.30573V7.44706H12.2706V6.87638H11.1345V17.1161H12.2705L12.2706 16.5455H15.1132L15.1186 17.687ZM18.5319 15.4097L12.2706 15.4095V10.8602H19.0972V14.8442C19.0959 14.9936 19.0359 15.1367 18.9301 15.2423C18.8244 15.3481 18.6814 15.4081 18.5319 15.4095L18.5319 15.4097Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M7.15602 6.30554C7.15602 6.62067 6.90048 6.87622 6.58533 6.87622C6.27018 6.87622 6.01465 6.62069 6.01465 6.30554C6.01465 5.99028 6.27018 5.73486 6.58533 5.73486C6.90048 5.73486 7.15602 5.99026 7.15602 6.30554Z",
    fill: fill
  }));
};

const IconBlog = _a => {
  var props = __rest(_a, []);

  const fill = props.fill || '#262626';
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M4.13381 14.7442C3.95699 14.6306 3.7928 14.5336 3.63479 14.4242C2.7761 13.8616 2.06546 13.1004 1.56317 12.2052C1.28032 11.6963 1.09999 11.1369 1.03258 10.5587C0.896442 9.41999 1.19001 8.27124 1.85575 7.3375C2.35728 6.61893 2.99728 6.00754 3.73803 5.53951C4.5036 5.04869 5.33718 4.67273 6.21189 4.42365C6.6156 4.30367 7.02713 4.21159 7.44346 4.14785C7.77405 4.09939 8.1067 4.0637 8.44138 4.03418C8.86918 3.99732 9.29902 3.99027 9.72788 4.01304C10.0416 4.02993 10.3595 4.05519 10.6689 4.08676C11.1669 4.14124 11.6598 4.23553 12.1427 4.36888C13.0848 4.61766 13.9821 5.01271 14.8017 5.53951C15.6121 6.05029 16.3 6.73318 16.8167 7.53958C17.3534 8.37418 17.6046 9.36066 17.5324 10.3503C17.4521 11.3908 17.0362 12.3771 16.3472 13.1609C15.6966 13.9213 14.895 14.5378 13.9933 14.9716C13.4665 15.2355 12.917 15.4511 12.3511 15.6159C11.8812 15.7521 11.402 15.855 10.9175 15.9232C10.2323 16.0224 9.53948 16.0576 8.84775 16.0285C8.51937 16.0139 8.19084 15.9801 7.86454 15.9464C7.65394 15.9254 7.46448 15.8896 7.26447 15.8601H7.26462C7.22775 15.8527 7.18957 15.8613 7.15932 15.8833C6.32897 16.4622 5.41433 16.9097 4.44755 17.2096C3.95647 17.3613 3.45373 17.4719 2.94431 17.5402C2.74898 17.5573 2.57026 17.4296 2.52327 17.2391C2.48141 17.072 2.53678 16.8956 2.66646 16.7822C2.80127 16.637 2.93389 16.4875 3.06855 16.34C3.34597 16.046 3.59343 15.7251 3.80754 15.3822C3.92752 15.18 4.0243 14.9569 4.13386 14.7442L4.13381 14.7442Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18.9344 17.7402C19.1019 18.1865 19.3479 18.5994 19.6607 18.9591C19.905 19.2433 20.1576 19.5213 20.404 19.8012V19.8014C20.4395 19.8445 20.472 19.8902 20.5008 19.9382C20.5535 20.0264 20.5658 20.133 20.5344 20.2308C20.489 20.4405 20.2871 20.5777 20.0755 20.5424C19.7534 20.473 19.4271 20.4351 19.1091 20.353C18.0218 20.08 16.9897 19.6213 16.0584 18.9972C16.0122 18.9693 15.9679 18.9383 15.9258 18.9045C15.88 18.8669 15.8189 18.8537 15.7616 18.8687C15.3911 18.9171 15.0206 18.976 14.6478 19.0056C14.2752 19.0351 13.9068 19.0371 13.5363 19.0392C13.1327 19.0368 12.7299 19.0094 12.3298 18.9571C11.6369 18.8749 10.9546 18.7204 10.2939 18.4961C9.58513 18.2542 8.90901 17.9254 8.28119 17.517L8.24756 17.4938L8.5802 17.5129C9.01548 17.5417 9.45224 17.5417 9.88753 17.5129C10.2118 17.4919 10.5381 17.4729 10.8602 17.4308C11.2286 17.3823 11.5971 17.3192 11.9613 17.2434C12.7113 17.0864 13.443 16.8522 14.1447 16.5443C14.78 16.2738 15.3849 15.9365 15.949 15.5379C16.7193 14.9957 17.389 14.3231 17.9279 13.5504C18.4317 12.8317 18.7794 12.0156 18.9491 11.1546C19.0433 10.6558 19.0745 10.1473 19.0417 9.64073C19.009 9.17784 18.9235 8.72008 18.7871 8.27656V8.24072L18.848 8.27656C19.5396 8.65635 20.164 9.14713 20.6965 9.72915C21.2258 10.2957 21.6234 10.9723 21.8609 11.7104C22.024 12.2481 22.0854 12.8113 22.0419 13.3716C21.9745 14.2291 21.6707 15.0512 21.164 15.7464C20.6475 16.4643 19.9951 17.0736 19.2438 17.5402L18.9344 17.7402Z",
    fill: fill
  }));
};

const IconLockClosed = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M4 8v-2c0-3.314 2.686-6 6-6s6 2.686 6 6v0 2h1c1.105 0 2 0.895 2 2v0 8c0 1.105-0.895 2-2 2v0h-14c-1.105 0-2-0.895-2-2v0-8c0-1.1 0.9-2 2-2h1zM9 14.73v2.27h2v-2.27c0.602-0.352 1-0.996 1-1.732 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.736 0.398 1.38 0.991 1.727l0.009 0.005zM7 6v2h6v-2c0-1.657-1.343-3-3-3s-3 1.343-3 3v0z",
    fill: fill
  }));
};

const IconLockOpen = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M4 8v-2c0-3.314 2.686-6 6-6s6 2.686 6 6v0h-3v2h4c1.105 0 2 0.895 2 2v0 8c0 1.105-0.895 2-2 2v0h-14c-1.105 0-2-0.895-2-2v0-8c0-1.1 0.9-2 2-2h1zM9 14.73v2.27h2v-2.27c0.602-0.352 1-0.996 1-1.732 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.736 0.398 1.38 0.991 1.727l0.009 0.005zM7 6v2h6v-2c0-1.657-1.343-3-3-3s-3 1.343-3 3v0z",
    fill: fill
  }));
};

const IconStudentV2 = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M9.73179 10.793C10.6879 10.2624 11.3284 9.31549 11.3284 8.23442C11.3284 7.62181 11.1248 7.03848 10.7429 6.53729V4.49667L12.1189 3.85575V5.15666C11.8332 5.29804 11.6329 5.61127 11.6329 5.97627C11.6329 6.47266 12.0023 6.87662 12.4562 6.87662C12.9101 6.87662 13.2789 6.47268 13.2789 5.97627C13.2789 5.61137 13.0789 5.29825 12.7934 5.15687V3.32693C12.7934 3.32509 12.793 3.32336 12.793 3.32153C12.7928 3.31256 12.7914 3.30379 12.7905 3.29482C12.7896 3.28534 12.789 3.27617 12.7871 3.26669C12.7864 3.26241 12.7858 3.25813 12.7849 3.25385C12.7831 3.24641 12.7802 3.23927 12.7782 3.23163C12.7752 3.22245 12.773 3.21318 12.7694 3.20421C12.7674 3.19921 12.7656 3.19412 12.7636 3.18912C12.7627 3.18759 12.7625 3.18596 12.7618 3.18443C12.7593 3.17944 12.7562 3.17526 12.7534 3.17047C12.7489 3.16211 12.7451 3.15385 12.74 3.14621C12.7368 3.14152 12.7338 3.13673 12.7305 3.13204C12.726 3.12572 12.721 3.12011 12.7163 3.1141C12.7109 3.10758 12.7057 3.10085 12.6999 3.09473C12.6958 3.09066 12.692 3.08689 12.688 3.08301C12.6822 3.07741 12.6756 3.07241 12.6695 3.06731C12.6634 3.06232 12.6574 3.05702 12.6509 3.05243C12.6462 3.04907 12.6412 3.04591 12.6363 3.04275C12.6291 3.03806 12.6217 3.03439 12.6141 3.03042C12.6087 3.02746 12.604 3.02389 12.5986 3.02124L8.11877 0.935058C8.11408 0.93302 8.1096 0.932102 8.10481 0.93037C8.09421 0.925885 8.0834 0.922521 8.07219 0.919157C8.06189 0.915998 8.0517 0.913347 8.04141 0.911105C8.0304 0.908862 8.01939 0.907741 8.00818 0.90662C7.99788 0.905703 7.98749 0.904785 7.97719 0.904785C7.96547 0.904785 7.95405 0.905703 7.94233 0.907028C7.93244 0.907945 7.92256 0.909066 7.91267 0.911105C7.90125 0.913347 7.88994 0.916507 7.87873 0.920075C7.86884 0.92303 7.85895 0.926394 7.84927 0.930166C7.84428 0.932204 7.83898 0.933122 7.83398 0.935364L3.3547 3.02134C3.34929 3.02379 3.34501 3.02746 3.33961 3.03031C3.32952 3.03571 3.31943 3.04152 3.30975 3.04825C3.30078 3.05406 3.29221 3.06058 3.28386 3.06731C3.27529 3.07424 3.26724 3.08148 3.25939 3.08953C3.25154 3.09758 3.2441 3.10553 3.23687 3.1143C3.23034 3.12235 3.22402 3.13091 3.21801 3.13968C3.21149 3.14957 3.20537 3.15966 3.19976 3.17026C3.19711 3.17525 3.19365 3.17943 3.1912 3.18463C3.18916 3.18891 3.18825 3.1936 3.18651 3.19788C3.18182 3.20889 3.17815 3.2199 3.17479 3.23111C3.17163 3.24141 3.16898 3.2516 3.16674 3.26189C3.1647 3.2727 3.16337 3.2835 3.16225 3.29451C3.16134 3.30532 3.16021 3.31612 3.16021 3.32713C3.16021 3.33814 3.16113 3.34874 3.16225 3.35975C3.16337 3.37075 3.1645 3.38156 3.16674 3.39236C3.16878 3.40266 3.17173 3.41285 3.17479 3.42315C3.17815 3.43436 3.18172 3.44567 3.18651 3.45637C3.18835 3.46066 3.18916 3.46534 3.1912 3.46962C3.19273 3.47319 3.19569 3.47574 3.19732 3.4791C3.20996 3.50387 3.22474 3.52762 3.24319 3.54882C3.2441 3.54995 3.24502 3.55127 3.24584 3.55239C3.26428 3.57308 3.2863 3.59082 3.31015 3.60662C3.31688 3.6111 3.32361 3.61498 3.33064 3.61895C3.33869 3.62344 3.34573 3.62904 3.35429 3.63312L5.20991 4.49727V6.53831C4.82776 7.03919 4.62402 7.62254 4.62402 8.23494C4.62402 9.31601 5.26455 10.2629 6.22065 10.7935C4.07331 11.3559 2.52393 12.9193 2.52393 14.7561C2.52393 14.9422 2.67478 15.0933 2.86111 15.0933H13.0915C13.2776 15.0933 13.4287 14.9422 13.4287 14.7561C13.4289 12.9187 11.8793 11.3555 9.73196 10.793L9.73179 10.793ZM7.97627 5.04107L4.29572 3.32693L7.97627 1.61279L11.6571 3.32693L7.97627 5.04107ZM12.4558 6.20245C12.3855 6.20245 12.307 6.10583 12.307 5.97648C12.307 5.84703 12.3857 5.75029 12.4558 5.75029C12.5259 5.75029 12.6042 5.84692 12.6042 5.97648C12.6041 6.10582 12.5256 6.20245 12.4558 6.20245ZM7.83406 5.7187C7.84506 5.72369 7.85658 5.72614 7.86759 5.73011C7.87595 5.73277 7.8838 5.73623 7.89205 5.73847C7.92019 5.74571 7.94822 5.7504 7.97615 5.7504H7.97635H7.97655C8.00469 5.7504 8.03272 5.74571 8.06065 5.73847C8.06921 5.73623 8.07706 5.73307 8.08542 5.73011C8.09642 5.72634 8.10764 5.7238 8.11864 5.7189L10.0679 4.81112V6.38612C8.69373 6.67775 7.25893 6.67775 5.88456 6.38612V4.81112L7.83406 5.7187ZM5.29866 8.23452C5.29866 7.80621 5.43066 7.39461 5.68151 7.03227C6.43487 7.19678 7.20506 7.28342 7.97635 7.28342C8.74745 7.28342 9.51782 7.19688 10.2712 7.03257C10.5218 7.39473 10.6538 7.80662 10.6538 8.23483C10.6538 9.5223 9.45269 10.5695 7.97632 10.5695C6.49998 10.5694 5.29856 9.5218 5.29856 8.23454L5.29866 8.23452ZM7.97642 11.2437C10.4563 11.2437 12.4993 12.6397 12.731 14.4188H3.22159C3.45337 12.6399 5.49666 11.2437 7.97616 11.2437H7.97642Z"
  }));
};

const IconGroupV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95846 2.29175C6.25477 2.29175 4.8863 3.66022 4.8863 5.36391C4.8863 7.06811 6.25465 8.43669 7.95846 8.43669C9.66227 8.43669 11.0306 7.06811 11.0306 5.36391C11.0306 3.66022 9.66216 2.29175 7.95846 2.29175ZM7.95846 3.29175C9.10988 3.29175 10.0306 4.2125 10.0306 5.36391C10.0306 6.51586 9.10995 7.43669 7.95846 7.43669C6.80698 7.43669 5.8863 6.51586 5.8863 5.36391C5.8863 4.2125 6.80705 3.29175 7.95846 3.29175ZM4.19329 2.91966C4.46943 2.91966 4.69329 3.14352 4.69329 3.41966C4.69329 3.69581 4.46943 3.91966 4.19329 3.91966C3.40104 3.91966 2.75851 4.56192 2.75851 5.35383C2.75851 6.14575 3.40104 6.788 4.19329 6.788C4.46943 6.788 4.69329 7.01186 4.69329 7.288C4.69329 7.56414 4.46943 7.788 4.19329 7.788C2.84885 7.788 1.75851 6.69813 1.75851 5.35383C1.75851 4.00953 2.84885 2.91966 4.19329 2.91966ZM14.1647 5.35383C14.1647 4.00953 13.0743 2.91966 11.7299 2.91966C11.4537 2.91966 11.2299 3.14352 11.2299 3.41966C11.2299 3.69581 11.4537 3.91966 11.7299 3.91966C12.5221 3.91966 13.1647 4.56192 13.1647 5.35383C13.1647 6.14575 12.5221 6.788 11.7299 6.788C11.4537 6.788 11.2299 7.01186 11.2299 7.288C11.2299 7.56414 11.4537 7.788 11.7299 7.788C13.0743 7.788 14.1647 6.69813 14.1647 5.35383ZM13.6639 9.03673C13.3437 8.96448 13.0016 8.91509 12.6537 8.8911C12.3783 8.8721 12.1395 9.08002 12.1205 9.35551C12.1015 9.631 12.3095 9.86973 12.5849 9.88873C12.8826 9.90926 13.1744 9.95138 13.458 10.0152C13.8991 10.1018 14.1867 10.2453 14.2581 10.3948C14.3118 10.5077 14.3118 10.6405 14.2576 10.7547C14.1872 10.9028 13.902 11.0456 13.4671 11.135C13.1966 11.1906 13.0224 11.455 13.078 11.7255C13.1337 11.9959 13.398 12.1701 13.6685 12.1145C14.3873 11.9667 14.9138 11.7031 15.1609 11.1838C15.344 10.7977 15.344 10.3499 15.1609 9.96476C14.9121 9.44346 14.3765 9.17625 13.6639 9.03673ZM3.80263 9.35551C3.78363 9.08002 3.5449 8.8721 3.26941 8.8911C2.92155 8.91509 2.57944 8.96448 2.24559 9.03961L2.10796 9.06873C1.47621 9.21308 0.994245 9.47834 0.762903 9.96469C0.579 10.3495 0.579 10.7981 0.763097 11.1842C1.00905 11.703 1.53556 11.9666 2.25466 12.1145C2.52514 12.1701 2.7895 11.9959 2.84512 11.7255C2.90074 11.455 2.72656 11.1906 2.45608 11.135C2.02135 11.0456 1.73644 10.9029 1.66622 10.7548C1.61152 10.6401 1.61152 10.5081 1.66555 10.3951C1.73687 10.2451 2.02418 10.1017 2.45143 10.0181L2.67359 9.97262C2.89504 9.93167 3.11495 9.90413 3.33822 9.88873C3.6137 9.86973 3.82163 9.631 3.80263 9.35551ZM3.44469 11.4564C3.44469 9.86582 5.08998 9.30645 7.95846 9.30645L8.16169 9.30739C10.9103 9.33321 12.4722 9.89387 12.4722 11.4448C12.4722 12.9593 10.9792 13.5392 8.35978 13.591L7.95846 13.5948C5.0834 13.5948 3.44469 13.0453 3.44469 11.4564ZM11.4722 11.4448C11.4722 10.7045 10.2852 10.3064 7.95846 10.3064C5.63399 10.3064 4.44469 10.7108 4.44469 11.4564C4.44469 12.1969 5.63134 12.5948 7.95846 12.5948C10.2822 12.5948 11.4722 12.1901 11.4722 11.4448Z",
    fill: fill
  }));
};

const IconPersonV2 = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0027 1.33325C6.04668 1.33325 4.46102 2.92568 4.46102 4.89003C4.46102 6.85439 6.04668 8.44682 8.0027 8.44682C9.95872 8.44682 11.5444 6.85439 11.5444 4.89003C11.5444 2.92568 9.95872 1.33325 8.0027 1.33325ZM8.0027 2.29836C9.42796 2.29836 10.5834 3.45869 10.5834 4.89003C10.5834 6.32137 9.42796 7.4817 8.0027 7.4817C6.57744 7.4817 5.42203 6.32137 5.42203 4.89003C5.42203 3.45869 6.57744 2.29836 8.0027 2.29836ZM6.5532 9.88051C6.03472 9.9165 5.51064 9.99051 4.9937 10.1013C3.99595 10.3068 3.19774 10.7175 2.858 11.3998C2.72986 11.6667 2.66543 11.9524 2.66652 12.2417C2.66613 12.5289 2.73004 12.815 2.85358 13.0768C3.1798 13.7513 3.88504 14.133 4.83733 14.3446L5.00792 14.3802C5.51083 14.4937 6.03507 14.5701 6.56281 14.6059C6.60776 14.6191 6.71489 14.6314 6.83181 14.6373L6.92798 14.6409C6.97743 14.6421 7.03356 14.6424 7.11717 14.6424C7.87573 14.6841 8.66212 14.672 9.44485 14.6053C9.86197 14.5768 10.2819 14.5222 10.6983 14.4423L11.0099 14.3776C12.0382 14.1748 12.8082 13.789 13.1456 13.0775C13.3957 12.5493 13.3957 11.9364 13.1457 11.4084C12.8092 10.6988 12.049 10.3162 11.0021 10.1005C10.5913 10.0128 10.174 9.94795 9.75362 9.90651L9.44631 9.88051C8.48379 9.7956 7.51572 9.7956 6.5532 9.88051ZM9.3622 10.8419L9.37066 10.8426C9.85309 10.8765 10.3326 10.9443 10.8056 11.0452C11.5832 11.2054 12.1109 11.471 12.2779 11.8231C12.4036 12.0886 12.4036 12.3971 12.2778 12.6628C12.1218 12.9918 11.6478 13.246 10.9628 13.4013L10.8128 13.4331C10.3305 13.5407 9.85259 13.6101 9.37153 13.6431C8.62512 13.7065 7.88313 13.718 7.14301 13.678L6.88061 13.6735C6.80776 13.6698 6.74637 13.6627 6.68948 13.6513C6.23898 13.6173 5.83361 13.5635 5.44001 13.4855L5.205 13.4357C4.42497 13.2828 3.8926 13.0161 3.71999 12.6592C3.65959 12.5312 3.62733 12.3868 3.62752 12.2405C3.62698 12.0951 3.65882 11.9539 3.72062 11.8252C3.88845 11.4882 4.45263 11.198 5.19053 11.0459C5.66699 10.9439 6.14624 10.8762 6.62845 10.8426C7.54385 10.7619 8.45564 10.7619 9.3622 10.8419Z",
    fill: fill
  }));
};

const IconCamera = _a => {
  var props = __rest(_a, []);

  const fill = props.fill;
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M11.9412 8.52866C11.9412 10.2384 10.5551 11.6243 8.84558 11.6243C7.13604 11.6243 5.75 10.2384 5.75 8.52866C5.75 6.81908 7.13604 5.43317 8.84558 5.43317C10.5551 5.43317 11.9412 6.81908 11.9412 8.52866Z",
    fill: fill
  }), React.createElement("path", {
    d: "M16.23 2.56244H13.2404L12.4366 0.954926C12.1199 0.322118 11.5987 0 10.891 0H6.94106C6.23364 0 5.71238 0.322135 5.39575 0.954926L4.59199 2.56244H1.6024C0.5412 2.56244 0.000976562 3.10266 0.000976562 4.164V13.4529C0.000976562 14.5142 0.5412 15.0544 1.60254 15.0544H16.23C17.2913 15.0544 17.8315 14.5142 17.8315 13.4529V4.164C17.8315 3.10266 17.2913 2.56244 16.23 2.56244ZM8.91626 12.9724C6.41021 12.9724 4.37866 10.941 4.37866 8.43485C4.37866 5.92866 6.41043 3.89725 8.91626 3.89725C11.422 3.89725 13.4538 5.92902 13.4538 8.43485C13.4538 10.9409 11.4219 12.9724 8.91626 12.9724ZM15.6965 5.65908C15.1655 5.65908 14.7352 5.22902 14.7352 4.69821C14.7352 4.1674 15.1655 3.7372 15.6965 3.7372C16.227 3.7372 16.6575 4.16726 16.6575 4.69821C16.6572 5.22874 16.2269 5.65908 15.6965 5.65908Z",
    fill: fill
  }));
};

var Icon$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    IconCalendar: IconCalendar,
    IconChat: IconChat,
    IconPencil: IconPencil,
    IconNotification: IconNotification,
    IconSetting: IconSetting,
    IconList: IconList,
    IconLevel: IconLevel,
    IconInBox: IconInBox,
    IconHamburger: IconHamburger,
    IconSend: IconSend,
    IconVoice: IconVoice,
    IconPaperPlus: IconPaperPlus,
    IconDashboard: IconDashboard,
    IconAdmin: IconAdmin,
    IconApplication: IconApplication,
    IconManagement: IconManagement,
    IconFile: IconFile,
    IconBoldLevel: IconBoldLevel,
    IconUser: IconUser,
    IconUsers: IconUsers,
    IconTestResult: IconTestResult,
    IconGroup: IconGroup,
    IconCourse: IconCourse,
    IconMaterial: IconMaterial,
    IconEnrolment: IconEnrolment,
    IconStudent: IconStudent,
    IconAttendance: IconAttendance,
    IconSubject: IconSubject,
    IconPaymant: IconPaymant,
    IconSalaryIn: IconSalaryIn,
    IconSalaryOut: IconSalaryOut,
    IconDiscount: IconDiscount,
    IconCheckInOut: IconCheckInOut,
    IconNews: IconNews,
    IconContacts: IconContacts,
    IconTask: IconTask,
    IconForm: IconForm,
    IconLink: IconLink,
    IconAnalytics: IconAnalytics,
    IconExpense: IconExpense,
    IconVacation: IconVacation,
    IconExtra: IconExtra,
    IconSchool: IconSchool,
    IconChatBot: IconChatBot,
    IconVocab: IconVocab,
    IconFeature: IconFeature,
    IconExceptions: IconExceptions,
    IconInternational: IconInternational,
    IconEvents: IconEvents,
    IconCfEvents: IconCfEvents,
    IconNotificationTemplates: IconNotificationTemplates,
    IconRole: IconRole,
    IconPermission: IconPermission,
    IconAcl: IconAcl,
    IconZoom: IconZoom,
    IconClassroom: IconClassroom,
    IconAdd: IconGroup$1,
    IconPlus: IconPlus,
    IconPersonal: IconPersonal,
    IconLearning: IconLearning,
    IconFinances: IconFinances,
    IconFinancesBold: IconFinancesBold,
    IconSales: IconSales,
    IconInfo: IconInfo,
    IconPlusOutlined: IconPlusOutlined,
    IconUnorderedListOutlined: IconUnorderedListOutlined,
    IconSearchOutlined: IconSearchOutlined,
    IconUploadOutlined: IconUploadOutlined,
    IconBarChartOutlined: IconBarChartOutlined,
    IconDropBox: IconDropBox,
    IconLetter: IconLetter,
    IconLock: IconLock,
    IconInfoCircle: IconInfoCircle,
    IconHelpCircle: IconHelpCircle,
    IconPieChart: IconPieChart,
    IconMessageSuare: IconMessageSquare,
    IconPulse: IconPulse,
    IconClose: IconClose,
    IconCloseOutlined: IconCloseOutlined,
    IconPersonOutlined: IconPersonOutlined,
    IconBriefcase: IconBriefcase,
    IconMail: IconMail,
    IconLockOutlined: IconLockOutlined,
    IconArrowDown: IconArrowDown,
    IconArrowUp: IconArrowUp,
    IconArrowLeft: IconArrowLeft,
    IconArrowRight: IconArrowRight,
    IconUserAddPlus: IconUserAddPlus,
    IconEditPen: IconEditPen,
    IconCheckCircle: IconCheckCircle,
    IconTrash: IconTrash,
    IconTrashColored: IconTrashColored,
    IconInBoxOutline: IconInBoxOutline,
    IconSettingsOutline: IconSettingsOutline,
    IconUserOutline: IconUserOutline,
    IconSave: IconGroup$2,
    IconDocument: IconMaterial$1,
    IconMiusOutlined: IconMiusOutlined,
    IconKey: IconKey,
    IconKeyOutlined: IconKeyOutlined,
    IconArrowDownBold: IconArrowDownBold,
    IconColoredBook: IconColoredFile,
    IconColoredFile: IconColoredBook,
    IconEye: IconEye,
    IconLockBold: IconLockBold,
    IconEditPenCircle: IconEditPenCircle,
    IconStar: IconStar,
    IconClip: IconClip,
    IconNotes: IconNotes,
    IconMergeRequest: IconMergeRequest,
    IconPenUnderline: IconPenUnderline,
    IconPrint: IconPrint,
    IconBellOutlined: IconBellOutlined,
    IconBellWithPaper: IconBellWithPaper,
    IconExport: IconExport,
    IconImport: IconImport,
    IconPen: IconPen,
    IconTrashLined: IconTrashLined,
    IconFilePDF: IconFilePDF,
    IconNotePadColored: IconNotePadColored,
    IconGlobeOutline: IconGlobeOutline,
    IconBookBold: IconContact,
    IconMoreActions: IconMoreActions,
    IconUploadBulk: IconUploadBulk,
    IconMoreActionsCircle: IconMoreActionsCircle,
    IconLamp: IconLamp,
    IconExit: IconExit,
    IconHome: IconHome,
    IconApps: IconApps,
    IconCalendarV2: IconCalendarV2,
    IconCategory: IconHome$1,
    IconComment: IconComment,
    IconFileDocument: IconFileDocument,
    IconRectangles: IconRectangles,
    IconInvoice: IconInvoice,
    IconLogout: IconLogout,
    IconLogoutV2: IconLogoutV2,
    IconNewsV2: IconNewsV2,
    IconProfile: IconProfile,
    IconSettingsV2: IconSettingsV2,
    IconTrendingUp: IconTrendingUp,
    IconWatch: IconWatch,
    IconVideoCamera: IconVideoCamera,
    IconBadge: IconBadge,
    IconPlayOutlined: IconPlayOutlined,
    IconCloseCircle: IconCloseCircle,
    IconClone: IconClone,
    IconBack: IconBack,
    IconRefresh: IconRefresh,
    IconGlobe: IconGlobe,
    IconPerson: IconPerson,
    IconCloneV2: IconCloneV2,
    IconReply: IconForward,
    IconEmoji: IconEmoji,
    IconPieChartV2: IconPieChartV2,
    IconMaterialV2: IconMaterialV2,
    IconAppsV2: IconAppsV2,
    IconClasses: IconClasses,
    IconOnlinePayment: IconOnlinePayment,
    IconBlog: IconBlog,
    IconLockClosed: IconLockClosed,
    IconLockOpen: IconLockOpen,
    IconStudentV2: IconStudentV2,
    IconGroupV2: IconGroupV2,
    IconPersonV2: IconPersonV2,
    IconCamera: IconCamera
});

var css_248z$I = ".t-card-container .t-card {\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  background: #ffffff;\n}\n.t-card-container .t-card .ant-card-body {\n  padding: 8px 16px !important;\n}\n.t-card-container .t-card .ant-card-body .t-card-text-wrapper {\n  height: 32px;\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #f2f2f3;\n  margin-top: 8px;\n  padding: 8px 0;\n  height: 47px;\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container .t-card-grade-tag {\n  margin-left: auto;\n  display: flex;\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container .t-card-grade-tag .t-tag {\n  height: 24px;\n  min-width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container .t-card-grade-tag svg {\n  margin-right: 4px;\n  cursor: pointer;\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container .t-card-grade-tag svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-card-container .t-card .ant-card-body .t-card-note-container .t-card-note-input {\n  border: none;\n  box-shadow: none;\n}\n.t-card-container .t-card .ant-card-head {\n  border-bottom: none;\n  padding: 16px 16px 0 16px;\n}\n.t-card-container .t-card .ant-card-head .ant-card-head-wrapper {\n  align-items: flex-start;\n}\n.t-card-container .t-card .ant-card-head .ant-card-head-title {\n  padding: 0;\n  white-space: normal;\n}\n.t-card-container .t-card .ant-card-head .ant-card-extra {\n  padding: 0;\n}\n";
styleInject(css_248z$I);

const StudentAttendanceCard = _a => {
  var {
    children,
    title,
    onBlur,
    openMessages
  } = _a,
      props = __rest(_a, ["children", "title", "onBlur", "openMessages"]);

  const {
    image,
    name,
    email,
    id,
    attendanceData = {}
  } = props;
  const {
    attend = false,
    excused = false,
    trial = false,
    score = 0
  } = attendanceData;

  const getStatus = () => {
    if (isEmpty(attendanceData)) {
      return {};
    }

    if (attend) {
      if (trial) {
        return {
          status: 'Trial',
          color: StatusType.WARNING
        };
      }

      return {
        status: 'Present',
        color: StatusType.SUCCESS
      };
    }

    if (excused) {
      return {
        status: 'Excused',
        color: StatusType.DEFAULT
      };
    }

    return {
      status: 'Absent',
      color: StatusType.ERROR
    };
  };

  const content = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "t-card-text-wrapper"
  }, React.createElement(TLink, {
    href: `/students/${id}`,
    title: React.createElement(TText, {
      rows: 1,
      level: 4
    }, name)
  }), React.createElement(TText, {
    textColor: "dark-50",
    rows: 1,
    level: 4
  }, email)), React.createElement("div", {
    className: "t-card-note-container"
  }, !isEmpty(attendanceData) && React.createElement(_Input, Object.assign({
    className: "t-card-note-input",
    onBlur: onBlur,
    placeholder: "Add a note",
    bordered: false
  }, props)), React.createElement("div", {
    className: "t-card-grade-tag"
  }, !!openMessages && React.createElement(IconChat, {
    onClick: openMessages,
    fill: "red",
    size: "md"
  }), React.createElement(TTag, {
    type: TagTypes.NEUTRAL
  }, score || '-'))));
  const {
    status,
    color
  } = getStatus();
  return React.createElement("div", {
    className: "t-card-container"
  }, React.createElement(_Card, {
    className: "t-card",
    bodyStyle: {
      padding: '16px'
    },
    extra: React.createElement(TBadge, {
      type: "reverse",
      status: color,
      statusText: status
    }),
    title: React.createElement(TAvatar, {
      src: image,
      name: name,
      size: "md"
    })
  }, React.createElement(_Card.Meta, {
    description: content
  })));
};

const img$3 = "data:image/svg+xml,%3csvg width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d)'%3e%3crect x='4' y='2' width='37' height='37' rx='12' fill='white'/%3e%3c/g%3e%3cg clipPath='url(%23clip0)'%3e%3cpath d='M22.0388 9H21.9612C19.2108 9 16.9812 11.2296 16.9812 13.98V21.5225C16.9812 23.1326 17.2488 24.7314 17.7729 26.2537L18.6669 28.8502L21.2671 27.9549L20.5772 25.9515C20.2408 24.9744 20.9667 23.9568 22 23.9568C23.0333 23.9568 23.7592 24.9744 23.4228 25.9515L22.733 27.9549L25.3331 28.8502L26.2265 26.2556C26.7505 24.7337 27.018 23.1352 27.0182 21.5256L27.0188 13.98C27.0188 11.2296 24.7892 9 22.0388 9V9Z' fill='url(%23paint0_linear)'/%3e%3cpath d='M22.0388 9H21.9612C21.6528 9 21.3511 9.02824 21.0583 9.08188C23.3777 9.50664 25.1355 11.538 25.1355 13.98L25.1349 21.5256C25.1348 23.1352 24.8672 24.7336 24.3432 26.2556L23.6495 28.2704L25.3331 28.8501L26.2265 26.2556C26.7505 24.7336 27.0181 23.1352 27.0182 21.5256L27.0188 13.98C27.0188 11.2296 24.7892 9 22.0388 9V9Z' fill='url(%23paint1_linear)'/%3e%3cpath d='M25.3898 26.2583H18.6103C17.9016 26.2583 17.3271 26.8328 17.3271 27.5414C17.3271 28.2501 17.9016 28.8245 18.6103 28.8245H25.3899C26.0985 28.8245 26.673 28.25 26.673 27.5414C26.673 26.8327 26.0985 26.2583 25.3898 26.2583Z' fill='url(%23paint2_linear)'/%3e%3cpath d='M25.3899 26.2583H23.5066C24.2153 26.2583 24.7897 26.8328 24.7897 27.5414C24.7897 28.2501 24.2152 28.8245 23.5066 28.8245H25.3899C26.0986 28.8245 26.673 28.25 26.673 27.5414C26.6731 26.8327 26.0986 26.2583 25.3899 26.2583Z' fill='url(%23paint3_linear)'/%3e%3cpath d='M25.749 30.2028C25.749 31.7477 24.0705 33.0001 22 33.0001C19.9295 33.0001 18.251 31.7477 18.251 30.2028C18.251 28.658 25.749 28.6579 25.749 30.2028Z' fill='url(%23paint4_linear)'/%3e%3cpath d='M21.0583 29.0773C22.5714 29.1858 23.8657 29.5609 23.8657 30.2028C23.8657 31.505 22.6731 32.5993 21.0583 32.911C21.3592 32.9691 21.6748 33 22 33C24.0705 33 25.749 31.7477 25.749 30.2028C25.749 29.2998 23.1872 28.9246 21.0583 29.0773Z' fill='url(%23paint5_linear)'/%3e%3cpath d='M25.3898 28.8247H18.6103C17.9016 28.8247 17.3271 29.3992 17.3271 30.1078C17.3271 30.8165 17.9016 31.3909 18.6103 31.3909H25.3899C26.0985 31.3909 26.673 30.8164 26.673 30.1078C26.673 29.3992 26.0985 28.8247 25.3898 28.8247Z' fill='url(%23paint6_linear)'/%3e%3cpath d='M26.6683 30.0014C26.6428 29.6894 26.5059 29.4089 26.297 29.2005C26.065 28.968 25.744 28.8245 25.3897 28.8245H18.6104C17.9374 28.8245 17.3854 29.3426 17.3318 30.0014H24.3636C24.6095 30.0014 24.7969 30.2308 24.7375 30.4695C24.7357 30.4767 24.7339 30.4833 24.732 30.4893C24.5695 31.0116 24.0822 31.3906 23.5064 31.3906H25.3897C26.0984 31.3906 26.673 30.8165 26.673 30.1078C26.673 30.072 26.6715 30.0362 26.6683 30.0014Z' fill='url(%23paint7_linear)'/%3e%3cpath d='M15.7685 14.781C16.0166 15.7809 17.0284 16.3903 18.0283 16.1422L26.8703 13.948C27.8702 13.6999 28.4797 12.6881 28.2316 11.6882C27.9834 10.6883 26.9716 10.0788 25.9717 10.327L17.1297 12.5212C16.1298 12.7693 15.5203 13.7811 15.7685 14.781Z' fill='url(%23paint8_linear)'/%3e%3cpath d='M28.2316 11.6882C27.9834 10.6882 26.9717 10.0788 25.9718 10.327L25.8632 10.3539C26.0923 10.5849 26.2642 10.8786 26.3483 11.2173C26.5964 12.2172 25.987 13.229 24.9871 13.4771L16.2537 15.6444C16.701 16.0951 17.3672 16.3063 18.0283 16.1422L26.8704 13.948C27.8703 13.6998 28.4797 12.6881 28.2316 11.6882Z' fill='url(%23paint9_linear)'/%3e%3cpath d='M15.7685 18.6192C16.0166 19.6192 17.0284 20.2286 18.0283 19.9805L26.8703 17.7863C27.8702 17.5381 28.4797 16.5264 28.2316 15.5264C27.9834 14.5265 26.9716 13.9171 25.9717 14.1652L17.1297 16.3594C16.1298 16.6076 15.5203 17.6193 15.7685 18.6192Z' fill='url(%23paint10_linear)'/%3e%3cpath d='M28.2316 15.5264C27.9834 14.5265 26.9717 13.9171 25.9718 14.1652L25.8632 14.1922C26.0923 14.4231 26.2642 14.7168 26.3483 15.0556C26.5964 16.0555 25.987 17.0672 24.9871 17.3154L16.2537 19.4826C16.701 19.9334 17.3672 20.1445 18.0283 19.9805L26.8704 17.7863C27.8703 17.5381 28.4797 16.5263 28.2316 15.5264Z' fill='url(%23paint11_linear)'/%3e%3cpath d='M15.7685 22.4574C16.0166 23.4573 17.0284 24.0667 18.0283 23.8186L26.8703 21.6244C27.8702 21.3762 28.4797 20.3645 28.2316 19.3646C27.9834 18.3647 26.9716 17.7552 25.9717 18.0034L17.1297 20.1976C16.1298 20.4457 15.5203 21.4575 15.7685 22.4574Z' fill='url(%23paint12_linear)'/%3e%3cpath d='M28.2316 19.3646C27.9834 18.3646 26.9717 17.7552 25.9718 18.0034L25.8632 18.0303C26.0923 18.2613 26.2642 18.555 26.3483 18.8937C26.5964 19.8936 25.987 20.9054 24.9871 21.1535L16.2537 23.3208C16.701 23.7715 17.3672 23.9826 18.0283 23.8186L26.8704 21.6244C27.8703 21.3762 28.4797 20.3645 28.2316 19.3646Z' fill='url(%23paint13_linear)'/%3e%3cpath d='M33.5287 18.0947H31.3102C31.0499 18.0947 30.8389 17.8837 30.8389 17.6234C30.8389 17.3631 31.0499 17.1521 31.3102 17.1521H33.5287C33.7889 17.1521 33.9999 17.3631 33.9999 17.6234C33.9999 17.8837 33.7889 18.0947 33.5287 18.0947Z' fill='url(%23paint14_linear)'/%3e%3cpath d='M12.6898 18.0947H10.4713C10.211 18.0947 10 17.8837 10 17.6234C10 17.3631 10.211 17.1521 10.4713 17.1521H12.6898C12.9501 17.1521 13.1611 17.3631 13.1611 17.6234C13.1611 17.8837 12.9501 18.0947 12.6898 18.0947Z' fill='url(%23paint15_linear)'/%3e%3cpath d='M30.1521 26.2466C30.0315 26.2466 29.9109 26.2006 29.8189 26.1086L28.2501 24.5398C28.066 24.3558 28.066 24.0574 28.2501 23.8734C28.4342 23.6894 28.7325 23.6894 28.9166 23.8734L30.4853 25.4421C30.6694 25.6262 30.6694 25.9246 30.4853 26.1086C30.3933 26.2006 30.2727 26.2466 30.1521 26.2466Z' fill='url(%23paint16_linear)'/%3e%3cpath d='M15.4167 11.5113C15.2961 11.5113 15.1755 11.4653 15.0835 11.3733L13.5147 9.80453C13.3307 9.62048 13.3307 9.32208 13.5147 9.13804C13.6988 8.95399 13.9972 8.95399 14.1812 9.13804L15.75 10.7067C15.934 10.8908 15.934 11.1892 15.75 11.3732C15.6579 11.4653 15.5373 11.5113 15.4167 11.5113Z' fill='url(%23paint17_linear)'/%3e%3cpath d='M13.848 26.2466C13.7274 26.2466 13.6068 26.2006 13.5147 26.1086C13.3307 25.9246 13.3307 25.6261 13.5147 25.4421L15.0835 23.8734C15.2675 23.6894 15.5659 23.6894 15.75 23.8734C15.934 24.0574 15.934 24.3558 15.75 24.5398L14.1812 26.1086C14.0892 26.2006 13.9686 26.2466 13.848 26.2466Z' fill='url(%23paint18_linear)'/%3e%3cpath d='M28.5834 11.5114C28.4628 11.5114 28.3421 11.4653 28.2501 11.3733C28.066 11.1893 28.066 10.8909 28.2501 10.7068L29.8188 9.13814C30.003 8.95409 30.3013 8.95414 30.4853 9.13814C30.6694 9.32219 30.6694 9.62059 30.4853 9.80463L28.9166 11.3733C28.8245 11.4653 28.7039 11.5114 28.5834 11.5114Z' fill='url(%23paint19_linear)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d' x='0' y='0' width='45' height='45' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e%3cfeOffset dy='2'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.466667 0 0 0 0 0.431373 0 0 0 0 0.670588 0 0 0 0.12 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear' x1='16.9812' y1='18.9251' x2='27.0188' y2='18.9251' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='21.0583' y1='18.9251' x2='27.0188' y2='18.9251' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFD15B'/%3e%3cstop offset='1' stop-color='%23ECA026'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='18.1046' y1='27.5414' x2='25.9335' y2='27.5414' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F8F6F7'/%3e%3cstop offset='0.1788' stop-color='%23F8F6F7'/%3e%3cstop offset='1' stop-color='%23E7E6F5'/%3e%3c/linearGradient%3e%3clinearGradient id='paint3_linear' x1='22.8315' y1='27.5414' x2='25.8746' y2='27.5414' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F8F6F7'/%3e%3cstop offset='1' stop-color='%23D1CEEB'/%3e%3c/linearGradient%3e%3clinearGradient id='paint4_linear' x1='19.2235' y1='31.0221' x2='22.6745' y2='31.0221' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23A79BA7'/%3e%3cstop offset='0.7487' stop-color='%237A6D79'/%3e%3cstop offset='1' stop-color='%23685E68'/%3e%3c/linearGradient%3e%3clinearGradient id='paint5_linear' x1='19.1765' y1='31.0221' x2='24.0708' y2='31.0221' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237A6D79'/%3e%3cstop offset='1' stop-color='%23554E56'/%3e%3c/linearGradient%3e%3clinearGradient id='paint6_linear' x1='18.1046' y1='30.1078' x2='25.9335' y2='30.1078' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F8F6F7'/%3e%3cstop offset='0.1788' stop-color='%23F8F6F7'/%3e%3cstop offset='1' stop-color='%23E7E6F5'/%3e%3c/linearGradient%3e%3clinearGradient id='paint7_linear' x1='17.9059' y1='30.1075' x2='27.2001' y2='30.1075' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F8F6F7'/%3e%3cstop offset='1' stop-color='%23D1CEEB'/%3e%3c/linearGradient%3e%3clinearGradient id='paint8_linear' x1='15.8539' y1='13.2346' x2='27.8433' y2='13.2346' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint9_linear' x1='20.7765' y1='13.2345' x2='27.811' y2='13.2345' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint10_linear' x1='15.8539' y1='17.0728' x2='27.8433' y2='17.0728' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint11_linear' x1='20.7765' y1='17.0728' x2='27.811' y2='17.0728' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint12_linear' x1='15.8539' y1='20.911' x2='27.8433' y2='20.911' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint13_linear' x1='20.7765' y1='20.911' x2='27.811' y2='20.911' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint14_linear' x1='30.5803' y1='17.6234' x2='33.993' y2='17.6234' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint15_linear' x1='10.251' y1='17.6234' x2='13.5139' y2='17.6234' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint16_linear' x1='27.7569' y1='24.991' x2='31.4169' y2='24.991' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint17_linear' x1='13.2' y1='10.2556' x2='16.6208' y2='10.2556' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint18_linear' x1='12.855' y1='24.991' x2='16.9538' y2='24.991' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3clinearGradient id='paint19_linear' x1='27.8197' y1='10.2557' x2='31.0221' y2='10.2557' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFF9DF'/%3e%3cstop offset='0.593' stop-color='%23FFE177'/%3e%3cstop offset='1' stop-color='%23FEB137'/%3e%3c/linearGradient%3e%3cclipPath id='clip0'%3e%3crect width='24' height='24' fill='white' transform='translate(10 9)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

const img$4 = "data:image/png;base64,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";

const img$5 = "data:image/svg+xml,%3csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fillRule='evenodd' clipRule='evenodd' d='M20 3.75C11.0312 3.75 3.75 11.0312 3.75 20C3.75 28.9688 11.0312 36.25 20 36.25C28.9688 36.25 36.25 28.9688 36.25 20C36.25 11.0312 28.9688 3.75 20 3.75ZM16.75 27.3125V12.6875L26.5 20L16.75 27.3125Z' fill='white'/%3e%3c/svg%3e";

var css_248z$J = ".t-video-player-container .t-video-player-wrapper .t-video-player {\n  border-radius: var(--border-radius, 8px) !important;\n}\n.t-video-player-container .t-video-player-wrapper .t-defaultImage-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--border-radius, 8px);\n}\n.t-video-player-container .t-video-player-wrapper .t-defaultImage-wrapper .t-player-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 110px;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n";
styleInject(css_248z$J);

const TVideoPlayer = ({
  height,
  width,
  videoUrl,
  href,
  playerText
}) => {
  return React.createElement("div", {
    className: "t-video-player-container"
  }, React.createElement("div", {
    className: "t-video-player-wrapper",
    style: {
      width: width,
      height: height
    }
  }, videoUrl ? React.createElement("iframe", {
    className: "t-video-player",
    src: videoUrl
  }) : React.createElement("div", {
    className: "t-defaultImage-wrapper",
    style: {
      backgroundImage: `url(${img$4})`,
      backgroundSize: `${width} ${height}`,
      width: width,
      height: height
    }
  }, React.createElement("a", {
    href: href,
    target: "_blank",
    className: "t-player-wrapper"
  }, React.createElement("img", {
    alt: "player",
    src: img$5
  }), playerText && React.createElement(TText, {
    textColor: "dark-10",
    level: 2
  }, playerText)))));
};

var css_248z$K = ".t-video-player-card {\n  padding: 16px;\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  display: flex;\n  justify-content: space-between;\n  background: #ffffff;\n  height: 152px;\n}\n@media screen and (max-width: 576px) {\n  .t-video-player-card {\n    flex-direction: column;\n    align-items: center;\n    height: unset;\n    margin-bottom: 16px;\n  }\n}\n.t-video-player-card .t-video-info-wrapper {\n  display: flex;\n  align-items: flex-start;\n}\n.t-video-player-card .t-video-info-wrapper img {\n  margin-right: 12px;\n}\n.t-video-player-card .t-video-info-wrapper .t-video-info-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-right: 16px;\n}\n@media screen and (max-width: 576px) {\n  .t-video-player-card .t-video-info-wrapper .t-video-info-text-wrapper {\n    max-width: 100%;\n    text-align: center;\n  }\n}\n@media screen and (max-width: 768px) {\n  .t-video-player-card .t-video-info-wrapper .t-video-info-text-wrapper {\n    margin-bottom: 16px;\n  }\n}\n.cardHover:hover {\n  -webkit-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -moz-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  transition: all 0.3s ease-in-out;\n}\n";
styleInject(css_248z$K);

const TNextSessionCard$1 = ({
  title,
  description,
  height,
  href,
  onHover
}) => {
  const [mobile, setMobile] = React.useState(false);
  React.useEffect(() => {
    const windowWidth = window.screen.width;

    if (windowWidth < 1199) {
      setMobile(true);
    }
  });
  const classNames = ['t-video-player-card'];

  if (onHover) {
    classNames.push('cardHover');
  }

  return React.createElement("div", {
    style: {
      height: `${height}`
    },
    className: classNames.join(' ')
  }, React.createElement("div", {
    className: "t-video-info-wrapper"
  }, React.createElement("img", {
    src: img$3,
    alt: "light"
  }), React.createElement("div", {
    className: "t-video-info-text-wrapper"
  }, React.createElement(TText, {
    textColor: "indicator-caution",
    level: 1,
    paddingBottom: 3,
    bold: true
  }, title), React.createElement(TText, {
    level: 3,
    rows: 2
  }, description))), React.createElement("div", {
    className: "t-video-card"
  }, React.createElement(TVideoPlayer, {
    href: href,
    width: !mobile ? '12vw' : '230px',
    height: "120px"
  })));
};

const IconLeftRightArrow = _a => {
  var props = __rest(_a, []);
  return React.createElement(Icon, Object.assign({}, props), React.createElement("path", {
    d: "M21.9199 11.62C21.8723 11.4972 21.8009 11.3851 21.7099 11.29L19.2099 8.79C19.0216 8.6017 18.7662 8.49591 18.4999 8.49591C18.2336 8.49591 17.9782 8.6017 17.7899 8.79C17.6016 8.9783 17.4958 9.2337 17.4958 9.5C17.4958 9.7663 17.6016 10.0217 17.7899 10.21L18.5899 11H15.9999C15.7347 11 15.4803 11.1054 15.2928 11.2929C15.1053 11.4804 14.9999 11.7348 14.9999 12C14.9999 12.2652 15.1053 12.5196 15.2928 12.7071C15.4803 12.8946 15.7347 13 15.9999 13H18.5899L17.7899 13.79C17.6962 13.883 17.6218 13.9936 17.571 14.1154C17.5202 14.2373 17.4941 14.368 17.4941 14.5C17.4941 14.632 17.5202 14.7627 17.571 14.8846C17.6218 15.0064 17.6962 15.117 17.7899 15.21C17.8829 15.3037 17.9935 15.3781 18.1153 15.4289C18.2372 15.4797 18.3679 15.5058 18.4999 15.5058C18.6319 15.5058 18.7626 15.4797 18.8845 15.4289C19.0063 15.3781 19.1169 15.3037 19.2099 15.21L21.7099 12.71C21.8009 12.6149 21.8723 12.5028 21.9199 12.38C22.0199 12.1365 22.0199 11.8635 21.9199 11.62ZM7.9999 11H5.4099L6.2099 10.21C6.3982 10.0217 6.50399 9.7663 6.50399 9.5C6.50399 9.2337 6.3982 8.9783 6.2099 8.79C6.02159 8.6017 5.7662 8.49591 5.4999 8.49591C5.23359 8.49591 4.9782 8.6017 4.7899 8.79L2.2899 11.29C2.19886 11.3851 2.12749 11.4972 2.0799 11.62C1.97988 11.8635 1.97988 12.1365 2.0799 12.38C2.12749 12.5028 2.19886 12.6149 2.2899 12.71L4.7899 15.21C4.88286 15.3037 4.99346 15.3781 5.11532 15.4289C5.23718 15.4797 5.36788 15.5058 5.4999 15.5058C5.63191 15.5058 5.76261 15.4797 5.88447 15.4289C6.00633 15.3781 6.11693 15.3037 6.2099 15.21C6.30362 15.117 6.37802 15.0064 6.42879 14.8846C6.47956 14.7627 6.50569 14.632 6.50569 14.5C6.50569 14.368 6.47956 14.2373 6.42879 14.1154C6.37802 13.9936 6.30362 13.883 6.2099 13.79L5.4099 13H7.9999C8.26511 13 8.51947 12.8946 8.707 12.7071C8.89454 12.5196 8.9999 12.2652 8.9999 12C8.9999 11.7348 8.89454 11.4804 8.707 11.2929C8.51947 11.1054 8.26511 11 7.9999 11V11ZM11.9999 7C11.7347 7 11.4803 7.10536 11.2928 7.29289C11.1053 7.48043 10.9999 7.73478 10.9999 8V16C10.9999 16.2652 11.1053 16.5196 11.2928 16.7071C11.4803 16.8946 11.7347 17 11.9999 17C12.2651 17 12.5195 16.8946 12.707 16.7071C12.8945 16.5196 12.9999 16.2652 12.9999 16V8C12.9999 7.73478 12.8945 7.48043 12.707 7.29289C12.5195 7.10536 12.2651 7 11.9999 7Z",
    fill: "#262626"
  }));
};

const img$6 = "data:image/png;base64,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";

var css_248z$L = ".t-tasksListItem {\n  display: flex;\n  border-bottom: 1px solid #eaeaeb;\n  padding: 16px;\n  border-right: 4px solid transparent;\n}\n.t-tasksListItem .t-avatar-wrapper {\n  padding-right: 16px;\n}\n.t-tasksListItem .t-tasks-assigned-wrapper {\n  display: flex;\n  align-items: center;\n}\n.t-tasksListItem .t-tasks-assigned-wrapper .t-icon-leftTight-wrapper {\n  margin: 0 8px 0 8px;\n}\n.t-tasksListItem .t-content-row {\n  width: 100%;\n  padding-right: 4px;\n}\n@media screen and (max-width: 479px) {\n  .t-tasksListItem {\n    flex-direction: column;\n  }\n}\n.t-tasksListItem .t-content-info p p {\n  margin: 0px;\n}\n.t-tasksListItem .t-infoContainer {\n  margin-right: 8px;\n  width: 70%;\n}\n@media screen and (max-width: 479px) {\n  .t-tasksListItem .t-infoContainer {\n    width: 100%;\n  }\n}\n.t-tasksListItem .t-infoContainer .t-authorName {\n  color: var(--text-dark-50, #909091);\n  font-size: 13px;\n}\n.t-tasksListItem .t-statusContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 30%;\n}\n@media screen and (max-width: 479px) {\n  .t-tasksListItem .t-statusContainer {\n    justify-content: initial;\n    width: 100%;\n  }\n}\n.t-tasksListItem:hover {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n  cursor: pointer;\n}\n";
styleInject(css_248z$L);

const TTasksListItem = ({
  title,
  author,
  status = StatusType.SUCCESS,
  statusText = 'Success',
  image,
  description,
  section,
  assignedBy,
  assignee,
  onItemClick
}) => {
  return React.createElement("div", {
    className: "t-tasksListItem",
    onClick: onItemClick
  }, React.createElement("div", {
    className: "t-avatar-wrapper"
  }, React.createElement(TAvatar, {
    src: image || img$6,
    size: "lm"
  })), React.createElement(_Row, {
    className: "t-content-row"
  }, React.createElement(_Col, {
    span: 18,
    className: "t-content-info"
  }, React.createElement(TText, {
    rows: 2,
    level: 2,
    bold: true,
    paddingBottom: 3
  }, section.title), React.createElement(TText, {
    rows: 2,
    level: 3,
    textColor: "dark-50",
    innerText: description || 'There is no description',
    paddingBottom: 2
  }), React.createElement("div", {
    className: "t-tasks-assigned-wrapper"
  }, !isEmpty(assignedBy) && React.createElement(TAvatar, {
    src: assignedBy.image,
    size: "xs",
    name: assignedBy.fullName,
    text: assignedBy.fullName,
    textLevel: 3,
    avatarColor: "indicator-neutral"
  }), !isEmpty(assignee) && !isEmpty(assignedBy) && React.createElement("div", {
    className: "t-icon-leftTight-wrapper"
  }, React.createElement(IconLeftRightArrow, {
    size: "sm"
  })), !isEmpty(assignee) && React.createElement(TAvatar, {
    src: assignee.image,
    size: "xs",
    name: assignee.fullName,
    text: assignee.fullName,
    textLevel: 3,
    avatarColor: "indicator-neutral"
  }))), React.createElement(_Col, {
    span: 6,
    className: "t-statusContainer"
  }, React.createElement(TBadge, {
    status: status,
    statusText: statusText
  }))));
};

const TTasksCardList = ({
  title,
  seeAllLink,
  tasks = [],
  loading = false,
  height,
  fallback,
  onItemClick,
  onHover
}) => {
  return React.createElement(TCardList, {
    title: title,
    seeAllLink: seeAllLink,
    loading: loading,
    height: height,
    fallback: fallback,
    onHover: onHover
  }, tasks.map((item, index) => React.createElement(TTasksListItem, {
    key: index,
    statusText: item.status,
    assignee: item.assignee,
    assignedBy: item.assignedBy,
    section: item,
    image: item.image,
    description: item.description,
    onItemClick: event => {
      onItemClick && onItemClick(item);
    }
  })));
};

var css_248z$M = ".t-dataTableCard-container {\n  border-radius: 8px;\n  border: 1px solid #f2f2f3;\n  box-shadow: 0 2px 4px rgba(119, 110, 171, 0.12);\n}\n.t-dataTableCard-container .t-card-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f2f2f3;\n  border-top-left-radius: var(--border-radius, 8px);\n  border-top-right-radius: var(--border-radius, 8px);\n  padding: 16px 16px 16px 24px;\n}\n.t-dataTableCard-container .t-card-title .t-card-title-text {\n  font-size: 20px;\n  color: var(--text-dark-100, #262626);\n  margin-right: 16px;\n}\n.t-dataTableCard-container .t-card-title a {\n  font-size: 13px;\n  color: var(--text-dark-20, #d0d0d1);\n}\n.t-dataTableCard-container .t-card-title a:hover {\n  color: var(--primary-color, #f54e95);\n}\n.t-dataTableCard-container .t-card-table-footer {\n  padding: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n.t-dataTableCard-container .t-data-table-card-cursor-pointer .ant-table-row {\n  cursor: pointer;\n}\n.t-dataTableCard-container .ant-card {\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  overflow: auto;\n}\n.t-dataTableCard-container .ant-card .t-card-fallback,\n.t-dataTableCard-container .ant-card .t-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n";
styleInject(css_248z$M);

const TDataTableCard = ({
  title,
  seeAllLink,
  height,
  data,
  columns,
  pagination,
  seeMoreLink,
  fallback,
  loading = false,
  noPadding,
  rowKey = 'id',
  cursorPointer,
  onRowClick = () => {},
  onItemClick = () => {}
}) => {
  const classnames = [cursorPointer && 't-data-table-card-cursor-pointer'];
  return React.createElement("div", {
    className: "t-dataTableCard-container",
    onClick: onItemClick
  }, React.createElement("div", {
    className: "t-card-title"
  }, React.createElement(TText, {
    rows: 1,
    level: 1,
    bold: true
  }, title), seeAllLink && React.createElement(TText, {
    level: 3,
    textColor: "dark-20"
  }, seeAllLink)), React.createElement(_Card, {
    style: {
      height: height || 'auto'
    },
    bodyStyle: {
      padding: noPadding ? '0' : '16px'
    }
  }, React.createElement(React.Fragment, null, loading ? React.createElement(TLoading, null) : !isEmpty(data) ? React.createElement(_Table, {
    rowKey: rowKey,
    className: classnames.join(' '),
    pagination: pagination,
    dataSource: data,
    columns: columns,
    onRow: record => {
      return {
        onClick: () => onRowClick(record)
      };
    }
  }) : React.createElement("div", {
    className: "t-card-fallback"
  }, fallback))), React.createElement("div", {
    className: "t-card-table-footer"
  }, seeMoreLink));
};

const img$7 = "data:image/png;base64,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";

const img$8 = "data:image/png;base64,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";

const img$9 = "data:image/png;base64,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";

var css_248z$N = ".t-messages-list-item {\n  cursor: pointer;\n  box-sizing: border-box;\n  display: flex;\n  height: 117px;\n  border-bottom: 1px solid #eaeaeb;\n  border-right: 4px solid transparent;\n  padding: 16px;\n}\n@media screen and (max-width: 767px) {\n  .t-messages-list-item {\n    padding: 8px 32px 16px 32px;\n  }\n}\n.t-messages-list-item .t-avatar-container .t-avatar-wrapper {\n  margin-right: 16px;\n}\n.t-messages-list-item .t-avatar-container .t-avatar-group-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.t-messages-list-item .t-avatar-container .t-avatar-group-wrapper .ant-avatar {\n  background: #9696ff;\n}\n.t-messages-list-item .t-content-wrapper {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.t-messages-list-item .t-content-wrapper .t-content-info {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  text-align: left;\n}\n.t-messages-list-item .t-content-wrapper .t-content-info p {\n  word-break: break-all;\n}\n.t-messages-list-item .t-content-wrapper .t-content-info .t-authorName {\n  color: var(--text-dark-50, #909091);\n  font-size: 13px;\n}\n.t-messages-list-item .t-content-wrapper .t-time-viewer-container {\n  width: 100%;\n  text-align: right;\n}\n.t-messages-list-item .t-content-wrapper .t-time-viewer-container p {\n  color: #e6e6e7;\n}\n@media screen and (max-width: 767px) {\n  .t-messages-list-item .t-content-wrapper {\n    flex-wrap: wrap;\n  }\n  .t-messages-list-item .t-content-wrapper .t-content-info {\n    flex-basis: 100%;\n  }\n  .t-messages-list-item .t-content-wrapper .t-content-date {\n    flex-basis: 100%;\n  }\n  .t-messages-list-item .t-content-wrapper .t-content-date .t-time-viewer-container {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n}\n.t-messages-list-item:hover,\n.t-messages-list-item-active {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n}\n.t-messages-list-item.t-messages-list-item-closed .t-avatar-wrapper,\n.t-messages-list-item.t-messages-list-item-closed .t-text {\n  opacity: 0.5;\n}\n.t-messages-list-item.t-messages-list-item-closed .t-text.t-body2 {\n  text-decoration: line-through;\n}\n";
styleInject(css_248z$N);

const getMessageText = (text, type) => {
  if (!type) {
    return text;
  }

  if (['audio', 'video', 'image'].includes(type)) {
    return `[${type}]`;
  }

  return '[attachment]';
};

const TMessageListItem = ({
  channel,
  onClick = () => {},
  noMessagesText
}) => {
  const groupDefaultImages = [img$9, img$8];

  const renderAvatar = () => {
    if (channel.avatar !== '') {
      return React.createElement(TAvatar, {
        src: channel.avatar,
        size: "md"
      }, channel.avatarAlt);
    }

    if (!!channel.type && channel.type === 'group') {
      return React.createElement(TAvatarGroup, {
        size: "xs"
      }, groupDefaultImages && groupDefaultImages.map((item, index) => {
        return React.createElement(TAvatar, {
          src: item,
          key: index,
          alt: `${index}`,
          size: "xs"
        });
      }));
    }

    return React.createElement(TAvatar, {
      src: img$7,
      size: "md"
    }, channel.avatarAlt);
  };

  const {
    author,
    type,
    text,
    date
  } = (channel === null || channel === void 0 ? void 0 : channel.lastMessage) || {};
  return React.createElement("div", {
    className: ['t-messages-list-item', channel.closed ? 't-messages-list-item-closed' : ''].join(' '),
    onClick: e => onClick(e, channel)
  }, React.createElement("div", {
    style: {
      marginRight: 12
    }
  }, renderAvatar()), React.createElement("div", {
    className: "t-content-wrapper"
  }, React.createElement("div", {
    className: "t-content-info"
  }, React.createElement(TText, {
    rows: 1,
    level: 2,
    bold: true,
    paddingBottom: 3
  }, channel.title), text ? React.createElement("div", {
    style: {
      minWidth: '100%'
    }
  }, React.createElement(TText, {
    rows: 1,
    level: 3
  }, React.createElement("span", {
    className: "t-authorName"
  }, author, ": "), getMessageText(text, type))) : React.createElement(TText, {
    textColor: "dark-20",
    rows: 1,
    level: 3
  }, noMessagesText)), React.createElement("div", {
    className: "t-content-date"
  }, React.createElement(TimeViewer, {
    fromNow: true,
    start: date
  }))));
};

var css_248z$O = ".t-conv-message-item-container {\n  display: flex;\n  flex-direction: column;\n}\n.t-conv-message-container {\n  display: flex;\n  padding: 16px;\n  text-align: initial;\n}\n.t-conv-message-container .t-chatApp-conv-message-wrapper {\n  width: 100%;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n.t-conv-message-container .t-chatApp-conv-message-avatar {\n  margin-right: 16px;\n}\n.chatApp__convMessageValue {\n  width: 100%;\n}\n.chatApp__convMessageValue .t-conv-message-text {\n  background: #f7f7f8;\n  border-radius: 4px 4px 20px 8px;\n  max-width: 450px;\n  width: fit-content;\n  margin-left: 0;\n}\n.chatApp__convMessageValue .t-conv-message-text pre {\n  margin-bottom: 0;\n  white-space: pre-wrap;\n  padding: 12px;\n  word-break: break-all;\n}\n.chatApp__convMessageValue .t-conv-message-text-replied {\n  background: #e9e9f0;\n}\n.chatApp__convMessageValue .chatApp__convMessageHeader {\n  display: flex;\n}\n.chatApp__convMessageValue .chatApp__convMessageHeader .chatApp__convMessageHeaderText {\n  font-weight: 500;\n}\n.chatApp__convMessageValue .chatApp__convMessageHeader .chatApp__convMessageDate {\n  font-size: 13;\n  font-weight: 400;\n  color: #909091;\n  margin: 0 8px;\n}\n.chatApp__convMessageValue img,\n.chatApp__convMessageValue audio,\n.chatApp__convMessageValue video {\n  max-width: 400px;\n  width: 100%;\n}\n.t-chatApp-message-seen-avatars-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n}\n.t-chatApp-message-seen-avatars-wrapper .t-chatApp-message-seen-avatar {\n  margin: 0 1px;\n}\n.t-chatApp-message-seen-names-wrapper {\n  max-width: fit-content;\n}\n.t-chatApp-message-seen-names-wrapper .t-chatApp-message-seen-name {\n  font-size: 13px;\n  color: 'gray';\n}\n.t-conv-message-container-right {\n  display: flex;\n  flex-direction: row-reverse;\n  padding: 16px;\n  text-align: initial;\n}\n.t-conv-message-container-right .t-chatApp-conv-message-wrapper {\n  width: 100%;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n.t-conv-message-container-right .t-chatApp-conv-message-wrapper .t-chatApp-message-seen-names-wrapper {\n  max-width: fit-content;\n  text-align: right;\n}\n.t-conv-message-container-right .t-chatApp-conv-message-wrapper .t-chatApp-message-seen-avatars-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n.t-conv-message-container-right .t-chatApp-conv-message-avatar {\n  margin-left: 16px;\n}\n.t-conv-message-container-right .t-conv-replied-message {\n  margin-left: auto;\n}\n.t-conv-message-container-right .t-conv-message-text {\n  border-radius: 4px 4px 20px 8px;\n  max-width: 450px;\n  width: fit-content;\n  margin-left: auto;\n}\n.t-conv-message-container-right .t-conv-message-text-replied {\n  background: #e9e9f0;\n}\n.t-avatar-with-text-container {\n  align-items: flex-start;\n}\n.t-conv-replied-message {\n  background: #f7f7f8;\n  border-radius: 4px 4px 20px 8px;\n  max-width: 450px;\n  width: fit-content;\n  padding: 12px 12px 24px;\n  margin-bottom: -23px;\n  color: #bbbbbc;\n}\n.t-conv-message-text-link {\n  margin-bottom: 0;\n  white-space: pre-wrap;\n  padding: 12px;\n  word-break: break-all;\n}\n";
styleInject(css_248z$O);

const TMessageItem = ({
  message,
  getMessage,
  renderSeenNames
}) => {
  const [seenNamesVisible, setSeenNamesVisible] = useState(false);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "t-conv-message-container-right"
  }, React.createElement("div", {
    className: "t-chatApp-conv-message-wrapper"
  }, React.createElement("div", {
    className: "chatApp__convMessageValue"
  }, React.createElement("p", {
    className: "chatApp__convMessageHeader"
  }, !isEmpty(message.repliedMessage) && React.createElement(React.Fragment, null, React.createElement(IconForward, {
    fill: "currentcolor",
    size: "s"
  }), "\u00A0", React.createElement("span", {
    className: "chatApp__convMessageHeaderText"
  }, "You replied to ", message.repliedMessage.sender.name, ' ')), message.edited && React.createElement("small", null, "(edited)")), !isEmpty(message.repliedMessage) && React.createElement("div", {
    className: "t-conv-replied-message"
  }, message.repliedMessage.text), React.createElement(_Tooltip, {
    placement: "left",
    title: React.createElement("span", {
      className: "chatApp__convMessageDate"
    }, message.date ? moment$1(message.date).format('MMM DD HH:mm') : '')
  }, getMessage()), seenNamesVisible && renderSeenNames(), React.createElement("div", {
    className: "t-chatApp-message-seen-avatars-wrapper",
    onClick: () => setSeenNamesVisible(!seenNamesVisible)
  }, (message.seen || []).map((user, index) => React.createElement("div", {
    key: index
  }, React.createElement(TAvatar, {
    className: "t-chatApp-message-seen-avatar",
    src: user.avatar,
    name: user.name,
    size: "xxs"
  }))))))));
};

const TMessageItem$1 = ({
  message,
  getMessage,
  renderSeenNames
}) => {
  const [seenNamesVisible, setSeenNamesVisible] = useState(false);
  return React.createElement("div", {
    className: "t-conv-message-item-container"
  }, React.createElement("div", {
    className: "t-conv-message-container"
  }, React.createElement(TAvatar, {
    src: message.sender.avatar,
    name: message.sender.name,
    className: "t-chatApp-conv-message-avatar"
  }), React.createElement("div", {
    className: "t-chatApp-conv-message-wrapper"
  }, React.createElement("div", {
    className: "chatApp__convMessageValue"
  }, React.createElement("p", {
    className: "chatApp__convMessageHeader"
  }, !isEmpty(message.repliedMessage) ? React.createElement(React.Fragment, null, React.createElement(IconForward, {
    fill: "currentcolor",
    size: "s"
  }), "\u00A0", React.createElement("span", {
    className: "chatApp__convMessageHeaderText"
  }, message.sender.name, " replied to", ' ', message.repliedMessage.sender.name), ' ') : React.createElement("span", {
    className: "chatApp__convMessageHeaderText"
  }, message.sender.name), message.edited && React.createElement("small", null, "(edited)")), !isEmpty(message.repliedMessage) && React.createElement("div", {
    className: "t-conv-replied-message"
  }, message.repliedMessage.text), React.createElement(_Tooltip, {
    placement: "left",
    title: React.createElement("span", {
      className: "chatApp__convMessageDate"
    }, message.date ? moment$1(message.date).format('MMM DD HH:mm') : '')
  }, getMessage()), seenNamesVisible && renderSeenNames(), React.createElement("div", {
    className: "t-chatApp-message-seen-avatars-wrapper",
    onClick: () => setSeenNamesVisible(!seenNamesVisible)
  }, (message.seen || []).map((user, index) => React.createElement("div", {
    key: index
  }, React.createElement(TAvatar, {
    className: "t-chatApp-message-seen-avatar",
    src: user.avatar,
    name: user.name,
    size: "xxs"
  }))))))));
};

const TMessageItem$2 = ({
  message,
  isMe
}) => {
  const getMessage = () => {
    switch (message.type) {
      case 'image':
        {
          return React.createElement("img", {
            alt: "img",
            src: message.text
          });
        }

      case 'audio':
        {
          return React.createElement(React.Fragment, null, React.createElement("audio", {
            controls: true,
            src: message.text
          }, "\u00AF\\_(\u30C4)_/\u00AF"), message.fileName && React.createElement("div", null, message.fileName));
        }

      case 'video':
        {
          return React.createElement("video", {
            controls: true,
            src: message.text
          }, "\u00AF\\_(\u30C4)_/\u00AF");
        }

      case 'attachment':
        {
          return React.createElement("a", {
            href: message.text
          }, message.text);
        }

      case 'link':
        {
          const urlify = text => {
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, url => {
              return `<a href=${url}">${url}</a>`;
            });
          };

          const html = urlify(message.text);
          return React.createElement("div", {
            className: ['t-conv-message-text', 't-conv-message-text-link'].join(' '),
            dangerouslySetInnerHTML: {
              __html: html
            }
          });
        }

      default:
        {
          const classNames = ['t-conv-message-text'];

          if (!isEmpty(message.repliedMessage)) {
            classNames.push('t-conv-message-text-replied');
          }

          return React.createElement("div", {
            className: classNames.join(' ')
          }, React.createElement("pre", null, message.text));
        }
    }
  };

  const renderSeenNames = () => {
    return React.createElement("div", {
      className: "t-chatApp-message-seen-names-wrapper"
    }, message.seen.map((item, index) => React.createElement("span", {
      style: {
        color: 'gray'
      },
      className: "t-chatApp-message-seen-name",
      key: index
    }, item.name, message.seen.length - 1 != index && ', ')));
  };

  const renderMessages = () => {
    if (isMe) {
      return React.createElement(TMessageItem, {
        message: message,
        getMessage: getMessage,
        renderSeenNames: renderSeenNames
      });
    }

    return React.createElement(TMessageItem$1, {
      message: message,
      getMessage: getMessage,
      renderSeenNames: renderSeenNames
    });
  };

  return React.createElement(React.Fragment, null, renderMessages());
};

const TMessage = ({
  sender,
  message,
  getActiveMessage,
  getForwardedMessage,
  getRepliedMessage,
  handleRemoveMessage,
  actions,
  setModalVisible
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  const isMe = message.sender.id === sender.id;
  const menu = React.createElement(_Menu, {
    onClick: e => {
      switch (e.key) {
        case 'update':
          getActiveMessage(message);
          break;

        case 'delete':
          handleRemoveMessage(message.id);
          break;

        case 'forward':
          getForwardedMessage(message);
          setModalVisible(true);
          break;
      }
    },
    className: "t-dropdown-menu"
  }, (actions === null || actions === void 0 ? void 0 : actions.update) && React.createElement(_Menu.Item, {
    key: "update",
    disabled: !isMe || !message.id
  }, translate('ui.message.update')), (actions === null || actions === void 0 ? void 0 : actions.delete) && React.createElement(_Menu.Item, {
    key: "delete",
    disabled: !isMe || !message.id
  }, translate('ui.message.remove')), (actions === null || actions === void 0 ? void 0 : actions.forward) && React.createElement(_Menu.Item, {
    key: "forward"
  }, translate('Forward')));
  return React.createElement("div", {
    className: !isMe ? 'chatApp__convMessageItemContainer' : 'chatApp__convMessageItemContainer-right'
  }, React.createElement(TMessageItem$2, {
    message: message,
    isMe: isMe
  }), React.createElement("div", {
    className: "chatApp__message-actions"
  }, React.createElement("div", {
    className: "chatApp__convMessageItem-action",
    onClick: () => getRepliedMessage(message)
  }, React.createElement(IconForward, {
    size: "s"
  })), !isEmpty(actions) && React.createElement(TDropdown, {
    overlay: menu
  }, React.createElement("div", {
    className: "chatApp__convMessageItem-action"
  }, React.createElement(IconMoreActions, {
    size: "s"
  })))));
};

var Message = withLocalization(TMessage);

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof commonjsGlobal !== "undefined") {
    win = commonjsGlobal;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

var window_1 = win;

var nav;

if (typeof navigator !== 'undefined') {
  nav = navigator;
} else {
  nav = {};
}

var navigator_1 = nav;

// Copied from https://github.com/chris-rudmin/Recorderjs

var waveEncoder = () => {
  let BYTES_PER_SAMPLE = 2;

  let recorded = [];

  function encode (buffer) {
    let length = buffer.length;
    let data = new Uint8Array(length * BYTES_PER_SAMPLE);
    for (let i = 0; i < length; i++) {
      let index = i * BYTES_PER_SAMPLE;
      let sample = buffer[i];
      if (sample > 1) {
        sample = 1;
      } else if (sample < -1) {
        sample = -1;
      }
      sample = sample * 32768;
      data[index] = sample;
      data[index + 1] = sample >> 8;
    }
    recorded.push(data);
  }

  function dump (sampleRate) {
    let bufferLength = recorded.length ? recorded[0].length : 0;
    let length = recorded.length * bufferLength;
    let wav = new Uint8Array(44 + length);
    let view = new DataView(wav.buffer);

    // RIFF identifier 'RIFF'
    view.setUint32(0, 1380533830, false);
    // file length minus RIFF identifier length and file description length
    view.setUint32(4, 36 + length, true);
    // RIFF type 'WAVE'
    view.setUint32(8, 1463899717, false);
    // format chunk identifier 'fmt '
    view.setUint32(12, 1718449184, false);
    // format chunk length
    view.setUint32(16, 16, true);
    // sample format (raw)
    view.setUint16(20, 1, true);
    // channel count
    view.setUint16(22, 1, true);
    // sample rate
    view.setUint32(24, sampleRate, true);
    // byte rate (sample rate * block align)
    view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true);
    // block align (channel count * bytes per sample)
    view.setUint16(32, BYTES_PER_SAMPLE, true);
    // bits per sample
    view.setUint16(34, 8 * BYTES_PER_SAMPLE, true);
    // data chunk identifier 'data'
    view.setUint32(36, 1684108385, false);
    // data chunk length
    view.setUint32(40, length, true);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let i = 0; i < recorded.length; i++) {
      wav.set(recorded[i], i * bufferLength + 44);
    }

    recorded = [];
    postMessage(wav.buffer, [wav.buffer]);
  }

  onmessage = e => {
    if (e.data[0] === 'encode') {
      encode(e.data[1]);
    } else if (e.data[0] === 'dump') {
      dump(e.data[1]);
    }
  };
};

let AudioContext = window_1.AudioContext || window_1.webkitAudioContext;

function createWorker (fn) {
  let js = fn
    .toString()
    .replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, '')
    .replace(/}$/, '');
  let blob = new Blob([js]);
  return new Worker(URL.createObjectURL(blob))
}

function error (method) {
  let event = new Event('error');
  event.data = new Error('Wrong state for ' + method);
  return event
}

let context, processor;

/**
 * Audio Recorder with MediaRecorder API.
 *
 * @example
 * navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
 *   let recorder = new MediaRecorder(stream)
 * })
 */
class MediaRecorder {
  /**
   * @param {MediaStream} stream The audio stream to record.
   */
  constructor (stream, config = null) {
    /**
     * The `MediaStream` passed into the constructor.
     * @type {MediaStream}
     */
    this.stream = stream;
    this.config = config;
    /**
     * The current state of recording process.
     * @type {"inactive"|"recording"|"paused"}
     */
    this.state = 'inactive';

    this.em = document.createDocumentFragment();
    this.encoder = createWorker(MediaRecorder.encoder);

    let recorder = this;
    this.encoder.addEventListener('message', e => {
      let event = new Event('dataavailable');
      event.data = new Blob([e.data], { type: recorder.mimeType });
      recorder.em.dispatchEvent(event);
      if (recorder.state === 'inactive') {
        recorder.em.dispatchEvent(new Event('stop'));
      }
    });
  }

  /**
   * Begins recording media.
   *
   * @param {number} [timeslice] The milliseconds to record into each `Blob`.
   *                             If this parameter isn’t included, single `Blob`
   *                             will be recorded.
   *
   * @return {undefined}
   *
   * @example
   * recordButton.addEventListener('click', () => {
   *   recorder.start()
   * })
   */
  start (timeslice) {
    if (this.state !== 'inactive') {
      return this.em.dispatchEvent(error('start'))
    }

    this.state = 'recording';

    if (!context) {
      context = new AudioContext(this.config);
    }
    this.clone = this.stream.clone();
    this.input = context.createMediaStreamSource(this.clone);

    if (!processor) {
      processor = context.createScriptProcessor(2048, 1, 1);
    }

    let recorder = this;

    recorder.encoder.postMessage(['init', context.sampleRate]);

    processor.onaudioprocess = function (e) {
      if (recorder.state === 'recording') {
        recorder.encoder.postMessage([
          'encode',
          e.inputBuffer.getChannelData(0)
        ]);
      }
    };

    this.input.connect(processor);
    processor.connect(context.destination);

    this.em.dispatchEvent(new Event('start'));

    if (timeslice) {
      this.slicing = setInterval(() => {
        if (recorder.state === 'recording') recorder.requestData();
      }, timeslice);
    }

    return undefined
  }

  /**
   * Stop media capture and raise `dataavailable` event with recorded data.
   *
   * @return {undefined}
   *
   * @example
   * finishButton.addEventListener('click', () => {
   *   recorder.stop()
   * })
   */
  stop () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error('stop'))
    }

    this.requestData();
    this.state = 'inactive';
    this.clone.getTracks().forEach(track => {
      track.stop();
    });
    this.input.disconnect();
    return clearInterval(this.slicing)
  }

  /**
   * Pauses recording of media streams.
   *
   * @return {undefined}
   *
   * @example
   * pauseButton.addEventListener('click', () => {
   *   recorder.pause()
   * })
   */
  pause () {
    if (this.state !== 'recording') {
      return this.em.dispatchEvent(error('pause'))
    }

    this.state = 'paused';
    return this.em.dispatchEvent(new Event('pause'))
  }

  /**
   * Resumes media recording when it has been previously paused.
   *
   * @return {undefined}
   *
   * @example
   * resumeButton.addEventListener('click', () => {
   *   recorder.resume()
   * })
   */
  resume () {
    if (this.state !== 'paused') {
      return this.em.dispatchEvent(error('resume'))
    }

    this.state = 'recording';
    return this.em.dispatchEvent(new Event('resume'))
  }

  /**
   * Raise a `dataavailable` event containing the captured media.
   *
   * @return {undefined}
   *
   * @example
   * this.on('nextData', () => {
   *   recorder.requestData()
   * })
   */
  requestData () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error('requestData'))
    }

    return this.encoder.postMessage(['dump', context.sampleRate])
  }

  /**
   * Add listener for specified event type.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The listener function.
   *
   * @return {undefined}
   *
   * @example
   * recorder.addEventListener('dataavailable', e => {
   *   audio.src = URL.createObjectURL(e.data)
   * })
   */
  addEventListener (...args) {
    this.em.addEventListener(...args);
  }

  /**
   * Remove event listener.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The same function used in `addEventListener`.
   *
   * @return {undefined}
   */
  removeEventListener (...args) {
    this.em.removeEventListener(...args);
  }

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {Event} event The event object.
   *
   * @return {boolean} Is event was no canceled by any listener.
   */
  dispatchEvent (...args) {
    this.em.dispatchEvent(...args);
  }
}

/**
 * The MIME type that is being used for recording.
 * @type {string}
 */
MediaRecorder.prototype.mimeType = 'audio/wav';

/**
 * Returns `true` if the MIME type specified is one the polyfill can record.
 *
 * This polyfill supports `audio/wav` and `audio/mpeg`.
 *
 * @param {string} mimeType The mimeType to check.
 *
 * @return {boolean} `true` on `audio/wav` and `audio/mpeg` MIME type.
 */
MediaRecorder.isTypeSupported = mimeType => {
  return MediaRecorder.prototype.mimeType === mimeType
};

/**
 * `true` if MediaRecorder can not be polyfilled in the current browser.
 * @type {boolean}
 *
 * @example
 * if (MediaRecorder.notSupported) {
 *   showWarning('Audio recording is not supported in this browser')
 * }
 */
MediaRecorder.notSupported = !navigator_1.mediaDevices || !AudioContext;

/**
 * Converts RAW audio buffer to compressed audio files.
 * It will be loaded to Web Worker.
 * By default, WAVE encoder will be used.
 * @type {function}
 *
 * @example
 * MediaRecorder.prototype.mimeType = 'audio/ogg'
 * MediaRecorder.encoder = oggEncoder
 */
MediaRecorder.encoder = waveEncoder;

var css_248z$P = ".t-voice-recorder-container .t-voice-recorder-wrapper {\n  background: #f7f7f8;\n  border-radius: var(--border-radius, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  height: 40px;\n}\n.t-voice-recorder-container .active {\n  cursor: pointer;\n}\n.t-voice-recorder-container .active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-voice-recorder-container .disabled {\n  cursor: unset;\n}\n.t-voice-recorder-container .disabled svg path {\n  fill: var(--text-dark-20, #d0d0d1);\n}\n.t-voice-recorder-container .svgDefault {\n  cursor: pointer;\n}\n.t-voice-recorder-container .svgDefault svg path {\n  stroke: #fbfbfc;\n  fill: var(--text-dark-20, #d0d0d1);\n}\n.t-voice-recorder-disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.4;\n}\n";
styleInject(css_248z$P);

const TVoiceRecorder = ({
  folderName = 'voiceRecorder',
  size,
  onUpload,
  handleSuccess = item => {
    console.log(item, '< ITEM');
  },
  handleError = err => {
    console.log(err, '< ERROR');

    _message.error(err.message);
  },
  disabled
}) => {
  const [recording, setRecording] = React.useState(false);
  const recorder = React.useRef(null);

  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({
      audio: true
    }).then(stream => {
      recorder.current = new MediaRecorder(stream);
      recorder.current.start();
      recorder.current.addEventListener('dataavailable', item => saveRecord(item));
    });
    setRecording(true);
  };

  const saveRecord = e => {
    const file = new File([e.data], 'file', {
      type: e.data.type,
      lastModified: Date.now()
    });
    const uploadOptions = {
      fileList: [file],
      file,
      folder: folderName,
      type: file.type.split('/').pop(),
      filename: file.name,
      headers: {
        'X-Requested-With': null
      },
      withCredentials: true
    };
    onUpload(uploadOptions).then(item => {
      handleSuccess(file, item);
    }).catch(err => handleError(err));
  };

  const stopRecording = () => {
    if (!recorder.current) {
      setRecording(false);
      return null;
    }

    recorder.current.stop();
    const [track] = recorder.current.stream.getTracks();

    if (!track) {
      setRecording(false);
      return null;
    }

    track.stop();
    setRecording(false);
  };

  return React.createElement("div", {
    className: ['t-voice-recorder-container', disabled ? 't-voice-recorder-disabled' : ''].join(' ')
  }, React.createElement("div", {
    className: ['t-voice-recorder-wrapper', MediaRecorder.notSupported ? 'disabled' : recording ? 'active' : 'stopped'].join(' ')
  }, React.createElement(IconVoice, {
    size: size,
    onClick: () => !disabled && (recording ? stopRecording() : startRecording())
  })));
};

var css_248z$Q = ".t-upload-container {\n  background: #f7f7f8;\n  border-radius: var(--border-radius, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  height: 40px;\n}\n.t-upload-container .svgDefault svg path {\n  stroke: #fbfbfc;\n  fill: var(--text-dark-20, #d0d0d1);\n}\n.t-upload-disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.4;\n}\n";
styleInject(css_248z$Q);

const TUpload = ({
  children,
  folderName = 'fileUpload',
  onUpload,
  handleSuccess = item => {
    console.log(item, '< ITEM');
  },
  handleError = err => {
    _message.error(err.message);
  },
  disabled
}) => {
  const handleUpload = data => {
    const {
      file,
      fileList
    } = data;
    const uploadData = {
      fileList,
      file,
      folder: folderName,
      type: file.type.split('/').pop(),
      filename: 'file'
    };
    onUpload(uploadData).then(item => {
      const url = item.url || item.path;
      handleSuccess(file, item);
    }).catch(err => handleError(err));
  };

  const uploadProps = {
    multiple: false,
    showUploadList: false,
    headers: {
      'X-Requested-With': null
    },
    withCredentials: true,
    customRequest: handleUpload // onChange: handleUpload,

  };
  return React.createElement("div", {
    className: ['t-upload-container', disabled ? 't-upload-disabled' : ''].join(' ')
  }, React.createElement(_Upload, Object.assign({
    disabled: disabled
  }, uploadProps), children));
};

var compressed = true;
var categories = [
	{
		id: "people",
		name: "Smileys & People",
		emojis: [
			"grinning",
			"smiley",
			"smile",
			"grin",
			"laughing",
			"sweat_smile",
			"rolling_on_the_floor_laughing",
			"joy",
			"slightly_smiling_face",
			"upside_down_face",
			"wink",
			"blush",
			"innocent",
			"smiling_face_with_3_hearts",
			"heart_eyes",
			"star-struck",
			"kissing_heart",
			"kissing",
			"relaxed",
			"kissing_closed_eyes",
			"kissing_smiling_eyes",
			"yum",
			"stuck_out_tongue",
			"stuck_out_tongue_winking_eye",
			"zany_face",
			"stuck_out_tongue_closed_eyes",
			"money_mouth_face",
			"hugging_face",
			"face_with_hand_over_mouth",
			"shushing_face",
			"thinking_face",
			"zipper_mouth_face",
			"face_with_raised_eyebrow",
			"neutral_face",
			"expressionless",
			"no_mouth",
			"smirk",
			"unamused",
			"face_with_rolling_eyes",
			"grimacing",
			"lying_face",
			"relieved",
			"pensive",
			"sleepy",
			"drooling_face",
			"sleeping",
			"mask",
			"face_with_thermometer",
			"face_with_head_bandage",
			"nauseated_face",
			"face_vomiting",
			"sneezing_face",
			"hot_face",
			"cold_face",
			"woozy_face",
			"dizzy_face",
			"exploding_head",
			"face_with_cowboy_hat",
			"partying_face",
			"sunglasses",
			"nerd_face",
			"face_with_monocle",
			"confused",
			"worried",
			"slightly_frowning_face",
			"white_frowning_face",
			"open_mouth",
			"hushed",
			"astonished",
			"flushed",
			"pleading_face",
			"frowning",
			"anguished",
			"fearful",
			"cold_sweat",
			"disappointed_relieved",
			"cry",
			"sob",
			"scream",
			"confounded",
			"persevere",
			"disappointed",
			"sweat",
			"weary",
			"tired_face",
			"yawning_face",
			"triumph",
			"rage",
			"angry",
			"face_with_symbols_on_mouth",
			"smiling_imp",
			"imp",
			"skull",
			"skull_and_crossbones",
			"hankey",
			"clown_face",
			"japanese_ogre",
			"japanese_goblin",
			"ghost",
			"alien",
			"space_invader",
			"robot_face",
			"smiley_cat",
			"smile_cat",
			"joy_cat",
			"heart_eyes_cat",
			"smirk_cat",
			"kissing_cat",
			"scream_cat",
			"crying_cat_face",
			"pouting_cat",
			"see_no_evil",
			"hear_no_evil",
			"speak_no_evil",
			"wave",
			"raised_back_of_hand",
			"raised_hand_with_fingers_splayed",
			"hand",
			"spock-hand",
			"ok_hand",
			"pinching_hand",
			"v",
			"crossed_fingers",
			"i_love_you_hand_sign",
			"the_horns",
			"call_me_hand",
			"point_left",
			"point_right",
			"point_up_2",
			"middle_finger",
			"point_down",
			"point_up",
			"+1",
			"-1",
			"fist",
			"facepunch",
			"left-facing_fist",
			"right-facing_fist",
			"clap",
			"raised_hands",
			"open_hands",
			"palms_up_together",
			"handshake",
			"pray",
			"writing_hand",
			"nail_care",
			"selfie",
			"muscle",
			"mechanical_arm",
			"mechanical_leg",
			"leg",
			"foot",
			"ear",
			"ear_with_hearing_aid",
			"nose",
			"brain",
			"tooth",
			"bone",
			"eyes",
			"eye",
			"tongue",
			"lips",
			"baby",
			"child",
			"boy",
			"girl",
			"adult",
			"person_with_blond_hair",
			"man",
			"bearded_person",
			"red_haired_man",
			"curly_haired_man",
			"white_haired_man",
			"bald_man",
			"woman",
			"red_haired_woman",
			"red_haired_person",
			"curly_haired_woman",
			"curly_haired_person",
			"white_haired_woman",
			"white_haired_person",
			"bald_woman",
			"bald_person",
			"blond-haired-woman",
			"blond-haired-man",
			"older_adult",
			"older_man",
			"older_woman",
			"person_frowning",
			"man-frowning",
			"woman-frowning",
			"person_with_pouting_face",
			"man-pouting",
			"woman-pouting",
			"no_good",
			"man-gesturing-no",
			"woman-gesturing-no",
			"ok_woman",
			"man-gesturing-ok",
			"woman-gesturing-ok",
			"information_desk_person",
			"man-tipping-hand",
			"woman-tipping-hand",
			"raising_hand",
			"man-raising-hand",
			"woman-raising-hand",
			"deaf_person",
			"deaf_man",
			"deaf_woman",
			"bow",
			"man-bowing",
			"woman-bowing",
			"face_palm",
			"man-facepalming",
			"woman-facepalming",
			"shrug",
			"man-shrugging",
			"woman-shrugging",
			"health_worker",
			"male-doctor",
			"female-doctor",
			"student",
			"male-student",
			"female-student",
			"teacher",
			"male-teacher",
			"female-teacher",
			"judge",
			"male-judge",
			"female-judge",
			"farmer",
			"male-farmer",
			"female-farmer",
			"cook",
			"male-cook",
			"female-cook",
			"mechanic",
			"male-mechanic",
			"female-mechanic",
			"factory_worker",
			"male-factory-worker",
			"female-factory-worker",
			"office_worker",
			"male-office-worker",
			"female-office-worker",
			"scientist",
			"male-scientist",
			"female-scientist",
			"technologist",
			"male-technologist",
			"female-technologist",
			"singer",
			"male-singer",
			"female-singer",
			"artist",
			"male-artist",
			"female-artist",
			"pilot",
			"male-pilot",
			"female-pilot",
			"astronaut",
			"male-astronaut",
			"female-astronaut",
			"firefighter",
			"male-firefighter",
			"female-firefighter",
			"cop",
			"male-police-officer",
			"female-police-officer",
			"sleuth_or_spy",
			"male-detective",
			"female-detective",
			"guardsman",
			"male-guard",
			"female-guard",
			"construction_worker",
			"male-construction-worker",
			"female-construction-worker",
			"prince",
			"princess",
			"man_with_turban",
			"man-wearing-turban",
			"woman-wearing-turban",
			"man_with_gua_pi_mao",
			"person_with_headscarf",
			"man_in_tuxedo",
			"bride_with_veil",
			"pregnant_woman",
			"breast-feeding",
			"angel",
			"santa",
			"mrs_claus",
			"superhero",
			"male_superhero",
			"female_superhero",
			"supervillain",
			"male_supervillain",
			"female_supervillain",
			"mage",
			"male_mage",
			"female_mage",
			"fairy",
			"male_fairy",
			"female_fairy",
			"vampire",
			"male_vampire",
			"female_vampire",
			"merperson",
			"merman",
			"mermaid",
			"elf",
			"male_elf",
			"female_elf",
			"genie",
			"male_genie",
			"female_genie",
			"zombie",
			"male_zombie",
			"female_zombie",
			"massage",
			"man-getting-massage",
			"woman-getting-massage",
			"haircut",
			"man-getting-haircut",
			"woman-getting-haircut",
			"walking",
			"man-walking",
			"woman-walking",
			"standing_person",
			"man_standing",
			"woman_standing",
			"kneeling_person",
			"man_kneeling",
			"woman_kneeling",
			"person_with_probing_cane",
			"man_with_probing_cane",
			"woman_with_probing_cane",
			"person_in_motorized_wheelchair",
			"man_in_motorized_wheelchair",
			"woman_in_motorized_wheelchair",
			"person_in_manual_wheelchair",
			"man_in_manual_wheelchair",
			"woman_in_manual_wheelchair",
			"runner",
			"man-running",
			"woman-running",
			"dancer",
			"man_dancing",
			"man_in_business_suit_levitating",
			"dancers",
			"man-with-bunny-ears-partying",
			"woman-with-bunny-ears-partying",
			"person_in_steamy_room",
			"man_in_steamy_room",
			"woman_in_steamy_room",
			"person_climbing",
			"man_climbing",
			"woman_climbing",
			"fencer",
			"horse_racing",
			"skier",
			"snowboarder",
			"golfer",
			"man-golfing",
			"woman-golfing",
			"surfer",
			"man-surfing",
			"woman-surfing",
			"rowboat",
			"man-rowing-boat",
			"woman-rowing-boat",
			"swimmer",
			"man-swimming",
			"woman-swimming",
			"person_with_ball",
			"man-bouncing-ball",
			"woman-bouncing-ball",
			"weight_lifter",
			"man-lifting-weights",
			"woman-lifting-weights",
			"bicyclist",
			"man-biking",
			"woman-biking",
			"mountain_bicyclist",
			"man-mountain-biking",
			"woman-mountain-biking",
			"person_doing_cartwheel",
			"man-cartwheeling",
			"woman-cartwheeling",
			"wrestlers",
			"man-wrestling",
			"woman-wrestling",
			"water_polo",
			"man-playing-water-polo",
			"woman-playing-water-polo",
			"handball",
			"man-playing-handball",
			"woman-playing-handball",
			"juggling",
			"man-juggling",
			"woman-juggling",
			"person_in_lotus_position",
			"man_in_lotus_position",
			"woman_in_lotus_position",
			"bath",
			"sleeping_accommodation",
			"people_holding_hands",
			"two_women_holding_hands",
			"couple",
			"two_men_holding_hands",
			"couplekiss",
			"woman-kiss-man",
			"man-kiss-man",
			"woman-kiss-woman",
			"couple_with_heart",
			"woman-heart-man",
			"man-heart-man",
			"woman-heart-woman",
			"family",
			"man-woman-boy",
			"man-woman-girl",
			"man-woman-girl-boy",
			"man-woman-boy-boy",
			"man-woman-girl-girl",
			"man-man-boy",
			"man-man-girl",
			"man-man-girl-boy",
			"man-man-boy-boy",
			"man-man-girl-girl",
			"woman-woman-boy",
			"woman-woman-girl",
			"woman-woman-girl-boy",
			"woman-woman-boy-boy",
			"woman-woman-girl-girl",
			"man-boy",
			"man-boy-boy",
			"man-girl",
			"man-girl-boy",
			"man-girl-girl",
			"woman-boy",
			"woman-boy-boy",
			"woman-girl",
			"woman-girl-boy",
			"woman-girl-girl",
			"speaking_head_in_silhouette",
			"bust_in_silhouette",
			"busts_in_silhouette",
			"footprints",
			"kiss",
			"love_letter",
			"cupid",
			"gift_heart",
			"sparkling_heart",
			"heartpulse",
			"heartbeat",
			"revolving_hearts",
			"two_hearts",
			"heart_decoration",
			"heavy_heart_exclamation_mark_ornament",
			"broken_heart",
			"heart",
			"orange_heart",
			"yellow_heart",
			"green_heart",
			"blue_heart",
			"purple_heart",
			"brown_heart",
			"black_heart",
			"white_heart",
			"100",
			"anger",
			"boom",
			"dizzy",
			"sweat_drops",
			"dash",
			"hole",
			"bomb",
			"speech_balloon",
			"eye-in-speech-bubble",
			"left_speech_bubble",
			"right_anger_bubble",
			"thought_balloon",
			"zzz"
		]
	},
	{
		id: "nature",
		name: "Animals & Nature",
		emojis: [
			"monkey_face",
			"monkey",
			"gorilla",
			"orangutan",
			"dog",
			"dog2",
			"guide_dog",
			"service_dog",
			"poodle",
			"wolf",
			"fox_face",
			"raccoon",
			"cat",
			"cat2",
			"lion_face",
			"tiger",
			"tiger2",
			"leopard",
			"horse",
			"racehorse",
			"unicorn_face",
			"zebra_face",
			"deer",
			"cow",
			"ox",
			"water_buffalo",
			"cow2",
			"pig",
			"pig2",
			"boar",
			"pig_nose",
			"ram",
			"sheep",
			"goat",
			"dromedary_camel",
			"camel",
			"llama",
			"giraffe_face",
			"elephant",
			"rhinoceros",
			"hippopotamus",
			"mouse",
			"mouse2",
			"rat",
			"hamster",
			"rabbit",
			"rabbit2",
			"chipmunk",
			"hedgehog",
			"bat",
			"bear",
			"koala",
			"panda_face",
			"sloth",
			"otter",
			"skunk",
			"kangaroo",
			"badger",
			"feet",
			"turkey",
			"chicken",
			"rooster",
			"hatching_chick",
			"baby_chick",
			"hatched_chick",
			"bird",
			"penguin",
			"dove_of_peace",
			"eagle",
			"duck",
			"swan",
			"owl",
			"flamingo",
			"peacock",
			"parrot",
			"frog",
			"crocodile",
			"turtle",
			"lizard",
			"snake",
			"dragon_face",
			"dragon",
			"sauropod",
			"t-rex",
			"whale",
			"whale2",
			"dolphin",
			"fish",
			"tropical_fish",
			"blowfish",
			"shark",
			"octopus",
			"shell",
			"snail",
			"butterfly",
			"bug",
			"ant",
			"bee",
			"beetle",
			"cricket",
			"spider",
			"spider_web",
			"scorpion",
			"mosquito",
			"microbe",
			"bouquet",
			"cherry_blossom",
			"white_flower",
			"rosette",
			"rose",
			"wilted_flower",
			"hibiscus",
			"sunflower",
			"blossom",
			"tulip",
			"seedling",
			"evergreen_tree",
			"deciduous_tree",
			"palm_tree",
			"cactus",
			"ear_of_rice",
			"herb",
			"shamrock",
			"four_leaf_clover",
			"maple_leaf",
			"fallen_leaf",
			"leaves"
		]
	},
	{
		id: "foods",
		name: "Food & Drink",
		emojis: [
			"grapes",
			"melon",
			"watermelon",
			"tangerine",
			"lemon",
			"banana",
			"pineapple",
			"mango",
			"apple",
			"green_apple",
			"pear",
			"peach",
			"cherries",
			"strawberry",
			"kiwifruit",
			"tomato",
			"coconut",
			"avocado",
			"eggplant",
			"potato",
			"carrot",
			"corn",
			"hot_pepper",
			"cucumber",
			"leafy_green",
			"broccoli",
			"garlic",
			"onion",
			"mushroom",
			"peanuts",
			"chestnut",
			"bread",
			"croissant",
			"baguette_bread",
			"pretzel",
			"bagel",
			"pancakes",
			"waffle",
			"cheese_wedge",
			"meat_on_bone",
			"poultry_leg",
			"cut_of_meat",
			"bacon",
			"hamburger",
			"fries",
			"pizza",
			"hotdog",
			"sandwich",
			"taco",
			"burrito",
			"stuffed_flatbread",
			"falafel",
			"egg",
			"fried_egg",
			"shallow_pan_of_food",
			"stew",
			"bowl_with_spoon",
			"green_salad",
			"popcorn",
			"butter",
			"salt",
			"canned_food",
			"bento",
			"rice_cracker",
			"rice_ball",
			"rice",
			"curry",
			"ramen",
			"spaghetti",
			"sweet_potato",
			"oden",
			"sushi",
			"fried_shrimp",
			"fish_cake",
			"moon_cake",
			"dango",
			"dumpling",
			"fortune_cookie",
			"takeout_box",
			"crab",
			"lobster",
			"shrimp",
			"squid",
			"oyster",
			"icecream",
			"shaved_ice",
			"ice_cream",
			"doughnut",
			"cookie",
			"birthday",
			"cake",
			"cupcake",
			"pie",
			"chocolate_bar",
			"candy",
			"lollipop",
			"custard",
			"honey_pot",
			"baby_bottle",
			"glass_of_milk",
			"coffee",
			"tea",
			"sake",
			"champagne",
			"wine_glass",
			"cocktail",
			"tropical_drink",
			"beer",
			"beers",
			"clinking_glasses",
			"tumbler_glass",
			"cup_with_straw",
			"beverage_box",
			"mate_drink",
			"ice_cube",
			"chopsticks",
			"knife_fork_plate",
			"fork_and_knife",
			"spoon",
			"hocho",
			"amphora"
		]
	},
	{
		id: "activity",
		name: "Activities",
		emojis: [
			"jack_o_lantern",
			"christmas_tree",
			"fireworks",
			"sparkler",
			"firecracker",
			"sparkles",
			"balloon",
			"tada",
			"confetti_ball",
			"tanabata_tree",
			"bamboo",
			"dolls",
			"flags",
			"wind_chime",
			"rice_scene",
			"red_envelope",
			"ribbon",
			"gift",
			"reminder_ribbon",
			"admission_tickets",
			"ticket",
			"medal",
			"trophy",
			"sports_medal",
			"first_place_medal",
			"second_place_medal",
			"third_place_medal",
			"soccer",
			"baseball",
			"softball",
			"basketball",
			"volleyball",
			"football",
			"rugby_football",
			"tennis",
			"flying_disc",
			"bowling",
			"cricket_bat_and_ball",
			"field_hockey_stick_and_ball",
			"ice_hockey_stick_and_puck",
			"lacrosse",
			"table_tennis_paddle_and_ball",
			"badminton_racquet_and_shuttlecock",
			"boxing_glove",
			"martial_arts_uniform",
			"goal_net",
			"golf",
			"ice_skate",
			"fishing_pole_and_fish",
			"diving_mask",
			"running_shirt_with_sash",
			"ski",
			"sled",
			"curling_stone",
			"dart",
			"yo-yo",
			"kite",
			"8ball",
			"crystal_ball",
			"nazar_amulet",
			"video_game",
			"joystick",
			"slot_machine",
			"game_die",
			"jigsaw",
			"teddy_bear",
			"spades",
			"hearts",
			"diamonds",
			"clubs",
			"chess_pawn",
			"black_joker",
			"mahjong",
			"flower_playing_cards",
			"performing_arts",
			"frame_with_picture",
			"art",
			"thread",
			"yarn"
		]
	},
	{
		id: "places",
		name: "Travel & Places",
		emojis: [
			"earth_africa",
			"earth_americas",
			"earth_asia",
			"globe_with_meridians",
			"world_map",
			"japan",
			"compass",
			"snow_capped_mountain",
			"mountain",
			"volcano",
			"mount_fuji",
			"camping",
			"beach_with_umbrella",
			"desert",
			"desert_island",
			"national_park",
			"stadium",
			"classical_building",
			"building_construction",
			"bricks",
			"house_buildings",
			"derelict_house_building",
			"house",
			"house_with_garden",
			"office",
			"post_office",
			"european_post_office",
			"hospital",
			"bank",
			"hotel",
			"love_hotel",
			"convenience_store",
			"school",
			"department_store",
			"factory",
			"japanese_castle",
			"european_castle",
			"wedding",
			"tokyo_tower",
			"statue_of_liberty",
			"church",
			"mosque",
			"hindu_temple",
			"synagogue",
			"shinto_shrine",
			"kaaba",
			"fountain",
			"tent",
			"foggy",
			"night_with_stars",
			"cityscape",
			"sunrise_over_mountains",
			"sunrise",
			"city_sunset",
			"city_sunrise",
			"bridge_at_night",
			"hotsprings",
			"carousel_horse",
			"ferris_wheel",
			"roller_coaster",
			"barber",
			"circus_tent",
			"steam_locomotive",
			"railway_car",
			"bullettrain_side",
			"bullettrain_front",
			"train2",
			"metro",
			"light_rail",
			"station",
			"tram",
			"monorail",
			"mountain_railway",
			"train",
			"bus",
			"oncoming_bus",
			"trolleybus",
			"minibus",
			"ambulance",
			"fire_engine",
			"police_car",
			"oncoming_police_car",
			"taxi",
			"oncoming_taxi",
			"car",
			"oncoming_automobile",
			"blue_car",
			"truck",
			"articulated_lorry",
			"tractor",
			"racing_car",
			"racing_motorcycle",
			"motor_scooter",
			"manual_wheelchair",
			"motorized_wheelchair",
			"auto_rickshaw",
			"bike",
			"scooter",
			"skateboard",
			"busstop",
			"motorway",
			"railway_track",
			"oil_drum",
			"fuelpump",
			"rotating_light",
			"traffic_light",
			"vertical_traffic_light",
			"octagonal_sign",
			"construction",
			"anchor",
			"boat",
			"canoe",
			"speedboat",
			"passenger_ship",
			"ferry",
			"motor_boat",
			"ship",
			"airplane",
			"small_airplane",
			"airplane_departure",
			"airplane_arriving",
			"parachute",
			"seat",
			"helicopter",
			"suspension_railway",
			"mountain_cableway",
			"aerial_tramway",
			"satellite",
			"rocket",
			"flying_saucer",
			"bellhop_bell",
			"luggage",
			"hourglass",
			"hourglass_flowing_sand",
			"watch",
			"alarm_clock",
			"stopwatch",
			"timer_clock",
			"mantelpiece_clock",
			"clock12",
			"clock1230",
			"clock1",
			"clock130",
			"clock2",
			"clock230",
			"clock3",
			"clock330",
			"clock4",
			"clock430",
			"clock5",
			"clock530",
			"clock6",
			"clock630",
			"clock7",
			"clock730",
			"clock8",
			"clock830",
			"clock9",
			"clock930",
			"clock10",
			"clock1030",
			"clock11",
			"clock1130",
			"new_moon",
			"waxing_crescent_moon",
			"first_quarter_moon",
			"moon",
			"full_moon",
			"waning_gibbous_moon",
			"last_quarter_moon",
			"waning_crescent_moon",
			"crescent_moon",
			"new_moon_with_face",
			"first_quarter_moon_with_face",
			"last_quarter_moon_with_face",
			"thermometer",
			"sunny",
			"full_moon_with_face",
			"sun_with_face",
			"ringed_planet",
			"star",
			"star2",
			"stars",
			"milky_way",
			"cloud",
			"partly_sunny",
			"thunder_cloud_and_rain",
			"mostly_sunny",
			"barely_sunny",
			"partly_sunny_rain",
			"rain_cloud",
			"snow_cloud",
			"lightning",
			"tornado",
			"fog",
			"wind_blowing_face",
			"cyclone",
			"rainbow",
			"closed_umbrella",
			"umbrella",
			"umbrella_with_rain_drops",
			"umbrella_on_ground",
			"zap",
			"snowflake",
			"snowman",
			"snowman_without_snow",
			"comet",
			"fire",
			"droplet",
			"ocean"
		]
	},
	{
		id: "objects",
		name: "Objects",
		emojis: [
			"eyeglasses",
			"dark_sunglasses",
			"goggles",
			"lab_coat",
			"safety_vest",
			"necktie",
			"shirt",
			"jeans",
			"scarf",
			"gloves",
			"coat",
			"socks",
			"dress",
			"kimono",
			"sari",
			"one-piece_swimsuit",
			"briefs",
			"shorts",
			"bikini",
			"womans_clothes",
			"purse",
			"handbag",
			"pouch",
			"shopping_bags",
			"school_satchel",
			"mans_shoe",
			"athletic_shoe",
			"hiking_boot",
			"womans_flat_shoe",
			"high_heel",
			"sandal",
			"ballet_shoes",
			"boot",
			"crown",
			"womans_hat",
			"tophat",
			"mortar_board",
			"billed_cap",
			"helmet_with_white_cross",
			"prayer_beads",
			"lipstick",
			"ring",
			"gem",
			"mute",
			"speaker",
			"sound",
			"loud_sound",
			"loudspeaker",
			"mega",
			"postal_horn",
			"bell",
			"no_bell",
			"musical_score",
			"musical_note",
			"notes",
			"studio_microphone",
			"level_slider",
			"control_knobs",
			"microphone",
			"headphones",
			"radio",
			"saxophone",
			"guitar",
			"musical_keyboard",
			"trumpet",
			"violin",
			"banjo",
			"drum_with_drumsticks",
			"iphone",
			"calling",
			"phone",
			"telephone_receiver",
			"pager",
			"fax",
			"battery",
			"electric_plug",
			"computer",
			"desktop_computer",
			"printer",
			"keyboard",
			"three_button_mouse",
			"trackball",
			"minidisc",
			"floppy_disk",
			"cd",
			"dvd",
			"abacus",
			"movie_camera",
			"film_frames",
			"film_projector",
			"clapper",
			"tv",
			"camera",
			"camera_with_flash",
			"video_camera",
			"vhs",
			"mag",
			"mag_right",
			"candle",
			"bulb",
			"flashlight",
			"izakaya_lantern",
			"diya_lamp",
			"notebook_with_decorative_cover",
			"closed_book",
			"book",
			"green_book",
			"blue_book",
			"orange_book",
			"books",
			"notebook",
			"ledger",
			"page_with_curl",
			"scroll",
			"page_facing_up",
			"newspaper",
			"rolled_up_newspaper",
			"bookmark_tabs",
			"bookmark",
			"label",
			"moneybag",
			"yen",
			"dollar",
			"euro",
			"pound",
			"money_with_wings",
			"credit_card",
			"receipt",
			"chart",
			"currency_exchange",
			"heavy_dollar_sign",
			"email",
			"e-mail",
			"incoming_envelope",
			"envelope_with_arrow",
			"outbox_tray",
			"inbox_tray",
			"package",
			"mailbox",
			"mailbox_closed",
			"mailbox_with_mail",
			"mailbox_with_no_mail",
			"postbox",
			"ballot_box_with_ballot",
			"pencil2",
			"black_nib",
			"lower_left_fountain_pen",
			"lower_left_ballpoint_pen",
			"lower_left_paintbrush",
			"lower_left_crayon",
			"memo",
			"briefcase",
			"file_folder",
			"open_file_folder",
			"card_index_dividers",
			"date",
			"calendar",
			"spiral_note_pad",
			"spiral_calendar_pad",
			"card_index",
			"chart_with_upwards_trend",
			"chart_with_downwards_trend",
			"bar_chart",
			"clipboard",
			"pushpin",
			"round_pushpin",
			"paperclip",
			"linked_paperclips",
			"straight_ruler",
			"triangular_ruler",
			"scissors",
			"card_file_box",
			"file_cabinet",
			"wastebasket",
			"lock",
			"unlock",
			"lock_with_ink_pen",
			"closed_lock_with_key",
			"key",
			"old_key",
			"hammer",
			"axe",
			"pick",
			"hammer_and_pick",
			"hammer_and_wrench",
			"dagger_knife",
			"crossed_swords",
			"gun",
			"bow_and_arrow",
			"shield",
			"wrench",
			"nut_and_bolt",
			"gear",
			"compression",
			"scales",
			"probing_cane",
			"link",
			"chains",
			"toolbox",
			"magnet",
			"alembic",
			"test_tube",
			"petri_dish",
			"dna",
			"microscope",
			"telescope",
			"satellite_antenna",
			"syringe",
			"drop_of_blood",
			"pill",
			"adhesive_bandage",
			"stethoscope",
			"door",
			"bed",
			"couch_and_lamp",
			"chair",
			"toilet",
			"shower",
			"bathtub",
			"razor",
			"lotion_bottle",
			"safety_pin",
			"broom",
			"basket",
			"roll_of_paper",
			"soap",
			"sponge",
			"fire_extinguisher",
			"shopping_trolley",
			"smoking",
			"coffin",
			"funeral_urn",
			"moyai"
		]
	},
	{
		id: "symbols",
		name: "Symbols",
		emojis: [
			"atm",
			"put_litter_in_its_place",
			"potable_water",
			"wheelchair",
			"mens",
			"womens",
			"restroom",
			"baby_symbol",
			"wc",
			"passport_control",
			"customs",
			"baggage_claim",
			"left_luggage",
			"warning",
			"children_crossing",
			"no_entry",
			"no_entry_sign",
			"no_bicycles",
			"no_smoking",
			"do_not_litter",
			"non-potable_water",
			"no_pedestrians",
			"no_mobile_phones",
			"underage",
			"radioactive_sign",
			"biohazard_sign",
			"arrow_up",
			"arrow_upper_right",
			"arrow_right",
			"arrow_lower_right",
			"arrow_down",
			"arrow_lower_left",
			"arrow_left",
			"arrow_upper_left",
			"arrow_up_down",
			"left_right_arrow",
			"leftwards_arrow_with_hook",
			"arrow_right_hook",
			"arrow_heading_up",
			"arrow_heading_down",
			"arrows_clockwise",
			"arrows_counterclockwise",
			"back",
			"end",
			"on",
			"soon",
			"top",
			"place_of_worship",
			"atom_symbol",
			"om_symbol",
			"star_of_david",
			"wheel_of_dharma",
			"yin_yang",
			"latin_cross",
			"orthodox_cross",
			"star_and_crescent",
			"peace_symbol",
			"menorah_with_nine_branches",
			"six_pointed_star",
			"aries",
			"taurus",
			"gemini",
			"cancer",
			"leo",
			"virgo",
			"libra",
			"scorpius",
			"sagittarius",
			"capricorn",
			"aquarius",
			"pisces",
			"ophiuchus",
			"twisted_rightwards_arrows",
			"repeat",
			"repeat_one",
			"arrow_forward",
			"fast_forward",
			"black_right_pointing_double_triangle_with_vertical_bar",
			"black_right_pointing_triangle_with_double_vertical_bar",
			"arrow_backward",
			"rewind",
			"black_left_pointing_double_triangle_with_vertical_bar",
			"arrow_up_small",
			"arrow_double_up",
			"arrow_down_small",
			"arrow_double_down",
			"double_vertical_bar",
			"black_square_for_stop",
			"black_circle_for_record",
			"eject",
			"cinema",
			"low_brightness",
			"high_brightness",
			"signal_strength",
			"vibration_mode",
			"mobile_phone_off",
			"female_sign",
			"male_sign",
			"medical_symbol",
			"infinity",
			"recycle",
			"fleur_de_lis",
			"trident",
			"name_badge",
			"beginner",
			"o",
			"white_check_mark",
			"ballot_box_with_check",
			"heavy_check_mark",
			"heavy_multiplication_x",
			"x",
			"negative_squared_cross_mark",
			"heavy_plus_sign",
			"heavy_minus_sign",
			"heavy_division_sign",
			"curly_loop",
			"loop",
			"part_alternation_mark",
			"eight_spoked_asterisk",
			"eight_pointed_black_star",
			"sparkle",
			"bangbang",
			"interrobang",
			"question",
			"grey_question",
			"grey_exclamation",
			"exclamation",
			"wavy_dash",
			"copyright",
			"registered",
			"tm",
			"hash",
			"keycap_star",
			"zero",
			"one",
			"two",
			"three",
			"four",
			"five",
			"six",
			"seven",
			"eight",
			"nine",
			"keycap_ten",
			"capital_abcd",
			"abcd",
			"1234",
			"symbols",
			"abc",
			"a",
			"ab",
			"b",
			"cl",
			"cool",
			"free",
			"information_source",
			"id",
			"m",
			"new",
			"ng",
			"o2",
			"ok",
			"parking",
			"sos",
			"up",
			"vs",
			"koko",
			"sa",
			"u6708",
			"u6709",
			"u6307",
			"ideograph_advantage",
			"u5272",
			"u7121",
			"u7981",
			"accept",
			"u7533",
			"u5408",
			"u7a7a",
			"congratulations",
			"secret",
			"u55b6",
			"u6e80",
			"red_circle",
			"large_orange_circle",
			"large_yellow_circle",
			"large_green_circle",
			"large_blue_circle",
			"large_purple_circle",
			"large_brown_circle",
			"black_circle",
			"white_circle",
			"large_red_square",
			"large_orange_square",
			"large_yellow_square",
			"large_green_square",
			"large_blue_square",
			"large_purple_square",
			"large_brown_square",
			"black_large_square",
			"white_large_square",
			"black_medium_square",
			"white_medium_square",
			"black_medium_small_square",
			"white_medium_small_square",
			"black_small_square",
			"white_small_square",
			"large_orange_diamond",
			"large_blue_diamond",
			"small_orange_diamond",
			"small_blue_diamond",
			"small_red_triangle",
			"small_red_triangle_down",
			"diamond_shape_with_a_dot_inside",
			"radio_button",
			"white_square_button",
			"black_square_button"
		]
	},
	{
		id: "flags",
		name: "Flags",
		emojis: [
			"checkered_flag",
			"cn",
			"crossed_flags",
			"de",
			"es",
			"flag-ac",
			"flag-ad",
			"flag-ae",
			"flag-af",
			"flag-ag",
			"flag-ai",
			"flag-al",
			"flag-am",
			"flag-ao",
			"flag-aq",
			"flag-ar",
			"flag-as",
			"flag-at",
			"flag-au",
			"flag-aw",
			"flag-ax",
			"flag-az",
			"flag-ba",
			"flag-bb",
			"flag-bd",
			"flag-be",
			"flag-bf",
			"flag-bg",
			"flag-bh",
			"flag-bi",
			"flag-bj",
			"flag-bl",
			"flag-bm",
			"flag-bn",
			"flag-bo",
			"flag-bq",
			"flag-br",
			"flag-bs",
			"flag-bt",
			"flag-bv",
			"flag-bw",
			"flag-by",
			"flag-bz",
			"flag-ca",
			"flag-cc",
			"flag-cd",
			"flag-cf",
			"flag-cg",
			"flag-ch",
			"flag-ci",
			"flag-ck",
			"flag-cl",
			"flag-cm",
			"flag-co",
			"flag-cp",
			"flag-cr",
			"flag-cu",
			"flag-cv",
			"flag-cw",
			"flag-cx",
			"flag-cy",
			"flag-cz",
			"flag-dg",
			"flag-dj",
			"flag-dk",
			"flag-dm",
			"flag-do",
			"flag-dz",
			"flag-ea",
			"flag-ec",
			"flag-ee",
			"flag-eg",
			"flag-eh",
			"flag-england",
			"flag-er",
			"flag-et",
			"flag-eu",
			"flag-fi",
			"flag-fj",
			"flag-fk",
			"flag-fm",
			"flag-fo",
			"flag-ga",
			"flag-gd",
			"flag-ge",
			"flag-gf",
			"flag-gg",
			"flag-gh",
			"flag-gi",
			"flag-gl",
			"flag-gm",
			"flag-gn",
			"flag-gp",
			"flag-gq",
			"flag-gr",
			"flag-gs",
			"flag-gt",
			"flag-gu",
			"flag-gw",
			"flag-gy",
			"flag-hk",
			"flag-hm",
			"flag-hn",
			"flag-hr",
			"flag-ht",
			"flag-hu",
			"flag-ic",
			"flag-id",
			"flag-ie",
			"flag-il",
			"flag-im",
			"flag-in",
			"flag-io",
			"flag-iq",
			"flag-ir",
			"flag-is",
			"flag-je",
			"flag-jm",
			"flag-jo",
			"flag-ke",
			"flag-kg",
			"flag-kh",
			"flag-ki",
			"flag-km",
			"flag-kn",
			"flag-kp",
			"flag-kw",
			"flag-ky",
			"flag-kz",
			"flag-la",
			"flag-lb",
			"flag-lc",
			"flag-li",
			"flag-lk",
			"flag-lr",
			"flag-ls",
			"flag-lt",
			"flag-lu",
			"flag-lv",
			"flag-ly",
			"flag-ma",
			"flag-mc",
			"flag-md",
			"flag-me",
			"flag-mf",
			"flag-mg",
			"flag-mh",
			"flag-mk",
			"flag-ml",
			"flag-mm",
			"flag-mn",
			"flag-mo",
			"flag-mp",
			"flag-mq",
			"flag-mr",
			"flag-ms",
			"flag-mt",
			"flag-mu",
			"flag-mv",
			"flag-mw",
			"flag-mx",
			"flag-my",
			"flag-mz",
			"flag-na",
			"flag-nc",
			"flag-ne",
			"flag-nf",
			"flag-ng",
			"flag-ni",
			"flag-nl",
			"flag-no",
			"flag-np",
			"flag-nr",
			"flag-nu",
			"flag-nz",
			"flag-om",
			"flag-pa",
			"flag-pe",
			"flag-pf",
			"flag-pg",
			"flag-ph",
			"flag-pk",
			"flag-pl",
			"flag-pm",
			"flag-pn",
			"flag-pr",
			"flag-ps",
			"flag-pt",
			"flag-pw",
			"flag-py",
			"flag-qa",
			"flag-re",
			"flag-ro",
			"flag-rs",
			"flag-rw",
			"flag-sa",
			"flag-sb",
			"flag-sc",
			"flag-scotland",
			"flag-sd",
			"flag-se",
			"flag-sg",
			"flag-sh",
			"flag-si",
			"flag-sj",
			"flag-sk",
			"flag-sl",
			"flag-sm",
			"flag-sn",
			"flag-so",
			"flag-sr",
			"flag-ss",
			"flag-st",
			"flag-sv",
			"flag-sx",
			"flag-sy",
			"flag-sz",
			"flag-ta",
			"flag-tc",
			"flag-td",
			"flag-tf",
			"flag-tg",
			"flag-th",
			"flag-tj",
			"flag-tk",
			"flag-tl",
			"flag-tm",
			"flag-tn",
			"flag-to",
			"flag-tr",
			"flag-tt",
			"flag-tv",
			"flag-tw",
			"flag-tz",
			"flag-ua",
			"flag-ug",
			"flag-um",
			"flag-uy",
			"flag-uz",
			"flag-va",
			"flag-vc",
			"flag-ve",
			"flag-vg",
			"flag-vi",
			"flag-vn",
			"flag-vu",
			"flag-wales",
			"flag-wf",
			"flag-ws",
			"flag-xk",
			"flag-ye",
			"flag-yt",
			"flag-za",
			"flag-zm",
			"flag-zw",
			"fr",
			"gb",
			"it",
			"jp",
			"kr",
			"pirate_flag",
			"rainbow-flag",
			"ru",
			"triangular_flag_on_post",
			"us",
			"waving_black_flag",
			"waving_white_flag"
		]
	}
];
var emojis = {
	"100": {
		a: "Hundred Points Symbol",
		b: "1F4AF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"score",
			"perfect",
			"numbers",
			"century",
			"exam",
			"quiz",
			"test",
			"pass",
			"hundred"
		],
		k: [
			26,
			5
		],
		o: 2
	},
	"1234": {
		a: "Input Symbol for Numbers",
		b: "1F522",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"numbers",
			"blue-square"
		],
		k: [
			28,
			5
		],
		o: 2
	},
	grinning: {
		a: "Grinning Face",
		b: "1F600",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"smile",
			"happy",
			"joy",
			":D",
			"grin"
		],
		k: [
			30,
			35
		],
		m: ":D",
		o: 2
	},
	monkey_face: {
		a: "Monkey Face",
		b: "1F435",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"circus"
		],
		k: [
			12,
			25
		],
		l: [
			":o)"
		],
		o: 2
	},
	grapes: {
		a: "Grapes",
		b: "1F347",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food",
			"wine"
		],
		k: [
			6,
			31
		],
		o: 2
	},
	eyeglasses: {
		a: "Eyeglasses",
		b: "1F453",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"accessories",
			"eyesight",
			"nerdy",
			"dork",
			"geek"
		],
		k: [
			14,
			7
		],
		o: 2
	},
	checkered_flag: {
		a: "Chequered Flag",
		b: "1F3C1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"contest",
			"finishline",
			"race",
			"gokart"
		],
		k: [
			8,
			39
		],
		o: 2
	},
	jack_o_lantern: {
		a: "Jack-O-Lantern",
		b: "1F383",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"halloween",
			"light",
			"pumpkin",
			"creepy",
			"fall"
		],
		k: [
			7,
			34
		],
		o: 2
	},
	wave: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44B-1F3FB",
				non_qualified: null,
				image: "1f44b-1f3fb.png",
				sheet_x: 13,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44B-1F3FC",
				non_qualified: null,
				image: "1f44b-1f3fc.png",
				sheet_x: 13,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44B-1F3FD",
				non_qualified: null,
				image: "1f44b-1f3fd.png",
				sheet_x: 13,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44B-1F3FE",
				non_qualified: null,
				image: "1f44b-1f3fe.png",
				sheet_x: 13,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44B-1F3FF",
				non_qualified: null,
				image: "1f44b-1f3ff.png",
				sheet_x: 13,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Waving Hand Sign",
		b: "1F44B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hands",
			"gesture",
			"goodbye",
			"solong",
			"farewell",
			"hello",
			"hi",
			"palm"
		],
		k: [
			13,
			26
		],
		o: 2
	},
	earth_africa: {
		a: "Earth Globe Europe-Africa",
		b: "1F30D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"globe",
			"world",
			"international"
		],
		k: [
			5,
			32
		],
		o: 2
	},
	atm: {
		a: "Automated Teller Machine",
		b: "1F3E7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"cash",
			"blue-square",
			"payment",
			"bank"
		],
		k: [
			11,
			1
		],
		o: 2
	},
	melon: {
		a: "Melon",
		b: "1F348",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			6,
			32
		],
		o: 2
	},
	triangular_flag_on_post: {
		a: "Triangular Flag on Post",
		b: "1F6A9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mark",
			"milestone",
			"place"
		],
		k: [
			35,
			0
		],
		o: 2
	},
	put_litter_in_its_place: {
		a: "Put Litter in Its Place Symbol",
		b: "1F6AE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"sign",
			"human",
			"info"
		],
		k: [
			35,
			5
		],
		o: 2
	},
	christmas_tree: {
		a: "Christmas Tree",
		b: "1F384",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"festival",
			"vacation",
			"december",
			"xmas",
			"celebration"
		],
		k: [
			7,
			35
		],
		o: 2
	},
	monkey: {
		a: "Monkey",
		b: "1F412",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"banana",
			"circus"
		],
		k: [
			11,
			46
		],
		o: 2
	},
	earth_americas: {
		a: "Earth Globe Americas",
		b: "1F30E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"globe",
			"world",
			"USA",
			"international"
		],
		k: [
			5,
			33
		],
		o: 2
	},
	dark_sunglasses: {
		a: "Dark Sunglasses",
		b: "1F576-FE0F",
		c: "1F576",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"cool",
			"accessories"
		],
		k: [
			29,
			33
		],
		o: 2
	},
	raised_back_of_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91A-1F3FB",
				non_qualified: null,
				image: "1f91a-1f3fb.png",
				sheet_x: 37,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F91A-1F3FC",
				non_qualified: null,
				image: "1f91a-1f3fc.png",
				sheet_x: 37,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F91A-1F3FD",
				non_qualified: null,
				image: "1f91a-1f3fd.png",
				sheet_x: 37,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F91A-1F3FE",
				non_qualified: null,
				image: "1f91a-1f3fe.png",
				sheet_x: 37,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F91A-1F3FF",
				non_qualified: null,
				image: "1f91a-1f3ff.png",
				sheet_x: 37,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Raised Back of Hand",
		b: "1F91A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"raised",
			"backhand"
		],
		k: [
			37,
			43
		],
		o: 4
	},
	smiley: {
		a: "Smiling Face with Open Mouth",
		b: "1F603",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"happy",
			"joy",
			"haha",
			":D",
			":)",
			"smile",
			"funny"
		],
		k: [
			30,
			38
		],
		l: [
			"=)",
			"=-)"
		],
		m: ":)",
		o: 2
	},
	earth_asia: {
		a: "Earth Globe Asia-Australia",
		b: "1F30F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"globe",
			"world",
			"east",
			"international"
		],
		k: [
			5,
			34
		],
		o: 2
	},
	crossed_flags: {
		a: "Crossed Flags",
		b: "1F38C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"nation",
			"country",
			"border"
		],
		k: [
			7,
			48
		],
		o: 2
	},
	watermelon: {
		a: "Watermelon",
		b: "1F349",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food",
			"picnic",
			"summer"
		],
		k: [
			6,
			33
		],
		o: 2
	},
	goggles: {
		a: "Goggles",
		b: "1F97D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			15
		],
		o: 11
	},
	raised_hand_with_fingers_splayed: {
		skin_variations: {
			"1F3FB": {
				unified: "1F590-1F3FB",
				non_qualified: null,
				image: "1f590-1f3fb.png",
				sheet_x: 29,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F590-1F3FC",
				non_qualified: null,
				image: "1f590-1f3fc.png",
				sheet_x: 29,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F590-1F3FD",
				non_qualified: null,
				image: "1f590-1f3fd.png",
				sheet_x: 29,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F590-1F3FE",
				non_qualified: null,
				image: "1f590-1f3fe.png",
				sheet_x: 29,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F590-1F3FF",
				non_qualified: null,
				image: "1f590-1f3ff.png",
				sheet_x: 29,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Raised Hand with Fingers Splayed",
		b: "1F590-FE0F",
		c: "1F590",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hand",
			"fingers",
			"palm"
		],
		k: [
			29,
			48
		],
		o: 2
	},
	smile: {
		a: "Smiling Face with Open Mouth and Smiling Eyes",
		b: "1F604",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"happy",
			"joy",
			"funny",
			"haha",
			"laugh",
			"like",
			":D",
			":)"
		],
		k: [
			30,
			39
		],
		l: [
			"C:",
			"c:",
			":D",
			":-D"
		],
		m: ":)",
		o: 2
	},
	potable_water: {
		a: "Potable Water Symbol",
		b: "1F6B0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"liquid",
			"restroom",
			"cleaning",
			"faucet"
		],
		k: [
			35,
			7
		],
		o: 2
	},
	fireworks: {
		a: "Fireworks",
		b: "1F386",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"festival",
			"carnival",
			"congratulations"
		],
		k: [
			7,
			42
		],
		o: 2
	},
	gorilla: {
		a: "Gorilla",
		b: "1F98D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"circus"
		],
		k: [
			42,
			31
		],
		o: 4
	},
	lab_coat: {
		a: "Lab Coat",
		b: "1F97C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			14
		],
		o: 11
	},
	tangerine: {
		a: "Tangerine",
		b: "1F34A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"fruit",
			"nature",
			"orange"
		],
		k: [
			6,
			34
		],
		o: 2
	},
	wheelchair: {
		a: "Wheelchair Symbol",
		b: "267F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"disabled",
			"a11y",
			"accessibility"
		],
		k: [
			53,
			40
		],
		o: 2
	},
	waving_black_flag: {
		a: "Waving Black Flag",
		b: "1F3F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			17
		],
		o: 2
	},
	orangutan: {
		a: "Orangutan",
		b: "1F9A7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			55
		],
		o: 12
	},
	sparkler: {
		a: "Firework Sparkler",
		b: "1F387",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stars",
			"night",
			"shine"
		],
		k: [
			7,
			43
		],
		o: 2
	},
	globe_with_meridians: {
		a: "Globe with Meridians",
		b: "1F310",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"earth",
			"international",
			"world",
			"internet",
			"interweb",
			"i18n"
		],
		k: [
			5,
			35
		],
		o: 2
	},
	grin: {
		a: "Grinning Face with Smiling Eyes",
		b: "1F601",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"happy",
			"smile",
			"joy",
			"kawaii"
		],
		k: [
			30,
			36
		],
		o: 2
	},
	hand: {
		skin_variations: {
			"1F3FB": {
				unified: "270B-1F3FB",
				non_qualified: null,
				image: "270b-1f3fb.png",
				sheet_x: 54,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "270B-1F3FC",
				non_qualified: null,
				image: "270b-1f3fc.png",
				sheet_x: 54,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "270B-1F3FD",
				non_qualified: null,
				image: "270b-1f3fd.png",
				sheet_x: 54,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "270B-1F3FE",
				non_qualified: null,
				image: "270b-1f3fe.png",
				sheet_x: 54,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "270B-1F3FF",
				non_qualified: null,
				image: "270b-1f3ff.png",
				sheet_x: 54,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Raised Hand",
		b: "270B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			49
		],
		n: [
			"raised_hand"
		],
		o: 2
	},
	firecracker: {
		a: "Firecracker",
		b: "1F9E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			27
		],
		o: 11
	},
	lemon: {
		a: "Lemon",
		b: "1F34B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature"
		],
		k: [
			6,
			35
		],
		o: 2
	},
	dog: {
		a: "Dog Face",
		b: "1F436",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"friend",
			"nature",
			"woof",
			"puppy",
			"pet",
			"faithful"
		],
		k: [
			12,
			26
		],
		o: 2
	},
	mens: {
		a: "Mens Symbol",
		b: "1F6B9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"toilet",
			"restroom",
			"wc",
			"blue-square",
			"gender",
			"male"
		],
		k: [
			36,
			10
		],
		o: 2
	},
	"spock-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F596-1F3FB",
				non_qualified: null,
				image: "1f596-1f3fb.png",
				sheet_x: 30,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F596-1F3FC",
				non_qualified: null,
				image: "1f596-1f3fc.png",
				sheet_x: 30,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F596-1F3FD",
				non_qualified: null,
				image: "1f596-1f3fd.png",
				sheet_x: 30,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F596-1F3FE",
				non_qualified: null,
				image: "1f596-1f3fe.png",
				sheet_x: 30,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F596-1F3FF",
				non_qualified: null,
				image: "1f596-1f3ff.png",
				sheet_x: 30,
				sheet_y: 8,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Raised Hand with Part Between Middle and Ring Fingers",
		b: "1F596",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			3
		],
		o: 2
	},
	world_map: {
		a: "World Map",
		b: "1F5FA-FE0F",
		c: "1F5FA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"location",
			"direction"
		],
		k: [
			30,
			29
		],
		o: 2
	},
	laughing: {
		a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
		b: "1F606",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"happy",
			"joy",
			"lol",
			"satisfied",
			"haha",
			"face",
			"glad",
			"XD",
			"laugh"
		],
		k: [
			30,
			41
		],
		l: [
			":>",
			":->"
		],
		n: [
			"satisfied"
		],
		o: 2
	},
	waving_white_flag: {
		a: "Waving White Flag",
		b: "1F3F3-FE0F",
		c: "1F3F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			12
		],
		o: 2
	},
	safety_vest: {
		a: "Safety Vest",
		b: "1F9BA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			54
		],
		o: 12
	},
	sweat_smile: {
		a: "Smiling Face with Open Mouth and Cold Sweat",
		b: "1F605",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"hot",
			"happy",
			"laugh",
			"sweat",
			"smile",
			"relief"
		],
		k: [
			30,
			40
		],
		o: 2
	},
	sparkles: {
		a: "Sparkles",
		b: "2728",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stars",
			"shine",
			"shiny",
			"cool",
			"awesome",
			"good",
			"magic"
		],
		k: [
			55,
			16
		],
		o: 2
	},
	banana: {
		a: "Banana",
		b: "1F34C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food",
			"monkey"
		],
		k: [
			6,
			36
		],
		o: 2
	},
	"rainbow-flag": {
		a: "Rainbow Flag",
		b: "1F3F3-FE0F-200D-1F308",
		c: "1F3F3-200D-1F308",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			11
		],
		o: 4
	},
	ok_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44C-1F3FB",
				non_qualified: null,
				image: "1f44c-1f3fb.png",
				sheet_x: 13,
				sheet_y: 33,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44C-1F3FC",
				non_qualified: null,
				image: "1f44c-1f3fc.png",
				sheet_x: 13,
				sheet_y: 34,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44C-1F3FD",
				non_qualified: null,
				image: "1f44c-1f3fd.png",
				sheet_x: 13,
				sheet_y: 35,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44C-1F3FE",
				non_qualified: null,
				image: "1f44c-1f3fe.png",
				sheet_x: 13,
				sheet_y: 36,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44C-1F3FF",
				non_qualified: null,
				image: "1f44c-1f3ff.png",
				sheet_x: 13,
				sheet_y: 37,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Ok Hand Sign",
		b: "1F44C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"limbs",
			"perfect",
			"ok",
			"okay"
		],
		k: [
			13,
			32
		],
		o: 2
	},
	japan: {
		a: "Silhouette of Japan",
		b: "1F5FE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nation",
			"country",
			"japanese",
			"asia"
		],
		k: [
			30,
			33
		],
		o: 2
	},
	dog2: {
		a: "Dog",
		b: "1F415",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"friend",
			"doge",
			"pet",
			"faithful"
		],
		k: [
			11,
			50
		],
		o: 2
	},
	womens: {
		a: "Womens Symbol",
		b: "1F6BA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"woman",
			"female",
			"toilet",
			"loo",
			"restroom",
			"gender"
		],
		k: [
			36,
			11
		],
		o: 2
	},
	necktie: {
		a: "Necktie",
		b: "1F454",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shirt",
			"suitup",
			"formal",
			"fashion",
			"cloth",
			"business"
		],
		k: [
			14,
			8
		],
		o: 2
	},
	pirate_flag: {
		a: "Pirate Flag",
		b: "1F3F4-200D-2620-FE0F",
		c: "1F3F4-200D-2620",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			13
		],
		o: 11
	},
	guide_dog: {
		a: "Guide Dog",
		b: "1F9AE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			2
		],
		o: 12
	},
	restroom: {
		a: "Restroom",
		b: "1F6BB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"toilet",
			"refresh",
			"wc",
			"gender"
		],
		k: [
			36,
			12
		],
		o: 2
	},
	compass: {
		a: "Compass",
		b: "1F9ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			32
		],
		o: 11
	},
	rolling_on_the_floor_laughing: {
		a: "Rolling on the Floor Laughing",
		b: "1F923",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			20
		],
		o: 4
	},
	balloon: {
		a: "Balloon",
		b: "1F388",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"party",
			"celebration",
			"birthday",
			"circus"
		],
		k: [
			7,
			44
		],
		o: 2
	},
	pinching_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F90F-1F3FB",
				non_qualified: null,
				image: "1f90f-1f3fb.png",
				sheet_x: 37,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F90F-1F3FC",
				non_qualified: null,
				image: "1f90f-1f3fc.png",
				sheet_x: 37,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F90F-1F3FD",
				non_qualified: null,
				image: "1f90f-1f3fd.png",
				sheet_x: 37,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F90F-1F3FE",
				non_qualified: null,
				image: "1f90f-1f3fe.png",
				sheet_x: 37,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F90F-1F3FF",
				non_qualified: null,
				image: "1f90f-1f3ff.png",
				sheet_x: 37,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Pinching Hand",
		b: "1F90F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			17
		],
		o: 12
	},
	pineapple: {
		a: "Pineapple",
		b: "1F34D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			6,
			37
		],
		o: 2
	},
	shirt: {
		a: "T-Shirt",
		b: "1F455",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			14,
			9
		],
		n: [
			"tshirt"
		],
		o: 2
	},
	service_dog: {
		a: "Service Dog",
		b: "1F415-200D-1F9BA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			49
		],
		o: 12
	},
	baby_symbol: {
		a: "Baby Symbol",
		b: "1F6BC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"orange-square",
			"child"
		],
		k: [
			36,
			13
		],
		o: 2
	},
	joy: {
		a: "Face with Tears of Joy",
		b: "1F602",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"cry",
			"tears",
			"weep",
			"happy",
			"happytears",
			"haha"
		],
		k: [
			30,
			37
		],
		o: 2
	},
	tada: {
		a: "Party Popper",
		b: "1F389",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"party",
			"congratulations",
			"birthday",
			"magic",
			"circus",
			"celebration"
		],
		k: [
			7,
			45
		],
		o: 2
	},
	mango: {
		a: "Mango",
		b: "1F96D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			3
		],
		o: 11
	},
	v: {
		skin_variations: {
			"1F3FB": {
				unified: "270C-1F3FB",
				non_qualified: null,
				image: "270c-1f3fb.png",
				sheet_x: 54,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "270C-1F3FC",
				non_qualified: null,
				image: "270c-1f3fc.png",
				sheet_x: 55,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "270C-1F3FD",
				non_qualified: null,
				image: "270c-1f3fd.png",
				sheet_x: 55,
				sheet_y: 1,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "270C-1F3FE",
				non_qualified: null,
				image: "270c-1f3fe.png",
				sheet_x: 55,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "270C-1F3FF",
				non_qualified: null,
				image: "270c-1f3ff.png",
				sheet_x: 55,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Victory Hand",
		b: "270C-FE0F",
		c: "270C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"ohyeah",
			"hand",
			"peace",
			"victory",
			"two"
		],
		k: [
			54,
			55
		],
		o: 2
	},
	snow_capped_mountain: {
		a: "Snow Capped Mountain",
		b: "1F3D4-FE0F",
		c: "1F3D4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			39
		],
		o: 2
	},
	"flag-ac": {
		a: "Ascension Island Flag",
		b: "1F1E6-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			31
		],
		o: 2
	},
	jeans: {
		a: "Jeans",
		b: "1F456",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"shopping"
		],
		k: [
			14,
			10
		],
		o: 2
	},
	poodle: {
		a: "Poodle",
		b: "1F429",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dog",
			"animal",
			"101",
			"nature",
			"pet"
		],
		k: [
			12,
			13
		],
		o: 2
	},
	crossed_fingers: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91E-1F3FB",
				non_qualified: null,
				image: "1f91e-1f3fb.png",
				sheet_x: 38,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F91E-1F3FC",
				non_qualified: null,
				image: "1f91e-1f3fc.png",
				sheet_x: 38,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F91E-1F3FD",
				non_qualified: null,
				image: "1f91e-1f3fd.png",
				sheet_x: 38,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F91E-1F3FE",
				non_qualified: null,
				image: "1f91e-1f3fe.png",
				sheet_x: 38,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F91E-1F3FF",
				non_qualified: null,
				image: "1f91e-1f3ff.png",
				sheet_x: 38,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Hand with Index and Middle Fingers Crossed",
		b: "1F91E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"good",
			"lucky"
		],
		k: [
			38,
			5
		],
		n: [
			"hand_with_index_and_middle_fingers_crossed"
		],
		o: 4
	},
	"flag-ad": {
		a: "Andorra Flag",
		b: "1F1E6-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			32
		],
		o: 2
	},
	slightly_smiling_face: {
		a: "Slightly Smiling Face",
		b: "1F642",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"smile"
		],
		k: [
			31,
			44
		],
		l: [
			":)",
			"(:",
			":-)"
		],
		o: 2
	},
	apple: {
		a: "Red Apple",
		b: "1F34E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"mac",
			"school"
		],
		k: [
			6,
			38
		],
		o: 2
	},
	wc: {
		a: "Water Closet",
		b: "1F6BE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"toilet",
			"restroom",
			"blue-square"
		],
		k: [
			36,
			15
		],
		o: 2
	},
	scarf: {
		a: "Scarf",
		b: "1F9E3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			22
		],
		o: 5
	},
	mountain: {
		a: "Mountain",
		b: "26F0-FE0F",
		c: "26F0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"nature",
			"environment"
		],
		k: [
			54,
			11
		],
		o: 2
	},
	confetti_ball: {
		a: "Confetti Ball",
		b: "1F38A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"festival",
			"party",
			"birthday",
			"circus"
		],
		k: [
			7,
			46
		],
		o: 2
	},
	i_love_you_hand_sign: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91F-1F3FB",
				non_qualified: null,
				image: "1f91f-1f3fb.png",
				sheet_x: 38,
				sheet_y: 12,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F91F-1F3FC",
				non_qualified: null,
				image: "1f91f-1f3fc.png",
				sheet_x: 38,
				sheet_y: 13,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F91F-1F3FD",
				non_qualified: null,
				image: "1f91f-1f3fd.png",
				sheet_x: 38,
				sheet_y: 14,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F91F-1F3FE",
				non_qualified: null,
				image: "1f91f-1f3fe.png",
				sheet_x: 38,
				sheet_y: 15,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F91F-1F3FF",
				non_qualified: null,
				image: "1f91f-1f3ff.png",
				sheet_x: 38,
				sheet_y: 16,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "I Love You Hand Sign",
		b: "1F91F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			11
		],
		o: 5
	},
	wolf: {
		a: "Wolf Face",
		b: "1F43A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"wild"
		],
		k: [
			12,
			30
		],
		o: 2
	},
	gloves: {
		a: "Gloves",
		b: "1F9E4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			23
		],
		o: 5
	},
	"flag-ae": {
		a: "United Arab Emirates Flag",
		b: "1F1E6-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			33
		],
		o: 2
	},
	upside_down_face: {
		a: "Upside-Down Face",
		b: "1F643",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"flipped",
			"silly",
			"smile"
		],
		k: [
			31,
			45
		],
		o: 2
	},
	green_apple: {
		a: "Green Apple",
		b: "1F34F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature"
		],
		k: [
			6,
			39
		],
		o: 2
	},
	passport_control: {
		a: "Passport Control",
		b: "1F6C2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"custom",
			"blue-square"
		],
		k: [
			36,
			24
		],
		o: 2
	},
	volcano: {
		a: "Volcano",
		b: "1F30B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"nature",
			"disaster"
		],
		k: [
			5,
			30
		],
		o: 2
	},
	tanabata_tree: {
		a: "Tanabata Tree",
		b: "1F38B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature",
			"branch",
			"summer"
		],
		k: [
			7,
			47
		],
		o: 2
	},
	customs: {
		a: "Customs",
		b: "1F6C3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"passport",
			"border",
			"blue-square"
		],
		k: [
			36,
			25
		],
		o: 2
	},
	coat: {
		a: "Coat",
		b: "1F9E5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			24
		],
		o: 5
	},
	wink: {
		a: "Winking Face",
		b: "1F609",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"happy",
			"mischievous",
			"secret",
			";)",
			"smile",
			"eye"
		],
		k: [
			30,
			44
		],
		l: [
			";)",
			";-)"
		],
		m: ";)",
		o: 2
	},
	bamboo: {
		a: "Pine Decoration",
		b: "1F38D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature",
			"vegetable",
			"panda",
			"pine_decoration"
		],
		k: [
			7,
			49
		],
		o: 2
	},
	"flag-af": {
		a: "Afghanistan Flag",
		b: "1F1E6-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			34
		],
		o: 2
	},
	fox_face: {
		a: "Fox Face",
		b: "1F98A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"face"
		],
		k: [
			42,
			28
		],
		o: 4
	},
	pear: {
		a: "Pear",
		b: "1F350",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			6,
			40
		],
		o: 2
	},
	mount_fuji: {
		a: "Mount Fuji",
		b: "1F5FB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"mountain",
			"nature",
			"japanese"
		],
		k: [
			30,
			30
		],
		o: 2
	},
	the_horns: {
		skin_variations: {
			"1F3FB": {
				unified: "1F918-1F3FB",
				non_qualified: null,
				image: "1f918-1f3fb.png",
				sheet_x: 37,
				sheet_y: 32,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F918-1F3FC",
				non_qualified: null,
				image: "1f918-1f3fc.png",
				sheet_x: 37,
				sheet_y: 33,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F918-1F3FD",
				non_qualified: null,
				image: "1f918-1f3fd.png",
				sheet_x: 37,
				sheet_y: 34,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F918-1F3FE",
				non_qualified: null,
				image: "1f918-1f3fe.png",
				sheet_x: 37,
				sheet_y: 35,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F918-1F3FF",
				non_qualified: null,
				image: "1f918-1f3ff.png",
				sheet_x: 37,
				sheet_y: 36,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Sign of the Horns",
		b: "1F918",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			31
		],
		n: [
			"sign_of_the_horns"
		],
		o: 2
	},
	call_me_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F919-1F3FB",
				non_qualified: null,
				image: "1f919-1f3fb.png",
				sheet_x: 37,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F919-1F3FC",
				non_qualified: null,
				image: "1f919-1f3fc.png",
				sheet_x: 37,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F919-1F3FD",
				non_qualified: null,
				image: "1f919-1f3fd.png",
				sheet_x: 37,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F919-1F3FE",
				non_qualified: null,
				image: "1f919-1f3fe.png",
				sheet_x: 37,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F919-1F3FF",
				non_qualified: null,
				image: "1f919-1f3ff.png",
				sheet_x: 37,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Call Me Hand",
		b: "1F919",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hands",
			"gesture"
		],
		k: [
			37,
			37
		],
		o: 4
	},
	"flag-ag": {
		a: "Antigua & Barbuda Flag",
		b: "1F1E6-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			35
		],
		o: 2
	},
	raccoon: {
		a: "Raccoon",
		b: "1F99D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			47
		],
		o: 11
	},
	dolls: {
		a: "Japanese Dolls",
		b: "1F38E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"toy",
			"kimono"
		],
		k: [
			7,
			50
		],
		o: 2
	},
	blush: {
		a: "Smiling Face with Smiling Eyes",
		b: "1F60A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"smile",
			"happy",
			"flushed",
			"crush",
			"embarrassed",
			"shy",
			"joy"
		],
		k: [
			30,
			45
		],
		m: ":)",
		o: 2
	},
	peach: {
		a: "Peach",
		b: "1F351",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			6,
			41
		],
		o: 2
	},
	baggage_claim: {
		a: "Baggage Claim",
		b: "1F6C4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"airport",
			"transport"
		],
		k: [
			36,
			26
		],
		o: 2
	},
	socks: {
		a: "Socks",
		b: "1F9E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			25
		],
		o: 5
	},
	camping: {
		a: "Camping",
		b: "1F3D5-FE0F",
		c: "1F3D5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"outdoors",
			"tent"
		],
		k: [
			10,
			40
		],
		o: 2
	},
	dress: {
		a: "Dress",
		b: "1F457",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"clothes",
			"fashion",
			"shopping"
		],
		k: [
			14,
			11
		],
		o: 2
	},
	beach_with_umbrella: {
		a: "Beach with Umbrella",
		b: "1F3D6-FE0F",
		c: "1F3D6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			41
		],
		o: 2
	},
	cherries: {
		a: "Cherries",
		b: "1F352",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"fruit"
		],
		k: [
			6,
			42
		],
		o: 2
	},
	cat: {
		a: "Cat Face",
		b: "1F431",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"meow",
			"nature",
			"pet",
			"kitten"
		],
		k: [
			12,
			21
		],
		o: 2
	},
	point_left: {
		skin_variations: {
			"1F3FB": {
				unified: "1F448-1F3FB",
				non_qualified: null,
				image: "1f448-1f3fb.png",
				sheet_x: 13,
				sheet_y: 9,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F448-1F3FC",
				non_qualified: null,
				image: "1f448-1f3fc.png",
				sheet_x: 13,
				sheet_y: 10,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F448-1F3FD",
				non_qualified: null,
				image: "1f448-1f3fd.png",
				sheet_x: 13,
				sheet_y: 11,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F448-1F3FE",
				non_qualified: null,
				image: "1f448-1f3fe.png",
				sheet_x: 13,
				sheet_y: 12,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F448-1F3FF",
				non_qualified: null,
				image: "1f448-1f3ff.png",
				sheet_x: 13,
				sheet_y: 13,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Left Pointing Backhand Index",
		b: "1F448",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"direction",
			"fingers",
			"hand",
			"left"
		],
		k: [
			13,
			8
		],
		o: 2
	},
	left_luggage: {
		a: "Left Luggage",
		b: "1F6C5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"travel"
		],
		k: [
			36,
			27
		],
		o: 2
	},
	"flag-ai": {
		a: "Anguilla Flag",
		b: "1F1E6-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			36
		],
		o: 2
	},
	innocent: {
		a: "Smiling Face with Halo",
		b: "1F607",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"angel",
			"heaven",
			"halo"
		],
		k: [
			30,
			42
		],
		o: 2
	},
	flags: {
		a: "Carp Streamer",
		b: "1F38F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fish",
			"japanese",
			"koinobori",
			"carp",
			"banner"
		],
		k: [
			7,
			51
		],
		o: 2
	},
	warning: {
		a: "Warning Sign",
		b: "26A0-FE0F",
		c: "26A0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"exclamation",
			"wip",
			"alert",
			"error",
			"problem",
			"issue"
		],
		k: [
			53,
			50
		],
		o: 2
	},
	strawberry: {
		a: "Strawberry",
		b: "1F353",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food",
			"nature"
		],
		k: [
			6,
			43
		],
		o: 2
	},
	point_right: {
		skin_variations: {
			"1F3FB": {
				unified: "1F449-1F3FB",
				non_qualified: null,
				image: "1f449-1f3fb.png",
				sheet_x: 13,
				sheet_y: 15,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F449-1F3FC",
				non_qualified: null,
				image: "1f449-1f3fc.png",
				sheet_x: 13,
				sheet_y: 16,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F449-1F3FD",
				non_qualified: null,
				image: "1f449-1f3fd.png",
				sheet_x: 13,
				sheet_y: 17,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F449-1F3FE",
				non_qualified: null,
				image: "1f449-1f3fe.png",
				sheet_x: 13,
				sheet_y: 18,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F449-1F3FF",
				non_qualified: null,
				image: "1f449-1f3ff.png",
				sheet_x: 13,
				sheet_y: 19,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Right Pointing Backhand Index",
		b: "1F449",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"right"
		],
		k: [
			13,
			14
		],
		o: 2
	},
	desert: {
		a: "Desert",
		b: "1F3DC-FE0F",
		c: "1F3DC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"warm",
			"saharah"
		],
		k: [
			10,
			47
		],
		o: 2
	},
	kimono: {
		a: "Kimono",
		b: "1F458",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dress",
			"fashion",
			"women",
			"female",
			"japanese"
		],
		k: [
			14,
			12
		],
		o: 2
	},
	"flag-al": {
		a: "Albania Flag",
		b: "1F1E6-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			37
		],
		o: 2
	},
	wind_chime: {
		a: "Wind Chime",
		b: "1F390",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"ding",
			"spring",
			"bell"
		],
		k: [
			7,
			52
		],
		o: 2
	},
	smiling_face_with_3_hearts: {
		a: "Smiling Face with Smiling Eyes and Three Hearts",
		b: "1F970",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			6
		],
		o: 11
	},
	cat2: {
		a: "Cat",
		b: "1F408",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"meow",
			"pet",
			"cats"
		],
		k: [
			11,
			36
		],
		o: 2
	},
	rice_scene: {
		a: "Moon Viewing Ceremony",
		b: "1F391",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"japan",
			"asia",
			"tsukimi"
		],
		k: [
			7,
			53
		],
		o: 2
	},
	heart_eyes: {
		a: "Smiling Face with Heart-Shaped Eyes",
		b: "1F60D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush",
			"heart"
		],
		k: [
			30,
			48
		],
		o: 2
	},
	sari: {
		a: "Sari",
		b: "1F97B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			13
		],
		o: 12
	},
	"flag-am": {
		a: "Armenia Flag",
		b: "1F1E6-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			38
		],
		o: 2
	},
	lion_face: {
		a: "Lion Face",
		b: "1F981",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			19
		],
		o: 2
	},
	desert_island: {
		a: "Desert Island",
		b: "1F3DD-FE0F",
		c: "1F3DD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"tropical",
			"mojito"
		],
		k: [
			10,
			48
		],
		o: 2
	},
	point_up_2: {
		skin_variations: {
			"1F3FB": {
				unified: "1F446-1F3FB",
				non_qualified: null,
				image: "1f446-1f3fb.png",
				sheet_x: 12,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F446-1F3FC",
				non_qualified: null,
				image: "1f446-1f3fc.png",
				sheet_x: 12,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F446-1F3FD",
				non_qualified: null,
				image: "1f446-1f3fd.png",
				sheet_x: 12,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F446-1F3FE",
				non_qualified: null,
				image: "1f446-1f3fe.png",
				sheet_x: 13,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F446-1F3FF",
				non_qualified: null,
				image: "1f446-1f3ff.png",
				sheet_x: 13,
				sheet_y: 1,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Up Pointing Backhand Index",
		b: "1F446",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"up"
		],
		k: [
			12,
			53
		],
		o: 2
	},
	kiwifruit: {
		a: "Kiwifruit",
		b: "1F95D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			44
		],
		o: 4
	},
	children_crossing: {
		a: "Children Crossing",
		b: "1F6B8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"school",
			"warning",
			"danger",
			"sign",
			"driving",
			"yellow-diamond"
		],
		k: [
			36,
			9
		],
		o: 2
	},
	national_park: {
		a: "National Park",
		b: "1F3DE-FE0F",
		c: "1F3DE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"environment",
			"nature"
		],
		k: [
			10,
			49
		],
		o: 2
	},
	no_entry: {
		a: "No Entry",
		b: "26D4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"limit",
			"security",
			"privacy",
			"bad",
			"denied",
			"stop",
			"circle"
		],
		k: [
			54,
			8
		],
		o: 2
	},
	"one-piece_swimsuit": {
		a: "One-Piece Swimsuit",
		b: "1FA71",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			52
		],
		o: 12
	},
	tiger: {
		a: "Tiger Face",
		b: "1F42F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cat",
			"danger",
			"wild",
			"nature",
			"roar"
		],
		k: [
			12,
			19
		],
		o: 2
	},
	red_envelope: {
		a: "Red Gift Envelope",
		b: "1F9E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			26
		],
		o: 11
	},
	"star-struck": {
		a: "Grinning Face with Star Eyes",
		b: "1F929",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			43
		],
		n: [
			"grinning_face_with_star_eyes"
		],
		o: 5
	},
	middle_finger: {
		skin_variations: {
			"1F3FB": {
				unified: "1F595-1F3FB",
				non_qualified: null,
				image: "1f595-1f3fb.png",
				sheet_x: 29,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F595-1F3FC",
				non_qualified: null,
				image: "1f595-1f3fc.png",
				sheet_x: 29,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F595-1F3FD",
				non_qualified: null,
				image: "1f595-1f3fd.png",
				sheet_x: 30,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F595-1F3FE",
				non_qualified: null,
				image: "1f595-1f3fe.png",
				sheet_x: 30,
				sheet_y: 1,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F595-1F3FF",
				non_qualified: null,
				image: "1f595-1f3ff.png",
				sheet_x: 30,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Reversed Hand with Middle Finger Extended",
		b: "1F595",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			54
		],
		n: [
			"reversed_hand_with_middle_finger_extended"
		],
		o: 2
	},
	"flag-ao": {
		a: "Angola Flag",
		b: "1F1E6-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			39
		],
		o: 2
	},
	tomato: {
		a: "Tomato",
		b: "1F345",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"vegetable",
			"nature",
			"food"
		],
		k: [
			6,
			29
		],
		o: 2
	},
	coconut: {
		a: "Coconut",
		b: "1F965",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			52
		],
		o: 5
	},
	ribbon: {
		a: "Ribbon",
		b: "1F380",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"decoration",
			"pink",
			"girl",
			"bowtie"
		],
		k: [
			7,
			31
		],
		o: 2
	},
	no_entry_sign: {
		a: "No Entry Sign",
		b: "1F6AB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"forbid",
			"stop",
			"limit",
			"denied",
			"disallow",
			"circle"
		],
		k: [
			35,
			2
		],
		o: 2
	},
	point_down: {
		skin_variations: {
			"1F3FB": {
				unified: "1F447-1F3FB",
				non_qualified: null,
				image: "1f447-1f3fb.png",
				sheet_x: 13,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F447-1F3FC",
				non_qualified: null,
				image: "1f447-1f3fc.png",
				sheet_x: 13,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F447-1F3FD",
				non_qualified: null,
				image: "1f447-1f3fd.png",
				sheet_x: 13,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F447-1F3FE",
				non_qualified: null,
				image: "1f447-1f3fe.png",
				sheet_x: 13,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F447-1F3FF",
				non_qualified: null,
				image: "1f447-1f3ff.png",
				sheet_x: 13,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Down Pointing Backhand Index",
		b: "1F447",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"down"
		],
		k: [
			13,
			2
		],
		o: 2
	},
	"flag-aq": {
		a: "Antarctica Flag",
		b: "1F1E6-1F1F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			40
		],
		o: 2
	},
	briefs: {
		a: "Briefs",
		b: "1FA72",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			53
		],
		o: 12
	},
	kissing_heart: {
		a: "Face Throwing a Kiss",
		b: "1F618",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			31,
			2
		],
		l: [
			":*",
			":-*"
		],
		o: 2
	},
	tiger2: {
		a: "Tiger",
		b: "1F405",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"roar"
		],
		k: [
			11,
			33
		],
		o: 2
	},
	stadium: {
		a: "Stadium",
		b: "1F3DF-FE0F",
		c: "1F3DF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"place",
			"sports",
			"concert",
			"venue"
		],
		k: [
			10,
			50
		],
		o: 2
	},
	leopard: {
		a: "Leopard",
		b: "1F406",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			11,
			34
		],
		o: 2
	},
	no_bicycles: {
		a: "No Bicycles",
		b: "1F6B3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cyclist",
			"prohibited",
			"circle"
		],
		k: [
			35,
			10
		],
		o: 2
	},
	kissing: {
		a: "Kissing Face",
		b: "1F617",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"face",
			"3",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			31,
			1
		],
		o: 2
	},
	"flag-ar": {
		a: "Argentina Flag",
		b: "1F1E6-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			41
		],
		o: 2
	},
	avocado: {
		a: "Avocado",
		b: "1F951",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food"
		],
		k: [
			41,
			32
		],
		o: 4
	},
	point_up: {
		skin_variations: {
			"1F3FB": {
				unified: "261D-1F3FB",
				non_qualified: null,
				image: "261d-1f3fb.png",
				sheet_x: 53,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "261D-1F3FC",
				non_qualified: null,
				image: "261d-1f3fc.png",
				sheet_x: 53,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "261D-1F3FD",
				non_qualified: null,
				image: "261d-1f3fd.png",
				sheet_x: 53,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "261D-1F3FE",
				non_qualified: null,
				image: "261d-1f3fe.png",
				sheet_x: 53,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "261D-1F3FF",
				non_qualified: null,
				image: "261d-1f3ff.png",
				sheet_x: 53,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Up Pointing Index",
		b: "261D-FE0F",
		c: "261D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hand",
			"fingers",
			"direction",
			"up"
		],
		k: [
			53,
			2
		],
		o: 2
	},
	gift: {
		a: "Wrapped Present",
		b: "1F381",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"present",
			"birthday",
			"christmas",
			"xmas"
		],
		k: [
			7,
			32
		],
		o: 2
	},
	classical_building: {
		a: "Classical Building",
		b: "1F3DB-FE0F",
		c: "1F3DB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"art",
			"culture",
			"history"
		],
		k: [
			10,
			46
		],
		o: 2
	},
	shorts: {
		a: "Shorts",
		b: "1FA73",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			54
		],
		o: 12
	},
	"+1": {
		skin_variations: {
			"1F3FB": {
				unified: "1F44D-1F3FB",
				non_qualified: null,
				image: "1f44d-1f3fb.png",
				sheet_x: 13,
				sheet_y: 39,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44D-1F3FC",
				non_qualified: null,
				image: "1f44d-1f3fc.png",
				sheet_x: 13,
				sheet_y: 40,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44D-1F3FD",
				non_qualified: null,
				image: "1f44d-1f3fd.png",
				sheet_x: 13,
				sheet_y: 41,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44D-1F3FE",
				non_qualified: null,
				image: "1f44d-1f3fe.png",
				sheet_x: 13,
				sheet_y: 42,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44D-1F3FF",
				non_qualified: null,
				image: "1f44d-1f3ff.png",
				sheet_x: 13,
				sheet_y: 43,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Thumbs Up Sign",
		b: "1F44D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"thumbsup",
			"yes",
			"awesome",
			"good",
			"agree",
			"accept",
			"cool",
			"hand",
			"like"
		],
		k: [
			13,
			38
		],
		n: [
			"thumbsup"
		],
		o: 2
	},
	horse: {
		a: "Horse Face",
		b: "1F434",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"brown",
			"nature"
		],
		k: [
			12,
			24
		],
		o: 2
	},
	bikini: {
		a: "Bikini",
		b: "1F459",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"swimming",
			"female",
			"woman",
			"girl",
			"fashion",
			"beach",
			"summer"
		],
		k: [
			14,
			13
		],
		o: 2
	},
	no_smoking: {
		a: "No Smoking Symbol",
		b: "1F6AD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cigarette",
			"blue-square",
			"smell",
			"smoke"
		],
		k: [
			35,
			4
		],
		o: 2
	},
	eggplant: {
		a: "Aubergine",
		b: "1F346",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"nature",
			"food",
			"aubergine"
		],
		k: [
			6,
			30
		],
		o: 2
	},
	"flag-as": {
		a: "American Samoa Flag",
		b: "1F1E6-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			42
		],
		o: 2
	},
	reminder_ribbon: {
		a: "Reminder Ribbon",
		b: "1F397-FE0F",
		c: "1F397",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"cause",
			"support",
			"awareness"
		],
		k: [
			8,
			0
		],
		o: 2
	},
	building_construction: {
		a: "Building Construction",
		b: "1F3D7-FE0F",
		c: "1F3D7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wip",
			"working",
			"progress"
		],
		k: [
			10,
			42
		],
		o: 2
	},
	relaxed: {
		a: "White Smiling Face",
		b: "263A-FE0F",
		c: "263A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"blush",
			"massage",
			"happiness"
		],
		k: [
			53,
			17
		],
		o: 2
	},
	kissing_closed_eyes: {
		a: "Kissing Face with Closed Eyes",
		b: "1F61A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			31,
			4
		],
		o: 2
	},
	"-1": {
		skin_variations: {
			"1F3FB": {
				unified: "1F44E-1F3FB",
				non_qualified: null,
				image: "1f44e-1f3fb.png",
				sheet_x: 13,
				sheet_y: 45,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44E-1F3FC",
				non_qualified: null,
				image: "1f44e-1f3fc.png",
				sheet_x: 13,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44E-1F3FD",
				non_qualified: null,
				image: "1f44e-1f3fd.png",
				sheet_x: 13,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44E-1F3FE",
				non_qualified: null,
				image: "1f44e-1f3fe.png",
				sheet_x: 13,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44E-1F3FF",
				non_qualified: null,
				image: "1f44e-1f3ff.png",
				sheet_x: 13,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Thumbs Down Sign",
		b: "1F44E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"thumbsdown",
			"no",
			"dislike",
			"hand"
		],
		k: [
			13,
			44
		],
		n: [
			"thumbsdown"
		],
		o: 2
	},
	admission_tickets: {
		a: "Admission Tickets",
		b: "1F39F-FE0F",
		c: "1F39F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			8,
			5
		],
		o: 2
	},
	"flag-at": {
		a: "Austria Flag",
		b: "1F1E6-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			43
		],
		o: 2
	},
	womans_clothes: {
		a: "Womans Clothes",
		b: "1F45A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"shopping_bags",
			"female"
		],
		k: [
			14,
			14
		],
		o: 2
	},
	do_not_litter: {
		a: "Do Not Litter Symbol",
		b: "1F6AF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"trash",
			"bin",
			"garbage",
			"circle"
		],
		k: [
			35,
			6
		],
		o: 2
	},
	potato: {
		a: "Potato",
		b: "1F954",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"tuber",
			"vegatable",
			"starch"
		],
		k: [
			41,
			35
		],
		o: 4
	},
	racehorse: {
		a: "Horse",
		b: "1F40E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"gamble",
			"luck"
		],
		k: [
			11,
			42
		],
		o: 2
	},
	bricks: {
		a: "Brick",
		b: "1F9F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			36
		],
		o: 11
	},
	fist: {
		skin_variations: {
			"1F3FB": {
				unified: "270A-1F3FB",
				non_qualified: null,
				image: "270a-1f3fb.png",
				sheet_x: 54,
				sheet_y: 44,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "270A-1F3FC",
				non_qualified: null,
				image: "270a-1f3fc.png",
				sheet_x: 54,
				sheet_y: 45,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "270A-1F3FD",
				non_qualified: null,
				image: "270a-1f3fd.png",
				sheet_x: 54,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "270A-1F3FE",
				non_qualified: null,
				image: "270a-1f3fe.png",
				sheet_x: 54,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "270A-1F3FF",
				non_qualified: null,
				image: "270a-1f3ff.png",
				sheet_x: 54,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Raised Fist",
		b: "270A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"hand",
			"grasp"
		],
		k: [
			54,
			43
		],
		o: 2
	},
	house_buildings: {
		a: "House Buildings",
		b: "1F3D8-FE0F",
		c: "1F3D8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			43
		],
		o: 2
	},
	carrot: {
		a: "Carrot",
		b: "1F955",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"food",
			"orange"
		],
		k: [
			41,
			36
		],
		o: 4
	},
	ticket: {
		a: "Ticket",
		b: "1F3AB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"event",
			"concert",
			"pass"
		],
		k: [
			8,
			17
		],
		o: 2
	},
	"flag-au": {
		a: "Australia Flag",
		b: "1F1E6-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			44
		],
		o: 2
	},
	"non-potable_water": {
		a: "Non-Potable Water Symbol",
		b: "1F6B1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"faucet",
			"tap",
			"circle"
		],
		k: [
			35,
			8
		],
		o: 2
	},
	purse: {
		a: "Purse",
		b: "1F45B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"accessories",
			"money",
			"sales",
			"shopping"
		],
		k: [
			14,
			15
		],
		o: 2
	},
	unicorn_face: {
		a: "Unicorn Face",
		b: "1F984",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			22
		],
		o: 2
	},
	kissing_smiling_eyes: {
		a: "Kissing Face with Smiling Eyes",
		b: "1F619",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			31,
			3
		],
		o: 2
	},
	facepunch: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44A-1F3FB",
				non_qualified: null,
				image: "1f44a-1f3fb.png",
				sheet_x: 13,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44A-1F3FC",
				non_qualified: null,
				image: "1f44a-1f3fc.png",
				sheet_x: 13,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44A-1F3FD",
				non_qualified: null,
				image: "1f44a-1f3fd.png",
				sheet_x: 13,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44A-1F3FE",
				non_qualified: null,
				image: "1f44a-1f3fe.png",
				sheet_x: 13,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44A-1F3FF",
				non_qualified: null,
				image: "1f44a-1f3ff.png",
				sheet_x: 13,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Fisted Hand Sign",
		b: "1F44A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"angry",
			"violence",
			"fist",
			"hit",
			"attack",
			"hand"
		],
		k: [
			13,
			20
		],
		n: [
			"punch"
		],
		o: 2
	},
	medal: {
		a: "Medal",
		b: "1F396-FE0F",
		c: "1F396",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			7,
			56
		],
		o: 2
	},
	zebra_face: {
		a: "Zebra Face",
		b: "1F993",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			37
		],
		o: 5
	},
	handbag: {
		a: "Handbag",
		b: "1F45C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"accessory",
			"accessories",
			"shopping"
		],
		k: [
			14,
			16
		],
		o: 2
	},
	derelict_house_building: {
		a: "Derelict House Building",
		b: "1F3DA-FE0F",
		c: "1F3DA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			45
		],
		o: 2
	},
	yum: {
		a: "Face Savouring Delicious Food",
		b: "1F60B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"happy",
			"joy",
			"tongue",
			"smile",
			"face",
			"silly",
			"yummy",
			"nom",
			"delicious",
			"savouring"
		],
		k: [
			30,
			46
		],
		o: 2
	},
	corn: {
		a: "Ear of Maize",
		b: "1F33D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"vegetable",
			"plant"
		],
		k: [
			6,
			21
		],
		o: 2
	},
	"flag-aw": {
		a: "Aruba Flag",
		b: "1F1E6-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			45
		],
		o: 2
	},
	no_pedestrians: {
		a: "No Pedestrians",
		b: "1F6B7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"rules",
			"crossing",
			"walking",
			"circle"
		],
		k: [
			36,
			8
		],
		o: 2
	},
	house: {
		a: "House Building",
		b: "1F3E0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"home"
		],
		k: [
			10,
			51
		],
		o: 2
	},
	hot_pepper: {
		a: "Hot Pepper",
		b: "1F336-FE0F",
		c: "1F336",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"spicy",
			"chilli",
			"chili"
		],
		k: [
			6,
			14
		],
		o: 2
	},
	"flag-ax": {
		a: "Åland Islands Flag",
		b: "1F1E6-1F1FD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			46
		],
		o: 2
	},
	trophy: {
		a: "Trophy",
		b: "1F3C6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"win",
			"award",
			"contest",
			"place",
			"ftw",
			"ceremony"
		],
		k: [
			9,
			26
		],
		o: 2
	},
	deer: {
		a: "Deer",
		b: "1F98C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"horns",
			"venison"
		],
		k: [
			42,
			30
		],
		o: 4
	},
	"left-facing_fist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F91B-1F3FB",
				non_qualified: null,
				image: "1f91b-1f3fb.png",
				sheet_x: 37,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F91B-1F3FC",
				non_qualified: null,
				image: "1f91b-1f3fc.png",
				sheet_x: 37,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F91B-1F3FD",
				non_qualified: null,
				image: "1f91b-1f3fd.png",
				sheet_x: 37,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F91B-1F3FE",
				non_qualified: null,
				image: "1f91b-1f3fe.png",
				sheet_x: 37,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F91B-1F3FF",
				non_qualified: null,
				image: "1f91b-1f3ff.png",
				sheet_x: 37,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Left-Facing Fist",
		b: "1F91B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			49
		],
		o: 4
	},
	stuck_out_tongue: {
		a: "Face with Stuck-out Tongue",
		b: "1F61B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"tongue"
		],
		k: [
			31,
			5
		],
		l: [
			":p",
			":-p",
			":P",
			":-P",
			":b",
			":-b"
		],
		m: ":p",
		o: 2
	},
	pouch: {
		a: "Pouch",
		b: "1F45D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bag",
			"accessories",
			"shopping"
		],
		k: [
			14,
			17
		],
		o: 2
	},
	no_mobile_phones: {
		a: "No Mobile Phones",
		b: "1F4F5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"iphone",
			"mute",
			"circle"
		],
		k: [
			27,
			18
		],
		o: 2
	},
	stuck_out_tongue_winking_eye: {
		a: "Face with Stuck-out Tongue and Winking Eye",
		b: "1F61C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"wink",
			"tongue"
		],
		k: [
			31,
			6
		],
		l: [
			";p",
			";-p",
			";b",
			";-b",
			";P",
			";-P"
		],
		m: ";p",
		o: 2
	},
	sports_medal: {
		a: "Sports Medal",
		b: "1F3C5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			9,
			25
		],
		o: 2
	},
	cucumber: {
		a: "Cucumber",
		b: "1F952",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fruit",
			"food",
			"pickle"
		],
		k: [
			41,
			33
		],
		o: 4
	},
	cow: {
		a: "Cow Face",
		b: "1F42E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		k: [
			12,
			18
		],
		o: 2
	},
	underage: {
		a: "No One Under Eighteen Symbol",
		b: "1F51E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"18",
			"drink",
			"pub",
			"night",
			"minor",
			"circle"
		],
		k: [
			28,
			1
		],
		o: 2
	},
	"flag-az": {
		a: "Azerbaijan Flag",
		b: "1F1E6-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			47
		],
		o: 2
	},
	shopping_bags: {
		a: "Shopping Bags",
		b: "1F6CD-FE0F",
		c: "1F6CD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			35
		],
		o: 2
	},
	"right-facing_fist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F91C-1F3FB",
				non_qualified: null,
				image: "1f91c-1f3fb.png",
				sheet_x: 37,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F91C-1F3FC",
				non_qualified: null,
				image: "1f91c-1f3fc.png",
				sheet_x: 38,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F91C-1F3FD",
				non_qualified: null,
				image: "1f91c-1f3fd.png",
				sheet_x: 38,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F91C-1F3FE",
				non_qualified: null,
				image: "1f91c-1f3fe.png",
				sheet_x: 38,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F91C-1F3FF",
				non_qualified: null,
				image: "1f91c-1f3ff.png",
				sheet_x: 38,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Right-Facing Fist",
		b: "1F91C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			55
		],
		o: 4
	},
	house_with_garden: {
		a: "House with Garden",
		b: "1F3E1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"home",
			"plant",
			"nature"
		],
		k: [
			10,
			52
		],
		o: 2
	},
	clap: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44F-1F3FB",
				non_qualified: null,
				image: "1f44f-1f3fb.png",
				sheet_x: 13,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F44F-1F3FC",
				non_qualified: null,
				image: "1f44f-1f3fc.png",
				sheet_x: 13,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F44F-1F3FD",
				non_qualified: null,
				image: "1f44f-1f3fd.png",
				sheet_x: 13,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F44F-1F3FE",
				non_qualified: null,
				image: "1f44f-1f3fe.png",
				sheet_x: 13,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F44F-1F3FF",
				non_qualified: null,
				image: "1f44f-1f3ff.png",
				sheet_x: 13,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Clapping Hands Sign",
		b: "1F44F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hands",
			"praise",
			"applause",
			"congrats",
			"yay"
		],
		k: [
			13,
			50
		],
		o: 2
	},
	leafy_green: {
		a: "Leafy Green",
		b: "1F96C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			2
		],
		o: 11
	},
	office: {
		a: "Office Building",
		b: "1F3E2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"bureau",
			"work"
		],
		k: [
			10,
			53
		],
		o: 2
	},
	"flag-ba": {
		a: "Bosnia & Herzegovina Flag",
		b: "1F1E7-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			48
		],
		o: 2
	},
	zany_face: {
		a: "Grinning Face with One Large and One Small Eye",
		b: "1F92A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			44
		],
		n: [
			"grinning_face_with_one_large_and_one_small_eye"
		],
		o: 5
	},
	first_place_medal: {
		a: "First Place Medal",
		b: "1F947",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			22
		],
		o: 4
	},
	ox: {
		a: "Ox",
		b: "1F402",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cow",
			"beef"
		],
		k: [
			11,
			30
		],
		o: 2
	},
	school_satchel: {
		a: "School Satchel",
		b: "1F392",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"student",
			"education",
			"bag",
			"backpack"
		],
		k: [
			7,
			54
		],
		o: 2
	},
	radioactive_sign: {
		a: "Radioactive Sign",
		b: "2622-FE0F",
		c: "2622",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			9
		],
		o: 2
	},
	second_place_medal: {
		a: "Second Place Medal",
		b: "1F948",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			23
		],
		o: 4
	},
	stuck_out_tongue_closed_eyes: {
		a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
		b: "1F61D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"prank",
			"playful",
			"mischievous",
			"smile",
			"tongue"
		],
		k: [
			31,
			7
		],
		o: 2
	},
	broccoli: {
		a: "Broccoli",
		b: "1F966",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			53
		],
		o: 5
	},
	biohazard_sign: {
		a: "Biohazard Sign",
		b: "2623-FE0F",
		c: "2623",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			10
		],
		o: 2
	},
	mans_shoe: {
		a: "Mans Shoe",
		b: "1F45E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"male"
		],
		k: [
			14,
			18
		],
		n: [
			"shoe"
		],
		o: 2
	},
	raised_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64C-1F3FB",
				non_qualified: null,
				image: "1f64c-1f3fb.png",
				sheet_x: 33,
				sheet_y: 9,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64C-1F3FC",
				non_qualified: null,
				image: "1f64c-1f3fc.png",
				sheet_x: 33,
				sheet_y: 10,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64C-1F3FD",
				non_qualified: null,
				image: "1f64c-1f3fd.png",
				sheet_x: 33,
				sheet_y: 11,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64C-1F3FE",
				non_qualified: null,
				image: "1f64c-1f3fe.png",
				sheet_x: 33,
				sheet_y: 12,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64C-1F3FF",
				non_qualified: null,
				image: "1f64c-1f3ff.png",
				sheet_x: 33,
				sheet_y: 13,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Person Raising Both Hands in Celebration",
		b: "1F64C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"gesture",
			"hooray",
			"yea",
			"celebration",
			"hands"
		],
		k: [
			33,
			8
		],
		o: 2
	},
	post_office: {
		a: "Japanese Post Office",
		b: "1F3E3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"envelope",
			"communication"
		],
		k: [
			10,
			54
		],
		o: 2
	},
	"flag-bb": {
		a: "Barbados Flag",
		b: "1F1E7-1F1E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			49
		],
		o: 2
	},
	water_buffalo: {
		a: "Water Buffalo",
		b: "1F403",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"ox",
			"cow"
		],
		k: [
			11,
			31
		],
		o: 2
	},
	third_place_medal: {
		a: "Third Place Medal",
		b: "1F949",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			24
		],
		o: 4
	},
	european_post_office: {
		a: "European Post Office",
		b: "1F3E4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"email"
		],
		k: [
			10,
			55
		],
		o: 2
	},
	athletic_shoe: {
		a: "Athletic Shoe",
		b: "1F45F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shoes",
			"sports",
			"sneakers"
		],
		k: [
			14,
			19
		],
		o: 2
	},
	arrow_up: {
		a: "Upwards Black Arrow",
		b: "2B06-FE0F",
		c: "2B06",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"continue",
			"top",
			"direction"
		],
		k: [
			55,
			38
		],
		o: 2
	},
	cow2: {
		a: "Cow",
		b: "1F404",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		k: [
			11,
			32
		],
		o: 2
	},
	open_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F450-1F3FB",
				non_qualified: null,
				image: "1f450-1f3fb.png",
				sheet_x: 14,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F450-1F3FC",
				non_qualified: null,
				image: "1f450-1f3fc.png",
				sheet_x: 14,
				sheet_y: 1,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F450-1F3FD",
				non_qualified: null,
				image: "1f450-1f3fd.png",
				sheet_x: 14,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F450-1F3FE",
				non_qualified: null,
				image: "1f450-1f3fe.png",
				sheet_x: 14,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F450-1F3FF",
				non_qualified: null,
				image: "1f450-1f3ff.png",
				sheet_x: 14,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Open Hands Sign",
		b: "1F450",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fingers",
			"butterfly",
			"hands",
			"open"
		],
		k: [
			13,
			56
		],
		o: 2
	},
	garlic: {
		a: "Garlic",
		b: "1F9C4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			12
		],
		o: 12
	},
	money_mouth_face: {
		a: "Money-Mouth Face",
		b: "1F911",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"rich",
			"dollar",
			"money"
		],
		k: [
			37,
			24
		],
		o: 2
	},
	"flag-bd": {
		a: "Bangladesh Flag",
		b: "1F1E7-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			50
		],
		o: 2
	},
	soccer: {
		a: "Soccer Ball",
		b: "26BD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"football"
		],
		k: [
			53,
			56
		],
		o: 2
	},
	hugging_face: {
		a: "Hugging Face",
		b: "1F917",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			30
		],
		o: 2
	},
	onion: {
		a: "Onion",
		b: "1F9C5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			13
		],
		o: 12
	},
	arrow_upper_right: {
		a: "North East Arrow",
		b: "2197-FE0F",
		c: "2197",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"point",
			"direction",
			"diagonal",
			"northeast"
		],
		k: [
			52,
			17
		],
		o: 2
	},
	palms_up_together: {
		skin_variations: {
			"1F3FB": {
				unified: "1F932-1F3FB",
				non_qualified: null,
				image: "1f932-1f3fb.png",
				sheet_x: 39,
				sheet_y: 6,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F932-1F3FC",
				non_qualified: null,
				image: "1f932-1f3fc.png",
				sheet_x: 39,
				sheet_y: 7,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F932-1F3FD",
				non_qualified: null,
				image: "1f932-1f3fd.png",
				sheet_x: 39,
				sheet_y: 8,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F932-1F3FE",
				non_qualified: null,
				image: "1f932-1f3fe.png",
				sheet_x: 39,
				sheet_y: 9,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F932-1F3FF",
				non_qualified: null,
				image: "1f932-1f3ff.png",
				sheet_x: 39,
				sheet_y: 10,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Palms Up Together",
		b: "1F932",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			39,
			5
		],
		o: 5
	},
	pig: {
		a: "Pig Face",
		b: "1F437",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"oink",
			"nature"
		],
		k: [
			12,
			27
		],
		o: 2
	},
	hospital: {
		a: "Hospital",
		b: "1F3E5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"health",
			"surgery",
			"doctor"
		],
		k: [
			10,
			56
		],
		o: 2
	},
	hiking_boot: {
		a: "Hiking Boot",
		b: "1F97E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			16
		],
		o: 11
	},
	"flag-be": {
		a: "Belgium Flag",
		b: "1F1E7-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			51
		],
		o: 2
	},
	"flag-bf": {
		a: "Burkina Faso Flag",
		b: "1F1E7-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			52
		],
		o: 2
	},
	mushroom: {
		a: "Mushroom",
		b: "1F344",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"vegetable"
		],
		k: [
			6,
			28
		],
		o: 2
	},
	pig2: {
		a: "Pig",
		b: "1F416",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			11,
			51
		],
		o: 2
	},
	baseball: {
		a: "Baseball",
		b: "26BE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"balls"
		],
		k: [
			54,
			0
		],
		o: 2
	},
	face_with_hand_over_mouth: {
		a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
		b: "1F92D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			47
		],
		n: [
			"smiling_face_with_smiling_eyes_and_hand_covering_mouth"
		],
		o: 5
	},
	handshake: {
		a: "Handshake",
		b: "1F91D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"agreement",
			"shake"
		],
		k: [
			38,
			4
		],
		o: 4
	},
	womans_flat_shoe: {
		a: "Flat Shoe",
		b: "1F97F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			17
		],
		o: 11
	},
	bank: {
		a: "Bank",
		b: "1F3E6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"money",
			"sales",
			"cash",
			"business",
			"enterprise"
		],
		k: [
			11,
			0
		],
		o: 2
	},
	arrow_right: {
		a: "Black Rightwards Arrow",
		b: "27A1-FE0F",
		c: "27A1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"next"
		],
		k: [
			55,
			32
		],
		o: 2
	},
	peanuts: {
		a: "Peanuts",
		b: "1F95C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"nut"
		],
		k: [
			41,
			43
		],
		o: 4
	},
	shushing_face: {
		a: "Face with Finger Covering Closed Lips",
		b: "1F92B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			45
		],
		n: [
			"face_with_finger_covering_closed_lips"
		],
		o: 5
	},
	pray: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64F-1F3FB",
				non_qualified: null,
				image: "1f64f-1f3fb.png",
				sheet_x: 33,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64F-1F3FC",
				non_qualified: null,
				image: "1f64f-1f3fc.png",
				sheet_x: 33,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64F-1F3FD",
				non_qualified: null,
				image: "1f64f-1f3fd.png",
				sheet_x: 33,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64F-1F3FE",
				non_qualified: null,
				image: "1f64f-1f3fe.png",
				sheet_x: 33,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64F-1F3FF",
				non_qualified: null,
				image: "1f64f-1f3ff.png",
				sheet_x: 33,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Person with Folded Hands",
		b: "1F64F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"please",
			"hope",
			"wish",
			"namaste",
			"highfive"
		],
		k: [
			33,
			50
		],
		o: 2
	},
	softball: {
		a: "Softball",
		b: "1F94E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			29
		],
		o: 11
	},
	high_heel: {
		a: "High-Heeled Shoe",
		b: "1F460",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"shoes",
			"female",
			"pumps",
			"stiletto"
		],
		k: [
			14,
			20
		],
		o: 2
	},
	"flag-bg": {
		a: "Bulgaria Flag",
		b: "1F1E7-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			53
		],
		o: 2
	},
	arrow_lower_right: {
		a: "South East Arrow",
		b: "2198-FE0F",
		c: "2198",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"diagonal",
			"southeast"
		],
		k: [
			52,
			18
		],
		o: 2
	},
	hotel: {
		a: "Hotel",
		b: "1F3E8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"accomodation",
			"checkin"
		],
		k: [
			11,
			2
		],
		o: 2
	},
	boar: {
		a: "Boar",
		b: "1F417",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			11,
			52
		],
		o: 2
	},
	sandal: {
		a: "Womans Sandal",
		b: "1F461",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shoes",
			"fashion",
			"flip flops"
		],
		k: [
			14,
			21
		],
		o: 2
	},
	"flag-bh": {
		a: "Bahrain Flag",
		b: "1F1E7-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			54
		],
		o: 2
	},
	arrow_down: {
		a: "Downwards Black Arrow",
		b: "2B07-FE0F",
		c: "2B07",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			55,
			39
		],
		o: 2
	},
	thinking_face: {
		a: "Thinking Face",
		b: "1F914",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			27
		],
		o: 2
	},
	writing_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "270D-1F3FB",
				non_qualified: null,
				image: "270d-1f3fb.png",
				sheet_x: 55,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "270D-1F3FC",
				non_qualified: null,
				image: "270d-1f3fc.png",
				sheet_x: 55,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "270D-1F3FD",
				non_qualified: null,
				image: "270d-1f3fd.png",
				sheet_x: 55,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "270D-1F3FE",
				non_qualified: null,
				image: "270d-1f3fe.png",
				sheet_x: 55,
				sheet_y: 8,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "270D-1F3FF",
				non_qualified: null,
				image: "270d-1f3ff.png",
				sheet_x: 55,
				sheet_y: 9,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Writing Hand",
		b: "270D-FE0F",
		c: "270D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"lower_left_ballpoint_pen",
			"stationery",
			"write",
			"compose"
		],
		k: [
			55,
			4
		],
		o: 2
	},
	chestnut: {
		a: "Chestnut",
		b: "1F330",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"squirrel"
		],
		k: [
			6,
			8
		],
		o: 2
	},
	basketball: {
		a: "Basketball and Hoop",
		b: "1F3C0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"balls",
			"NBA"
		],
		k: [
			8,
			38
		],
		o: 2
	},
	pig_nose: {
		a: "Pig Nose",
		b: "1F43D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"oink"
		],
		k: [
			12,
			33
		],
		o: 2
	},
	love_hotel: {
		a: "Love Hotel",
		b: "1F3E9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"like",
			"affection",
			"dating"
		],
		k: [
			11,
			3
		],
		o: 2
	},
	nail_care: {
		skin_variations: {
			"1F3FB": {
				unified: "1F485-1F3FB",
				non_qualified: null,
				image: "1f485-1f3fb.png",
				sheet_x: 24,
				sheet_y: 34,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F485-1F3FC",
				non_qualified: null,
				image: "1f485-1f3fc.png",
				sheet_x: 24,
				sheet_y: 35,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F485-1F3FD",
				non_qualified: null,
				image: "1f485-1f3fd.png",
				sheet_x: 24,
				sheet_y: 36,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F485-1F3FE",
				non_qualified: null,
				image: "1f485-1f3fe.png",
				sheet_x: 24,
				sheet_y: 37,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F485-1F3FF",
				non_qualified: null,
				image: "1f485-1f3ff.png",
				sheet_x: 24,
				sheet_y: 38,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Nail Polish",
		b: "1F485",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beauty",
			"manicure",
			"finger",
			"fashion",
			"nail"
		],
		k: [
			24,
			33
		],
		o: 2
	},
	volleyball: {
		a: "Volleyball",
		b: "1F3D0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"balls"
		],
		k: [
			10,
			35
		],
		o: 2
	},
	"flag-bi": {
		a: "Burundi Flag",
		b: "1F1E7-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			55
		],
		o: 2
	},
	arrow_lower_left: {
		a: "South West Arrow",
		b: "2199-FE0F",
		c: "2199",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"diagonal",
			"southwest"
		],
		k: [
			52,
			19
		],
		o: 2
	},
	ram: {
		a: "Ram",
		b: "1F40F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"sheep",
			"nature"
		],
		k: [
			11,
			43
		],
		o: 2
	},
	ballet_shoes: {
		a: "Ballet Shoes",
		b: "1FA70",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			51
		],
		o: 12
	},
	zipper_mouth_face: {
		a: "Zipper-Mouth Face",
		b: "1F910",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"sealed",
			"zipper",
			"secret"
		],
		k: [
			37,
			23
		],
		o: 2
	},
	bread: {
		a: "Bread",
		b: "1F35E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"wheat",
			"breakfast",
			"toast"
		],
		k: [
			6,
			54
		],
		o: 2
	},
	convenience_store: {
		a: "Convenience Store",
		b: "1F3EA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"shopping",
			"groceries"
		],
		k: [
			11,
			4
		],
		o: 2
	},
	boot: {
		a: "Womans Boots",
		b: "1F462",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shoes",
			"fashion"
		],
		k: [
			14,
			22
		],
		o: 2
	},
	sheep: {
		a: "Sheep",
		b: "1F411",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"wool",
			"shipit"
		],
		k: [
			11,
			45
		],
		o: 2
	},
	face_with_raised_eyebrow: {
		a: "Face with One Eyebrow Raised",
		b: "1F928",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			42
		],
		n: [
			"face_with_one_eyebrow_raised"
		],
		o: 5
	},
	"flag-bj": {
		a: "Benin Flag",
		b: "1F1E7-1F1EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			0,
			56
		],
		o: 2
	},
	arrow_left: {
		a: "Leftwards Black Arrow",
		b: "2B05-FE0F",
		c: "2B05",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"previous",
			"back"
		],
		k: [
			55,
			37
		],
		o: 2
	},
	selfie: {
		skin_variations: {
			"1F3FB": {
				unified: "1F933-1F3FB",
				non_qualified: null,
				image: "1f933-1f3fb.png",
				sheet_x: 39,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F933-1F3FC",
				non_qualified: null,
				image: "1f933-1f3fc.png",
				sheet_x: 39,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F933-1F3FD",
				non_qualified: null,
				image: "1f933-1f3fd.png",
				sheet_x: 39,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F933-1F3FE",
				non_qualified: null,
				image: "1f933-1f3fe.png",
				sheet_x: 39,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F933-1F3FF",
				non_qualified: null,
				image: "1f933-1f3ff.png",
				sheet_x: 39,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Selfie",
		b: "1F933",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"camera",
			"phone"
		],
		k: [
			39,
			11
		],
		o: 4
	},
	croissant: {
		a: "Croissant",
		b: "1F950",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"bread",
			"french"
		],
		k: [
			41,
			31
		],
		o: 4
	},
	school: {
		a: "School",
		b: "1F3EB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"student",
			"education",
			"learn",
			"teach"
		],
		k: [
			11,
			5
		],
		o: 2
	},
	football: {
		a: "American Football",
		b: "1F3C8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"balls",
			"NFL"
		],
		k: [
			9,
			33
		],
		o: 2
	},
	goat: {
		a: "Goat",
		b: "1F410",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			11,
			44
		],
		o: 2
	},
	department_store: {
		a: "Department Store",
		b: "1F3EC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"shopping",
			"mall"
		],
		k: [
			11,
			6
		],
		o: 2
	},
	"flag-bl": {
		a: "St. Barthélemy Flag",
		b: "1F1E7-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			0
		],
		o: 2
	},
	crown: {
		a: "Crown",
		b: "1F451",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"king",
			"kod",
			"leader",
			"royalty",
			"lord"
		],
		k: [
			14,
			5
		],
		o: 2
	},
	arrow_upper_left: {
		a: "North West Arrow",
		b: "2196-FE0F",
		c: "2196",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"point",
			"direction",
			"diagonal",
			"northwest"
		],
		k: [
			52,
			16
		],
		o: 2
	},
	neutral_face: {
		a: "Neutral Face",
		b: "1F610",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"indifference",
			"meh",
			":|",
			"neutral"
		],
		k: [
			30,
			51
		],
		l: [
			":|",
			":-|"
		],
		o: 2
	},
	rugby_football: {
		a: "Rugby Football",
		b: "1F3C9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"team"
		],
		k: [
			9,
			34
		],
		o: 2
	},
	muscle: {
		skin_variations: {
			"1F3FB": {
				unified: "1F4AA-1F3FB",
				non_qualified: null,
				image: "1f4aa-1f3fb.png",
				sheet_x: 25,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F4AA-1F3FC",
				non_qualified: null,
				image: "1f4aa-1f3fc.png",
				sheet_x: 25,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F4AA-1F3FD",
				non_qualified: null,
				image: "1f4aa-1f3fd.png",
				sheet_x: 25,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F4AA-1F3FE",
				non_qualified: null,
				image: "1f4aa-1f3fe.png",
				sheet_x: 25,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F4AA-1F3FF",
				non_qualified: null,
				image: "1f4aa-1f3ff.png",
				sheet_x: 26,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Flexed Biceps",
		b: "1F4AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"arm",
			"flex",
			"hand",
			"summer",
			"strong",
			"biceps"
		],
		k: [
			25,
			52
		],
		o: 2
	},
	baguette_bread: {
		a: "Baguette Bread",
		b: "1F956",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"bread",
			"french"
		],
		k: [
			41,
			37
		],
		o: 4
	},
	expressionless: {
		a: "Expressionless Face",
		b: "1F611",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"indifferent",
			"-_-",
			"meh",
			"deadpan"
		],
		k: [
			30,
			52
		],
		o: 2
	},
	womans_hat: {
		a: "Womans Hat",
		b: "1F452",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fashion",
			"accessories",
			"female",
			"lady",
			"spring"
		],
		k: [
			14,
			6
		],
		o: 2
	},
	pretzel: {
		a: "Pretzel",
		b: "1F968",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			55
		],
		o: 5
	},
	mechanical_arm: {
		a: "Mechanical Arm",
		b: "1F9BE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			6
		],
		o: 12
	},
	arrow_up_down: {
		a: "Up Down Arrow",
		b: "2195-FE0F",
		c: "2195",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"way",
			"vertical"
		],
		k: [
			52,
			15
		],
		o: 2
	},
	dromedary_camel: {
		a: "Dromedary Camel",
		b: "1F42A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"hot",
			"desert",
			"hump"
		],
		k: [
			12,
			14
		],
		o: 2
	},
	tennis: {
		a: "Tennis Racquet and Ball",
		b: "1F3BE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"balls",
			"green"
		],
		k: [
			8,
			36
		],
		o: 2
	},
	"flag-bm": {
		a: "Bermuda Flag",
		b: "1F1E7-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			1
		],
		o: 2
	},
	factory: {
		a: "Factory",
		b: "1F3ED",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"industry",
			"pollution",
			"smoke"
		],
		k: [
			11,
			7
		],
		o: 2
	},
	japanese_castle: {
		a: "Japanese Castle",
		b: "1F3EF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"building"
		],
		k: [
			11,
			9
		],
		o: 2
	},
	no_mouth: {
		a: "Face Without Mouth",
		b: "1F636",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"hellokitty"
		],
		k: [
			31,
			32
		],
		o: 2
	},
	mechanical_leg: {
		a: "Mechanical Leg",
		b: "1F9BF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			7
		],
		o: 12
	},
	bagel: {
		a: "Bagel",
		b: "1F96F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			5
		],
		o: 11
	},
	camel: {
		a: "Bactrian Camel",
		b: "1F42B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"hot",
			"desert",
			"hump"
		],
		k: [
			12,
			15
		],
		o: 2
	},
	tophat: {
		a: "Top Hat",
		b: "1F3A9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"magic",
			"gentleman",
			"classy",
			"circus"
		],
		k: [
			8,
			15
		],
		o: 2
	},
	left_right_arrow: {
		a: "Left Right Arrow",
		b: "2194-FE0F",
		c: "2194",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"direction",
			"horizontal",
			"sideways"
		],
		k: [
			52,
			14
		],
		o: 2
	},
	"flag-bn": {
		a: "Brunei Flag",
		b: "1F1E7-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			2
		],
		o: 2
	},
	flying_disc: {
		a: "Flying Disc",
		b: "1F94F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			30
		],
		o: 11
	},
	smirk: {
		a: "Smirking Face",
		b: "1F60F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"smile",
			"mean",
			"prank",
			"smug",
			"sarcasm"
		],
		k: [
			30,
			50
		],
		o: 2
	},
	mortar_board: {
		a: "Graduation Cap",
		b: "1F393",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"school",
			"college",
			"degree",
			"university",
			"graduation",
			"cap",
			"hat",
			"legal",
			"learn",
			"education"
		],
		k: [
			7,
			55
		],
		o: 2
	},
	european_castle: {
		a: "European Castle",
		b: "1F3F0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"royalty",
			"history"
		],
		k: [
			11,
			10
		],
		o: 2
	},
	leg: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B5-1F3FB",
				non_qualified: null,
				image: "1f9b5-1f3fb.png",
				sheet_x: 43,
				sheet_y: 6,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B5-1F3FC",
				non_qualified: null,
				image: "1f9b5-1f3fc.png",
				sheet_x: 43,
				sheet_y: 7,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B5-1F3FD",
				non_qualified: null,
				image: "1f9b5-1f3fd.png",
				sheet_x: 43,
				sheet_y: 8,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B5-1F3FE",
				non_qualified: null,
				image: "1f9b5-1f3fe.png",
				sheet_x: 43,
				sheet_y: 9,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B5-1F3FF",
				non_qualified: null,
				image: "1f9b5-1f3ff.png",
				sheet_x: 43,
				sheet_y: 10,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Leg",
		b: "1F9B5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			5
		],
		o: 11
	},
	pancakes: {
		a: "Pancakes",
		b: "1F95E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"breakfast",
			"flapjacks",
			"hotcakes"
		],
		k: [
			41,
			45
		],
		o: 4
	},
	leftwards_arrow_with_hook: {
		a: "Leftwards Arrow with Hook",
		b: "21A9-FE0F",
		c: "21A9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"back",
			"return",
			"blue-square",
			"undo",
			"enter"
		],
		k: [
			52,
			20
		],
		o: 2
	},
	"flag-bo": {
		a: "Bolivia Flag",
		b: "1F1E7-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			3
		],
		o: 2
	},
	bowling: {
		a: "Bowling",
		b: "1F3B3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"fun",
			"play"
		],
		k: [
			8,
			25
		],
		o: 2
	},
	llama: {
		a: "Llama",
		b: "1F999",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			43
		],
		o: 11
	},
	arrow_right_hook: {
		a: "Rightwards Arrow with Hook",
		b: "21AA-FE0F",
		c: "21AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"return",
			"rotate",
			"direction"
		],
		k: [
			52,
			21
		],
		o: 2
	},
	wedding: {
		a: "Wedding",
		b: "1F492",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"couple",
			"marriage",
			"bride",
			"groom"
		],
		k: [
			25,
			28
		],
		o: 2
	},
	"flag-bq": {
		a: "Caribbean Netherlands Flag",
		b: "1F1E7-1F1F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			4
		],
		o: 2
	},
	foot: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B6-1F3FB",
				non_qualified: null,
				image: "1f9b6-1f3fb.png",
				sheet_x: 43,
				sheet_y: 12,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B6-1F3FC",
				non_qualified: null,
				image: "1f9b6-1f3fc.png",
				sheet_x: 43,
				sheet_y: 13,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B6-1F3FD",
				non_qualified: null,
				image: "1f9b6-1f3fd.png",
				sheet_x: 43,
				sheet_y: 14,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B6-1F3FE",
				non_qualified: null,
				image: "1f9b6-1f3fe.png",
				sheet_x: 43,
				sheet_y: 15,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B6-1F3FF",
				non_qualified: null,
				image: "1f9b6-1f3ff.png",
				sheet_x: 43,
				sheet_y: 16,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Foot",
		b: "1F9B6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			11
		],
		o: 11
	},
	giraffe_face: {
		a: "Giraffe Face",
		b: "1F992",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			36
		],
		o: 5
	},
	unamused: {
		a: "Unamused Face",
		b: "1F612",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"indifference",
			"bored",
			"straight face",
			"serious",
			"sarcasm"
		],
		k: [
			30,
			53
		],
		m: ":(",
		o: 2
	},
	billed_cap: {
		a: "Billed Cap",
		b: "1F9E2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			21
		],
		o: 5
	},
	waffle: {
		a: "Waffle",
		b: "1F9C7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			15
		],
		o: 12
	},
	cricket_bat_and_ball: {
		a: "Cricket Bat and Ball",
		b: "1F3CF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			34
		],
		o: 2
	},
	helmet_with_white_cross: {
		a: "Helmet with White Cross",
		b: "26D1-FE0F",
		c: "26D1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			6
		],
		o: 2
	},
	ear: {
		skin_variations: {
			"1F3FB": {
				unified: "1F442-1F3FB",
				non_qualified: null,
				image: "1f442-1f3fb.png",
				sheet_x: 12,
				sheet_y: 40,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F442-1F3FC",
				non_qualified: null,
				image: "1f442-1f3fc.png",
				sheet_x: 12,
				sheet_y: 41,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F442-1F3FD",
				non_qualified: null,
				image: "1f442-1f3fd.png",
				sheet_x: 12,
				sheet_y: 42,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F442-1F3FE",
				non_qualified: null,
				image: "1f442-1f3fe.png",
				sheet_x: 12,
				sheet_y: 43,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F442-1F3FF",
				non_qualified: null,
				image: "1f442-1f3ff.png",
				sheet_x: 12,
				sheet_y: 44,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Ear",
		b: "1F442",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"hear",
			"sound",
			"listen"
		],
		k: [
			12,
			39
		],
		o: 2
	},
	elephant: {
		a: "Elephant",
		b: "1F418",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"nose",
			"th",
			"circus"
		],
		k: [
			11,
			53
		],
		o: 2
	},
	cheese_wedge: {
		a: "Cheese Wedge",
		b: "1F9C0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			8
		],
		o: 2
	},
	tokyo_tower: {
		a: "Tokyo Tower",
		b: "1F5FC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"japanese"
		],
		k: [
			30,
			31
		],
		o: 2
	},
	arrow_heading_up: {
		a: "Arrow Pointing Rightwards Then Curving Upwards",
		b: "2934-FE0F",
		c: "2934",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"top"
		],
		k: [
			55,
			35
		],
		o: 2
	},
	field_hockey_stick_and_ball: {
		a: "Field Hockey Stick and Ball",
		b: "1F3D1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			36
		],
		o: 2
	},
	"flag-br": {
		a: "Brazil Flag",
		b: "1F1E7-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			5
		],
		o: 2
	},
	face_with_rolling_eyes: {
		a: "Face with Rolling Eyes",
		b: "1F644",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			31,
			46
		],
		o: 2
	},
	ear_with_hearing_aid: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9BB-1F3FB",
				non_qualified: null,
				image: "1f9bb-1f3fb.png",
				sheet_x: 43,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9BB-1F3FC",
				non_qualified: null,
				image: "1f9bb-1f3fc.png",
				sheet_x: 44,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9BB-1F3FD",
				non_qualified: null,
				image: "1f9bb-1f3fd.png",
				sheet_x: 44,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9BB-1F3FE",
				non_qualified: null,
				image: "1f9bb-1f3fe.png",
				sheet_x: 44,
				sheet_y: 2,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9BB-1F3FF",
				non_qualified: null,
				image: "1f9bb-1f3ff.png",
				sheet_x: 44,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Ear with Hearing Aid",
		b: "1F9BB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			55
		],
		o: 12
	},
	arrow_heading_down: {
		a: "Arrow Pointing Rightwards Then Curving Downwards",
		b: "2935-FE0F",
		c: "2935",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			55,
			36
		],
		o: 2
	},
	ice_hockey_stick_and_puck: {
		a: "Ice Hockey Stick and Puck",
		b: "1F3D2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			37
		],
		o: 2
	},
	meat_on_bone: {
		a: "Meat on Bone",
		b: "1F356",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"good",
			"food",
			"drumstick"
		],
		k: [
			6,
			46
		],
		o: 2
	},
	prayer_beads: {
		a: "Prayer Beads",
		b: "1F4FF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dhikr",
			"religious"
		],
		k: [
			27,
			27
		],
		o: 2
	},
	statue_of_liberty: {
		a: "Statue of Liberty",
		b: "1F5FD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"american",
			"newyork"
		],
		k: [
			30,
			32
		],
		o: 2
	},
	grimacing: {
		a: "Grimacing Face",
		b: "1F62C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"grimace",
			"teeth"
		],
		k: [
			31,
			22
		],
		o: 2
	},
	"flag-bs": {
		a: "Bahamas Flag",
		b: "1F1E7-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			6
		],
		o: 2
	},
	rhinoceros: {
		a: "Rhinoceros",
		b: "1F98F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"horn"
		],
		k: [
			42,
			33
		],
		o: 4
	},
	lacrosse: {
		a: "Lacrosse Stick and Ball",
		b: "1F94D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			28
		],
		o: 11
	},
	poultry_leg: {
		a: "Poultry Leg",
		b: "1F357",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"meat",
			"drumstick",
			"bird",
			"chicken",
			"turkey"
		],
		k: [
			6,
			47
		],
		o: 2
	},
	hippopotamus: {
		a: "Hippopotamus",
		b: "1F99B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			45
		],
		o: 11
	},
	nose: {
		skin_variations: {
			"1F3FB": {
				unified: "1F443-1F3FB",
				non_qualified: null,
				image: "1f443-1f3fb.png",
				sheet_x: 12,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F443-1F3FC",
				non_qualified: null,
				image: "1f443-1f3fc.png",
				sheet_x: 12,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F443-1F3FD",
				non_qualified: null,
				image: "1f443-1f3fd.png",
				sheet_x: 12,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F443-1F3FE",
				non_qualified: null,
				image: "1f443-1f3fe.png",
				sheet_x: 12,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F443-1F3FF",
				non_qualified: null,
				image: "1f443-1f3ff.png",
				sheet_x: 12,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Nose",
		b: "1F443",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"smell",
			"sniff"
		],
		k: [
			12,
			45
		],
		o: 2
	},
	arrows_clockwise: {
		a: "Clockwise Downwards and Upwards Open Circle Arrows",
		b: "1F503",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sync",
			"cycle",
			"round",
			"repeat"
		],
		k: [
			27,
			31
		],
		o: 2
	},
	"flag-bt": {
		a: "Bhutan Flag",
		b: "1F1E7-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			7
		],
		o: 2
	},
	church: {
		a: "Church",
		b: "26EA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"building",
			"religion",
			"christ"
		],
		k: [
			54,
			10
		],
		o: 2
	},
	lipstick: {
		a: "Lipstick",
		b: "1F484",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"female",
			"girl",
			"fashion",
			"woman"
		],
		k: [
			24,
			32
		],
		o: 2
	},
	lying_face: {
		a: "Lying Face",
		b: "1F925",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"lie",
			"pinocchio"
		],
		k: [
			38,
			22
		],
		o: 4
	},
	arrows_counterclockwise: {
		a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
		b: "1F504",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"sync",
			"cycle"
		],
		k: [
			27,
			32
		],
		o: 2
	},
	"flag-bv": {
		a: "Bouvet Island Flag",
		b: "1F1E7-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			8
		],
		o: 2
	},
	cut_of_meat: {
		a: "Cut of Meat",
		b: "1F969",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			56
		],
		o: 5
	},
	mosque: {
		a: "Mosque",
		b: "1F54C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"islam",
			"worship",
			"minaret"
		],
		k: [
			28,
			36
		],
		o: 2
	},
	ring: {
		a: "Ring",
		b: "1F48D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wedding",
			"propose",
			"marriage",
			"valentines",
			"diamond",
			"fashion",
			"jewelry",
			"gem",
			"engagement"
		],
		k: [
			25,
			23
		],
		o: 2
	},
	brain: {
		a: "Brain",
		b: "1F9E0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			19
		],
		o: 5
	},
	table_tennis_paddle_and_ball: {
		a: "Table Tennis Paddle and Ball",
		b: "1F3D3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			38
		],
		o: 2
	},
	relieved: {
		a: "Relieved Face",
		b: "1F60C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"relaxed",
			"phew",
			"massage",
			"happiness"
		],
		k: [
			30,
			47
		],
		o: 2
	},
	mouse: {
		a: "Mouse Face",
		b: "1F42D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"cheese_wedge",
			"rodent"
		],
		k: [
			12,
			17
		],
		o: 2
	},
	hindu_temple: {
		a: "Hindu Temple",
		b: "1F6D5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			41
		],
		o: 12
	},
	back: {
		a: "Back with Leftwards Arrow Above",
		b: "1F519",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"arrow",
			"words",
			"return"
		],
		k: [
			27,
			53
		],
		o: 2
	},
	gem: {
		a: "Gem Stone",
		b: "1F48E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue",
			"ruby",
			"diamond",
			"jewelry"
		],
		k: [
			25,
			24
		],
		o: 2
	},
	pensive: {
		a: "Pensive Face",
		b: "1F614",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"sad",
			"depressed",
			"upset"
		],
		k: [
			30,
			55
		],
		o: 2
	},
	"flag-bw": {
		a: "Botswana Flag",
		b: "1F1E7-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			9
		],
		o: 2
	},
	mouse2: {
		a: "Mouse",
		b: "1F401",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"rodent"
		],
		k: [
			11,
			29
		],
		o: 2
	},
	bacon: {
		a: "Bacon",
		b: "1F953",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"breakfast",
			"pork",
			"pig",
			"meat"
		],
		k: [
			41,
			34
		],
		o: 4
	},
	tooth: {
		a: "Tooth",
		b: "1F9B7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			17
		],
		o: 11
	},
	badminton_racquet_and_shuttlecock: {
		a: "Badminton Racquet and Shuttlecock",
		b: "1F3F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			20
		],
		o: 2
	},
	rat: {
		a: "Rat",
		b: "1F400",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"mouse",
			"rodent"
		],
		k: [
			11,
			28
		],
		o: 2
	},
	synagogue: {
		a: "Synagogue",
		b: "1F54D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"judaism",
			"worship",
			"temple",
			"jewish"
		],
		k: [
			28,
			37
		],
		o: 2
	},
	end: {
		a: "End with Leftwards Arrow Above",
		b: "1F51A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"words",
			"arrow"
		],
		k: [
			27,
			54
		],
		o: 2
	},
	bone: {
		a: "Bone",
		b: "1F9B4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			4
		],
		o: 11
	},
	boxing_glove: {
		a: "Boxing Glove",
		b: "1F94A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"fighting"
		],
		k: [
			41,
			25
		],
		o: 4
	},
	mute: {
		a: "Speaker with Cancellation Stroke",
		b: "1F507",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"volume",
			"silence",
			"quiet"
		],
		k: [
			27,
			35
		],
		o: 2
	},
	hamburger: {
		a: "Hamburger",
		b: "1F354",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"meat",
			"fast food",
			"beef",
			"cheeseburger",
			"mcdonalds",
			"burger king"
		],
		k: [
			6,
			44
		],
		o: 2
	},
	"flag-by": {
		a: "Belarus Flag",
		b: "1F1E7-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			10
		],
		o: 2
	},
	sleepy: {
		a: "Sleepy Face",
		b: "1F62A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"tired",
			"rest",
			"nap"
		],
		k: [
			31,
			20
		],
		o: 2
	},
	on: {
		a: "On with Exclamation Mark with Left Right Arrow Above",
		b: "1F51B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"arrow",
			"words"
		],
		k: [
			27,
			55
		],
		o: 2
	},
	martial_arts_uniform: {
		a: "Martial Arts Uniform",
		b: "1F94B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"judo",
			"karate",
			"taekwondo"
		],
		k: [
			41,
			26
		],
		o: 4
	},
	speaker: {
		a: "Speaker",
		b: "1F508",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"volume",
			"silence",
			"broadcast"
		],
		k: [
			27,
			36
		],
		o: 2
	},
	drooling_face: {
		a: "Drooling Face",
		b: "1F924",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face"
		],
		k: [
			38,
			21
		],
		o: 4
	},
	eyes: {
		a: "Eyes",
		b: "1F440",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"look",
			"watch",
			"stalk",
			"peek",
			"see"
		],
		k: [
			12,
			36
		],
		o: 2
	},
	"flag-bz": {
		a: "Belize Flag",
		b: "1F1E7-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			11
		],
		o: 2
	},
	hamster: {
		a: "Hamster Face",
		b: "1F439",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			12,
			29
		],
		o: 2
	},
	shinto_shrine: {
		a: "Shinto Shrine",
		b: "26E9-FE0F",
		c: "26E9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"temple",
			"japan",
			"kyoto"
		],
		k: [
			54,
			9
		],
		o: 2
	},
	fries: {
		a: "French Fries",
		b: "1F35F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chips",
			"snack",
			"fast food"
		],
		k: [
			6,
			55
		],
		o: 2
	},
	goal_net: {
		a: "Goal Net",
		b: "1F945",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports"
		],
		k: [
			41,
			21
		],
		o: 4
	},
	kaaba: {
		a: "Kaaba",
		b: "1F54B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mecca",
			"mosque",
			"islam"
		],
		k: [
			28,
			35
		],
		o: 2
	},
	soon: {
		a: "Soon with Rightwards Arrow Above",
		b: "1F51C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"arrow",
			"words"
		],
		k: [
			27,
			56
		],
		o: 2
	},
	"flag-ca": {
		a: "Canada Flag",
		b: "1F1E8-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			12
		],
		o: 2
	},
	rabbit: {
		a: "Rabbit Face",
		b: "1F430",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"pet",
			"spring",
			"magic",
			"bunny"
		],
		k: [
			12,
			20
		],
		o: 2
	},
	eye: {
		a: "Eye",
		b: "1F441-FE0F",
		c: "1F441",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"look",
			"see",
			"watch",
			"stare"
		],
		k: [
			12,
			38
		],
		o: 2
	},
	sleeping: {
		a: "Sleeping Face",
		b: "1F634",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"tired",
			"sleepy",
			"night",
			"zzz"
		],
		k: [
			31,
			30
		],
		o: 2
	},
	pizza: {
		a: "Slice of Pizza",
		b: "1F355",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"party"
		],
		k: [
			6,
			45
		],
		o: 2
	},
	sound: {
		a: "Speaker with One Sound Wave",
		b: "1F509",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"volume",
			"speaker",
			"broadcast"
		],
		k: [
			27,
			37
		],
		o: 2
	},
	rabbit2: {
		a: "Rabbit",
		b: "1F407",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"pet",
			"magic",
			"spring"
		],
		k: [
			11,
			35
		],
		o: 2
	},
	fountain: {
		a: "Fountain",
		b: "26F2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"summer",
			"water",
			"fresh"
		],
		k: [
			54,
			13
		],
		o: 2
	},
	golf: {
		a: "Flag in Hole",
		b: "26F3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"business",
			"flag",
			"hole",
			"summer"
		],
		k: [
			54,
			14
		],
		o: 2
	},
	top: {
		a: "Top with Upwards Arrow Above",
		b: "1F51D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"words",
			"blue-square"
		],
		k: [
			28,
			0
		],
		o: 2
	},
	mask: {
		a: "Face with Medical Mask",
		b: "1F637",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"sick",
			"ill",
			"disease"
		],
		k: [
			31,
			33
		],
		o: 2
	},
	"flag-cc": {
		a: "Cocos (keeling) Islands Flag",
		b: "1F1E8-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			13
		],
		o: 2
	},
	hotdog: {
		a: "Hot Dog",
		b: "1F32D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"frankfurter"
		],
		k: [
			6,
			5
		],
		o: 2
	},
	loud_sound: {
		a: "Speaker with Three Sound Waves",
		b: "1F50A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"volume",
			"noise",
			"noisy",
			"speaker",
			"broadcast"
		],
		k: [
			27,
			38
		],
		o: 2
	},
	tongue: {
		a: "Tongue",
		b: "1F445",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mouth",
			"playful"
		],
		k: [
			12,
			52
		],
		o: 2
	},
	place_of_worship: {
		a: "Place of Worship",
		b: "1F6D0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"religion",
			"church",
			"temple",
			"prayer"
		],
		k: [
			36,
			38
		],
		o: 2
	},
	ice_skate: {
		a: "Ice Skate",
		b: "26F8-FE0F",
		c: "26F8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports"
		],
		k: [
			54,
			18
		],
		o: 2
	},
	sandwich: {
		a: "Sandwich",
		b: "1F96A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			0
		],
		o: 5
	},
	chipmunk: {
		a: "Chipmunk",
		b: "1F43F-FE0F",
		c: "1F43F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"rodent",
			"squirrel"
		],
		k: [
			12,
			35
		],
		o: 2
	},
	loudspeaker: {
		a: "Public Address Loudspeaker",
		b: "1F4E2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"volume",
			"sound"
		],
		k: [
			26,
			56
		],
		o: 2
	},
	lips: {
		a: "Mouth",
		b: "1F444",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mouth",
			"kiss"
		],
		k: [
			12,
			51
		],
		o: 2
	},
	"flag-cd": {
		a: "Congo - Kinshasa Flag",
		b: "1F1E8-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			14
		],
		o: 2
	},
	tent: {
		a: "Tent",
		b: "26FA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"camping",
			"outdoors"
		],
		k: [
			54,
			37
		],
		o: 2
	},
	face_with_thermometer: {
		a: "Face with Thermometer",
		b: "1F912",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sick",
			"temperature",
			"thermometer",
			"cold",
			"fever"
		],
		k: [
			37,
			25
		],
		o: 2
	},
	taco: {
		a: "Taco",
		b: "1F32E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"mexican"
		],
		k: [
			6,
			6
		],
		o: 2
	},
	foggy: {
		a: "Foggy",
		b: "1F301",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"mountain"
		],
		k: [
			5,
			20
		],
		o: 2
	},
	"flag-cf": {
		a: "Central African Republic Flag",
		b: "1F1E8-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			15
		],
		o: 2
	},
	baby: {
		skin_variations: {
			"1F3FB": {
				unified: "1F476-1F3FB",
				non_qualified: null,
				image: "1f476-1f3fb.png",
				sheet_x: 23,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F476-1F3FC",
				non_qualified: null,
				image: "1f476-1f3fc.png",
				sheet_x: 23,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F476-1F3FD",
				non_qualified: null,
				image: "1f476-1f3fd.png",
				sheet_x: 23,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F476-1F3FE",
				non_qualified: null,
				image: "1f476-1f3fe.png",
				sheet_x: 23,
				sheet_y: 8,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F476-1F3FF",
				non_qualified: null,
				image: "1f476-1f3ff.png",
				sheet_x: 23,
				sheet_y: 9,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Baby",
		b: "1F476",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"child",
			"boy",
			"girl",
			"toddler"
		],
		k: [
			23,
			4
		],
		o: 2
	},
	atom_symbol: {
		a: "Atom Symbol",
		b: "269B-FE0F",
		c: "269B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"science",
			"physics",
			"chemistry"
		],
		k: [
			53,
			48
		],
		o: 2
	},
	fishing_pole_and_fish: {
		a: "Fishing Pole and Fish",
		b: "1F3A3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"hobby",
			"summer"
		],
		k: [
			8,
			9
		],
		o: 2
	},
	hedgehog: {
		a: "Hedgehog",
		b: "1F994",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			38
		],
		o: 5
	},
	face_with_head_bandage: {
		a: "Face with Head-Bandage",
		b: "1F915",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"injured",
			"clumsy",
			"bandage",
			"hurt"
		],
		k: [
			37,
			28
		],
		o: 2
	},
	mega: {
		a: "Cheering Megaphone",
		b: "1F4E3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"speaker",
			"volume"
		],
		k: [
			27,
			0
		],
		o: 2
	},
	nauseated_face: {
		a: "Nauseated Face",
		b: "1F922",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"vomit",
			"gross",
			"green",
			"sick",
			"throw up",
			"ill"
		],
		k: [
			38,
			19
		],
		o: 4
	},
	child: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D2-1F3FB",
				non_qualified: null,
				image: "1f9d2-1f3fb.png",
				sheet_x: 48,
				sheet_y: 17,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D2-1F3FC",
				non_qualified: null,
				image: "1f9d2-1f3fc.png",
				sheet_x: 48,
				sheet_y: 18,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D2-1F3FD",
				non_qualified: null,
				image: "1f9d2-1f3fd.png",
				sheet_x: 48,
				sheet_y: 19,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D2-1F3FE",
				non_qualified: null,
				image: "1f9d2-1f3fe.png",
				sheet_x: 48,
				sheet_y: 20,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D2-1F3FF",
				non_qualified: null,
				image: "1f9d2-1f3ff.png",
				sheet_x: 48,
				sheet_y: 21,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Child",
		b: "1F9D2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			16
		],
		o: 5
	},
	"flag-cg": {
		a: "Congo - Brazzaville Flag",
		b: "1F1E8-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			16
		],
		o: 2
	},
	bat: {
		a: "Bat",
		b: "1F987",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"blind",
			"vampire"
		],
		k: [
			42,
			25
		],
		o: 4
	},
	diving_mask: {
		a: "Diving Mask",
		b: "1F93F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			15
		],
		o: 12
	},
	burrito: {
		a: "Burrito",
		b: "1F32F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"mexican"
		],
		k: [
			6,
			7
		],
		o: 2
	},
	postal_horn: {
		a: "Postal Horn",
		b: "1F4EF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"instrument",
			"music"
		],
		k: [
			27,
			12
		],
		o: 2
	},
	night_with_stars: {
		a: "Night with Stars",
		b: "1F303",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"evening",
			"city",
			"downtown"
		],
		k: [
			5,
			22
		],
		o: 2
	},
	om_symbol: {
		a: "Om Symbol",
		b: "1F549-FE0F",
		c: "1F549",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			28,
			33
		],
		o: 2
	},
	star_of_david: {
		a: "Star of David",
		b: "2721-FE0F",
		c: "2721",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"judaism"
		],
		k: [
			55,
			15
		],
		o: 2
	},
	boy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F466-1F3FB",
				non_qualified: null,
				image: "1f466-1f3fb.png",
				sheet_x: 14,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F466-1F3FC",
				non_qualified: null,
				image: "1f466-1f3fc.png",
				sheet_x: 14,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F466-1F3FD",
				non_qualified: null,
				image: "1f466-1f3fd.png",
				sheet_x: 14,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F466-1F3FE",
				non_qualified: null,
				image: "1f466-1f3fe.png",
				sheet_x: 14,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F466-1F3FF",
				non_qualified: null,
				image: "1f466-1f3ff.png",
				sheet_x: 14,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Boy",
		b: "1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"man",
			"male",
			"guy",
			"teenager"
		],
		k: [
			14,
			26
		],
		o: 2
	},
	bell: {
		a: "Bell",
		b: "1F514",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"notification",
			"christmas",
			"xmas",
			"chime"
		],
		k: [
			27,
			48
		],
		o: 2
	},
	"flag-ch": {
		a: "Switzerland Flag",
		b: "1F1E8-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			17
		],
		o: 2
	},
	running_shirt_with_sash: {
		a: "Running Shirt with Sash",
		b: "1F3BD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"play",
			"pageant"
		],
		k: [
			8,
			35
		],
		o: 2
	},
	stuffed_flatbread: {
		a: "Stuffed Flatbread",
		b: "1F959",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"flatbread",
			"stuffed",
			"gyro"
		],
		k: [
			41,
			40
		],
		o: 4
	},
	bear: {
		a: "Bear Face",
		b: "1F43B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"wild"
		],
		k: [
			12,
			31
		],
		o: 2
	},
	cityscape: {
		a: "Cityscape",
		b: "1F3D9-FE0F",
		c: "1F3D9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"night life",
			"urban"
		],
		k: [
			10,
			44
		],
		o: 2
	},
	face_vomiting: {
		a: "Face with Open Mouth Vomiting",
		b: "1F92E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			48
		],
		n: [
			"face_with_open_mouth_vomiting"
		],
		o: 5
	},
	wheel_of_dharma: {
		a: "Wheel of Dharma",
		b: "2638-FE0F",
		c: "2638",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		k: [
			53,
			15
		],
		o: 2
	},
	ski: {
		a: "Ski and Ski Boot",
		b: "1F3BF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"winter",
			"cold",
			"snow"
		],
		k: [
			8,
			37
		],
		o: 2
	},
	girl: {
		skin_variations: {
			"1F3FB": {
				unified: "1F467-1F3FB",
				non_qualified: null,
				image: "1f467-1f3fb.png",
				sheet_x: 14,
				sheet_y: 33,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F467-1F3FC",
				non_qualified: null,
				image: "1f467-1f3fc.png",
				sheet_x: 14,
				sheet_y: 34,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F467-1F3FD",
				non_qualified: null,
				image: "1f467-1f3fd.png",
				sheet_x: 14,
				sheet_y: 35,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F467-1F3FE",
				non_qualified: null,
				image: "1f467-1f3fe.png",
				sheet_x: 14,
				sheet_y: 36,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F467-1F3FF",
				non_qualified: null,
				image: "1f467-1f3ff.png",
				sheet_x: 14,
				sheet_y: 37,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Girl",
		b: "1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"female",
			"woman",
			"teenager"
		],
		k: [
			14,
			32
		],
		o: 2
	},
	falafel: {
		a: "Falafel",
		b: "1F9C6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			14
		],
		o: 12
	},
	sneezing_face: {
		a: "Sneezing Face",
		b: "1F927",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"gesundheit",
			"sneeze",
			"sick",
			"allergy"
		],
		k: [
			38,
			41
		],
		o: 4
	},
	no_bell: {
		a: "Bell with Cancellation Stroke",
		b: "1F515",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"volume",
			"mute",
			"quiet",
			"silent"
		],
		k: [
			27,
			49
		],
		o: 2
	},
	koala: {
		a: "Koala",
		b: "1F428",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			12,
			12
		],
		o: 2
	},
	sunrise_over_mountains: {
		a: "Sunrise over Mountains",
		b: "1F304",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"view",
			"vacation",
			"photo"
		],
		k: [
			5,
			23
		],
		o: 2
	},
	"flag-ci": {
		a: "Côte D’ivoire Flag",
		b: "1F1E8-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			18
		],
		o: 2
	},
	sunrise: {
		a: "Sunrise",
		b: "1F305",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"morning",
			"view",
			"vacation",
			"photo"
		],
		k: [
			5,
			24
		],
		o: 2
	},
	yin_yang: {
		a: "Yin Yang",
		b: "262F-FE0F",
		c: "262F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"balance"
		],
		k: [
			53,
			14
		],
		o: 2
	},
	adult: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fb.png",
				sheet_x: 48,
				sheet_y: 11,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fc.png",
				sheet_x: 48,
				sheet_y: 12,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fd.png",
				sheet_x: 48,
				sheet_y: 13,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fe.png",
				sheet_x: 48,
				sheet_y: 14,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3ff.png",
				sheet_x: 48,
				sheet_y: 15,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Adult",
		b: "1F9D1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			10
		],
		o: 5
	},
	hot_face: {
		a: "Overheated Face",
		b: "1F975",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			10
		],
		o: 11
	},
	musical_score: {
		a: "Musical Score",
		b: "1F3BC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"treble",
			"clef",
			"compose"
		],
		k: [
			8,
			34
		],
		o: 2
	},
	sled: {
		a: "Sled",
		b: "1F6F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			56
		],
		o: 5
	},
	egg: {
		a: "Egg",
		b: "1F95A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"chicken",
			"breakfast"
		],
		k: [
			41,
			41
		],
		o: 4
	},
	panda_face: {
		a: "Panda Face",
		b: "1F43C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"panda"
		],
		k: [
			12,
			32
		],
		o: 2
	},
	"flag-ck": {
		a: "Cook Islands Flag",
		b: "1F1E8-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			19
		],
		o: 2
	},
	"flag-cl": {
		a: "Chile Flag",
		b: "1F1E8-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			20
		],
		o: 2
	},
	person_with_blond_hair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB",
				non_qualified: null,
				image: "1f471-1f3fb.png",
				sheet_x: 22,
				sheet_y: 20,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F471-1F3FC",
				non_qualified: null,
				image: "1f471-1f3fc.png",
				sheet_x: 22,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F471-1F3FD",
				non_qualified: null,
				image: "1f471-1f3fd.png",
				sheet_x: 22,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F471-1F3FE",
				non_qualified: null,
				image: "1f471-1f3fe.png",
				sheet_x: 22,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F471-1F3FF",
				non_qualified: null,
				image: "1f471-1f3ff.png",
				sheet_x: 22,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F471-200D-2642-FE0F",
		a: "Person with Blond Hair",
		b: "1F471",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			22,
			19
		],
		o: 2
	},
	sloth: {
		a: "Sloth",
		b: "1F9A5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			53
		],
		o: 12
	},
	latin_cross: {
		a: "Latin Cross",
		b: "271D-FE0F",
		c: "271D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"christianity"
		],
		k: [
			55,
			14
		],
		o: 2
	},
	curling_stone: {
		a: "Curling Stone",
		b: "1F94C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			27
		],
		o: 5
	},
	cold_face: {
		a: "Freezing Face",
		b: "1F976",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			11
		],
		o: 11
	},
	fried_egg: {
		a: "Cooking",
		b: "1F373",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"breakfast",
			"kitchen",
			"egg"
		],
		k: [
			7,
			18
		],
		n: [
			"cooking"
		],
		o: 2
	},
	city_sunset: {
		a: "Cityscape at Dusk",
		b: "1F306",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"evening",
			"sky",
			"buildings"
		],
		k: [
			5,
			25
		],
		o: 2
	},
	musical_note: {
		a: "Musical Note",
		b: "1F3B5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"score",
			"tone",
			"sound"
		],
		k: [
			8,
			27
		],
		o: 2
	},
	"flag-cm": {
		a: "Cameroon Flag",
		b: "1F1E8-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			21
		],
		o: 2
	},
	notes: {
		a: "Multiple Musical Notes",
		b: "1F3B6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"score"
		],
		k: [
			8,
			28
		],
		o: 2
	},
	woozy_face: {
		a: "Face with Uneven Eyes and Wavy Mouth",
		b: "1F974",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			9
		],
		o: 11
	},
	dart: {
		a: "Direct Hit",
		b: "1F3AF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"game",
			"play",
			"bar"
		],
		k: [
			8,
			21
		],
		o: 2
	},
	orthodox_cross: {
		a: "Orthodox Cross",
		b: "2626-FE0F",
		c: "2626",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"suppedaneum",
			"religion"
		],
		k: [
			53,
			11
		],
		o: 2
	},
	shallow_pan_of_food: {
		a: "Shallow Pan of Food",
		b: "1F958",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"cooking",
			"casserole",
			"paella"
		],
		k: [
			41,
			39
		],
		o: 4
	},
	otter: {
		a: "Otter",
		b: "1F9A6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			54
		],
		o: 12
	},
	man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3fb.png",
				sheet_x: 17,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3fc.png",
				sheet_x: 17,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3fd.png",
				sheet_x: 17,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3fe.png",
				sheet_x: 17,
				sheet_y: 26,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3ff.png",
				sheet_x: 17,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man",
		b: "1F468",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mustache",
			"father",
			"dad",
			"guy",
			"classy",
			"sir",
			"moustache"
		],
		k: [
			17,
			22
		],
		o: 2
	},
	city_sunrise: {
		a: "Sunset over Buildings",
		b: "1F307",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"good morning",
			"dawn"
		],
		k: [
			5,
			26
		],
		o: 2
	},
	bearded_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D4-1F3FB",
				non_qualified: null,
				image: "1f9d4-1f3fb.png",
				sheet_x: 48,
				sheet_y: 29,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D4-1F3FC",
				non_qualified: null,
				image: "1f9d4-1f3fc.png",
				sheet_x: 48,
				sheet_y: 30,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D4-1F3FD",
				non_qualified: null,
				image: "1f9d4-1f3fd.png",
				sheet_x: 48,
				sheet_y: 31,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D4-1F3FE",
				non_qualified: null,
				image: "1f9d4-1f3fe.png",
				sheet_x: 48,
				sheet_y: 32,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D4-1F3FF",
				non_qualified: null,
				image: "1f9d4-1f3ff.png",
				sheet_x: 48,
				sheet_y: 33,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Bearded Person",
		b: "1F9D4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			28
		],
		o: 5
	},
	skunk: {
		a: "Skunk",
		b: "1F9A8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			56
		],
		o: 12
	},
	stew: {
		a: "Pot of Food",
		b: "1F372",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"meat",
			"soup"
		],
		k: [
			7,
			17
		],
		o: 2
	},
	cn: {
		a: "China Flag",
		b: "1F1E8-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"china",
			"chinese",
			"prc",
			"flag",
			"country",
			"nation",
			"banner"
		],
		k: [
			1,
			22
		],
		n: [
			"flag-cn"
		],
		o: 2
	},
	studio_microphone: {
		a: "Studio Microphone",
		b: "1F399-FE0F",
		c: "1F399",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sing",
			"recording",
			"artist",
			"talkshow"
		],
		k: [
			8,
			1
		],
		o: 2
	},
	star_and_crescent: {
		a: "Star and Crescent",
		b: "262A-FE0F",
		c: "262A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"islam"
		],
		k: [
			53,
			12
		],
		o: 2
	},
	"yo-yo": {
		a: "Yo-Yo",
		b: "1FA80",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			1
		],
		o: 12
	},
	bridge_at_night: {
		a: "Bridge at Night",
		b: "1F309",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"sanfrancisco"
		],
		k: [
			5,
			28
		],
		o: 2
	},
	dizzy_face: {
		a: "Dizzy Face",
		b: "1F635",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"spent",
			"unconscious",
			"xox",
			"dizzy"
		],
		k: [
			31,
			31
		],
		o: 2
	},
	red_haired_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9B0",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9b0.png",
				sheet_x: 16,
				sheet_y: 24,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9B0",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9b0.png",
				sheet_x: 16,
				sheet_y: 25,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9B0",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9b0.png",
				sheet_x: 16,
				sheet_y: 26,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9B0",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9b0.png",
				sheet_x: 16,
				sheet_y: 27,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9B0",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9b0.png",
				sheet_x: 16,
				sheet_y: 28,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Red Haired Man",
		b: "1F468-200D-1F9B0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			23
		],
		o: 11
	},
	kite: {
		a: "Kite",
		b: "1FA81",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			2
		],
		o: 12
	},
	bowl_with_spoon: {
		a: "Bowl with Spoon",
		b: "1F963",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			50
		],
		o: 5
	},
	"flag-co": {
		a: "Colombia Flag",
		b: "1F1E8-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			23
		],
		o: 2
	},
	peace_symbol: {
		a: "Peace Symbol",
		b: "262E-FE0F",
		c: "262E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hippie"
		],
		k: [
			53,
			13
		],
		o: 2
	},
	kangaroo: {
		a: "Kangaroo",
		b: "1F998",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			42
		],
		o: 11
	},
	hotsprings: {
		a: "Hot Springs",
		b: "2668-FE0F",
		c: "2668",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bath",
			"warm",
			"relax"
		],
		k: [
			53,
			37
		],
		o: 2
	},
	exploding_head: {
		a: "Shocked Face with Exploding Head",
		b: "1F92F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			49
		],
		n: [
			"shocked_face_with_exploding_head"
		],
		o: 5
	},
	level_slider: {
		a: "Level Slider",
		b: "1F39A-FE0F",
		c: "1F39A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"scale"
		],
		k: [
			8,
			2
		],
		o: 2
	},
	badger: {
		a: "Badger",
		b: "1F9A1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			51
		],
		o: 11
	},
	"8ball": {
		a: "Billiards",
		b: "1F3B1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"pool",
			"hobby",
			"game",
			"luck",
			"magic"
		],
		k: [
			8,
			23
		],
		o: 2
	},
	curly_haired_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9B1",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9b1.png",
				sheet_x: 16,
				sheet_y: 30,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9B1",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9b1.png",
				sheet_x: 16,
				sheet_y: 31,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9B1",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9b1.png",
				sheet_x: 16,
				sheet_y: 32,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9B1",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9b1.png",
				sheet_x: 16,
				sheet_y: 33,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9B1",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9b1.png",
				sheet_x: 16,
				sheet_y: 34,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Curly Haired Man",
		b: "1F468-200D-1F9B1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			29
		],
		o: 11
	},
	"flag-cp": {
		a: "Clipperton Island Flag",
		b: "1F1E8-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			24
		],
		o: 2
	},
	carousel_horse: {
		a: "Carousel Horse",
		b: "1F3A0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"carnival"
		],
		k: [
			8,
			6
		],
		o: 2
	},
	face_with_cowboy_hat: {
		a: "Face with Cowboy Hat",
		b: "1F920",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			17
		],
		o: 4
	},
	menorah_with_nine_branches: {
		a: "Menorah with Nine Branches",
		b: "1F54E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			28,
			38
		],
		o: 2
	},
	green_salad: {
		a: "Green Salad",
		b: "1F957",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"healthy",
			"lettuce"
		],
		k: [
			41,
			38
		],
		o: 4
	},
	control_knobs: {
		a: "Control Knobs",
		b: "1F39B-FE0F",
		c: "1F39B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dial"
		],
		k: [
			8,
			3
		],
		o: 2
	},
	popcorn: {
		a: "Popcorn",
		b: "1F37F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"movie theater",
			"films",
			"snack"
		],
		k: [
			7,
			30
		],
		o: 2
	},
	six_pointed_star: {
		a: "Six Pointed Star with Middle Dot",
		b: "1F52F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"religion",
			"jewish",
			"hexagram"
		],
		k: [
			28,
			18
		],
		o: 2
	},
	feet: {
		a: "Paw Prints",
		b: "1F43E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			12,
			34
		],
		n: [
			"paw_prints"
		],
		o: 2
	},
	ferris_wheel: {
		a: "Ferris Wheel",
		b: "1F3A1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"carnival",
			"londoneye"
		],
		k: [
			8,
			7
		],
		o: 2
	},
	microphone: {
		a: "Microphone",
		b: "1F3A4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sound",
			"music",
			"PA",
			"sing",
			"talkshow"
		],
		k: [
			8,
			10
		],
		o: 2
	},
	crystal_ball: {
		a: "Crystal Ball",
		b: "1F52E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"disco",
			"party",
			"magic",
			"circus",
			"fortune_teller"
		],
		k: [
			28,
			17
		],
		o: 2
	},
	partying_face: {
		a: "Face with Party Horn and Party Hat",
		b: "1F973",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			8
		],
		o: 11
	},
	"flag-cr": {
		a: "Costa Rica Flag",
		b: "1F1E8-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			25
		],
		o: 2
	},
	white_haired_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9B3",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9b3.png",
				sheet_x: 16,
				sheet_y: 42,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9B3",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9b3.png",
				sheet_x: 16,
				sheet_y: 43,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9B3",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9b3.png",
				sheet_x: 16,
				sheet_y: 44,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9B3",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9b3.png",
				sheet_x: 16,
				sheet_y: 45,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9B3",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9b3.png",
				sheet_x: 16,
				sheet_y: 46,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Haired Man",
		b: "1F468-200D-1F9B3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			41
		],
		o: 11
	},
	headphones: {
		a: "Headphone",
		b: "1F3A7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"score",
			"gadgets"
		],
		k: [
			8,
			13
		],
		o: 2
	},
	bald_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9B2",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9b2.png",
				sheet_x: 16,
				sheet_y: 36,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9B2",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9b2.png",
				sheet_x: 16,
				sheet_y: 37,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9B2",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9b2.png",
				sheet_x: 16,
				sheet_y: 38,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9B2",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9b2.png",
				sheet_x: 16,
				sheet_y: 39,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9B2",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9b2.png",
				sheet_x: 16,
				sheet_y: 40,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Bald Man",
		b: "1F468-200D-1F9B2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			35
		],
		o: 11
	},
	sunglasses: {
		a: "Smiling Face with Sunglasses",
		b: "1F60E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"cool",
			"smile",
			"summer",
			"beach",
			"sunglass"
		],
		k: [
			30,
			49
		],
		l: [
			"8)"
		],
		o: 2
	},
	butter: {
		a: "Butter",
		b: "1F9C8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			16
		],
		o: 12
	},
	roller_coaster: {
		a: "Roller Coaster",
		b: "1F3A2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"carnival",
			"playground",
			"photo",
			"fun"
		],
		k: [
			8,
			8
		],
		o: 2
	},
	turkey: {
		a: "Turkey",
		b: "1F983",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"bird"
		],
		k: [
			42,
			21
		],
		o: 2
	},
	nazar_amulet: {
		a: "Nazar Amulet",
		b: "1F9FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			50
		],
		o: 11
	},
	"flag-cu": {
		a: "Cuba Flag",
		b: "1F1E8-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			26
		],
		o: 2
	},
	aries: {
		a: "Aries",
		b: "2648",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			20
		],
		o: 2
	},
	"flag-cv": {
		a: "Cape Verde Flag",
		b: "1F1E8-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			27
		],
		o: 2
	},
	barber: {
		a: "Barber Pole",
		b: "1F488",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hair",
			"salon",
			"style"
		],
		k: [
			25,
			18
		],
		o: 2
	},
	taurus: {
		a: "Taurus",
		b: "2649",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"sign",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			21
		],
		o: 2
	},
	salt: {
		a: "Salt Shaker",
		b: "1F9C2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			10
		],
		o: 11
	},
	woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fb.png",
				sheet_x: 20,
				sheet_y: 10,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fc.png",
				sheet_x: 20,
				sheet_y: 11,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fd.png",
				sheet_x: 20,
				sheet_y: 12,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fe.png",
				sheet_x: 20,
				sheet_y: 13,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3ff.png",
				sheet_x: 20,
				sheet_y: 14,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman",
		b: "1F469",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"female",
			"girls",
			"lady"
		],
		k: [
			20,
			9
		],
		o: 2
	},
	video_game: {
		a: "Video Game",
		b: "1F3AE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"play",
			"console",
			"PS4",
			"controller"
		],
		k: [
			8,
			20
		],
		o: 2
	},
	chicken: {
		a: "Chicken",
		b: "1F414",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cluck",
			"nature",
			"bird"
		],
		k: [
			11,
			48
		],
		o: 2
	},
	radio: {
		a: "Radio",
		b: "1F4FB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"communication",
			"music",
			"podcast",
			"program"
		],
		k: [
			27,
			24
		],
		o: 2
	},
	nerd_face: {
		a: "Nerd Face",
		b: "1F913",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"nerdy",
			"geek",
			"dork"
		],
		k: [
			37,
			26
		],
		o: 2
	},
	red_haired_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9B0",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9b0.png",
				sheet_x: 19,
				sheet_y: 9,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9B0",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9b0.png",
				sheet_x: 19,
				sheet_y: 10,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9B0",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9b0.png",
				sheet_x: 19,
				sheet_y: 11,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9B0",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9b0.png",
				sheet_x: 19,
				sheet_y: 12,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9B0",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9b0.png",
				sheet_x: 19,
				sheet_y: 13,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Red Haired Woman",
		b: "1F469-200D-1F9B0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			8
		],
		o: 11
	},
	circus_tent: {
		a: "Circus Tent",
		b: "1F3AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"festival",
			"carnival",
			"party"
		],
		k: [
			8,
			16
		],
		o: 2
	},
	face_with_monocle: {
		a: "Face with Monocle",
		b: "1F9D0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			45,
			16
		],
		o: 5
	},
	canned_food: {
		a: "Canned Food",
		b: "1F96B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			1
		],
		o: 5
	},
	"flag-cw": {
		a: "Curaçao Flag",
		b: "1F1E8-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			28
		],
		o: 2
	},
	gemini: {
		a: "Gemini",
		b: "264A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			53,
			22
		],
		o: 2
	},
	saxophone: {
		a: "Saxophone",
		b: "1F3B7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"instrument",
			"jazz",
			"blues"
		],
		k: [
			8,
			29
		],
		o: 2
	},
	rooster: {
		a: "Rooster",
		b: "1F413",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"chicken"
		],
		k: [
			11,
			47
		],
		o: 2
	},
	joystick: {
		a: "Joystick",
		b: "1F579-FE0F",
		c: "1F579",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"game",
			"play"
		],
		k: [
			29,
			36
		],
		o: 2
	},
	guitar: {
		a: "Guitar",
		b: "1F3B8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"instrument"
		],
		k: [
			8,
			30
		],
		o: 2
	},
	slot_machine: {
		a: "Slot Machine",
		b: "1F3B0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bet",
			"gamble",
			"vegas",
			"fruit machine",
			"luck",
			"casino"
		],
		k: [
			8,
			22
		],
		o: 2
	},
	bento: {
		a: "Bento Box",
		b: "1F371",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japanese",
			"box"
		],
		k: [
			7,
			16
		],
		o: 2
	},
	steam_locomotive: {
		a: "Steam Locomotive",
		b: "1F682",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"train"
		],
		k: [
			34,
			1
		],
		o: 2
	},
	confused: {
		a: "Confused Face",
		b: "1F615",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"indifference",
			"huh",
			"weird",
			"hmmm",
			":/"
		],
		k: [
			30,
			56
		],
		l: [
			":\\",
			":-\\",
			":/",
			":-/"
		],
		o: 2
	},
	"flag-cx": {
		a: "Christmas Island Flag",
		b: "1F1E8-1F1FD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			29
		],
		o: 2
	},
	hatching_chick: {
		a: "Hatching Chick",
		b: "1F423",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"chicken",
			"egg",
			"born",
			"baby",
			"bird"
		],
		k: [
			12,
			7
		],
		o: 2
	},
	cancer: {
		a: "Cancer",
		b: "264B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			53,
			23
		],
		o: 2
	},
	red_haired_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9B0",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9b0.png",
				sheet_x: 47,
				sheet_y: 14,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9B0",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9b0.png",
				sheet_x: 47,
				sheet_y: 15,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9B0",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9b0.png",
				sheet_x: 47,
				sheet_y: 16,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9B0",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9b0.png",
				sheet_x: 47,
				sheet_y: 17,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9B0",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9b0.png",
				sheet_x: 47,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Red Haired Person",
		b: "1F9D1-200D-1F9B0",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			13
		],
		o: 12
	},
	"flag-cy": {
		a: "Cyprus Flag",
		b: "1F1E8-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			30
		],
		o: 2
	},
	worried: {
		a: "Worried Face",
		b: "1F61F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"concern",
			"nervous",
			":("
		],
		k: [
			31,
			9
		],
		o: 2
	},
	railway_car: {
		a: "Railway Car",
		b: "1F683",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			2
		],
		o: 2
	},
	leo: {
		a: "Leo",
		b: "264C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			24
		],
		o: 2
	},
	curly_haired_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9B1",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9b1.png",
				sheet_x: 19,
				sheet_y: 15,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9B1",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9b1.png",
				sheet_x: 19,
				sheet_y: 16,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9B1",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9b1.png",
				sheet_x: 19,
				sheet_y: 17,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9B1",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9b1.png",
				sheet_x: 19,
				sheet_y: 18,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9B1",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9b1.png",
				sheet_x: 19,
				sheet_y: 19,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Curly Haired Woman",
		b: "1F469-200D-1F9B1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			14
		],
		o: 11
	},
	baby_chick: {
		a: "Baby Chick",
		b: "1F424",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"chicken",
			"bird"
		],
		k: [
			12,
			8
		],
		o: 2
	},
	musical_keyboard: {
		a: "Musical Keyboard",
		b: "1F3B9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"piano",
			"instrument",
			"compose"
		],
		k: [
			8,
			31
		],
		o: 2
	},
	game_die: {
		a: "Game Die",
		b: "1F3B2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dice",
			"random",
			"tabletop",
			"play",
			"luck"
		],
		k: [
			8,
			24
		],
		o: 2
	},
	rice_cracker: {
		a: "Rice Cracker",
		b: "1F358",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			6,
			48
		],
		o: 2
	},
	virgo: {
		a: "Virgo",
		b: "264D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			53,
			25
		],
		o: 2
	},
	"flag-cz": {
		a: "Czechia Flag",
		b: "1F1E8-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			31
		],
		o: 2
	},
	curly_haired_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9B1",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9b1.png",
				sheet_x: 47,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9B1",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9b1.png",
				sheet_x: 47,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9B1",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9b1.png",
				sheet_x: 47,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9B1",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9b1.png",
				sheet_x: 47,
				sheet_y: 23,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9B1",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9b1.png",
				sheet_x: 47,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Curly Haired Person",
		b: "1F9D1-200D-1F9B1",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			19
		],
		o: 12
	},
	rice_ball: {
		a: "Rice Ball",
		b: "1F359",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			6,
			49
		],
		o: 2
	},
	hatched_chick: {
		a: "Front-Facing Baby Chick",
		b: "1F425",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"chicken",
			"baby",
			"bird"
		],
		k: [
			12,
			9
		],
		o: 2
	},
	jigsaw: {
		a: "Jigsaw Puzzle Piece",
		b: "1F9E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			28
		],
		o: 11
	},
	trumpet: {
		a: "Trumpet",
		b: "1F3BA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"brass"
		],
		k: [
			8,
			32
		],
		o: 2
	},
	slightly_frowning_face: {
		a: "Slightly Frowning Face",
		b: "1F641",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"frowning",
			"disappointed",
			"sad",
			"upset"
		],
		k: [
			31,
			43
		],
		o: 2
	},
	bullettrain_side: {
		a: "High-Speed Train",
		b: "1F684",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			3
		],
		o: 2
	},
	libra: {
		a: "Libra",
		b: "264E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			26
		],
		o: 2
	},
	de: {
		a: "Germany Flag",
		b: "1F1E9-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"german",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			1,
			32
		],
		n: [
			"flag-de"
		],
		o: 2
	},
	rice: {
		a: "Cooked Rice",
		b: "1F35A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"china",
			"asian"
		],
		k: [
			6,
			50
		],
		o: 2
	},
	violin: {
		a: "Violin",
		b: "1F3BB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"music",
			"instrument",
			"orchestra",
			"symphony"
		],
		k: [
			8,
			33
		],
		o: 2
	},
	white_haired_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9B3",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9b3.png",
				sheet_x: 19,
				sheet_y: 27,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9B3",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9b3.png",
				sheet_x: 19,
				sheet_y: 28,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9B3",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9b3.png",
				sheet_x: 19,
				sheet_y: 29,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9B3",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9b3.png",
				sheet_x: 19,
				sheet_y: 30,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9B3",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9b3.png",
				sheet_x: 19,
				sheet_y: 31,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "White Haired Woman",
		b: "1F469-200D-1F9B3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			26
		],
		o: 11
	},
	bird: {
		a: "Bird",
		b: "1F426",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"fly",
			"tweet",
			"spring"
		],
		k: [
			12,
			10
		],
		o: 2
	},
	white_frowning_face: {
		a: "White Frowning Face",
		b: "2639-FE0F",
		c: "2639",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			16
		],
		o: 2
	},
	bullettrain_front: {
		a: "High-Speed Train with Bullet Nose",
		b: "1F685",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"speed",
			"fast",
			"public",
			"travel"
		],
		k: [
			34,
			4
		],
		o: 2
	},
	teddy_bear: {
		a: "Teddy Bear",
		b: "1F9F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			43
		],
		o: 11
	},
	white_haired_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9B3",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9b3.png",
				sheet_x: 47,
				sheet_y: 32,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9B3",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9b3.png",
				sheet_x: 47,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9B3",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9b3.png",
				sheet_x: 47,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9B3",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9b3.png",
				sheet_x: 47,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9B3",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9b3.png",
				sheet_x: 47,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "White Haired Person",
		b: "1F9D1-200D-1F9B3",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			31
		],
		o: 12
	},
	spades: {
		a: "Black Spade Suit",
		b: "2660-FE0F",
		c: "2660",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poker",
			"cards",
			"suits",
			"magic"
		],
		k: [
			53,
			33
		],
		o: 2
	},
	banjo: {
		a: "Banjo",
		b: "1FA95",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			9
		],
		o: 12
	},
	train2: {
		a: "Train",
		b: "1F686",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			5
		],
		o: 2
	},
	scorpius: {
		a: "Scorpius",
		b: "264F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology",
			"scorpio"
		],
		k: [
			53,
			27
		],
		o: 2
	},
	curry: {
		a: "Curry and Rice",
		b: "1F35B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"spicy",
			"hot",
			"indian"
		],
		k: [
			6,
			51
		],
		o: 2
	},
	open_mouth: {
		a: "Face with Open Mouth",
		b: "1F62E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"surprise",
			"impressed",
			"wow",
			"whoa",
			":O"
		],
		k: [
			31,
			24
		],
		l: [
			":o",
			":-o",
			":O",
			":-O"
		],
		o: 2
	},
	"flag-dg": {
		a: "Diego Garcia Flag",
		b: "1F1E9-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			33
		],
		o: 2
	},
	penguin: {
		a: "Penguin",
		b: "1F427",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			12,
			11
		],
		o: 2
	},
	hearts: {
		a: "Black Heart Suit",
		b: "2665-FE0F",
		c: "2665",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			53,
			35
		],
		o: 2
	},
	ramen: {
		a: "Steaming Bowl",
		b: "1F35C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japanese",
			"noodle",
			"chopsticks"
		],
		k: [
			6,
			52
		],
		o: 2
	},
	sagittarius: {
		a: "Sagittarius",
		b: "2650",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			53,
			28
		],
		o: 2
	},
	bald_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9B2",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9b2.png",
				sheet_x: 19,
				sheet_y: 21,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9B2",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9b2.png",
				sheet_x: 19,
				sheet_y: 22,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9B2",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9b2.png",
				sheet_x: 19,
				sheet_y: 23,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9B2",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9b2.png",
				sheet_x: 19,
				sheet_y: 24,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9B2",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9b2.png",
				sheet_x: 19,
				sheet_y: 25,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Bald Woman",
		b: "1F469-200D-1F9B2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			20
		],
		o: 11
	},
	dove_of_peace: {
		a: "Dove of Peace",
		b: "1F54A-FE0F",
		c: "1F54A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			28,
			34
		],
		o: 2
	},
	hushed: {
		a: "Hushed Face",
		b: "1F62F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"woo",
			"shh"
		],
		k: [
			31,
			25
		],
		o: 2
	},
	metro: {
		a: "Metro",
		b: "1F687",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"blue-square",
			"mrt",
			"underground",
			"tube"
		],
		k: [
			34,
			6
		],
		o: 2
	},
	"flag-dj": {
		a: "Djibouti Flag",
		b: "1F1E9-1F1EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			34
		],
		o: 2
	},
	drum_with_drumsticks: {
		a: "Drum with Drumsticks",
		b: "1F941",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			17
		],
		o: 4
	},
	spaghetti: {
		a: "Spaghetti",
		b: "1F35D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"italian",
			"noodle"
		],
		k: [
			6,
			53
		],
		o: 2
	},
	eagle: {
		a: "Eagle",
		b: "1F985",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"bird"
		],
		k: [
			42,
			23
		],
		o: 4
	},
	astonished: {
		a: "Astonished Face",
		b: "1F632",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"xox",
			"surprised",
			"poisoned"
		],
		k: [
			31,
			28
		],
		o: 2
	},
	capricorn: {
		a: "Capricorn",
		b: "2651",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			53,
			29
		],
		o: 2
	},
	light_rail: {
		a: "Light Rail",
		b: "1F688",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			7
		],
		o: 2
	},
	"flag-dk": {
		a: "Denmark Flag",
		b: "1F1E9-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			35
		],
		o: 2
	},
	iphone: {
		a: "Mobile Phone",
		b: "1F4F1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"apple",
			"gadgets",
			"dial"
		],
		k: [
			27,
			14
		],
		o: 2
	},
	bald_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9B2",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9b2.png",
				sheet_x: 47,
				sheet_y: 26,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9B2",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9b2.png",
				sheet_x: 47,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9B2",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9b2.png",
				sheet_x: 47,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9B2",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9b2.png",
				sheet_x: 47,
				sheet_y: 29,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9B2",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9b2.png",
				sheet_x: 47,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Bald Person",
		b: "1F9D1-200D-1F9B2",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			25
		],
		o: 12
	},
	diamonds: {
		a: "Black Diamond Suit",
		b: "2666-FE0F",
		c: "2666",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			53,
			36
		],
		o: 2
	},
	clubs: {
		a: "Black Club Suit",
		b: "2663-FE0F",
		c: "2663",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			53,
			34
		],
		o: 2
	},
	aquarius: {
		a: "Aquarius",
		b: "2652",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			30
		],
		o: 2
	},
	sweet_potato: {
		a: "Roasted Sweet Potato",
		b: "1F360",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"nature"
		],
		k: [
			6,
			56
		],
		o: 2
	},
	"flag-dm": {
		a: "Dominica Flag",
		b: "1F1E9-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			36
		],
		o: 2
	},
	duck: {
		a: "Duck",
		b: "1F986",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"bird",
			"mallard"
		],
		k: [
			42,
			24
		],
		o: 4
	},
	calling: {
		a: "Mobile Phone with Rightwards Arrow at Left",
		b: "1F4F2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"iphone",
			"incoming"
		],
		k: [
			27,
			15
		],
		o: 2
	},
	station: {
		a: "Station",
		b: "1F689",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"public"
		],
		k: [
			34,
			8
		],
		o: 2
	},
	"blond-haired-woman": {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB-200D-2640-FE0F",
				non_qualified: "1F471-1F3FB-200D-2640",
				image: "1f471-1f3fb-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F471-1F3FC-200D-2640-FE0F",
				non_qualified: "1F471-1F3FC-200D-2640",
				image: "1f471-1f3fc-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F471-1F3FD-200D-2640-FE0F",
				non_qualified: "1F471-1F3FD-200D-2640",
				image: "1f471-1f3fd-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F471-1F3FE-200D-2640-FE0F",
				non_qualified: "1F471-1F3FE-200D-2640",
				image: "1f471-1f3fe-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F471-1F3FF-200D-2640-FE0F",
				non_qualified: "1F471-1F3FF-200D-2640",
				image: "1f471-1f3ff-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Blond Haired Woman",
		b: "1F471-200D-2640-FE0F",
		c: "1F471-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			22,
			7
		],
		o: 4
	},
	flushed: {
		a: "Flushed Face",
		b: "1F633",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"blush",
			"shy",
			"flattered"
		],
		k: [
			31,
			29
		],
		o: 2
	},
	pisces: {
		a: "Pisces",
		b: "2653",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"sign",
			"zodiac",
			"astrology"
		],
		k: [
			53,
			31
		],
		o: 2
	},
	chess_pawn: {
		a: "Chess Pawn",
		b: "265F-FE0F",
		c: "265F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			32
		],
		o: 11
	},
	"blond-haired-man": {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB-200D-2642-FE0F",
				non_qualified: "1F471-1F3FB-200D-2642",
				image: "1f471-1f3fb-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F471-1F3FC-200D-2642-FE0F",
				non_qualified: "1F471-1F3FC-200D-2642",
				image: "1f471-1f3fc-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F471-1F3FD-200D-2642-FE0F",
				non_qualified: "1F471-1F3FD-200D-2642",
				image: "1f471-1f3fd-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F471-1F3FE-200D-2642-FE0F",
				non_qualified: "1F471-1F3FE-200D-2642",
				image: "1f471-1f3fe-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F471-1F3FF-200D-2642-FE0F",
				non_qualified: "1F471-1F3FF-200D-2642",
				image: "1f471-1f3ff-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F471",
		a: "Blond Haired Man",
		b: "1F471-200D-2642-FE0F",
		c: "1F471-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			22,
			13
		],
		o: 4
	},
	phone: {
		a: "Black Telephone",
		b: "260E-FE0F",
		c: "260E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"communication",
			"dial",
			"telephone"
		],
		k: [
			52,
			54
		],
		n: [
			"telephone"
		],
		o: 2
	},
	oden: {
		a: "Oden",
		b: "1F362",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			7,
			1
		],
		o: 2
	},
	"flag-do": {
		a: "Dominican Republic Flag",
		b: "1F1E9-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			37
		],
		o: 2
	},
	tram: {
		a: "Tram",
		b: "1F68A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			9
		],
		o: 2
	},
	swan: {
		a: "Swan",
		b: "1F9A2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			52
		],
		o: 11
	},
	pleading_face: {
		a: "Face with Pleading Eyes",
		b: "1F97A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			12
		],
		o: 11
	},
	"flag-dz": {
		a: "Algeria Flag",
		b: "1F1E9-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			38
		],
		o: 2
	},
	monorail: {
		a: "Monorail",
		b: "1F69D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			28
		],
		o: 2
	},
	owl: {
		a: "Owl",
		b: "1F989",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"bird",
			"hoot"
		],
		k: [
			42,
			27
		],
		o: 4
	},
	sushi: {
		a: "Sushi",
		b: "1F363",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"fish",
			"japanese",
			"rice"
		],
		k: [
			7,
			2
		],
		o: 2
	},
	telephone_receiver: {
		a: "Telephone Receiver",
		b: "1F4DE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"communication",
			"dial"
		],
		k: [
			26,
			52
		],
		o: 2
	},
	black_joker: {
		a: "Playing Card Black Joker",
		b: "1F0CF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poker",
			"cards",
			"game",
			"play",
			"magic"
		],
		k: [
			0,
			15
		],
		o: 2
	},
	ophiuchus: {
		a: "Ophiuchus",
		b: "26CE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sign",
			"purple-square",
			"constellation",
			"astrology"
		],
		k: [
			54,
			4
		],
		o: 2
	},
	frowning: {
		a: "Frowning Face with Open Mouth",
		b: "1F626",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"aw",
			"what"
		],
		k: [
			31,
			16
		],
		o: 2
	},
	older_adult: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D3-1F3FB",
				non_qualified: null,
				image: "1f9d3-1f3fb.png",
				sheet_x: 48,
				sheet_y: 23,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D3-1F3FC",
				non_qualified: null,
				image: "1f9d3-1f3fc.png",
				sheet_x: 48,
				sheet_y: 24,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D3-1F3FD",
				non_qualified: null,
				image: "1f9d3-1f3fd.png",
				sheet_x: 48,
				sheet_y: 25,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D3-1F3FE",
				non_qualified: null,
				image: "1f9d3-1f3fe.png",
				sheet_x: 48,
				sheet_y: 26,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D3-1F3FF",
				non_qualified: null,
				image: "1f9d3-1f3ff.png",
				sheet_x: 48,
				sheet_y: 27,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Older Adult",
		b: "1F9D3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			22
		],
		o: 5
	},
	"flag-ea": {
		a: "Ceuta & Melilla Flag",
		b: "1F1EA-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			39
		],
		o: 2
	},
	flamingo: {
		a: "Flamingo",
		b: "1F9A9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			0
		],
		o: 12
	},
	pager: {
		a: "Pager",
		b: "1F4DF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bbcall",
			"oldschool",
			"90s"
		],
		k: [
			26,
			53
		],
		o: 2
	},
	mountain_railway: {
		a: "Mountain Railway",
		b: "1F69E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			29
		],
		o: 2
	},
	mahjong: {
		a: "Mahjong Tile Red Dragon",
		b: "1F004",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"game",
			"play",
			"chinese",
			"kanji"
		],
		k: [
			0,
			14
		],
		o: 2
	},
	older_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F474-1F3FB",
				non_qualified: null,
				image: "1f474-1f3fb.png",
				sheet_x: 22,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F474-1F3FC",
				non_qualified: null,
				image: "1f474-1f3fc.png",
				sheet_x: 22,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F474-1F3FD",
				non_qualified: null,
				image: "1f474-1f3fd.png",
				sheet_x: 22,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F474-1F3FE",
				non_qualified: null,
				image: "1f474-1f3fe.png",
				sheet_x: 22,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F474-1F3FF",
				non_qualified: null,
				image: "1f474-1f3ff.png",
				sheet_x: 22,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Older Man",
		b: "1F474",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"human",
			"male",
			"men",
			"old",
			"elder",
			"senior"
		],
		k: [
			22,
			49
		],
		o: 2
	},
	twisted_rightwards_arrows: {
		a: "Twisted Rightwards Arrows",
		b: "1F500",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"shuffle",
			"music",
			"random"
		],
		k: [
			27,
			28
		],
		o: 2
	},
	fried_shrimp: {
		a: "Fried Shrimp",
		b: "1F364",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"animal",
			"appetizer",
			"summer"
		],
		k: [
			7,
			3
		],
		o: 2
	},
	anguished: {
		a: "Anguished Face",
		b: "1F627",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"stunned",
			"nervous"
		],
		k: [
			31,
			17
		],
		l: [
			"D:"
		],
		o: 2
	},
	repeat: {
		a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
		b: "1F501",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"loop",
			"record"
		],
		k: [
			27,
			29
		],
		o: 2
	},
	fish_cake: {
		a: "Fish Cake with Swirl Design",
		b: "1F365",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"japan",
			"sea",
			"beach",
			"narutomaki",
			"pink",
			"swirl",
			"kamaboko",
			"surimi",
			"ramen"
		],
		k: [
			7,
			4
		],
		o: 2
	},
	fax: {
		a: "Fax Machine",
		b: "1F4E0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"communication",
			"technology"
		],
		k: [
			26,
			54
		],
		o: 2
	},
	older_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F475-1F3FB",
				non_qualified: null,
				image: "1f475-1f3fb.png",
				sheet_x: 22,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F475-1F3FC",
				non_qualified: null,
				image: "1f475-1f3fc.png",
				sheet_x: 23,
				sheet_y: 0,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F475-1F3FD",
				non_qualified: null,
				image: "1f475-1f3fd.png",
				sheet_x: 23,
				sheet_y: 1,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F475-1F3FE",
				non_qualified: null,
				image: "1f475-1f3fe.png",
				sheet_x: 23,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F475-1F3FF",
				non_qualified: null,
				image: "1f475-1f3ff.png",
				sheet_x: 23,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Older Woman",
		b: "1F475",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"human",
			"female",
			"women",
			"lady",
			"old",
			"elder",
			"senior"
		],
		k: [
			22,
			55
		],
		o: 2
	},
	"flag-ec": {
		a: "Ecuador Flag",
		b: "1F1EA-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			40
		],
		o: 2
	},
	peacock: {
		a: "Peacock",
		b: "1F99A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			44
		],
		o: 11
	},
	fearful: {
		a: "Fearful Face",
		b: "1F628",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"scared",
			"terrified",
			"nervous",
			"oops",
			"huh"
		],
		k: [
			31,
			18
		],
		o: 2
	},
	train: {
		a: "Tram Car",
		b: "1F68B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"carriage",
			"public",
			"travel"
		],
		k: [
			34,
			10
		],
		o: 2
	},
	flower_playing_cards: {
		a: "Flower Playing Cards",
		b: "1F3B4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"game",
			"sunset",
			"red"
		],
		k: [
			8,
			26
		],
		o: 2
	},
	repeat_one: {
		a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
		b: "1F502",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"loop"
		],
		k: [
			27,
			30
		],
		o: 2
	},
	moon_cake: {
		a: "Moon Cake",
		b: "1F96E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			4
		],
		o: 11
	},
	performing_arts: {
		a: "Performing Arts",
		b: "1F3AD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"acting",
			"theater",
			"drama"
		],
		k: [
			8,
			19
		],
		o: 2
	},
	cold_sweat: {
		a: "Face with Open Mouth and Cold Sweat",
		b: "1F630",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"nervous",
			"sweat"
		],
		k: [
			31,
			26
		],
		o: 2
	},
	person_frowning: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB",
				non_qualified: null,
				image: "1f64d-1f3fb.png",
				sheet_x: 33,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F64D-1F3FC",
				non_qualified: null,
				image: "1f64d-1f3fc.png",
				sheet_x: 33,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F64D-1F3FD",
				non_qualified: null,
				image: "1f64d-1f3fd.png",
				sheet_x: 33,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F64D-1F3FE",
				non_qualified: null,
				image: "1f64d-1f3fe.png",
				sheet_x: 33,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F64D-1F3FF",
				non_qualified: null,
				image: "1f64d-1f3ff.png",
				sheet_x: 33,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F64D-200D-2640-FE0F",
		a: "Person Frowning",
		b: "1F64D",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			33,
			26
		],
		o: 2
	},
	"flag-ee": {
		a: "Estonia Flag",
		b: "1F1EA-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			41
		],
		o: 2
	},
	battery: {
		a: "Battery",
		b: "1F50B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"power",
			"energy",
			"sustain"
		],
		k: [
			27,
			39
		],
		o: 2
	},
	parrot: {
		a: "Parrot",
		b: "1F99C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			46
		],
		o: 11
	},
	bus: {
		a: "Bus",
		b: "1F68C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"car",
			"vehicle",
			"transportation"
		],
		k: [
			34,
			11
		],
		o: 2
	},
	"flag-eg": {
		a: "Egypt Flag",
		b: "1F1EA-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			42
		],
		o: 2
	},
	arrow_forward: {
		a: "Black Right-Pointing Triangle",
		b: "25B6-FE0F",
		c: "25B6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"right",
			"direction",
			"play"
		],
		k: [
			52,
			43
		],
		o: 2
	},
	"man-frowning": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FB-200D-2642",
				image: "1f64d-1f3fb-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64D-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FC-200D-2642",
				image: "1f64d-1f3fc-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64D-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FD-200D-2642",
				image: "1f64d-1f3fd-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 23,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64D-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FE-200D-2642",
				image: "1f64d-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64D-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FF-200D-2642",
				image: "1f64d-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Frowning",
		b: "1F64D-200D-2642-FE0F",
		c: "1F64D-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			33,
			20
		],
		o: 4
	},
	disappointed_relieved: {
		a: "Disappointed but Relieved Face",
		b: "1F625",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"phew",
			"sweat",
			"nervous"
		],
		k: [
			31,
			15
		],
		o: 2
	},
	electric_plug: {
		a: "Electric Plug",
		b: "1F50C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"charger",
			"power"
		],
		k: [
			27,
			40
		],
		o: 2
	},
	frame_with_picture: {
		a: "Frame with Picture",
		b: "1F5BC-FE0F",
		c: "1F5BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			14
		],
		o: 2
	},
	oncoming_bus: {
		a: "Oncoming Bus",
		b: "1F68D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"transportation"
		],
		k: [
			34,
			12
		],
		o: 2
	},
	dango: {
		a: "Dango",
		b: "1F361",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"dessert",
			"sweet",
			"japanese",
			"barbecue",
			"meat"
		],
		k: [
			7,
			0
		],
		o: 2
	},
	frog: {
		a: "Frog Face",
		b: "1F438",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"croak",
			"toad"
		],
		k: [
			12,
			28
		],
		o: 2
	},
	computer: {
		a: "Personal Computer",
		b: "1F4BB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"laptop",
			"screen",
			"display",
			"monitor"
		],
		k: [
			26,
			17
		],
		o: 2
	},
	art: {
		a: "Artist Palette",
		b: "1F3A8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"design",
			"paint",
			"draw",
			"colors"
		],
		k: [
			8,
			14
		],
		o: 2
	},
	"flag-eh": {
		a: "Western Sahara Flag",
		b: "1F1EA-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			43
		],
		o: 2
	},
	fast_forward: {
		a: "Black Right-Pointing Double Triangle",
		b: "23E9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"play",
			"speed",
			"continue"
		],
		k: [
			52,
			26
		],
		o: 2
	},
	cry: {
		a: "Crying Face",
		b: "1F622",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"tears",
			"sad",
			"depressed",
			"upset",
			":'("
		],
		k: [
			31,
			12
		],
		l: [
			":'("
		],
		m: ":'(",
		o: 2
	},
	"woman-frowning": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FB-200D-2640",
				image: "1f64d-1f3fb-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64D-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FC-200D-2640",
				image: "1f64d-1f3fc-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64D-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FD-200D-2640",
				image: "1f64d-1f3fd-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64D-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FE-200D-2640",
				image: "1f64d-1f3fe-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64D-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FF-200D-2640",
				image: "1f64d-1f3ff-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F64D",
		a: "Woman Frowning",
		b: "1F64D-200D-2640-FE0F",
		c: "1F64D-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			33,
			14
		],
		o: 4
	},
	trolleybus: {
		a: "Trolleybus",
		b: "1F68E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bart",
			"transportation",
			"vehicle"
		],
		k: [
			34,
			13
		],
		o: 2
	},
	crocodile: {
		a: "Crocodile",
		b: "1F40A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"reptile",
			"lizard",
			"alligator"
		],
		k: [
			11,
			38
		],
		o: 2
	},
	dumpling: {
		a: "Dumpling",
		b: "1F95F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			46
		],
		o: 5
	},
	black_right_pointing_double_triangle_with_vertical_bar: {
		a: "Black Right Pointing Double Triangle with Vertical Bar",
		b: "23ED-FE0F",
		c: "23ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			30
		],
		o: 2
	},
	desktop_computer: {
		a: "Desktop Computer",
		b: "1F5A5-FE0F",
		c: "1F5A5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"computing",
			"screen"
		],
		k: [
			30,
			10
		],
		o: 2
	},
	person_with_pouting_face: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB",
				non_qualified: null,
				image: "1f64e-1f3fb.png",
				sheet_x: 33,
				sheet_y: 45,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F64E-1F3FC",
				non_qualified: null,
				image: "1f64e-1f3fc.png",
				sheet_x: 33,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F64E-1F3FD",
				non_qualified: null,
				image: "1f64e-1f3fd.png",
				sheet_x: 33,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F64E-1F3FE",
				non_qualified: null,
				image: "1f64e-1f3fe.png",
				sheet_x: 33,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F64E-1F3FF",
				non_qualified: null,
				image: "1f64e-1f3ff.png",
				sheet_x: 33,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F64E-200D-2640-FE0F",
		a: "Person with Pouting Face",
		b: "1F64E",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			33,
			44
		],
		o: 2
	},
	turtle: {
		a: "Turtle",
		b: "1F422",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"slow",
			"nature",
			"tortoise"
		],
		k: [
			12,
			6
		],
		o: 2
	},
	sob: {
		a: "Loudly Crying Face",
		b: "1F62D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"cry",
			"tears",
			"sad",
			"upset",
			"depressed"
		],
		k: [
			31,
			23
		],
		m: ":'(",
		o: 2
	},
	"flag-er": {
		a: "Eritrea Flag",
		b: "1F1EA-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			44
		],
		o: 2
	},
	thread: {
		a: "Spool of Thread",
		b: "1F9F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			40
		],
		o: 11
	},
	minibus: {
		a: "Minibus",
		b: "1F690",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"car",
			"transportation"
		],
		k: [
			34,
			15
		],
		o: 2
	},
	fortune_cookie: {
		a: "Fortune Cookie",
		b: "1F960",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			47
		],
		o: 5
	},
	yarn: {
		a: "Ball of Yarn",
		b: "1F9F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			41
		],
		o: 11
	},
	takeout_box: {
		a: "Takeout Box",
		b: "1F961",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			48
		],
		o: 5
	},
	"man-pouting": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FB-200D-2642",
				image: "1f64e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FC-200D-2642",
				image: "1f64e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FD-200D-2642",
				image: "1f64e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FE-200D-2642",
				image: "1f64e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FF-200D-2642",
				image: "1f64e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Pouting",
		b: "1F64E-200D-2642-FE0F",
		c: "1F64E-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			33,
			38
		],
		o: 4
	},
	printer: {
		a: "Printer",
		b: "1F5A8-FE0F",
		c: "1F5A8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"paper",
			"ink"
		],
		k: [
			30,
			11
		],
		o: 2
	},
	scream: {
		a: "Face Screaming in Fear",
		b: "1F631",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"munch",
			"scared",
			"omg"
		],
		k: [
			31,
			27
		],
		o: 2
	},
	es: {
		a: "Spain Flag",
		b: "1F1EA-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"spain",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			1,
			45
		],
		n: [
			"flag-es"
		],
		o: 2
	},
	ambulance: {
		a: "Ambulance",
		b: "1F691",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"health",
			"911",
			"hospital"
		],
		k: [
			34,
			16
		],
		o: 2
	},
	black_right_pointing_triangle_with_double_vertical_bar: {
		a: "Black Right Pointing Triangle with Double Vertical Bar",
		b: "23EF-FE0F",
		c: "23EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			32
		],
		o: 2
	},
	lizard: {
		a: "Lizard",
		b: "1F98E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"reptile"
		],
		k: [
			42,
			32
		],
		o: 4
	},
	"flag-et": {
		a: "Ethiopia Flag",
		b: "1F1EA-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			46
		],
		o: 2
	},
	keyboard: {
		a: "Keyboard",
		b: "2328-FE0F",
		c: "2328",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"computer",
			"type",
			"input",
			"text"
		],
		k: [
			52,
			24
		],
		o: 2
	},
	crab: {
		a: "Crab",
		b: "1F980",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"crustacean"
		],
		k: [
			42,
			18
		],
		o: 2
	},
	confounded: {
		a: "Confounded Face",
		b: "1F616",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"confused",
			"sick",
			"unwell",
			"oops",
			":S"
		],
		k: [
			31,
			0
		],
		o: 2
	},
	snake: {
		a: "Snake",
		b: "1F40D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"evil",
			"nature",
			"hiss",
			"python"
		],
		k: [
			11,
			41
		],
		o: 2
	},
	"woman-pouting": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FB-200D-2640",
				image: "1f64e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FC-200D-2640",
				image: "1f64e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FD-200D-2640",
				image: "1f64e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 35,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FE-200D-2640",
				image: "1f64e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FF-200D-2640",
				image: "1f64e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F64E",
		a: "Woman Pouting",
		b: "1F64E-200D-2640-FE0F",
		c: "1F64E-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			33,
			32
		],
		o: 4
	},
	arrow_backward: {
		a: "Black Left-Pointing Triangle",
		b: "25C0-FE0F",
		c: "25C0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"left",
			"direction"
		],
		k: [
			52,
			44
		],
		o: 2
	},
	fire_engine: {
		a: "Fire Engine",
		b: "1F692",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"cars",
			"vehicle"
		],
		k: [
			34,
			17
		],
		o: 2
	},
	rewind: {
		a: "Black Left-Pointing Double Triangle",
		b: "23EA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"play",
			"blue-square"
		],
		k: [
			52,
			27
		],
		o: 2
	},
	three_button_mouse: {
		a: "Three Button Mouse",
		b: "1F5B1-FE0F",
		c: "1F5B1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			12
		],
		o: 2
	},
	no_good: {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB",
				non_qualified: null,
				image: "1f645-1f3fb.png",
				sheet_x: 32,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F645-1F3FC",
				non_qualified: null,
				image: "1f645-1f3fc.png",
				sheet_x: 32,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F645-1F3FD",
				non_qualified: null,
				image: "1f645-1f3fd.png",
				sheet_x: 32,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F645-1F3FE",
				non_qualified: null,
				image: "1f645-1f3fe.png",
				sheet_x: 32,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F645-1F3FF",
				non_qualified: null,
				image: "1f645-1f3ff.png",
				sheet_x: 32,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F645-200D-2640-FE0F",
		a: "Face with No Good Gesture",
		b: "1F645",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			32,
			2
		],
		o: 2
	},
	police_car: {
		a: "Police Car",
		b: "1F693",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"cars",
			"transportation",
			"law",
			"legal",
			"enforcement"
		],
		k: [
			34,
			18
		],
		o: 2
	},
	dragon_face: {
		a: "Dragon Face",
		b: "1F432",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		k: [
			12,
			22
		],
		o: 2
	},
	persevere: {
		a: "Persevering Face",
		b: "1F623",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"sick",
			"no",
			"upset",
			"oops"
		],
		k: [
			31,
			13
		],
		o: 2
	},
	lobster: {
		a: "Lobster",
		b: "1F99E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			48
		],
		o: 11
	},
	"flag-eu": {
		a: "European Union Flag",
		b: "1F1EA-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			47
		],
		o: 2
	},
	disappointed: {
		a: "Disappointed Face",
		b: "1F61E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"sad",
			"upset",
			"depressed",
			":("
		],
		k: [
			31,
			8
		],
		l: [
			"):",
			":(",
			":-("
		],
		m: ":(",
		o: 2
	},
	shrimp: {
		a: "Shrimp",
		b: "1F990",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"ocean",
			"nature",
			"seafood"
		],
		k: [
			42,
			34
		],
		o: 4
	},
	dragon: {
		a: "Dragon",
		b: "1F409",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		k: [
			11,
			37
		],
		o: 2
	},
	"man-gesturing-no": {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB-200D-2642-FE0F",
				non_qualified: "1F645-1F3FB-200D-2642",
				image: "1f645-1f3fb-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F645-1F3FC-200D-2642-FE0F",
				non_qualified: "1F645-1F3FC-200D-2642",
				image: "1f645-1f3fc-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F645-1F3FD-200D-2642-FE0F",
				non_qualified: "1F645-1F3FD-200D-2642",
				image: "1f645-1f3fd-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F645-1F3FE-200D-2642-FE0F",
				non_qualified: "1F645-1F3FE-200D-2642",
				image: "1f645-1f3fe-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F645-1F3FF-200D-2642-FE0F",
				non_qualified: "1F645-1F3FF-200D-2642",
				image: "1f645-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Gesturing No",
		b: "1F645-200D-2642-FE0F",
		c: "1F645-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			31,
			53
		],
		o: 4
	},
	"flag-fi": {
		a: "Finland Flag",
		b: "1F1EB-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			48
		],
		o: 2
	},
	trackball: {
		a: "Trackball",
		b: "1F5B2-FE0F",
		c: "1F5B2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"trackpad"
		],
		k: [
			30,
			13
		],
		o: 2
	},
	black_left_pointing_double_triangle_with_vertical_bar: {
		a: "Black Left Pointing Double Triangle with Vertical Bar",
		b: "23EE-FE0F",
		c: "23EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			31
		],
		o: 2
	},
	oncoming_police_car: {
		a: "Oncoming Police Car",
		b: "1F694",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"law",
			"legal",
			"enforcement",
			"911"
		],
		k: [
			34,
			19
		],
		o: 2
	},
	minidisc: {
		a: "Minidisc",
		b: "1F4BD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"record",
			"data",
			"disk",
			"90s"
		],
		k: [
			26,
			19
		],
		o: 2
	},
	sweat: {
		a: "Face with Cold Sweat",
		b: "1F613",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"hot",
			"sad",
			"tired",
			"exercise"
		],
		k: [
			30,
			54
		],
		o: 2
	},
	squid: {
		a: "Squid",
		b: "1F991",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"ocean",
			"sea"
		],
		k: [
			42,
			35
		],
		o: 4
	},
	sauropod: {
		a: "Sauropod",
		b: "1F995",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			39
		],
		o: 5
	},
	arrow_up_small: {
		a: "Up-Pointing Small Red Triangle",
		b: "1F53C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"triangle",
			"direction",
			"point",
			"forward",
			"top"
		],
		k: [
			28,
			31
		],
		o: 2
	},
	"flag-fj": {
		a: "Fiji Flag",
		b: "1F1EB-1F1EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			49
		],
		o: 2
	},
	"woman-gesturing-no": {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB-200D-2640-FE0F",
				non_qualified: "1F645-1F3FB-200D-2640",
				image: "1f645-1f3fb-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F645-1F3FC-200D-2640-FE0F",
				non_qualified: "1F645-1F3FC-200D-2640",
				image: "1f645-1f3fc-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F645-1F3FD-200D-2640-FE0F",
				non_qualified: "1F645-1F3FD-200D-2640",
				image: "1f645-1f3fd-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F645-1F3FE-200D-2640-FE0F",
				non_qualified: "1F645-1F3FE-200D-2640",
				image: "1f645-1f3fe-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F645-1F3FF-200D-2640-FE0F",
				non_qualified: "1F645-1F3FF-200D-2640",
				image: "1f645-1f3ff-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F645",
		a: "Woman Gesturing No",
		b: "1F645-200D-2640-FE0F",
		c: "1F645-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			31,
			47
		],
		o: 4
	},
	taxi: {
		a: "Taxi",
		b: "1F695",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"uber",
			"vehicle",
			"cars",
			"transportation"
		],
		k: [
			34,
			20
		],
		o: 2
	},
	"flag-fk": {
		a: "Falkland Islands Flag",
		b: "1F1EB-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			50
		],
		o: 2
	},
	floppy_disk: {
		a: "Floppy Disk",
		b: "1F4BE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"oldschool",
			"technology",
			"save",
			"90s",
			"80s"
		],
		k: [
			26,
			20
		],
		o: 2
	},
	"t-rex": {
		a: "T-Rex",
		b: "1F996",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			40
		],
		o: 5
	},
	oyster: {
		a: "Oyster",
		b: "1F9AA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			1
		],
		o: 12
	},
	arrow_double_up: {
		a: "Black Up-Pointing Double Triangle",
		b: "23EB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"top"
		],
		k: [
			52,
			28
		],
		o: 2
	},
	oncoming_taxi: {
		a: "Oncoming Taxi",
		b: "1F696",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"cars",
			"uber"
		],
		k: [
			34,
			21
		],
		o: 2
	},
	ok_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB",
				non_qualified: null,
				image: "1f646-1f3fb.png",
				sheet_x: 32,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F646-1F3FC",
				non_qualified: null,
				image: "1f646-1f3fc.png",
				sheet_x: 32,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F646-1F3FD",
				non_qualified: null,
				image: "1f646-1f3fd.png",
				sheet_x: 32,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F646-1F3FE",
				non_qualified: null,
				image: "1f646-1f3fe.png",
				sheet_x: 32,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F646-1F3FF",
				non_qualified: null,
				image: "1f646-1f3ff.png",
				sheet_x: 32,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F646-200D-2640-FE0F",
		a: "Face with Ok Gesture",
		b: "1F646",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"women",
			"girl",
			"female",
			"pink",
			"human",
			"woman"
		],
		k: [
			32,
			20
		],
		o: 2
	},
	weary: {
		a: "Weary Face",
		b: "1F629",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"tired",
			"sleepy",
			"sad",
			"frustrated",
			"upset"
		],
		k: [
			31,
			19
		],
		o: 2
	},
	"man-gesturing-ok": {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB-200D-2642-FE0F",
				non_qualified: "1F646-1F3FB-200D-2642",
				image: "1f646-1f3fb-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F646-1F3FC-200D-2642-FE0F",
				non_qualified: "1F646-1F3FC-200D-2642",
				image: "1f646-1f3fc-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F646-1F3FD-200D-2642-FE0F",
				non_qualified: "1F646-1F3FD-200D-2642",
				image: "1f646-1f3fd-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F646-1F3FE-200D-2642-FE0F",
				non_qualified: "1F646-1F3FE-200D-2642",
				image: "1f646-1f3fe-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F646-1F3FF-200D-2642-FE0F",
				non_qualified: "1F646-1F3FF-200D-2642",
				image: "1f646-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Gesturing Ok",
		b: "1F646-200D-2642-FE0F",
		c: "1F646-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			14
		],
		o: 4
	},
	arrow_down_small: {
		a: "Down-Pointing Small Red Triangle",
		b: "1F53D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			28,
			32
		],
		o: 2
	},
	tired_face: {
		a: "Tired Face",
		b: "1F62B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sick",
			"whine",
			"upset",
			"frustrated"
		],
		k: [
			31,
			21
		],
		o: 2
	},
	car: {
		a: "Automobile",
		b: "1F697",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			34,
			22
		],
		n: [
			"red_car"
		],
		o: 2
	},
	icecream: {
		a: "Soft Ice Cream",
		b: "1F366",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"hot",
			"dessert",
			"summer"
		],
		k: [
			7,
			5
		],
		o: 2
	},
	cd: {
		a: "Optical Disc",
		b: "1F4BF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"dvd",
			"disk",
			"disc",
			"90s"
		],
		k: [
			26,
			21
		],
		o: 2
	},
	whale: {
		a: "Spouting Whale",
		b: "1F433",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		k: [
			12,
			23
		],
		o: 2
	},
	"flag-fm": {
		a: "Micronesia Flag",
		b: "1F1EB-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			51
		],
		o: 2
	},
	oncoming_automobile: {
		a: "Oncoming Automobile",
		b: "1F698",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"car",
			"vehicle",
			"transportation"
		],
		k: [
			34,
			23
		],
		o: 2
	},
	arrow_double_down: {
		a: "Black Down-Pointing Double Triangle",
		b: "23EC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			52,
			29
		],
		o: 2
	},
	"woman-gesturing-ok": {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB-200D-2640-FE0F",
				non_qualified: "1F646-1F3FB-200D-2640",
				image: "1f646-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F646-1F3FC-200D-2640-FE0F",
				non_qualified: "1F646-1F3FC-200D-2640",
				image: "1f646-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F646-1F3FD-200D-2640-FE0F",
				non_qualified: "1F646-1F3FD-200D-2640",
				image: "1f646-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F646-1F3FE-200D-2640-FE0F",
				non_qualified: "1F646-1F3FE-200D-2640",
				image: "1f646-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F646-1F3FF-200D-2640-FE0F",
				non_qualified: "1F646-1F3FF-200D-2640",
				image: "1f646-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F646",
		a: "Woman Gesturing Ok",
		b: "1F646-200D-2640-FE0F",
		c: "1F646-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			8
		],
		o: 4
	},
	yawning_face: {
		a: "Yawning Face",
		b: "1F971",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			7
		],
		o: 12
	},
	dvd: {
		a: "Dvd",
		b: "1F4C0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cd",
			"disk",
			"disc"
		],
		k: [
			26,
			22
		],
		o: 2
	},
	whale2: {
		a: "Whale",
		b: "1F40B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		k: [
			11,
			39
		],
		o: 2
	},
	"flag-fo": {
		a: "Faroe Islands Flag",
		b: "1F1EB-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			52
		],
		o: 2
	},
	shaved_ice: {
		a: "Shaved Ice",
		b: "1F367",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hot",
			"dessert",
			"summer"
		],
		k: [
			7,
			6
		],
		o: 2
	},
	double_vertical_bar: {
		a: "Double Vertical Bar",
		b: "23F8-FE0F",
		c: "23F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			37
		],
		o: 2
	},
	information_desk_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB",
				non_qualified: null,
				image: "1f481-1f3fb.png",
				sheet_x: 24,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F481-1F3FC",
				non_qualified: null,
				image: "1f481-1f3fc.png",
				sheet_x: 24,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F481-1F3FD",
				non_qualified: null,
				image: "1f481-1f3fd.png",
				sheet_x: 24,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F481-1F3FE",
				non_qualified: null,
				image: "1f481-1f3fe.png",
				sheet_x: 24,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F481-1F3FF",
				non_qualified: null,
				image: "1f481-1f3ff.png",
				sheet_x: 24,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F481-200D-2640-FE0F",
		a: "Information Desk Person",
		b: "1F481",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			24,
			2
		],
		o: 2
	},
	dolphin: {
		a: "Dolphin",
		b: "1F42C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"flipper",
			"fins",
			"beach"
		],
		k: [
			12,
			16
		],
		n: [
			"flipper"
		],
		o: 2
	},
	blue_car: {
		a: "Recreational Vehicle",
		b: "1F699",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			24
		],
		o: 2
	},
	ice_cream: {
		a: "Ice Cream",
		b: "1F368",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"hot",
			"dessert"
		],
		k: [
			7,
			7
		],
		o: 2
	},
	fr: {
		a: "France Flag",
		b: "1F1EB-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"banner",
			"flag",
			"nation",
			"france",
			"french",
			"country"
		],
		k: [
			1,
			53
		],
		n: [
			"flag-fr"
		],
		o: 2
	},
	triumph: {
		a: "Face with Look of Triumph",
		b: "1F624",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"gas",
			"phew",
			"proud",
			"pride"
		],
		k: [
			31,
			14
		],
		o: 2
	},
	abacus: {
		a: "Abacus",
		b: "1F9EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			33
		],
		o: 11
	},
	"man-tipping-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB-200D-2642-FE0F",
				non_qualified: "1F481-1F3FB-200D-2642",
				image: "1f481-1f3fb-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F481-1F3FC-200D-2642-FE0F",
				non_qualified: "1F481-1F3FC-200D-2642",
				image: "1f481-1f3fc-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F481-1F3FD-200D-2642-FE0F",
				non_qualified: "1F481-1F3FD-200D-2642",
				image: "1f481-1f3fd-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F481-1F3FE-200D-2642-FE0F",
				non_qualified: "1F481-1F3FE-200D-2642",
				image: "1f481-1f3fe-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F481-1F3FF-200D-2642-FE0F",
				non_qualified: "1F481-1F3FF-200D-2642",
				image: "1f481-1f3ff-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Tipping Hand",
		b: "1F481-200D-2642-FE0F",
		c: "1F481-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			23,
			53
		],
		o: 4
	},
	doughnut: {
		a: "Doughnut",
		b: "1F369",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"dessert",
			"snack",
			"sweet",
			"donut"
		],
		k: [
			7,
			8
		],
		o: 2
	},
	fish: {
		a: "Fish",
		b: "1F41F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"food",
			"nature"
		],
		k: [
			12,
			3
		],
		o: 2
	},
	truck: {
		a: "Delivery Truck",
		b: "1F69A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cars",
			"transportation"
		],
		k: [
			34,
			25
		],
		o: 2
	},
	movie_camera: {
		a: "Movie Camera",
		b: "1F3A5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"film",
			"record"
		],
		k: [
			8,
			11
		],
		o: 2
	},
	"flag-ga": {
		a: "Gabon Flag",
		b: "1F1EC-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			54
		],
		o: 2
	},
	rage: {
		a: "Pouting Face",
		b: "1F621",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"angry",
			"mad",
			"hate",
			"despise"
		],
		k: [
			31,
			11
		],
		o: 2
	},
	black_square_for_stop: {
		a: "Black Square for Stop",
		b: "23F9-FE0F",
		c: "23F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			38
		],
		o: 2
	},
	articulated_lorry: {
		a: "Articulated Lorry",
		b: "1F69B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"cars",
			"transportation",
			"express"
		],
		k: [
			34,
			26
		],
		o: 2
	},
	angry: {
		a: "Angry Face",
		b: "1F620",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mad",
			"face",
			"annoyed",
			"frustrated"
		],
		k: [
			31,
			10
		],
		l: [
			">:(",
			">:-("
		],
		o: 2
	},
	cookie: {
		a: "Cookie",
		b: "1F36A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"snack",
			"oreo",
			"chocolate",
			"sweet",
			"dessert"
		],
		k: [
			7,
			9
		],
		o: 2
	},
	gb: {
		a: "United Kingdom Flag",
		b: "1F1EC-1F1E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			55
		],
		n: [
			"uk",
			"flag-gb"
		],
		o: 2
	},
	tropical_fish: {
		a: "Tropical Fish",
		b: "1F420",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"swim",
			"ocean",
			"beach",
			"nemo"
		],
		k: [
			12,
			4
		],
		o: 2
	},
	"woman-tipping-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB-200D-2640-FE0F",
				non_qualified: "1F481-1F3FB-200D-2640",
				image: "1f481-1f3fb-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F481-1F3FC-200D-2640-FE0F",
				non_qualified: "1F481-1F3FC-200D-2640",
				image: "1f481-1f3fc-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F481-1F3FD-200D-2640-FE0F",
				non_qualified: "1F481-1F3FD-200D-2640",
				image: "1f481-1f3fd-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F481-1F3FE-200D-2640-FE0F",
				non_qualified: "1F481-1F3FE-200D-2640",
				image: "1f481-1f3fe-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F481-1F3FF-200D-2640-FE0F",
				non_qualified: "1F481-1F3FF-200D-2640",
				image: "1f481-1f3ff-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F481",
		a: "Woman Tipping Hand",
		b: "1F481-200D-2640-FE0F",
		c: "1F481-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			23,
			47
		],
		o: 4
	},
	black_circle_for_record: {
		a: "Black Circle for Record",
		b: "23FA-FE0F",
		c: "23FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			39
		],
		o: 2
	},
	film_frames: {
		a: "Film Frames",
		b: "1F39E-FE0F",
		c: "1F39E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			8,
			4
		],
		o: 2
	},
	film_projector: {
		a: "Film Projector",
		b: "1F4FD-FE0F",
		c: "1F4FD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"video",
			"tape",
			"record",
			"movie"
		],
		k: [
			27,
			26
		],
		o: 2
	},
	"flag-gd": {
		a: "Grenada Flag",
		b: "1F1EC-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			1,
			56
		],
		o: 2
	},
	blowfish: {
		a: "Blowfish",
		b: "1F421",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"food",
			"sea",
			"ocean"
		],
		k: [
			12,
			5
		],
		o: 2
	},
	face_with_symbols_on_mouth: {
		a: "Serious Face with Symbols Covering Mouth",
		b: "1F92C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			46
		],
		n: [
			"serious_face_with_symbols_covering_mouth"
		],
		o: 5
	},
	birthday: {
		a: "Birthday Cake",
		b: "1F382",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"dessert",
			"cake"
		],
		k: [
			7,
			33
		],
		o: 2
	},
	eject: {
		a: "Eject",
		b: "23CF-FE0F",
		c: "23CF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			25
		],
		o: 2
	},
	raising_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB",
				non_qualified: null,
				image: "1f64b-1f3fb.png",
				sheet_x: 33,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F64B-1F3FC",
				non_qualified: null,
				image: "1f64b-1f3fc.png",
				sheet_x: 33,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F64B-1F3FD",
				non_qualified: null,
				image: "1f64b-1f3fd.png",
				sheet_x: 33,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F64B-1F3FE",
				non_qualified: null,
				image: "1f64b-1f3fe.png",
				sheet_x: 33,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F64B-1F3FF",
				non_qualified: null,
				image: "1f64b-1f3ff.png",
				sheet_x: 33,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F64B-200D-2640-FE0F",
		a: "Happy Person Raising One Hand",
		b: "1F64B",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			33,
			2
		],
		o: 2
	},
	tractor: {
		a: "Tractor",
		b: "1F69C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"car",
			"farming",
			"agriculture"
		],
		k: [
			34,
			27
		],
		o: 2
	},
	"flag-ge": {
		a: "Georgia Flag",
		b: "1F1EC-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			0
		],
		o: 2
	},
	smiling_imp: {
		a: "Smiling Face with Horns",
		b: "1F608",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"devil",
			"horns"
		],
		k: [
			30,
			43
		],
		o: 2
	},
	racing_car: {
		a: "Racing Car",
		b: "1F3CE-FE0F",
		c: "1F3CE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"race",
			"fast",
			"formula",
			"f1"
		],
		k: [
			10,
			33
		],
		o: 2
	},
	cinema: {
		a: "Cinema",
		b: "1F3A6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"record",
			"film",
			"movie",
			"curtain",
			"stage",
			"theater"
		],
		k: [
			8,
			12
		],
		o: 2
	},
	clapper: {
		a: "Clapper Board",
		b: "1F3AC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"movie",
			"film",
			"record"
		],
		k: [
			8,
			18
		],
		o: 2
	},
	shark: {
		a: "Shark",
		b: "1F988",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"jaws",
			"fins",
			"beach"
		],
		k: [
			42,
			26
		],
		o: 4
	},
	cake: {
		a: "Shortcake",
		b: "1F370",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"dessert"
		],
		k: [
			7,
			15
		],
		o: 2
	},
	"man-raising-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FB-200D-2642",
				image: "1f64b-1f3fb-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64B-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FC-200D-2642",
				image: "1f64b-1f3fc-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64B-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FD-200D-2642",
				image: "1f64b-1f3fd-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64B-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FE-200D-2642",
				image: "1f64b-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64B-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FF-200D-2642",
				image: "1f64b-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Raising Hand",
		b: "1F64B-200D-2642-FE0F",
		c: "1F64B-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			53
		],
		o: 4
	},
	octopus: {
		a: "Octopus",
		b: "1F419",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"creature",
			"ocean",
			"sea",
			"nature",
			"beach"
		],
		k: [
			11,
			54
		],
		o: 2
	},
	"woman-raising-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FB-200D-2640",
				image: "1f64b-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F64B-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FC-200D-2640",
				image: "1f64b-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F64B-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FD-200D-2640",
				image: "1f64b-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F64B-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FE-200D-2640",
				image: "1f64b-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F64B-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FF-200D-2640",
				image: "1f64b-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F64B",
		a: "Woman Raising Hand",
		b: "1F64B-200D-2640-FE0F",
		c: "1F64B-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			47
		],
		o: 4
	},
	"flag-gf": {
		a: "French Guiana Flag",
		b: "1F1EC-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			1
		],
		o: 2
	},
	tv: {
		a: "Television",
		b: "1F4FA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"technology",
			"program",
			"oldschool",
			"show",
			"television"
		],
		k: [
			27,
			23
		],
		o: 2
	},
	imp: {
		a: "Imp",
		b: "1F47F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"devil",
			"angry",
			"horns"
		],
		k: [
			23,
			45
		],
		o: 2
	},
	cupcake: {
		a: "Cupcake",
		b: "1F9C1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			9
		],
		o: 11
	},
	racing_motorcycle: {
		a: "Racing Motorcycle",
		b: "1F3CD-FE0F",
		c: "1F3CD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			10,
			32
		],
		o: 2
	},
	low_brightness: {
		a: "Low Brightness Symbol",
		b: "1F505",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sun",
			"afternoon",
			"warm",
			"summer"
		],
		k: [
			27,
			33
		],
		o: 2
	},
	shell: {
		a: "Spiral Shell",
		b: "1F41A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"sea",
			"beach"
		],
		k: [
			11,
			55
		],
		o: 2
	},
	"flag-gg": {
		a: "Guernsey Flag",
		b: "1F1EC-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			2
		],
		o: 2
	},
	high_brightness: {
		a: "High Brightness Symbol",
		b: "1F506",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sun",
			"light"
		],
		k: [
			27,
			34
		],
		o: 2
	},
	deaf_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CF-1F3FB",
				non_qualified: null,
				image: "1f9cf-1f3fb.png",
				sheet_x: 45,
				sheet_y: 11,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CF-1F3FC",
				non_qualified: null,
				image: "1f9cf-1f3fc.png",
				sheet_x: 45,
				sheet_y: 12,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CF-1F3FD",
				non_qualified: null,
				image: "1f9cf-1f3fd.png",
				sheet_x: 45,
				sheet_y: 13,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CF-1F3FE",
				non_qualified: null,
				image: "1f9cf-1f3fe.png",
				sheet_x: 45,
				sheet_y: 14,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CF-1F3FF",
				non_qualified: null,
				image: "1f9cf-1f3ff.png",
				sheet_x: 45,
				sheet_y: 15,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Deaf Person",
		b: "1F9CF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			45,
			10
		],
		o: 12
	},
	skull: {
		a: "Skull",
		b: "1F480",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dead",
			"skeleton",
			"creepy",
			"death"
		],
		k: [
			23,
			46
		],
		o: 2
	},
	motor_scooter: {
		a: "Motor Scooter",
		b: "1F6F5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"vespa",
			"sasha"
		],
		k: [
			36,
			54
		],
		o: 4
	},
	camera: {
		a: "Camera",
		b: "1F4F7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"gadgets",
			"photography"
		],
		k: [
			27,
			20
		],
		o: 2
	},
	pie: {
		a: "Pie",
		b: "1F967",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			54
		],
		o: 5
	},
	"flag-gh": {
		a: "Ghana Flag",
		b: "1F1EC-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			3
		],
		o: 2
	},
	deaf_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CF-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9CF-1F3FB-200D-2642",
				image: "1f9cf-1f3fb-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CF-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9CF-1F3FC-200D-2642",
				image: "1f9cf-1f3fc-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CF-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9CF-1F3FD-200D-2642",
				image: "1f9cf-1f3fd-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 7,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CF-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9CF-1F3FE-200D-2642",
				image: "1f9cf-1f3fe-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 8,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CF-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9CF-1F3FF-200D-2642",
				image: "1f9cf-1f3ff-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 9,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Deaf Man",
		b: "1F9CF-200D-2642-FE0F",
		c: "1F9CF-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			45,
			4
		],
		o: 12
	},
	skull_and_crossbones: {
		a: "Skull and Crossbones",
		b: "2620-FE0F",
		c: "2620",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"poison",
			"danger",
			"deadly",
			"scary",
			"death",
			"pirate",
			"evil"
		],
		k: [
			53,
			8
		],
		o: 2
	},
	camera_with_flash: {
		a: "Camera with Flash",
		b: "1F4F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			27,
			21
		],
		o: 2
	},
	signal_strength: {
		a: "Antenna with Bars",
		b: "1F4F6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"reception",
			"phone",
			"internet",
			"connection",
			"wifi",
			"bluetooth",
			"bars"
		],
		k: [
			27,
			19
		],
		o: 2
	},
	chocolate_bar: {
		a: "Chocolate Bar",
		b: "1F36B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"snack",
			"dessert",
			"sweet"
		],
		k: [
			7,
			10
		],
		o: 2
	},
	manual_wheelchair: {
		a: "Manual Wheelchair",
		b: "1F9BD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			5
		],
		o: 12
	},
	snail: {
		a: "Snail",
		b: "1F40C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"slow",
			"animal",
			"shell"
		],
		k: [
			11,
			40
		],
		o: 2
	},
	motorized_wheelchair: {
		a: "Motorized Wheelchair",
		b: "1F9BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			4
		],
		o: 12
	},
	"flag-gi": {
		a: "Gibraltar Flag",
		b: "1F1EC-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			4
		],
		o: 2
	},
	hankey: {
		a: "Pile of Poo",
		b: "1F4A9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			25,
			51
		],
		n: [
			"poop",
			"shit"
		],
		o: 2
	},
	vibration_mode: {
		a: "Vibration Mode",
		b: "1F4F3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"orange-square",
			"phone"
		],
		k: [
			27,
			16
		],
		o: 2
	},
	deaf_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CF-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9CF-1F3FB-200D-2640",
				image: "1f9cf-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CF-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9CF-1F3FC-200D-2640",
				image: "1f9cf-1f3fc-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CF-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9CF-1F3FD-200D-2640",
				image: "1f9cf-1f3fd-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CF-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9CF-1F3FE-200D-2640",
				image: "1f9cf-1f3fe-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 2,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CF-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9CF-1F3FF-200D-2640",
				image: "1f9cf-1f3ff-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Deaf Woman",
		b: "1F9CF-200D-2640-FE0F",
		c: "1F9CF-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			55
		],
		o: 12
	},
	butterfly: {
		a: "Butterfly",
		b: "1F98B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"insect",
			"nature",
			"caterpillar"
		],
		k: [
			42,
			29
		],
		o: 4
	},
	video_camera: {
		a: "Video Camera",
		b: "1F4F9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"film",
			"record"
		],
		k: [
			27,
			22
		],
		o: 2
	},
	candy: {
		a: "Candy",
		b: "1F36C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"snack",
			"dessert",
			"sweet",
			"lolly"
		],
		k: [
			7,
			11
		],
		o: 2
	},
	auto_rickshaw: {
		a: "Auto Rickshaw",
		b: "1F6FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			2
		],
		o: 12
	},
	bow: {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB",
				non_qualified: null,
				image: "1f647-1f3fb.png",
				sheet_x: 32,
				sheet_y: 39,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F647-1F3FC",
				non_qualified: null,
				image: "1f647-1f3fc.png",
				sheet_x: 32,
				sheet_y: 40,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F647-1F3FD",
				non_qualified: null,
				image: "1f647-1f3fd.png",
				sheet_x: 32,
				sheet_y: 41,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F647-1F3FE",
				non_qualified: null,
				image: "1f647-1f3fe.png",
				sheet_x: 32,
				sheet_y: 42,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F647-1F3FF",
				non_qualified: null,
				image: "1f647-1f3ff.png",
				sheet_x: 32,
				sheet_y: 43,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F647-200D-2642-FE0F",
		a: "Person Bowing Deeply",
		b: "1F647",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			32,
			38
		],
		o: 2
	},
	mobile_phone_off: {
		a: "Mobile Phone off",
		b: "1F4F4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mute",
			"orange-square",
			"silence",
			"quiet"
		],
		k: [
			27,
			17
		],
		o: 2
	},
	clown_face: {
		a: "Clown Face",
		b: "1F921",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face"
		],
		k: [
			38,
			18
		],
		o: 4
	},
	lollipop: {
		a: "Lollipop",
		b: "1F36D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"snack",
			"candy",
			"sweet"
		],
		k: [
			7,
			12
		],
		o: 2
	},
	"flag-gl": {
		a: "Greenland Flag",
		b: "1F1EC-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			5
		],
		o: 2
	},
	vhs: {
		a: "Videocassette",
		b: "1F4FC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"record",
			"video",
			"oldschool",
			"90s",
			"80s"
		],
		k: [
			27,
			25
		],
		o: 2
	},
	bug: {
		a: "Bug",
		b: "1F41B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"insect",
			"nature",
			"worm"
		],
		k: [
			11,
			56
		],
		o: 2
	},
	bike: {
		a: "Bicycle",
		b: "1F6B2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"bicycle",
			"exercise",
			"hipster"
		],
		k: [
			35,
			9
		],
		o: 2
	},
	"man-bowing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB-200D-2642-FE0F",
				non_qualified: "1F647-1F3FB-200D-2642",
				image: "1f647-1f3fb-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F647-1F3FC-200D-2642-FE0F",
				non_qualified: "1F647-1F3FC-200D-2642",
				image: "1f647-1f3fc-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F647-1F3FD-200D-2642-FE0F",
				non_qualified: "1F647-1F3FD-200D-2642",
				image: "1f647-1f3fd-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 35,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F647-1F3FE-200D-2642-FE0F",
				non_qualified: "1F647-1F3FE-200D-2642",
				image: "1f647-1f3fe-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F647-1F3FF-200D-2642-FE0F",
				non_qualified: "1F647-1F3FF-200D-2642",
				image: "1f647-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F647",
		a: "Man Bowing",
		b: "1F647-200D-2642-FE0F",
		c: "1F647-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			32
		],
		o: 4
	},
	female_sign: {
		a: "Female Sign",
		b: "2640-FE0F",
		c: "2640",
		d: false,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			18
		],
		o: 4
	},
	japanese_ogre: {
		a: "Japanese Ogre",
		b: "1F479",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"monster",
			"red",
			"mask",
			"halloween",
			"scary",
			"creepy",
			"devil",
			"demon",
			"japanese",
			"ogre"
		],
		k: [
			23,
			34
		],
		o: 2
	},
	custard: {
		a: "Custard",
		b: "1F36E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dessert",
			"food"
		],
		k: [
			7,
			13
		],
		o: 2
	},
	ant: {
		a: "Ant",
		b: "1F41C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"insect",
			"nature",
			"bug"
		],
		k: [
			12,
			0
		],
		o: 2
	},
	mag: {
		a: "Left-Pointing Magnifying Glass",
		b: "1F50D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"search",
			"zoom",
			"find",
			"detective"
		],
		k: [
			27,
			41
		],
		o: 2
	},
	"flag-gm": {
		a: "Gambia Flag",
		b: "1F1EC-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			6
		],
		o: 2
	},
	honey_pot: {
		a: "Honey Pot",
		b: "1F36F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bees",
			"sweet",
			"kitchen"
		],
		k: [
			7,
			14
		],
		o: 2
	},
	"woman-bowing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB-200D-2640-FE0F",
				non_qualified: "1F647-1F3FB-200D-2640",
				image: "1f647-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F647-1F3FC-200D-2640-FE0F",
				non_qualified: "1F647-1F3FC-200D-2640",
				image: "1f647-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F647-1F3FD-200D-2640-FE0F",
				non_qualified: "1F647-1F3FD-200D-2640",
				image: "1f647-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F647-1F3FE-200D-2640-FE0F",
				non_qualified: "1F647-1F3FE-200D-2640",
				image: "1f647-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F647-1F3FF-200D-2640-FE0F",
				non_qualified: "1F647-1F3FF-200D-2640",
				image: "1f647-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Bowing",
		b: "1F647-200D-2640-FE0F",
		c: "1F647-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			32,
			26
		],
		o: 4
	},
	male_sign: {
		a: "Male Sign",
		b: "2642-FE0F",
		c: "2642",
		d: false,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			19
		],
		o: 4
	},
	mag_right: {
		a: "Right-Pointing Magnifying Glass",
		b: "1F50E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"search",
			"zoom",
			"find",
			"detective"
		],
		k: [
			27,
			42
		],
		o: 2
	},
	japanese_goblin: {
		a: "Japanese Goblin",
		b: "1F47A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"red",
			"evil",
			"mask",
			"monster",
			"scary",
			"creepy",
			"japanese",
			"goblin"
		],
		k: [
			23,
			35
		],
		o: 2
	},
	scooter: {
		a: "Scooter",
		b: "1F6F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			53
		],
		o: 4
	},
	bee: {
		a: "Honeybee",
		b: "1F41D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			12,
			1
		],
		n: [
			"honeybee"
		],
		o: 2
	},
	"flag-gn": {
		a: "Guinea Flag",
		b: "1F1EC-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			7
		],
		o: 2
	},
	candle: {
		a: "Candle",
		b: "1F56F-FE0F",
		c: "1F56F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fire",
			"wax"
		],
		k: [
			29,
			6
		],
		o: 2
	},
	skateboard: {
		a: "Skateboard",
		b: "1F6F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			1
		],
		o: 11
	},
	medical_symbol: {
		a: "Medical Symbol",
		b: "2695-FE0F",
		c: "2695",
		d: false,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			44
		],
		n: [
			"staff_of_aesculapius"
		],
		o: 4
	},
	ghost: {
		a: "Ghost",
		b: "1F47B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"halloween",
			"spooky",
			"scary"
		],
		k: [
			23,
			36
		],
		o: 2
	},
	beetle: {
		a: "Lady Beetle",
		b: "1F41E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"insect",
			"nature",
			"ladybug"
		],
		k: [
			12,
			2
		],
		o: 2
	},
	face_palm: {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB",
				non_qualified: null,
				image: "1f926-1f3fb.png",
				sheet_x: 38,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F926-1F3FC",
				non_qualified: null,
				image: "1f926-1f3fc.png",
				sheet_x: 38,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F926-1F3FD",
				non_qualified: null,
				image: "1f926-1f3fd.png",
				sheet_x: 38,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F926-1F3FE",
				non_qualified: null,
				image: "1f926-1f3fe.png",
				sheet_x: 38,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F926-1F3FF",
				non_qualified: null,
				image: "1f926-1f3ff.png",
				sheet_x: 38,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Face Palm",
		b: "1F926",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			38,
			35
		],
		o: 4
	},
	"flag-gp": {
		a: "Guadeloupe Flag",
		b: "1F1EC-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			8
		],
		o: 2
	},
	baby_bottle: {
		a: "Baby Bottle",
		b: "1F37C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"food",
			"container",
			"milk"
		],
		k: [
			7,
			27
		],
		o: 2
	},
	infinity: {
		a: "Infinity",
		b: "267E-FE0F",
		c: "267E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			39
		],
		o: 11
	},
	glass_of_milk: {
		a: "Glass of Milk",
		b: "1F95B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			42
		],
		o: 4
	},
	"man-facepalming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB-200D-2642-FE0F",
				non_qualified: "1F926-1F3FB-200D-2642",
				image: "1f926-1f3fb-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F926-1F3FC-200D-2642-FE0F",
				non_qualified: "1F926-1F3FC-200D-2642",
				image: "1f926-1f3fc-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F926-1F3FD-200D-2642-FE0F",
				non_qualified: "1F926-1F3FD-200D-2642",
				image: "1f926-1f3fd-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F926-1F3FE-200D-2642-FE0F",
				non_qualified: "1F926-1F3FE-200D-2642",
				image: "1f926-1f3fe-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F926-1F3FF-200D-2642-FE0F",
				non_qualified: "1F926-1F3FF-200D-2642",
				image: "1f926-1f3ff-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Facepalming",
		b: "1F926-200D-2642-FE0F",
		c: "1F926-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			29
		],
		o: 4
	},
	cricket: {
		a: "Cricket",
		b: "1F997",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports"
		],
		k: [
			42,
			41
		],
		o: 5
	},
	busstop: {
		a: "Bus Stop",
		b: "1F68F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"wait"
		],
		k: [
			34,
			14
		],
		o: 2
	},
	"flag-gq": {
		a: "Equatorial Guinea Flag",
		b: "1F1EC-1F1F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			9
		],
		o: 2
	},
	alien: {
		a: "Extraterrestrial Alien",
		b: "1F47D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"UFO",
			"paul",
			"weird",
			"outer_space"
		],
		k: [
			23,
			43
		],
		o: 2
	},
	bulb: {
		a: "Electric Light Bulb",
		b: "1F4A1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"light",
			"electricity",
			"idea"
		],
		k: [
			25,
			43
		],
		o: 2
	},
	"woman-facepalming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB-200D-2640-FE0F",
				non_qualified: "1F926-1F3FB-200D-2640",
				image: "1f926-1f3fb-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F926-1F3FC-200D-2640-FE0F",
				non_qualified: "1F926-1F3FC-200D-2640",
				image: "1f926-1f3fc-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F926-1F3FD-200D-2640-FE0F",
				non_qualified: "1F926-1F3FD-200D-2640",
				image: "1f926-1f3fd-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 26,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F926-1F3FE-200D-2640-FE0F",
				non_qualified: "1F926-1F3FE-200D-2640",
				image: "1f926-1f3fe-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F926-1F3FF-200D-2640-FE0F",
				non_qualified: "1F926-1F3FF-200D-2640",
				image: "1f926-1f3ff-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Facepalming",
		b: "1F926-200D-2640-FE0F",
		c: "1F926-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			23
		],
		o: 4
	},
	spider: {
		a: "Spider",
		b: "1F577-FE0F",
		c: "1F577",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"arachnid"
		],
		k: [
			29,
			34
		],
		o: 2
	},
	space_invader: {
		a: "Alien Monster",
		b: "1F47E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"game",
			"arcade",
			"play"
		],
		k: [
			23,
			44
		],
		o: 2
	},
	motorway: {
		a: "Motorway",
		b: "1F6E3-FE0F",
		c: "1F6E3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"road",
			"cupertino",
			"interstate",
			"highway"
		],
		k: [
			36,
			45
		],
		o: 2
	},
	"flag-gr": {
		a: "Greece Flag",
		b: "1F1EC-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			10
		],
		o: 2
	},
	recycle: {
		a: "Black Universal Recycling Symbol",
		b: "267B-FE0F",
		c: "267B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"arrow",
			"environment",
			"garbage",
			"trash"
		],
		k: [
			53,
			38
		],
		o: 2
	},
	coffee: {
		a: "Hot Beverage",
		b: "2615",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beverage",
			"caffeine",
			"latte",
			"espresso"
		],
		k: [
			53,
			0
		],
		o: 2
	},
	flashlight: {
		a: "Electric Torch",
		b: "1F526",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dark",
			"camping",
			"sight",
			"night"
		],
		k: [
			28,
			9
		],
		o: 2
	},
	spider_web: {
		a: "Spider Web",
		b: "1F578-FE0F",
		c: "1F578",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"insect",
			"arachnid",
			"silk"
		],
		k: [
			29,
			35
		],
		o: 2
	},
	izakaya_lantern: {
		a: "Izakaya Lantern",
		b: "1F3EE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"light",
			"paper",
			"halloween",
			"spooky"
		],
		k: [
			11,
			8
		],
		n: [
			"lantern"
		],
		o: 2
	},
	"flag-gs": {
		a: "South Georgia & South Sandwich Islands Flag",
		b: "1F1EC-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			11
		],
		o: 2
	},
	shrug: {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB",
				non_qualified: null,
				image: "1f937-1f3fb.png",
				sheet_x: 39,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F937-1F3FC",
				non_qualified: null,
				image: "1f937-1f3fc.png",
				sheet_x: 39,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F937-1F3FD",
				non_qualified: null,
				image: "1f937-1f3fd.png",
				sheet_x: 39,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F937-1F3FE",
				non_qualified: null,
				image: "1f937-1f3fe.png",
				sheet_x: 39,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F937-1F3FF",
				non_qualified: null,
				image: "1f937-1f3ff.png",
				sheet_x: 39,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Shrug",
		b: "1F937",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			39,
			47
		],
		o: 4
	},
	fleur_de_lis: {
		a: "Fleur De Lis",
		b: "269C-FE0F",
		c: "269C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"decorative",
			"scout"
		],
		k: [
			53,
			49
		],
		o: 2
	},
	robot_face: {
		a: "Robot Face",
		b: "1F916",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			29
		],
		o: 2
	},
	railway_track: {
		a: "Railway Track",
		b: "1F6E4-FE0F",
		c: "1F6E4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"train",
			"transportation"
		],
		k: [
			36,
			46
		],
		o: 2
	},
	tea: {
		a: "Teacup Without Handle",
		b: "1F375",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"bowl",
			"breakfast",
			"green",
			"british"
		],
		k: [
			7,
			20
		],
		o: 2
	},
	"flag-gt": {
		a: "Guatemala Flag",
		b: "1F1EC-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			12
		],
		o: 2
	},
	oil_drum: {
		a: "Oil Drum",
		b: "1F6E2-FE0F",
		c: "1F6E2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"barrell"
		],
		k: [
			36,
			44
		],
		o: 2
	},
	diya_lamp: {
		a: "Diya Lamp",
		b: "1FA94",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			8
		],
		o: 12
	},
	sake: {
		a: "Sake Bottle and Cup",
		b: "1F376",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wine",
			"drink",
			"drunk",
			"beverage",
			"japanese",
			"alcohol",
			"booze"
		],
		k: [
			7,
			21
		],
		o: 2
	},
	trident: {
		a: "Trident Emblem",
		b: "1F531",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weapon",
			"spear"
		],
		k: [
			28,
			20
		],
		o: 2
	},
	"man-shrugging": {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB-200D-2642-FE0F",
				non_qualified: "1F937-1F3FB-200D-2642",
				image: "1f937-1f3fb-200d-2642-fe0f.png",
				sheet_x: 39,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F937-1F3FC-200D-2642-FE0F",
				non_qualified: "1F937-1F3FC-200D-2642",
				image: "1f937-1f3fc-200d-2642-fe0f.png",
				sheet_x: 39,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F937-1F3FD-200D-2642-FE0F",
				non_qualified: "1F937-1F3FD-200D-2642",
				image: "1f937-1f3fd-200d-2642-fe0f.png",
				sheet_x: 39,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F937-1F3FE-200D-2642-FE0F",
				non_qualified: "1F937-1F3FE-200D-2642",
				image: "1f937-1f3fe-200d-2642-fe0f.png",
				sheet_x: 39,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F937-1F3FF-200D-2642-FE0F",
				non_qualified: "1F937-1F3FF-200D-2642",
				image: "1f937-1f3ff-200d-2642-fe0f.png",
				sheet_x: 39,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Shrugging",
		b: "1F937-200D-2642-FE0F",
		c: "1F937-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			39,
			41
		],
		o: 4
	},
	smiley_cat: {
		a: "Smiling Cat Face with Open Mouth",
		b: "1F63A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"happy",
			"smile"
		],
		k: [
			31,
			36
		],
		o: 2
	},
	scorpion: {
		a: "Scorpion",
		b: "1F982",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"arachnid"
		],
		k: [
			42,
			20
		],
		o: 2
	},
	"woman-shrugging": {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB-200D-2640-FE0F",
				non_qualified: "1F937-1F3FB-200D-2640",
				image: "1f937-1f3fb-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F937-1F3FC-200D-2640-FE0F",
				non_qualified: "1F937-1F3FC-200D-2640",
				image: "1f937-1f3fc-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F937-1F3FD-200D-2640-FE0F",
				non_qualified: "1F937-1F3FD-200D-2640",
				image: "1f937-1f3fd-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F937-1F3FE-200D-2640-FE0F",
				non_qualified: "1F937-1F3FE-200D-2640",
				image: "1f937-1f3fe-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F937-1F3FF-200D-2640-FE0F",
				non_qualified: "1F937-1F3FF-200D-2640",
				image: "1f937-1f3ff-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Shrugging",
		b: "1F937-200D-2640-FE0F",
		c: "1F937-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			39,
			35
		],
		o: 4
	},
	notebook_with_decorative_cover: {
		a: "Notebook with Decorative Cover",
		b: "1F4D4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"classroom",
			"notes",
			"record",
			"paper",
			"study"
		],
		k: [
			26,
			42
		],
		o: 2
	},
	fuelpump: {
		a: "Fuel Pump",
		b: "26FD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"gas station",
			"petroleum"
		],
		k: [
			54,
			38
		],
		o: 2
	},
	name_badge: {
		a: "Name Badge",
		b: "1F4DB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"fire",
			"forbid"
		],
		k: [
			26,
			49
		],
		o: 2
	},
	mosquito: {
		a: "Mosquito",
		b: "1F99F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			49
		],
		o: 11
	},
	"flag-gu": {
		a: "Guam Flag",
		b: "1F1EC-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			13
		],
		o: 2
	},
	smile_cat: {
		a: "Grinning Cat Face with Smiling Eyes",
		b: "1F638",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"smile"
		],
		k: [
			31,
			34
		],
		o: 2
	},
	champagne: {
		a: "Bottle with Popping Cork",
		b: "1F37E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"wine",
			"bottle",
			"celebration"
		],
		k: [
			7,
			29
		],
		o: 2
	},
	joy_cat: {
		a: "Cat Face with Tears of Joy",
		b: "1F639",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"haha",
			"happy",
			"tears"
		],
		k: [
			31,
			35
		],
		o: 2
	},
	closed_book: {
		a: "Closed Book",
		b: "1F4D5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"learn"
		],
		k: [
			26,
			43
		],
		o: 2
	},
	health_worker: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-2695-FE0F",
				non_qualified: "1F9D1-1F3FB-200D-2695",
				image: "1f9d1-1f3fb-200d-2695-fe0f.png",
				sheet_x: 47,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-2695-FE0F",
				non_qualified: "1F9D1-1F3FC-200D-2695",
				image: "1f9d1-1f3fc-200d-2695-fe0f.png",
				sheet_x: 47,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-2695-FE0F",
				non_qualified: "1F9D1-1F3FD-200D-2695",
				image: "1f9d1-1f3fd-200d-2695-fe0f.png",
				sheet_x: 47,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-2695-FE0F",
				non_qualified: "1F9D1-1F3FE-200D-2695",
				image: "1f9d1-1f3fe-200d-2695-fe0f.png",
				sheet_x: 47,
				sheet_y: 53,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-2695-FE0F",
				non_qualified: "1F9D1-1F3FF-200D-2695",
				image: "1f9d1-1f3ff-200d-2695-fe0f.png",
				sheet_x: 47,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Health Worker",
		b: "1F9D1-200D-2695-FE0F",
		c: "1F9D1-200D-2695",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			49
		],
		o: 12
	},
	rotating_light: {
		a: "Police Cars Revolving Light",
		b: "1F6A8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"police",
			"ambulance",
			"911",
			"emergency",
			"alert",
			"error",
			"pinged",
			"law",
			"legal"
		],
		k: [
			34,
			56
		],
		o: 2
	},
	microbe: {
		a: "Microbe",
		b: "1F9A0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			42,
			50
		],
		o: 11
	},
	"flag-gw": {
		a: "Guinea-Bissau Flag",
		b: "1F1EC-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			14
		],
		o: 2
	},
	wine_glass: {
		a: "Wine Glass",
		b: "1F377",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"booze"
		],
		k: [
			7,
			22
		],
		o: 2
	},
	beginner: {
		a: "Japanese Symbol for Beginner",
		b: "1F530",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"badge",
			"shield"
		],
		k: [
			28,
			19
		],
		o: 2
	},
	bouquet: {
		a: "Bouquet",
		b: "1F490",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"flowers",
			"nature",
			"spring"
		],
		k: [
			25,
			26
		],
		o: 2
	},
	heart_eyes_cat: {
		a: "Smiling Cat Face with Heart-Shaped Eyes",
		b: "1F63B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"love",
			"like",
			"affection",
			"cats",
			"valentines",
			"heart"
		],
		k: [
			31,
			37
		],
		o: 2
	},
	"male-doctor": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2695-FE0F",
				non_qualified: "1F468-1F3FB-200D-2695",
				image: "1f468-1f3fb-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2695-FE0F",
				non_qualified: "1F468-1F3FC-200D-2695",
				image: "1f468-1f3fc-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2695-FE0F",
				non_qualified: "1F468-1F3FD-200D-2695",
				image: "1f468-1f3fd-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2695-FE0F",
				non_qualified: "1F468-1F3FE-200D-2695",
				image: "1f468-1f3fe-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2695-FE0F",
				non_qualified: "1F468-1F3FF-200D-2695",
				image: "1f468-1f3ff-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Doctor",
		b: "1F468-200D-2695-FE0F",
		c: "1F468-200D-2695",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			2
		],
		o: 4
	},
	book: {
		a: "Open Book",
		b: "1F4D6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			26,
			44
		],
		n: [
			"open_book"
		],
		o: 2
	},
	traffic_light: {
		a: "Horizontal Traffic Light",
		b: "1F6A5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"signal"
		],
		k: [
			34,
			53
		],
		o: 2
	},
	cocktail: {
		a: "Cocktail Glass",
		b: "1F378",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"drunk",
			"alcohol",
			"beverage",
			"booze",
			"mojito"
		],
		k: [
			7,
			23
		],
		o: 2
	},
	o: {
		a: "Heavy Large Circle",
		b: "2B55",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"circle",
			"round"
		],
		k: [
			55,
			43
		],
		o: 2
	},
	"flag-gy": {
		a: "Guyana Flag",
		b: "1F1EC-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			15
		],
		o: 2
	},
	"female-doctor": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2695-FE0F",
				non_qualified: "1F469-1F3FB-200D-2695",
				image: "1f469-1f3fb-200d-2695-fe0f.png",
				sheet_x: 19,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2695-FE0F",
				non_qualified: "1F469-1F3FC-200D-2695",
				image: "1f469-1f3fc-200d-2695-fe0f.png",
				sheet_x: 19,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2695-FE0F",
				non_qualified: "1F469-1F3FD-200D-2695",
				image: "1f469-1f3fd-200d-2695-fe0f.png",
				sheet_x: 19,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2695-FE0F",
				non_qualified: "1F469-1F3FE-200D-2695",
				image: "1f469-1f3fe-200d-2695-fe0f.png",
				sheet_x: 19,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2695-FE0F",
				non_qualified: "1F469-1F3FF-200D-2695",
				image: "1f469-1f3ff-200d-2695-fe0f.png",
				sheet_x: 19,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Doctor",
		b: "1F469-200D-2695-FE0F",
		c: "1F469-200D-2695",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			44
		],
		o: 4
	},
	smirk_cat: {
		a: "Cat Face with Wry Smile",
		b: "1F63C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"smirk"
		],
		k: [
			31,
			38
		],
		o: 2
	},
	green_book: {
		a: "Green Book",
		b: "1F4D7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"read",
			"library",
			"knowledge",
			"study"
		],
		k: [
			26,
			45
		],
		o: 2
	},
	cherry_blossom: {
		a: "Cherry Blossom",
		b: "1F338",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant",
			"spring",
			"flower"
		],
		k: [
			6,
			16
		],
		o: 2
	},
	"flag-hk": {
		a: "Hong Kong Sar China Flag",
		b: "1F1ED-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			16
		],
		o: 2
	},
	vertical_traffic_light: {
		a: "Vertical Traffic Light",
		b: "1F6A6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"driving"
		],
		k: [
			34,
			54
		],
		o: 2
	},
	white_check_mark: {
		a: "White Heavy Check Mark",
		b: "2705",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"green-square",
			"ok",
			"agree",
			"vote",
			"election",
			"answer",
			"tick"
		],
		k: [
			54,
			40
		],
		o: 2
	},
	tropical_drink: {
		a: "Tropical Drink",
		b: "1F379",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beverage",
			"cocktail",
			"summer",
			"beach",
			"alcohol",
			"booze",
			"mojito"
		],
		k: [
			7,
			24
		],
		o: 2
	},
	kissing_cat: {
		a: "Kissing Cat Face with Closed Eyes",
		b: "1F63D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"kiss"
		],
		k: [
			31,
			39
		],
		o: 2
	},
	"flag-hm": {
		a: "Heard & Mcdonald Islands Flag",
		b: "1F1ED-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			17
		],
		o: 2
	},
	octagonal_sign: {
		a: "Octagonal Sign",
		b: "1F6D1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			39
		],
		o: 4
	},
	white_flower: {
		a: "White Flower",
		b: "1F4AE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"spring"
		],
		k: [
			26,
			4
		],
		o: 2
	},
	ballot_box_with_check: {
		a: "Ballot Box with Check",
		b: "2611-FE0F",
		c: "2611",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ok",
			"agree",
			"confirm",
			"black-square",
			"vote",
			"election",
			"yes",
			"tick"
		],
		k: [
			52,
			55
		],
		o: 2
	},
	student: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F393",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f393.png",
				sheet_x: 45,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F393",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f393.png",
				sheet_x: 45,
				sheet_y: 31,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F393",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f393.png",
				sheet_x: 45,
				sheet_y: 32,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F393",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f393.png",
				sheet_x: 45,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F393",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f393.png",
				sheet_x: 45,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Student",
		b: "1F9D1-200D-1F393",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			29
		],
		o: 12
	},
	blue_book: {
		a: "Blue Book",
		b: "1F4D8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"read",
			"library",
			"knowledge",
			"learn",
			"study"
		],
		k: [
			26,
			46
		],
		o: 2
	},
	beer: {
		a: "Beer Mug",
		b: "1F37A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		k: [
			7,
			25
		],
		o: 2
	},
	construction: {
		a: "Construction Sign",
		b: "1F6A7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wip",
			"progress",
			"caution",
			"warning"
		],
		k: [
			34,
			55
		],
		o: 2
	},
	rosette: {
		a: "Rosette",
		b: "1F3F5-FE0F",
		c: "1F3F5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"flower",
			"decoration",
			"military"
		],
		k: [
			11,
			18
		],
		o: 2
	},
	heavy_check_mark: {
		a: "Heavy Check Mark",
		b: "2714-FE0F",
		c: "2714",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ok",
			"nike",
			"answer",
			"yes",
			"tick"
		],
		k: [
			55,
			12
		],
		o: 2
	},
	scream_cat: {
		a: "Weary Cat Face",
		b: "1F640",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats",
			"munch",
			"scared",
			"scream"
		],
		k: [
			31,
			42
		],
		o: 2
	},
	orange_book: {
		a: "Orange Book",
		b: "1F4D9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"study"
		],
		k: [
			26,
			47
		],
		o: 2
	},
	beers: {
		a: "Clinking Beer Mugs",
		b: "1F37B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		k: [
			7,
			26
		],
		o: 2
	},
	"male-student": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f393.png",
				sheet_x: 14,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f393.png",
				sheet_x: 14,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f393.png",
				sheet_x: 14,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f393.png",
				sheet_x: 14,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f393.png",
				sheet_x: 14,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Student",
		b: "1F468-200D-1F393",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			14,
			50
		],
		o: 4
	},
	"flag-hn": {
		a: "Honduras Flag",
		b: "1F1ED-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			18
		],
		o: 2
	},
	crying_cat_face: {
		a: "Crying Cat Face",
		b: "1F63F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"tears",
			"weep",
			"sad",
			"cats",
			"upset",
			"cry"
		],
		k: [
			31,
			41
		],
		o: 2
	},
	anchor: {
		a: "Anchor",
		b: "2693",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ship",
			"ferry",
			"sea",
			"boat"
		],
		k: [
			53,
			42
		],
		o: 2
	},
	"flag-hr": {
		a: "Croatia Flag",
		b: "1F1ED-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			19
		],
		o: 2
	},
	heavy_multiplication_x: {
		a: "Heavy Multiplication X",
		b: "2716-FE0F",
		c: "2716",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"math",
			"calculation"
		],
		k: [
			55,
			13
		],
		o: 2
	},
	"female-student": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f393.png",
				sheet_x: 17,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f393.png",
				sheet_x: 17,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f393.png",
				sheet_x: 17,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f393.png",
				sheet_x: 17,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f393.png",
				sheet_x: 17,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Student",
		b: "1F469-200D-1F393",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			40
		],
		o: 4
	},
	rose: {
		a: "Rose",
		b: "1F339",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"flowers",
			"valentines",
			"love",
			"spring"
		],
		k: [
			6,
			17
		],
		o: 2
	},
	books: {
		a: "Books",
		b: "1F4DA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"literature",
			"library",
			"study"
		],
		k: [
			26,
			48
		],
		o: 2
	},
	clinking_glasses: {
		a: "Clinking Glasses",
		b: "1F942",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"beverage",
			"drink",
			"party",
			"alcohol",
			"celebrate",
			"cheers"
		],
		k: [
			41,
			18
		],
		o: 4
	},
	teacher: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F3EB",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f3eb.png",
				sheet_x: 45,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F3EB",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f3eb.png",
				sheet_x: 45,
				sheet_y: 49,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F3EB",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f3eb.png",
				sheet_x: 45,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F3EB",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f3eb.png",
				sheet_x: 45,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F3EB",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f3eb.png",
				sheet_x: 45,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Teacher",
		b: "1F9D1-200D-1F3EB",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			47
		],
		o: 12
	},
	x: {
		a: "Cross Mark",
		b: "274C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"no",
			"delete",
			"remove",
			"cancel"
		],
		k: [
			55,
			21
		],
		o: 2
	},
	pouting_cat: {
		a: "Pouting Cat Face",
		b: "1F63E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"cats"
		],
		k: [
			31,
			40
		],
		o: 2
	},
	wilted_flower: {
		a: "Wilted Flower",
		b: "1F940",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature",
			"flower"
		],
		k: [
			41,
			16
		],
		o: 4
	},
	boat: {
		a: "Sailboat",
		b: "26F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			16
		],
		n: [
			"sailboat"
		],
		o: 2
	},
	"flag-ht": {
		a: "Haiti Flag",
		b: "1F1ED-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			20
		],
		o: 2
	},
	tumbler_glass: {
		a: "Tumbler Glass",
		b: "1F943",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"liquor",
			"booze",
			"bourbon",
			"scotch",
			"whisky",
			"glass",
			"shot"
		],
		k: [
			41,
			19
		],
		o: 4
	},
	notebook: {
		a: "Notebook",
		b: "1F4D3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"record",
			"notes",
			"paper",
			"study"
		],
		k: [
			26,
			41
		],
		o: 2
	},
	"male-teacher": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3eb.png",
				sheet_x: 15,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3eb.png",
				sheet_x: 15,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3eb.png",
				sheet_x: 15,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3eb.png",
				sheet_x: 15,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3eb.png",
				sheet_x: 15,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Teacher",
		b: "1F468-200D-1F3EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			11
		],
		o: 4
	},
	ledger: {
		a: "Ledger",
		b: "1F4D2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"notes",
			"paper"
		],
		k: [
			26,
			40
		],
		o: 2
	},
	"flag-hu": {
		a: "Hungary Flag",
		b: "1F1ED-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			21
		],
		o: 2
	},
	cup_with_straw: {
		a: "Cup with Straw",
		b: "1F964",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			51
		],
		o: 5
	},
	hibiscus: {
		a: "Hibiscus",
		b: "1F33A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"vegetable",
			"flowers",
			"beach"
		],
		k: [
			6,
			18
		],
		o: 2
	},
	see_no_evil: {
		a: "See-No-Evil Monkey",
		b: "1F648",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"monkey",
			"animal",
			"nature",
			"haha"
		],
		k: [
			32,
			44
		],
		o: 2
	},
	canoe: {
		a: "Canoe",
		b: "1F6F6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"boat",
			"paddle",
			"water",
			"ship"
		],
		k: [
			36,
			55
		],
		o: 4
	},
	negative_squared_cross_mark: {
		a: "Negative Squared Cross Mark",
		b: "274E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"x",
			"green-square",
			"no",
			"deny"
		],
		k: [
			55,
			22
		],
		o: 2
	},
	"flag-ic": {
		a: "Canary Islands Flag",
		b: "1F1EE-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			22
		],
		o: 2
	},
	beverage_box: {
		a: "Beverage Box",
		b: "1F9C3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			11
		],
		o: 12
	},
	speedboat: {
		a: "Speedboat",
		b: "1F6A4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ship",
			"transportation",
			"vehicle",
			"summer"
		],
		k: [
			34,
			52
		],
		o: 2
	},
	heavy_plus_sign: {
		a: "Heavy Plus Sign",
		b: "2795",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"math",
			"calculation",
			"addition",
			"more",
			"increase"
		],
		k: [
			55,
			29
		],
		o: 2
	},
	sunflower: {
		a: "Sunflower",
		b: "1F33B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant",
			"fall"
		],
		k: [
			6,
			19
		],
		o: 2
	},
	page_with_curl: {
		a: "Page with Curl",
		b: "1F4C3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"office",
			"paper"
		],
		k: [
			26,
			25
		],
		o: 2
	},
	"female-teacher": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Teacher",
		b: "1F469-200D-1F3EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			1
		],
		o: 4
	},
	hear_no_evil: {
		a: "Hear-No-Evil Monkey",
		b: "1F649",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"monkey",
			"nature"
		],
		k: [
			32,
			45
		],
		o: 2
	},
	mate_drink: {
		a: "Mate Drink",
		b: "1F9C9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			17
		],
		o: 12
	},
	passenger_ship: {
		a: "Passenger Ship",
		b: "1F6F3-FE0F",
		c: "1F6F3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"yacht",
			"cruise",
			"ferry"
		],
		k: [
			36,
			52
		],
		o: 2
	},
	judge: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-2696-FE0F",
				non_qualified: "1F9D1-1F3FB-200D-2696",
				image: "1f9d1-1f3fb-200d-2696-fe0f.png",
				sheet_x: 47,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-2696-FE0F",
				non_qualified: "1F9D1-1F3FC-200D-2696",
				image: "1f9d1-1f3fc-200d-2696-fe0f.png",
				sheet_x: 48,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-2696-FE0F",
				non_qualified: "1F9D1-1F3FD-200D-2696",
				image: "1f9d1-1f3fd-200d-2696-fe0f.png",
				sheet_x: 48,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-2696-FE0F",
				non_qualified: "1F9D1-1F3FE-200D-2696",
				image: "1f9d1-1f3fe-200d-2696-fe0f.png",
				sheet_x: 48,
				sheet_y: 2,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-2696-FE0F",
				non_qualified: "1F9D1-1F3FF-200D-2696",
				image: "1f9d1-1f3ff-200d-2696-fe0f.png",
				sheet_x: 48,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Judge",
		b: "1F9D1-200D-2696-FE0F",
		c: "1F9D1-200D-2696",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			55
		],
		o: 12
	},
	scroll: {
		a: "Scroll",
		b: "1F4DC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"ancient",
			"history",
			"paper"
		],
		k: [
			26,
			50
		],
		o: 2
	},
	blossom: {
		a: "Blossom",
		b: "1F33C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"flowers",
			"yellow"
		],
		k: [
			6,
			20
		],
		o: 2
	},
	"flag-id": {
		a: "Indonesia Flag",
		b: "1F1EE-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			23
		],
		o: 2
	},
	speak_no_evil: {
		a: "Speak-No-Evil Monkey",
		b: "1F64A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"monkey",
			"animal",
			"nature",
			"omg"
		],
		k: [
			32,
			46
		],
		o: 2
	},
	heavy_minus_sign: {
		a: "Heavy Minus Sign",
		b: "2796",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"math",
			"calculation",
			"subtract",
			"less"
		],
		k: [
			55,
			30
		],
		o: 2
	},
	"flag-ie": {
		a: "Ireland Flag",
		b: "1F1EE-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			24
		],
		o: 2
	},
	ice_cube: {
		a: "Ice Cube",
		b: "1F9CA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			18
		],
		o: 12
	},
	page_facing_up: {
		a: "Page Facing Up",
		b: "1F4C4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"office",
			"paper",
			"information"
		],
		k: [
			26,
			26
		],
		o: 2
	},
	"male-judge": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2696-FE0F",
				non_qualified: "1F468-1F3FB-200D-2696",
				image: "1f468-1f3fb-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2696-FE0F",
				non_qualified: "1F468-1F3FC-200D-2696",
				image: "1f468-1f3fc-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2696-FE0F",
				non_qualified: "1F468-1F3FD-200D-2696",
				image: "1f468-1f3fd-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2696-FE0F",
				non_qualified: "1F468-1F3FE-200D-2696",
				image: "1f468-1f3fe-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2696-FE0F",
				non_qualified: "1F468-1F3FF-200D-2696",
				image: "1f468-1f3ff-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Judge",
		b: "1F468-200D-2696-FE0F",
		c: "1F468-200D-2696",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			8
		],
		o: 4
	},
	tulip: {
		a: "Tulip",
		b: "1F337",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"flowers",
			"plant",
			"nature",
			"summer",
			"spring"
		],
		k: [
			6,
			15
		],
		o: 2
	},
	ferry: {
		a: "Ferry",
		b: "26F4-FE0F",
		c: "26F4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"boat",
			"ship",
			"yacht"
		],
		k: [
			54,
			15
		],
		o: 2
	},
	kiss: {
		a: "Kiss Mark",
		b: "1F48B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"face",
			"lips",
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			21
		],
		o: 2
	},
	heavy_division_sign: {
		a: "Heavy Division Sign",
		b: "2797",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"divide",
			"math",
			"calculation"
		],
		k: [
			55,
			31
		],
		o: 2
	},
	newspaper: {
		a: "Newspaper",
		b: "1F4F0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"press",
			"headline"
		],
		k: [
			27,
			13
		],
		o: 2
	},
	"female-judge": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2696-FE0F",
				non_qualified: "1F469-1F3FB-200D-2696",
				image: "1f469-1f3fb-200d-2696-fe0f.png",
				sheet_x: 19,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2696-FE0F",
				non_qualified: "1F469-1F3FC-200D-2696",
				image: "1f469-1f3fc-200d-2696-fe0f.png",
				sheet_x: 19,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2696-FE0F",
				non_qualified: "1F469-1F3FD-200D-2696",
				image: "1f469-1f3fd-200d-2696-fe0f.png",
				sheet_x: 19,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2696-FE0F",
				non_qualified: "1F469-1F3FE-200D-2696",
				image: "1f469-1f3fe-200d-2696-fe0f.png",
				sheet_x: 19,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2696-FE0F",
				non_qualified: "1F469-1F3FF-200D-2696",
				image: "1f469-1f3ff-200d-2696-fe0f.png",
				sheet_x: 19,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Judge",
		b: "1F469-200D-2696-FE0F",
		c: "1F469-200D-2696",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			50
		],
		o: 4
	},
	seedling: {
		a: "Seedling",
		b: "1F331",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature",
			"grass",
			"lawn",
			"spring"
		],
		k: [
			6,
			9
		],
		o: 2
	},
	love_letter: {
		a: "Love Letter",
		b: "1F48C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"like",
			"affection",
			"envelope",
			"valentines"
		],
		k: [
			25,
			22
		],
		o: 2
	},
	chopsticks: {
		a: "Chopsticks",
		b: "1F962",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			49
		],
		o: 5
	},
	motor_boat: {
		a: "Motor Boat",
		b: "1F6E5-FE0F",
		c: "1F6E5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ship"
		],
		k: [
			36,
			47
		],
		o: 2
	},
	"flag-il": {
		a: "Israel Flag",
		b: "1F1EE-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			25
		],
		o: 2
	},
	curly_loop: {
		a: "Curly Loop",
		b: "27B0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"scribble",
			"draw",
			"shape",
			"squiggle"
		],
		k: [
			55,
			33
		],
		o: 2
	},
	"flag-im": {
		a: "Isle of Man Flag",
		b: "1F1EE-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			26
		],
		o: 2
	},
	evergreen_tree: {
		a: "Evergreen Tree",
		b: "1F332",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature"
		],
		k: [
			6,
			10
		],
		o: 2
	},
	cupid: {
		a: "Heart with Arrow",
		b: "1F498",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"heart",
			"affection",
			"valentines"
		],
		k: [
			25,
			34
		],
		o: 2
	},
	loop: {
		a: "Double Curly Loop",
		b: "27BF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tape",
			"cassette"
		],
		k: [
			55,
			34
		],
		o: 2
	},
	ship: {
		a: "Ship",
		b: "1F6A2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"titanic",
			"deploy"
		],
		k: [
			34,
			33
		],
		o: 2
	},
	farmer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F33E",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f33e.png",
				sheet_x: 45,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F33E",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f33e.png",
				sheet_x: 45,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F33E",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f33e.png",
				sheet_x: 45,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F33E",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f33e.png",
				sheet_x: 45,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F33E",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f33e.png",
				sheet_x: 45,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Farmer",
		b: "1F9D1-200D-1F33E",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			17
		],
		o: 12
	},
	rolled_up_newspaper: {
		a: "Rolled Up Newspaper",
		b: "1F5DE-FE0F",
		c: "1F5DE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			23
		],
		o: 2
	},
	knife_fork_plate: {
		a: "Knife Fork Plate",
		b: "1F37D-FE0F",
		c: "1F37D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			7,
			28
		],
		o: 2
	},
	fork_and_knife: {
		a: "Fork and Knife",
		b: "1F374",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cutlery",
			"kitchen"
		],
		k: [
			7,
			19
		],
		o: 2
	},
	"male-farmer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f33e.png",
				sheet_x: 14,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f33e.png",
				sheet_x: 14,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f33e.png",
				sheet_x: 14,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f33e.png",
				sheet_x: 14,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f33e.png",
				sheet_x: 14,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Farmer",
		b: "1F468-200D-1F33E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			14,
			38
		],
		o: 4
	},
	bookmark_tabs: {
		a: "Bookmark Tabs",
		b: "1F4D1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"favorite",
			"save",
			"order",
			"tidy"
		],
		k: [
			26,
			39
		],
		o: 2
	},
	part_alternation_mark: {
		a: "Part Alternation Mark",
		b: "303D-FE0F",
		c: "303D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"business",
			"economics",
			"bad"
		],
		k: [
			55,
			45
		],
		o: 2
	},
	"flag-in": {
		a: "India Flag",
		b: "1F1EE-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			27
		],
		o: 2
	},
	gift_heart: {
		a: "Heart with Ribbon",
		b: "1F49D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"valentines"
		],
		k: [
			25,
			39
		],
		o: 2
	},
	airplane: {
		a: "Airplane",
		b: "2708-FE0F",
		c: "2708",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"transportation",
			"flight",
			"fly"
		],
		k: [
			54,
			41
		],
		o: 2
	},
	deciduous_tree: {
		a: "Deciduous Tree",
		b: "1F333",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"nature"
		],
		k: [
			6,
			11
		],
		o: 2
	},
	spoon: {
		a: "Spoon",
		b: "1F944",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cutlery",
			"kitchen",
			"tableware"
		],
		k: [
			41,
			20
		],
		o: 4
	},
	"flag-io": {
		a: "British Indian Ocean Territory Flag",
		b: "1F1EE-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			28
		],
		o: 2
	},
	palm_tree: {
		a: "Palm Tree",
		b: "1F334",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"plant",
			"vegetable",
			"nature",
			"summer",
			"beach",
			"mojito",
			"tropical"
		],
		k: [
			6,
			12
		],
		o: 2
	},
	sparkling_heart: {
		a: "Sparkling Heart",
		b: "1F496",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			32
		],
		o: 2
	},
	"female-farmer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f33e.png",
				sheet_x: 17,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f33e.png",
				sheet_x: 17,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f33e.png",
				sheet_x: 17,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f33e.png",
				sheet_x: 17,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f33e.png",
				sheet_x: 17,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Farmer",
		b: "1F469-200D-1F33E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			28
		],
		o: 4
	},
	eight_spoked_asterisk: {
		a: "Eight Spoked Asterisk",
		b: "2733-FE0F",
		c: "2733",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"star",
			"sparkle",
			"green-square"
		],
		k: [
			55,
			17
		],
		o: 2
	},
	small_airplane: {
		a: "Small Airplane",
		b: "1F6E9-FE0F",
		c: "1F6E9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"flight",
			"transportation",
			"fly",
			"vehicle"
		],
		k: [
			36,
			48
		],
		o: 2
	},
	bookmark: {
		a: "Bookmark",
		b: "1F516",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"favorite",
			"label",
			"save"
		],
		k: [
			27,
			50
		],
		o: 2
	},
	cook: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F373",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f373.png",
				sheet_x: 45,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F373",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f373.png",
				sheet_x: 45,
				sheet_y: 25,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F373",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f373.png",
				sheet_x: 45,
				sheet_y: 26,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F373",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f373.png",
				sheet_x: 45,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F373",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f373.png",
				sheet_x: 45,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Cook",
		b: "1F9D1-200D-1F373",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			23
		],
		o: 12
	},
	eight_pointed_black_star: {
		a: "Eight Pointed Black Star",
		b: "2734-FE0F",
		c: "2734",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"orange-square",
			"shape",
			"polygon"
		],
		k: [
			55,
			18
		],
		o: 2
	},
	heartpulse: {
		a: "Growing Heart",
		b: "1F497",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"like",
			"love",
			"affection",
			"valentines",
			"pink"
		],
		k: [
			25,
			33
		],
		o: 2
	},
	label: {
		a: "Label",
		b: "1F3F7-FE0F",
		c: "1F3F7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sale",
			"tag"
		],
		k: [
			11,
			19
		],
		o: 2
	},
	"flag-iq": {
		a: "Iraq Flag",
		b: "1F1EE-1F1F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			29
		],
		o: 2
	},
	hocho: {
		a: "Hocho",
		b: "1F52A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"knife",
			"blade",
			"cutlery",
			"kitchen",
			"weapon"
		],
		k: [
			28,
			13
		],
		n: [
			"knife"
		],
		o: 2
	},
	cactus: {
		a: "Cactus",
		b: "1F335",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"plant",
			"nature"
		],
		k: [
			6,
			13
		],
		o: 2
	},
	airplane_departure: {
		a: "Airplane Departure",
		b: "1F6EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			49
		],
		o: 2
	},
	airplane_arriving: {
		a: "Airplane Arriving",
		b: "1F6EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			50
		],
		o: 2
	},
	ear_of_rice: {
		a: "Ear of Rice",
		b: "1F33E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant"
		],
		k: [
			6,
			22
		],
		o: 2
	},
	"flag-ir": {
		a: "Iran Flag",
		b: "1F1EE-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			30
		],
		o: 2
	},
	moneybag: {
		a: "Money Bag",
		b: "1F4B0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dollar",
			"payment",
			"coins",
			"sale"
		],
		k: [
			26,
			6
		],
		o: 2
	},
	"male-cook": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f373.png",
				sheet_x: 14,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f373.png",
				sheet_x: 14,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f373.png",
				sheet_x: 14,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f373.png",
				sheet_x: 14,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f373.png",
				sheet_x: 14,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Cook",
		b: "1F468-200D-1F373",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			14,
			44
		],
		o: 4
	},
	heartbeat: {
		a: "Beating Heart",
		b: "1F493",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines",
			"pink",
			"heart"
		],
		k: [
			25,
			29
		],
		o: 2
	},
	sparkle: {
		a: "Sparkle",
		b: "2747-FE0F",
		c: "2747",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stars",
			"green-square",
			"awesome",
			"good",
			"fireworks"
		],
		k: [
			55,
			20
		],
		o: 2
	},
	amphora: {
		a: "Amphora",
		b: "1F3FA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vase",
			"jar"
		],
		k: [
			11,
			22
		],
		o: 2
	},
	yen: {
		a: "Banknote with Yen Sign",
		b: "1F4B4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"japanese",
			"dollar",
			"currency"
		],
		k: [
			26,
			10
		],
		o: 2
	},
	revolving_hearts: {
		a: "Revolving Hearts",
		b: "1F49E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			40
		],
		o: 2
	},
	bangbang: {
		a: "Double Exclamation Mark",
		b: "203C-FE0F",
		c: "203C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"exclamation",
			"surprise"
		],
		k: [
			52,
			10
		],
		o: 2
	},
	parachute: {
		a: "Parachute",
		b: "1FA82",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			3
		],
		o: 12
	},
	herb: {
		a: "Herb",
		b: "1F33F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"plant",
			"medicine",
			"weed",
			"grass",
			"lawn"
		],
		k: [
			6,
			23
		],
		o: 2
	},
	"flag-is": {
		a: "Iceland Flag",
		b: "1F1EE-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			31
		],
		o: 2
	},
	"female-cook": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f373.png",
				sheet_x: 17,
				sheet_y: 35,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f373.png",
				sheet_x: 17,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f373.png",
				sheet_x: 17,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f373.png",
				sheet_x: 17,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f373.png",
				sheet_x: 17,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Cook",
		b: "1F469-200D-1F373",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			34
		],
		o: 4
	},
	mechanic: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F527",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f527.png",
				sheet_x: 46,
				sheet_y: 15,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F527",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f527.png",
				sheet_x: 46,
				sheet_y: 16,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F527",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f527.png",
				sheet_x: 46,
				sheet_y: 17,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F527",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f527.png",
				sheet_x: 46,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F527",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f527.png",
				sheet_x: 46,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Mechanic",
		b: "1F9D1-200D-1F527",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			14
		],
		o: 12
	},
	interrobang: {
		a: "Exclamation Question Mark",
		b: "2049-FE0F",
		c: "2049",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wat",
			"punctuation",
			"surprise"
		],
		k: [
			52,
			11
		],
		o: 2
	},
	seat: {
		a: "Seat",
		b: "1F4BA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sit",
			"airplane",
			"transport",
			"bus",
			"flight",
			"fly"
		],
		k: [
			26,
			16
		],
		o: 2
	},
	dollar: {
		a: "Banknote with Dollar Sign",
		b: "1F4B5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"bill",
			"currency"
		],
		k: [
			26,
			11
		],
		o: 2
	},
	two_hearts: {
		a: "Two Hearts",
		b: "1F495",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines",
			"heart"
		],
		k: [
			25,
			31
		],
		o: 2
	},
	it: {
		a: "Italy Flag",
		b: "1F1EE-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"italy",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			2,
			32
		],
		n: [
			"flag-it"
		],
		o: 2
	},
	shamrock: {
		a: "Shamrock",
		b: "2618-FE0F",
		c: "2618",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"plant",
			"nature",
			"irish",
			"clover"
		],
		k: [
			53,
			1
		],
		o: 2
	},
	four_leaf_clover: {
		a: "Four Leaf Clover",
		b: "1F340",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vegetable",
			"plant",
			"nature",
			"lucky",
			"irish"
		],
		k: [
			6,
			24
		],
		o: 2
	},
	euro: {
		a: "Banknote with Euro Sign",
		b: "1F4B6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"dollar",
			"currency"
		],
		k: [
			26,
			12
		],
		o: 2
	},
	question: {
		a: "Black Question Mark Ornament",
		b: "2753",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"doubt",
			"confused"
		],
		k: [
			55,
			23
		],
		o: 2
	},
	helicopter: {
		a: "Helicopter",
		b: "1F681",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"fly"
		],
		k: [
			34,
			0
		],
		o: 2
	},
	heart_decoration: {
		a: "Heart Decoration",
		b: "1F49F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"love",
			"like"
		],
		k: [
			25,
			41
		],
		o: 2
	},
	"flag-je": {
		a: "Jersey Flag",
		b: "1F1EF-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			33
		],
		o: 2
	},
	"male-mechanic": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f527.png",
				sheet_x: 15,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f527.png",
				sheet_x: 15,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f527.png",
				sheet_x: 15,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f527.png",
				sheet_x: 15,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f527.png",
				sheet_x: 15,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Mechanic",
		b: "1F468-200D-1F527",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			50
		],
		o: 4
	},
	suspension_railway: {
		a: "Suspension Railway",
		b: "1F69F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vehicle",
			"transportation"
		],
		k: [
			34,
			30
		],
		o: 2
	},
	heavy_heart_exclamation_mark_ornament: {
		a: "Heavy Heart Exclamation Mark Ornament",
		b: "2763-FE0F",
		c: "2763",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			55,
			27
		],
		o: 2
	},
	"female-mechanic": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f527.png",
				sheet_x: 18,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f527.png",
				sheet_x: 18,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f527.png",
				sheet_x: 18,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f527.png",
				sheet_x: 18,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f527.png",
				sheet_x: 18,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Mechanic",
		b: "1F469-200D-1F527",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			35
		],
		o: 4
	},
	"flag-jm": {
		a: "Jamaica Flag",
		b: "1F1EF-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			34
		],
		o: 2
	},
	grey_question: {
		a: "White Question Mark Ornament",
		b: "2754",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"doubts",
			"gray",
			"huh",
			"confused"
		],
		k: [
			55,
			24
		],
		o: 2
	},
	maple_leaf: {
		a: "Maple Leaf",
		b: "1F341",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant",
			"vegetable",
			"ca",
			"fall"
		],
		k: [
			6,
			25
		],
		o: 2
	},
	pound: {
		a: "Banknote with Pound Sign",
		b: "1F4B7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"british",
			"sterling",
			"money",
			"sales",
			"bills",
			"uk",
			"england",
			"currency"
		],
		k: [
			26,
			13
		],
		o: 2
	},
	money_with_wings: {
		a: "Money with Wings",
		b: "1F4B8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dollar",
			"bills",
			"payment",
			"sale"
		],
		k: [
			26,
			14
		],
		o: 2
	},
	"flag-jo": {
		a: "Jordan Flag",
		b: "1F1EF-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			35
		],
		o: 2
	},
	fallen_leaf: {
		a: "Fallen Leaf",
		b: "1F342",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant",
			"vegetable",
			"leaves"
		],
		k: [
			6,
			26
		],
		o: 2
	},
	factory_worker: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F3ED",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f3ed.png",
				sheet_x: 45,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F3ED",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f3ed.png",
				sheet_x: 45,
				sheet_y: 55,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F3ED",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f3ed.png",
				sheet_x: 45,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F3ED",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f3ed.png",
				sheet_x: 46,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F3ED",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f3ed.png",
				sheet_x: 46,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Factory Worker",
		b: "1F9D1-200D-1F3ED",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			53
		],
		o: 12
	},
	broken_heart: {
		a: "Broken Heart",
		b: "1F494",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sad",
			"sorry",
			"break",
			"heart",
			"heartbreak"
		],
		k: [
			25,
			30
		],
		l: [
			"</3"
		],
		m: "</3",
		o: 2
	},
	grey_exclamation: {
		a: "White Exclamation Mark Ornament",
		b: "2755",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"surprise",
			"punctuation",
			"gray",
			"wow",
			"warning"
		],
		k: [
			55,
			25
		],
		o: 2
	},
	mountain_cableway: {
		a: "Mountain Cableway",
		b: "1F6A0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"ski"
		],
		k: [
			34,
			31
		],
		o: 2
	},
	exclamation: {
		a: "Heavy Exclamation Mark Symbol",
		b: "2757",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"heavy_exclamation_mark",
			"danger",
			"surprise",
			"punctuation",
			"wow",
			"warning"
		],
		k: [
			55,
			26
		],
		n: [
			"heavy_exclamation_mark"
		],
		o: 2
	},
	leaves: {
		a: "Leaf Fluttering in Wind",
		b: "1F343",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"plant",
			"tree",
			"vegetable",
			"grass",
			"lawn",
			"spring"
		],
		k: [
			6,
			27
		],
		o: 2
	},
	heart: {
		a: "Heavy Black Heart",
		b: "2764-FE0F",
		c: "2764",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"valentines"
		],
		k: [
			55,
			28
		],
		l: [
			"<3"
		],
		m: "<3",
		o: 2
	},
	jp: {
		a: "Japan Flag",
		b: "1F1EF-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			2,
			36
		],
		n: [
			"flag-jp"
		],
		o: 2
	},
	"male-factory-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3ed.png",
				sheet_x: 15,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3ed.png",
				sheet_x: 15,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3ed.png",
				sheet_x: 15,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3ed.png",
				sheet_x: 15,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3ed.png",
				sheet_x: 15,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Factory Worker",
		b: "1F468-200D-1F3ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			17
		],
		o: 4
	},
	credit_card: {
		a: "Credit Card",
		b: "1F4B3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"dollar",
			"bill",
			"payment",
			"shopping"
		],
		k: [
			26,
			9
		],
		o: 2
	},
	aerial_tramway: {
		a: "Aerial Tramway",
		b: "1F6A1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"transportation",
			"vehicle",
			"ski"
		],
		k: [
			34,
			32
		],
		o: 2
	},
	"female-factory-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3ed.png",
				sheet_x: 18,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3ed.png",
				sheet_x: 18,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3ed.png",
				sheet_x: 18,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3ed.png",
				sheet_x: 18,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3ed.png",
				sheet_x: 18,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Factory Worker",
		b: "1F469-200D-1F3ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			7
		],
		o: 4
	},
	receipt: {
		a: "Receipt",
		b: "1F9FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			49
		],
		o: 11
	},
	wavy_dash: {
		a: "Wavy Dash",
		b: "3030-FE0F",
		c: "3030",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"draw",
			"line",
			"moustache",
			"mustache",
			"squiggle",
			"scribble"
		],
		k: [
			55,
			44
		],
		o: 2
	},
	"flag-ke": {
		a: "Kenya Flag",
		b: "1F1F0-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			37
		],
		o: 2
	},
	satellite: {
		a: "Satellite",
		b: "1F6F0-FE0F",
		c: "1F6F0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"communication",
			"future",
			"radio",
			"space"
		],
		k: [
			36,
			51
		],
		o: 2
	},
	orange_heart: {
		a: "Orange Heart",
		b: "1F9E1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			20
		],
		o: 5
	},
	yellow_heart: {
		a: "Yellow Heart",
		b: "1F49B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			37
		],
		m: "<3",
		o: 2
	},
	copyright: {
		a: "Copyright Sign",
		b: "00A9-FE0F",
		c: "00A9",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"ip",
			"license",
			"circle",
			"law",
			"legal"
		],
		k: [
			0,
			12
		],
		o: 2
	},
	rocket: {
		a: "Rocket",
		b: "1F680",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"launch",
			"ship",
			"staffmode",
			"NASA",
			"outer space",
			"outer_space",
			"fly"
		],
		k: [
			33,
			56
		],
		o: 2
	},
	chart: {
		a: "Chart with Upwards Trend and Yen Sign",
		b: "1F4B9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"green-square",
			"graph",
			"presentation",
			"stats"
		],
		k: [
			26,
			15
		],
		o: 2
	},
	"flag-kg": {
		a: "Kyrgyzstan Flag",
		b: "1F1F0-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			38
		],
		o: 2
	},
	office_worker: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F4BC",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f4bc.png",
				sheet_x: 46,
				sheet_y: 9,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F4BC",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f4bc.png",
				sheet_x: 46,
				sheet_y: 10,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F4BC",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f4bc.png",
				sheet_x: 46,
				sheet_y: 11,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F4BC",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f4bc.png",
				sheet_x: 46,
				sheet_y: 12,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F4BC",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f4bc.png",
				sheet_x: 46,
				sheet_y: 13,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Office Worker",
		b: "1F9D1-200D-1F4BC",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			8
		],
		o: 12
	},
	currency_exchange: {
		a: "Currency Exchange",
		b: "1F4B1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"dollar",
			"travel"
		],
		k: [
			26,
			7
		],
		o: 2
	},
	registered: {
		a: "Registered Sign",
		b: "00AE-FE0F",
		c: "00AE",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"alphabet",
			"circle"
		],
		k: [
			0,
			13
		],
		o: 2
	},
	green_heart: {
		a: "Green Heart",
		b: "1F49A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			36
		],
		m: "<3",
		o: 2
	},
	flying_saucer: {
		a: "Flying Saucer",
		b: "1F6F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			0
		],
		o: 5
	},
	"flag-kh": {
		a: "Cambodia Flag",
		b: "1F1F0-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			39
		],
		o: 2
	},
	"male-office-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f4bc.png",
				sheet_x: 15,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f4bc.png",
				sheet_x: 15,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f4bc.png",
				sheet_x: 15,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f4bc.png",
				sheet_x: 15,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f4bc.png",
				sheet_x: 15,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Office Worker",
		b: "1F468-200D-1F4BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			44
		],
		o: 4
	},
	tm: {
		a: "Trade Mark Sign",
		b: "2122-FE0F",
		c: "2122",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"trademark",
			"brand",
			"law",
			"legal"
		],
		k: [
			52,
			12
		],
		o: 2
	},
	bellhop_bell: {
		a: "Bellhop Bell",
		b: "1F6CE-FE0F",
		c: "1F6CE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"service"
		],
		k: [
			36,
			36
		],
		o: 2
	},
	blue_heart: {
		a: "Blue Heart",
		b: "1F499",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			35
		],
		m: "<3",
		o: 2
	},
	"flag-ki": {
		a: "Kiribati Flag",
		b: "1F1F0-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			40
		],
		o: 2
	},
	heavy_dollar_sign: {
		a: "Heavy Dollar Sign",
		b: "1F4B2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"money",
			"sales",
			"payment",
			"currency",
			"buck"
		],
		k: [
			26,
			8
		],
		o: 2
	},
	"female-office-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f4bc.png",
				sheet_x: 18,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f4bc.png",
				sheet_x: 18,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f4bc.png",
				sheet_x: 18,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f4bc.png",
				sheet_x: 18,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f4bc.png",
				sheet_x: 18,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Office Worker",
		b: "1F469-200D-1F4BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			29
		],
		o: 4
	},
	purple_heart: {
		a: "Purple Heart",
		b: "1F49C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			38
		],
		m: "<3",
		o: 2
	},
	scientist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F52C",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f52c.png",
				sheet_x: 46,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F52C",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f52c.png",
				sheet_x: 46,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F52C",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f52c.png",
				sheet_x: 46,
				sheet_y: 23,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F52C",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f52c.png",
				sheet_x: 46,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F52C",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f52c.png",
				sheet_x: 46,
				sheet_y: 25,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Scientist",
		b: "1F9D1-200D-1F52C",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			20
		],
		o: 12
	},
	luggage: {
		a: "Luggage",
		b: "1F9F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			38
		],
		o: 11
	},
	hash: {
		a: "Hash Key",
		b: "0023-FE0F-20E3",
		c: "0023-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"symbol",
			"blue-square",
			"twitter"
		],
		k: [
			0,
			0
		],
		o: 0
	},
	"flag-km": {
		a: "Comoros Flag",
		b: "1F1F0-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			41
		],
		o: 2
	},
	email: {
		a: "Envelope",
		b: "2709-FE0F",
		c: "2709",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"letter",
			"postal",
			"inbox",
			"communication"
		],
		k: [
			54,
			42
		],
		n: [
			"envelope"
		],
		o: 2
	},
	"e-mail": {
		a: "E-Mail Symbol",
		b: "1F4E7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"communication",
			"inbox"
		],
		k: [
			27,
			4
		],
		o: 2
	},
	keycap_star: {
		a: "Keycap Star",
		b: "002A-FE0F-20E3",
		c: "002A-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			0,
			1
		],
		o: 0
	},
	"flag-kn": {
		a: "St. Kitts & Nevis Flag",
		b: "1F1F0-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			42
		],
		o: 2
	},
	hourglass: {
		a: "Hourglass",
		b: "231B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"clock",
			"oldschool",
			"limit",
			"exam",
			"quiz",
			"test"
		],
		k: [
			52,
			23
		],
		o: 2
	},
	brown_heart: {
		a: "Brown Heart",
		b: "1F90E",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			16
		],
		o: 12
	},
	"male-scientist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f52c.png",
				sheet_x: 16,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f52c.png",
				sheet_x: 16,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f52c.png",
				sheet_x: 16,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f52c.png",
				sheet_x: 16,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f52c.png",
				sheet_x: 16,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Scientist",
		b: "1F468-200D-1F52C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			56
		],
		o: 4
	},
	hourglass_flowing_sand: {
		a: "Hourglass with Flowing Sand",
		b: "23F3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"oldschool",
			"time",
			"countdown"
		],
		k: [
			52,
			36
		],
		o: 2
	},
	black_heart: {
		a: "Black Heart",
		b: "1F5A4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"evil"
		],
		k: [
			30,
			9
		],
		o: 4
	},
	zero: {
		a: "Keycap 0",
		b: "0030-FE0F-20E3",
		c: "0030-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"0",
			"numbers",
			"blue-square",
			"null"
		],
		k: [
			0,
			2
		],
		o: 0
	},
	incoming_envelope: {
		a: "Incoming Envelope",
		b: "1F4E8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"inbox"
		],
		k: [
			27,
			5
		],
		o: 2
	},
	"flag-kp": {
		a: "North Korea Flag",
		b: "1F1F0-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			43
		],
		o: 2
	},
	"female-scientist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f52c.png",
				sheet_x: 18,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f52c.png",
				sheet_x: 18,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f52c.png",
				sheet_x: 18,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f52c.png",
				sheet_x: 18,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f52c.png",
				sheet_x: 18,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Scientist",
		b: "1F469-200D-1F52C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			41
		],
		o: 4
	},
	watch: {
		a: "Watch",
		b: "231A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"accessories"
		],
		k: [
			52,
			22
		],
		o: 2
	},
	white_heart: {
		a: "White Heart",
		b: "1F90D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			15
		],
		o: 12
	},
	one: {
		a: "Keycap 1",
		b: "0031-FE0F-20E3",
		c: "0031-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"blue-square",
			"numbers",
			"1"
		],
		k: [
			0,
			3
		],
		o: 0
	},
	kr: {
		a: "South Korea Flag",
		b: "1F1F0-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"south",
			"korea",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			2,
			44
		],
		n: [
			"flag-kr"
		],
		o: 2
	},
	envelope_with_arrow: {
		a: "Envelope with Downwards Arrow Above",
		b: "1F4E9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"communication"
		],
		k: [
			27,
			6
		],
		o: 2
	},
	technologist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F4BB",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f4bb.png",
				sheet_x: 46,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F4BB",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f4bb.png",
				sheet_x: 46,
				sheet_y: 4,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F4BB",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f4bb.png",
				sheet_x: 46,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F4BB",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f4bb.png",
				sheet_x: 46,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F4BB",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f4bb.png",
				sheet_x: 46,
				sheet_y: 7,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Technologist",
		b: "1F9D1-200D-1F4BB",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			2
		],
		o: 12
	},
	outbox_tray: {
		a: "Outbox Tray",
		b: "1F4E4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"inbox",
			"email"
		],
		k: [
			27,
			1
		],
		o: 2
	},
	"male-technologist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f4bb.png",
				sheet_x: 15,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f4bb.png",
				sheet_x: 15,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f4bb.png",
				sheet_x: 15,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f4bb.png",
				sheet_x: 15,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f4bb.png",
				sheet_x: 15,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Technologist",
		b: "1F468-200D-1F4BB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			38
		],
		o: 4
	},
	alarm_clock: {
		a: "Alarm Clock",
		b: "23F0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"wake"
		],
		k: [
			52,
			33
		],
		o: 2
	},
	"flag-kw": {
		a: "Kuwait Flag",
		b: "1F1F0-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			45
		],
		o: 2
	},
	two: {
		a: "Keycap 2",
		b: "0032-FE0F-20E3",
		c: "0032-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"numbers",
			"2",
			"prime",
			"blue-square"
		],
		k: [
			0,
			4
		],
		o: 0
	},
	anger: {
		a: "Anger Symbol",
		b: "1F4A2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"angry",
			"mad"
		],
		k: [
			25,
			44
		],
		o: 2
	},
	inbox_tray: {
		a: "Inbox Tray",
		b: "1F4E5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"documents"
		],
		k: [
			27,
			2
		],
		o: 2
	},
	three: {
		a: "Keycap 3",
		b: "0033-FE0F-20E3",
		c: "0033-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"3",
			"numbers",
			"prime",
			"blue-square"
		],
		k: [
			0,
			5
		],
		o: 0
	},
	"flag-ky": {
		a: "Cayman Islands Flag",
		b: "1F1F0-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			46
		],
		o: 2
	},
	stopwatch: {
		a: "Stopwatch",
		b: "23F1-FE0F",
		c: "23F1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"deadline"
		],
		k: [
			52,
			34
		],
		o: 2
	},
	"female-technologist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f4bb.png",
				sheet_x: 18,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f4bb.png",
				sheet_x: 18,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f4bb.png",
				sheet_x: 18,
				sheet_y: 26,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f4bb.png",
				sheet_x: 18,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f4bb.png",
				sheet_x: 18,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Technologist",
		b: "1F469-200D-1F4BB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			23
		],
		o: 4
	},
	boom: {
		a: "Collision Symbol",
		b: "1F4A5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bomb",
			"explode",
			"explosion",
			"collision",
			"blown"
		],
		k: [
			25,
			47
		],
		n: [
			"collision"
		],
		o: 2
	},
	"flag-kz": {
		a: "Kazakhstan Flag",
		b: "1F1F0-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			47
		],
		o: 2
	},
	four: {
		a: "Keycap 4",
		b: "0034-FE0F-20E3",
		c: "0034-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"4",
			"numbers",
			"blue-square"
		],
		k: [
			0,
			6
		],
		o: 0
	},
	timer_clock: {
		a: "Timer Clock",
		b: "23F2-FE0F",
		c: "23F2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"alarm"
		],
		k: [
			52,
			35
		],
		o: 2
	},
	singer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F3A4",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f3a4.png",
				sheet_x: 45,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F3A4",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f3a4.png",
				sheet_x: 45,
				sheet_y: 37,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F3A4",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f3a4.png",
				sheet_x: 45,
				sheet_y: 38,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F3A4",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f3a4.png",
				sheet_x: 45,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F3A4",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f3a4.png",
				sheet_x: 45,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Singer",
		b: "1F9D1-200D-1F3A4",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			35
		],
		o: 12
	},
	"package": {
		a: "Package",
		b: "1F4E6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"mail",
			"gift",
			"cardboard",
			"box",
			"moving"
		],
		k: [
			27,
			3
		],
		o: 2
	},
	mailbox: {
		a: "Closed Mailbox with Raised Flag",
		b: "1F4EB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"inbox",
			"communication"
		],
		k: [
			27,
			8
		],
		o: 2
	},
	"flag-la": {
		a: "Laos Flag",
		b: "1F1F1-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			48
		],
		o: 2
	},
	dizzy: {
		a: "Dizzy Symbol",
		b: "1F4AB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"star",
			"sparkle",
			"shoot",
			"magic"
		],
		k: [
			26,
			1
		],
		o: 2
	},
	five: {
		a: "Keycap 5",
		b: "0035-FE0F-20E3",
		c: "0035-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"5",
			"numbers",
			"blue-square",
			"prime"
		],
		k: [
			0,
			7
		],
		o: 0
	},
	"male-singer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3a4.png",
				sheet_x: 15,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3a4.png",
				sheet_x: 15,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3a4.png",
				sheet_x: 15,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3a4.png",
				sheet_x: 15,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3a4.png",
				sheet_x: 15,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Singer",
		b: "1F468-200D-1F3A4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			14,
			56
		],
		o: 4
	},
	mantelpiece_clock: {
		a: "Mantelpiece Clock",
		b: "1F570-FE0F",
		c: "1F570",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time"
		],
		k: [
			29,
			7
		],
		o: 2
	},
	"female-singer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3a4.png",
				sheet_x: 17,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3a4.png",
				sheet_x: 17,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3a4.png",
				sheet_x: 17,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3a4.png",
				sheet_x: 17,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3a4.png",
				sheet_x: 17,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Singer",
		b: "1F469-200D-1F3A4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			46
		],
		o: 4
	},
	"flag-lb": {
		a: "Lebanon Flag",
		b: "1F1F1-1F1E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			49
		],
		o: 2
	},
	six: {
		a: "Keycap 6",
		b: "0036-FE0F-20E3",
		c: "0036-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"6",
			"numbers",
			"blue-square"
		],
		k: [
			0,
			8
		],
		o: 0
	},
	mailbox_closed: {
		a: "Closed Mailbox with Lowered Flag",
		b: "1F4EA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"communication",
			"inbox"
		],
		k: [
			27,
			7
		],
		o: 2
	},
	sweat_drops: {
		a: "Splashing Sweat Symbol",
		b: "1F4A6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"water",
			"drip",
			"oops"
		],
		k: [
			25,
			48
		],
		o: 2
	},
	clock12: {
		a: "Clock Face Twelve Oclock",
		b: "1F55B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"noon",
			"midnight",
			"midday",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			50
		],
		o: 2
	},
	seven: {
		a: "Keycap 7",
		b: "0037-FE0F-20E3",
		c: "0037-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"7",
			"numbers",
			"blue-square",
			"prime"
		],
		k: [
			0,
			9
		],
		o: 0
	},
	mailbox_with_mail: {
		a: "Open Mailbox with Raised Flag",
		b: "1F4EC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"inbox",
			"communication"
		],
		k: [
			27,
			9
		],
		o: 2
	},
	clock1230: {
		a: "Clock Face Twelve-Thirty",
		b: "1F567",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			5
		],
		o: 2
	},
	dash: {
		a: "Dash Symbol",
		b: "1F4A8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"wind",
			"air",
			"fast",
			"shoo",
			"fart",
			"smoke",
			"puff"
		],
		k: [
			25,
			50
		],
		o: 2
	},
	artist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F3A8",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f3a8.png",
				sheet_x: 45,
				sheet_y: 42,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F3A8",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f3a8.png",
				sheet_x: 45,
				sheet_y: 43,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F3A8",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f3a8.png",
				sheet_x: 45,
				sheet_y: 44,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F3A8",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f3a8.png",
				sheet_x: 45,
				sheet_y: 45,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F3A8",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f3a8.png",
				sheet_x: 45,
				sheet_y: 46,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Artist",
		b: "1F9D1-200D-1F3A8",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			45,
			41
		],
		o: 12
	},
	"flag-lc": {
		a: "St. Lucia Flag",
		b: "1F1F1-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			50
		],
		o: 2
	},
	hole: {
		a: "Hole",
		b: "1F573-FE0F",
		c: "1F573",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"embarrassing"
		],
		k: [
			29,
			8
		],
		o: 2
	},
	"male-artist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3a8.png",
				sheet_x: 15,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3a8.png",
				sheet_x: 15,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3a8.png",
				sheet_x: 15,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3a8.png",
				sheet_x: 15,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3a8.png",
				sheet_x: 15,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Artist",
		b: "1F468-200D-1F3A8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			5
		],
		o: 4
	},
	clock1: {
		a: "Clock Face One Oclock",
		b: "1F550",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			39
		],
		o: 2
	},
	eight: {
		a: "Keycap 8",
		b: "0038-FE0F-20E3",
		c: "0038-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"8",
			"blue-square",
			"numbers"
		],
		k: [
			0,
			10
		],
		o: 0
	},
	mailbox_with_no_mail: {
		a: "Open Mailbox with Lowered Flag",
		b: "1F4ED",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"inbox"
		],
		k: [
			27,
			10
		],
		o: 2
	},
	"flag-li": {
		a: "Liechtenstein Flag",
		b: "1F1F1-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			51
		],
		o: 2
	},
	bomb: {
		a: "Bomb",
		b: "1F4A3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"boom",
			"explode",
			"explosion",
			"terrorism"
		],
		k: [
			25,
			45
		],
		o: 2
	},
	nine: {
		a: "Keycap 9",
		b: "0039-FE0F-20E3",
		c: "0039-20E3",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"blue-square",
			"numbers",
			"9"
		],
		k: [
			0,
			11
		],
		o: 0
	},
	postbox: {
		a: "Postbox",
		b: "1F4EE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"email",
			"letter",
			"envelope"
		],
		k: [
			27,
			11
		],
		o: 2
	},
	"female-artist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3a8.png",
				sheet_x: 17,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3a8.png",
				sheet_x: 17,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3a8.png",
				sheet_x: 17,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3a8.png",
				sheet_x: 17,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Artist",
		b: "1F469-200D-1F3A8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			52
		],
		o: 4
	},
	clock130: {
		a: "Clock Face One-Thirty",
		b: "1F55C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			51
		],
		o: 2
	},
	"flag-lk": {
		a: "Sri Lanka Flag",
		b: "1F1F1-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			52
		],
		o: 2
	},
	ballot_box_with_ballot: {
		a: "Ballot Box with Ballot",
		b: "1F5F3-FE0F",
		c: "1F5F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			28
		],
		o: 2
	},
	pilot: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-2708-FE0F",
				non_qualified: "1F9D1-1F3FB-200D-2708",
				image: "1f9d1-1f3fb-200d-2708-fe0f.png",
				sheet_x: 48,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-2708-FE0F",
				non_qualified: "1F9D1-1F3FC-200D-2708",
				image: "1f9d1-1f3fc-200d-2708-fe0f.png",
				sheet_x: 48,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-2708-FE0F",
				non_qualified: "1F9D1-1F3FD-200D-2708",
				image: "1f9d1-1f3fd-200d-2708-fe0f.png",
				sheet_x: 48,
				sheet_y: 7,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-2708-FE0F",
				non_qualified: "1F9D1-1F3FE-200D-2708",
				image: "1f9d1-1f3fe-200d-2708-fe0f.png",
				sheet_x: 48,
				sheet_y: 8,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-2708-FE0F",
				non_qualified: "1F9D1-1F3FF-200D-2708",
				image: "1f9d1-1f3ff-200d-2708-fe0f.png",
				sheet_x: 48,
				sheet_y: 9,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Pilot",
		b: "1F9D1-200D-2708-FE0F",
		c: "1F9D1-200D-2708",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			48,
			4
		],
		o: 12
	},
	keycap_ten: {
		a: "Keycap Ten",
		b: "1F51F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"numbers",
			"10",
			"blue-square"
		],
		k: [
			28,
			2
		],
		o: 2
	},
	clock2: {
		a: "Clock Face Two Oclock",
		b: "1F551",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			40
		],
		o: 2
	},
	"flag-lr": {
		a: "Liberia Flag",
		b: "1F1F1-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			53
		],
		o: 2
	},
	speech_balloon: {
		a: "Speech Balloon",
		b: "1F4AC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bubble",
			"words",
			"message",
			"talk",
			"chatting"
		],
		k: [
			26,
			2
		],
		o: 2
	},
	"eye-in-speech-bubble": {
		a: "Eye in Speech Bubble",
		b: "1F441-FE0F-200D-1F5E8-FE0F",
		d: true,
		e: true,
		f: false,
		h: false,
		k: [
			12,
			37
		],
		o: 2
	},
	"flag-ls": {
		a: "Lesotho Flag",
		b: "1F1F1-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			54
		],
		o: 2
	},
	clock230: {
		a: "Clock Face Two-Thirty",
		b: "1F55D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			52
		],
		o: 2
	},
	"male-pilot": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2708-FE0F",
				non_qualified: "1F468-1F3FB-200D-2708",
				image: "1f468-1f3fb-200d-2708-fe0f.png",
				sheet_x: 17,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2708-FE0F",
				non_qualified: "1F468-1F3FC-200D-2708",
				image: "1f468-1f3fc-200d-2708-fe0f.png",
				sheet_x: 17,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2708-FE0F",
				non_qualified: "1F468-1F3FD-200D-2708",
				image: "1f468-1f3fd-200d-2708-fe0f.png",
				sheet_x: 17,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2708-FE0F",
				non_qualified: "1F468-1F3FE-200D-2708",
				image: "1f468-1f3fe-200d-2708-fe0f.png",
				sheet_x: 17,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2708-FE0F",
				non_qualified: "1F468-1F3FF-200D-2708",
				image: "1f468-1f3ff-200d-2708-fe0f.png",
				sheet_x: 17,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Pilot",
		b: "1F468-200D-2708-FE0F",
		c: "1F468-200D-2708",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			14
		],
		o: 4
	},
	capital_abcd: {
		a: "Input Symbol for Latin Capital Letters",
		b: "1F520",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"alphabet",
			"words",
			"blue-square"
		],
		k: [
			28,
			3
		],
		o: 2
	},
	pencil2: {
		a: "Pencil",
		b: "270F-FE0F",
		c: "270F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"write",
			"paper",
			"writing",
			"school",
			"study"
		],
		k: [
			55,
			10
		],
		o: 2
	},
	"female-pilot": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2708-FE0F",
				non_qualified: "1F469-1F3FB-200D-2708",
				image: "1f469-1f3fb-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2708-FE0F",
				non_qualified: "1F469-1F3FC-200D-2708",
				image: "1f469-1f3fc-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2708-FE0F",
				non_qualified: "1F469-1F3FD-200D-2708",
				image: "1f469-1f3fd-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2708-FE0F",
				non_qualified: "1F469-1F3FE-200D-2708",
				image: "1f469-1f3fe-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2708-FE0F",
				non_qualified: "1F469-1F3FF-200D-2708",
				image: "1f469-1f3ff-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Pilot",
		b: "1F469-200D-2708-FE0F",
		c: "1F469-200D-2708",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			56
		],
		o: 4
	},
	black_nib: {
		a: "Black Nib",
		b: "2712-FE0F",
		c: "2712",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"pen",
			"stationery",
			"writing",
			"write"
		],
		k: [
			55,
			11
		],
		o: 2
	},
	left_speech_bubble: {
		a: "Left Speech Bubble",
		b: "1F5E8-FE0F",
		c: "1F5E8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"words",
			"message",
			"talk",
			"chatting"
		],
		k: [
			30,
			26
		],
		o: 2
	},
	clock3: {
		a: "Clock Face Three Oclock",
		b: "1F552",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			41
		],
		o: 2
	},
	abcd: {
		a: "Input Symbol for Latin Small Letters",
		b: "1F521",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"alphabet"
		],
		k: [
			28,
			4
		],
		o: 2
	},
	"flag-lt": {
		a: "Lithuania Flag",
		b: "1F1F1-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			55
		],
		o: 2
	},
	clock330: {
		a: "Clock Face Three-Thirty",
		b: "1F55E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			53
		],
		o: 2
	},
	astronaut: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F680",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f680.png",
				sheet_x: 46,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F680",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f680.png",
				sheet_x: 46,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F680",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f680.png",
				sheet_x: 46,
				sheet_y: 29,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F680",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f680.png",
				sheet_x: 46,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F680",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f680.png",
				sheet_x: 46,
				sheet_y: 31,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Astronaut",
		b: "1F9D1-200D-1F680",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			26
		],
		o: 12
	},
	"flag-lu": {
		a: "Luxembourg Flag",
		b: "1F1F1-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			2,
			56
		],
		o: 2
	},
	right_anger_bubble: {
		a: "Right Anger Bubble",
		b: "1F5EF-FE0F",
		c: "1F5EF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"caption",
			"speech",
			"thinking",
			"mad"
		],
		k: [
			30,
			27
		],
		o: 2
	},
	lower_left_fountain_pen: {
		a: "Lower Left Fountain Pen",
		b: "1F58B-FE0F",
		c: "1F58B",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			45
		],
		o: 2
	},
	"male-astronaut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f680.png",
				sheet_x: 16,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f680.png",
				sheet_x: 16,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f680.png",
				sheet_x: 16,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f680.png",
				sheet_x: 16,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f680.png",
				sheet_x: 16,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Astronaut",
		b: "1F468-200D-1F680",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			5
		],
		o: 4
	},
	thought_balloon: {
		a: "Thought Balloon",
		b: "1F4AD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bubble",
			"cloud",
			"speech",
			"thinking",
			"dream"
		],
		k: [
			26,
			3
		],
		o: 2
	},
	symbols: {
		a: "Input Symbol for Symbols",
		b: "1F523",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"music",
			"note",
			"ampersand",
			"percent",
			"glyphs",
			"characters"
		],
		k: [
			28,
			6
		],
		o: 2
	},
	clock4: {
		a: "Clock Face Four Oclock",
		b: "1F553",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			42
		],
		o: 2
	},
	"flag-lv": {
		a: "Latvia Flag",
		b: "1F1F1-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			0
		],
		o: 2
	},
	lower_left_ballpoint_pen: {
		a: "Lower Left Ballpoint Pen",
		b: "1F58A-FE0F",
		c: "1F58A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			44
		],
		o: 2
	},
	abc: {
		a: "Input Symbol for Latin Letters",
		b: "1F524",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"alphabet"
		],
		k: [
			28,
			7
		],
		o: 2
	},
	zzz: {
		a: "Sleeping Symbol",
		b: "1F4A4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sleepy",
			"tired",
			"dream"
		],
		k: [
			25,
			46
		],
		o: 2
	},
	lower_left_paintbrush: {
		a: "Lower Left Paintbrush",
		b: "1F58C-FE0F",
		c: "1F58C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			46
		],
		o: 2
	},
	"female-astronaut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f680.png",
				sheet_x: 18,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f680.png",
				sheet_x: 18,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f680.png",
				sheet_x: 18,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f680.png",
				sheet_x: 18,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f680.png",
				sheet_x: 18,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Astronaut",
		b: "1F469-200D-1F680",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			47
		],
		o: 4
	},
	"flag-ly": {
		a: "Libya Flag",
		b: "1F1F1-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			1
		],
		o: 2
	},
	clock430: {
		a: "Clock Face Four-Thirty",
		b: "1F55F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			54
		],
		o: 2
	},
	"flag-ma": {
		a: "Morocco Flag",
		b: "1F1F2-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			2
		],
		o: 2
	},
	a: {
		a: "Negative Squared Latin Capital Letter a",
		b: "1F170-FE0F",
		c: "1F170",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"red-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			16
		],
		o: 2
	},
	clock5: {
		a: "Clock Face Five Oclock",
		b: "1F554",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			43
		],
		o: 2
	},
	lower_left_crayon: {
		a: "Lower Left Crayon",
		b: "1F58D-FE0F",
		c: "1F58D",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			47
		],
		o: 2
	},
	firefighter: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F692",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f692.png",
				sheet_x: 46,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F692",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f692.png",
				sheet_x: 46,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F692",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f692.png",
				sheet_x: 46,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F692",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f692.png",
				sheet_x: 46,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F692",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f692.png",
				sheet_x: 46,
				sheet_y: 37,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Firefighter",
		b: "1F9D1-200D-1F692",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			46,
			32
		],
		o: 12
	},
	"male-firefighter": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f692.png",
				sheet_x: 16,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f692.png",
				sheet_x: 16,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f692.png",
				sheet_x: 16,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f692.png",
				sheet_x: 16,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f692.png",
				sheet_x: 16,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Firefighter",
		b: "1F468-200D-1F692",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			11
		],
		o: 4
	},
	memo: {
		a: "Memo",
		b: "1F4DD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"write",
			"documents",
			"stationery",
			"pencil",
			"paper",
			"writing",
			"legal",
			"exam",
			"quiz",
			"test",
			"study",
			"compose"
		],
		k: [
			26,
			51
		],
		n: [
			"pencil"
		],
		o: 2
	},
	ab: {
		a: "Negative Squared Ab",
		b: "1F18E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"red-square",
			"alphabet"
		],
		k: [
			0,
			20
		],
		o: 2
	},
	"flag-mc": {
		a: "Monaco Flag",
		b: "1F1F2-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			3
		],
		o: 2
	},
	clock530: {
		a: "Clock Face Five-Thirty",
		b: "1F560",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			55
		],
		o: 2
	},
	briefcase: {
		a: "Briefcase",
		b: "1F4BC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"business",
			"documents",
			"work",
			"law",
			"legal",
			"job",
			"career"
		],
		k: [
			26,
			18
		],
		o: 2
	},
	"female-firefighter": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f692.png",
				sheet_x: 18,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f692.png",
				sheet_x: 18,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f692.png",
				sheet_x: 18,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Firefighter",
		b: "1F469-200D-1F692",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			53
		],
		o: 4
	},
	clock6: {
		a: "Clock Face Six Oclock",
		b: "1F555",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule",
			"dawn",
			"dusk"
		],
		k: [
			28,
			44
		],
		o: 2
	},
	b: {
		a: "Negative Squared Latin Capital Letter B",
		b: "1F171-FE0F",
		c: "1F171",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"red-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			17
		],
		o: 2
	},
	"flag-md": {
		a: "Moldova Flag",
		b: "1F1F2-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			4
		],
		o: 2
	},
	clock630: {
		a: "Clock Face Six-Thirty",
		b: "1F561",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			56
		],
		o: 2
	},
	cl: {
		a: "Squared Cl",
		b: "1F191",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"alphabet",
			"words",
			"red-square"
		],
		k: [
			0,
			21
		],
		o: 2
	},
	"flag-me": {
		a: "Montenegro Flag",
		b: "1F1F2-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			5
		],
		o: 2
	},
	file_folder: {
		a: "File Folder",
		b: "1F4C1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"business",
			"office"
		],
		k: [
			26,
			23
		],
		o: 2
	},
	cop: {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB",
				non_qualified: null,
				image: "1f46e-1f3fb.png",
				sheet_x: 21,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F46E-1F3FC",
				non_qualified: null,
				image: "1f46e-1f3fc.png",
				sheet_x: 21,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F46E-1F3FD",
				non_qualified: null,
				image: "1f46e-1f3fd.png",
				sheet_x: 21,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F46E-1F3FE",
				non_qualified: null,
				image: "1f46e-1f3fe.png",
				sheet_x: 21,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F46E-1F3FF",
				non_qualified: null,
				image: "1f46e-1f3ff.png",
				sheet_x: 21,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F46E-200D-2642-FE0F",
		a: "Police Officer",
		b: "1F46E",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			21,
			49
		],
		o: 2
	},
	"male-police-officer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FB-200D-2642",
				image: "1f46e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F46E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FC-200D-2642",
				image: "1f46e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F46E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FD-200D-2642",
				image: "1f46e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F46E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FE-200D-2642",
				image: "1f46e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F46E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FF-200D-2642",
				image: "1f46e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F46E",
		a: "Male Police Officer",
		b: "1F46E-200D-2642-FE0F",
		c: "1F46E-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			21,
			43
		],
		o: 4
	},
	cool: {
		a: "Squared Cool",
		b: "1F192",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"words",
			"blue-square"
		],
		k: [
			0,
			22
		],
		o: 2
	},
	clock7: {
		a: "Clock Face Seven Oclock",
		b: "1F556",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			45
		],
		o: 2
	},
	"flag-mf": {
		a: "St. Martin Flag",
		b: "1F1F2-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			6
		],
		o: 2
	},
	open_file_folder: {
		a: "Open File Folder",
		b: "1F4C2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"load"
		],
		k: [
			26,
			24
		],
		o: 2
	},
	card_index_dividers: {
		a: "Card Index Dividers",
		b: "1F5C2-FE0F",
		c: "1F5C2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"organizing",
			"business",
			"stationery"
		],
		k: [
			30,
			15
		],
		o: 2
	},
	"flag-mg": {
		a: "Madagascar Flag",
		b: "1F1F2-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			7
		],
		o: 2
	},
	free: {
		a: "Squared Free",
		b: "1F193",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"words"
		],
		k: [
			0,
			23
		],
		o: 2
	},
	"female-police-officer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FB-200D-2640",
				image: "1f46e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F46E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FC-200D-2640",
				image: "1f46e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F46E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FD-200D-2640",
				image: "1f46e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F46E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FE-200D-2640",
				image: "1f46e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F46E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FF-200D-2640",
				image: "1f46e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Police Officer",
		b: "1F46E-200D-2640-FE0F",
		c: "1F46E-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			21,
			37
		],
		o: 4
	},
	clock730: {
		a: "Clock Face Seven-Thirty",
		b: "1F562",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			0
		],
		o: 2
	},
	date: {
		a: "Calendar",
		b: "1F4C5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"calendar",
			"schedule"
		],
		k: [
			26,
			27
		],
		o: 2
	},
	clock8: {
		a: "Clock Face Eight Oclock",
		b: "1F557",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			46
		],
		o: 2
	},
	information_source: {
		a: "Information Source",
		b: "2139-FE0F",
		c: "2139",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"alphabet",
			"letter"
		],
		k: [
			52,
			13
		],
		o: 2
	},
	sleuth_or_spy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB",
				non_qualified: null,
				image: "1f575-1f3fb.png",
				sheet_x: 29,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F575-1F3FC",
				non_qualified: null,
				image: "1f575-1f3fc.png",
				sheet_x: 29,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F575-1F3FD",
				non_qualified: null,
				image: "1f575-1f3fd.png",
				sheet_x: 29,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F575-1F3FE",
				non_qualified: null,
				image: "1f575-1f3fe.png",
				sheet_x: 29,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F575-1F3FF",
				non_qualified: null,
				image: "1f575-1f3ff.png",
				sheet_x: 29,
				sheet_y: 32,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
		a: "Sleuth or Spy",
		b: "1F575-FE0F",
		c: "1F575",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			29,
			27
		],
		o: 2
	},
	"flag-mh": {
		a: "Marshall Islands Flag",
		b: "1F1F2-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			8
		],
		o: 2
	},
	clock830: {
		a: "Clock Face Eight-Thirty",
		b: "1F563",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			1
		],
		o: 2
	},
	calendar: {
		a: "Tear-off Calendar",
		b: "1F4C6",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"schedule",
			"date",
			"planning"
		],
		k: [
			26,
			28
		],
		o: 2
	},
	"male-detective": {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB-200D-2642-FE0F",
				non_qualified: "1F575-1F3FB-200D-2642",
				image: "1f575-1f3fb-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F575-1F3FC-200D-2642-FE0F",
				non_qualified: "1F575-1F3FC-200D-2642",
				image: "1f575-1f3fc-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 23,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F575-1F3FD-200D-2642-FE0F",
				non_qualified: "1F575-1F3FD-200D-2642",
				image: "1f575-1f3fd-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F575-1F3FE-200D-2642-FE0F",
				non_qualified: "1F575-1F3FE-200D-2642",
				image: "1f575-1f3fe-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F575-1F3FF-200D-2642-FE0F",
				non_qualified: "1F575-1F3FF-200D-2642",
				image: "1f575-1f3ff-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 26,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F575-FE0F",
		a: "Male Detective",
		b: "1F575-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			29,
			21
		],
		o: 4
	},
	"flag-mk": {
		a: "North Macedonia Flag",
		b: "1F1F2-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			9
		],
		o: 2
	},
	id: {
		a: "Squared Id",
		b: "1F194",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"purple-square",
			"words"
		],
		k: [
			0,
			24
		],
		o: 2
	},
	spiral_note_pad: {
		a: "Spiral Note Pad",
		b: "1F5D2-FE0F",
		c: "1F5D2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			19
		],
		o: 2
	},
	"female-detective": {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB-200D-2640-FE0F",
				non_qualified: "1F575-1F3FB-200D-2640",
				image: "1f575-1f3fb-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F575-1F3FC-200D-2640-FE0F",
				non_qualified: "1F575-1F3FC-200D-2640",
				image: "1f575-1f3fc-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F575-1F3FD-200D-2640-FE0F",
				non_qualified: "1F575-1F3FD-200D-2640",
				image: "1f575-1f3fd-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F575-1F3FE-200D-2640-FE0F",
				non_qualified: "1F575-1F3FE-200D-2640",
				image: "1f575-1f3fe-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F575-1F3FF-200D-2640-FE0F",
				non_qualified: "1F575-1F3FF-200D-2640",
				image: "1f575-1f3ff-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Detective",
		b: "1F575-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			29,
			15
		],
		o: 4
	},
	clock9: {
		a: "Clock Face Nine Oclock",
		b: "1F558",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			47
		],
		o: 2
	},
	"flag-ml": {
		a: "Mali Flag",
		b: "1F1F2-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			10
		],
		o: 2
	},
	m: {
		a: "Circled Latin Capital Letter M",
		b: "24C2-FE0F",
		c: "24C2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"alphabet",
			"blue-circle",
			"letter"
		],
		k: [
			52,
			40
		],
		o: 2
	},
	"flag-mm": {
		a: "Myanmar (burma) Flag",
		b: "1F1F2-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			11
		],
		o: 2
	},
	clock930: {
		a: "Clock Face Nine-Thirty",
		b: "1F564",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			2
		],
		o: 2
	},
	guardsman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB",
				non_qualified: null,
				image: "1f482-1f3fb.png",
				sheet_x: 24,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F482-1F3FC",
				non_qualified: null,
				image: "1f482-1f3fc.png",
				sheet_x: 24,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F482-1F3FD",
				non_qualified: null,
				image: "1f482-1f3fd.png",
				sheet_x: 24,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F482-1F3FE",
				non_qualified: null,
				image: "1f482-1f3fe.png",
				sheet_x: 24,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F482-1F3FF",
				non_qualified: null,
				image: "1f482-1f3ff.png",
				sheet_x: 24,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F482-200D-2642-FE0F",
		a: "Guardsman",
		b: "1F482",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"uk",
			"gb",
			"british",
			"male",
			"guy",
			"royal"
		],
		k: [
			24,
			20
		],
		o: 2
	},
	"new": {
		a: "Squared New",
		b: "1F195",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"words",
			"start"
		],
		k: [
			0,
			25
		],
		o: 2
	},
	spiral_calendar_pad: {
		a: "Spiral Calendar Pad",
		b: "1F5D3-FE0F",
		c: "1F5D3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			20
		],
		o: 2
	},
	ng: {
		a: "Squared Ng",
		b: "1F196",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"words",
			"shape",
			"icon"
		],
		k: [
			0,
			26
		],
		o: 2
	},
	card_index: {
		a: "Card Index",
		b: "1F4C7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"business",
			"stationery"
		],
		k: [
			26,
			29
		],
		o: 2
	},
	clock10: {
		a: "Clock Face Ten Oclock",
		b: "1F559",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			48
		],
		o: 2
	},
	"flag-mn": {
		a: "Mongolia Flag",
		b: "1F1F2-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			12
		],
		o: 2
	},
	"male-guard": {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB-200D-2642-FE0F",
				non_qualified: "1F482-1F3FB-200D-2642",
				image: "1f482-1f3fb-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F482-1F3FC-200D-2642-FE0F",
				non_qualified: "1F482-1F3FC-200D-2642",
				image: "1f482-1f3fc-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F482-1F3FD-200D-2642-FE0F",
				non_qualified: "1F482-1F3FD-200D-2642",
				image: "1f482-1f3fd-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F482-1F3FE-200D-2642-FE0F",
				non_qualified: "1F482-1F3FE-200D-2642",
				image: "1f482-1f3fe-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F482-1F3FF-200D-2642-FE0F",
				non_qualified: "1F482-1F3FF-200D-2642",
				image: "1f482-1f3ff-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F482",
		a: "Male Guard",
		b: "1F482-200D-2642-FE0F",
		c: "1F482-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			24,
			14
		],
		o: 4
	},
	"flag-mo": {
		a: "Macao Sar China Flag",
		b: "1F1F2-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			13
		],
		o: 2
	},
	clock1030: {
		a: "Clock Face Ten-Thirty",
		b: "1F565",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			3
		],
		o: 2
	},
	chart_with_upwards_trend: {
		a: "Chart with Upwards Trend",
		b: "1F4C8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"recovery",
			"business",
			"economics",
			"money",
			"sales",
			"good",
			"success"
		],
		k: [
			26,
			30
		],
		o: 2
	},
	o2: {
		a: "Negative Squared Latin Capital Letter O",
		b: "1F17E-FE0F",
		c: "1F17E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"alphabet",
			"red-square",
			"letter"
		],
		k: [
			0,
			18
		],
		o: 2
	},
	"female-guard": {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB-200D-2640-FE0F",
				non_qualified: "1F482-1F3FB-200D-2640",
				image: "1f482-1f3fb-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F482-1F3FC-200D-2640-FE0F",
				non_qualified: "1F482-1F3FC-200D-2640",
				image: "1f482-1f3fc-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F482-1F3FD-200D-2640-FE0F",
				non_qualified: "1F482-1F3FD-200D-2640",
				image: "1f482-1f3fd-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F482-1F3FE-200D-2640-FE0F",
				non_qualified: "1F482-1F3FE-200D-2640",
				image: "1f482-1f3fe-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F482-1F3FF-200D-2640-FE0F",
				non_qualified: "1F482-1F3FF-200D-2640",
				image: "1f482-1f3ff-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Guard",
		b: "1F482-200D-2640-FE0F",
		c: "1F482-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			24,
			8
		],
		o: 4
	},
	chart_with_downwards_trend: {
		a: "Chart with Downwards Trend",
		b: "1F4C9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"recession",
			"business",
			"economics",
			"money",
			"sales",
			"bad",
			"failure"
		],
		k: [
			26,
			31
		],
		o: 2
	},
	"flag-mp": {
		a: "Northern Mariana Islands Flag",
		b: "1F1F2-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			14
		],
		o: 2
	},
	ok: {
		a: "Squared Ok",
		b: "1F197",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"good",
			"agree",
			"yes",
			"blue-square"
		],
		k: [
			0,
			27
		],
		o: 2
	},
	clock11: {
		a: "Clock Face Eleven Oclock",
		b: "1F55A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			49
		],
		o: 2
	},
	construction_worker: {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB",
				non_qualified: null,
				image: "1f477-1f3fb.png",
				sheet_x: 23,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F477-1F3FC",
				non_qualified: null,
				image: "1f477-1f3fc.png",
				sheet_x: 23,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F477-1F3FD",
				non_qualified: null,
				image: "1f477-1f3fd.png",
				sheet_x: 23,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F477-1F3FE",
				non_qualified: null,
				image: "1f477-1f3fe.png",
				sheet_x: 23,
				sheet_y: 26,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F477-1F3FF",
				non_qualified: null,
				image: "1f477-1f3ff.png",
				sheet_x: 23,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F477-200D-2642-FE0F",
		a: "Construction Worker",
		b: "1F477",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			23,
			22
		],
		o: 2
	},
	"male-construction-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB-200D-2642-FE0F",
				non_qualified: "1F477-1F3FB-200D-2642",
				image: "1f477-1f3fb-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F477-1F3FC-200D-2642-FE0F",
				non_qualified: "1F477-1F3FC-200D-2642",
				image: "1f477-1f3fc-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F477-1F3FD-200D-2642-FE0F",
				non_qualified: "1F477-1F3FD-200D-2642",
				image: "1f477-1f3fd-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F477-1F3FE-200D-2642-FE0F",
				non_qualified: "1F477-1F3FE-200D-2642",
				image: "1f477-1f3fe-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F477-1F3FF-200D-2642-FE0F",
				non_qualified: "1F477-1F3FF-200D-2642",
				image: "1f477-1f3ff-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F477",
		a: "Male Construction Worker",
		b: "1F477-200D-2642-FE0F",
		c: "1F477-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			23,
			16
		],
		o: 4
	},
	clock1130: {
		a: "Clock Face Eleven-Thirty",
		b: "1F566",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			29,
			4
		],
		o: 2
	},
	"flag-mq": {
		a: "Martinique Flag",
		b: "1F1F2-1F1F6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			15
		],
		o: 2
	},
	bar_chart: {
		a: "Bar Chart",
		b: "1F4CA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"graph",
			"presentation",
			"stats"
		],
		k: [
			26,
			32
		],
		o: 2
	},
	parking: {
		a: "Negative Squared Latin Capital Letter P",
		b: "1F17F-FE0F",
		c: "1F17F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cars",
			"blue-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			19
		],
		o: 2
	},
	new_moon: {
		a: "New Moon Symbol",
		b: "1F311",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			36
		],
		o: 2
	},
	"female-construction-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB-200D-2640-FE0F",
				non_qualified: "1F477-1F3FB-200D-2640",
				image: "1f477-1f3fb-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F477-1F3FC-200D-2640-FE0F",
				non_qualified: "1F477-1F3FC-200D-2640",
				image: "1f477-1f3fc-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F477-1F3FD-200D-2640-FE0F",
				non_qualified: "1F477-1F3FD-200D-2640",
				image: "1f477-1f3fd-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F477-1F3FE-200D-2640-FE0F",
				non_qualified: "1F477-1F3FE-200D-2640",
				image: "1f477-1f3fe-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F477-1F3FF-200D-2640-FE0F",
				non_qualified: "1F477-1F3FF-200D-2640",
				image: "1f477-1f3ff-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Construction Worker",
		b: "1F477-200D-2640-FE0F",
		c: "1F477-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			23,
			10
		],
		o: 4
	},
	sos: {
		a: "Squared Sos",
		b: "1F198",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"help",
			"red-square",
			"words",
			"emergency",
			"911"
		],
		k: [
			0,
			28
		],
		o: 2
	},
	clipboard: {
		a: "Clipboard",
		b: "1F4CB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"documents"
		],
		k: [
			26,
			33
		],
		o: 2
	},
	"flag-mr": {
		a: "Mauritania Flag",
		b: "1F1F2-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			16
		],
		o: 2
	},
	prince: {
		skin_variations: {
			"1F3FB": {
				unified: "1F934-1F3FB",
				non_qualified: null,
				image: "1f934-1f3fb.png",
				sheet_x: 39,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F934-1F3FC",
				non_qualified: null,
				image: "1f934-1f3fc.png",
				sheet_x: 39,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F934-1F3FD",
				non_qualified: null,
				image: "1f934-1f3fd.png",
				sheet_x: 39,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F934-1F3FE",
				non_qualified: null,
				image: "1f934-1f3fe.png",
				sheet_x: 39,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F934-1F3FF",
				non_qualified: null,
				image: "1f934-1f3ff.png",
				sheet_x: 39,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Prince",
		b: "1F934",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"boy",
			"man",
			"male",
			"crown",
			"royal",
			"king"
		],
		k: [
			39,
			17
		],
		o: 4
	},
	waxing_crescent_moon: {
		a: "Waxing Crescent Moon Symbol",
		b: "1F312",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			37
		],
		o: 2
	},
	"flag-ms": {
		a: "Montserrat Flag",
		b: "1F1F2-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			17
		],
		o: 2
	},
	pushpin: {
		a: "Pushpin",
		b: "1F4CC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"mark",
			"here"
		],
		k: [
			26,
			34
		],
		o: 2
	},
	up: {
		a: "Squared Up with Exclamation Mark",
		b: "1F199",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"above",
			"high"
		],
		k: [
			0,
			29
		],
		o: 2
	},
	"flag-mt": {
		a: "Malta Flag",
		b: "1F1F2-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			18
		],
		o: 2
	},
	princess: {
		skin_variations: {
			"1F3FB": {
				unified: "1F478-1F3FB",
				non_qualified: null,
				image: "1f478-1f3fb.png",
				sheet_x: 23,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F478-1F3FC",
				non_qualified: null,
				image: "1f478-1f3fc.png",
				sheet_x: 23,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F478-1F3FD",
				non_qualified: null,
				image: "1f478-1f3fd.png",
				sheet_x: 23,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F478-1F3FE",
				non_qualified: null,
				image: "1f478-1f3fe.png",
				sheet_x: 23,
				sheet_y: 32,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F478-1F3FF",
				non_qualified: null,
				image: "1f478-1f3ff.png",
				sheet_x: 23,
				sheet_y: 33,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Princess",
		b: "1F478",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"girl",
			"woman",
			"female",
			"blond",
			"crown",
			"royal",
			"queen"
		],
		k: [
			23,
			28
		],
		o: 2
	},
	round_pushpin: {
		a: "Round Pushpin",
		b: "1F4CD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"location",
			"map",
			"here"
		],
		k: [
			26,
			35
		],
		o: 2
	},
	first_quarter_moon: {
		a: "First Quarter Moon Symbol",
		b: "1F313",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			38
		],
		o: 2
	},
	vs: {
		a: "Squared Vs",
		b: "1F19A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"words",
			"orange-square"
		],
		k: [
			0,
			30
		],
		o: 2
	},
	"flag-mu": {
		a: "Mauritius Flag",
		b: "1F1F2-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			19
		],
		o: 2
	},
	koko: {
		a: "Squared Katakana Koko",
		b: "1F201",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"blue-square",
			"here",
			"katakana",
			"japanese",
			"destination"
		],
		k: [
			5,
			4
		],
		o: 2
	},
	man_with_turban: {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB",
				non_qualified: null,
				image: "1f473-1f3fb.png",
				sheet_x: 22,
				sheet_y: 44,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F473-1F3FC",
				non_qualified: null,
				image: "1f473-1f3fc.png",
				sheet_x: 22,
				sheet_y: 45,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F473-1F3FD",
				non_qualified: null,
				image: "1f473-1f3fd.png",
				sheet_x: 22,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F473-1F3FE",
				non_qualified: null,
				image: "1f473-1f3fe.png",
				sheet_x: 22,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F473-1F3FF",
				non_qualified: null,
				image: "1f473-1f3ff.png",
				sheet_x: 22,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F473-200D-2642-FE0F",
		a: "Man with Turban",
		b: "1F473",
		d: true,
		e: true,
		f: true,
		h: false,
		j: [
			"male",
			"indian",
			"hinduism",
			"arabs"
		],
		k: [
			22,
			43
		],
		o: 2
	},
	moon: {
		a: "Waxing Gibbous Moon Symbol",
		b: "1F314",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			39
		],
		n: [
			"waxing_gibbous_moon"
		],
		o: 2
	},
	paperclip: {
		a: "Paperclip",
		b: "1F4CE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"documents",
			"stationery"
		],
		k: [
			26,
			36
		],
		o: 2
	},
	linked_paperclips: {
		a: "Linked Paperclips",
		b: "1F587-FE0F",
		c: "1F587",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			43
		],
		o: 2
	},
	"man-wearing-turban": {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB-200D-2642-FE0F",
				non_qualified: "1F473-1F3FB-200D-2642",
				image: "1f473-1f3fb-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F473-1F3FC-200D-2642-FE0F",
				non_qualified: "1F473-1F3FC-200D-2642",
				image: "1f473-1f3fc-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F473-1F3FD-200D-2642-FE0F",
				non_qualified: "1F473-1F3FD-200D-2642",
				image: "1f473-1f3fd-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F473-1F3FE-200D-2642-FE0F",
				non_qualified: "1F473-1F3FE-200D-2642",
				image: "1f473-1f3fe-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F473-1F3FF-200D-2642-FE0F",
				non_qualified: "1F473-1F3FF-200D-2642",
				image: "1f473-1f3ff-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F473",
		a: "Man Wearing Turban",
		b: "1F473-200D-2642-FE0F",
		c: "1F473-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			22,
			37
		],
		o: 4
	},
	sa: {
		a: "Squared Katakana Sa",
		b: "1F202-FE0F",
		c: "1F202",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"blue-square",
			"katakana"
		],
		k: [
			5,
			5
		],
		o: 2
	},
	full_moon: {
		a: "Full Moon Symbol",
		b: "1F315",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"yellow",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			40
		],
		o: 2
	},
	"flag-mv": {
		a: "Maldives Flag",
		b: "1F1F2-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			20
		],
		o: 2
	},
	"flag-mw": {
		a: "Malawi Flag",
		b: "1F1F2-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			21
		],
		o: 2
	},
	waning_gibbous_moon: {
		a: "Waning Gibbous Moon Symbol",
		b: "1F316",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep",
			"waxing_gibbous_moon"
		],
		k: [
			5,
			41
		],
		o: 2
	},
	"woman-wearing-turban": {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB-200D-2640-FE0F",
				non_qualified: "1F473-1F3FB-200D-2640",
				image: "1f473-1f3fb-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F473-1F3FC-200D-2640-FE0F",
				non_qualified: "1F473-1F3FC-200D-2640",
				image: "1f473-1f3fc-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F473-1F3FD-200D-2640-FE0F",
				non_qualified: "1F473-1F3FD-200D-2640",
				image: "1f473-1f3fd-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F473-1F3FE-200D-2640-FE0F",
				non_qualified: "1F473-1F3FE-200D-2640",
				image: "1f473-1f3fe-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 35,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F473-1F3FF-200D-2640-FE0F",
				non_qualified: "1F473-1F3FF-200D-2640",
				image: "1f473-1f3ff-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Wearing Turban",
		b: "1F473-200D-2640-FE0F",
		c: "1F473-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			22,
			31
		],
		o: 4
	},
	u6708: {
		a: "Squared Cjk Unified Ideograph-6708",
		b: "1F237-FE0F",
		c: "1F237",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chinese",
			"month",
			"moon",
			"japanese",
			"orange-square",
			"kanji"
		],
		k: [
			5,
			13
		],
		o: 2
	},
	straight_ruler: {
		a: "Straight Ruler",
		b: "1F4CF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"calculate",
			"length",
			"math",
			"school",
			"drawing",
			"architect",
			"sketch"
		],
		k: [
			26,
			37
		],
		o: 2
	},
	u6709: {
		a: "Squared Cjk Unified Ideograph-6709",
		b: "1F236",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"orange-square",
			"chinese",
			"have",
			"kanji"
		],
		k: [
			5,
			12
		],
		o: 2
	},
	triangular_ruler: {
		a: "Triangular Ruler",
		b: "1F4D0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"math",
			"architect",
			"sketch"
		],
		k: [
			26,
			38
		],
		o: 2
	},
	man_with_gua_pi_mao: {
		skin_variations: {
			"1F3FB": {
				unified: "1F472-1F3FB",
				non_qualified: null,
				image: "1f472-1f3fb.png",
				sheet_x: 22,
				sheet_y: 26,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F472-1F3FC",
				non_qualified: null,
				image: "1f472-1f3fc.png",
				sheet_x: 22,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F472-1F3FD",
				non_qualified: null,
				image: "1f472-1f3fd.png",
				sheet_x: 22,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F472-1F3FE",
				non_qualified: null,
				image: "1f472-1f3fe.png",
				sheet_x: 22,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F472-1F3FF",
				non_qualified: null,
				image: "1f472-1f3ff.png",
				sheet_x: 22,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man with Gua Pi Mao",
		b: "1F472",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"male",
			"boy",
			"chinese"
		],
		k: [
			22,
			25
		],
		o: 2
	},
	"flag-mx": {
		a: "Mexico Flag",
		b: "1F1F2-1F1FD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			22
		],
		o: 2
	},
	last_quarter_moon: {
		a: "Last Quarter Moon Symbol",
		b: "1F317",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			42
		],
		o: 2
	},
	person_with_headscarf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D5-1F3FB",
				non_qualified: null,
				image: "1f9d5-1f3fb.png",
				sheet_x: 48,
				sheet_y: 35,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D5-1F3FC",
				non_qualified: null,
				image: "1f9d5-1f3fc.png",
				sheet_x: 48,
				sheet_y: 36,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D5-1F3FD",
				non_qualified: null,
				image: "1f9d5-1f3fd.png",
				sheet_x: 48,
				sheet_y: 37,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D5-1F3FE",
				non_qualified: null,
				image: "1f9d5-1f3fe.png",
				sheet_x: 48,
				sheet_y: 38,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D5-1F3FF",
				non_qualified: null,
				image: "1f9d5-1f3ff.png",
				sheet_x: 48,
				sheet_y: 39,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Person with Headscarf",
		b: "1F9D5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			34
		],
		o: 5
	},
	waning_crescent_moon: {
		a: "Waning Crescent Moon Symbol",
		b: "1F318",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			43
		],
		o: 2
	},
	u6307: {
		a: "Squared Cjk Unified Ideograph-6307",
		b: "1F22F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chinese",
			"point",
			"green-square",
			"kanji"
		],
		k: [
			5,
			7
		],
		o: 2
	},
	scissors: {
		a: "Black Scissors",
		b: "2702-FE0F",
		c: "2702",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stationery",
			"cut"
		],
		k: [
			54,
			39
		],
		o: 2
	},
	"flag-my": {
		a: "Malaysia Flag",
		b: "1F1F2-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			23
		],
		o: 2
	},
	ideograph_advantage: {
		a: "Circled Ideograph Advantage",
		b: "1F250",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chinese",
			"kanji",
			"obtain",
			"get",
			"circle"
		],
		k: [
			5,
			17
		],
		o: 2
	},
	man_in_tuxedo: {
		skin_variations: {
			"1F3FB": {
				unified: "1F935-1F3FB",
				non_qualified: null,
				image: "1f935-1f3fb.png",
				sheet_x: 39,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F935-1F3FC",
				non_qualified: null,
				image: "1f935-1f3fc.png",
				sheet_x: 39,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F935-1F3FD",
				non_qualified: null,
				image: "1f935-1f3fd.png",
				sheet_x: 39,
				sheet_y: 26,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F935-1F3FE",
				non_qualified: null,
				image: "1f935-1f3fe.png",
				sheet_x: 39,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F935-1F3FF",
				non_qualified: null,
				image: "1f935-1f3ff.png",
				sheet_x: 39,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man in Tuxedo",
		b: "1F935",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"couple",
			"marriage",
			"wedding",
			"groom"
		],
		k: [
			39,
			23
		],
		o: 4
	},
	"flag-mz": {
		a: "Mozambique Flag",
		b: "1F1F2-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			24
		],
		o: 2
	},
	card_file_box: {
		a: "Card File Box",
		b: "1F5C3-FE0F",
		c: "1F5C3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"business",
			"stationery"
		],
		k: [
			30,
			16
		],
		o: 2
	},
	crescent_moon: {
		a: "Crescent Moon",
		b: "1F319",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"night",
			"sleep",
			"sky",
			"evening",
			"magic"
		],
		k: [
			5,
			44
		],
		o: 2
	},
	"flag-na": {
		a: "Namibia Flag",
		b: "1F1F3-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			25
		],
		o: 2
	},
	bride_with_veil: {
		skin_variations: {
			"1F3FB": {
				unified: "1F470-1F3FB",
				non_qualified: null,
				image: "1f470-1f3fb.png",
				sheet_x: 22,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F470-1F3FC",
				non_qualified: null,
				image: "1f470-1f3fc.png",
				sheet_x: 22,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F470-1F3FD",
				non_qualified: null,
				image: "1f470-1f3fd.png",
				sheet_x: 22,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F470-1F3FE",
				non_qualified: null,
				image: "1f470-1f3fe.png",
				sheet_x: 22,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F470-1F3FF",
				non_qualified: null,
				image: "1f470-1f3ff.png",
				sheet_x: 22,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Bride with Veil",
		b: "1F470",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"couple",
			"marriage",
			"wedding",
			"woman",
			"bride"
		],
		k: [
			22,
			1
		],
		o: 2
	},
	new_moon_with_face: {
		a: "New Moon with Face",
		b: "1F31A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			45
		],
		o: 2
	},
	file_cabinet: {
		a: "File Cabinet",
		b: "1F5C4-FE0F",
		c: "1F5C4",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"filing",
			"organizing"
		],
		k: [
			30,
			17
		],
		o: 2
	},
	u5272: {
		a: "Squared Cjk Unified Ideograph-5272",
		b: "1F239",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cut",
			"divide",
			"chinese",
			"kanji",
			"pink-square"
		],
		k: [
			5,
			15
		],
		o: 2
	},
	wastebasket: {
		a: "Wastebasket",
		b: "1F5D1-FE0F",
		c: "1F5D1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"bin",
			"trash",
			"rubbish",
			"garbage",
			"toss"
		],
		k: [
			30,
			18
		],
		o: 2
	},
	pregnant_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F930-1F3FB",
				non_qualified: null,
				image: "1f930-1f3fb.png",
				sheet_x: 38,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F930-1F3FC",
				non_qualified: null,
				image: "1f930-1f3fc.png",
				sheet_x: 38,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F930-1F3FD",
				non_qualified: null,
				image: "1f930-1f3fd.png",
				sheet_x: 38,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F930-1F3FE",
				non_qualified: null,
				image: "1f930-1f3fe.png",
				sheet_x: 38,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F930-1F3FF",
				non_qualified: null,
				image: "1f930-1f3ff.png",
				sheet_x: 38,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Pregnant Woman",
		b: "1F930",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"baby"
		],
		k: [
			38,
			50
		],
		o: 4
	},
	first_quarter_moon_with_face: {
		a: "First Quarter Moon with Face",
		b: "1F31B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			46
		],
		o: 2
	},
	"flag-nc": {
		a: "New Caledonia Flag",
		b: "1F1F3-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			26
		],
		o: 2
	},
	u7121: {
		a: "Squared Cjk Unified Ideograph-7121",
		b: "1F21A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nothing",
			"chinese",
			"kanji",
			"japanese",
			"orange-square"
		],
		k: [
			5,
			6
		],
		o: 2
	},
	lock: {
		a: "Lock",
		b: "1F512",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"security",
			"password",
			"padlock"
		],
		k: [
			27,
			46
		],
		o: 2
	},
	"flag-ne": {
		a: "Niger Flag",
		b: "1F1F3-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			27
		],
		o: 2
	},
	last_quarter_moon_with_face: {
		a: "Last Quarter Moon with Face",
		b: "1F31C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			47
		],
		o: 2
	},
	"breast-feeding": {
		skin_variations: {
			"1F3FB": {
				unified: "1F931-1F3FB",
				non_qualified: null,
				image: "1f931-1f3fb.png",
				sheet_x: 39,
				sheet_y: 0,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F931-1F3FC",
				non_qualified: null,
				image: "1f931-1f3fc.png",
				sheet_x: 39,
				sheet_y: 1,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F931-1F3FD",
				non_qualified: null,
				image: "1f931-1f3fd.png",
				sheet_x: 39,
				sheet_y: 2,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F931-1F3FE",
				non_qualified: null,
				image: "1f931-1f3fe.png",
				sheet_x: 39,
				sheet_y: 3,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F931-1F3FF",
				non_qualified: null,
				image: "1f931-1f3ff.png",
				sheet_x: 39,
				sheet_y: 4,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Breast-Feeding",
		b: "1F931",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			38,
			56
		],
		o: 5
	},
	u7981: {
		a: "Squared Cjk Unified Ideograph-7981",
		b: "1F232",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"kanji",
			"japanese",
			"chinese",
			"forbidden",
			"limit",
			"restricted",
			"red-square"
		],
		k: [
			5,
			8
		],
		o: 2
	},
	accept: {
		a: "Circled Ideograph Accept",
		b: "1F251",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"ok",
			"good",
			"chinese",
			"kanji",
			"agree",
			"yes",
			"orange-circle"
		],
		k: [
			5,
			18
		],
		o: 2
	},
	angel: {
		skin_variations: {
			"1F3FB": {
				unified: "1F47C-1F3FB",
				non_qualified: null,
				image: "1f47c-1f3fb.png",
				sheet_x: 23,
				sheet_y: 38,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F47C-1F3FC",
				non_qualified: null,
				image: "1f47c-1f3fc.png",
				sheet_x: 23,
				sheet_y: 39,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F47C-1F3FD",
				non_qualified: null,
				image: "1f47c-1f3fd.png",
				sheet_x: 23,
				sheet_y: 40,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F47C-1F3FE",
				non_qualified: null,
				image: "1f47c-1f3fe.png",
				sheet_x: 23,
				sheet_y: 41,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F47C-1F3FF",
				non_qualified: null,
				image: "1f47c-1f3ff.png",
				sheet_x: 23,
				sheet_y: 42,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Baby Angel",
		b: "1F47C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"heaven",
			"wings",
			"halo"
		],
		k: [
			23,
			37
		],
		o: 2
	},
	unlock: {
		a: "Open Lock",
		b: "1F513",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"privacy",
			"security"
		],
		k: [
			27,
			47
		],
		o: 2
	},
	"flag-nf": {
		a: "Norfolk Island Flag",
		b: "1F1F3-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			28
		],
		o: 2
	},
	thermometer: {
		a: "Thermometer",
		b: "1F321-FE0F",
		c: "1F321",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"temperature",
			"hot",
			"cold"
		],
		k: [
			5,
			52
		],
		o: 2
	},
	"flag-ng": {
		a: "Nigeria Flag",
		b: "1F1F3-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			29
		],
		o: 2
	},
	u7533: {
		a: "Squared Cjk Unified Ideograph-7533",
		b: "1F238",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chinese",
			"japanese",
			"kanji",
			"orange-square"
		],
		k: [
			5,
			14
		],
		o: 2
	},
	sunny: {
		a: "Black Sun with Rays",
		b: "2600-FE0F",
		c: "2600",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"nature",
			"brightness",
			"summer",
			"beach",
			"spring"
		],
		k: [
			52,
			49
		],
		o: 2
	},
	lock_with_ink_pen: {
		a: "Lock with Ink Pen",
		b: "1F50F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"security",
			"secret"
		],
		k: [
			27,
			43
		],
		o: 2
	},
	santa: {
		skin_variations: {
			"1F3FB": {
				unified: "1F385-1F3FB",
				non_qualified: null,
				image: "1f385-1f3fb.png",
				sheet_x: 7,
				sheet_y: 37,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F385-1F3FC",
				non_qualified: null,
				image: "1f385-1f3fc.png",
				sheet_x: 7,
				sheet_y: 38,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F385-1F3FD",
				non_qualified: null,
				image: "1f385-1f3fd.png",
				sheet_x: 7,
				sheet_y: 39,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F385-1F3FE",
				non_qualified: null,
				image: "1f385-1f3fe.png",
				sheet_x: 7,
				sheet_y: 40,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F385-1F3FF",
				non_qualified: null,
				image: "1f385-1f3ff.png",
				sheet_x: 7,
				sheet_y: 41,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Father Christmas",
		b: "1F385",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"festival",
			"man",
			"male",
			"xmas",
			"father christmas"
		],
		k: [
			7,
			36
		],
		o: 2
	},
	closed_lock_with_key: {
		a: "Closed Lock with Key",
		b: "1F510",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"security",
			"privacy"
		],
		k: [
			27,
			44
		],
		o: 2
	},
	u5408: {
		a: "Squared Cjk Unified Ideograph-5408",
		b: "1F234",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"chinese",
			"join",
			"kanji",
			"red-square"
		],
		k: [
			5,
			10
		],
		o: 2
	},
	"flag-ni": {
		a: "Nicaragua Flag",
		b: "1F1F3-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			30
		],
		o: 2
	},
	mrs_claus: {
		skin_variations: {
			"1F3FB": {
				unified: "1F936-1F3FB",
				non_qualified: null,
				image: "1f936-1f3fb.png",
				sheet_x: 39,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F936-1F3FC",
				non_qualified: null,
				image: "1f936-1f3fc.png",
				sheet_x: 39,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F936-1F3FD",
				non_qualified: null,
				image: "1f936-1f3fd.png",
				sheet_x: 39,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F936-1F3FE",
				non_qualified: null,
				image: "1f936-1f3fe.png",
				sheet_x: 39,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F936-1F3FF",
				non_qualified: null,
				image: "1f936-1f3ff.png",
				sheet_x: 39,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Mother Christmas",
		b: "1F936",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"woman",
			"female",
			"xmas",
			"mother christmas"
		],
		k: [
			39,
			29
		],
		n: [
			"mother_christmas"
		],
		o: 4
	},
	full_moon_with_face: {
		a: "Full Moon with Face",
		b: "1F31D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			5,
			48
		],
		o: 2
	},
	key: {
		a: "Key",
		b: "1F511",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"lock",
			"door",
			"password"
		],
		k: [
			27,
			45
		],
		o: 2
	},
	superhero: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B8-1F3FB",
				non_qualified: null,
				image: "1f9b8-1f3fb.png",
				sheet_x: 43,
				sheet_y: 31,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B8-1F3FC",
				non_qualified: null,
				image: "1f9b8-1f3fc.png",
				sheet_x: 43,
				sheet_y: 32,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B8-1F3FD",
				non_qualified: null,
				image: "1f9b8-1f3fd.png",
				sheet_x: 43,
				sheet_y: 33,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B8-1F3FE",
				non_qualified: null,
				image: "1f9b8-1f3fe.png",
				sheet_x: 43,
				sheet_y: 34,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B8-1F3FF",
				non_qualified: null,
				image: "1f9b8-1f3ff.png",
				sheet_x: 43,
				sheet_y: 35,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Superhero",
		b: "1F9B8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			30
		],
		o: 11
	},
	"flag-nl": {
		a: "Netherlands Flag",
		b: "1F1F3-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			31
		],
		o: 2
	},
	u7a7a: {
		a: "Squared Cjk Unified Ideograph-7a7a",
		b: "1F233",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"kanji",
			"japanese",
			"chinese",
			"empty",
			"sky",
			"blue-square"
		],
		k: [
			5,
			9
		],
		o: 2
	},
	sun_with_face: {
		a: "Sun with Face",
		b: "1F31E",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"morning",
			"sky"
		],
		k: [
			5,
			49
		],
		o: 2
	},
	male_superhero: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B8-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9B8-1F3FB-200D-2642",
				image: "1f9b8-1f3fb-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 25,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B8-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9B8-1F3FC-200D-2642",
				image: "1f9b8-1f3fc-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 26,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B8-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9B8-1F3FD-200D-2642",
				image: "1f9b8-1f3fd-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 27,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B8-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9B8-1F3FE-200D-2642",
				image: "1f9b8-1f3fe-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 28,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B8-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9B8-1F3FF-200D-2642",
				image: "1f9b8-1f3ff-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 29,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Superhero",
		b: "1F9B8-200D-2642-FE0F",
		c: "1F9B8-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			24
		],
		o: 11
	},
	ringed_planet: {
		a: "Ringed Planet",
		b: "1FA90",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			4
		],
		o: 12
	},
	old_key: {
		a: "Old Key",
		b: "1F5DD-FE0F",
		c: "1F5DD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"lock",
			"door",
			"password"
		],
		k: [
			30,
			22
		],
		o: 2
	},
	congratulations: {
		a: "Circled Ideograph Congratulation",
		b: "3297-FE0F",
		c: "3297",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"chinese",
			"kanji",
			"japanese",
			"red-circle"
		],
		k: [
			55,
			46
		],
		o: 2
	},
	"flag-no": {
		a: "Norway Flag",
		b: "1F1F3-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			32
		],
		o: 2
	},
	star: {
		a: "White Medium Star",
		b: "2B50",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"night",
			"yellow"
		],
		k: [
			55,
			42
		],
		o: 2
	},
	secret: {
		a: "Circled Ideograph Secret",
		b: "3299-FE0F",
		c: "3299",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"privacy",
			"chinese",
			"sshh",
			"kanji",
			"red-circle"
		],
		k: [
			55,
			47
		],
		o: 2
	},
	"flag-np": {
		a: "Nepal Flag",
		b: "1F1F3-1F1F5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			33
		],
		o: 2
	},
	female_superhero: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B8-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9B8-1F3FB-200D-2640",
				image: "1f9b8-1f3fb-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 19,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B8-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9B8-1F3FC-200D-2640",
				image: "1f9b8-1f3fc-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 20,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B8-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9B8-1F3FD-200D-2640",
				image: "1f9b8-1f3fd-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 21,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B8-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9B8-1F3FE-200D-2640",
				image: "1f9b8-1f3fe-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 22,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B8-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9B8-1F3FF-200D-2640",
				image: "1f9b8-1f3ff-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 23,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Superhero",
		b: "1F9B8-200D-2640-FE0F",
		c: "1F9B8-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			18
		],
		o: 11
	},
	hammer: {
		a: "Hammer",
		b: "1F528",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			28,
			11
		],
		o: 2
	},
	star2: {
		a: "Glowing Star",
		b: "1F31F",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"night",
			"sparkle",
			"awesome",
			"good",
			"magic"
		],
		k: [
			5,
			50
		],
		o: 2
	},
	"flag-nr": {
		a: "Nauru Flag",
		b: "1F1F3-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			34
		],
		o: 2
	},
	axe: {
		a: "Axe",
		b: "1FA93",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			7
		],
		o: 12
	},
	u55b6: {
		a: "Squared Cjk Unified Ideograph-55b6",
		b: "1F23A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"japanese",
			"opening hours",
			"orange-square"
		],
		k: [
			5,
			16
		],
		o: 2
	},
	supervillain: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B9-1F3FB",
				non_qualified: null,
				image: "1f9b9-1f3fb.png",
				sheet_x: 43,
				sheet_y: 49,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B9-1F3FC",
				non_qualified: null,
				image: "1f9b9-1f3fc.png",
				sheet_x: 43,
				sheet_y: 50,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B9-1F3FD",
				non_qualified: null,
				image: "1f9b9-1f3fd.png",
				sheet_x: 43,
				sheet_y: 51,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B9-1F3FE",
				non_qualified: null,
				image: "1f9b9-1f3fe.png",
				sheet_x: 43,
				sheet_y: 52,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B9-1F3FF",
				non_qualified: null,
				image: "1f9b9-1f3ff.png",
				sheet_x: 43,
				sheet_y: 53,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Supervillain",
		b: "1F9B9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			48
		],
		o: 11
	},
	stars: {
		a: "Shooting Star",
		b: "1F320",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"night",
			"photo"
		],
		k: [
			5,
			51
		],
		o: 2
	},
	u6e80: {
		a: "Squared Cjk Unified Ideograph-6e80",
		b: "1F235",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"full",
			"chinese",
			"japanese",
			"red-square",
			"kanji"
		],
		k: [
			5,
			11
		],
		o: 2
	},
	"flag-nu": {
		a: "Niue Flag",
		b: "1F1F3-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			35
		],
		o: 2
	},
	pick: {
		a: "Pick",
		b: "26CF-FE0F",
		c: "26CF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tools",
			"dig"
		],
		k: [
			54,
			5
		],
		o: 2
	},
	male_supervillain: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B9-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9B9-1F3FB-200D-2642",
				image: "1f9b9-1f3fb-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 43,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B9-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9B9-1F3FC-200D-2642",
				image: "1f9b9-1f3fc-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 44,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B9-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9B9-1F3FD-200D-2642",
				image: "1f9b9-1f3fd-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 45,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B9-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9B9-1F3FE-200D-2642",
				image: "1f9b9-1f3fe-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 46,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B9-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9B9-1F3FF-200D-2642",
				image: "1f9b9-1f3ff-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 47,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Supervillain",
		b: "1F9B9-200D-2642-FE0F",
		c: "1F9B9-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			42
		],
		o: 11
	},
	female_supervillain: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9B9-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9B9-1F3FB-200D-2640",
				image: "1f9b9-1f3fb-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 37,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9B9-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9B9-1F3FC-200D-2640",
				image: "1f9b9-1f3fc-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 38,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9B9-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9B9-1F3FD-200D-2640",
				image: "1f9b9-1f3fd-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 39,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9B9-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9B9-1F3FE-200D-2640",
				image: "1f9b9-1f3fe-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 40,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9B9-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9B9-1F3FF-200D-2640",
				image: "1f9b9-1f3ff-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 41,
				added_in: "11.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Supervillain",
		b: "1F9B9-200D-2640-FE0F",
		c: "1F9B9-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			36
		],
		o: 11
	},
	hammer_and_pick: {
		a: "Hammer and Pick",
		b: "2692-FE0F",
		c: "2692",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			53,
			41
		],
		o: 2
	},
	milky_way: {
		a: "Milky Way",
		b: "1F30C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"photo",
			"space",
			"stars"
		],
		k: [
			5,
			31
		],
		o: 2
	},
	red_circle: {
		a: "Large Red Circle",
		b: "1F534",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"error",
			"danger"
		],
		k: [
			28,
			23
		],
		o: 2
	},
	"flag-nz": {
		a: "New Zealand Flag",
		b: "1F1F3-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			36
		],
		o: 2
	},
	large_orange_circle: {
		a: "Large Orange Circle",
		b: "1F7E0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			3
		],
		o: 12
	},
	hammer_and_wrench: {
		a: "Hammer and Wrench",
		b: "1F6E0-FE0F",
		c: "1F6E0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			36,
			42
		],
		o: 2
	},
	"flag-om": {
		a: "Oman Flag",
		b: "1F1F4-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			37
		],
		o: 2
	},
	cloud: {
		a: "Cloud",
		b: "2601-FE0F",
		c: "2601",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"sky"
		],
		k: [
			52,
			50
		],
		o: 2
	},
	mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB",
				non_qualified: null,
				image: "1f9d9-1f3fb.png",
				sheet_x: 49,
				sheet_y: 50,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC",
				non_qualified: null,
				image: "1f9d9-1f3fc.png",
				sheet_x: 49,
				sheet_y: 51,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD",
				non_qualified: null,
				image: "1f9d9-1f3fd.png",
				sheet_x: 49,
				sheet_y: 52,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE",
				non_qualified: null,
				image: "1f9d9-1f3fe.png",
				sheet_x: 49,
				sheet_y: 53,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF",
				non_qualified: null,
				image: "1f9d9-1f3ff.png",
				sheet_x: 49,
				sheet_y: 54,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D9-200D-2640-FE0F",
		a: "Mage",
		b: "1F9D9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			49
		],
		o: 5
	},
	dagger_knife: {
		a: "Dagger Knife",
		b: "1F5E1-FE0F",
		c: "1F5E1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			24
		],
		o: 2
	},
	partly_sunny: {
		a: "Sun Behind Cloud",
		b: "26C5",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"nature",
			"cloudy",
			"morning",
			"fall",
			"spring"
		],
		k: [
			54,
			2
		],
		o: 2
	},
	large_yellow_circle: {
		a: "Large Yellow Circle",
		b: "1F7E1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			4
		],
		o: 12
	},
	male_mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FB-200D-2642",
				image: "1f9d9-1f3fb-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 44,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FC-200D-2642",
				image: "1f9d9-1f3fc-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 45,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FD-200D-2642",
				image: "1f9d9-1f3fd-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 46,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FE-200D-2642",
				image: "1f9d9-1f3fe-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 47,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FF-200D-2642",
				image: "1f9d9-1f3ff-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 48,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Mage",
		b: "1F9D9-200D-2642-FE0F",
		c: "1F9D9-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			43
		],
		o: 5
	},
	"flag-pa": {
		a: "Panama Flag",
		b: "1F1F5-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			38
		],
		o: 2
	},
	thunder_cloud_and_rain: {
		a: "Thunder Cloud and Rain",
		b: "26C8-FE0F",
		c: "26C8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			3
		],
		o: 2
	},
	large_green_circle: {
		a: "Large Green Circle",
		b: "1F7E2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			5
		],
		o: 12
	},
	female_mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FB-200D-2640",
				image: "1f9d9-1f3fb-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 38,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D9-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FC-200D-2640",
				image: "1f9d9-1f3fc-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 39,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D9-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FD-200D-2640",
				image: "1f9d9-1f3fd-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 40,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D9-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FE-200D-2640",
				image: "1f9d9-1f3fe-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 41,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D9-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FF-200D-2640",
				image: "1f9d9-1f3ff-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 42,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D9-1F3FF"
			}
		},
		obsoletes: "1F9D9",
		a: "Female Mage",
		b: "1F9D9-200D-2640-FE0F",
		c: "1F9D9-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			37
		],
		o: 5
	},
	crossed_swords: {
		a: "Crossed Swords",
		b: "2694-FE0F",
		c: "2694",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weapon"
		],
		k: [
			53,
			43
		],
		o: 2
	},
	"flag-pe": {
		a: "Peru Flag",
		b: "1F1F5-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			39
		],
		o: 2
	},
	gun: {
		a: "Pistol",
		b: "1F52B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"violence",
			"weapon",
			"pistol",
			"revolver"
		],
		k: [
			28,
			14
		],
		o: 2
	},
	mostly_sunny: {
		a: "Mostly Sunny",
		b: "1F324-FE0F",
		c: "1F324",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			53
		],
		n: [
			"sun_small_cloud"
		],
		o: 2
	},
	fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB",
				non_qualified: null,
				image: "1f9da-1f3fb.png",
				sheet_x: 50,
				sheet_y: 11,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC",
				non_qualified: null,
				image: "1f9da-1f3fc.png",
				sheet_x: 50,
				sheet_y: 12,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD",
				non_qualified: null,
				image: "1f9da-1f3fd.png",
				sheet_x: 50,
				sheet_y: 13,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE",
				non_qualified: null,
				image: "1f9da-1f3fe.png",
				sheet_x: 50,
				sheet_y: 14,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF",
				non_qualified: null,
				image: "1f9da-1f3ff.png",
				sheet_x: 50,
				sheet_y: 15,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9DA-200D-2640-FE0F",
		a: "Fairy",
		b: "1F9DA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			10
		],
		o: 5
	},
	"flag-pf": {
		a: "French Polynesia Flag",
		b: "1F1F5-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			40
		],
		o: 2
	},
	large_blue_circle: {
		a: "Large Blue Circle",
		b: "1F535",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"icon",
			"button"
		],
		k: [
			28,
			24
		],
		o: 2
	},
	large_purple_circle: {
		a: "Large Purple Circle",
		b: "1F7E3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			6
		],
		o: 12
	},
	bow_and_arrow: {
		a: "Bow and Arrow",
		b: "1F3F9",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports"
		],
		k: [
			11,
			21
		],
		o: 2
	},
	male_fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FB-200D-2642",
				image: "1f9da-1f3fb-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 5,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FC-200D-2642",
				image: "1f9da-1f3fc-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 6,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FD-200D-2642",
				image: "1f9da-1f3fd-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 7,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FE-200D-2642",
				image: "1f9da-1f3fe-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 8,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FF-200D-2642",
				image: "1f9da-1f3ff-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 9,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Male Fairy",
		b: "1F9DA-200D-2642-FE0F",
		c: "1F9DA-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			4
		],
		o: 5
	},
	barely_sunny: {
		a: "Barely Sunny",
		b: "1F325-FE0F",
		c: "1F325",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			54
		],
		n: [
			"sun_behind_cloud"
		],
		o: 2
	},
	"flag-pg": {
		a: "Papua New Guinea Flag",
		b: "1F1F5-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			41
		],
		o: 2
	},
	shield: {
		a: "Shield",
		b: "1F6E1-FE0F",
		c: "1F6E1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"protection",
			"security"
		],
		k: [
			36,
			43
		],
		o: 2
	},
	partly_sunny_rain: {
		a: "Partly Sunny Rain",
		b: "1F326-FE0F",
		c: "1F326",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			55
		],
		n: [
			"sun_behind_rain_cloud"
		],
		o: 2
	},
	large_brown_circle: {
		a: "Large Brown Circle",
		b: "1F7E4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			7
		],
		o: 12
	},
	female_fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FB-200D-2640",
				image: "1f9da-1f3fb-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 56,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoletes: "1F9DA-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FC-200D-2640",
				image: "1f9da-1f3fc-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 0,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoletes: "1F9DA-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FD-200D-2640",
				image: "1f9da-1f3fd-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 1,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoletes: "1F9DA-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FE-200D-2640",
				image: "1f9da-1f3fe-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 2,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoletes: "1F9DA-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FF-200D-2640",
				image: "1f9da-1f3ff-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 3,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false,
				obsoletes: "1F9DA-1F3FF"
			}
		},
		obsoletes: "1F9DA",
		a: "Female Fairy",
		b: "1F9DA-200D-2640-FE0F",
		c: "1F9DA-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			55
		],
		o: 5
	},
	"flag-ph": {
		a: "Philippines Flag",
		b: "1F1F5-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			42
		],
		o: 2
	},
	"flag-pk": {
		a: "Pakistan Flag",
		b: "1F1F5-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			43
		],
		o: 2
	},
	black_circle: {
		a: "Medium Black Circle",
		b: "26AB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"button",
			"round"
		],
		k: [
			53,
			53
		],
		o: 2
	},
	wrench: {
		a: "Wrench",
		b: "1F527",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"tools",
			"diy",
			"ikea",
			"fix",
			"maintainer"
		],
		k: [
			28,
			10
		],
		o: 2
	},
	vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB",
				non_qualified: null,
				image: "1f9db-1f3fb.png",
				sheet_x: 50,
				sheet_y: 29,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC",
				non_qualified: null,
				image: "1f9db-1f3fc.png",
				sheet_x: 50,
				sheet_y: 30,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD",
				non_qualified: null,
				image: "1f9db-1f3fd.png",
				sheet_x: 50,
				sheet_y: 31,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE",
				non_qualified: null,
				image: "1f9db-1f3fe.png",
				sheet_x: 50,
				sheet_y: 32,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF",
				non_qualified: null,
				image: "1f9db-1f3ff.png",
				sheet_x: 50,
				sheet_y: 33,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9DB-200D-2640-FE0F",
		a: "Vampire",
		b: "1F9DB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			28
		],
		o: 5
	},
	rain_cloud: {
		a: "Rain Cloud",
		b: "1F327-FE0F",
		c: "1F327",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			56
		],
		o: 2
	},
	snow_cloud: {
		a: "Snow Cloud",
		b: "1F328-FE0F",
		c: "1F328",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			6,
			0
		],
		o: 2
	},
	"flag-pl": {
		a: "Poland Flag",
		b: "1F1F5-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			44
		],
		o: 2
	},
	male_vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FB-200D-2642",
				image: "1f9db-1f3fb-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 23,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FC-200D-2642",
				image: "1f9db-1f3fc-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 24,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FD-200D-2642",
				image: "1f9db-1f3fd-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 25,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FE-200D-2642",
				image: "1f9db-1f3fe-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 26,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FF-200D-2642",
				image: "1f9db-1f3ff-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 27,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Male Vampire",
		b: "1F9DB-200D-2642-FE0F",
		c: "1F9DB-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			22
		],
		o: 5
	},
	nut_and_bolt: {
		a: "Nut and Bolt",
		b: "1F529",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"handy",
			"tools",
			"fix"
		],
		k: [
			28,
			12
		],
		o: 2
	},
	white_circle: {
		a: "Medium White Circle",
		b: "26AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"round"
		],
		k: [
			53,
			52
		],
		o: 2
	},
	female_vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FB-200D-2640",
				image: "1f9db-1f3fb-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 17,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DB-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FC-200D-2640",
				image: "1f9db-1f3fc-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 18,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DB-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FD-200D-2640",
				image: "1f9db-1f3fd-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 19,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DB-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FE-200D-2640",
				image: "1f9db-1f3fe-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 20,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DB-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FF-200D-2640",
				image: "1f9db-1f3ff-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 21,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DB-1F3FF"
			}
		},
		obsoletes: "1F9DB",
		a: "Female Vampire",
		b: "1F9DB-200D-2640-FE0F",
		c: "1F9DB-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			16
		],
		o: 5
	},
	"flag-pm": {
		a: "St. Pierre & Miquelon Flag",
		b: "1F1F5-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			45
		],
		o: 2
	},
	large_red_square: {
		a: "Large Red Square",
		b: "1F7E5",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			8
		],
		o: 12
	},
	lightning: {
		a: "Lightning",
		b: "1F329-FE0F",
		c: "1F329",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			6,
			1
		],
		n: [
			"lightning_cloud"
		],
		o: 2
	},
	gear: {
		a: "Gear",
		b: "2699-FE0F",
		c: "2699",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"cog"
		],
		k: [
			53,
			47
		],
		o: 2
	},
	merperson: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB",
				non_qualified: null,
				image: "1f9dc-1f3fb.png",
				sheet_x: 50,
				sheet_y: 47,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC",
				non_qualified: null,
				image: "1f9dc-1f3fc.png",
				sheet_x: 50,
				sheet_y: 48,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD",
				non_qualified: null,
				image: "1f9dc-1f3fd.png",
				sheet_x: 50,
				sheet_y: 49,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE",
				non_qualified: null,
				image: "1f9dc-1f3fe.png",
				sheet_x: 50,
				sheet_y: 50,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF",
				non_qualified: null,
				image: "1f9dc-1f3ff.png",
				sheet_x: 50,
				sheet_y: 51,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9DC-200D-2642-FE0F",
		a: "Merperson",
		b: "1F9DC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			46
		],
		o: 5
	},
	tornado: {
		a: "Tornado",
		b: "1F32A-FE0F",
		c: "1F32A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"cyclone",
			"twister"
		],
		k: [
			6,
			2
		],
		n: [
			"tornado_cloud"
		],
		o: 2
	},
	large_orange_square: {
		a: "Large Orange Square",
		b: "1F7E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			10
		],
		o: 12
	},
	"flag-pn": {
		a: "Pitcairn Islands Flag",
		b: "1F1F5-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			46
		],
		o: 2
	},
	compression: {
		a: "Compression",
		b: "1F5DC-FE0F",
		c: "1F5DC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			21
		],
		o: 2
	},
	merman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FB-200D-2642",
				image: "1f9dc-1f3fb-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 41,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DC-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FC-200D-2642",
				image: "1f9dc-1f3fc-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 42,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DC-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FD-200D-2642",
				image: "1f9dc-1f3fd-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 43,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DC-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FE-200D-2642",
				image: "1f9dc-1f3fe-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 44,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DC-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FF-200D-2642",
				image: "1f9dc-1f3ff-200d-2642-fe0f.png",
				sheet_x: 50,
				sheet_y: 45,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DC-1F3FF"
			}
		},
		obsoletes: "1F9DC",
		a: "Merman",
		b: "1F9DC-200D-2642-FE0F",
		c: "1F9DC-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			40
		],
		o: 5
	},
	large_yellow_square: {
		a: "Large Yellow Square",
		b: "1F7E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			11
		],
		o: 12
	},
	fog: {
		a: "Fog",
		b: "1F32B-FE0F",
		c: "1F32B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather"
		],
		k: [
			6,
			3
		],
		o: 2
	},
	scales: {
		a: "Scales",
		b: "2696-FE0F",
		c: "2696",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			53,
			45
		],
		o: 2
	},
	"flag-pr": {
		a: "Puerto Rico Flag",
		b: "1F1F5-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			47
		],
		o: 2
	},
	wind_blowing_face: {
		a: "Wind Blowing Face",
		b: "1F32C-FE0F",
		c: "1F32C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			6,
			4
		],
		o: 2
	},
	"flag-ps": {
		a: "Palestinian Territories Flag",
		b: "1F1F5-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			48
		],
		o: 2
	},
	mermaid: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FB-200D-2640",
				image: "1f9dc-1f3fb-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 35,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FC-200D-2640",
				image: "1f9dc-1f3fc-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 36,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FD-200D-2640",
				image: "1f9dc-1f3fd-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 37,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FE-200D-2640",
				image: "1f9dc-1f3fe-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 38,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FF-200D-2640",
				image: "1f9dc-1f3ff-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 39,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Mermaid",
		b: "1F9DC-200D-2640-FE0F",
		c: "1F9DC-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			34
		],
		o: 5
	},
	probing_cane: {
		a: "Probing Cane",
		b: "1F9AF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			43,
			3
		],
		o: 12
	},
	large_green_square: {
		a: "Large Green Square",
		b: "1F7E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			12
		],
		o: 12
	},
	"flag-pt": {
		a: "Portugal Flag",
		b: "1F1F5-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			49
		],
		o: 2
	},
	link: {
		a: "Link Symbol",
		b: "1F517",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"rings",
			"url"
		],
		k: [
			27,
			51
		],
		o: 2
	},
	large_blue_square: {
		a: "Large Blue Square",
		b: "1F7E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			9
		],
		o: 12
	},
	elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB",
				non_qualified: null,
				image: "1f9dd-1f3fb.png",
				sheet_x: 51,
				sheet_y: 8,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC",
				non_qualified: null,
				image: "1f9dd-1f3fc.png",
				sheet_x: 51,
				sheet_y: 9,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD",
				non_qualified: null,
				image: "1f9dd-1f3fd.png",
				sheet_x: 51,
				sheet_y: 10,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE",
				non_qualified: null,
				image: "1f9dd-1f3fe.png",
				sheet_x: 51,
				sheet_y: 11,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF",
				non_qualified: null,
				image: "1f9dd-1f3ff.png",
				sheet_x: 51,
				sheet_y: 12,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9DD-200D-2642-FE0F",
		a: "Elf",
		b: "1F9DD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			7
		],
		o: 5
	},
	cyclone: {
		a: "Cyclone",
		b: "1F300",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"swirl",
			"blue",
			"cloud",
			"vortex",
			"spiral",
			"whirlpool",
			"spin",
			"tornado",
			"hurricane",
			"typhoon"
		],
		k: [
			5,
			19
		],
		o: 2
	},
	rainbow: {
		a: "Rainbow",
		b: "1F308",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"nature",
			"happy",
			"unicorn_face",
			"photo",
			"sky",
			"spring"
		],
		k: [
			5,
			27
		],
		o: 2
	},
	male_elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FB-200D-2642",
				image: "1f9dd-1f3fb-200d-2642-fe0f.png",
				sheet_x: 51,
				sheet_y: 2,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DD-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FC-200D-2642",
				image: "1f9dd-1f3fc-200d-2642-fe0f.png",
				sheet_x: 51,
				sheet_y: 3,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DD-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FD-200D-2642",
				image: "1f9dd-1f3fd-200d-2642-fe0f.png",
				sheet_x: 51,
				sheet_y: 4,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DD-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FE-200D-2642",
				image: "1f9dd-1f3fe-200d-2642-fe0f.png",
				sheet_x: 51,
				sheet_y: 5,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DD-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FF-200D-2642",
				image: "1f9dd-1f3ff-200d-2642-fe0f.png",
				sheet_x: 51,
				sheet_y: 6,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9DD-1F3FF"
			}
		},
		obsoletes: "1F9DD",
		a: "Male Elf",
		b: "1F9DD-200D-2642-FE0F",
		c: "1F9DD-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			1
		],
		o: 5
	},
	"flag-pw": {
		a: "Palau Flag",
		b: "1F1F5-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			50
		],
		o: 2
	},
	chains: {
		a: "Chains",
		b: "26D3-FE0F",
		c: "26D3",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"lock",
			"arrest"
		],
		k: [
			54,
			7
		],
		o: 2
	},
	large_purple_square: {
		a: "Large Purple Square",
		b: "1F7EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			13
		],
		o: 12
	},
	female_elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FB-200D-2640",
				image: "1f9dd-1f3fb-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 53,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FC-200D-2640",
				image: "1f9dd-1f3fc-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 54,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FD-200D-2640",
				image: "1f9dd-1f3fd-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 55,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FE-200D-2640",
				image: "1f9dd-1f3fe-200d-2640-fe0f.png",
				sheet_x: 50,
				sheet_y: 56,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FF-200D-2640",
				image: "1f9dd-1f3ff-200d-2640-fe0f.png",
				sheet_x: 51,
				sheet_y: 0,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Female Elf",
		b: "1F9DD-200D-2640-FE0F",
		c: "1F9DD-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			50,
			52
		],
		o: 5
	},
	"flag-py": {
		a: "Paraguay Flag",
		b: "1F1F5-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			51
		],
		o: 2
	},
	closed_umbrella: {
		a: "Closed Umbrella",
		b: "1F302",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"weather",
			"rain",
			"drizzle"
		],
		k: [
			5,
			21
		],
		o: 2
	},
	toolbox: {
		a: "Toolbox",
		b: "1F9F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			35
		],
		o: 11
	},
	large_brown_square: {
		a: "Large Brown Square",
		b: "1F7EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			37,
			14
		],
		o: 12
	},
	magnet: {
		a: "Magnet",
		b: "1F9F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			37
		],
		o: 11
	},
	genie: {
		obsoleted_by: "1F9DE-200D-2642-FE0F",
		a: "Genie",
		b: "1F9DE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			15
		],
		o: 5
	},
	"flag-qa": {
		a: "Qatar Flag",
		b: "1F1F6-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			52
		],
		o: 2
	},
	umbrella: {
		a: "Umbrella",
		b: "2602-FE0F",
		c: "2602",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"rainy",
			"weather",
			"spring"
		],
		k: [
			52,
			51
		],
		o: 2
	},
	black_large_square: {
		a: "Black Large Square",
		b: "2B1B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"icon",
			"button"
		],
		k: [
			55,
			40
		],
		o: 2
	},
	male_genie: {
		obsoletes: "1F9DE",
		a: "Male Genie",
		b: "1F9DE-200D-2642-FE0F",
		c: "1F9DE-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			14
		],
		o: 5
	},
	umbrella_with_rain_drops: {
		a: "Umbrella with Rain Drops",
		b: "2614",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			56
		],
		o: 2
	},
	"flag-re": {
		a: "Réunion Flag",
		b: "1F1F7-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			53
		],
		o: 2
	},
	white_large_square: {
		a: "White Large Square",
		b: "2B1C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"icon",
			"stone",
			"button"
		],
		k: [
			55,
			41
		],
		o: 2
	},
	alembic: {
		a: "Alembic",
		b: "2697-FE0F",
		c: "2697",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"distilling",
			"science",
			"experiment",
			"chemistry"
		],
		k: [
			53,
			46
		],
		o: 2
	},
	black_medium_square: {
		a: "Black Medium Square",
		b: "25FC-FE0F",
		c: "25FC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"button",
			"icon"
		],
		k: [
			52,
			46
		],
		o: 2
	},
	test_tube: {
		a: "Test Tube",
		b: "1F9EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			29
		],
		o: 11
	},
	"flag-ro": {
		a: "Romania Flag",
		b: "1F1F7-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			54
		],
		o: 2
	},
	female_genie: {
		a: "Female Genie",
		b: "1F9DE-200D-2640-FE0F",
		c: "1F9DE-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			13
		],
		o: 5
	},
	umbrella_on_ground: {
		a: "Umbrella on Ground",
		b: "26F1-FE0F",
		c: "26F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			12
		],
		o: 2
	},
	zombie: {
		obsoleted_by: "1F9DF-200D-2642-FE0F",
		a: "Zombie",
		b: "1F9DF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			18
		],
		o: 5
	},
	zap: {
		a: "High Voltage Sign",
		b: "26A1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"thunder",
			"weather",
			"lightning bolt",
			"fast"
		],
		k: [
			53,
			51
		],
		o: 2
	},
	white_medium_square: {
		a: "White Medium Square",
		b: "25FB-FE0F",
		c: "25FB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"stone",
			"icon"
		],
		k: [
			52,
			45
		],
		o: 2
	},
	"flag-rs": {
		a: "Serbia Flag",
		b: "1F1F7-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			3,
			55
		],
		o: 2
	},
	petri_dish: {
		a: "Petri Dish",
		b: "1F9EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			30
		],
		o: 11
	},
	snowflake: {
		a: "Snowflake",
		b: "2744-FE0F",
		c: "2744",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas"
		],
		k: [
			55,
			19
		],
		o: 2
	},
	dna: {
		a: "Dna Double Helix",
		b: "1F9EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			31
		],
		o: 11
	},
	male_zombie: {
		obsoletes: "1F9DF",
		a: "Male Zombie",
		b: "1F9DF-200D-2642-FE0F",
		c: "1F9DF-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			17
		],
		o: 5
	},
	black_medium_small_square: {
		a: "Black Medium Small Square",
		b: "25FE",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"icon",
			"shape",
			"button"
		],
		k: [
			52,
			48
		],
		o: 2
	},
	ru: {
		a: "Russia Flag",
		b: "1F1F7-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"russian",
			"federation",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			3,
			56
		],
		n: [
			"flag-ru"
		],
		o: 2
	},
	female_zombie: {
		a: "Female Zombie",
		b: "1F9DF-200D-2640-FE0F",
		c: "1F9DF-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			16
		],
		o: 5
	},
	"flag-rw": {
		a: "Rwanda Flag",
		b: "1F1F7-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			0
		],
		o: 2
	},
	snowman: {
		a: "Snowman",
		b: "2603-FE0F",
		c: "2603",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen",
			"without_snow"
		],
		k: [
			52,
			52
		],
		o: 2
	},
	white_medium_small_square: {
		a: "White Medium Small Square",
		b: "25FD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"stone",
			"icon",
			"button"
		],
		k: [
			52,
			47
		],
		o: 2
	},
	microscope: {
		a: "Microscope",
		b: "1F52C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"laboratory",
			"experiment",
			"zoomin",
			"science",
			"study"
		],
		k: [
			28,
			15
		],
		o: 2
	},
	snowman_without_snow: {
		a: "Snowman Without Snow",
		b: "26C4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			54,
			1
		],
		o: 2
	},
	telescope: {
		a: "Telescope",
		b: "1F52D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"stars",
			"space",
			"zoom",
			"science",
			"astronomy"
		],
		k: [
			28,
			16
		],
		o: 2
	},
	massage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB",
				non_qualified: null,
				image: "1f486-1f3fb.png",
				sheet_x: 24,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F486-1F3FC",
				non_qualified: null,
				image: "1f486-1f3fc.png",
				sheet_x: 24,
				sheet_y: 53,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F486-1F3FD",
				non_qualified: null,
				image: "1f486-1f3fd.png",
				sheet_x: 24,
				sheet_y: 54,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F486-1F3FE",
				non_qualified: null,
				image: "1f486-1f3fe.png",
				sheet_x: 24,
				sheet_y: 55,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F486-1F3FF",
				non_qualified: null,
				image: "1f486-1f3ff.png",
				sheet_x: 24,
				sheet_y: 56,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F486-200D-2640-FE0F",
		a: "Face Massage",
		b: "1F486",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			24,
			51
		],
		o: 2
	},
	black_small_square: {
		a: "Black Small Square",
		b: "25AA-FE0F",
		c: "25AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"icon"
		],
		k: [
			52,
			41
		],
		o: 2
	},
	"flag-sa": {
		a: "Saudi Arabia Flag",
		b: "1F1F8-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			1
		],
		o: 2
	},
	"man-getting-massage": {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB-200D-2642-FE0F",
				non_qualified: "1F486-1F3FB-200D-2642",
				image: "1f486-1f3fb-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F486-1F3FC-200D-2642-FE0F",
				non_qualified: "1F486-1F3FC-200D-2642",
				image: "1f486-1f3fc-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F486-1F3FD-200D-2642-FE0F",
				non_qualified: "1F486-1F3FD-200D-2642",
				image: "1f486-1f3fd-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F486-1F3FE-200D-2642-FE0F",
				non_qualified: "1F486-1F3FE-200D-2642",
				image: "1f486-1f3fe-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F486-1F3FF-200D-2642-FE0F",
				non_qualified: "1F486-1F3FF-200D-2642",
				image: "1f486-1f3ff-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Getting Massage",
		b: "1F486-200D-2642-FE0F",
		c: "1F486-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			24,
			45
		],
		o: 4
	},
	comet: {
		a: "Comet",
		b: "2604-FE0F",
		c: "2604",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"space"
		],
		k: [
			52,
			53
		],
		o: 2
	},
	white_small_square: {
		a: "White Small Square",
		b: "25AB-FE0F",
		c: "25AB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"icon"
		],
		k: [
			52,
			42
		],
		o: 2
	},
	"flag-sb": {
		a: "Solomon Islands Flag",
		b: "1F1F8-1F1E7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			2
		],
		o: 2
	},
	satellite_antenna: {
		a: "Satellite Antenna",
		b: "1F4E1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			26,
			55
		],
		o: 2
	},
	large_orange_diamond: {
		a: "Large Orange Diamond",
		b: "1F536",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			25
		],
		o: 2
	},
	"woman-getting-massage": {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB-200D-2640-FE0F",
				non_qualified: "1F486-1F3FB-200D-2640",
				image: "1f486-1f3fb-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F486-1F3FC-200D-2640-FE0F",
				non_qualified: "1F486-1F3FC-200D-2640",
				image: "1f486-1f3fc-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F486-1F3FD-200D-2640-FE0F",
				non_qualified: "1F486-1F3FD-200D-2640",
				image: "1f486-1f3fd-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F486-1F3FE-200D-2640-FE0F",
				non_qualified: "1F486-1F3FE-200D-2640",
				image: "1f486-1f3fe-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F486-1F3FF-200D-2640-FE0F",
				non_qualified: "1F486-1F3FF-200D-2640",
				image: "1f486-1f3ff-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F486",
		a: "Woman Getting Massage",
		b: "1F486-200D-2640-FE0F",
		c: "1F486-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			24,
			39
		],
		o: 4
	},
	fire: {
		a: "Fire",
		b: "1F525",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"hot",
			"cook",
			"flame"
		],
		k: [
			28,
			8
		],
		o: 2
	},
	syringe: {
		a: "Syringe",
		b: "1F489",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"health",
			"hospital",
			"drugs",
			"blood",
			"medicine",
			"needle",
			"doctor",
			"nurse"
		],
		k: [
			25,
			19
		],
		o: 2
	},
	"flag-sc": {
		a: "Seychelles Flag",
		b: "1F1F8-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			3
		],
		o: 2
	},
	large_blue_diamond: {
		a: "Large Blue Diamond",
		b: "1F537",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			26
		],
		o: 2
	},
	"flag-sd": {
		a: "Sudan Flag",
		b: "1F1F8-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			4
		],
		o: 2
	},
	droplet: {
		a: "Droplet",
		b: "1F4A7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"water",
			"drip",
			"faucet",
			"spring"
		],
		k: [
			25,
			49
		],
		o: 2
	},
	drop_of_blood: {
		a: "Drop of Blood",
		b: "1FA78",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			55
		],
		o: 12
	},
	haircut: {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB",
				non_qualified: null,
				image: "1f487-1f3fb.png",
				sheet_x: 25,
				sheet_y: 13,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F487-1F3FC",
				non_qualified: null,
				image: "1f487-1f3fc.png",
				sheet_x: 25,
				sheet_y: 14,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F487-1F3FD",
				non_qualified: null,
				image: "1f487-1f3fd.png",
				sheet_x: 25,
				sheet_y: 15,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F487-1F3FE",
				non_qualified: null,
				image: "1f487-1f3fe.png",
				sheet_x: 25,
				sheet_y: 16,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F487-1F3FF",
				non_qualified: null,
				image: "1f487-1f3ff.png",
				sheet_x: 25,
				sheet_y: 17,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F487-200D-2640-FE0F",
		a: "Haircut",
		b: "1F487",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			25,
			12
		],
		o: 2
	},
	ocean: {
		a: "Water Wave",
		b: "1F30A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sea",
			"water",
			"wave",
			"nature",
			"tsunami",
			"disaster"
		],
		k: [
			5,
			29
		],
		o: 2
	},
	"flag-se": {
		a: "Sweden Flag",
		b: "1F1F8-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			5
		],
		o: 2
	},
	"man-getting-haircut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB-200D-2642-FE0F",
				non_qualified: "1F487-1F3FB-200D-2642",
				image: "1f487-1f3fb-200d-2642-fe0f.png",
				sheet_x: 25,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F487-1F3FC-200D-2642-FE0F",
				non_qualified: "1F487-1F3FC-200D-2642",
				image: "1f487-1f3fc-200d-2642-fe0f.png",
				sheet_x: 25,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F487-1F3FD-200D-2642-FE0F",
				non_qualified: "1F487-1F3FD-200D-2642",
				image: "1f487-1f3fd-200d-2642-fe0f.png",
				sheet_x: 25,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F487-1F3FE-200D-2642-FE0F",
				non_qualified: "1F487-1F3FE-200D-2642",
				image: "1f487-1f3fe-200d-2642-fe0f.png",
				sheet_x: 25,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F487-1F3FF-200D-2642-FE0F",
				non_qualified: "1F487-1F3FF-200D-2642",
				image: "1f487-1f3ff-200d-2642-fe0f.png",
				sheet_x: 25,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Getting Haircut",
		b: "1F487-200D-2642-FE0F",
		c: "1F487-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			25,
			6
		],
		o: 4
	},
	small_orange_diamond: {
		a: "Small Orange Diamond",
		b: "1F538",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			27
		],
		o: 2
	},
	pill: {
		a: "Pill",
		b: "1F48A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"health",
			"medicine",
			"doctor",
			"pharmacy",
			"drug"
		],
		k: [
			25,
			20
		],
		o: 2
	},
	"woman-getting-haircut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB-200D-2640-FE0F",
				non_qualified: "1F487-1F3FB-200D-2640",
				image: "1f487-1f3fb-200d-2640-fe0f.png",
				sheet_x: 25,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F487-1F3FC-200D-2640-FE0F",
				non_qualified: "1F487-1F3FC-200D-2640",
				image: "1f487-1f3fc-200d-2640-fe0f.png",
				sheet_x: 25,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F487-1F3FD-200D-2640-FE0F",
				non_qualified: "1F487-1F3FD-200D-2640",
				image: "1f487-1f3fd-200d-2640-fe0f.png",
				sheet_x: 25,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F487-1F3FE-200D-2640-FE0F",
				non_qualified: "1F487-1F3FE-200D-2640",
				image: "1f487-1f3fe-200d-2640-fe0f.png",
				sheet_x: 25,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F487-1F3FF-200D-2640-FE0F",
				non_qualified: "1F487-1F3FF-200D-2640",
				image: "1f487-1f3ff-200d-2640-fe0f.png",
				sheet_x: 25,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F487",
		a: "Woman Getting Haircut",
		b: "1F487-200D-2640-FE0F",
		c: "1F487-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			25,
			0
		],
		o: 4
	},
	small_blue_diamond: {
		a: "Small Blue Diamond",
		b: "1F539",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			28
		],
		o: 2
	},
	"flag-sg": {
		a: "Singapore Flag",
		b: "1F1F8-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			6
		],
		o: 2
	},
	adhesive_bandage: {
		a: "Adhesive Bandage",
		b: "1FA79",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			56
		],
		o: 12
	},
	walking: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB",
				non_qualified: null,
				image: "1f6b6-1f3fb.png",
				sheet_x: 36,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC",
				non_qualified: null,
				image: "1f6b6-1f3fc.png",
				sheet_x: 36,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD",
				non_qualified: null,
				image: "1f6b6-1f3fd.png",
				sheet_x: 36,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE",
				non_qualified: null,
				image: "1f6b6-1f3fe.png",
				sheet_x: 36,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF",
				non_qualified: null,
				image: "1f6b6-1f3ff.png",
				sheet_x: 36,
				sheet_y: 7,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F6B6-200D-2642-FE0F",
		a: "Pedestrian",
		b: "1F6B6",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			36,
			2
		],
		o: 2
	},
	small_red_triangle: {
		a: "Up-Pointing Red Triangle",
		b: "1F53A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"direction",
			"up",
			"top"
		],
		k: [
			28,
			29
		],
		o: 2
	},
	"flag-sh": {
		a: "St. Helena Flag",
		b: "1F1F8-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			7
		],
		o: 2
	},
	stethoscope: {
		a: "Stethoscope",
		b: "1FA7A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			0
		],
		o: 12
	},
	"man-walking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FB-200D-2642",
				image: "1f6b6-1f3fb-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FC-200D-2642",
				image: "1f6b6-1f3fc-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FD-200D-2642",
				image: "1f6b6-1f3fd-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FE-200D-2642",
				image: "1f6b6-1f3fe-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FF-200D-2642",
				image: "1f6b6-1f3ff-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F6B6",
		a: "Man Walking",
		b: "1F6B6-200D-2642-FE0F",
		c: "1F6B6-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			53
		],
		o: 4
	},
	"flag-si": {
		a: "Slovenia Flag",
		b: "1F1F8-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			8
		],
		o: 2
	},
	door: {
		a: "Door",
		b: "1F6AA",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"house",
			"entry",
			"exit"
		],
		k: [
			35,
			1
		],
		o: 2
	},
	small_red_triangle_down: {
		a: "Down-Pointing Red Triangle",
		b: "1F53B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"direction",
			"bottom"
		],
		k: [
			28,
			30
		],
		o: 2
	},
	"flag-sj": {
		a: "Svalbard & Jan Mayen Flag",
		b: "1F1F8-1F1EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			9
		],
		o: 2
	},
	diamond_shape_with_a_dot_inside: {
		a: "Diamond Shape with a Dot Inside",
		b: "1F4A0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"jewel",
			"blue",
			"gem",
			"crystal",
			"fancy"
		],
		k: [
			25,
			42
		],
		o: 2
	},
	"woman-walking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FB-200D-2640",
				image: "1f6b6-1f3fb-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FC-200D-2640",
				image: "1f6b6-1f3fc-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FD-200D-2640",
				image: "1f6b6-1f3fd-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FE-200D-2640",
				image: "1f6b6-1f3fe-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FF-200D-2640",
				image: "1f6b6-1f3ff-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Walking",
		b: "1F6B6-200D-2640-FE0F",
		c: "1F6B6-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			47
		],
		o: 4
	},
	bed: {
		a: "Bed",
		b: "1F6CF-FE0F",
		c: "1F6CF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sleep",
			"rest"
		],
		k: [
			36,
			37
		],
		o: 2
	},
	radio_button: {
		a: "Radio Button",
		b: "1F518",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"input",
			"old",
			"music",
			"circle"
		],
		k: [
			27,
			52
		],
		o: 2
	},
	"flag-sk": {
		a: "Slovakia Flag",
		b: "1F1F8-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			10
		],
		o: 2
	},
	standing_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CD-1F3FB",
				non_qualified: null,
				image: "1f9cd-1f3fb.png",
				sheet_x: 44,
				sheet_y: 32,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CD-1F3FC",
				non_qualified: null,
				image: "1f9cd-1f3fc.png",
				sheet_x: 44,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CD-1F3FD",
				non_qualified: null,
				image: "1f9cd-1f3fd.png",
				sheet_x: 44,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CD-1F3FE",
				non_qualified: null,
				image: "1f9cd-1f3fe.png",
				sheet_x: 44,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CD-1F3FF",
				non_qualified: null,
				image: "1f9cd-1f3ff.png",
				sheet_x: 44,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Standing Person",
		b: "1F9CD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			31
		],
		o: 12
	},
	couch_and_lamp: {
		a: "Couch and Lamp",
		b: "1F6CB-FE0F",
		c: "1F6CB",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"read",
			"chill"
		],
		k: [
			36,
			28
		],
		o: 2
	},
	man_standing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CD-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9CD-1F3FB-200D-2642",
				image: "1f9cd-1f3fb-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 26,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CD-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9CD-1F3FC-200D-2642",
				image: "1f9cd-1f3fc-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CD-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9CD-1F3FD-200D-2642",
				image: "1f9cd-1f3fd-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CD-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9CD-1F3FE-200D-2642",
				image: "1f9cd-1f3fe-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 29,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CD-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9CD-1F3FF-200D-2642",
				image: "1f9cd-1f3ff-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Standing",
		b: "1F9CD-200D-2642-FE0F",
		c: "1F9CD-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			25
		],
		o: 12
	},
	white_square_button: {
		a: "White Square Button",
		b: "1F533",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"input"
		],
		k: [
			28,
			22
		],
		o: 2
	},
	"flag-sl": {
		a: "Sierra Leone Flag",
		b: "1F1F8-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			11
		],
		o: 2
	},
	chair: {
		a: "Chair",
		b: "1FA91",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			5
		],
		o: 12
	},
	toilet: {
		a: "Toilet",
		b: "1F6BD",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"restroom",
			"wc",
			"washroom",
			"bathroom",
			"potty"
		],
		k: [
			36,
			14
		],
		o: 2
	},
	black_square_button: {
		a: "Black Square Button",
		b: "1F532",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"shape",
			"input",
			"frame"
		],
		k: [
			28,
			21
		],
		o: 2
	},
	"flag-sm": {
		a: "San Marino Flag",
		b: "1F1F8-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			12
		],
		o: 2
	},
	woman_standing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CD-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9CD-1F3FB-200D-2640",
				image: "1f9cd-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CD-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9CD-1F3FC-200D-2640",
				image: "1f9cd-1f3fc-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CD-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9CD-1F3FD-200D-2640",
				image: "1f9cd-1f3fd-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CD-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9CD-1F3FE-200D-2640",
				image: "1f9cd-1f3fe-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 23,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CD-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9CD-1F3FF-200D-2640",
				image: "1f9cd-1f3ff-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Standing",
		b: "1F9CD-200D-2640-FE0F",
		c: "1F9CD-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			19
		],
		o: 12
	},
	kneeling_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CE-1F3FB",
				non_qualified: null,
				image: "1f9ce-1f3fb.png",
				sheet_x: 44,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CE-1F3FC",
				non_qualified: null,
				image: "1f9ce-1f3fc.png",
				sheet_x: 44,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CE-1F3FD",
				non_qualified: null,
				image: "1f9ce-1f3fd.png",
				sheet_x: 44,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CE-1F3FE",
				non_qualified: null,
				image: "1f9ce-1f3fe.png",
				sheet_x: 44,
				sheet_y: 53,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CE-1F3FF",
				non_qualified: null,
				image: "1f9ce-1f3ff.png",
				sheet_x: 44,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Kneeling Person",
		b: "1F9CE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			49
		],
		o: 12
	},
	shower: {
		a: "Shower",
		b: "1F6BF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"clean",
			"water",
			"bathroom"
		],
		k: [
			36,
			16
		],
		o: 2
	},
	"flag-sn": {
		a: "Senegal Flag",
		b: "1F1F8-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			13
		],
		o: 2
	},
	bathtub: {
		a: "Bathtub",
		b: "1F6C1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"clean",
			"shower",
			"bathroom"
		],
		k: [
			36,
			23
		],
		o: 2
	},
	"flag-so": {
		a: "Somalia Flag",
		b: "1F1F8-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			14
		],
		o: 2
	},
	man_kneeling: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CE-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9CE-1F3FB-200D-2642",
				image: "1f9ce-1f3fb-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 44,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CE-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9CE-1F3FC-200D-2642",
				image: "1f9ce-1f3fc-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 45,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CE-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9CE-1F3FD-200D-2642",
				image: "1f9ce-1f3fd-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 46,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CE-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9CE-1F3FE-200D-2642",
				image: "1f9ce-1f3fe-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 47,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CE-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9CE-1F3FF-200D-2642",
				image: "1f9ce-1f3ff-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Kneeling",
		b: "1F9CE-200D-2642-FE0F",
		c: "1F9CE-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			43
		],
		o: 12
	},
	"flag-sr": {
		a: "Suriname Flag",
		b: "1F1F8-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			15
		],
		o: 2
	},
	woman_kneeling: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9CE-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9CE-1F3FB-200D-2640",
				image: "1f9ce-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 38,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9CE-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9CE-1F3FC-200D-2640",
				image: "1f9ce-1f3fc-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9CE-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9CE-1F3FD-200D-2640",
				image: "1f9ce-1f3fd-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9CE-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9CE-1F3FE-200D-2640",
				image: "1f9ce-1f3fe-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 41,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9CE-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9CE-1F3FF-200D-2640",
				image: "1f9ce-1f3ff-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 42,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Kneeling",
		b: "1F9CE-200D-2640-FE0F",
		c: "1F9CE-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			44,
			37
		],
		o: 12
	},
	razor: {
		a: "Razor",
		b: "1FA92",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			52,
			6
		],
		o: 12
	},
	person_with_probing_cane: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9AF",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9af.png",
				sheet_x: 47,
				sheet_y: 8,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9AF",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9af.png",
				sheet_x: 47,
				sheet_y: 9,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9AF",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9af.png",
				sheet_x: 47,
				sheet_y: 10,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9AF",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9af.png",
				sheet_x: 47,
				sheet_y: 11,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9AF",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9af.png",
				sheet_x: 47,
				sheet_y: 12,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Person with Probing Cane",
		b: "1F9D1-200D-1F9AF",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			7
		],
		o: 12
	},
	"flag-ss": {
		a: "South Sudan Flag",
		b: "1F1F8-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			16
		],
		o: 2
	},
	lotion_bottle: {
		a: "Lotion Bottle",
		b: "1F9F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			39
		],
		o: 11
	},
	"flag-st": {
		a: "São Tomé & Príncipe Flag",
		b: "1F1F8-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			17
		],
		o: 2
	},
	safety_pin: {
		a: "Safety Pin",
		b: "1F9F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			42
		],
		o: 11
	},
	man_with_probing_cane: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9AF",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9af.png",
				sheet_x: 16,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9AF",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9af.png",
				sheet_x: 16,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9AF",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9af.png",
				sheet_x: 16,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9AF",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9af.png",
				sheet_x: 16,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9AF",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9af.png",
				sheet_x: 16,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man with Probing Cane",
		b: "1F468-200D-1F9AF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			17
		],
		o: 12
	},
	broom: {
		a: "Broom",
		b: "1F9F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			44
		],
		o: 11
	},
	woman_with_probing_cane: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9AF",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9af.png",
				sheet_x: 19,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9AF",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9af.png",
				sheet_x: 19,
				sheet_y: 4,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9AF",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9af.png",
				sheet_x: 19,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9AF",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9af.png",
				sheet_x: 19,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9AF",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9af.png",
				sheet_x: 19,
				sheet_y: 7,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman with Probing Cane",
		b: "1F469-200D-1F9AF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			2
		],
		o: 12
	},
	"flag-sv": {
		a: "El Salvador Flag",
		b: "1F1F8-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			18
		],
		o: 2
	},
	"flag-sx": {
		a: "Sint Maarten Flag",
		b: "1F1F8-1F1FD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			19
		],
		o: 2
	},
	basket: {
		a: "Basket",
		b: "1F9FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			45
		],
		o: 11
	},
	person_in_motorized_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9BC",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9bc.png",
				sheet_x: 47,
				sheet_y: 38,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9BC",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9bc.png",
				sheet_x: 47,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9BC",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9bc.png",
				sheet_x: 47,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9BC",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9bc.png",
				sheet_x: 47,
				sheet_y: 41,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9BC",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9bc.png",
				sheet_x: 47,
				sheet_y: 42,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Person in Motorized Wheelchair",
		b: "1F9D1-200D-1F9BC",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			37
		],
		o: 12
	},
	man_in_motorized_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9BC",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9bc.png",
				sheet_x: 16,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9BC",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9bc.png",
				sheet_x: 16,
				sheet_y: 49,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9BC",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9bc.png",
				sheet_x: 16,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9BC",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9bc.png",
				sheet_x: 16,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9BC",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9bc.png",
				sheet_x: 16,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man in Motorized Wheelchair",
		b: "1F468-200D-1F9BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			47
		],
		o: 12
	},
	"flag-sy": {
		a: "Syria Flag",
		b: "1F1F8-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			20
		],
		o: 2
	},
	roll_of_paper: {
		a: "Roll of Paper",
		b: "1F9FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			46
		],
		o: 11
	},
	woman_in_motorized_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9BC",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9bc.png",
				sheet_x: 19,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9BC",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9bc.png",
				sheet_x: 19,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9BC",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9bc.png",
				sheet_x: 19,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9BC",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9bc.png",
				sheet_x: 19,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9BC",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9bc.png",
				sheet_x: 19,
				sheet_y: 37,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman in Motorized Wheelchair",
		b: "1F469-200D-1F9BC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			32
		],
		o: 12
	},
	"flag-sz": {
		a: "Eswatini Flag",
		b: "1F1F8-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			21
		],
		o: 2
	},
	soap: {
		a: "Bar of Soap",
		b: "1F9FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			47
		],
		o: 11
	},
	"flag-ta": {
		a: "Tristan Da Cunha Flag",
		b: "1F1F9-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			22
		],
		o: 2
	},
	sponge: {
		a: "Sponge",
		b: "1F9FD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			48
		],
		o: 11
	},
	person_in_manual_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F9BD",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f9bd.png",
				sheet_x: 47,
				sheet_y: 44,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F9BD",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f9bd.png",
				sheet_x: 47,
				sheet_y: 45,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F9BD",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f9bd.png",
				sheet_x: 47,
				sheet_y: 46,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F9BD",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f9bd.png",
				sheet_x: 47,
				sheet_y: 47,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F9BD",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f9bd.png",
				sheet_x: 47,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: false,
				has_img_facebook: false
			}
		},
		a: "Person in Manual Wheelchair",
		b: "1F9D1-200D-1F9BD",
		d: true,
		e: false,
		f: false,
		h: false,
		k: [
			47,
			43
		],
		o: 12
	},
	fire_extinguisher: {
		a: "Fire Extinguisher",
		b: "1F9EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			51,
			34
		],
		o: 11
	},
	man_in_manual_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F9BD",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f9bd.png",
				sheet_x: 16,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F9BD",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f9bd.png",
				sheet_x: 16,
				sheet_y: 55,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F9BD",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f9bd.png",
				sheet_x: 16,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F9BD",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f9bd.png",
				sheet_x: 17,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F9BD",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f9bd.png",
				sheet_x: 17,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man in Manual Wheelchair",
		b: "1F468-200D-1F9BD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			16,
			53
		],
		o: 12
	},
	"flag-tc": {
		a: "Turks & Caicos Islands Flag",
		b: "1F1F9-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			23
		],
		o: 2
	},
	woman_in_manual_wheelchair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F9BD",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f9bd.png",
				sheet_x: 19,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F9BD",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f9bd.png",
				sheet_x: 19,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F9BD",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f9bd.png",
				sheet_x: 19,
				sheet_y: 41,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F9BD",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f9bd.png",
				sheet_x: 19,
				sheet_y: 42,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F9BD",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f9bd.png",
				sheet_x: 19,
				sheet_y: 43,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman in Manual Wheelchair",
		b: "1F469-200D-1F9BD",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			19,
			38
		],
		o: 12
	},
	"flag-td": {
		a: "Chad Flag",
		b: "1F1F9-1F1E9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			24
		],
		o: 2
	},
	shopping_trolley: {
		a: "Shopping Trolley",
		b: "1F6D2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			40
		],
		o: 4
	},
	runner: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB",
				non_qualified: null,
				image: "1f3c3-1f3fb.png",
				sheet_x: 9,
				sheet_y: 2,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC",
				non_qualified: null,
				image: "1f3c3-1f3fc.png",
				sheet_x: 9,
				sheet_y: 3,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD",
				non_qualified: null,
				image: "1f3c3-1f3fd.png",
				sheet_x: 9,
				sheet_y: 4,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE",
				non_qualified: null,
				image: "1f3c3-1f3fe.png",
				sheet_x: 9,
				sheet_y: 5,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF",
				non_qualified: null,
				image: "1f3c3-1f3ff.png",
				sheet_x: 9,
				sheet_y: 6,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F3C3-200D-2642-FE0F",
		a: "Runner",
		b: "1F3C3",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			9,
			1
		],
		n: [
			"running"
		],
		o: 2
	},
	"flag-tf": {
		a: "French Southern Territories Flag",
		b: "1F1F9-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			25
		],
		o: 2
	},
	smoking: {
		a: "Smoking Symbol",
		b: "1F6AC",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"kills",
			"tobacco",
			"cigarette",
			"joint",
			"smoke"
		],
		k: [
			35,
			3
		],
		o: 2
	},
	coffin: {
		a: "Coffin",
		b: "26B0-FE0F",
		c: "26B0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"vampire",
			"dead",
			"die",
			"death",
			"rip",
			"graveyard",
			"cemetery",
			"casket",
			"funeral",
			"box"
		],
		k: [
			53,
			54
		],
		o: 2
	},
	"man-running": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FB-200D-2642",
				image: "1f3c3-1f3fb-200d-2642-fe0f.png",
				sheet_x: 8,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FC-200D-2642",
				image: "1f3c3-1f3fc-200d-2642-fe0f.png",
				sheet_x: 8,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FD-200D-2642",
				image: "1f3c3-1f3fd-200d-2642-fe0f.png",
				sheet_x: 8,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FE-200D-2642",
				image: "1f3c3-1f3fe-200d-2642-fe0f.png",
				sheet_x: 8,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FF-200D-2642",
				image: "1f3c3-1f3ff-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F3C3",
		a: "Man Running",
		b: "1F3C3-200D-2642-FE0F",
		c: "1F3C3-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			8,
			52
		],
		o: 4
	},
	"flag-tg": {
		a: "Togo Flag",
		b: "1F1F9-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			26
		],
		o: 2
	},
	"woman-running": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FB-200D-2640",
				image: "1f3c3-1f3fb-200d-2640-fe0f.png",
				sheet_x: 8,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FC-200D-2640",
				image: "1f3c3-1f3fc-200d-2640-fe0f.png",
				sheet_x: 8,
				sheet_y: 48,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FD-200D-2640",
				image: "1f3c3-1f3fd-200d-2640-fe0f.png",
				sheet_x: 8,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FE-200D-2640",
				image: "1f3c3-1f3fe-200d-2640-fe0f.png",
				sheet_x: 8,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FF-200D-2640",
				image: "1f3c3-1f3ff-200d-2640-fe0f.png",
				sheet_x: 8,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Running",
		b: "1F3C3-200D-2640-FE0F",
		c: "1F3C3-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			8,
			46
		],
		o: 4
	},
	funeral_urn: {
		a: "Funeral Urn",
		b: "26B1-FE0F",
		c: "26B1",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"dead",
			"die",
			"death",
			"rip",
			"ashes"
		],
		k: [
			53,
			55
		],
		o: 2
	},
	"flag-th": {
		a: "Thailand Flag",
		b: "1F1F9-1F1ED",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			27
		],
		o: 2
	},
	moyai: {
		a: "Moyai",
		b: "1F5FF",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"rock",
			"easter island",
			"moai"
		],
		k: [
			30,
			34
		],
		o: 2
	},
	"flag-tj": {
		a: "Tajikistan Flag",
		b: "1F1F9-1F1EF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			28
		],
		o: 2
	},
	dancer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F483-1F3FB",
				non_qualified: null,
				image: "1f483-1f3fb.png",
				sheet_x: 24,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F483-1F3FC",
				non_qualified: null,
				image: "1f483-1f3fc.png",
				sheet_x: 24,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F483-1F3FD",
				non_qualified: null,
				image: "1f483-1f3fd.png",
				sheet_x: 24,
				sheet_y: 29,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F483-1F3FE",
				non_qualified: null,
				image: "1f483-1f3fe.png",
				sheet_x: 24,
				sheet_y: 30,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F483-1F3FF",
				non_qualified: null,
				image: "1f483-1f3ff.png",
				sheet_x: 24,
				sheet_y: 31,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Dancer",
		b: "1F483",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"female",
			"girl",
			"woman",
			"fun"
		],
		k: [
			24,
			26
		],
		o: 2
	},
	"flag-tk": {
		a: "Tokelau Flag",
		b: "1F1F9-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			29
		],
		o: 2
	},
	man_dancing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F57A-1F3FB",
				non_qualified: null,
				image: "1f57a-1f3fb.png",
				sheet_x: 29,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F57A-1F3FC",
				non_qualified: null,
				image: "1f57a-1f3fc.png",
				sheet_x: 29,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F57A-1F3FD",
				non_qualified: null,
				image: "1f57a-1f3fd.png",
				sheet_x: 29,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F57A-1F3FE",
				non_qualified: null,
				image: "1f57a-1f3fe.png",
				sheet_x: 29,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F57A-1F3FF",
				non_qualified: null,
				image: "1f57a-1f3ff.png",
				sheet_x: 29,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Dancing",
		b: "1F57A",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"male",
			"boy",
			"fun",
			"dancer"
		],
		k: [
			29,
			37
		],
		o: 4
	},
	"flag-tl": {
		a: "Timor-Leste Flag",
		b: "1F1F9-1F1F1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			30
		],
		o: 2
	},
	man_in_business_suit_levitating: {
		skin_variations: {
			"1F3FB": {
				unified: "1F574-1F3FB",
				non_qualified: null,
				image: "1f574-1f3fb.png",
				sheet_x: 29,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F574-1F3FC",
				non_qualified: null,
				image: "1f574-1f3fc.png",
				sheet_x: 29,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F574-1F3FD",
				non_qualified: null,
				image: "1f574-1f3fd.png",
				sheet_x: 29,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F574-1F3FE",
				non_qualified: null,
				image: "1f574-1f3fe.png",
				sheet_x: 29,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F574-1F3FF",
				non_qualified: null,
				image: "1f574-1f3ff.png",
				sheet_x: 29,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man in Business Suit Levitating",
		b: "1F574-FE0F",
		c: "1F574",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			29,
			9
		],
		o: 2
	},
	"flag-tm": {
		a: "Turkmenistan Flag",
		b: "1F1F9-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			31
		],
		o: 2
	},
	dancers: {
		obsoleted_by: "1F46F-200D-2640-FE0F",
		a: "Woman with Bunny Ears",
		b: "1F46F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			22,
			0
		],
		o: 2
	},
	"man-with-bunny-ears-partying": {
		a: "Man with Bunny Ears Partying",
		b: "1F46F-200D-2642-FE0F",
		c: "1F46F-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			21,
			56
		],
		o: 4
	},
	"flag-tn": {
		a: "Tunisia Flag",
		b: "1F1F9-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			32
		],
		o: 2
	},
	"flag-to": {
		a: "Tonga Flag",
		b: "1F1F9-1F1F4",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			33
		],
		o: 2
	},
	"woman-with-bunny-ears-partying": {
		obsoletes: "1F46F",
		a: "Woman with Bunny Ears Partying",
		b: "1F46F-200D-2640-FE0F",
		c: "1F46F-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			21,
			55
		],
		o: 4
	},
	"flag-tr": {
		a: "Turkey Flag",
		b: "1F1F9-1F1F7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			34
		],
		o: 2
	},
	person_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB",
				non_qualified: null,
				image: "1f9d6-1f3fb.png",
				sheet_x: 48,
				sheet_y: 53,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC",
				non_qualified: null,
				image: "1f9d6-1f3fc.png",
				sheet_x: 48,
				sheet_y: 54,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD",
				non_qualified: null,
				image: "1f9d6-1f3fd.png",
				sheet_x: 48,
				sheet_y: 55,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE",
				non_qualified: null,
				image: "1f9d6-1f3fe.png",
				sheet_x: 48,
				sheet_y: 56,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF",
				non_qualified: null,
				image: "1f9d6-1f3ff.png",
				sheet_x: 49,
				sheet_y: 0,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9D6-200D-2642-FE0F",
		a: "Person in Steamy Room",
		b: "1F9D6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			52
		],
		o: 5
	},
	man_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FB-200D-2642",
				image: "1f9d6-1f3fb-200d-2642-fe0f.png",
				sheet_x: 48,
				sheet_y: 47,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D6-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FC-200D-2642",
				image: "1f9d6-1f3fc-200d-2642-fe0f.png",
				sheet_x: 48,
				sheet_y: 48,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D6-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FD-200D-2642",
				image: "1f9d6-1f3fd-200d-2642-fe0f.png",
				sheet_x: 48,
				sheet_y: 49,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D6-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FE-200D-2642",
				image: "1f9d6-1f3fe-200d-2642-fe0f.png",
				sheet_x: 48,
				sheet_y: 50,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D6-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FF-200D-2642",
				image: "1f9d6-1f3ff-200d-2642-fe0f.png",
				sheet_x: 48,
				sheet_y: 51,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D6-1F3FF"
			}
		},
		obsoletes: "1F9D6",
		a: "Man in Steamy Room",
		b: "1F9D6-200D-2642-FE0F",
		c: "1F9D6-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			46
		],
		o: 5
	},
	"flag-tt": {
		a: "Trinidad & Tobago Flag",
		b: "1F1F9-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			35
		],
		o: 2
	},
	woman_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FB-200D-2640",
				image: "1f9d6-1f3fb-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 41,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FC-200D-2640",
				image: "1f9d6-1f3fc-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 42,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FD-200D-2640",
				image: "1f9d6-1f3fd-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 43,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FE-200D-2640",
				image: "1f9d6-1f3fe-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 44,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FF-200D-2640",
				image: "1f9d6-1f3ff-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 45,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman in Steamy Room",
		b: "1F9D6-200D-2640-FE0F",
		c: "1F9D6-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			48,
			40
		],
		o: 5
	},
	"flag-tv": {
		a: "Tuvalu Flag",
		b: "1F1F9-1F1FB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			36
		],
		o: 2
	},
	"flag-tw": {
		a: "Taiwan Flag",
		b: "1F1F9-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			37
		],
		o: 2
	},
	person_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB",
				non_qualified: null,
				image: "1f9d7-1f3fb.png",
				sheet_x: 49,
				sheet_y: 14,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC",
				non_qualified: null,
				image: "1f9d7-1f3fc.png",
				sheet_x: 49,
				sheet_y: 15,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD",
				non_qualified: null,
				image: "1f9d7-1f3fd.png",
				sheet_x: 49,
				sheet_y: 16,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE",
				non_qualified: null,
				image: "1f9d7-1f3fe.png",
				sheet_x: 49,
				sheet_y: 17,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF",
				non_qualified: null,
				image: "1f9d7-1f3ff.png",
				sheet_x: 49,
				sheet_y: 18,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D7-200D-2640-FE0F",
		a: "Person Climbing",
		b: "1F9D7",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			13
		],
		o: 5
	},
	man_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FB-200D-2642",
				image: "1f9d7-1f3fb-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 8,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FC-200D-2642",
				image: "1f9d7-1f3fc-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 9,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FD-200D-2642",
				image: "1f9d7-1f3fd-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 10,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FE-200D-2642",
				image: "1f9d7-1f3fe-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 11,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FF-200D-2642",
				image: "1f9d7-1f3ff-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 12,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Climbing",
		b: "1F9D7-200D-2642-FE0F",
		c: "1F9D7-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			7
		],
		o: 5
	},
	"flag-tz": {
		a: "Tanzania Flag",
		b: "1F1F9-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			38
		],
		o: 2
	},
	"flag-ua": {
		a: "Ukraine Flag",
		b: "1F1FA-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			39
		],
		o: 2
	},
	woman_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FB-200D-2640",
				image: "1f9d7-1f3fb-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 2,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D7-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FC-200D-2640",
				image: "1f9d7-1f3fc-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 3,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D7-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FD-200D-2640",
				image: "1f9d7-1f3fd-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 4,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D7-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FE-200D-2640",
				image: "1f9d7-1f3fe-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 5,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D7-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FF-200D-2640",
				image: "1f9d7-1f3ff-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 6,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D7-1F3FF"
			}
		},
		obsoletes: "1F9D7",
		a: "Woman Climbing",
		b: "1F9D7-200D-2640-FE0F",
		c: "1F9D7-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			1
		],
		o: 5
	},
	"flag-ug": {
		a: "Uganda Flag",
		b: "1F1FA-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			40
		],
		o: 2
	},
	fencer: {
		a: "Fencer",
		b: "1F93A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			32
		],
		o: 4
	},
	"flag-um": {
		a: "U.s. Outlying Islands Flag",
		b: "1F1FA-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			41
		],
		o: 2
	},
	horse_racing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C7-1F3FB",
				non_qualified: null,
				image: "1f3c7-1f3fb.png",
				sheet_x: 9,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C7-1F3FC",
				non_qualified: null,
				image: "1f3c7-1f3fc.png",
				sheet_x: 9,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C7-1F3FD",
				non_qualified: null,
				image: "1f3c7-1f3fd.png",
				sheet_x: 9,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C7-1F3FE",
				non_qualified: null,
				image: "1f3c7-1f3fe.png",
				sheet_x: 9,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C7-1F3FF",
				non_qualified: null,
				image: "1f3c7-1f3ff.png",
				sheet_x: 9,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Horse Racing",
		b: "1F3C7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"animal",
			"betting",
			"competition",
			"gambling",
			"luck"
		],
		k: [
			9,
			27
		],
		o: 2
	},
	skier: {
		a: "Skier",
		b: "26F7-FE0F",
		c: "26F7",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"winter",
			"snow"
		],
		k: [
			54,
			17
		],
		o: 2
	},
	"flag-un": {
		a: "United Nations Flag",
		b: "1F1FA-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			42
		],
		o: 4
	},
	us: {
		a: "United States Flag",
		b: "1F1FA-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"united",
			"states",
			"america",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			4,
			43
		],
		n: [
			"flag-us"
		],
		o: 2
	},
	snowboarder: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C2-1F3FB",
				non_qualified: null,
				image: "1f3c2-1f3fb.png",
				sheet_x: 8,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C2-1F3FC",
				non_qualified: null,
				image: "1f3c2-1f3fc.png",
				sheet_x: 8,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C2-1F3FD",
				non_qualified: null,
				image: "1f3c2-1f3fd.png",
				sheet_x: 8,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C2-1F3FE",
				non_qualified: null,
				image: "1f3c2-1f3fe.png",
				sheet_x: 8,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C2-1F3FF",
				non_qualified: null,
				image: "1f3c2-1f3ff.png",
				sheet_x: 8,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Snowboarder",
		b: "1F3C2",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"sports",
			"winter"
		],
		k: [
			8,
			40
		],
		o: 2
	},
	golfer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB",
				non_qualified: null,
				image: "1f3cc-1f3fb.png",
				sheet_x: 10,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC",
				non_qualified: null,
				image: "1f3cc-1f3fc.png",
				sheet_x: 10,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD",
				non_qualified: null,
				image: "1f3cc-1f3fd.png",
				sheet_x: 10,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE",
				non_qualified: null,
				image: "1f3cc-1f3fe.png",
				sheet_x: 10,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF",
				non_qualified: null,
				image: "1f3cc-1f3ff.png",
				sheet_x: 10,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
		a: "Golfer",
		b: "1F3CC-FE0F",
		c: "1F3CC",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			10,
			26
		],
		o: 2
	},
	"flag-uy": {
		a: "Uruguay Flag",
		b: "1F1FA-1F1FE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			44
		],
		o: 2
	},
	"flag-uz": {
		a: "Uzbekistan Flag",
		b: "1F1FA-1F1FF",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			45
		],
		o: 2
	},
	"man-golfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FB-200D-2642",
				image: "1f3cc-1f3fb-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FC-200D-2642",
				image: "1f3cc-1f3fc-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FD-200D-2642",
				image: "1f3cc-1f3fd-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 23,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FE-200D-2642",
				image: "1f3cc-1f3fe-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FF-200D-2642",
				image: "1f3cc-1f3ff-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F3CC-FE0F",
		a: "Man Golfing",
		b: "1F3CC-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			10,
			20
		],
		o: 4
	},
	"flag-va": {
		a: "Vatican City Flag",
		b: "1F1FB-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			46
		],
		o: 2
	},
	"woman-golfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FB-200D-2640",
				image: "1f3cc-1f3fb-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FC-200D-2640",
				image: "1f3cc-1f3fc-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FD-200D-2640",
				image: "1f3cc-1f3fd-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FE-200D-2640",
				image: "1f3cc-1f3fe-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FF-200D-2640",
				image: "1f3cc-1f3ff-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Golfing",
		b: "1F3CC-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			10,
			14
		],
		o: 4
	},
	"flag-vc": {
		a: "St. Vincent & Grenadines Flag",
		b: "1F1FB-1F1E8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			47
		],
		o: 2
	},
	surfer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB",
				non_qualified: null,
				image: "1f3c4-1f3fb.png",
				sheet_x: 9,
				sheet_y: 20,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC",
				non_qualified: null,
				image: "1f3c4-1f3fc.png",
				sheet_x: 9,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD",
				non_qualified: null,
				image: "1f3c4-1f3fd.png",
				sheet_x: 9,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE",
				non_qualified: null,
				image: "1f3c4-1f3fe.png",
				sheet_x: 9,
				sheet_y: 23,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF",
				non_qualified: null,
				image: "1f3c4-1f3ff.png",
				sheet_x: 9,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F3C4-200D-2642-FE0F",
		a: "Surfer",
		b: "1F3C4",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			9,
			19
		],
		o: 2
	},
	"man-surfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FB-200D-2642",
				image: "1f3c4-1f3fb-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FC-200D-2642",
				image: "1f3c4-1f3fc-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FD-200D-2642",
				image: "1f3c4-1f3fd-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FE-200D-2642",
				image: "1f3c4-1f3fe-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FF-200D-2642",
				image: "1f3c4-1f3ff-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F3C4",
		a: "Man Surfing",
		b: "1F3C4-200D-2642-FE0F",
		c: "1F3C4-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			9,
			13
		],
		o: 4
	},
	"flag-ve": {
		a: "Venezuela Flag",
		b: "1F1FB-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			48
		],
		o: 2
	},
	"flag-vg": {
		a: "British Virgin Islands Flag",
		b: "1F1FB-1F1EC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			49
		],
		o: 2
	},
	"woman-surfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FB-200D-2640",
				image: "1f3c4-1f3fb-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FC-200D-2640",
				image: "1f3c4-1f3fc-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FD-200D-2640",
				image: "1f3c4-1f3fd-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FE-200D-2640",
				image: "1f3c4-1f3fe-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FF-200D-2640",
				image: "1f3c4-1f3ff-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Surfing",
		b: "1F3C4-200D-2640-FE0F",
		c: "1F3C4-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			9,
			7
		],
		o: 4
	},
	rowboat: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB",
				non_qualified: null,
				image: "1f6a3-1f3fb.png",
				sheet_x: 34,
				sheet_y: 47,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC",
				non_qualified: null,
				image: "1f6a3-1f3fc.png",
				sheet_x: 34,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD",
				non_qualified: null,
				image: "1f6a3-1f3fd.png",
				sheet_x: 34,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE",
				non_qualified: null,
				image: "1f6a3-1f3fe.png",
				sheet_x: 34,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF",
				non_qualified: null,
				image: "1f6a3-1f3ff.png",
				sheet_x: 34,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F6A3-200D-2642-FE0F",
		a: "Rowboat",
		b: "1F6A3",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			34,
			46
		],
		o: 2
	},
	"flag-vi": {
		a: "U.s. Virgin Islands Flag",
		b: "1F1FB-1F1EE",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			50
		],
		o: 2
	},
	"man-rowing-boat": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FB-200D-2642",
				image: "1f6a3-1f3fb-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FC-200D-2642",
				image: "1f6a3-1f3fc-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FD-200D-2642",
				image: "1f6a3-1f3fd-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FE-200D-2642",
				image: "1f6a3-1f3fe-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FF-200D-2642",
				image: "1f6a3-1f3ff-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F6A3",
		a: "Man Rowing Boat",
		b: "1F6A3-200D-2642-FE0F",
		c: "1F6A3-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			34,
			40
		],
		o: 4
	},
	"flag-vn": {
		a: "Vietnam Flag",
		b: "1F1FB-1F1F3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			51
		],
		o: 2
	},
	"flag-vu": {
		a: "Vanuatu Flag",
		b: "1F1FB-1F1FA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			52
		],
		o: 2
	},
	"woman-rowing-boat": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FB-200D-2640",
				image: "1f6a3-1f3fb-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 35,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FC-200D-2640",
				image: "1f6a3-1f3fc-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FD-200D-2640",
				image: "1f6a3-1f3fd-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FE-200D-2640",
				image: "1f6a3-1f3fe-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FF-200D-2640",
				image: "1f6a3-1f3ff-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Rowing Boat",
		b: "1F6A3-200D-2640-FE0F",
		c: "1F6A3-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			34,
			34
		],
		o: 4
	},
	swimmer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB",
				non_qualified: null,
				image: "1f3ca-1f3fb.png",
				sheet_x: 9,
				sheet_y: 48,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC",
				non_qualified: null,
				image: "1f3ca-1f3fc.png",
				sheet_x: 9,
				sheet_y: 49,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD",
				non_qualified: null,
				image: "1f3ca-1f3fd.png",
				sheet_x: 9,
				sheet_y: 50,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE",
				non_qualified: null,
				image: "1f3ca-1f3fe.png",
				sheet_x: 9,
				sheet_y: 51,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF",
				non_qualified: null,
				image: "1f3ca-1f3ff.png",
				sheet_x: 9,
				sheet_y: 52,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F3CA-200D-2642-FE0F",
		a: "Swimmer",
		b: "1F3CA",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			9,
			47
		],
		o: 2
	},
	"flag-wf": {
		a: "Wallis & Futuna Flag",
		b: "1F1FC-1F1EB",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			53
		],
		o: 2
	},
	"man-swimming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FB-200D-2642",
				image: "1f3ca-1f3fb-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 42,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FC-200D-2642",
				image: "1f3ca-1f3fc-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FD-200D-2642",
				image: "1f3ca-1f3fd-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FE-200D-2642",
				image: "1f3ca-1f3fe-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FF-200D-2642",
				image: "1f3ca-1f3ff-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F3CA",
		a: "Man Swimming",
		b: "1F3CA-200D-2642-FE0F",
		c: "1F3CA-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			9,
			41
		],
		o: 4
	},
	"flag-ws": {
		a: "Samoa Flag",
		b: "1F1FC-1F1F8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			54
		],
		o: 2
	},
	"woman-swimming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FB-200D-2640",
				image: "1f3ca-1f3fb-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FC-200D-2640",
				image: "1f3ca-1f3fc-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FD-200D-2640",
				image: "1f3ca-1f3fd-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FE-200D-2640",
				image: "1f3ca-1f3fe-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FF-200D-2640",
				image: "1f3ca-1f3ff-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Swimming",
		b: "1F3CA-200D-2640-FE0F",
		c: "1F3CA-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			9,
			35
		],
		o: 4
	},
	"flag-xk": {
		a: "Kosovo Flag",
		b: "1F1FD-1F1F0",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			55
		],
		o: 2
	},
	person_with_ball: {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB",
				non_qualified: null,
				image: "26f9-1f3fb.png",
				sheet_x: 54,
				sheet_y: 32,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "26F9-1F3FC",
				non_qualified: null,
				image: "26f9-1f3fc.png",
				sheet_x: 54,
				sheet_y: 33,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "26F9-1F3FD",
				non_qualified: null,
				image: "26f9-1f3fd.png",
				sheet_x: 54,
				sheet_y: 34,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "26F9-1F3FE",
				non_qualified: null,
				image: "26f9-1f3fe.png",
				sheet_x: 54,
				sheet_y: 35,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "26F9-1F3FF",
				non_qualified: null,
				image: "26f9-1f3ff.png",
				sheet_x: 54,
				sheet_y: 36,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
		a: "Person with Ball",
		b: "26F9-FE0F",
		c: "26F9",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			54,
			31
		],
		o: 2
	},
	"flag-ye": {
		a: "Yemen Flag",
		b: "1F1FE-1F1EA",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			4,
			56
		],
		o: 2
	},
	"man-bouncing-ball": {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB-200D-2642-FE0F",
				non_qualified: "26F9-1F3FB-200D-2642",
				image: "26f9-1f3fb-200d-2642-fe0f.png",
				sheet_x: 54,
				sheet_y: 26,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "26F9-1F3FC-200D-2642-FE0F",
				non_qualified: "26F9-1F3FC-200D-2642",
				image: "26f9-1f3fc-200d-2642-fe0f.png",
				sheet_x: 54,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "26F9-1F3FD-200D-2642-FE0F",
				non_qualified: "26F9-1F3FD-200D-2642",
				image: "26f9-1f3fd-200d-2642-fe0f.png",
				sheet_x: 54,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "26F9-1F3FE-200D-2642-FE0F",
				non_qualified: "26F9-1F3FE-200D-2642",
				image: "26f9-1f3fe-200d-2642-fe0f.png",
				sheet_x: 54,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "26F9-1F3FF-200D-2642-FE0F",
				non_qualified: "26F9-1F3FF-200D-2642",
				image: "26f9-1f3ff-200d-2642-fe0f.png",
				sheet_x: 54,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "26F9-FE0F",
		a: "Man Bouncing Ball",
		b: "26F9-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			54,
			25
		],
		o: 4
	},
	"flag-yt": {
		a: "Mayotte Flag",
		b: "1F1FE-1F1F9",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			0
		],
		o: 2
	},
	"woman-bouncing-ball": {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB-200D-2640-FE0F",
				non_qualified: "26F9-1F3FB-200D-2640",
				image: "26f9-1f3fb-200d-2640-fe0f.png",
				sheet_x: 54,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "26F9-1F3FC-200D-2640-FE0F",
				non_qualified: "26F9-1F3FC-200D-2640",
				image: "26f9-1f3fc-200d-2640-fe0f.png",
				sheet_x: 54,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "26F9-1F3FD-200D-2640-FE0F",
				non_qualified: "26F9-1F3FD-200D-2640",
				image: "26f9-1f3fd-200d-2640-fe0f.png",
				sheet_x: 54,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "26F9-1F3FE-200D-2640-FE0F",
				non_qualified: "26F9-1F3FE-200D-2640",
				image: "26f9-1f3fe-200d-2640-fe0f.png",
				sheet_x: 54,
				sheet_y: 23,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "26F9-1F3FF-200D-2640-FE0F",
				non_qualified: "26F9-1F3FF-200D-2640",
				image: "26f9-1f3ff-200d-2640-fe0f.png",
				sheet_x: 54,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Bouncing Ball",
		b: "26F9-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			54,
			19
		],
		o: 4
	},
	"flag-za": {
		a: "South Africa Flag",
		b: "1F1FF-1F1E6",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			1
		],
		o: 2
	},
	"flag-zm": {
		a: "Zambia Flag",
		b: "1F1FF-1F1F2",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			2
		],
		o: 2
	},
	weight_lifter: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB",
				non_qualified: null,
				image: "1f3cb-1f3fb.png",
				sheet_x: 10,
				sheet_y: 9,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC",
				non_qualified: null,
				image: "1f3cb-1f3fc.png",
				sheet_x: 10,
				sheet_y: 10,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD",
				non_qualified: null,
				image: "1f3cb-1f3fd.png",
				sheet_x: 10,
				sheet_y: 11,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE",
				non_qualified: null,
				image: "1f3cb-1f3fe.png",
				sheet_x: 10,
				sheet_y: 12,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF",
				non_qualified: null,
				image: "1f3cb-1f3ff.png",
				sheet_x: 10,
				sheet_y: 13,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
		a: "Weight Lifter",
		b: "1F3CB-FE0F",
		c: "1F3CB",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			10,
			8
		],
		o: 2
	},
	"man-lifting-weights": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FB-200D-2642",
				image: "1f3cb-1f3fb-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FC-200D-2642",
				image: "1f3cb-1f3fc-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FD-200D-2642",
				image: "1f3cb-1f3fd-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FE-200D-2642",
				image: "1f3cb-1f3fe-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FF-200D-2642",
				image: "1f3cb-1f3ff-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F3CB-FE0F",
		a: "Man Lifting Weights",
		b: "1F3CB-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			10,
			2
		],
		o: 4
	},
	"flag-zw": {
		a: "Zimbabwe Flag",
		b: "1F1FF-1F1FC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			5,
			3
		],
		o: 2
	},
	"woman-lifting-weights": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FB-200D-2640",
				image: "1f3cb-1f3fb-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FC-200D-2640",
				image: "1f3cb-1f3fc-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FD-200D-2640",
				image: "1f3cb-1f3fd-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FE-200D-2640",
				image: "1f3cb-1f3fe-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FF-200D-2640",
				image: "1f3cb-1f3ff-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Lifting Weights",
		b: "1F3CB-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			9,
			53
		],
		o: 4
	},
	"flag-england": {
		a: "England Flag",
		b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			14
		],
		o: 5
	},
	bicyclist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB",
				non_qualified: null,
				image: "1f6b4-1f3fb.png",
				sheet_x: 35,
				sheet_y: 24,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC",
				non_qualified: null,
				image: "1f6b4-1f3fc.png",
				sheet_x: 35,
				sheet_y: 25,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD",
				non_qualified: null,
				image: "1f6b4-1f3fd.png",
				sheet_x: 35,
				sheet_y: 26,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE",
				non_qualified: null,
				image: "1f6b4-1f3fe.png",
				sheet_x: 35,
				sheet_y: 27,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF",
				non_qualified: null,
				image: "1f6b4-1f3ff.png",
				sheet_x: 35,
				sheet_y: 28,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F6B4-200D-2642-FE0F",
		a: "Bicyclist",
		b: "1F6B4",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			35,
			23
		],
		o: 2
	},
	"flag-scotland": {
		a: "Scotland Flag",
		b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			15
		],
		o: 5
	},
	"flag-wales": {
		a: "Wales Flag",
		b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			11,
			16
		],
		o: 5
	},
	"man-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FB-200D-2642",
				image: "1f6b4-1f3fb-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FC-200D-2642",
				image: "1f6b4-1f3fc-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FD-200D-2642",
				image: "1f6b4-1f3fd-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 20,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FE-200D-2642",
				image: "1f6b4-1f3fe-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FF-200D-2642",
				image: "1f6b4-1f3ff-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F6B4",
		a: "Man Biking",
		b: "1F6B4-200D-2642-FE0F",
		c: "1F6B4-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			17
		],
		o: 4
	},
	"woman-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FB-200D-2640",
				image: "1f6b4-1f3fb-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FC-200D-2640",
				image: "1f6b4-1f3fc-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FD-200D-2640",
				image: "1f6b4-1f3fd-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FE-200D-2640",
				image: "1f6b4-1f3fe-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FF-200D-2640",
				image: "1f6b4-1f3ff-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Biking",
		b: "1F6B4-200D-2640-FE0F",
		c: "1F6B4-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			11
		],
		o: 4
	},
	mountain_bicyclist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB",
				non_qualified: null,
				image: "1f6b5-1f3fb.png",
				sheet_x: 35,
				sheet_y: 42,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC",
				non_qualified: null,
				image: "1f6b5-1f3fc.png",
				sheet_x: 35,
				sheet_y: 43,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD",
				non_qualified: null,
				image: "1f6b5-1f3fd.png",
				sheet_x: 35,
				sheet_y: 44,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE",
				non_qualified: null,
				image: "1f6b5-1f3fe.png",
				sheet_x: 35,
				sheet_y: 45,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF",
				non_qualified: null,
				image: "1f6b5-1f3ff.png",
				sheet_x: 35,
				sheet_y: 46,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		obsoleted_by: "1F6B5-200D-2642-FE0F",
		a: "Mountain Bicyclist",
		b: "1F6B5",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			35,
			41
		],
		o: 2
	},
	"man-mountain-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FB-200D-2642",
				image: "1f6b5-1f3fb-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 36,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FC-200D-2642",
				image: "1f6b5-1f3fc-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FD-200D-2642",
				image: "1f6b5-1f3fd-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FE-200D-2642",
				image: "1f6b5-1f3fe-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FF-200D-2642",
				image: "1f6b5-1f3ff-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		obsoletes: "1F6B5",
		a: "Man Mountain Biking",
		b: "1F6B5-200D-2642-FE0F",
		c: "1F6B5-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			35
		],
		o: 4
	},
	"woman-mountain-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FB-200D-2640",
				image: "1f6b5-1f3fb-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FC-200D-2640",
				image: "1f6b5-1f3fc-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FD-200D-2640",
				image: "1f6b5-1f3fd-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FE-200D-2640",
				image: "1f6b5-1f3fe-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FF-200D-2640",
				image: "1f6b5-1f3ff-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Mountain Biking",
		b: "1F6B5-200D-2640-FE0F",
		c: "1F6B5-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			35,
			29
		],
		o: 4
	},
	person_doing_cartwheel: {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB",
				non_qualified: null,
				image: "1f938-1f3fb.png",
				sheet_x: 40,
				sheet_y: 9,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F938-1F3FC",
				non_qualified: null,
				image: "1f938-1f3fc.png",
				sheet_x: 40,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F938-1F3FD",
				non_qualified: null,
				image: "1f938-1f3fd.png",
				sheet_x: 40,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F938-1F3FE",
				non_qualified: null,
				image: "1f938-1f3fe.png",
				sheet_x: 40,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F938-1F3FF",
				non_qualified: null,
				image: "1f938-1f3ff.png",
				sheet_x: 40,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Person Doing Cartwheel",
		b: "1F938",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			40,
			8
		],
		o: 4
	},
	"man-cartwheeling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB-200D-2642-FE0F",
				non_qualified: "1F938-1F3FB-200D-2642",
				image: "1f938-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 3,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F938-1F3FC-200D-2642-FE0F",
				non_qualified: "1F938-1F3FC-200D-2642",
				image: "1f938-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F938-1F3FD-200D-2642-FE0F",
				non_qualified: "1F938-1F3FD-200D-2642",
				image: "1f938-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F938-1F3FE-200D-2642-FE0F",
				non_qualified: "1F938-1F3FE-200D-2642",
				image: "1f938-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F938-1F3FF-200D-2642-FE0F",
				non_qualified: "1F938-1F3FF-200D-2642",
				image: "1f938-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Cartwheeling",
		b: "1F938-200D-2642-FE0F",
		c: "1F938-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			2
		],
		o: 4
	},
	"woman-cartwheeling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB-200D-2640-FE0F",
				non_qualified: "1F938-1F3FB-200D-2640",
				image: "1f938-1f3fb-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 54,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F938-1F3FC-200D-2640-FE0F",
				non_qualified: "1F938-1F3FC-200D-2640",
				image: "1f938-1f3fc-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F938-1F3FD-200D-2640-FE0F",
				non_qualified: "1F938-1F3FD-200D-2640",
				image: "1f938-1f3fd-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F938-1F3FE-200D-2640-FE0F",
				non_qualified: "1F938-1F3FE-200D-2640",
				image: "1f938-1f3fe-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F938-1F3FF-200D-2640-FE0F",
				non_qualified: "1F938-1F3FF-200D-2640",
				image: "1f938-1f3ff-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Cartwheeling",
		b: "1F938-200D-2640-FE0F",
		c: "1F938-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			39,
			53
		],
		o: 4
	},
	wrestlers: {
		a: "Wrestlers",
		b: "1F93C",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			35
		],
		o: 4
	},
	"man-wrestling": {
		a: "Man Wrestling",
		b: "1F93C-200D-2642-FE0F",
		c: "1F93C-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			34
		],
		o: 4
	},
	"woman-wrestling": {
		a: "Woman Wrestling",
		b: "1F93C-200D-2640-FE0F",
		c: "1F93C-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			33
		],
		o: 4
	},
	water_polo: {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB",
				non_qualified: null,
				image: "1f93d-1f3fb.png",
				sheet_x: 40,
				sheet_y: 49,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F93D-1F3FC",
				non_qualified: null,
				image: "1f93d-1f3fc.png",
				sheet_x: 40,
				sheet_y: 50,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F93D-1F3FD",
				non_qualified: null,
				image: "1f93d-1f3fd.png",
				sheet_x: 40,
				sheet_y: 51,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F93D-1F3FE",
				non_qualified: null,
				image: "1f93d-1f3fe.png",
				sheet_x: 40,
				sheet_y: 52,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F93D-1F3FF",
				non_qualified: null,
				image: "1f93d-1f3ff.png",
				sheet_x: 40,
				sheet_y: 53,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Water Polo",
		b: "1F93D",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			40,
			48
		],
		o: 4
	},
	"man-playing-water-polo": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FB-200D-2642",
				image: "1f93d-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 43,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F93D-1F3FC-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FC-200D-2642",
				image: "1f93d-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 44,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F93D-1F3FD-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FD-200D-2642",
				image: "1f93d-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 45,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F93D-1F3FE-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FE-200D-2642",
				image: "1f93d-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 46,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F93D-1F3FF-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FF-200D-2642",
				image: "1f93d-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 47,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Playing Water Polo",
		b: "1F93D-200D-2642-FE0F",
		c: "1F93D-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			42
		],
		o: 4
	},
	"woman-playing-water-polo": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FB-200D-2640",
				image: "1f93d-1f3fb-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 37,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F93D-1F3FC-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FC-200D-2640",
				image: "1f93d-1f3fc-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 38,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F93D-1F3FD-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FD-200D-2640",
				image: "1f93d-1f3fd-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 39,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F93D-1F3FE-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FE-200D-2640",
				image: "1f93d-1f3fe-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 40,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F93D-1F3FF-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FF-200D-2640",
				image: "1f93d-1f3ff-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 41,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Playing Water Polo",
		b: "1F93D-200D-2640-FE0F",
		c: "1F93D-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			36
		],
		o: 4
	},
	handball: {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB",
				non_qualified: null,
				image: "1f93e-1f3fb.png",
				sheet_x: 41,
				sheet_y: 10,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC": {
				unified: "1F93E-1F3FC",
				non_qualified: null,
				image: "1f93e-1f3fc.png",
				sheet_x: 41,
				sheet_y: 11,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD": {
				unified: "1F93E-1F3FD",
				non_qualified: null,
				image: "1f93e-1f3fd.png",
				sheet_x: 41,
				sheet_y: 12,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE": {
				unified: "1F93E-1F3FE",
				non_qualified: null,
				image: "1f93e-1f3fe.png",
				sheet_x: 41,
				sheet_y: 13,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF": {
				unified: "1F93E-1F3FF",
				non_qualified: null,
				image: "1f93e-1f3ff.png",
				sheet_x: 41,
				sheet_y: 14,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: false
			}
		},
		a: "Handball",
		b: "1F93E",
		d: true,
		e: true,
		f: true,
		h: false,
		k: [
			41,
			9
		],
		o: 4
	},
	"man-playing-handball": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FB-200D-2642",
				image: "1f93e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 4,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F93E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FC-200D-2642",
				image: "1f93e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 5,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F93E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FD-200D-2642",
				image: "1f93e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 6,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F93E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FE-200D-2642",
				image: "1f93e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 7,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F93E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FF-200D-2642",
				image: "1f93e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 8,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Playing Handball",
		b: "1F93E-200D-2642-FE0F",
		c: "1F93E-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			41,
			3
		],
		o: 4
	},
	"woman-playing-handball": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FB-200D-2640",
				image: "1f93e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 55,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F93E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FC-200D-2640",
				image: "1f93e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 56,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F93E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FD-200D-2640",
				image: "1f93e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 0,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F93E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FE-200D-2640",
				image: "1f93e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 1,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F93E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FF-200D-2640",
				image: "1f93e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 2,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Playing Handball",
		b: "1F93E-200D-2640-FE0F",
		c: "1F93E-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			54
		],
		o: 4
	},
	juggling: {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB",
				non_qualified: null,
				image: "1f939-1f3fb.png",
				sheet_x: 40,
				sheet_y: 27,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F939-1F3FC",
				non_qualified: null,
				image: "1f939-1f3fc.png",
				sheet_x: 40,
				sheet_y: 28,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F939-1F3FD",
				non_qualified: null,
				image: "1f939-1f3fd.png",
				sheet_x: 40,
				sheet_y: 29,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F939-1F3FE",
				non_qualified: null,
				image: "1f939-1f3fe.png",
				sheet_x: 40,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F939-1F3FF",
				non_qualified: null,
				image: "1f939-1f3ff.png",
				sheet_x: 40,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Juggling",
		b: "1F939",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			26
		],
		o: 4
	},
	"man-juggling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB-200D-2642-FE0F",
				non_qualified: "1F939-1F3FB-200D-2642",
				image: "1f939-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 21,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F939-1F3FC-200D-2642-FE0F",
				non_qualified: "1F939-1F3FC-200D-2642",
				image: "1f939-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 22,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F939-1F3FD-200D-2642-FE0F",
				non_qualified: "1F939-1F3FD-200D-2642",
				image: "1f939-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 23,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F939-1F3FE-200D-2642-FE0F",
				non_qualified: "1F939-1F3FE-200D-2642",
				image: "1f939-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 24,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F939-1F3FF-200D-2642-FE0F",
				non_qualified: "1F939-1F3FF-200D-2642",
				image: "1f939-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 25,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man Juggling",
		b: "1F939-200D-2642-FE0F",
		c: "1F939-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			20
		],
		o: 4
	},
	"woman-juggling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB-200D-2640-FE0F",
				non_qualified: "1F939-1F3FB-200D-2640",
				image: "1f939-1f3fb-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 15,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F939-1F3FC-200D-2640-FE0F",
				non_qualified: "1F939-1F3FC-200D-2640",
				image: "1f939-1f3fc-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 16,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F939-1F3FD-200D-2640-FE0F",
				non_qualified: "1F939-1F3FD-200D-2640",
				image: "1f939-1f3fd-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 17,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F939-1F3FE-200D-2640-FE0F",
				non_qualified: "1F939-1F3FE-200D-2640",
				image: "1f939-1f3fe-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 18,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F939-1F3FF-200D-2640-FE0F",
				non_qualified: "1F939-1F3FF-200D-2640",
				image: "1f939-1f3ff-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 19,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Woman Juggling",
		b: "1F939-200D-2640-FE0F",
		c: "1F939-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			40,
			14
		],
		o: 4
	},
	person_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB",
				non_qualified: null,
				image: "1f9d8-1f3fb.png",
				sheet_x: 49,
				sheet_y: 32,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC",
				non_qualified: null,
				image: "1f9d8-1f3fc.png",
				sheet_x: 49,
				sheet_y: 33,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD",
				non_qualified: null,
				image: "1f9d8-1f3fd.png",
				sheet_x: 49,
				sheet_y: 34,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE",
				non_qualified: null,
				image: "1f9d8-1f3fe.png",
				sheet_x: 49,
				sheet_y: 35,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF",
				non_qualified: null,
				image: "1f9d8-1f3ff.png",
				sheet_x: 49,
				sheet_y: 36,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D8-200D-2640-FE0F",
		a: "Person in Lotus Position",
		b: "1F9D8",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			31
		],
		o: 5
	},
	man_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FB-200D-2642",
				image: "1f9d8-1f3fb-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 26,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FC-200D-2642",
				image: "1f9d8-1f3fc-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 27,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FD-200D-2642",
				image: "1f9d8-1f3fd-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 28,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FE-200D-2642",
				image: "1f9d8-1f3fe-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 29,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FF-200D-2642",
				image: "1f9d8-1f3ff-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 30,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man in Lotus Position",
		b: "1F9D8-200D-2642-FE0F",
		c: "1F9D8-200D-2642",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			25
		],
		o: 5
	},
	woman_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FB-200D-2640",
				image: "1f9d8-1f3fb-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 20,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D8-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FC-200D-2640",
				image: "1f9d8-1f3fc-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 21,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D8-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FD-200D-2640",
				image: "1f9d8-1f3fd-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 22,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D8-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FE-200D-2640",
				image: "1f9d8-1f3fe-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 23,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D8-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FF-200D-2640",
				image: "1f9d8-1f3ff-200d-2640-fe0f.png",
				sheet_x: 49,
				sheet_y: 24,
				added_in: "5.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true,
				obsoletes: "1F9D8-1F3FF"
			}
		},
		obsoletes: "1F9D8",
		a: "Woman in Lotus Position",
		b: "1F9D8-200D-2640-FE0F",
		c: "1F9D8-200D-2640",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			49,
			19
		],
		o: 5
	},
	bath: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6C0-1F3FB",
				non_qualified: null,
				image: "1f6c0-1f3fb.png",
				sheet_x: 36,
				sheet_y: 18,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6C0-1F3FC",
				non_qualified: null,
				image: "1f6c0-1f3fc.png",
				sheet_x: 36,
				sheet_y: 19,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6C0-1F3FD",
				non_qualified: null,
				image: "1f6c0-1f3fd.png",
				sheet_x: 36,
				sheet_y: 20,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6C0-1F3FE",
				non_qualified: null,
				image: "1f6c0-1f3fe.png",
				sheet_x: 36,
				sheet_y: 21,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6C0-1F3FF",
				non_qualified: null,
				image: "1f6c0-1f3ff.png",
				sheet_x: 36,
				sheet_y: 22,
				added_in: "2.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Bath",
		b: "1F6C0",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"clean",
			"shower",
			"bathroom"
		],
		k: [
			36,
			17
		],
		o: 2
	},
	sleeping_accommodation: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6CC-1F3FB",
				non_qualified: null,
				image: "1f6cc-1f3fb.png",
				sheet_x: 36,
				sheet_y: 30,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F6CC-1F3FC",
				non_qualified: null,
				image: "1f6cc-1f3fc.png",
				sheet_x: 36,
				sheet_y: 31,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F6CC-1F3FD",
				non_qualified: null,
				image: "1f6cc-1f3fd.png",
				sheet_x: 36,
				sheet_y: 32,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F6CC-1F3FE",
				non_qualified: null,
				image: "1f6cc-1f3fe.png",
				sheet_x: 36,
				sheet_y: 33,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F6CC-1F3FF",
				non_qualified: null,
				image: "1f6cc-1f3ff.png",
				sheet_x: 36,
				sheet_y: 34,
				added_in: "4.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Sleeping Accommodation",
		b: "1F6CC",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			36,
			29
		],
		o: 2
	},
	people_holding_hands: {
		skin_variations: {
			"1F3FB-1F3FB": {
				unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png",
				sheet_x: 46,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FC": {
				unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png",
				sheet_x: 46,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FD": {
				unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png",
				sheet_x: 46,
				sheet_y: 41,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FE": {
				unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png",
				sheet_x: 46,
				sheet_y: 42,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FF": {
				unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png",
				sheet_x: 46,
				sheet_y: 43,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FB": {
				unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png",
				sheet_x: 46,
				sheet_y: 44,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FC": {
				unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png",
				sheet_x: 46,
				sheet_y: 45,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FD": {
				unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png",
				sheet_x: 46,
				sheet_y: 46,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FE": {
				unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png",
				sheet_x: 46,
				sheet_y: 47,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FF": {
				unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png",
				sheet_x: 46,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FB": {
				unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png",
				sheet_x: 46,
				sheet_y: 49,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FC": {
				unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png",
				sheet_x: 46,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FD": {
				unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png",
				sheet_x: 46,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FE": {
				unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png",
				sheet_x: 46,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FF": {
				unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png",
				sheet_x: 46,
				sheet_y: 53,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE-1F3FB": {
				unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png",
				sheet_x: 46,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FC": {
				unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png",
				sheet_x: 46,
				sheet_y: 55,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FD": {
				unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png",
				sheet_x: 46,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FE": {
				unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png",
				sheet_x: 47,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FF": {
				unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png",
				sheet_x: 47,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF-1F3FB": {
				unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png",
				sheet_x: 47,
				sheet_y: 2,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FC": {
				unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png",
				sheet_x: 47,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FD": {
				unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png",
				sheet_x: 47,
				sheet_y: 4,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FE": {
				unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png",
				sheet_x: 47,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FF": {
				unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png",
				sheet_x: 47,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "People Holding Hands",
		b: "1F9D1-200D-1F91D-200D-1F9D1",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			46,
			38
		],
		o: 12
	},
	two_women_holding_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F46D-1F3FB",
				non_qualified: null,
				image: "1f46d-1f3fb.png",
				sheet_x: 21,
				sheet_y: 12,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F46D-1F3FC",
				non_qualified: null,
				image: "1f46d-1f3fc.png",
				sheet_x: 21,
				sheet_y: 13,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F46D-1F3FD",
				non_qualified: null,
				image: "1f46d-1f3fd.png",
				sheet_x: 21,
				sheet_y: 14,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F46D-1F3FE",
				non_qualified: null,
				image: "1f46d-1f3fe.png",
				sheet_x: 21,
				sheet_y: 15,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F46D-1F3FF",
				non_qualified: null,
				image: "1f46d-1f3ff.png",
				sheet_x: 21,
				sheet_y: 16,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FC": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png",
				sheet_x: 21,
				sheet_y: 17,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FD": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png",
				sheet_x: 21,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FE": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png",
				sheet_x: 21,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FF": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png",
				sheet_x: 21,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FB": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png",
				sheet_x: 21,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FD": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png",
				sheet_x: 21,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FE": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png",
				sheet_x: 21,
				sheet_y: 23,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FF": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png",
				sheet_x: 21,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FB": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png",
				sheet_x: 21,
				sheet_y: 25,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FC": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png",
				sheet_x: 21,
				sheet_y: 26,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FE": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png",
				sheet_x: 21,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FF": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png",
				sheet_x: 21,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE-1F3FB": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png",
				sheet_x: 21,
				sheet_y: 29,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FC": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png",
				sheet_x: 21,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FD": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png",
				sheet_x: 21,
				sheet_y: 31,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FF": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png",
				sheet_x: 21,
				sheet_y: 32,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF-1F3FB": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png",
				sheet_x: 21,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FC": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png",
				sheet_x: 21,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FD": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png",
				sheet_x: 21,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FE": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png",
				sheet_x: 21,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Two Women Holding Hands",
		b: "1F46D",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"pair",
			"friendship",
			"couple",
			"love",
			"like",
			"female",
			"people",
			"human"
		],
		k: [
			21,
			11
		],
		n: [
			"women_holding_hands"
		],
		o: 2
	},
	couple: {
		skin_variations: {
			"1F3FB": {
				unified: "1F46B-1F3FB",
				non_qualified: null,
				image: "1f46b-1f3fb.png",
				sheet_x: 20,
				sheet_y: 17,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F46B-1F3FC",
				non_qualified: null,
				image: "1f46b-1f3fc.png",
				sheet_x: 20,
				sheet_y: 18,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F46B-1F3FD",
				non_qualified: null,
				image: "1f46b-1f3fd.png",
				sheet_x: 20,
				sheet_y: 19,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F46B-1F3FE",
				non_qualified: null,
				image: "1f46b-1f3fe.png",
				sheet_x: 20,
				sheet_y: 20,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F46B-1F3FF",
				non_qualified: null,
				image: "1f46b-1f3ff.png",
				sheet_x: 20,
				sheet_y: 21,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FC": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 20,
				sheet_y: 22,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FD": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 23,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FE": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 24,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FF": {
				unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 25,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FB": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 26,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FD": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 27,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FE": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 28,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FF": {
				unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 29,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FB": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 30,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FC": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 20,
				sheet_y: 31,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FE": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 32,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FF": {
				unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 33,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FB": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 34,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FC": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 20,
				sheet_y: 35,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FD": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 36,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FF": {
				unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 37,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FB": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 38,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FC": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 20,
				sheet_y: 39,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FD": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 40,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FE": {
				unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 41,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Man and Woman Holding Hands",
		b: "1F46B",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"pair",
			"people",
			"human",
			"love",
			"date",
			"dating",
			"like",
			"affection",
			"valentines",
			"marriage"
		],
		k: [
			20,
			16
		],
		n: [
			"man_and_woman_holding_hands",
			"woman_and_man_holding_hands"
		],
		o: 2
	},
	two_men_holding_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F46C-1F3FB",
				non_qualified: null,
				image: "1f46c-1f3fb.png",
				sheet_x: 20,
				sheet_y: 43,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC": {
				unified: "1F46C-1F3FC",
				non_qualified: null,
				image: "1f46c-1f3fc.png",
				sheet_x: 20,
				sheet_y: 44,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD": {
				unified: "1F46C-1F3FD",
				non_qualified: null,
				image: "1f46c-1f3fd.png",
				sheet_x: 20,
				sheet_y: 45,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE": {
				unified: "1F46C-1F3FE",
				non_qualified: null,
				image: "1f46c-1f3fe.png",
				sheet_x: 20,
				sheet_y: 46,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF": {
				unified: "1F46C-1F3FF",
				non_qualified: null,
				image: "1f46c-1f3ff.png",
				sheet_x: 20,
				sheet_y: 47,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FB-1F3FC": {
				unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 20,
				sheet_y: 48,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FD": {
				unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 49,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FE": {
				unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 50,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FB-1F3FF": {
				unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 51,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FB": {
				unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 52,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FC-1F3FD": {
				unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 20,
				sheet_y: 53,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FE": {
				unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 20,
				sheet_y: 54,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FC-1F3FF": {
				unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 20,
				sheet_y: 55,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FB": {
				unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 20,
				sheet_y: 56,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FC": {
				unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 21,
				sheet_y: 0,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FD-1F3FE": {
				unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 21,
				sheet_y: 1,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FD-1F3FF": {
				unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 21,
				sheet_y: 2,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FE-1F3FB": {
				unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 21,
				sheet_y: 3,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FC": {
				unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 21,
				sheet_y: 4,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FD": {
				unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 21,
				sheet_y: 5,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FE-1F3FF": {
				unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
				sheet_x: 21,
				sheet_y: 6,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: false,
				has_img_twitter: true,
				has_img_facebook: false
			},
			"1F3FF-1F3FB": {
				unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
				sheet_x: 21,
				sheet_y: 7,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FC": {
				unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
				sheet_x: 21,
				sheet_y: 8,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FD": {
				unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
				sheet_x: 21,
				sheet_y: 9,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			},
			"1F3FF-1F3FE": {
				unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
				sheet_x: 21,
				sheet_y: 10,
				added_in: "12.1",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_facebook: true
			}
		},
		a: "Two Men Holding Hands",
		b: "1F46C",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"pair",
			"couple",
			"love",
			"like",
			"bromance",
			"friendship",
			"people",
			"human"
		],
		k: [
			20,
			42
		],
		n: [
			"men_holding_hands"
		],
		o: 2
	},
	couplekiss: {
		obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
		a: "Kiss",
		b: "1F48F",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			25,
			25
		],
		o: 2
	},
	"woman-kiss-man": {
		obsoletes: "1F48F",
		a: "Woman Kiss Man",
		b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
		c: "1F469-200D-2764-200D-1F48B-200D-1F468",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			20,
			7
		],
		o: 2
	},
	"man-kiss-man": {
		a: "Man Kiss Man",
		b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
		c: "1F468-200D-2764-200D-1F48B-200D-1F468",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			21
		],
		o: 2
	},
	"woman-kiss-woman": {
		a: "Woman Kiss Woman",
		b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
		c: "1F469-200D-2764-200D-1F48B-200D-1F469",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			20,
			8
		],
		o: 2
	},
	couple_with_heart: {
		obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
		a: "Couple with Heart",
		b: "1F491",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			25,
			27
		],
		o: 2
	},
	"woman-heart-man": {
		obsoletes: "1F491",
		a: "Woman Heart Man",
		b: "1F469-200D-2764-FE0F-200D-1F468",
		c: "1F469-200D-2764-200D-1F468",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			20,
			5
		],
		o: 2
	},
	"man-heart-man": {
		a: "Man Heart Man",
		b: "1F468-200D-2764-FE0F-200D-1F468",
		c: "1F468-200D-2764-200D-1F468",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			17,
			20
		],
		o: 2
	},
	"woman-heart-woman": {
		a: "Woman Heart Woman",
		b: "1F469-200D-2764-FE0F-200D-1F469",
		c: "1F469-200D-2764-200D-1F469",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			20,
			6
		],
		o: 2
	},
	family: {
		obsoleted_by: "1F468-200D-1F469-200D-1F466",
		a: "Family",
		b: "1F46A",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			20,
			15
		],
		n: [
			"man-woman-boy"
		],
		o: 2
	},
	"man-woman-boy": {
		obsoletes: "1F46A",
		a: "Man Woman Boy",
		b: "1F468-200D-1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			33
		],
		n: [
			"family"
		],
		o: 2
	},
	"man-woman-girl": {
		a: "Man Woman Girl",
		b: "1F468-200D-1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			35
		],
		o: 2
	},
	"man-woman-girl-boy": {
		a: "Man Woman Girl Boy",
		b: "1F468-200D-1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			36
		],
		o: 2
	},
	"man-woman-boy-boy": {
		a: "Man Woman Boy Boy",
		b: "1F468-200D-1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			34
		],
		o: 2
	},
	"man-woman-girl-girl": {
		a: "Man Woman Girl Girl",
		b: "1F468-200D-1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			37
		],
		o: 2
	},
	"man-man-boy": {
		a: "Man Man Boy",
		b: "1F468-200D-1F468-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			28
		],
		o: 2
	},
	"man-man-girl": {
		a: "Man Man Girl",
		b: "1F468-200D-1F468-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			30
		],
		o: 2
	},
	"man-man-girl-boy": {
		a: "Man Man Girl Boy",
		b: "1F468-200D-1F468-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			31
		],
		o: 2
	},
	"man-man-boy-boy": {
		a: "Man Man Boy Boy",
		b: "1F468-200D-1F468-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			29
		],
		o: 2
	},
	"man-man-girl-girl": {
		a: "Man Man Girl Girl",
		b: "1F468-200D-1F468-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			32
		],
		o: 2
	},
	"woman-woman-boy": {
		a: "Woman Woman Boy",
		b: "1F469-200D-1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			18
		],
		o: 2
	},
	"woman-woman-girl": {
		a: "Woman Woman Girl",
		b: "1F469-200D-1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			20
		],
		o: 2
	},
	"woman-woman-girl-boy": {
		a: "Woman Woman Girl Boy",
		b: "1F469-200D-1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			21
		],
		o: 2
	},
	"woman-woman-boy-boy": {
		a: "Woman Woman Boy Boy",
		b: "1F469-200D-1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			19
		],
		o: 2
	},
	"woman-woman-girl-girl": {
		a: "Woman Woman Girl Girl",
		b: "1F469-200D-1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			22
		],
		o: 2
	},
	"man-boy": {
		a: "Man Boy",
		b: "1F468-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			24
		],
		o: 4
	},
	"man-boy-boy": {
		a: "Man Boy Boy",
		b: "1F468-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			23
		],
		o: 4
	},
	"man-girl": {
		a: "Man Girl",
		b: "1F468-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			27
		],
		o: 4
	},
	"man-girl-boy": {
		a: "Man Girl Boy",
		b: "1F468-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			25
		],
		o: 4
	},
	"man-girl-girl": {
		a: "Man Girl Girl",
		b: "1F468-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			15,
			26
		],
		o: 4
	},
	"woman-boy": {
		a: "Woman Boy",
		b: "1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			14
		],
		o: 4
	},
	"woman-boy-boy": {
		a: "Woman Boy Boy",
		b: "1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			13
		],
		o: 4
	},
	"woman-girl": {
		a: "Woman Girl",
		b: "1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			17
		],
		o: 4
	},
	"woman-girl-boy": {
		a: "Woman Girl Boy",
		b: "1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			15
		],
		o: 4
	},
	"woman-girl-girl": {
		a: "Woman Girl Girl",
		b: "1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			18,
			16
		],
		o: 4
	},
	speaking_head_in_silhouette: {
		a: "Speaking Head in Silhouette",
		b: "1F5E3-FE0F",
		c: "1F5E3",
		d: true,
		e: true,
		f: true,
		h: true,
		k: [
			30,
			25
		],
		o: 2
	},
	bust_in_silhouette: {
		a: "Bust in Silhouette",
		b: "1F464",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"user",
			"person",
			"human"
		],
		k: [
			14,
			24
		],
		o: 2
	},
	busts_in_silhouette: {
		a: "Busts in Silhouette",
		b: "1F465",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"user",
			"person",
			"human",
			"group",
			"team"
		],
		k: [
			14,
			25
		],
		o: 2
	},
	footprints: {
		a: "Footprints",
		b: "1F463",
		d: true,
		e: true,
		f: true,
		h: true,
		j: [
			"feet",
			"tracking",
			"walking",
			"beach"
		],
		k: [
			14,
			23
		],
		o: 2
	}
};
var aliases = {
	raised_hand: "hand",
	satisfied: "laughing",
	tshirt: "shirt",
	hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
	sign_of_the_horns: "the_horns",
	grinning_face_with_star_eyes: "star-struck",
	reversed_hand_with_middle_finger_extended: "middle_finger",
	thumbsup: "+1",
	thumbsdown: "-1",
	punch: "facepunch",
	grinning_face_with_one_large_and_one_small_eye: "zany_face",
	shoe: "mans_shoe",
	smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
	face_with_finger_covering_closed_lips: "shushing_face",
	face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
	face_with_open_mouth_vomiting: "face_vomiting",
	cooking: "fried_egg",
	"flag-cn": "cn",
	shocked_face_with_exploding_head: "exploding_head",
	paw_prints: "feet",
	"flag-de": "de",
	telephone: "phone",
	"flag-es": "es",
	red_car: "car",
	flipper: "dolphin",
	"flag-fr": "fr",
	uk: "gb",
	"flag-gb": "gb",
	serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
	poop: "hankey",
	shit: "hankey",
	honeybee: "bee",
	staff_of_aesculapius: "medical_symbol",
	lantern: "izakaya_lantern",
	open_book: "book",
	sailboat: "boat",
	knife: "hocho",
	"flag-it": "it",
	heavy_exclamation_mark: "exclamation",
	"flag-jp": "jp",
	envelope: "email",
	"flag-kr": "kr",
	collision: "boom",
	pencil: "memo",
	waxing_gibbous_moon: "moon",
	mother_christmas: "mrs_claus",
	sun_small_cloud: "mostly_sunny",
	sun_behind_cloud: "barely_sunny",
	sun_behind_rain_cloud: "partly_sunny_rain",
	lightning_cloud: "lightning",
	tornado_cloud: "tornado",
	"flag-ru": "ru",
	running: "runner",
	"flag-us": "us",
	women_holding_hands: "two_women_holding_hands",
	man_and_woman_holding_hands: "couple",
	woman_and_man_holding_hands: "couple",
	men_holding_hands: "two_men_holding_hands",
	"man-woman-boy": "family",
	family: "man-woman-boy"
};
var data = {
	compressed: compressed,
	categories: categories,
	emojis: emojis,
	aliases: aliases
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var mapping = {
  name: 'a',
  unified: 'b',
  non_qualified: 'c',
  has_img_apple: 'd',
  has_img_google: 'e',
  has_img_twitter: 'f',
  has_img_facebook: 'h',
  keywords: 'j',
  sheet: 'k',
  emoticons: 'l',
  text: 'm',
  short_names: 'n',
  added_in: 'o'
};

var buildSearch = function buildSearch(emoji) {
  var search = [];

  var addToSearch = function addToSearch(strings, split) {
    if (!strings) {
      return;
    }
    (Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
      (split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
        s = s.toLowerCase();

        if (search.indexOf(s) == -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false);
  addToSearch(emoji.emoticons, false);
  return search.join(',');
};

var uncompress = function uncompress(data) {
  data.compressed = false;

  for (var id in data.emojis) {
    var emoji = data.emojis[id];

    for (var key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }

    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id);
    emoji.sheet_x = emoji.sheet[0];
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;
    if (!emoji.text) emoji.text = '';
    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);
    emoji.search = buildSearch(emoji);
  }
};

var _String = String;
var stringFromCodePoint = _String.fromCodePoint || function stringFromCodePoint() {
  var MAX_SIZE = 0x4000;
  var codeUnits = [];
  var highSurrogate;
  var lowSurrogate;
  var index = -1;
  var length = arguments.length;

  if (!length) {
    return '';
  }

  var result = '';

  while (++index < length) {
    var codePoint = Number(arguments[index]);

    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 0x10ffff || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint // not an integer
    ) {
        throw RangeError('Invalid code point: ' + codePoint);
      }

    if (codePoint <= 0xffff) {
      // BMP code point
      codeUnits.push(codePoint);
    } else {
      // Astral code point; split in surrogate halves
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      codePoint -= 0x10000;
      highSurrogate = (codePoint >> 10) + 0xd800;
      lowSurrogate = codePoint % 0x400 + 0xdc00;
      codeUnits.push(highSurrogate, lowSurrogate);
    }

    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }

  return result;
};

var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

function unifiedToNative(unified) {
  var unicodes = unified.split('-'),
      codePoints = unicodes.map(function (u) {
    return "0x".concat(u);
  });
  return stringFromCodePoint.apply(null, codePoints);
}

function sanitize(emoji) {
  var name = emoji.name,
      short_names = emoji.short_names,
      skin_tone = emoji.skin_tone,
      skin_variations = emoji.skin_variations,
      emoticons = emoji.emoticons,
      unified = emoji.unified,
      custom = emoji.custom,
      customCategory = emoji.customCategory,
      imageUrl = emoji.imageUrl,
      id = emoji.id || short_names[0],
      colons = ":".concat(id, ":");

  if (custom) {
    return {
      id: id,
      name: name,
      short_names: short_names,
      colons: colons,
      emoticons: emoticons,
      custom: custom,
      customCategory: customCategory,
      imageUrl: imageUrl
    };
  }

  if (skin_tone) {
    colons += ":skin-tone-".concat(skin_tone, ":");
  }

  return {
    id: id,
    name: name,
    short_names: short_names,
    colons: colons,
    emoticons: emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    "native": unifiedToNative(unified)
  };
}

function getSanitizedData() {
  return sanitize(getData.apply(void 0, arguments));
}

function getData(emoji, skin, set, data) {
  var emojiData = {};

  if (typeof emoji == 'string') {
    var matches = emoji.match(COLONS_REGEX);

    if (matches) {
      emoji = matches[1];

      if (matches[2]) {
        skin = parseInt(matches[2], 10);
      }
    }

    if (data.aliases.hasOwnProperty(emoji)) {
      emoji = data.aliases[emoji];
    }

    if (data.emojis.hasOwnProperty(emoji)) {
      emojiData = data.emojis[emoji];
    } else {
      return null;
    }
  } else if (emoji.id) {
    if (data.aliases.hasOwnProperty(emoji.id)) {
      emoji.id = data.aliases[emoji.id];
    }

    if (data.emojis.hasOwnProperty(emoji.id)) {
      emojiData = data.emojis[emoji.id];
      skin || (skin = emoji.skin);
    }
  }

  if (!Object.keys(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;

    if (!emojiData.search) {
      emojiData.search = buildSearch(emoji);
    }
  }

  emojiData.emoticons || (emojiData.emoticons = []);
  emojiData.variations || (emojiData.variations = []);

  if (emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    var skinKey = SKINS[skin - 1],
        variationData = emojiData.skin_variations[skinKey];

    if (variationData) {
      if (!variationData.variations && emojiData.variations) {
        delete emojiData.variations;
      }

      if (set && (variationData["has_img_".concat(set)] == undefined || variationData["has_img_".concat(set)]) || !set) {
        emojiData.skin_tone = skin;

        for (var k in variationData) {
          var v = variationData[k];
          emojiData[k] = v;
        }
      }
    }
  }

  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }

  return emojiData;
}

function uniq(arr) {
  return arr.reduce(function (acc, item) {
    if (acc.indexOf(item) === -1) {
      acc.push(item);
    }

    return acc;
  }, []);
}

function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);
  return uniqA.filter(function (item) {
    return uniqB.indexOf(item) >= 0;
  });
}

function deepMerge(a, b) {
  var o = {};

  for (var key in a) {
    var originalValue = a[key],
        value = originalValue;

    if (b.hasOwnProperty(key)) {
      value = b[key];
    }

    if (_typeof_1(value) === 'object') {
      value = deepMerge(originalValue, value);
    }

    o[key] = value;
  }

  return o;
} // https://github.com/sonicdoe/measure-scrollbar


function measureScrollbar() {
  if (typeof document == 'undefined') return 0;
  var div = document.createElement('div');
  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';
  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return scrollbarWidth;
} // Use requestIdleCallback() if available, else fall back to setTimeout().
// Throttle so as not to run too frequently.


function throttleIdleTask(func) {
  var doIdleTask = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
  var running = false;
  return function throttled() {
    if (running) {
      return;
    }

    running = true;
    doIdleTask(function () {
      running = false;
      func();
    });
  };
}

var NAMESPACE = 'emoji-mart';
var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;
var getter;
var setter;

function setHandlers(handlers) {
  handlers || (handlers = {});
  getter = handlers.getter;
  setter = handlers.setter;
}

function setNamespace(namespace) {
  NAMESPACE = namespace;
}

function update(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}

function set(key, value) {
  if (setter) {
    setter(key, value);
  } else {
    if (!isLocalStorageSupported) return;

    try {
      window.localStorage["".concat(NAMESPACE, ".").concat(key)] = JSON.stringify(value);
    } catch (e) {}
  }
}

function get(key) {
  if (getter) {
    return getter(key);
  } else {
    if (!isLocalStorageSupported) return;

    try {
      var value = window.localStorage["".concat(NAMESPACE, ".").concat(key)];

      if (value) {
        return JSON.parse(value);
      }
    } catch (e) {
      return;
    }
  }
}

var store = {
  update: update,
  set: set,
  get: get,
  setNamespace: setNamespace,
  setHandlers: setHandlers
};

var NimbleEmojiIndex =
/*#__PURE__*/
function () {
  function NimbleEmojiIndex(data, set) {
    classCallCheck(this, NimbleEmojiIndex);

    if (data.compressed) {
      uncompress(data);
    }

    this.data = data || {};
    this.set = set || null;
    this.originalPool = {};
    this.index = {};
    this.emojis = {};
    this.emoticons = {};
    this.customEmojisList = [];
    this.buildIndex();
  }

  createClass(NimbleEmojiIndex, [{
    key: "buildIndex",
    value: function buildIndex() {
      var _this = this;

      var _loop = function _loop(emoji) {
        var emojiData = _this.data.emojis[emoji],
            short_names = emojiData.short_names,
            emoticons = emojiData.emoticons,
            skin_variations = emojiData.skin_variations,
            id = short_names[0];

        if (emoticons) {
          emoticons.forEach(function (emoticon) {
            if (_this.emoticons[emoticon]) {
              return;
            }

            _this.emoticons[emoticon] = id;
          });
        } // If skin variations include them


        if (skin_variations) {
          _this.emojis[id] = {};

          for (var skinTone = 1; skinTone <= 6; skinTone++) {
            _this.emojis[id][skinTone] = getSanitizedData({
              id: id,
              skin: skinTone
            }, skinTone, _this.set, _this.data);
          }
        } else {
          _this.emojis[id] = getSanitizedData(id, null, _this.set, _this.data);
        }

        _this.originalPool[id] = emojiData;
      };

      for (var emoji in this.data.emojis) {
        _loop(emoji);
      }
    }
  }, {
    key: "clearCustomEmojis",
    value: function clearCustomEmojis(pool) {
      var _this2 = this;

      this.customEmojisList.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        delete pool[emojiId];
        delete _this2.emojis[emojiId];
      });
    }
  }, {
    key: "addCustomToPool",
    value: function addCustomToPool(custom, pool) {
      var _this3 = this;

      if (this.customEmojisList.length) this.clearCustomEmojis(pool);
      custom.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = getData(emoji, null, null, _this3.data);
          _this3.emojis[emojiId] = getSanitizedData(emoji, null, null, _this3.data);
        }
      });
      this.customEmojisList = custom;
      this.index = {};
    }
  }, {
    key: "search",
    value: function search(value) {
      var _this4 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          emojisToShowFilter = _ref.emojisToShowFilter,
          maxResults = _ref.maxResults,
          include = _ref.include,
          exclude = _ref.exclude,
          _ref$custom = _ref.custom,
          custom = _ref$custom === void 0 ? [] : _ref$custom;

      if (this.customEmojisList != custom) this.addCustomToPool(custom, this.originalPool);
      var skinTone = store.get('skin') || 1;
      maxResults || (maxResults = 75);
      include || (include = []);
      exclude || (exclude = []);
      var results = null,
          pool = this.originalPool;

      if (value.length) {
        if (value == '-' || value == '-1') {
          return [this.emojis['-1'][skinTone]];
        }

        var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
            allResults = [];

        if (values.length > 2) {
          values = [values[0], values[1]];
        }

        if (include.length || exclude.length) {
          pool = {};
          this.data.categories.forEach(function (category) {
            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;

            if (!isIncluded || isExcluded) {
              return;
            }

            category.emojis.forEach(function (emojiId) {
              return pool[emojiId] = _this4.data.emojis[emojiId];
            });
          });

          if (custom.length) {
            var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
            var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;

            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom, pool);
            }
          }
        }

        allResults = values.map(function (value) {
          var aPool = pool,
              aIndex = _this4.index,
              length = 0;

          for (var charIndex = 0; charIndex < value.length; charIndex++) {
            var _char = value[charIndex];
            length++;
            aIndex[_char] || (aIndex[_char] = {});
            aIndex = aIndex[_char];

            if (!aIndex.results) {
              (function () {
                var scores = {};
                aIndex.results = [];
                aIndex.pool = {};

                for (var id in aPool) {
                  var emoji = aPool[id],
                      search = emoji.search,
                      sub = value.substr(0, length),
                      subIndex = search.indexOf(sub);

                  if (subIndex != -1) {
                    var score = subIndex + 1;
                    if (sub == id) score = 0;

                    if (_this4.emojis[id] && _this4.emojis[id][skinTone]) {
                      aIndex.results.push(_this4.emojis[id][skinTone]);
                    } else {
                      aIndex.results.push(_this4.emojis[id]);
                    }

                    aIndex.pool[id] = emoji;
                    scores[id] = score;
                  }
                }

                aIndex.results.sort(function (a, b) {
                  var aScore = scores[a.id],
                      bScore = scores[b.id];

                  if (aScore == bScore) {
                    return a.id.localeCompare(b.id);
                  } else {
                    return aScore - bScore;
                  }
                });
              })();
            }

            aPool = aIndex.pool;
          }

          return aIndex.results;
        }).filter(function (a) {
          return a;
        });

        if (allResults.length > 1) {
          results = intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }

      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(function (result) {
            return emojisToShowFilter(pool[result.id]);
          });
        }

        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }

      return results;
    }
  }]);

  return NimbleEmojiIndex;
}();

var emojiIndex = new NimbleEmojiIndex(data);

var DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];
var frequently, initialized;
var defaults = {};

function init() {
  initialized = true;
  frequently = store.get('frequently');
}

function add(emoji) {
  if (!initialized) init();
  var id = emoji.id;
  frequently || (frequently = defaults);
  frequently[id] || (frequently[id] = 0);
  frequently[id] += 1;
  store.set('last', id);
  store.set('frequently', frequently);
}

function get$1(perLine) {
  if (!initialized) init();

  if (!frequently) {
    defaults = {};
    var result = [];

    for (var i = 0; i < perLine; i++) {
      defaults[DEFAULTS[i]] = perLine - i;
      result.push(DEFAULTS[i]);
    }

    return result;
  }

  var quantity = perLine * 4;
  var frequentlyKeys = [];

  for (var key in frequently) {
    if (frequently.hasOwnProperty(key)) {
      frequentlyKeys.push(key);
    }
  }

  var sorted = frequentlyKeys.sort(function (a, b) {
    return frequently[a] - frequently[b];
  }).reverse();
  var sliced = sorted.slice(0, quantity);
  var last = store.get('last');

  if (last && sliced.indexOf(last) == -1) {
    sliced.pop();
    sliced.push(last);
  }

  return sliced;
}

var frequently$1 = {
  add: add,
  get: get$1
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty$1;

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var categories$1 = {
  activity: function activity() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
    }));
  },
  custom: function custom() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("g", {
      transform: "translate(2.000000, 1.000000)"
    }, React.createElement("rect", {
      id: "Rectangle",
      x: "8",
      y: "0",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    })));
  },
  flags: function flags() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
    }));
  },
  foods: function foods() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
    }));
  },
  nature: function nature() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
    }), React.createElement("path", {
      d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
    }));
  },
  objects: function objects() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
    }), React.createElement("path", {
      d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
    }));
  },
  people: function people() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }), React.createElement("path", {
      d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
    }));
  },
  places: function places() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
    }), React.createElement("path", {
      d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
    }));
  },
  recent: function recent() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
    }), React.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }));
  },
  symbols: function symbols() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React.createElement("path", {
      d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
    }));
  }
};
var search = {
  search: function search() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React.createElement("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    }));
  },
  "delete": function _delete() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React.createElement("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    }));
  }
};

var icons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    categories: categories$1,
    search: search
});

var EmojiPropTypes = {
  data: propTypes.object.isRequired,
  onOver: propTypes.func,
  onLeave: propTypes.func,
  onClick: propTypes.func,
  fallback: propTypes.func,
  backgroundImageFn: propTypes.func,
  "native": propTypes.bool,
  forceSize: propTypes.bool,
  tooltip: propTypes.bool,
  useButton: propTypes.bool,
  skin: propTypes.oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: propTypes.oneOf([16, 20, 32, 64]),
  sheetColumns: propTypes.number,
  sheetRows: propTypes.number,
  set: propTypes.oneOf(['apple', 'google', 'twitter', 'facebook']),
  size: propTypes.number.isRequired,
  emoji: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired
};
var PickerPropTypes = {
  onClick: propTypes.func,
  onSelect: propTypes.func,
  onSkinChange: propTypes.func,
  perLine: propTypes.number,
  emojiSize: propTypes.number,
  i18n: propTypes.object,
  style: propTypes.object,
  title: propTypes.string,
  emoji: propTypes.string,
  color: propTypes.string,
  set: EmojiPropTypes.set,
  skin: EmojiPropTypes.skin,
  "native": propTypes.bool,
  backgroundImageFn: EmojiPropTypes.backgroundImageFn,
  sheetSize: EmojiPropTypes.sheetSize,
  emojisToShowFilter: propTypes.func,
  showPreview: propTypes.bool,
  showSkinTones: propTypes.bool,
  emojiTooltip: EmojiPropTypes.tooltip,
  useButton: EmojiPropTypes.useButton,
  theme: propTypes.oneOf(['auto', 'light', 'dark']),
  include: propTypes.arrayOf(propTypes.string),
  exclude: propTypes.arrayOf(propTypes.string),
  recent: propTypes.arrayOf(propTypes.string),
  autoFocus: propTypes.bool,
  enableFrequentEmojiSort: propTypes.bool,
  custom: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string.isRequired,
    short_names: propTypes.arrayOf(propTypes.string).isRequired,
    emoticons: propTypes.arrayOf(propTypes.string),
    keywords: propTypes.arrayOf(propTypes.string),
    imageUrl: propTypes.string,
    spriteUrl: propTypes.string,
    sheet_x: propTypes.number,
    sheet_y: propTypes.number,
    size: propTypes.number,
    sheetColumns: propTypes.number,
    sheetRows: propTypes.number
  })),
  skinEmoji: propTypes.string,
  notFound: propTypes.func,
  notFoundEmoji: propTypes.string,
  icons: propTypes.object
};

var Anchors =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(Anchors, _React$PureComponent);

  function Anchors(props) {
    var _this;

    classCallCheck(this, Anchors);

    _this = possibleConstructorReturn(this, getPrototypeOf(Anchors).call(this, props));
    var defaultCategory = props.categories.filter(function (category) {
      return category.first;
    })[0];
    _this.state = {
      selected: defaultCategory.name
    };
    _this.handleClick = _this.handleClick.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(Anchors, [{
    key: "handleClick",
    value: function handleClick(e) {
      var index = e.currentTarget.getAttribute('data-index');
      var _this$props = this.props,
          categories = _this$props.categories,
          onAnchorClick = _this$props.onAnchorClick;
      onAnchorClick(categories[index], index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          categories = _this$props2.categories,
          color = _this$props2.color,
          i18n = _this$props2.i18n,
          icons = _this$props2.icons,
          selected = this.state.selected;
      return React.createElement("nav", {
        className: "emoji-mart-anchors",
        "aria-label": i18n.categorieslabel
      }, categories.map(function (category, i) {
        var id = category.id,
            name = category.name,
            anchor = category.anchor,
            isSelected = name == selected;

        if (anchor === false) {
          return null;
        }

        var iconId = id.startsWith('custom-') ? 'custom' : id;
        return React.createElement("button", {
          key: id,
          "aria-label": i18n.categories[iconId],
          title: i18n.categories[iconId],
          "data-index": i,
          type: 'button',
          onClick: _this2.handleClick,
          className: "emoji-mart-anchor ".concat(isSelected ? 'emoji-mart-anchor-selected' : ''),
          style: {
            color: isSelected ? color : null
          }
        }, React.createElement("div", {
          className: "emoji-mart-anchor-icon"
        }, icons.categories[iconId]()), React.createElement("span", {
          className: "emoji-mart-anchor-bar",
          style: {
            backgroundColor: color
          }
        }));
      }));
    }
  }]);

  return Anchors;
}(React.PureComponent);
Anchors.propTypes
/* remove-proptypes */
= {
  categories: propTypes.array,
  onAnchorClick: propTypes.func,
  icons: propTypes.object
};
Anchors.defaultProps = {
  categories: [],
  onAnchorClick: function onAnchorClick() {},
  icons: {}
};

var EmojiDefaultProps = {
  skin: 1,
  set: 'apple',
  sheetSize: 64,
  sheetColumns: 57,
  sheetRows: 57,
  "native": false,
  forceSize: false,
  tooltip: false,
  useButton: true,
  backgroundImageFn: function backgroundImageFn(set, sheetSize) {
    return "https://unpkg.com/emoji-datasource-".concat(set, "@").concat("5.0.1", "/img/").concat(set, "/sheets-256/").concat(sheetSize, ".png");
  }
};
var PickerDefaultProps = {
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onSkinChange: function onSkinChange() {},
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: 'Emoji Mart™',
  emoji: 'department_store',
  color: '#ae65c5',
  set: EmojiDefaultProps.set,
  theme: 'light',
  skin: null,
  defaultSkin: EmojiDefaultProps.skin,
  "native": EmojiDefaultProps["native"],
  sheetSize: EmojiDefaultProps.sheetSize,
  backgroundImageFn: EmojiDefaultProps.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: true,
  showSkinTones: true,
  emojiTooltip: EmojiDefaultProps.tooltip,
  useButton: EmojiDefaultProps.useButton,
  autoFocus: false,
  enableFrequentEmojiSort: false,
  custom: [],
  skinEmoji: '',
  notFound: function notFound() {},
  notFoundEmoji: 'sleuth_or_spy',
  icons: {}
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _getData = function _getData(props) {
  var emoji = props.emoji,
      skin = props.skin,
      set = props.set,
      data = props.data;
  return getData(emoji, skin, set, data);
};

var _getPosition = function _getPosition(props) {
  var _getData2 = _getData(props),
      sheet_x = _getData2.sheet_x,
      sheet_y = _getData2.sheet_y,
      multiplyX = 100 / (props.sheetColumns - 1),
      multiplyY = 100 / (props.sheetRows - 1);

  return "".concat(multiplyX * sheet_x, "% ").concat(multiplyY * sheet_y, "%");
};

var _getSanitizedData = function _getSanitizedData(props) {
  var emoji = props.emoji,
      skin = props.skin,
      set = props.set,
      data = props.data;
  return getSanitizedData(emoji, skin, set, data);
};

var _handleClick = function _handleClick(e, props) {
  if (!props.onClick) {
    return;
  }

  var onClick = props.onClick,
      emoji = _getSanitizedData(props);

  onClick(emoji, e);
};

var _handleOver = function _handleOver(e, props) {
  if (!props.onOver) {
    return;
  }

  var onOver = props.onOver,
      emoji = _getSanitizedData(props);

  onOver(emoji, e);
};

var _handleLeave = function _handleLeave(e, props) {
  if (!props.onLeave) {
    return;
  }

  var onLeave = props.onLeave,
      emoji = _getSanitizedData(props);

  onLeave(emoji, e);
};

var _isNumeric = function _isNumeric(value) {
  return !isNaN(value - parseFloat(value));
};

var _convertStyleToCSS = function _convertStyleToCSS(style) {
  var div = document.createElement('div');

  for (var key in style) {
    var value = style[key];

    if (_isNumeric(value)) {
      value += 'px';
    }

    div.style[key] = value;
  }

  return div.getAttribute('style');
};

var NimbleEmoji = function NimbleEmoji(props) {
  if (props.data.compressed) {
    uncompress(props.data);
  }

  for (var k in NimbleEmoji.defaultProps) {
    if (props[k] == undefined && NimbleEmoji.defaultProps[k] != undefined) {
      props[k] = NimbleEmoji.defaultProps[k];
    }
  }

  var data = _getData(props);

  if (!data) {
    if (props.fallback) {
      return props.fallback(null, props);
    } else {
      return null;
    }
  }

  var unified = data.unified,
      custom = data.custom,
      short_names = data.short_names,
      imageUrl = data.imageUrl,
      style = {},
      children = props.children,
      className = 'emoji-mart-emoji',
      nativeEmoji = unified && unifiedToNative(unified),
      label = [nativeEmoji].concat(short_names).filter(Boolean).join(', '),
      title = null;

  if (!unified && !custom) {
    if (props.fallback) {
      return props.fallback(data, props);
    } else {
      return null;
    }
  }

  if (props.tooltip) {
    title = short_names[0];
  }

  if (props["native"] && unified) {
    className += ' emoji-mart-emoji-native';
    style = {
      fontSize: props.size
    };
    children = nativeEmoji;

    if (props.forceSize) {
      style.display = 'inline-block';
      style.width = props.size;
      style.height = props.size;
      style.wordBreak = 'keep-all';
    }
  } else if (custom) {
    className += ' emoji-mart-emoji-custom';
    style = {
      width: props.size,
      height: props.size,
      display: 'inline-block'
    };

    if (data.spriteUrl) {
      style = _objectSpread({}, style, {
        backgroundImage: "url(".concat(data.spriteUrl, ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      });
    } else {
      style = _objectSpread({}, style, {
        backgroundImage: "url(".concat(imageUrl, ")"),
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      });
    }
  } else {
    var setHasEmoji = data["has_img_".concat(props.set)] == undefined || data["has_img_".concat(props.set)];

    if (!setHasEmoji) {
      if (props.fallback) {
        return props.fallback(data, props);
      } else {
        return null;
      }
    } else {
      style = {
        width: props.size,
        height: props.size,
        display: 'inline-block',
        backgroundImage: "url(".concat(props.backgroundImageFn(props.set, props.sheetSize), ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      };
    }
  }

  var Tag = {
    name: 'span',
    props: {}
  };

  if (props.onClick && props.useButton) {
    Tag.name = 'button';
    Tag.props = {
      type: 'button'
    };
  }

  if (props.html) {
    style = _convertStyleToCSS(style);
    return "<".concat(Tag.name, " style='").concat(style, "' aria-label='").concat(label, "' ").concat(title ? "title='".concat(title, "'") : '', " class='").concat(className, "'>").concat(children || '', "</").concat(Tag.name, ">");
  } else {
    return React.createElement(Tag.name, _extends_1({
      onClick: function onClick(e) {
        return _handleClick(e, props);
      },
      onMouseEnter: function onMouseEnter(e) {
        return _handleOver(e, props);
      },
      onMouseLeave: function onMouseLeave(e) {
        return _handleLeave(e, props);
      },
      "aria-label": label,
      title: title,
      className: className
    }, Tag.props), React.createElement("span", {
      style: style
    }, children));
  }
};

NimbleEmoji.propTypes
/* remove-proptypes */
= _objectSpread({}, EmojiPropTypes, {
  data: propTypes.object.isRequired
});
NimbleEmoji.defaultProps = EmojiDefaultProps;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NotFound =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(NotFound, _React$PureComponent);

  function NotFound() {
    classCallCheck(this, NotFound);

    return possibleConstructorReturn(this, getPrototypeOf(NotFound).apply(this, arguments));
  }

  createClass(NotFound, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          emojiProps = _this$props.emojiProps,
          i18n = _this$props.i18n,
          notFound = _this$props.notFound,
          notFoundEmoji = _this$props.notFoundEmoji;
      var component = notFound && notFound() || React.createElement("div", {
        className: "emoji-mart-no-results"
      }, NimbleEmoji(_objectSpread$1({
        data: data
      }, emojiProps, {
        size: 38,
        emoji: notFoundEmoji,
        onOver: null,
        onLeave: null,
        onClick: null
      })), React.createElement("div", {
        className: "emoji-mart-no-results-label"
      }, i18n.notfound));
      return component;
    }
  }]);

  return NotFound;
}(React.PureComponent);
NotFound.propTypes
/* remove-proptypes */
= {
  notFound: propTypes.func.isRequired,
  emojiProps: propTypes.object.isRequired
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Category =
/*#__PURE__*/
function (_React$Component) {
  inherits(Category, _React$Component);

  function Category(props) {
    var _this;

    classCallCheck(this, Category);

    _this = possibleConstructorReturn(this, getPrototypeOf(Category).call(this, props));
    _this.data = props.data;
    _this.setContainerRef = _this.setContainerRef.bind(assertThisInitialized(_this));
    _this.setLabelRef = _this.setLabelRef.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(Category, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.margin = 0;
      this.minMargin = 0;
      this.memoizeSize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$props = this.props,
          name = _this$props.name,
          perLine = _this$props.perLine,
          _native = _this$props["native"],
          hasStickyPosition = _this$props.hasStickyPosition,
          emojis = _this$props.emojis,
          emojiProps = _this$props.emojiProps,
          skin = emojiProps.skin,
          size = emojiProps.size,
          set = emojiProps.set,
          nextPerLine = nextProps.perLine,
          nextNative = nextProps["native"],
          nextHasStickyPosition = nextProps.hasStickyPosition,
          nextEmojis = nextProps.emojis,
          nextEmojiProps = nextProps.emojiProps,
          nextSkin = nextEmojiProps.skin,
          nextSize = nextEmojiProps.size,
          nextSet = nextEmojiProps.set,
          shouldUpdate = false;

      if (name == 'Recent' && perLine != nextPerLine) {
        shouldUpdate = true;
      }

      if (name == 'Search') {
        shouldUpdate = !(emojis == nextEmojis);
      }

      if (skin != nextSkin || size != nextSize || _native != nextNative || set != nextSet || hasStickyPosition != nextHasStickyPosition) {
        shouldUpdate = true;
      }

      return shouldUpdate;
    }
  }, {
    key: "memoizeSize",
    value: function memoizeSize() {
      if (!this.container) {
        // probably this is a test environment, e.g. jest
        this.top = 0;
        this.maxMargin = 0;
        return;
      }

      var parent = this.container.parentElement;

      var _this$container$getBo = this.container.getBoundingClientRect(),
          top = _this$container$getBo.top,
          height = _this$container$getBo.height;

      var _parent$getBoundingCl = parent.getBoundingClientRect(),
          parentTop = _parent$getBoundingCl.top;

      var _this$label$getBoundi = this.label.getBoundingClientRect(),
          labelHeight = _this$label$getBoundi.height;

      this.top = top - parentTop + parent.scrollTop;

      if (height == 0) {
        this.maxMargin = 0;
      } else {
        this.maxMargin = height - labelHeight;
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(scrollTop) {
      var margin = scrollTop - this.top;
      margin = margin < this.minMargin ? this.minMargin : margin;
      margin = margin > this.maxMargin ? this.maxMargin : margin;
      if (margin == this.margin) return;

      if (!this.props.hasStickyPosition) {
        this.label.style.top = "".concat(margin, "px");
      }

      this.margin = margin;
      return true;
    }
  }, {
    key: "getEmojis",
    value: function getEmojis() {
      var _this2 = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          emojis = _this$props2.emojis,
          recent = _this$props2.recent,
          perLine = _this$props2.perLine;

      if (name == 'Recent') {
        var custom = this.props.custom;
        var frequentlyUsed = recent || frequently$1.get(perLine);

        if (frequentlyUsed.length) {
          emojis = frequentlyUsed.map(function (id) {
            var emoji = custom.filter(function (e) {
              return e.id === id;
            })[0];

            if (emoji) {
              return emoji;
            }

            return id;
          }).filter(function (id) {
            return !!getData(id, null, null, _this2.data);
          });
        }

        if (emojis.length === 0 && frequentlyUsed.length > 0) {
          return null;
        }
      }

      if (emojis) {
        emojis = emojis.slice(0);
      }

      return emojis;
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay(display) {
      var emojis = this.getEmojis();

      if (!emojis || !this.container) {
        return;
      }

      this.container.style.display = display;
    }
  }, {
    key: "setContainerRef",
    value: function setContainerRef(c) {
      this.container = c;
    }
  }, {
    key: "setLabelRef",
    value: function setLabelRef(c) {
      this.label = c;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          name = _this$props3.name,
          hasStickyPosition = _this$props3.hasStickyPosition,
          emojiProps = _this$props3.emojiProps,
          i18n = _this$props3.i18n,
          notFound = _this$props3.notFound,
          notFoundEmoji = _this$props3.notFoundEmoji,
          emojis = this.getEmojis(),
          labelStyles = {},
          labelSpanStyles = {},
          containerStyles = {};

      if (!emojis) {
        containerStyles = {
          display: 'none'
        };
      }

      if (!hasStickyPosition) {
        labelStyles = {
          height: 28
        };
        labelSpanStyles = {
          position: 'absolute'
        };
      }

      var label = i18n.categories[id] || name;
      return React.createElement("section", {
        ref: this.setContainerRef,
        className: "emoji-mart-category",
        "aria-label": label,
        style: containerStyles
      }, React.createElement("div", {
        style: labelStyles,
        "data-name": name,
        className: "emoji-mart-category-label"
      }, React.createElement("span", {
        style: labelSpanStyles,
        ref: this.setLabelRef,
        "aria-hidden": true
        /* already labeled by the section aria-label */

      }, label)), React.createElement("ul", {
        className: "emoji-mart-category-list"
      }, emojis && emojis.map(function (emoji) {
        return React.createElement("li", {
          key: emoji.short_names && emoji.short_names.join('_') || emoji
        }, NimbleEmoji(_objectSpread$2({
          emoji: emoji,
          data: _this3.data
        }, emojiProps)));
      })), emojis && !emojis.length && React.createElement(NotFound, {
        i18n: i18n,
        notFound: notFound,
        notFoundEmoji: notFoundEmoji,
        data: this.data,
        emojiProps: emojiProps
      }));
    }
  }]);

  return Category;
}(React.Component);
Category.propTypes
/* remove-proptypes */
= {
  emojis: propTypes.array,
  hasStickyPosition: propTypes.bool,
  name: propTypes.string.isRequired,
  "native": propTypes.bool.isRequired,
  perLine: propTypes.number.isRequired,
  emojiProps: propTypes.object.isRequired,
  recent: propTypes.arrayOf(propTypes.string),
  notFound: propTypes.func,
  notFoundEmoji: propTypes.string.isRequired
};
Category.defaultProps = {
  emojis: [],
  hasStickyPosition: true
};

var Skins =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(Skins, _React$PureComponent);

  function Skins(props) {
    var _this;

    classCallCheck(this, Skins);

    _this = possibleConstructorReturn(this, getPrototypeOf(Skins).call(this, props));
    _this.state = {
      opened: false
    };
    return _this;
  }

  createClass(Skins, [{
    key: "handleClick",
    value: function handleClick(e) {
      var skin = parseInt(e.currentTarget.getAttribute('data-skin'));
      var onChange = this.props.onChange;

      if (!this.state.opened) {
        this.setState({
          opened: true
        });
      } else {
        this.setState({
          opened: false
        });

        if (skin != this.props.skin) {
          onChange(skin);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Skins;
}(React.PureComponent);
Skins.propTypes
/* remove-proptypes */
= {
  onChange: propTypes.func,
  skin: propTypes.number.isRequired
};
Skins.defaultProps = {
  onChange: function onChange() {}
};

var SkinsEmoji =
/*#__PURE__*/
function (_Skins) {
  inherits(SkinsEmoji, _Skins);

  function SkinsEmoji(props) {
    var _this;

    classCallCheck(this, SkinsEmoji);

    _this = possibleConstructorReturn(this, getPrototypeOf(SkinsEmoji).call(this, props));
    _this.handleClick = _this.handleClick.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(SkinsEmoji, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          skin = _this$props.skin,
          emojiProps = _this$props.emojiProps,
          data = _this$props.data,
          skinEmoji = _this$props.skinEmoji,
          i18n = _this$props.i18n;
      var opened = this.state.opened;
      var skinToneNodes = [];

      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin;
        skinToneNodes.push(React.createElement("span", {
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch custom".concat(selected ? ' selected' : '')
        }, React.createElement("span", {
          onClick: this.handleClick,
          "data-skin": skinTone,
          className: "emoji-mart-skin-tone-".concat(skinTone)
        }, NimbleEmoji({
          emoji: skinEmoji,
          data: data,
          skin: skinTone,
          backgroundImageFn: emojiProps.backgroundImageFn,
          "native": emojiProps["native"],
          set: emojiProps.set,
          sheetSize: emojiProps.sheetSize,
          size: 23
        }))));
      }

      return React.createElement("div", {
        className: "emoji-mart-skin-swatches custom".concat(opened ? ' opened' : '')
      }, React.createElement("div", {
        className: "emoji-mart-skin-text".concat(opened ? ' opened' : '')
      }, i18n.skintext), skinToneNodes);
    }
  }]);

  return SkinsEmoji;
}(Skins);
SkinsEmoji.propTypes
/* remove-proptypes */
= {
  onChange: propTypes.func,
  skin: propTypes.number.isRequired,
  emojiProps: propTypes.object.isRequired,
  skinTone: propTypes.number,
  skinEmoji: propTypes.string.isRequired,
  i18n: propTypes.object
};
SkinsEmoji.defaultProps = {
  onChange: function onChange() {},
  skinTone: null
};

var SkinsDot =
/*#__PURE__*/
function (_Skins) {
  inherits(SkinsDot, _Skins);

  function SkinsDot(props) {
    var _this;

    classCallCheck(this, SkinsDot);

    _this = possibleConstructorReturn(this, getPrototypeOf(SkinsDot).call(this, props));
    _this.handleClick = _this.handleClick.bind(assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(SkinsDot, [{
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      // if either enter or space is pressed, then execute
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          skin = _this$props.skin,
          i18n = _this$props.i18n;
      var opened = this.state.opened;
      var skinToneNodes = [];

      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin;
        var visible = opened || selected;
        skinToneNodes.push(React.createElement("span", _extends_1({
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch".concat(selected ? ' selected' : ''),
          "aria-label": i18n.skintones[skinTone],
          "aria-hidden": !visible
        }, opened ? {
          role: 'menuitem'
        } : {}), React.createElement("span", _extends_1({
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          role: "button"
        }, selected ? {
          'aria-haspopup': true,
          'aria-expanded': !!opened
        } : {}, opened ? {
          'aria-pressed': !!selected
        } : {}, {
          tabIndex: visible ? '0' : '',
          "aria-label": i18n.skintones[skinTone],
          title: i18n.skintones[skinTone],
          "data-skin": skinTone,
          className: "emoji-mart-skin emoji-mart-skin-tone-".concat(skinTone)
        }))));
      }

      return React.createElement("section", {
        className: "emoji-mart-skin-swatches".concat(opened ? ' opened' : ''),
        "aria-label": i18n.skintext
      }, React.createElement("div", opened ? {
        role: 'menubar'
      } : {}, skinToneNodes));
    }
  }]);

  return SkinsDot;
}(Skins);
SkinsDot.propTypes
/* remove-proptypes */
= {
  onChange: propTypes.func,
  skin: propTypes.number.isRequired,
  i18n: propTypes.object
};
SkinsDot.defaultProps = {
  onChange: function onChange() {}
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Preview =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(Preview, _React$PureComponent);

  function Preview(props) {
    var _this;

    classCallCheck(this, Preview);

    _this = possibleConstructorReturn(this, getPrototypeOf(Preview).call(this, props));
    _this.data = props.data;
    _this.state = {
      emoji: null
    };
    return _this;
  }

  createClass(Preview, [{
    key: "render",
    value: function render() {
      var emoji = this.state.emoji,
          _this$props = this.props,
          emojiProps = _this$props.emojiProps,
          skinsProps = _this$props.skinsProps,
          showSkinTones = _this$props.showSkinTones,
          title = _this$props.title,
          idleEmoji = _this$props.emoji,
          i18n = _this$props.i18n,
          showPreview = _this$props.showPreview;

      if (emoji && showPreview) {
        var emojiData = getData(emoji, null, null, this.data),
            _emojiData$emoticons = emojiData.emoticons,
            emoticons = _emojiData$emoticons === void 0 ? [] : _emojiData$emoticons,
            knownEmoticons = [],
            listedEmoticons = [];
        emoticons.forEach(function (emoticon) {
          if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) {
            return;
          }

          knownEmoticons.push(emoticon.toLowerCase());
          listedEmoticons.push(emoticon);
        });
        return React.createElement("div", {
          className: "emoji-mart-preview"
        }, React.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, NimbleEmoji(_objectSpread$3({
          key: emoji.id,
          emoji: emoji,
          data: this.data
        }, emojiProps))), React.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React.createElement("div", {
          className: "emoji-mart-preview-name"
        }, emoji.name), React.createElement("div", {
          className: "emoji-mart-preview-shortnames"
        }, emojiData.short_names.map(function (short_name) {
          return React.createElement("span", {
            key: short_name,
            className: "emoji-mart-preview-shortname"
          }, ":", short_name, ":");
        })), React.createElement("div", {
          className: "emoji-mart-preview-emoticons"
        }, listedEmoticons.map(function (emoticon) {
          return React.createElement("span", {
            key: emoticon,
            className: "emoji-mart-preview-emoticon"
          }, emoticon);
        }))));
      } else {
        return React.createElement("div", {
          className: "emoji-mart-preview"
        }, React.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, idleEmoji && idleEmoji.length && NimbleEmoji(_objectSpread$3({
          emoji: idleEmoji,
          data: this.data
        }, emojiProps))), React.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React.createElement("span", {
          className: "emoji-mart-title-label"
        }, title)), showSkinTones && React.createElement("div", {
          className: "emoji-mart-preview-skins".concat(skinsProps.skinEmoji ? ' custom' : '')
        }, skinsProps.skinEmoji ? React.createElement(SkinsEmoji, {
          skin: skinsProps.skin,
          emojiProps: emojiProps,
          data: this.data,
          skinEmoji: skinsProps.skinEmoji,
          i18n: i18n,
          onChange: skinsProps.onChange
        }) : React.createElement(SkinsDot, {
          skin: skinsProps.skin,
          i18n: i18n,
          onChange: skinsProps.onChange
        })));
      }
    }
  }]);

  return Preview;
}(React.PureComponent);
Preview.propTypes
/* remove-proptypes */
= {
  showSkinTones: propTypes.bool,
  title: propTypes.string.isRequired,
  emoji: propTypes.string.isRequired,
  emojiProps: propTypes.object.isRequired,
  skinsProps: propTypes.object.isRequired
};
Preview.defaultProps = {
  showSkinTones: true,
  onChange: function onChange() {}
};

var id = 0;

var Search =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(Search, _React$PureComponent);

  function Search(props) {
    var _this;

    classCallCheck(this, Search);

    _this = possibleConstructorReturn(this, getPrototypeOf(Search).call(this, props));
    _this.state = {
      icon: search.search,
      isSearching: false,
      id: ++id
    };
    _this.data = props.data;
    _this.emojiIndex = new NimbleEmojiIndex(_this.data);
    _this.setRef = _this.setRef.bind(assertThisInitialized(_this));
    _this.clear = _this.clear.bind(assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(assertThisInitialized(_this)); // throttle keyboard input so that typing isn't delayed

    _this.handleChange = throttleIdleTask(_this.handleChange.bind(assertThisInitialized(_this)));
    return _this;
  }

  createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // in some cases (e.g. preact) the input may already be pre-populated
      // this.input is undefined in Jest tests
      if (this.input && this.input.value) {
        this.search(this.input.value);
      }
    }
  }, {
    key: "search",
    value: function search$1(value) {
      if (value == '') this.setState({
        icon: search.search,
        isSearching: false
      });else this.setState({
        icon: search["delete"],
        isSearching: true
      });
      this.props.onSearch(this.emojiIndex.search(value, {
        emojisToShowFilter: this.props.emojisToShowFilter,
        maxResults: this.props.maxResults,
        include: this.props.include,
        exclude: this.props.exclude,
        custom: this.props.custom
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.input.value == '') return;
      this.input.value = '';
      this.input.focus();
      this.search('');
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      if (this.input) {
        this.search(this.input.value);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      if (e.keyCode === 13) {
        this.clear();
      }
    }
  }, {
    key: "setRef",
    value: function setRef(c) {
      this.input = c;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          i18n = _this$props.i18n,
          autoFocus = _this$props.autoFocus;
      var _this$state = this.state,
          icon = _this$state.icon,
          isSearching = _this$state.isSearching,
          id = _this$state.id;
      var inputId = "emoji-mart-search-".concat(id);
      return React.createElement("section", {
        className: "emoji-mart-search",
        "aria-label": i18n.search
      }, React.createElement("input", {
        id: inputId,
        ref: this.setRef,
        type: "search",
        onChange: this.handleChange,
        placeholder: i18n.search,
        autoFocus: autoFocus
      }), React.createElement("label", {
        className: "emoji-mart-sr-only",
        htmlFor: inputId
      }, i18n.search), React.createElement("button", {
        className: "emoji-mart-search-icon",
        onClick: this.clear,
        onKeyUp: this.handleKeyUp,
        "aria-label": i18n.clear,
        disabled: !isSearching
      }, icon()));
    }
  }]);

  return Search;
}(React.PureComponent);
Search.propTypes
/* remove-proptypes */
= {
  onSearch: propTypes.func,
  maxResults: propTypes.number,
  emojisToShowFilter: propTypes.func,
  autoFocus: propTypes.bool
};
Search.defaultProps = {
  onSearch: function onSearch() {},
  maxResults: 75,
  emojisToShowFilter: null,
  autoFocus: false
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var I18N = {
  search: 'Search',
  clear: 'Clear',
  // Accessible label on "clear" button
  notfound: 'No Emoji Found',
  skintext: 'Choose your default skin tone',
  categories: {
    search: 'Search Results',
    recent: 'Frequently Used',
    people: 'Smileys & People',
    nature: 'Animals & Nature',
    foods: 'Food & Drink',
    activity: 'Activity',
    places: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    custom: 'Custom'
  },
  categorieslabel: 'Emoji categories',
  // Accessible title for the list of categories
  skintones: {
    1: 'Default Skin Tone',
    2: 'Light Skin Tone',
    3: 'Medium-Light Skin Tone',
    4: 'Medium Skin Tone',
    5: 'Medium-Dark Skin Tone',
    6: 'Dark Skin Tone'
  }
};

var NimblePicker =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(NimblePicker, _React$PureComponent);

  function NimblePicker(props) {
    var _this;

    classCallCheck(this, NimblePicker);

    _this = possibleConstructorReturn(this, getPrototypeOf(NimblePicker).call(this, props));
    _this.CUSTOM = [];
    _this.RECENT_CATEGORY = {
      id: 'recent',
      name: 'Recent',
      emojis: null
    };
    _this.SEARCH_CATEGORY = {
      id: 'search',
      name: 'Search',
      emojis: null,
      anchor: false
    };

    if (props.data.compressed) {
      uncompress(props.data);
    }

    _this.data = props.data;
    _this.i18n = deepMerge(I18N, props.i18n);
    _this.icons = deepMerge(icons, props.icons);
    _this.state = {
      firstRender: true
    };
    _this.categories = [];
    var allCategories = [].concat(_this.data.categories);

    if (props.custom.length > 0) {
      var customCategories = {};
      var customCategoriesCreated = 0;
      props.custom.forEach(function (emoji) {
        if (!customCategories[emoji.customCategory]) {
          customCategories[emoji.customCategory] = {
            id: emoji.customCategory ? "custom-".concat(emoji.customCategory) : 'custom',
            name: emoji.customCategory || 'Custom',
            emojis: [],
            anchor: customCategoriesCreated === 0
          };
          customCategoriesCreated++;
        }

        var category = customCategories[emoji.customCategory];

        var customEmoji = _objectSpread$4({}, emoji, {
          // `<Category />` expects emoji to have an `id`.
          id: emoji.short_names[0],
          custom: true
        });

        category.emojis.push(customEmoji);

        _this.CUSTOM.push(customEmoji);
      });
      allCategories = allCategories.concat(Object.keys(customCategories).map(function (key) {
        return customCategories[key];
      }));
    }

    _this.hideRecent = true;

    if (props.include != undefined) {
      allCategories.sort(function (a, b) {
        if (props.include.indexOf(a.id) > props.include.indexOf(b.id)) {
          return 1;
        }

        return -1;
      });
    }

    for (var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      var category = allCategories[categoryIndex];
      var isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : true;
      var isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : false;

      if (!isIncluded || isExcluded) {
        continue;
      }

      if (props.emojisToShowFilter) {
        var newEmojis = [];
        var emojis = category.emojis;

        for (var emojiIndex = 0; emojiIndex < emojis.length; emojiIndex++) {
          var emoji = emojis[emojiIndex];

          if (props.emojisToShowFilter(_this.data.emojis[emoji] || emoji)) {
            newEmojis.push(emoji);
          }
        }

        if (newEmojis.length) {
          var newCategory = {
            emojis: newEmojis,
            name: category.name,
            id: category.id
          };

          _this.categories.push(newCategory);
        }
      } else {
        _this.categories.push(category);
      }
    }

    var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : true;
    var excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : false;

    if (includeRecent && !excludeRecent) {
      _this.hideRecent = false;

      _this.categories.unshift(_this.RECENT_CATEGORY);
    }

    if (_this.categories[0]) {
      _this.categories[0].first = true;
    }

    _this.categories.unshift(_this.SEARCH_CATEGORY);

    _this.setAnchorsRef = _this.setAnchorsRef.bind(assertThisInitialized(_this));
    _this.handleAnchorClick = _this.handleAnchorClick.bind(assertThisInitialized(_this));
    _this.setSearchRef = _this.setSearchRef.bind(assertThisInitialized(_this));
    _this.handleSearch = _this.handleSearch.bind(assertThisInitialized(_this));
    _this.setScrollRef = _this.setScrollRef.bind(assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(assertThisInitialized(_this));
    _this.handleScrollPaint = _this.handleScrollPaint.bind(assertThisInitialized(_this));
    _this.handleEmojiOver = _this.handleEmojiOver.bind(assertThisInitialized(_this));
    _this.handleEmojiLeave = _this.handleEmojiLeave.bind(assertThisInitialized(_this));
    _this.handleEmojiClick = _this.handleEmojiClick.bind(assertThisInitialized(_this));
    _this.handleEmojiSelect = _this.handleEmojiSelect.bind(assertThisInitialized(_this));
    _this.setPreviewRef = _this.setPreviewRef.bind(assertThisInitialized(_this));
    _this.handleSkinChange = _this.handleSkinChange.bind(assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(assertThisInitialized(_this));
    _this.handleDarkMatchMediaChange = _this.handleDarkMatchMediaChange.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(NimblePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.firstRender) {
        this.testStickyPosition();
        this.firstRenderTimeout = setTimeout(function () {
          _this2.setState({
            firstRender: false
          });
        }, 60);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateCategoriesSize();
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.SEARCH_CATEGORY.emojis = null;
      clearTimeout(this.leaveTimeout);
      clearTimeout(this.firstRenderTimeout);

      if (this.darkMatchMedia) {
        this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
      }
    }
  }, {
    key: "testStickyPosition",
    value: function testStickyPosition() {
      var stickyTestElement = document.createElement('div');
      var prefixes = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
      prefixes.forEach(function (prefix) {
        return stickyTestElement.style.position = "".concat(prefix, "sticky");
      });
      this.hasStickyPosition = !!stickyTestElement.style.position.length;
    }
  }, {
    key: "getPreferredTheme",
    value: function getPreferredTheme() {
      if (this.props.theme != 'auto') return this.props.theme;
      if (this.state.theme) return this.state.theme;
      if (typeof matchMedia !== 'function') return PickerDefaultProps.theme;

      if (!this.darkMatchMedia) {
        this.darkMatchMedia = matchMedia('(prefers-color-scheme: dark)');
        this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange);
      }

      if (this.darkMatchMedia.media.match(/^not/)) return PickerDefaultProps.theme;
      return this.darkMatchMedia.matches ? 'dark' : 'light';
    }
  }, {
    key: "handleDarkMatchMediaChange",
    value: function handleDarkMatchMediaChange() {
      this.setState({
        theme: this.darkMatchMedia.matches ? 'dark' : 'light'
      });
    }
  }, {
    key: "handleEmojiOver",
    value: function handleEmojiOver(emoji) {
      var preview = this.preview;

      if (!preview) {
        return;
      } // Use Array.prototype.find() when it is more widely supported.


      var emojiData = this.CUSTOM.filter(function (customEmoji) {
        return customEmoji.id === emoji.id;
      })[0];

      for (var key in emojiData) {
        if (emojiData.hasOwnProperty(key)) {
          emoji[key] = emojiData[key];
        }
      }

      preview.setState({
        emoji: emoji
      });
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: "handleEmojiLeave",
    value: function handleEmojiLeave(emoji) {
      var preview = this.preview;

      if (!preview) {
        return;
      }

      this.leaveTimeout = setTimeout(function () {
        preview.setState({
          emoji: null
        });
      }, 16);
    }
  }, {
    key: "handleEmojiClick",
    value: function handleEmojiClick(emoji, e) {
      this.props.onClick(emoji, e);
      this.handleEmojiSelect(emoji);
    }
  }, {
    key: "handleEmojiSelect",
    value: function handleEmojiSelect(emoji) {
      var _this3 = this;

      this.props.onSelect(emoji);
      if (!this.hideRecent && !this.props.recent) frequently$1.add(emoji);
      var component = this.categoryRefs['category-1'];

      if (component) {
        var maxMargin = component.maxMargin;

        if (this.props.enableFrequentEmojiSort) {
          component.forceUpdate();
        }

        requestAnimationFrame(function () {
          if (!_this3.scroll) return;
          component.memoizeSize();
          if (maxMargin == component.maxMargin) return;

          _this3.updateCategoriesSize();

          _this3.handleScrollPaint();

          if (_this3.SEARCH_CATEGORY.emojis) {
            component.updateDisplay('none');
          }
        });
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (!this.waitingForPaint) {
        this.waitingForPaint = true;
        requestAnimationFrame(this.handleScrollPaint);
      }
    }
  }, {
    key: "handleScrollPaint",
    value: function handleScrollPaint() {
      this.waitingForPaint = false;

      if (!this.scroll) {
        return;
      }

      var activeCategory = null;

      if (this.SEARCH_CATEGORY.emojis) {
        activeCategory = this.SEARCH_CATEGORY;
      } else {
        var target = this.scroll,
            scrollTop = target.scrollTop,
            scrollingDown = scrollTop > (this.scrollTop || 0),
            minTop = 0;

        for (var i = 0, l = this.categories.length; i < l; i++) {
          var ii = scrollingDown ? this.categories.length - 1 - i : i,
              category = this.categories[ii],
              component = this.categoryRefs["category-".concat(ii)];

          if (component) {
            var active = component.handleScroll(scrollTop);

            if (!minTop || component.top < minTop) {
              if (component.top > 0) {
                minTop = component.top;
              }
            }

            if (active && !activeCategory) {
              activeCategory = category;
            }
          }
        }

        if (scrollTop < minTop) {
          activeCategory = this.categories.filter(function (category) {
            return !(category.anchor === false);
          })[0];
        } else if (scrollTop + this.clientHeight >= this.scrollHeight) {
          activeCategory = this.categories[this.categories.length - 1];
        }
      }

      if (activeCategory) {
        var anchors = this.anchors,
            _activeCategory = activeCategory,
            categoryName = _activeCategory.name;

        if (anchors.state.selected != categoryName) {
          anchors.setState({
            selected: categoryName
          });
        }
      }

      this.scrollTop = scrollTop;
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(emojis) {
      this.SEARCH_CATEGORY.emojis = emojis;

      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs["category-".concat(i)];

        if (component && component.props.name != 'Search') {
          var display = emojis ? 'none' : 'inherit';
          component.updateDisplay(display);
        }
      }

      this.forceUpdate();

      if (this.scroll) {
        this.scroll.scrollTop = 0;
      }

      this.handleScroll();
    }
  }, {
    key: "handleAnchorClick",
    value: function handleAnchorClick(category, i) {
      var component = this.categoryRefs["category-".concat(i)],
          scroll = this.scroll,
          anchors = this.anchors,
          scrollToComponent = null;

      scrollToComponent = function scrollToComponent() {
        if (component) {
          var top = component.top;

          if (category.first) {
            top = 0;
          } else {
            top += 1;
          }

          scroll.scrollTop = top;
        }
      };

      if (this.SEARCH_CATEGORY.emojis) {
        this.handleSearch(null);
        this.search.clear();
        requestAnimationFrame(scrollToComponent);
      } else {
        scrollToComponent();
      }
    }
  }, {
    key: "handleSkinChange",
    value: function handleSkinChange(skin) {
      var newState = {
        skin: skin
      },
          onSkinChange = this.props.onSkinChange;
      this.setState(newState);
      store.update(newState);
      onSkinChange(skin);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var handled = false;

      switch (e.keyCode) {
        case 13:
          var emoji;

          if (this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data))) {
            this.handleEmojiSelect(emoji);
            handled = true;
          }

          break;
      }

      if (handled) {
        e.preventDefault();
      }
    }
  }, {
    key: "updateCategoriesSize",
    value: function updateCategoriesSize() {
      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs["category-".concat(i)];
        if (component) component.memoizeSize();
      }

      if (this.scroll) {
        var target = this.scroll;
        this.scrollHeight = target.scrollHeight;
        this.clientHeight = target.clientHeight;
      }
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
    }
  }, {
    key: "setAnchorsRef",
    value: function setAnchorsRef(c) {
      this.anchors = c;
    }
  }, {
    key: "setSearchRef",
    value: function setSearchRef(c) {
      this.search = c;
    }
  }, {
    key: "setPreviewRef",
    value: function setPreviewRef(c) {
      this.preview = c;
    }
  }, {
    key: "setScrollRef",
    value: function setScrollRef(c) {
      this.scroll = c;
    }
  }, {
    key: "setCategoryRef",
    value: function setCategoryRef(name, c) {
      if (!this.categoryRefs) {
        this.categoryRefs = {};
      }

      this.categoryRefs[name] = c;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          perLine = _this$props.perLine,
          emojiSize = _this$props.emojiSize,
          set = _this$props.set,
          sheetSize = _this$props.sheetSize,
          sheetColumns = _this$props.sheetColumns,
          sheetRows = _this$props.sheetRows,
          style = _this$props.style,
          title = _this$props.title,
          emoji = _this$props.emoji,
          color = _this$props.color,
          _native = _this$props["native"],
          backgroundImageFn = _this$props.backgroundImageFn,
          emojisToShowFilter = _this$props.emojisToShowFilter,
          showPreview = _this$props.showPreview,
          showSkinTones = _this$props.showSkinTones,
          emojiTooltip = _this$props.emojiTooltip,
          useButton = _this$props.useButton,
          include = _this$props.include,
          exclude = _this$props.exclude,
          recent = _this$props.recent,
          autoFocus = _this$props.autoFocus,
          skinEmoji = _this$props.skinEmoji,
          notFound = _this$props.notFound,
          notFoundEmoji = _this$props.notFoundEmoji;
      var width = perLine * (emojiSize + 12) + 12 + 2 + measureScrollbar();
      var theme = this.getPreferredTheme();
      var skin = this.props.skin || this.state.skin || store.get('skin') || this.props.defaultSkin;
      return React.createElement("section", {
        style: _objectSpread$4({
          width: width
        }, style),
        className: "emoji-mart emoji-mart-".concat(theme),
        "aria-label": title,
        onKeyDown: this.handleKeyDown
      }, React.createElement("div", {
        className: "emoji-mart-bar"
      }, React.createElement(Anchors, {
        ref: this.setAnchorsRef,
        data: this.data,
        i18n: this.i18n,
        color: color,
        categories: this.categories,
        onAnchorClick: this.handleAnchorClick,
        icons: this.icons
      })), React.createElement(Search, {
        ref: this.setSearchRef,
        onSearch: this.handleSearch,
        data: this.data,
        i18n: this.i18n,
        emojisToShowFilter: emojisToShowFilter,
        include: include,
        exclude: exclude,
        custom: this.CUSTOM,
        autoFocus: autoFocus
      }), React.createElement("div", {
        ref: this.setScrollRef,
        className: "emoji-mart-scroll",
        onScroll: this.handleScroll
      }, this.getCategories().map(function (category, i) {
        return React.createElement(Category, {
          ref: _this4.setCategoryRef.bind(_this4, "category-".concat(i)),
          key: category.name,
          id: category.id,
          name: category.name,
          emojis: category.emojis,
          perLine: perLine,
          "native": _native,
          hasStickyPosition: _this4.hasStickyPosition,
          data: _this4.data,
          i18n: _this4.i18n,
          recent: category.id == _this4.RECENT_CATEGORY.id ? recent : undefined,
          custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : undefined,
          emojiProps: {
            "native": _native,
            skin: skin,
            size: emojiSize,
            set: set,
            sheetSize: sheetSize,
            sheetColumns: sheetColumns,
            sheetRows: sheetRows,
            forceSize: _native,
            tooltip: emojiTooltip,
            backgroundImageFn: backgroundImageFn,
            useButton: useButton,
            onOver: _this4.handleEmojiOver,
            onLeave: _this4.handleEmojiLeave,
            onClick: _this4.handleEmojiClick
          },
          notFound: notFound,
          notFoundEmoji: notFoundEmoji
        });
      })), (showPreview || showSkinTones) && React.createElement("div", {
        className: "emoji-mart-bar"
      }, React.createElement(Preview, {
        ref: this.setPreviewRef,
        data: this.data,
        title: title,
        emoji: emoji,
        showSkinTones: showSkinTones,
        showPreview: showPreview,
        emojiProps: {
          "native": _native,
          size: 38,
          skin: skin,
          set: set,
          sheetSize: sheetSize,
          sheetColumns: sheetColumns,
          sheetRows: sheetRows,
          backgroundImageFn: backgroundImageFn
        },
        skinsProps: {
          skin: skin,
          onChange: this.handleSkinChange,
          skinEmoji: skinEmoji
        },
        i18n: this.i18n
      })));
    }
  }]);

  return NimblePicker;
}(React.PureComponent);
NimblePicker.propTypes
/* remove-proptypes */
= _objectSpread$4({}, PickerPropTypes, {
  data: propTypes.object.isRequired
});
NimblePicker.defaultProps = _objectSpread$4({}, PickerDefaultProps);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Picker =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits(Picker, _React$PureComponent);

  function Picker() {
    classCallCheck(this, Picker);

    return possibleConstructorReturn(this, getPrototypeOf(Picker).apply(this, arguments));
  }

  createClass(Picker, [{
    key: "render",
    value: function render() {
      return React.createElement(NimblePicker, _extends_1({}, this.props, this.state));
    }
  }]);

  return Picker;
}(React.PureComponent);
Picker.propTypes
/* remove-proptypes */
= PickerPropTypes;
Picker.defaultProps = _objectSpread$5({}, PickerDefaultProps, {
  data: data
});

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Emoji = function Emoji(props) {
  for (var k in Emoji.defaultProps) {
    if (props[k] == undefined && Emoji.defaultProps[k] != undefined) {
      props[k] = Emoji.defaultProps[k];
    }
  }

  return NimbleEmoji(_objectSpread$6({}, props));
};

Emoji.propTypes
/* remove-proptypes */
= EmojiPropTypes;
Emoji.defaultProps = _objectSpread$6({}, EmojiDefaultProps, {
  data: data
});

var css_248z$R = ".emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n.emoji-mart-anchor:focus { outline: 0 }\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform; /* avoids \"repaints on scroll\" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type=\"search\">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Segoe UI\", \"Apple Color Emoji\", \"Twemoji Mozilla\", \"Noto Color Emoji\", \"Android Emoji\";\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: .5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999A9C;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) { transition-delay: 0s }\n.emoji-mart-skin-swatch:nth-child(2) { transition-delay: .03s }\n.emoji-mart-skin-swatch:nth-child(3) { transition-delay: .06s }\n.emoji-mart-skin-swatch:nth-child(4) { transition-delay: .09s }\n.emoji-mart-skin-swatch:nth-child(5) { transition-delay: .12s }\n.emoji-mart-skin-swatch:nth-child(6) { transition-delay: .15s }\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: \"\";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 { background-color: #ffc93a }\n.emoji-mart-skin-tone-2 { background-color: #fadcbc }\n.emoji-mart-skin-tone-3 { background-color: #e0bb95 }\n.emoji-mart-skin-tone-4 { background-color: #bf8f68 }\n.emoji-mart-skin-tone-5 { background-color: #9b643d }\n.emoji-mart-skin-tone-6 { background-color: #594539 }\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n";
styleInject(css_248z$R);

var css_248z$S = ".t-inputArea-container {\n  box-shadow: 0px -6px 12px -7px rgba(119, 110, 171, 0.08);\n  margin-top: 6px;\n}\n.t-inputArea-container .t-inputArea-reply-wrapper {\n  text-align: left;\n  padding: 8px;\n}\n.t-inputArea-container .t-inputArea-reply-wrapper .t-inputArea-reply-by-user {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n.t-inputArea-container .inputArea {\n  padding: 4px;\n  display: flex;\n  align-items: center;\n}\n.t-inputArea-container .inputArea .t-inputArea-voiceUpload-wrapper {\n  display: flex;\n}\n.t-inputArea-container .inputArea .t-inputArea-voiceUpload-wrapper .t-upload-container {\n  cursor: pointer;\n  margin-left: 4px;\n}\n.t-inputArea-container .inputArea .formItem {\n  width: 100% !important;\n  margin: 0;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper {\n  display: flex;\n  align-items: center;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .t-input-area {\n  position: relative;\n  width: 100%;\n  margin: 0 16px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .t-input-area .t-inputArea-emojies-wrapper {\n  position: absolute;\n  bottom: 42px;\n  right: 0;\n  width: fit-content;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .t-input-area .t-inputArea-emoji-wrapper {\n  position: absolute;\n  top: 11px;\n  right: 12px;\n  cursor: pointer;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .buttons {\n  font-size: 2px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .buttons svg {\n  color: #b1b2b3;\n  font-size: 22px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .buttons :nth-child(2) svg {\n  font-size: 23px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .inputPart {\n  border: none;\n  box-shadow: none;\n  height: 40px !important;\n  min-height: 40px !important;\n  max-height: 40px !important;\n  resize: none;\n  padding-top: 10px;\n  background: #f7f7f8;\n  border-radius: 4px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper .inputPart[disabled] {\n  background-color: white;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper button {\n  font-size: 16px;\n}\n.t-inputArea-container .inputArea .t-input-area-wrapper button svg {\n  margin-right: 8px;\n}\n.emoji-mart-category .emoji-mart-emoji span {\n  cursor: pointer;\n}\n";
styleInject(css_248z$S);

const {
  TextArea
} = _Input;

const detectMessageType = type => {
  const messageType = type.split('/').shift();

  if (!['image', 'video', 'audio'].includes(messageType)) {
    return 'attachment';
  }

  return messageType;
};

const detectLink = value => {
  const pattern = new RegExp(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);
  const isLink = pattern.test(value);
  const type = isLink ? {
    type: 'link'
  } : {};
  return type;
};

const TInputArea = ({
  repliedMessage,
  unsetRepliedMessage,
  activeMessage,
  unsetActiveMessage,
  disabled,
  actions,
  channelId,
  onUpload,
  onSendMessage,
  handleError = err => {
    _message.error(err.message);
  }
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  const [noMessage, setNoMessage] = useState(true);
  const [message, setMessage] = useState((activeMessage || {}).text);
  const [showEmoji, setShowEmoji] = useState(false);
  const emojiRef = useRef(null);
  const emojiIconRef = useRef(null);

  document.onkeydown = event => {
    if (event.key !== 'Escape') {
      return;
    }

    unsetActiveMessage();
  };

  const handleSendMessage = (message, channelId) => {
    const messageBody = Object.assign({}, message);
    const isActiveMessage = !isEmpty(activeMessage);

    if (isActiveMessage) {
      !messageBody.messageId && (messageBody.messageId = activeMessage.id);
      messageBody.date = activeMessage.date;
      messageBody.id = activeMessage.id;
    }

    if (!isEmpty(repliedMessage)) {
      messageBody.repliedMessage = {
        text: repliedMessage.text,
        sender: repliedMessage.sender,
        date: repliedMessage.date
      };
      unsetRepliedMessage();
    }

    onSendMessage(messageBody, channelId);

    if (isActiveMessage) {
      unsetActiveMessage();
    }
  };

  function onPressEnter(e) {
    const keyCode = e.which || e.keyCode;

    if (keyCode === 13 && !e.shiftKey) {
      // Don't generate a new line
      e.preventDefault();

      if (e.target.value.trim() !== '') {
        handleSendMessage(Object.assign({
          text: e.target.value,
          date: new Date()
        }, detectLink(e.target.value)), channelId);
      }
    }
  }

  const handleSuccess = (file, response, action) => {
    handleSendMessage({
      text: response.url || response.path,
      date: new Date(),
      fileType: action === 'recorder' ? 'audio/wav' : file.type,
      fileName: file.name,
      type: action === 'recorder' ? 'audio' : detectMessageType(file.type)
    }, channelId);
  };

  const onPaste = file => {
    if (!file) {
      return;
    }

    const uploadData = {
      file,
      folder: `channel-${channelId}`,
      type: file.type.split('/').pop(),
      filename: 'file'
    };
    onUpload(uploadData).then(item => {
      handleSuccess(file, item, 'attachment');
    }).catch(err => handleError(err));
  };

  const handleEmojiSelect = e => {
    const emoji = e.native;
    setMessage(message => (message || '') + `${emoji} `);
  };

  const handleClick = event => {
    const isEmojiIcon = emojiIconRef && emojiIconRef.current && emojiIconRef.current.contains(event.target);
    const isTarget = emojiRef && emojiRef.current && emojiRef.current.contains(event.target);

    if (isEmojiIcon) {
      setShowEmoji(!showEmoji);
      return;
    }

    if (!isTarget && showEmoji) {
      setShowEmoji(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
  return React.createElement("div", {
    className: "t-inputArea-container"
  }, !isEmpty(repliedMessage) && React.createElement("div", {
    className: "t-inputArea-reply-wrapper"
  }, React.createElement("div", {
    className: "t-inputArea-reply-by-user"
  }, React.createElement("div", null, React.createElement(TText, {
    level: 3
  }, translate('Reply to')), "\u00A0", React.createElement(TText, {
    level: 3,
    semiBold: true
  }, repliedMessage.sender.name)), React.createElement(IconCloseOutlined, {
    onClick: unsetRepliedMessage
  })), React.createElement(TText, {
    level: 4
  }, repliedMessage.text)), React.createElement(TForm, {
    className: "inputArea",
    onSuccess: value => {
      return handleSendMessage(Object.assign({
        text: message,
        date: new Date()
      }, detectLink(message)), channelId);
    }
  }, React.createElement("div", {
    className: "t-inputArea-voiceUpload-wrapper"
  }, (actions === null || actions === void 0 ? void 0 : actions.recorder) && React.createElement(TVoiceRecorder, {
    folderName: `channel-${channelId}`,
    onUpload: onUpload,
    handleSuccess: (file, response) => handleSuccess(file, response, 'recorder'),
    size: "md",
    disabled: disabled
  }), (actions === null || actions === void 0 ? void 0 : actions.attachment) && React.createElement(TUpload, {
    folderName: `channel-${channelId}`,
    onUpload: onUpload,
    handleSuccess: (file, response) => handleSuccess(file, response, 'attachment'),
    disabled: disabled
  }, React.createElement(IconClip, {
    size: "md"
  }))), React.createElement(_Form.Item, {
    name: "message",
    className: "formItem"
  }, React.createElement("div", {
    className: "t-input-area-wrapper",
    onPaste: e => onPaste(e.clipboardData.files[0])
  }, React.createElement("div", {
    className: "t-input-area"
  }, React.createElement(TextArea, {
    value: message,
    className: "inputPart",
    autoSize: {
      minRows: 2,
      maxRows: 2
    },
    autoFocus: true,
    placeholder: translate('ui.type.message', {}, false),
    onChange: item => {
      setMessage(item.target.value);
      setNoMessage(item.target.value.trim() === '');
      return;
    },
    onPressEnter: onPressEnter,
    disabled: disabled
  }), React.createElement("div", {
    ref: emojiRef,
    className: "t-inputArea-emojies-wrapper"
  }, showEmoji && React.createElement(Picker, {
    onSelect: handleEmojiSelect,
    emojiSize: 20,
    enableFrequentEmojiSort: true,
    title: "Pick your emoji...",
    notFoundEmoji: "sleuth_or_spy",
    emoji: "point_up",
    color: "#ae65c5",
    showPreview: true,
    showSkinTones: true
  })), React.createElement("div", {
    className: "t-inputArea-emoji-wrapper",
    ref: emojiIconRef
  }, React.createElement(IconEmoji, null))), React.createElement(TButton, {
    size: "large",
    icon: React.createElement(IconSend, null),
    disabled: noMessage && !message
  }, translate(isEmpty(activeMessage) ? 'ui.message.send' : 'ui.message.update'))))));
};

const sent = [];

const TForwardMessage = ({
  channels,
  modalVisible,
  setModalVisible,
  onForwardMessage,
  forwardedMessage,
  filter
}) => {
  const {
    translate
  } = useContext(ConfigContext);

  const handleSendMessage = channel => {
    const messageBody = Object.assign({}, forwardedMessage);
    delete messageBody.id;
    delete messageBody.messageId;
    messageBody.date = new Date();
    onForwardMessage(messageBody, channel);
    sent.push(channel.id);
  };

  return React.createElement(_Modal, {
    title: React.createElement(TText, {
      level: 1,
      rows: 1,
      semiBold: true
    }, translate('Forward')),
    visible: modalVisible,
    className: "t-chat-forward-container",
    bodyStyle: {
      maxHeight: '70vh',
      overflow: 'scroll'
    },
    footer: null,
    centered: true,
    onCancel: () => setModalVisible(false),
    afterClose: () => remove(sent)
  }, React.createElement("div", {
    className: "t-chat-forward-wrapper"
  }, React.createElement("div", {
    className: "t-chat-search-input-wrapper"
  }, filter), React.createElement(_Divider, null), React.createElement("div", {
    className: "t-chat-forward-channelItems"
  }, channels === null || channels === void 0 ? void 0 : channels.map(channel => {
    const classnames = ['t-chat-forward-send-button', sent.includes(channel.id) && 't-chat-forward-send-button-disabled'];
    return React.createElement("div", {
      key: channel.id,
      className: "t-chat-forward-channelItem"
    }, React.createElement(TAvatar, {
      src: channel.avatar !== '' ? channel.avatar : img$7,
      size: "sm"
    }, channel.avatarAlt), React.createElement("div", {
      className: "t-chat-forward-channelItem-body"
    }, React.createElement(TText, {
      level: 4,
      rows: 1
    }, channel.title), React.createElement(_Button, {
      className: classnames.filter(Boolean).join(' '),
      size: "middle",
      shape: "round",
      onClick: () => handleSendMessage(channel),
      disabled: sent.includes(channel.id)
    }, !sent.includes(channel.id) ? translate('Send') : translate('Sent'))));
  }))));
};

var css_248z$T = ".actionMenu {\n  right: -20vw;\n}\n.chatApp__loaderWrapper {\n  margin: 80px auto;\n  text-align: center;\n}\n.chatApp__loaderText {\n  color: #4870df;\n  font-weight: bold;\n}\n.chatApp__loader,\n.chatApp__loader::before,\n.chatApp__loader::after {\n  border-radius: 1em;\n  width: 1em;\n  height: 1em;\n  animation-fill-mode: both;\n  animation: loading 1.8s infinite ease-in-out;\n}\n.chatApp__loader {\n  margin: auto;\n  color: #4870df;\n  font-size: 12px;\n  position: relative;\n  animation-delay: -0.16s;\n}\n.chatApp__loader::before,\n.chatApp__loader::after {\n  content: '';\n  position: absolute;\n  top: 0;\n}\n.chatApp__loader::before {\n  left: -1.5em;\n  animation-delay: -0.32s;\n}\n.chatApp__loader::after {\n  left: 1.5em;\n}\n.chatApp__room {\n  display: flex;\n  align-content: flex-start;\n  justify-content: center;\n  animation: fadeChatApp 0.6s ease-in-out;\n  animation-fill-mode: forwards;\n}\n.chatApp__conv {\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n  float: left;\n  margin: 0 1rem;\n  box-shadow: 0 35px 20px -30px #f10003;\n}\n.chatApp__convTitle {\n  display: inline-block;\n  margin: 0 0 2rem 0;\n  font-size: 18px;\n  font-weight: bold;\n  color: grey;\n  text-transform: uppercase;\n  position: relative;\n}\n.chatApp__convTitle::after {\n  content: '';\n  position: absolute;\n  background-color: #4870df;\n  width: 100%;\n  height: 2px;\n  border-radius: 30px;\n  left: 0;\n  right: 0;\n  bottom: -16px;\n}\n.chatApp__convTimeline {\n  display: flex;\n  flex-direction: column-reverse;\n  background-color: #fff;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.chatApp__message-actions {\n  display: none;\n}\n.chatApp__convMessageItemContainer {\n  display: flex;\n  align-items: center;\n}\n.chatApp__convMessageItemContainer:hover .chatApp__message-actions {\n  display: flex;\n}\n.chatApp__convMessageItemContainer-right {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n}\n.chatApp__convMessageItemContainer-right:hover .chatApp__message-actions {\n  display: flex;\n}\n.chatApp__convMessageItem-action {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n}\n.chatApp__convMessageItem-action:hover {\n  background-color: #f7f7f8;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.chatApp__convMessageValue {\n  position: relative;\n  min-height: 40px;\n  padding: 0.1rem;\n  border-radius: grey;\n  font-size: 14px;\n  line-height: 18px;\n}\n.chatApp__convMessageValue .ant-card-body {\n  padding: 5px !important;\n}\n.chatApp__convMessageValue .ant-divider-horizontal {\n  margin: 0 !important;\n}\n.chatApp__convSendMessage {\n  position: relative;\n  border-bottom-left-radius: grey;\n  border-bottom-right-radius: grey;\n  background-color: #fff;\n}\n.chatApp__convMessageHeader {\n  margin-bottom: 0.2rem;\n}\n.chatApp__convSendMessage {\n  padding: 1rem;\n}\n.chatApp__convInput {\n  float: left;\n  height: 40px;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 40px;\n  margin: 0 0.5rem 0 0;\n  width: calc(100% - 52px);\n  background-color: #dedfed;\n  box-shadow: inset 0 0 0 2px #dedfed;\n  font-size: 14px;\n  font-family: 'Quicksand', sans-serif;\n  font-weight: bold;\n  transition: 0.15s all ease-in-out;\n  box-sizing: border-box;\n}\n.chatApp__convInput::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #b1b1b1;\n  opacity: 1;\n}\n.chatApp__convInput:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b1b1b1;\n}\n.chatApp__convInput::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b1b1b1;\n}\n.chatApp__convInput:focus,\n.chatApp__convInput:active {\n  box-shadow: inset 0 0 0 2px #7690d6;\n}\n.chatApp__convInput:focus {\n  outline: none;\n}\n.chatApp__convButton {\n  float: right;\n  position: relative;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 30px;\n  color: #fff;\n  background-color: #4870df;\n  text-align: center;\n  box-shadow: 0 14px 10px -8px rgba(0, 0, 0, 0.2);\n  transition: 0.15s all ease-in-out;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.chatApp__convButton:hover {\n  background-color: #3c559c;\n}\n.chatApp__convButton i {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 0 0 0 1px;\n  font-size: 22px;\n}\n.chatApp__convButton--loading {\n  cursor: wait;\n  background-color: #4870df;\n}\n.chatApp__convButton--loading:hover {\n  background-color: #4870df;\n}\n.chatApp__convButton--loading::before,\n.chatApp__convButton--loading::after {\n  content: '';\n  position: absolute;\n  z-index: 1;\n  display: block;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  margin: auto;\n  border-radius: 40px;\n  background-color: #fff;\n}\n.chatApp__convButton--loading::after {\n  animation: loadSendMessage 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n}\n.chatApp__convButton--loading i {\n  display: none;\n}\n.chatApp__convSendMessage--typing .chatApp__convTyping {\n  display: block;\n}\n.chatApp__convTyping {\n  position: absolute;\n  top: 0;\n  font-size: 10px;\n  font-weight: bold;\n}\n.chatApp__convTypingDot {\n  position: relative;\n  left: 4px;\n  display: inline-block;\n  width: 2px;\n  height: 2px;\n  background-color: #606060;\n  animation: typingMessage 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n}\n.chatApp__convTypingDot::before,\n.chatApp__convTypingDot::after {\n  content: '';\n  position: absolute;\n  display: inline-block;\n  width: 2px;\n  height: 2px;\n  background-color: #606060;\n  animation: typingMessage 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n}\n.chatApp__convTypingDot::before {\n  left: 4px;\n  animation-delay: 0.5s;\n}\n.chatApp__convTypingDot::after {\n  left: 8px;\n  animation-delay: 1s;\n}\n.chatApp__conv-messages-uniq-dates {\n  font-size: 12px;\n  color: var(--text-dark-50, #909091);\n}\n@media screen and (max-width: 768px) {\n  .chatApp__room {\n    flex-wrap: wrap;\n    padding: 2rem 1rem;\n  }\n  .chatApp__conv {\n    flex-basis: 100%;\n    min-width: auto;\n    width: 100%;\n    margin: 0;\n  }\n  .chatApp__conv:first-of-type {\n    margin: 0 0 4rem 0;\n  }\n}\n@keyframes Messenger-module_loading__11TPZ {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 1em 0 -1.3em;\n  }\n  40% {\n    box-shadow: 0 1em 0 0;\n  }\n}\n@keyframes Messenger-module_fadeChatApp__3fzh1 {\n  0% {\n    opacity: 0;\n    transform: translateY(1rem);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n@keyframes Messenger-module_fadeNewMessage__2Cw2o {\n  0% {\n    opacity: 0;\n    transform: translateY(1rem);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n@keyframes Messenger-module_loadSendMessage__32Bvc {\n  0% {\n    opacity: 1;\n    width: 4px;\n    height: 4px;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n@keyframes Messenger-module_typingMessage__2s82x {\n  0% {\n    background-color: #606060;\n  }\n  50% {\n    background-color: #fff;\n  }\n  60% {\n    background-color: #606060;\n  }\n}\n.inputArea {\n  padding: 4px;\n  display: flex;\n  align-items: center;\n}\n.inputArea .formItem {\n  width: 100% !important;\n  margin: 0;\n}\n.inputArea .buttons svg {\n  color: #b1b2b3;\n  font-size: 22px;\n}\n.inputArea .buttons :nth-child(2) svg {\n  font-size: 23px;\n}\n.inputArea .inputPart {\n  border-radius: 24px;\n  padding-left: 18px !important;\n}\n.inputArea .inputPart .ant-input {\n  text-align: left !important;\n}\n.inputArea .inputPart input {\n  border: none;\n}\n.inputArea .inputPart input:hover,\n.inputArea .inputPart input:focus,\n.inputArea .inputPart input:active,\n.inputArea .inputPart input::selection {\n  border: none !important;\n  box-shadow: none !important;\n}\n.functionButtons {\n  border: none;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  color: red !important;\n}\n.functionButtons:hover,\n.functionButtons:focus,\n.functionButtons:active,\n.functionButtons::selection {\n  border: none !important;\n  color: var(--primary-color, #f54e95) !important;\n  box-shadow: none !important;\n}\n.svgDefault {\n  fill: var(--text-dark-20, #d0d0d1) !important;\n  stroke: #fbfbfc !important;\n}\n.active {\n  cursor: pointer !important;\n  fill: var(--primary-color, #f54e95) !important;\n}\n.disabled {\n  cursor: unset !important;\n  fill: var(--text-dark-20, #d0d0d1) !important;\n}\n.stopped {\n  cursor: pointer !important;\n}\n";
styleInject(css_248z$T);

var css_248z$U = ".t-messenger-container {\n  text-align: center;\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  padding: 1px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.t-messenger-container .t-messenger-title {\n  text-align: left;\n  padding: 36px 36px 24px 36px;\n  border-bottom: 1px solid #f2f2f3;\n  height: 92px;\n}\n.t-messenger-container .t-messenger-content-wrapper {\n  overflow: auto;\n}\n.t-messenger-container .t-messenger-content-wrapper .t-messenger-messages {\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  height: calc(100vh - 205px);\n}\n.recording {\n  border: none;\n  background-color: transparent;\n}\n.recording:hover,\n.recording:focus,\n.recording:active,\n.recording::selection {\n  background-color: red;\n  color: white;\n}\n";
styleInject(css_248z$U);

const groupByDate = messages => {
  const dates = {};
  messages.forEach(item => {
    const currentDate = moment$1(item.date).format('MMMM DD');

    if (!dates[currentDate]) {
      dates[currentDate] = [];
    }

    dates[currentDate].push(item);
  });
  return dates;
};

const TMessenger = ({
  sender,
  title,
  channelId,
  onSendMessage,
  onForwardMessage,
  onReplyMessage,
  chatHeight,
  disabled,
  messages = [],
  actions,
  messageActions,
  handleRemoveMessage,
  onUpload,
  onScrollTop,
  disableOnScroll = true,
  channels,
  filter
}) => {
  const [loading, setLoading] = useState(false);
  const [activeMessage, setActiveMessage] = useState(null);
  const [forwardedMessage, setForwardedMessage] = useState(null);
  const [repliedMessage, setRepliedMessage] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [groupedMessages, setGroupedMessages] = useState();

  const handleOnScrollTop = () => {
    if (typeof onScrollTop === 'function' && !loading) {
      setLoading(true);
      onScrollTop(messages).then(() => {
        setLoading(false);
      });
    }
  };

  const getScrollPosition = e => {
    if (disableOnScroll) {
      return;
    }

    const y = e.target.scrollHeight + e.target.scrollTop - e.target.clientHeight;

    if (y < 15) {
      handleOnScrollTop();
    }
  };

  useEffect(() => {
    setGroupedMessages(groupByDate(messages));
  }, [messages]);

  const renderMessages = () => {
    if (isEmpty(groupedMessages)) {
      return null;
    }

    return Object.keys(groupedMessages).map((item, index) => {
      const sortedMessages = groupedMessages[item].sort((a, b) => {
        return moment$1(a.date).isAfter(b.date) ? 1 : -1;
      });
      return React.createElement("div", {
        key: index
      }, React.createElement("p", {
        className: "chatApp__conv-messages-uniq-dates"
      }, item), sortedMessages.map(mess => {
        return React.createElement(Message, {
          getActiveMessage: message => setActiveMessage(message),
          getForwardedMessage: message => setForwardedMessage(message),
          getRepliedMessage: message => setRepliedMessage(message),
          sender: sender,
          handleRemoveMessage: handleRemoveMessage,
          actions: messageActions,
          key: mess.id,
          message: mess,
          setModalVisible: setModalVisible
        });
      }));
    });
  };

  return React.createElement("div", {
    className: "t-messenger-container"
  }, React.createElement(TForwardMessage, {
    channels: channels,
    modalVisible: modalVisible,
    setModalVisible: setModalVisible,
    onForwardMessage: onForwardMessage,
    forwardedMessage: forwardedMessage,
    filter: filter
  }), React.createElement(_Card, {
    title: title && React.createElement("div", {
      className: "t-messenger-title"
    }, React.createElement(TText, {
      level: 1,
      bold: true,
      rows: 1
    }, title)),
    cover: React.createElement("div", {
      className: "t-messenger-content-wrapper",
      style: {
        height: chatHeight
      }
    }, React.createElement("div", {
      onScroll: getScrollPosition,
      className: 'chatApp__convTimeline t-messenger-messages',
      style: {
        height: chatHeight
      }
    }, renderMessages())),
    bodyStyle: {
      padding: 0
    },
    bordered: false
  }, React.createElement(TInputArea, {
    activeMessage: activeMessage,
    unsetActiveMessage: () => setActiveMessage({}),
    repliedMessage: repliedMessage,
    unsetRepliedMessage: () => setRepliedMessage({}),
    key: `InputKey-${Date.now()}`,
    actions: actions,
    onSendMessage: onSendMessage,
    onReplyMessage: onReplyMessage,
    channelId: channelId,
    onUpload: onUpload,
    disabled: disabled
  })));
};

// Unique ID creation requires a high quality random # generator.  In node.js
// this is pretty straight-forward - we use the crypto API.



var rng = function nodeRNG() {
  return crypto.randomBytes(16);
};

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

var bytesToUuid_1 = bytesToUuid;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid_1(b);
}

var v1_1 = v1;

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid_1(rnds);
}

var v4_1 = v4;

var uuid = v4_1;
uuid.v1 = v1_1;
uuid.v4 = v4_1;

var uuid_1 = uuid;

const TMessengerBody = ({
  channel,
  onSendMessage,
  onRemoveMessage,
  chatHeight,
  getMessages,
  newMessage,
  actions,
  messageActions,
  onUpload,
  sender,
  channels,
  filter
}) => {
  const [messages, setMessages] = useState([]);
  const [noMessage, setNoMessage] = useState(false);
  useEffect(() => {
    if (typeof getMessages === 'function') {
      getMessages(channel.id).then(messages => {
        setMessages(messages);
      });
    }
  }, []);
  useEffect(() => {
    if (!newMessage || newMessage.channelId !== channel.id || messages.find(item => item.id === newMessage.id)) {
      return;
    }

    setMessages([newMessage, ...messages]);
  }, [newMessage]);

  const handleSendMessage = message => __awaiter(void 0, void 0, void 0, function* () {
    const data = Object.assign(Object.assign({
      id: uuid_1.v4()
    }, message), {
      sender
    });

    if (!message.id) {
      setMessages([data, ...messages]);
    } else {
      const messageMap = keyBy(messages, 'id');
      data.id = messageMap[message.messageId].id;
      messageMap[message.messageId] = Object.assign(Object.assign({}, data), {
        edited: true
      });
      setMessages(Object.values(messageMap));
    }

    onSendMessage(data, channel);
  });

  const handleReplyMessage = message => __awaiter(void 0, void 0, void 0, function* () {
    const data = Object.assign(Object.assign({
      id: uuid_1.v4()
    }, message), {
      sender
    });

    if (!message.messageId) {
      setMessages([data, ...messages]);
    } else {
      const messageMap = keyBy(messages, 'messageId');
      messageMap[message.messageId] = Object.assign(Object.assign({}, data), {
        edited: true
      });
      setMessages(Object.values(messageMap));
    }

    onSendMessage(data, channel);
  });

  const handleForwardMessage = (message, forwardToChannel) => __awaiter(void 0, void 0, void 0, function* () {
    message.forwardedMessage = message.sender;

    if (!isEmpty(message.repliedMessage)) {
      delete message.repliedMessage;
    }

    const data = Object.assign(Object.assign({
      id: uuid_1.v4()
    }, message), {
      sender
    });

    if (forwardToChannel.id === channel.id) {
      setMessages([data, ...messages]);
    }

    onSendMessage(data, forwardToChannel);
  });

  const handleRemoveMessage = id => __awaiter(void 0, void 0, void 0, function* () {
    const messageMap = keyBy(messages, 'id');
    delete messageMap[id];
    setMessages(Object.values(messageMap));
    onRemoveMessage(id);
  });

  const handleScrollTop = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (!noMessage) {
      if (typeof getMessages === 'function') {
        getMessages(channel.id, messages.length).then(newMessages => {
          setMessages([...messages, ...newMessages]);

          if (newMessages.length === 0) {
            setNoMessage(true);
          }
        });
      }
    }
  }), [messages]);
  return React.createElement(TMessenger, {
    sender: sender,
    handleRemoveMessage: handleRemoveMessage,
    onReplyMessage: handleReplyMessage,
    messages: messages,
    channelId: channel.id,
    title: channel.title,
    disabled: channel.closed,
    actions: actions,
    messageActions: messageActions,
    onUpload: onUpload,
    chatHeight: chatHeight,
    onSendMessage: handleSendMessage,
    onForwardMessage: handleForwardMessage,
    onScrollTop: handleScrollTop,
    disableOnScroll: noMessage,
    channels: channels,
    filter: filter
  });
};

var css_248z$V = ".t-chat-container {\n  display: flex;\n  width: 100%;\n}\n@media screen and (max-width: 576px) {\n  .t-chat-container {\n    display: unset;\n  }\n}\n@media screen and (max-width: 576px) {\n  .t-chat-container .ant-tabs {\n    display: flex;\n    flex-direction: column;\n  }\n  .t-chat-container .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {\n    overflow: auto;\n  }\n}\n@media screen and (max-width: 768px) {\n  .t-chat-container .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {\n    overflow: auto;\n  }\n}\n.t-chat-container .t-chat {\n  width: 100%;\n  padding: 2px;\n}\n.t-chat-container .t-chat .t-content-info {\n  overflow: hidden;\n  white-space: pre-wrap;\n}\n.t-chat-container .t-chat .ant-tab {\n  height: 612px;\n}\n.t-chat-container .t-chat .t-tab-bar-header {\n  padding: 16px;\n}\n.t-chat-container .t-chat .t-tab-bar-footer {\n  padding: 16px;\n}\n.t-chat-container .t-chat .ant-tabs-nav-list {\n  overflow-y: auto;\n  display: block;\n}\n.t-chat-container .t-chat .ant-tabs-nav {\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  display: flex;\n  flex-direction: column-reverse;\n}\n.t-chat-container .t-chat .ant-tabs-extra-content {\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n}\n.t-chat-container .t-chat .ant-tabs-extra-content .ant-form-item {\n  margin: 0px;\n  padding: 0px;\n}\n.t-chat-container .t-chat .ant-tabs-content-holder {\n  border: none;\n  width: 75%;\n}\n@media screen and (max-width: 768px) {\n  .t-chat-container .t-chat .ant-tabs-content-holder {\n    width: 100%;\n  }\n}\n.t-chat-container .t-chat .ant-tabs-nav-operations {\n  display: none !important;\n}\n.t-chat-container .t-chat .ant-tabs-tab {\n  padding: 0px;\n  display: block;\n  width: 100%;\n}\n.t-chat-container .t-chat .t-messages-list-item {\n  border-right: 2px solid transparent;\n  height: auto;\n}\n.t-chat-container .t-chat .t-messages-list-item .t-content-wrapper {\n  flex-direction: column;\n  height: auto;\n}\n@media screen and (max-width: 480px) {\n  .t-chat-container .t-chat .t-messages-list-item .t-content-wrapper {\n    flex-direction: revert;\n  }\n}\n.t-chat-container .t-chat .ant-tabs-tab-btn {\n  width: 100%;\n  text-align: left;\n}\n.t-chat-container .t-chat .ant-tabs-ink-bar {\n  background-color: var(--primary-color, #f54e95);\n  border-right: 2px solid transparent;\n}\n.t-chat-container .t-chat .ant-tabs-tab-active {\n  background: #f7f7f8;\n}\n.t-chat-container .t-chat .t-messages-list-item:hover {\n  border-right: 2px solid var(--primary-color, #f54e95);\n  background: #f7f7f8;\n}\n@media screen and (max-width: 768px) {\n  .t-chat-container .t-chat {\n    display: flex;\n    flex-direction: column;\n  }\n}\n.t-chat-forward-container .ant-modal-header {\n  text-align: center;\n  border-bottom: none;\n}\n.t-chat-forward-container .t-chat-forward-wrapper {\n  background-color: #fff;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper {\n  width: 100%;\n  text-align: center;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper .t-chat-forward-search-input {\n  max-width: 386px;\n  border: 1px solid #d9d9d9;\n  border-radius: 33px;\n  overflow: hidden;\n  transition: all 0.3s, height 0s;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper .t-chat-forward-search-input:hover {\n  border-color: var(--primary-color, #f54e95);\n  box-shadow: 0 0 0 2px rgb(245 78 7.45%);\n  border-right-width: 1px !important;\n  outline: 0;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper .t-chat-forward-search-input .ant-input-affix-wrapper {\n  border: none;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper .t-chat-forward-search-input .ant-input-affix-wrapper-focused {\n  box-shadow: unset;\n  outline: 0;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-search-input-wrapper .t-chat-forward-search-input .ant-input-search-button {\n  border: none;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-forward-channelItems .t-chat-forward-channelItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-forward-channelItems .t-chat-forward-channelItem .t-chat-forward-channelItem-body {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9e9e9;\n  padding: 16px 0;\n  margin-left: 16px;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-forward-channelItems .t-chat-forward-channelItem .t-chat-forward-channelItem-body .t-chat-forward-send-button {\n  font-size: 15px;\n  height: 28px;\n  padding: 0px 13px;\n  background-color: var(--primary-color, #f54e95);\n  border: none;\n  color: #fff;\n  width: 62px;\n}\n.t-chat-forward-container .t-chat-forward-wrapper .t-chat-forward-channelItems .t-chat-forward-channelItem .t-chat-forward-channelItem-body .t-chat-forward-send-button-disabled {\n  background-color: #e6e6e7;\n}\n";
styleInject(css_248z$V);

const TabPane = _Tabs.TabPane;

const TChannelList = ({
  channels = [],
  height,
  onChannelChange,
  activeChannel,
  onItemClick,
  header,
  messenger,
  onScrollBottom,
  disableOnScroll = false
}) => {
  const [loading, setLoading] = useState(false);

  const handleOnScrollTop = () => {
    if (typeof onScrollBottom === 'function' && !loading) {
      setLoading(true);
      onScrollBottom(channels).then(() => {
        setLoading(false);
      });
    }
  };

  const getScrollPosition = e => {
    if (disableOnScroll) {
      return;
    }

    const y = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;

    if (y === 0) {
      handleOnScrollTop();
    }
  };

  const size = useWindowSize();
  const mobile = size.width < 769; // useEffect(() => {
  //   if (isIntersecting && !isFetching && onChangePage) {
  //     onChangePage();
  //   }
  // }, [isIntersecting]);

  return React.createElement("div", {
    className: "t-chat-container"
  }, React.createElement(_Tabs, {
    className: "t-chat",
    tabPosition: "left",
    tabBarGutter: 0,
    activeKey: activeChannel,
    onChange: onChannelChange,
    onTabClick: onItemClick,
    tabBarExtraContent: header,
    tabBarStyle: {
      marginBottom: mobile ? '50px' : 'auto',
      height: mobile ? 'calc(100vh - 350px)' : height,
      width: mobile ? '100%' : '25%'
    },
    onScroll: getScrollPosition
  }, channels.map(item => React.createElement(TabPane, {
    tab: React.createElement(TMessageListItem, {
      channel: item
    }),
    key: item.id,
    style: {
      paddingLeft: !mobile ? '16px' : '0px'
    }
  }, React.createElement(TMessengerBody, Object.assign({}, messenger, {
    channel: item,
    channels: channels,
    filter: header
  }))))));
};

const TMessagesCardList = ({
  title,
  seeAllLink,
  messages = [],
  loading = false,
  height,
  fallback,
  noMessagesText
}) => {
  return React.createElement(React.Fragment, null, React.createElement(TCardList, {
    title: title,
    seeAllLink: seeAllLink,
    loading: loading,
    height: height,
    fallback: fallback
  }, messages.map((item, index) => React.createElement(TMessageListItem, Object.assign({
    noMessagesText: noMessagesText,
    key: index
  }, item)))));
};

var css_248z$W = ".e-messages-list-item {\n  cursor: pointer;\n  box-sizing: border-box;\n  display: flex;\n  height: 135px;\n  border-bottom: 1px solid #eaeaeb;\n  border-right: 4px solid transparent;\n  padding: 24px;\n}\n.e-messages-list-item .e-avatar-container .e-avatar-wrapper {\n  margin-right: 16px;\n}\n.e-messages-list-item .e-avatar-container .e-avatar-group-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.e-messages-list-item .e-avatar-container .e-avatar-group-wrapper .ant-avatar {\n  background: #9696ff;\n}\n.e-messages-list-item .e-content-wrapper {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n@media screen and (max-width: 576px) {\n  .e-messages-list-item .e-content-wrapper {\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n.e-messages-list-item .e-content-wrapper .e-content-info {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n.e-messages-list-item .e-content-wrapper .e-content-info p {\n  word-break: break-all;\n}\n.e-messages-list-item .e-content-wrapper .e-content-info .e-authorName {\n  color: var(--text-dark-50, #909091);\n  font-size: 13px;\n}\n.e-messages-list-item .e-content-wrapper .e-time-viewer-container {\n  width: 100px;\n  text-align: right;\n}\n@media screen and (max-width: 576px) {\n  .e-messages-list-item .e-content-wrapper .e-time-viewer-container {\n    text-align: initial;\n  }\n}\n.e-messages-list-item .e-content-wrapper .e-content-date {\n  text-align: end;\n}\n@media screen and (max-width: 576px) {\n  .e-messages-list-item .e-content-wrapper .e-content-date {\n    text-align: initial;\n  }\n}\n.e-messages-list-item:hover,\n.e-messages-list-item-active {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n}\n.e-messages-list-item.e-messages-list-item-closed .e-avatar-wrapper,\n.e-messages-list-item.e-messages-list-item-closed .e-text {\n  opacity: 0.5;\n}\n.e-messages-list-item.e-messages-list-item-closed .e-text.e-body2 {\n  text-decoration: line-through;\n}\n";
styleInject(css_248z$W);

const getMessageText$1 = (text, type) => {
  if (!type) {
    return text;
  }

  if (['audio', 'video', 'image'].includes(type)) {
    return `[${type}]`;
  }

  return '[attachment]';
};

const TMessageListItem$1 = ({
  channel,
  onClick = () => {},
  noMessagesText
}) => {
  const groupDefaultImages = [img$9, img$8];
  return React.createElement("div", {
    className: ['e-messages-list-item', channel.closed ? 'e-messages-list-item-closed' : ''].join(' '),
    onClick: e => onClick(e, channel)
  }, React.createElement("div", {
    className: "e-avatar-container"
  }, !!channel.type && channel.type !== 'group' ? React.createElement("div", {
    className: "e-avatar-wrapper"
  }, React.createElement(TAvatar, {
    src: channel.avatar !== '' ? channel.avatar : img$7,
    size: "md"
  }, channel.avatarAlt)) : React.createElement("div", {
    className: "e-avatar-group-wrapper"
  }, React.createElement(TAvatarGroup, {
    size: "xs"
  }, groupDefaultImages && groupDefaultImages.map((item, index) => {
    return React.createElement(TAvatar, {
      src: item,
      key: index,
      alt: `${index}`,
      size: "xs"
    });
  })))), React.createElement("div", {
    className: "e-content-wrapper"
  }, React.createElement("div", {
    className: "e-content-info"
  }, React.createElement(TText, {
    rows: 1,
    level: 3,
    textColor: "dark-30"
  }, channel.lastMessage.author), React.createElement(TText, {
    rows: 1,
    level: 2,
    bold: true
  }, channel.title), channel.lastMessage.text ? React.createElement(TText, {
    rows: 1,
    level: 3
  }, getMessageText$1(channel.lastMessage.text, channel.lastMessage.type)) : React.createElement(TText, {
    textColor: "dark-20",
    rows: 1,
    level: 3
  }, noMessagesText)), React.createElement("div", {
    className: "e-content-date"
  }, React.createElement(TimeViewer$1, {
    fromNow: true,
    start: channel.lastMessage.date
  }))));
};

const img$a = "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M29.3511 29.0615H15.0447C13.5818 29.0615 12.3958 27.8755 12.3958 26.4126V2.89893C12.3958 1.43604 13.5818 0.25 15.0447 0.25H29.3511C30.814 0.25 32 1.43604 32 2.89893V26.4126C32 27.8755 30.814 29.0615 29.3511 29.0615Z' fill='url(%23paint0_linear)'/%3e%3cpath d='M12.3958 24.0254V26.4124C12.3958 27.8752 13.5818 29.0613 15.0447 29.0613H29.3511C30.814 29.0613 32 27.8752 32 26.4124V24.0254H12.3958Z' fill='url(%23paint1_linear)'/%3e%3cpath d='M28.252 24.0251H16.1438C15.4109 24.0251 14.8169 23.4312 14.8169 22.6982V4.07202C14.8169 3.33911 15.4109 2.74512 16.1438 2.74512H28.252C28.9849 2.74512 29.5789 3.33911 29.5789 4.07202V22.6982C29.5786 23.4312 28.9846 24.0251 28.252 24.0251Z' fill='url(%23paint2_linear)'/%3e%3cpath d='M23.7029 26.5432C23.7029 27.3743 23.0291 28.0481 22.1978 28.0481C21.3667 28.0481 20.6929 27.3743 20.6929 26.5432C20.6929 25.7119 21.3667 25.0381 22.1978 25.0381C23.0291 25.0381 23.7029 25.7119 23.7029 26.5432Z' fill='url(%23paint3_linear)'/%3e%3cpath d='M21.802 15.8945H28.4766V16.876H21.802V15.8945Z' fill='url(%23paint4_linear)'/%3e%3cpath d='M21.802 18.3203H28.4766V19.3018H21.802V18.3203Z' fill='url(%23paint5_linear)'/%3e%3cpath d='M21.802 20.7461H27.1169V21.7275H21.802V20.7461Z' fill='url(%23paint6_linear)'/%3e%3cpath d='M20.2009 10.4321C19.9597 10.1172 19.5808 9.91309 19.1533 9.91309H14.8169V22.6982C14.8169 23.4312 15.4109 24.0251 16.1438 24.0251H28.252C28.9846 24.0251 29.5789 23.4312 29.5789 22.6982V19.8098L20.2009 10.4321Z' fill='url(%23paint7_linear)'/%3e%3cpath d='M19.1533 31.699H3.48975C2.7605 31.699 2.16943 31.1077 2.16943 30.3784V11.2336C2.16943 10.5044 2.7605 9.91309 3.48975 9.91309H19.1536C19.8826 9.91309 20.4739 10.5044 20.4739 11.2336V30.3784C20.4739 31.1077 19.8826 31.699 19.1533 31.699Z' fill='url(%23paint8_linear)'/%3e%3cpath d='M3.48975 31.6997H19.1536C19.8826 31.6997 20.4739 31.1084 20.4739 30.3792V29.0144L17.9614 26.502C17.7197 26.2361 17.3716 26.0693 16.9841 26.0693H2.16943V30.3794C2.16943 31.1084 2.7605 31.6997 3.48975 31.6997Z' fill='url(%23paint9_linear)'/%3e%3cpath d='M16.9841 26.0693H1.32031C0.591064 26.0693 0 26.6604 0 27.3896V29.1301C0 30.5493 1.15039 31.6997 2.56934 31.6997H19.2849C18.7434 31.6997 18.3044 31.2607 18.3044 30.7192V27.3896C18.3044 26.6604 17.7134 26.0693 16.9841 26.0693Z' fill='url(%23paint10_linear)'/%3e%3cpath d='M4.31885 21.0273H18.3245V21.793H4.31885V21.0273Z' fill='%23A1B5D8'/%3e%3cpath d='M4.5 18H18.5056V18.7656H4.5V18Z' fill='%23A1B5D8'/%3e%3cpath d='M4.5 15H18.5056V15.7656H4.5V15Z' fill='%23A1B5D8'/%3e%3cpath d='M4.31885 24.042H15.4714V24.8076H4.31885V24.042Z' fill='%23A1B5D8'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear' x1='18.9914' y1='14.6558' x2='35.39' y2='14.6558' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233B395F'/%3e%3cstop offset='0.0633' stop-color='%2337355A'/%3e%3cstop offset='0.4033' stop-color='%23232543'/%3e%3cstop offset='0.7232' stop-color='%23171B35'/%3e%3cstop offset='1' stop-color='%23131830'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='22.1978' y1='26.3034' x2='22.1978' y2='28.66' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23131830' stop-opacity='0'/%3e%3cstop offset='1' stop-color='%23131830'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='17.2707' y1='8.45802' x2='36.7957' y2='27.983' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4'/%3e%3cstop offset='0.3262' stop-color='%237045D4'/%3e%3cstop offset='0.5324' stop-color='%237045D4'/%3e%3cstop offset='0.7054' stop-color='%237045D4'/%3e%3cstop offset='0.779167' stop-color='%237045D4'/%3e%3cstop offset='0.836458' stop-color='%237045D4'/%3e%3cstop offset='0.859' stop-color='%237045D4'/%3e%3cstop offset='0.8591' stop-color='%23EE1A51'/%3e%3cstop offset='0.8592' stop-color='%237045D4'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3clinearGradient id='paint3_linear' x1='22.765' y1='27.1102' x2='20.2488' y2='24.5941' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233B395F'/%3e%3cstop offset='0.0633' stop-color='%2337355A'/%3e%3cstop offset='0.4033' stop-color='%23232543'/%3e%3cstop offset='0.7232' stop-color='%23171B35'/%3e%3cstop offset='1' stop-color='%23131830'/%3e%3c/linearGradient%3e%3clinearGradient id='paint4_linear' x1='24.2475' y1='15.4935' x2='29.4314' y2='20.6774' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFFCF8'/%3e%3cstop offset='0.1875' stop-color='%23FAF8F6'/%3e%3cstop offset='0.4041' stop-color='%23ECEEF2'/%3e%3cstop offset='0.6353' stop-color='%23D5DCEA'/%3e%3cstop offset='0.875' stop-color='%23B5C4DF'/%3e%3cstop offset='1' stop-color='%23A1B5D8'/%3e%3c/linearGradient%3e%3clinearGradient id='paint5_linear' x1='23.1713' y1='16.8431' x2='28.3553' y2='22.027' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFFCF8'/%3e%3cstop offset='0.1875' stop-color='%23FAF8F6'/%3e%3cstop offset='0.4041' stop-color='%23ECEEF2'/%3e%3cstop offset='0.6353' stop-color='%23D5DCEA'/%3e%3cstop offset='0.875' stop-color='%23B5C4DF'/%3e%3cstop offset='1' stop-color='%23A1B5D8'/%3e%3c/linearGradient%3e%3clinearGradient id='paint6_linear' x1='21.7512' y1='18.5285' x2='26.9537' y2='23.731' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFFCF8'/%3e%3cstop offset='0.1875' stop-color='%23FAF8F6'/%3e%3cstop offset='0.4041' stop-color='%23ECEEF2'/%3e%3cstop offset='0.6353' stop-color='%23D5DCEA'/%3e%3cstop offset='0.875' stop-color='%23B5C4DF'/%3e%3cstop offset='1' stop-color='%23A1B5D8'/%3e%3c/linearGradient%3e%3clinearGradient id='paint7_linear' x1='23.6302' y1='22.9531' x2='16.0412' y2='15.364' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%237045D4' stop-opacity='0'/%3e%3cstop offset='0.5838' stop-color='%237045D4' stop-opacity='0.584314'/%3e%3cstop offset='1' stop-color='%237045D4'/%3e%3c/linearGradient%3e%3clinearGradient id='paint8_linear' x1='5.33408' y1='11.8055' x2='22.1122' y2='37.0268' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFFCF8'/%3e%3cstop offset='0.1875' stop-color='%23FAF8F6'/%3e%3cstop offset='0.4041' stop-color='%23ECEEF2'/%3e%3cstop offset='0.6353' stop-color='%23D5DCEA'/%3e%3cstop offset='0.875' stop-color='%23B5C4DF'/%3e%3cstop offset='1' stop-color='%23A1B5D8'/%3e%3c/linearGradient%3e%3clinearGradient id='paint9_linear' x1='16.3116' y1='34.9592' x2='10.4152' y2='29.0628' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23A1B5D8' stop-opacity='0'/%3e%3cstop offset='0.0343' stop-color='%239FB3D5' stop-opacity='0.035294'/%3e%3cstop offset='0.4515' stop-color='%238898AF' stop-opacity='0.45098'/%3e%3cstop offset='0.788' stop-color='%23798898' stop-opacity='0.788235'/%3e%3cstop offset='1' stop-color='%23748290'/%3e%3c/linearGradient%3e%3clinearGradient id='paint10_linear' x1='9.64241' y1='29.0342' x2='9.64241' y2='32.9157' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFFCF8'/%3e%3cstop offset='0.1875' stop-color='%23FAF8F6'/%3e%3cstop offset='0.4041' stop-color='%23ECEEF2'/%3e%3cstop offset='0.6353' stop-color='%23D5DCEA'/%3e%3cstop offset='0.875' stop-color='%23B5C4DF'/%3e%3cstop offset='1' stop-color='%23A1B5D8'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

const TMessagesCardList$1 = ({
  title,
  viewAll,
  messages = [],
  loading = false,
  height,
  fallback,
  noMessagesText,
  headerIcon
}) => {
  return React.createElement(React.Fragment, null, React.createElement(TCardList$1, {
    title: title,
    viewAll: viewAll,
    loading: loading,
    height: height,
    fallback: fallback,
    headerIcon: headerIcon || img$a
  }, messages.map((item, index) => React.createElement(TMessageListItem$1, Object.assign({
    noMessagesText: noMessagesText,
    key: index
  }, item)))));
};

var css_248z$X = ".t-title {\n  font-family: HelveticaNeue;\n  font-weight: inherit;\n  padding: 0;\n  margin: 0;\n  word-break: break-all;\n  color: var(--text-dark-100, #262626);\n}\n.t-1 {\n  font-size: 64px;\n}\n.t-2 {\n  font-size: 44px;\n}\n.t-3 {\n  font-size: 32px;\n}\n.t-4 {\n  font-size: 24px;\n}\n.t-bold {\n  font-weight: bold;\n}\n.t-title-paddingBottom-1 {\n  padding-bottom: 64px;\n}\n.t-title-paddingBottom-2 {\n  padding-bottom: 32px;\n}\n.t-tite-paddingBottom-3 {\n  padding-bottom: 16px;\n}\n.t-title-paddingBottom-4 {\n  padding-bottom: 8px;\n}\n.t-text-color-primary {\n  color: var(--primary-color, #f54e95);\n}\n.t-text-color-white {\n  color: #fff;\n}\n.t-text-color-dark-100 {\n  color: var(--text-dark-100, #262626);\n}\n.t-text-color-dark-50 {\n  color: var(--text-dark-50, #909091);\n}\n.t-text-color-dark-30 {\n  color: var(--text-dark-30, #bbbbbc);\n}\n.t-text-color-dark-20 {\n  color: var(--text-dark-20, #d0d0d1);\n}\n.t-text-color-dark-10 {\n  color: var(--text-dark-10, #e6e6e7);\n}\n.t-text-color-indicator-good {\n  color: #3be3c5;\n}\n.t-text-color-indicator-caution {\n  color: #ffc960;\n}\n.t-text-color-indicator-bad {\n  color: #ff395d;\n}\n.t-text-color-indicator-neutral {\n  color: #9696ff;\n}\n.t-title-row-1 {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  height: fit-content;\n}\n.t-title-row-2 {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  height: fit-content;\n}\n.t-title-row-3 {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  height: fit-content;\n}\n";
styleInject(css_248z$X);

const TTitle = _a => {
  var {
    children,
    level = 1,
    bold = false,
    paddingBottom,
    rows,
    textColor = 'dark-100',
    alt
  } = _a,
      props = __rest(_a, ["children", "level", "bold", "paddingBottom", "rows", "textColor", "alt"]);

  const classNames = [`t-title t-${level} ${bold && 't-bold'} t-title-paddingBottom-${paddingBottom} t-text-color-${textColor}
    t-title-row-${rows}
    `];
  const Tag = `h${level}`;
  return React.createElement(Tag, Object.assign({
    className: classNames.join(' '),
    title: alt
  }, props), children);
};

var css_248z$Y = ".t-summary {\n  display: flex;\n  border-bottom: 1px solid #eaeaeb;\n  justify-content: space-between;\n  background: #ffffff;\n  padding: 4px 16px 6px 16px;\n  align-items: center;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  border-radius: var(--border-radius, 8px);\n}\n.t-summary .t-summary-large {\n  width: 48px;\n  height: 48px;\n}\n.t-summary .t-summary-medium {\n  width: 48px;\n  height: 48px;\n}\n.t-summary .t-summary-small {\n  width: 36px;\n  height: 36px;\n}\n.t-summary .t-summary-extraSmall {\n  width: 28px;\n  height: 28px;\n}\n.cardHover:hover {\n  -webkit-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -moz-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  transition: all 0.3s ease-in-out;\n}\n";
styleInject(css_248z$Y);

const TSummary = ({
  result,
  label,
  icon,
  size = 'medium',
  onHover
}) => {
  const classNames = `t-summary-${size}`;
  const summerySize = {
    large: 3,
    medium: 3,
    small: 4,
    extraSmall: 4
  };
  const cardHover = ['t-summary'];

  if (onHover) {
    cardHover.push('cardHover');
  }

  return React.createElement("div", {
    className: cardHover.join(' ')
  }, React.createElement("div", null, React.createElement(TTitle, {
    level: summerySize[size],
    bold: true
  }, result), React.createElement(TText, {
    rows: 1,
    level: summerySize[size]
  }, label)), React.createElement("div", null, React.createElement("img", {
    className: classNames,
    src: `${icon}`
  })));
};

var css_248z$Z = "";
styleInject(css_248z$Z);

const TCarousel = _a => {
  var {
    renderer,
    items
  } = _a,
      props = __rest(_a, ["renderer", "items"]);

  const settings = {// dots: false,
    // infinite: true,
    // speed: 500,
    // slidesToShow: 10,
    // slidesToScroll: 10,
  };
  return React.createElement("div", {
    className: "carousel-container"
  }, React.createElement(_Carousel, Object.assign({}, settings), items.map(item => renderer(item))));
};

var css_248z$_ = ".stepsItemIcon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 8px 0 0;\n  font-size: 16px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  border: 1px solid var(--primary-color, #f54e95);\n  color: var(--primary-color, #f54e95);\n  border-radius: 32px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n.activeStepsItemIcon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 8px 0 0;\n  font-size: 16px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  border: 1px solid var(--primary-color, #f54e95);\n  background-color: var(--primary-color, #f54e95);\n  color: white;\n  border-radius: 32px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n";
styleInject(css_248z$_);

let template = [];
const ellipsisTemplate = {
  icon: React.createElement("p", {
    className: "stepsItemIcon"
  }, React.createElement(EllipsisOutlined$2, null))
};

const createTemplate = (data, length, limit) => {
  if (length <= limit) {
    template = data;
    return;
  }

  const middleIndex = Math.ceil(length / 2) - 1;
  set$1(template, 0, Object.assign(Object.assign({}, data[0]), {
    stepIndex: 1,
    icon: React.createElement("p", {
      className: "stepsItemIcon"
    }, "1")
  }));
  set$1(template, middleIndex, Object.assign({
    stepIndex: middleIndex + 1
  }, ellipsisTemplate));
  set$1(template, length - 1, Object.assign(Object.assign({}, data[length - 1]), {
    stepIndex: length,
    icon: React.createElement("p", {
      className: "stepsItemIcon"
    }, length)
  }));
};

const EllipsisSteps = ({
  currentStep,
  steps = [],
  limit = 3,
  handelNext = () => {},
  renderTitle = value => value.name || ''
}) => {
  const middleIndex = Math.ceil(steps.length / 2) - 1;
  const [stepsForRender, setSteps] = useState(template.filter(Boolean));
  const [lastStep, setLastStep] = useState(Math.max(currentStep - 1 || 0, 0));
  const size = useWindowSize();
  const isMobile = size.width < 426;
  useEffect(() => {
    if (!isEmpty(template)) {
      return;
    }

    createTemplate(steps, steps.length, limit);
  }, [size]);
  const onNext = useCallback(current => {
    let index = get$3(stepsForRender, `${current}.stepIndex`);

    if (!index) {
      index = current + 1;
    }

    handelNext(index);
  }, [stepsForRender]);
  useEffect(() => {
    const res = cloneDeep(template);

    if (![0, middleIndex, steps.length - 1].includes(lastStep)) {
      res[lastStep] = undefined;
    } else if (lastStep === middleIndex && steps.length > limit) {
      res[lastStep] = Object.assign({
        stepIndex: middleIndex + 1
      }, ellipsisTemplate);
    }

    res[currentStep] = Object.assign(Object.assign({}, steps[currentStep]), {
      stepIndex: currentStep + 1,
      icon: React.createElement("p", {
        className: "activeStepsItemIcon"
      }, currentStep + 1)
    });
    setLastStep(currentStep);
    setSteps(res.filter(Boolean));
  }, [currentStep, steps]);
  return React.createElement(_Steps, {
    current: currentStep,
    onChange: current => {
      onNext(current);
    },
    direction: isMobile ? 'vertical' : 'horizontal'
  }, stepsForRender.map((section, index) => React.createElement(_Steps.Step, {
    key: `section-${section.id || index}`,
    title: renderTitle(section),
    icon: section.icon
  })));
};

const IconLeft = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#F7F7F8"
  }), React.createElement("path", {
    d: "M14 7.3335L9.33333 12.0002L14 16.6668",
    stroke: "#262F56"
  }));
};

const IconRight = _a => {
  var props = __rest(_a, []);

  return React.createElement(Icon, Object.assign({}, props), React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    transform: "rotate(-180 12 12)",
    fill: "#F7F7F8"
  }), React.createElement("path", {
    d: "M10 16.6665L14.6667 11.9998L10 7.33317",
    stroke: "#262F56"
  }));
};

var css_248z$$ = ".period-container .arrow-icon {\n  border: none;\n  background: unset;\n  align-items: center;\n}\n.period-container .arrow-icon:hover {\n  background: unset;\n}\n.period-container .center {\n  text-align: center;\n}\n.period-container .mr-bottom {\n  margin-bottom: 5px;\n}\n@media screen and (max-width: 768px) {\n  .period-container .ant-steps-item-content .ant-steps-item-title {\n    font-size: 15px;\n  }\n  .period-container .ant-steps-vertical {\n    align-items: center;\n  }\n}\n";
styleInject(css_248z$$);

const CalendarPeriod = _a => {
  var {
    periodStatistics,
    period,
    periodCount,
    changPeriod,
    sessions
  } = _a,
      props = __rest(_a, ["periodStatistics", "period", "periodCount", "changPeriod", "sessions"]);

  const size = useWindowSize();
  const isDesktop = size.width < 1025;
  const isMobile = size.width < 426;
  const leftArrowColProps = {
    xs: isDesktop ? 24 : 1,
    sm: isDesktop ? 24 : 1,
    md: isDesktop ? 24 : 1,
    lg: isDesktop ? 24 : 1,
    xl: 1,
    xxl: 1
  };
  const ellipsisColProps = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 17,
    xxl: 19
  };
  const rightArrowColProps = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: isDesktop ? 24 : 4,
    xl: 5,
    xxl: 4
  };
  return React.createElement(_Row, {
    gutter: 24,
    align: "middle",
    justify: "space-between",
    className: "period-container"
  }, React.createElement(_Col, Object.assign({}, leftArrowColProps, {
    className: isDesktop ? 'center mr-bottom' : ''
  }), React.createElement(_Button, {
    className: "arrow-icon",
    icon: React.createElement(IconLeft, {
      size: "md",
      fill: "none"
    }),
    disabled: !(periodCount > 1 && period !== 1),
    onClick: () => changPeriod(period - 1)
  }), isDesktop && React.createElement(_Button, {
    className: "arrow-icon",
    icon: React.createElement(IconRight, {
      size: "md",
      fill: "none"
    }),
    disabled: !(periodCount > 1 && period !== periodCount),
    onClick: () => changPeriod(period + 1)
  })), React.createElement(_Col, Object.assign({}, ellipsisColProps), React.createElement(_Row, {
    gutter: 24,
    align: "middle",
    justify: "space-between",
    className: isDesktop ? 'mr-bottom' : ''
  }, React.createElement(EllipsisSteps, {
    renderTitle: value => value.period ? `${moment$1(value.startDate).format('MMM-DD')} - ${moment$1(value.endDate).format('MMM-DD')}` : '',
    handelNext: step => {
      changPeriod(step);
    },
    currentStep: period - 1,
    steps: get$3(sessions, 'periods', [])
  }))), React.createElement(_Col, Object.assign({}, rightArrowColProps), React.createElement(_Row, {
    gutter: 24,
    align: "middle",
    justify: isDesktop ? 'center' : 'end'
  }, React.createElement(_Col, null, React.createElement(TTag, {
    type: TagTypes.TRIAL
  }, periodStatistics.attend || 0)), React.createElement(_Col, null, React.createElement(TTag, {
    type: TagTypes.WRONG
  }, periodStatistics.absent || 0)), React.createElement(_Col, null, React.createElement(TTag, {
    type: periodStatistics.attendancePerformance < 50 ? TagTypes.WRONG : TagTypes.TRIAL
  }, get$3(periodStatistics, 'attendancePerformance', 0))), !isDesktop && React.createElement(_Button, {
    className: "arrow-icon",
    icon: React.createElement(IconRight, {
      size: "md",
      fill: "none"
    }),
    disabled: !(periodCount > 1 && period !== periodCount),
    onClick: () => changPeriod(period + 1)
  }))));
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (process.env.NODE_ENV !== 'production') {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? invariant_1(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant_1(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef$1 = canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(defaultKey);
  !(canAcceptRef$1 || !methods.length) ? process.env.NODE_ENV !== "production" ? invariant_1(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant_1(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!isProp(props, key) && isProp(prevProps, key)) {
          nextState.values[key] = props[defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var MILI    = 'milliseconds'
  , SECONDS = 'seconds'
  , MINUTES = 'minutes'
  , HOURS   = 'hours'
  , DAY     = 'day'
  , WEEK    = 'week'
  , MONTH   = 'month'
  , YEAR    = 'year'
  , DECADE  = 'decade'
  , CENTURY = 'century';

var multiplierMilli = {
  'milliseconds': 1,
  'seconds': 1000,
  'minutes': 60 * 1000,
  'hours': 60 * 60 * 1000,
  'day': 24 * 60 * 60 * 1000,
  'week': 7 * 24 * 60 * 60 * 1000 
};

var multiplierMonth = {
  'month': 1,
  'year': 12,
  'decade': 10 * 12,
  'century': 100 * 12
};

function daysOf(year) {
  return [31, daysInFeb(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
}

function daysInFeb(year) {
  return (
      year % 4 === 0 
      && year % 100 !== 0
    ) || year % 400 === 0
      ? 29
      : 28
}

function add$1(d, num, unit) {
  d = new Date(d);

  switch (unit){
    case MILI:
    case SECONDS:
    case MINUTES:
    case HOURS:
    case DAY:
    case WEEK:
      return addMillis(d, num * multiplierMilli[unit])
    case MONTH:
    case YEAR:
    case DECADE:
    case CENTURY:
      return addMonths(d, num * multiplierMonth[unit])
  }

  throw new TypeError('Invalid units: "' + unit + '"')
}

function addMillis(d, num) {
  var nextDate = new Date(+(d) + num);

  return solveDST(d, nextDate)
}

function addMonths(d, num) {
  var year = d.getFullYear()
    , month = d.getMonth()
    , day = d.getDate()
    , totalMonths = year * 12 + month + num
    , nextYear = Math.trunc(totalMonths / 12)
    , nextMonth = totalMonths % 12
    , nextDay = Math.min(day, daysOf(nextYear)[nextMonth]);

  var nextDate = new Date(d);
  nextDate.setFullYear(nextYear);

  // To avoid a bug when sets the Feb month
  // with a date > 28 or date > 29 (leap year)
  nextDate.setDate(1);

  nextDate.setMonth(nextMonth);
  nextDate.setDate(nextDay);

  return nextDate
}

function solveDST(currentDate, nextDate) {
  var currentOffset = currentDate.getTimezoneOffset()
    , nextOffset = nextDate.getTimezoneOffset();

  // if is DST, add the difference in minutes
  // else the difference is zero
  var diffMinutes = (nextOffset - currentOffset);

  return new Date(+(nextDate) + diffMinutes * multiplierMilli['minutes'])
}

function subtract(d, num, unit) {
  return add$1(d, -num, unit)
}

function startOf(d, unit, firstOfWeek) {
  d = new Date(d);

  switch (unit) {
    case CENTURY:
    case DECADE:
    case YEAR:
        d = month(d, 0);
    case MONTH:
        d = date(d, 1);
    case WEEK:
    case DAY:
        d = hours(d, 0);
    case HOURS:
        d = minutes(d, 0);
    case MINUTES:
        d = seconds(d, 0);
    case SECONDS:
        d = milliseconds(d, 0);
  }

  if (unit === DECADE)
    d = subtract(d, year(d) % 10, 'year');

  if (unit === CENTURY)
    d = subtract(d, year(d) % 100, 'year');

  if (unit === WEEK)
    d = weekday(d, 0, firstOfWeek);

  return d
}

function endOf(d, unit, firstOfWeek){
  d = new Date(d);
  d = startOf(d, unit, firstOfWeek);
  switch (unit) {
    case CENTURY:
    case DECADE:
    case YEAR:
    case MONTH:
    case WEEK:
      d = add$1(d, 1, unit);
      d = subtract(d, 1, DAY);
      d.setHours(23, 59, 59, 999);
      break;
    case DAY:
      d.setHours(23, 59, 59, 999);
      break;
    case HOURS:
    case MINUTES:
    case SECONDS:
      d = add$1(d, 1, unit);
      d = subtract(d, 1, MILI);
  }
  return d
}

var eq =  createComparer(function(a, b){ return a === b });
var gt =  createComparer(function(a, b){ return a > b });
var gte = createComparer(function(a, b){ return a >= b });
var lt =  createComparer(function(a, b){ return a < b });
var lte = createComparer(function(a, b){ return a <= b });

function min(){
  return new Date(Math.min.apply(Math, arguments))
}

function max(){
  return new Date(Math.max.apply(Math, arguments))
}

function inRange(day, min, max, unit){
  unit = unit || 'day';

  return (!min || gte(day, min, unit))
      && (!max || lte(day, max, unit))
}

var milliseconds = createAccessor('Milliseconds');
var seconds =      createAccessor('Seconds');
var minutes =      createAccessor('Minutes');
var hours =        createAccessor('Hours');
var day =          createAccessor('Day');
var date =         createAccessor('Date');
var month =        createAccessor('Month');
var year =         createAccessor('FullYear');

function weekday(d, val, firstDay) {
    var w = (day(d) + 7 - (firstDay || 0) ) % 7;

    return val === undefined
      ? w
      : add$1(d, val - w, DAY);
}

function createAccessor(method){
  var hourLength = (function(method) {  
    switch(method) {
      case 'Milliseconds':
        return 3600000;
      case 'Seconds':
        return 3600;
      case 'Minutes':
        return 60;
      case 'Hours':
        return 1;
      default:
        return null;
    }
  })(method);
  
  return function(d, val){
    if (val === undefined)
      return d['get' + method]()

    var dateOut = new Date(d);
    dateOut['set' + method](val);
    
    if(hourLength && dateOut['get'+method]() != val && (method === 'Hours' || val >=hourLength && (dateOut.getHours()-d.getHours()<Math.floor(val/hourLength))) ){
      //Skip DST hour, if it occurs
      dateOut['set'+method](val+hourLength);
    }
    
    return dateOut
  }
}

function createComparer(operator) {
  return function (a, b, unit) {
    return operator(+startOf(a, unit), +startOf(b, unit))
  };
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$1(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}

function getComputedStyle$1(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}

var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}

function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle$1(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* eslint-disable no-bitwise, no-cond-assign */
// HTML DOM and SVG DOM may have different support levels,
// so we need to check on context instead of a document root element.
function contains(context, node) {
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

function isDocument(element) {
  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}

function isWindow(node) {
  if ('window' in node && node.window === node) return node;
  if (isDocument(node)) return node.defaultView || false;
  return false;
}

function getscrollAccessor(offset) {
  var prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';

  function scrollAccessor(node, val) {
    var win = isWindow(node);

    if (val === undefined) {
      return win ? win[offset] : node[prop];
    }

    if (win) {
      win.scrollTo(win[offset], val);
    } else {
      node[prop] = val;
    }
  }

  return scrollAccessor;
}

var getScrollLeft = getscrollAccessor('pageXOffset');

var getScrollTop = getscrollAccessor('pageYOffset');

function offset(node) {
  var doc = ownerDocument(node);
  var box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  var docElem = doc && doc.documentElement; // Make sure it's not a disconnected DOM node

  if (!docElem || !contains(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
  box = {
    top: box.top + getScrollTop(docElem) - (docElem.clientTop || 0),
    left: box.left + getScrollLeft(docElem) - (docElem.clientLeft || 0),
    width: box.width,
    height: box.height
  };
  return box;
}

var isHTMLElement = function isHTMLElement(e) {
  return !!e && 'offsetParent' in e;
};

function offsetParent(node) {
  var doc = ownerDocument(node);
  var parent = node && node.offsetParent;

  while (isHTMLElement(parent) && parent.nodeName !== 'HTML' && style(parent, 'position') === 'static') {
    parent = parent.offsetParent;
  }

  return parent || doc.documentElement;
}

var nodeName = function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
};

function position(node, offsetParent$1) {
  var parentOffset = {
    top: 0,
    left: 0
  };
  var offset$1; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if (style(node, 'position') === 'fixed') {
    offset$1 = node.getBoundingClientRect();
  } else {
    var parent = offsetParent$1 || offsetParent(node);
    offset$1 = offset(node);
    if (nodeName(parent) !== 'html') parentOffset = offset(parent);
    var borderTop = String(style(parent, 'borderTopWidth') || 0);
    parentOffset.top += parseInt(borderTop, 10) - getScrollTop(parent) || 0;
    var borderLeft = String(style(parent, 'borderLeftWidth') || 0);
    parentOffset.left += parseInt(borderLeft, 10) - getScrollLeft(parent) || 0;
  }

  var marginTop = String(style(node, 'marginTop') || 0);
  var marginLeft = String(style(node, 'marginLeft') || 0); // Subtract parent offsets and node margins

  return _extends({}, offset$1, {
    top: offset$1.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
    left: offset$1.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
  });
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* https://github.com/component/raf */
var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime();
  var ms = Math.max(0, 16 - (curr - prev));
  var handle = setTimeout(fn, ms);
  prev = curr;
  return handle;
}

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancelMethod = 'clearTimeout';
var rafImpl = fallback; // eslint-disable-next-line import/no-mutable-exports

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};

if (canUseDOM) {
  vendors.some(function (vendor) {
    var rafMethod = getKey(vendor, 'request');

    if (rafMethod in window) {
      cancelMethod = getKey(vendor, 'cancel'); // @ts-ignore

      rafImpl = function rafImpl(cb) {
        return window[rafMethod](cb);
      };
    }

    return !!rafImpl;
  });
}

var cancel = function cancel(id) {
  // @ts-ignore
  if (typeof window[cancelMethod] === 'function') window[cancelMethod](id);
};
var request = rafImpl;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$1(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck$1 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$1({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$1({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$1(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update$1() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$1({}, attributes, data.attributes);
  data.styles = _extends$1({}, styles, data.styles);
  data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$1(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$1(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset$1(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$1({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$1({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$1({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$1({}, side, reference[side]),
      end: defineProperty$1({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset$1,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck$1(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$1({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$1({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$1({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$1({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass$1(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update$1.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return useState(null);
}

var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return useMemo(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

var initialPopperStyles = {
  position: 'absolute',
  top: '0',
  left: '0',
  opacity: '0',
  pointerEvents: 'none'
};
var initialArrowStyles = {};
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param {HTMLElement} referenceElement The element
 * @param {HTMLElement} popperElement
 * @param {Object}      options
 * @param {Object}      options.modifiers Popper.js modifiers
 * @param {Boolean}     options.enabled toggle the popper functionality on/off
 * @param {String}      options.placement The popper element placement relative to the reference element
 * @param {Boolean}     options.positionFixed use fixed positioning
 * @param {Boolean}     options.eventsEnabled have Popper listen on window resize events to reposition the element
 */

function usePopper(referenceElement, popperElement, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$positionFixed = _ref.positionFixed,
      positionFixed = _ref$positionFixed === void 0 ? false : _ref$positionFixed,
      _ref$eventsEnabled = _ref.eventsEnabled,
      eventsEnabled = _ref$eventsEnabled === void 0 ? true : _ref$eventsEnabled,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? {} : _ref$modifiers;

  var popperInstanceRef = useRef();
  var hasArrow = !!(modifiers.arrow && modifiers.arrow.element);
  var scheduleUpdate = useCallback(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.scheduleUpdate();
    }
  }, []);

  var _useState = useState({
    placement: placement,
    scheduleUpdate: scheduleUpdate,
    outOfBoundaries: false,
    styles: initialPopperStyles,
    arrowStyles: initialArrowStyles
  }),
      state = _useState[0],
      setState = _useState[1]; // A placement difference in state means popper determined a new placement
  // apart from the props value. By the time the popper element is rendered with
  // the new position Popper has already measured it, if the place change triggers
  // a size change it will result in a misaligned popper. So we schedule an update to be sure.


  useEffect(function () {
    scheduleUpdate();
  }, [state.placement, scheduleUpdate]);
  /** Toggle Events */

  useEffect(function () {
    if (popperInstanceRef.current) {
      // eslint-disable-next-line no-unused-expressions
      eventsEnabled ? popperInstanceRef.current.enableEventListeners() : popperInstanceRef.current.disableEventListeners();
    }
  }, [eventsEnabled]);
  useEffect(function () {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }

    var arrow = modifiers.arrow && _extends({}, modifiers.arrow, {
      element: modifiers.arrow.element
    });

    popperInstanceRef.current = new Popper(referenceElement, popperElement, {
      placement: placement,
      positionFixed: positionFixed,
      modifiers: _extends({}, modifiers, {
        arrow: arrow,
        applyStyle: {
          enabled: false
        },
        updateStateModifier: {
          enabled: true,
          order: 900,
          fn: function fn(data) {
            setState({
              scheduleUpdate: scheduleUpdate,
              styles: _extends({
                position: data.offsets.popper.position
              }, data.styles),
              arrowStyles: data.arrowStyles,
              outOfBoundaries: data.hide,
              placement: data.placement
            });
          }
        }
      })
    });
    return function () {
      if (popperInstanceRef.current !== null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = null;
      }
    }; // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, placement, positionFixed, referenceElement, popperElement, hasArrow]);
  return state;
}

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  var ref = useCommittedRef(fn);
  return useCallback(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$2 = function() {};

if (__DEV__) {
  var printWarning$2 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$2 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning$2.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$2;

function ownerDocument$1 (componentOrElement) {
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}

var escapeKeyCode = 27;

var noop$1 = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>|HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object}  options
 * @param {boolean} options.disabled
 * @param {string}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */


function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = useRef(false);
  var onClose = onRootClose || noop$1;
  var handleMouseCapture = useCallback(function (e) {
    var currentTarget = ref && ('current' in ref ? ref.current : ref);
    warning_1(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || contains(currentTarget, e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  useEffect(function () {
    if (disabled || ref == null) return undefined;
    var doc = ownerDocument$1(ref.current); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, handleMouse);
    var removeKeyupListener = listen(doc, 'keyup', handleKeyUp);
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return listen(el, 'mousemove', noop$1);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

var resolveRef = function resolveRef(ref) {
  if (typeof document === 'undefined') return undefined;
  if (ref == null) return ownerDocument().body;
  if (typeof ref === 'function') ref = ref();
  if (ref && ref.current) ref = ref.current;
  if (ref && ref.nodeType) return ref;
  return null;
};

function useWaitForDOMRef(ref, onResolved) {
  var _useState = useState(function () {
    return resolveRef(ref);
  }),
      resolvedRef = _useState[0],
      setRef = _useState[1];

  if (!resolvedRef) {
    var earlyRef = resolveRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  useEffect(function () {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  useEffect(function () {
    var nextRef = resolveRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */

var Overlay = React.forwardRef(function (props, outerRef) {
  var flip = props.flip,
      placement = props.placement,
      containerPadding = props.containerPadding,
      _props$popperConfig = props.popperConfig,
      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
      Transition = props.transition;

  var _useCallbackRef = useCallbackRef(),
      rootElement = _useCallbackRef[0],
      attachRef = _useCallbackRef[1];

  var _useCallbackRef2 = useCallbackRef(),
      arrowElement = _useCallbackRef2[0],
      attachArrowRef = _useCallbackRef2[1];

  var mergedRef = useMergedRefs(attachRef, outerRef);
  var container = useWaitForDOMRef(props.container);
  var target = useWaitForDOMRef(props.target);

  var _useState = useState(!props.show),
      exited = _useState[0],
      setExited = _useState[1];

  var _popperConfig$modifie = popperConfig.modifiers,
      modifiers = _popperConfig$modifie === void 0 ? {} : _popperConfig$modifie;

  var _usePopper = usePopper(target, rootElement, _extends({}, popperConfig, {
    placement: placement || 'bottom',
    enableEvents: props.show,
    modifiers: _extends({}, modifiers, {
      preventOverflow: _extends({
        padding: containerPadding || 5
      }, modifiers.preventOverflow),
      arrow: _extends({}, modifiers.arrow, {
        enabled: !!arrowElement,
        element: arrowElement
      }),
      flip: _extends({
        enabled: !!flip
      }, modifiers.preventOverflow)
    })
  })),
      styles = _usePopper.styles,
      arrowStyles = _usePopper.arrowStyles,
      popper = _objectWithoutPropertiesLoose(_usePopper, ["styles", "arrowStyles"]);

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  var handleHidden = function handleHidden() {
    setExited(true);

    if (props.onExited) {
      props.onExited.apply(props, arguments);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  var mountOverlay = props.show || Transition && !exited;
  useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var child = props.children(_extends({}, popper, {
    show: props.show,
    props: {
      style: styles,
      ref: mergedRef
    },
    arrowProps: {
      style: arrowStyles,
      ref: attachArrowRef
    }
  }));

  if (Transition) {
    var onExit = props.onExit,
        onExiting = props.onExiting,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered;
    child = React.createElement(Transition, {
      "in": props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, child);
  }

  return container ? ReactDOM.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: propTypes.bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: propTypes.oneOf(Popper.placements),

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: propTypes.any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: propTypes.any,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: propTypes.bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   outOfBoundaries: ?boolean,
   *   scheduleUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */
  children: propTypes.func.isRequired,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: propTypes.number,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: propTypes.object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: propTypes.bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: propTypes.oneOf(['click', 'mousedown']),

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: propTypes.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = propTypes.func;

    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(void 0, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: propTypes.elementType,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: propTypes.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: propTypes.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: propTypes.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: propTypes.func
};
Overlay.defaultProps = {
  containerPadding: 5
};

function height(node, client) {
  var win = isWindow(node);
  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
}

var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}

var matchesImpl;
function matches(node, selector) {
  if (!matchesImpl) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;

    matchesImpl = function matchesImpl(n, s) {
      return nativeMatch.call(n, s);
    };
  }

  return matchesImpl(node, selector);
}

function closest(node, selector, stopAt) {
  if (node.closest && !stopAt) node.closest(selector);
  var nextNode = node;

  do {
    if (matches(nextNode, selector)) return nextNode;
    nextNode = nextNode.parentElement;
  } while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);

  return null;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root.Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag(new Map$1) != mapTag$2) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag$2) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$1)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var getTag$1 = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag$1 : getTag$1(object),
      othTag = othIsArr ? arrayTag$1 : getTag$1(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get$2(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax$1(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate), index);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$1 = Math.ceil,
    nativeMax$2 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$2(nativeCeil$1((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var memoizeOne_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': memoizeOne
});

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$3(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$3(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var defineProperty$2 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$2 ? identity : function(func, string) {
  return defineProperty$2(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

function getWidth(node, client) {
  var win = isWindow(node);
  return win ? win.innerWidth : client ? node.clientWidth : offset(node).width;
}

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$a.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$c.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$3:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);

    case regexpTag$2:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$4;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$4;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] =
cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] =
cloneableTags[boolTag$3] = cloneableTags[dateTag$3] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$5] =
cloneableTags[numberTag$3] = cloneableTags[objectTag$3] =
cloneableTags[regexpTag$3] = cloneableTags[setTag$5] =
cloneableTags[stringTag$3] = cloneableTags[symbolTag$3] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$3 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

/** `Object#toString` result references. */
var objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$4) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$d.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults$1 = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn$1(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq$1(value, objectProto$g[key]) && !hasOwnProperty$e.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

function NoopWrapper(props) {
  return props.children;
}

var navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};
var views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};

var viewNames = Object.keys(views).map(function (k) {
  return views[k];
});
var accessor = propTypes.oneOfType([propTypes.string, propTypes.func]);
var dateFormat = propTypes.any;
var dateRangeFormat = propTypes.func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */

var views$1 = propTypes.oneOfType([propTypes.arrayOf(propTypes.oneOf(viewNames)), propTypes.objectOf(function (prop, key) {
  var isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';

  if (isBuiltinView) {
    return null;
  } else {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return propTypes.elementType.apply(propTypes, [prop, key].concat(args));
  }
})]);
var DayLayoutAlgorithmPropType = propTypes.oneOfType([propTypes.oneOf(['overlap', 'no-overlap']), propTypes.func]);

function notify(handler, args) {
  handler && handler.apply(null, [].concat(args));
}

var localePropType = propTypes.oneOfType([propTypes.string, propTypes.func]);

function _format(localizer, formatter, value, format, culture) {
  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
  !(result == null || typeof result === 'string') ? process.env.NODE_ENV !== "production" ? invariant_1(false, '`localizer format(..)` must return a string, null, or undefined') : invariant_1(false) : void 0;
  return result;
}

var DateLocalizer = function DateLocalizer(spec) {
  var _this = this;

  !(typeof spec.format === 'function') ? process.env.NODE_ENV !== "production" ? invariant_1(false, 'date localizer `format(..)` must be a function') : invariant_1(false) : void 0;
  !(typeof spec.firstOfWeek === 'function') ? process.env.NODE_ENV !== "production" ? invariant_1(false, 'date localizer `firstOfWeek(..)` must be a function') : invariant_1(false) : void 0;
  this.propType = spec.propType || localePropType;
  this.startOfWeek = spec.firstOfWeek;
  this.formats = spec.formats;

  this.format = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _format.apply(void 0, [_this, spec.format].concat(args));
  };
};
function mergeWithDefaults(localizer, culture, formatOverrides, messages) {
  var formats = _extends({}, localizer.formats, formatOverrides);

  return _extends({}, localizer, {
    messages: messages,
    startOfWeek: function startOfWeek() {
      return localizer.startOfWeek(culture);
    },
    format: function format(value, _format2) {
      return localizer.format(value, formats[_format2] || _format2, culture);
    }
  });
}

var defaultMessages = {
  date: 'Date',
  time: 'Time',
  event: 'Event',
  allDay: 'All Day',
  week: 'Week',
  work_week: 'Work Week',
  day: 'Day',
  month: 'Month',
  previous: 'Back',
  next: 'Next',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  today: 'Today',
  agenda: 'Agenda',
  noEventsInRange: 'There are no events in this range.',
  showMore: function showMore(total) {
    return "+" + total + " more";
  }
};
function messages(msgs) {
  return _extends({}, defaultMessages, msgs);
}

/* eslint no-fallthrough: off */
var MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24
};
function firstVisibleDay(date, localizer) {
  var firstOfMonth = startOf(date, 'month');
  return startOf(firstOfMonth, 'week', localizer.startOfWeek());
}
function lastVisibleDay(date, localizer) {
  var endOfMonth = endOf(date, 'month');
  return endOf(endOfMonth, 'week', localizer.startOfWeek());
}
function visibleDays(date, localizer) {
  var current = firstVisibleDay(date, localizer),
      last = lastVisibleDay(date, localizer),
      days = [];

  while (lte(current, last, 'day')) {
    days.push(current);
    current = add$1(current, 1, 'day');
  }

  return days;
}
function ceil(date, unit) {
  var floor = startOf(date, unit);
  return eq(floor, date) ? floor : add$1(floor, 1, unit);
}
function range$1(start, end, unit) {
  if (unit === void 0) {
    unit = 'day';
  }

  var current = start,
      days = [];

  while (lte(current, end, unit)) {
    days.push(current);
    current = add$1(current, 1, unit);
  }

  return days;
}
function merge(date, time) {
  if (time == null && date == null) return null;
  if (time == null) time = new Date();
  if (date == null) date = new Date();
  date = startOf(date, 'day');
  date = hours(date, hours(time));
  date = minutes(date, minutes(time));
  date = seconds(date, seconds(time));
  return milliseconds(date, milliseconds(time));
}
function isJustDate(date) {
  return hours(date) === 0 && minutes(date) === 0 && seconds(date) === 0 && milliseconds(date) === 0;
}
function diff(dateA, dateB, unit) {
  if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB); // the .round() handles an edge case
  // with DST where the total won't be exact
  // since one day in the range may be shorter/longer by an hour

  return Math.round(Math.abs(+startOf(dateA, unit) / MILLI[unit] - +startOf(dateB, unit) / MILLI[unit]));
}

var EventCell =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EventCell, _React$Component);

  function EventCell() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventCell.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        className = _this$props.className,
        event = _this$props.event,
        selected = _this$props.selected,
        isAllDay = _this$props.isAllDay,
        onSelect = _this$props.onSelect,
        _onDoubleClick = _this$props.onDoubleClick,
        _onKeyPress = _this$props.onKeyPress,
        localizer = _this$props.localizer,
        continuesPrior = _this$props.continuesPrior,
        continuesAfter = _this$props.continuesAfter,
        accessors = _this$props.accessors,
        getters = _this$props.getters,
        children = _this$props.children,
        _this$props$component = _this$props.components,
        Event = _this$props$component.event,
        EventWrapper = _this$props$component.eventWrapper,
        slotStart = _this$props.slotStart,
        slotEnd = _this$props.slotEnd,
        props = _objectWithoutPropertiesLoose(_this$props, ["style", "className", "event", "selected", "isAllDay", "onSelect", "onDoubleClick", "onKeyPress", "localizer", "continuesPrior", "continuesAfter", "accessors", "getters", "children", "components", "slotStart", "slotEnd"]);

    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var allDay = accessors.allDay(event);
    var showAsAllDay = isAllDay || allDay || diff(start, ceil(end, 'day'), 'day') > 1;
    var userProps = getters.eventProp(event, start, end, selected);
    var content = React.createElement("div", {
      className: "rbc-event-content",
      title: tooltip || undefined
    }, Event ? React.createElement(Event, {
      event: event,
      continuesPrior: continuesPrior,
      continuesAfter: continuesAfter,
      title: title,
      isAllDay: allDay,
      localizer: localizer,
      slotStart: slotStart,
      slotEnd: slotEnd
    }) : title);
    return React.createElement(EventWrapper, _extends({}, this.props, {
      type: "date"
    }), React.createElement("div", _extends({}, props, {
      tabIndex: 0,
      style: _extends({}, userProps.style, style),
      className: clsx('rbc-event', className, userProps.className, {
        'rbc-selected': selected,
        'rbc-event-allday': showAsAllDay,
        'rbc-event-continues-prior': continuesPrior,
        'rbc-event-continues-after': continuesAfter
      }),
      onClick: function onClick(e) {
        return onSelect && onSelect(event, e);
      },
      onDoubleClick: function onDoubleClick(e) {
        return _onDoubleClick && _onDoubleClick(event, e);
      },
      onKeyPress: function onKeyPress(e) {
        return _onKeyPress && _onKeyPress(event, e);
      }
    }), typeof children === 'function' ? children(content) : content));
  };

  return EventCell;
}(React.Component);

EventCell.propTypes = process.env.NODE_ENV !== "production" ? {
  event: propTypes.object.isRequired,
  slotStart: propTypes.instanceOf(Date),
  slotEnd: propTypes.instanceOf(Date),
  selected: propTypes.bool,
  isAllDay: propTypes.bool,
  continuesPrior: propTypes.bool,
  continuesAfter: propTypes.bool,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object,
  onSelect: propTypes.func,
  onDoubleClick: propTypes.func,
  onKeyPress: propTypes.func
} : {};

function isSelected(event, selected) {
  if (!event || selected == null) return false;
  return [].concat(selected).indexOf(event) !== -1;
}
function slotWidth(rowBox, slots) {
  var rowWidth = rowBox.right - rowBox.left;
  var cellWidth = rowWidth / slots;
  return cellWidth;
}
function getSlotAtX(rowBox, x, rtl, slots) {
  var cellWidth = slotWidth(rowBox, slots);
  return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function pointInBox(box, _ref) {
  var x = _ref.x,
      y = _ref.y;
  return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function dateCellSelection(start, rowBox, box, slots, rtl) {
  var startIdx = -1;
  var endIdx = -1;
  var lastSlotIdx = slots - 1;
  var cellWidth = slotWidth(rowBox, slots); // cell under the mouse

  var currentSlot = getSlotAtX(rowBox, box.x, rtl, slots); // Identify row as either the initial row
  // or the row under the current mouse point

  var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
  var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y; // this row's position relative to the start point

  var isAboveStart = start.y > rowBox.bottom;
  var isBelowStart = rowBox.top > start.y;
  var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom; // this row is between the current and start rows, so entirely selected

  if (isBetween) {
    startIdx = 0;
    endIdx = lastSlotIdx;
  }

  if (isCurrentRow) {
    if (isBelowStart) {
      startIdx = 0;
      endIdx = currentSlot;
    } else if (isAboveStart) {
      startIdx = currentSlot;
      endIdx = lastSlotIdx;
    }
  }

  if (isStartRow) {
    // select the cell under the initial point
    startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);

    if (isCurrentRow) {
      if (currentSlot < startIdx) startIdx = currentSlot;else endIdx = currentSlot; //select current range
    } else if (start.y < box.y) {
      // the current row is below start row
      // select cells to the right of the start cell
      endIdx = lastSlotIdx;
    } else {
      // select cells to the left of the start cell
      startIdx = 0;
    }
  }

  return {
    startIdx: startIdx,
    endIdx: endIdx
  };
}

var Popup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Popup, _React$Component);

  function Popup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        _this$props$popupOffs = _this$props.popupOffset,
        popupOffset = _this$props$popupOffs === void 0 ? 5 : _this$props$popupOffs,
        popperRef = _this$props.popperRef,
        _getOffset = offset(popperRef.current),
        top = _getOffset.top,
        left = _getOffset.left,
        width = _getOffset.width,
        height = _getOffset.height,
        viewBottom = window.innerHeight + getScrollTop(window),
        viewRight = window.innerWidth + getScrollLeft(window),
        bottom = top + height,
        right = left + width;

    if (bottom > viewBottom || right > viewRight) {
      var topOffset, leftOffset;
      if (bottom > viewBottom) topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
      if (right > viewRight) leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);
      this.setState({
        topOffset: topOffset,
        leftOffset: leftOffset
      }); //eslint-disable-line
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        events = _this$props2.events,
        selected = _this$props2.selected,
        getters = _this$props2.getters,
        accessors = _this$props2.accessors,
        components = _this$props2.components,
        onSelect = _this$props2.onSelect,
        onDoubleClick = _this$props2.onDoubleClick,
        onKeyPress = _this$props2.onKeyPress,
        slotStart = _this$props2.slotStart,
        slotEnd = _this$props2.slotEnd,
        localizer = _this$props2.localizer,
        popperRef = _this$props2.popperRef;
    var width = this.props.position.width,
        topOffset = (this.state || {}).topOffset || 0,
        leftOffset = (this.state || {}).leftOffset || 0;
    var style = {
      top: -topOffset,
      left: -leftOffset,
      minWidth: width + width / 2
    };
    return React.createElement("div", {
      style: _extends({}, this.props.style, style),
      className: "rbc-overlay",
      ref: popperRef
    }, React.createElement("div", {
      className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function (event, idx) {
      return React.createElement(EventCell, {
        key: idx,
        type: "popup",
        event: event,
        getters: getters,
        onSelect: onSelect,
        accessors: accessors,
        components: components,
        onDoubleClick: onDoubleClick,
        onKeyPress: onKeyPress,
        continuesPrior: lt(accessors.end(event), slotStart, 'day'),
        continuesAfter: gte(accessors.start(event), slotEnd, 'day'),
        slotStart: slotStart,
        slotEnd: slotEnd,
        selected: isSelected(event, selected),
        draggable: true,
        onDragStart: function onDragStart() {
          return _this.props.handleDragStart(event);
        },
        onDragEnd: function onDragEnd() {
          return _this.props.show();
        }
      });
    }));
  };

  return Popup;
}(React.Component);

Popup.propTypes = process.env.NODE_ENV !== "production" ? {
  position: propTypes.object,
  popupOffset: propTypes.oneOfType([propTypes.number, propTypes.shape({
    x: propTypes.number,
    y: propTypes.number
  })]),
  events: propTypes.array,
  selected: propTypes.object,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired,
  onSelect: propTypes.func,
  onDoubleClick: propTypes.func,
  onKeyPress: propTypes.func,
  handleDragStart: propTypes.func,
  show: propTypes.func,
  slotStart: propTypes.instanceOf(Date),
  slotEnd: propTypes.number,
  popperRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.Element
  })])
  /**
   * The Overlay component, of react-overlays, creates a ref that is passed to the Popup, and
   * requires proper ref forwarding to be used without error
   */

} : {};
var Popup$1 = React.forwardRef(function (props, ref) {
  return React.createElement(Popup, _extends({
    popperRef: ref
  }, props));
});

function addEventListener$1(type, handler, target) {
  if (target === void 0) {
    target = document;
  }

  return listen(target, type, handler, {
    passive: false
  });
}

function isOverContainer(container, x, y) {
  return !container || contains(container, document.elementFromPoint(x, y));
}

function getEventNodeFromPoint(node, _ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  var target = document.elementFromPoint(clientX, clientY);
  return closest(target, '.rbc-event', node);
}
function isEvent(node, bounds) {
  return !!getEventNodeFromPoint(node, bounds);
}

function getEventCoordinates(e) {
  var target = e;

  if (e.touches && e.touches.length) {
    target = e.touches[0];
  }

  return {
    clientX: target.clientX,
    clientY: target.clientY,
    pageX: target.pageX,
    pageY: target.pageY
  };
}

var clickTolerance = 5;
var clickInterval = 250;

var Selection =
/*#__PURE__*/
function () {
  function Selection(node, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$global = _ref2.global,
        global = _ref2$global === void 0 ? false : _ref2$global,
        _ref2$longPressThresh = _ref2.longPressThreshold,
        longPressThreshold = _ref2$longPressThresh === void 0 ? 250 : _ref2$longPressThresh;

    this.isDetached = false;
    this.container = node;
    this.globalMouse = !node || global;
    this.longPressThreshold = longPressThreshold;
    this._listeners = Object.create(null);
    this._handleInitialEvent = this._handleInitialEvent.bind(this);
    this._handleMoveEvent = this._handleMoveEvent.bind(this);
    this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
    this._keyListener = this._keyListener.bind(this);
    this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
    this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this); // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
    // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356

    this._removeTouchMoveWindowListener = addEventListener$1('touchmove', function () {}, window);
    this._removeKeyDownListener = addEventListener$1('keydown', this._keyListener);
    this._removeKeyUpListener = addEventListener$1('keyup', this._keyListener);
    this._removeDropFromOutsideListener = addEventListener$1('drop', this._dropFromOutsideListener);
    this._onDragOverfromOutisde = addEventListener$1('dragover', this._dragOverFromOutsideListener);

    this._addInitialEventListener();
  }

  var _proto = Selection.prototype;

  _proto.on = function on(type, handler) {
    var handlers = this._listeners[type] || (this._listeners[type] = []);
    handlers.push(handler);
    return {
      remove: function remove() {
        var idx = handlers.indexOf(handler);
        if (idx !== -1) handlers.splice(idx, 1);
      }
    };
  };

  _proto.emit = function emit(type) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result;
    var handlers = this._listeners[type] || [];
    handlers.forEach(function (fn) {
      if (result === undefined) result = fn.apply(void 0, args);
    });
    return result;
  };

  _proto.teardown = function teardown() {
    this.isDetached = true;
    this.listeners = Object.create(null);
    this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
    this._removeInitialEventListener && this._removeInitialEventListener();
    this._removeEndListener && this._removeEndListener();
    this._onEscListener && this._onEscListener();
    this._removeMoveListener && this._removeMoveListener();
    this._removeKeyUpListener && this._removeKeyUpListener();
    this._removeKeyDownListener && this._removeKeyDownListener();
    this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
  };

  _proto.isSelected = function isSelected(node) {
    var box = this._selectRect;
    if (!box || !this.selecting) return false;
    return objectsCollide(box, getBoundsForNode(node));
  };

  _proto.filter = function filter(items) {
    var box = this._selectRect; //not selecting

    if (!box || !this.selecting) return [];
    return items.filter(this.isSelected, this);
  } // Adds a listener that will call the handler only after the user has pressed on the screen
  // without moving their finger for 250ms.
  ;

  _proto._addLongPressListener = function _addLongPressListener(handler, initialEvent) {
    var _this = this;

    var timer = null;
    var removeTouchMoveListener = null;
    var removeTouchEndListener = null;

    var handleTouchStart = function handleTouchStart(initialEvent) {
      timer = setTimeout(function () {
        cleanup();
        handler(initialEvent);
      }, _this.longPressThreshold);
      removeTouchMoveListener = addEventListener$1('touchmove', function () {
        return cleanup();
      });
      removeTouchEndListener = addEventListener$1('touchend', function () {
        return cleanup();
      });
    };

    var removeTouchStartListener = addEventListener$1('touchstart', handleTouchStart);

    var cleanup = function cleanup() {
      if (timer) {
        clearTimeout(timer);
      }

      if (removeTouchMoveListener) {
        removeTouchMoveListener();
      }

      if (removeTouchEndListener) {
        removeTouchEndListener();
      }

      timer = null;
      removeTouchMoveListener = null;
      removeTouchEndListener = null;
    };

    if (initialEvent) {
      handleTouchStart(initialEvent);
    }

    return function () {
      cleanup();
      removeTouchStartListener();
    };
  } // Listen for mousedown and touchstart events. When one is received, disable the other and setup
  // future event handling based on the type of event.
  ;

  _proto._addInitialEventListener = function _addInitialEventListener() {
    var _this2 = this;

    var removeMouseDownListener = addEventListener$1('mousedown', function (e) {
      _this2._removeInitialEventListener();

      _this2._handleInitialEvent(e);

      _this2._removeInitialEventListener = addEventListener$1('mousedown', _this2._handleInitialEvent);
    });
    var removeTouchStartListener = addEventListener$1('touchstart', function (e) {
      _this2._removeInitialEventListener();

      _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
    });

    this._removeInitialEventListener = function () {
      removeMouseDownListener();
      removeTouchStartListener();
    };
  };

  _proto._dropFromOutsideListener = function _dropFromOutsideListener(e) {
    var _getEventCoordinates = getEventCoordinates(e),
        pageX = _getEventCoordinates.pageX,
        pageY = _getEventCoordinates.pageY,
        clientX = _getEventCoordinates.clientX,
        clientY = _getEventCoordinates.clientY;

    this.emit('dropFromOutside', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
    e.preventDefault();
  };

  _proto._dragOverFromOutsideListener = function _dragOverFromOutsideListener(e) {
    var _getEventCoordinates2 = getEventCoordinates(e),
        pageX = _getEventCoordinates2.pageX,
        pageY = _getEventCoordinates2.pageY,
        clientX = _getEventCoordinates2.clientX,
        clientY = _getEventCoordinates2.clientY;

    this.emit('dragOverFromOutside', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
    e.preventDefault();
  };

  _proto._handleInitialEvent = function _handleInitialEvent(e) {
    if (this.isDetached) {
      return;
    }

    var _getEventCoordinates3 = getEventCoordinates(e),
        clientX = _getEventCoordinates3.clientX,
        clientY = _getEventCoordinates3.clientY,
        pageX = _getEventCoordinates3.pageX,
        pageY = _getEventCoordinates3.pageY;

    var node = this.container(),
        collides,
        offsetData; // Right clicks

    if (e.which === 3 || e.button === 2 || !isOverContainer(node, clientX, clientY)) return;

    if (!this.globalMouse && node && !contains(node, e.target)) {
      var _normalizeDistance = normalizeDistance(0),
          top = _normalizeDistance.top,
          left = _normalizeDistance.left,
          bottom = _normalizeDistance.bottom,
          right = _normalizeDistance.right;

      offsetData = getBoundsForNode(node);
      collides = objectsCollide({
        top: offsetData.top - top,
        left: offsetData.left - left,
        bottom: offsetData.bottom + bottom,
        right: offsetData.right + right
      }, {
        top: pageY,
        left: pageX
      });
      if (!collides) return;
    }

    var result = this.emit('beforeSelect', this._initialEventData = {
      isTouch: /^touch/.test(e.type),
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
    if (result === false) return;

    switch (e.type) {
      case 'mousedown':
        this._removeEndListener = addEventListener$1('mouseup', this._handleTerminatingEvent);
        this._onEscListener = addEventListener$1('keydown', this._handleTerminatingEvent);
        this._removeMoveListener = addEventListener$1('mousemove', this._handleMoveEvent);
        break;

      case 'touchstart':
        this._handleMoveEvent(e);

        this._removeEndListener = addEventListener$1('touchend', this._handleTerminatingEvent);
        this._removeMoveListener = addEventListener$1('touchmove', this._handleMoveEvent);
        break;
    }
  };

  _proto._handleTerminatingEvent = function _handleTerminatingEvent(e) {
    var _getEventCoordinates4 = getEventCoordinates(e),
        pageX = _getEventCoordinates4.pageX,
        pageY = _getEventCoordinates4.pageY;

    this.selecting = false;
    this._removeEndListener && this._removeEndListener();
    this._removeMoveListener && this._removeMoveListener();
    if (!this._initialEventData) return;
    var inRoot = !this.container || contains(this.container(), e.target);
    var bounds = this._selectRect;
    var click = this.isClick(pageX, pageY);
    this._initialEventData = null;

    if (e.key === 'Escape') {
      return this.emit('reset');
    }

    if (!inRoot) {
      return this.emit('reset');
    }

    if (click && inRoot) {
      return this._handleClickEvent(e);
    } // User drag-clicked in the Selectable area


    if (!click) return this.emit('select', bounds);
  };

  _proto._handleClickEvent = function _handleClickEvent(e) {
    var _getEventCoordinates5 = getEventCoordinates(e),
        pageX = _getEventCoordinates5.pageX,
        pageY = _getEventCoordinates5.pageY,
        clientX = _getEventCoordinates5.clientX,
        clientY = _getEventCoordinates5.clientY;

    var now = new Date().getTime();

    if (this._lastClickData && now - this._lastClickData.timestamp < clickInterval) {
      // Double click event
      this._lastClickData = null;
      return this.emit('doubleClick', {
        x: pageX,
        y: pageY,
        clientX: clientX,
        clientY: clientY
      });
    } // Click event


    this._lastClickData = {
      timestamp: now
    };
    return this.emit('click', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
  };

  _proto._handleMoveEvent = function _handleMoveEvent(e) {
    if (this._initialEventData === null || this.isDetached) {
      return;
    }

    var _this$_initialEventDa = this._initialEventData,
        x = _this$_initialEventDa.x,
        y = _this$_initialEventDa.y;

    var _getEventCoordinates6 = getEventCoordinates(e),
        pageX = _getEventCoordinates6.pageX,
        pageY = _getEventCoordinates6.pageY;

    var w = Math.abs(x - pageX);
    var h = Math.abs(y - pageY);
    var left = Math.min(pageX, x),
        top = Math.min(pageY, y),
        old = this.selecting; // Prevent emitting selectStart event until mouse is moved.
    // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.

    if (this.isClick(pageX, pageY) && !old && !(w || h)) {
      return;
    }

    this.selecting = true;
    this._selectRect = {
      top: top,
      left: left,
      x: pageX,
      y: pageY,
      right: left + w,
      bottom: top + h
    };

    if (!old) {
      this.emit('selectStart', this._initialEventData);
    }

    if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);
    e.preventDefault();
  };

  _proto._keyListener = function _keyListener(e) {
    this.ctrl = e.metaKey || e.ctrlKey;
  };

  _proto.isClick = function isClick(pageX, pageY) {
    var _this$_initialEventDa2 = this._initialEventData,
        x = _this$_initialEventDa2.x,
        y = _this$_initialEventDa2.y,
        isTouch = _this$_initialEventDa2.isTouch;
    return !isTouch && Math.abs(pageX - x) <= clickTolerance && Math.abs(pageY - y) <= clickTolerance;
  };

  return Selection;
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */


function normalizeDistance(distance) {
  if (distance === void 0) {
    distance = 0;
  }

  if (typeof distance !== 'object') distance = {
    top: distance,
    left: distance,
    right: distance,
    bottom: distance
  };
  return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */


function objectsCollide(nodeA, nodeB, tolerance) {
  if (tolerance === void 0) {
    tolerance = 0;
  }

  var _getBoundsForNode = getBoundsForNode(nodeA),
      aTop = _getBoundsForNode.top,
      aLeft = _getBoundsForNode.left,
      _getBoundsForNode$rig = _getBoundsForNode.right,
      aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig,
      _getBoundsForNode$bot = _getBoundsForNode.bottom,
      aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;

  var _getBoundsForNode2 = getBoundsForNode(nodeB),
      bTop = _getBoundsForNode2.top,
      bLeft = _getBoundsForNode2.left,
      _getBoundsForNode2$ri = _getBoundsForNode2.right,
      bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri,
      _getBoundsForNode2$bo = _getBoundsForNode2.bottom,
      bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;

  return !( // 'a' bottom doesn't touch 'b' top
  aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
  aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
  aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
  aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */

function getBoundsForNode(node) {
  if (!node.getBoundingClientRect) return node;
  var rect = node.getBoundingClientRect(),
      left = rect.left + pageOffset('left'),
      top = rect.top + pageOffset('top');
  return {
    top: top,
    left: left,
    right: (node.offsetWidth || 0) + left,
    bottom: (node.offsetHeight || 0) + top
  };
}

function pageOffset(dir) {
  if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
  if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}

var BackgroundCells =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(BackgroundCells, _React$Component);

  function BackgroundCells(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.state = {
      selecting: false
    };
    return _this;
  }

  var _proto = BackgroundCells.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        range = _this$props.range,
        getNow = _this$props.getNow,
        getters = _this$props.getters,
        currentDate = _this$props.date,
        Wrapper = _this$props.components.dateCellWrapper;
    var _this$state = this.state,
        selecting = _this$state.selecting,
        startIdx = _this$state.startIdx,
        endIdx = _this$state.endIdx;
    var current = getNow();
    return React.createElement("div", {
      className: "rbc-row-bg"
    }, range.map(function (date, index) {
      var selected = selecting && index >= startIdx && index <= endIdx;

      var _getters$dayProp = getters.dayProp(date),
          className = _getters$dayProp.className,
          style = _getters$dayProp.style;

      return React.createElement(Wrapper, {
        key: index,
        value: date,
        range: range
      }, React.createElement("div", {
        style: style,
        className: clsx('rbc-day-bg', className, selected && 'rbc-selected-cell', eq(date, current, 'day') && 'rbc-today', currentDate && month(currentDate) !== month(date) && 'rbc-off-range-bg')
      }));
    }));
  };

  _proto._selectable = function _selectable() {
    var _this2 = this;

    var node = findDOMNode(this);
    var selector = this._selector = new Selection(this.props.container, {
      longPressThreshold: this.props.longPressThreshold
    });

    var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
      if (!isEvent(findDOMNode(_this2), point)) {
        var rowBox = getBoundsForNode(node);
        var _this2$props = _this2.props,
            range = _this2$props.range,
            rtl = _this2$props.rtl;

        if (pointInBox(rowBox, point)) {
          var currentCell = getSlotAtX(rowBox, point.x, rtl, range.length);

          _this2._selectSlot({
            startIdx: currentCell,
            endIdx: currentCell,
            action: actionType,
            box: point
          });
        }
      }

      _this2._initial = {};

      _this2.setState({
        selecting: false
      });
    };

    selector.on('selecting', function (box) {
      var _this2$props2 = _this2.props,
          range = _this2$props2.range,
          rtl = _this2$props2.rtl;
      var startIdx = -1;
      var endIdx = -1;

      if (!_this2.state.selecting) {
        notify(_this2.props.onSelectStart, [box]);
        _this2._initial = {
          x: box.x,
          y: box.y
        };
      }

      if (selector.isSelected(node)) {
        var nodeBox = getBoundsForNode(node);

        var _dateCellSelection = dateCellSelection(_this2._initial, nodeBox, box, range.length, rtl);

        startIdx = _dateCellSelection.startIdx;
        endIdx = _dateCellSelection.endIdx;
      }

      _this2.setState({
        selecting: true,
        startIdx: startIdx,
        endIdx: endIdx
      });
    });
    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;
      return !isEvent(findDOMNode(_this2), box);
    });
    selector.on('click', function (point) {
      return selectorClicksHandler(point, 'click');
    });
    selector.on('doubleClick', function (point) {
      return selectorClicksHandler(point, 'doubleClick');
    });
    selector.on('select', function (bounds) {
      _this2._selectSlot(_extends({}, _this2.state, {
        action: 'select',
        bounds: bounds
      }));

      _this2._initial = {};

      _this2.setState({
        selecting: false
      });

      notify(_this2.props.onSelectEnd, [_this2.state]);
    });
  };

  _proto._teardownSelectable = function _teardownSelectable() {
    if (!this._selector) return;

    this._selector.teardown();

    this._selector = null;
  };

  _proto._selectSlot = function _selectSlot(_ref) {
    var endIdx = _ref.endIdx,
        startIdx = _ref.startIdx,
        action = _ref.action,
        bounds = _ref.bounds,
        box = _ref.box;
    if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
      start: startIdx,
      end: endIdx,
      action: action,
      bounds: bounds,
      box: box,
      resourceId: this.props.resourceId
    });
  };

  return BackgroundCells;
}(React.Component);

BackgroundCells.propTypes = process.env.NODE_ENV !== "production" ? {
  date: propTypes.instanceOf(Date),
  getNow: propTypes.func.isRequired,
  getters: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  container: propTypes.func,
  dayPropGetter: propTypes.func,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: propTypes.number,
  onSelectSlot: propTypes.func.isRequired,
  onSelectEnd: propTypes.func,
  onSelectStart: propTypes.func,
  range: propTypes.arrayOf(propTypes.instanceOf(Date)),
  rtl: propTypes.bool,
  type: propTypes.string,
  resourceId: propTypes.any
} : {};

/* eslint-disable react/prop-types */

var EventRowMixin = {
  propTypes: {
    slotMetrics: propTypes.object.isRequired,
    selected: propTypes.object,
    isAllDay: propTypes.bool,
    accessors: propTypes.object.isRequired,
    localizer: propTypes.object.isRequired,
    components: propTypes.object.isRequired,
    getters: propTypes.object.isRequired,
    onSelect: propTypes.func,
    onDoubleClick: propTypes.func,
    onKeyPress: propTypes.func
  },
  defaultProps: {
    segments: [],
    selected: {}
  },
  renderEvent: function renderEvent(props, event) {
    var selected = props.selected,
        _ = props.isAllDay,
        accessors = props.accessors,
        getters = props.getters,
        onSelect = props.onSelect,
        onDoubleClick = props.onDoubleClick,
        onKeyPress = props.onKeyPress,
        localizer = props.localizer,
        slotMetrics = props.slotMetrics,
        components = props.components;
    var continuesPrior = slotMetrics.continuesPrior(event);
    var continuesAfter = slotMetrics.continuesAfter(event);
    return React.createElement(EventCell, {
      event: event,
      getters: getters,
      localizer: localizer,
      accessors: accessors,
      components: components,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      onKeyPress: onKeyPress,
      continuesPrior: continuesPrior,
      continuesAfter: continuesAfter,
      slotStart: slotMetrics.first,
      slotEnd: slotMetrics.last,
      selected: isSelected(event, selected)
    });
  },
  renderSpan: function renderSpan(slots, len, key, content) {
    if (content === void 0) {
      content = ' ';
    }

    var per = Math.abs(len) / slots * 100 + '%';
    return React.createElement("div", {
      key: key,
      className: "rbc-row-segment" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
      ,
      style: {
        WebkitFlexBasis: per,
        flexBasis: per,
        maxWidth: per
      }
    }, content);
  }
};

var EventRow =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EventRow, _React$Component);

  function EventRow() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventRow.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        segments = _this$props.segments,
        slots = _this$props.slotMetrics.slots,
        className = _this$props.className;
    var lastEnd = 1;
    return React.createElement("div", {
      className: clsx(className, 'rbc-row')
    }, segments.reduce(function (row, _ref, li) {
      var event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span;
      var key = '_lvl_' + li;
      var gap = left - lastEnd;
      var content = EventRowMixin.renderEvent(_this.props, event);
      if (gap) row.push(EventRowMixin.renderSpan(slots, gap, key + "_gap"));
      row.push(EventRowMixin.renderSpan(slots, span, key, content));
      lastEnd = right + 1;
      return row;
    }, []));
  };

  return EventRow;
}(React.Component);

EventRow.propTypes = process.env.NODE_ENV !== "production" ? _extends({
  segments: propTypes.array
}, EventRowMixin.propTypes) : {};
EventRow.defaultProps = _extends({}, EventRowMixin.defaultProps);

function endOfRange(dateRange, unit) {
  if (unit === void 0) {
    unit = 'day';
  }

  return {
    first: dateRange[0],
    last: add$1(dateRange[dateRange.length - 1], 1, unit)
  };
}
function eventSegments(event, range, accessors) {
  var _endOfRange = endOfRange(range),
      first = _endOfRange.first,
      last = _endOfRange.last;

  var slots = diff(first, last, 'day');
  var start = max(startOf(accessors.start(event), 'day'), first);
  var end = min(ceil(accessors.end(event), 'day'), last);
  var padding = findIndex$1(range, function (x) {
    return eq(x, start, 'day');
  });
  var span = diff(start, end, 'day');
  span = Math.min(span, slots);
  span = Math.max(span, 1);
  return {
    event: event,
    span: span,
    left: padding + 1,
    right: Math.max(padding + span, 1)
  };
}
function eventLevels(rowSegments, limit) {
  if (limit === void 0) {
    limit = Infinity;
  }

  var i,
      j,
      seg,
      levels = [],
      extra = [];

  for (i = 0; i < rowSegments.length; i++) {
    seg = rowSegments[i];

    for (j = 0; j < levels.length; j++) {
      if (!segsOverlap(seg, levels[j])) break;
    }

    if (j >= limit) {
      extra.push(seg);
    } else {
      (levels[j] || (levels[j] = [])).push(seg);
    }
  }

  for (i = 0; i < levels.length; i++) {
    levels[i].sort(function (a, b) {
      return a.left - b.left;
    }); //eslint-disable-line
  }

  return {
    levels: levels,
    extra: extra
  };
}
function inRange$1(e, start, end, accessors) {
  var eStart = startOf(accessors.start(e), 'day');
  var eEnd = accessors.end(e);
  var startsBeforeEnd = lte(eStart, end, 'day'); // when the event is zero duration we need to handle a bit differently

  var endsAfterStart = !eq(eStart, eEnd, 'minutes') ? gt(eEnd, start, 'minutes') : gte(eEnd, start, 'minutes');
  return startsBeforeEnd && endsAfterStart;
}
function segsOverlap(seg, otherSegs) {
  return otherSegs.some(function (otherSeg) {
    return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
  });
}
function sortEvents(evtA, evtB, accessors) {
  var startSort = +startOf(accessors.start(evtA), 'day') - +startOf(accessors.start(evtB), 'day');
  var durA = diff(accessors.start(evtA), ceil(accessors.end(evtA), 'day'), 'day');
  var durB = diff(accessors.start(evtB), ceil(accessors.end(evtB), 'day'), 'day');
  return startSort || // sort by start Day first
  Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
  !!accessors.allDay(evtB) - !!accessors.allDay(evtA) || // then allDay single day events
  +accessors.start(evtA) - +accessors.start(evtB); // then sort by start time
}

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var eventsInSlot = function eventsInSlot(segments, slot) {
  return segments.filter(function (seg) {
    return isSegmentInSlot(seg, slot);
  }).length;
};

var EventEndingRow =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EventEndingRow, _React$Component);

  function EventEndingRow() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventEndingRow.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        segments = _this$props.segments,
        slots = _this$props.slotMetrics.slots;
    var rowSegments = eventLevels(segments).levels[0];
    var current = 1,
        lastEnd = 1,
        row = [];

    while (current <= slots) {
      var key = '_lvl_' + current;

      var _ref = rowSegments.filter(function (seg) {
        return isSegmentInSlot(seg, current);
      })[0] || {},
          event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span; //eslint-disable-line


      if (!event) {
        current++;
        continue;
      }

      var gap = Math.max(0, left - lastEnd);

      if (this.canRenderSlotEvent(left, span)) {
        var content = EventRowMixin.renderEvent(this.props, event);

        if (gap) {
          row.push(EventRowMixin.renderSpan(slots, gap, key + '_gap'));
        }

        row.push(EventRowMixin.renderSpan(slots, span, key, content));
        lastEnd = current = right + 1;
      } else {
        if (gap) {
          row.push(EventRowMixin.renderSpan(slots, gap, key + '_gap'));
        }

        row.push(EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
        lastEnd = current = current + 1;
      }
    }

    return React.createElement("div", {
      className: "rbc-row"
    }, row);
  };

  _proto.canRenderSlotEvent = function canRenderSlotEvent(slot, span) {
    var segments = this.props.segments;
    return range(slot, slot + span).every(function (s) {
      var count = eventsInSlot(segments, s);
      return count === 1;
    });
  };

  _proto.renderShowMore = function renderShowMore(segments, slot) {
    var _this = this;

    var localizer = this.props.localizer;
    var count = eventsInSlot(segments, slot);
    return count ? React.createElement("a", {
      key: 'sm_' + slot,
      href: "#",
      className: 'rbc-show-more',
      onClick: function onClick(e) {
        return _this.showMore(slot, e);
      }
    }, localizer.messages.showMore(count)) : false;
  };

  _proto.showMore = function showMore(slot, e) {
    e.preventDefault();
    this.props.onShowMore(slot, e.target);
  };

  return EventEndingRow;
}(React.Component);

EventEndingRow.propTypes = process.env.NODE_ENV !== "production" ? _extends({
  segments: propTypes.array,
  slots: propTypes.number,
  onShowMore: propTypes.func
}, EventRowMixin.propTypes) : {};
EventEndingRow.defaultProps = _extends({}, EventRowMixin.defaultProps);

var isSegmentInSlot$1 = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var isEqual = function isEqual(a, b) {
  return a[0].range === b[0].range && a[0].events === b[0].events;
};

function getSlotMetrics() {
  return memoizeOne(function (options) {
    var range = options.range,
        events = options.events,
        maxRows = options.maxRows,
        minRows = options.minRows,
        accessors = options.accessors;

    var _endOfRange = endOfRange(range),
        first = _endOfRange.first,
        last = _endOfRange.last;

    var segments = events.map(function (evt) {
      return eventSegments(evt, range, accessors);
    });

    var _eventLevels = eventLevels(segments, Math.max(maxRows - 1, 1)),
        levels = _eventLevels.levels,
        extra = _eventLevels.extra;

    while (levels.length < minRows) {
      levels.push([]);
    }

    return {
      first: first,
      last: last,
      levels: levels,
      extra: extra,
      range: range,
      slots: range.length,
      clone: function clone(args) {
        var metrics = getSlotMetrics();
        return metrics(_extends({}, options, args));
      },
      getDateForSlot: function getDateForSlot(slotNumber) {
        return range[slotNumber];
      },
      getSlotForDate: function getSlotForDate(date) {
        return range.find(function (r) {
          return eq(r, date, 'day');
        });
      },
      getEventsForSlot: function getEventsForSlot(slot) {
        return segments.filter(function (seg) {
          return isSegmentInSlot$1(seg, slot);
        }).map(function (seg) {
          return seg.event;
        });
      },
      continuesPrior: function continuesPrior(event) {
        return lt(accessors.start(event), first, 'day');
      },
      continuesAfter: function continuesAfter(event) {
        var eventEnd = accessors.end(event);
        var singleDayDuration = eq(accessors.start(event), eventEnd, 'minutes');
        return singleDayDuration ? gte(eventEnd, last, 'minutes') : gt(eventEnd, last, 'minutes');
      }
    };
  }, isEqual);
}

var DateContentRow =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DateContentRow, _React$Component);

  function DateContentRow() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelectSlot = function (slot) {
      var _this$props = _this.props,
          range = _this$props.range,
          onSelectSlot = _this$props.onSelectSlot;
      onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
    };

    _this.handleShowMore = function (slot, target) {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          onShowMore = _this$props2.onShowMore;

      var metrics = _this.slotMetrics(_this.props);

      var row = qsa(findDOMNode(_assertThisInitialized$1(_this)), '.rbc-row-bg')[0];
      var cell;
      if (row) cell = row.children[slot - 1];
      var events = metrics.getEventsForSlot(slot);
      onShowMore(events, range[slot - 1], cell, slot, target);
    };

    _this.createHeadingRef = function (r) {
      _this.headingRow = r;
    };

    _this.createEventRef = function (r) {
      _this.eventRow = r;
    };

    _this.getContainer = function () {
      var container = _this.props.container;
      return container ? container() : findDOMNode(_assertThisInitialized$1(_this));
    };

    _this.renderHeadingCell = function (date, index) {
      var _this$props3 = _this.props,
          renderHeader = _this$props3.renderHeader,
          getNow = _this$props3.getNow;
      return renderHeader({
        date: date,
        key: "header_" + index,
        className: clsx('rbc-date-cell', eq(date, getNow(), 'day') && 'rbc-now')
      });
    };

    _this.renderDummy = function () {
      var _this$props4 = _this.props,
          className = _this$props4.className,
          range = _this$props4.range,
          renderHeader = _this$props4.renderHeader;
      return React.createElement("div", {
        className: className
      }, React.createElement("div", {
        className: "rbc-row-content"
      }, renderHeader && React.createElement("div", {
        className: "rbc-row",
        ref: _this.createHeadingRef
      }, range.map(_this.renderHeadingCell)), React.createElement("div", {
        className: "rbc-row",
        ref: _this.createEventRef
      }, React.createElement("div", {
        className: "rbc-row-segment"
      }, React.createElement("div", {
        className: "rbc-event"
      }, React.createElement("div", {
        className: "rbc-event-content"
      }, "\xA0"))))));
    };

    _this.slotMetrics = getSlotMetrics();
    return _this;
  }

  var _proto = DateContentRow.prototype;

  _proto.getRowLimit = function getRowLimit() {
    var eventHeight = height(this.eventRow);
    var headingHeight = this.headingRow ? height(this.headingRow) : 0;
    var eventSpace = height(findDOMNode(this)) - headingHeight;
    return Math.max(Math.floor(eventSpace / eventHeight), 1);
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        date = _this$props5.date,
        rtl = _this$props5.rtl,
        range = _this$props5.range,
        className = _this$props5.className,
        selected = _this$props5.selected,
        selectable = _this$props5.selectable,
        renderForMeasure = _this$props5.renderForMeasure,
        accessors = _this$props5.accessors,
        getters = _this$props5.getters,
        components = _this$props5.components,
        getNow = _this$props5.getNow,
        renderHeader = _this$props5.renderHeader,
        onSelect = _this$props5.onSelect,
        localizer = _this$props5.localizer,
        onSelectStart = _this$props5.onSelectStart,
        onSelectEnd = _this$props5.onSelectEnd,
        onDoubleClick = _this$props5.onDoubleClick,
        onKeyPress = _this$props5.onKeyPress,
        resourceId = _this$props5.resourceId,
        longPressThreshold = _this$props5.longPressThreshold,
        isAllDay = _this$props5.isAllDay;
    if (renderForMeasure) return this.renderDummy();
    var metrics = this.slotMetrics(this.props);
    var levels = metrics.levels,
        extra = metrics.extra;
    var WeekWrapper = components.weekWrapper;
    var eventRowProps = {
      selected: selected,
      accessors: accessors,
      getters: getters,
      localizer: localizer,
      components: components,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      onKeyPress: onKeyPress,
      resourceId: resourceId,
      slotMetrics: metrics
    };
    return React.createElement("div", {
      className: className
    }, React.createElement(BackgroundCells, {
      date: date,
      getNow: getNow,
      rtl: rtl,
      range: range,
      selectable: selectable,
      container: this.getContainer,
      getters: getters,
      onSelectStart: onSelectStart,
      onSelectEnd: onSelectEnd,
      onSelectSlot: this.handleSelectSlot,
      components: components,
      longPressThreshold: longPressThreshold,
      resourceId: resourceId
    }), React.createElement("div", {
      className: "rbc-row-content"
    }, renderHeader && React.createElement("div", {
      className: "rbc-row ",
      ref: this.createHeadingRef
    }, range.map(this.renderHeadingCell)), React.createElement(WeekWrapper, _extends({
      isAllDay: isAllDay
    }, eventRowProps), levels.map(function (segs, idx) {
      return React.createElement(EventRow, _extends({
        key: idx,
        segments: segs
      }, eventRowProps));
    }), !!extra.length && React.createElement(EventEndingRow, _extends({
      segments: extra,
      onShowMore: this.handleShowMore
    }, eventRowProps)))));
  };

  return DateContentRow;
}(React.Component);

DateContentRow.propTypes = process.env.NODE_ENV !== "production" ? {
  date: propTypes.instanceOf(Date),
  events: propTypes.array.isRequired,
  range: propTypes.array.isRequired,
  rtl: propTypes.bool,
  resourceId: propTypes.any,
  renderForMeasure: propTypes.bool,
  renderHeader: propTypes.func,
  container: propTypes.func,
  selected: propTypes.object,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: propTypes.number,
  onShowMore: propTypes.func,
  onSelectSlot: propTypes.func,
  onSelect: propTypes.func,
  onSelectEnd: propTypes.func,
  onSelectStart: propTypes.func,
  onDoubleClick: propTypes.func,
  onKeyPress: propTypes.func,
  dayPropGetter: propTypes.func,
  getNow: propTypes.func.isRequired,
  isAllDay: propTypes.bool,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired,
  minRows: propTypes.number.isRequired,
  maxRows: propTypes.number.isRequired
} : {};
DateContentRow.defaultProps = {
  minRows: 0,
  maxRows: Infinity
};

var Header$2 = function Header(_ref) {
  var label = _ref.label;
  return React.createElement("span", null, label);
};

Header$2.propTypes = process.env.NODE_ENV !== "production" ? {
  label: propTypes.node
} : {};

var DateHeader = function DateHeader(_ref) {
  var label = _ref.label,
      drilldownView = _ref.drilldownView,
      onDrillDown = _ref.onDrillDown;

  if (!drilldownView) {
    return React.createElement("span", null, label);
  }

  return React.createElement("a", {
    href: "#",
    onClick: onDrillDown
  }, label);
};

DateHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  label: propTypes.node,
  date: propTypes.instanceOf(Date),
  drilldownView: propTypes.string,
  onDrillDown: propTypes.func,
  isOffRange: propTypes.bool
} : {};

var eventsForWeek = function eventsForWeek(evts, start, end, accessors) {
  return evts.filter(function (e) {
    return inRange$1(e, start, end, accessors);
  });
};

var MonthView =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MonthView, _React$Component);

  function MonthView() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.getContainer = function () {
      return findDOMNode(_assertThisInitialized$1(_this));
    };

    _this.renderWeek = function (week, weekIdx) {
      var _this$props = _this.props,
          events = _this$props.events,
          components = _this$props.components,
          selectable = _this$props.selectable,
          getNow = _this$props.getNow,
          selected = _this$props.selected,
          date = _this$props.date,
          localizer = _this$props.localizer,
          longPressThreshold = _this$props.longPressThreshold,
          accessors = _this$props.accessors,
          getters = _this$props.getters;
      var _this$state = _this.state,
          needLimitMeasure = _this$state.needLimitMeasure,
          rowLimit = _this$state.rowLimit;
      events = eventsForWeek(events, week[0], week[week.length - 1], accessors);
      events.sort(function (a, b) {
        return sortEvents(a, b, accessors);
      });
      return React.createElement(DateContentRow, {
        key: weekIdx,
        ref: weekIdx === 0 ? _this.slotRowRef : undefined,
        container: _this.getContainer,
        className: "rbc-month-row",
        getNow: getNow,
        date: date,
        range: week,
        events: events,
        maxRows: rowLimit,
        selected: selected,
        selectable: selectable,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        renderHeader: _this.readerDateHeading,
        renderForMeasure: needLimitMeasure,
        onShowMore: _this.handleShowMore,
        onSelect: _this.handleSelectEvent,
        onDoubleClick: _this.handleDoubleClickEvent,
        onKeyPress: _this.handleKeyPressEvent,
        onSelectSlot: _this.handleSelectSlot,
        longPressThreshold: longPressThreshold,
        rtl: _this.props.rtl
      });
    };

    _this.readerDateHeading = function (_ref) {
      var date = _ref.date,
          className = _ref.className,
          props = _objectWithoutPropertiesLoose(_ref, ["date", "className"]);

      var _this$props2 = _this.props,
          currentDate = _this$props2.date,
          getDrilldownView = _this$props2.getDrilldownView,
          localizer = _this$props2.localizer;
      var isOffRange = month(date) !== month(currentDate);
      var isCurrent = eq(date, currentDate, 'day');
      var drilldownView = getDrilldownView(date);
      var label = localizer.format(date, 'dateFormat');
      var DateHeaderComponent = _this.props.components.dateHeader || DateHeader;
      return React.createElement("div", _extends({}, props, {
        className: clsx(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current')
      }), React.createElement(DateHeaderComponent, {
        label: label,
        date: date,
        drilldownView: drilldownView,
        isOffRange: isOffRange,
        onDrillDown: function onDrillDown(e) {
          return _this.handleHeadingClick(date, drilldownView, e);
        }
      }));
    };

    _this.handleSelectSlot = function (range, slotInfo) {
      _this._pendingSelection = _this._pendingSelection.concat(range);
      clearTimeout(_this._selectTimer);
      _this._selectTimer = setTimeout(function () {
        return _this.selectDates(slotInfo);
      });
    };

    _this.handleHeadingClick = function (date, view, e) {
      e.preventDefault();

      _this.clearSelection();

      notify(_this.props.onDrillDown, [date, view]);
    };

    _this.handleSelectEvent = function () {
      _this.clearSelection();

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      notify(_this.props.onSelectEvent, args);
    };

    _this.handleDoubleClickEvent = function () {
      _this.clearSelection();

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      notify(_this.props.onDoubleClickEvent, args);
    };

    _this.handleKeyPressEvent = function () {
      _this.clearSelection();

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      notify(_this.props.onKeyPressEvent, args);
    };

    _this.handleShowMore = function (events, date, cell, slot, target) {
      var _this$props3 = _this.props,
          popup = _this$props3.popup,
          onDrillDown = _this$props3.onDrillDown,
          onShowMore = _this$props3.onShowMore,
          getDrilldownView = _this$props3.getDrilldownView; //cancel any pending selections so only the event click goes through.

      _this.clearSelection();

      if (popup) {
        var position$1 = position(cell, findDOMNode(_assertThisInitialized$1(_this)));

        _this.setState({
          overlay: {
            date: date,
            events: events,
            position: position$1,
            target: target
          }
        });
      } else {
        notify(onDrillDown, [date, getDrilldownView(date) || views.DAY]);
      }

      notify(onShowMore, [events, date, slot]);
    };

    _this.overlayDisplay = function () {
      _this.setState({
        overlay: null
      });
    };

    _this._bgRows = [];
    _this._pendingSelection = [];
    _this.slotRowRef = React.createRef();
    _this.state = {
      rowLimit: 5,
      needLimitMeasure: true
    };
    return _this;
  }

  var _proto = MonthView.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(_ref2) {
    var date = _ref2.date;
    this.setState({
      needLimitMeasure: !eq(date, this.props.date, 'month')
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var running;
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
    window.addEventListener('resize', this._resizeListener = function () {
      if (!running) {
        request(function () {
          running = false;

          _this2.setState({
            needLimitMeasure: true
          }); //eslint-disable-line

        });
      }
    }, false);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener, false);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        date = _this$props4.date,
        localizer = _this$props4.localizer,
        className = _this$props4.className,
        month = visibleDays(date, localizer),
        weeks = chunk(month, 7);
    this._weekCount = weeks.length;
    return React.createElement("div", {
      className: clsx('rbc-month-view', className)
    }, React.createElement("div", {
      className: "rbc-row rbc-month-header"
    }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
  };

  _proto.renderHeaders = function renderHeaders(row) {
    var _this$props5 = this.props,
        localizer = _this$props5.localizer,
        components = _this$props5.components;
    var first = row[0];
    var last = row[row.length - 1];
    var HeaderComponent = components.header || Header$2;
    return range$1(first, last, 'day').map(function (day, idx) {
      return React.createElement("div", {
        key: 'header_' + idx,
        className: "rbc-header"
      }, React.createElement(HeaderComponent, {
        date: day,
        localizer: localizer,
        label: localizer.format(day, 'weekdayFormat')
      }));
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    var _this3 = this;

    var overlay = this.state && this.state.overlay || {};
    var _this$props6 = this.props,
        accessors = _this$props6.accessors,
        localizer = _this$props6.localizer,
        components = _this$props6.components,
        getters = _this$props6.getters,
        selected = _this$props6.selected,
        popupOffset = _this$props6.popupOffset;
    return React.createElement(Overlay, {
      rootClose: true,
      placement: "bottom",
      show: !!overlay.position,
      onHide: function onHide() {
        return _this3.setState({
          overlay: null
        });
      },
      target: function target() {
        return overlay.target;
      }
    }, function (_ref3) {
      var props = _ref3.props;
      return React.createElement(Popup$1, _extends({}, props, {
        popupOffset: popupOffset,
        accessors: accessors,
        getters: getters,
        selected: selected,
        components: components,
        localizer: localizer,
        position: overlay.position,
        show: _this3.overlayDisplay,
        events: overlay.events,
        slotStart: overlay.date,
        slotEnd: overlay.end,
        onSelect: _this3.handleSelectEvent,
        onDoubleClick: _this3.handleDoubleClickEvent,
        onKeyPress: _this3.handleKeyPressEvent,
        handleDragStart: _this3.props.handleDragStart
      }));
    });
  };

  _proto.measureRowLimit = function measureRowLimit() {
    this.setState({
      needLimitMeasure: false,
      rowLimit: this.slotRowRef.current.getRowLimit()
    });
  };

  _proto.selectDates = function selectDates(slotInfo) {
    var slots = this._pendingSelection.slice();

    this._pendingSelection = [];
    slots.sort(function (a, b) {
      return +a - +b;
    });
    notify(this.props.onSelectSlot, {
      slots: slots,
      start: slots[0],
      end: slots[slots.length - 1],
      action: slotInfo.action,
      bounds: slotInfo.bounds,
      box: slotInfo.box
    });
  };

  _proto.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  return MonthView;
}(React.Component);

MonthView.propTypes = process.env.NODE_ENV !== "production" ? {
  events: propTypes.array.isRequired,
  date: propTypes.instanceOf(Date),
  min: propTypes.instanceOf(Date),
  max: propTypes.instanceOf(Date),
  step: propTypes.number,
  getNow: propTypes.func.isRequired,
  scrollToTime: propTypes.instanceOf(Date),
  rtl: propTypes.bool,
  width: propTypes.number,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired,
  selected: propTypes.object,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: propTypes.number,
  onNavigate: propTypes.func,
  onSelectSlot: propTypes.func,
  onSelectEvent: propTypes.func,
  onDoubleClickEvent: propTypes.func,
  onKeyPressEvent: propTypes.func,
  onShowMore: propTypes.func,
  onDrillDown: propTypes.func,
  getDrilldownView: propTypes.func.isRequired,
  popup: propTypes.bool,
  handleDragStart: propTypes.func,
  popupOffset: propTypes.oneOfType([propTypes.number, propTypes.shape({
    x: propTypes.number,
    y: propTypes.number
  })])
} : {};

MonthView.range = function (date, _ref4) {
  var localizer = _ref4.localizer;
  var start = firstVisibleDay(date, localizer);
  var end = lastVisibleDay(date, localizer);
  return {
    start: start,
    end: end
  };
};

MonthView.navigate = function (date, action) {
  switch (action) {
    case navigate.PREVIOUS:
      return add$1(date, -1, 'month');

    case navigate.NEXT:
      return add$1(date, 1, 'month');

    default:
      return date;
  }
};

MonthView.title = function (date, _ref5) {
  var localizer = _ref5.localizer;
  return localizer.format(date, 'monthHeaderFormat');
};

var getDstOffset = function getDstOffset(start, end) {
  return start.getTimezoneOffset() - end.getTimezoneOffset();
};

var getKey$1 = function getKey(min, max, step, slots) {
  return "" + +startOf(min, 'minutes') + ("" + +startOf(max, 'minutes')) + (step + "-" + slots);
};

function getSlotMetrics$1(_ref) {
  var start = _ref.min,
      end = _ref.max,
      step = _ref.step,
      timeslots = _ref.timeslots;
  var key = getKey$1(start, end, step, timeslots); // if the start is on a DST-changing day but *after* the moment of DST
  // transition we need to add those extra minutes to our minutesFromMidnight

  var daystart = startOf(start, 'day');
  var daystartdstoffset = getDstOffset(daystart, start);
  var totalMin = 1 + diff(start, end, 'minutes') + getDstOffset(start, end);
  var minutesFromMidnight = diff(daystart, start, 'minutes') + daystartdstoffset;
  var numGroups = Math.ceil(totalMin / (step * timeslots));
  var numSlots = numGroups * timeslots;
  var groups = new Array(numGroups);
  var slots = new Array(numSlots); // Each slot date is created from "zero", instead of adding `step` to
  // the previous one, in order to avoid DST oddities

  for (var grp = 0; grp < numGroups; grp++) {
    groups[grp] = new Array(timeslots);

    for (var slot = 0; slot < timeslots; slot++) {
      var slotIdx = grp * timeslots + slot;
      var minFromStart = slotIdx * step; // A date with total minutes calculated from the start of the day

      slots[slotIdx] = groups[grp][slot] = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + minFromStart, 0, 0);
    }
  } // Necessary to be able to select up until the last timeslot in a day


  var lastSlotMinFromStart = slots.length * step;
  slots.push(new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + lastSlotMinFromStart, 0, 0));

  function positionFromDate(date) {
    var diff$1 = diff(start, date, 'minutes') + getDstOffset(start, date);
    return Math.min(diff$1, totalMin);
  }

  return {
    groups: groups,
    update: function update(args) {
      if (getKey$1(args) !== key) return getSlotMetrics$1(args);
      return this;
    },
    dateIsInGroup: function dateIsInGroup(date, groupIndex) {
      var nextGroup = groups[groupIndex + 1];
      return inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
    },
    nextSlot: function nextSlot(slot) {
      var next = slots[Math.min(slots.indexOf(slot) + 1, slots.length - 1)]; // in the case of the last slot we won't a long enough range so manually get it

      if (next === slot) next = add$1(slot, step, 'minutes');
      return next;
    },
    closestSlotToPosition: function closestSlotToPosition(percent) {
      var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
      return slots[slot];
    },
    closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
      var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
      return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
    },
    closestSlotFromDate: function closestSlotFromDate(date, offset) {
      if (offset === void 0) {
        offset = 0;
      }

      if (lt(date, start, 'minutes')) return slots[0];
      var diffMins = diff(start, date, 'minutes');
      return slots[(diffMins - diffMins % step) / step + offset];
    },
    startsBeforeDay: function startsBeforeDay(date) {
      return lt(date, start, 'day');
    },
    startsAfterDay: function startsAfterDay(date) {
      return gt(date, end, 'day');
    },
    startsBefore: function startsBefore(date) {
      return lt(merge(start, date), start, 'minutes');
    },
    startsAfter: function startsAfter(date) {
      return gt(merge(end, date), end, 'minutes');
    },
    getRange: function getRange(rangeStart, rangeEnd, ignoreMin, ignoreMax) {
      if (!ignoreMin) rangeStart = min(end, max(start, rangeStart));
      if (!ignoreMax) rangeEnd = min(end, max(start, rangeEnd));
      var rangeStartMin = positionFromDate(rangeStart);
      var rangeEndMin = positionFromDate(rangeEnd);
      var top = rangeEndMin > step * numSlots && !eq(end, rangeEnd) ? (rangeStartMin - step) / (step * numSlots) * 100 : rangeStartMin / (step * numSlots) * 100;
      return {
        top: top,
        height: rangeEndMin / (step * numSlots) * 100 - top,
        start: positionFromDate(rangeStart),
        startDate: rangeStart,
        end: positionFromDate(rangeEnd),
        endDate: rangeEnd
      };
    },
    getCurrentTimePosition: function getCurrentTimePosition(rangeStart) {
      var rangeStartMin = positionFromDate(rangeStart);
      var top = rangeStartMin / (step * numSlots) * 100;
      return top;
    }
  };
}

var Event$1 =
/*#__PURE__*/
function () {
  function Event(data, _ref) {
    var accessors = _ref.accessors,
        slotMetrics = _ref.slotMetrics;

    var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)),
        start = _slotMetrics$getRange.start,
        startDate = _slotMetrics$getRange.startDate,
        end = _slotMetrics$getRange.end,
        endDate = _slotMetrics$getRange.endDate,
        top = _slotMetrics$getRange.top,
        height = _slotMetrics$getRange.height;

    this.start = start;
    this.end = end;
    this.startMs = +startDate;
    this.endMs = +endDate;
    this.top = top;
    this.height = height;
    this.data = data;
  }
  /**
   * The event's width without any overlap.
   */


  _createClass$1(Event, [{
    key: "_width",
    get: function get() {
      // The container event's width is determined by the maximum number of
      // events in any of its rows.
      if (this.rows) {
        var columns = this.rows.reduce(function (max, row) {
          return Math.max(max, row.leaves.length + 1);
        }, // add itself
        0) + 1; // add the container

        return 100 / columns;
      }

      var availableWidth = 100 - this.container._width; // The row event's width is the space left by the container, divided
      // among itself and its leaves.

      if (this.leaves) {
        return availableWidth / (this.leaves.length + 1);
      } // The leaf event's width is determined by its row's width


      return this.row._width;
    }
    /**
     * The event's calculated width, possibly with extra width added for
     * overlapping effect.
     */

  }, {
    key: "width",
    get: function get() {
      var noOverlap = this._width;
      var overlap = Math.min(100, this._width * 1.7); // Containers can always grow.

      if (this.rows) {
        return overlap;
      } // Rows can grow if they have leaves.


      if (this.leaves) {
        return this.leaves.length > 0 ? overlap : noOverlap;
      } // Leaves can grow unless they're the last item in a row.


      var leaves = this.row.leaves;
      var index = leaves.indexOf(this);
      return index === leaves.length - 1 ? noOverlap : overlap;
    }
  }, {
    key: "xOffset",
    get: function get() {
      // Containers have no offset.
      if (this.rows) return 0; // Rows always start where their container ends.

      if (this.leaves) return this.container._width; // Leaves are spread out evenly on the space left by its row.

      var _this$row = this.row,
          leaves = _this$row.leaves,
          xOffset = _this$row.xOffset,
          _width = _this$row._width;
      var index = leaves.indexOf(this) + 1;
      return xOffset + index * _width;
    }
  }]);

  return Event;
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */


function onSameRow(a, b, minimumStartDifference) {
  return (// Occupies the same start slot.
    Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end
  );
}

function sortByRender(events) {
  var sortedByTime = sortBy(events, ['startMs', function (e) {
    return -e.endMs;
  }]);
  var sorted = [];

  while (sortedByTime.length > 0) {
    var event = sortedByTime.shift();
    sorted.push(event);

    for (var i = 0; i < sortedByTime.length; i++) {
      var test = sortedByTime[i]; // Still inside this event, look for next.

      if (event.endMs > test.startMs) continue; // We've found the first event of the next event group.
      // If that event is not right next to our current event, we have to
      // move it here.

      if (i > 0) {
        var _event = sortedByTime.splice(i, 1)[0];
        sorted.push(_event);
      } // We've already found the next event group, so stop looking.


      break;
    }
  }

  return sorted;
}

function getStyledEvents(_ref2) {
  var events = _ref2.events,
      minimumStartDifference = _ref2.minimumStartDifference,
      slotMetrics = _ref2.slotMetrics,
      accessors = _ref2.accessors;
  // Create proxy events and order them so that we don't have
  // to fiddle with z-indexes.
  var proxies = events.map(function (event) {
    return new Event$1(event, {
      slotMetrics: slotMetrics,
      accessors: accessors
    });
  });
  var eventsInRenderOrder = sortByRender(proxies); // Group overlapping events, while keeping order.
  // Every event is always one of: container, row or leaf.
  // Containers can contain rows, and rows can contain leaves.

  var containerEvents = [];

  var _loop = function _loop(i) {
    var event = eventsInRenderOrder[i]; // Check if this event can go into a container event.

    var container = containerEvents.find(function (c) {
      return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
    }); // Couldn't find a container — that means this event is a container.

    if (!container) {
      event.rows = [];
      containerEvents.push(event);
      return "continue";
    } // Found a container for the event.


    event.container = container; // Check if the event can be placed in an existing row.
    // Start looking from behind.

    var row = null;

    for (var j = container.rows.length - 1; !row && j >= 0; j--) {
      if (onSameRow(container.rows[j], event, minimumStartDifference)) {
        row = container.rows[j];
      }
    }

    if (row) {
      // Found a row, so add it.
      row.leaves.push(event);
      event.row = row;
    } else {
      // Couldn't find a row – that means this event is a row.
      event.leaves = [];
      container.rows.push(event);
    }
  };

  for (var i = 0; i < eventsInRenderOrder.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  } // Return the original events, along with their styles.


  return eventsInRenderOrder.map(function (event) {
    return {
      event: event.data,
      style: {
        top: event.top,
        height: event.height,
        width: event.width,
        xOffset: Math.max(0, event.xOffset)
      }
    };
  });
}

function getMaxIdxDFS(node, maxIdx, visited) {
  for (var i = 0; i < node.friends.length; ++i) {
    if (visited.indexOf(node.friends[i]) > -1) continue;
    maxIdx = maxIdx > node.friends[i].idx ? maxIdx : node.friends[i].idx; // TODO : trace it by not object but kinda index or something for performance

    visited.push(node.friends[i]);
    var newIdx = getMaxIdxDFS(node.friends[i], maxIdx, visited);
    maxIdx = maxIdx > newIdx ? maxIdx : newIdx;
  }

  return maxIdx;
}

function noOverlap (_ref) {
  var events = _ref.events,
      minimumStartDifference = _ref.minimumStartDifference,
      slotMetrics = _ref.slotMetrics,
      accessors = _ref.accessors;
  var styledEvents = getStyledEvents({
    events: events,
    minimumStartDifference: minimumStartDifference,
    slotMetrics: slotMetrics,
    accessors: accessors
  });
  styledEvents.sort(function (a, b) {
    a = a.style;
    b = b.style;
    if (a.top !== b.top) return a.top > b.top ? 1 : -1;else return a.top + a.height < b.top + b.height ? 1 : -1;
  });

  for (var i = 0; i < styledEvents.length; ++i) {
    styledEvents[i].friends = [];
    delete styledEvents[i].style.left;
    delete styledEvents[i].style.left;
    delete styledEvents[i].idx;
    delete styledEvents[i].size;
  }

  for (var _i = 0; _i < styledEvents.length - 1; ++_i) {
    var se1 = styledEvents[_i];
    var y1 = se1.style.top;
    var y2 = se1.style.top + se1.style.height;

    for (var j = _i + 1; j < styledEvents.length; ++j) {
      var se2 = styledEvents[j];
      var y3 = se2.style.top;
      var y4 = se2.style.top + se2.style.height; // be friends when overlapped

      if (y3 <= y1 && y1 < y4 || y1 <= y3 && y3 < y2) {
        // TODO : hashmap would be effective for performance
        se1.friends.push(se2);
        se2.friends.push(se1);
      }
    }
  }

  for (var _i2 = 0; _i2 < styledEvents.length; ++_i2) {
    var se = styledEvents[_i2];
    var bitmap = [];

    for (var _j = 0; _j < 100; ++_j) {
      bitmap.push(1);
    } // 1 means available


    for (var _j2 = 0; _j2 < se.friends.length; ++_j2) {
      if (se.friends[_j2].idx !== undefined) bitmap[se.friends[_j2].idx] = 0;
    } // 0 means reserved


    se.idx = bitmap.indexOf(1);
  }

  for (var _i3 = 0; _i3 < styledEvents.length; ++_i3) {
    var size = 0;
    if (styledEvents[_i3].size) continue;
    var allFriends = [];
    var maxIdx = getMaxIdxDFS(styledEvents[_i3], 0, allFriends);
    size = 100 / (maxIdx + 1);
    styledEvents[_i3].size = size;

    for (var _j3 = 0; _j3 < allFriends.length; ++_j3) {
      allFriends[_j3].size = size;
    }
  }

  for (var _i4 = 0; _i4 < styledEvents.length; ++_i4) {
    var e = styledEvents[_i4];
    e.style.left = e.idx * e.size; // stretch to maximum

    var _maxIdx = 0;

    for (var _j4 = 0; _j4 < e.friends.length; ++_j4) {
      var idx = e.friends[_j4];
      _maxIdx = _maxIdx > idx ? _maxIdx : idx;
    }

    if (_maxIdx <= e.idx) e.size = 100 - e.idx * e.size; // padding between events
    // for this feature, `width` is not percentage based unit anymore
    // it will be used with calc()

    var padding = e.idx === 0 ? 0 : 3;
    e.style.width = "calc(" + e.size + "% - " + padding + "px)";
    e.style.height = "calc(" + e.style.height + "% - 2px)";
    e.style.xOffset = "calc(" + e.style.left + "% + " + padding + "px)";
  }

  return styledEvents;
}

/*eslint no-unused-vars: "off"*/
var DefaultAlgorithms = {
  overlap: getStyledEvents,
  'no-overlap': noOverlap
};

function isFunction$2(a) {
  return !!(a && a.constructor && a.call && a.apply);
} //


function getStyledEvents$1(_ref) {
  var events = _ref.events,
      minimumStartDifference = _ref.minimumStartDifference,
      slotMetrics = _ref.slotMetrics,
      accessors = _ref.accessors,
      dayLayoutAlgorithm = _ref.dayLayoutAlgorithm;
  var algorithm = dayLayoutAlgorithm;
  if (dayLayoutAlgorithm in DefaultAlgorithms) algorithm = DefaultAlgorithms[dayLayoutAlgorithm];

  if (!isFunction$2(algorithm)) {
    // invalid algorithm
    return [];
  }

  return algorithm.apply(this, arguments);
}

var TimeSlotGroup =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TimeSlotGroup, _Component);

  function TimeSlotGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TimeSlotGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        renderSlot = _this$props.renderSlot,
        resource = _this$props.resource,
        group = _this$props.group,
        getters = _this$props.getters,
        _this$props$component = _this$props.components;
    _this$props$component = _this$props$component === void 0 ? {} : _this$props$component;
    var _this$props$component2 = _this$props$component.timeSlotWrapper,
        Wrapper = _this$props$component2 === void 0 ? NoopWrapper : _this$props$component2;
    var groupProps = getters ? getters.slotGroupProp() : {};
    return React.createElement("div", _extends({
      className: "rbc-timeslot-group"
    }, groupProps), group.map(function (value, idx) {
      var slotProps = getters ? getters.slotProp(value, resource) : {};
      return React.createElement(Wrapper, {
        key: idx,
        value: value,
        resource: resource
      }, React.createElement("div", _extends({}, slotProps, {
        className: clsx('rbc-time-slot', slotProps.className)
      }), renderSlot && renderSlot(value, idx)));
    }));
  };

  return TimeSlotGroup;
}(Component);
TimeSlotGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  renderSlot: propTypes.func,
  group: propTypes.array.isRequired,
  resource: propTypes.any,
  components: propTypes.object,
  getters: propTypes.object
} : {};

function stringifyPercent(v) {
  return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */


function TimeGridEvent(props) {
  var _extends2;

  var style = props.style,
      className = props.className,
      event = props.event,
      accessors = props.accessors,
      rtl = props.rtl,
      selected = props.selected,
      label = props.label,
      continuesEarlier = props.continuesEarlier,
      continuesLater = props.continuesLater,
      getters = props.getters,
      onClick = props.onClick,
      onDoubleClick = props.onDoubleClick,
      onKeyPress = props.onKeyPress,
      _props$components = props.components,
      Event = _props$components.event,
      EventWrapper = _props$components.eventWrapper;
  var title = accessors.title(event);
  var tooltip = accessors.tooltip(event);
  var end = accessors.end(event);
  var start = accessors.start(event);
  var userProps = getters.eventProp(event, start, end, selected);
  var height = style.height,
      top = style.top,
      width = style.width,
      xOffset = style.xOffset;
  var inner = [React.createElement("div", {
    key: "1",
    className: "rbc-event-label"
  }, label), React.createElement("div", {
    key: "2",
    className: "rbc-event-content"
  }, Event ? React.createElement(Event, {
    event: event,
    title: title
  }) : title)];
  return React.createElement(EventWrapper, _extends({
    type: "time"
  }, props), React.createElement("div", {
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    onKeyPress: onKeyPress,
    style: _extends({}, userProps.style, (_extends2 = {
      top: stringifyPercent(top)
    }, _extends2[rtl ? 'right' : 'left'] = stringifyPercent(xOffset), _extends2.width = stringifyPercent(width), _extends2.height = stringifyPercent(height), _extends2)),
    title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
    className: clsx('rbc-event', className, userProps.className, {
      'rbc-selected': selected,
      'rbc-event-continues-earlier': continuesEarlier,
      'rbc-event-continues-later': continuesLater
    })
  }, inner));
}

var DayColumn =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DayColumn, _React$Component);

  function DayColumn() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = {
      selecting: false,
      timeIndicatorPosition: null
    };
    _this.intervalTriggered = false;

    _this.renderEvents = function () {
      var _this$props = _this.props,
          events = _this$props.events,
          rtl = _this$props.rtl,
          selected = _this$props.selected,
          accessors = _this$props.accessors,
          localizer = _this$props.localizer,
          getters = _this$props.getters,
          components = _this$props.components,
          step = _this$props.step,
          timeslots = _this$props.timeslots,
          dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm;

      var _assertThisInitialize = _assertThisInitialized$1(_this),
          slotMetrics = _assertThisInitialize.slotMetrics;

      var messages = localizer.messages;
      var styledEvents = getStyledEvents$1({
        events: events,
        accessors: accessors,
        slotMetrics: slotMetrics,
        minimumStartDifference: Math.ceil(step * timeslots / 2),
        dayLayoutAlgorithm: dayLayoutAlgorithm
      });
      return styledEvents.map(function (_ref, idx) {
        var event = _ref.event,
            style = _ref.style;
        var end = accessors.end(event);
        var start = accessors.start(event);
        var format = 'eventTimeRangeFormat';
        var label;
        var startsBeforeDay = slotMetrics.startsBeforeDay(start);
        var startsAfterDay = slotMetrics.startsAfterDay(end);
        if (startsBeforeDay) format = 'eventTimeRangeEndFormat';else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
        if (startsBeforeDay && startsAfterDay) label = messages.allDay;else label = localizer.format({
          start: start,
          end: end
        }, format);
        var continuesEarlier = startsBeforeDay || slotMetrics.startsBefore(start);
        var continuesLater = startsAfterDay || slotMetrics.startsAfter(end);
        return React.createElement(TimeGridEvent, {
          style: style,
          event: event,
          label: label,
          key: 'evt_' + idx,
          getters: getters,
          rtl: rtl,
          components: components,
          continuesEarlier: continuesEarlier,
          continuesLater: continuesLater,
          accessors: accessors,
          selected: isSelected(event, selected),
          onClick: function onClick(e) {
            return _this._select(event, e);
          },
          onDoubleClick: function onDoubleClick(e) {
            return _this._doubleClick(event, e);
          },
          onKeyPress: function onKeyPress(e) {
            return _this._keyPress(event, e);
          }
        });
      });
    };

    _this._selectable = function () {
      var node = findDOMNode(_assertThisInitialized$1(_this));
      var selector = _this._selector = new Selection(function () {
        return findDOMNode(_assertThisInitialized$1(_this));
      }, {
        longPressThreshold: _this.props.longPressThreshold
      });

      var maybeSelect = function maybeSelect(box) {
        var onSelecting = _this.props.onSelecting;
        var current = _this.state || {};
        var state = selectionState(box);
        var start = state.startDate,
            end = state.endDate;

        if (onSelecting) {
          if (eq(current.startDate, start, 'minutes') && eq(current.endDate, end, 'minutes') || onSelecting({
            start: start,
            end: end,
            resourceId: _this.props.resource
          }) === false) return;
        }

        if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) {
          _this.setState(state);
        }
      };

      var selectionState = function selectionState(point) {
        var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, getBoundsForNode(node));

        if (!_this.state.selecting) {
          _this._initialSlot = currentSlot;
        }

        var initialSlot = _this._initialSlot;

        if (lte(initialSlot, currentSlot)) {
          currentSlot = _this.slotMetrics.nextSlot(currentSlot);
        } else if (gt(initialSlot, currentSlot)) {
          initialSlot = _this.slotMetrics.nextSlot(initialSlot);
        }

        var selectRange = _this.slotMetrics.getRange(min(initialSlot, currentSlot), max(initialSlot, currentSlot));

        return _extends({}, selectRange, {
          selecting: true,
          top: selectRange.top + "%",
          height: selectRange.height + "%"
        });
      };

      var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
        if (!isEvent(findDOMNode(_assertThisInitialized$1(_this)), box)) {
          var _selectionState = selectionState(box),
              startDate = _selectionState.startDate,
              endDate = _selectionState.endDate;

          _this._selectSlot({
            startDate: startDate,
            endDate: endDate,
            action: actionType,
            box: box
          });
        }

        _this.setState({
          selecting: false
        });
      };

      selector.on('selecting', maybeSelect);
      selector.on('selectStart', maybeSelect);
      selector.on('beforeSelect', function (box) {
        if (_this.props.selectable !== 'ignoreEvents') return;
        return !isEvent(findDOMNode(_assertThisInitialized$1(_this)), box);
      });
      selector.on('click', function (box) {
        return selectorClicksHandler(box, 'click');
      });
      selector.on('doubleClick', function (box) {
        return selectorClicksHandler(box, 'doubleClick');
      });
      selector.on('select', function (bounds) {
        if (_this.state.selecting) {
          _this._selectSlot(_extends({}, _this.state, {
            action: 'select',
            bounds: bounds
          }));

          _this.setState({
            selecting: false
          });
        }
      });
      selector.on('reset', function () {
        if (_this.state.selecting) {
          _this.setState({
            selecting: false
          });
        }
      });
    };

    _this._teardownSelectable = function () {
      if (!_this._selector) return;

      _this._selector.teardown();

      _this._selector = null;
    };

    _this._selectSlot = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate,
          action = _ref2.action,
          bounds = _ref2.bounds,
          box = _ref2.box;
      var current = startDate,
          slots = [];

      while (lte(current, endDate)) {
        slots.push(current);
        current = new Date(+current + _this.props.step * 60 * 1000); // using Date ensures not to create an endless loop the day DST begins
      }

      notify(_this.props.onSelectSlot, {
        slots: slots,
        start: startDate,
        end: endDate,
        resourceId: _this.props.resource,
        action: action,
        bounds: bounds,
        box: box
      });
    };

    _this._select = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      notify(_this.props.onSelectEvent, args);
    };

    _this._doubleClick = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      notify(_this.props.onDoubleClickEvent, args);
    };

    _this._keyPress = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      notify(_this.props.onKeyPressEvent, args);
    };

    _this.slotMetrics = getSlotMetrics$1(_this.props);
    return _this;
  }

  var _proto = DayColumn.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();

    if (this.props.isNow) {
      this.setTimeIndicatorPositionUpdateInterval();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();

    this.clearTimeIndicatorInterval();
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
    this.slotMetrics = this.slotMetrics.update(nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var getNowChanged = !eq(prevProps.getNow(), this.props.getNow(), 'minutes');

    if (prevProps.isNow !== this.props.isNow || getNowChanged) {
      this.clearTimeIndicatorInterval();

      if (this.props.isNow) {
        var tail = !getNowChanged && eq(prevProps.date, this.props.date, 'minutes') && prevState.timeIndicatorPosition === this.state.timeIndicatorPosition;
        this.setTimeIndicatorPositionUpdateInterval(tail);
      }
    } else if (this.props.isNow && (!eq(prevProps.min, this.props.min, 'minutes') || !eq(prevProps.max, this.props.max, 'minutes'))) {
      this.positionTimeIndicator();
    }
  }
  /**
   * @param tail {Boolean} - whether `positionTimeIndicator` call should be
   *   deferred or called upon setting interval (`true` - if deferred);
   */
  ;

  _proto.setTimeIndicatorPositionUpdateInterval = function setTimeIndicatorPositionUpdateInterval(tail) {
    var _this2 = this;

    if (tail === void 0) {
      tail = false;
    }

    if (!this.intervalTriggered && !tail) {
      this.positionTimeIndicator();
    }

    this._timeIndicatorTimeout = window.setTimeout(function () {
      _this2.intervalTriggered = true;

      _this2.positionTimeIndicator();

      _this2.setTimeIndicatorPositionUpdateInterval();
    }, 60000);
  };

  _proto.clearTimeIndicatorInterval = function clearTimeIndicatorInterval() {
    this.intervalTriggered = false;
    window.clearTimeout(this._timeIndicatorTimeout);
  };

  _proto.positionTimeIndicator = function positionTimeIndicator() {
    var _this$props2 = this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        getNow = _this$props2.getNow;
    var current = getNow();

    if (current >= min && current <= max) {
      var top = this.slotMetrics.getCurrentTimePosition(current);
      this.intervalTriggered = true;
      this.setState({
        timeIndicatorPosition: top
      });
    } else {
      this.clearTimeIndicatorInterval();
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        max = _this$props3.max,
        rtl = _this$props3.rtl,
        isNow = _this$props3.isNow,
        resource = _this$props3.resource,
        accessors = _this$props3.accessors,
        localizer = _this$props3.localizer,
        _this$props3$getters = _this$props3.getters,
        dayProp = _this$props3$getters.dayProp,
        getters = _objectWithoutPropertiesLoose(_this$props3$getters, ["dayProp"]),
        _this$props3$componen = _this$props3.components,
        EventContainer = _this$props3$componen.eventContainerWrapper,
        components = _objectWithoutPropertiesLoose(_this$props3$componen, ["eventContainerWrapper"]);

    var slotMetrics = this.slotMetrics;
    var _this$state = this.state,
        selecting = _this$state.selecting,
        top = _this$state.top,
        height = _this$state.height,
        startDate = _this$state.startDate,
        endDate = _this$state.endDate;
    var selectDates = {
      start: startDate,
      end: endDate
    };

    var _dayProp = dayProp(max),
        className = _dayProp.className,
        style = _dayProp.style;

    return React.createElement("div", {
      style: style,
      className: clsx(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', // WHY
      selecting && 'rbc-slot-selecting')
    }, slotMetrics.groups.map(function (grp, idx) {
      return React.createElement(TimeSlotGroup, {
        key: idx,
        group: grp,
        resource: resource,
        getters: getters,
        components: components
      });
    }), React.createElement(EventContainer, {
      localizer: localizer,
      resource: resource,
      accessors: accessors,
      getters: getters,
      components: components,
      slotMetrics: slotMetrics
    }, React.createElement("div", {
      className: clsx('rbc-events-container', rtl && 'rtl')
    }, this.renderEvents())), selecting && React.createElement("div", {
      className: "rbc-slot-selection",
      style: {
        top: top,
        height: height
      }
    }, React.createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && this.intervalTriggered && React.createElement("div", {
      className: "rbc-current-time-indicator",
      style: {
        top: this.state.timeIndicatorPosition + "%"
      }
    }));
  };

  return DayColumn;
}(React.Component);

DayColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  events: propTypes.array.isRequired,
  step: propTypes.number.isRequired,
  date: propTypes.instanceOf(Date).isRequired,
  min: propTypes.instanceOf(Date).isRequired,
  max: propTypes.instanceOf(Date).isRequired,
  getNow: propTypes.func.isRequired,
  isNow: propTypes.bool,
  rtl: propTypes.bool,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired,
  showMultiDayTimes: propTypes.bool,
  culture: propTypes.string,
  timeslots: propTypes.number,
  selected: propTypes.object,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  eventOffset: propTypes.number,
  longPressThreshold: propTypes.number,
  onSelecting: propTypes.func,
  onSelectSlot: propTypes.func.isRequired,
  onSelectEvent: propTypes.func.isRequired,
  onDoubleClickEvent: propTypes.func.isRequired,
  onKeyPressEvent: propTypes.func,
  className: propTypes.string,
  dragThroughEvents: propTypes.bool,
  resource: propTypes.any,
  dayLayoutAlgorithm: DayLayoutAlgorithmPropType
} : {};
DayColumn.defaultProps = {
  dragThroughEvents: true,
  timeslots: 2
};

var TimeGutter =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TimeGutter, _Component);

  function TimeGutter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.renderSlot = function (value, idx) {
      if (idx !== 0) return null;
      var _this$props = _this.props,
          localizer = _this$props.localizer,
          getNow = _this$props.getNow;

      var isNow = _this.slotMetrics.dateIsInGroup(getNow(), idx);

      return React.createElement("span", {
        className: clsx('rbc-label', isNow && 'rbc-now')
      }, localizer.format(value, 'timeGutterFormat'));
    };

    var _this$props2 = _this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        timeslots = _this$props2.timeslots,
        step = _this$props2.step;
    _this.slotMetrics = getSlotMetrics$1({
      min: min,
      max: max,
      timeslots: timeslots,
      step: step
    });
    return _this;
  }

  var _proto = TimeGutter.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var min = nextProps.min,
        max = nextProps.max,
        timeslots = nextProps.timeslots,
        step = nextProps.step;
    this.slotMetrics = this.slotMetrics.update({
      min: min,
      max: max,
      timeslots: timeslots,
      step: step
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        resource = _this$props3.resource,
        components = _this$props3.components,
        getters = _this$props3.getters;
    return React.createElement("div", {
      className: "rbc-time-gutter rbc-time-column"
    }, this.slotMetrics.groups.map(function (grp, idx) {
      return React.createElement(TimeSlotGroup, {
        key: idx,
        group: grp,
        resource: resource,
        components: components,
        renderSlot: _this2.renderSlot,
        getters: getters
      });
    }));
  };

  return TimeGutter;
}(Component);
TimeGutter.propTypes = process.env.NODE_ENV !== "production" ? {
  min: propTypes.instanceOf(Date).isRequired,
  max: propTypes.instanceOf(Date).isRequired,
  timeslots: propTypes.number.isRequired,
  step: propTypes.number.isRequired,
  getNow: propTypes.func.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object,
  localizer: propTypes.object.isRequired,
  resource: propTypes.string
} : {};

var ResourceHeader = function ResourceHeader(_ref) {
  var label = _ref.label;
  return React.createElement(React.Fragment, null, label);
};

ResourceHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  label: propTypes.node,
  index: propTypes.number,
  resource: propTypes.object
} : {};

var TimeGridHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TimeGridHeader, _React$Component);

  function TimeGridHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleHeaderClick = function (date, view, e) {
      e.preventDefault();
      notify(_this.props.onDrillDown, [date, view]);
    };

    _this.renderRow = function (resource) {
      var _this$props = _this.props,
          events = _this$props.events,
          rtl = _this$props.rtl,
          selectable = _this$props.selectable,
          getNow = _this$props.getNow,
          range = _this$props.range,
          getters = _this$props.getters,
          localizer = _this$props.localizer,
          accessors = _this$props.accessors,
          components = _this$props.components;
      var resourceId = accessors.resourceId(resource);
      var eventsToDisplay = resource ? events.filter(function (event) {
        return accessors.resource(event) === resourceId;
      }) : events;
      return React.createElement(DateContentRow, {
        isAllDay: true,
        rtl: rtl,
        getNow: getNow,
        minRows: 2,
        range: range,
        events: eventsToDisplay,
        resourceId: resourceId,
        className: "rbc-allday-cell",
        selectable: selectable,
        selected: _this.props.selected,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        onSelect: _this.props.onSelectEvent,
        onDoubleClick: _this.props.onDoubleClickEvent,
        onKeyPress: _this.props.onKeyPressEvent,
        onSelectSlot: _this.props.onSelectSlot,
        longPressThreshold: _this.props.longPressThreshold
      });
    };

    return _this;
  }

  var _proto = TimeGridHeader.prototype;

  _proto.renderHeaderCells = function renderHeaderCells(range) {
    var _this2 = this;

    var _this$props2 = this.props,
        localizer = _this$props2.localizer,
        getDrilldownView = _this$props2.getDrilldownView,
        getNow = _this$props2.getNow,
        dayProp = _this$props2.getters.dayProp,
        _this$props2$componen = _this$props2.components.header,
        HeaderComponent = _this$props2$componen === void 0 ? Header$2 : _this$props2$componen;
    var today = getNow();
    return range.map(function (date, i) {
      var drilldownView = getDrilldownView(date);
      var label = localizer.format(date, 'dayFormat');

      var _dayProp = dayProp(date),
          className = _dayProp.className,
          style = _dayProp.style;

      var header = React.createElement(HeaderComponent, {
        date: date,
        label: label,
        localizer: localizer
      });
      return React.createElement("div", {
        key: i,
        style: style,
        className: clsx('rbc-header', className, eq(date, today, 'day') && 'rbc-today')
      }, drilldownView ? React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          return _this2.handleHeaderClick(date, drilldownView, e);
        }
      }, header) : React.createElement("span", null, header));
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        width = _this$props3.width,
        rtl = _this$props3.rtl,
        resources = _this$props3.resources,
        range = _this$props3.range,
        events = _this$props3.events,
        getNow = _this$props3.getNow,
        accessors = _this$props3.accessors,
        selectable = _this$props3.selectable,
        components = _this$props3.components,
        getters = _this$props3.getters,
        scrollRef = _this$props3.scrollRef,
        localizer = _this$props3.localizer,
        isOverflowing = _this$props3.isOverflowing,
        _this$props3$componen = _this$props3.components,
        TimeGutterHeader = _this$props3$componen.timeGutterHeader,
        _this$props3$componen2 = _this$props3$componen.resourceHeader,
        ResourceHeaderComponent = _this$props3$componen2 === void 0 ? ResourceHeader : _this$props3$componen2;
    var style = {};

    if (isOverflowing) {
      style[rtl ? 'marginLeft' : 'marginRight'] = scrollbarSize() + "px";
    }

    var groupedEvents = resources.groupEvents(events);
    return React.createElement("div", {
      style: style,
      ref: scrollRef,
      className: clsx('rbc-time-header', isOverflowing && 'rbc-overflowing')
    }, React.createElement("div", {
      className: "rbc-label rbc-time-header-gutter",
      style: {
        width: width,
        minWidth: width,
        maxWidth: width
      }
    }, TimeGutterHeader && React.createElement(TimeGutterHeader, null)), resources.map(function (_ref, idx) {
      var id = _ref[0],
          resource = _ref[1];
      return React.createElement("div", {
        className: "rbc-time-header-content",
        key: id || idx
      }, resource && React.createElement("div", {
        className: "rbc-row rbc-row-resource",
        key: "resource_" + idx
      }, React.createElement("div", {
        className: "rbc-header"
      }, React.createElement(ResourceHeaderComponent, {
        index: idx,
        label: accessors.resourceTitle(resource),
        resource: resource
      }))), React.createElement("div", {
        className: "rbc-row rbc-time-header-cell" + (range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
      }, _this3.renderHeaderCells(range)), React.createElement(DateContentRow, {
        isAllDay: true,
        rtl: rtl,
        getNow: getNow,
        minRows: 2,
        range: range,
        events: groupedEvents.get(id) || [],
        resourceId: resource && id,
        className: "rbc-allday-cell",
        selectable: selectable,
        selected: _this3.props.selected,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        onSelect: _this3.props.onSelectEvent,
        onDoubleClick: _this3.props.onDoubleClickEvent,
        onKeyPress: _this3.props.onKeyPressEvent,
        onSelectSlot: _this3.props.onSelectSlot,
        longPressThreshold: _this3.props.longPressThreshold
      }));
    }));
  };

  return TimeGridHeader;
}(React.Component);

TimeGridHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  range: propTypes.array.isRequired,
  events: propTypes.array.isRequired,
  resources: propTypes.object,
  getNow: propTypes.func.isRequired,
  isOverflowing: propTypes.bool,
  rtl: propTypes.bool,
  width: propTypes.number,
  localizer: propTypes.object.isRequired,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  selected: propTypes.object,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: propTypes.number,
  onSelectSlot: propTypes.func,
  onSelectEvent: propTypes.func,
  onDoubleClickEvent: propTypes.func,
  onKeyPressEvent: propTypes.func,
  onDrillDown: propTypes.func,
  getDrilldownView: propTypes.func.isRequired,
  scrollRef: propTypes.any
} : {};

var NONE = {};
function Resources(resources, accessors) {
  return {
    map: function map(fn) {
      if (!resources) return [fn([NONE, null], 0)];
      return resources.map(function (resource, idx) {
        return fn([accessors.resourceId(resource), resource], idx);
      });
    },
    groupEvents: function groupEvents(events) {
      var eventsByResource = new Map();

      if (!resources) {
        // Return all events if resources are not provided
        eventsByResource.set(NONE, events);
        return eventsByResource;
      }

      events.forEach(function (event) {
        var id = accessors.resource(event) || NONE;
        var resourceEvents = eventsByResource.get(id) || [];
        resourceEvents.push(event);
        eventsByResource.set(id, resourceEvents);
      });
      return eventsByResource;
    }
  };
}

var TimeGrid =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TimeGrid, _Component);

  function TimeGrid(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleScroll = function (e) {
      if (_this.scrollRef.current) {
        _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    };

    _this.handleResize = function () {
      cancel(_this.rafHandle);
      _this.rafHandle = request(_this.checkOverflow);
    };

    _this.gutterRef = function (ref) {
      _this.gutter = ref && findDOMNode(ref);
    };

    _this.handleSelectAlldayEvent = function () {
      //cancel any pending selections so only the event click goes through.
      _this.clearSelection();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      notify(_this.props.onSelectEvent, args);
    };

    _this.handleSelectAllDaySlot = function (slots, slotInfo) {
      var onSelectSlot = _this.props.onSelectSlot;
      notify(onSelectSlot, {
        slots: slots,
        start: slots[0],
        end: slots[slots.length - 1],
        action: slotInfo.action,
        resourceId: slotInfo.resourceId
      });
    };

    _this.checkOverflow = function () {
      if (_this._updatingOverflow) return;
      var content = _this.contentRef.current;
      var isOverflowing = content.scrollHeight > content.clientHeight;

      if (_this.state.isOverflowing !== isOverflowing) {
        _this._updatingOverflow = true;

        _this.setState({
          isOverflowing: isOverflowing
        }, function () {
          _this._updatingOverflow = false;
        });
      }
    };

    _this.memoizedResources = memoizeOne(function (resources, accessors) {
      return Resources(resources, accessors);
    });
    _this.state = {
      gutterWidth: undefined,
      isOverflowing: null
    };
    _this.scrollRef = React.createRef();
    _this.contentRef = React.createRef();
    _this._scrollRatio = null;
    return _this;
  }

  var _proto = TimeGrid.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this.calculateScroll();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.checkOverflow();

    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll();
    window.addEventListener('resize', this.handleResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    cancel(this.rafHandle);

    if (this.measureGutterAnimationFrameRequest) {
      window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll(); //this.checkOverflow()
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        range = _this$props.range,
        scrollToTime = _this$props.scrollToTime; // When paginating, reset scroll

    if (!eq(nextProps.range[0], range[0], 'minute') || !eq(nextProps.scrollToTime, scrollToTime, 'minute')) {
      this.calculateScroll(nextProps);
    }
  };

  _proto.renderEvents = function renderEvents(range, events, now) {
    var _this2 = this;

    var _this$props2 = this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        components = _this$props2.components,
        accessors = _this$props2.accessors,
        localizer = _this$props2.localizer,
        dayLayoutAlgorithm = _this$props2.dayLayoutAlgorithm;
    var resources = this.memoizedResources(this.props.resources, accessors);
    var groupedEvents = resources.groupEvents(events);
    return resources.map(function (_ref, i) {
      var id = _ref[0],
          resource = _ref[1];
      return range.map(function (date, jj) {
        var daysEvents = (groupedEvents.get(id) || []).filter(function (event) {
          return inRange(date, accessors.start(event), accessors.end(event), 'day');
        });
        return React.createElement(DayColumn, _extends({}, _this2.props, {
          localizer: localizer,
          min: merge(date, min),
          max: merge(date, max),
          resource: resource && id,
          components: components,
          isNow: eq(date, now, 'day'),
          key: i + '-' + jj,
          date: date,
          events: daysEvents,
          dayLayoutAlgorithm: dayLayoutAlgorithm
        }));
      });
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        events = _this$props3.events,
        range = _this$props3.range,
        width = _this$props3.width,
        rtl = _this$props3.rtl,
        selected = _this$props3.selected,
        getNow = _this$props3.getNow,
        resources = _this$props3.resources,
        components = _this$props3.components,
        accessors = _this$props3.accessors,
        getters = _this$props3.getters,
        localizer = _this$props3.localizer,
        min = _this$props3.min,
        max = _this$props3.max,
        showMultiDayTimes = _this$props3.showMultiDayTimes,
        longPressThreshold = _this$props3.longPressThreshold;
    width = width || this.state.gutterWidth;
    var start = range[0],
        end = range[range.length - 1];
    this.slots = range.length;
    var allDayEvents = [],
        rangeEvents = [];
    events.forEach(function (event) {
      if (inRange$1(event, start, end, accessors)) {
        var eStart = accessors.start(event),
            eEnd = accessors.end(event);

        if (accessors.allDay(event) || isJustDate(eStart) && isJustDate(eEnd) || !showMultiDayTimes && !eq(eStart, eEnd, 'day')) {
          allDayEvents.push(event);
        } else {
          rangeEvents.push(event);
        }
      }
    });
    allDayEvents.sort(function (a, b) {
      return sortEvents(a, b, accessors);
    });
    return React.createElement("div", {
      className: clsx('rbc-time-view', resources && 'rbc-time-view-resources')
    }, React.createElement(TimeGridHeader, {
      range: range,
      events: allDayEvents,
      width: width,
      rtl: rtl,
      getNow: getNow,
      localizer: localizer,
      selected: selected,
      resources: this.memoizedResources(resources, accessors),
      selectable: this.props.selectable,
      accessors: accessors,
      getters: getters,
      components: components,
      scrollRef: this.scrollRef,
      isOverflowing: this.state.isOverflowing,
      longPressThreshold: longPressThreshold,
      onSelectSlot: this.handleSelectAllDaySlot,
      onSelectEvent: this.handleSelectAlldayEvent,
      onDoubleClickEvent: this.props.onDoubleClickEvent,
      onKeyPressEvent: this.props.onKeyPressEvent,
      onDrillDown: this.props.onDrillDown,
      getDrilldownView: this.props.getDrilldownView
    }), React.createElement("div", {
      ref: this.contentRef,
      className: "rbc-time-content",
      onScroll: this.handleScroll
    }, React.createElement(TimeGutter, {
      date: start,
      ref: this.gutterRef,
      localizer: localizer,
      min: merge(start, min),
      max: merge(start, max),
      step: this.props.step,
      getNow: this.props.getNow,
      timeslots: this.props.timeslots,
      components: components,
      className: "rbc-time-gutter",
      getters: getters
    }), this.renderEvents(range, rangeEvents, getNow())));
  };

  _proto.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  _proto.measureGutter = function measureGutter() {
    var _this3 = this;

    if (this.measureGutterAnimationFrameRequest) {
      window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
    }

    this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(function () {
      var width = getWidth(_this3.gutter);

      if (width && _this3.state.gutterWidth !== width) {
        _this3.setState({
          gutterWidth: width
        });
      }
    });
  };

  _proto.applyScroll = function applyScroll() {
    if (this._scrollRatio != null) {
      var content = this.contentRef.current;
      content.scrollTop = content.scrollHeight * this._scrollRatio; // Only do this once

      this._scrollRatio = null;
    }
  };

  _proto.calculateScroll = function calculateScroll(props) {
    if (props === void 0) {
      props = this.props;
    }

    var _props = props,
        min = _props.min,
        max = _props.max,
        scrollToTime = _props.scrollToTime;
    var diffMillis = scrollToTime - startOf(scrollToTime, 'day');
    var totalMillis = diff(max, min);
    this._scrollRatio = diffMillis / totalMillis;
  };

  return TimeGrid;
}(Component);
TimeGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  events: propTypes.array.isRequired,
  resources: propTypes.array,
  step: propTypes.number,
  timeslots: propTypes.number,
  range: propTypes.arrayOf(propTypes.instanceOf(Date)),
  min: propTypes.instanceOf(Date),
  max: propTypes.instanceOf(Date),
  getNow: propTypes.func.isRequired,
  scrollToTime: propTypes.instanceOf(Date),
  showMultiDayTimes: propTypes.bool,
  rtl: propTypes.bool,
  width: propTypes.number,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired,
  selected: propTypes.object,
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: propTypes.number,
  onNavigate: propTypes.func,
  onSelectSlot: propTypes.func,
  onSelectEnd: propTypes.func,
  onSelectStart: propTypes.func,
  onSelectEvent: propTypes.func,
  onDoubleClickEvent: propTypes.func,
  onKeyPressEvent: propTypes.func,
  onDrillDown: propTypes.func,
  getDrilldownView: propTypes.func.isRequired,
  dayLayoutAlgorithm: DayLayoutAlgorithmPropType
} : {};
TimeGrid.defaultProps = {
  step: 30,
  timeslots: 2,
  min: startOf(new Date(), 'day'),
  max: endOf(new Date(), 'day'),
  scrollToTime: startOf(new Date(), 'day')
};

var Day =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Day, _React$Component);

  function Day() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Day.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = _objectWithoutPropertiesLoose(_this$props, ["date"]);

    var range = Day.range(date);
    return React.createElement(TimeGrid, _extends({}, props, {
      range: range,
      eventOffset: 10
    }));
  };

  return Day;
}(React.Component);

Day.propTypes = process.env.NODE_ENV !== "production" ? {
  date: propTypes.instanceOf(Date).isRequired
} : {};

Day.range = function (date) {
  return [startOf(date, 'day')];
};

Day.navigate = function (date, action) {
  switch (action) {
    case navigate.PREVIOUS:
      return add$1(date, -1, 'day');

    case navigate.NEXT:
      return add$1(date, 1, 'day');

    default:
      return date;
  }
};

Day.title = function (date, _ref) {
  var localizer = _ref.localizer;
  return localizer.format(date, 'dayHeaderFormat');
};

var Week =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Week, _React$Component);

  function Week() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Week.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = _objectWithoutPropertiesLoose(_this$props, ["date"]);

    var range = Week.range(date, this.props);
    return React.createElement(TimeGrid, _extends({}, props, {
      range: range,
      eventOffset: 15
    }));
  };

  return Week;
}(React.Component);

Week.propTypes = process.env.NODE_ENV !== "production" ? {
  date: propTypes.instanceOf(Date).isRequired
} : {};
Week.defaultProps = TimeGrid.defaultProps;

Week.navigate = function (date, action) {
  switch (action) {
    case navigate.PREVIOUS:
      return add$1(date, -1, 'week');

    case navigate.NEXT:
      return add$1(date, 1, 'week');

    default:
      return date;
  }
};

Week.range = function (date, _ref) {
  var localizer = _ref.localizer;
  var firstOfWeek = localizer.startOfWeek();
  var start = startOf(date, 'week', firstOfWeek);
  var end = endOf(date, 'week', firstOfWeek);
  return range$1(start, end);
};

Week.title = function (date, _ref2) {
  var localizer = _ref2.localizer;

  var _Week$range = Week.range(date, {
    localizer: localizer
  }),
      start = _Week$range[0],
      rest = _Week$range.slice(1);

  return localizer.format({
    start: start,
    end: rest.pop()
  }, 'dayRangeHeaderFormat');
};

function workWeekRange(date, options) {
  return Week.range(date, options).filter(function (d) {
    return [6, 0].indexOf(d.getDay()) === -1;
  });
}

var WorkWeek =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(WorkWeek, _React$Component);

  function WorkWeek() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WorkWeek.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = _objectWithoutPropertiesLoose(_this$props, ["date"]);

    var range = workWeekRange(date, this.props);
    return React.createElement(TimeGrid, _extends({}, props, {
      range: range,
      eventOffset: 15
    }));
  };

  return WorkWeek;
}(React.Component);

WorkWeek.propTypes = process.env.NODE_ENV !== "production" ? {
  date: propTypes.instanceOf(Date).isRequired
} : {};
WorkWeek.defaultProps = TimeGrid.defaultProps;
WorkWeek.range = workWeekRange;
WorkWeek.navigate = Week.navigate;

WorkWeek.title = function (date, _ref) {
  var localizer = _ref.localizer;

  var _workWeekRange = workWeekRange(date, {
    localizer: localizer
  }),
      start = _workWeekRange[0],
      rest = _workWeekRange.slice(1);

  return localizer.format({
    start: start,
    end: rest.pop()
  }, 'dayRangeHeaderFormat');
};

function Agenda(_ref) {
  var selected = _ref.selected,
      getters = _ref.getters,
      accessors = _ref.accessors,
      localizer = _ref.localizer,
      components = _ref.components,
      length = _ref.length,
      date = _ref.date,
      events = _ref.events;
  var headerRef = useRef(null);
  var dateColRef = useRef(null);
  var timeColRef = useRef(null);
  var contentRef = useRef(null);
  var tbodyRef = useRef(null);
  useEffect(function () {
    _adjustHeader();
  });

  var renderDay = function renderDay(day, events, dayKey) {
    var Event = components.event,
        AgendaDate = components.date;
    events = events.filter(function (e) {
      return inRange$1(e, startOf(day, 'day'), endOf(day, 'day'), accessors);
    });
    return events.map(function (event, idx) {
      var title = accessors.title(event);
      var end = accessors.end(event);
      var start = accessors.start(event);
      var userProps = getters.eventProp(event, start, end, isSelected(event, selected));
      var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
      var first = idx === 0 ? React.createElement("td", {
        rowSpan: events.length,
        className: "rbc-agenda-date-cell"
      }, AgendaDate ? React.createElement(AgendaDate, {
        day: day,
        label: dateLabel
      }) : dateLabel) : false;
      return React.createElement("tr", {
        key: dayKey + '_' + idx,
        className: userProps.className,
        style: userProps.style
      }, first, React.createElement("td", {
        className: "rbc-agenda-time-cell"
      }, timeRangeLabel(day, event)), React.createElement("td", {
        className: "rbc-agenda-event-cell"
      }, Event ? React.createElement(Event, {
        event: event,
        title: title
      }) : title));
    }, []);
  };

  var timeRangeLabel = function timeRangeLabel(day, event) {
    var labelClass = '',
        TimeComponent = components.time,
        label = localizer.messages.allDay;
    var end = accessors.end(event);
    var start = accessors.start(event);

    if (!accessors.allDay(event)) {
      if (eq(start, end)) {
        label = localizer.format(start, 'agendaTimeFormat');
      } else if (eq(start, end, 'day')) {
        label = localizer.format({
          start: start,
          end: end
        }, 'agendaTimeRangeFormat');
      } else if (eq(day, start, 'day')) {
        label = localizer.format(start, 'agendaTimeFormat');
      } else if (eq(day, end, 'day')) {
        label = localizer.format(end, 'agendaTimeFormat');
      }
    }

    if (gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
    if (lt(day, end, 'day')) labelClass += ' rbc-continues-after';
    return React.createElement("span", {
      className: labelClass.trim()
    }, TimeComponent ? React.createElement(TimeComponent, {
      event: event,
      day: day,
      label: label
    }) : label);
  };

  var _adjustHeader = function _adjustHeader() {
    if (!tbodyRef.current) return;
    var header = headerRef.current;
    var firstRow = tbodyRef.current.firstChild;
    if (!firstRow) return;
    var isOverflowing = contentRef.current.scrollHeight > contentRef.current.clientHeight;
    var _widths = [];
    var widths = _widths;
    _widths = [getWidth(firstRow.children[0]), getWidth(firstRow.children[1])];

    if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
      dateColRef.current.style.width = _widths[0] + 'px';
      timeColRef.current.style.width = _widths[1] + 'px';
    }

    if (isOverflowing) {
      addClass(header, 'rbc-header-overflowing');
      header.style.marginRight = scrollbarSize() + 'px';
    } else {
      removeClass(header, 'rbc-header-overflowing');
    }
  };

  var messages = localizer.messages;
  var end = add$1(date, length, 'day');
  var range$1$1 = range$1(date, end, 'day');
  events = events.filter(function (event) {
    return inRange$1(event, date, end, accessors);
  });
  events.sort(function (a, b) {
    return +accessors.start(a) - +accessors.start(b);
  });
  return React.createElement("div", {
    className: "rbc-agenda-view"
  }, events.length !== 0 ? React.createElement(React.Fragment, null, React.createElement("table", {
    ref: headerRef,
    className: "rbc-agenda-table"
  }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", {
    className: "rbc-header",
    ref: dateColRef
  }, messages.date), React.createElement("th", {
    className: "rbc-header",
    ref: timeColRef
  }, messages.time), React.createElement("th", {
    className: "rbc-header"
  }, messages.event)))), React.createElement("div", {
    className: "rbc-agenda-content",
    ref: contentRef
  }, React.createElement("table", {
    className: "rbc-agenda-table"
  }, React.createElement("tbody", {
    ref: tbodyRef
  }, range$1$1.map(function (day, idx) {
    return renderDay(day, events, idx);
  }))))) : React.createElement("span", {
    className: "rbc-agenda-empty"
  }, messages.noEventsInRange));
}

Agenda.propTypes = process.env.NODE_ENV !== "production" ? {
  events: propTypes.array,
  date: propTypes.instanceOf(Date),
  length: propTypes.number.isRequired,
  selected: propTypes.object,
  accessors: propTypes.object.isRequired,
  components: propTypes.object.isRequired,
  getters: propTypes.object.isRequired,
  localizer: propTypes.object.isRequired
} : {};
Agenda.defaultProps = {
  length: 30
};

Agenda.range = function (start, _ref2) {
  var _ref2$length = _ref2.length,
      length = _ref2$length === void 0 ? Agenda.defaultProps.length : _ref2$length;
  var end = add$1(start, length, 'day');
  return {
    start: start,
    end: end
  };
};

Agenda.navigate = function (date, action, _ref3) {
  var _ref3$length = _ref3.length,
      length = _ref3$length === void 0 ? Agenda.defaultProps.length : _ref3$length;

  switch (action) {
    case navigate.PREVIOUS:
      return add$1(date, -length, 'day');

    case navigate.NEXT:
      return add$1(date, length, 'day');

    default:
      return date;
  }
};

Agenda.title = function (start, _ref4) {
  var _ref4$length = _ref4.length,
      length = _ref4$length === void 0 ? Agenda.defaultProps.length : _ref4$length,
      localizer = _ref4.localizer;
  var end = add$1(start, length, 'day');
  return localizer.format({
    start: start,
    end: end
  }, 'agendaHeaderFormat');
};

var _VIEWS;
var VIEWS = (_VIEWS = {}, _VIEWS[views.MONTH] = MonthView, _VIEWS[views.WEEK] = Week, _VIEWS[views.WORK_WEEK] = WorkWeek, _VIEWS[views.DAY] = Day, _VIEWS[views.AGENDA] = Agenda, _VIEWS);

function moveDate(View, _ref) {
  var action = _ref.action,
      date = _ref.date,
      today = _ref.today,
      props = _objectWithoutPropertiesLoose(_ref, ["action", "date", "today"]);

  View = typeof View === 'string' ? VIEWS[View] : View;

  switch (action) {
    case navigate.TODAY:
      date = today || new Date();
      break;

    case navigate.DATE:
      break;

    default:
      !(View && typeof View.navigate === 'function') ? process.env.NODE_ENV !== "production" ? invariant_1(false, 'Calendar View components must implement a static `.navigate(date, action)` method.s') : invariant_1(false) : void 0;
      date = View.navigate(date, action, props);
  }

  return date;
}

var Toolbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Toolbar, _React$Component);

  function Toolbar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.navigate = function (action) {
      _this.props.onNavigate(action);
    };

    _this.view = function (view) {
      _this.props.onView(view);
    };

    return _this;
  }

  var _proto = Toolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        messages = _this$props.localizer.messages,
        label = _this$props.label;
    return React.createElement("div", {
      className: "rbc-toolbar"
    }, React.createElement("span", {
      className: "rbc-btn-group"
    }, React.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, navigate.TODAY)
    }, messages.today), React.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, navigate.PREVIOUS)
    }, messages.previous), React.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, navigate.NEXT)
    }, messages.next)), React.createElement("span", {
      className: "rbc-toolbar-label"
    }, label), React.createElement("span", {
      className: "rbc-btn-group"
    }, this.viewNamesGroup(messages)));
  };

  _proto.viewNamesGroup = function viewNamesGroup(messages) {
    var _this2 = this;

    var viewNames = this.props.views;
    var view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(function (name) {
        return React.createElement("button", {
          type: "button",
          key: name,
          className: clsx({
            'rbc-active': view === name
          }),
          onClick: _this2.view.bind(null, name)
        }, messages[name]);
      });
    }
  };

  return Toolbar;
}(React.Component);

Toolbar.propTypes = process.env.NODE_ENV !== "production" ? {
  view: propTypes.string.isRequired,
  views: propTypes.arrayOf(propTypes.string).isRequired,
  label: propTypes.node.isRequired,
  localizer: propTypes.object,
  onNavigate: propTypes.func.isRequired,
  onView: propTypes.func.isRequired
} : {};

/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */
function accessor$1(data, field) {
  var value = null;
  if (typeof field === 'function') value = field(data);else if (typeof field === 'string' && typeof data === 'object' && data != null && field in data) value = data[field];
  return value;
}
var wrapAccessor = function wrapAccessor(acc) {
  return function (data) {
    return accessor$1(data, acc);
  };
};

function viewNames$1(_views) {
  return !Array.isArray(_views) ? Object.keys(_views) : _views;
}

function isValidView(view, _ref) {
  var _views = _ref.views;
  var names = viewNames$1(_views);
  return names.indexOf(view) !== -1;
}
/**
 * react-big-calendar is a full featured Calendar component for managing events and dates. It uses
 * modern `flexbox` for layout, making it super responsive and performant. Leaving most of the layout heavy lifting
 * to the browser. __note:__ The default styles use `height: 100%` which means your container must set an explicit
 * height (feel free to adjust the styles to suit your specific needs).
 *
 * Big Calendar is unopiniated about editing and moving events, preferring to let you implement it in a way that makes
 * the most sense to your app. It also tries not to be prescriptive about your event data structures, just tell it
 * how to find the start and end datetimes and you can pass it whatever you want.
 *
 * One thing to note is that, `react-big-calendar` treats event start/end dates as an _exclusive_ range.
 * which means that the event spans up to, but not including, the end date. In the case
 * of displaying events on whole days, end dates are rounded _up_ to the next day. So an
 * event ending on `Apr 8th 12:00:00 am` will not appear on the 8th, whereas one ending
 * on `Apr 8th 12:01:00 am` will. If you want _inclusive_ ranges consider providing a
 * function `endAccessor` that returns the end date + 1 day for those events that end at midnight.
 */


var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Calendar, _React$Component);

  function Calendar() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.getViews = function () {
      var views = _this.props.views;

      if (Array.isArray(views)) {
        return transform(views, function (obj, name) {
          return obj[name] = VIEWS[name];
        }, {});
      }

      if (typeof views === 'object') {
        return mapValues(views, function (value, key) {
          if (value === true) {
            return VIEWS[key];
          }

          return value;
        });
      }

      return VIEWS;
    };

    _this.getView = function () {
      var views = _this.getViews();

      return views[_this.props.view];
    };

    _this.getDrilldownView = function (date) {
      var _this$props = _this.props,
          view = _this$props.view,
          drilldownView = _this$props.drilldownView,
          getDrilldownView = _this$props.getDrilldownView;
      if (!getDrilldownView) return drilldownView;
      return getDrilldownView(date, view, Object.keys(_this.getViews()));
    };

    _this.handleRangeChange = function (date, viewComponent, view) {
      var _this$props2 = _this.props,
          onRangeChange = _this$props2.onRangeChange,
          localizer = _this$props2.localizer;

      if (onRangeChange) {
        if (viewComponent.range) {
          onRangeChange(viewComponent.range(date, {
            localizer: localizer
          }), view);
        } else {
          if (process.env.NODE_ENV !== 'production') {
            console.error('onRangeChange prop not supported for this view');
          }
        }
      }
    };

    _this.handleNavigate = function (action, newDate) {
      var _this$props3 = _this.props,
          view = _this$props3.view,
          date = _this$props3.date,
          getNow = _this$props3.getNow,
          onNavigate = _this$props3.onNavigate,
          props = _objectWithoutPropertiesLoose(_this$props3, ["view", "date", "getNow", "onNavigate"]);

      var ViewComponent = _this.getView();

      var today = getNow();
      date = moveDate(ViewComponent, _extends({}, props, {
        action: action,
        date: newDate || date || today,
        today: today
      }));
      onNavigate(date, view, action);

      _this.handleRangeChange(date, ViewComponent);
    };

    _this.handleViewChange = function (view) {
      if (view !== _this.props.view && isValidView(view, _this.props)) {
        _this.props.onView(view);
      }

      var views = _this.getViews();

      _this.handleRangeChange(_this.props.date || _this.props.getNow(), views[view], view);
    };

    _this.handleSelectEvent = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      notify(_this.props.onSelectEvent, args);
    };

    _this.handleDoubleClickEvent = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      notify(_this.props.onDoubleClickEvent, args);
    };

    _this.handleKeyPressEvent = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      notify(_this.props.onKeyPressEvent, args);
    };

    _this.handleSelectSlot = function (slotInfo) {
      notify(_this.props.onSelectSlot, slotInfo);
    };

    _this.handleDrillDown = function (date, view) {
      var onDrillDown = _this.props.onDrillDown;

      if (onDrillDown) {
        onDrillDown(date, view, _this.drilldownView);
        return;
      }

      if (view) _this.handleViewChange(view);

      _this.handleNavigate(navigate.DATE, date);
    };

    _this.state = {
      context: _this.getContext(_this.props)
    };
    return _this;
  }

  var _proto = Calendar.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      context: this.getContext(nextProps)
    });
  };

  _proto.getContext = function getContext(_ref2) {
    var startAccessor = _ref2.startAccessor,
        endAccessor = _ref2.endAccessor,
        allDayAccessor = _ref2.allDayAccessor,
        tooltipAccessor = _ref2.tooltipAccessor,
        titleAccessor = _ref2.titleAccessor,
        resourceAccessor = _ref2.resourceAccessor,
        resourceIdAccessor = _ref2.resourceIdAccessor,
        resourceTitleAccessor = _ref2.resourceTitleAccessor,
        eventPropGetter = _ref2.eventPropGetter,
        slotPropGetter = _ref2.slotPropGetter,
        slotGroupPropGetter = _ref2.slotGroupPropGetter,
        dayPropGetter = _ref2.dayPropGetter,
        view = _ref2.view,
        views = _ref2.views,
        localizer = _ref2.localizer,
        culture = _ref2.culture,
        _ref2$messages = _ref2.messages,
        messages$1 = _ref2$messages === void 0 ? {} : _ref2$messages,
        _ref2$components = _ref2.components,
        components = _ref2$components === void 0 ? {} : _ref2$components,
        _ref2$formats = _ref2.formats,
        formats = _ref2$formats === void 0 ? {} : _ref2$formats;
    var names = viewNames$1(views);
    var msgs = messages(messages$1);
    return {
      viewNames: names,
      localizer: mergeWithDefaults(localizer, culture, formats, msgs),
      getters: {
        eventProp: function eventProp() {
          return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
        },
        slotProp: function slotProp() {
          return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
        },
        slotGroupProp: function slotGroupProp() {
          return slotGroupPropGetter && slotGroupPropGetter.apply(void 0, arguments) || {};
        },
        dayProp: function dayProp() {
          return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
        }
      },
      components: defaults$1(components[view] || {}, omit(components, names), {
        eventWrapper: NoopWrapper,
        eventContainerWrapper: NoopWrapper,
        dateCellWrapper: NoopWrapper,
        weekWrapper: NoopWrapper,
        timeSlotWrapper: NoopWrapper
      }),
      accessors: {
        start: wrapAccessor(startAccessor),
        end: wrapAccessor(endAccessor),
        allDay: wrapAccessor(allDayAccessor),
        tooltip: wrapAccessor(tooltipAccessor),
        title: wrapAccessor(titleAccessor),
        resource: wrapAccessor(resourceAccessor),
        resourceId: wrapAccessor(resourceIdAccessor),
        resourceTitle: wrapAccessor(resourceTitleAccessor)
      }
    };
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        view = _this$props4.view,
        toolbar = _this$props4.toolbar,
        events = _this$props4.events,
        style = _this$props4.style,
        className = _this$props4.className,
        elementProps = _this$props4.elementProps,
        current = _this$props4.date,
        getNow = _this$props4.getNow,
        length = _this$props4.length,
        showMultiDayTimes = _this$props4.showMultiDayTimes,
        onShowMore = _this$props4.onShowMore,
        _0 = _this$props4.components,
        _1 = _this$props4.formats,
        _2 = _this$props4.messages,
        _3 = _this$props4.culture,
        props = _objectWithoutPropertiesLoose(_this$props4, ["view", "toolbar", "events", "style", "className", "elementProps", "date", "getNow", "length", "showMultiDayTimes", "onShowMore", "components", "formats", "messages", "culture"]);

    current = current || getNow();
    var View = this.getView();
    var _this$state$context = this.state.context,
        accessors = _this$state$context.accessors,
        components = _this$state$context.components,
        getters = _this$state$context.getters,
        localizer = _this$state$context.localizer,
        viewNames = _this$state$context.viewNames;
    var CalToolbar = components.toolbar || Toolbar;
    var label = View.title(current, {
      localizer: localizer,
      length: length
    });
    return React.createElement("div", _extends({}, elementProps, {
      className: clsx(className, 'rbc-calendar', props.rtl && 'rbc-rtl'),
      style: style
    }), toolbar && React.createElement(CalToolbar, {
      date: current,
      view: view,
      views: viewNames,
      label: label,
      onView: this.handleViewChange,
      onNavigate: this.handleNavigate,
      localizer: localizer
    }), React.createElement(View, _extends({}, props, {
      events: events,
      date: current,
      getNow: getNow,
      length: length,
      localizer: localizer,
      getters: getters,
      components: components,
      accessors: accessors,
      showMultiDayTimes: showMultiDayTimes,
      getDrilldownView: this.getDrilldownView,
      onNavigate: this.handleNavigate,
      onDrillDown: this.handleDrillDown,
      onSelectEvent: this.handleSelectEvent,
      onDoubleClickEvent: this.handleDoubleClickEvent,
      onKeyPressEvent: this.handleKeyPressEvent,
      onSelectSlot: this.handleSelectSlot,
      onShowMore: onShowMore
    })));
  }
  /**
   *
   * @param date
   * @param viewComponent
   * @param {'month'|'week'|'work_week'|'day'|'agenda'} [view] - optional
   * parameter. It appears when range change on view changing. It could be handy
   * when you need to have both: range and view type at once, i.e. for manage rbc
   * state via url
   */
  ;

  return Calendar;
}(React.Component);

Calendar.defaultProps = {
  elementProps: {},
  popup: false,
  toolbar: true,
  view: views.MONTH,
  views: [views.MONTH, views.WEEK, views.DAY, views.AGENDA],
  step: 30,
  length: 30,
  drilldownView: views.DAY,
  titleAccessor: 'title',
  tooltipAccessor: 'title',
  allDayAccessor: 'allDay',
  startAccessor: 'start',
  endAccessor: 'end',
  resourceAccessor: 'resourceId',
  resourceIdAccessor: 'id',
  resourceTitleAccessor: 'title',
  longPressThreshold: 250,
  getNow: function getNow() {
    return new Date();
  },
  dayLayoutAlgorithm: 'overlap'
};
Calendar.propTypes = process.env.NODE_ENV !== "production" ? {
  localizer: propTypes.object.isRequired,

  /**
   * Props passed to main calendar `<div>`.
   *
   */
  elementProps: propTypes.object,

  /**
   * The current date value of the calendar. Determines the visible view range.
   * If `date` is omitted then the result of `getNow` is used; otherwise the
   * current date is used.
   *
   * @controllable onNavigate
   */
  date: propTypes.instanceOf(Date),

  /**
   * The current view of the calendar.
   *
   * @default 'month'
   * @controllable onView
   */
  view: propTypes.string,

  /**
   * The initial view set for the Calendar.
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @default 'month'
   */
  defaultView: propTypes.string,

  /**
   * An array of event objects to display on the calendar. Events objects
   * can be any shape, as long as the Calendar knows how to retrieve the
   * following details of the event:
   *
   *  - start time
   *  - end time
   *  - title
   *  - whether its an "all day" event or not
   *  - any resource the event may be related to
   *
   * Each of these properties can be customized or generated dynamically by
   * setting the various "accessor" props. Without any configuration the default
   * event should look like:
   *
   * ```js
   * Event {
   *   title: string,
   *   start: Date,
   *   end: Date,
   *   allDay?: boolean
   *   resource?: any,
   * }
   * ```
   */
  events: propTypes.arrayOf(propTypes.object),

  /**
   * Accessor for the event title, used to display event information. Should
   * resolve to a `renderable` value.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  titleAccessor: accessor,

  /**
   * Accessor for the event tooltip. Should
   * resolve to a `renderable` value. Removes the tooltip if null.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  tooltipAccessor: accessor,

  /**
   * Determines whether the event should be considered an "all day" event and ignore time.
   * Must resolve to a `boolean` value.
   *
   * ```js
   * string | (event: Object) => boolean
   * ```
   *
   * @type {(func|string)}
   */
  allDayAccessor: accessor,

  /**
   * The start date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  startAccessor: accessor,

  /**
   * The end date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  endAccessor: accessor,

  /**
   * Returns the id of the `resource` that the event is a member of. This
   * id should match at least one resource in the `resources` array.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  resourceAccessor: accessor,

  /**
   * An array of resource objects that map events to a specific resource.
   * Resource objects, like events, can be any shape or have any properties,
   * but should be uniquly identifiable via the `resourceIdAccessor`, as
   * well as a "title" or name as provided by the `resourceTitleAccessor` prop.
   */
  resources: propTypes.arrayOf(propTypes.object),

  /**
   * Provides a unique identifier for each resource in the `resources` array
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceIdAccessor: accessor,

  /**
   * Provides a human readable name for the resource object, used in headers.
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceTitleAccessor: accessor,

  /**
   * Determines the current date/time which is highlighted in the views.
   *
   * The value affects which day is shaded and which time is shown as
   * the current time. It also affects the date used by the Today button in
   * the toolbar.
   *
   * Providing a value here can be useful when you are implementing time zones
   * using the `startAccessor` and `endAccessor` properties.
   *
   * @type {func}
   * @default () => new Date()
   */
  getNow: propTypes.func,

  /**
   * Callback fired when the `date` value changes.
   *
   * @controllable date
   */
  onNavigate: propTypes.func,

  /**
   * Callback fired when the `view` value changes.
   *
   * @controllable view
   */
  onView: propTypes.func,

  /**
   * Callback fired when date header, or the truncated events links are clicked
   *
   */
  onDrillDown: propTypes.func,

  /**
   *
   * ```js
   * (dates: Date[] | { start: Date; end: Date }, view: 'month'|'week'|'work_week'|'day'|'agenda'|undefined) => void
   * ```
   *
   * Callback fired when the visible date range changes. Returns an Array of dates
   * or an object with start and end dates for BUILTIN views. Optionally new `view`
   * will be returned when callback called after view change.
   *
   * Custom views may return something different.
   */
  onRangeChange: propTypes.func,

  /**
   * A callback fired when a date selection is made. Only fires when `selectable` is `true`.
   *
   * ```js
   * (
   *   slotInfo: {
   *     start: Date,
   *     end: Date,
   *     resourceId:  (number|string),
   *     slots: Array<Date>,
   *     action: "select" | "click" | "doubleClick",
   *     bounds: ?{ // For "select" action
   *       x: number,
   *       y: number,
   *       top: number,
   *       right: number,
   *       left: number,
   *       bottom: number,
   *     },
   *     box: ?{ // For "click" or "doubleClick" actions
   *       clientX: number,
   *       clientY: number,
   *       x: number,
   *       y: number,
   *     },
   *   }
   * ) => any
   * ```
   */
  onSelectSlot: propTypes.func,

  /**
   * Callback fired when a calendar event is selected.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => any
   * ```
   *
   * @controllable selected
   */
  onSelectEvent: propTypes.func,

  /**
   * Callback fired when a calendar event is clicked twice.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => void
   * ```
   */
  onDoubleClickEvent: propTypes.func,

  /**
   * Callback fired when a focused calendar event recieves a key press.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => void
   * ```
   */
  onKeyPressEvent: propTypes.func,

  /**
   * Callback fired when dragging a selection in the Time views.
   *
   * Returning `false` from the handler will prevent a selection.
   *
   * ```js
   * (range: { start: Date, end: Date, resourceId: (number|string) }) => ?boolean
   * ```
   */
  onSelecting: propTypes.func,

  /**
   * Callback fired when a +{count} more is clicked
   *
   * ```js
   * (events: Object, date: Date) => any
   * ```
   */
  onShowMore: propTypes.func,

  /**
   * The selected event, if any.
   */
  selected: propTypes.object,

  /**
   * An array of built-in view names to allow the calendar to display.
   * accepts either an array of builtin view names,
   *
   * ```jsx
   * views={['month', 'day', 'agenda']}
   * ```
   * or an object hash of the view name and the component (or boolean for builtin).
   *
   * ```jsx
   * views={{
   *   month: true,
   *   week: false,
   *   myweek: WorkWeekViewComponent,
   * }}
   * ```
   *
   * Custom views can be any React component, that implements the following
   * interface:
   *
   * ```js
   * interface View {
   *   static title(date: Date, { formats: DateFormat[], culture: string?, ...props }): string
   *   static navigate(date: Date, action: 'PREV' | 'NEXT' | 'DATE'): Date
   * }
   * ```
   *
   * @type Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @View
   ['month', 'week', 'day', 'agenda']
   */
  views: views$1,

  /**
   * The string name of the destination view for drill-down actions, such
   * as clicking a date header, or the truncated events links. If
   * `getDrilldownView` is also specified it will be used instead.
   *
   * Set to `null` to disable drill-down actions.
   *
   * ```js
   * <Calendar
   *   drilldownView="agenda"
   * />
   * ```
   */
  drilldownView: propTypes.string,

  /**
   * Functionally equivalent to `drilldownView`, but accepts a function
   * that can return a view name. It's useful for customizing the drill-down
   * actions depending on the target date and triggering view.
   *
   * Return `null` to disable drill-down actions.
   *
   * ```js
   * <Calendar
   *   getDrilldownView={(targetDate, currentViewName, configuredViewNames) =>
   *     if (currentViewName === 'month' && configuredViewNames.includes('week'))
   *       return 'week'
   *
   *     return null;
   *   }}
   * />
   * ```
   */
  getDrilldownView: propTypes.func,

  /**
   * Determines the end date from date prop in the agenda view
   * date prop + length (in number of days) = end date
   */
  length: propTypes.number,

  /**
   * Determines whether the toolbar is displayed
   */
  toolbar: propTypes.bool,

  /**
   * Show truncated events in an overlay when you click the "+_x_ more" link.
   */
  popup: propTypes.bool,

  /**
   * Distance in pixels, from the edges of the viewport, the "show more" overlay should be positioned.
   *
   * ```jsx
   * <Calendar popupOffset={30}/>
   * <Calendar popupOffset={{x: 30, y: 20}}/>
   * ```
   */
  popupOffset: propTypes.oneOfType([propTypes.number, propTypes.shape({
    x: propTypes.number,
    y: propTypes.number
  })]),

  /**
   * Allows mouse selection of ranges of dates/times.
   *
   * The 'ignoreEvents' option prevents selection code from running when a
   * drag begins over an event. Useful when you want custom event click or drag
   * logic
   */
  selectable: propTypes.oneOf([true, false, 'ignoreEvents']),

  /**
   * Specifies the number of miliseconds the user must press and hold on the screen for a touch
   * to be considered a "long press." Long presses are used for time slot selection on touch
   * devices.
   *
   * @type {number}
   * @default 250
   */
  longPressThreshold: propTypes.number,

  /**
   * Determines the selectable time increments in week and day views, in minutes.
   */
  step: propTypes.number,

  /**
   * The number of slots per "section" in the time grid views. Adjust with `step`
   * to change the default of 1 hour long groups, with 30 minute slots.
   */
  timeslots: propTypes.number,

  /**
   *Switch the calendar to a `right-to-left` read direction.
   */
  rtl: propTypes.bool,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the event node.
   *
   * ```js
   * (
   * 	event: Object,
   * 	start: Date,
   * 	end: Date,
   * 	isSelected: boolean
   * ) => { className?: string, style?: Object }
   * ```
   */
  eventPropGetter: propTypes.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the time-slot node. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date, resourceId: (number|string)) => { className?: string, style?: Object }
   * ```
   */
  slotPropGetter: propTypes.func,

  /**
   * Optionally provide a function that returns an object of props to be applied
   * to the time-slot group node. Useful to dynamically change the sizing of time nodes.
   * ```js
   * () => { style?: Object }
   * ```
   */
  slotGroupPropGetter: propTypes.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the day background. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  dayPropGetter: propTypes.func,

  /**
   * Support to show multi-day events with specific start and end times in the
   * main time grid (rather than in the all day header).
   *
   * **Note: This may cause calendars with several events to look very busy in
   * the week and day views.**
   */
  showMultiDayTimes: propTypes.bool,

  /**
   * Constrains the minimum _time_ of the Day and Week views.
   */
  min: propTypes.instanceOf(Date),

  /**
   * Constrains the maximum _time_ of the Day and Week views.
   */
  max: propTypes.instanceOf(Date),

  /**
   * Determines how far down the scroll pane is initially scrolled down.
   */
  scrollToTime: propTypes.instanceOf(Date),

  /**
   * Specify a specific culture code for the Calendar.
   *
   * **Note: it's generally better to handle this globally via your i18n library.**
   */
  culture: propTypes.string,

  /**
   * Localizer specific formats, tell the Calendar how to format and display dates.
   *
   * `format` types are dependent on the configured localizer; both Moment and Globalize
   * accept strings of tokens according to their own specification, such as: `'DD mm yyyy'`.
   *
   * ```jsx
   * let formats = {
   *   dateFormat: 'dd',
   *
   *   dayFormat: (date, , localizer) =>
   *     localizer.format(date, 'DDD', culture),
   *
   *   dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
   *     localizer.format(start, { date: 'short' }, culture) + ' – ' +
   *     localizer.format(end, { date: 'short' }, culture)
   * }
   *
   * <Calendar formats={formats} />
   * ```
   *
   * All localizers accept a function of
   * the form `(date: Date, culture: ?string, localizer: Localizer) -> string`
   */
  formats: propTypes.shape({
    /**
     * Format for the day of the month heading in the Month view.
     * e.g. "01", "02", "03", etc
     */
    dateFormat: dateFormat,

    /**
     * A day of the week format for Week and Day headings,
     * e.g. "Wed 01/04"
     *
     */
    dayFormat: dateFormat,

    /**
     * Week day name format for the Month week day headings,
     * e.g: "Sun", "Mon", "Tue", etc
     *
     */
    weekdayFormat: dateFormat,

    /**
     * The timestamp cell formats in Week and Time views, e.g. "4:00 AM"
     */
    timeGutterFormat: dateFormat,

    /**
     * Toolbar header format for the Month view, e.g "2015 April"
     *
     */
    monthHeaderFormat: dateFormat,

    /**
     * Toolbar header format for the Week views, e.g. "Mar 29 - Apr 04"
     */
    dayRangeHeaderFormat: dateRangeFormat,

    /**
     * Toolbar header format for the Day view, e.g. "Wednesday Apr 01"
     */
    dayHeaderFormat: dateFormat,

    /**
     * Toolbar header format for the Agenda view, e.g. "4/1/2015 – 5/1/2015"
     */
    agendaHeaderFormat: dateRangeFormat,

    /**
     * A time range format for selecting time slots, e.g "8:00am – 2:00pm"
     */
    selectRangeFormat: dateRangeFormat,
    agendaDateFormat: dateFormat,
    agendaTimeFormat: dateFormat,
    agendaTimeRangeFormat: dateRangeFormat,

    /**
     * Time range displayed on events.
     */
    eventTimeRangeFormat: dateRangeFormat,

    /**
     * An optional event time range for events that continue onto another day
     */
    eventTimeRangeStartFormat: dateFormat,

    /**
     * An optional event time range for events that continue from another day
     */
    eventTimeRangeEndFormat: dateFormat
  }),

  /**
   * Customize how different sections of the calendar render by providing custom Components.
   * In particular the `Event` component can be specified for the entire calendar, or you can
   * provide an individual component for each view type.
   *
   * ```jsx
   * let components = {
   *   event: MyEvent, // used by each view (Month, Day, Week)
   *   eventWrapper: MyEventWrapper,
   *   eventContainerWrapper: MyEventContainerWrapper,
   *   dateCellWrapper: MyDateCellWrapper,
   *   timeSlotWrapper: MyTimeSlotWrapper,
   *   timeGutterHeader: MyTimeGutterWrapper,
   *   toolbar: MyToolbar,
   *   agenda: {
   *   	 event: MyAgendaEvent // with the agenda view use a different component to render events
   *     time: MyAgendaTime,
   *     date: MyAgendaDate,
   *   },
   *   day: {
   *     header: MyDayHeader,
   *     event: MyDayEvent,
   *   },
   *   week: {
   *     header: MyWeekHeader,
   *     event: MyWeekEvent,
   *   },
   *   month: {
   *     header: MyMonthHeader,
   *     dateHeader: MyMonthDateHeader,
   *     event: MyMonthEvent,
   *   }
   * }
   * <Calendar components={components} />
   * ```
   */
  components: propTypes.shape({
    event: propTypes.elementType,
    eventWrapper: propTypes.elementType,
    eventContainerWrapper: propTypes.elementType,
    dateCellWrapper: propTypes.elementType,
    timeSlotWrapper: propTypes.elementType,
    timeGutterHeader: propTypes.elementType,
    resourceHeader: propTypes.elementType,
    toolbar: propTypes.elementType,
    agenda: propTypes.shape({
      date: propTypes.elementType,
      time: propTypes.elementType,
      event: propTypes.elementType
    }),
    day: propTypes.shape({
      header: propTypes.elementType,
      event: propTypes.elementType
    }),
    week: propTypes.shape({
      header: propTypes.elementType,
      event: propTypes.elementType
    }),
    month: propTypes.shape({
      header: propTypes.elementType,
      dateHeader: propTypes.elementType,
      event: propTypes.elementType
    })
  }),

  /**
   * String messages used throughout the component, override to provide localizations
   */
  messages: propTypes.shape({
    allDay: propTypes.node,
    previous: propTypes.node,
    next: propTypes.node,
    today: propTypes.node,
    month: propTypes.node,
    week: propTypes.node,
    day: propTypes.node,
    agenda: propTypes.node,
    date: propTypes.node,
    time: propTypes.node,
    event: propTypes.node,
    noEventsInRange: propTypes.node,
    showMore: propTypes.func
  }),

  /**
   * A day event layout(arrangement) algorithm.
   * `overlap` allows events to be overlapped.
   * `no-overlap` resizes events to avoid overlap.
   * or custom `Function(events, minimumStartDifference, slotMetrics, accessors)`
   */
  dayLayoutAlgorithm: DayLayoutAlgorithmPropType
} : {};
var Calendar$1 = uncontrollable(Calendar, {
  view: 'onView',
  date: 'onNavigate',
  selected: 'onSelectEvent'
});

var dateRangeFormat$1 = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'L', culture) + ' – ' + local.format(end, 'L', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'LT', culture) + ' – ' + local.format(end, 'LT', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, 'LT', culture) + ' – ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' – ' + local.format(end, 'LT', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMMM DD', culture) + ' – ' + local.format(end, eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};

var formats = {
  dateFormat: 'DD',
  dayFormat: 'DD ddd',
  weekdayFormat: 'ddd',
  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,
  timeGutterFormat: 'LT',
  monthHeaderFormat: 'MMMM YYYY',
  dayHeaderFormat: 'dddd MMM DD',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat$1,
  agendaDateFormat: 'ddd MMM DD',
  agendaTimeFormat: 'LT',
  agendaTimeRangeFormat: timeRangeFormat
};
function moment (moment) {
  var locale = function locale(m, c) {
    return c ? m.locale(c) : m;
  };

  return new DateLocalizer({
    formats: formats,
    firstOfWeek: function firstOfWeek(culture) {
      var data = culture ? moment.localeData(culture) : moment.localeData();
      return data ? data.firstDayOfWeek() : 0;
    },
    format: function format(value, _format, culture) {
      return locale(moment(value), culture).format(_format);
    }
  });
}

var css_248z$10 = ".t-calendar-event-popup {\n  min-width: 375px;\n}\n.t-calendar-event-popup .t-calendarListItem:hover {\n  border-right: 4px solid #fff !important;\n  background: unset !important;\n}\n.t-calendarListItem {\n  display: flex;\n  border-bottom: 1px solid #eaeaeb;\n  padding: 16px;\n  justify-content: space-between;\n  border-right: 4px solid transparent;\n}\n.t-calendarListItem .t-timeAndEvents {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.t-calendarListItem .t-infoContainer {\n  display: flex;\n  align-items: center;\n  width: 70%;\n}\n.t-calendarListItem .t-infoContainer .t-avatarGroup {\n  display: flex;\n  align-items: center;\n}\n.t-calendarListItem .t-infoContainer .t-avatarGroup p {\n  margin-left: 8px;\n  margin-top: 2px;\n}\n@media screen and (max-width: 390px) {\n  .t-calendarListItem .t-infoContainer .t-avatarGroup {\n    flex-direction: unset;\n    align-items: flex-start;\n    padding-bottom: 16px;\n  }\n}\n.t-calendarListItem .t-infoContainer .t-dateContainer {\n  margin-right: 17px;\n}\n.t-calendarListItem:hover {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n  cursor: pointer;\n}\n.rbc-event.event-wrapper {\n  background-color: rgba(148, 148, 255, 0.2);\n}\n";
styleInject(css_248z$10);

const CalendarEventItem = _a => {
  var {
    title
  } = _a,
      rest = __rest(_a, ["title"]);

  return React.createElement(_Popover, {
    overlayClassName: "t-calendar-event-popup",
    trigger: "click",
    content: React.createElement(TCalendarEventViewItem, Object.assign({}, rest, {
      title: title
    }))
  }, React.createElement("div", {
    className: "t-calendar-event-item"
  }, React.createElement(TText, {
    level: 3,
    rows: 1
  }, title)));
};

var css_248z$11 = ".calendar-header {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 12px 12px 12px 16px;\n}\n.calendar-header .calendar-header-buttons {\n  display: flex;\n}\n.calendar-header .calendar-header-buttons .button-group {\n  margin-right: 32px;\n}\n.calendar-header .calendar-header-buttons .button-group .ant-radio-button-wrapper:last-child {\n  border-top-right-radius: var(--border-radius, 8px);\n  border-bottom-right-radius: var(--border-radius, 8px);\n}\n.calendar-header .calendar-header-buttons .button-group .ant-radio-button-wrapper:first-child {\n  border-top-left-radius: var(--border-radius, 8px);\n  border-bottom-left-radius: var(--border-radius, 8px);\n}\n.calendar-header .calendar-header-buttons .month-control {\n  display: flex;\n  align-items: center;\n}\n.calendar-header .calendar-header-buttons .month-control .month-label {\n  margin: 0 8px 1px;\n}\n.calendar-header .calendar-header-buttons .month-control div {\n  cursor: pointer;\n  margin: 0;\n}\n";
styleInject(css_248z$11);

const CalendarToolbar = ({
  date,
  changeDate,
  onFilterChange,
  calendarView,
  changeCalendarView
}, props) => {
  const {
    translate
  } = useContext(ConfigContext);
  const {
    label
  } = props;
  const colCustomStyle = {
    xs: {
      span: 7,
      push: 9
    },
    sm: {
      span: 12,
      push: 0
    },
    md: {
      span: 24,
      push: 10
    },
    lg: {
      span: 6,
      push: 0
    },
    xl: {
      span: 6,
      pull: 0
    },
    xxl: {
      span: 6,
      pull: 0
    },
    style: {
      marginBottom: 15
    }
  };
  const monthColStyle = Object.assign(Object.assign({}, colCustomStyle), {
    xs: {
      span: 24,
      push: 0
    },
    md: {
      span: 24,
      push: 0
    },
    lg: {
      span: 8,
      push: 0
    }
  });
  const btnGroupColStyle = Object.assign(Object.assign({}, colCustomStyle), {
    xs: {
      span: 18,
      push: 3
    },
    md: {
      span: 24,
      pull: 7
    },
    lg: {
      span: 10,
      pull: 0
    },
    xl: {
      span: 6,
      pull: 0
    }
  });
  return React.createElement(_Row, {
    gutter: 24,
    justify: 'space-between'
  }, React.createElement(_Col, Object.assign({}, colCustomStyle, {
    style: {
      marginBottom: 15
    }
  }), React.createElement(TText, {
    level: 1,
    bold: true
  }, translate('ui.calendar'))), React.createElement(_Col, Object.assign({}, monthColStyle), React.createElement(_Row, {
    gutter: 24,
    justify: 'center',
    style: {
      alignItems: 'center',
      marginBottom: 15
    }
  }, React.createElement(_Col, {
    onClick: () => {
      const view = calendarView === 'agenda' ? 'month' : calendarView;
      const momentStartDate = moment$1(date).add(-1, view).startOf(view);
      changeDate(new Date(momentStartDate.toString()));
      onFilterChange({
        startDate: momentStartDate.toISOString(),
        endDate: moment$1(date).add(-1, view).endOf(view).toISOString(),
        date: moment$1(date).add(-1, view).toDate(),
        calendarView: view
      });
    }
  }, React.createElement(IconLeft, {
    size: "md"
  })), React.createElement(_Col, null, React.createElement(TText, {
    level: 1
  }, label)), React.createElement(_Col, {
    onClick: () => {
      const view = calendarView === 'agenda' ? 'month' : calendarView;
      const momentStartDate = moment$1(date).add(1, view).startOf(view);
      changeDate(new Date(momentStartDate.toString()));
      onFilterChange({
        startDate: momentStartDate.toISOString(),
        endDate: moment$1(date).add(1, view).endOf(view).toISOString(),
        date: moment$1(date).add(1, view).toDate(),
        calendarView: view
      });
    }
  }, React.createElement(IconRight, {
    size: "md"
  })))), React.createElement(_Col, Object.assign({}, btnGroupColStyle, {
    style: {
      marginBottom: 15,
      textAlign: 'end'
    }
  }), React.createElement(_Radio.Group, {
    className: "button-group",
    buttonStyle: "solid",
    defaultValue: calendarView,
    onChange: val => changeCalendarView(val.target.value)
  }, React.createElement(_Radio.Button, {
    value: "month"
  }, translate('ui.month')), React.createElement(_Radio.Button, {
    value: "week"
  }, translate('ui.week')), React.createElement(_Radio.Button, {
    value: "day"
  }, translate('ui.day')), React.createElement(_Radio.Button, {
    value: "agenda"
  }, translate('ui.agenda')))));
};

var css_248z$12 = "@charset \"UTF-8\";\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0; }\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer; }\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed; }\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; }\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit; }\n\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.rbc-ellipsis, .rbc-event-label, .rbc-row-segment .rbc-event-content, .rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.rbc-rtl {\n  direction: rtl; }\n\n.rbc-off-range {\n  color: #999999; }\n\n.rbc-off-range-bg {\n  background: #e6e6e6; }\n\n.rbc-header {\n  overflow: hidden;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid #DDD; }\n  .rbc-header + .rbc-header {\n    border-left: 1px solid #DDD; }\n  .rbc-rtl .rbc-header + .rbc-header {\n    border-left-width: 0;\n    border-right: 1px solid #DDD; }\n  .rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n    color: inherit;\n    text-decoration: none; }\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4; }\n\n.rbc-today {\n  background-color: #eaf6ff; }\n\n.rbc-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px; }\n  .rbc-toolbar .rbc-toolbar-label {\n    flex-grow: 1;\n    padding: 0 10px;\n    text-align: center; }\n  .rbc-toolbar button {\n    color: #373a3c;\n    display: inline-block;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    background: none;\n    background-image: none;\n    border: 1px solid #ccc;\n    padding: .375rem 1rem;\n    border-radius: 4px;\n    line-height: normal;\n    white-space: nowrap; }\n    .rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n      background-image: none;\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n      background-color: #e6e6e6;\n      border-color: #adadad; }\n      .rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {\n        color: #373a3c;\n        background-color: #d4d4d4;\n        border-color: #8c8c8c; }\n    .rbc-toolbar button:focus {\n      color: #373a3c;\n      background-color: #e6e6e6;\n      border-color: #adadad; }\n    .rbc-toolbar button:hover {\n      color: #373a3c;\n      background-color: #e6e6e6;\n      border-color: #adadad; }\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap; }\n  .rbc-btn-group > button:first-child:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .rbc-btn-group > button:last-child:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n    border-radius: 4px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n    border-radius: 4px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .rbc-btn-group > button:not(:first-child):not(:last-child) {\n    border-radius: 0; }\n  .rbc-btn-group button + button {\n    margin-left: -1px; }\n  .rbc-rtl .rbc-btn-group button + button {\n    margin-left: 0;\n    margin-right: -1px; }\n  .rbc-btn-group + .rbc-btn-group,\n  .rbc-btn-group + button {\n    margin-left: 10px; }\n\n.rbc-event {\n  border: none;\n  box-sizing: border-box;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  width: 100%;\n  text-align: left; }\n  .rbc-slot-selecting .rbc-event {\n    cursor: inherit;\n    pointer-events: none; }\n  .rbc-event.rbc-selected {\n    background-color: #265985; }\n  .rbc-event:focus {\n    outline: 5px auto #3b99fc; }\n\n.rbc-event-label {\n  font-size: 80%; }\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5); }\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.rbc-row {\n  display: flex;\n  flex-direction: row; }\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px; }\n\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1); }\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal; }\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #DDD;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%; }\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row; }\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  flex-basis: 0px;\n  overflow: hidden;\n  height: 100%; }\n  .rbc-month-row + .rbc-month-row {\n    border-top: 1px solid #DDD; }\n\n.rbc-date-cell {\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right; }\n  .rbc-date-cell.rbc-now {\n    font-weight: bold; }\n  .rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n    color: inherit;\n    text-decoration: none; }\n\n.rbc-row-bg {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden; }\n\n.rbc-day-bg {\n  flex: 1 0 0%; }\n  .rbc-day-bg + .rbc-day-bg {\n    border-left: 1px solid #DDD; }\n  .rbc-rtl .rbc-day-bg + .rbc-day-bg {\n    border-left-width: 0;\n    border-right: 1px solid #DDD; }\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px; }\n  .rbc-overlay > * + * {\n    margin-top: 1px; }\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px; }\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto; }\n  .rbc-agenda-view table.rbc-agenda-table {\n    width: 100%;\n    border: 1px solid #DDD;\n    border-spacing: 0;\n    border-collapse: collapse; }\n    .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n      padding: 5px 10px;\n      vertical-align: top; }\n    .rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n      padding-left: 15px;\n      padding-right: 15px;\n      text-transform: lowercase; }\n    .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n      border-left: 1px solid #DDD; }\n    .rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n      border-left-width: 0;\n      border-right: 1px solid #DDD; }\n    .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n      border-top: 1px solid #DDD; }\n    .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n      padding: 3px 5px;\n      text-align: left;\n      border-bottom: 1px solid #DDD; }\n      .rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n        text-align: right; }\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase; }\n  .rbc-agenda-time-cell .rbc-continues-after:after {\n    content: ' »'; }\n  .rbc-agenda-time-cell .rbc-continues-prior:before {\n    content: '« '; }\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap; }\n\n.rbc-agenda-event-cell {\n  width: 100%; }\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%; }\n  .rbc-time-column .rbc-timeslot-group {\n    flex: 1; }\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #DDD;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap; }\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none; }\n\n.rbc-label {\n  padding: 0 5px; }\n\n.rbc-day-slot {\n  position: relative; }\n  .rbc-day-slot .rbc-events-container {\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    margin-right: 10px;\n    top: 0; }\n    .rbc-day-slot .rbc-events-container.rbc-rtl {\n      left: 10px;\n      right: 0; }\n  .rbc-day-slot .rbc-event {\n    border: 1px solid #265985;\n    display: flex;\n    max-height: 100%;\n    min-height: 20px;\n    flex-flow: column wrap;\n    align-items: flex-start;\n    overflow: hidden;\n    position: absolute; }\n  .rbc-day-slot .rbc-event-label {\n    flex: none;\n    padding-right: 5px;\n    width: auto; }\n  .rbc-day-slot .rbc-event-content {\n    width: 100%;\n    flex: 1 1 0;\n    word-wrap: break-word;\n    line-height: 1;\n    height: 100%;\n    min-height: 1em; }\n  .rbc-day-slot .rbc-time-slot {\n    border-top: 1px solid #f7f7f7; }\n\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #DDD;\n  z-index: 10;\n  margin-right: -1px; }\n\n.rbc-time-view-resources .rbc-time-header {\n  overflow: hidden; }\n\n.rbc-time-view-resources .rbc-time-header-content {\n  min-width: auto;\n  flex: 1 0 0;\n  flex-basis: 0px; }\n\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n  display: none; }\n\n.rbc-time-view-resources .rbc-day-slot {\n  min-width: 140px; }\n\n.rbc-time-view-resources .rbc-header,\n.rbc-time-view-resources .rbc-day-bg {\n  width: 140px;\n  flex: 1 1 0;\n  flex-basis: 0 px; }\n\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px; }\n\n.rbc-time-slot {\n  flex: 1 0 0; }\n  .rbc-time-slot.rbc-now {\n    font-weight: bold; }\n\n.rbc-day-header {\n  text-align: center; }\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px; }\n\n.rbc-slot-selecting {\n  cursor: move; }\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #DDD;\n  min-height: 0; }\n  .rbc-time-view .rbc-time-gutter {\n    white-space: nowrap; }\n  .rbc-time-view .rbc-allday-cell {\n    box-sizing: content-box;\n    width: 100%;\n    height: 100%;\n    position: relative; }\n  .rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n    border-left: 1px solid #DDD; }\n  .rbc-time-view .rbc-allday-events {\n    position: relative;\n    z-index: 4; }\n  .rbc-time-view .rbc-row {\n    box-sizing: border-box;\n    min-height: 20px; }\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: row; }\n  .rbc-time-header.rbc-overflowing {\n    border-right: 1px solid #DDD; }\n  .rbc-rtl .rbc-time-header.rbc-overflowing {\n    border-right-width: 0;\n    border-left: 1px solid #DDD; }\n  .rbc-time-header > .rbc-row:first-child {\n    border-bottom: 1px solid #DDD; }\n  .rbc-time-header > .rbc-row.rbc-row-resource {\n    border-bottom: 1px solid #DDD; }\n\n.rbc-time-header-cell-single-day {\n  display: none; }\n\n.rbc-time-header-content {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  border-left: 1px solid #DDD; }\n  .rbc-rtl .rbc-time-header-content {\n    border-left-width: 0;\n    border-right: 1px solid #DDD; }\n  .rbc-time-header-content > .rbc-row.rbc-row-resource {\n    border-bottom: 1px solid #DDD;\n    flex-shrink: 0; }\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #DDD;\n  overflow-y: auto;\n  position: relative; }\n  .rbc-time-content > .rbc-time-gutter {\n    flex: none; }\n  .rbc-time-content > * + * > * {\n    border-left: 1px solid #DDD; }\n  .rbc-rtl .rbc-time-content > * + * > * {\n    border-left-width: 0;\n    border-right: 1px solid #DDD; }\n  .rbc-time-content > .rbc-day-slot {\n    width: 100%;\n    user-select: none;\n    -webkit-user-select: none; }\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none; }\n";
styleInject(css_248z$12);

var css_248z$13 = ".calendar-container {\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  border-radius: var(--border-radius, 8px);\n  overflow: hidden;\n}\n.calendar-container .rbc-off-range-bg {\n  background: #fbfbfc;\n}\n.calendar-container .rbc-today {\n  background-color: #f54e951a;\n}\n.calendar-container .rbc-month-view {\n  border: none;\n}\n.calendar-container .rbc-month-view .day-wrapper {\n  border-top: 1px solid #f2f2f3;\n  margin: 0 4px;\n}\n.calendar-container .rbc-month-view .rbc-day-bg + .rbc-day-bg {\n  border: none;\n  border-top: 1px solid #f2f2f3;\n  margin: 0 4px;\n}\n.calendar-container .rbc-month-view .rbc-header {\n  text-align: right;\n  margin: 0 4px;\n  padding: 0 4px;\n}\n.calendar-container .rbc-month-view .rbc-header > span {\n  font-size: 15px;\n  font-weight: normal;\n}\n.calendar-container .rbc-month-view .rbc-header + .rbc-header {\n  text-align: right;\n  border-right: none;\n  border-left: none;\n  border-bottom: 1px solid #f2f2f3;\n  margin: 0 4px;\n  padding: 0 4px;\n}\n.calendar-container .rbc-month-view .rbc-month-row + .rbc-month-row {\n  border: none;\n}\n.calendar-container .rbc-month-view .rbc-date-cell {\n  font-size: 14px;\n  padding: 0 8px;\n}\n.calendar-container .event-wrapper {\n  font-size: 12px;\n  background-color: #9696ff33;\n  margin-bottom: 4px;\n  border: none;\n}\n.calendar-container .rbc-day-slot .rbc-event-label {\n  display: none;\n}\n";
styleInject(css_248z$13);

const localizer = moment(moment$1);

const TCalendar = ({
  events = [],
  onFilterChange,
  date: propsDate,
  height,
  loading = false,
  onEventItemClick = () => {},
  onBook = () => {},
  momentLocale
}) => {
  const [calendarView, setCalendarView] = useState('month');
  const [date, setDate] = useState(propsDate ? new Date(propsDate) : new Date());
  const changeCalendarView = useCallback(value => {
    setCalendarView(value);
  }, []);
  const timeRangeFormat = useCallback(({
    eventStartDate,
    eventEndDate
  }, culture, locale) => {
    return `${locale.format(eventStartDate, 'DD MMM YYYY', culture)} - ${locale.format(eventEndDate, 'DD MMM YYYY', culture)}`;
  }, []);
  return React.createElement("div", {
    className: "calendar-container"
  }, loading && React.createElement(TLoading, {
    overlay: true
  }), React.createElement(Calendar$1, {
    selectable: true,
    localizer: localizer,
    events: events,
    startAccessor: event => new Date(event.eventStartDate),
    endAccessor: event => new Date(event.eventEndDate),
    formats: {
      timeGutterFormat: 'HH:mm',
      agendaHeaderFormat: timeRangeFormat
    },
    view: calendarView,
    onView: view => changeCalendarView(view),
    scrollToTime: new Date(),
    popup: true,
    date: date,
    style: {
      height
    },
    components: {
      event: props => React.createElement(CalendarEventItem, Object.assign({}, props.event, {
        onItemClick: () => onEventItemClick(props.event),
        onBook: () => onBook(props.event)
      })),
      toolbar: prop => CalendarToolbar({
        date,
        changeDate: setDate,
        onFilterChange,
        calendarView,
        changeCalendarView
      }, prop)
    },
    eventPropGetter: event => ({
      style: {
        backgroundColor: `${event.color}`
      },
      className: 'event-wrapper'
    }),
    dayPropGetter: _date => ({
      className: 'day-wrapper'
    }),
    culture: momentLocale
  }));
};

var Calendar$2 = withLocalization(TCalendar);

var css_248z$14 = ".t-practice-card .t-practice-card-grid {\n  box-shadow: none;\n}\n.t-practice-card .t-practice-card-grid.t-practice-card-left {\n  width: 60%;\n}\n.t-practice-card .t-practice-card-grid.t-practice-card-right {\n  width: 40%;\n  padding-left: 0;\n}\n.t-practice-card .t-practice-card-grid img {\n  width: 100%;\n}\n.t-practice-card .t-practice-card-grid .t-practice-card-partner {\n  margin-top: 12px;\n}\n.t-practice-card .t-practice-card-grid .t-practice-card-partner .t-avatar-image {\n  display: inline-block;\n  padding-right: 8px;\n}\n.t-practice-card .t-practice-card-grid .t-practice-card-partner .t-text {\n  display: inline-block;\n}\n.t-practice-card .t-practice-card-grid .t-practice-card-description {\n  margin-top: 12px;\n}\n.t-practice-card .t-practice-card-grid .t-button {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n}\n.t-courseCardConent .t-cardContentRow-1 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.t-courseCardConent .t-cardContentRow-1 .t-courseCardTitle p:nth-of-type(1) {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  height: fit-content;\n  word-break: unset;\n}\n.t-courseCardConent .t-cardContentRow-1 .t-courseCardScheduleWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.t-courseCardConent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer {\n  margin-bottom: 8px;\n}\n.t-courseCardConent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer p:nth-child(1) {\n  white-space: nowrap;\n}\n.t-courseCardConent .t-cardContentRow-2 {\n  margin-bottom: 8px;\n}\n.t-courseCardConent .t-cardContentRow-2 button {\n  padding: 0px;\n}\n.t-courseCardConent .t-cardContentRow-3 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.t-courseCardConent .t-cardContentRow-3 .t-avatarWrapper {\n  display: flex;\n  align-items: center;\n}\n.t-courseCardConent .t-cardContentRow-3 .t-avatarWrapper .t-avatar-group {\n  margin-right: 20px;\n}\n.t-courseCardConent .t-cardContentRow-3 .t-levelWrapper {\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 767px) {\n  .t-courseCardConent .t-cardContentRow-3 .t-levelWrapper {\n    align-items: flex-start;\n  }\n}\n.t-courseCardConent .t-cardContentRow-3 .t-levelWrapper p {\n  margin-right: 8px;\n}\n.t-courseCardConent .t-cardContentRow-3 .t-levelWrapper .t-icon {\n  margin-right: 0px;\n}\n.t-courseCardConent .t-cardContentRow-4 {\n  display: flex;\n  justify-content: space-between;\n}\n.t-courseCardConent .t-cardContentRow-4 .t-groupCountWrapper {\n  display: flex;\n  align-items: center;\n}\n";
styleInject(css_248z$14);

const TPracticeCard = ({
  course,
  buttonText,
  buttonAction
}) => {
  return React.createElement(_Card, {
    className: "t-practice-card"
  }, React.createElement(_Card.Grid, {
    hoverable: false,
    className: "t-practice-card-grid t-practice-card-left"
  }, React.createElement("img", {
    src: course.image
  })), React.createElement(_Card.Grid, {
    hoverable: false,
    className: "t-practice-card-grid t-practice-card-right"
  }, React.createElement(TText, {
    bold: true,
    level: 1
  }, course.title), React.createElement("div", {
    className: "t-practice-card-partner"
  }, React.createElement(TAvatar, {
    src: course.partnerLogo,
    size: "xs"
  }), React.createElement(TText, {
    bold: true,
    level: 3
  }, course.partnerName)), React.createElement("div", {
    className: "t-practice-card-description"
  }, React.createElement(TText, {
    level: 3,
    innerText: course.description
  })), React.createElement(TButton, {
    type: "primary",
    onClick: buttonAction
  }, buttonText)));
};

const withSkeleton = (Component, SkeletonComponent) => _a => {
  var {
    skeletonLoading = false,
    grid
  } = _a,
      props = __rest(_a, ["skeletonLoading", "grid"]);

  return skeletonLoading ? React.createElement(SkeletonComponent, {
    row: grid === null || grid === void 0 ? void 0 : grid.row,
    col: grid === null || grid === void 0 ? void 0 : grid.col
  }) : React.createElement(Component, Object.assign({}, props, {
    grid: grid
  }));
};

const img$b = "data:image/png;base64,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";

var css_248z$15 = ".t-scheduleViewerContainer {\n  text-align: end;\n}\n.t-scheduleViewerContainer .t-scheduleTypeText {\n  font-size: 12px;\n  color: var(--text-dark-50, #909091);\n}\n";
styleInject(css_248z$15);

const TScheduleViewer = ({
  start,
  end,
  locale,
  type,
  isFlexible
}) => {
  const classNames = ['t-scheduleViewerContainer'];
  const startDate = moment$1(start).format('MMM D');
  const endDate = moment$1(end).format('MMM D');

  function MonthShow() {
    if (start && end) {
      return `${startDate} - ${endDate}`;
    }

    if (start || end) {
      return `${start ? startDate : endDate}`;
    }

    return null;
  }

  moment$1.locale(locale === 'hy' ? 'hy-am' : locale);
  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(TText, {
    level: 3,
    rows: 1
  }, MonthShow()), React.createElement("span", {
    className: "t-scheduleTypeText"
  }, type), !!isFlexible && React.createElement(TText, {
    level: 3,
    rows: 1,
    textColor: "dark-50"
  }, "Flexible"));
};

var css_248z$16 = ".t-imageCardContainer {\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  background: #ffffff;\n}\n.t-imageCardContainer .ant-card-cover {\n  position: relative;\n}\n.t-imageCardContainer .t-imageCardCoverImgWrapper {\n  padding-bottom: 52.55%;\n}\n.t-imageCardContainer .t-imageCardCoverImgWrapper .t-imageCardCoverImg {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  border-radius: var(--border-radius, 8px) var(--border-radius, 8px) 0 0;\n}\n";
styleInject(css_248z$16);

const TImageCard = _a => {
  var {
    children,
    image,
    coverHeight,
    cover
  } = _a,
      props = __rest(_a, ["children", "image", "coverHeight", "cover"]);

  return React.createElement(_Card, {
    cover: !cover && !!image ? React.createElement("div", {
      className: "t-imageCardCoverImgWrapper"
    }, React.createElement("img", {
      style: {
        height: coverHeight
      },
      src: image,
      className: "t-imageCardCoverImg"
    })) : React.createElement("div", {
      style: {
        height: coverHeight
      }
    }, cover),
    className: "t-imageCardContainer",
    bodyStyle: {
      padding: '16px'
    }
  }, children);
};

var css_248z$17 = ".t-levelWrapper {\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 767px) {\n  .t-levelWrapper {\n    align-items: flex-start;\n  }\n}\n.t-levelWrapper p {\n  margin-right: 8px;\n}\n.t-levelWrapper .t-icon {\n  margin-right: 0;\n}\n";
styleInject(css_248z$17);

const LevelViewer = ({
  level
}) => {
  const classNames = ['t-levelWrapper'];

  if (!level) {
    return null;
  }

  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(TText, {
    level: 4,
    rows: 1
  }, level), React.createElement(IconLevel, {
    size: "sm"
  }));
};

var css_248z$18 = ".t-courseCardContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.t-courseCardContent .t-cardContentRow-1 {\n  display: flex;\n  justify-content: space-between;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardTitle {\n  margin-right: 8px;\n  width: 70%;\n  padding-bottom: 16px;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardTitle p:nth-of-type(1) {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  height: fit-content;\n  word-break: unset;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-top: 8px;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer {\n  margin-bottom: 8px;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer p:nth-child(1) {\n  white-space: nowrap;\n}\n.t-courseCardContent .t-cardContentRow-2 button {\n  padding: 0;\n}\n.t-courseCardContent .t-cardContentRow-2 p > p {\n  margin: 0;\n}\n.t-courseCardContent .t-cardContentRow-4 {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .has-margin {\n  margin-top: 8px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-icon-with-text {\n  display: flex;\n  align-items: center;\n  margin-top: auto;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-info-text {\n  margin-left: 8px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-avatar-group {\n  margin-right: 20px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-groupCountWrapper {\n  display: flex;\n  align-items: center;\n}\n.t-courseCardContent .t-right-wrapper {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n}\n.t-skeleton-card-container {\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n.t-skeleton-card-container .t-skeleton-cover-image {\n  border-top-left-radius: var(--border-radius, 8px);\n  border-top-right-radius: var(--border-radius, 8px);\n  width: 100% !important;\n  height: 190px !important;\n}\n";
styleInject(css_248z$18);

const TCourseCardSkeleton = () => {
  return React.createElement(_Card, {
    className: "t-skeleton-card-container",
    cover: React.createElement(_Skeleton.Image, {
      className: "t-skeleton-cover-image"
    })
  }, React.createElement(_Skeleton, {
    round: true,
    active: true,
    paragraph: {
      rows: 2
    }
  }));
};

const TCourseCard = ({
  course,
  contentHeight = '124px',
  actions
}) => {
  var _a;

  const {
    translate
  } = useContext(ConfigContext);
  const {
    teachers = [],
    description = '',
    startDate = '',
    endDate = '',
    level = '',
    studentsCount,
    isFlexible = false,
    price
  } = course;

  function showTeacher(teachers) {
    var _a;

    if (!teachers || !teachers.length) {
      return null;
    }

    if (teachers.length > 1) {
      const teachersNames = React.createElement("div", null, teachers.map((item, index) => {
        return React.createElement(TText, {
          level: 3,
          rows: 1,
          key: index
        }, item.fullName);
      }));
      return React.createElement(TPopover, {
        content: teachersNames
      }, "Teachers");
    }

    return React.createElement(TText, {
      level: 3,
      rows: 1
    }, (_a = teachers[0]) === null || _a === void 0 ? void 0 : _a.fullName);
  }

  const teacher = showTeacher(teachers);
  return React.createElement(TImageCard, {
    image: course.image || img$b
  }, React.createElement("div", {
    style: {
      height: contentHeight
    },
    className: "t-courseCardContent"
  }, React.createElement("div", {
    className: "t-cardContentRow-1"
  }, React.createElement("div", {
    className: "t-courseCardTitle"
  }, React.createElement(TText, {
    bold: true,
    level: 2,
    rows: 2
  }, course.name)), React.createElement("div", {
    className: "t-courseCardScheduleWrapper"
  }, React.createElement(TScheduleViewer, {
    isFlexible: isFlexible,
    start: startDate,
    end: endDate
  }), React.createElement(LevelViewer, {
    level: level
  }))), !!description && React.createElement("div", {
    className: "t-cardContentRow-2"
  }, React.createElement(TText, {
    innerText: description,
    readMore: true,
    level: 3,
    rows: 1
  })), React.createElement("div", {
    className: "t-cardContentRow-4"
  }, React.createElement("div", {
    className: "t-info-wrapper"
  }, !!teachers.length && React.createElement("div", {
    className: "t-icon-with-text"
  }, React.createElement(TAvatar, {
    src: '',
    name: (_a = teachers[0]) === null || _a === void 0 ? void 0 : _a.fullName,
    size: "xxs"
  }), React.createElement("div", {
    className: "t-info-text"
  }, teacher)), !!studentsCount && React.createElement("div", {
    className: "has-margin"
  }, React.createElement("div", {
    className: "t-icon-with-text"
  }, React.createElement(IconUsers, {
    size: "xs"
  }), React.createElement("div", {
    className: "t-info-text"
  }, React.createElement(TText, {
    level: 3,
    rows: 1
  }, translate('ui.student.count', {
    count: studentsCount
  })))))), (price || actions) && React.createElement("div", {
    className: "t-right-wrapper"
  }, price && React.createElement("div", {
    className: "t-price-wrapper"
  }, React.createElement(TText, {
    level: 1
  }, price)), actions && React.createElement("div", {
    className: "actions-wrapper"
  }, actions)))));
};

var CourseCard = withSkeleton(TCourseCard, TCourseCardSkeleton);

var css_248z$19 = ".horizontal-card-container {\n  box-shadow: 0 2px 4px rgba(119, 110, 171, 0.12);\n  padding: 16px;\n  transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.horizontal-card-container .actions-wrapper {\n  display: flex;\n  padding-left: 8px;\n}\n.horizontal-card-container .actions-wrapper .action-wrapper {\n  cursor: pointer;\n  margin: 0 4px;\n}\n.horizontal-card-container.horizontal-card-container-disabled {\n  cursor: not-allowed;\n}\n.horizontal-card-container.horizontal-card-container-primary {\n  background: var(--primary-color, #f54e95);\n}\n.horizontal-card-container.horizontal-card-container-primary-light {\n  background: var(--primary-color-light, #fff0f4);\n}\n.horizontal-card-container.horizontal-card-container-indicator {\n  background: #9696ff;\n}\n.horizontal-card-container.horizontal-card-container-active {\n  background: var(--primary-color-light, #fff0f4);\n}\n.horizontal-card-container.horizontal-card-container-strong {\n  box-shadow: none;\n  background: #e9e9f0;\n}\n.horizontal-card-container.horizontal-card-container-soft {\n  box-shadow: none;\n  background: #f7f7f8;\n}\n.horizontal-card-container.horizontal-card-container-white {\n  background: #fff;\n}\n.horizontal-card-container-border-sm {\n  border-radius: 2px;\n}\n.horizontal-card-container-border-md {\n  border-radius: 4px;\n}\n.horizontal-card-container-border-lg {\n  border-radius: 8px;\n}\n.horizontal-card-container-border-xl {\n  border-radius: 16px;\n}\n.horizontal-card-container-hover:hover {\n  box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -webkit-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  -moz-box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);\n  transition: all 0.3s ease-in-out;\n}\n.horizontal-card-container-padding-xs {\n  padding: 8px;\n}\n.horizontal-card-container-padding-sm {\n  padding: 12px;\n}\n.horizontal-card-container-padding-md {\n  padding: 16px;\n}\n";
styleInject(css_248z$19);

const HorizontalCard = ({
  title,
  titlefontWeight,
  description,
  extraContent,
  icon,
  actions = [],
  onItemClick,
  active,
  background,
  titleColor,
  descriptionColor,
  titleSize = 2,
  descriptionSize = 3,
  iconPositionY,
  actionsPositionY,
  padding = 'md',
  disabled = false,
  hover = false,
  borderRadius = 'lg',
  prefix
}) => {
  const classNames = ['horizontal-card-container'];
  classNames.push(`horizontal-card-container-border-${borderRadius}`, `horizontal-card-container-padding-${padding}`);

  if (active) {
    classNames.push('horizontal-card-container-active');
  }

  if (background) {
    classNames.push(`horizontal-card-container-${background}`);
  }

  if (hover) {
    classNames.push(`horizontal-card-container-hover`);
  }

  if (disabled) {
    classNames.push(`horizontal-card-container-disabled`);
  }

  const titlefontWeightProps = {};

  if (titlefontWeight === 'bold') {
    titlefontWeightProps.bold = true;
  }

  if (titlefontWeight === 'semiBold') {
    titlefontWeightProps.semiBold = true;
  }

  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onItemClick
  }, prefix, React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "space-between"
  }, React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: iconPositionY
  }, icon && React.createElement(Wrapper$2, {
    display: "flex",
    pr: 1
  }, icon), React.createElement(Wrapper$2, null, typeof title !== 'string' ? title : React.createElement(TText, Object.assign({
    semiBold: true,
    level: titleSize,
    rows: 1
  }, titlefontWeightProps, {
    textColor: titleColor
  }), title), description && React.createElement(TText, {
    textColor: descriptionColor,
    level: descriptionSize,
    rows: 1
  }, description))), !!actions.length && React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: actionsPositionY
  }, React.createElement("div", {
    className: "actions-wrapper"
  }, actions.map((item, index) => {
    return React.createElement("div", {
      key: index,
      className: 'action-wrapper',
      onClick: item.onClick
    }, item.icon);
  })))), !!extraContent && React.createElement(Wrapper$2, null, extraContent));
};

var css_248z$1a = ".t-courseCardContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.t-courseCardContent .t-cardContentRow-1 {\n  display: flex;\n  justify-content: space-between;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardTitle {\n  margin-right: 8px;\n  width: 70%;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardTitle p:nth-of-type(1) {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  height: fit-content;\n  word-break: unset;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-top: 8px;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer {\n  margin-bottom: 8px;\n}\n.t-courseCardContent .t-cardContentRow-1 .t-courseCardScheduleWrapper .t-scheduleViewerContainer p:nth-child(1) {\n  white-space: nowrap;\n}\n.t-courseCardContent .t-cardContentRow-2 button {\n  padding: 0;\n}\n.t-courseCardContent .t-cardContentRow-4 {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .has-margin {\n  margin-top: 8px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-icon-with-text {\n  display: flex;\n  align-items: center;\n  margin-top: auto;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-info-text {\n  margin-left: 8px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-info-wrapper .t-avatar-group {\n  margin-right: 20px;\n}\n.t-courseCardContent .t-cardContentRow-4 .button-wrapper {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 1px;\n}\n.t-courseCardContent .t-cardContentRow-4 .t-groupCountWrapper {\n  display: flex;\n  align-items: center;\n}\n";
styleInject(css_248z$1a);

const TCourseCardListSkeleton = ({
  row,
  col
}) => {
  return React.createElement(_Row, Object.assign({}, row), Array(20).fill(undefined).map((value, index) => React.createElement(_Col, Object.assign({
    key: index
  }, col), React.createElement(TCourseCardSkeleton, null))));
};

const TCourseCardList = ({
  courseList,
  renderItem,
  renderActions = () => null,
  grid,
  contentHeight
}) => {
  return React.createElement(_Row, Object.assign({}, grid === null || grid === void 0 ? void 0 : grid.row), courseList.map((item, index) => {
    if (renderItem) {
      if (grid === null || grid === void 0 ? void 0 : grid.col) {
        return React.createElement(_Col, Object.assign({
          key: index
        }, grid.col), renderItem(item, index));
      }

      return renderItem(item, index);
    }

    return React.createElement(_Col, Object.assign({
      key: index
    }, grid === null || grid === void 0 ? void 0 : grid.col), React.createElement(CourseCard, {
      course: item,
      actions: renderActions(item),
      contentHeight: contentHeight
    }));
  }));
};

var CourseCardList = withSkeleton(TCourseCardList, TCourseCardListSkeleton);

var css_248z$1b = ".t-course-videoPlayer-container .t-imageCardContainer .t-imageCardCoverImgWrapper .t-imageCardCoverImg {\n  position: unset;\n}\n.t-course-videoPlayer-container .t-imageCardContainer .t-imageCardCoverImgWrapper {\n  padding-bottom: 0;\n}\n.t-course-videoPlayer-container .t-course-player-container {\n  position: absolute;\n  top: calc((100% - 72px - 68px) / 2);\n  left: calc((100% - 200px) / 2);\n}\n.t-course-videoPlayer-container .t-course-player-container .t-course-player-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n";
styleInject(css_248z$1b);

const TVideoCourseCard = ({
  href,
  playerText,
  handleAdd,
  buttonText,
  coverHeight
}) => {
  return React.createElement("div", {
    className: "t-course-videoPlayer-container"
  }, React.createElement(TImageCard, {
    coverHeight: coverHeight,
    image: img$4
  }, React.createElement("div", {
    className: "t-course-player-container"
  }, href && React.createElement("a", {
    href: href,
    target: "_blank",
    className: "t-course-player-wrapper"
  }, React.createElement("img", {
    alt: "player",
    src: img$5
  }), playerText && React.createElement(TText, {
    textColor: "dark-10",
    level: 2
  }, playerText))), React.createElement("div", null, React.createElement("div", {
    className: "t-button-wrapper"
  }, React.createElement(TButton, {
    size: "large",
    fullWidth: true,
    icon: React.createElement("span", null, React.createElement(IconPencil, {
      fill: "currentcolor",
      size: "md"
    })),
    onClick: handleAdd
  }, buttonText)))));
};

const img$c = "data:image/svg+xml,%3csvg width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d)'%3e%3crect x='4' y='2' width='37' height='37' rx='12' fill='white'/%3e%3c/g%3e%3cg clipPath='url(%23clip0)'%3e%3cpath d='M21.3678 25.1271C22.5705 24.9515 24.3065 23.8752 27.1036 21.0781C31.9523 16.2293 35.7463 10.4536 34.5239 9.23115C33.3015 8.00874 27.5258 11.8027 22.6769 16.6515C19.8799 19.4486 18.8036 21.1845 18.6279 22.3873L18.9379 24.9649L21.3678 25.1271Z' fill='%23F89E00'/%3e%3cpath d='M19.5123 27.579L18.7176 25.1852L16.4579 24.5245C16.4579 24.5245 13.6654 23.822 11.9035 26.9542C10.1387 30.0836 12.4792 32.9999 12.4792 32.9999C13.2363 31.5921 13.6682 31.7361 15.3581 31.3416C17.0479 30.9472 19.5123 29.6518 19.5123 27.579Z' fill='%237C5748'/%3e%3cpath d='M17.6123 25.679L16.4578 24.5245C16.4578 24.5245 13.6653 23.822 11.9035 26.9542C10.1387 30.0836 12.4792 32.9999 12.4792 32.9999C11.3421 28.8054 16.2419 26.3641 17.6123 25.679Z' fill='%235F4C44'/%3e%3cpath d='M12.937 25.61C12.5742 25.9496 12.2229 26.3872 11.9035 26.9544C10.1387 30.0837 12.4792 33 12.4792 33C13.2363 31.5923 13.6682 31.7362 15.3581 31.3418C15.6373 31.2755 15.9396 31.1863 16.2448 31.0712C16.167 30.7919 16.1757 30.4378 16.3974 30.0088C16.3974 30.0088 15.1768 29.6519 14.3476 28.8228C14.149 28.6241 14.0367 28.4082 13.959 28.175C13.7114 27.4322 13.8554 26.5284 12.937 25.61Z' fill='%23DB1F16'/%3e%3cpath d='M12.937 25.61C12.5742 25.9496 12.2229 26.3872 11.9035 26.9544C10.1387 30.0837 12.4792 33 12.4792 33C11.9322 30.9848 12.7786 29.3784 13.9589 28.175C13.7114 27.4322 13.8554 26.5284 12.937 25.61Z' fill='%23B22627'/%3e%3cpath d='M21.5729 25.3319L18.4231 22.1821C18.1735 21.9325 17.7687 21.9325 17.5191 22.1821L16.2693 23.4319C16.0196 23.6816 16.0196 24.0864 16.2693 24.336L19.4191 27.4858C19.6687 27.7355 20.0735 27.7355 20.3231 27.4858L21.5729 26.236C21.8226 25.9863 21.8226 25.5816 21.5729 25.3319Z' fill='%23C0C9D2'/%3e%3cpath d='M17.5403 24.6902L18.7772 23.4532C19.0304 23.2001 19.4409 23.2001 19.6941 23.4532L18.4297 22.1888C18.1765 21.9356 17.766 21.9356 17.5128 22.1888L16.2758 23.4258C16.0226 23.6789 16.0226 24.0894 16.2758 24.3427L17.5403 25.6071C17.2871 25.3539 17.2871 24.9434 17.5403 24.6902Z' fill='%23A6AEBA'/%3e%3cpath d='M23.7845 17.7591C20.9874 20.5562 19.746 22.1271 19.3132 23.0727L18.6279 22.3874C18.8036 21.1846 19.8798 19.4487 22.6769 16.6516C27.5257 11.8028 33.3015 8.0089 34.5239 9.23126C33.9131 8.62043 28.6333 12.9104 23.7845 17.7591Z' fill='%23D38302'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d' x='0' y='0' width='45' height='45' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e%3cfeOffset dy='2'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.466667 0 0 0 0 0.431373 0 0 0 0 0.670588 0 0 0 0.12 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3e%3c/filter%3e%3cclipPath id='clip0'%3e%3crect width='24' height='24' fill='white' transform='translate(11 9)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

const img$d = "data:image/png;base64,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";

var css_248z$1c = ".t-website-create-card {\n  padding: 16px;\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  display: flex;\n  justify-content: space-between;\n  background: #ffffff;\n  height: 152px;\n}\n@media screen and (max-width: 576px) {\n  .t-website-create-card {\n    flex-direction: column;\n    align-items: center;\n    height: unset;\n    margin-bottom: 16px;\n  }\n}\n.t-website-create-card .t-website-info-wrapper {\n  display: flex;\n  align-items: flex-start;\n}\n.t-website-create-card .t-website-info-wrapper img {\n  margin-right: 12px;\n}\n.t-website-create-card .t-website-info-wrapper .t-website-info-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-right: 16px;\n}\n@media screen and (max-width: 576px) {\n  .t-website-create-card .t-website-info-wrapper .t-website-info-text-wrapper {\n    max-width: 100%;\n    text-align: center;\n    align-items: center;\n  }\n}\n@media screen and (max-width: 768px) {\n  .t-website-create-card .t-website-info-wrapper .t-website-info-text-wrapper {\n    margin-bottom: 16px;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1600px) {\n  .t-website-create-card .t-website-image-wrapper img {\n    height: 120px;\n    width: 12vw;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n}\n";
styleInject(css_248z$1c);

const TWebsiteCreateCard = ({
  title,
  description,
  height,
  hrefText,
  href,
  target
}) => {
  return React.createElement("div", {
    style: {
      height: `${height}`
    },
    className: "t-website-create-card"
  }, React.createElement("div", {
    className: "t-website-info-wrapper"
  }, React.createElement("img", {
    src: img$c,
    alt: "painter"
  }), React.createElement("div", {
    className: "t-website-info-text-wrapper"
  }, React.createElement(TText, {
    textColor: "primary",
    rows: 1,
    level: 1,
    paddingBottom: 3,
    bold: true
  }, title), React.createElement(TText, {
    textColor: "dark-100",
    level: 3,
    rows: 2,
    paddingBottom: 1
  }, description), React.createElement(TText, {
    underline: true,
    textColor: "primary",
    level: 3,
    rows: 2
  }, React.createElement(TLink, {
    href: href,
    title: hrefText,
    target: target
  })))), React.createElement("div", {
    className: "t-website-image-wrapper"
  }, React.createElement("img", {
    src: img$d
  })));
};

var css_248z$1d = ".t-icon-text {\n  display: flex;\n  border-radius: var(--border-radius, 8px);\n  align-items: center;\n  cursor: pointer;\n}\n.t-icon-text .t-icon-left {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n}\n.t-icon-text .t-icon-left svg:hover path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-icon-text .t-icon-right {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n}\n.t-icon-text .t-icon-right svg:hover path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-icon-background {\n  background: #f2f2f3;\n}\n";
styleInject(css_248z$1d);

const TIconText = _a => {
  var {
    textSize = 1,
    type = 'primary',
    htmlType = 'submit',
    placement = 'left',
    onClick,
    background,
    icon,
    rows,
    bold = false,
    textColor = 'dark-100'
  } = _a,
      props = __rest(_a, ["textSize", "type", "htmlType", "placement", "onClick", "background", "icon", "rows", "bold", "textColor"]);

  const classNames = ['t-icon-text'];

  if (!!background) {
    classNames.push('t-icon-background');
  }

  if (!!textSize) {
    classNames.push(`t-icon-text-${textSize}`);
  }

  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onClick
  }, placement === 'left' && React.createElement("span", {
    className: "t-icon-left"
  }, icon), React.createElement(TText, {
    bold: bold,
    rows: rows,
    textColor: textColor,
    level: textSize
  }, props.children), placement === 'right' && React.createElement("span", {
    className: "t-icon-right"
  }, icon));
};

const img$e = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALbSURBVHgB7Zk/TBNxFMffXa+FBk1IRAdZLIsMCC6EAQbaziCTyuBUXIXdgcnZ1lWMJib+m/wzFx10MAwWZcDpWHRQSUwMCe3Rnu/7er+zrULuelJ+JP0mv9z112vf577v996vHEQtcl13msdtHrbbOX3gcZ/HOdpP/Ga/B3bUAkO/4jIUHB9e87hIeqjEI20Yxk/Tm1gmfeAgsICJDLeed5v0VBoOLpO+mgOgTqlt1SWk2CWNZZLm6gJGlfaAFkVUbeMr7RU3qbrxhdxvv2TOSJ2iWOo0WdlhMkfOUhS1XcWAKReKAnhggDMnqffWnBzbUVuAcMy5947cnTIZfT1kzY6SlRn2IWr2D6p9YmdfrVONbwTXxHOT4uihAwKucmdVzgEWvzouAP8SXHZerjPoR3mduJEJDRlqDUpAdg6Kz48LnJpHul17W1yNTaQosTAljsrxRA85j9fks+bQAJmpgcAxQzm4e/2hpAzOJXJTPtzu0jMBa/pidrU3f9lPe2XlrTiJAkrmrwQNGbzN7K1u1tcTB1TOqcCAQ+qSj3KUvHtNzjEHV5XguMmfhctYJv8fkFMkgVrWXPW93TQvN8AFAQFGSYppvn5jzpM1CqrIjdqH7Uv8mdypyKE17e0oMGDj3TcGxpqCJNW8BPCe47ltTQz512G+MQtBFa5Ilp5yj9sma2ZUqlMChy0Sfo11GlShUpxYzEpgBFIuyU7BIGgtCgzbWyMcrhU4QPOuEkbhGzVXc6XgNWp2Mj47tu82ptLtN+rFjOw4hwqoIJ0Vb6tD1c6MUezCoL8ekXa0EoCp7TC+MBkarm1ABVG++Vx640FCunuwNDr5Y6FR+JlVLX7m4vkuBSRfyjCxkUGKZc/LMYq6fzRFVRcwqo4F4BbpqxIAX5C+KqHNTFP94aWOSpn8FPMNnxRIPxWYbet4PALGCSZIDyfBkPaY/hYeCfN44Nb/NdAp2TzyXj006TcNs9hWisbpDQAAAABJRU5ErkJggg==";

var css_248z$1e = ".t-image-choose-card-wrapper {\n  position: relative;\n}\n.t-image-choose-card-wrapper .t-card-container {\n  transition: 0.3s;\n}\n.t-image-choose-card-wrapper .t-choose-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.3s;\n}\n.t-image-choose-card-wrapper .t-choose-card-buttons {\n  display: none;\n}\n.t-image-choose-card-wrapper .t-template-name {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n}\n.t-image-choose-card-wrapper:hover .t-choose-image {\n  -webkit-filter: brightness(0.5);\n  filter: brightness(0.5);\n}\n.t-image-choose-card-wrapper:hover .t-choose-card-buttons {\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.t-image-choose-card-wrapper:hover .t-choose-card-buttons .t-choose-card-viewIcon {\n  margin-left: 6px;\n  cursor: pointer;\n}\n.t-image-choose-card-selected {\n  border-radius: var(--border-radius, 8px);\n  border: 2px solid var(--primary-color, #f54e95);\n}\n.t-choose-image-full-screen-container {\n  background: #000000a1;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  position: fixed;\n}\n.t-choose-image-full-screen-container .t-choose-image-full-screen {\n  position: fixed;\n  object-fit: contain;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  width: 80%;\n  height: 80%;\n}\n";
styleInject(css_248z$1e);

const TImageChooseCard = ({
  src,
  height,
  buttonText,
  handleChoose,
  value,
  selected,
  fullScreenButton = true,
  templateName,
  url
}) => {
  const [fullScreen, setFullScreen] = React.useState(false);
  const classNames = ['t-image-choose-card-wrapper', selected && `t-image-choose-card-selected`];

  const makeFullScreen = () => {
    setFullScreen(!fullScreen);
  };

  const onChange = () => {
    handleChoose(value);
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(TCardContainer, {
    background: "light-100"
  }, React.createElement("img", {
    className: "t-choose-image",
    src: src,
    style: {
      height
    }
  }), React.createElement("div", {
    className: "t-choose-card-buttons"
  }, React.createElement(TButton, {
    size: "large",
    onClick: onChange
  }, buttonText), url && React.createElement("div", {
    className: "t-choose-card-viewIcon"
  }, React.createElement("a", {
    href: url,
    target: "_blank"
  }, React.createElement("img", {
    src: img$e
  }))), fullScreenButton && !url && React.createElement("div", {
    className: "t-choose-card-viewIcon",
    onClick: makeFullScreen
  }, React.createElement("img", {
    src: img$e
  }))), React.createElement("div", {
    className: "t-template-name"
  }, React.createElement(TText, null, templateName)))), fullScreen && React.createElement("div", {
    className: "t-choose-image-full-screen-container",
    onClick: () => setFullScreen(false)
  }, React.createElement("img", {
    className: "t-choose-image-full-screen",
    src: src
  })));
};

var css_248z$1f = ".t-dropdown-trigger-default .ant-btn-default:nth-child(1) {\n  display: none;\n}\n.t-dropdown-menu {\n  padding: 8px;\n}\n";
styleInject(css_248z$1f);

const TDropdownButton = ({
  actions,
  icon,
  children
}) => {
  const menu = React.createElement(_Menu, {
    className: "t-dropdown-menu"
  }, actions === null || actions === void 0 ? void 0 : actions.map((item, index) => {
    return React.createElement(_Menu.Item, {
      key: index
    }, item);
  }));
  const classNames = [!children && 't-dropdown-trigger-default'];
  return React.createElement(_Dropdown.Button, {
    className: classNames.join(' '),
    icon: icon,
    overlay: menu
  }, children);
};

var css_248z$1g = ".t-progress-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.t-progress-card-header .t-dropdown-trigger-default .ant-dropdown-trigger {\n  border: none;\n  box-shadow: none;\n  margin-left: 24px;\n}\n";
styleInject(css_248z$1g);

const TProgressCard = ({
  avatarImage,
  title,
  progresses = [],
  actions
}) => {
  const progressColor = {
    attendance: '#3BE3C5',
    performance: '#9696FF'
  };
  return React.createElement(TCardContainer, {
    background: "white"
  }, React.createElement(Wrapper$2, {
    mb: 2
  }, React.createElement("div", {
    className: "t-progress-card-header"
  }, React.createElement(TAvatar, {
    boldText: true,
    src: avatarImage,
    name: title,
    text: title
  }), !!actions && React.createElement(TDropdownButton, {
    icon: React.createElement(IconMoreActions, {
      size: "md"
    }),
    actions: actions
  }))), progresses.map((item, index) => {
    return React.createElement(Wrapper$2, {
      pt: 2,
      key: index
    }, React.createElement(TProgress, {
      status: "active",
      label: item.name,
      percent: item.percent,
      strokeColor: progressColor[item.type]
    }));
  }));
};

var css_248z$1h = ".t-action-card-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.t-action-card-wrapper .t-action-card-title-wrapper {\n  width: max-content;\n}\n";
styleInject(css_248z$1h);

const TActionCard = ({
  action,
  title
}) => {
  return React.createElement(TCardContainer, {
    borderd: true
  }, React.createElement("div", {
    className: "t-action-card-wrapper"
  }, React.createElement("div", {
    className: "t-action-card-title-wrapper"
  }, React.createElement(TText, {
    bold: true,
    level: 2,
    rows: 1,
    textColor: "dark-100"
  }, title)), React.createElement("div", {
    className: "t-action-wrapper"
  }, action)));
};

const img$f = "data:image/jpeg;base64,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";

var css_248z$1i = ".t-checkout {\n  position: relative;\n}\n.t-checkout .t-title {\n  color: var(--text-dark-50, #909091);\n}\n.t-checkout .t-price {\n  text-align: right;\n}\n.t-checkout .t-divider {\n  margin: 5px 0;\n}\n.t-checkout .t-payments-wrapper {\n  text-align: center;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.t-checkout .t-payments-wrapper .t-payment {\n  cursor: pointer;\n  width: 200px;\n  height: 150px;\n  margin-left: auto;\n  margin-right: auto;\n  border: 1px solid var(--text-dark-10, #e6e6e7);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  margin-top: 16px;\n}\n.t-checkout .t-payments-wrapper .t-payment img {\n  max-width: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  position: relative;\n}\n.t-checkout .t-payments-wrapper .t-payment.t-payment-omise {\n  padding: 16px;\n}\n";
styleInject(css_248z$1i);

const TArca = ({
  onSelect
}) => {
  return React.createElement("div", {
    className: "t-payment t-payment-arca",
    onClick: () => onSelect('arca')
  }, React.createElement("img", {
    src: img$f,
    alt: "arca"
  }));
};

var pure = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.13.1",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
};
var validateLoadParams = function validateLoadParams(params) {
  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");

  if (params === null || _typeof(params) !== 'object') {
    throw new Error(errorMessage);
  }

  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') {
    return params;
  }

  throw new Error(errorMessage);
};

var loadParams;
var loadStripeCalled = false;
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadStripeCalled = true;
  var startTime = Date.now();
  return loadScript(loadParams).then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};

loadStripe.setLoadParameters = function (params) {
  if (loadStripeCalled) {
    throw new Error('You cannot change load parameters after calling loadStripe');
  }

  loadParams = validateLoadParams(params);
};

exports.loadStripe = loadStripe;
});

var pure$1 = pure;

const img$g = "data:image/png;base64,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";

pure$1.loadStripe.setLoadParameters({
  advancedFraudSignals: false
});

const TArca$1 = ({
  onSelect
}) => {
  return React.createElement("div", {
    className: "t-payment t-payment-stripe",
    onClick: () => onSelect('stripe')
  }, React.createElement("img", {
    src: img$g,
    alt: "Stripe"
  }));
};

const redirectToPayment = ({
  publishableKey,
  sessionId
}, onError) => __awaiter(void 0, void 0, void 0, function* () {
  const stripe = yield pure$1.loadStripe(publishableKey);
  const {
    error
  } = yield stripe.redirectToCheckout({
    sessionId
  });

  if (error) {
    onError(`Strapi redirectToCheckout failed ERROR: ${error && error.message}`);
  }
});

const img$h = "data:image/png;base64,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";

const TOmise = ({
  onSelect
}) => {
  return React.createElement("div", {
    className: "t-payment t-payment-omise",
    onClick: () => onSelect('omise')
  }, React.createElement("img", {
    src: img$h,
    alt: "Omise"
  }));
};

const redirectToPayment$1 = ({
  redirect
}, onError) => __awaiter(void 0, void 0, void 0, function* () {
  if (!redirect) {
    onError('Omise redirectToCheckout failed');
  } else {
    window.location = redirect;
  }
});

const TCheckout = ({
  items = [],
  totalTitle,
  totalPrice,
  paymentTypes = [],
  onPaymentSelect,
  response,
  loading = false,
  onError = () => {}
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  useEffect(() => {
    if (response) {
      switch (response.type) {
        case PaymentTypes.ARCA:
          window.location = response.redirect;
          break;

        case PaymentTypes.STRIPE:
          redirectToPayment(response, onError);
          break;

        case PaymentTypes.OMISE:
          redirectToPayment$1(response, onError);
          break;

        default:
          onError('Non Supported payment method for order checkout');
      }
    }
  }, [response]);
  return React.createElement("div", {
    className: "t-checkout"
  }, loading && React.createElement(TLoading, {
    overlay: true
  }), items.map((item, index) => React.createElement(_Row, {
    key: index
  }, React.createElement(_Col, {
    span: 18,
    className: "t-title"
  }, item.title), React.createElement(_Col, {
    span: 6,
    className: "t-price"
  }, item.price))), React.createElement(_Divider, {
    className: "t-divider"
  }), totalTitle && React.createElement(_Row, null, React.createElement(_Col, {
    span: 18,
    className: "t-title"
  }, totalTitle), React.createElement(_Col, {
    span: 6,
    className: "t-price"
  }, totalPrice)), React.createElement("div", {
    className: "t-payments-wrapper"
  }, !paymentTypes.length && React.createElement(TText, null, translate('ui.no.payments.text')), paymentTypes.map(item => {
    switch (item) {
      case PaymentTypes.ARCA:
        return React.createElement(TArca, {
          key: item,
          onSelect: onPaymentSelect
        });

      case PaymentTypes.STRIPE:
        return React.createElement(TArca$1, {
          key: item,
          onSelect: onPaymentSelect
        });

      case PaymentTypes.OMISE:
        return React.createElement(TOmise, {
          key: item,
          onSelect: onPaymentSelect
        });

      default:
        return null;
    }
  })));
};

const TScheduleViewerCard = ({
  title,
  data,
  isFlexible
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  const props = {};

  if (!isEmpty(data)) {
    props.mb = 1;
  }

  return React.createElement(TCardContainer, {
    borderd: true
  }, React.createElement(Wrapper$2, Object.assign({}, props), title), !!isFlexible && React.createElement(Wrapper$2, {
    pt: 3,
    pl: 3
  }, React.createElement(TText, {
    rows: 1,
    level: 3
  }, translate('ui.flexible.schedule'))), !isEmpty(data) && React.createElement(_Row, {
    gutter: [8, 8]
  }, data.map((item, index) => React.createElement(_Col, {
    span: 12,
    key: index
  }, React.createElement(TText, {
    bold: true,
    level: 3,
    rows: 1
  }, item.weekDay), React.createElement(TText, {
    level: 3,
    rows: 1
  }, item.start, " - ", item.end)))));
};

var css_248z$1j = ".t-preview-list-item-hover:hover {\n  background: #fbfbfc;\n  cursor: pointer;\n}\n";
styleInject(css_248z$1j);

const TPreviewListItem = ({
  onItemClick,
  name,
  actions,
  avatar,
  hover = false
}) => {
  const classNames = [];

  if (!!hover) {
    classNames.push('t-preview-list-item-hover');
  }

  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onItemClick
  }, React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    divider: true,
    py: 1
  }, React.createElement("div", null, React.createElement(TAvatar, {
    src: avatar,
    name: name,
    text: name
  })), React.createElement("div", null, actions)));
};

const TStudentsList = ({
  data = [],
  fallback,
  hover = true,
  onItemClick = () => {}
}) => {
  return React.createElement(React.Fragment, null, !!data.length ? data.map((item, index) => React.createElement("div", {
    key: index
  }, React.createElement(TPreviewListItem, {
    hover: hover,
    actions: item.actions,
    name: item.name,
    avatar: item.avatar,
    onItemClick: () => onItemClick(item)
  }), data.length - 1 !== index && React.createElement(_Divider, {
    style: {
      margin: 0
    }
  }))) : React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, fallback));
};

var css_248z$1k = ".t-tabs-container-top .t-tabs .ant-tabs-nav {\n  border-radius: var(--border-radius, 8px) var(--border-radius, 8px) 0px 0px;\n  background: #fff;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab {\n  color: var(--text-dark-50, #909091);\n  padding: 24px 0 12px 0;\n  margin: 0 24px 0 0;\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--primary-color, #f54e95);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-ink-bar {\n  background: var(--primary-color, #f54e95);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab:hover {\n  color: var(--text-dark-100, #262626);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn p,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus p,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus p,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active p,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active p {\n  color: var(--primary-color, #f54e95);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn svg,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus svg,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus svg,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active svg,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active svg {\n  color: var(--primary-color, #f54e95);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn svg path,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus svg path,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus svg path,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active svg path,\n.t-tabs-container-top .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-tabs-container-top .t-tabs .ant-tabs-nav::before {\n  border: none;\n}\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab {\n  padding: 8px 16px 8px 16px;\n}\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn p,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus p,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus p,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active p,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active p {\n  color: var(--primary-color, #f54e95);\n}\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn svg,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus svg,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus svg,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active svg,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active svg {\n  color: var(--primary-color, #f54e95);\n}\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn svg path,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:focus svg path,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:focus svg path,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-btn:active svg path,\n.t-tabs-container-left .t-tabs .ant-tabs-nav .ant-tabs-tab-remove:active svg path {\n  fill: var(--primary-color, #f54e95);\n}\n";
styleInject(css_248z$1k);

const {
  TabPane: TabPane$1
} = _Tabs;

const TTabs = ({
  data,
  centered,
  defaultActiveKey,
  size = 'default',
  tabPosition = 'top',
  height = 'auto',
  tabBarStyle = {},
  tabBarExtraContent
}) => {
  const classNames = [];

  if (tabPosition === 'left') {
    classNames.push('t-tabs-container-left');
  }

  if (tabPosition === 'top') {
    classNames.push('t-tabs-container-top');
  }

  return React.createElement("div", {
    className: classNames.join('')
  }, React.createElement(_Tabs, {
    defaultActiveKey: defaultActiveKey,
    tabBarExtraContent: tabBarExtraContent,
    size: size,
    className: "t-tabs",
    style: {
      height: height
    },
    centered: centered,
    tabPosition: tabPosition,
    tabBarStyle: tabBarStyle
  }, data.map((i, index) => React.createElement(TabPane$1, {
    tab: i.tabName,
    key: index,
    disabled: i.disabled
  }, i.content))));
};

var css_248z$1l = ".t-info-card-main-container {\n  display: flex;\n  justify-content: space-between;\n}\n@media screen and (max-width: 767px) {\n  .t-info-card-main-container {\n    display: flex;\n    justify-content: center;\n  }\n}\n.t-info-card-main-container .t-info-card-container {\n  display: flex;\n  height: 130px;\n}\n.t-info-card-main-container .t-info-card-container .t-info-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n@media screen and (max-width: 767px) {\n  .t-info-card-main-container .t-info-card-container .t-info-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 767px) {\n  .t-info-card-main-container .t-info-card-container {\n    flex-direction: column;\n    text-align: center;\n    height: auto;\n  }\n}\n.t-info-card-main-container .t-info-card-container .t-info-img-wrapper {\n  display: 'flex';\n  justify-content: 'center';\n  align-items: 'center';\n  margin-right: 16px;\n}\n.t-info-card-main-container .t-info-card-container .t-info-img-wrapper .t-avatar-container span {\n  font-size: 44px;\n}\n@media screen and (max-width: 767px) {\n  .t-info-card-main-container .t-info-card-container .t-info-img-wrapper {\n    margin: 0 auto;\n    margin-bottom: 16px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .t-info-card-main-container .t-info-card-container .t-subject-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n.t-skeleton-info-card-container {\n  display: flex;\n}\n.t-skeleton-info-card-container .t-skeleton-cover-image-skeleton .ant-skeleton-avatar-circle {\n  width: 116px;\n  height: 116px;\n}\n";
styleInject(css_248z$1l);

const InfoCardSkeleton = () => {
  return React.createElement(TCardContainer, null, React.createElement("div", {
    className: "t-skeleton-info-card-container"
  }, React.createElement(Wrapper$2, {
    mr: 1
  }, React.createElement(_Skeleton.Avatar, {
    active: true,
    className: "t-skeleton-cover-image-skeleton"
  })), React.createElement(_Skeleton, {
    round: true,
    active: true,
    paragraph: {
      rows: 2
    }
  })));
};

const TInfoCard = ({
  data
}) => {
  const {
    title = '',
    avatarName = '',
    description = '',
    image = '',
    subject = '',
    actions,
    indicator,
    subjectFontWeight = 'bold',
    disableTitleHover = false,
    moreInfo,
    onClick = () => {}
  } = data;
  const subjectFontWeightProps = subjectFontWeight === 'bold' ? {
    bold: true
  } : subjectFontWeight === 'semiBold' ? {
    semiBold: true
  } : {};

  function renderInfoCard() {
    return React.createElement("div", {
      className: "t-info-card-container",
      onClick: onClick
    }, React.createElement("div", {
      className: "t-info-img-wrapper"
    }, React.createElement(TAvatar, {
      name: avatarName,
      size: "xxxl",
      textLevel: 4,
      src: image
    })), React.createElement("div", {
      className: "t-info-wrapper"
    }, React.createElement(Wrapper$2, {
      mb: 2
    }, React.createElement(TText, {
      hover: !disableTitleHover,
      rows: 2,
      bold: true
    }, title), moreInfo && React.createElement(Wrapper$2, {
      display: "flex",
      textAlign: "center",
      py: 3
    }, moreInfo), !!subject && typeof subject === 'string' ? React.createElement("div", {
      className: "t-subject-wrapper"
    }, React.createElement(TText, Object.assign({}, subjectFontWeightProps, {
      rows: 1,
      level: 3,
      textColor: "dark-50"
    }), subject)) : subject), !!description && React.createElement(TText, {
      level: 3,
      rows: 2
    }, description)));
  }

  return React.createElement(TCardContainer, {
    highlighted: data.highlighted
  }, React.createElement("div", {
    className: "t-info-card-main-container"
  }, renderInfoCard(), React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "end",
    flexDirecton: "column",
    justifyContent: "space-between",
    ml: 1
  }, !!actions && React.createElement(Wrapper$2, {
    display: "inline",
    justifyContent: "center",
    pt: 1
  }, actions), !!indicator && React.createElement(Wrapper$2, {
    display: "inline",
    justifyContent: "center",
    pt: 1
  }, indicator))));
};

var InfoCard = withSkeleton(TInfoCard, InfoCardSkeleton);

const InfoCardListSkeleton = ({
  row,
  col
}) => {
  return React.createElement(_Row, Object.assign({}, row), Array(12).fill(undefined).map((item, index) => React.createElement(_Col, Object.assign({}, col, {
    key: index
  }), React.createElement(InfoCardSkeleton, null))));
};

const InfoCardList = ({
  infoList,
  renderItem,
  grid
}) => {
  return React.createElement(_Row, Object.assign({}, grid === null || grid === void 0 ? void 0 : grid.row), infoList.map((item, index) => {
    if (renderItem) {
      if (grid === null || grid === void 0 ? void 0 : grid.col) {
        return React.createElement(_Col, Object.assign({
          key: index
        }, grid.col), renderItem(item, index));
      }

      return renderItem(item, index);
    }

    return React.createElement(_Col, Object.assign({}, grid === null || grid === void 0 ? void 0 : grid.col, {
      key: item.id
    }), React.createElement(InfoCard, {
      data: item
    }));
  }));
};

var InfoCardList$1 = withSkeleton(InfoCardList, InfoCardListSkeleton);

var css_248z$1m = ".t-skeleton-teacher-profile-card-container .t-skeleton-cover-image {\n  border-top-left-radius: var(--border-radius, 8px);\n  border-top-right-radius: var(--border-radius, 8px);\n  width: 100%;\n  height: 300px;\n}\n.t-teacher-profile-cover-photo {\n  border-radius: 8px 8px 0 0;\n  height: 100%;\n}\n.t-teacher-profile-cover-photo img {\n  border-radius: 8px 8px 0 0;\n}\n.t-teacher-profile-cover-photo iframe {\n  border-radius: 8px 8px 0 0;\n}\n";
styleInject(css_248z$1m);

const TTeacherProfileCardSkeleton = () => {
  return React.createElement("div", {
    className: "t-skeleton-teacher-profile-card-container"
  }, React.createElement(TImageCard, {
    cover: React.createElement(_Skeleton.Image, {
      className: "t-skeleton-cover-image"
    })
  }, React.createElement(Wrapper$2, {
    mb: 1,
    display: "flex",
    alignItems: "center"
  }, React.createElement(Wrapper$2, {
    mr: 1
  }, React.createElement(_Skeleton.Avatar, {
    size: "large"
  })), React.createElement(_Skeleton, {
    round: true,
    active: true,
    paragraph: {
      rows: 1
    }
  }))));
};

const img$i = "data:image/png;base64,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";

var loadScript = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};
  cb = cb || function() {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes$1(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb);

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes$1(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isMediaStream = isMediaStream;
exports.isBlobUrl = isBlobUrl;
exports.supportsWebKitPresentationMode = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(loadScript);

var _deepmerge = _interopRequireDefault(cjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video');
  // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function
  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}
});

var patterns = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;



function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
var MATCH_URL_VIMEO = /vimeo\.com\/.+/;
exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-]+)/;
exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_]+)$/;
exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlayFile(item)) {
          return true;
        }

        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, utils.isMediaStream)(url) || (0, utils.isBlobUrl)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};

var canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return MATCH_URL_YOUTUBE.test(item);
      });
    }

    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
  },
  facebook: function facebook(url) {
    return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};
exports.canPlay = canPlay;
});

var YouTube_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "parsePlaylist", function (url) {
      if (url instanceof Array) {
        return {
          listType: 'playlist',
          playlist: url.map(_this.getID).join(',')
        };
      }

      if (MATCH_PLAYLIST.test(url)) {
        var _url$match = url.match(MATCH_PLAYLIST),
            _url$match2 = _slicedToArray(_url$match, 2),
            playlistId = _url$match2[1];

        return {
          listType: 'playlist',
          list: playlistId.replace(/^UC/, 'UU')
        };
      }

      if (MATCH_USER_UPLOADS.test(url)) {
        var _url$match3 = url.match(MATCH_USER_UPLOADS),
            _url$match4 = _slicedToArray(_url$match3, 2),
            username = _url$match4[1];

        return {
          listType: 'user_uploads',
          list: username
        };
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
      var data = event.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop,
          _this$props$config = _this$props.config,
          playerVars = _this$props$config.playerVars,
          onUnstarted = _this$props$config.onUnstarted;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;
      if (data === UNSTARTED) onUnstarted();

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist'); // Only loop manually if not playing a playlist

        if (loop && !isPlaylist) {
          if (playerVars.start) {
            _this.seekTo(playerVars.start);
          } else {
            _this.play();
          }
        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "getID",
    value: function getID(url) {
      if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
        return null;
      }

      return url.match(patterns.MATCH_URL_YOUTUBE)[1];
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var playerVars = config.playerVars,
          embedOptions = config.embedOptions;
      var id = this.getID(url);

      if (isReady) {
        if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
          this.player.loadPlaylist(this.parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread(_objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, utils.parseStartTime)(url),
            end: (0, utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline ? 1 : 0
          }, _this2.parsePlaylist(url)), playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          },
          host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
        }, embedOptions));
      }, _onError);

      if (embedOptions.events) {
        console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause');
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports["default"] = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", patterns.canPlay.youtube);
});

var SoundCloud_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, function () {
            var remaining = _this2.duration - _this2.currentTime;

            if (remaining < 0.05) {
              // Prevent onPause firing right before onEnded
              return;
            }

            _this2.props.onPause();
          });

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread(_objectSpread({}, _this2.props.config.options), {}, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports["default"] = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", patterns.canPlay.soundcloud);

_defineProperty(SoundCloud, "loopOnEnded", true);
});

var Vimeo_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, _this2.props.config.playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });

        _this2.player.on('bufferstart', _this2.props.onBuffer);

        _this2.player.on('bufferend', _this2.props.onBufferEnd);
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports["default"] = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "canPlay", patterns.canPlay.vimeo);

_defineProperty(Vimeo, "forceLoad", true);
});

var Facebook_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.appId,
          xfbml: true,
          version: _this2.props.config.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (_this2.props.muted) {
              _this2.callPlayer('mute');
            } else {
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var attributes = this.props.config.attributes;
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      }, attributes));
    }
  }]);

  return Facebook;
}(_react.Component);

exports["default"] = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", patterns.canPlay.facebook);

_defineProperty(Facebook, "loopOnEnded", true);
});

var Streamable_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(patterns.MATCH_URL_STREAMABLE)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports["default"] = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", patterns.canPlay.streamable);
});

var Wistia_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var PLAYER_ID_PREFIX = 'wistia-player-';

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props5 = this.props,
          playing = _this$props5.playing,
          muted = _this$props5.muted,
          controls = _this$props5.controls,
          _onReady = _this$props5.onReady,
          config = _this$props5.config,
          onError = _this$props5.onError;
      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Wistia) {
        if (config.customControls) {
          config.customControls.forEach(function (control) {
            return Wistia.defineControl(control);
          });
        }

        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.playerID,
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls,
            fullscreenButton: controls,
            playbar: controls,
            playbackRateControl: controls,
            qualityControl: controls,
            volumeControl: controls,
            settingsControl: controls,
            smallPlayButton: controls
          }, config.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.props.url;
      var videoID = url && url.match(patterns.MATCH_URL_WISTIA)[1];
      var className = "wistia_embed wistia_async_".concat(videoID);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.playerID,
        key: videoID,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports["default"] = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", patterns.canPlay.wistia);

_defineProperty(Wistia, "loopOnEnded", true);
});

var Twitch_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;

      var isChannel = patterns.MATCH_URL_TWITCH_CHANNEL.test(url);

      var id = isChannel ? url.match(patterns.MATCH_URL_TWITCH_CHANNEL)[1] : url.match(patterns.MATCH_URL_TWITCH_VIDEO)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls,
          time: (0, utils.parseStartTime)(url)
        }, config.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports["default"] = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", patterns.canPlay.twitch);

_defineProperty(Twitch, "loopOnEnded", true);
});

var DailyMotion_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(patterns.MATCH_URL_DAILYMOTION),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports["default"] = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", patterns.canPlay.dailymotion);

_defineProperty(DailyMotion, "loopOnEnded", true);
});

var Mixcloud_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(patterns.MATCH_URL_MIXCLOUD)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, utils.queryString)(_objectSpread(_objectSpread({}, config.options), {}, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports["default"] = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", patterns.canPlay.mixcloud);

_defineProperty(Mixcloud, "loopOnEnded", true);
});

var Vidyard_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://play.vidyard.com/embed/v4.js';
var SDK_GLOBAL = 'VidyardV4';
var SDK_GLOBAL_READY = 'onVidyardAPI';

var Vidyard = /*#__PURE__*/function (_Component) {
  _inherits(Vidyard, _Component);

  var _super = _createSuper(Vidyard);

  function Vidyard() {
    var _this;

    _classCallCheck(this, Vidyard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vidyard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          playing = _this$props.playing,
          config = _this$props.config,
          onError = _this$props.onError,
          onDuration = _this$props.onDuration;
      var id = url && url.match(patterns.MATCH_URL_VIDYARD)[1];

      if (this.player) {
        this.stop();
      }

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (Vidyard) {
        if (!_this2.container) return;
        Vidyard.api.addReadyListener(function (data, player) {
          _this2.player = player;

          _this2.player.on('ready', _this2.props.onReady);

          _this2.player.on('play', _this2.props.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seek', _this2.props.onSeek);

          _this2.player.on('playerComplete', _this2.props.onEnded);
        }, id);
        Vidyard.api.renderPlayer(_objectSpread({
          uuid: id,
          container: _this2.container,
          autoplay: playing ? 1 : 0
        }, config.options));
        Vidyard.api.getPlayerMetadata(id).then(function (meta) {
          _this2.duration = meta.length_in_seconds;
          onDuration(meta.length_in_seconds);
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      window.VidyardV4.api.destroyPlayer(this.player);
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seek', amount);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackSpeed', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('currentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return Vidyard;
}(_react.Component);

exports["default"] = Vidyard;

_defineProperty(Vidyard, "displayName", 'Vidyard');

_defineProperty(Vidyard, "canPlay", patterns.canPlay.vidyard);
});

var Kaltura_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Kaltura = /*#__PURE__*/function (_Component) {
  _inherits(Kaltura, _Component);

  var _super = _createSuper(Kaltura);

  function Kaltura() {
    var _this;

    _classCallCheck(this, Kaltura);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Kaltura, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.on('ready', function () {
          _this2.player.isReady = true;

          _this2.player.on('play', _this2.props.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seeked', _this2.props.onSeek);

          _this2.player.on('ended', _this2.props.onEnded);

          _this2.player.on('error', _this2.props.onError);

          _this2.player.on('timeupdate', function (_ref) {
            var duration = _ref.duration,
                seconds = _ref.seconds;
            _this2.duration = duration;
            _this2.currentTime = seconds;
          });

          _this2.player.on('buffered', function (_ref2) {
            var percent = _ref2.percent;

            if (_this2.duration) {
              _this2.secondsLoaded = _this2.duration * percent;
            }
          });

          _this2.player.setLoop(_this2.props.loop);

          if (_this2.props.muted) {
            _this2.player.mute();
          }

          setTimeout(function () {
            _this2.props.onReady();
          });
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: this.props.url,
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true,
        allow: "encrypted-media",
        referrerPolicy: "no-referrer-when-downgrade"
      });
    }
  }]);

  return Kaltura;
}(_react.Component);

exports["default"] = Kaltura;

_defineProperty(Kaltura, "displayName", 'Kaltura');

_defineProperty(Kaltura, "canPlay", patterns.canPlay.kaltura);
});

var FilePlayer_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HAS_NAVIGATOR = typeof navigator !== 'undefined';
var IS_IPAD_PRO = HAS_NAVIGATOR && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_IOS = HAS_NAVIGATOR && (/iPad|iPhone|iPod/.test(navigator.userAgent) || IS_IPAD_PRO) && !window.MSStream;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var FLV_SDK_URL = 'https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js';
var FLV_GLOBAL = 'flvjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
var MATCH_CLOUDFLARE_STREAM = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/;
var REPLACE_CLOUDFLARE_STREAM = 'https://videodelivery.net/{id}/manifest/video.m3u8';

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && (0, utils.supportsWebKitPresentationMode)(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
      this.addListeners(this.player);

      if (IS_IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer, prevProps.url);
        this.addListeners(this.player);
      }

      if (this.props.url !== prevProps.url && !(0, utils.isMediaStream)(this.props.url)) {
        this.player.srcObject = null;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playsinline = _this$props10.playsinline;
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.addEventListener('canplay', this.onReady);
      }

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player, url) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.removeEventListener('canplay', this.onReady);
      }
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.forceVideo) {
        return false;
      }

      if (props.config.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return patterns.AUDIO_EXTENSIONS.test(props.url) || props.config.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      if (this.props.config.forceHLS) {
        return true;
      }

      if (IS_IOS) {
        return false;
      }

      return patterns.HLS_EXTENSIONS.test(url) || MATCH_CLOUDFLARE_STREAM.test(url);
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return patterns.DASH_EXTENSIONS.test(url) || this.props.config.forceDASH;
    }
  }, {
    key: "shouldUseFLV",
    value: function shouldUseFLV(url) {
      return patterns.FLV_EXTENSIONS.test(url) || this.props.config.forceFLV;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config = this.props.config,
          hlsVersion = _this$props$config.hlsVersion,
          hlsOptions = _this$props$config.hlsOptions,
          dashVersion = _this$props$config.dashVersion,
          flvVersion = _this$props$config.flvVersion;

      if (this.hls) {
        this.hls.destroy();
      }

      if (this.dash) {
        this.dash.reset();
      }

      if (this.shouldUseHLS(url)) {
        (0, utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(hlsOptions);

          _this2.hls.on(Hls.Events.MANIFEST_PARSED, function () {
            _this2.props.onReady();
          });

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          if (MATCH_CLOUDFLARE_STREAM.test(url)) {
            var id = url.match(MATCH_CLOUDFLARE_STREAM)[1];

            _this2.hls.loadSource(REPLACE_CLOUDFLARE_STREAM.replace('{id}', id));
          } else {
            _this2.hls.loadSource(url);
          }

          _this2.hls.attachMedia(_this2.player);

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          if (parseInt(dashVersion) < 3) {
            _this2.dash.getDebug().setLogToBrowserConsole(false);
          } else {
            _this2.dash.updateSettings({
              debug: {
                logLevel: dashjs.Debug.LOG_LEVEL_NONE
              }
            });
          }

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseFLV(url)) {
        (0, utils.getSDK)(FLV_SDK_URL.replace('VERSION', flvVersion), FLV_GLOBAL).then(function (flvjs) {
          _this2.flv = flvjs.createPlayer({
            type: 'flv',
            url: url
          });

          _this2.flv.attachMediaElement(_this2.player);

          _this2.flv.load();

          _this2.props.onLoaded();
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if ((0, utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if ((0, utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      var useFLV = this.shouldUseFLV(url);

      if (url instanceof Array || (0, utils.isMediaStream)(url) || useHLS || useDASH || useFLV) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          url = _this$props11.url,
          playing = _this$props11.playing,
          loop = _this$props11.loop,
          controls = _this$props11.controls,
          muted = _this$props11.muted,
          config = _this$props11.config,
          width = _this$props11.width,
          height = _this$props11.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.attributes), url instanceof Array && url.map(this.renderSourceElement), config.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports["default"] = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", patterns.canPlay.file);
});

var players = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;







function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = [{
  key: 'youtube',
  name: 'YouTube',
  canPlay: patterns.canPlay.youtube,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(YouTube_1);
    });
  })
}, {
  key: 'soundcloud',
  name: 'SoundCloud',
  canPlay: patterns.canPlay.soundcloud,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(SoundCloud_1);
    });
  })
}, {
  key: 'vimeo',
  name: 'Vimeo',
  canPlay: patterns.canPlay.vimeo,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Vimeo_1);
    });
  })
}, {
  key: 'facebook',
  name: 'Facebook',
  canPlay: patterns.canPlay.facebook,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Facebook_1);
    });
  })
}, {
  key: 'streamable',
  name: 'Streamable',
  canPlay: patterns.canPlay.streamable,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Streamable_1);
    });
  })
}, {
  key: 'wistia',
  name: 'Wistia',
  canPlay: patterns.canPlay.wistia,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Wistia_1);
    });
  })
}, {
  key: 'twitch',
  name: 'Twitch',
  canPlay: patterns.canPlay.twitch,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Twitch_1);
    });
  })
}, {
  key: 'dailymotion',
  name: 'DailyMotion',
  canPlay: patterns.canPlay.dailymotion,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(DailyMotion_1);
    });
  })
}, {
  key: 'mixcloud',
  name: 'Mixcloud',
  canPlay: patterns.canPlay.mixcloud,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Mixcloud_1);
    });
  })
}, {
  key: 'vidyard',
  name: 'Vidyard',
  canPlay: patterns.canPlay.vidyard,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Vidyard_1);
    });
  })
}, {
  key: 'kaltura',
  name: 'Kaltura',
  canPlay: patterns.canPlay.kaltura,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Kaltura_1);
    });
  })
}, {
  key: 'file',
  name: 'FilePlayer',
  canPlay: patterns.canPlay.file,
  canEnablePIP: function canEnablePIP(url) {
    return patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, utils.supportsWebKitPresentationMode)()) && !patterns.AUDIO_EXTENSIONS.test(url);
  },
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(FilePlayer_1);
    });
  })
}];
exports["default"] = _default;
});

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var props = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes$1 = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes$1;

var noop = function noop() {};

var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: 'div',
  previewTabIndex: 0,
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      }
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: '0.14.16',
      dashVersion: '3.1.3',
      flvVersion: '1.5.0'
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};
exports.defaultProps = defaultProps;
});

var Player_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

var _reactFastCompare = _interopRequireDefault(reactFastCompare);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "handlePlayerMount", function (player) {
      _this.player = player;

      _this.player.load(_this.props.url);

      _this.progress();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady && this.props.stopOnUnmount) {
        this.player.stop();

        if (this.player.disablePIP) {
          this.player.disablePIP();
        }
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // If there isn’t a player available, don’t do anything
      if (!this.player) {
        return;
      } // Invoke player methods based on changed props


      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer;

      if (!(0, _reactFastCompare["default"])(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", props.propTypes);

_defineProperty(Player, "defaultProps", props.defaultProps);
});

var Preview_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';
var cache = {};

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        _this.props.onClick();
      }
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      if (cache[url]) {
        this.setState({
          image: cache[url]
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });

          cache[url] = image;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon,
          previewTabIndex = _this$props2.previewTabIndex;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick,
        tabIndex: previewTabIndex,
        onKeyPress: this.handleKeyPress
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(memoizeOne_esm);

var ReactPlayer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReactPlayer = void 0;

var _react = _interopRequireWildcard(React);

var _deepmerge = _interopRequireDefault(cjs);

var _memoizeOne = _interopRequireDefault(require$$2);

var _reactFastCompare = _interopRequireDefault(reactFastCompare);





var _Player3 = _interopRequireDefault(Player_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Preview = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(Preview_1);
  });
});
var IS_BROWSER = typeof window !== 'undefined' && window.document;
var IS_GLOBAL = typeof commonjsGlobal !== 'undefined' && commonjsGlobal.window && commonjsGlobal.window.document;
var SUPPORTED_PROPS = Object.keys(props.propTypes); // Return null when rendering on the server
// as Suspense is not supported yet

var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
  return null;
};
var customPlayers = [];

var createReactPlayer = function createReactPlayer(players, fallback) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(ReactPlayer, _Component);

    var _super = _createSuper(ReactPlayer);

    function ReactPlayer() {
      var _this;

      _classCallCheck(this, ReactPlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        showPreview: !!_this.props.light
      });

      _defineProperty(_assertThisInitialized(_this), "references", {
        wrapper: function wrapper(_wrapper) {
          _this.wrapper = _wrapper;
        },
        player: function player(_player) {
          _this.player = _player;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function (e) {
        _this.setState({
          showPreview: false
        });

        _this.props.onClickPreview(e);
      });

      _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
        _this.setState({
          showPreview: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
        _this.props.onReady(_assertThisInitialized(_this));
      });

      _defineProperty(_assertThisInitialized(_this), "getActivePlayer", (0, _memoizeOne["default"])(function (url) {
        for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
          var player = _arr[_i];

          if (player.canPlay(url)) {
            return player;
          }
        }

        if (fallback) {
          return fallback;
        }

        return null;
      }));

      _defineProperty(_assertThisInitialized(_this), "getConfig", (0, _memoizeOne["default"])(function (url, key) {
        var config = _this.props.config;
        return _deepmerge["default"].all([props.defaultProps.config, props.defaultProps.config[key] || {}, config, config[key] || {}]);
      }));

      _defineProperty(_assertThisInitialized(_this), "getAttributes", (0, _memoizeOne["default"])(function (url) {
        return (0, utils.omit)(_this.props, SUPPORTED_PROPS);
      }));

      _defineProperty(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
        if (!url) return null;

        var player = _this.getActivePlayer(url);

        if (!player) return null;

        var config = _this.getConfig(url, player.key);

        return /*#__PURE__*/_react["default"].createElement(_Player3["default"], _extends({}, _this.props, {
          key: player.key,
          ref: _this.references.player,
          config: config,
          activePlayer: player.lazyPlayer || player,
          onReady: _this.handleReady
        }));
      });

      return _this;
    }

    _createClass(ReactPlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _reactFastCompare["default"])(this.props, nextProps) || !(0, _reactFastCompare["default"])(this.state, nextState);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var light = this.props.light;

        if (!prevProps.light && light) {
          this.setState({
            showPreview: true
          });
        }

        if (prevProps.light && !light) {
          this.setState({
            showPreview: false
          });
        }
      }
    }, {
      key: "renderPreview",
      value: function renderPreview(url) {
        if (!url) return null;
        var _this$props = this.props,
            light = _this$props.light,
            playIcon = _this$props.playIcon,
            previewTabIndex = _this$props.previewTabIndex;
        return /*#__PURE__*/_react["default"].createElement(Preview, {
          url: url,
          light: light,
          playIcon: playIcon,
          previewTabIndex: previewTabIndex,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            url = _this$props2.url,
            style = _this$props2.style,
            width = _this$props2.width,
            height = _this$props2.height,
            fallback = _this$props2.fallback,
            Wrapper = _this$props2.wrapper;
        var showPreview = this.state.showPreview;
        var attributes = this.getAttributes(url);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          ref: this.references.wrapper,
          style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height
          })
        }, attributes), /*#__PURE__*/_react["default"].createElement(UniversalSuspense, {
          fallback: fallback
        }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
      }
    }]);

    return ReactPlayer;
  }(_react.Component), _defineProperty(_class, "displayName", 'ReactPlayer'), _defineProperty(_class, "propTypes", props.propTypes), _defineProperty(_class, "defaultProps", props.defaultProps), _defineProperty(_class, "addCustomPlayer", function (player) {
    customPlayers.push(player);
  }), _defineProperty(_class, "removeCustomPlayers", function () {
    customPlayers.length = 0;
  }), _defineProperty(_class, "canPlay", function (url) {
    for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
      var _Player = _arr2[_i2];

      if (_Player.canPlay(url)) {
        return true;
      }
    }

    return false;
  }), _defineProperty(_class, "canEnablePIP", function (url) {
    for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
      var _Player2 = _arr3[_i3];

      if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
        return true;
      }
    }

    return false;
  }), _temp;
};

exports.createReactPlayer = createReactPlayer;
});

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _players = _interopRequireDefault(players);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Fall back to FilePlayer if nothing else can play the URL
var fallback = _players["default"][_players["default"].length - 1];

var _default = (0, ReactPlayer.createReactPlayer)(_players["default"], fallback);

exports["default"] = _default;
});

var ReactPlayer$1 = /*@__PURE__*/getDefaultExportFromCjs(lib$1);

const TTeacherProfileCard = ({
  teacher,
  coverHeight = '300px'
}) => {
  const {
    name = '',
    avatarName = '',
    image = '',
    email = '',
    subject = '',
    video = '',
    moreInfo,
    actions
  } = teacher;
  return React.createElement("div", {
    className: "t-teacher-profile-container"
  }, React.createElement(TImageCard, {
    coverHeight: coverHeight,
    cover: !video ? React.createElement("div", {
      className: "t-teacher-profile-cover-photo"
    }, React.createElement("img", {
      src: img$i,
      style: {
        height: coverHeight,
        objectFit: 'cover',
        width: '100%'
      }
    })) : React.createElement("div", {
      className: "t-teacher-profile-cover-photo"
    }, React.createElement(ReactPlayer$1, {
      controls: true,
      width: "100%",
      height: "100%",
      url: video
    }))
  }, React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "center",
    mb: 1
  }, React.createElement(TAvatar, {
    size: "lm",
    boldText: true,
    name: avatarName,
    src: image
  }), React.createElement(Wrapper$2, {
    ml: 2
  }, React.createElement(TText, {
    rows: 2,
    bold: true
  }, name), !!subject && React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "center"
  }, React.createElement(Wrapper$2, {
    mr: 3
  }, React.createElement(IconSubject, {
    fill: "#909091"
  })), React.createElement(TText, {
    textColor: "dark-50",
    level: 3
  }, subject)), moreInfo && React.createElement(Wrapper$2, {
    display: "flex",
    textAlign: "center",
    py: 3
  }, moreInfo))), !!email && React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: "center"
  }, React.createElement(Wrapper$2, {
    mr: 3
  }, React.createElement(IconLetter, {
    fill: "#909091"
  })), React.createElement(TText, {
    textColor: "dark-50",
    level: 3
  }, email)), !!actions && React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "flex-end"
  }, actions)));
};

var TeacherProfileCard = withSkeleton(TTeacherProfileCard, TTeacherProfileCardSkeleton);

var css_248z$1n = ".e-teacher-profile-container {\n  padding: 32px 24px;\n  border-radius: var(--border-radius, 8px);\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.e-teacher-profile-container .e-image .t-avatar-container span {\n  font-size: 44px;\n}\n.e-teacher-profile-container .e-about .e-label {\n  color: var(--primary-color, #f54e95);\n  margin-right: 4px;\n}\n";
styleInject(css_248z$1n);

const TeacherProfileCard$1 = ({
  name,
  image,
  height,
  aboutList = [],
  moreInfo
}) => {
  return React.createElement("div", {
    className: "e-teacher-profile-container"
  }, React.createElement("div", {
    style: {
      height: height || 'auto',
      overflow: 'auto'
    }
  }, React.createElement("div", {
    className: 'e-image'
  }, React.createElement(Wrapper$2, {
    mb: 1,
    display: "flex",
    justifyContent: "center"
  }, React.createElement(TAvatar, {
    name: name,
    size: "xxxl",
    src: image
  })), React.createElement(Wrapper$2, {
    textAlign: "center",
    mb: 1
  }, React.createElement(TTitle, {
    level: 4,
    rows: 1
  }, name, moreInfo && React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "center",
    textAlign: "center"
  }, moreInfo)))), React.createElement("div", {
    className: 'e-about'
  }, !!aboutList.length && aboutList.map((item, index) => React.createElement(Wrapper$2, {
    display: "flex",
    py: 3,
    key: index
  }, React.createElement("label", {
    className: "e-label"
  }, item.lable, ":"), React.createElement(TText, {
    rows: 1,
    level: 3
  }, item.content))))));
};

const ParagraphWithHeadingSkeleton = () => {
  return React.createElement(TCardContainer, null, React.createElement(Wrapper$2, {
    mb: 1,
    display: "flex",
    alignItems: "center"
  }, React.createElement(Wrapper$2, {
    mr: 1
  }, React.createElement(_Skeleton, {
    round: true,
    active: true
  })), React.createElement(_Skeleton, {
    round: true,
    active: true,
    paragraph: {
      rows: 4
    }
  })));
};

var css_248z$1o = ".t-tag {\n  font-size: 13px;\n  color: #fff;\n  border-radius: var(--border-radius, 8px);\n  padding: 2px 8px 3px 8px;\n}\n.t-tag.t-tag-warning {\n  background-color: #f7b500;\n}\n.t-tag.t-tag-wrong {\n  background-color: #ff6464;\n}\n.t-tag.t-tag-positive {\n  background-color: #52aeff;\n}\n.t-tag.t-tag-trial {\n  background-color: #3ece76;\n}\n.t-tag.t-tag-neutral {\n  background-color: #9696ff;\n}\n.t-tag.t-tag-good {\n  background-color: #3be3c5;\n}\n";
styleInject(css_248z$1o);

const ParagraphWithHeading = ({
  title,
  paragraph,
  fallBack = 'No Data',
  titleSize = 1,
  paragraphize = 2
}) => {
  return React.createElement(TCardContainer, null, React.createElement(Wrapper$2, {
    mb: 4
  }, React.createElement(TText, {
    semiBold: true,
    level: titleSize
  }, title)), paragraph ? React.createElement(TText, {
    level: paragraphize
  }, paragraph) : React.createElement(TText, {
    textColor: "dark-50",
    level: 2
  }, fallBack));
};

var ParagraphWithHeading$1 = withSkeleton(ParagraphWithHeading, ParagraphWithHeadingSkeleton);

var css_248z$1p = ".t-news-list-item {\n  display: flex;\n  border-bottom: 1px solid #eaeaeb;\n  padding: 16px;\n  border-right: 4px solid transparent;\n}\n.t-news-list-item .t-news-list-item-info-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.t-news-list-item:hover {\n  border-right: 4px solid var(--primary-color, #f54e95);\n  background: #fbfbfc;\n}\n";
styleInject(css_248z$1p);

const NewsListItem = ({
  title,
  description,
  avatar,
  link,
  author,
  date
}) => {
  const {
    translate
  } = useContext(ConfigContext);
  return React.createElement("div", {
    className: "t-news-list-item"
  }, React.createElement(Wrapper$2, {
    mr: 1
  }, React.createElement(TAvatar, {
    name: title,
    src: avatar
  })), React.createElement("div", {
    className: "t-news-list-item-info-wrapper"
  }, React.createElement(Wrapper$2, null, React.createElement(TText, {
    bold: true,
    rows: 1
  }, title), React.createElement(TText, {
    level: 2,
    rows: 2
  }, description), !!author && React.createElement(TText, {
    rows: 1,
    level: 3,
    textColor: "dark-50"
  }, translate('news.author'), ":", ` ${author}`), !!date && React.createElement(TText, {
    rows: 1,
    level: 3,
    textColor: "dark-50"
  }, translate('news.date'), ":", ` ${moment$1(date).format('LL')}`)), !!link && React.createElement(Wrapper$2, {
    ml: 1
  }, React.createElement("a", {
    target: "_blank",
    href: link
  }, React.createElement(IconLink, {
    size: "xl"
  })))));
};

const NewsCardList = ({
  title,
  seeAllLink,
  news = [],
  loading = false,
  height,
  fallback
}) => {
  return React.createElement(TCardList, {
    title: title,
    seeAllLink: seeAllLink,
    loading: loading,
    height: height,
    fallback: fallback
  }, news.map((item, index) => React.createElement(NewsListItem, Object.assign({
    key: index
  }, item))));
};

var css_248z$1q = ".t-modal .ant-modal-content {\n  border-radius: 8px;\n}\n.t-modal .ant-modal-title {\n  border-radius: 8px 8px 0 0;\n}\n.t-modal .ant-modal-close-x {\n  padding-right: 8px;\n}\n.t-modal .ant-modal-header {\n  background: #fff;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n}\n.t-modal .ant-modal-footer .ant-btn-primary:read-only {\n  background-color: var(--primary-color, #f54e95);\n  color: #fff;\n  border-color: var(--primary-color, #f54e95);\n}\n.t-modal .ant-modal-footer .ant-btn {\n  border-radius: var(--border-radius, 8px);\n  color: var(--text-dark-100, #262626);\n  border-color: var(--text-dark-50, #909091);\n}\n";
styleInject(css_248z$1q);

const Modal = _a => {
  var {
    children
  } = _a,
      props = __rest(_a, ["children"]);

  return React.createElement(_Modal, Object.assign({
    className: "t-modal"
  }, props), children);
};

var css_248z$1r = ".t-info-item {\n  padding: 16px;\n  background: #fff;\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  border-radius: var(--border-radius, 8px);\n}\n.t-max-content-info-item {\n  width: max-content;\n}\n";
styleInject(css_248z$1r);

const InfoItem = ({
  lable,
  content,
  onClick = () => {},
  lableSize = 3,
  lableColor = 'dark-20',
  width,
  fallBack = 'No Data'
}) => {
  const classNames = ['t-info-item'];

  if (width === 'maxContent') {
    classNames.push('t-max-content-info-item');
  }

  return React.createElement("div", null, React.createElement(Wrapper$2, {
    pl: 1,
    pb: 3
  }, React.createElement(TText, {
    rows: 1,
    textColor: lableColor,
    level: lableSize
  }, lable)), React.createElement("div", {
    onClick: onClick,
    className: classNames.join(' ')
  }, !!content ? content : React.createElement(TText, {
    textColor: "dark-50",
    level: 2
  }, fallBack)));
};

var css_248z$1s = ".t-note-card-container {\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  border-radius: 4px;\n  background: #fff;\n  padding: 16px;\n  transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n  min-height: 240px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.t-note-card-container .t-note-files {\n  margin-right: 8px;\n  color: var(--primary-color, #f54e95);\n  display: flex;\n  align-items: center;\n}\n.t-note-card-container .ant-dropdown-link {\n  color: var(--primary-color, #f54e95);\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n.t-note-card-container .ant-dropdown-link svg path {\n  fill: var(--primary-color, #f54e95);\n}\n.t-note-dropdown a {\n  color: var(--primary-color, #f54e95);\n}\n.t-note-dropdown ul li {\n  color: var(--primary-color, #f54e95);\n}\n";
styleInject(css_248z$1s);

const NoteCard = ({
  title,
  description,
  dropdownData = [],
  date,
  name,
  dropdownText,
  onItemClick = () => {}
}) => {
  const classNames = ['t-note-card-container'];
  const menu = React.createElement(_Menu, null, dropdownData.map((item, index) => {
    return React.createElement(_Menu.Item, {
      key: index
    }, React.createElement("span", {
      key: index,
      className: 't-note-files'
    }, React.createElement("a", {
      href: item.src,
      target: "_blank",
      rel: "noopener noreferrer"
    }, item.name)));
  }));
  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onItemClick
  }, React.createElement(Wrapper$2, {
    mb: 1
  }, React.createElement(TText, {
    rows: 1,
    bold: true,
    level: 1
  }, title)), React.createElement(Wrapper$2, {
    mb: 1
  }, React.createElement(TText, {
    readMore: true,
    rows: 3,
    level: 3
  }, description)), React.createElement(Wrapper$2, {
    mb: 1
  }, !!dropdownData.length && React.createElement(_Dropdown, {
    overlay: menu,
    overlayClassName: 't-note-dropdown'
  }, React.createElement("a", {
    className: "ant-dropdown-link",
    onClick: e => e.preventDefault()
  }, dropdownText, React.createElement(IconArrowDown, null)))), React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center'
  }, React.createElement(Wrapper$2, {
    mr: 2
  }, React.createElement(TText, {
    rows: 1,
    textColor: "dark-50",
    level: 3
  }, name)), React.createElement(TText, {
    rows: 1,
    textColor: "dark-50",
    level: 3
  }, date)));
};

var css_248z$1t = ".document-card-container {\n  box-shadow: var(--box-shadow-strong, 0px 2px 4px rgba(119, 110, 171, 0.12));\n  border-radius: 4px;\n  background: #fff;\n  padding: 16px;\n  transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.document-card-container .actions-wrapper {\n  display: flex;\n  padding-left: 8px;\n}\n.document-card-container .actions-wrapper .action-wrapper {\n  cursor: pointer;\n  margin: 0 8px;\n}\n.document-card-container-active {\n  background: #fff0f4;\n}\n.document-card-container-strong {\n  background: #e9e9f0;\n}\n.document-card-container-soft {\n  background: #f7f7f8;\n}\n.document-card-container-hover:hover {\n  background: #f7f7f8;\n  transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.uploader {\n  margin-top: 8px;\n}\n.date {\n  margin-top: 8px;\n}\n";
styleInject(css_248z$1t);

const DocumentCard = ({
  title,
  titlefontWeight = false,
  uploader,
  icon,
  actions = [],
  onItemClick,
  date = '',
  active,
  background,
  titleColor,
  uploaderColor,
  titleSize = 2,
  uploaderSize = 3,
  actionsPositionY,
  hover = false
}) => {
  const classNames = ['document-card-container'];

  if (active) {
    classNames.push('document-card-container-active');
  }

  if (background) {
    classNames.push(`document-card-container-${background}`);
  }

  if (hover) {
    classNames.push(`document-card-container-hover`);
  }

  return React.createElement("div", {
    className: classNames.join(' '),
    onClick: onItemClick
  }, React.createElement(Wrapper$2, {
    display: "flex",
    justifyContent: "space-between"
  }, React.createElement(Wrapper$2, {
    display: "flex"
  }, icon && React.createElement(Wrapper$2, {
    display: "flex",
    pr: 1,
    mt: 3
  }, icon), React.createElement(Wrapper$2, null, React.createElement(TText, {
    level: titleSize,
    rows: 1,
    semiBold: titlefontWeight === 'bold',
    textColor: titleColor
  }, title), React.createElement("div", {
    className: "uploader"
  }, uploader && React.createElement(TText, {
    textColor: uploaderColor,
    level: uploaderSize,
    rows: 1
  }, uploader)), React.createElement("div", {
    className: "date"
  }, React.createElement(TText, {
    textColor: uploaderColor,
    level: uploaderSize,
    rows: 1
  }, date)))), !!actions.length && React.createElement(Wrapper$2, {
    display: "flex",
    alignItems: actionsPositionY
  }, React.createElement("div", {
    className: "actions-wrapper"
  }, actions.map((item, index) => {
    return React.createElement("div", {
      key: index,
      className: "action-wrapper",
      onClick: item.onClick
    }, item.icon);
  })))));
};

var index = (props => React.createElement(_Switch, Object.assign({}, props)));

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const IconDynamic = _a => {
  var {
    name
  } = _a,
      props = __rest(_a, ["name"]);

  const Component = Icon$2[capitalize(name)];

  if (!Component) {
    return null;
  }

  return React.createElement(Component, Object.assign({}, props));
};

const img$j = "data:image/png;base64,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";

var css_248z$1u = ".t_empty_result_container {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column !important;\n  text-align: center;\n  /* Center vertically and horizontally */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.t_empty_result_container .t_title {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 20px;\n  line-height: 32px;\n  letter-spacing: 0.2px;\n  margin-top: 40px;\n}\n@media screen and (max-width: 480px) {\n  .t_empty_result_container .t_img_container img {\n    width: 100%;\n    height: auto;\n  }\n}\n";
styleInject(css_248z$1u);

const TEmptyResultPage = ({
  title = '',
  second_title = '',
  path_to_img = img$j
}) => {
  return React.createElement(_Row, {
    gutter: 24,
    className: "t_empty_result_container"
  }, React.createElement(_Col, {
    className: "t_img_container"
  }, React.createElement("img", {
    src: path_to_img,
    alt: "Empty Result Page"
  })), React.createElement(_Col, {
    className: "t_title"
  }, React.createElement("p", null, title), React.createElement("p", null, second_title)));
};

export { TActionCard as ActionCard, AgendaCard, TAttendanceTag as AttendanceTag, AttendanceTagTypes, TAutoComplete as AutoComplete, TAvatar as Avatar, TAvatarGroup as AvatarGroup, TButton as Button, Calendar$2 as Calendar, TCalendarCardList as CalendarCardList, TCalendarCardList$1 as CalendarCardListESchool, CalendarPeriod, TCardContainer as CardContainer, TCardList as CardList, TCardList$1 as CardListESchool, TCarousel as Carousel, TChannelList as Chat, TCheckout as Checkout, TProvider as ConfigProvider, CourseCard, CourseCardList, TDataTableCard as DataTableCard, TDatePicker as DatePicker, DateViewer, TDivider as Divider, DocumentCard, TDropdown as Dropdown, TEmptyResultPage as EmptyResultPage, EventButton, TExternalLink as ExternalLink, TForm as Form, Header, Header$1 as HeaderVertical, HorizontalCard, IconAcl, IconGroup$1 as IconAdd, IconAdmin, IconAnalytics, IconApplication, IconApps, IconAppsV2, IconArrowDown, IconArrowDownBold, IconArrowLeft, IconArrowRight, IconArrowUp, IconAttendance, IconBack, IconBadge, IconBarChartOutlined, IconBellOutlined, IconBellWithPaper, IconBlog, IconBoldLevel, IconContact as IconBookBold, IconBriefcase, IconCalendar, IconCalendarV2, IconCamera, IconHome$1 as IconCategory, IconCfEvents, IconChat, IconChatBot, IconCheckCircle, IconCheckInOut, IconClasses, IconClassroom, IconClip, IconClone, IconCloneV2, IconClose, IconCloseCircle, IconCloseOutlined, IconColoredFile as IconColoredBook, IconColoredBook as IconColoredFile, IconComment, IconContacts, IconCourse, IconDashboard, IconDiscount, IconMaterial$1 as IconDocument, IconDropBox, IconDynamic, IconEditPen, IconEditPenCircle, IconEmoji, IconEnrolment, IconEvents, IconExceptions, IconExit, IconExpense, IconExport, IconExtra, IconEye, IconFeature, IconFile, IconFileDocument, IconFilePDF, IconFinances, IconFinancesBold, IconForm, IconGlobe, IconGlobeOutline, IconGroup, IconGroupV2, IconHamburger, IconHelpCircle, IconHome, IconImport, IconInBox, IconInBoxOutline, IconInfo, IconInfoCircle, IconInternational, IconInvoice, IconKey, IconKeyOutlined, IconLamp, IconLearning, IconLetter, IconLevel, IconLink, IconList, IconLock, IconLockBold, IconLockClosed, IconLockOpen, IconLockOutlined, IconLogout, IconLogoutV2, IconMail, IconManagement, IconMaterial, IconMaterialV2, IconMergeRequest, IconMessageSquare as IconMessageSuare, IconMiusOutlined, IconMoreActions, IconMoreActionsCircle, IconNews, IconNewsV2, IconNotePadColored, IconNotes, IconNotification, IconNotificationTemplates, IconOnlinePayment, IconPaperPlus, IconPaymant, IconPen, IconPenUnderline, IconPencil, IconPermission, IconPerson, IconPersonOutlined, IconPersonV2, IconPersonal, IconPieChart, IconPieChartV2, IconPlayOutlined, IconPlus, IconPlusOutlined, IconPrint, IconProfile, IconPulse, IconRectangles, IconRefresh, IconForward as IconReply, IconRole, IconSalaryIn, IconSalaryOut, IconSales, IconGroup$2 as IconSave, IconSchool, IconSearchOutlined, IconSend, IconSetting, IconSettingsOutline, IconSettingsV2, IconStar, IconStudent, IconStudentV2, IconSubject, IconTask, IconTestResult, TIconText as IconText, IconTrash, IconTrashColored, IconTrashLined, IconTrendingUp, IconUnorderedListOutlined, IconUploadBulk, IconUploadOutlined, IconUser, IconUserAddPlus, IconUserOutline, IconUsers, IconVacation, IconVideoCamera, IconVocab, IconVoice, IconWatch, IconZoom, TImageChooseCard as ImageChooseCard, InfoCard, InfoCardList$1 as InfoCardList, InfoItem, InputTypes, TMessagesCardList as MessagesCardList, TMessagesCardList$1 as MessagesCardListESchool, TMessenger as Messenger, TMessengerBody as MessengerBody, TInputArea as MessengerInputArea, Modal, NewsCardList, NoteCard, NotificationCard, ParagraphWithHeading$1 as ParagraphWithHeading, PaymentTypes, TPopover as Popover, PracticeActions, TPracticeCard as PracticeCard, TStudentsList as PreviewList, TPreviewListItem as PreviewListItem, ProfileAvatar, TProgress as Progress, TProgressCard as ProgressCard, Rank, RateResult, TScheduleViewerCard as ScheduleViewerCard, Inputs as Search, TSelect as Select, SelectTypes, StatusType, StudentAttendanceCard, TSummary as Summary, SummeryType, index as Switch, TTabs as Tabs, TabsSizeType, TTag as Tag, TagTypes, TTasksCardList as TasksCardList, TTasksListItem as TasksListItem, TeacherProfileCard, TeacherProfileCard$1 as TeacherProfileCardESchool, TText as Text, Inputs as TextInput, TTimePicker as TimePicker, TTitle as Title, TTooltip as Tooltip, TUpload as Upload, TVideoCourseCard as VideoCourseCard, TNextSessionCard$1 as VideoPlayerCard, TVoiceRecorder as VoiceRecorder, TWebsiteCreateCard as WebsiteCreateCard, TWelcomeCard as WelcomeCard, TWelcomeCard$1 as WelcomeCardESchool, TStudentInfoList as WelcomeMessage, Wrapper$2 as Wrapper };
//# sourceMappingURL=index.es.js.map
